(window.webpackJsonp = window.webpackJsonp || []).push([
  [127, 2, 3, 9, 138],
  {
    "+6XX": function (e, t, n) {
      var o = n("y1pI");
      e.exports = function (e) {
        return o(this.__data__, e) > -1;
      };
    },
    "+JPL": function (e, t, n) {
      e.exports = { default: n("+SFK"), __esModule: !0 };
    },
    "+K+b": function (e, t, n) {
      var o = n("JHRd");
      e.exports = function (e) {
        var t = new e.constructor(e.byteLength);
        return new o(t).set(new o(e)), t;
      };
    },
    "+SFK": function (e, t, n) {
      n("AUvm"),
        n("wgeU"),
        n("adOz"),
        n("dl0q"),
        (e.exports = n("WEpk").Symbol);
    },
    "+VcZ": function (e, t, n) {
      "use strict";
      var o = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              (o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                "value" in o && (o.writable = !0),
                Object.defineProperty(e, o.key, o);
            }
          }
          return function (t, n, o) {
            return n && e(t.prototype, n), o && e(t, o), t;
          };
        })(),
        a = function (e, t, n) {
          for (var o = !0; o; ) {
            var a = e,
              r = t,
              i = n;
            (o = !1), null === a && (a = Function.prototype);
            var l = Object.getOwnPropertyDescriptor(a, r);
            if (void 0 !== l) {
              if ("value" in l) return l.value;
              var s = l.get;
              if (void 0 === s) return;
              return s.call(i);
            }
            var c = Object.getPrototypeOf(a);
            if (null === c) return;
            (e = c), (t = r), (n = i), (o = !0), (l = c = void 0);
          }
        };
      function r(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function i(e, t, n) {
        return (
          t in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      var l,
        s,
        c,
        _,
        u,
        d = n("q1tI"),
        p = r(d),
        f = r(n("17x9")),
        h = n("MTB2"),
        m = r(n("TSYQ")),
        y = r(n("Gytx")),
        b = 0,
        v = "transform",
        g = !0,
        w = 0,
        x = -1,
        k = (function (e) {
          function t(e, n) {
            !(function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              a(Object.getPrototypeOf(t.prototype), "constructor", this).call(
                this,
                e,
                n,
              ),
              (this.handleResize = this.handleResize.bind(this)),
              (this.handleScroll = this.handleScroll.bind(this)),
              (this.handleScrollStart = this.handleScrollStart.bind(this)),
              (this.delta = 0),
              (this.stickyTop = 0),
              (this.stickyBottom = 0),
              (this.frozen = !1),
              (this.skipNextScrollEvent = !1),
              (this.scrollTop = -1),
              this.bottomBoundaryTarget,
              this.topTarget,
              this.subscribers,
              (this.state = {
                top: 0,
                bottom: 0,
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                topBoundary: 0,
                bottomBoundary: 1 / 0,
                status: b,
                pos: 0,
                activated: !1,
              });
          }
          return (
            (function (e, t) {
              if ("function" !== typeof t && null !== t)
                throw new TypeError(
                  "Super expression must either be null or a function, not " +
                    typeof t,
                );
              (e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t &&
                  (Object.setPrototypeOf
                    ? Object.setPrototypeOf(e, t)
                    : (e.__proto__ = t));
            })(t, e),
            o(t, [
              {
                key: "getTargetHeight",
                value: function (e) {
                  return (e && e.offsetHeight) || 0;
                },
              },
              {
                key: "getTopPosition",
                value: function (e) {
                  return (
                    "string" ===
                      typeof (e =
                        e || this.props.top || this.props.topTarget || 0) &&
                      (this.topTarget || (this.topTarget = l.querySelector(e)),
                      (e = this.getTargetHeight(this.topTarget))),
                    e
                  );
                },
              },
              {
                key: "getTargetBottom",
                value: function (e) {
                  if (!e) return -1;
                  var t = e.getBoundingClientRect();
                  return this.scrollTop + t.bottom;
                },
              },
              {
                key: "getBottomBoundary",
                value: function (e) {
                  var t = e || this.props.bottomBoundary;
                  return (
                    "object" === typeof t && (t = t.value || t.target || 0),
                    "string" === typeof t &&
                      (this.bottomBoundaryTarget ||
                        (this.bottomBoundaryTarget = l.querySelector(t)),
                      (t = this.getTargetBottom(this.bottomBoundaryTarget))),
                    t && t > 0 ? t : 1 / 0
                  );
                },
              },
              {
                key: "reset",
                value: function () {
                  this.setState({ status: b, pos: 0 });
                },
              },
              {
                key: "release",
                value: function (e) {
                  this.setState({ status: 1, pos: e - this.state.y });
                },
              },
              {
                key: "fix",
                value: function (e) {
                  this.setState({ status: 2, pos: e });
                },
              },
              {
                key: "updateInitialDimension",
                value: function (e) {
                  e = e || {};
                  var t = this.outerElement.getBoundingClientRect(),
                    n = this.innerElement.getBoundingClientRect(),
                    o = t.width || t.right - t.left,
                    a = n.height || n.bottom - n.top,
                    r = t.top + this.scrollTop;
                  this.setState({
                    top: this.getTopPosition(e.top),
                    bottom: Math.min(this.state.top + a, x),
                    width: o,
                    height: a,
                    x: t.left,
                    y: r,
                    bottomBoundary: this.getBottomBoundary(e.bottomBoundary),
                    topBoundary: r,
                  });
                },
              },
              {
                key: "handleResize",
                value: function (e, t) {
                  this.props.shouldFreeze() ||
                    ((x = t.resize.height),
                    this.updateInitialDimension(),
                    this.update());
                },
              },
              {
                key: "handleScrollStart",
                value: function (e, t) {
                  (this.frozen = this.props.shouldFreeze()),
                    this.frozen ||
                      (this.scrollTop === t.scroll.top
                        ? (this.skipNextScrollEvent = !0)
                        : ((this.scrollTop = t.scroll.top),
                          this.updateInitialDimension()));
                },
              },
              {
                key: "handleScroll",
                value: function (e, t) {
                  this.skipNextScrollEvent
                    ? (this.skipNextScrollEvent = !1)
                    : ((w = t.scroll.delta),
                      (this.scrollTop = t.scroll.top),
                      this.update());
                },
              },
              {
                key: "update",
                value: function () {
                  if (
                    !this.props.enabled ||
                    this.state.bottomBoundary - this.state.topBoundary <=
                      this.state.height ||
                    (0 === this.state.width && 0 === this.state.height)
                  )
                    this.state.status !== b && this.reset();
                  else {
                    var e = w,
                      t = this.scrollTop + this.state.top,
                      n = this.scrollTop + this.state.bottom;
                    if (t <= this.state.topBoundary) this.reset();
                    else if (n >= this.state.bottomBoundary)
                      (this.stickyBottom = this.state.bottomBoundary),
                        (this.stickyTop =
                          this.stickyBottom - this.state.height),
                        this.release(this.stickyTop);
                    else if (this.state.height > x - this.state.top)
                      switch (this.state.status) {
                        case b:
                          this.release(this.state.y),
                            (this.stickyTop = this.state.y),
                            (this.stickyBottom =
                              this.stickyTop + this.state.height);
                        case 1:
                          (this.stickyBottom =
                            this.stickyTop + this.state.height),
                            e > 0 && n > this.stickyBottom
                              ? this.fix(this.state.bottom - this.state.height)
                              : e < 0 &&
                                t < this.stickyTop &&
                                this.fix(this.state.top);
                          break;
                        case 2:
                          var o = !0,
                            a = this.state.pos,
                            r = this.state.height;
                          if (e > 0 && a === this.state.top)
                            (this.stickyTop = t - e),
                              (this.stickyBottom = this.stickyTop + r);
                          else if (e < 0 && a === this.state.bottom - r)
                            (this.stickyBottom = n - e),
                              (this.stickyTop = this.stickyBottom - r);
                          else if (
                            a !== this.state.bottom - r &&
                            a !== this.state.top
                          ) {
                            var i = a + r - this.state.bottom;
                            (this.stickyBottom = n - e + i),
                              (this.stickyTop = this.stickyBottom - r);
                          } else o = !1;
                          o && this.release(this.stickyTop);
                      }
                    else this.fix(this.state.top);
                    this.delta = e;
                  }
                },
              },
              {
                key: "componentWillReceiveProps",
                value: function (e) {
                  this.updateInitialDimension(e), this.update();
                },
              },
              {
                key: "componentDidUpdate",
                value: function (e, t) {
                  var n = this;
                  t.status !== this.state.status &&
                    this.props.onStateChange &&
                    this.props.onStateChange({ status: this.state.status }),
                    e.enabled !== this.props.enabled &&
                      (this.props.enabled
                        ? this.setState({ activated: !0 }, function () {
                            n.updateInitialDimension(), n.update();
                          })
                        : this.setState({ activated: !1 }, function () {
                            n.reset();
                          }));
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  for (var e = (this.subscribers || []).length - 1; e >= 0; e--)
                    this.subscribers[e].unsubscribe();
                },
              },
              {
                key: "componentDidMount",
                value: function () {
                  u ||
                    ((u = window),
                    (l = document),
                    (c = l.documentElement),
                    (s = l.body),
                    (x = u.innerHeight || c.clientHeight),
                    (_ = window.Modernizr) &&
                      _.prefixed &&
                      ((g = _.csstransforms3d), (v = _.prefixed("transform")))),
                    (this.scrollTop = s.scrollTop + c.scrollTop),
                    this.props.enabled &&
                      (this.setState({ activated: !0 }),
                      this.updateInitialDimension(),
                      this.update()),
                    (this.subscribers = [
                      (0, h.subscribe)(
                        "scrollStart",
                        this.handleScrollStart.bind(this),
                        { useRAF: !0 },
                      ),
                      (0, h.subscribe)("scroll", this.handleScroll.bind(this), {
                        useRAF: !0,
                        enableScrollInfo: !0,
                      }),
                      (0, h.subscribe)("resize", this.handleResize.bind(this), {
                        enableResizeInfo: !0,
                      }),
                    ]);
                },
              },
              {
                key: "translate",
                value: function (e, t) {
                  g && this.props.enableTransforms && this.state.activated
                    ? (e[v] = "translate3d(0," + Math.round(t) + "px,0)")
                    : (e.top = t + "px");
                },
              },
              {
                key: "shouldComponentUpdate",
                value: function (e, t) {
                  return (
                    !this.props.shouldFreeze() &&
                    !(
                      (0, y.default)(this.props, e) &&
                      (0, y.default)(this.state, t)
                    )
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e,
                    t = this,
                    n = {
                      position: 2 === this.state.status ? "fixed" : "relative",
                      top: 2 === this.state.status ? "0px" : "",
                      zIndex: this.props.innerZ,
                    },
                    o = {};
                  this.translate(n, this.state.pos),
                    this.state.status !== b &&
                      ((n.width = this.state.width + "px"),
                      (o.height = this.state.height + "px"));
                  var a = (0, m.default)(
                      "sticky-outer-wrapper",
                      this.props.className,
                      (i(
                        (e = {}),
                        this.props.activeClass,
                        2 === this.state.status,
                      ),
                      i(e, this.props.releasedClass, 1 === this.state.status),
                      e),
                    ),
                    r = this.props.children;
                  return p.default.createElement(
                    "div",
                    {
                      ref: function (e) {
                        t.outerElement = e;
                      },
                      className: a,
                      style: o,
                    },
                    p.default.createElement(
                      "div",
                      {
                        ref: function (e) {
                          t.innerElement = e;
                        },
                        className: "sticky-inner-wrapper",
                        style: n,
                      },
                      "function" === typeof r
                        ? r({ status: this.state.status })
                        : r,
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(d.Component);
      (k.displayName = "Sticky"),
        (k.defaultProps = {
          shouldFreeze: function () {
            return !1;
          },
          enabled: !0,
          top: 0,
          bottomBoundary: 0,
          enableTransforms: !0,
          activeClass: "active",
          releasedClass: "released",
          onStateChange: null,
        }),
        (k.propTypes = {
          enabled: f.default.bool,
          top: f.default.oneOfType([f.default.string, f.default.number]),
          bottomBoundary: f.default.oneOfType([
            f.default.object,
            f.default.string,
            f.default.number,
          ]),
          enableTransforms: f.default.bool,
          activeClass: f.default.string,
          releasedClass: f.default.string,
          onStateChange: f.default.func,
          shouldFreeze: f.default.func,
          innerZ: f.default.oneOfType([f.default.string, f.default.number]),
        }),
        (k.STATUS_ORIGINAL = b),
        (k.STATUS_RELEASED = 1),
        (k.STATUS_FIXED = 2),
        (e.exports = k);
    },
    "+iFO": function (e, t, n) {
      var o = n("dTAl"),
        a = n("LcsW"),
        r = n("6sVZ");
      e.exports = function (e) {
        return "function" != typeof e.constructor || r(e) ? {} : o(a(e));
      };
    },
    "/+VL": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return S;
      });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("rePB"),
        i = n("yWgo"),
        l = n("Agtg"),
        s = n("md7G"),
        c = n("foSv"),
        _ = n("JX7q"),
        u = n("Ji7U");
      function d(e, t) {
        var n = Object.keys(t).filter(function (n) {
          var o = t[n].options;
          return (function e(t, n) {
            if (t === n) return !0;
            var o = Object.prototype.toString.call(t),
              a = Object.prototype.toString.call(n);
            if (o !== a) return !1;
            if ("[object Object]" !== o && "[object Object]" !== a)
              return t === n;
            if (t && n && "object" === typeof t && "object" === typeof n)
              for (var r in t)
                if (
                  Object.prototype.hasOwnProperty.call(t, r) &&
                  !1 === e(t[r], n[r])
                )
                  return !1;
            return !0;
          })(e, o);
        })[0];
        return t[n];
      }
      function p(e) {
        var t = e.root;
        return JSON.stringify(e, function (e, n) {
          if ("root" === e && t) {
            var o = Array.prototype.slice.call(t.classList).reduce(function (
                e,
                t,
              ) {
                return e + t;
              }, ""),
              a = t.id;
            return "".concat(a, "-").concat(o);
          }
          return n;
        });
      }
      var f = (function () {
          function e() {
            Object(o.default)(this, e),
              Object(r.a)(this, "registry", void 0),
              (this.registry = new WeakMap());
          }
          return (
            Object(a.default)(e, [
              {
                key: "elementExists",
                value: function (e) {
                  return this.registry.has(e);
                },
              },
              {
                key: "getElement",
                value: function (e) {
                  return this.registry.get(e);
                },
              },
              {
                key: "addElement",
                value: function (e, t) {
                  e && this.registry.set(e, t || {});
                },
              },
              {
                key: "removeElement",
                value: function (e) {
                  this.registry.delete(e);
                },
              },
              {
                key: "clear",
                value: function () {
                  this.registry = new WeakMap();
                },
              },
            ]),
            e
          );
        })(),
        h = (function (e) {
          return (e.enter = "enter"), (e.exit = "exit"), e;
        })({});
      function m(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function y(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? m(Object(n), !0).forEach(function (t) {
                Object(r.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : m(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function b(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var v = (function (e) {
        function t() {
          var e;
          return (
            Object(o.default)(this, t),
            (e = b(this, t)),
            Object(r.a)(Object(_.a)(e), "elementRegistry", void 0),
            (e.elementRegistry = new f()),
            e
          );
        }
        return (
          Object(u.a)(t, e),
          Object(a.default)(t, [
            {
              key: "observeNodeIntersection",
              value: function (e, t, n) {
                var o, a;
                e.inView &&
                  (null === (o = e.callback) ||
                    void 0 === o ||
                    null === (a = o.scrollIntoView) ||
                    void 0 === a ||
                    a.call(o, t),
                  e.startFrameTask());
                this.addCallback(
                  e.element,
                  function () {
                    var n, o;
                    e.inView ||
                      ((e.inView = !0),
                      null === (n = e.callback) ||
                        void 0 === n ||
                        null === (o = n.scrollIntoView) ||
                        void 0 === o ||
                        o.call(n, t),
                      e.startFrameTask());
                  },
                  function () {
                    var n, o;
                    e.inView &&
                      ((e.inView = !1),
                      null === (n = e.callback) ||
                        void 0 === n ||
                        null === (o = n.scrollOutOfWiew) ||
                        void 0 === o ||
                        o.call(n, t),
                      e.stopFrameTask());
                  },
                ),
                  this.observe(e.element, n);
              },
            },
            {
              key: "observe",
              value: function (e) {
                var t =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
                e &&
                  (this.elementRegistry.addElement(e, y({}, t)),
                  this.setupObserver(e, y({}, t)));
              },
            },
            {
              key: "unobserve",
              value: function (e, t) {
                var n = this.findMatchingRootEntry(t);
                (this.elementRegistry.removeElement(e), n) &&
                  n.intersectionObserver.unobserve(e);
              },
            },
            {
              key: "dispatchEnterCallback",
              value: function (e, t) {
                this.dispatchCallback(h.enter, e, t);
              },
            },
            {
              key: "dispatchExitCallback",
              value: function (e, t) {
                this.dispatchCallback(h.exit, e, t);
              },
            },
            {
              key: "destroy",
              value: function () {
                this.elementRegistry.clear();
              },
            },
            {
              key: "handleIntersection",
              value: function (e) {
                var t = this;
                return function (n) {
                  return t.onIntersection(e, n);
                };
              },
            },
            {
              key: "setupObserver",
              value: function (e, t) {
                var n,
                  o = t.root,
                  a = void 0 === o ? window : o,
                  i = this.findRootFromRegistry(a);
                if ((i && (n = d(t, i)), n)) {
                  var l = n,
                    s = l.elements,
                    c = l.intersectionObserver;
                  s.push(e), c && c.observe(e);
                } else {
                  var _ = {
                      elements: [e],
                      intersectionObserver: this.newObserver(e, t),
                      options: t,
                    },
                    u = p(t);
                  i
                    ? (i[u] = _)
                    : this.elementRegistry.addElement(a, Object(r.a)({}, u, _));
                }
              },
            },
            {
              key: "newObserver",
              value: function (e, t) {
                var n = t.root,
                  o = t.rootMargin,
                  a = t.threshold,
                  r = new IntersectionObserver(
                    this.handleIntersection(t).bind(this),
                    { root: n, rootMargin: o, threshold: a },
                  );
                return r.observe(e), r;
              },
            },
            {
              key: "onIntersection",
              value: function (e, t) {
                var n = this;
                t.forEach(function (t) {
                  var o = t.isIntersecting,
                    a = t.intersectionRatio,
                    r = e.threshold || 0;
                  Array.isArray(r) && (r = r[r.length - 1]);
                  var i = n.findMatchingRootEntry(e);
                  o || a > r
                    ? i &&
                      i.elements.some(function (e) {
                        return (
                          !(!e || e !== t.target) &&
                          (n.dispatchEnterCallback(e, t), !0)
                        );
                      })
                    : i &&
                      i.elements.some(function (e) {
                        return (
                          !(!e || e !== t.target) &&
                          (n.dispatchExitCallback(e, t), !0)
                        );
                      });
                });
              },
            },
            {
              key: "findRootFromRegistry",
              value: function (e) {
                if (this.elementRegistry)
                  return this.elementRegistry.getElement(e);
              },
            },
            {
              key: "findMatchingRootEntry",
              value: function (e) {
                var t = e.root,
                  n = void 0 === t ? window : t,
                  o = this.findRootFromRegistry(n);
                if (o) return o[p(e)];
              },
            },
          ]),
          t
        );
      })(
        (function () {
          function e() {
            Object(o.default)(this, e),
              Object(r.a)(this, "registry", void 0),
              (this.registry = new f());
          }
          return (
            Object(a.default)(e, [
              {
                key: "addCallback",
                value: function (e, t, n) {
                  var o = Object(r.a)(Object(r.a)({}, h.enter, [t]), h.exit, [
                      n,
                    ]),
                    a = this.registry.getElement(e);
                  a &&
                    (a.enter && (o.enter = a.enter.concat(o.enter || [])),
                    a.exit && (o.exit = a.exit.concat(o.exit || []))),
                    this.registry.addElement(e, o);
                },
              },
              {
                key: "dispatchCallback",
                value: function (e, t, n) {
                  if (e === h.enter) {
                    var o = this.registry.getElement(t);
                    (null === o || void 0 === o ? void 0 : o.enter.length) >
                      0 &&
                      o.enter.forEach(function (e) {
                        e(n);
                      });
                  } else {
                    var a = this.registry.getElement(t);
                    (null === a || void 0 === a ? void 0 : a.exit.length) > 0 &&
                      a.exit.forEach(function (e) {
                        e(n);
                      });
                  }
                },
              },
            ]),
            e
          );
        })(),
      );
      function g(e, t, n) {
        var o, a;
        if (t && !e.inView)
          (e.inView = !0),
            null === (o = e.callback) ||
              void 0 === o ||
              null === (a = o.scrollIntoView) ||
              void 0 === a ||
              a.call(o, n),
            e.startFrameTask();
        else if (!t && e.inView) {
          var r, i;
          (e.inView = !1),
            null === (r = e.callback) ||
              void 0 === r ||
              null === (i = r.scrollOutOfWiew) ||
              void 0 === i ||
              i.call(r, n),
            e.stopFrameTask();
        }
      }
      var w = 84,
        x = 125,
        k = (function () {
          function e(t) {
            var n = this;
            Object(o.default)(this, e),
              Object(r.a)(this, "dimension", void 0),
              Object(r.a)(this, "monitorTimeout", void 0),
              Object(r.a)(this, "monitoring", !1),
              Object(r.a)(this, "startTime", 0),
              Object(r.a)(this, "frameTime", 0),
              Object(r.a)(this, "accumulateOffsetMills", 0),
              Object(r.a)(this, "totalOffsetMills", void 0),
              Object(r.a)(this, "displayFrameTimes", []),
              Object(r.a)(this, "janks", 0),
              Object(r.a)(this, "bigJanks", 0),
              Object(r.a)(this, "jankList", []),
              Object(r.a)(this, "jankPositionList", []),
              Object(r.a)(this, "dimensionListenerKey", "ScrollMonitor"),
              Object(r.a)(this, "handleScrollStart", function () {
                clearTimeout(n.monitorTimeout),
                  (n.monitorTimeout = void 0),
                  n.start();
              }),
              Object(r.a)(this, "handleScrollEnd", function () {
                n.monitorTimeout = window.setTimeout(function () {
                  n.stop();
                }, 5e3);
              }),
              Object(r.a)(this, "detect", function () {
                var e = window.requestAnimationFrame;
                n.startTime = performance.now();
                n.monitoring &&
                  (function t() {
                    if (n.monitoring) {
                      var o = performance.now();
                      n.accumulateOffsetMills = o - n.totalOffsetMills;
                      var a = Number((o - n.frameTime).toFixed(3));
                      n.displayFrameTimes.push(a),
                        n.displayFrameTimes.length > 4 &&
                          n.displayFrameTimes.shift(),
                        a >
                          ((n.displayFrameTimes[0] +
                            n.displayFrameTimes[1] +
                            n.displayFrameTimes[2]) /
                            3) *
                            2 &&
                          a > w &&
                          (a > x
                            ? ((n.bigJanks += 1),
                              n.jankList.push(a),
                              n.jankPositionList.push({
                                pos: n.dimension.pageOffsetY,
                                type: 1,
                              }))
                            : ((n.janks += 1),
                              n.jankList.push(a),
                              n.jankPositionList.push({
                                pos: n.dimension.pageOffsetY,
                                type: 0,
                              }))),
                        n.accumulateOffsetMills >= 1e3 &&
                          (n.totalOffsetMills += n.accumulateOffsetMills),
                        (n.frameTime = o),
                        e(t);
                    }
                  })();
              }),
              Object(r.a)(this, "calculate", function () {
                var e = performance.now() - n.startTime,
                  t = "time:"
                    .concat(e, "ms jankList:")
                    .concat(n.jankList, " jankPosition:")
                    .concat(
                      n.jankPositionList.map(function (e) {
                        return e.pos;
                      }),
                    );
                console.log(t);
                var o = 0,
                  a = 0;
                n.jankList.forEach(function (e) {
                  (o += e), e > x && (a += e);
                });
                var r = Number(((100 * o) / e).toFixed(2)),
                  i = Number(((100 * a) / e).toFixed(2)),
                  l = "jankCount:"
                    .concat(n.janks, " bigJankCount:")
                    .concat(n.bigJanks, " jankRate:")
                    .concat(r, "% bigJankRate:")
                    .concat(i, "%");
                console.log(l), n.clear(), n.report(t, l, r);
              }),
              (this.dimension = t);
          }
          return (
            Object(a.default)(e, [
              {
                key: "init",
                value: function () {
                  var e = this;
                  window.addEventListener("load", function () {
                    setTimeout(function () {
                      e.checkEnvironment() &&
                        (e.dimension.addDimensionListener(
                          e.dimensionListenerKey,
                          {
                            onScrollStart: e.handleScrollStart,
                            onScrollEnd: e.handleScrollEnd,
                          },
                        ),
                        document.addEventListener(
                          "visibilitychange",
                          function () {
                            document.hidden && e.stop();
                          },
                        ));
                    }, 2e3);
                  });
                },
              },
              {
                key: "checkEnvironment",
                value: function () {
                  return (
                    ("Sentry" in window &&
                      "object" === typeof window.Sentry &&
                      "captureEvent" in window.Sentry) ||
                    (console.log(
                      "ScrollMonitor::checkEnvironment return false: Sentry is illegal",
                    ),
                    !1)
                  );
                },
              },
              {
                key: "start",
                value: function () {
                  this.monitoring || ((this.monitoring = !0), this.detect());
                },
              },
              {
                key: "stop",
                value: function () {
                  this.monitoring && ((this.monitoring = !1), this.calculate());
                },
              },
              {
                key: "report",
                value: function (e, t, n) {
                  var o,
                    a,
                    r = window.location.pathname;
                  (o = n > 8 ? "8+" : n > 4 ? "4+" : "0~4"),
                    window.sensorsDataAnalytic201505 &&
                      (a =
                        window.sensorsDataAnalytic201505.quick(
                          "getAnonymousID",
                        ));
                  var i = {
                      message: "Performance JANKRATE event from scroll monitor",
                      level: "log",
                      tags: {
                        category: "Custom Event",
                        path: r,
                        rates: e,
                        jankcounts: t,
                        jankRate: n,
                        baseline: o,
                        userId: a,
                      },
                    },
                    l = window.Sentry.captureEvent(i);
                  this.reportMeasurements(n, l);
                },
              },
              {
                key: "clear",
                value: function () {
                  (this.startTime = 0),
                    (this.frameTime = 0),
                    (this.accumulateOffsetMills = 0),
                    (this.displayFrameTimes = []),
                    (this.janks = 0),
                    (this.bigJanks = 0),
                    (this.jankList = []),
                    (this.jankPositionList = []);
                },
              },
              {
                key: "generateSentryTraceID",
                value: function (e, t) {
                  for (var n = t, o = "", a = n.length, r = 0; r < e; r++)
                    o += n.charAt(Math.floor(Math.random() * a));
                  return o;
                },
              },
              {
                key: "reportMeasurements",
                value: function (e, t) {
                  var n = e / 100,
                    o = window.Sentry.getCurrentHub().getClient().getDsn(),
                    a = o.publicKey,
                    r = o.host,
                    l = document.referrer,
                    s = Object(i.n)() ? "prod" : "test",
                    c = window.location.href,
                    _ = navigator.userAgent,
                    u = this.generateSentryTraceID(32, t),
                    d = this.generateSentryTraceID(32, t),
                    p = this.generateSentryTraceID(32, t),
                    f = this.generateSentryTraceID(16, t),
                    h = Date.now() / 1e3;
                  fetch(
                    "https://"
                      .concat(r, "/api/698/envelope/?sentry_key=")
                      .concat(
                        a,
                        "&sentry_version=7&sentry_client=sentry.javascript.react%2F7.61.1",
                      ),
                    {
                      referrer: l,
                      referrerPolicy: "origin",
                      body: '{"event_id":"'
                        .concat(
                          u,
                          '","sdk":{"name":"sentry.javascript.react","version":"7.61.1"},"trace":{"environment":"',
                        )
                        .concat(s, '","release":"0.0.1","public_key":"')
                        .concat(a, '","trace_id":"')
                        .concat(
                          d,
                          '"}}\n{"type":"transaction"}\n{"contexts":{"trace":{"op":"jankrate","span_id":"',
                        )
                        .concat(f, '","tags":{"jankEventID":"')
                        .concat(t, '"},"trace_id":"')
                        .concat(p, '"}},"spans":[],"start_timestamp":')
                        .concat(h, ',"tags":{},"timestamp":')
                        .concat(
                          h,
                          ',"transaction":"performance JANKRATE","type":"transaction","transaction_info":{"source":"url"},"measurements":{"jankRate":{"value":',
                        )
                        .concat(
                          n,
                          ',"unit":"percent"}},"platform":"javascript","event_id":"',
                        )
                        .concat(u, '","environment":"')
                        .concat(
                          s,
                          '","release":"0.0.1","sdk":{"integrations":[],"name":"sentry.javascript.react","version":"7.61.1","packages":[]},"breadcrumbs":[{}],"request":{"url":"',
                        )
                        .concat(c, '","headers":{"Referer":"')
                        .concat(l, '","User-Agent":"')
                        .concat(_, '"}}}'),
                      method: "POST",
                      mode: "no-cors",
                      credentials: "omit",
                    },
                  );
                },
              },
            ]),
            e
          );
        })();
      function O(e, t) {
        var n = e.top,
          o = e.left,
          a = e.width,
          r = e.height;
        return (
          n < t.pageOffsetY + t.innerHeight &&
          o < t.pageOffsetX + t.innerWidth &&
          n + r > t.pageOffsetY &&
          o + a > t.pageOffsetX
        );
      }
      var I = (function () {
          function e(t, n, a) {
            Object(o.default)(this, e),
              Object(r.a)(this, "scrollElement", void 0),
              Object(r.a)(this, "scrollTaskList", void 0),
              Object(r.a)(this, "scrollCallback", void 0),
              Object(r.a)(this, "nodeInfo", void 0),
              Object(r.a)(this, "frameTaskRunning", !1),
              (this.scrollElement = t),
              (this.nodeInfo = {
                top: 0,
                left: 0,
                width: 0,
                height: 0,
                inView: !1,
              }),
              (this.scrollTaskList = []),
              a && this.addTask(a),
              n && (this.scrollCallback = n);
          }
          return (
            Object(a.default)(e, [
              {
                key: "element",
                get: function () {
                  return this.scrollElement;
                },
              },
              {
                key: "callback",
                get: function () {
                  return this.scrollCallback;
                },
              },
              {
                key: "IScrollNode",
                get: function () {
                  return this.nodeInfo;
                },
              },
              {
                key: "top",
                get: function () {
                  return this.nodeInfo.top;
                },
              },
              {
                key: "left",
                get: function () {
                  return this.nodeInfo.left;
                },
              },
              {
                key: "width",
                get: function () {
                  return this.nodeInfo.width;
                },
              },
              {
                key: "height",
                get: function () {
                  return this.nodeInfo.height;
                },
              },
              {
                key: "inView",
                get: function () {
                  return this.nodeInfo.inView;
                },
                set: function (e) {
                  this.nodeInfo.inView = e;
                },
              },
              {
                key: "equals",
                value: function (e) {
                  return this.scrollElement.isSameNode(e);
                },
              },
              {
                key: "refreshPosition",
                value: function (e) {
                  (this.nodeInfo.top = this.scrollElement.offsetTop),
                    (this.nodeInfo.left = this.scrollElement.offsetLeft),
                    (this.nodeInfo.width = this.scrollElement.offsetWidth),
                    (this.nodeInfo.height = this.scrollElement.offsetHeight);
                  for (var t = this.scrollElement.offsetParent; t; )
                    (this.nodeInfo.top += t.offsetTop),
                      (this.nodeInfo.left += t.offsetLeft),
                      (t = t.offsetParent);
                  this.inView = O(this, e);
                },
              },
              {
                key: "addTask",
                value: function (e) {
                  this.scrollTaskList = this.scrollTaskList.concat(e);
                },
              },
              {
                key: "runFrameTask",
                value: function () {
                  var e = this;
                  this.frameTaskRunning &&
                    setTimeout(function () {
                      e.inView &&
                        e.scrollTaskList.length > 0 &&
                        e.scrollTaskList.forEach(function (t, n, o) {
                          var a = t(e);
                          !0 === Boolean(a) && o.splice(n, 1);
                        }),
                        e.runFrameTask();
                    }, 60);
                },
              },
              {
                key: "startFrameTask",
                value: function () {
                  !this.frameTaskRunning &&
                    this.scrollTaskList.length > 0 &&
                    ((this.frameTaskRunning = !0), this.runFrameTask());
                },
              },
              {
                key: "stopFrameTask",
                value: function () {
                  this.frameTaskRunning = !1;
                },
              },
            ]),
            e
          );
        })(),
        S = (function () {
          function e() {
            (Object(o.default)(this, e),
            Object(r.a)(this, "scrollNodes", []),
            Object(r.a)(this, "dimension", void 0),
            Object(r.a)(this, "sharedIntersectionObserver", void 0),
            Object(r.a)(this, "isSupportIntersectionObserver", !1),
            Object(r.a)(this, "checkElementTaskRunning", !1),
            (this.isSupportIntersectionObserver =
              window &&
              "IntersectionObserver" in window &&
              "isIntersecting" in window.IntersectionObserverEntry.prototype),
            (this.dimension = new l.b()),
            this.isSupportIntersectionObserver &&
              (this.sharedIntersectionObserver = new v()),
            !Object(i.n)() || Math.random() < 0.1) &&
              new k(this.dimension).init();
          }
          return (
            Object(a.default)(
              e,
              [
                {
                  key: "addNode",
                  value: function (e, t, n, o, a, r) {
                    if (!e || !window)
                      return (
                        console.warn(
                          "ScrollManager::addNode attempt adding an illegal element",
                        ),
                        null
                      );
                    if (n) {
                      var i = this.scrollNodes[this.findScrollNode(e)];
                      if (!i || a) {
                        var l = this.addScrollNode(e, t, n),
                          s = this.scrollNodes[l];
                        return this.observeInView(s, o, r), s;
                      }
                      return i.refreshPosition(this.dimension), i;
                    }
                    var c = new I(e, t, n);
                    return (
                      c.refreshPosition(this.dimension),
                      this.observeInView(c, o, r),
                      c
                    );
                  },
                },
                {
                  key: "removeNode",
                  value: function (e) {
                    var t = this.findScrollNode(e);
                    return -1 !== t
                      ? (this.scrollNodes.splice(t, 1),
                        this.unObserveInView(e),
                        !0)
                      : (this.unObserveInView(e), !1);
                  },
                },
                {
                  key: "addTask",
                  value: function (e, t) {
                    var n = this.scrollNodes[this.findScrollNode(e)];
                    return n
                      ? (n.addTask(t),
                        this.checkElementTaskRunning ||
                          this.isSupportIntersectionObserver ||
                          ((this.checkElementTaskRunning = !0),
                          this.runCheckElementTask()),
                        !0)
                      : (console.warn(
                          "ScrollManager::addTask cannot find target node",
                        ),
                        !1);
                  },
                },
                {
                  key: "getDimension",
                  value: function () {
                    return this.dimension;
                  },
                },
                {
                  key: "checkElementInView",
                  value: function (e) {
                    var t =
                      !(arguments.length > 1 && void 0 !== arguments[1]) ||
                      arguments[1];
                    if (!e)
                      return (
                        console.warn(
                          "ScrollManager::checkElementInView attempt checking an empty target element",
                        ),
                        !1
                      );
                    var n = this.scrollNodes[this.findScrollNode(e)];
                    if (!n)
                      return (
                        console.warn(
                          "ScrollManager::checkElementInView attempt checking an illegal target element",
                        ),
                        !1
                      );
                    if (!t) {
                      n.refreshPosition(this.dimension);
                      var o = O(n, this.dimension);
                      g(n, o, this.dimension);
                    }
                    return n.inView;
                  },
                },
                {
                  key: "runCheckElementTask",
                  value: function () {
                    var e = this;
                    setTimeout(function () {
                      !e.dimension.isOffsetValid && e.dimension.updateOffset();
                      for (var t = 0; t < e.scrollNodes.length; t++) {
                        var n = e.scrollNodes[t];
                        g(n, O(n, e.dimension), e.dimension);
                      }
                      e.runCheckElementTask();
                    }, 150);
                  },
                },
                {
                  key: "addScrollNode",
                  value: function (e, t, n) {
                    var o = this,
                      a = new I(e, t, n);
                    if (0 === this.scrollNodes.length)
                      return this.scrollNodes.push(a), 0;
                    var r = -1;
                    return (
                      this.scrollNodes.every(function (e, t) {
                        if (e.top >= a.top)
                          return o.scrollNodes.splice(t, 0, a), (r = t), !1;
                        var n = o.scrollNodes.length;
                        return (
                          t === n - 1 && ((r = n), o.scrollNodes.push(a)), !0
                        );
                      }),
                      r
                    );
                  },
                },
                {
                  key: "findScrollNode",
                  value: function (e) {
                    var t = -1;
                    return (
                      this.scrollNodes.every(function (n, o) {
                        return !n.element.isSameNode(e) || ((t = o), !1);
                      }),
                      t
                    );
                  },
                },
                {
                  key: "observeInView",
                  value: function (e) {
                    var t =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : 500,
                      n = arguments.length > 2 ? arguments[2] : void 0;
                    if (this.isSupportIntersectionObserver)
                      this.sharedIntersectionObserver.observeNodeIntersection(
                        e,
                        this.dimension,
                        { rootMargin: "".concat(t, "px"), threshold: n || 0 },
                      );
                    else {
                      var o = O(e, this.dimension);
                      g(e, o, this.dimension),
                        this.checkElementTaskRunning ||
                          ((this.checkElementTaskRunning = !0),
                          this.runCheckElementTask());
                    }
                  },
                },
                {
                  key: "unObserveInView",
                  value: function (e) {
                    this.isSupportIntersectionObserver &&
                      this.sharedIntersectionObserver.unobserve(e, { root: e });
                  },
                },
              ],
              [
                {
                  key: "getInstance",
                  value: function () {
                    return (
                      this.instance || (this.instance = new e()), this.instance
                    );
                  },
                },
              ],
            ),
            e
          );
        })();
      Object(r.a)(S, "instance", void 0);
    },
    "/9aa": function (e, t, n) {
      var o = n("NykK"),
        a = n("ExA7"),
        r = "[object Symbol]";
      e.exports = function (e) {
        return "symbol" == typeof e || (a(e) && o(e) == r);
      };
    },
    "/NQ+": function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return j;
      }),
        n.d(t, "a", function () {
          return T;
        }),
        n.d(t, "d", function () {
          return L;
        }),
        n.d(t, "c", function () {
          return B;
        }),
        n.d(t, "f", function () {
          return R;
        }),
        n.d(t, "e", function () {
          return F;
        }),
        n.d(t, "h", function () {
          return G;
        }),
        n.d(t, "g", function () {
          return Y;
        }),
        n.d(t, "i", function () {
          return J;
        }),
        n.d(t, "k", function () {
          return re;
        }),
        n.d(t, "j", function () {
          return ie;
        });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("iKuz"),
        u = n.n(_),
        d = n("q1tI"),
        p = n.n(d),
        f = n("XnI8"),
        h = n("FCep"),
        m = n("Gsew"),
        y = n("yWgo"),
        b = n("KQm4"),
        v = n("r7AC"),
        g = (n("hKI/"), n("3vbH")),
        w = n("cKzW"),
        x = (n("gUhf"), n("XrJB")),
        k = n.n(x),
        O = (n("aiR1"), p.a.createElement),
        I = {
          "./content.css": {
            "modal-content-a": "content__modal-content-a___sV8Tx",
            "content-a-hr": "content__content-a-hr___1h394",
            "content-a-item": "content__content-a-item___1v0vA",
            "content-a-item-scene": "content__content-a-item-scene___lcDpL",
            "content-a-item-img": "content__content-a-item-img___2gMoH",
            "content-a-item-text": "content__content-a-item-text___2rOFe",
            video: "content__video___3iIO3",
            "video-buttom": "content__video-buttom___3zx2r",
            "replay-buttom": "content__replay-buttom___Rg4FG",
            "play-buttom": "content__play-buttom___1SrVY",
            "pause-buttom": "content__pause-buttom___3MrRD",
            "loading-buttom": "content__loading-buttom___1kuac",
            "downgrade-video": "content__downgrade-video___AsXka",
            "downgrade-play-btn": "content__downgrade-play-btn___1C8hC",
            "downgrade-pic": "content__downgrade-pic___37etP",
            "modal-content-a-mobile": "content__modal-content-a-mobile___HCDAw",
            "content-d-hr": "content__content-d-hr___3UJbe",
            "modal-content-b": "content__modal-content-b___1PJ2u",
            "content-b-scene": "content__content-b-scene___2gxbn",
            "content-b-img": "content__content-b-img___3BG8D",
            "content-b-item-video": "content__content-b-item-video___1uVAe",
            "content-b-item-text": "content__content-b-item-text___1xSJh",
            "content-b-hr": "content__content-b-hr___2D5Bj",
            "content-b-text": "content__content-b-text___1dLXo",
            "modal-content-b-mobile": "content__modal-content-b-mobile___12biZ",
            "modal-content-c": "content__modal-content-c___1WZAL",
            "content-c-scene": "content__content-c-scene___24dWD",
            "content-c-avatar": "content__content-c-avatar___Hch-G",
            "content-c-desc": "content__content-c-desc___1RbSC",
            "content-c-text": "content__content-c-text___1cV7c",
            "content-c-text-img": "content__content-c-text-img___sOk98",
            "content-c-text-desc": "content__content-c-text-desc___27Wao",
            "modal-content-c-mobile": "content__modal-content-c-mobile___1r-Fl",
            "content-d-item-text": "content__content-d-item-text___1IE6e",
            "content-d-item-text1": "content__content-d-item-text1___2_Kbi",
            "content-d-item-scene": "content__content-d-item-scene___2iBIx",
            "video-box-pop": "content__video-box-pop___zZz2b",
            "video-item": "content__video-item___3msSe",
            "video-button": "content__video-button___2EnF9",
            "video-box-pop-m": "content__video-box-pop-m___SL6nf",
            icon: "content__icon___2sOK-",
            "watch-video-icon": "content__watch-video-icon___1IQxS",
            "modal-content-e": "content__modal-content-e___2Mi6b",
            "content-e-scene": "content__content-e-scene___3U1la",
            "content-e-top-bg": "content__content-e-top-bg___3TnZr",
            "content-e-desc": "content__content-e-desc___k8WET",
            "content-e-section": "content__content-e-section___2GT7H",
            "content-e-section-1": "content__content-e-section-1___2xmvg",
            "content-e-features": "content__content-e-features___1kuYS",
            "content-e-feature": "content__content-e-feature___1PHJo",
            "content-e-icon": "content__content-e-icon___E0z_T",
            "content-e-section-2": "content__content-e-section-2___2U5WZ",
            "content-e-bg-1": "content__content-e-bg-1___1MHuJ",
            "content-e-bg-2": "content__content-e-bg-2___3gFhr",
            "content-e-section-3": "content__content-e-section-3___HAzzR",
            "content-e-cards": "content__content-e-cards___1cIdi",
            "content-e-card": "content__content-e-card___A_uPM",
            "content-e-section-4": "content__content-e-section-4___q1ANH",
            "modal-content-e-mobile": "content__modal-content-e-mobile___3sg9D",
            "modal-content-f": "content__modal-content-f___uOJ6S",
            "content-f-scene": "content__content-f-scene___IRexU",
            "content-f-top-bg": "content__content-f-top-bg___20WGC",
            "content-f-cards": "content__content-f-cards___3Lybz",
            "content-f-card": "content__content-f-card___EzJ4_",
            "content-f-card-title": "content__content-f-card-title___2mybz",
            "content-f-card-desc": "content__content-f-card-desc___19iIH",
            "modal-content-f-mobile": "content__modal-content-f-mobile___3dN1f",
          },
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
        };
      function S(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var j = {
          modalContent: {
            label: "\u5f39\u7a97\u914d\u7f6e",
            props: {
              modal_OpenBtnAText: {
                label: "\u6253\u5f00\u5f39\u7a97\u6309\u94ae\u6587\u6848",
                type: "string",
                content: "text",
              },
              modal_contentATitle1: {
                label: "\u7b2c\u4e00\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentADesc1: {
                label: "\u7b2c\u4e00\u5757\u6bb5\u843d",
                type: "string",
                content: "text",
              },
              modal_contentAType1: {
                label: "\u7b2c\u4e00\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  { label: "\u89c6\u9891", value: "video" },
                ],
              },
              modal_contentAImg1: {
                label:
                  "\u7b2c\u4e00\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentAVideo1: {
                label: "\u7b2c\u4e00\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentADownImg1: {
                label:
                  "\u7b2c\u4e00\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentADownVideo1: {
                label:
                  "\u7b2c\u4e00\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
              modal_contentATitle2: {
                label: "\u7b2c\u4e8c\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentADesc2: {
                label: "\u7b2c\u4e8c\u5757\u6bb5\u843d",
                type: "string",
                content: "text",
              },
              modal_contentAType2: {
                label: "\u7b2c\u4e8c\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  { label: "\u89c6\u9891", value: "video" },
                ],
              },
              modal_contentAImg2: {
                label:
                  "\u7b2c\u4e8c\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentAVideo2: {
                label: "\u7b2c\u4e8c\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentADownImg2: {
                label:
                  "\u7b2c\u4e8c\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentADownVideo2: {
                label:
                  "\u7b2c\u4e8c\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
              modal_contentATitle3: {
                label: "\u7b2c\u4e09\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentADesc3: {
                label: "\u7b2c\u4e09\u5757\u6bb5\u843d",
                type: "string",
                content: "text",
              },
              modal_contentAType3: {
                label: "\u7b2c\u4e09\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  { label: "\u89c6\u9891", value: "video" },
                ],
              },
              modal_contentAVideoLoop3: {
                label:
                  "\u7b2c\u4e09\u5757\u89c6\u9891\u662f\u5426\u81ea\u52a8\u5faa\u73af",
                type: "boolean",
              },
              modal_contentAImg3: {
                label:
                  "\u7b2c\u4e09\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentAVideo3: {
                label: "\u7b2c\u4e09\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentADownImg3: {
                label:
                  "\u7b2c\u4e09\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentADownVideo3: {
                label:
                  "\u7b2c\u4e09\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
              modal_contentATitle4: {
                label: "\u7b2c\u56db\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentADesc4: {
                label: "\u7b2c\u56db\u5757\u6bb5\u843d",
                type: "string",
                content: "text",
              },
              modal_contentAType4: {
                label: "\u7b2c\u56db\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  { label: "\u89c6\u9891", value: "video" },
                ],
              },
              modal_contentAImg4: {
                label:
                  "\u7b2c\u56db\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentAVideo4: {
                label: "\u7b2c\u56db\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentADownImg4: {
                label:
                  "\u7b2c\u56db\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentADownVideo4: {
                label:
                  "\u7b2c\u56db\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
              modal_contentATitle5: {
                label: "\u7b2c\u4e94\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentADesc5: {
                label: "\u7b2c\u4e94\u5757\u6bb5\u843d",
                type: "string",
                content: "text",
              },
              modal_contentAType5: {
                label: "\u7b2c\u4e94\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  { label: "\u89c6\u9891", value: "video" },
                ],
              },
              modal_contentAVideoLoop5: {
                label:
                  "\u7b2c\u4e94\u5757\u89c6\u9891\u662f\u5426\u81ea\u52a8\u5faa\u73af",
                type: "boolean",
              },
              modal_contentAImg5: {
                label:
                  "\u7b2c\u4e94\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentAVideo5: {
                label: "\u7b2c\u4e94\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentADownImg5: {
                label:
                  "\u7b2c\u4e94\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentADownVideo5: {
                label:
                  "\u7b2c\u4e94\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
            },
          },
        },
        T = {
          modal_OpenBtnAText: "v3.260.modalbutton.contenta.openbtn",
          modal_contentATitle1: "v3.260.modalbutton.contenta.t1",
          modal_contentADesc1: "v3.260.modalbutton.contenta.d1",
          modal_contentAImg1:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentAType1: "image",
          modal_contentAVideo1: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentADownImg1:
            "https://www1.djicdn.com/dps/89074013d874ff8ce10acb8a9e51528c.jpg",
          modal_contentADownVideo1: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentATitle2: "v3.260.modalbutton.contenta.t2",
          modal_contentADesc2: "v3.260.modalbutton.contenta.d2",
          modal_contentAImg2:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentAType2: "image",
          modal_contentAVideo2: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentADownImg2:
            "https://www1.djicdn.com/dps/89074013d874ff8ce10acb8a9e51528c.jpg",
          modal_contentADownVideo2: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentATitle3: "v3.260.modalbutton.contenta.t3",
          modal_contentADesc3: "v3.260.modalbutton.contenta.d3",
          modal_contentAImg3:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentAType3: "image",
          modal_contentAVideo3: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentADownImg3:
            "https://www1.djicdn.com/dps/89074013d874ff8ce10acb8a9e51528c.jpg",
          modal_contentADownVideo3: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentATitle4: "v3.260.modalbutton.contenta.t4",
          modal_contentADesc4: "v3.260.modalbutton.contenta.d4",
          modal_contentAImg4:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentAType4: "image",
          modal_contentAVideo4: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentADownImg4:
            "https://www1.djicdn.com/dps/89074013d874ff8ce10acb8a9e51528c.jpg",
          modal_contentADownVideo4: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentATitle5: "v3.260.modalbutton.contenta.t5",
          modal_contentADesc5: "v3.260.modalbutton.contenta.d5",
          modal_contentAImg5:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentAType5: "video",
          modal_contentAVideo5: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentADownImg5:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentADownVideo5: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
        },
        C = (function (e) {
          function t() {
            var e;
            return (
              Object(o.default)(this, t),
              ((e = S(this, t)).state = {
                triggerPlay: !1,
                initVideo: !1,
                triggerPause: !1,
                videoDomInViewList: new Array(5).fill(!1),
              }),
              (e.videoBox = []),
              e
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(
              t,
              [
                {
                  key: "componentDidUpdate",
                  value: function (e, t) {
                    var n = this,
                      o = this.state.videoDomInViewList;
                    if (
                      !t.initVideo &&
                      this.state.initVideo &&
                      this.videoBox.length > 0
                    ) {
                      var a = Object(b.a)(o);
                      this.videoBox.forEach(function (e, t) {
                        Object(v.b)({
                          elm: e,
                          threshold: 0,
                          callback: function (o) {
                            if (
                              o.inView &&
                              "undefined" !== typeof document &&
                              !a[t]
                            ) {
                              var r = document.querySelector(
                                  "#".concat(e.id, " .modal-play-button"),
                                ),
                                i = document.querySelector(
                                  "#".concat(e.id, " .modal-pause-button"),
                                );
                              r &&
                                ((a[t] = !0),
                                n.setState({
                                  videoDomInViewList: Object(b.a)(a),
                                }),
                                (r.style.display = "none"),
                                i && (i.style.display = "block"));
                            }
                          },
                        });
                      });
                    }
                    e.modalShow &&
                      !this.props.modalShow &&
                      this.videoBox.length > 0 &&
                      this.videoBox.forEach(function (e) {
                        if ("undefined" !== typeof document) {
                          var t = document.querySelector(
                              "#".concat(e.id, " .modal-play-button"),
                            ),
                            n = document.querySelector(
                              "#".concat(e.id, " .modal-pause-button"),
                            ),
                            o = document.querySelector(
                              "#".concat(e.id, " .modal-replay-button"),
                            );
                          t &&
                            ((t.style.display = "block"),
                            n && (n.style.display = "none"),
                            o && (o.style.display = "none"));
                        }
                      });
                  },
                },
                { key: "componentWillUnmount", value: function () {} },
                {
                  key: "renderVideo",
                  value: function (e) {
                    var t = this,
                      n = this.props,
                      o = n.isMobile,
                      a = n.modalShow,
                      r = (this.state.triggerPlay, e.modal_contentAImg),
                      i = e.modal_contentADownImg,
                      l = e.modal_contentADownVideo,
                      s = e.modal_contentAVideo,
                      c = e.modal_contentAVideoLoop,
                      _ = e.inView,
                      u = Object(y.h)(),
                      d = l && l.path;
                    d || (d = s && s.path);
                    var p = O(
                      "div",
                      { className: "content__downgrade-video___AsXka" },
                      O("img", {
                        src: i || r,
                        className: "content__downgrade-pic___37etP",
                      }),
                      O(
                        w.a,
                        { link: d, isMobile: o },
                        O("div", {
                          className: "content__downgrade-play-btn___1C8hC",
                        }),
                      ),
                    );
                    return O(
                      g.a,
                      {
                        style: { height: "100%", width: "100%" },
                        triggerPlay: _,
                        triggerPause: _ && !a,
                        replayClassName: c ? "" : "modal-replay-button",
                        playClassName: "modal-play-button",
                        pauseClassName: "modal-pause-button",
                        loadingClassName: "modal-loading-button",
                        downgradeDom: p,
                      },
                      O(
                        "div",
                        {
                          className: "content__video___3iIO3",
                          "data-video": "once",
                        },
                        O(
                          "video",
                          {
                            muted: !0,
                            poster: r,
                            style: u ? { transform: "scale(1.1)" } : {},
                            loop: !!c,
                          },
                          O("source", {
                            type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                            src: s ? s.path : "",
                          }),
                        ),
                        !c &&
                          O("div", {
                            key: "replay",
                            "data-link": "ture",
                            className:
                              "modal-replay-button content__video-buttom___3zx2r content__replay-buttom___Rg4FG",
                            ref: function (e) {
                              t.replayBtn = e;
                            },
                          }),
                        O("div", {
                          key: "pause",
                          "data-link": "ture",
                          className:
                            "modal-pause-button content__video-buttom___3zx2r content__pause-buttom___3MrRD",
                          ref: function (e) {
                            t.pauseBtn = e;
                          },
                        }),
                        O("div", {
                          key: "play",
                          "data-link": "ture",
                          className:
                            "modal-play-button content__video-buttom___3zx2r content__play-buttom___1SrVY",
                          ref: function (e) {
                            t.playBtn = e;
                          },
                        }),
                        O(
                          "div",
                          {
                            className:
                              "modal-loading-button content__loading-buttom___1kuac",
                          },
                          O(k.a, { name: "circle-notch", spin: !0 }),
                        ),
                      ),
                    );
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var e = this,
                      t = this.props,
                      n = t.modalContent,
                      o = t.t,
                      a = t.isMobile,
                      r = t.id,
                      i = this.state,
                      l = i.initVideo,
                      s = i.videoDomInViewList,
                      c = "wm260-modal-content-a-".concat(r);
                    return O(
                      "div",
                      {
                        className: u()(
                          a
                            ? "modal-content-a modal-content-a-mobile"
                            : "modal-content-a",
                          I,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      O(
                        "div",
                        {
                          className: "content__content-a-item___1v0vA",
                          id: "".concat(c, "-0"),
                          ref: function (t) {
                            e.videoBox[0] = t;
                          },
                        },
                        O(
                          "div",
                          {
                            className: "content__content-a-item-scene___lcDpL",
                          },
                          l && "video" === n.modal_contentAType1
                            ? this.renderVideo({
                                modal_contentAImg: n.modal_contentAImg1,
                                modal_contentADownImg: n.modal_contentADownImg1,
                                modal_contentADownVideo:
                                  n.modal_contentADownVideo1,
                                modal_contentAVideo: n.modal_contentAVideo1,
                                inView: s[0],
                              })
                            : O(h.a, {
                                visibleByDefault: !0,
                                type: "img",
                                src: n.modal_contentAImg1,
                                className:
                                  "content__content-a-item-img___2gMoH",
                              }),
                        ),
                        O(
                          "div",
                          { className: "content__content-a-item-text___2rOFe" },
                          O("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentATitle1),
                            },
                          }),
                          O("p", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentADesc1),
                            },
                          }),
                        ),
                      ),
                      O("div", { className: "content__content-a-hr___1h394" }),
                      O(
                        "div",
                        {
                          className: "content__content-a-item___1v0vA",
                          id: "".concat(c, "-1"),
                          ref: function (t) {
                            e.videoBox[1] = t;
                          },
                        },
                        O(
                          "div",
                          { className: "content__content-a-item-text___2rOFe" },
                          O("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentATitle2),
                            },
                          }),
                          O("p", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentADesc2),
                            },
                          }),
                        ),
                        O(
                          "div",
                          {
                            className: "content__content-a-item-scene___lcDpL",
                          },
                          l && "video" === n.modal_contentAType2
                            ? this.renderVideo({
                                modal_contentAImg: n.modal_contentAImg2,
                                modal_contentADownImg: n.modal_contentADownImg2,
                                modal_contentADownVideo:
                                  n.modal_contentADownVideo2,
                                modal_contentAVideo: n.modal_contentAVideo2,
                                inView: s[1],
                              })
                            : O(h.a, {
                                visibleByDefault: !0,
                                type: "img",
                                src: n.modal_contentAImg2,
                                className:
                                  "content__content-a-item-img___2gMoH",
                              }),
                        ),
                      ),
                      O("div", { className: "content__content-a-hr___1h394" }),
                      O(
                        "div",
                        {
                          className: "content__content-a-item___1v0vA",
                          id: "".concat(c, "-2"),
                          ref: function (t) {
                            e.videoBox[2] = t;
                          },
                        },
                        O(
                          "div",
                          {
                            className: "content__content-a-item-scene___lcDpL",
                          },
                          l && "video" === n.modal_contentAType3
                            ? this.renderVideo({
                                modal_contentAImg: n.modal_contentAImg3,
                                modal_contentADownImg: n.modal_contentADownImg3,
                                modal_contentADownVideo:
                                  n.modal_contentADownVideo3,
                                modal_contentAVideo: n.modal_contentAVideo3,
                                modal_contentAVideoLoop:
                                  n.modal_contentAVideoLoop3,
                                inView: s[2],
                              })
                            : O(h.a, {
                                visibleByDefault: !0,
                                type: "img",
                                src: n.modal_contentAImg3,
                                className:
                                  "content__content-a-item-img___2gMoH",
                              }),
                        ),
                        O(
                          "div",
                          { className: "content__content-a-item-text___2rOFe" },
                          O("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentATitle3),
                            },
                          }),
                          O("p", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentADesc3),
                            },
                          }),
                        ),
                      ),
                      O("div", { className: "content__content-a-hr___1h394" }),
                      O(
                        "div",
                        {
                          className: "content__content-a-item___1v0vA",
                          id: "".concat(c, "-3"),
                          ref: function (t) {
                            e.videoBox[3] = t;
                          },
                        },
                        O(
                          "div",
                          { className: "content__content-a-item-text___2rOFe" },
                          O("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentATitle4),
                            },
                          }),
                          O("p", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentADesc4),
                            },
                          }),
                        ),
                        O(
                          "div",
                          {
                            className: "content__content-a-item-scene___lcDpL",
                          },
                          l && "video" === n.modal_contentAType4
                            ? this.renderVideo({
                                modal_contentAImg: n.modal_contentAImg4,
                                modal_contentADownImg: n.modal_contentADownImg4,
                                modal_contentADownVideo:
                                  n.modal_contentADownVideo4,
                                modal_contentAVideo: n.modal_contentAVideo4,
                                inView: s[3],
                              })
                            : O(h.a, {
                                visibleByDefault: !0,
                                type: "img",
                                src: n.modal_contentAImg4,
                                className:
                                  "content__content-a-item-img___2gMoH",
                              }),
                        ),
                      ),
                      O("div", { className: "content__content-a-hr___1h394" }),
                      O(
                        "div",
                        {
                          className: "content__content-a-item___1v0vA",
                          id: "".concat(c, "-4"),
                          ref: function (t) {
                            e.videoBox[4] = t;
                          },
                        },
                        O(
                          "div",
                          {
                            className: "content__content-a-item-scene___lcDpL",
                          },
                          l && "video" === n.modal_contentAType5
                            ? this.renderVideo({
                                modal_contentAImg: n.modal_contentAImg5,
                                modal_contentADownImg: n.modal_contentADownImg5,
                                modal_contentADownVideo:
                                  n.modal_contentADownVideo5,
                                modal_contentAVideo: n.modal_contentAVideo5,
                                modal_contentAVideoLoop:
                                  n.modal_contentAVideoLoop5,
                                inView: s[4],
                              })
                            : O(h.a, {
                                visibleByDefault: !0,
                                type: "img",
                                src: n.modal_contentAImg5,
                                className:
                                  "content__content-a-item-img___2gMoH",
                              }),
                        ),
                        O(
                          "div",
                          { className: "content__content-a-item-text___2rOFe" },
                          O("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentATitle5),
                            },
                          }),
                          O("p", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentADesc5),
                            },
                          }),
                        ),
                      ),
                    );
                  },
                },
              ],
              [
                {
                  key: "getDerivedStateFromProps",
                  value: function (e, t) {
                    return !t.initVideo && e.initVideo
                      ? { initVideo: !0 }
                      : null;
                  },
                },
              ],
            ),
            t
          );
        })(p.a.Component);
      Object(c.a)(C, "defaultProps", {
        t: function () {},
        isMobile: !1,
        initVideo: !1,
        modalShow: !1,
        modalContent: T,
      });
      var M = p.a.createElement,
        P = {
          "./content.css": {
            "modal-content-a": "content__modal-content-a___sV8Tx",
            "content-a-hr": "content__content-a-hr___1h394",
            "content-a-item": "content__content-a-item___1v0vA",
            "content-a-item-scene": "content__content-a-item-scene___lcDpL",
            "content-a-item-img": "content__content-a-item-img___2gMoH",
            "content-a-item-text": "content__content-a-item-text___2rOFe",
            video: "content__video___3iIO3",
            "video-buttom": "content__video-buttom___3zx2r",
            "replay-buttom": "content__replay-buttom___Rg4FG",
            "play-buttom": "content__play-buttom___1SrVY",
            "pause-buttom": "content__pause-buttom___3MrRD",
            "loading-buttom": "content__loading-buttom___1kuac",
            "downgrade-video": "content__downgrade-video___AsXka",
            "downgrade-play-btn": "content__downgrade-play-btn___1C8hC",
            "downgrade-pic": "content__downgrade-pic___37etP",
            "modal-content-a-mobile": "content__modal-content-a-mobile___HCDAw",
            "content-d-hr": "content__content-d-hr___3UJbe",
            "modal-content-b": "content__modal-content-b___1PJ2u",
            "content-b-scene": "content__content-b-scene___2gxbn",
            "content-b-img": "content__content-b-img___3BG8D",
            "content-b-item-video": "content__content-b-item-video___1uVAe",
            "content-b-item-text": "content__content-b-item-text___1xSJh",
            "content-b-hr": "content__content-b-hr___2D5Bj",
            "content-b-text": "content__content-b-text___1dLXo",
            "modal-content-b-mobile": "content__modal-content-b-mobile___12biZ",
            "modal-content-c": "content__modal-content-c___1WZAL",
            "content-c-scene": "content__content-c-scene___24dWD",
            "content-c-avatar": "content__content-c-avatar___Hch-G",
            "content-c-desc": "content__content-c-desc___1RbSC",
            "content-c-text": "content__content-c-text___1cV7c",
            "content-c-text-img": "content__content-c-text-img___sOk98",
            "content-c-text-desc": "content__content-c-text-desc___27Wao",
            "modal-content-c-mobile": "content__modal-content-c-mobile___1r-Fl",
            "content-d-item-text": "content__content-d-item-text___1IE6e",
            "content-d-item-text1": "content__content-d-item-text1___2_Kbi",
            "content-d-item-scene": "content__content-d-item-scene___2iBIx",
            "video-box-pop": "content__video-box-pop___zZz2b",
            "video-item": "content__video-item___3msSe",
            "video-button": "content__video-button___2EnF9",
            "video-box-pop-m": "content__video-box-pop-m___SL6nf",
            icon: "content__icon___2sOK-",
            "watch-video-icon": "content__watch-video-icon___1IQxS",
            "modal-content-e": "content__modal-content-e___2Mi6b",
            "content-e-scene": "content__content-e-scene___3U1la",
            "content-e-top-bg": "content__content-e-top-bg___3TnZr",
            "content-e-desc": "content__content-e-desc___k8WET",
            "content-e-section": "content__content-e-section___2GT7H",
            "content-e-section-1": "content__content-e-section-1___2xmvg",
            "content-e-features": "content__content-e-features___1kuYS",
            "content-e-feature": "content__content-e-feature___1PHJo",
            "content-e-icon": "content__content-e-icon___E0z_T",
            "content-e-section-2": "content__content-e-section-2___2U5WZ",
            "content-e-bg-1": "content__content-e-bg-1___1MHuJ",
            "content-e-bg-2": "content__content-e-bg-2___3gFhr",
            "content-e-section-3": "content__content-e-section-3___HAzzR",
            "content-e-cards": "content__content-e-cards___1cIdi",
            "content-e-card": "content__content-e-card___A_uPM",
            "content-e-section-4": "content__content-e-section-4___q1ANH",
            "modal-content-e-mobile": "content__modal-content-e-mobile___3sg9D",
            "modal-content-f": "content__modal-content-f___uOJ6S",
            "content-f-scene": "content__content-f-scene___IRexU",
            "content-f-top-bg": "content__content-f-top-bg___20WGC",
            "content-f-cards": "content__content-f-cards___3Lybz",
            "content-f-card": "content__content-f-card___EzJ4_",
            "content-f-card-title": "content__content-f-card-title___2mybz",
            "content-f-card-desc": "content__content-f-card-desc___19iIH",
            "modal-content-f-mobile": "content__modal-content-f-mobile___3dN1f",
          },
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
        };
      function E(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var L = {
          modalContent: {
            label: "\u5f39\u7a97\u914d\u7f6e",
            props: {
              modal_OpenBtnBText: {
                label: "\u6253\u5f00\u5f39\u7a97\u6309\u94ae\u6587\u6848",
                type: "string",
                content: "text",
              },
              modal_contentBImg: {
                label: "\u5f39\u7a97\u5185\u5bb9\u5c01\u9762\u56fe\u7247",
                type: "image",
              },
              modal_contentBText: {
                type: "array",
                label: "\u5f39\u7a97\u6587\u6848",
                key: "contentBText",
                props: {
                  title: {
                    content: "text",
                    type: "string",
                    key: "TextTitle",
                    label: "\u6587\u6848\u6807\u9898",
                  },
                  desc: {
                    content: "text",
                    type: "string",
                    key: "TextDesc",
                    label: "\u6587\u6848\u6bb5\u843d",
                  },
                  notShow: {
                    label:
                      "\u662f\u5426\u5728\u7279\u6b8a\u56fd\u5bb6\u4e0d\u5c55\u793a",
                    type: "boolean",
                  },
                  modal_has_video: {
                    label: "\u662f\u5426\u6709\u89c6\u9891",
                    type: "boolean",
                  },
                  onlyShowVideoInSpecialCountry: {
                    label:
                      "\u89c6\u9891\u662f\u5426\u53ea\u5728\u7279\u6b8a\u56fd\u5bb6\u5c55\u793a",
                    type: "boolean",
                  },
                  modal_contentImg: {
                    label:
                      "\u89c6\u9891\u5c01\u9762\u56fe\uff08pc\u7aef+m\u7aef\uff09",
                    type: "image",
                  },
                  modal_contentVideo: {
                    label:
                      "\u89c6\u9891\u94fe\u63a5\uff08pc\u7aef+m\u7aef\uff09",
                    type: "string",
                    content: "url",
                  },
                  modal_contentVideoLoop: {
                    label:
                      "\u89c6\u9891\u662f\u5426\u81ea\u52a8\u5faa\u73af\uff08m\u7aef\uff09",
                    type: "boolean",
                  },
                  modal_contentDownImg: {
                    label:
                      "\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                    type: "image",
                  },
                  modal_contentDownVideo: {
                    label:
                      "\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                    type: "string",
                    content: "url",
                  },
                },
              },
            },
          },
        },
        B = {
          modal_OpenBtnBText: "v3.260.modalbutton.contentb.openbtn",
          modal_contentBImg:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentBText: [
            {
              title: "v3.260.modalbutton.contentb.t1",
              desc: "v3.260.modalbutton.contentb.d1",
              notShow: !1,
            },
            {
              title: "v3.260.modalbutton.contentb.t2",
              desc: "v3.260.modalbutton.contentb.d2",
              notShow: !1,
            },
            {
              title: "v3.260.modalbutton.contentb.t3",
              desc: "v3.260.modalbutton.contentb.d3",
              notShow: !1,
            },
          ],
        },
        N = (function (e) {
          function t() {
            var e;
            return (
              Object(o.default)(this, t),
              ((e = E(this, t)).state = {
                initVideo: !1,
                videoDomInViewList: new Array(5).fill(!1),
              }),
              (e.videoBox = []),
              e
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(
              t,
              [
                {
                  key: "componentDidUpdate",
                  value: function (e, t) {
                    var n = this,
                      o = this.state.videoDomInViewList;
                    if (
                      !t.initVideo &&
                      this.state.initVideo &&
                      this.videoBox.length > 0
                    ) {
                      var a = Object(b.a)(o);
                      this.videoBox.forEach(function (e, t) {
                        if (e) {
                          Object(v.b)({
                            elm: e,
                            threshold: 0,
                            callback: function (o) {
                              if (
                                o.inView &&
                                "undefined" !== typeof document &&
                                !a[t]
                              ) {
                                var r = document.querySelector(
                                    "#".concat(e.id, " .modal-play-button"),
                                  ),
                                  i = document.querySelector(
                                    "#".concat(e.id, " .modal-pause-button"),
                                  );
                                r &&
                                  ((a[t] = !0),
                                  n.setState({
                                    videoDomInViewList: Object(b.a)(a),
                                  }),
                                  (r.style.display = "none"),
                                  i && (i.style.display = "block"));
                              }
                            },
                          });
                        }
                      });
                    }
                    e.modalShow &&
                      !this.props.modalShow &&
                      this.videoBox.length > 0 &&
                      this.videoBox.forEach(function (e) {
                        if (e && "undefined" !== typeof document) {
                          var t = document.querySelector(
                              "#".concat(e.id, " .modal-play-button"),
                            ),
                            n = document.querySelector(
                              "#".concat(e.id, " .modal-pause-button"),
                            ),
                            o = document.querySelector(
                              "#".concat(e.id, " .modal-replay-button"),
                            );
                          t &&
                            ((t.style.display = "block"),
                            n && (n.style.display = "none"),
                            o && (o.style.display = "none"));
                        }
                      });
                  },
                },
                {
                  key: "renderVideo",
                  value: function (e) {
                    var t = this,
                      n = this.props,
                      o = n.isMobile,
                      a = n.modalShow,
                      r = e.modal_contentImg,
                      i = e.modal_contentDownImg,
                      l = e.modal_contentDownVideo,
                      s = e.modal_contentVideo,
                      c = e.modal_contentVideoLoop,
                      _ = e.inView,
                      u = Object(y.h)(),
                      d = l && l.path;
                    d || (d = s && s.path);
                    var p = M(
                      "div",
                      { className: "content__downgrade-video___AsXka" },
                      M("img", {
                        src: i || r,
                        className: "content__downgrade-pic___37etP",
                      }),
                      M(
                        w.a,
                        { link: d, isMobile: o },
                        M("div", {
                          className: "content__downgrade-play-btn___1C8hC",
                        }),
                      ),
                    );
                    return M(
                      g.a,
                      {
                        style: { height: "100%", width: "100%" },
                        triggerPlay: _,
                        triggerPause: _ && !a,
                        replayClassName: c ? "" : "modal-replay-button",
                        playClassName: "modal-play-button",
                        pauseClassName: "modal-pause-button",
                        loadingClassName: "modal-b-loading-button",
                        downgradeDom: p,
                      },
                      M(
                        "div",
                        {
                          className: "content__video___3iIO3",
                          "data-video": "once",
                          style: { height: "100%" },
                        },
                        M(
                          "video",
                          {
                            muted: !0,
                            poster: r,
                            style: u ? { transform: "scale(1.1)" } : {},
                            loop: !!c,
                          },
                          M("source", {
                            type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                            src: s ? s.path : "",
                          }),
                        ),
                        !c &&
                          M("div", {
                            key: "replay",
                            "data-link": "ture",
                            className:
                              "modal-replay-button content__video-buttom___3zx2r content__replay-buttom___Rg4FG",
                            ref: function (e) {
                              t.replayBtn = e;
                            },
                          }),
                        M("div", {
                          key: "pause",
                          "data-link": "ture",
                          className:
                            "modal-pause-button content__video-buttom___3zx2r content__pause-buttom___3MrRD",
                          ref: function (e) {
                            t.pauseBtn = e;
                          },
                        }),
                        M("div", {
                          key: "play",
                          "data-link": "ture",
                          className:
                            "modal-play-button content__video-buttom___3zx2r content__play-buttom___1SrVY",
                          ref: function (e) {
                            t.playBtn = e;
                          },
                        }),
                        M(
                          "div",
                          {
                            className:
                              "modal-b-loading-button content__loading-buttom___1kuac",
                          },
                          M(k.a, { name: "circle-notch", spin: !0 }),
                        ),
                      ),
                    );
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var e = this,
                      t = this.state,
                      n = t.videoDomInViewList,
                      o = t.initVideo,
                      a = this.props,
                      r = a.modalContent,
                      i = a.t,
                      l = a.isMobile,
                      s = a.specialCountry,
                      c = a.isSpecialShowVideoCountry,
                      _ = a.id,
                      d = r.modal_contentBText || [],
                      p = "wm260-modal-content-b-".concat(_);
                    return M(
                      "div",
                      {
                        className: u()(
                          l
                            ? "modal-content-b modal-content-b-mobile"
                            : "modal-content-b",
                          P,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      M(
                        "div",
                        { className: "content__content-b-scene___2gxbn" },
                        M(h.a, {
                          type: "img",
                          visibleByDefault: !0,
                          src: r.modal_contentBImg,
                          className: "content__content-b-img___3BG8D",
                        }),
                      ),
                      M(
                        "div",
                        {
                          className: "content__content-b-text___1dLXo",
                          ref: function (t) {
                            e.contentBTextBox = t;
                          },
                        },
                        d.map(function (t, a) {
                          return s && t.notShow
                            ? null
                            : M(
                                "div",
                                {
                                  className:
                                    "content__content-b-item-text___1xSJh",
                                  key: a,
                                  id: "".concat(p, "-").concat(a),
                                  ref: function (t) {
                                    e.videoBox[a] = t;
                                  },
                                },
                                M("h4", {
                                  dangerouslySetInnerHTML: {
                                    __html: i(t.title),
                                  },
                                }),
                                M("p", {
                                  dangerouslySetInnerHTML: {
                                    __html: i(t.desc),
                                  },
                                }),
                                o &&
                                  t.modal_has_video &&
                                  (!t.onlyShowVideoInSpecialCountry || c) &&
                                  M(
                                    "div",
                                    {
                                      className:
                                        "content__content-b-item-video___1uVAe",
                                    },
                                    e.renderVideo({
                                      modal_contentImg: t.modal_contentImg,
                                      modal_contentDownImg:
                                        t.modal_contentDownImg,
                                      modal_contentDownVideo:
                                        t.modal_contentDownVideo,
                                      modal_contentVideo: t.modal_contentVideo,
                                      modal_contentVideoLoop:
                                        t.modal_contentVideoLoop,
                                      inView: n[a],
                                    }),
                                  ),
                                d.length - 1 === a
                                  ? null
                                  : M("div", {
                                      className:
                                        "content__content-b-hr___2D5Bj",
                                    }),
                              );
                        }),
                      ),
                    );
                  },
                },
              ],
              [
                {
                  key: "getDerivedStateFromProps",
                  value: function (e, t) {
                    return !t.initVideo && e.initVideo
                      ? { initVideo: !0 }
                      : null;
                  },
                },
              ],
            ),
            t
          );
        })(p.a.PureComponent);
      Object(c.a)(N, "defaultProps", {
        t: function () {},
        isMobile: !1,
        modalContent: B,
        specialCountry: !1,
        isSpecialShowVideoCountry: !1,
      });
      var D = p.a.createElement,
        z = {
          "./content.css": {
            "modal-content-a": "content__modal-content-a___sV8Tx",
            "content-a-hr": "content__content-a-hr___1h394",
            "content-a-item": "content__content-a-item___1v0vA",
            "content-a-item-scene": "content__content-a-item-scene___lcDpL",
            "content-a-item-img": "content__content-a-item-img___2gMoH",
            "content-a-item-text": "content__content-a-item-text___2rOFe",
            video: "content__video___3iIO3",
            "video-buttom": "content__video-buttom___3zx2r",
            "replay-buttom": "content__replay-buttom___Rg4FG",
            "play-buttom": "content__play-buttom___1SrVY",
            "pause-buttom": "content__pause-buttom___3MrRD",
            "loading-buttom": "content__loading-buttom___1kuac",
            "downgrade-video": "content__downgrade-video___AsXka",
            "downgrade-play-btn": "content__downgrade-play-btn___1C8hC",
            "downgrade-pic": "content__downgrade-pic___37etP",
            "modal-content-a-mobile": "content__modal-content-a-mobile___HCDAw",
            "content-d-hr": "content__content-d-hr___3UJbe",
            "modal-content-b": "content__modal-content-b___1PJ2u",
            "content-b-scene": "content__content-b-scene___2gxbn",
            "content-b-img": "content__content-b-img___3BG8D",
            "content-b-item-video": "content__content-b-item-video___1uVAe",
            "content-b-item-text": "content__content-b-item-text___1xSJh",
            "content-b-hr": "content__content-b-hr___2D5Bj",
            "content-b-text": "content__content-b-text___1dLXo",
            "modal-content-b-mobile": "content__modal-content-b-mobile___12biZ",
            "modal-content-c": "content__modal-content-c___1WZAL",
            "content-c-scene": "content__content-c-scene___24dWD",
            "content-c-avatar": "content__content-c-avatar___Hch-G",
            "content-c-desc": "content__content-c-desc___1RbSC",
            "content-c-text": "content__content-c-text___1cV7c",
            "content-c-text-img": "content__content-c-text-img___sOk98",
            "content-c-text-desc": "content__content-c-text-desc___27Wao",
            "modal-content-c-mobile": "content__modal-content-c-mobile___1r-Fl",
            "content-d-item-text": "content__content-d-item-text___1IE6e",
            "content-d-item-text1": "content__content-d-item-text1___2_Kbi",
            "content-d-item-scene": "content__content-d-item-scene___2iBIx",
            "video-box-pop": "content__video-box-pop___zZz2b",
            "video-item": "content__video-item___3msSe",
            "video-button": "content__video-button___2EnF9",
            "video-box-pop-m": "content__video-box-pop-m___SL6nf",
            icon: "content__icon___2sOK-",
            "watch-video-icon": "content__watch-video-icon___1IQxS",
            "modal-content-e": "content__modal-content-e___2Mi6b",
            "content-e-scene": "content__content-e-scene___3U1la",
            "content-e-top-bg": "content__content-e-top-bg___3TnZr",
            "content-e-desc": "content__content-e-desc___k8WET",
            "content-e-section": "content__content-e-section___2GT7H",
            "content-e-section-1": "content__content-e-section-1___2xmvg",
            "content-e-features": "content__content-e-features___1kuYS",
            "content-e-feature": "content__content-e-feature___1PHJo",
            "content-e-icon": "content__content-e-icon___E0z_T",
            "content-e-section-2": "content__content-e-section-2___2U5WZ",
            "content-e-bg-1": "content__content-e-bg-1___1MHuJ",
            "content-e-bg-2": "content__content-e-bg-2___3gFhr",
            "content-e-section-3": "content__content-e-section-3___HAzzR",
            "content-e-cards": "content__content-e-cards___1cIdi",
            "content-e-card": "content__content-e-card___A_uPM",
            "content-e-section-4": "content__content-e-section-4___q1ANH",
            "modal-content-e-mobile": "content__modal-content-e-mobile___3sg9D",
            "modal-content-f": "content__modal-content-f___uOJ6S",
            "content-f-scene": "content__content-f-scene___IRexU",
            "content-f-top-bg": "content__content-f-top-bg___20WGC",
            "content-f-cards": "content__content-f-cards___3Lybz",
            "content-f-card": "content__content-f-card___EzJ4_",
            "content-f-card-title": "content__content-f-card-title___2mybz",
            "content-f-card-desc": "content__content-f-card-desc___19iIH",
            "modal-content-f-mobile": "content__modal-content-f-mobile___3dN1f",
          },
        };
      function A(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var R = {
          modalContent: {
            label: "\u5f39\u7a97\u914d\u7f6e",
            props: {
              modal_OpenBtnCText: {
                label: "\u6253\u5f00\u5f39\u7a97\u6309\u94ae\u6587\u6848",
                type: "string",
                content: "text",
              },
              modal_contentCAvatar: {
                label: "\u4f5c\u8005\u5934\u50cf",
                type: "image",
              },
              modal_contentCName: {
                label: "\u4f5c\u8005\u59d3\u540d",
                type: "string",
                content: "text",
              },
              modal_contentCDesc: {
                label: "\u4f5c\u8005\u7b80\u4ecb",
                type: "string",
                content: "text",
              },
              modal_contentCSamplePic_1: {
                type: "array",
                label: "\u6837\u5f201\u56fe\u7247",
                key: "pic1",
                props: {
                  pic: {
                    type: "image",
                    label: "\u6837\u5f201\u56fe\u7247",
                    key: "pic",
                  },
                },
              },
              modal_contentCSampleText_1: {
                type: "array",
                label: "\u6837\u5f201\u6587\u6848",
                key: "text1",
                props: {
                  desc: {
                    content: "text",
                    type: "string",
                    key: "text",
                    label: "\u6837\u5f201\u6587\u6848",
                  },
                },
              },
              modal_contentCSamplePic_2: {
                type: "array",
                label: "\u6837\u5f202\u56fe\u7247",
                key: "pic1",
                props: {
                  pic: {
                    type: "image",
                    label: "\u6837\u5f202\u56fe\u7247",
                    key: "pic",
                  },
                },
              },
              modal_contentCSampleText_2: {
                type: "array",
                label: "\u6837\u5f202\u6587\u6848",
                key: "text1",
                props: {
                  desc: {
                    content: "text",
                    type: "string",
                    key: "text",
                    label: "\u6837\u5f202\u6587\u6848",
                  },
                },
              },
              modal_contentCSamplePic_3: {
                type: "array",
                label: "\u6837\u5f203\u56fe\u7247",
                key: "pic1",
                props: {
                  pic: {
                    type: "image",
                    label: "\u6837\u5f203\u56fe\u7247",
                    key: "pic",
                  },
                },
              },
              modal_contentCSampleText_3: {
                type: "array",
                label: "\u6837\u5f203\u6587\u6848",
                key: "text1",
                props: {
                  desc: {
                    content: "text",
                    type: "string",
                    key: "text",
                    label: "\u6837\u5f203\u6587\u6848",
                  },
                },
              },
              modal_contentCSamplePic_4: {
                type: "array",
                label: "\u6837\u5f204\u56fe\u7247",
                key: "pic1",
                props: {
                  pic: {
                    type: "image",
                    label: "\u6837\u5f204\u56fe\u7247",
                    key: "pic",
                  },
                },
              },
              modal_contentCSampleText_4: {
                type: "array",
                label: "\u6837\u5f204\u6587\u6848",
                key: "text1",
                props: {
                  desc: {
                    content: "text",
                    type: "string",
                    key: "text",
                    label: "\u6837\u5f204\u6587\u6848",
                  },
                },
              },
            },
          },
        },
        F = {
          modal_OpenBtnCText: "v3.260.modalbutton.contentC.openbtn",
          modal_contentCAvatar:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentCName: "v3.260.modalbutton.contentc.name",
          modal_contentCDesc: "v3.260.modalbutton.contentc.desc",
          modal_contentCSamplePic_1: [
            {
              pic: "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
            },
          ],
          modal_contentCSampleText_1: [
            { desc: "v3.260.modalbutton.contentc.sample1.desc" },
          ],
          modal_contentCSamplePic_2: [
            {
              pic: "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
            },
          ],
          modal_contentCSampleText_2: [
            { desc: "v3.260.modalbutton.contentc.sample2.desc" },
            { desc: "v3.260.modalbutton.contentc.sample2.desc" },
          ],
          modal_contentCSamplePic_3: [
            {
              pic: "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
            },
          ],
          modal_contentCSampleText_3: [
            { desc: "v3.260.modalbutton.contentc.sample3.desc" },
          ],
          modal_contentCSamplePic_4: [
            {
              pic: "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
            },
          ],
          modal_contentCSampleText_4: [
            { desc: "v3.260.modalbutton.contentc.sample4.desc" },
          ],
        },
        V = (function (e) {
          function t() {
            return Object(o.default)(this, t), A(this, t, arguments);
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.modalContent,
                    n = e.t,
                    o = e.isMobile;
                  t.modal_contentCText;
                  return D(
                    "div",
                    {
                      className: u()(
                        o
                          ? "modal-content-c modal-content-c-mobile"
                          : "modal-content-c",
                        z,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    D(
                      "div",
                      { className: "content__content-c-scene___24dWD" },
                      D(h.a, {
                        visibleByDefault: !0,
                        type: "img",
                        src: t.modal_contentCAvatar,
                        className: "content__content-c-avatar___Hch-G",
                      }),
                      D(
                        "div",
                        { className: "content__content-c-desc___1RbSC" },
                        D("h4", {
                          dangerouslySetInnerHTML: {
                            __html: n(t.modal_contentCName),
                          },
                        }),
                        D("p", {
                          dangerouslySetInnerHTML: {
                            __html: n(t.modal_contentCDesc),
                          },
                        }),
                      ),
                    ),
                    D(
                      "div",
                      { className: "content__content-c-text___1cV7c" },
                      t.modal_contentCSampleText_1 &&
                        t.modal_contentCSampleText_1.length
                        ? D(
                            "div",
                            {
                              className: "content__content-c-text-desc___27Wao",
                            },
                            t.modal_contentCSampleText_1.map(function (e) {
                              return D("p", {
                                dangerouslySetInnerHTML: { __html: n(e.desc) },
                              });
                            }),
                          )
                        : null,
                      t.modal_contentCSamplePic_1 &&
                        t.modal_contentCSamplePic_1.length
                        ? t.modal_contentCSamplePic_1.map(function (e) {
                            return D(h.a, {
                              visibleByDefault: !0,
                              type: "img",
                              src: e.pic,
                              className: "content__content-c-text-img___sOk98",
                            });
                          })
                        : null,
                      t.modal_contentCSampleText_2 &&
                        t.modal_contentCSampleText_2.length
                        ? D(
                            "div",
                            {
                              className: "content__content-c-text-desc___27Wao",
                            },
                            t.modal_contentCSampleText_2.map(function (e) {
                              return D("p", {
                                dangerouslySetInnerHTML: { __html: n(e.desc) },
                              });
                            }),
                          )
                        : null,
                      t.modal_contentCSamplePic_2 &&
                        t.modal_contentCSamplePic_2.length
                        ? t.modal_contentCSamplePic_2.map(function (e) {
                            return D(h.a, {
                              visibleByDefault: !0,
                              type: "img",
                              src: e.pic,
                              className: "content__content-c-text-img___sOk98",
                            });
                          })
                        : null,
                      t.modal_contentCSampleText_3 &&
                        t.modal_contentCSampleText_3.length
                        ? D(
                            "div",
                            {
                              className: "content__content-c-text-desc___27Wao",
                            },
                            t.modal_contentCSampleText_3.map(function (e) {
                              return D("p", {
                                dangerouslySetInnerHTML: { __html: n(e.desc) },
                              });
                            }),
                          )
                        : null,
                      t.modal_contentCSamplePic_3 &&
                        t.modal_contentCSamplePic_3.length
                        ? t.modal_contentCSamplePic_3.map(function (e) {
                            return D(h.a, {
                              visibleByDefault: !0,
                              type: "img",
                              src: e.pic,
                              className: "content__content-c-text-img___sOk98",
                            });
                          })
                        : null,
                      t.modal_contentCSampleText_4 &&
                        t.modal_contentCSampleText_4.length
                        ? D(
                            "div",
                            {
                              className: "content__content-c-text-desc___27Wao",
                            },
                            t.modal_contentCSampleText_4.map(function (e) {
                              return D("p", {
                                dangerouslySetInnerHTML: { __html: n(e.desc) },
                              });
                            }),
                          )
                        : null,
                      t.modal_contentCSamplePic_4 &&
                        t.modal_contentCSamplePic_4.length
                        ? t.modal_contentCSamplePic_4.map(function (e) {
                            return D(h.a, {
                              visibleByDefault: !0,
                              type: "img",
                              src: e.pic,
                              className: "content__content-c-text-img___sOk98",
                            });
                          })
                        : null,
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(p.a.PureComponent);
      Object(c.a)(V, "defaultProps", {
        t: function () {},
        isMobile: !1,
        modalContent: F,
      });
      var H = p.a.createElement,
        W = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./content.css": {
            "modal-content-a": "content__modal-content-a___sV8Tx",
            "content-a-hr": "content__content-a-hr___1h394",
            "content-a-item": "content__content-a-item___1v0vA",
            "content-a-item-scene": "content__content-a-item-scene___lcDpL",
            "content-a-item-img": "content__content-a-item-img___2gMoH",
            "content-a-item-text": "content__content-a-item-text___2rOFe",
            video: "content__video___3iIO3",
            "video-buttom": "content__video-buttom___3zx2r",
            "replay-buttom": "content__replay-buttom___Rg4FG",
            "play-buttom": "content__play-buttom___1SrVY",
            "pause-buttom": "content__pause-buttom___3MrRD",
            "loading-buttom": "content__loading-buttom___1kuac",
            "downgrade-video": "content__downgrade-video___AsXka",
            "downgrade-play-btn": "content__downgrade-play-btn___1C8hC",
            "downgrade-pic": "content__downgrade-pic___37etP",
            "modal-content-a-mobile": "content__modal-content-a-mobile___HCDAw",
            "content-d-hr": "content__content-d-hr___3UJbe",
            "modal-content-b": "content__modal-content-b___1PJ2u",
            "content-b-scene": "content__content-b-scene___2gxbn",
            "content-b-img": "content__content-b-img___3BG8D",
            "content-b-item-video": "content__content-b-item-video___1uVAe",
            "content-b-item-text": "content__content-b-item-text___1xSJh",
            "content-b-hr": "content__content-b-hr___2D5Bj",
            "content-b-text": "content__content-b-text___1dLXo",
            "modal-content-b-mobile": "content__modal-content-b-mobile___12biZ",
            "modal-content-c": "content__modal-content-c___1WZAL",
            "content-c-scene": "content__content-c-scene___24dWD",
            "content-c-avatar": "content__content-c-avatar___Hch-G",
            "content-c-desc": "content__content-c-desc___1RbSC",
            "content-c-text": "content__content-c-text___1cV7c",
            "content-c-text-img": "content__content-c-text-img___sOk98",
            "content-c-text-desc": "content__content-c-text-desc___27Wao",
            "modal-content-c-mobile": "content__modal-content-c-mobile___1r-Fl",
            "content-d-item-text": "content__content-d-item-text___1IE6e",
            "content-d-item-text1": "content__content-d-item-text1___2_Kbi",
            "content-d-item-scene": "content__content-d-item-scene___2iBIx",
            "video-box-pop": "content__video-box-pop___zZz2b",
            "video-item": "content__video-item___3msSe",
            "video-button": "content__video-button___2EnF9",
            "video-box-pop-m": "content__video-box-pop-m___SL6nf",
            icon: "content__icon___2sOK-",
            "watch-video-icon": "content__watch-video-icon___1IQxS",
            "modal-content-e": "content__modal-content-e___2Mi6b",
            "content-e-scene": "content__content-e-scene___3U1la",
            "content-e-top-bg": "content__content-e-top-bg___3TnZr",
            "content-e-desc": "content__content-e-desc___k8WET",
            "content-e-section": "content__content-e-section___2GT7H",
            "content-e-section-1": "content__content-e-section-1___2xmvg",
            "content-e-features": "content__content-e-features___1kuYS",
            "content-e-feature": "content__content-e-feature___1PHJo",
            "content-e-icon": "content__content-e-icon___E0z_T",
            "content-e-section-2": "content__content-e-section-2___2U5WZ",
            "content-e-bg-1": "content__content-e-bg-1___1MHuJ",
            "content-e-bg-2": "content__content-e-bg-2___3gFhr",
            "content-e-section-3": "content__content-e-section-3___HAzzR",
            "content-e-cards": "content__content-e-cards___1cIdi",
            "content-e-card": "content__content-e-card___A_uPM",
            "content-e-section-4": "content__content-e-section-4___q1ANH",
            "modal-content-e-mobile": "content__modal-content-e-mobile___3sg9D",
            "modal-content-f": "content__modal-content-f___uOJ6S",
            "content-f-scene": "content__content-f-scene___IRexU",
            "content-f-top-bg": "content__content-f-top-bg___20WGC",
            "content-f-cards": "content__content-f-cards___3Lybz",
            "content-f-card": "content__content-f-card___EzJ4_",
            "content-f-card-title": "content__content-f-card-title___2mybz",
            "content-f-card-desc": "content__content-f-card-desc___19iIH",
            "modal-content-f-mobile": "content__modal-content-f-mobile___3dN1f",
          },
        };
      function U(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var G = {
          modalContent: {
            label: "\u5f39\u7a97\u914d\u7f6e",
            props: {
              modal_OpenBtnDText: {
                label: "\u6253\u5f00\u5f39\u7a97\u6309\u94ae\u6587\u6848",
                type: "string",
                content: "text",
              },
              modal_contentDTitle1: {
                label: "\u7b2c\u4e00\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentDDesc1: {
                label: "\u7b2c\u4e00\u5757\u6bb5\u843d",
                type: "string",
                content: "text",
              },
              modal_contentDTitle2: {
                label: "\u7b2c\u4e8c\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentDType2: {
                label: "\u7b2c\u4e8c\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  {
                    label: "\u89c6\u9891-\u70b9\u51fb\u64ad\u653e",
                    value: "video_click",
                  },
                  {
                    label:
                      "\u89c6\u9891-\u975e\u70b9\u51fb\u64ad\u653e-\u81ea\u52a8\u5faa\u73af",
                    value: "video_noclick_loop",
                  },
                  {
                    label:
                      "\u89c6\u9891-\u975e\u70b9\u51fb\u64ad\u653e-\u4e0d\u81ea\u52a8\u5faa\u73af",
                    value: "video_noclick_noloop",
                  },
                ],
              },
              modal_contentDImg2: {
                label:
                  "\u7b2c\u4e8c\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentDVideo2: {
                label: "\u7b2c\u4e8c\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentDDownImg2: {
                label:
                  "\u7b2c\u4e8c\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentDDownVideo2: {
                label:
                  "\u7b2c\u4e8c\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
              modal_contentDTitle3: {
                label: "\u7b2c\u4e09\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentDType3: {
                label: "\u7b2c\u4e09\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  {
                    label: "\u89c6\u9891-\u70b9\u51fb\u64ad\u653e",
                    value: "video_click",
                  },
                  {
                    label:
                      "\u89c6\u9891-\u975e\u70b9\u51fb\u64ad\u653e-\u81ea\u52a8\u5faa\u73af",
                    value: "video_noclick_loop",
                  },
                  {
                    label:
                      "\u89c6\u9891-\u975e\u70b9\u51fb\u64ad\u653e-\u4e0d\u81ea\u52a8\u5faa\u73af",
                    value: "video_noclick_noloop",
                  },
                ],
              },
              modal_contentDImg3: {
                label:
                  "\u7b2c\u4e09\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentDVideo3: {
                label: "\u7b2c\u4e09\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentDDownImg3: {
                label:
                  "\u7b2c\u4e09\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentDDownVideo3: {
                label:
                  "\u7b2c\u4e09\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
              modal_contentDTitle4: {
                label: "\u7b2c\u56db\u5757\u6807\u9898",
                type: "string",
                content: "text",
              },
              modal_contentDType4: {
                label: "\u7b2c\u56db\u5757\u5a92\u4f53\u7c7b\u578b",
                type: "select",
                items: [
                  { label: "\u56fe\u7247", value: "image" },
                  {
                    label: "\u89c6\u9891-\u70b9\u51fb\u64ad\u653e",
                    value: "video_click",
                  },
                  {
                    label:
                      "\u89c6\u9891-\u975e\u70b9\u51fb\u64ad\u653e-\u81ea\u52a8\u5faa\u73af",
                    value: "video_noclick_loop",
                  },
                  {
                    label:
                      "\u89c6\u9891-\u975e\u70b9\u51fb\u64ad\u653e-\u4e0d\u81ea\u52a8\u5faa\u73af",
                    value: "video_noclick_noloop",
                  },
                ],
              },
              modal_contentDImg4: {
                label:
                  "\u7b2c\u56db\u5757\u56fe\u7247 - \u5fc5\u586b\uff0c\u5a92\u4f53\u7c7b\u578b\u4e3a\u56fe\u7247\u65f6\u662f\u56fe\u7247\uff0c\u662f\u89c6\u9891\u65f6\u662f\u5c01\u9762\u56fe",
                type: "image",
              },
              modal_contentDVideo4: {
                label: "\u7b2c\u56db\u5757\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              modal_contentDDownImg4: {
                label:
                  "\u7b2c\u56db\u5757\u964d\u7ea7\u89c6\u9891\u5c01\u9762\uff08m\u7aef\uff09",
                type: "image",
              },
              modal_contentDDownVideo4: {
                label:
                  "\u7b2c\u56db\u5757\u964d\u7ea7\u89c6\u9891\u94fe\u63a5\uff08m\u7aef\uff09",
                type: "string",
                content: "url",
              },
            },
          },
        },
        Y = {
          modal_OpenBtnDText: "v3.260.modalbutton.contentd.openbtn",
          modal_contentDTitle1: "v3.260.modalbutton.contentd.t1",
          modal_contentDDesc1: "v3.260.modalbutton.contentd.d1",
          modal_contentDTitle2: "v3.260.modalbutton.contentd.t2",
          modal_contentDImg2:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentDType2: "image",
          modal_contentDVideo2: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentDDownImg2:
            "https://www1.djicdn.com/dps/89074013d874ff8ce10acb8a9e51528c.jpg",
          modal_contentDDownVideo2: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentDTitle3: "v3.260.modalbutton.contentd.t3",
          modal_contentDImg3:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentDType3: "video",
          modal_contentDVideo3: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentDDownImg3:
            "https://www1.djicdn.com/dps/89074013d874ff8ce10acb8a9e51528c.jpg",
          modal_contentDDownVideo3: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentDTitle4: "v3.260.modalbutton.contentd.t4",
          modal_contentDImg4:
            "https://www1.djicdn.com/dps/89074015d874ff8ce10acb8a9e51528c.jpg",
          modal_contentDType4: "video",
          modal_contentDVideo4: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
          modal_contentDDownImg4:
            "https://www1.djicdn.com/dps/89074013d874ff8ce10acb8a9e51528c.jpg",
          modal_contentDDownVideo4: {
            path: "https://www1.djicdn.com/reactor/assets/_next/static/videos/1621d2c2-bc12-42ed-90b1-b319dd1489ad.mp4",
          },
        },
        q = (function (e) {
          function t() {
            var e;
            return (
              Object(o.default)(this, t),
              ((e = U(this, t)).state = {
                initVideo: !1,
                videoDomInViewList: new Array(5).fill(!1),
              }),
              (e.videoBox = []),
              (e.videoDom = []),
              (e.videoPlayIcon = []),
              e
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(
              t,
              [
                {
                  key: "componentDidUpdate",
                  value: function (e, t) {
                    var n = this,
                      o = this.state.videoDomInViewList;
                    if (
                      !t.initVideo &&
                      this.state.initVideo &&
                      this.videoBox.length > 0
                    ) {
                      var a = Object(b.a)(o);
                      this.videoBox.forEach(function (e, t) {
                        Object(v.b)({
                          elm: e,
                          threshold: 0,
                          callback: function (o) {
                            if (
                              o.inView &&
                              "undefined" !== typeof document &&
                              !a[t]
                            ) {
                              var r = document.querySelector(
                                  "#".concat(e.id, " .modal-play-button"),
                                ),
                                i = document.querySelector(
                                  "#".concat(e.id, " .modal-pause-button"),
                                );
                              r &&
                                ((a[t] = !0),
                                n.setState({
                                  videoDomInViewList: Object(b.a)(a),
                                }),
                                (r.style.display = "none"),
                                i && (i.style.display = "block"));
                            }
                          },
                        });
                      });
                    }
                    e.modalShow &&
                      !this.props.modalShow &&
                      this.videoBox.length > 0 &&
                      this.videoBox.forEach(function (e) {
                        if ("undefined" !== typeof document) {
                          var t = document.querySelector(
                              "#".concat(e.id, " .modal-play-button"),
                            ),
                            n = document.querySelector(
                              "#".concat(e.id, " .modal-pause-button"),
                            ),
                            o = document.querySelector(
                              "#".concat(e.id, " .modal-replay-button"),
                            );
                          t &&
                            ((t.style.display = "block"),
                            n && (n.style.display = "none"),
                            o && (o.style.display = "none"));
                        }
                      });
                  },
                },
                { key: "componentWillUnmount", value: function () {} },
                {
                  key: "handlePlay",
                  value: function (e) {
                    var t = this;
                    this.videoDom[e] &&
                      this.videoDom[e].paused &&
                      (this.videoDom[e].setAttribute("controls", !0),
                      setTimeout(function () {
                        t.videoDom[e].play();
                      }, 10),
                      (this.videoPlayIcon[e].style.opacity = 0));
                  },
                },
                {
                  key: "renderVideo",
                  value: function (e) {
                    var t = this,
                      n = this.props,
                      o = n.isMobile,
                      a = n.modalShow,
                      r = e.modal_contentDImg,
                      i = e.modal_contentDDownImg,
                      l = e.modal_contentDDownVideo,
                      s = e.modal_contentDVideo,
                      c = e.modal_contentDVideoLoop,
                      _ = e.inView,
                      u = Object(y.h)(),
                      d = l && l.path;
                    d || (d = s && s.path);
                    var p = H(
                      "div",
                      { className: "content__downgrade-video___AsXka" },
                      H("img", {
                        alt: "",
                        src: i || r,
                        className: "content__downgrade-pic___37etP",
                      }),
                      H(
                        w.a,
                        { link: d, isMobile: o },
                        H("div", {
                          className: "content__downgrade-play-btn___1C8hC",
                        }),
                      ),
                    );
                    return H(
                      g.a,
                      {
                        style: { height: "100%", width: "100%" },
                        triggerPlay: _,
                        triggerPause: _ && !a,
                        replayClassName: c ? "" : "modal-replay-button",
                        playClassName: "modal-play-button",
                        pauseClassName: "modal-pause-button",
                        loadingClassName: "modal-loading-button",
                        downgradeDom: p,
                      },
                      H(
                        "div",
                        {
                          className: "content__video___3iIO3",
                          "data-video": "once",
                        },
                        H(
                          "video",
                          {
                            muted: !0,
                            poster: r,
                            style: u ? { transform: "scale(1.1)" } : {},
                            loop: !!c,
                          },
                          H("source", {
                            type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                            src: s ? s.path : "",
                          }),
                        ),
                        !c &&
                          H("div", {
                            key: "replay",
                            "data-link": "ture",
                            className:
                              "modal-replay-button content__video-buttom___3zx2r content__replay-buttom___Rg4FG",
                            ref: function (e) {
                              t.replayBtn = e;
                            },
                          }),
                        H("div", {
                          key: "pause",
                          "data-link": "ture",
                          className:
                            "modal-pause-button content__video-buttom___3zx2r content__pause-buttom___3MrRD",
                          ref: function (e) {
                            t.pauseBtn = e;
                          },
                        }),
                        H("div", {
                          key: "play",
                          "data-link": "ture",
                          className:
                            "modal-play-button content__video-buttom___3zx2r content__play-buttom___1SrVY",
                          ref: function (e) {
                            t.playBtn = e;
                          },
                        }),
                        H(
                          "div",
                          {
                            className:
                              "modal-loading-button content__loading-buttom___1kuac",
                          },
                          H(k.a, { name: "circle-notch", spin: !0 }),
                        ),
                      ),
                    );
                  },
                },
                {
                  key: "renderClickVideo",
                  value: function (e, t) {
                    var n = this,
                      o = this.props.isMobile,
                      a = e.modal_contentDImg,
                      r = e.modal_contentDDownImg,
                      i = e.modal_contentDDownVideo,
                      l = e.modal_contentDVideo,
                      s = i && i.path;
                    return (
                      s || (s = l && l.path),
                      H(
                        "div",
                        {
                          className: u()(
                            o
                              ? "video-box-pop video-box-pop-m"
                              : "video-box-pop",
                            W,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                        },
                        o
                          ? H(
                              w.a,
                              { link: s, isMobile: !0 },
                              H(h.a, {
                                type: "img",
                                src: r || a,
                                tagType: "div",
                                className: "",
                              }),
                              H(
                                "div",
                                { className: "content__video-button___2EnF9" },
                                H("i", { className: "content__icon___2sOK-" }),
                              ),
                            )
                          : H(
                              "div",
                              {
                                className: "content__video-item___3msSe",
                                onClick: this.handlePlay.bind(this, t),
                                style: { height: "100%", width: "100%" },
                              },
                              H(
                                "video",
                                {
                                  poster: a,
                                  ref: function (e) {
                                    n.videoDom[t] = e;
                                  },
                                  playsinline: "true",
                                  "webkit-playsinline": "true",
                                  "x5-playsinline": "true",
                                },
                                H("source", {
                                  type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                                  src: l ? l.path : "",
                                }),
                              ),
                              H(
                                "div",
                                {
                                  className: "content__video-button___2EnF9",
                                  ref: function (e) {
                                    n.videoPlayIcon[t] = e;
                                  },
                                },
                                H(
                                  "span",
                                  {
                                    className:
                                      "content__watch-video-icon___1IQxS",
                                  },
                                  H(k.a, {
                                    weight: "solid",
                                    name: "fa-solid-play",
                                  }),
                                ),
                              ),
                            ),
                      )
                    );
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var e = this,
                      t = this.props,
                      n = t.modalContent,
                      o = t.t,
                      a = t.isMobile,
                      r = t.id,
                      i = this.state,
                      l = i.initVideo,
                      s = i.videoDomInViewList,
                      c = "wm260-modal-content-d-".concat(r);
                    return H(
                      "div",
                      {
                        className: u()(
                          a
                            ? "modal-content-a modal-content-a-mobile"
                            : "modal-content-a",
                          W,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      H(
                        "div",
                        {
                          className: "",
                          id: "".concat(c, "-0"),
                          ref: function (t) {
                            e.videoBox[0] = t;
                          },
                        },
                        H(
                          "div",
                          {
                            className:
                              "content__content-d-item-text___1IE6e content__content-d-item-text1___2_Kbi",
                          },
                          H("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentDTitle1),
                            },
                          }),
                          H("p", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentDDesc1),
                            },
                          }),
                        ),
                      ),
                      H("div", { className: "content__content-d-hr___3UJbe" }),
                      H(
                        "div",
                        {
                          className: "",
                          id: "".concat(c, "-1"),
                          ref: function (t) {
                            e.videoBox[1] = t;
                          },
                        },
                        H(
                          "div",
                          { className: "content__content-d-item-text___1IE6e" },
                          H("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentDTitle2),
                            },
                          }),
                        ),
                        H(
                          "div",
                          {
                            className: "content__content-d-item-scene___2iBIx",
                          },
                          !l ||
                            ("video_noclick_loop" !== n.modal_contentDType2 &&
                              "video_noclick_noloop" !== n.modal_contentDType2)
                            ? l && "video_click" === n.modal_contentDType2
                              ? this.renderClickVideo(
                                  {
                                    modal_contentDImg: n.modal_contentDImg2,
                                    modal_contentDDownImg:
                                      n.modal_contentDDownImg2,
                                    modal_contentDDownVideo:
                                      n.modal_contentDDownVideo2,
                                    modal_contentDVideo: n.modal_contentDVideo2,
                                    inView: s[1],
                                  },
                                  1,
                                )
                              : H(h.a, {
                                  visibleByDefault: !0,
                                  type: "img",
                                  src: n.modal_contentDImg2,
                                  className: "",
                                })
                            : this.renderVideo({
                                modal_contentDImg: n.modal_contentDImg2,
                                modal_contentDDownImg: n.modal_contentDDownImg2,
                                modal_contentDDownVideo:
                                  n.modal_contentDDownVideo2,
                                modal_contentDVideo: n.modal_contentDVideo2,
                                modal_contentDVideoLoop:
                                  "video_noclick_loop" ===
                                  n.modal_contentDType2,
                                inView: s[1],
                              }),
                        ),
                      ),
                      H("div", { className: "content__content-d-hr___3UJbe" }),
                      H(
                        "div",
                        {
                          className: "",
                          id: "".concat(c, "-2"),
                          ref: function (t) {
                            e.videoBox[2] = t;
                          },
                        },
                        H(
                          "div",
                          { className: "content__content-d-item-text___1IE6e" },
                          H("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentDTitle3),
                            },
                          }),
                        ),
                        H(
                          "div",
                          {
                            className: "content__content-d-item-scene___2iBIx",
                          },
                          !l ||
                            ("video_noclick_loop" !== n.modal_contentDType3 &&
                              "video_noclick_noloop" !== n.modal_contentDType3)
                            ? l && "video_click" === n.modal_contentDType3
                              ? this.renderClickVideo(
                                  {
                                    modal_contentDImg: n.modal_contentDImg3,
                                    modal_contentDDownImg:
                                      n.modal_contentDDownImg3,
                                    modal_contentDDownVideo:
                                      n.modal_contentDDownVideo3,
                                    modal_contentDVideo: n.modal_contentDVideo3,
                                    inView: s[2],
                                  },
                                  2,
                                )
                              : H(h.a, {
                                  visibleByDefault: !0,
                                  type: "img",
                                  src: n.modal_contentDImg3,
                                  className: "",
                                })
                            : this.renderVideo({
                                modal_contentDImg: n.modal_contentDImg3,
                                modal_contentDDownImg: n.modal_contentDDownImg3,
                                modal_contentDDownVideo:
                                  n.modal_contentDDownVideo3,
                                modal_contentDVideo: n.modal_contentDVideo3,
                                modal_contentDVideoLoop:
                                  "video_noclick_loop" ===
                                  n.modal_contentDType3,
                                inView: s[2],
                              }),
                        ),
                      ),
                      H("div", { className: "content__content-d-hr___3UJbe" }),
                      H(
                        "div",
                        {
                          className: "",
                          id: "".concat(c, "-3"),
                          ref: function (t) {
                            e.videoBox[3] = t;
                          },
                        },
                        H(
                          "div",
                          { className: "content__content-d-item-text___1IE6e" },
                          H("h4", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentDTitle4),
                            },
                          }),
                          H("p", {
                            dangerouslySetInnerHTML: {
                              __html: o(n.modal_contentDDesc4),
                            },
                          }),
                        ),
                        H(
                          "div",
                          {
                            className: "content__content-d-item-scene___2iBIx",
                          },
                          !l ||
                            ("video_noclick_loop" !== n.modal_contentDType4 &&
                              "video_noclick_noloop" !== n.modal_contentDType4)
                            ? l && "video_click" === n.modal_contentDType4
                              ? this.renderClickVideo(
                                  {
                                    modal_contentDImg: n.modal_contentDImg4,
                                    modal_contentDDownImg:
                                      n.modal_contentDDownImg4,
                                    modal_contentDDownVideo:
                                      n.modal_contentDDownVideo4,
                                    modal_contentDVideo: n.modal_contentDVideo4,
                                    inView: s[3],
                                  },
                                  3,
                                )
                              : H(h.a, {
                                  visibleByDefault: !0,
                                  type: "img",
                                  src: n.modal_contentDImg4,
                                  className: "",
                                })
                            : this.renderVideo({
                                modal_contentDImg: n.modal_contentDImg4,
                                modal_contentDDownImg: n.modal_contentDDownImg4,
                                modal_contentDDownVideo:
                                  n.modal_contentDDownVideo4,
                                modal_contentDVideo: n.modal_contentDVideo4,
                                modal_contentDVideoLoop:
                                  "video_noclick_loop" ===
                                  n.modal_contentDType4,
                                inView: s[3],
                              }),
                        ),
                      ),
                    );
                  },
                },
              ],
              [
                {
                  key: "getDerivedStateFromProps",
                  value: function (e, t) {
                    return !t.initVideo && e.initVideo
                      ? { initVideo: !0 }
                      : null;
                  },
                },
              ],
            ),
            t
          );
        })(p.a.Component);
      Object(c.a)(q, "defaultProps", {
        t: function () {},
        isMobile: !1,
        modalShow: !1,
        modalContent: Y,
      });
      var X = n("HcE9"),
        Z = p.a.createElement,
        K = {
          "./content.css": {
            "modal-content-a": "content__modal-content-a___sV8Tx",
            "content-a-hr": "content__content-a-hr___1h394",
            "content-a-item": "content__content-a-item___1v0vA",
            "content-a-item-scene": "content__content-a-item-scene___lcDpL",
            "content-a-item-img": "content__content-a-item-img___2gMoH",
            "content-a-item-text": "content__content-a-item-text___2rOFe",
            video: "content__video___3iIO3",
            "video-buttom": "content__video-buttom___3zx2r",
            "replay-buttom": "content__replay-buttom___Rg4FG",
            "play-buttom": "content__play-buttom___1SrVY",
            "pause-buttom": "content__pause-buttom___3MrRD",
            "loading-buttom": "content__loading-buttom___1kuac",
            "downgrade-video": "content__downgrade-video___AsXka",
            "downgrade-play-btn": "content__downgrade-play-btn___1C8hC",
            "downgrade-pic": "content__downgrade-pic___37etP",
            "modal-content-a-mobile": "content__modal-content-a-mobile___HCDAw",
            "content-d-hr": "content__content-d-hr___3UJbe",
            "modal-content-b": "content__modal-content-b___1PJ2u",
            "content-b-scene": "content__content-b-scene___2gxbn",
            "content-b-img": "content__content-b-img___3BG8D",
            "content-b-item-video": "content__content-b-item-video___1uVAe",
            "content-b-item-text": "content__content-b-item-text___1xSJh",
            "content-b-hr": "content__content-b-hr___2D5Bj",
            "content-b-text": "content__content-b-text___1dLXo",
            "modal-content-b-mobile": "content__modal-content-b-mobile___12biZ",
            "modal-content-c": "content__modal-content-c___1WZAL",
            "content-c-scene": "content__content-c-scene___24dWD",
            "content-c-avatar": "content__content-c-avatar___Hch-G",
            "content-c-desc": "content__content-c-desc___1RbSC",
            "content-c-text": "content__content-c-text___1cV7c",
            "content-c-text-img": "content__content-c-text-img___sOk98",
            "content-c-text-desc": "content__content-c-text-desc___27Wao",
            "modal-content-c-mobile": "content__modal-content-c-mobile___1r-Fl",
            "content-d-item-text": "content__content-d-item-text___1IE6e",
            "content-d-item-text1": "content__content-d-item-text1___2_Kbi",
            "content-d-item-scene": "content__content-d-item-scene___2iBIx",
            "video-box-pop": "content__video-box-pop___zZz2b",
            "video-item": "content__video-item___3msSe",
            "video-button": "content__video-button___2EnF9",
            "video-box-pop-m": "content__video-box-pop-m___SL6nf",
            icon: "content__icon___2sOK-",
            "watch-video-icon": "content__watch-video-icon___1IQxS",
            "modal-content-e": "content__modal-content-e___2Mi6b",
            "content-e-scene": "content__content-e-scene___3U1la",
            "content-e-top-bg": "content__content-e-top-bg___3TnZr",
            "content-e-desc": "content__content-e-desc___k8WET",
            "content-e-section": "content__content-e-section___2GT7H",
            "content-e-section-1": "content__content-e-section-1___2xmvg",
            "content-e-features": "content__content-e-features___1kuYS",
            "content-e-feature": "content__content-e-feature___1PHJo",
            "content-e-icon": "content__content-e-icon___E0z_T",
            "content-e-section-2": "content__content-e-section-2___2U5WZ",
            "content-e-bg-1": "content__content-e-bg-1___1MHuJ",
            "content-e-bg-2": "content__content-e-bg-2___3gFhr",
            "content-e-section-3": "content__content-e-section-3___HAzzR",
            "content-e-cards": "content__content-e-cards___1cIdi",
            "content-e-card": "content__content-e-card___A_uPM",
            "content-e-section-4": "content__content-e-section-4___q1ANH",
            "modal-content-e-mobile": "content__modal-content-e-mobile___3sg9D",
            "modal-content-f": "content__modal-content-f___uOJ6S",
            "content-f-scene": "content__content-f-scene___IRexU",
            "content-f-top-bg": "content__content-f-top-bg___20WGC",
            "content-f-cards": "content__content-f-cards___3Lybz",
            "content-f-card": "content__content-f-card___EzJ4_",
            "content-f-card-title": "content__content-f-card-title___2mybz",
            "content-f-card-desc": "content__content-f-card-desc___19iIH",
            "modal-content-f-mobile": "content__modal-content-f-mobile___3dN1f",
          },
        };
      function Q(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var J = {
          modalContent: {
            label: "\u5f39\u7a97\u914d\u7f6e",
            props: {
              modal_OpenBtnEText: {
                label: "\u6253\u5f00\u5f39\u7a97\u6309\u94ae\u6587\u6848",
                type: "string",
                content: "text",
              },
              topBackgroundImage: {
                type: "image",
                label: "\u9876\u90e8\u80cc\u666f\u56fe",
              },
              topTitle: {
                type: "string",
                content: "text",
                label: "\u9876\u90e8\u6807\u9898",
              },
              topDescription: {
                type: "string",
                content: "text",
                label: "\u9876\u90e8\u63cf\u8ff0",
              },
            },
          },
          part1: {
            label: "\u5178\u578b\u529f\u80fd",
            props: {
              subtitle1: {
                label: "\u5178\u578b\u529f\u80fd",
                type: "string",
                content: "text",
              },
              icon1: { type: "image", label: "icon 1" },
              iconText1: {
                label: "icon \u6587\u5b57 1",
                type: "string",
                content: "text",
              },
              icon2: { type: "image", label: "icon 2" },
              iconText2: {
                label: "icon \u6587\u5b57 2",
                type: "string",
                content: "text",
              },
              icon3: { type: "image", label: "icon 3" },
              iconText3: {
                label: "icon \u6587\u5b57 3",
                type: "string",
                content: "text",
              },
              icon4: { type: "image", label: "icon 4" },
              iconText4: {
                label: "icon \u6587\u5b57 4",
                type: "string",
                content: "text",
              },
            },
          },
          part2: {
            label: "\u5e94\u7528\u573a\u666f",
            props: {
              subtitle2: {
                label: "\u5e94\u7528\u573a\u666f",
                type: "string",
                content: "text",
              },
              part2Desc1: {
                label: "\u63cf\u8ff0 1",
                type: "string",
                content: "text",
              },
              part2Image1: { label: "\u56fe\u7247 1", type: "image" },
              part2Desc2: {
                label: "\u63cf\u8ff0 2",
                type: "string",
                content: "text",
              },
              part2Image2: { label: "\u56fe\u7247 2", type: "image" },
            },
          },
          part3: {
            label: "\u76f8\u5173\u4e0b\u8f7d",
            props: {
              subtitle3: {
                label: "\u76f8\u5173\u4e0b\u8f7d",
                type: "string",
                content: "text",
              },
              card1Text: {
                label: "\u5361\u7247\u4e00\u6807\u9898",
                type: "string",
                content: "text",
              },
              card1LinkText: {
                label: "\u5361\u7247\u4e00\u94fe\u63a5\u6587\u6848",
                type: "string",
                content: "text",
              },
              card1LinkUrl: {
                label: "\u5361\u7247\u4e00 URL",
                type: "string",
                content: "url",
              },
              card2Text: {
                label: "\u5361\u7247\u4e8c\u6807\u9898",
                type: "string",
                content: "text",
              },
              card2LinkText: {
                label: "\u5361\u7247\u4e8c\u94fe\u63a5\u6587\u6848",
                type: "string",
                content: "text",
              },
              card2LinkUrl: {
                label: "\u5361\u7247\u4e8c URL",
                type: "string",
                content: "url",
              },
              card3Text: {
                label: "\u5361\u7247\u4e09\u6807\u9898",
                type: "string",
                content: "text",
              },
              card3LinkText: {
                label: "\u5361\u7247\u4e09\u94fe\u63a5\u6587\u6848",
                type: "string",
                content: "text",
              },
              card3LinkUrl: {
                label: "\u5361\u7247\u4e09 URL",
                type: "string",
                content: "url",
              },
            },
          },
          part4: {
            label: "SDK",
            props: {
              subtitle4: {
                label: "SDK\u6807\u9898",
                type: "string",
                content: "text",
              },
              sdkDesc: {
                label: "SDK\u63cf\u8ff0",
                type: "string",
                content: "text",
              },
            },
          },
        },
        $ = (function (e) {
          function t() {
            return Object(o.default)(this, t), Q(this, t, arguments);
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.modalContent,
                    n = e.t,
                    o = e.isMobile,
                    a = e.gaSend,
                    r = t || {},
                    i = r.topBackgroundImage,
                    l = r.topTitle,
                    s = r.topDescription,
                    c = r.subtitle1,
                    _ = r.icon1,
                    d = r.iconText1,
                    p = r.icon2,
                    f = r.iconText2,
                    m = r.icon3,
                    b = r.iconText3,
                    v = r.icon4,
                    g = r.iconText4,
                    w = r.subtitle2,
                    x = r.part2Desc1,
                    k = r.part2Image1,
                    O = r.part2Desc2,
                    I = r.part2Image2,
                    S = r.subtitle3,
                    j = r.card1Text,
                    T = r.card1LinkText,
                    C = r.card1LinkUrl,
                    M = r.card2Text,
                    P = r.card2LinkText,
                    E = r.card2LinkUrl,
                    L = r.card3Text,
                    B = r.card3LinkText,
                    N = r.card3LinkUrl,
                    D = r.subtitle4,
                    z = r.sdkDesc,
                    A = [
                      { icon: _, iconText: d },
                      { icon: p, iconText: f },
                      { icon: m, iconText: b },
                      { icon: v, iconText: g },
                    ],
                    R = [
                      { text: j, linkUrl: (C && C.path) || "", linkText: T },
                      { text: M, linkUrl: (E && E.path) || "", linkText: P },
                      { text: L, linkUrl: (N && N.path) || "", linkText: B },
                    ],
                    F = y.Q
                      ? (window.location.pathname || "").split("/").slice(-1)
                      : "",
                    V = o ? "m-" : "pc-";
                  return Z(
                    "div",
                    {
                      className: u()(
                        o
                          ? "modal-content-e modal-content-e-mobile"
                          : "modal-content-e",
                        K,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    Z(
                      "div",
                      { className: "content__content-e-scene___3U1la" },
                      Z(h.a, {
                        visibleByDefault: !0,
                        type: "bg",
                        src: i,
                        className: "content__content-e-top-bg___3TnZr",
                      }),
                      Z(
                        "div",
                        { className: "content__content-e-desc___k8WET" },
                        Z("h4", { dangerouslySetInnerHTML: { __html: n(l) } }),
                        Z("p", { dangerouslySetInnerHTML: { __html: n(s) } }),
                      ),
                    ),
                    Z(
                      "div",
                      {
                        className:
                          "content__content-e-section___2GT7H content__content-e-section-1___2xmvg",
                      },
                      Z("h5", { dangerouslySetInnerHTML: { __html: n(c) } }),
                      Z(
                        "div",
                        { className: "content__content-e-features___1kuYS" },
                        A.map(function (e) {
                          return Z(
                            "div",
                            { className: "content__content-e-feature___1PHJo" },
                            Z(h.a, {
                              visibleByDefault: !0,
                              type: "bg",
                              src: e.icon,
                              className: "content__content-e-icon___E0z_T",
                            }),
                            Z("p", {
                              dangerouslySetInnerHTML: {
                                __html: n(e.iconText),
                              },
                            }),
                          );
                        }),
                      ),
                    ),
                    Z(
                      "div",
                      {
                        className:
                          "content__content-e-section___2GT7H content__content-e-section-2___2U5WZ",
                      },
                      Z("h5", { dangerouslySetInnerHTML: { __html: n(w) } }),
                      Z("p", { dangerouslySetInnerHTML: { __html: n(x) } }),
                      Z(h.a, {
                        visibleByDefault: !0,
                        type: o ? "img" : "bg",
                        src: k,
                        className: "content__content-e-bg-1___1MHuJ",
                      }),
                      Z("p", { dangerouslySetInnerHTML: { __html: n(O) } }),
                      Z(h.a, {
                        visibleByDefault: !0,
                        type: o ? "img" : "bg",
                        src: I,
                        className: "content__content-e-bg-2___3gFhr",
                      }),
                    ),
                    Z(
                      "div",
                      {
                        className:
                          "content__content-e-section___2GT7H content__content-e-section-3___HAzzR",
                      },
                      Z("h5", { dangerouslySetInnerHTML: { __html: n(S) } }),
                      Z(
                        "div",
                        { className: "content__content-e-cards___1cIdi" },
                        R.map(function (e, t) {
                          return Z(
                            "div",
                            { className: "content__content-e-card___A_uPM" },
                            Z("h6", {
                              dangerouslySetInnerHTML: { __html: n(e.text) },
                            }),
                            Z(
                              X.c,
                              {
                                type: "download",
                                href: e.linkUrl,
                                onClick: function () {
                                  return a(
                                    "click",
                                    "sdk-modal-card-download-".concat(t + 1),
                                    "".concat(V, "-").concat(F),
                                  );
                                },
                              },
                              Z("span", {
                                dangerouslySetInnerHTML: {
                                  __html: n(e.linkText) || "",
                                },
                              }),
                            ),
                          );
                        }),
                      ),
                    ),
                    Z(
                      "div",
                      {
                        className:
                          "content__content-e-section___2GT7H content__content-e-section-4___q1ANH",
                      },
                      Z("h5", { dangerouslySetInnerHTML: { __html: n(D) } }),
                      Z("p", { dangerouslySetInnerHTML: { __html: n(z) } }),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(p.a.PureComponent);
      Object(c.a)($, "defaultProps", {
        t: function () {},
        isMobile: !1,
        modalContent: {},
      });
      var ee = p.a.createElement;
      function te(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function ne(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? te(Object(n), !0).forEach(function (t) {
                Object(c.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : te(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var oe = {
        "./content.css": {
          "modal-content-a": "content__modal-content-a___sV8Tx",
          "content-a-hr": "content__content-a-hr___1h394",
          "content-a-item": "content__content-a-item___1v0vA",
          "content-a-item-scene": "content__content-a-item-scene___lcDpL",
          "content-a-item-img": "content__content-a-item-img___2gMoH",
          "content-a-item-text": "content__content-a-item-text___2rOFe",
          video: "content__video___3iIO3",
          "video-buttom": "content__video-buttom___3zx2r",
          "replay-buttom": "content__replay-buttom___Rg4FG",
          "play-buttom": "content__play-buttom___1SrVY",
          "pause-buttom": "content__pause-buttom___3MrRD",
          "loading-buttom": "content__loading-buttom___1kuac",
          "downgrade-video": "content__downgrade-video___AsXka",
          "downgrade-play-btn": "content__downgrade-play-btn___1C8hC",
          "downgrade-pic": "content__downgrade-pic___37etP",
          "modal-content-a-mobile": "content__modal-content-a-mobile___HCDAw",
          "content-d-hr": "content__content-d-hr___3UJbe",
          "modal-content-b": "content__modal-content-b___1PJ2u",
          "content-b-scene": "content__content-b-scene___2gxbn",
          "content-b-img": "content__content-b-img___3BG8D",
          "content-b-item-video": "content__content-b-item-video___1uVAe",
          "content-b-item-text": "content__content-b-item-text___1xSJh",
          "content-b-hr": "content__content-b-hr___2D5Bj",
          "content-b-text": "content__content-b-text___1dLXo",
          "modal-content-b-mobile": "content__modal-content-b-mobile___12biZ",
          "modal-content-c": "content__modal-content-c___1WZAL",
          "content-c-scene": "content__content-c-scene___24dWD",
          "content-c-avatar": "content__content-c-avatar___Hch-G",
          "content-c-desc": "content__content-c-desc___1RbSC",
          "content-c-text": "content__content-c-text___1cV7c",
          "content-c-text-img": "content__content-c-text-img___sOk98",
          "content-c-text-desc": "content__content-c-text-desc___27Wao",
          "modal-content-c-mobile": "content__modal-content-c-mobile___1r-Fl",
          "content-d-item-text": "content__content-d-item-text___1IE6e",
          "content-d-item-text1": "content__content-d-item-text1___2_Kbi",
          "content-d-item-scene": "content__content-d-item-scene___2iBIx",
          "video-box-pop": "content__video-box-pop___zZz2b",
          "video-item": "content__video-item___3msSe",
          "video-button": "content__video-button___2EnF9",
          "video-box-pop-m": "content__video-box-pop-m___SL6nf",
          icon: "content__icon___2sOK-",
          "watch-video-icon": "content__watch-video-icon___1IQxS",
          "modal-content-e": "content__modal-content-e___2Mi6b",
          "content-e-scene": "content__content-e-scene___3U1la",
          "content-e-top-bg": "content__content-e-top-bg___3TnZr",
          "content-e-desc": "content__content-e-desc___k8WET",
          "content-e-section": "content__content-e-section___2GT7H",
          "content-e-section-1": "content__content-e-section-1___2xmvg",
          "content-e-features": "content__content-e-features___1kuYS",
          "content-e-feature": "content__content-e-feature___1PHJo",
          "content-e-icon": "content__content-e-icon___E0z_T",
          "content-e-section-2": "content__content-e-section-2___2U5WZ",
          "content-e-bg-1": "content__content-e-bg-1___1MHuJ",
          "content-e-bg-2": "content__content-e-bg-2___3gFhr",
          "content-e-section-3": "content__content-e-section-3___HAzzR",
          "content-e-cards": "content__content-e-cards___1cIdi",
          "content-e-card": "content__content-e-card___A_uPM",
          "content-e-section-4": "content__content-e-section-4___q1ANH",
          "modal-content-e-mobile": "content__modal-content-e-mobile___3sg9D",
          "modal-content-f": "content__modal-content-f___uOJ6S",
          "content-f-scene": "content__content-f-scene___IRexU",
          "content-f-top-bg": "content__content-f-top-bg___20WGC",
          "content-f-cards": "content__content-f-cards___3Lybz",
          "content-f-card": "content__content-f-card___EzJ4_",
          "content-f-card-title": "content__content-f-card-title___2mybz",
          "content-f-card-desc": "content__content-f-card-desc___19iIH",
          "modal-content-f-mobile": "content__modal-content-f-mobile___3dN1f",
        },
      };
      function ae(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var re = {
          modalButton: {
            switch: "hasModalButton",
            label: "\u5f39\u7a97\u6309\u94ae\u8bbe\u7f6e",
            props: {
              modalBtnFontSize: {
                type: "string",
                label: "\u5f39\u7a97\u6309\u94ae\u5b57\u53f7",
              },
              modalBtnHeight: {
                type: "string",
                label: "\u5f39\u7a97\u6309\u94ae\u9ad8\u5ea6",
              },
              modalBtnMarginTop: {
                type: "string",
                label: "\u5f39\u7a97\u6309\u94ae\u4e0a\u8fb9\u8ddd",
              },
              modalBtnText: {
                type: "string",
                content: "text",
                label: "\u5f39\u7a97\u6309\u94ae\u6587\u6848",
              },
              modalBtnIsLightTheme: {
                type: "boolean",
                label: "\u5f39\u7a97\u4f7f\u7528\u767d\u8272\u4e3b\u9898",
              },
              modalBtnGaLabel: {
                type: "string",
                label: "\u5f39\u7a97\u6309\u94ae ga-label",
              },
              modalBtnPaddingY: {
                type: "string",
                label: "\u5f39\u7a97\u6309\u94ae\u4e0a\u4e0b\u5185\u8fb9\u8ddd",
              },
              modalBtnContentTopImage: {
                type: "image",
                label: "\u5f39\u7a97\u9876\u56fe",
              },
              modalBtnContentTopImageHeight: {
                type: "string",
                label: "\u5f39\u7a97\u9876\u56fe\u9ad8\u5ea6",
              },
              modalBtnContentList: {
                type: "array",
                props: {
                  title: {
                    label: "\u6807\u9898",
                    type: "string",
                    content: "text",
                  },
                  desc: {
                    label: "\u63cf\u8ff0",
                    type: "string",
                    content: "text",
                  },
                  titleFont: {
                    type: "font",
                    label: "\u6807\u9898-\u5b57\u4f53\u914d\u7f6e",
                  },
                  descFont: {
                    type: "font",
                    label: "\u63cf\u8ff0-\u5b57\u4f53\u914d\u7f6e",
                  },
                },
              },
            },
          },
        },
        ie = {
          hasModalButton: !1,
          modalBtnFontSize: "16px",
          modalBtnHeight: "40px",
          modalBtnMarginTop: "24px",
          modalBtnText: "\u4e86\u89e3\u66f4\u591a",
          modalBtnContentTopImage: "",
          modalBtnIsLightTheme: !1,
          modalBtnContentTopImageHeight: "448px",
          modalBtnContentList: [
            {
              title: "Modal-Headline-1",
              desc: "Modal-Desc-1",
              titleFont: {},
              descFont: {},
            },
            {
              title: "Modal-Headline-2",
              desc: "Modal-Desc-2",
              titleFont: {},
              descFont: {},
            },
            {
              title: "Modal-Headline-3",
              desc: "Modal-Desc-3",
              titleFont: {},
              descFont: {},
            },
          ],
        },
        le = (function (e) {
          function t() {
            return Object(o.default)(this, t), ae(this, t, arguments);
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.modalContent,
                    n = e.t,
                    o = e.isMobile,
                    a = t || {},
                    r = a.modalBtnContentTopImage,
                    i = a.modalBtnContentTopImageHeight,
                    l = a.modalBtnContentList;
                  return ee(
                    "div",
                    {
                      className: u()(
                        o
                          ? "modal-content-f modal-content-f-mobile"
                          : "modal-content-f",
                        oe,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    ee(
                      "div",
                      { className: "content__content-f-scene___IRexU" },
                      ee(h.a, {
                        visibleByDefault: !0,
                        type: "bg",
                        src: r,
                        style: i ? { height: i } : {},
                        className: "content__content-f-top-bg___20WGC",
                      }),
                    ),
                    ee(
                      "div",
                      { className: "content__content-f-cards___3Lybz" },
                      (l || []).map(function (e, t) {
                        return ee(
                          "div",
                          {
                            className: "content__content-f-card___EzJ4_",
                            key: t,
                          },
                          ee("h5", {
                            className: "content__content-f-card-title___2mybz",
                            style: ne({}, e.titleFont || {}),
                            dangerouslySetInnerHTML: { __html: n(e.title) },
                          }),
                          ee("p", {
                            className: "content__content-f-card-desc___19iIH",
                            style: ne({}, e.descFont || {}),
                            dangerouslySetInnerHTML: { __html: n(e.desc) },
                          }),
                        );
                      }),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(p.a.PureComponent);
      Object(c.a)(le, "defaultProps", {
        t: function () {},
        isMobile: !1,
        modalContent: ie,
      });
      n("mjmx");
      var se = p.a.createElement,
        ce = {
          "./style.css": {
            "click-modal-btn-m": "style__click-modal-btn-m___2X214",
            "click-modal-btn": "style__click-modal-btn___2_uoL",
            "btn-downgrade": "style__btn-downgrade___JQfwc",
            "click-modal-btn-pc": "style__click-modal-btn-pc___1MeaG",
            "btn-gradient": "style__btn-gradient___2uWjE",
            content: "style__content___3PPcc",
            "btn-white": "style__btn-white___3agIi",
            "click-modal-btn-icon": "style__click-modal-btn-icon___3uHq6",
            "modal-container": "style__modal-container___3u7_z",
            "modal-close": "style__modal-close___ZQXTM",
            "modal-frame": "style__modal-frame___34s1W",
            "modal-content-box": "style__modal-content-box___K5aRM",
            "modal-container-m": "style__modal-container-m___3008D",
            "modal-button-type-F": "style__modal-button-type-F___2XWnn",
            "light-theme": "style__light-theme___cKoK3",
            "modal-container-pc": "style__modal-container-pc___3voHp",
          },
        };
      function _e(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ue = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = _e(this, t, [e])).state = {
              modalShow: !1,
              opened: !1,
              initVideo: !1,
              isIE: !1,
            }),
            (n.handleCloseButtonClick = n.handleCloseButtonClick.bind(
              Object(l.a)(n),
            )),
            (n.handleShowButtonClick = n.handleShowButtonClick.bind(
              Object(l.a)(n),
            )),
            (n.handleWrapperClick = n.handleWrapperClick.bind(Object(l.a)(n))),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = Object(y.h)();
                this.setState({ isIE: e }),
                  this.props.onRef && this.props.onRef(this);
              },
            },
            {
              key: "handleShowButtonClick",
              value: function (e) {
                e.preventDefault();
                var t = this.state.opened;
                this.props.isStopPropagation && e.stopPropagation();
                var n = this.modalDom;
                if ("undefined" !== typeof document && document) {
                  var o = document.querySelector("body"),
                    a = document.querySelector("html");
                  if (
                    (t
                      ? ((this.bodyInitialScroll =
                          window.scrollY || window.pageYOffset),
                        this.setState({ modalShow: !0, initVideo: !0 }))
                      : (n.removeNode
                          ? (n.removeNode(),
                            n.appendChild(this.iframeDom),
                            this.iframeDom.appendChild(this.closeDom),
                            o && o.appendChild(n))
                          : (n.remove(), o && o.append(n)),
                        (this.bodyInitialScroll =
                          window.scrollY || window.pageYOffset),
                        this.setState({
                          modalShow: !0,
                          initVideo: !0,
                          opened: !0,
                        })),
                    o)
                  ) {
                    (this.bodyInitialOverflow = o.style.overflow),
                      (a.style.overflow = "hidden");
                    var r = this.props,
                      i = r.gaSend,
                      l = r.gaLabel;
                    i("click", "modal-button-".concat(void 0 === l ? "" : l));
                  }
                }
              },
            },
            {
              key: "handleCloseButtonClick",
              value: function (e) {
                if (
                  (this.props.isStopPropagation && e && e.stopPropagation(),
                  "undefined" !== typeof document && document)
                ) {
                  var t = document.querySelector("body"),
                    n = document.querySelector("html");
                  t &&
                    ((t.style.overflow = this.bodyInitialOverflow || ""),
                    (t.style.height = ""),
                    (n.style.overflow = ""),
                    window.scrollTo(0, this.bodyInitialScroll),
                    this.setState({ modalShow: !1 }));
                }
              },
            },
            {
              key: "handleWrapperClick",
              value: function (e) {
                e.stopPropagation(),
                  e.target &&
                    e.target.classList.contains("modal-container") &&
                    this.handleCloseButtonClick();
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.containerClassname,
                  o = t.modalContent,
                  a = t.lightThemeOn,
                  r = t.style,
                  i = t.contentStyle,
                  l = t.btnStyle,
                  s = t.isMobile,
                  c = t.t,
                  _ = t.translateOff,
                  d = t.contentType,
                  p = t.id,
                  f = t.specialCountry,
                  y = t.isSpecialShowVideoCountry,
                  b = t.gaSend,
                  v = this.state,
                  g = v.modalShow,
                  w = v.initVideo,
                  x = v.isIE;
                if (["A", "B", "C", "D", "E", "F"].indexOf(d) < 0) return null;
                var k = "modal_OpenBtn".concat(d, "Text"),
                  O = function (e) {
                    return _ ? e : c(e);
                  };
                return se(
                  h.a,
                  null,
                  se(
                    "div",
                    { style: r },
                    se(
                      "button",
                      {
                        type: "button",
                        ref: function (t) {
                          e.modalBtn = t;
                        },
                        style: l,
                        onClick: this.handleShowButtonClick,
                        className: u()(
                          "click-modal-btn "
                            .concat(
                              s ? "click-modal-btn-m" : "click-modal-btn-pc",
                              "  ",
                            )
                            .concat(x ? "btn-downgrade" : "btn-gradient", " ")
                            .concat(
                              "D" === d ? " btn-white" : "",
                              " modal-button-type-",
                            )
                            .concat(d, " ")
                            .concat(a ? "light-theme" : ""),
                          ce,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      se(
                        "span",
                        { className: "style__content___3PPcc", style: i },
                        s && "D" === d ? "" : se("span", null, O(o[k])),
                        se(m.a, { weight: "light", name: "plus-circle" }),
                      ),
                    ),
                    se(
                      "div",
                      {
                        style: { display: g ? "block" : "none" },
                        ref: function (t) {
                          e.modalDom = t;
                        },
                        onClick: this.handleWrapperClick,
                        className:
                          "modal-container ".concat(n ? " ".concat(n) : "") +
                          " " +
                          u()(
                            s
                              ? "modal-container modal-container-m"
                              : "modal-container modal-container-pc",
                            ce,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                      },
                      se(
                        "div",
                        {
                          ref: function (t) {
                            e.iframeDom = t;
                          },
                          className: "style__modal-frame___34s1W",
                        },
                        se("div", {
                          ref: function (t) {
                            e.closeDom = t;
                          },
                          className: "style__modal-close___ZQXTM",
                          onClick: this.handleCloseButtonClick,
                        }),
                        se(
                          "div",
                          { className: "style__modal-content-box___K5aRM" },
                          "A" === d
                            ? se(C, {
                                t: O,
                                id: p,
                                modalContent: o,
                                isMobile: s,
                                initVideo: w,
                                modalShow: g,
                              })
                            : null,
                          "B" === d
                            ? se(N, {
                                id: p,
                                initVideo: w,
                                isSpecialShowVideoCountry: y,
                                specialCountry: f,
                                t: O,
                                modalContent: o,
                                isMobile: s,
                                modalShow: g,
                              })
                            : null,
                          "C" === d
                            ? se(V, { t: O, modalContent: o, isMobile: s })
                            : null,
                          "D" === d
                            ? se(q, {
                                t: O,
                                id: p,
                                modalContent: o,
                                isMobile: s,
                                initVideo: w,
                                modalShow: g,
                              })
                            : null,
                          "E" === d
                            ? se($, {
                                t: O,
                                id: p,
                                initVideo: w,
                                modalContent: o,
                                isMobile: s,
                                modalShow: g,
                                gaSend: b,
                              })
                            : null,
                          "F" === d
                            ? se(le, {
                                t: O,
                                id: p,
                                initVideo: w,
                                modalContent: o,
                                isMobile: s,
                                modalShow: g,
                                gaSend: b,
                              })
                            : null,
                        ),
                      ),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(p.a.Component);
      Object(c.a)(ue, "defaultProps", {
        t: function () {},
        isMobile: !1,
        modalContent: { modalOpenBtnText: "v3.260.modalbutton.click.text" },
        gaSend: function () {},
        style: {},
        btnStyle: {},
        contentType: "A",
        containerClassname: "",
        isStopPropagation: !1,
        id: 0,
        specialCountry: !1,
        isSpecialShowVideoCountry: !1,
      });
      t.l = Object(f.a)(ue);
    },
    "/Nsm": function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o = (function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e)
          for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return (t.default = e), t;
      })(n("Aw7D"));
      t.default = function (e, t, n, a, r) {
        (/^\s+$/.test(t) || "" === t) &&
          a.push(o.format(r.messages.whitespace, e.fullField));
      };
    },
    "/Pgi": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      });
      var o = n("q1tI");
      function a(e, t) {
        return "undefined" === typeof window
          ? Object(o.useEffect)(e, t)
          : Object(o.useLayoutEffect)(e, t);
      }
    },
    "/xfr": function (e, t, n) {
      "use strict";
      function o(e) {
        return (
          null !== e &&
          "object" === typeof e &&
          "constructor" in e &&
          e.constructor === Object
        );
      }
      function a(e, t) {
        void 0 === e && (e = {}),
          void 0 === t && (t = {}),
          Object.keys(t).forEach(function (n) {
            "undefined" === typeof e[n]
              ? (e[n] = t[n])
              : o(t[n]) &&
                o(e[n]) &&
                Object.keys(t[n]).length > 0 &&
                a(e[n], t[n]);
          });
      }
      n.d(t, "a", function () {
        return i;
      }),
        n.d(t, "b", function () {
          return s;
        });
      var r = {
        body: {},
        addEventListener: function () {},
        removeEventListener: function () {},
        activeElement: { blur: function () {}, nodeName: "" },
        querySelector: function () {
          return null;
        },
        querySelectorAll: function () {
          return [];
        },
        getElementById: function () {
          return null;
        },
        createEvent: function () {
          return { initEvent: function () {} };
        },
        createElement: function () {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () {},
            getElementsByTagName: function () {
              return [];
            },
          };
        },
        createElementNS: function () {
          return {};
        },
        importNode: function () {
          return null;
        },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
      };
      function i() {
        var e = "undefined" !== typeof document ? document : {};
        return a(e, r), e;
      }
      var l = {
        document: r,
        navigator: { userAgent: "" },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
        history: {
          replaceState: function () {},
          pushState: function () {},
          go: function () {},
          back: function () {},
        },
        CustomEvent: function () {
          return this;
        },
        addEventListener: function () {},
        removeEventListener: function () {},
        getComputedStyle: function () {
          return {
            getPropertyValue: function () {
              return "";
            },
          };
        },
        Image: function () {},
        Date: function () {},
        screen: {},
        setTimeout: function () {},
        clearTimeout: function () {},
        matchMedia: function () {
          return {};
        },
        requestAnimationFrame: function (e) {
          return "undefined" === typeof setTimeout
            ? (e(), null)
            : setTimeout(e, 0);
        },
        cancelAnimationFrame: function (e) {
          "undefined" !== typeof setTimeout && clearTimeout(e);
        },
      };
      function s() {
        var e = "undefined" !== typeof window ? window : {};
        return a(e, l), e;
      }
    },
    "03A+": function (e, t, n) {
      var o = n("JTzB"),
        a = n("ExA7"),
        r = Object.prototype,
        i = r.hasOwnProperty,
        l = r.propertyIsEnumerable,
        s = o(
          (function () {
            return arguments;
          })(),
        )
          ? o
          : function (e) {
              return a(e) && i.call(e, "callee") && !l.call(e, "callee");
            };
      e.exports = s;
    },
    "05bn": function (e, t, n) {
      var o, a, r, i;
      "undefined" != typeof self && self,
        (e.exports =
          ((o = n("q1tI")),
          (a = n("17x9")),
          (r = n("TSYQ")),
          (i = n("OLES")),
          (function (e) {
            function t(o) {
              if (n[o]) return n[o].exports;
              var a = (n[o] = { i: o, l: !1, exports: {} });
              return (
                e[o].call(a.exports, a, a.exports, t), (a.l = !0), a.exports
              );
            }
            var n = {};
            return (
              (t.m = e),
              (t.c = n),
              (t.d = function (e, n, o) {
                t.o(e, n) ||
                  Object.defineProperty(e, n, {
                    configurable: !1,
                    enumerable: !0,
                    get: o,
                  });
              }),
              (t.n = function (e) {
                var n =
                  e && e.__esModule
                    ? function () {
                        return e.default;
                      }
                    : function () {
                        return e;
                      };
                return t.d(n, "a", n), n;
              }),
              (t.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }),
              (t.p = ""),
              t((t.s = 268))
            );
          })({
            0: function (e, t) {
              var n = (e.exports =
                "undefined" != typeof window && window.Math == Math
                  ? window
                  : "undefined" != typeof self && self.Math == Math
                    ? self
                    : Function("return this")());
              "number" == typeof __g && (__g = n);
            },
            1: function (e, t) {
              var n = (e.exports = { version: "2.5.3" });
              "number" == typeof __e && (__e = n);
            },
            10: function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(27),
                i = n(18),
                l = "prototype",
                s = function (e, t, n) {
                  var c,
                    _,
                    u,
                    d = e & s.F,
                    p = e & s.G,
                    f = e & s.S,
                    h = e & s.P,
                    m = e & s.B,
                    y = e & s.W,
                    b = p ? a : a[t] || (a[t] = {}),
                    v = b[l],
                    g = p ? o : f ? o[t] : (o[t] || {})[l];
                  for (c in (p && (n = t), n))
                    ((_ = !d && g && void 0 !== g[c]) && c in b) ||
                      ((u = _ ? g[c] : n[c]),
                      (b[c] =
                        p && "function" != typeof g[c]
                          ? n[c]
                          : m && _
                            ? r(u, o)
                            : y && g[c] == u
                              ? (function (e) {
                                  var t = function (t, n, o) {
                                    if (this instanceof e) {
                                      switch (arguments.length) {
                                        case 0:
                                          return new e();
                                        case 1:
                                          return new e(t);
                                        case 2:
                                          return new e(t, n);
                                      }
                                      return new e(t, n, o);
                                    }
                                    return e.apply(this, arguments);
                                  };
                                  return (t[l] = e[l]), t;
                                })(u)
                              : h && "function" == typeof u
                                ? r(Function.call, u)
                                : u),
                      h &&
                        (((b.virtual || (b.virtual = {}))[c] = u),
                        e & s.R && v && !v[c] && i(v, c, u)));
                };
              (s.F = 1),
                (s.G = 2),
                (s.S = 4),
                (s.P = 8),
                (s.B = 16),
                (s.W = 32),
                (s.U = 64),
                (s.R = 128),
                (e.exports = s);
            },
            11: function (e, t, n) {
              var o = n(36),
                a = n(22);
              e.exports =
                Object.keys ||
                function (e) {
                  return o(e, a);
                };
            },
            112: function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(67)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = n(9),
                c = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(s),
                _ = o(n(140)),
                u = o(n(23)),
                d = o(n(12)),
                p = o(n(141)),
                f = o(n(142)),
                h = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                m =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                y = (function (e) {
                  function t(t) {
                    var n = e.call(this, t) || this;
                    return (
                      (n.onVisibleChange = function (e) {
                        var t = n.props.onVisibleChange;
                        "visible" in n.props ||
                          n.setState({ visible: !n.isNoTitle() && e }),
                          t && !n.isNoTitle() && t(e);
                      }),
                      (n.onPopupAlign = function (e, t) {
                        var o = n.getPlacements(),
                          r = (0, a.default)(o).filter(function (e) {
                            return (
                              o[e].points[0] === t.points[0] &&
                              o[e].points[1] === t.points[1]
                            );
                          })[0];
                        if (r) {
                          var i = e.getBoundingClientRect(),
                            l = { top: "50%", left: "50%" };
                          r.indexOf("top") >= 0 || r.indexOf("Bottom") >= 0
                            ? (l.top = i.height - t.offset[1] + "px")
                            : (r.indexOf("Top") >= 0 ||
                                r.indexOf("bottom") >= 0) &&
                              (l.top = -t.offset[1] + "px"),
                            r.indexOf("left") >= 0 || r.indexOf("Right") >= 0
                              ? (l.left = i.width - t.offset[0] + "px")
                              : (r.indexOf("right") >= 0 ||
                                  r.indexOf("Left") >= 0) &&
                                (l.left = -t.offset[0] + "px"),
                            (e.style.transformOrigin = l.left + " " + l.top);
                        }
                      }),
                      (n.state = {
                        visible: !!t.visible || !!t.defaultVisible,
                      }),
                      n
                    );
                  }
                  return (
                    h(t, e),
                    (t.prototype.componentWillReceiveProps = function (e) {
                      "visible" in e && this.setState({ visible: e.visible });
                    }),
                    (t.prototype.getPlacements = function () {
                      var e = this.props,
                        t = e.builtinPlacements,
                        n = e.arrowPointAtCenter,
                        o = e.autoAdjustOverflow;
                      return (
                        t ||
                        (0, p.default)({
                          arrowPointAtCenter: n,
                          verticalArrowShift: 8,
                          autoAdjustOverflow: o,
                        })
                      );
                    }),
                    (t.prototype.getDisabledCompatibleChildren = function (e) {
                      if (
                        "button" === e.type &&
                        e.props.disabled &&
                        this.isHoverTrigger()
                      ) {
                        var t = (function (e, t) {
                            var n = {},
                              o = m({}, e);
                            return (
                              [
                                "position",
                                "left",
                                "right",
                                "top",
                                "bottom",
                                "float",
                                "display",
                                "zIndex",
                              ].forEach(function (t) {
                                e && t in e && ((n[t] = e[t]), delete o[t]);
                              }),
                              { picked: n, omited: o }
                            );
                          })(e.props.style),
                          n = t.picked,
                          o = t.omited,
                          a = m({ display: "inline-block" }, n, {
                            cursor: "not-allowed",
                          }),
                          r = m({}, o, { pointerEvents: "none" }),
                          i = (0, s.cloneElement)(e, {
                            style: r,
                            className: null,
                          });
                        return c.createElement(
                          "span",
                          { style: a, className: e.props.className },
                          i,
                        );
                      }
                      return e;
                    }),
                    (t.prototype.isNoTitle = function () {
                      return !this.props.title && !this.props.overlay;
                    }),
                    (t.prototype.isHoverTrigger = function () {
                      var e = this.props.trigger;
                      return (
                        !e ||
                        "hover" === e ||
                        (!!Array.isArray(e) && e.indexOf("hover") >= 0)
                      );
                    }),
                    (t.prototype.render = function () {
                      var e = this.props,
                        t = this.state,
                        n = e.prefixCls,
                        o = e.title,
                        a = e.overlay,
                        r = e.openClassName,
                        i = e.getPopupContainer,
                        l = e.children,
                        d = t.visible;
                      "visible" in e || !this.isNoTitle() || (d = !1);
                      var p,
                        h = this.getDisabledCompatibleChildren(
                          c.isValidElement(l)
                            ? l
                            : c.createElement("span", null, l),
                        ),
                        y = h.props,
                        b = (0, u.default)(
                          y.className,
                          (((p = {})[r || n + "-open"] = !0), p),
                        ),
                        v = (0, u.default)(
                          f.default["quark-tooltip"],
                          this.props.className,
                        );
                      return c.createElement(
                        _.default,
                        m({}, this.props, {
                          className: v,
                          visible: d,
                          overlay: a || o || "",
                          getTooltipContainer: i,
                          builtinPlacements: this.getPlacements(),
                          onVisibleChange: this.onVisibleChange,
                          onPopupAlign: this.onPopupAlign,
                        }),
                        d ? (0, s.cloneElement)(h, { className: b }) : h,
                      );
                    }),
                    (t.propTypes = {
                      arrowPointAtCenter: d.default.bool,
                      autoAdjustOverflow: d.default.bool,
                      builtinPlacements: d.default.object,
                      className: d.default.string,
                      defaultVisible: d.default.bool,
                      mouseEnterDelay: d.default.number,
                      mouseLeaveDelay: d.default.number,
                      prefixCls: d.default.string,
                      placement: d.default.string,
                      trigger: d.default.string,
                      title: d.default.oneOfType([
                        d.default.string,
                        d.default.node,
                      ]),
                      transitionName: d.default.string,
                      visible: d.default.bool,
                    }),
                    (t.defaultProps = {
                      arrowPointAtCenter: !1,
                      autoAdjustOverflow: !0,
                      prefixCls: "quark-tooltip",
                      mouseEnterDelay: 0.1,
                      mouseLeaveDelay: 0.1,
                      placement: "top",
                      transitionName: "fade-in",
                      trigger: "hover",
                    }),
                    t
                  );
                })(c.Component);
              t.default = y;
            },
            12: function (e, t) {
              e.exports = a;
            },
            13: function (e, t, n) {
              e.exports = { default: n(49), __esModule: !0 };
            },
            14: function (e, t, n) {
              e.exports = { default: n(51), __esModule: !0 };
            },
            140: function (e, t) {
              e.exports = i;
            },
            141: function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              function a(e) {
                return "boolean" == typeof e ? (e ? s : c) : l({}, c, e);
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = o(n(67)),
                i = o(n(16));
              (t.getOverflowOptions = a),
                (t.default = function (e) {
                  void 0 === e && (e = {});
                  var t = e.arrowWidth,
                    n = void 0 === t ? 5 : t,
                    o = e.horizontalArrowShift,
                    i = void 0 === o ? 16 : o,
                    s = e.verticalArrowShift,
                    c = void 0 === s ? 12 : s,
                    d = e.autoAdjustOverflow,
                    p = void 0 === d || d,
                    f = {
                      left: { points: ["cr", "cl"], offset: [-4, 0] },
                      right: { points: ["cl", "cr"], offset: [4, 0] },
                      top: { points: ["bc", "tc"], offset: [0, -4] },
                      bottom: { points: ["tc", "bc"], offset: [0, 4] },
                      topLeft: { points: ["bl", "tc"], offset: [-(i + n), -4] },
                      leftTop: { points: ["tr", "cl"], offset: [-4, -(c + n)] },
                      topRight: { points: ["br", "tc"], offset: [i + n, -4] },
                      rightTop: { points: ["tl", "cr"], offset: [4, -(c + n)] },
                      bottomRight: { points: ["tr", "bc"], offset: [i + n, 4] },
                      rightBottom: { points: ["bl", "cr"], offset: [4, c + n] },
                      bottomLeft: {
                        points: ["tl", "bc"],
                        offset: [-(i + n), 4],
                      },
                      leftBottom: { points: ["br", "cl"], offset: [-4, c + n] },
                    };
                  return (
                    (0, r.default)(f).forEach(function (t) {
                      f[t] = e.arrowPointAtCenter
                        ? l({}, f[t], { overflow: a(p), targetOffset: _ })
                        : l({}, u[t], { overflow: a(p) });
                    }),
                    f
                  );
                });
              var l =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                s = { adjustX: 1, adjustY: 1 },
                c = { adjustX: 0, adjustY: 0 },
                _ = [0, 0],
                u = {
                  left: {
                    points: ["cr", "cl"],
                    overflow: s,
                    offset: [-3, 0],
                    targetOffset: _,
                  },
                  right: {
                    points: ["cl", "cr"],
                    overflow: s,
                    offset: [3, 0],
                    targetOffset: _,
                  },
                  top: {
                    points: ["bc", "tc"],
                    overflow: s,
                    offset: [0, -3],
                    targetOffset: _,
                  },
                  bottom: {
                    points: ["tc", "bc"],
                    overflow: s,
                    offset: [0, 3],
                    targetOffset: _,
                  },
                  topLeft: {
                    points: ["bl", "tl"],
                    overflow: s,
                    offset: [0, -3],
                    targetOffset: _,
                  },
                  leftTop: {
                    points: ["tr", "tl"],
                    overflow: s,
                    offset: [-3, 0],
                    targetOffset: _,
                  },
                  topRight: {
                    points: ["br", "tr"],
                    overflow: s,
                    offset: [0, -3],
                    targetOffset: _,
                  },
                  rightTop: {
                    points: ["tl", "tr"],
                    overflow: s,
                    offset: [3, 0],
                    targetOffset: _,
                  },
                  bottomRight: {
                    points: ["tr", "br"],
                    overflow: s,
                    offset: [0, 3],
                    targetOffset: _,
                  },
                  rightBottom: {
                    points: ["bl", "br"],
                    overflow: s,
                    offset: [3, 0],
                    targetOffset: _,
                  },
                  bottomLeft: {
                    points: ["tl", "bl"],
                    overflow: s,
                    offset: [0, 3],
                    targetOffset: _,
                  },
                  leftBottom: {
                    points: ["br", "bl"],
                    overflow: s,
                    offset: [-3, 0],
                    targetOffset: _,
                  },
                };
            },
            142: function (e, t) {},
            15: function (e, t) {
              t.f = {}.propertyIsEnumerable;
            },
            16: function (e, t, n) {
              e.exports = { default: n(57), __esModule: !0 };
            },
            17: function (e, t) {
              var n = 0,
                o = Math.random();
              e.exports = function (e) {
                return "Symbol(".concat(
                  void 0 === e ? "" : e,
                  ")_",
                  (++n + o).toString(36),
                );
              };
            },
            18: function (e, t, n) {
              var o = n(4),
                a = n(20);
              e.exports = n(2)
                ? function (e, t, n) {
                    return o.f(e, t, a(1, n));
                  }
                : function (e, t, n) {
                    return (e[t] = n), e;
                  };
            },
            2: function (e, t, n) {
              e.exports = !n(8)(function () {
                return (
                  7 !=
                  Object.defineProperty({}, "a", {
                    get: function () {
                      return 7;
                    },
                  }).a
                );
              });
            },
            20: function (e, t) {
              e.exports = function (e, t) {
                return {
                  enumerable: !(1 & e),
                  configurable: !(2 & e),
                  writable: !(4 & e),
                  value: t,
                };
              };
            },
            21: function (e, t, n) {
              var o = n(3);
              e.exports = function (e, t) {
                if (!o(e)) return e;
                var n, a;
                if (
                  t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
                  return a;
                if (
                  !t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                throw TypeError("Can't convert object to primitive value");
              };
            },
            22: function (e, t) {
              e.exports =
                "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                  ",",
                );
            },
            23: function (e, t) {
              e.exports = r;
            },
            25: function (e, t, n) {
              var o = n(0),
                a = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
              e.exports = function (e) {
                return a[e] || (a[e] = {});
              };
            },
            26: function (e, t) {
              t.f = Object.getOwnPropertySymbols;
            },
            268: function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 });
              var o = (function (e) {
                return e && e.__esModule ? e : { default: e };
              })(n(112));
              t.default = o.default;
            },
            27: function (e, t, n) {
              var o = n(42);
              e.exports = function (e, t, n) {
                if ((o(e), void 0 === t)) return e;
                switch (n) {
                  case 1:
                    return function (n) {
                      return e.call(t, n);
                    };
                  case 2:
                    return function (n, o) {
                      return e.call(t, n, o);
                    };
                  case 3:
                    return function (n, o, a) {
                      return e.call(t, n, o, a);
                    };
                }
                return function () {
                  return e.apply(t, arguments);
                };
              };
            },
            28: function (e, t) {
              var n = Math.ceil,
                o = Math.floor;
              e.exports = function (e) {
                return isNaN((e = +e)) ? 0 : (e > 0 ? o : n)(e);
              };
            },
            29: function (e, t, n) {
              var o = n(25)("keys"),
                a = n(17);
              e.exports = function (e) {
                return o[e] || (o[e] = a(e));
              };
            },
            3: function (e, t) {
              e.exports = function (e) {
                return "object" == typeof e
                  ? null !== e
                  : "function" == typeof e;
              };
            },
            30: function (e, t) {
              e.exports = function (e) {
                if (void 0 == e) throw TypeError("Can't call method on  " + e);
                return e;
              };
            },
            31: function (e, t, n) {
              var o = n(3),
                a = n(0).document,
                r = o(a) && o(a.createElement);
              e.exports = function (e) {
                return r ? a.createElement(e) : {};
              };
            },
            32: function (e, t, n) {
              e.exports =
                !n(2) &&
                !n(8)(function () {
                  return (
                    7 !=
                    Object.defineProperty(n(31)("div"), "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
            },
            33: function (e, t) {
              var n = {}.toString;
              e.exports = function (e) {
                return n.call(e).slice(8, -1);
              };
            },
            34: function (e, t, n) {
              var o = n(5),
                a = n(48),
                r = n(22),
                i = n(29)("IE_PROTO"),
                l = function () {},
                s = function () {
                  var e,
                    t = n(31)("iframe"),
                    o = r.length;
                  for (
                    t.style.display = "none",
                      n(44).appendChild(t),
                      t.src = "javascript:",
                      (e = t.contentWindow.document).open(),
                      e.write("<script>document.F=Object</script>"),
                      e.close(),
                      s = e.F;
                    o--;

                  )
                    delete s.prototype[r[o]];
                  return s();
                };
              e.exports =
                Object.create ||
                function (e, t) {
                  var n;
                  return (
                    null !== e
                      ? ((l.prototype = o(e)),
                        (n = new l()),
                        (l.prototype = null),
                        (n[i] = e))
                      : (n = s()),
                    void 0 === t ? n : a(n, t)
                  );
                };
            },
            35: function (e, t, n) {
              var o = n(33);
              e.exports = Object("z").propertyIsEnumerable(0)
                ? Object
                : function (e) {
                    return "String" == o(e) ? e.split("") : Object(e);
                  };
            },
            36: function (e, t, n) {
              var o = n(7),
                a = n(6),
                r = n(46)(!1),
                i = n(29)("IE_PROTO");
              e.exports = function (e, t) {
                var n,
                  l = a(e),
                  s = 0,
                  c = [];
                for (n in l) n != i && o(l, n) && c.push(n);
                for (; t.length > s; )
                  o(l, (n = t[s++])) && (~r(c, n) || c.push(n));
                return c;
              };
            },
            37: function (e, t, n) {
              var o = n(15),
                a = n(20),
                r = n(6),
                i = n(21),
                l = n(7),
                s = n(32),
                c = Object.getOwnPropertyDescriptor;
              t.f = n(2)
                ? c
                : function (e, t) {
                    if (((e = r(e)), (t = i(t, !0)), s))
                      try {
                        return c(e, t);
                      } catch (e) {}
                    if (l(e, t)) return a(!o.f.call(e, t), e[t]);
                  };
            },
            4: function (e, t, n) {
              var o = n(5),
                a = n(32),
                r = n(21),
                i = Object.defineProperty;
              t.f = n(2)
                ? Object.defineProperty
                : function (e, t, n) {
                    if ((o(e), (t = r(t, !0)), o(n), a))
                      try {
                        return i(e, t, n);
                      } catch (e) {}
                    if ("get" in n || "set" in n)
                      throw TypeError("Accessors not supported!");
                    return "value" in n && (e[t] = n.value), e;
                  };
            },
            41: function (e, t, n) {
              var o = n(30);
              e.exports = function (e) {
                return Object(o(e));
              };
            },
            42: function (e, t) {
              e.exports = function (e) {
                if ("function" != typeof e)
                  throw TypeError(e + " is not a function!");
                return e;
              };
            },
            43: function (e, t, n) {
              var o = n(28),
                a = Math.min;
              e.exports = function (e) {
                return e > 0 ? a(o(e), 9007199254740991) : 0;
              };
            },
            44: function (e, t, n) {
              var o = n(0).document;
              e.exports = o && o.documentElement;
            },
            46: function (e, t, n) {
              var o = n(6),
                a = n(43),
                r = n(47);
              e.exports = function (e) {
                return function (t, n, i) {
                  var l,
                    s = o(t),
                    c = a(s.length),
                    _ = r(i, c);
                  if (e && n != n) {
                    for (; c > _; ) if ((l = s[_++]) != l) return !0;
                  } else
                    for (; c > _; _++)
                      if ((e || _ in s) && s[_] === n) return e || _ || 0;
                  return !e && -1;
                };
              };
            },
            47: function (e, t, n) {
              var o = n(28),
                a = Math.max,
                r = Math.min;
              e.exports = function (e, t) {
                return (e = o(e)) < 0 ? a(e + t, 0) : r(e, t);
              };
            },
            48: function (e, t, n) {
              var o = n(4),
                a = n(5),
                r = n(11);
              e.exports = n(2)
                ? Object.defineProperties
                : function (e, t) {
                    a(e);
                    for (var n, i = r(t), l = i.length, s = 0; l > s; )
                      o.f(e, (n = i[s++]), t[n]);
                    return e;
                  };
            },
            49: function (e, t, n) {
              n(50);
              var o = n(1).Object;
              e.exports = function (e, t) {
                return o.create(e, t);
              };
            },
            5: function (e, t, n) {
              var o = n(3);
              e.exports = function (e) {
                if (!o(e)) throw TypeError(e + " is not an object!");
                return e;
              };
            },
            50: function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { create: n(34) });
            },
            51: function (e, t, n) {
              n(52), (e.exports = n(1).Object.setPrototypeOf);
            },
            52: function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { setPrototypeOf: n(53).set });
            },
            53: function (e, t, n) {
              var o = n(3),
                a = n(5),
                r = function (e, t) {
                  if ((a(e), !o(t) && null !== t))
                    throw TypeError(t + ": can't set as prototype!");
                };
              e.exports = {
                set:
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function (e, t, o) {
                        try {
                          (o = n(27)(
                            Function.call,
                            n(37).f(Object.prototype, "__proto__").set,
                            2,
                          ))(e, []),
                            (t = !(e instanceof Array));
                        } catch (e) {
                          t = !0;
                        }
                        return function (e, n) {
                          return r(e, n), t ? (e.__proto__ = n) : o(e, n), e;
                        };
                      })({}, !1)
                    : void 0),
                check: r,
              };
            },
            57: function (e, t, n) {
              n(58), (e.exports = n(1).Object.assign);
            },
            58: function (e, t, n) {
              var o = n(10);
              o(o.S + o.F, "Object", { assign: n(59) });
            },
            59: function (e, t, n) {
              "use strict";
              var o = n(11),
                a = n(26),
                r = n(15),
                i = n(41),
                l = n(35),
                s = Object.assign;
              e.exports =
                !s ||
                n(8)(function () {
                  var e = {},
                    t = {},
                    n = Symbol(),
                    o = "abcdefghijklmnopqrst";
                  return (
                    (e[n] = 7),
                    o.split("").forEach(function (e) {
                      t[e] = e;
                    }),
                    7 != s({}, e)[n] || Object.keys(s({}, t)).join("") != o
                  );
                })
                  ? function (e, t) {
                      for (
                        var n = i(e),
                          s = arguments.length,
                          c = 1,
                          _ = a.f,
                          u = r.f;
                        s > c;

                      )
                        for (
                          var d,
                            p = l(arguments[c++]),
                            f = _ ? o(p).concat(_(p)) : o(p),
                            h = f.length,
                            m = 0;
                          h > m;

                        )
                          u.call(p, (d = f[m++])) && (n[d] = p[d]);
                      return n;
                    }
                  : s;
            },
            6: function (e, t, n) {
              var o = n(35),
                a = n(30);
              e.exports = function (e) {
                return o(a(e));
              };
            },
            67: function (e, t, n) {
              e.exports = { default: n(77), __esModule: !0 };
            },
            7: function (e, t) {
              var n = {}.hasOwnProperty;
              e.exports = function (e, t) {
                return n.call(e, t);
              };
            },
            77: function (e, t, n) {
              n(78), (e.exports = n(1).Object.keys);
            },
            78: function (e, t, n) {
              var o = n(41),
                a = n(11);
              n(79)("keys", function () {
                return function (e) {
                  return a(o(e));
                };
              });
            },
            79: function (e, t, n) {
              var o = n(10),
                a = n(1),
                r = n(8);
              e.exports = function (e, t) {
                var n = (a.Object || {})[e] || Object[e],
                  i = {};
                (i[e] = t(n)),
                  o(
                    o.S +
                      o.F *
                        r(function () {
                          n(1);
                        }),
                    "Object",
                    i,
                  );
              };
            },
            8: function (e, t) {
              e.exports = function (e) {
                try {
                  return !!e();
                } catch (e) {
                  return !0;
                }
              };
            },
            9: function (e, t) {
              e.exports = o;
            },
          })));
    },
    "0Cz8": function (e, t, n) {
      var o = n("Xi7e"),
        a = n("ebwN"),
        r = n("e4Nc"),
        i = 200;
      e.exports = function (e, t) {
        var n = this.__data__;
        if (n instanceof o) {
          var l = n.__data__;
          if (!a || l.length < i - 1)
            return l.push([e, t]), (this.size = ++n.size), this;
          n = this.__data__ = new r(l);
        }
        return n.set(e, t), (this.size = n.size), this;
      };
    },
    "0Xqd": function (e, t, n) {
      "use strict";
      var o = n("/xfr"),
        a = n("cKS0");
      function r() {
        return (r =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      var i = {
        run: function () {
          var e = this,
            t = e.slides.eq(e.activeIndex),
            n = e.params.autoplay.delay;
          t.attr("data-swiper-autoplay") &&
            (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
            clearTimeout(e.autoplay.timeout),
            (e.autoplay.timeout = Object(a.g)(function () {
              var t;
              e.params.autoplay.reverseDirection
                ? e.params.loop
                  ? (e.loopFix(),
                    (t = e.slidePrev(e.params.speed, !0, !0)),
                    e.emit("autoplay"))
                  : e.isBeginning
                    ? e.params.autoplay.stopOnLastSlide
                      ? e.autoplay.stop()
                      : ((t = e.slideTo(
                          e.slides.length - 1,
                          e.params.speed,
                          !0,
                          !0,
                        )),
                        e.emit("autoplay"))
                    : ((t = e.slidePrev(e.params.speed, !0, !0)),
                      e.emit("autoplay"))
                : e.params.loop
                  ? (e.loopFix(),
                    (t = e.slideNext(e.params.speed, !0, !0)),
                    e.emit("autoplay"))
                  : e.isEnd
                    ? e.params.autoplay.stopOnLastSlide
                      ? e.autoplay.stop()
                      : ((t = e.slideTo(0, e.params.speed, !0, !0)),
                        e.emit("autoplay"))
                    : ((t = e.slideNext(e.params.speed, !0, !0)),
                      e.emit("autoplay")),
                e.params.cssMode && e.autoplay.running
                  ? e.autoplay.run()
                  : !1 === t && e.autoplay.run();
            }, n));
        },
        start: function () {
          return (
            "undefined" === typeof this.autoplay.timeout &&
            !this.autoplay.running &&
            ((this.autoplay.running = !0),
            this.emit("autoplayStart"),
            this.autoplay.run(),
            !0)
          );
        },
        stop: function () {
          return (
            !!this.autoplay.running &&
            "undefined" !== typeof this.autoplay.timeout &&
            (this.autoplay.timeout &&
              (clearTimeout(this.autoplay.timeout),
              (this.autoplay.timeout = void 0)),
            (this.autoplay.running = !1),
            this.emit("autoplayStop"),
            !0)
          );
        },
        pause: function (e) {
          var t = this;
          t.autoplay.running &&
            (t.autoplay.paused ||
              (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
              (t.autoplay.paused = !0),
              0 !== e && t.params.autoplay.waitForTransition
                ? ["transitionend", "webkitTransitionEnd"].forEach(
                    function (e) {
                      t.$wrapperEl[0].addEventListener(
                        e,
                        t.autoplay.onTransitionEnd,
                      );
                    },
                  )
                : ((t.autoplay.paused = !1), t.autoplay.run())));
        },
        onVisibilityChange: function () {
          var e = Object(o.a)();
          "hidden" === e.visibilityState &&
            this.autoplay.running &&
            this.autoplay.pause(),
            "visible" === e.visibilityState &&
              this.autoplay.paused &&
              (this.autoplay.run(), (this.autoplay.paused = !1));
        },
        onTransitionEnd: function (e) {
          var t = this;
          t &&
            !t.destroyed &&
            t.$wrapperEl &&
            e.target === t.$wrapperEl[0] &&
            (["transitionend", "webkitTransitionEnd"].forEach(function (e) {
              t.$wrapperEl[0].removeEventListener(
                e,
                t.autoplay.onTransitionEnd,
              );
            }),
            (t.autoplay.paused = !1),
            t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
        },
        onMouseEnter: function () {
          var e = this;
          e.params.autoplay.disableOnInteraction
            ? e.autoplay.stop()
            : e.autoplay.pause(),
            ["transitionend", "webkitTransitionEnd"].forEach(function (t) {
              e.$wrapperEl[0].removeEventListener(
                t,
                e.autoplay.onTransitionEnd,
              );
            });
        },
        onMouseLeave: function () {
          this.params.autoplay.disableOnInteraction ||
            ((this.autoplay.paused = !1), this.autoplay.run());
        },
        attachMouseEvents: function () {
          this.params.autoplay.pauseOnMouseEnter &&
            (this.$el.on("mouseenter", this.autoplay.onMouseEnter),
            this.$el.on("mouseleave", this.autoplay.onMouseLeave));
        },
        detachMouseEvents: function () {
          this.$el.off("mouseenter", this.autoplay.onMouseEnter),
            this.$el.off("mouseleave", this.autoplay.onMouseLeave);
        },
      };
      t.a = {
        name: "autoplay",
        params: {
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !0,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1,
          },
        },
        create: function () {
          Object(a.a)(this, {
            autoplay: r({}, i, { running: !1, paused: !1 }),
          });
        },
        on: {
          init: function (e) {
            e.params.autoplay.enabled &&
              (e.autoplay.start(),
              Object(o.a)().addEventListener(
                "visibilitychange",
                e.autoplay.onVisibilityChange,
              ),
              e.autoplay.attachMouseEvents());
          },
          beforeTransitionStart: function (e, t, n) {
            e.autoplay.running &&
              (n || !e.params.autoplay.disableOnInteraction
                ? e.autoplay.pause(t)
                : e.autoplay.stop());
          },
          sliderFirstMove: function (e) {
            e.autoplay.running &&
              (e.params.autoplay.disableOnInteraction
                ? e.autoplay.stop()
                : e.autoplay.pause());
          },
          touchEnd: function (e) {
            e.params.cssMode &&
              e.autoplay.paused &&
              !e.params.autoplay.disableOnInteraction &&
              e.autoplay.run();
          },
          destroy: function (e) {
            e.autoplay.detachMouseEvents(),
              e.autoplay.running && e.autoplay.stop(),
              Object(o.a)().removeEventListener(
                "visibilitychange",
                e.autoplay.onVisibilityChange,
              );
          },
        },
      };
    },
    "0eaO": function (e, t, n) {},
    "0tVQ": function (e, t, n) {
      n("FlQf"), n("VJsP"), (e.exports = n("WEpk").Array.from);
    },
    "0y5z": function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o,
        a = n("AQPw"),
        r = (o = a) && o.__esModule ? o : { default: o };
      t.default = r.default;
    },
    "0ycA": function (e, t) {
      e.exports = function () {
        return [];
      };
    },
    "1+5i": function (e, t, n) {
      var o = n("w/wX"),
        a = n("sEf8"),
        r = n("mdPL"),
        i = r && r.isSet,
        l = i ? a(i) : o;
      e.exports = l;
    },
    "1RGQ": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return j;
      });
      var o = n("tm1d"),
        a = n("JKea"),
        r = n("mrSG"),
        i = n("IQvP"),
        l = n("1bLc"),
        s = n("90zR"),
        c = n("82gj"),
        _ = function (e, t, n) {
          var o = e * e,
            a = t * t;
          return Math.sqrt(Math.max(0, n * (a - o) + o));
        },
        u = [i.a, l.a, s.a],
        d = function (e) {
          return u.find(function (t) {
            return t.test(e);
          });
        },
        p = function (e) {
          return (
            "'" +
            e +
            "' is not an animatable color. Use the equivalent color code instead."
          );
        },
        f = function (e, t) {
          var n = d(e),
            o = d(t);
          Object(c.a)(!!n, p(e)),
            Object(c.a)(!!o, p(t)),
            Object(c.a)(
              n.transform === o.transform,
              "Both colors must be hex/RGBA, OR both must be HSLA.",
            );
          var i = n.parse(e),
            l = o.parse(t),
            u = Object(r.a)({}, i),
            f = n === s.a ? a.a : _;
          return function (e) {
            for (var t in u) "alpha" !== t && (u[t] = f(i[t], l[t], e));
            return (u.alpha = Object(a.a)(i.alpha, l.alpha, e)), n.transform(u);
          };
        },
        h = n("V6Gm"),
        m = n("Epvc"),
        y = n("aqq1"),
        b = n("NJgT");
      function v(e, t) {
        return Object(y.a)(e)
          ? function (n) {
              return Object(a.a)(e, t, n);
            }
          : h.a.test(e)
            ? f(e, t)
            : k(e, t);
      }
      var g = function (e, t) {
          var n = Object(r.e)([], e),
            o = n.length,
            a = e.map(function (e, n) {
              return v(e, t[n]);
            });
          return function (e) {
            for (var t = 0; t < o; t++) n[t] = a[t](e);
            return n;
          };
        },
        w = function (e, t) {
          var n = Object(r.a)(Object(r.a)({}, e), t),
            o = {};
          for (var a in n)
            void 0 !== e[a] && void 0 !== t[a] && (o[a] = v(e[a], t[a]));
          return function (e) {
            for (var t in o) n[t] = o[t](e);
            return n;
          };
        };
      function x(e) {
        for (
          var t = m.a.parse(e), n = t.length, o = 0, a = 0, r = 0, i = 0;
          i < n;
          i++
        )
          o || "number" === typeof t[i] ? o++ : void 0 !== t[i].hue ? r++ : a++;
        return { parsed: t, numNumbers: o, numRGB: a, numHSL: r };
      }
      var k = function (e, t) {
          var n = m.a.createTransformer(t),
            o = x(e),
            a = x(t);
          return (
            Object(c.a)(
              o.numHSL === a.numHSL &&
                o.numRGB === a.numRGB &&
                o.numNumbers >= a.numNumbers,
              "Complex values '" +
                e +
                "' and '" +
                t +
                "' too different to mix. Ensure all colors are of the same type.",
            ),
            Object(b.a)(g(o.parsed, a.parsed), n)
          );
        },
        O = n("LUwM"),
        I = function (e, t) {
          return function (n) {
            return Object(a.a)(e, t, n);
          };
        };
      function S(e, t, n) {
        for (
          var o,
            a = [],
            r =
              n ||
              ("number" === typeof (o = e[0])
                ? I
                : "string" === typeof o
                  ? h.a.test(o)
                    ? f
                    : k
                  : Array.isArray(o)
                    ? g
                    : "object" === typeof o
                      ? w
                      : void 0),
            i = e.length - 1,
            l = 0;
          l < i;
          l++
        ) {
          var s = r(e[l], e[l + 1]);
          if (t) {
            var c = Array.isArray(t) ? t[l] : t;
            s = Object(b.a)(c, s);
          }
          a.push(s);
        }
        return a;
      }
      function j(e, t, n) {
        var a = void 0 === n ? {} : n,
          r = a.clamp,
          i = void 0 === r || r,
          l = a.ease,
          s = a.mixer,
          _ = e.length;
        Object(c.a)(
          _ === t.length,
          "Both input and output ranges must be the same length",
        ),
          Object(c.a)(
            !l || !Array.isArray(l) || l.length === _ - 1,
            "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.",
          ),
          e[0] > e[_ - 1] &&
            ((e = [].concat(e)), (t = [].concat(t)), e.reverse(), t.reverse());
        var u = S(t, l, s),
          d =
            2 === _
              ? (function (e, t) {
                  var n = e[0],
                    a = e[1],
                    r = t[0];
                  return function (e) {
                    return r(Object(o.a)(n, a, e));
                  };
                })(e, u)
              : (function (e, t) {
                  var n = e.length,
                    a = n - 1;
                  return function (r) {
                    var i = 0,
                      l = !1;
                    if (
                      (r <= e[0]
                        ? (l = !0)
                        : r >= e[a] && ((i = a - 1), (l = !0)),
                      !l)
                    ) {
                      for (var s = 1; s < n && !(e[s] > r || s === a); s++);
                      i = s - 1;
                    }
                    var c = Object(o.a)(e[i], e[i + 1], r);
                    return t[i](c);
                  };
                })(e, u);
        return i
          ? function (t) {
              return d(Object(O.a)(e[0], e[_ - 1], t));
            }
          : d;
      }
    },
    "1Sjk": function (e, t, n) {
      e.exports = {
        "wm161-model-container": "style__wm161-model-container___30e7G",
        "model-switch": "style__model-switch___12ICk",
        "model-title": "style__model-title___1EHUJ",
        "model-tabs": "style__model-tabs___1WJZg",
        "model-tabs-back-mask": "style__model-tabs-back-mask___SDF0o",
        "model-tabs-panel": "style__model-tabs-panel___2GSAa",
        "model-ar-block": "style__model-ar-block___2vuJC",
        "model-block": "style__model-block___Gknf8",
        "model-desc": "style__model-desc___heClW",
        "model-ar-desc": "style__model-ar-desc___3oWGU",
        "not-support-ar": "style__not-support-ar___29TGI",
        "not-good-support-ar": "style__not-good-support-ar___3MeFG",
        "normal-ar-entry": "style__normal-ar-entry___13sZa",
        "angle-right-icon": "style__angle-right-icon___2_0ZE",
        "model-ar-img": "style__model-ar-img___2Qxvz",
        "unfold-model-viewer": "style__unfold-model-viewer___2RNj3",
        "fold-model-viewer": "style__fold-model-viewer___10qQa",
        "model-content": "style__model-content___1gy78",
        "model-progress": "style__model-progress___2B0L7",
        "cube-box": "style__cube-box___1iJ7a",
        cube: "style__cube___3cAOS",
        sides: "style__sides___2TZd1",
        rotate: "style__rotate___14J0k",
        top: "style__top___NArHd",
        "top-animation": "style__top-animation___2e3Rd",
        bottom: "style__bottom___-RVp6",
        "bottom-animation": "style__bottom-animation___18LYJ",
        front: "style__front___1v1IB",
        "front-animation": "style__front-animation___2446z",
        back: "style__back___32Zg8",
        "back-animation": "style__back-animation___L5DSw",
        left: "style__left___3LNwS",
        "left-animation": "style__left-animation___3R-c2",
        right: "style__right___1IR51",
        "right-animation": "style__right-animation___3-4Xm",
        text: "style__text___2_gjz",
        "bar-wrapper": "style__bar-wrapper___1U5Gx",
        bar: "style__bar___u4qNR",
        "model-error": "style__model-error___10zDo",
        "model-retry-btn": "style__model-retry-btn___1AvnD",
        "model-retry-logo": "style__model-retry-logo___2TjAl",
        "model-error-logo": "style__model-error-logo___237uu",
        "progress-show": "style__progress-show___1uNUe",
        "switch-model": "style__switch-model___2r4Zd",
        "model-ar-tips": "style__model-ar-tips___9ZVUu",
        "wm161-model-container-in-modal":
          "style__wm161-model-container-in-modal___tMx0t",
        "model-3d-block": "style__model-3d-block___3u3CB",
        "normal-ar-entry-first": "style__normal-ar-entry-first___1IXa_",
        "wm161-model-container-light-theme":
          "style__wm161-model-container-light-theme___3Vg_B",
      };
    },
    "1bLc": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return c;
      });
      var o = n("mrSG"),
        a = n("C68Z"),
        r = n("3T+G"),
        i = n("wFID"),
        l = Object(r.a)(0, 255),
        s = Object(o.a)(Object(o.a)({}, a.b), {
          transform: function (e) {
            return Math.round(l(e));
          },
        }),
        c = {
          test: Object(i.a)("rgb", "red"),
          parse: Object(i.b)("red", "green", "blue"),
          transform: function (e) {
            var t = e.red,
              n = e.green,
              o = e.blue,
              i = e.alpha,
              l = void 0 === i ? 1 : i;
            return (
              "rgba(" +
              s.transform(t) +
              ", " +
              s.transform(n) +
              ", " +
              s.transform(o) +
              ", " +
              Object(r.e)(a.a.transform(l)) +
              ")"
            );
          },
        };
    },
    "1d9b": function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("q1tI"),
        u = n.n(_),
        d = n("XnI8"),
        p = n("9/5/"),
        f = n.n(p),
        h = (n("zZ+F"), n("yWgo")),
        m = n("Sggk"),
        y = n("8tV9"),
        b = n("gn4A"),
        v = n.n(b),
        g = u.a.createElement;
      function w(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var x = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = w(this, t, [e])).state = {
              windowHeight: 0,
              includeModuleHeights: 0,
            }),
            (n.bodyColorSet = !1),
            (n.bodyColorReset = !1),
            (n.onResize = n.onResize.bind(Object(l.a)(n))),
            (n.calcInclueModuleHeight = n.calcInclueModuleHeight.bind(
              Object(l.a)(n),
            )),
            (n.checkHeightWhenScroll = n.checkHeightWhenScroll.bind(
              Object(l.a)(n),
            )),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                this.checkHeightAfterWindowLoaded(),
                  this.onResize(),
                  (this.debounceResize = f()(this.onResize, 300)),
                  window.addEventListener("resize", this.debounceResize);
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                window.removeEventListener("resize", this.debounceResize),
                  this.checkTimer && clearTimeout(this.checkTimer);
              },
            },
            {
              key: "checkHeightWhenScroll",
              value: function (e) {
                var t = this,
                  n = (this.props.component_data, 0 === e || 1 === e);
                ("undefined" === typeof document || this.checkTimer || n) &&
                  (n && this.clearCheckTimer(),
                  (this.isIpad =
                    "boolean" === typeof this.isIpad
                      ? this.isIpad
                      : v.a.isIpad()),
                  this.isIpad ||
                    (e < 0.02 &&
                      !this.bodyColorSet &&
                      (this.setBodyColorToBlack(),
                      (this.bodyColorSet = !0),
                      (this.bodyColorReset = !1)),
                    e >= 0.02 &&
                      !this.bodyColorReset &&
                      (this.resetBodyColor(),
                      (this.bodyColorReset = !0),
                      (this.bodyColorSet = !1))));
                !(function e() {
                  t.checkTimer = setTimeout(function () {
                    t.progress === t.prevProgress
                      ? t.clearCheckTimer()
                      : ((t.prevProgress = t.progress),
                        t.calcInclueModuleHeight(),
                        e());
                  }, 500);
                })();
              },
            },
            {
              key: "setBodyColorToBlack",
              value: function () {
                this.props.component_data;
                "undefined" !== typeof document &&
                  (document.body.style.backgroundColor = "black");
              },
            },
            {
              key: "resetBodyColor",
              value: function () {
                this.props.component_data;
                "undefined" !== typeof document &&
                  "black" === document.body.style.backgroundColor &&
                  (document.body.style.backgroundColor = "white");
              },
            },
            {
              key: "clearCheckTimer",
              value: function () {
                this.checkTimer &&
                  (clearTimeout(this.checkTimer), (this.checkTimer = null));
              },
            },
            {
              key: "calcInclueModuleHeight",
              value: function () {
                var e = this.props.component_data,
                  t = (void 0 === e ? {} : e).includeModuleNums,
                  n = void 0 === t ? 0 : t,
                  o = "",
                  a = 0,
                  r = 0;
                if (this.section && this.section.parentElement) {
                  o = this.section.parentElement.id;
                  for (
                    var i = document.getElementsByClassName("section-content"),
                      l = 0;
                    l < i.length;
                    l++
                  )
                    if (i[l].id === o) {
                      a = l;
                      break;
                    }
                  for (var s = a + 1; s <= a + parseInt(n); s++)
                    i[s] && i[s].offsetHeight && (r += i[s].offsetHeight);
                  this.setState({ includeModuleHeights: r });
                }
              },
            },
            {
              key: "checkHeightAfterWindowLoaded",
              value: function () {
                "complete" !== document.readyState
                  ? window.addEventListener("load", this.calcInclueModuleHeight)
                  : this.calcInclueModuleHeight();
              },
            },
            {
              key: "onResize",
              value: function () {
                h.Q &&
                  (this.setState(function (e) {
                    return {
                      windowHeight:
                        e.windowHeight > window.innerHeight
                          ? e.windowHeight
                          : window.innerHeight,
                    };
                  }),
                  this.checkHeightAfterWindowLoaded());
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props.component_data || {},
                  n = t.changeColorHeight,
                  o = t.backgroundColorStart,
                  a = t.backgroundColorEnd,
                  r = t.triggerOffsetScreen,
                  i = void 0 === r ? 0.3 : r,
                  l = this.state,
                  s = l.windowHeight,
                  c = l.includeModuleHeights,
                  _ = +n * s;
                return g(
                  "section",
                  {
                    className: "style__section-103-change-color___5cRUs",
                    ref: function (t) {
                      e.section = t;
                    },
                  },
                  g(
                    "div",
                    {
                      className: "style__sticky-container___SiEyD",
                      ref: function (t) {
                        e.trigger = t;
                      },
                    },
                    g(
                      m.a,
                      null,
                      g(
                        m.b,
                        {
                          key: "animation",
                          triggerHook: 0,
                          duration: _,
                          offset: +i * s,
                          triggerElement: this.section,
                        },
                        function (t) {
                          return (
                            (e.progress = t),
                            e.checkHeightWhenScroll(e.progress),
                            g(
                              "div",
                              { style: { height: c + "px" } },
                              g(
                                y.b,
                                {
                                  totalProgress: t,
                                  from: { backgroundColor: o },
                                  to: { backgroundColor: a },
                                  paused: !0,
                                },
                                g("div", {
                                  style: {
                                    height: c + "px",
                                    width: "100%",
                                    backgroundColor: a,
                                  },
                                }),
                              ),
                            )
                          );
                        },
                      ),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(u.a.Component);
      Object(c.a)(x, "defaultProps", {
        component_data: {
          backgroundColorStart: "#000000",
          backgroundColorEnd: "#ffffff",
          changeColorHeight: 0,
          includeModuleNums: 3,
        },
      }),
        Object(c.a)(x, "propSettings", {
          key: "ac103ChangeColor",
          name: "ac103ChangeColor",
          contentSetting: {
            setting: {
              label: "\u914d\u7f6e",
              props: {
                isMobile: {
                  label: "\u662f\u5426\u662f\u79fb\u52a8\u7aef\u4f7f\u7528",
                  type: "boolean",
                },
                backgroundColorStart: {
                  label:
                    "\u80cc\u666f\u989c\u8272(\u5f00\u59cb), \u9ed8\u8ba4: #000000",
                  type: "string",
                  content: "color",
                },
                backgroundColorEnd: {
                  label:
                    "\u80cc\u666f\u989c\u8272(\u7ed3\u675f), \u9ed8\u8ba4: #ffffff",
                  type: "string",
                  content: "color",
                },
                changeColorHeight: {
                  label:
                    "\u6539\u53d8\u989c\u8272\u8ddd\u79bb(\u5c4f\u9ad8\u500d\u6570), \u9ed8\u8ba4: 0",
                  type: "number",
                },
                includeModuleNums: {
                  type: "number",
                  label:
                    "\u5305\u542b\u6a21\u5757\u4e2a\u6570, \u9ed8\u8ba4: 3",
                },
                triggerOffsetScreen: {
                  type: "number",
                  label:
                    "\u89c6\u9891\u8d70\u4e86\u591a\u5c11\u5c4f\u4e4b\u540e\u5f00\u59cb\u53d8\u7070 (\u9ed8\u8ba4 0.4\uff0c0.0~1.0)",
                },
              },
            },
          },
          skinSetting: {},
        }),
        (t.a = Object(d.a)(x));
    },
    "1icT": function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return r;
      }),
        n.d(t, "a", function () {
          return i;
        }),
        n.d(t, "e", function () {
          return l;
        }),
        n.d(t, "d", function () {
          return s;
        }),
        n.d(t, "c", function () {
          return c;
        });
      var o = n("q1tI"),
        a = n.n(o).a.createElement,
        r = function (e) {
          return a(
            "svg",
            e,
            a("path", {
              d: "m12 10.695 9.39-9.39c.72-.72 1.89-.72 2.61 0L13.305 12l9.39 9.39c.72.72.72 1.89 0 2.61L12 13.305l-9.39 9.39c-.72.72-1.89.72-2.61 0L10.695 12l-9.39-9.39c-.72-.72-.72-1.89 0-2.61L12 10.695Z",
              fillRule: "nonzero",
              stroke: "current",
              fill: "current",
            }),
          );
        };
      r.defaultProps = {
        width: "24",
        height: "24",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var i = function (e) {
        return a(
          "svg",
          e,
          a("path", {
            d: "M8.8 7.2h5.6A1.6 1.6 0 0 1 16 8.8H8.8v5.6A1.6 1.6 0 0 1 7.2 16V8.8H1.6A1.6 1.6 0 0 1 0 7.2h7.2V1.6A1.6 1.6 0 0 1 8.8 0v7.2Z",
            fillRule: "nonzero",
            stroke: "current",
            fill: "current",
          }),
        );
      };
      i.defaultProps = {
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var l = function (e) {
        return a(
          "svg",
          e,
          a("path", {
            d: "M9.762 0h-.94a.238.238 0 0 0-.238.25l.08 1.641A4.905 4.905 0 0 0 4.916.16 4.929 4.929 0 0 0 0 5.083a4.919 4.919 0 0 0 8.212 3.649.238.238 0 0 0 .01-.346l-.674-.674a.238.238 0 0 0-.325-.011 3.488 3.488 0 0 1-5.766-3.07 3.489 3.489 0 0 1 6.357-1.5l-2.013-.097a.238.238 0 0 0-.25.238v.941c0 .132.107.238.239.238h3.972A.238.238 0 0 0 10 4.213V.238A.238.238 0 0 0 9.762 0Z",
            fill: "#FFF",
            fillRule: "evenodd",
          }),
        );
      };
      l.defaultProps = {
        width: "10",
        height: "10",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var s = function (e) {
        return a(
          "svg",
          e,
          a("path", {
            d: "m7.553 4.696-6.24 3.2c-.423.218-.96.082-1.2-.302A.743.743 0 0 1 0 7.2V.799C0 .358.394 0 .88 0c.152 0 .3.036.433.103l6.24 3.201c.423.217.572.705.333 1.089a.844.844 0 0 1-.333.303Z",
            fill: "#FFF",
            fillRule: "nonzero",
          }),
        );
      };
      s.defaultProps = {
        width: "8",
        height: "8",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var c = function (e) {
        return a(
          "svg",
          e,
          a("path", {
            d: "M2.893 9H.964A.965.965 0 0 1 0 8.036V.964C0 .432.432 0 .964 0h1.929c.532 0 .964.432.964.964v7.072A.965.965 0 0 1 2.893 9ZM9 8.036V.964A.965.965 0 0 0 8.036 0H6.107a.965.965 0 0 0-.964.964v7.072c0 .532.432.964.964.964h1.929A.965.965 0 0 0 9 8.036Z",
            fill: "#FFF",
            fillRule: "evenodd",
          }),
        );
      };
      c.defaultProps = {
        width: "9",
        height: "9",
        xmlns: "http://www.w3.org/2000/svg",
      };
    },
    "1w3K": function (e, t, n) {
      "use strict";
      var o = l(n("Si88")),
        a = l(n("PAGr")),
        r = l(n("UnXY")),
        i = l(n("S3Uj"));
      function l(e) {
        return e && e.__esModule ? e : { default: e };
      }
      e.exports = {
        Transition: i.default,
        TransitionGroup: r.default,
        ReplaceTransition: a.default,
        CSSTransition: o.default,
      };
    },
    "29s/": function (e, t, n) {
      var o = n("WEpk"),
        a = n("5T2Y"),
        r = a["__core-js_shared__"] || (a["__core-js_shared__"] = {});
      (e.exports = function (e, t) {
        return r[e] || (r[e] = void 0 !== t ? t : {});
      })("versions", []).push({
        version: o.version,
        mode: n("uOPS") ? "pure" : "global",
        copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)",
      });
    },
    "2GTP": function (e, t, n) {
      var o = n("eaoh");
      e.exports = function (e, t, n) {
        if ((o(e), void 0 === t)) return e;
        switch (n) {
          case 1:
            return function (n) {
              return e.call(t, n);
            };
          case 2:
            return function (n, o) {
              return e.call(t, n, o);
            };
          case 3:
            return function (n, o, a) {
              return e.call(t, n, o, a);
            };
        }
        return function () {
          return e.apply(t, arguments);
        };
      };
    },
    "2Nb0": function (e, t, n) {
      n("FlQf"), n("bBy9"), (e.exports = n("zLkG").f("iterator"));
    },
    "2OhW": function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("iKuz"),
        u = n.n(_),
        d = n("q1tI"),
        p = n.n(d),
        f = n("t3Un"),
        h = n("XnI8"),
        m = n("ISdw"),
        y = n("u11H"),
        b = n("XrJB"),
        v = n.n(b),
        g = (n("aiR1"), n("HL8k"), n("yWgo")),
        w = p.a.createElement,
        x = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "area-linkage": "style__area-linkage___UcXvr",
            "form-group": "style__form-group___uFcrd",
            hide: "style__hide___2Vks2",
            "select-box": "style__select-box___1Ez_H",
            select: "style__select___1jXjt",
            icon: "style__icon___2hy01",
          },
        };
      function k(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var O = function (e, t, n) {
          if ("string" !== typeof e) return "";
          var o = e.replace(" *", "").replace("*", ""),
            a = t && !n ? " *" : "";
          return "".concat(o).concat(a);
        },
        I = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t),
              ((n = k(this, t, [e])).state = {
                continent: [],
                states: [],
                country: [],
                cities: [],
              }),
              (n.renderContinent = n.renderContinent.bind(Object(l.a)(n))),
              (n.renderCountry = n.renderCountry.bind(Object(l.a)(n))),
              (n.renderState = n.renderState.bind(Object(l.a)(n))),
              (n.renderCity = n.renderCity.bind(Object(l.a)(n))),
              (n.loadContinents = n.loadContinents.bind(Object(l.a)(n))),
              (n.handleChangeContinent = n.handleChangeContinent.bind(
                Object(l.a)(n),
              )),
              (n.handleChangeCountry = n.handleChangeCountry.bind(
                Object(l.a)(n),
              )),
              (n.handleChangeState = n.handleChangeState.bind(Object(l.a)(n))),
              (n.formatLabel = n.formatLabel.bind(Object(l.a)(n))),
              n
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this,
                    t = this.props.autoMatch;
                  Object(g.pb)(function () {
                    setTimeout(function () {
                      e.loadContinents(), t && e.autoSetAddressByIp();
                    }, 10);
                  });
                },
              },
              {
                key: "loadContinents",
                value: function () {
                  var e = this,
                    t = this.props.localization;
                  y.default
                    .request({ method: "GET", name: "dealerContinent" }, t)
                    .then(function (e) {
                      return e.json();
                    })
                    .then(function (t) {
                      try {
                        e.setState({ continent: t });
                      } catch (n) {}
                    });
                },
              },
              {
                key: "autoSetAddressByIp",
                value: function () {
                  var e = this,
                    t = this.props.localization,
                    n = Object(g.L)("ip", !0),
                    o = {};
                  n && "" !== n && (o.ip = n),
                    y.default
                      .request(
                        { method: "GET", name: "flySafeIpLocation", query: o },
                        t,
                      )
                      .then(function (e) {
                        return e.json();
                      })
                      .then(function (t) {
                        if (t && "200" === t.status) {
                          var n =
                              "CN" === t.country
                                ? t.state && t.state.name_cn
                                : "",
                            o = t.continent,
                            a = t.country;
                          n ? e.setAddress(o, a, n) : e.setAddress(o, a);
                        }
                      });
                },
              },
              {
                key: "setAddress",
                value: function (e, t, n) {
                  var o = this,
                    a = this.props,
                    r = a.form,
                    i =
                      (a.component_data || {}).customContinentKey ||
                      "continent";
                  try {
                    var l = function (e) {
                        return { target: { value: e } };
                      },
                      s = t.toLowerCase();
                    e &&
                      (r.setFieldsValue(Object(c.a)({}, i, e)),
                      this.handleChangeContinent(l(e), s, function () {
                        s &&
                          o.handleChangeCountry(l(s), n, function (e) {
                            e && o.handleChangeState(l(e));
                          });
                      }));
                  } catch (_) {}
                },
              },
              {
                key: "handleChangeContinent",
                value: function (e, t, n) {
                  var o = this,
                    a = e.target.value,
                    r = this.props,
                    i = r.localization,
                    l = r.form,
                    s = r.component_data.customCountryKey || "activity_country";
                  this.setState({ states: [], country: [], cities: [] }),
                    y.default
                      .request(
                        {
                          method: "GET",
                          name: "dealerCountry",
                          query: { continent: a },
                        },
                        i,
                      )
                      .then(function (e) {
                        return e.json();
                      })
                      .then(function (e) {
                        try {
                          t
                            ? (l.setFieldsValue(Object(c.a)({}, s, t)),
                              o.setState({ country: e }),
                              "function" === typeof n && n())
                            : (l.resetFields(s),
                              l.setFieldsValue({ state: "" }),
                              o.setState({ country: e, states: [] }));
                        } catch (a) {}
                      });
                },
              },
              {
                key: "handleChangeCountry",
                value: function (e, t, n) {
                  var o = this,
                    a = e.target.value,
                    r = this.props,
                    i = r.localization,
                    l = r.form,
                    s = r.onCountryChange,
                    c = r.hideStates;
                  this.setState({ cities: [] }),
                    s && s(a),
                    c ||
                      Object(f.a)(
                        {
                          url: y.default.renderAPI(
                            "/api/dealers/states/".concat(a),
                          ),
                        },
                        i,
                      )
                        .then(function (e) {
                          return e.json();
                        })
                        .then(function (e) {
                          try {
                            if (
                              (o.setState({ states: e }),
                              t &&
                                e &&
                                Array.isArray(e.data) &&
                                e.data.length > 0)
                            ) {
                              var a = (
                                e.data.find(function (e) {
                                  return e.name.includes(t);
                                }) || {}
                              ).code;
                              a && l.setFieldsValue({ state: a || "" }),
                                "function" === typeof n && n(a);
                            }
                          } catch (r) {}
                        });
                },
              },
              {
                key: "handleChangeState",
                value: function (e) {
                  var t = this,
                    n = e.target.value,
                    o = this.props,
                    a = o.localization,
                    r = o.form,
                    i = o.hideCities;
                  this.setState({ cities: [] }),
                    i ||
                      y.default
                        .request(
                          {
                            method: "GET",
                            name: "citiesInChina",
                            query: { state: n },
                          },
                          a,
                        )
                        .then(function (e) {
                          return e.json();
                        })
                        .then(function (e) {
                          try {
                            r.setFieldsValue({ city: "" }),
                              t.setState({ cities: e });
                          } catch (n) {}
                        });
                },
              },
              {
                key: "formatLabel",
                value: function (e) {
                  var t = this.props.formatLabel;
                  return "function" === typeof t ? t(e) : e;
                },
              },
              {
                key: "renderContinent",
                value: function () {
                  var e = this.state.continent;
                  return e && e.data && e.data.length > 0
                    ? e.data.map(function (e) {
                        return w(
                          "option",
                          { value: e.code, key: e.code },
                          e.name,
                        );
                      })
                    : null;
                },
              },
              {
                key: "renderCountry",
                value: function () {
                  var e = this.state.country;
                  return e && e.data && e.data.length > 0
                    ? e.data.map(function (e) {
                        return w(
                          "option",
                          { value: e.code, key: e.code },
                          e.name,
                        );
                      })
                    : null;
                },
              },
              {
                key: "renderState",
                value: function () {
                  var e = this.state.states;
                  return e && e.data && e.data.length > 0
                    ? e.data.map(function (e) {
                        return w(
                          "option",
                          { value: e.code, key: e.code },
                          e.name,
                        );
                      })
                    : null;
                },
              },
              {
                key: "renderCity",
                value: function () {
                  var e = this.state.cities;
                  return e && e.data && e.data.length > 0
                    ? e.data.map(function (e, t) {
                        return w("option", { value: e, key: t }, e);
                      })
                    : null;
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.form,
                    n = e.component_data,
                    o = e.t,
                    a = e.children,
                    r = e.removeContainer,
                    i = void 0 !== r && r,
                    l = e.notRequired,
                    s = void 0 !== l && l,
                    c = e.hasFormTitle,
                    _ = void 0 !== c && c,
                    d = e.hideContinentCountryInCn,
                    f = void 0 !== d && d,
                    h = e.localization,
                    y = e.hideRequiredStar,
                    b = (n || {}).countryErrorMsg,
                    g = !s,
                    k = this.state,
                    I = k.states,
                    S = k.cities,
                    j = t.getFieldDecorator,
                    T = {
                      initialValue: "",
                      validateTrigger: "onBlur",
                      rules: [
                        {
                          required: g,
                          whitespace: !0,
                          message: o(n.promptRequire),
                        },
                      ],
                    },
                    C =
                      "cn" === h.country.toLowerCase() && f
                        ? "form-group hide"
                        : "form-group",
                    M = "cn" !== h.country.toLowerCase() && f;
                  return i
                    ? w(
                        p.a.Fragment,
                        null,
                        w(
                          "div",
                          { className: C },
                          _
                            ? w("p", {
                                className: "form-title",
                                dangerouslySetInnerHTML: {
                                  __html: O(o(n.continent), g),
                                },
                              })
                            : null,
                          w(
                            m.b,
                            { label: this.formatLabel(o(n.continent_label)) },
                            w(
                              "div",
                              {
                                className: "style__select-box___1Ez_H",
                                error: n.customContinentKey || "continent",
                              },
                              j(
                                n.customContinentKey || "continent",
                                T,
                              )(
                                w(
                                  "select",
                                  {
                                    className: "style__select___1jXjt",
                                    name: n.customContinentKey || "continent",
                                    onChange: this.handleChangeContinent,
                                  },
                                  w(
                                    "option",
                                    { value: "" },
                                    O(o(n.continent), g, y),
                                  ),
                                  this.renderContinent(),
                                ),
                              ),
                              w(
                                "div",
                                { className: "style__icon___2hy01" },
                                w(v.a, { name: "caret-down" }),
                              ),
                            ),
                          ),
                        ),
                        w(
                          "div",
                          { className: C },
                          _
                            ? w("p", {
                                className: "form-title",
                                dangerouslySetInnerHTML: {
                                  __html: O(o(n.country), g),
                                },
                              })
                            : null,
                          w(
                            m.b,
                            { label: this.formatLabel(o(n.country_label)) },
                            w(
                              "div",
                              {
                                className: "style__select-box___1Ez_H",
                                error: n.customCountryKey || "activity_country",
                                warningMsg: b,
                              },
                              j(
                                n.customCountryKey || "activity_country",
                                T,
                              )(
                                w(
                                  "select",
                                  {
                                    className: "style__select___1jXjt",
                                    name:
                                      n.customCountryKey || "activity_country",
                                    onChange: this.handleChangeCountry,
                                  },
                                  w(
                                    "option",
                                    { value: "" },
                                    O(o(n.country), g, y),
                                  ),
                                  this.renderCountry(),
                                ),
                              ),
                              w(
                                "div",
                                { className: "style__icon___2hy01" },
                                w(v.a, { name: "caret-down" }),
                              ),
                            ),
                          ),
                        ),
                        I && I.data && I.data.length > 0
                          ? w(
                              "div",
                              { className: "form-group" },
                              _
                                ? w("p", {
                                    className: "form-title",
                                    dangerouslySetInnerHTML: {
                                      __html: O(o(n.state), g),
                                    },
                                  })
                                : null,
                              w(
                                m.b,
                                { label: this.formatLabel(o(n.state_label)) },
                                w(
                                  "div",
                                  {
                                    className: "style__select-box___1Ez_H",
                                    error: "state",
                                  },
                                  j(
                                    "state",
                                    T,
                                  )(
                                    w(
                                      "select",
                                      {
                                        className: "style__select___1jXjt",
                                        name: "state",
                                        onChange: this.handleChangeState,
                                      },
                                      w(
                                        "option",
                                        { value: "" },
                                        O(o(n.state), g, y),
                                      ),
                                      this.renderState(),
                                    ),
                                  ),
                                  w(
                                    "div",
                                    { className: "style__icon___2hy01" },
                                    w(v.a, { name: "caret-down" }),
                                  ),
                                ),
                              ),
                            )
                          : null,
                        S && S.data && S.data.length > 0 && !M
                          ? w(
                              "div",
                              { className: "form-group" },
                              _
                                ? w("p", {
                                    className: "form-title",
                                    dangerouslySetInnerHTML: {
                                      __html: O(o(n.city), g),
                                    },
                                  })
                                : null,
                              w(
                                m.b,
                                { label: this.formatLabel(o(n.city_label)) },
                                w(
                                  "div",
                                  {
                                    className: "style__select-box___1Ez_H",
                                    error: "city",
                                  },
                                  j(
                                    "city",
                                    T,
                                  )(
                                    w(
                                      "select",
                                      {
                                        className: "style__select___1jXjt",
                                        name: "activity_city",
                                      },
                                      w(
                                        "option",
                                        { value: "" },
                                        O(o(n.city), g, y),
                                      ),
                                      this.renderCity(),
                                    ),
                                  ),
                                  w(
                                    "div",
                                    { className: "style__icon___2hy01" },
                                    w(v.a, { name: "caret-down" }),
                                  ),
                                ),
                              ),
                            )
                          : null,
                      )
                    : w(
                        "div",
                        {
                          className: "area-linkage style__area-linkage___UcXvr",
                        },
                        a,
                        w(
                          "div",
                          {
                            className: u()(C, x, {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            }),
                          },
                          _
                            ? w("p", {
                                className: "form-title",
                                dangerouslySetInnerHTML: {
                                  __html: O(o(n.continent), g),
                                },
                              })
                            : null,
                          w(
                            m.b,
                            { label: this.formatLabel(o(n.continent_label)) },
                            w(
                              "div",
                              {
                                error: n.customContinentKey || "continent",
                                className: "style__select-box___1Ez_H",
                              },
                              j(
                                n.customContinentKey || "continent",
                                T,
                              )(
                                w(
                                  "select",
                                  {
                                    className: "style__select___1jXjt",
                                    name: n.customContinentKey || "continent",
                                    onChange: this.handleChangeContinent,
                                  },
                                  w(
                                    "option",
                                    { value: "" },
                                    O(o(n.continent), g, y),
                                  ),
                                  this.renderContinent(),
                                ),
                              ),
                              w(
                                "div",
                                { className: "style__icon___2hy01" },
                                w(v.a, { name: "caret-down" }),
                              ),
                            ),
                          ),
                        ),
                        w(
                          "div",
                          {
                            className: u()(C, x, {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            }),
                          },
                          _
                            ? w("p", {
                                className: "form-title",
                                dangerouslySetInnerHTML: {
                                  __html: O(o(n.country), g),
                                },
                              })
                            : null,
                          w(
                            m.b,
                            { label: this.formatLabel(o(n.country_label)) },
                            w(
                              "div",
                              {
                                error: n.customCountryKey || "activity_country",
                                className: "style__select-box___1Ez_H",
                                warningMsg: b,
                              },
                              j(
                                n.customCountryKey || "activity_country",
                                T,
                              )(
                                w(
                                  "select",
                                  {
                                    className: "style__select___1jXjt",
                                    name:
                                      n.customCountryKey || "activity_country",
                                    onChange: this.handleChangeCountry,
                                  },
                                  w(
                                    "option",
                                    { value: "" },
                                    O(o(n.country), g, y),
                                  ),
                                  this.renderCountry(),
                                ),
                              ),
                              w(
                                "div",
                                { className: "style__icon___2hy01" },
                                w(v.a, { name: "caret-down" }),
                              ),
                            ),
                          ),
                        ),
                        I && I.data && I.data.length > 0
                          ? w(
                              "div",
                              { className: "style__form-group___uFcrd" },
                              _
                                ? w("p", {
                                    className: "form-title",
                                    dangerouslySetInnerHTML: {
                                      __html: O(o(n.state), g),
                                    },
                                  })
                                : null,
                              w(
                                m.b,
                                { label: this.formatLabel(o(n.state_label)) },
                                w(
                                  "div",
                                  {
                                    className: "style__select-box___1Ez_H",
                                    error: "state",
                                  },
                                  j(
                                    "state",
                                    T,
                                  )(
                                    w(
                                      "select",
                                      {
                                        className: "style__select___1jXjt",
                                        name: "activity_state",
                                        onChange: this.handleChangeState,
                                      },
                                      w(
                                        "option",
                                        { value: "" },
                                        O(o(n.state), g, y),
                                      ),
                                      this.renderState(),
                                    ),
                                  ),
                                  w(
                                    "div",
                                    { className: "style__icon___2hy01" },
                                    w(v.a, { name: "caret-down" }),
                                  ),
                                ),
                              ),
                            )
                          : null,
                        S && S.data && S.data.length > 0 && !M
                          ? w(
                              "div",
                              { className: "style__form-group___uFcrd" },
                              _
                                ? w("p", {
                                    className: "form-title",
                                    dangerouslySetInnerHTML: {
                                      __html: O(o(n.city), g),
                                    },
                                  })
                                : null,
                              w(
                                m.b,
                                { label: this.formatLabel(o(n.city_label)) },
                                w(
                                  "div",
                                  {
                                    className: "style__select-box___1Ez_H",
                                    error: "city",
                                  },
                                  j(
                                    "city",
                                    T,
                                  )(
                                    w(
                                      "select",
                                      {
                                        className: "style__select___1jXjt",
                                        name: "activity_city",
                                      },
                                      w(
                                        "option",
                                        { value: "" },
                                        O(o(n.city), g, y),
                                      ),
                                      this.renderCity(),
                                    ),
                                  ),
                                  w(
                                    "div",
                                    { className: "style__icon___2hy01" },
                                    w(v.a, { name: "caret-down" }),
                                  ),
                                ),
                              ),
                            )
                          : null,
                      );
                },
              },
            ]),
            t
          );
        })(p.a.Component);
      Object(c.a)(I, "defaultProps", {
        t: function () {},
        form: "",
        component_data: {},
        removeContainer: !1,
        notRequired: !0,
        autoMatch: !1,
        hasFormTitle: !1,
        hideContinentCountryInCn: !1,
        hideStates: !1,
        hideCities: !1,
      }),
        (t.a = Object(h.a)(I));
    },
    "2SQs": function (e, t, n) {
      (function (t) {
        var n = 200,
          o = "__lodash_hash_undefined__",
          a = 1 / 0,
          r = 9007199254740991,
          i = "[object Arguments]",
          l = "[object Function]",
          s = "[object GeneratorFunction]",
          c = "[object Symbol]",
          _ = /^\[object .+?Constructor\]$/,
          u = /^(?:0|[1-9]\d*)$/,
          d = "object" == typeof t && t && t.Object === Object && t,
          p = "object" == typeof self && self && self.Object === Object && self,
          f = d || p || Function("return this")();
        function h(e, t, n) {
          switch (n.length) {
            case 0:
              return e.call(t);
            case 1:
              return e.call(t, n[0]);
            case 2:
              return e.call(t, n[0], n[1]);
            case 3:
              return e.call(t, n[0], n[1], n[2]);
          }
          return e.apply(t, n);
        }
        function m(e, t) {
          return (
            !!(e ? e.length : 0) &&
            (function (e, t, n) {
              if (t !== t)
                return (function (e, t, n, o) {
                  var a = e.length,
                    r = n + (o ? 1 : -1);
                  for (; o ? r-- : ++r < a; ) if (t(e[r], r, e)) return r;
                  return -1;
                })(e, g, n);
              var o = n - 1,
                a = e.length;
              for (; ++o < a; ) if (e[o] === t) return o;
              return -1;
            })(e, t, 0) > -1
          );
        }
        function y(e, t, n) {
          for (var o = -1, a = e ? e.length : 0; ++o < a; )
            if (n(t, e[o])) return !0;
          return !1;
        }
        function b(e, t) {
          for (var n = -1, o = e ? e.length : 0, a = Array(o); ++n < o; )
            a[n] = t(e[n], n, e);
          return a;
        }
        function v(e, t) {
          for (var n = -1, o = t.length, a = e.length; ++n < o; )
            e[a + n] = t[n];
          return e;
        }
        function g(e) {
          return e !== e;
        }
        function w(e, t) {
          return e.has(t);
        }
        function x(e, t) {
          return function (n) {
            return e(t(n));
          };
        }
        var k = Array.prototype,
          O = Function.prototype,
          I = Object.prototype,
          S = f["__core-js_shared__"],
          j = (function () {
            var e = /[^.]+$/.exec((S && S.keys && S.keys.IE_PROTO) || "");
            return e ? "Symbol(src)_1." + e : "";
          })(),
          T = O.toString,
          C = I.hasOwnProperty,
          M = I.toString,
          P = RegExp(
            "^" +
              T.call(C)
                .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  "$1.*?",
                ) +
              "$",
          ),
          E = f.Symbol,
          L = x(Object.getPrototypeOf, Object),
          B = I.propertyIsEnumerable,
          N = k.splice,
          D = E ? E.isConcatSpreadable : void 0,
          z = Object.getOwnPropertySymbols,
          A = Math.max,
          R = Q(f, "Map"),
          F = Q(Object, "create");
        function V(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        function H(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        function W(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        function U(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.__data__ = new W(); ++t < n; ) this.add(e[t]);
        }
        function G(e, t) {
          var n =
              ae(e) || oe(e)
                ? (function (e, t) {
                    for (var n = -1, o = Array(e); ++n < e; ) o[n] = t(n);
                    return o;
                  })(e.length, String)
                : [],
            o = n.length,
            a = !!o;
          for (var r in e)
            (!t && !C.call(e, r)) ||
              (a && ("length" == r || te(r, o))) ||
              n.push(r);
          return n;
        }
        function Y(e, t) {
          for (var n, o, a = e.length; a--; )
            if ((n = e[a][0]) === (o = t) || (n !== n && o !== o)) return a;
          return -1;
        }
        function q(e) {
          return (
            !(!le(e) || ((t = e), j && j in t)) &&
            (ie(e) ||
            (function (e) {
              var t = !1;
              if (null != e && "function" != typeof e.toString)
                try {
                  t = !!(e + "");
                } catch (n) {}
              return t;
            })(e)
              ? P
              : _
            ).test(
              (function (e) {
                if (null != e) {
                  try {
                    return T.call(e);
                  } catch (t) {}
                  try {
                    return e + "";
                  } catch (t) {}
                }
                return "";
              })(e),
            )
          );
          var t;
        }
        function X(e) {
          if (!le(e))
            return (function (e) {
              var t = [];
              if (null != e) for (var n in Object(e)) t.push(n);
              return t;
            })(e);
          var t = (function (e) {
              var t = e && e.constructor,
                n = ("function" == typeof t && t.prototype) || I;
              return e === n;
            })(e),
            n = [];
          for (var o in e)
            ("constructor" != o || (!t && C.call(e, o))) && n.push(o);
          return n;
        }
        function Z(e) {
          return (function (e, t, n) {
            var o = t(e);
            return ae(e) ? o : v(o, n(e));
          })(e, ce, $);
        }
        function K(e, t) {
          var n = e.__data__;
          return (function (e) {
            var t = typeof e;
            return "string" == t ||
              "number" == t ||
              "symbol" == t ||
              "boolean" == t
              ? "__proto__" !== e
              : null === e;
          })(t)
            ? n["string" == typeof t ? "string" : "hash"]
            : n.map;
        }
        function Q(e, t) {
          var n = (function (e, t) {
            return null == e ? void 0 : e[t];
          })(e, t);
          return q(n) ? n : void 0;
        }
        (V.prototype.clear = function () {
          this.__data__ = F ? F(null) : {};
        }),
          (V.prototype.delete = function (e) {
            return this.has(e) && delete this.__data__[e];
          }),
          (V.prototype.get = function (e) {
            var t = this.__data__;
            if (F) {
              var n = t[e];
              return n === o ? void 0 : n;
            }
            return C.call(t, e) ? t[e] : void 0;
          }),
          (V.prototype.has = function (e) {
            var t = this.__data__;
            return F ? void 0 !== t[e] : C.call(t, e);
          }),
          (V.prototype.set = function (e, t) {
            return (this.__data__[e] = F && void 0 === t ? o : t), this;
          }),
          (H.prototype.clear = function () {
            this.__data__ = [];
          }),
          (H.prototype.delete = function (e) {
            var t = this.__data__,
              n = Y(t, e);
            return (
              !(n < 0) && (n == t.length - 1 ? t.pop() : N.call(t, n, 1), !0)
            );
          }),
          (H.prototype.get = function (e) {
            var t = this.__data__,
              n = Y(t, e);
            return n < 0 ? void 0 : t[n][1];
          }),
          (H.prototype.has = function (e) {
            return Y(this.__data__, e) > -1;
          }),
          (H.prototype.set = function (e, t) {
            var n = this.__data__,
              o = Y(n, e);
            return o < 0 ? n.push([e, t]) : (n[o][1] = t), this;
          }),
          (W.prototype.clear = function () {
            this.__data__ = {
              hash: new V(),
              map: new (R || H)(),
              string: new V(),
            };
          }),
          (W.prototype.delete = function (e) {
            return K(this, e).delete(e);
          }),
          (W.prototype.get = function (e) {
            return K(this, e).get(e);
          }),
          (W.prototype.has = function (e) {
            return K(this, e).has(e);
          }),
          (W.prototype.set = function (e, t) {
            return K(this, e).set(e, t), this;
          }),
          (U.prototype.add = U.prototype.push =
            function (e) {
              return this.__data__.set(e, o), this;
            }),
          (U.prototype.has = function (e) {
            return this.__data__.has(e);
          });
        var J = z ? x(z, Object) : pe,
          $ = z
            ? function (e) {
                for (var t = []; e; ) v(t, J(e)), (e = L(e));
                return t;
              }
            : pe;
        function ee(e) {
          return ae(e) || oe(e) || !!(D && e && e[D]);
        }
        function te(e, t) {
          return (
            !!(t = null == t ? r : t) &&
            ("number" == typeof e || u.test(e)) &&
            e > -1 &&
            e % 1 == 0 &&
            e < t
          );
        }
        function ne(e) {
          if (
            "string" == typeof e ||
            (function (e) {
              return "symbol" == typeof e || (se(e) && M.call(e) == c);
            })(e)
          )
            return e;
          var t = e + "";
          return "0" == t && 1 / e == -a ? "-0" : t;
        }
        function oe(e) {
          return (
            (function (e) {
              return se(e) && re(e);
            })(e) &&
            C.call(e, "callee") &&
            (!B.call(e, "callee") || M.call(e) == i)
          );
        }
        var ae = Array.isArray;
        function re(e) {
          return (
            null != e &&
            (function (e) {
              return "number" == typeof e && e > -1 && e % 1 == 0 && e <= r;
            })(e.length) &&
            !ie(e)
          );
        }
        function ie(e) {
          var t = le(e) ? M.call(e) : "";
          return t == l || t == s;
        }
        function le(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function se(e) {
          return !!e && "object" == typeof e;
        }
        function ce(e) {
          return re(e) ? G(e, !0) : X(e);
        }
        var _e,
          ue,
          de =
            ((_e = function (e, t) {
              return null == e
                ? {}
                : ((t = b(
                    (function e(t, n, o, a, r) {
                      var i = -1,
                        l = t.length;
                      for (o || (o = ee), r || (r = []); ++i < l; ) {
                        var s = t[i];
                        n > 0 && o(s)
                          ? n > 1
                            ? e(s, n - 1, o, a, r)
                            : v(r, s)
                          : a || (r[r.length] = s);
                      }
                      return r;
                    })(t, 1),
                    ne,
                  )),
                  (function (e, t) {
                    return (function (e, t, n) {
                      for (var o = -1, a = t.length, r = {}; ++o < a; ) {
                        var i = t[o],
                          l = e[i];
                        n(l, i) && (r[i] = l);
                      }
                      return r;
                    })((e = Object(e)), t, function (t, n) {
                      return n in e;
                    });
                  })(
                    e,
                    (function (e, t, o, a) {
                      var r,
                        i = -1,
                        l = m,
                        s = !0,
                        c = e.length,
                        _ = [],
                        u = t.length;
                      if (!c) return _;
                      o &&
                        (t = b(
                          t,
                          ((r = o),
                          function (e) {
                            return r(e);
                          }),
                        )),
                        a
                          ? ((l = y), (s = !1))
                          : t.length >= n &&
                            ((l = w), (s = !1), (t = new U(t)));
                      e: for (; ++i < c; ) {
                        var d = e[i],
                          p = o ? o(d) : d;
                        if (((d = a || 0 !== d ? d : 0), s && p === p)) {
                          for (var f = u; f--; ) if (t[f] === p) continue e;
                          _.push(d);
                        } else l(t, p, a) || _.push(d);
                      }
                      return _;
                    })(Z(e), t),
                  ));
            }),
            (ue = A(void 0 === ue ? _e.length - 1 : ue, 0)),
            function () {
              for (
                var e = arguments,
                  t = -1,
                  n = A(e.length - ue, 0),
                  o = Array(n);
                ++t < n;

              )
                o[t] = e[ue + t];
              t = -1;
              for (var a = Array(ue + 1); ++t < ue; ) a[t] = e[t];
              return (a[ue] = o), h(_e, this, a);
            });
        function pe() {
          return [];
        }
        e.exports = de;
      }).call(this, n("yLpj"));
    },
    "2W6z": function (e, t, n) {
      "use strict";
      var o = function () {};
      e.exports = o;
    },
    "2faE": function (e, t, n) {
      var o = n("5K7Z"),
        a = n("eUtF"),
        r = n("G8Mo"),
        i = Object.defineProperty;
      t.f = n("jmDH")
        ? Object.defineProperty
        : function (e, t, n) {
            if ((o(e), (t = r(t, !0)), o(n), a))
              try {
                return i(e, t, n);
              } catch (l) {}
            if ("get" in n || "set" in n)
              throw TypeError("Accessors not supported!");
            return "value" in n && (e[t] = n.value), e;
          };
    },
    "2gN3": function (e, t, n) {
      var o = n("Kz5y")["__core-js_shared__"];
      e.exports = o;
    },
    "2oKn": function (e, t, n) {},
    "2rCR": function (e, t, n) {
      "use strict";
      var o = n("ODXe"),
        a = n("rePB"),
        r = n("1OyB"),
        i = n("vuIU");
      function l(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function s(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? l(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : l(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var c =
          "\n.float-action-button-wrapper .button-wrapper {\n  position: fixed;\n  z-index: 9997;\n  right: 2%;\n  bottom: 128px;;\n  height: 48px;\n  width: 48px;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  background-image: linear-gradient(#535759, #3b3e40);\n  color: #fff;\n  box-shadow: 0px 16px 32px rgb(0 0 0 / 10%);\n  border-radius: 50%;\n  display: flex;\n  cursor: pointer;\n}\n\n.dji-pc .float-action-button-wrapper .button-wrapper {\n  width: 56px;\n  height: 56px;\n  bottom: 220px;\n}\n\n.float-action-button-wrapper .button-wrapper.active .normal-icon {\n  opacity: 0;\n  transform: rotate(180deg);\n}\n.float-action-button-wrapper .button-wrapper.active .active-icon {\n  opacity: 1;\n  transform: rotate(0deg);\n}\n.float-action-button-wrapper .button-wrapper .icon {\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  top: 16px;\n  left: 16px;\n  transition: all 0.3s ease;\n}\n.dji-pc .float-action-button-wrapper .button-wrapper .icon {\n  top: 20px;\n  left: 20px;\n}\n.float-action-button-wrapper .button-wrapper .normal-icon {\n  opacity: 1;\n  transform: rotate(0deg);\n}\n.float-action-button-wrapper .button-wrapper .active-icon {\n  opacity: 0;\n  transform: rotate(-180deg);\n}\n.float-action-button-wrapper .hover-tips {\n  color: #fff;\n  background: #3b3e40;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  opacity: 0;\n  position: fixed;\n  bottom: 133px;\n  right: 84px;\n  pointer-events: none;\n  visibility: hidden;\n  z-index: 999;\n  line-height: 20px;\n  padding: 8px 12px;\n  letter-spacing: -0.02em;\n  max-width: 240px;\n  text-align: left;\n  word-wrap: break-word;\n  box-shadow: 0px 8px 16px rgb(0 0 0 / 10%);\n  transition: opacity 0.3s ease-out;\n}\n.dji-pc .float-action-button-wrapper .hover-tips {\n  right: calc(2% + 68px);\n  bottom: 229px;\n}\n.float-action-button-wrapper .hover-tips.active {\n  pointer-events: auto;\n  opacity: 0.9;\n  visibility: visible;\n}\n.float-action-button-wrapper .hover-tips::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n  border-left-color: #3b3e40;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.pc-float-action-button-wrapper .contact-card-wrapper {\n  position: fixed;\n  right: calc(2% + 68px);\n  bottom: 224px;\n  z-index: 9997;\n  opacity: 0;\n  transition: all 0.3s ease;\n  background-color: #fff;\n  width: 320px;\n  box-sizing: border-box;\n  transform-origin: right bottom;\n  border-radius: 8px !important;\n  box-shadow: 0px 8px 16px rgb(0 0 0 / 10%);\n  visibility: hidden;\n  transform: scale(0.9);\n}\n.pc-float-action-button-wrapper .contact-card-wrapper::after {\n  content: '';\n  width: 16px;\n  height: 16px;\n  background-color: #fff;\n  position: absolute;\n  right: -4px;\n  bottom: 16px;\n  transform: rotate(45deg);\n}\n.pc-float-action-button-wrapper .contact-card-wrapper.active {\n  visibility: visible;\n  opacity: 1;\n  transform: scale(1);\n}\n.float-action-button-wrapper .contact-card-wrapper .card-header {\n  display: flex;\n  min-height: 56px;\n  padding: 16px;\n  position: relative;\n  align-items: center;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-header h4, .float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item {\n  overflow: hidden;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-header h4, .float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item .item-title {\n  color: rgba(0,0,0,0.85);\n  font-weight: 500;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-header h4 {\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-header::after {\n  content: '';\n  background-color: rgba(0,0,0,0.06);\n  width: 100%;\n  height: 1px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-content-wrapper {\n  position: relative;\n  overflow: hidden;\n}\n.pc-float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .content-wrapper {\n  width: 340px;\n  max-height: 320px;\n  box-sizing: border-box;\n  overflow-y: scroll;\n  transition: all 0.6s ease;\n  padding: 16px 36px 0 16px;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item:last-child .split-line {\n  display: none;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item:last-child {\n  padding-bottom: 24px;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item .item-title {\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item .item-desc {\n  margin-top: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  color: rgba(0,0,0,0.65);\n}\n.float-action-button-wrapper .item-link {\n  margin-top: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: -0.02em;\n  display: inline-block;\n  cursor: pointer;\n  color: #1890ff;\n  background-repeat: no-repeat;\n  background-size: 16px 16px;\n  background-position: 0px 2px;\n  vertical-align: middle;\n}\n.float-action-button-wrapper .button-wrapper.link-type .item-link {\n  width: 100%;\n  height: 100%;\n  margin-top: 0;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.float-action-button-wrapper .item-link:hover, .float-action-button-wrapper .item-link:active, .float-action-button-wrapper .item-link:focus {\n  text-decoration: underline;\n}\n.float-action-button-wrapper .item-link span {\n  vertical-align: middle;\n}\n.float-action-button-wrapper .item-link .link-icon {\n  width: 16px;\n  height: auto;\n  vertical-align: middle;\n}\n.pc-float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item .split-line {\n  width: 288px;\n  position: relative;\n  height: 32px;\n}\n.m-float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item .split-line {\n  width: 100%;\n  position: relative;\n  height: 32px;\n}\n.float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .card-item .split-line::after {\n  position: absolute;\n  top: 16px;\n  content: \"\";\n  width: 100%;\n  height: 1px;\n  background: rgba(0,0,0,0.06);\n}\n.float-action-button-wrapper .toggle-modal-bg {\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  z-index: 9996;\n}\n.float-action-button-wrapper .toggle-modal-bg.active {\n  display: block;\n}\n.float-action-button-online-service {\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9998;\n  background: rgba(0,0,0,0.65);\n  visibility: hidden;\n  opacity: 0;\n  transition: all .3s ease;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.float-action-button-online-service.active {\n  opacity: 1;\n  visibility: visible;\n}\n.float-action-button-online-service.active.loading .spinner {\n  display: block;\n}\n.float-action-button-online-service .float-action-button-online-service-wrap {\n  display: block;\n}\n.float-action-button-online-service.active.loading .float-action-button-online-service-wrap {\n  display: none;\n}\n.float-action-button-online-service .spinner {\n  display: none;\n  width: 82px;\n  text-align: center;\n}\n\n.float-action-button-online-service .spinner > div {\n  margin: 0 2px;\n  width: 18px;\n  height: 18px;\n  background-color: #fff;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.float-action-button-online-service .spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.float-action-button-online-service .spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n.float-action-button-online-service-wrap iframe {\n  overflow: hidden;\n  width: 768px;\n  height: 630px;\n}\n.float-action-button-online-service-skin {\n  padding: 15px;\n  width: auto;\n  height: auto;\n  position: relative;\n}\n.float-action-button-online-service-skin .online-service-close-icon {\n  display: block;\n  position: absolute;\n  top: 32px;\n  right: 30px;\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n.m-float-action-button-wrapper .button-wrapper {\n  z-index: 9101;\n}\n.m-float-action-button-wrapper .contact-card-wrapper {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  max-height: 100%;\n  z-index: 10002;\n  transform: translateY(48px);\n  transform-origin: center center;\n  border-radius: 8px 8px 0 0 !important;\n  opacity: 0;\n  transition: all 0.3s ease;\n  background-color: #fff;\n  visibility: hidden;\n}\n.m-float-action-button-wrapper .contact-card-wrapper.active {\n  opacity: 1;\n  transform: translateY(0);\n  visibility: visible;\n}\n.m-float-action-button-wrapper .contact-card-wrapper .card-header .close-icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  position: absolute;\n  right: 20px;\n  top: 8px;\n}\n.m-float-action-button-wrapper .contact-card-wrapper .card-header .close-icon img {\n  width: 14px;\n  height: 14px;\n}\n.m-float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .content-wrapper {\n  width: calc(100% + 10px);\n  max-height: calc(100vh - 56px);\n  padding: 24px 34px 0 24px;\n  box-sizing: border-box;\n  overflow-y: scroll;\n  transition: all 0.6s ease;\n}\n.m-float-action-button-wrapper .toggle-modal-bg {\n  z-index: 10001;\n  background-color: rgba(0,0,0,0.5);\n}\n.m-float-action-button-wrapper .contact-card-wrapper .card-header {\n  padding: 8px 52px 8px 24px;\n}\n@media screen and (min-width: 1600px) {\n  .pc-float-action-button-wrapper .contact-card-wrapper .card-content-wrapper .content-wrapper {\n    max-height: 480px;\n  }\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% { -webkit-transform: scale(0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  } 40% {\n    -webkit-transform: scale(1.0);\n    transform: scale(1.0);\n  }\n}\n",
        _ = (function () {
          function e(t) {
            var n = this;
            Object(r.default)(this, e),
              (this.showTips = !1),
              (this.isActive = !1),
              (this.isClick = !1),
              (this.iframeLink = ""),
              (this.hasOnlineServiceConfig = !1),
              (this.defaultConfig = {
                isShow: !0,
                isMobile: !1,
                normalIcon:
                  "https://www1.djicdn.com/dps/f5edbe00f124fe9b16e84d55d136d1ec.svg",
                activeIcon:
                  "https://www1.djicdn.com/dps/e6b306f88963870b29731833fc251fd3.svg",
                gaCategory: "",
                hoverTips: "",
                mainTitle: "",
                contentList: [
                  {
                    subTitle: "",
                    desc: "",
                    link: "",
                    linkType: "",
                    linkIcon: "",
                    linkText: "",
                  },
                ],
                gaSend: function () {},
                showOnlineServicePopUp: !1,
                displayMainOnly: !1,
                mainLinkType: "chat",
                mainLink: "",
              }),
              this.init(t),
              this.config.isShow &&
                this.buildFloatActionButton(function () {
                  n.addEventListeners();
                });
          }
          return (
            Object(i.default)(e, [
              {
                key: "init",
                value: function (e) {
                  this.config = s(s({}, this.defaultConfig), e);
                },
              },
              {
                key: "DOMReady",
                value: function (e) {
                  (
                    document.attachEvent
                      ? "complete" === document.readyState
                      : "loading" !== document.readyState
                  )
                    ? e()
                    : document.addEventListener("DOMContentLoaded", e);
                },
              },
              {
                key: "buildFloatActionButton",
                value: function (e) {
                  var t = this;
                  this.DOMReady(function () {
                    document.querySelector(".float-action-button-wrapper") ||
                      (t.initStyle(),
                      t.renderFloatActionButtonDom(),
                      "function" === typeof e && e());
                  });
                },
              },
              {
                key: "gaSend",
                value: function (e, t, n) {
                  ("function" !== typeof ga ? this.config.gaSend : ga)(
                    "send",
                    "event",
                    e,
                    t,
                    n,
                  );
                },
              },
              {
                key: "initStyle",
                value: function () {
                  if ("undefined" !== typeof document) {
                    var e =
                        document.head ||
                        document.getElementsByTagName("head")[0],
                      t = document.createElement("style");
                    (t.type = "text/css"),
                      e.appendChild(t),
                      t.styleSheet
                        ? (t.styleSheet.cssText = c)
                        : t.appendChild(document.createTextNode(c));
                  }
                },
              },
              {
                key: "checkInboundLink",
                value: function (e) {
                  if (!e) return !1;
                  if (
                    !(
                      !e.match(/^http/gi) &&
                      !e.match(/www/gi) &&
                      !e.match(/com/gi) &&
                      !e.match(/^\/\//)
                    )
                  ) {
                    var t = /(http|https):\/\/(.+)\/?(.+)$/.exec(e),
                      n = Object(o.a)(t, 3)[2],
                      a = new RegExp(n, "gi"),
                      r = new RegExp(window.location.host, "gi");
                    if (!(a.test(e) && r.test(e))) return !0;
                  }
                  return !1;
                },
              },
              {
                key: "renderLinkBtn",
                value: function (e) {
                  var t = "";
                  switch (e.linkType) {
                    case "phone":
                      t = '<a class="item-link" style="background-image: url('
                        .concat(
                          e.linkIcon ? e.linkIcon : this.config.normalIcon,
                          "); padding-left: ",
                        )
                        .concat(e.linkIcon ? 20 : 0, 'px" data-ga-label=')
                        .concat(e.linkType, " href=")
                        .concat(e.link, ">")
                        .concat(e.linkText ? e.linkText : "", "</a>");
                      break;
                    case "chat":
                      (this.iframeLink = e.link),
                        (this.hasOnlineServiceConfig = !0),
                        (t =
                          '<a class="item-link online-server-btn" style="background-image: url('
                            .concat(
                              e.linkIcon ? e.linkIcon : this.config.normalIcon,
                              "); padding-left: ",
                            )
                            .concat(e.linkIcon ? 20 : 0, 'px" data-ga-label=')
                            .concat(e.linkType, " href='javascript:;'>")
                            .concat(e.linkText ? e.linkText : "", "</a>"));
                      break;
                    default:
                      t = '<a class="item-link" target="'
                        .concat(
                          this.checkInboundLink(e.link || "")
                            ? "_blank"
                            : "_self",
                          '" data-ga-label=',
                        )
                        .concat(e.linkType, " href=")
                        .concat(e.link, "><span>")
                        .concat(
                          e.linkText ? e.linkText : "",
                          '</span><img class="link-icon" src="',
                        )
                        .concat(
                          e.linkIcon ? e.linkIcon : this.config.normalIcon,
                          '" alt="" /></a>',
                        );
                  }
                  return t;
                },
              },
              {
                key: "renderFloatActionButtonDom",
                value: function () {
                  var e = this,
                    t = this.config,
                    n = '<div class="hover-tips">'.concat(
                      t.hoverTips,
                      "</div>",
                    ),
                    o =
                      '<div class="button-wrapper popup-type">\n      <img class="icon normal-icon" src='
                        .concat(
                          t.normalIcon,
                          ' alt="" />\n      <img class="icon active-icon" src=',
                        )
                        .concat(t.activeIcon, ' alt="" />\n    </div>'),
                    a = { linkType: t.mainLinkType, link: t.mainLink },
                    r = '<div class="button-wrapper link-type">\n      '.concat(
                      this.renderLinkBtn(a),
                      "\n    </div>",
                    ),
                    i = t.contentList
                      .map(function (t) {
                        return '<div class="card-item">\n        '
                          .concat(
                            t.subTitle &&
                              '<h5 class="item-title">'.concat(
                                t.subTitle,
                                "</h5>",
                              ),
                            "\n        ",
                          )
                          .concat(
                            t.desc &&
                              '<div class="item-desc">'.concat(
                                t.desc,
                                "</div>",
                              ),
                            "\n        ",
                          )
                          .concat(
                            t.link ? e.renderLinkBtn(t) : "",
                            '\n        <div class="split-line"></div>\n      </div>',
                          );
                      })
                      .join(""),
                    l =
                      '<iframe class="float-action-button-online-service-iframe" frameborder="0" vspace="0" hspace="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" scrolling="auto" src='.concat(
                        this.iframeLink,
                        "></iframe>",
                      ),
                    s =
                      '<div class="float-action-button-online-service loading">\n      <div class="float-action-button-online-service-wrap">\n        <div class="float-action-button-online-service-skin">\n          '
                        .concat(
                          '<div class="online-service-close-icon"><img src="https://www1.djicdn.com/assets/images/support/modal-close-2fd42214ca9e05a276373e3c08f52548.png" alt="" /></div>',
                          '\n          <div class="float-action-button-online-service-outer"><div class="float-action-button-online-service-inner">\n            ',
                        )
                        .concat(
                          l,
                          "\n          </div></div>\n        </div>\n      </div>\n      ",
                        )
                        .concat(
                          '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>',
                          "\n    </div>\n    ",
                        ),
                    c = '<div class="float-action-button-wrapper '
                      .concat(
                        t.isMobile
                          ? "m-float-action-button-wrapper"
                          : "pc-float-action-button-wrapper",
                        '">\n      ',
                      )
                      .concat(t.displayMainOnly ? r : o, "\n      ")
                      .concat(
                        !t.isMobile && t.hoverTips ? n : "",
                        '\n      <div class="toggle-modal-bg"></div>\n      <div class="contact-card-wrapper">\n        <div class="card-header">\n          <h4>',
                      )
                      .concat(t.mainTitle, "</h4>\n          ")
                      .concat(
                        t.isMobile
                          ? '<div class="close-icon"><img src="https://www1.djicdn.com/dps/0577a1c8ecef23ede9e7dd5633e64321.svg" alt="" /></div>'
                          : "",
                        '\n        </div>\n        <div class="card-content-wrapper">\n          <div class="content-wrapper">\n            ',
                      )
                      .concat(
                        i,
                        "\n          </div>\n        </div>\n      </div>\n      ",
                      )
                      .concat(
                        this.hasOnlineServiceConfig && t.showOnlineServicePopUp
                          ? s
                          : "",
                        "\n      </div>\n    ",
                      ),
                    _ = document.createElement("div"),
                    u = document.getElementsByTagName("body")[0];
                  _.innerHTML = c;
                  var d = _.children[0];
                  u.appendChild(d);
                },
              },
              {
                key: "addEventListeners",
                value: function () {
                  var e = this,
                    t = document.querySelector(
                      ".float-action-button-wrapper .button-wrapper",
                    ),
                    n = document.querySelector(
                      ".float-action-button-wrapper .popup-type",
                    ),
                    o = document.querySelector(
                      ".m-float-action-button-wrapper .card-content-wrapper .content-wrapper",
                    ),
                    a = document.querySelector(
                      ".float-action-button-wrapper .contact-card-wrapper",
                    ),
                    r = document.querySelector(
                      ".float-action-button-wrapper .hover-tips",
                    ),
                    i = document.querySelector(
                      ".float-action-button-wrapper .toggle-modal-bg",
                    ),
                    l = document.querySelectorAll(
                      ".float-action-button-wrapper .item-link",
                    ),
                    s = document.querySelector(
                      ".m-float-action-button-wrapper .contact-card-wrapper .card-header .close-icon",
                    ),
                    c = document.querySelector(
                      ".float-action-button-wrapper .online-server-btn",
                    ),
                    _ = document.querySelector(
                      ".float-action-button-online-service",
                    ),
                    u = document.querySelector(".online-service-close-icon"),
                    d = document.querySelector(
                      ".float-action-button-online-service-wrap iframe",
                    ),
                    p = this.config;
                  t &&
                    (t.addEventListener("mouseenter", function () {
                      (e.showTips = !0),
                        e.showTips &&
                          !e.isClick &&
                          r &&
                          ((r.style.bottom = "".concat(
                            248 - r.offsetHeight / 2,
                            "px",
                          )),
                          e.addClass(r));
                    }),
                    t.addEventListener("mouseleave", function () {
                      (e.showTips = !1),
                        e.isActive || (e.isClick = !1),
                        e.removeClass(r);
                    })),
                    n &&
                      n.addEventListener("click", function () {
                        (e.isActive = !e.isActive),
                          (e.isClick = !0),
                          e.isActive
                            ? (e.gaSend(p.gaCategory, "click", "open"),
                              e.config.isMobile && o.scrollTo(0, 0),
                              e.addClass(a),
                              e.addClass(i),
                              e.removeClass(r),
                              e.addClass(n))
                            : (e.gaSend(p.gaCategory, "click", "close"),
                              e.removeClass(a),
                              e.removeClass(i),
                              e.removeClass(r),
                              e.removeClass(n));
                      }),
                    i &&
                      i.addEventListener("click", function () {
                        e.gaSend(p.gaCategory, "click", "close"),
                          (e.isActive = !1),
                          (e.isClick = !1),
                          e.removeClass(a),
                          e.removeClass(i),
                          e.removeClass(n);
                      }),
                    s &&
                      s.addEventListener("click", function () {
                        e.gaSend(p.gaCategory, "click", "close"),
                          (e.isActive = !1),
                          e.removeClass(a),
                          e.removeClass(i),
                          e.removeClass(n);
                      }),
                    l.length > 0 &&
                      Array.prototype.forEach.call(l, function (t) {
                        t.addEventListener("click", function () {
                          e.gaSend(
                            p.gaCategory,
                            "click",
                            t.getAttribute("data-ga-label"),
                          );
                        });
                      }),
                    d &&
                      d.addEventListener("load", function () {
                        e.removeClass(_, "loading");
                      }),
                    _
                      ? (c &&
                          c.addEventListener("click", function () {
                            e.addClass(_),
                              (e.isActive = !1),
                              (e.isClick = !1),
                              e.removeClass(a),
                              e.removeClass(i),
                              e.removeClass(n);
                          }),
                        u &&
                          u.addEventListener("click", function () {
                            e.removeClass(_),
                              (d.src = d.src),
                              e.addClass(_, "loading");
                          }),
                        _.addEventListener("click", function () {
                          e.removeClass(_),
                            (d.src = d.src),
                            e.addClass(_, "loading");
                        }))
                      : c &&
                        c.addEventListener("click", function () {
                          if ("" !== e.iframeLink) {
                            var t = (window.screen.availHeight - 30 - 650) / 2,
                              n = (window.screen.availWidth - 10 - 520) / 2;
                            window.open(
                              e.iframeLink,
                              "",
                              "width=520,height=650,top="
                                .concat(t, ",left=")
                                .concat(n, ",scrollbars=yes,resizable=yes"),
                            );
                          }
                        });
                },
              },
              {
                key: "removeClass",
                value: function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : "active";
                  e && e.classList && e.classList.remove(t);
                },
              },
              {
                key: "addClass",
                value: function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : "active";
                  e && e.classList && e.classList.add(t);
                },
              },
            ]),
            e
          );
        })();
      t.a = _;
    },
    "3/+E": function (e, t, n) {},
    "3Fdi": function (e, t) {
      var n = Function.prototype.toString;
      e.exports = function (e) {
        if (null != e) {
          try {
            return n.call(e);
          } catch (t) {}
          try {
            return e + "";
          } catch (t) {}
        }
        return "";
      };
    },
    "3GJH": function (e, t, n) {
      n("lCc8");
      var o = n("WEpk").Object;
      e.exports = function (e, t) {
        return o.create(e, t);
      };
    },
    "3OWR": function (e, t, n) {
      var o = n("MrPd"),
        a = n("juv8"),
        r = n("LsHQ"),
        i = n("MMmD"),
        l = n("6sVZ"),
        s = n("7GkX"),
        c = Object.prototype.hasOwnProperty,
        _ = r(function (e, t) {
          if (l(t) || i(t)) a(t, s(t), e);
          else for (var n in t) c.call(t, n) && o(e, n, t[n]);
        });
      e.exports = _;
    },
    "3PAf": function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t) && !e.required) return n();
          r.default.required(e, t, o, l, a),
            void 0 !== t &&
              (r.default.type(e, t, o, l, a), r.default.range(e, t, o, l, a));
        }
        n(l);
      };
    },
    "3T+G": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      }),
        n.d(t, "b", function () {
          return i;
        }),
        n.d(t, "c", function () {
          return r;
        }),
        n.d(t, "d", function () {
          return s;
        }),
        n.d(t, "e", function () {
          return a;
        }),
        n.d(t, "f", function () {
          return l;
        });
      var o = function (e, t) {
          return function (n) {
            return Math.max(Math.min(n, t), e);
          };
        },
        a = function (e) {
          return e % 1 ? Number(e.toFixed(5)) : e;
        },
        r = /(-)?([\d]*\.?[\d])+/g,
        i =
          /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi,
        l =
          /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
      function s(e) {
        return "string" === typeof e;
      }
    },
    "3iuL": function (e, t, n) {
      var o = n("RIqP"),
        a = n("lSNA"),
        r = {
          NAME: "v2.product.enterprise.contact.form.name",
          PHONE: "v2.product.enterprise.contact.form.phone",
          EMAIL: "v2.product.enterprise.contact.form.mail",
          INSTITUTION: "v2.product.enterprise.contact.form.company",
          COMPANY: "v2.product.enterprise.contact.form.company.name",
          ECOSYSTEM_INSTITUTION:
            "v2.product.enterprise.ecosystem.form.institution",
          COMPANY_ADDRESS: "v2.product.enterprise.contact.form.company.address",
          COMPANY_INTRO: "v2.product.enterprise.contact.form.company.intro",
          PRODUCT_TYPE: "v2.product.enterprise.contact.form.product.type",
          PRODUCT_INTRO: "v2.product.enterprise.contact.form.product.intro",
          SDK_TECHNOLOGY: "v2.product.enterprise.contact.form.sdktech",
          PLANE_TYPE: "v2.product.enterprise.contact.form.planetype",
          FILE_UPLOAD: "v2.product.enterprise.contact.form.fileupload",
          FILE_UPLOAD_TIP: "v2.product.enterprise.contact.form.fileuploadtip",
          FILE_UPLOAD_TYPE_TIP:
            "v2.product.enterprise.contact.form.fileuploadtypetip",
          ECOSYSTEM_COMPANY:
            "v2.product.enterprise.ecosystem.form.company.name",
          ECOSYSTEM_NAME: "v2.product.enterprise.ecosystem.form.name",
          ECOSYSTEM_PHONE: "v2.product.enterprise.ecosystem.form.phone",
          ECOSYSTEM_EMAIL: "v2.product.enterprise.ecosystem.form.email",
          CONTINENT: "v2.product.enterprise.contact.form.continents",
          COUNTRY: "v2.product.enterprise.contact.form.country",
          PROVINCE: "v2.product.enterprise.contact.form.city",
          CITY: "v2.product.enterprise.contact.form.city.forchina",
          AG_IDENTITY: "v4.form.s2.identity",
          AUTO_ROLE: "v4.auto.contact.role",
          REMARK: "v2.product.enterprise.contact.form.coop",
          REQUIRED_TIP: "v2.product.enterprise.contact.form.right.copyright",
          FILE_ERROR_TIP: "v2.product.enterprise.contact.form.right.file",
          EMAIL_ERROR_TIP: "v2.product.enterprise.contact.form.right.mail",
          NAME_ERROR_TIP: "v2.product.enterprise.contact.form.right.name",
          PHONE_ERROR_TIP: "v2.product.enterprise.contact.form.right.phone",
          INDUSTRY_ERROR_TIP:
            "v2.product.enterprise.contact.form.right.industry",
          CITY_ERROR_TIP: "v2.product.enterprise.contact.form.right.city",
          COMPANY_ERROR_TIP: "v2.product.enterprise.contact.form.right.company",
          MUST_SELECT_TIP: "v2.product.enterprise.contact.form.must",
          VALIDATE_CODE_SLIDE_TIP: "v2.product.enterprise.contact.form.slide",
          SUBMIT: "v2.product.enterprise.contact.form.submit",
          successTitle: "v2.product.enterprise.contact.form.submit.success",
          successDesc: "v2.product.enterprise.contact.form.information.success",
          errorTitle: "v2.product.enterprise.contact.form.submit.fault",
          errorDesc:
            "v2.product.enterprise.contact.form.name.information.wrong",
          BACK: "v2.product.enterprise.contact.back",
        },
        i = {
          ENTERPRISE: "enterprise",
          AGRICULTURE: "agriculture",
          EDUCATION: "education",
          DELIVERY: "delivery",
          AUTO: "auto",
          ENTERPRISE_CN: "enterprise_cn",
        },
        l = [
          {
            key: "form.label.cn.surveying",
            labelTranslateKey: "v2.product.enterprise.cotact.form.cn.surveying",
          },
          {
            key: "form.label.cn.electricalnetwork",
            labelTranslateKey:
              "v2.product.enterprise.contact.form.cn.electricalnetwork",
          },
          {
            key: "form.label.cn.energy",
            labelTranslateKey: "v2.product.enterprise.cotact.form.cn.energy",
          },
          {
            key: "form.label.cn.firefighting",
            labelTranslateKey:
              "v2.product.enterprise.cotact.form.cn.firefighting",
          },
          {
            key: "form.label.cn.environment-protect",
            labelTranslateKey:
              "v2.product.enterprise.cotact.form.cn.environment-protect",
          },
          {
            key: "form.label.cn.traffic",
            labelTranslateKey: "v2.product.enterprise.cotact.form.cn.traffic",
          },
          {
            key: "form.label.cn.science-education",
            labelTranslateKey:
              "v2.product.enterprise.cotact.form.cn.science-education",
          },
          {
            key: "form.label.cn.forestry",
            labelTranslateKey: "v2.product.enterprise.cotact.form.cn.forestry",
          },
          {
            key: "form.label.cn.hydraulic",
            labelTranslateKey: "v2.product.enterprise.cotact.form.cn.hydraulic",
          },
          {
            key: "form.label.cn.judicial",
            labelTranslateKey: "v2.product.enterprise.cotact.form.cn.judicial",
          },
          {
            key: "form.label.cn.law-enforcement",
            labelTranslateKey:
              "v2.product.enterprise.cotact.form.cn.law-enforcement",
          },
          {
            key: "form.label.cn.government",
            labelTranslateKey:
              "v2.product.enterprise.cotact.form.cn.government",
          },
          {
            key: "form.label.cn.engineering-construction",
            labelTranslateKey:
              "v2.product.enterprise.cotact.form.cn.engineering-construction",
          },
          {
            key: "form.label.cn.city-management",
            labelTranslateKey:
              "v2.product.enterprise.cotact.form.cn.city-management",
          },
          {
            key: "form.label.cn.other",
            labelTranslateKey: "v2.product.enterprise.cotact.form.cn.other",
          },
        ],
        s = [
          {
            key: "public-safety",
            labelTranslateKey:
              "v2.product.enterprise.contact.form.public-safety",
          },
          {
            key: "electricity",
            labelTranslateKey: "v2.product.enterprise.contact.form.electricity",
          },
          {
            key: "oil-and-gas",
            labelTranslateKey: "v2.product.enterprise.contact.form.oil-and-gas",
          },
          {
            key: "surveying",
            labelTranslateKey: "v2.product.enterprise.contact.form.surveying",
          },
          {
            key: "construction",
            labelTranslateKey:
              "v2.product.enterprise.contact.form.construction",
          },
          {
            key: "other",
            labelTranslateKey: "v2.product.enterprise.contact.form.other",
          },
        ],
        c = [
          {
            key: "school",
            labelTranslateKey: "v2.product.enterprise.contact.form.school",
          },
          {
            key: "personal",
            labelTranslateKey: "v2.product.enterprise.contact.form.person",
          },
          {
            key: "business",
            labelTranslateKey: "v2.product.enterprise.contact.form.business",
          },
          {
            key: "government",
            labelTranslateKey: "v2.product.enterprise.contact.form.goverment",
          },
          {
            key: "other",
            labelTranslateKey: "v2.product.enterprise.contact.form.other",
          },
        ],
        _ = [
          {
            key: "auto-supplier",
            labelTranslateKey: "v4.auto.contact.supplier",
          },
          {
            key: "auto-customer",
            labelTranslateKey: "v4.auto.contact.customer",
          },
          { key: "other", labelTranslateKey: "v4.auto.contact.other" },
        ],
        u = [
          {
            key: "ag-flyer",
            labelTranslateKey:
              "v3.collections.agriculture.agri-translate-form.identity.desc1",
          },
          {
            key: "ag-dealer",
            labelTranslateKey:
              "v3.collections.agriculture.agri-translate-form.identity.desc2",
          },
          {
            key: "farmer",
            labelTranslateKey:
              "v3.collections.agriculture.agri-translate-form.identity.desc3",
          },
          {
            key: "ag-materials",
            labelTranslateKey:
              "v3.collections.agriculture.agri-translate-form.identity.desc4",
          },
          {
            key: "ag-seller",
            labelTranslateKey:
              "v3.collections.agriculture.agri-translate-form.identity.desc5",
          },
          {
            key: "ag-servicer",
            labelTranslateKey:
              "v3.collections.agriculture.agri-translate-form.identity.desc6",
          },
          {
            key: "other",
            labelTranslateKey:
              "v3.collections.agriculture.agri-translate-form.identity.desc7",
          },
        ],
        d = [
          {
            key: "form.label.cn.delivery.flyer",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.flyer",
          },
          {
            key: "form.label.cn.delivery.dealer",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.dealer",
          },
          {
            key: "form.label.cn.delivery.transport",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.transport",
          },
          {
            key: "form.label.cn.delivery.engineering",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.engineering",
          },
          {
            key: "form.label.cn.delivery.system",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.system",
          },
          {
            key: "form.label.cn.delivery.emergency",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.emergency",
          },
          {
            key: "form.label.cn.delivery.energy",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.energy",
          },
          {
            key: "form.label.cn.delivery.publicsafety",
            labelTranslateKey:
              "v2.product.delivery.cotact.form.cn.publicsafety",
          },
          {
            key: "form.label.cn.delivery.landscape",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.landscape",
          },
          {
            key: "form.label.cn.delivery.watertrans",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.watertrans",
          },
          {
            key: "form.label.cn.delivery.others",
            labelTranslateKey: "v2.product.delivery.cotact.form.cn.others",
          },
        ],
        p = a(
          a(
            a(
              a(a(a({}, i.ENTERPRISE, s), i.EDUCATION, c), i.AGRICULTURE, u),
              i.AUTO,
              _,
            ),
            i.ENTERPRISE_CN,
            l,
          ),
          i.DELIVERY,
          d,
        ),
        f = [].concat(
          o(Object.values(r)),
          o(
            s.map(function (e) {
              return e.key;
            }),
          ),
          o(
            c.map(function (e) {
              return e.key;
            }),
          ),
          o(
            _.map(function (e) {
              return e.key;
            }),
          ),
          o(
            u.map(function (e) {
              return e.key;
            }),
          ),
          o(
            d.map(function (e) {
              return e.key;
            }),
          ),
          o(
            l.map(function (e) {
              return e.key;
            }),
          ),
          o(
            l.map(function (e) {
              return e.labelTranslateKey;
            }),
          ),
          o(
            s.map(function (e) {
              return e.labelTranslateKey;
            }),
          ),
          o(
            c.map(function (e) {
              return e.labelTranslateKey;
            }),
          ),
          o(
            _.map(function (e) {
              return e.labelTranslateKey;
            }),
          ),
          o(
            u.map(function (e) {
              return e.labelTranslateKey;
            }),
          ),
          o(
            d.map(function (e) {
              return e.labelTranslateKey;
            }),
          ),
        );
      e.exports = {
        FORMGATYPES: {
          DEFAULT: "Submit_fail_0",
          CAPTCHA_VERIFICATION_FAIL: "Submit_fail_1",
          EMAIL_VERIFICATION_FAIL: "Submit_fail_2",
          TERMS_REQUIRE: "Submit_fail_3",
          REQUIRE: "Submit_fail_4",
          MORE_SUBMISSION: "Submit_fail_5",
          PHONE_VERIFICATION_FAIL: "Submit_fail_6",
          SUCCESS: "Submit_success",
        },
        FORM_KEY: r,
        INSTITUTION_TYPE: i,
        INSTITUTION_TYPE_TO_OPTIONS: p,
        PREFETCH_KEYS: f,
      };
    },
    "3utc": function (e, t, n) {
      "use strict";
      var o = n("ODXe"),
        a = n("rePB"),
        r = n("iKuz"),
        i = n.n(r),
        l = n("q1tI"),
        s = n.n(l),
        c = n("ATyU"),
        _ = n("XnI8"),
        u = n("DdlN"),
        d = n("FCep"),
        p = (n("6fKH"), n("XrJB")),
        f = n.n(p),
        h = n("S5C5"),
        m = n("j0XM"),
        y = n("IrEl"),
        b = n("jCXQ"),
        v = n("yWgo"),
        g = {
          key: "wm261ScrollText",
          name: "wm261ScrollText",
          contentSetting: {
            animationCards: {
              label: "\u52a8\u6548\u5361\u7247",
              group_type: "array_card",
              group_prop_name: "animationCards",
              props: {
                cardLayout: {
                  label: "\u5361\u7247\u5e03\u5c40\u6548\u679c",
                  props: {
                    cardWidth: {
                      type: "number",
                      label: "\u5361\u7247\u5185\u5bb9\u5bbd\u5ea6",
                    },
                  },
                },
                desc: {
                  switch: "hasDesc",
                  label: "\u63cf\u8ff0\u8bbe\u7f6e",
                  props: {
                    desc: {
                      type: "string",
                      content: "text",
                      label: "\u63cf\u8ff0\u6587\u6848",
                    },
                    descStyle: {
                      type: "font",
                      label: "\u63cf\u8ff0-\u5b57\u4f53\u914d\u7f6e",
                    },
                  },
                },
                icon: {
                  switch: "hasIcon",
                  label: "\u56fe\u6807\u6a21\u5757",
                  props: {
                    iconStyle: {
                      type: "font",
                      label:
                        "\u56fe\u6807\u6587\u6848-\u5b57\u4f53\u914d\u7f6e",
                    },
                    iconList: {
                      type: "array",
                      label: "\u56fe\u6807\u6570\u7ec4",
                      props: {
                        icon: { type: "image", label: "\u56fe\u6807" },
                        iconTitle: {
                          type: "string",
                          content: "text",
                          label: "\u56fe\u6807\u6587\u6848",
                        },
                      },
                    },
                  },
                },
                link: {
                  switch: "hasLink",
                  label: "\u94fe\u63a5\u8bbe\u7f6e",
                  props: {
                    link: {
                      type: "string",
                      content: "text",
                      label: "\u94fe\u63a5\u6587\u6848",
                    },
                    linkUrl: {
                      label: "\u94fe\u63a5\u8df3\u8f6c\u5730\u5740",
                      type: "string",
                    },
                    linkStyle: {
                      type: "font",
                      label: "\u94fe\u63a5-\u5b57\u4f53\u914d\u7f6e",
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            downgrade: {
              label: "\u662f\u5426\u964d\u7ea7",
              props: {
                forceDowngrade: {
                  label: "\u662f\u5426\u964d\u7ea7",
                  type: "boolean",
                },
              },
            },
            background: {
              label: "\u80cc\u666f\u8bbe\u7f6e",
              props: {
                backgroundColor: {
                  label: "\u80cc\u666f\u989c\u8272",
                  type: "string",
                },
                backgroundImage: {
                  label: "\u80cc\u666f\u56fe\u7247",
                  type: "image",
                },
              },
            },
            foreground: {
              switch: "hasPicture",
              label: "\u524d\u666f\u8bbe\u7f6e",
              props: {
                foregroundImage: {
                  type: "image",
                  label: "\u524d\u666f\u56fe\u7247\uff08\u6b63\u5e38\uff09",
                },
                foregroundImageText: {
                  type: "string",
                  content: "text",
                  label: "\u3010SEO\u3011\u524d\u666f\u56fe\u7247\u6587\u6848",
                },
                foregroundImagePos: {
                  type: "select",
                  label: "\u524d\u666f\u56fe\u7247\u76f8\u5bf9\u4f4d\u7f6e",
                  items: [
                    { value: "top", label: "\u5c45\u9876" },
                    { value: "bottom", label: "\u5c45\u5e95" },
                  ],
                },
                foregroundImageDistance: {
                  type: "number",
                  helptext:
                    "\u6570\u503c\u8303\u56f4\u53ea\u80fd\u4e3a\u6b63\u6570\uff0c\u4e0d\u80fd\u914d\u8d1f\u6570",
                  label: "\u524d\u666f\u56fe\u7247\u8ddd\u79bb",
                },
              },
            },
            styles: {
              label: "\u5e03\u5c40\u914d\u7f6e",
              props: {
                cardTop: {
                  label: "\u5361\u7247\u8ddd\u79bb\u9876\u90e8\u8ddd\u79bb",
                  helptext: "\u9ed8\u8ba410vh",
                  type: "string",
                },
              },
            },
            animation: {
              label: "\u52a8\u6548\u914d\u7f6e",
              props: {
                hasLastCardFadeOut: {
                  label:
                    "\u662f\u5426\u6709\u6700\u540e\u4e00\u5f20\u5361\u7247\u51fa\u573a\u52a8\u6548",
                  type: "boolean",
                },
                cardFadeInDuration: {
                  label:
                    "\u3010\u901f\u5ea6\u914d\u7f6e\u3011\u5361\u7247\u5165\u573a",
                  type: "number",
                },
                cardStopDuration: {
                  label:
                    "\u3010\u901f\u5ea6\u914d\u7f6e\u3011\u5361\u7247\u505c\u987f",
                  type: "number",
                },
                cardFadeOutDuration: {
                  label:
                    "\u3010\u901f\u5ea6\u914d\u7f6e\u3011\u5361\u7247\u51fa\u573a ",
                  type: "number",
                },
                endDuration: {
                  label:
                    "\u3010\u901f\u5ea6\u914d\u7f6e\u3011\u6700\u540e\u505c\u987f",
                  type: "number",
                },
                cardFadeInDistance: {
                  label:
                    "\u3010\u53c2\u6570\u914d\u7f6e\u3011\u5361\u7247\u5165\u573a\u4f4d\u79fb\u8ddd\u79bb",
                  type: "number",
                },
                cardFadeOutDistance: {
                  label:
                    "\u3010\u53c2\u6570\u914d\u7f6e\u3011\u5361\u7247\u51fa\u573a\u4f4d\u79fb\u8ddd\u79bb",
                  type: "number",
                },
              },
            },
          },
        },
        w = s.a.createElement,
        x = {
          "./style.css": {
            banner: "style__banner___30hgC",
            sticky: "style__sticky___1eUOZ",
            "sticky-wrapper": "style__sticky-wrapper___2u1sG",
            "text-wrapper": "style__text-wrapper___1UVgU",
            "text-content": "style__text-content___3ntlV",
            desc: "style__desc___12rzR",
            "text-content0": "style__text-content0___35c1i",
            "text-content1": "style__text-content1___1Iq6N",
            "text-content2": "style__text-content2___29p3d",
            "feature-list": "style__feature-list___1R4ER",
            "feature-item": "style__feature-item___iC0Qb",
            text: "style__text___1UywC",
            "store-link": "style__store-link___2W2z7",
            "text-box": "style__text-box___2zG2S",
            "foreground-wrapper": "style__foreground-wrapper___3dsoQ",
          },
        };
      function k(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function O(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? k(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : k(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var I = Object(v.G)(g.skinSetting),
        S = function (e, t) {
          return e || t;
        },
        j = function (e, t) {
          return null === e || void 0 === e ? void 0 : e[t];
        },
        T = function (e, t) {
          return e && t;
        },
        C = function (e) {
          var t,
            n = e.item,
            o = e.t;
          return w(
            "ul",
            { className: "style__feature-list___1R4ER" },
            null === (t = n.iconList) || void 0 === t
              ? void 0
              : t.map(function (e, t) {
                  return w(
                    "li",
                    { className: "style__feature-item___iC0Qb", key: t },
                    w(d.a, { type: "img", src: e.icon, alt: e.iconTitle }),
                    w("p", {
                      className: "style__text___1UywC",
                      style: O({}, j(n.iconStyle, "style")),
                      dangerouslySetInnerHTML: { __html: e.iconTitle },
                    }),
                  );
                }),
          );
        },
        M = function (e) {
          var t = e.item,
            n = e.localization,
            o = e.gaSend,
            a = e.t;
          return w(
            "a",
            {
              className: "style__store-link___2W2z7",
              href: Object(h.e)(
                Object(h.k)({
                  url: "/where-to-buy",
                  country: j(n, "country"),
                  locale: j(n, "language"),
                }),
                t.linkUrl,
                j(n, "country"),
              ),
              style: O({}, j(t.linkStyle, "style")),
              target: "_blank",
              onClick: function () {
                return o("click", "Learn-More");
              },
            },
            w("span", { style: O({}, j(t.linkStyle, "style")) }, a(t.link)),
            w(f.a, { name: "external-link" }),
          );
        },
        P = function (e) {
          var t = e.drivers,
            n = e.d,
            o = e.t,
            a = e.localization,
            r = e.gaSend;
          return S(n.animationCards, []).map(function (e, l) {
            return w(
              c.a.div,
              {
                className: "style__text-wrapper___1UVgU",
                style: {
                  opacity: t["fadeIn-".concat(l)].moto,
                  y: t["fadeInY-".concat(l)].moto,
                  zIndex: t["zIndex-".concat(l)].moto,
                },
              },
              w(
                "div",
                {
                  style: {
                    paddingTop: S(n.cardTop, ""),
                    width: ((s = e.cardWidth), s ? "".concat(s, "px") : ""),
                  },
                  className: i()("text-content text-content".concat(l), x, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
                },
                T(
                  T(e.hasDesc, e.desc),
                  w("p", {
                    className: "style__desc___12rzR",
                    style: O({}, j(e.descStyle, "style")),
                    dangerouslySetInnerHTML: { __html: e.desc },
                  }),
                ),
                T(e.hasIcon, w(C, { item: e, t: o })),
                T(
                  T(e.hasLink, e.link),
                  w(M, { item: e, localization: a, gaSend: r, t: o }),
                ),
              ),
            );
            var s;
          });
        },
        E = function (e) {
          var t = e.data,
            n = e.t,
            o = {
              bottom:
                "bottom" === t.foregroundImagePos
                  ? S(t.foregroundImageDistance, 0)
                  : "",
              top:
                "top" === t.foregroundImagePos
                  ? S(t.foregroundImageDistance, 0)
                  : "",
            };
          return t.hasPicture
            ? w(
                "div",
                { className: "style__foreground-wrapper___3dsoQ", style: o },
                w(d.a, {
                  type: "img",
                  src: t.foregroundImage,
                  alt: n(t.foregroundImageText),
                }),
              )
            : null;
        },
        L = function (e) {
          var t,
            n = e.component_data,
            a = (function (e) {
              for (
                var t,
                  n = e.cardFadeInDuration,
                  o = e.cardStopDuration,
                  a = e.cardFadeOutDuration,
                  r = e.endDuration,
                  i = e.hasLastCardFadeOut,
                  l = 0,
                  s = S(
                    null === e || void 0 === e
                      ? void 0
                      : null === (t = e.animationCards) || void 0 === t
                        ? void 0
                        : t.length,
                    0,
                  ),
                  c = 0;
                c < s;
                c++
              )
                l +=
                  i || c !== s - 1
                    ? S(n, 0) + S(o, 0) + S(a, 0)
                    : S(n, 0) + S(o, 0);
              return (l += r);
            })(n),
            r = e.V0Dom,
            i = e.localization,
            s = e.gaSend,
            c = e.mobileMode,
            _ = e.t,
            d = n.backgroundColor,
            p = n.backgroundImage,
            f = n.forceDowngrade,
            h = Object(l.useRef)(),
            v = Object(b.c)({ mobileMode: c, forceDowngrade: f }),
            g = Object(o.a)(v, 1)[0],
            x = Object(u.a)({ mobileMode: c, sectionRef: h }),
            k = Object(o.a)(x, 2)[1],
            O = (function (e, t) {
              for (
                var n = e.data || {},
                  o = n.animationCards,
                  a = n.cardFadeInDistance,
                  r = void 0 === a ? 300 : a,
                  i = n.cardFadeOutDistance,
                  l = void 0 === i ? 100 : i,
                  s = n.cardFadeInDuration,
                  c = void 0 === s ? 200 : s,
                  _ = n.cardStopDuration,
                  u = void 0 === _ ? 200 : _,
                  d = n.cardFadeOutDuration,
                  p = void 0 === d ? 200 : d,
                  f = n.hasLastCardFadeOut,
                  h = (t / 1080) * r,
                  m = (t / 1080) * l,
                  y = 0,
                  b = 0,
                  v = null === o || void 0 === o ? void 0 : o.length,
                  g = {},
                  w = 0;
                w < v;
                w++
              ) {
                var x = (y = b) + +c,
                  k = x + +u;
                (b = k + +p),
                  f || w !== v - 1
                    ? ((g["fadeIn-".concat(w)] = {
                        label: "\u5165\u51fa\u573a - \u6e10\u73b0\u6e10\u9690",
                        change: "opacity",
                        actions: [
                          { from: 0, to: 1, start: y, end: x },
                          { from: 1, to: 0, start: k, end: b },
                        ],
                        valueFixed: 4,
                      }),
                      (g["fadeInY-".concat(w)] = {
                        label: "\u4f4d\u79fb",
                        change: "y",
                        actions: [
                          { from: h, to: 0, start: y, end: x },
                          { from: 0, to: -m, start: k, end: b },
                        ],
                        valueFixed: 4,
                      }))
                    : ((g["fadeIn-".concat(w)] = {
                        label: "\u5165\u51fa\u573a - \u6e10\u73b0\u6e10\u9690",
                        change: "opacity",
                        actions: [{ from: 0, to: 1, start: y, end: x }],
                        valueFixed: 4,
                      }),
                      (g["fadeInY-".concat(w)] = {
                        label: "\u4f4d\u79fb",
                        change: "y",
                        actions: [{ from: h, to: 0, start: y, end: x }],
                        valueFixed: 4,
                      })),
                  (g["zIndex-".concat(w)] = {
                    label: "\u663e\u793a",
                    change: "zIndex",
                    actions: [
                      { from: -1, to: 3, start: y, end: y + 1 },
                      { from: 3, to: -1, start: b - 1, end: b },
                    ],
                  });
              }
              return g;
            })({ data: n }, k),
            j = Object(m.a)({ animationConfig: O, rawDuration: a });
          (t = n),
            I.forEach(function (e) {
              t[e] = "" === t[e] || void 0 === t[e] ? void 0 : +t[e];
            });
            // console.log(g)
            // console.log(k)
          var T = a + k,
            C = Object(y.a)({
              target: h,
              offset: ["start start", "end end"],
              isDowngrade: g,
              customCB: function (e, t) {
                var n = e.y;
                console.log(t)
                j(n.progress, t.drivers);
              },
              customDefaultValues: function () {
                return { drivers: j(0) };
              },
            }).drivers,
            M = S(r, "V0\u7ec4\u4ef6\u672a\u914d\u7f6e"),
            L = { backgroundColor: d, backgroundImage: "url(".concat(p, ")") };
          return g
            ? M
            : w(
                "section",
                {
                  ref: h,
                  className: "style__banner___30hgC",
                  style: { height: T },
                  id: "wm261-section-banner",
                },
                w(
                  "div",
                  { className: "style__sticky___1eUOZ" },
                  w(
                    "div",
                    { className: "style__sticky-wrapper___2u1sG", style: L },
                    w(P, {
                      d: n,
                      t: _,
                      drivers: C,
                      localization: i,
                      gaSend: s,
                    }),
                    w(E, { data: n, t: _ }),
                  ),
                ),
              );
        };
      (L.defaultProps = {
        component_data: {
          animationCards: [],
          forceDowngrade: !1,
          cardFadeInDistance: 300,
          cardFadeOutDistance: 100,
          cardFadeInDuration: 200,
          cardStopDuration: 200,
          cardFadeOutDuration: 200,
          endDuration: 200,
          cardTop: "10vh",
        },
      }),
        (L.propSettings = g);
      t.a = Object(_.a)(L);
    },
    "3vbH": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return b;
      });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("q1tI"),
        u = n("r7AC"),
        d = n("gn4A"),
        p = n.n(d),
        f = _.createElement;
      function h(e, t) {
        var n =
          ("undefined" !== typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" === typeof e) return m(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return m(e, t);
            })(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var o = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return o >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[o++] };
              },
              e: function (e) {
                throw e;
              },
              f: a,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var r,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (r = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw r;
            }
          },
        };
      }
      function m(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      function y(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var b = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            (n = y(this, t, [e])),
            Object(c.a)(Object(l.a)(n), "videoContainerDom", void 0),
            Object(c.a)(Object(l.a)(n), "video", void 0),
            Object(c.a)(Object(l.a)(n), "videoInView", void 0),
            Object(c.a)(Object(l.a)(n), "listenersToRemove", void 0),
            Object(c.a)(Object(l.a)(n), "autoPlayRetryTimes", void 0),
            Object(c.a)(Object(l.a)(n), "playerTimeout", void 0),
            Object(c.a)(Object(l.a)(n), "videoPlayed", !1),
            (n.state = {
              downgrade: !1,
              isWeixin: !1,
              isMobile: !1,
              visibleBorderOffset: 100,
              iPhoneVersion: !1,
            }),
            (n.listenersToRemove = []),
            (n.autoPlayRetryTimes = 3),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(
            t,
            [
              {
                key: "componentDidMount",
                value: function () {
                  var e;
                  if (window) {
                    var t = window.navigator.userAgent,
                      n =
                        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                          t,
                        ),
                      o = !!t.match(/MicroMessenger/gi),
                      a =
                        !!t.match(/iPhone/i) &&
                        (null === (e = t.match(/OS (\d+)_(\d+)_?(\d+)?/i)) ||
                        void 0 === e
                          ? void 0
                          : e[1]),
                      r = this.props,
                      i = r.videoDowngradeInObsoleteDevice,
                      l = r.videoDowngradeInMini,
                      s =
                        p.a.isDowngrade() ||
                        (i && p.a.isObsoleteMobileDevice()) ||
                        (l && p.a.checkIsIphoneMini());
                    this.setState(
                      {
                        downgrade: s,
                        isWeixin: o,
                        isMobile: n,
                        visibleBorderOffset: n ? 48 : 100,
                        iPhoneVersion: !!a && +a,
                      },
                      this.init,
                    );
                  }
                },
              },
              {
                key: "UNSAFE_componentWillUpdate",
                value: function (e) {
                  e.triggerPlay &&
                    !this.props.triggerPlay &&
                    this.triggerVideoPlay(this.video),
                    e.triggerPause &&
                      !this.props.triggerPause &&
                      this.video &&
                      (this.triggerVideoPause(),
                      Number.isNaN(this.video.duration) ||
                        (this.video.currentTime = 0));
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  this.listenersToRemove.forEach(function (e) {
                    "function" === typeof e && e();
                  }),
                    window.videoPlayerLoadCount &&
                      (window.videoPlayerLoadCount -= 1);
                },
              },
              {
                key: "init",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.lazyLoad,
                    o = t.visiblePlay,
                    a = t.showWholeElmPlay,
                    r = t.reset,
                    i = t.replayClassName,
                    l = t.playClassName,
                    s = t.pauseClassName,
                    c = t.loadingClassName,
                    _ = this.state,
                    u = _.downgrade,
                    d = _.isWeixin,
                    p = _.isMobile,
                    f = this;
                  function h() {
                    window &&
                      (window.videoPlayerLoadCount
                        ? (window.videoPlayerLoadCount += 1)
                        : (window.videoPlayerLoadCount = 1));
                  }
                  function m() {
                    (o || a) && f.initVisiblePlay(),
                      l && f.initPlay(),
                      s && f.initPause(),
                      i && f.initReplay(),
                      r && f.bindEndReset(),
                      c && f.initLoadingState();
                  }
                  u ||
                    ((this.video =
                      this.videoContainerDom.querySelector("video")),
                    this.video &&
                      (this.initPlayListener(this.video),
                      (this.video.style.opacity = 0.99)),
                    this.video.addEventListener("loadstart", h),
                    this.listenersToRemove.push(function () {
                      e.video.removeEventListener("loadstart", h);
                    }),
                    p && this.videoWithControl(),
                    n && this.initLazyLoad(),
                    d
                      ? (document.addEventListener("WeixinJSBridgeReady", m),
                        this.listenersToRemove.push(function () {
                          document.removeEventListener(
                            "WeixinJSBridgeReady",
                            m,
                          );
                        }))
                      : ((o || a) && f.initVisiblePlay(),
                        l && this.initPlay(),
                        s && this.initPause(),
                        i && this.initReplay(),
                        r && this.bindEndReset(),
                        c && f.initLoadingState()));
                },
              },
              {
                key: "initPlayListener",
                value: function (e) {
                  var t = this;
                  (e.onplaying = function () {
                    t.video.isPlaying = !0;
                  }),
                    (e.onpause = function () {
                      t.video.isPlaying = !1;
                    });
                },
              },
              {
                key: "bindEndReset",
                value: function () {
                  var e = this,
                    t = this;
                  function n() {
                    Number.isNaN(t.video.duration) || (t.video.currentTime = 0);
                  }
                  this.video.addEventListener("ended", n),
                    this.listenersToRemove.push(function () {
                      e.video.removeEventListener("ended", n);
                    });
                },
              },
              {
                key: "initVisiblePlay",
                value: function () {
                  var e = this,
                    n = this.props,
                    o = n.showWholeElmPlay,
                    a = n.replayWhenRevisible,
                    r = n.replayClassName,
                    i = this,
                    l = a,
                    s = function (n) {
                      var o = n.inView,
                        a = n.observer;
                      return (
                        o
                          ? ((i.videoInView = !0),
                            clearTimeout(e.playerTimeout),
                            (e.playerTimeout = setTimeout(function () {
                              !(function (e) {
                                if (i.videoInView)
                                  if (l) {
                                    i.videoPlayed ||
                                      (i.video &&
                                        !Number.isNaN(i.video.duration) &&
                                        (t.bindVideoEvent(i.video, function () {
                                          i.triggerVideoPlay(i.video),
                                            i.triggerVideoPause(),
                                            (i.video.currentTime = 0);
                                        }),
                                        (i.videoPlayed = !0)));
                                    var n =
                                        !i.video.paused &&
                                        !i.video.ended &&
                                        i.video.readyState > 2,
                                      o = !r,
                                      a = i.videoInView && !n && o;
                                    (i.videoInView || a) &&
                                      (n ||
                                        t.bindVideoEvent(i.video, function () {
                                          (Number.isNaN(i.video.duration) ||
                                            (i.video.currentTime = 0),
                                          i.triggerVideoPlay(i.video),
                                          r) &&
                                            (i.videoContainerDom.querySelector(
                                              ".".concat(r),
                                            ).style.display = "none");
                                          i.videoPlayed = !0;
                                        }));
                                  } else {
                                    if (i.videoPlayed || !i.videoInView) return;
                                    t.bindVideoEvent(i.video, function () {
                                      Number.isNaN(i.video.duration) ||
                                        (i.video.currentTime = 0),
                                        i.triggerVideoPlay(i.video),
                                        (i.videoPlayed = !0);
                                    }),
                                      e.disconnect();
                                  }
                              })(a);
                            }, 800)))
                          : (clearTimeout(e.playerTimeout),
                            i.triggerVideoPause(),
                            (i.video.currentTime = 0),
                            (i.videoInView = !1)),
                        !0
                      );
                    };
                  o
                    ? Object(u.b)({
                        elm: this.video,
                        threshold: 1,
                        callback: s,
                      })
                    : Object(u.b)({
                        elm: i.videoContainerDom,
                        offset: this.state.visibleBorderOffset,
                        callback: s,
                      });
                },
              },
              {
                key: "initPlay",
                value: function () {
                  var e,
                    n = this,
                    o = this.props,
                    a = o.playClassName,
                    r = o.pauseClassName,
                    i = n.videoContainerDom,
                    l = i.querySelector(".".concat(a));
                  function s(o) {
                    o && o.preventDefault(),
                      t.bindVideoEvent(n.video, function () {
                        n.triggerVideoPlay(n.video);
                      }),
                      (l.style.display = "none"),
                      r && e && (e.style.display = "block");
                  }
                  r && (e = i.querySelector(".".concat(r))),
                    (l.style.display = "block"),
                    l.addEventListener("click", s),
                    this.listenersToRemove.push(function () {
                      l.removeEventListener("click", s);
                    });
                },
              },
              {
                key: "initPause",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.playClassName,
                    o = t.pauseClassName,
                    a = e.videoContainerDom,
                    r = a.querySelector(".".concat(n)),
                    i = a.querySelector(".".concat(o));
                  function l(t) {
                    t && t.preventDefault(),
                      e.triggerVideoPause(),
                      (r.style.display = "block"),
                      (i.style.display = "none");
                  }
                  i.addEventListener("click", l),
                    this.listenersToRemove.push(function () {
                      i.removeEventListener("click", l);
                    });
                },
              },
              {
                key: "initReplay",
                value: function () {
                  var e = this,
                    n = this.props,
                    o = n.replayClassName,
                    a = n.playClassName,
                    r = n.pauseClassName,
                    i = e.videoContainerDom,
                    l = i.querySelector(".".concat(o)),
                    s = a && i.querySelector(".".concat(a)),
                    c = r && i.querySelector(".".concat(r));
                  function _() {
                    (l.style.display = "block"),
                      s &&
                        c &&
                        ((s.style.display = "none"),
                        (c.style.display = "none")),
                      e.triggerVideoPause();
                  }
                  function u(n) {
                    n && n.preventDefault(),
                      t.bindVideoEvent(e.video, function () {
                        Number.isNaN(e.video.duration) ||
                          (e.video.currentTime = 0),
                          e.triggerVideoPlay(e.video),
                          c && (c.style.display = "block");
                      }),
                      (l.style.display = "none");
                  }
                  e.video.addEventListener("ended", _),
                    l.addEventListener("click", u),
                    this.listenersToRemove.push(function () {
                      e.video.removeEventListener("ended", _),
                        l.removeEventListener("click", u);
                    });
                },
              },
              {
                key: "initLoadingState",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.loadingClassName,
                    o = t.playClassName,
                    a = t.pauseClassName,
                    r = t.replayClassName,
                    i = e.videoContainerDom,
                    l = i.querySelector(".".concat(n)),
                    s = i.querySelector(".".concat(o)),
                    c = i.querySelector(".".concat(a)),
                    _ = r ? i.querySelector(".".concat(r)) : null,
                    u = function (e, t) {
                      e &&
                        (t
                          ? ((e.style.opacity = ""),
                            (e.style.pointerEvents = "auto"))
                          : ((e.style.opacity = 0),
                            (e.style.pointerEvents = "none")));
                    },
                    d = function () {
                      (l.style.opacity = 1), u(s, !1), u(c, !1), u(_, !1);
                    },
                    p = function () {
                      d();
                    },
                    f = function () {
                      (l.style.opacity = 0), u(s, !0), u(c, !0), u(_, !0);
                    };
                  e.video.addEventListener("loadstart", function t() {
                    d(), e.video.removeEventListener("loadstart", t);
                  }),
                    e.video.addEventListener("waiting", p),
                    e.video.addEventListener("canplay", f),
                    this.listenersToRemove.push(function () {
                      e.video.removeEventListener("waiting", p),
                        e.video.removeEventListener("canplay", f);
                    });
                },
              },
              {
                key: "initLazyLoad",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.lazyLoadThreshold,
                    o = t.videoLazyLoadDistance ? 5e3 : n;
                  Object(u.b)({
                    elm: this.video,
                    offset: o - this.state.visibleBorderOffset,
                    callback: function (t) {
                      if (t.inView) {
                        var n = e.video.dataset.layzrPoster;
                        n && e.video.setAttribute("poster", n);
                        var o,
                          a = h(e.video.querySelectorAll("source"));
                        try {
                          for (a.s(); !(o = a.n()).done; ) {
                            var r = o.value,
                              i = r.dataset.layzrSrc;
                            r.setAttribute("src", i);
                          }
                        } catch (l) {
                          a.e(l);
                        } finally {
                          a.f();
                        }
                        e.video.load();
                      }
                    },
                  });
                },
              },
              {
                key: "triggerVideoPlay",
                value: function (e) {
                  var t,
                    n = this,
                    o = this;
                  this.state.isWeixin && window.WeixinJSBridge
                    ? window.WeixinJSBridge.invoke(
                        "getNetworkType",
                        {},
                        function () {
                          setTimeout(function () {
                            var t = e.play();
                            t &&
                              t.then &&
                              "function" === typeof t.then &&
                              t
                                .then(
                                  function () {
                                    return null;
                                  },
                                  function () {
                                    return null;
                                  },
                                )
                                .catch(function () {
                                  return null;
                                });
                          }, 0);
                        },
                        !1,
                      )
                    : setTimeout(function () {
                        (t = e.play()) &&
                          t.then &&
                          "function" === typeof t.then &&
                          t
                            .then(
                              function () {
                                return null;
                              },
                              function () {
                                n.autoPlayRetryTimes--,
                                  n.autoPlayRetryTimes &&
                                    setTimeout(function () {
                                      o.triggerVideoPlay(o.video);
                                    }, 100);
                              },
                            )
                            .catch(function () {
                              return null;
                            });
                      }, 0);
                },
              },
              {
                key: "triggerVideoPause",
                value: function () {
                  this.video.isPlaying && this.video.pause();
                },
              },
              {
                key: "videoWithControl",
                value: function () {
                  var e = this,
                    t = this.state.iPhoneVersion,
                    n = t && Number(t) >= 14;
                  !n && (this.video.style.opacity = 0),
                    this.video.removeAttribute("autoplay"),
                    this.video.setAttribute("muted", !0),
                    this.video.setAttribute("playsinline", !0),
                    this.video.setAttribute("x5-playsinline", !0),
                    this.video.setAttribute("webkit-playsinline", !0),
                    !n && this.video.setAttribute("controls", !0),
                    setTimeout(function () {
                      n ||
                        (e.video.removeAttribute("controls"),
                        (e.video.style.opacity = 0.99));
                    }, 0);
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.children,
                    o = t.downgradeDom,
                    a = t.style;
                  return this.state.downgrade && o
                    ? o
                    : f(
                        "div",
                        {
                          className: "video-player-box",
                          style: a,
                          ref: function (t) {
                            e.videoContainerDom = t;
                          },
                        },
                        n,
                      );
                },
              },
            ],
            [
              {
                key: "bindVideoEvent",
                value: function (e, t) {
                  window &&
                  !!window.MSInputMethodContext &&
                  !!document.documentMode
                    ? (e.load && e.load(),
                      e.addEventListener("canplay", function n() {
                        t(), e.removeEventListener("canplay", n);
                      }))
                    : t(e);
                },
              },
            ],
          ),
          t
        );
      })(_.Component);
      Object(c.a)(b, "defaultProps", {
        reset: !1,
        replayWhenRevisible: !1,
        showWholeElmPlay: !1,
        visiblePlay: !1,
        lazyLoad: !1,
        videoLazyLoadDistance: !1,
        lazyLoadThreshold: 1200,
        replayClassName: "",
        loadingClassName: "",
        downgradeDom: null,
        pauseClassName: "",
        playClassName: "",
        style: {},
        triggerPlay: {},
        triggerPause: {},
        videoDowngradeInObsoleteDevice: !1,
        videoDowngradeInMini: !1,
      });
    },
    "3z1L": function (e, t, n) {
      e.exports = {
        "media-video": "video__media-video___1WZym",
        dark: "video__dark___1ne7c",
        "video-button": "video__video-button___3OKvN",
        "video-button-box": "video__video-button-box___3If3A",
        "replay-button": "video__replay-button___3qvXn",
        hidden: "video__hidden___1fdch",
        "pause-button": "video__pause-button___1w7xC",
        "downgrade-img": "video__downgrade-img___1U438",
        "downgrade-pic": "video__downgrade-pic___3waNg",
        "downgrade-play-btn": "video__downgrade-play-btn___1hPQ1",
      };
    },
    "44Ds": function (e, t, n) {
      var o = n("e4Nc"),
        a = "Expected a function";
      function r(e, t) {
        if ("function" != typeof e || (null != t && "function" != typeof t))
          throw new TypeError(a);
        var n = function () {
          var o = arguments,
            a = t ? t.apply(this, o) : o[0],
            r = n.cache;
          if (r.has(a)) return r.get(a);
          var i = e.apply(this, o);
          return (n.cache = r.set(a, i) || r), i;
        };
        return (n.cache = new (r.Cache || o)()), n;
      }
      (r.Cache = o), (e.exports = r);
    },
    "4Sk2": function (e, t, n) {
      e.exports = {
        "section-common-bgzoomout-static-version":
          "style__section-common-bgzoomout-static-version___30s1M",
        "zoom-out-bg": "style__zoom-out-bg___1OGwi",
        "bg-style": "style__bg-style___2p1VZ",
        "text-box": "style__text-box___1X1B6",
        "text-eyebrow": "style__text-eyebrow___1ahGq",
        "text-headline": "style__text-headline___MVU5A",
        "text-description": "style__text-description___2HkiS",
        "mobile-mode": "style__mobile-mode___2qID_",
        "section-common-bgzoomout": "style__section-common-bgzoomout___30Gbs",
        sticky: "style__sticky___ZZvSo",
        "bg-gradient-section": "style__bg-gradient-section___2Q4w6",
        "animation-module": "style__animation-module___2xRPL",
        "section-borders": "style__section-borders___3YnOY",
        "zoomout-bg-box": "style__zoomout-bg-box___3_3lD",
        "font-box": "style__font-box___1iyye",
        eyebrow: "style__eyebrow___1u_jA",
        headline: "style__headline___2qzvn",
        description: "style__description___3SZjs",
        mask: "style__mask___2b91C",
        "elevator-position": "style__elevator-position___3DYgt",
        "pc-mode": "style__pc-mode___1_uEq",
        "media-screen-1440": "style__media-screen-1440___1q6RV",
        "copywriting-template-default":
          "style__copywriting-template-default___3vJkQ",
        "media-screen-1600": "style__media-screen-1600___2dRAI",
      };
    },
    "4kuk": function (e, t, n) {
      var o = n("SfRM"),
        a = n("Hvzi"),
        r = n("u8Dt"),
        i = n("ekgI"),
        l = n("JSQU");
      function s(e) {
        var t = -1,
          n = null == e ? 0 : e.length;
        for (this.clear(); ++t < n; ) {
          var o = e[t];
          this.set(o[0], o[1]);
        }
      }
      (s.prototype.clear = o),
        (s.prototype.delete = a),
        (s.prototype.get = r),
        (s.prototype.has = i),
        (s.prototype.set = l),
        (e.exports = s);
    },
    "4uTw": function (e, t, n) {
      var o = n("Z0cm"),
        a = n("9ggG"),
        r = n("GNiM"),
        i = n("dt0z");
      e.exports = function (e, t) {
        return o(e) ? e : a(e, t) ? [e] : r(i(e));
      };
    },
    "53h+": function (e, t, n) {
      e.exports = {
        form: "style__form___1smfs",
        "form-item": "style__form-item____HyRV",
        "form-item-margin": "style__form-item-margin___yDrps",
        "form-item-label": "style__form-item-label___3RoYq",
        button: "style__button___29kjB",
        "form-error": "style__form-error___1S7vw",
        "form-error-height": "style__form-error-height___11O7x",
        "form-item-control-wrapper": "style__form-item-control-wrapper___3S24U",
        "form-hide": "style__form-hide___3vFRM",
        "form-error-wrapper": "style__form-error-wrapper___3thdL",
      };
    },
    "5K7Z": function (e, t, n) {
      var o = n("93I4");
      e.exports = function (e) {
        if (!o(e)) throw TypeError(e + " is not an object!");
        return e;
      };
    },
    "5T2Y": function (e, t) {
      var n = (e.exports =
        "undefined" != typeof window && window.Math == Math
          ? window
          : "undefined" != typeof self && self.Math == Math
            ? self
            : Function("return this")());
      "number" == typeof __g && (__g = n);
    },
    "5Tg0": function (e, t, n) {
      (function (e) {
        var o = n("Kz5y"),
          a = t && !t.nodeType && t,
          r = a && "object" == typeof e && e && !e.nodeType && e,
          i = r && r.exports === a ? o.Buffer : void 0,
          l = i ? i.allocUnsafe : void 0;
        e.exports = function (e, t) {
          if (t) return e.slice();
          var n = e.length,
            o = l ? l(n) : new e.constructor(n);
          return e.copy(o), o;
        };
      }).call(this, n("YuTi")(e));
    },
    "5suc": function (e, t, n) {
      "use strict";
      var o = n("q1tI");
      t.a = function (e) {
        var t = e,
          n = Object(o.useCallback)(
            function () {
              return (
                t.scrollTop ||
                document.body.scrollTop ||
                document.documentElement.scrollTop
              );
            },
            [t],
          ),
          a = Object(o.useCallback)(
            function (e) {
              (t.style.position = "fixed"),
                (t.style.width = "100%"),
                (t.style.top = "-".concat(e, "px"));
            },
            [t],
          ),
          r = Object(o.useCallback)(
            function () {
              t.style.position = "";
              var e = t.style.top;
              window.scrollTo(0, -parseInt(e, 10)), (t.style.top = "");
            },
            [t],
          );
        return [
          Object(o.useCallback)(
            function () {
              var e = n();
              a(e);
            },
            [n, a],
          ),
          Object(o.useCallback)(
            function () {
              r();
            },
            [r],
          ),
        ];
      };
    },
    "5tpG": function (e, t, n) {
      e.exports = {
        "section-light": "style__section-light___DuWYU",
        title: "style__title___3kG2-",
        "horizontal-line": "style__horizontal-line___1s5kI",
        desc: "style__desc___3sB3X",
        "link-btn": "style__link-btn___3j-N5",
        "angle-right-icon": "style__angle-right-icon___16AJE",
        "tab-item": "style__tab-item___2DnLB",
        "tab-item-active": "style__tab-item-active___1uuRJ",
        "tab-content-item": "style__tab-content-item___3Na1e",
        "tab-slider": "style__tab-slider___2UsoW",
        "tab-bar": "style__tab-bar___1s0Os",
        "sample-tab-section-m": "style__sample-tab-section-m___2125X",
        "h1-title": "style__h1-title___332tl",
        "tabs-wrap": "style__tabs-wrap___3IO-a",
        tabs: "style__tabs___1LR0m",
        "tab-box": "style__tab-box___2zLwi",
        "tab-content": "style__tab-content___F48oS",
        "tab-content-box": "style__tab-content-box___3R-5Y",
        "tab-content-active": "style__tab-content-active___13anz",
        mask: "style__mask___dTzU-",
        "tab-desc-box": "style__tab-desc-box___ukU91",
        "carousel-box": "style__carousel-box___3vmOP",
        "text-box": "style__text-box___3tqQN",
        "main-title": "style__main-title___S2CKW",
        "sub-title": "style__sub-title___zco8a",
        "sample-description": "style__sample-description___2vW0R",
        "sample-specs": "style__sample-specs___BCNmz",
        "sample-specs-key": "style__sample-specs-key___2XFV5",
        "sample-specs-value": "style__sample-specs-value___14s6K",
        "dji-divider": "style__dji-divider___1ycDw",
        "sample-info": "style__sample-info___1aJHm",
        "sample-preview": "style__sample-preview___3dvw3",
        "sample-download-info": "style__sample-download-info___rR4SQ",
        icon: "style__icon___vR10M",
        "dji-btn": "style__dji-btn___3qtWz",
        "dji-btn-dark": "style__dji-btn-dark___1SGFM",
        sample_info: "style__sample_info___2cmtJ",
        "tab-pill": "style__tab-pill___1vXUE",
        "child-tab-item": "style__child-tab-item___18AaU",
        active: "style__active___8vHG7",
        loading: "style__loading___20SYB",
        "loading-icon": "style__loading-icon___2lBBn",
        "fa-spin": "style__fa-spin___ox4QL",
        "no-data": "style__no-data___Yq8eq",
        "content-wrapper": "style__content-wrapper___AVwxb",
        text: "style__text___z78VG",
        "opacity-animation": "style__opacity-animation___v_if0",
      };
    },
    "5vMV": function (e, t, n) {
      var o = n("B+OT"),
        a = n("NsO/"),
        r = n("W070")(!1),
        i = n("VVlx")("IE_PROTO");
      e.exports = function (e, t) {
        var n,
          l = a(e),
          s = 0,
          c = [];
        for (n in l) n != i && o(l, n) && c.push(n);
        for (; t.length > s; ) o(l, (n = t[s++])) && (~r(c, n) || c.push(n));
        return c;
      };
    },
    "6/1s": function (e, t, n) {
      var o = n("YqAc")("meta"),
        a = n("93I4"),
        r = n("B+OT"),
        i = n("2faE").f,
        l = 0,
        s =
          Object.isExtensible ||
          function () {
            return !0;
          },
        c = !n("KUxP")(function () {
          return s(Object.preventExtensions({}));
        }),
        _ = function (e) {
          i(e, o, { value: { i: "O" + ++l, w: {} } });
        },
        u = (e.exports = {
          KEY: o,
          NEED: !1,
          fastKey: function (e, t) {
            if (!a(e))
              return "symbol" == typeof e
                ? e
                : ("string" == typeof e ? "S" : "P") + e;
            if (!r(e, o)) {
              if (!s(e)) return "F";
              if (!t) return "E";
              _(e);
            }
            return e[o].i;
          },
          getWeak: function (e, t) {
            if (!r(e, o)) {
              if (!s(e)) return !0;
              if (!t) return !1;
              _(e);
            }
            return e[o].w;
          },
          onFreeze: function (e) {
            return c && u.NEED && s(e) && !r(e, o) && _(e), e;
          },
        });
    },
    "6A9R": function (e, t, n) {
      e.exports = {
        "floating-button": "style__floating-button___3JFqx",
        button: "style__button___2kMoR",
        notification: "style__notification___-cIRj",
        active: "style__active___H2Pfs",
        content: "style__content___nD_l_",
        "notification-safari": "style__notification-safari___nP_NM",
        "button-safari": "style__button-safari___3v8lO",
      };
    },
    "6AKW": function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return o;
      }),
        n.d(t, "c", function () {
          return a;
        }),
        n.d(t, "d", function () {
          return r;
        }),
        n.d(t, "a", function () {
          return i;
        }),
        n.d(t, "g", function () {
          return l;
        }),
        n.d(t, "e", function () {
          return s;
        }),
        n.d(t, "i", function () {
          return c;
        }),
        n.d(t, "k", function () {
          return _;
        }),
        n.d(t, "h", function () {
          return u;
        }),
        n.d(t, "j", function () {
          return d;
        }),
        n.d(t, "f", function () {
          return p;
        });
      var o = 24,
        a = 600,
        r = 48,
        i = 24,
        l = 430,
        s = "1200px",
        c = 1200,
        _ = 1080,
        u = 640,
        d = 48,
        p = 32503564800;
    },
    "6HgK": function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("Ff2n"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("rePB"),
        d = n("q1tI"),
        p = n("2mql"),
        f = n.n(p),
        h = n("XnI8"),
        m = n("zT9C"),
        y = n.n(m),
        b = n("S5C5"),
        v = (n("vejd"), ["component_data", "t", "localization"]),
        g = d.createElement;
      function w(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var x = function (e, t, n, o) {
        e &&
          Object.keys(e).forEach(function (a) {
            var r = e[a];
            r.props &&
              "array_card" !== r.group_type &&
              (function e(t, n, o, a) {
                Object.keys(t).forEach(function (r) {
                  var i = t[r],
                    l = n[r];
                  l &&
                    ("array" === i.type && l.length
                      ? l.forEach(function (t) {
                          e(i.props, t, o, a);
                        })
                      : "string" === i.type && "text" === i.content && l
                        ? (n[r] = o(n[r]))
                        : "string" === i.type &&
                          "url" === i.content &&
                          l.type &&
                          ("www" === l.type
                            ? (n[r] = Object(b.i)(l.path, a.country))
                            : (n[r] = l.path)));
                });
              })(r.props, t, n, o);
          });
      };
      t.a = function (e, t) {
        var n = (function (n) {
          function l(e) {
            var t;
            return (
              Object(r.default)(this, l),
              ((t = w(this, l, [e])).handleComponentClick =
                t.handleComponentClick.bind(Object(c.a)(t))),
              t
            );
          }
          return (
            Object(_.a)(l, n),
            Object(i.default)(l, [
              {
                key: "handleComponentClick",
                value: function (e) {
                  var t = this.props.gaSend;
                  if (t && e && e.target && "function" === typeof t) {
                    var n = e.target;
                    if (n && n.getAttribute && n.getAttribute("data-ga-label"))
                      t("click", n.getAttribute("data-ga-label"));
                    else
                      for (; n.parentNode; )
                        if (
                          (n = n.parentNode) &&
                          n.getAttribute &&
                          n.getAttribute("data-ga-label")
                        )
                          return void t(
                            "click",
                            n.getAttribute("data-ga-label"),
                          );
                  }
                },
              },
              {
                key: "render",
                value: function () {
                  var n = this.props,
                    r = n.component_data,
                    i = void 0 === r ? {} : r,
                    l = n.t,
                    s = n.localization,
                    c = Object(a.a)(n, v),
                    _ = y()(i);
                  return (
                    ["layoutSetting", "skinSetting", "contentSetting"].forEach(
                      function (e) {
                        var n = t[e];
                        n &&
                          (x(n, _, l, s),
                          Object.keys(n).forEach(function (e) {
                            var t = n[e];
                            if ("array_card" === t.group_type && t.props) {
                              var o = t.group_prop_name,
                                a = _[o];
                              a &&
                                a.length &&
                                a.forEach(function (e) {
                                  x(t.props, e, l, s);
                                });
                            }
                          }));
                      },
                    ),
                    g(
                      "div",
                      {
                        className: "atom-component",
                        role: "button",
                        tabIndex: 0,
                        onClick: this.handleComponentClick,
                        style: { outline: "none" },
                      },
                      g(e, Object(o.a)({}, _, c, { localization: s, t: l })),
                    )
                  );
                },
              },
            ]),
            l
          );
        })(d.Component);
        return (
          Object(u.a)(n, "defaultProps", {
            gaSend: function () {},
            t: function () {},
            localization: {},
            component_data: e.defaultProps,
          }),
          Object(u.a)(n, "propSettings", t),
          f()(Object(h.a)(n), e)
        );
      };
    },
    "6fKH": function (e, t, n) {
      e.exports = {
        banner: "style__banner___30hgC",
        sticky: "style__sticky___1eUOZ",
        "sticky-wrapper": "style__sticky-wrapper___2u1sG",
        "text-wrapper": "style__text-wrapper___1UVgU",
        "text-content": "style__text-content___3ntlV",
        desc: "style__desc___12rzR",
        "text-content0": "style__text-content0___35c1i",
        "text-content1": "style__text-content1___1Iq6N",
        "text-content2": "style__text-content2___29p3d",
        "feature-list": "style__feature-list___1R4ER",
        "feature-item": "style__feature-item___iC0Qb",
        text: "style__text___1UywC",
        "store-link": "style__store-link___2W2z7",
        "text-box": "style__text-box___2zG2S",
        "foreground-wrapper": "style__foreground-wrapper___3dsoQ",
      };
    },
    "6sVZ": function (e, t) {
      var n = Object.prototype;
      e.exports = function (e) {
        var t = e && e.constructor;
        return e === (("function" == typeof t && t.prototype) || n);
      };
    },
    "6tYh": function (e, t, n) {
      var o = n("93I4"),
        a = n("5K7Z"),
        r = function (e, t) {
          if ((a(e), !o(t) && null !== t))
            throw TypeError(t + ": can't set as prototype!");
        };
      e.exports = {
        set:
          Object.setPrototypeOf ||
          ("__proto__" in {}
            ? (function (e, t, o) {
                try {
                  (o = n("2GTP")(
                    Function.call,
                    n("vwuL").f(Object.prototype, "__proto__").set,
                    2,
                  ))(e, []),
                    (t = !(e instanceof Array));
                } catch (a) {
                  t = !0;
                }
                return function (e, n) {
                  return r(e, n), t ? (e.__proto__ = n) : o(e, n), e;
                };
              })({}, !1)
            : void 0),
        check: r,
      };
    },
    "7/Y7": function (e, t, n) {
      e.exports = {
        "section-comments-component":
          "style__section-comments-component___bQMLM",
        container: "style__container___1pbF3",
        "horizontal-line": "style__horizontal-line___1pQNn",
        "comment-title": "style__comment-title___1LkaH",
        "comment-item": "style__comment-item___1ZFK5",
        "section-comment-dark": "style__section-comment-dark___2PMSj",
        "section-comment-light": "style__section-comment-light___1GO2f",
      };
    },
    "75bK": function (e, t, n) {
      "use strict";
      var o = n("rePB"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("Ji7U"),
        c = n("HcE9"),
        _ = n("q1tI"),
        u = n.n(_),
        d = n("/MKj"),
        p = n("S5C5"),
        f = u.a.createElement;
      function h(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function m(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? h(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : h(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function y(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var b = (function (e) {
        function t(e) {
          var n;
          return (
            Object(a.default)(this, t),
            ((n = y(this, t)).state = { target: e.target }),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(r.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this.props.href;
                if (window.location.href && /(https?:)?\/\//.test(e))
                  try {
                    var t = new URL(window.location.href),
                      n = new URL(e);
                    t.host !== n.host && this.setState({ target: "_blank" });
                  } catch (o) {}
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.state.target,
                  t = this.props,
                  n = t.prefix,
                  o = t.href,
                  a = t.localization,
                  r = t.context.subdomain,
                  i = o;
                n &&
                  (i = Object(p.k)({
                    url: o,
                    domain: r,
                    country: a.country,
                    locale: a.language,
                  }));
                var l = m(m({}, this.props), {}, { target: e, href: i });
                return f(c.c, l);
              },
            },
          ]),
          t
        );
      })(u.a.Component);
      t.a = Object(d.b)(function (e) {
        return { localization: e.localization, context: e.context };
      })(b);
    },
    "77Zs": function (e, t, n) {
      var o = n("Xi7e");
      e.exports = function () {
        (this.__data__ = new o()), (this.size = 0);
      };
    },
    "7GkX": function (e, t, n) {
      var o = n("b80T"),
        a = n("A90E"),
        r = n("MMmD");
      e.exports = function (e) {
        return r(e) ? o(e) : a(e);
      };
    },
    "7Ix3": function (e, t) {
      e.exports = function (e) {
        var t = [];
        if (null != e) for (var n in Object(e)) t.push(n);
        return t;
      };
    },
    "7bI+": function (e, t, n) {
      "use strict";
      var o = n("KQm4"),
        a = n("wx14"),
        r = n("rePB"),
        i = n("1OyB"),
        l = n("vuIU"),
        s = n("md7G"),
        c = n("foSv"),
        _ = n("Ji7U"),
        u = n("q1tI"),
        d = n.n(u),
        p = n("0b+E"),
        f = n("TSYQ"),
        h = n.n(f),
        m = n("ODXe"),
        y = n("HaE+"),
        b = n("iKuz"),
        v = n.n(b),
        g = n("t8Fj"),
        w = n.n(g),
        x = n("xk4V"),
        k = n.n(x),
        O = n("XnI8"),
        I = n("/MKj"),
        S = n("u11H"),
        j = n("S5C5"),
        T = n("yWgo"),
        C = n("ZO6J"),
        M = n("JX7q"),
        P = (n("epst"), n("Gsew")),
        E = d.a.createElement,
        L = {
          "./style.css": {
            "sub-nav-wrap": "style__sub-nav-wrap___37c08",
            "sub-nav-collapsed": "style__sub-nav-collapsed___3gfAG",
            "sub-nav-mask": "style__sub-nav-mask___11WGm",
            "angle-down": "style__angle-down___2-RnT",
            "sub-nav": "style__sub-nav___2cPn2",
            "sub-nav-tab": "style__sub-nav-tab___3qeZX",
            "sub-nav-drop": "style__sub-nav-drop___zg0Kd",
            "sub-nav-content": "style__sub-nav-content___1YXj1",
            "sub-nav-container": "style__sub-nav-container___rNAuB",
            "product-title": "style__product-title___2-wyq",
            "sub-nav-toggle": "style__sub-nav-toggle___Rmz1a",
            "sub-nav-toggle-btn": "style__sub-nav-toggle-btn___mSLdS",
            "sub-nav-right": "style__sub-nav-right___VvG5D",
            "sub-nav-btn": "style__sub-nav-btn___2eOM0",
            "sub-nav-buy-now": "style__sub-nav-buy-now___2U6wS",
          },
        };
      function B(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var N = (function (e) {
        function t() {
          var e;
          return (
            Object(i.default)(this, t),
            ((e = B(this, t)).state = {
              active: !1,
              dropListHeight: 0,
              maskHeight: 0,
            }),
            (e.resetToggle = e.resetToggle.bind(Object(M.a)(e))),
            (e.resetMaskHeight = e.resetMaskHeight.bind(Object(M.a)(e))),
            (e.handelToggle = e.handelToggle.bind(Object(M.a)(e))),
            e
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                window.addEventListener("scroll", this.resetToggle),
                  window.addEventListener("resize", this.resetMaskHeight),
                  window.scrollY &&
                    window.scrollTo &&
                    window.scrollTo({ top: window.scrollY + 1 });
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                window.removeEventListener("scroll", this.resetToggle),
                  window.removeEventListener("resize", this.resetMaskHeight);
              },
            },
            {
              key: "resetToggle",
              value: function () {
                this.state.active && this.setState({ active: !1 });
              },
            },
            {
              key: "resetMaskHeight",
              value: function () {
                this.state.maskHeight !== window.innerHeight &&
                  this.setState({ maskHeight: window.innerHeight });
              },
            },
            {
              key: "handelToggle",
              value: function () {
                var e = this.state.active,
                  t = this.dropList.clientHeight;
                this.setState({
                  active: !e,
                  dropListHeight: t,
                  maskHeight: window.innerHeight,
                });
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.productData,
                  o = t.localization,
                  a = t.t,
                  r = t.context.subdomain,
                  i = n.shopping_guides,
                  l = n.slug,
                  s = n.title,
                  c = n.sub_nav,
                  _ = this.state,
                  u = _.active,
                  d = _.dropListHeight,
                  p = _.maskHeight;
                if (!l) return null;
                var f,
                  m,
                  y = l ? "mobile_".concat(l, "_detail") : "",
                  b =
                    i &&
                    i.product_list &&
                    i.product_list[0] &&
                    i.product_list[0].primary_button;
                i && i.show && b && b.link && b.title
                  ? ((f = b.link), (m = b.title))
                  : n.buylink &&
                    ((f = n.buylink), (m = a("v2.common.buy_now"))),
                  f &&
                    (f = Object(j.k)({
                      domain: "store",
                      url: f,
                      country: o.country,
                      locale: o.language,
                      mobileMode: !0,
                    }));
                var g = h()({ "sub-nav-wrap": !0, "sub-nav-collapsed": u }),
                  x = { maxHeight: u ? d : "0" },
                  O = { height: p },
                  I = /^http(s)?:\/\/(.*?)\//,
                  S = "www.dji.com";
                return (
                  (S = window.location.host),
                  E(
                    "div",
                    {
                      className: v()(g, L, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    E(
                      w.a,
                      { innerZ: "9100" },
                      E(
                        "nav",
                        { className: "style__sub-nav___2cPn2" },
                        E(
                          "div",
                          { className: "style__sub-nav-content___1YXj1" },
                          E("div", {
                            className: "style__sub-nav-mask___11WGm",
                            style: O,
                            onClick: this.resetToggle,
                          }),
                          E(
                            "div",
                            { className: "style__sub-nav-tab___3qeZX" },
                            E(
                              "div",
                              { className: "style__sub-nav-container___rNAuB" },
                              E(
                                "div",
                                { className: "style__product-title___2-wyq" },
                                E(
                                  "a",
                                  {
                                    href: Object(j.k)({
                                      url: l,
                                      country: o.country,
                                      locale: o.language,
                                      mobileMode: !0,
                                      domain: r,
                                    }),
                                    "data-ga-category": y,
                                    "data-ga-action": "click",
                                    "data-ga-label": "navbar_title",
                                  },
                                  s,
                                ),
                              ),
                              E(
                                "div",
                                { className: "style__sub-nav-toggle___Rmz1a" },
                                E(
                                  "div",
                                  {
                                    onClick: this.handelToggle,
                                    className:
                                      "style__sub-nav-toggle-btn___mSLdS",
                                  },
                                  E(
                                    "div",
                                    { className: "style__angle-down___2-RnT" },
                                    E(P.a, { name: "angle-right" }),
                                  ),
                                ),
                              ),
                              f
                                ? E(
                                    "div",
                                    {
                                      className:
                                        "style__sub-nav-buy-now___2U6wS",
                                    },
                                    E(
                                      "a",
                                      {
                                        href: f,
                                        className: "style__sub-nav-btn___2eOM0",
                                        "data-ga-category": y,
                                        "data-ga-action": "click",
                                        "data-ga-label": "buy_now",
                                        target: "_blank",
                                        "data-bd-track": Object(j.j)(f) ? 7 : 1,
                                      },
                                      m,
                                    ),
                                  )
                                : null,
                            ),
                          ),
                          E(
                            "div",
                            {
                              className: "style__sub-nav-drop___zg0Kd",
                              style: x,
                            },
                            E(
                              "div",
                              { className: "style__sub-nav-container___rNAuB" },
                              E(
                                "ul",
                                {
                                  className: "style__sub-nav-right___VvG5D",
                                  ref: function (t) {
                                    e.dropList = t;
                                  },
                                },
                                c && c.length
                                  ? c.map(function (e, t) {
                                      return /^(https?:)?\/\//.test(e.link)
                                        ? E(
                                            "li",
                                            { key: k()() },
                                            E(
                                              "a",
                                              {
                                                href: Object(j.k)({
                                                  url: e.link,
                                                  country: o.country,
                                                  locale: o.language,
                                                  mobileMode: !0,
                                                }),
                                                target:
                                                  I.exec(e.link)[2] === S
                                                    ? "_self"
                                                    : "_blank",
                                                "data-ga-category": y,
                                                "data-ga-action": "click",
                                                "data-ga-label":
                                                  e.ga_label ||
                                                  "nav_button".concat(t),
                                              },
                                              e.title,
                                            ),
                                          )
                                        : E(
                                            "li",
                                            { key: k()() },
                                            E(
                                              "a",
                                              {
                                                href: Object(j.k)({
                                                  url: e.link,
                                                  country: o.country,
                                                  locale: o.language,
                                                  mobileMode: !0,
                                                  domain: r,
                                                }),
                                                "data-ga-category": y,
                                                "data-ga-action": "click",
                                                "data-ga-label":
                                                  e.ga_label ||
                                                  "nav_button".concat(t),
                                              },
                                              e.title,
                                            ),
                                          );
                                    })
                                  : null,
                              ),
                            ),
                          ),
                        ),
                      ),
                    ),
                  )
                );
              },
            },
          ]),
          t
        );
      })(d.a.Component);
      N.defaultProps = { t: function () {}, productData: {} };
      var D = Object(O.a)(
          Object(I.b)(function (e) {
            return { context: e.context };
          })(N),
        ),
        z = n("hKI/"),
        A = n.n(z),
        R = (n("waHC"), d.a.createElement),
        F = {
          "./popover.css": {
            popover: "popover__popover___19ztE",
            show: "popover__show___2UdCz",
            "is-m": "popover__is-m___3pbTZ",
            "flex-box": "popover__flex-box___14szQ",
            "is-pc": "popover__is-pc___2rxjc",
            arrow: "popover__arrow___29rRa",
            close: "popover__close___1jBk4",
            "cover-image": "popover__cover-image___1yWkS",
            "content-text": "popover__content-text___2OyWK",
            title: "popover__title___245CC",
            desc: "popover__desc___3NoMo",
            container: "popover__container___2DyOM",
            "learn-more": "popover__learn-more___wGmmT",
          },
        },
        V = Object(O.a)(function (e) {
          var t,
            n = e.productData,
            o = e.mobileMode,
            a = e.gaSend,
            r = e.t,
            i = e.buyLink,
            l = Object(u.useState)(!1),
            s = l[0],
            c = l[1],
            _ = Object(u.useState)(0),
            d = _[0],
            p = _[1],
            f = Object(u.useRef)(null),
            h = Object(u.useRef)(null),
            m = Object(u.useRef)(null),
            y = Object(u.useRef)(null),
            b = Object(u.useRef)(null),
            g = function () {
              c(!1), a("click", "close");
            },
            w = function () {
              var e = document.querySelector("html");
              e.removeEventListener("click", y.current),
                e.removeEventListener("keydown", y.current),
                e.removeEventListener("mousemove", y.current),
                e.removeEventListener("mousewheel", y.current),
                e.removeEventListener("scroll", y.current);
            },
            x = function (e) {
              clearTimeout(f.current),
                (f.current = setTimeout(function () {
                  var e = new Date().getTime();
                  (T.Q &&
                    window.localStorage.getItem("BUY_NOW_POPOVER_CLOSE")) < e &&
                    (c(!0),
                    a("click", "show"),
                    clearTimeout(h.current),
                    (h.current = setTimeout(function () {
                      g();
                    }, 1e4)),
                    y.current && w());
                }, e));
            };
          Object(u.useEffect)(function () {
            return (
              window.ABTest || (window.ABTest = {}),
              (window.ABTest.showBuyTipsA = function (e, t) {
                !(function (e, t) {
                  if ((x(e), !t)) {
                    y.current = function () {
                      return x(e);
                    };
                    var n = document.querySelector("html");
                    n.addEventListener("click", y.current),
                      n.addEventListener("keydown", y.current),
                      n.addEventListener("mousemove", y.current),
                      n.addEventListener("mousewheel", y.current),
                      n.addEventListener("scroll", y.current);
                  }
                })(e || 6e4, t);
              }),
              p(window.innerHeight || window.screen.height),
              window.addEventListener(
                "resize",
                A()(function () {
                  return p(window.innerHeight || window.screen.height);
                }, 300),
              ),
              o && document.body.appendChild(b.current),
              function () {
                clearTimeout(f.current),
                  clearTimeout(h.current),
                  w(),
                  o &&
                    document.body.contains(b.current) &&
                    document.body.removeChild(b.current);
              }
            );
          }, []);
          var k = Object(j.m)(
            null === n || void 0 === n
              ? void 0
              : null === (t = n.cover) || void 0 === t
                ? void 0
                : t.url,
          );
          return R(
            "div",
            {
              style: o && { "--windowHeight": "".concat(d, "px") },
              ref: b,
              key: "product-buy-popover",
              className: v()(
                "popover "
                  .concat(o ? "is-m" : "is-pc", " ")
                  .concat(s ? "show" : ""),
                F,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
            },
            R(
              "div",
              { className: "popover__container___2DyOM" },
              R(
                "div",
                {
                  className: "popover__flex-box___14szQ",
                  onClick: function (e) {
                    o &&
                      i &&
                      m.current &&
                      !m.current.contains(e.target) &&
                      (window.open(i, "_blank"), a("click", "buy_now_2"));
                  },
                },
                !o &&
                  R("div", {
                    className: "popover__cover-image___1yWkS",
                    style: { backgroundImage: "url('".concat(k, "')") },
                  }),
                R(
                  "div",
                  { className: "popover__content-text___2OyWK" },
                  R("div", {
                    className: "popover__title___245CC",
                    dangerouslySetInnerHTML: {
                      __html: r("v1.product.buy.popover.title"),
                    },
                  }),
                  R("div", {
                    className: "popover__desc___3NoMo",
                    dangerouslySetInnerHTML: {
                      __html: r("v1.product.buy.popover.desc"),
                    },
                  }),
                ),
                o &&
                  R("div", {
                    className: "popover__learn-more___wGmmT",
                    dangerouslySetInnerHTML: {
                      __html: r("v1.product.buy.popover.button.text"),
                    },
                  }),
                R("div", {
                  className: "popover__close___1jBk4",
                  onClick: function () {
                    g(), clearTimeout(h.current);
                    var e = new Date(Date.now() + 864e5).getTime();
                    T.Q &&
                      window.localStorage.setItem("BUY_NOW_POPOVER_CLOSE", e);
                  },
                  ref: m,
                }),
              ),
            ),
            !o && R("div", { className: "popover__arrow___29rRa" }),
          );
        }),
        H = (n("CElf"), d.a.createElement),
        W = {
          "./dropdown.css": {
            "dropdown-switcher": "dropdown__dropdown-switcher___3gu-Y",
            "dropdown-mask": "dropdown__dropdown-mask___2S3xP",
            active: "dropdown__active___36qe5",
            "product-dropdown": "dropdown__product-dropdown___2hk-O",
            "dropdown-item": "dropdown__dropdown-item___3O-Rr",
            "series-dropdown": "dropdown__series-dropdown___2qsGE",
            "store-dropdown": "dropdown__store-dropdown___GAa4r",
          },
        },
        U = "&utm_source=official&utm_medium=product&utm_campaign=mini-3-pro",
        G = {
          series: [
            { link: "https://www.dji.com/mini-3", text: "DJI Mini 3" },
            { link: "https://www.dji.com/mini-2-se", text: "DJI Mini 2 SE" },
            {
              link: "https://www.dji.com/products/camera-drones#mini-series",
              text: "\u67e5\u770b\u5168\u90e8 DJI Mini \u7cfb\u5217",
            },
          ],
          store: [
            {
              link: "https://store.dji.com/product/dji-mini-3-pro?vid=113961".concat(
                U,
              ),
              text: "DJI Mini 3 Pro\uff08\u666e\u901a\u9065\u63a7\u5668\uff09",
              gaLabel: "store-",
              target: "_blank",
            },
            {
              link: "https://store.dji.com/product/dji-mini-3-pro?vid=113991".concat(
                U,
              ),
              text: "DJI Mini 3 Pro\uff08\u5e26\u5c4f\u9065\u63a7\u5668\uff09",
              gaLabel: "store-",
              target: "_blank",
            },
            {
              link: "https://store.dji.com/product/dji-mini-3-pro?vid=142281".concat(
                U,
              ),
              text: "DJI Mini 3 Pro \u6c89\u6d78\u5f0f\u98de\u884c\u5957\u88c5",
              gaLabel: "store-",
              target: "_blank",
            },
            {
              link: "https://store.dji.com/product/dji-mini-3-pro?vid=113931".concat(
                U,
              ),
              text: "DJI Mini 3 Pro\uff08\u4e0d\u542b\u9065\u63a7\u5668\uff09",
              gaLabel: "store-",
              target: "_blank",
            },
          ],
        },
        Y = function (e) {
          var t = e.type,
            n = e.active;
          return H(
            "div",
            {
              key: t,
              className:
                "product-subnav-dropdown " +
                v()(
                  ""
                    .concat(t, "-dropdown product-dropdown ")
                    .concat(n ? "active" : ""),
                  W,
                  {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  },
                ),
            },
            (G[t] || []).map(function (e) {
              return H(
                "a",
                {
                  target: e.target || "_self",
                  "data-ga-category": "product-dropdown",
                  "data-ga-action": "click",
                  "data-ga-label": "".concat(e.gaLabel || "").concat(e.text),
                  href: e.link,
                  className: "dropdown__dropdown-item___3O-Rr",
                },
                e.text,
              );
            }),
          );
        },
        q = Object(O.a)(function (e) {
          var t = e.mobileMode,
            n = Object(u.useState)(!1),
            o = n[0],
            a = n[1];
          function r(e) {
            e &&
              e.target &&
              e.target.className &&
              -1 === e.target.className.indexOf("dropdown__") &&
              i();
          }
          function i() {
            a(!1),
              document.removeEventListener("scroll", i),
              document.removeEventListener("click", r);
          }
          return (
            Object(u.useEffect)(
              function () {
                o &&
                  (document.addEventListener("scroll", i),
                  document.addEventListener("click", r));
              },
              [o],
            ),
            H(
              d.a.Fragment,
              null,
              H("span", {
                onClick: function () {
                  return a(function (e) {
                    return !e;
                  });
                },
                className: v()(
                  "dropdown-switcher ".concat(o ? "active" : ""),
                  W,
                  {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  },
                ),
              }),
              t &&
                H("span", {
                  className: "dropdown__dropdown-mask___2S3xP",
                  onClick: function () {
                    return a(!1);
                  },
                }),
              H(Y, { type: "series", active: o }),
              H(Y, { type: "store", active: o }),
            )
          );
        }),
        X = (n("WDec"), d.a.createElement),
        Z = {
          "./style.css": {
            "sub-nav-wrap-common": "style__sub-nav-wrap-common___3PVba",
            "sub-nav-right": "style__sub-nav-right___ruIrR",
            "sub-nav": "style__sub-nav___AjIC_",
            "sub-nav-wrap-dark": "style__sub-nav-wrap-dark___LJNeE",
            "product-title": "style__product-title___29p40",
            "sub-nav-wrap-light": "style__sub-nav-wrap-light___1ECG_",
            "sub-nav-container": "style__sub-nav-container___21l4Q",
            "sub-nav-display-none": "style__sub-nav-display-none___nMoeI",
            "sub-nav-btn": "style__sub-nav-btn___fguHS",
            "buy-now": "style__buy-now___2TgCR",
            "buy-now-box": "style__buy-now-box___1nqqw",
            "buy-now-store-point": "style__buy-now-store-point___3DBaA",
            point: "style__point___2bNPa",
            "product-price": "style__product-price___wyUEp",
            origin: "style__origin___29TtQ",
          },
        };
      function K() {
        K = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new M(o || []);
          return a(i, "_invoke", { value: S(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var g = {};
        c(g, i, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          x = w && w(w(P([])));
        x && x !== n && o.call(x, i) && (g = x);
        var k = (v.prototype = y.prototype = Object.create(g));
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function I(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function S(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = j(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function j(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                j(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function T(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function C(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function M(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(T, this),
            this.reset(!0);
        }
        function P(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(k, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(k)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          O(I.prototype),
          c(I.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = I),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new I(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          O(k),
          c(k, s, "Generator"),
          c(k, i, function () {
            return this;
          }),
          c(k, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = P),
          (M.prototype = {
            constructor: M,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(C),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), C(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    C(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: P(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      function Q(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var J = (function (e) {
        function t() {
          var e;
          return (
            Object(i.default)(this, t),
            ((e = Q(this, t)).state = { showPrice: !1, priceInfo: {} }),
            e
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                window.scrollY &&
                  window.scrollTo &&
                  window.scrollTo({ top: window.scrollY }),
                  this.getPrice();
              },
            },
            {
              key: "getPrice",
              value: (function () {
                var e = Object(y.default)(
                  K().mark(function e() {
                    var t, n, o, a, r, i, l, s, c, _, u, d;
                    return K().wrap(
                      function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              if (
                                ((t = this.props),
                                (n = t.localization),
                                (o = t.productData),
                                (a = (void 0 === o ? {} : o).ean),
                                (i = this),
                                (r = void 0 === a ? "" : a))
                              ) {
                                e.next = 5;
                                break;
                              }
                              return e.abrupt("return");
                            case 5:
                              return (
                                (e.prev = 5),
                                (e.next = 8),
                                S.default.request(
                                  {
                                    name: "productGetPrice",
                                    method: "GET",
                                    query: { ean: r },
                                  },
                                  n,
                                )
                              );
                            case 8:
                              return (l = e.sent), (e.next = 11), l.json();
                            case 11:
                              200 === (s = e.sent).status &&
                                ((c = s.data),
                                (_ = void 0 === c ? [] : c),
                                (u = Object(m.a)(_, 1)),
                                (d = u[0]) &&
                                  d.price &&
                                  d.on_sale &&
                                  i.setState({ priceInfo: d, showPrice: !0 })),
                                (e.next = 18);
                              break;
                            case 15:
                              (e.prev = 15),
                                (e.t0 = e.catch(5)),
                                console.error(e.t0);
                            case 18:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this,
                      [[5, 15]],
                    );
                  }),
                );
                return function () {
                  return e.apply(this, arguments);
                };
              })(),
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.productData,
                  o = t.localization,
                  a = t.mobileMode,
                  r = t.t,
                  i = t.context,
                  l = t.gaSend,
                  s = i.subdomain,
                  c = n.shopping_guides,
                  _ = n.slug,
                  u = n.title,
                  p = n.sub_nav_theme,
                  f = n.sub_nav,
                  m = n.priceData,
                  y = void 0 === m ? {} : m;
                if (!_) return null;
                if (a) return X(D, { productData: n });
                var b = _ ? "".concat(_, "_detail") : "",
                  g = p || "light";
                g = g.toLowerCase();
                var x,
                  O,
                  I = h()({
                    "sub-nav-wrap-common": !0,
                    "sub-nav-wrap-light": "light" === g,
                    "sub-nav-wrap-dark": "dark" === g,
                  }),
                  S =
                    c &&
                    c.product_list &&
                    c.product_list[0] &&
                    c.product_list[0].primary_button,
                  M = null === S || void 0 === S ? void 0 : S.link_type,
                  P =
                    "store-path" !== M && "absolute-path" !== M && M
                      ? s
                      : "store",
                  E = "relative-path" === M ? "_self" : "_blank",
                  L = !1;
                c && c.show && S && S.link && S.title
                  ? ((x = S.link), (O = S.title))
                  : n.buylink &&
                    ((x = n.buylink),
                    (O = r("v2.common.buy_now")),
                    (P = "store")),
                  x &&
                    ((x = Object(j.k)({
                      domain: P,
                      url: x,
                      country: o.country,
                      locale: o.language,
                      mobileMode: a,
                    })),
                    (L = Object(j.j)(x)));
                var B = /^http(s)?:\/\/(.*?)\//,
                  N = "www.dji.com";
                N = window.location.host;
                var z = "".concat(_, "_detail.subnav.buy_now.store_point.text"),
                  A = this.state,
                  R = A.priceInfo,
                  F = void 0 === R ? {} : R,
                  H = A.showPrice;
                !F.price && y.price && y.on_sale && ((F = y), (H = !0));
                var W =
                  "mini-3-pro" === _ &&
                  "CN" === o.country &&
                  "zh-CN" === o.language;
                return X(
                  "div",
                  {
                    className: v()(I, Z, {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    }),
                  },
                  X(
                    w.a,
                    null,
                    X(
                      "nav",
                      { className: "style__sub-nav___AjIC_" },
                      X(
                        "div",
                        { className: "style__sub-nav-container___21l4Q" },
                        X(
                          "div",
                          {
                            className:
                              "product-subnav-title style__product-title___29p40",
                          },
                          X(
                            "a",
                            {
                              href: Object(j.k)({
                                url: _,
                                country: o.country,
                                locale: o.language,
                                mobileMode: a,
                                domain: s,
                              }),
                            },
                            u,
                          ),
                          W && X(q, { mobileMode: !1 }),
                        ),
                        X(
                          "ul",
                          { className: "style__sub-nav-right___ruIrR" },
                          f && f.length
                            ? f.map(function (t, n) {
                                var r =
                                    (null === t || void 0 === t
                                      ? void 0
                                      : t.hide_on_pc) || !1,
                                  i = h()({ "sub-nav-display-none": r });
                                return /(inspire-3\/samples$)/.test(t.link) &&
                                  e.props.mobileMode
                                  ? null
                                  : /(inspire-3\/premium-service$)/.test(t.link)
                                    ? X(
                                        "li",
                                        {
                                          key: k()(),
                                          className: v()(i, Z, {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          }),
                                        },
                                        X(
                                          "a",
                                          {
                                            href: Object(j.k)({
                                              url: t.link,
                                              country: o.country,
                                              locale: o.language,
                                              mobileMode: a,
                                              domain: s,
                                            }),
                                            "data-ga-category": b,
                                            "data-ga-action": "click",
                                            "data-ga-label":
                                              t.ga_label ||
                                              "nav_button".concat(n),
                                            target: "_blank",
                                          },
                                          t.title,
                                        ),
                                      )
                                    : "anchor" === t.nav_type
                                      ? X(
                                          "li",
                                          {
                                            key: k()(),
                                            className: v()(i, Z, {
                                              autoResolveMultipleImports: !0,
                                              handleMissingStyleName: "warn",
                                            }),
                                          },
                                          X(
                                            "a",
                                            {
                                              className:
                                                "style__sub-nav-btn___fguHS",
                                              href: t.link,
                                              "data-ga-category": b,
                                              "data-ga-action": "click",
                                              "data-ga-label":
                                                t.ga_label ||
                                                "nav_button".concat(n),
                                              target:
                                                B.exec(t.link) &&
                                                B.exec(t.link)[2] === N
                                                  ? "_self"
                                                  : "_blank",
                                            },
                                            t.title,
                                          ),
                                        )
                                      : /(store\.dji\.com)/.test(t.link) &&
                                          -1 !== C.a.indexOf(o.country)
                                        ? X(
                                            "li",
                                            {
                                              key: k()(),
                                              "data-key": "where-to-buy",
                                              className: v()(i, Z, {
                                                autoResolveMultipleImports: !0,
                                                handleMissingStyleName: "warn",
                                              }),
                                            },
                                            X(
                                              "a",
                                              {
                                                href: Object(j.k)({
                                                  url: "/where-to-buy",
                                                  country: o.country,
                                                  locale: o.language,
                                                  mobileMode: a,
                                                  domain: "store",
                                                }),
                                                target:
                                                  B.exec(t.link) &&
                                                  B.exec(t.link)[2] === N
                                                    ? "_self"
                                                    : "_blank",
                                                "data-ga-category": b,
                                                "data-ga-action": "click",
                                                "data-ga-label":
                                                  t.ga_label ||
                                                  "nav_button".concat(n),
                                              },
                                              t.title,
                                            ),
                                          )
                                        : /^(https?:)?\/\//.test(t.link)
                                          ? X(
                                              "li",
                                              {
                                                key: k()(),
                                                "data-key": t.link,
                                                className: v()(i, Z, {
                                                  autoResolveMultipleImports:
                                                    !0,
                                                  handleMissingStyleName:
                                                    "warn",
                                                }),
                                              },
                                              X(
                                                "a",
                                                {
                                                  href: Object(j.k)({
                                                    url: t.link,
                                                    country: o.country,
                                                    locale: o.language,
                                                    mobileMode: a,
                                                  }),
                                                  target:
                                                    B.exec(t.link) &&
                                                    B.exec(t.link)[2] === N
                                                      ? "_self"
                                                      : "_blank",
                                                  "data-ga-category": b,
                                                  "data-ga-action": "click",
                                                  "data-ga-label":
                                                    t.ga_label ||
                                                    "nav_button".concat(n),
                                                },
                                                t.title,
                                              ),
                                            )
                                          : X(
                                              "li",
                                              {
                                                key: k()(),
                                                "data-key": t.link,
                                                className: v()(i, Z, {
                                                  autoResolveMultipleImports:
                                                    !0,
                                                  handleMissingStyleName:
                                                    "warn",
                                                }),
                                              },
                                              X(
                                                "a",
                                                {
                                                  href: Object(j.k)({
                                                    url: t.link,
                                                    country: o.country,
                                                    locale: o.language,
                                                    mobileMode: a,
                                                    domain: s,
                                                  }),
                                                  "data-ga-category": b,
                                                  "data-ga-action": "click",
                                                  "data-ga-label":
                                                    t.ga_label ||
                                                    "nav_button".concat(n),
                                                },
                                                t.title,
                                              ),
                                            );
                              })
                            : null,
                          x
                            ? X(
                                "li",
                                {
                                  key: k()(),
                                  className: "style__buy-now-box___1nqqw",
                                },
                                !Object(T.bb)(
                                  "".concat(
                                    _,
                                    "_detail.subnav.buy_now.store_point.switch",
                                  ),
                                  r,
                                ) &&
                                  X(
                                    "div",
                                    {
                                      className:
                                        "style__buy-now-store-point___3DBaA",
                                    },
                                    X(
                                      "span",
                                      {
                                        className:
                                          "style__product-price___wyUEp",
                                      },
                                      H &&
                                        F.price &&
                                        X(
                                          d.a.Fragment,
                                          null,
                                          X("span", {
                                            dangerouslySetInnerHTML: {
                                              __html: r(
                                                "v3.common.shoppingguide.price.prefix",
                                              ),
                                            },
                                          }),
                                          X("span", {
                                            dangerouslySetInnerHTML: {
                                              __html: F.price,
                                            },
                                          }),
                                          X("span", {
                                            dangerouslySetInnerHTML: {
                                              __html: r(
                                                "v3.common.shoppingguide.price.suffix",
                                              ),
                                            },
                                          }),
                                          F.has_discount &&
                                            X(
                                              "span",
                                              {
                                                className:
                                                  "style__origin___29TtQ",
                                              },
                                              F.original_price,
                                            ),
                                        ),
                                    ),
                                    !Object(T.bb)(z, r) &&
                                      X(
                                        "span",
                                        { className: "style__point___2bNPa" },
                                        r(z),
                                      ),
                                  ),
                                X(
                                  "a",
                                  {
                                    href: x,
                                    className: "style__sub-nav-btn___fguHS",
                                    "data-ga-category": b,
                                    "data-ga-action": "click",
                                    "data-ga-label": "buy_now",
                                    target: E,
                                    "data-bd-track": Object(j.j)(x) ? 7 : 1,
                                  },
                                  O,
                                ),
                                L &&
                                  X(V, { productData: n, gaSend: l(b), t: r }),
                              )
                            : null,
                        ),
                      ),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(d.a.PureComponent);
      J.defaultProps = { t: function () {}, productData: {} };
      var $ = Object(O.a)(
          Object(I.b)(function (e) {
            return { context: e.context };
          })(J),
        ),
        ee = n("Gytx"),
        te = n.n(ee),
        ne = n("/+VL"),
        oe = d.a.createElement;
      function ae(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var re = (function (e) {
          return (
            (e[(e.STATUS_ORIGINAL = 0)] = "STATUS_ORIGINAL"),
            (e[(e.STATUS_RELEASED = 1)] = "STATUS_RELEASED"),
            (e[(e.STATUS_FIXED = 2)] = "STATUS_FIXED"),
            e
          );
        })(re || {}),
        ie = (function (e) {
          function t(e, n) {
            var o;
            return (
              Object(i.default)(this, t),
              (o = ae(this, t, [e, n])),
              Object(r.a)(Object(M.a)(o), "stickyTop", void 0),
              Object(r.a)(Object(M.a)(o), "stickyBottom", void 0),
              Object(r.a)(Object(M.a)(o), "frozen", void 0),
              Object(r.a)(Object(M.a)(o), "skipNextScrollEvent", void 0),
              Object(r.a)(Object(M.a)(o), "scrollTop", void 0),
              Object(r.a)(Object(M.a)(o), "bottomBoundaryTarget", void 0),
              Object(r.a)(Object(M.a)(o), "topTarget", void 0),
              Object(r.a)(Object(M.a)(o), "outerElement", void 0),
              Object(r.a)(Object(M.a)(o), "innerElement", void 0),
              Object(r.a)(Object(M.a)(o), "scrollDelta", 0),
              Object(r.a)(Object(M.a)(o), "dimensionListenerKey", "sticky"),
              (o.handleResize = o.handleResize.bind(Object(M.a)(o))),
              (o.handleScroll = o.handleScroll.bind(Object(M.a)(o))),
              (o.handleScrollStart = o.handleScrollStart.bind(Object(M.a)(o))),
              (o.stickyTop = 0),
              (o.stickyBottom = 0),
              (o.frozen = !1),
              (o.skipNextScrollEvent = !1),
              (o.scrollTop = -1),
              (o.state = {
                top: 0,
                bottom: 0,
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                topBoundary: 0,
                bottomBoundary: 1 / 0,
                status: re.STATUS_ORIGINAL,
                pos: 0,
                activated: !1,
              }),
              o
            );
          }
          return (
            Object(_.a)(t, e),
            Object(l.default)(t, [
              {
                key: "getTargetHeight",
                value: function (e) {
                  return (e && e.offsetHeight) || 0;
                },
              },
              {
                key: "getTopPosition",
                value: function (e) {
                  return (
                    "string" === typeof (e = e || this.props.top || 0) &&
                      (this.topTarget ||
                        (this.topTarget = document.querySelector(e)),
                      (e = this.getTargetHeight(this.topTarget))),
                    e
                  );
                },
              },
              {
                key: "getTargetBottom",
                value: function (e) {
                  if (!e) return -1;
                  var t = e.getBoundingClientRect();
                  return this.scrollTop + t.bottom;
                },
              },
              {
                key: "getBottomBoundary",
                value: function (e) {
                  var t = e || this.props.bottomBoundary;
                  return (
                    "object" === typeof t && (t = t.value || t.target || 0),
                    "string" === typeof t &&
                      (this.bottomBoundaryTarget ||
                        (this.bottomBoundaryTarget = document.querySelector(t)),
                      (t = this.getTargetBottom(this.bottomBoundaryTarget))),
                    t && t > 0 ? t : 1 / 0
                  );
                },
              },
              {
                key: "reset",
                value: function () {
                  this.setState({ status: re.STATUS_ORIGINAL, pos: 0 });
                },
              },
              {
                key: "release",
                value: function (e) {
                  this.setState(function (t) {
                    return { status: re.STATUS_RELEASED, pos: e - t.y };
                  });
                },
              },
              {
                key: "fix",
                value: function (e) {
                  (this.state.status === re.STATUS_FIXED &&
                    e === this.state.pos) ||
                    this.setState({ status: re.STATUS_FIXED, pos: e });
                },
              },
              {
                key: "updateInitialDimension",
                value: function (e) {
                  if (((e = e || {}), this.outerElement && this.innerElement)) {
                    var t = this.outerElement.getBoundingClientRect(),
                      n = this.innerElement.getBoundingClientRect(),
                      o = Math.ceil(t.width || t.right - t.left),
                      a = Math.ceil(n.height || n.bottom - n.top),
                      r = Math.ceil(t.top + this.scrollTop),
                      i = ne.a.getInstance().getDimension().innerHeight,
                      l = Math.ceil(this.getTopPosition(e.top)),
                      s = Math.ceil(Math.min(this.state.top + a, i)),
                      c = this.getBottomBoundary(e.bottomBoundary);
                    this.setState(function () {
                      return {
                        top: l,
                        bottom: s,
                        width: o,
                        height: a,
                        x: t.left,
                        y: r,
                        bottomBoundary: c,
                        topBoundary: r,
                      };
                    });
                  }
                },
              },
              {
                key: "handleResize",
                value: function () {
                  var e, t;
                  (null !== (e = (t = this.props).shouldFreeze) &&
                    void 0 !== e &&
                    e.call(t)) ||
                    (this.updateInitialDimension(), this.update());
                },
              },
              {
                key: "handleScrollStart",
                value: function (e) {
                  var t, n;
                  (this.frozen =
                    (null === (t = (n = this.props).shouldFreeze) ||
                    void 0 === t
                      ? void 0
                      : t.call(n)) || !1),
                    this.frozen ||
                      (this.scrollTop === e.pageOffsetY
                        ? (this.skipNextScrollEvent = !0)
                        : ((this.scrollTop = e.pageOffsetY),
                          this.updateInitialDimension()));
                },
              },
              {
                key: "handleScroll",
                value: function (e) {
                  this.skipNextScrollEvent
                    ? (this.skipNextScrollEvent = !1)
                    : ((this.scrollDelta = e.scrollDelta),
                      (this.scrollTop = e.pageOffsetY),
                      this.update());
                },
              },
              {
                key: "update",
                value: function () {
                  if (
                    !this.props.enabled ||
                    this.state.bottomBoundary - this.state.topBoundary <=
                      this.state.height ||
                    (0 === this.state.width && 0 === this.state.height)
                  )
                    this.state.status !== re.STATUS_ORIGINAL && this.reset();
                  else {
                    var e = this.scrollDelta,
                      t = this.scrollTop + this.state.top,
                      n = this.scrollTop + this.state.bottom,
                      o = ne.a.getInstance().getDimension().innerHeight;
                    if (t <= this.state.topBoundary) this.reset();
                    else if (n >= this.state.bottomBoundary)
                      (this.stickyBottom = this.state.bottomBoundary),
                        (this.stickyTop =
                          this.stickyBottom - this.state.height),
                        this.release(this.stickyTop);
                    else if (this.state.height > o - this.state.top) {
                      var a = !0,
                        r = this.state.pos,
                        i = this.state.height;
                      switch (this.state.status) {
                        case re.STATUS_ORIGINAL:
                          this.release(this.state.y),
                            (this.stickyTop = this.state.y),
                            (this.stickyBottom =
                              this.stickyTop + this.state.height);
                        case re.STATUS_RELEASED:
                          (this.stickyBottom =
                            this.stickyTop + this.state.height),
                            e > 0 && n > this.stickyBottom
                              ? this.fix(this.state.bottom - this.state.height)
                              : e < 0 &&
                                t < this.stickyTop &&
                                this.fix(this.state.top);
                          break;
                        case re.STATUS_FIXED:
                          if (e > 0 && r === this.state.top)
                            (this.stickyTop = t - e),
                              (this.stickyBottom = this.stickyTop + i);
                          else if (e < 0 && r === this.state.bottom - i)
                            (this.stickyBottom = n - e),
                              (this.stickyTop = this.stickyBottom - i);
                          else if (
                            r !== this.state.bottom - i &&
                            r !== this.state.top
                          ) {
                            var l = r + i - this.state.bottom;
                            (this.stickyBottom = n - e + l),
                              (this.stickyTop = this.stickyBottom - i);
                          } else a = !1;
                          a && this.release(this.stickyTop);
                      }
                    } else this.fix(this.state.top);
                  }
                },
              },
              {
                key: "componentDidUpdate",
                value: function (e, t) {
                  var n = this;
                  t.status !== this.state.status &&
                    this.props.onStateChange &&
                    this.props.onStateChange({ status: this.state.status }),
                    this.props.top !== t.top &&
                      (this.updateInitialDimension(), this.update()),
                    !te()(this.props, e) &&
                      (e.enabled !== this.props.enabled
                        ? this.props.enabled
                          ? this.setState({ activated: !0 }, function () {
                              n.updateInitialDimension(), n.update();
                            })
                          : this.setState({ activated: !1 }, function () {
                              n.reset();
                            })
                        : (e.top === this.props.top &&
                            e.bottomBoundary === this.props.bottomBoundary) ||
                          (this.updateInitialDimension(), this.update()));
                },
              },
              {
                key: "componentDidMount",
                value: function () {
                  (this.scrollTop =
                    document.body.scrollTop +
                    document.documentElement.scrollTop),
                    this.props.enabled &&
                      (this.setState({ activated: !0 }),
                      this.updateInitialDimension(),
                      this.update()),
                    ne.a
                      .getInstance()
                      .getDimension()
                      .addDimensionListener(this.dimensionListenerKey, {
                        onScrollStart: this.handleScrollStart,
                        onScroll: this.handleScroll,
                        onResize: this.handleResize,
                      });
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  ne.a
                    .getInstance()
                    .getDimension()
                    .removeDimensionListener(this.dimensionListenerKey);
                },
              },
              {
                key: "translate",
                value: function (e, t) {
                  this.state.activated
                    ? (e.transform = "translate3d(0,".concat(
                        Math.round(t),
                        "px,0)",
                      ))
                    : (e.top = "".concat(t, "px"));
                },
              },
              {
                key: "shouldComponentUpdate",
                value: function (e, t) {
                  return (
                    !this.props.shouldFreeze() &&
                    !(te()(this.props, e) && te()(this.state, t))
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = {
                      position:
                        this.state.status === re.STATUS_FIXED
                          ? "fixed"
                          : "relative",
                      top: this.state.status === re.STATUS_FIXED ? "0px" : "",
                      zIndex: Number(this.props.innerZ),
                    },
                    n = {};
                  this.translate(t, this.state.pos),
                    this.state.status !== re.STATUS_ORIGINAL &&
                      ((t.width = "".concat(this.state.width, "px")),
                      (n.height = "".concat(this.state.height, "px")));
                  var o = h()(
                      "sticky-outer-wrapper",
                      this.props.className,
                      Object(r.a)(
                        Object(r.a)(
                          {},
                          this.props.activeClass,
                          this.state.status === re.STATUS_FIXED,
                        ),
                        this.props.releasedClass,
                        this.state.status === re.STATUS_RELEASED,
                      ),
                    ),
                    a = h()(
                      "sticky-inner-wrapper",
                      this.props.innerClass,
                      Object(r.a)(
                        {},
                        this.props.innerActiveClass,
                        this.state.status === re.STATUS_FIXED,
                      ),
                    ),
                    i = this.props.children;
                  return oe(
                    "div",
                    {
                      ref: function (t) {
                        e.outerElement = t;
                      },
                      className: o,
                      style: n,
                    },
                    oe(
                      "div",
                      {
                        ref: function (t) {
                          e.innerElement = t;
                        },
                        className: a,
                        style: t,
                      },
                      "function" === typeof i
                        ? i({ status: this.state.status })
                        : i,
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(u.Component);
      ie.defaultProps = {
        shouldFreeze: function () {
          return !1;
        },
        enabled: !0,
        top: 0,
        bottomBoundary: 0,
        activeClass: "active",
        releasedClass: "released",
        onStateChange: null,
        className: "",
        innerClass: "",
        innerActiveClass: "",
        innerZ: 9100,
      };
      var le = ie,
        se = (n("oGC9"), d.a.createElement),
        ce = {
          "./style.css": {
            "nav-placeholder": "style__nav-placeholder___3afxR",
            "sub-nav-wrap": "style__sub-nav-wrap___1m88z",
            "sub-nav-collapsed": "style__sub-nav-collapsed___2D0Xo",
            "sub-nav-mask": "style__sub-nav-mask___3Tn2P",
            "angle-down": "style__angle-down___E5J4Y",
            "sub-nav": "style__sub-nav___2tLmj",
            "sub-nav-fingerpost": "style__sub-nav-fingerpost___2xggV",
            active: "style__active___1MU_0",
            "sub-nav-tab": "style__sub-nav-tab___1d_ik",
            "sub-nav-drop": "style__sub-nav-drop___2nrnB",
            "sub-nav-content": "style__sub-nav-content___2qtPa",
            "sub-nav-container": "style__sub-nav-container___1vn1w",
            flex: "style__flex___U7fc4",
            "sub-nav-right": "style__sub-nav-right___284bL",
            "product-title": "style__product-title___TDuJE",
            "sub-nav-toggle": "style__sub-nav-toggle___1Evlt",
            "sub-nav-toggle-btn": "style__sub-nav-toggle-btn___6-0-s",
            "sub-nav-dropdown": "style__sub-nav-dropdown___3O2KH",
            "type-b": "style__type-b___1Y7XM",
            "sub-nav-btn": "style__sub-nav-btn___2Zr1P",
            "sub-nav-buy-now": "style__sub-nav-buy-now___2PDWz",
            "sub-nav-display-none-mobile":
              "style__sub-nav-display-none-mobile___1KcLY",
          },
        };
      function _e(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ue = (function (e) {
        function t(e) {
          var n;
          return (
            Object(i.default)(this, t),
            (n = _e(this, t, [e])),
            Object(r.a)(Object(M.a)(n), "setStartPoint", function (e) {
              var t = e.target.href;
              e.preventDefault();
              var o = Math.round(n.tabBarItem.scrollLeft),
                a = ""
                  .concat(t)
                  .concat(-1 === t.indexOf("?") ? "?" : "&", "startPoint=")
                  .concat(o),
                r = Object(j.h)(a);
              window.open(a, r);
            }),
            Object(r.a)(Object(M.a)(n), "getStartPoint", function () {
              if (T.Q) {
                var e = new RegExp("(^|&)startPoint=([^&]*)(&|$)", "i"),
                  t = window.location.search.substr(1).match(e);
                if (null != t) return decodeURIComponent(t[2]);
              }
              return 0;
            }),
            (n.state = { pathname: "" }),
            (n.tabBar = d.a.createRef()),
            (n.tabBarItem = d.a.createRef()),
            (n.getCenter = n.getCenter.bind(Object(M.a)(n))),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                this.setState({ pathname: window.location.pathname });
              },
            },
            {
              key: "componentDidUpdate",
              value: function () {
                this.getCenter();
              },
            },
            {
              key: "getCenter",
              value: function () {
                var e = document.querySelector(
                  "#sub-nav-fingerpost-abtest > ul > li.active",
                );
                if (e) {
                  var t =
                      document.getElementsByClassName("page-wrapper")[0]
                        .clientWidth,
                    n = e.offsetLeft + e.offsetWidth / 2 - t / 2;
                  this.tabBarItem.scroll({ left: n, behavior: "smooth" }),
                    (this.tabBarItem.style.transform = "none");
                }
              },
            },
            {
              key: "render",
              value: function () {
                var e,
                  t,
                  n = this,
                  o = this.props,
                  a = o.productData,
                  r = o.localization,
                  i = o.t,
                  l = o.context,
                  s = o.gaSend,
                  c = l.subdomain,
                  _ = a.shopping_guides,
                  u = a.slug,
                  d = a.title,
                  p = a.sub_nav,
                  f = this.state.pathname;
                if (!u) return null;
                var m,
                  y,
                  b = u ? "mobile_".concat(u, "_detail") : "",
                  g =
                    null === _ || void 0 === _
                      ? void 0
                      : null === (e = _.product_list) || void 0 === e
                        ? void 0
                        : null === (t = e[0]) || void 0 === t
                          ? void 0
                          : t.primary_button,
                  w = null === g || void 0 === g ? void 0 : g.link_type,
                  x =
                    "store-path" !== w && "absolute-path" !== w && w
                      ? c
                      : "store",
                  k = "relative-path" === w ? "_self" : "_blank",
                  O = !1;
                (null === _ || void 0 === _ ? void 0 : _.show) &&
                (null === g || void 0 === g ? void 0 : g.link) &&
                (null === g || void 0 === g ? void 0 : g.title)
                  ? ((m = g.link), (y = g.title))
                  : a.buylink &&
                    ((m = a.buylink),
                    (y = i("v2.common.buy_now")),
                    (x = "store")),
                  m &&
                    ((m = Object(j.k)({
                      domain: x,
                      url: m,
                      country: r.country,
                      locale: r.language,
                      mobileMode: !0,
                    })),
                    (O = Object(j.j)(m)));
                var I = h()({ "sub-nav-wrap": !0 }),
                  S = /^http(s)?:\/\/(.*?)\//,
                  T = "www.dji.com";
                T = window.location.host;
                var M = Object(j.k)({
                    url: u,
                    country: r.country,
                    locale: r.language,
                    mobileMode: !0,
                    domain: c,
                  }),
                  P = "" !== f && M.endsWith(f) ? "active" : "",
                  E = this.getStartPoint(),
                  L =
                    "mini-3-pro" === u &&
                    "CN" === r.country &&
                    "zh-CN" === r.language;
                return se(
                  "div",
                  null,
                  se("div", {
                    id: "double-sub-nav",
                    className: "style__nav-placeholder___3afxR",
                  }),
                  se(
                    "div",
                    {
                      id: "sticky-nav",
                      className: v()(I, ce, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    se(
                      le,
                      { innerZ: "9100", enableTransforms: !1 },
                      se(
                        "nav",
                        { className: "style__sub-nav___2tLmj" },
                        se("div", {
                          className: "style__sub-nav-content___2qtPa",
                        }),
                        se(
                          "div",
                          { className: "style__sub-nav-tab___1d_ik" },
                          se(
                            "div",
                            { className: "style__sub-nav-container___1vn1w" },
                            se(
                              "div",
                              {
                                className:
                                  "product-subnav-title style__product-title___TDuJE",
                              },
                              se(
                                "a",
                                {
                                  href: Object(j.k)({
                                    url: u,
                                    country: r.country,
                                    locale: r.language,
                                    mobileMode: !0,
                                    domain: c,
                                  }),
                                  "data-ga-category": b,
                                  "data-ga-action": "click",
                                  "data-ga-label": "navbar_title",
                                },
                                d,
                              ),
                              L && se(q, { mobileMode: !0 }),
                            ),
                            m &&
                              se(
                                "div",
                                { className: "style__sub-nav-buy-now___2PDWz" },
                                se(
                                  "a",
                                  {
                                    href: m,
                                    className: "style__sub-nav-btn___2Zr1P",
                                    "data-ga-category": b,
                                    "data-ga-action": "click",
                                    "data-ga-label": "buy_now",
                                    target: k,
                                    "data-bd-track": Object(j.j)(m) ? 7 : 1,
                                  },
                                  y,
                                ),
                              ),
                          ),
                        ),
                        se(
                          "div",
                          {
                            id: "sub-nav-fingerpost-abtest",
                            className: "style__sub-nav-fingerpost___2xggV",
                            ref: function (e) {
                              n.tabBar = e;
                            },
                          },
                          se(
                            "ul",
                            {
                              ref: function (e) {
                                n.tabBarItem = e;
                              },
                              style: {
                                transform: "translateX(-".concat(E, "px)"),
                              },
                            },
                            se(
                              "li",
                              {
                                className:
                                  (P ? P + " " : "") +
                                  v()(P, ce, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              },
                              se("a", {
                                href: Object(j.k)({
                                  url: u,
                                  country: r.country,
                                  locale: r.language,
                                  mobileMode: !0,
                                  domain: c,
                                }),
                                "data-ga-category": b,
                                "data-ga-action": "click",
                                "data-ga-label": "navbar_title",
                                dangerouslySetInnerHTML: {
                                  __html: i("v2.common.overview"),
                                },
                                onClick: this.setStartPoint,
                              }),
                            ),
                            (null === p || void 0 === p ? void 0 : p.length) >
                              0 &&
                              p.map(function (e, t) {
                                var o =
                                    (null === e || void 0 === e
                                      ? void 0
                                      : e.hide_on_mobile) || !1,
                                  a = h()({ "sub-nav-display-none-mobile": o }),
                                  i = Object(j.k)({
                                    url: e.link,
                                    country: r.country,
                                    locale: r.language,
                                    mobileMode: !0,
                                    domain: c,
                                  }),
                                  l = "" !== f && i.endsWith(f) ? "active" : "";
                                return /(store\.dji\.com)/.test(e.link) &&
                                  -1 !== C.a.indexOf(r.country)
                                  ? se(
                                      "li",
                                      {
                                        key: "navitem_a_".concat(t),
                                        "data-key": "where-to-buy",
                                        className:
                                          (l ? l + " " : "") +
                                          v()("".concat(l, " ").concat(a), ce, {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          }),
                                      },
                                      se(
                                        "a",
                                        {
                                          href: Object(j.k)({
                                            url: "/where-to-buy",
                                            country: r.country,
                                            locale: r.language,
                                            mobileMode: !0,
                                            domain: "store",
                                          }),
                                          target:
                                            S.exec(e.link)[2] === T
                                              ? "_self"
                                              : "_blank",
                                          "data-ga-category": b,
                                          "data-ga-action": "click",
                                          "data-ga-label":
                                            e.ga_label ||
                                            "nav_button".concat(t),
                                          onClick: n.setStartPoint,
                                        },
                                        e.title,
                                      ),
                                    )
                                  : "anchor" === e.nav_type
                                    ? se(
                                        "li",
                                        {
                                          key: "navitem_a_".concat(t),
                                          "data-key": e.link,
                                          className:
                                            (l ? l + " " : "") +
                                            v()(
                                              "".concat(l, " ").concat(a),
                                              ce,
                                              {
                                                autoResolveMultipleImports: !0,
                                                handleMissingStyleName: "warn",
                                              },
                                            ),
                                        },
                                        se(
                                          "a",
                                          {
                                            href: e.link,
                                            target: Object(j.h)(e.link),
                                            "data-ga-category": b,
                                            "data-ga-action": "click",
                                            "data-ga-label":
                                              e.ga_label ||
                                              "nav_button".concat(t),
                                          },
                                          e.title,
                                        ),
                                      )
                                    : /^(https?:)?\/\//.test(e.link)
                                      ? se(
                                          "li",
                                          {
                                            key: "navitem_a_".concat(t),
                                            "data-key": e.link,
                                            className:
                                              (l ? l + " " : "") +
                                              v()(
                                                "".concat(l, " ").concat(a),
                                                ce,
                                                {
                                                  autoResolveMultipleImports:
                                                    !0,
                                                  handleMissingStyleName:
                                                    "warn",
                                                },
                                              ),
                                          },
                                          se(
                                            "a",
                                            {
                                              href: Object(j.k)({
                                                url: e.link,
                                                country: r.country,
                                                locale: r.language,
                                                mobileMode: !0,
                                              }),
                                              target:
                                                S.exec(e.link)[2] === T
                                                  ? "_self"
                                                  : "_blank",
                                              "data-ga-category": b,
                                              "data-ga-action": "click",
                                              "data-ga-label":
                                                e.ga_label ||
                                                "nav_button".concat(t),
                                              onClick: n.setStartPoint,
                                            },
                                            e.title,
                                          ),
                                        )
                                      : /(inspire-3\/samples$)/.test(e.link) &&
                                          n.props.mobileMode
                                        ? null
                                        : se(
                                            "li",
                                            {
                                              key: "navitem_a_".concat(t),
                                              "data-key": e.link,
                                              className:
                                                (l ? l + " " : "") +
                                                v()(
                                                  "".concat(l, " ").concat(a),
                                                  ce,
                                                  {
                                                    autoResolveMultipleImports:
                                                      !0,
                                                    handleMissingStyleName:
                                                      "warn",
                                                  },
                                                ),
                                            },
                                            se(
                                              "a",
                                              {
                                                href: Object(j.k)({
                                                  url: e.link,
                                                  country: r.country,
                                                  locale: r.language,
                                                  mobileMode: !0,
                                                  domain: c,
                                                }),
                                                target:
                                                  /(inspire-3\/premium-service$)/.test(
                                                    e.link,
                                                  )
                                                    ? "_blank"
                                                    : "_self",
                                                "data-ga-category": b,
                                                "data-ga-action": "click",
                                                "data-ga-label":
                                                  e.ga_label ||
                                                  "nav_button".concat(t),
                                                onClick: n.setStartPoint,
                                              },
                                              e.title,
                                            ),
                                          );
                              }),
                          ),
                        ),
                      ),
                      O &&
                        se(V, {
                          buyLink: m,
                          productData: a,
                          gaSend: s(b),
                          mobileMode: !0,
                          t: i,
                        }),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(d.a.Component);
      ue.defaultProps = { t: function () {}, productData: {} };
      var de = Object(O.a)(
          Object(I.b)(function (e) {
            return { context: e.context };
          })(ue),
        ),
        pe = n("XrJB"),
        fe = n.n(pe),
        he = (n("aiR1"), n("5tpG"), d.a.createElement),
        me = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "section-light": "style__section-light___DuWYU",
            title: "style__title___3kG2-",
            "horizontal-line": "style__horizontal-line___1s5kI",
            desc: "style__desc___3sB3X",
            "link-btn": "style__link-btn___3j-N5",
            "angle-right-icon": "style__angle-right-icon___16AJE",
            "tab-item": "style__tab-item___2DnLB",
            "tab-item-active": "style__tab-item-active___1uuRJ",
            "tab-content-item": "style__tab-content-item___3Na1e",
            "tab-slider": "style__tab-slider___2UsoW",
            "tab-bar": "style__tab-bar___1s0Os",
            "sample-tab-section-m": "style__sample-tab-section-m___2125X",
            "fa-spin": "style__fa-spin___ox4QL",
            "h1-title": "style__h1-title___332tl",
            "tabs-wrap": "style__tabs-wrap___3IO-a",
            tabs: "style__tabs___1LR0m",
            "tab-box": "style__tab-box___2zLwi",
            "tab-content": "style__tab-content___F48oS",
            "tab-content-box": "style__tab-content-box___3R-5Y",
            "tab-content-active": "style__tab-content-active___13anz",
            mask: "style__mask___dTzU-",
            "tab-desc-box": "style__tab-desc-box___ukU91",
            "carousel-box": "style__carousel-box___3vmOP",
            "text-box": "style__text-box___3tqQN",
            "main-title": "style__main-title___S2CKW",
            "sub-title": "style__sub-title___zco8a",
            "sample-description": "style__sample-description___2vW0R",
            "sample-specs": "style__sample-specs___BCNmz",
            "sample-specs-key": "style__sample-specs-key___2XFV5",
            "sample-specs-value": "style__sample-specs-value___14s6K",
            "dji-divider": "style__dji-divider___1ycDw",
            "sample-info": "style__sample-info___1aJHm",
            "sample-preview": "style__sample-preview___3dvw3",
            "sample-download-info": "style__sample-download-info___rR4SQ",
            icon: "style__icon___vR10M",
            "dji-btn": "style__dji-btn___3qtWz",
            "dji-btn-dark": "style__dji-btn-dark___1SGFM",
            sample_info: "style__sample_info___2cmtJ",
            "tab-pill": "style__tab-pill___1vXUE",
            "child-tab-item": "style__child-tab-item___18AaU",
            active: "style__active___8vHG7",
            loading: "style__loading___20SYB",
            "loading-icon": "style__loading-icon___2lBBn",
            "no-data": "style__no-data___Yq8eq",
            "content-wrapper": "style__content-wrapper___AVwxb",
            text: "style__text___z78VG",
            "opacity-animation": "style__opacity-animation___v_if0",
          },
        };
      function ye() {
        ye = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new M(o || []);
          return a(i, "_invoke", { value: S(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var g = {};
        c(g, i, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          x = w && w(w(P([])));
        x && x !== n && o.call(x, i) && (g = x);
        var k = (v.prototype = y.prototype = Object.create(g));
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function I(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function S(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = j(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function j(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                j(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function T(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function C(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function M(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(T, this),
            this.reset(!0);
        }
        function P(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(k, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(k)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          O(I.prototype),
          c(I.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = I),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new I(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          O(k),
          c(k, s, "Generator"),
          c(k, i, function () {
            return this;
          }),
          c(k, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = P),
          (M.prototype = {
            constructor: M,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(C),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), C(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    C(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: P(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      function be(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ve = (function (e) {
          function t(e) {
            var n;
            return (
              Object(i.default)(this, t),
              ((n = be(this, t, [e])).state = {
                currentData: e.sampleData.data[0],
                currentNav: e.sampleData.data[0].subtypes,
                currentSlug: e.sampleData.data[0].slug,
                currentChildSlug: e.sampleData.data[0].slug,
                loading: !0,
              }),
              (n.updateCurrentTabContent = n.updateCurrentTabContent.bind(
                Object(M.a)(n),
              )),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(l.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  this.activeTab && this.updateCurrentTabContent();
                },
              },
              {
                key: "componentDidUpdate",
                value: function (e) {
                  e.activeKey !== this.props.activeKey &&
                    this.updateCurrentTabContent();
                },
              },
              {
                key: "handleTabClick",
                value: function (e, t) {
                  var n = this.props.onTabClick;
                  n && n(e, t);
                  var o = document.querySelector("html");
                  o && o.scrollIntoView({ behavior: "smooth" });
                },
              },
              {
                key: "updateCurrentTabContent",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.sampleData,
                    o = t.activeKey;
                  n.data &&
                    Array.isArray(n.data) &&
                    n.data.map(function (t) {
                      if (o === t.slug) {
                        var n = t;
                        e.setState({
                          currentData: n.samples,
                          currentNav: n.subtypes,
                          currentSlug: n.slug,
                          currentChildSlug: n.slug,
                        }),
                          e.state.loading && e.setState({ loading: !1 });
                      }
                    });
                },
              },
              {
                key: "handleChildTabClick",
                value: (function () {
                  var e = Object(y.default)(
                    ye().mark(function e(t) {
                      var n, o, a, r, i, l, s, c, _;
                      return ye().wrap(
                        function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                for (
                                  n = this.props,
                                    n.localization,
                                    n.productData.slug,
                                    o = n.sampleData,
                                    a = this.state.currentSlug,
                                    r = [],
                                    i = o.data,
                                    l = {},
                                    s = 0;
                                  s < i.length;
                                  s += 1
                                )
                                  a === i[s].slug && (l = i[s]);
                                if (((c = l.samples), t !== a)) {
                                  e.next = 10;
                                  break;
                                }
                                return (
                                  this.setState({
                                    currentData: c,
                                    currentChildSlug: t,
                                  }),
                                  e.abrupt("return")
                                );
                              case 10:
                                for (_ = 0; _ < c.length; _ += 1)
                                  t === c[_].sample_type_slug && r.push(c[_]);
                                this.setState({
                                  currentData: r,
                                  currentChildSlug: t,
                                });
                              case 12:
                              case "end":
                                return e.stop();
                            }
                        },
                        e,
                        this,
                      );
                    }),
                  );
                  return function (t) {
                    return e.apply(this, arguments);
                  };
                })(),
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.sampleData,
                    o = t.activeKey,
                    a = t.t,
                    r = this.state,
                    i = r.currentData,
                    l = r.currentNav,
                    s = r.currentSlug,
                    c = r.currentChildSlug,
                    _ = r.loading,
                    u = h()({ "tab-content-item": !0 });
                  return he(
                    "div",
                    {
                      className:
                        "style__sample-tab-section-m___2125X style__section-light___DuWYU",
                      ref: function (t) {
                        return (e.section = t);
                      },
                    },
                    he("h1", {
                      className: "style__h1-title___332tl",
                      dangerouslySetInnerHTML: {
                        __html: a("v4.sample.main.title"),
                      },
                    }),
                    he(
                      "div",
                      { className: "style__tabs-wrap___3IO-a" },
                      he(
                        "div",
                        { className: "style__tabs___1LR0m" },
                        he(
                          "div",
                          { className: "style__tab-box___2zLwi" },
                          he(
                            "div",
                            {
                              className: "style__tab-bar___1s0Os",
                              ref: function (t) {
                                e.tabBar = t;
                              },
                            },
                            he("div", {
                              className: "style__tab-slider___2UsoW",
                            }),
                            n.data && Array.isArray(n.data)
                              ? n.data.map(function (t, n) {
                                  var a = h()({
                                    "tab-item": !0,
                                    "tab-item-active": o === t.slug,
                                  });
                                  return he("div", {
                                    ref: function (n) {
                                      o === t.slug && (e.activeTab = n);
                                    },
                                    onClick: e.handleTabClick.bind(
                                      e,
                                      t.slug,
                                      n,
                                    ),
                                    key: t.title,
                                    dangerouslySetInnerHTML: {
                                      __html: t.title,
                                    },
                                    className: v()(a, me, {
                                      autoResolveMultipleImports: !0,
                                      handleMissingStyleName: "warn",
                                    }),
                                  });
                                })
                              : null,
                          ),
                        ),
                      ),
                    ),
                    he(
                      "div",
                      { className: "style__tab-content___F48oS" },
                      he(
                        "div",
                        {
                          className: v()(u, me, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                        },
                        o === s && l.length > 0
                          ? he(
                              "div",
                              { className: "style__tab-pill___1vXUE" },
                              he("div", {
                                onClick: this.handleChildTabClick.bind(this, s),
                                dangerouslySetInnerHTML: {
                                  __html: a("v4.sample.child_name.all"),
                                },
                                className: v()(
                                  "child-tab-item ".concat(
                                    c === s ? "active" : "",
                                  ),
                                  me,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                              }),
                              l &&
                                l.map(function (t) {
                                  return he(
                                    "div",
                                    {
                                      onClick: e.handleChildTabClick.bind(
                                        e,
                                        t.slug,
                                      ),
                                      className: v()(
                                        "child-tab-item ".concat(
                                          c === t.slug ? "active" : "",
                                        ),
                                        me,
                                        {
                                          autoResolveMultipleImports: !0,
                                          handleMissingStyleName: "warn",
                                        },
                                      ),
                                    },
                                    t.title,
                                  );
                                }),
                            )
                          : null,
                        i && i.length > 0
                          ? i.map(function (e, t) {
                              return he(
                                d.a.Fragment,
                                null,
                                he(
                                  "div",
                                  {
                                    className: v()("tab-content-box ", me, {
                                      autoResolveMultipleImports: !0,
                                      handleMissingStyleName: "warn",
                                    }),
                                  },
                                  he(
                                    "div",
                                    {
                                      className:
                                        "style__sample-preview___3dvw3",
                                    },
                                    he("img", { src: e.cover }),
                                  ),
                                  he(
                                    "div",
                                    { className: "style__sample-info___1aJHm" },
                                    "" !== e.title
                                      ? he("h2", {
                                          className:
                                            "style__main-title___S2CKW",
                                          dangerouslySetInnerHTML: {
                                            __html: e.title,
                                          },
                                        })
                                      : null,
                                    "" !== e.subtitle
                                      ? he("h3", {
                                          className: "style__sub-title___zco8a",
                                          dangerouslySetInnerHTML: {
                                            __html: e.subtitle,
                                          },
                                        })
                                      : null,
                                    "" !== e.description
                                      ? he("p", {
                                          className:
                                            "style__sample-description___2vW0R",
                                          dangerouslySetInnerHTML: {
                                            __html: e.description,
                                          },
                                        })
                                      : null,
                                    he(
                                      "ul",
                                      {
                                        className:
                                          "style__sample-specs___BCNmz",
                                      },
                                      e.specifications &&
                                        e.specifications.map(function (e) {
                                          return he(
                                            "li",
                                            null,
                                            he("p", {
                                              className:
                                                "style__sample-specs-key___2XFV5",
                                              dangerouslySetInnerHTML: {
                                                __html: e.key,
                                              },
                                            }),
                                            he("p", {
                                              className:
                                                "style__sample-specs-value___14s6K",
                                              dangerouslySetInnerHTML: {
                                                __html: e.value,
                                              },
                                            }),
                                          );
                                        }),
                                    ),
                                    he(
                                      "div",
                                      {
                                        className:
                                          "style__sample-download-info___rR4SQ",
                                      },
                                      he(
                                        "a",
                                        {
                                          className:
                                            "style__dji-btn___3qtWz style__dji-btn-dark___1SGFM",
                                          href: e.button.link,
                                        },
                                        he(fe.a, {
                                          name: "download-o",
                                          className: "style__icon___vR10M",
                                        }),
                                        he("span", {
                                          dangerouslySetInnerHTML: {
                                            __html: e.button.title,
                                          },
                                        }),
                                      ),
                                      he(
                                        "p",
                                        {
                                          className:
                                            "style__sample_info___2cmtJ",
                                        },
                                        he("span", {
                                          dangerouslySetInnerHTML: {
                                            __html: e.button.description,
                                          },
                                        }),
                                      ),
                                    ),
                                  ),
                                  t === i.length - 1
                                    ? null
                                    : he("div", {
                                        className: "style__dji-divider___1ycDw",
                                      }),
                                ),
                              );
                            })
                          : null,
                        _ || 0 !== i.length
                          ? null
                          : he(
                              "div",
                              { className: "style__no-data___Yq8eq" },
                              he("div", { className: "style__icon___vR10M" }),
                              he("p", {
                                className: "style__text___z78VG",
                                dangerouslySetInnerHTML: {
                                  __html: a("v4.sample.no-data.title"),
                                },
                              }),
                            ),
                        _
                          ? he(
                              "div",
                              { className: "style__loading___20SYB" },
                              he(fe.a, {
                                name: "loading-alt-light",
                                className: "style__loading-icon___2lBBn",
                              }),
                            )
                          : null,
                      ),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(d.a.PureComponent),
        ge = Object(O.a)(ve),
        we = d.a.createElement;
      function xe(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ke = (function (e) {
        function t(e) {
          var n;
          Object(i.default)(this, t), (n = xe(this, t, [e]));
          var o = e.sampleData.data;
          return (
            (n.state = { activeKey: o && o[0].slug }),
            (n.handleTabClick = n.handleTabClick.bind(Object(M.a)(n))),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "handleTabClick",
              value: function (e, t) {
                this.setState({ activeKey: e });
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.props,
                  t = e.sampleData,
                  n = e.localization,
                  o = e.productData,
                  a = e.t,
                  r = this.state.activeKey;
                return we(
                  "section",
                  null,
                  we(ge, {
                    t: a,
                    productData: o,
                    sampleData: t,
                    activeKey: r,
                    onTabClick: this.handleTabClick,
                    localization: n,
                  }),
                );
              },
            },
          ]),
          t
        );
      })(d.a.PureComponent);
      Object(r.a)(ke, "defaultProps", { t: function () {}, productData: {} });
      var Oe = Object(O.a)(ke),
        Ie = (n("Upok"), d.a.createElement),
        Se = {
          "./tab.css": {
            "tab-bar-out-wrapper": "tab__tab-bar-out-wrapper___3_Vhg",
            "tab-bar-wrapper": "tab__tab-bar-wrapper___3QL_W",
            "tab-bar-nav-box": "tab__tab-bar-nav-box___35mcF",
            "tab-bar-nav": "tab__tab-bar-nav___3Yu3Z",
            "tab-bar-items": "tab__tab-bar-items___2OxSW",
            "tab-bar-item-line": "tab__tab-bar-item-line___2E9vU",
            "tab-bar-item": "tab__tab-bar-item___1xnyp",
            active: "tab__active___2YY4g",
            "tab-bar-item-content": "tab__tab-bar-item-content___R8JyK",
            "tab-content-wrapper": "tab__tab-content-wrapper___1q5Vj",
            "tab-content": "tab__tab-content___3dlKz",
            "sample-list-box": "tab__sample-list-box___2kpJs",
            "sample-list-inner-box": "tab__sample-list-inner-box___8gr2v",
            "sub-type-list": "tab__sub-type-list___15XFl",
            "sub-type-item": "tab__sub-type-item___2eqef",
            "sample-item": "tab__sample-item___XNv9X",
            "left-sec": "tab__left-sec___20aHQ",
            "right-sec": "tab__right-sec___2HV3j",
            "main-title": "tab__main-title___2QyPs",
            "sub-title": "tab__sub-title___3FjVd",
            desc: "tab__desc___jLJpT",
            "spec-list-box-margin-top": "tab__spec-list-box-margin-top___3R4b0",
            "spec-list-box": "tab__spec-list-box___10vOA",
            "spec-item-margin-bottom": "tab__spec-item-margin-bottom___3Raf4",
            "spec-item": "tab__spec-item___34gA0",
            key: "tab__key___bSUC1",
            value: "tab__value___37vgB",
            "download-box": "tab__download-box___1LhiB",
            "download-box-margin-top": "tab__download-box-margin-top___leY8u",
            btn: "tab__btn___2JzKz",
            "btn-desc": "tab__btn-desc___3etZz",
            divider: "tab__divider___3himh",
            "empty-mask": "tab__empty-mask___2Ftu0",
            "empty-icon": "tab__empty-icon___uBD8R",
            text: "tab__text___3my1N",
          },
        };
      function je(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var Te = (function (e) {
        function t(e) {
          var n;
          return (
            Object(i.default)(this, t),
            ((n = je(this, t, [e])).state = {}),
            (n.tabDom = []),
            (n.tabBar = d.a.createRef()),
            (n.activeTab = d.a.createRef()),
            (n.tabBarItem = d.a.createRef()),
            (n.handleTabClick = n.handleTabClick.bind(Object(M.a)(n))),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                (0, this.props.childRef)(this);
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                (0, this.props.childRef)(void 0);
              },
            },
            {
              key: "handleTabClick",
              value: function (e) {
                var t = this.props.onTabClick;
                t && t(e);
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.activeKey,
                  o = t.tabContentList;
                return Ie(
                  "div",
                  { className: "tab__tab-bar-out-wrapper___3_Vhg" },
                  Ie(
                    "div",
                    { className: "tab__tab-bar-wrapper___3QL_W" },
                    Ie(
                      "div",
                      {
                        className: "tab__tab-bar-nav-box___35mcF",
                        ref: function (t) {
                          e.tabBar = t;
                        },
                      },
                      o &&
                        o.length > 0 &&
                        Ie(
                          "div",
                          { className: "tab__tab-bar-nav___3Yu3Z" },
                          Ie(
                            "div",
                            {
                              className: "tab__tab-bar-items___2OxSW",
                              ref: function (t) {
                                e.tabBarItem = t;
                              },
                            },
                            o.map(function (t, o) {
                              return Ie(
                                "div",
                                {
                                  key: o,
                                  onClick: function () {
                                    e.handleTabClick(o);
                                  },
                                  ref: function (t) {
                                    (e.tabDom[o] = t),
                                      n === o && (e.activeTab = t);
                                  },
                                  className: v()(
                                    "tab-bar-item ".concat(
                                      n === o ? "active" : "",
                                    ),
                                    Se,
                                    {
                                      autoResolveMultipleImports: !0,
                                      handleMissingStyleName: "warn",
                                    },
                                  ),
                                },
                                Ie(
                                  "div",
                                  {
                                    className:
                                      "tab__tab-bar-item-content___R8JyK",
                                  },
                                  t.title,
                                ),
                              );
                            }),
                          ),
                        ),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(d.a.PureComponent);
      Object(r.a)(Te, "defaultProps", {
        t: function (e) {
          return "".concat(e);
        },
        component_data: {},
      });
      var Ce = Object(O.a)(Te),
        Me = d.a.createElement,
        Pe = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./tab.css": {
            "tab-bar-out-wrapper": "tab__tab-bar-out-wrapper___3_Vhg",
            "tab-bar-wrapper": "tab__tab-bar-wrapper___3QL_W",
            "tab-bar-nav-box": "tab__tab-bar-nav-box___35mcF",
            "tab-bar-nav": "tab__tab-bar-nav___3Yu3Z",
            "tab-bar-items": "tab__tab-bar-items___2OxSW",
            "tab-bar-item-line": "tab__tab-bar-item-line___2E9vU",
            "tab-bar-item": "tab__tab-bar-item___1xnyp",
            active: "tab__active___2YY4g",
            "tab-bar-item-content": "tab__tab-bar-item-content___R8JyK",
            "tab-content-wrapper": "tab__tab-content-wrapper___1q5Vj",
            "tab-content": "tab__tab-content___3dlKz",
            "sample-list-box": "tab__sample-list-box___2kpJs",
            "sample-list-inner-box": "tab__sample-list-inner-box___8gr2v",
            "sub-type-list": "tab__sub-type-list___15XFl",
            "sub-type-item": "tab__sub-type-item___2eqef",
            "sample-item": "tab__sample-item___XNv9X",
            "left-sec": "tab__left-sec___20aHQ",
            "right-sec": "tab__right-sec___2HV3j",
            "main-title": "tab__main-title___2QyPs",
            "sub-title": "tab__sub-title___3FjVd",
            desc: "tab__desc___jLJpT",
            "spec-list-box-margin-top": "tab__spec-list-box-margin-top___3R4b0",
            "spec-list-box": "tab__spec-list-box___10vOA",
            "spec-item-margin-bottom": "tab__spec-item-margin-bottom___3Raf4",
            "spec-item": "tab__spec-item___34gA0",
            key: "tab__key___bSUC1",
            value: "tab__value___37vgB",
            "download-box": "tab__download-box___1LhiB",
            "download-box-margin-top": "tab__download-box-margin-top___leY8u",
            btn: "tab__btn___2JzKz",
            "btn-desc": "tab__btn-desc___3etZz",
            divider: "tab__divider___3himh",
            "empty-mask": "tab__empty-mask___2Ftu0",
            "empty-icon": "tab__empty-icon___uBD8R",
            text: "tab__text___3my1N",
          },
        };
      function Ee(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var Le = (function (e) {
        function t(e) {
          var n;
          return (
            Object(i.default)(this, t),
            ((n = Ee(this, t, [e])).state = { showTabContentList: [] }),
            (n.carouselCard = []),
            (n.subTypeList = []),
            (n.handleSelectSubType = n.handleSelectSubType.bind(
              Object(M.a)(n),
            )),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this.props,
                  t = e.childRef,
                  n = e.tabContentList;
                if ((t(this), n && n.length > 0)) {
                  var a = n.map(function (e) {
                    var t = e.samples,
                      n = e.slug,
                      a = e.subtypes,
                      r = e.title;
                    return {
                      samples: Object(o.a)(t),
                      slug: n,
                      subtypes: Object(o.a)(a),
                      title: r,
                      empty: !1,
                      activeSubTypeIndex: 0,
                    };
                  });
                  this.setState({ showTabContentList: a });
                }
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                (0, this.props.childRef)(void 0);
              },
            },
            {
              key: "handleSelectSubType",
              value: function (e, t) {
                var n = this.props,
                  a = n.activeKey,
                  r = n.tabContentList,
                  i = Object(o.a)(r),
                  l = this.state.showTabContentList,
                  s = Object(o.a)(l),
                  c = [];
                i[a] &&
                  i[a].samples &&
                  i[a] &&
                  i[a].samples.length > 0 &&
                  (c =
                    "all_samples" === e
                      ? i[a].samples
                      : i[a].samples.filter(function (t) {
                          return t.sample_type_slug === e;
                        })),
                  (s[a].activeSubTypeIndex = t),
                  (s[a].samples = c),
                  (s[a].empty = 0 === c.length),
                  this.setState({ showTabContentList: Object(o.a)(s) });
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.t,
                  o = t.activeKey,
                  a = this.state.showTabContentList;
                return Me(
                  "div",
                  { className: "tab__tab-content-wrapper___1q5Vj" },
                  a &&
                    a.length > 0 &&
                    Me(
                      "div",
                      null,
                      Me(
                        "div",
                        null,
                        a.map(function (t, a) {
                          return Me(
                            "div",
                            {
                              key: a,
                              ref: function (t) {
                                e.carouselCard[a] = t;
                              },
                              className: v()(
                                "sample-list-box ".concat(
                                  o === a ? "active" : "",
                                ),
                                Pe,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            o === a
                              ? Me(
                                  "div",
                                  null,
                                  t.subtypes && t.subtypes.length > 0
                                    ? Me(
                                        "div",
                                        {
                                          className:
                                            "tab__sub-type-list___15XFl",
                                        },
                                        Me(
                                          "div",
                                          {
                                            onClick: function () {
                                              return e.handleSelectSubType(
                                                "all_samples",
                                                0,
                                              );
                                            },
                                            className: v()(
                                              "sub-type-item ".concat(
                                                0 === t.activeSubTypeIndex
                                                  ? "active"
                                                  : "",
                                              ),
                                              Pe,
                                              {
                                                autoResolveMultipleImports: !0,
                                                handleMissingStyleName: "warn",
                                              },
                                            ),
                                          },
                                          n("v4.sample.child_name.all"),
                                        ),
                                        t.subtypes.map(function (n, o) {
                                          return Me(
                                            "div",
                                            {
                                              key: o,
                                              onClick: function () {
                                                return e.handleSelectSubType(
                                                  n.slug,
                                                  o + 1,
                                                );
                                              },
                                              className: v()(
                                                "sub-type-item ".concat(
                                                  t.activeSubTypeIndex === o + 1
                                                    ? "active"
                                                    : "",
                                                ),
                                                Pe,
                                                {
                                                  autoResolveMultipleImports:
                                                    !0,
                                                  handleMissingStyleName:
                                                    "warn",
                                                },
                                              ),
                                            },
                                            n.title,
                                          );
                                        }),
                                      )
                                    : null,
                                  t.empty
                                    ? null
                                    : Me(
                                        "div",
                                        null,
                                        t.samples &&
                                          t.samples.length > 0 &&
                                          t.samples.map(function (e, n) {
                                            return Me(
                                              "div",
                                              {
                                                className:
                                                  "tab__sample-list-inner-box___8gr2v",
                                                key: n,
                                              },
                                              Me(
                                                "div",
                                                {
                                                  className:
                                                    "tab__sample-item___XNv9X",
                                                },
                                                Me(
                                                  "div",
                                                  {
                                                    className:
                                                      "tab__left-sec___20aHQ",
                                                  },
                                                  Me("img", {
                                                    src: e.cover,
                                                    alt: "\u52a0\u8f7d\u4e2d",
                                                  }),
                                                ),
                                                Me(
                                                  "div",
                                                  {
                                                    className:
                                                      "tab__right-sec___2HV3j",
                                                  },
                                                  e.title
                                                    ? Me(
                                                        "p",
                                                        {
                                                          className:
                                                            "tab__main-title___2QyPs",
                                                        },
                                                        e.title,
                                                      )
                                                    : null,
                                                  e.subtitle && e.title
                                                    ? Me(
                                                        "p",
                                                        {
                                                          className:
                                                            "tab__sub-title___3FjVd",
                                                        },
                                                        e.subtitle,
                                                      )
                                                    : null,
                                                  e.description
                                                    ? Me(
                                                        "p",
                                                        {
                                                          className:
                                                            "tab__desc___jLJpT",
                                                        },
                                                        e.description,
                                                      )
                                                    : null,
                                                  Me(
                                                    "div",
                                                    {
                                                      className:
                                                        "tab__spec-list-box___10vOA tab__spec-list-box-margin-top___3R4b0",
                                                    },
                                                    e.specifications &&
                                                      e.specifications.length >
                                                        0 &&
                                                      e.specifications.map(
                                                        function (e, t) {
                                                          return Me(
                                                            "div",
                                                            {
                                                              className:
                                                                "tab__spec-item___34gA0",
                                                              key: t,
                                                            },
                                                            Me(
                                                              "span",
                                                              {
                                                                className:
                                                                  "tab__key___bSUC1",
                                                              },
                                                              e.key,
                                                            ),
                                                            Me(
                                                              "span",
                                                              {
                                                                className:
                                                                  "tab__value___37vgB",
                                                              },
                                                              e.value,
                                                            ),
                                                          );
                                                        },
                                                      ),
                                                  ),
                                                  Me(
                                                    "div",
                                                    {
                                                      className:
                                                        "tab__download-box___1LhiB",
                                                    },
                                                    "download" === e.button.type
                                                      ? Me(
                                                          "a",
                                                          {
                                                            className:
                                                              "tab__btn___2JzKz",
                                                            href: e.button.link,
                                                          },
                                                          Me(fe.a, {
                                                            name: "download-o",
                                                          }),
                                                          Me(
                                                            "span",
                                                            null,
                                                            e.button.title,
                                                          ),
                                                        )
                                                      : null,
                                                    Me(
                                                      "span",
                                                      {
                                                        className:
                                                          "tab__btn-desc___3etZz",
                                                      },
                                                      e.button.description,
                                                    ),
                                                  ),
                                                ),
                                              ),
                                              n !== t.samples.length - 1
                                                ? Me("div", {
                                                    className:
                                                      "tab__divider___3himh",
                                                  })
                                                : null,
                                            );
                                          }),
                                      ),
                                  t.empty
                                    ? Me(
                                        "div",
                                        {
                                          className: "tab__empty-mask___2Ftu0",
                                        },
                                        Me("span", {
                                          className: "tab__empty-icon___uBD8R",
                                        }),
                                        Me("p", {
                                          className: "tab__text___3my1N",
                                          dangerouslySetInnerHTML: {
                                            __html: n(
                                              "v4.sample.no-data.title",
                                            ),
                                          },
                                        }),
                                      )
                                    : null,
                                )
                              : null,
                          );
                        }),
                      ),
                    ),
                );
              },
            },
          ]),
          t
        );
      })(d.a.PureComponent);
      Le.defaultProps = {
        t: function (e) {
          return "".concat(e);
        },
      };
      var Be = Object(O.a)(Le),
        Ne = (n("tfAK"), d.a.createElement);
      function De(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ze = (function (e) {
        function t(e) {
          var n;
          return (
            Object(i.default)(this, t),
            ((n = De(this, t, [e])).state = { activeKey: 0, isIE: !1 }),
            (n.handleTabClick = n.handleTabClick.bind(Object(M.a)(n))),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                this.setState({ isIE: Object(T.h)() });
              },
            },
            {
              key: "handleTabClick",
              value: function (e) {
                var t = this.state.isIE;
                this.setState({ activeKey: e }),
                  t || window.scrollTo({ top: 0, behavior: "smooth" });
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.sampleData,
                  o = t.t,
                  a = t.productData,
                  r = n.data,
                  i = this.state.activeKey;
                return Ne(
                  "section",
                  { className: "style__product-sample-wrapper___2k80u" },
                  Ne(
                    "div",
                    {
                      className: "style__product-sample-inner-wrapper___SlMRm",
                    },
                    o("v4.sample.main.title") &&
                      "" !== o("v4.sample.main.title")
                      ? Ne(
                          "div",
                          { className: "style__sample-title___2_u67" },
                          o("v4.sample.main.title"),
                        )
                      : null,
                    Ne(Ce, {
                      tabContentList: r,
                      onTabClick: this.handleTabClick,
                      activeKey: i,
                      childRef: function (t) {
                        e.tabBar = t;
                      },
                    }),
                    Ne(Be, {
                      productData: a,
                      tabContentList: r,
                      activeKey: i,
                      childRef: function (t) {
                        e.tabContent = t;
                      },
                    }),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(d.a.PureComponent);
      Object(r.a)(ze, "defaultProps", { t: function () {}, productData: {} });
      var Ae = Object(O.a)(ze),
        Re = (n("2oKn"), d.a.createElement);
      function Fe(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var Ve = (function (e) {
        function t() {
          return Object(i.default)(this, t), Fe(this, t, arguments);
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "render",
              value: function () {
                var e = this.props,
                  t = e.mobileMode,
                  n = e.sampleData,
                  o = e.productData;
                return Re(t ? Oe : Ae, { sampleData: n, productData: o });
              },
            },
          ]),
          t
        );
      })(d.a.PureComponent);
      Object(r.a)(Ve, "defaultProps", { t: function () {}, productData: {} });
      var He = Object(O.a)(Ve),
        We = n("WCLa"),
        Ue = n("iLw5"),
        Ge = n.n(Ue);
      function Ye(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function qe(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Ye(Object(n), !0).forEach(function (t) {
                Object(r.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : Ye(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var Xe = n("D5mW"),
        Ze = Xe.SUPPORT_DATA_KEY_MAP,
        Ke = Xe.SUPPORT_CROSS_DATA_MAP,
        Qe = Xe.SUPPORT_TRANSFORM_DATA_MAP,
        Je = function (e, t) {
          return e && Array.isArray(t) && t.length ? Ge()(e, t) : e;
        },
        $e = function (e, t) {
          if (e) {
            var n = {},
              o = {},
              a = Ze[t];
            !!a ? ((o = e[a.slug]), (n = Je(o, a.dataKeys))) : (n = o = e[t]),
              (function (e, t, n) {
                var o = Qe[e];
                Array.isArray(o) &&
                  t &&
                  o.forEach(function (e) {
                    e &&
                      "function" === typeof e.transform &&
                      (t[e.dataKey] = e.transform(n));
                  });
              })(t, n, o);
            var i = (Ke[t] || []).reduce(function (t, n) {
              var o = n.slug,
                a = n.dataKeys,
                i = Je(e[o], a);
              return qe(qe({}, t), i ? Object(r.a)({}, o, i) : {});
            }, {});
            return n ? qe(Object(r.a)({}, t, n), i) : void 0;
          }
        },
        et = (n("XwSB"), n("VJv2")),
        tt = n("6AKW"),
        nt = d.a.createElement;
      function ot(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function at(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? ot(Object(n), !0).forEach(function (t) {
                Object(r.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : ot(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function rt(e, t, n) {
        return (
          (t = Object(c.a)(t)),
          Object(s.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(c.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var it = (function (e) {
        function t() {
          var e;
          return (
            Object(i.default)(this, t),
            ((e = rt(this, t)).V1toV0map = {}),
            (e.V1toV0doms = {}),
            (e.isV1relatedV0Hit = {}),
            e
          );
        }
        return (
          Object(_.a)(t, e),
          Object(l.default)(t, [
            {
              key: "getGaSend",
              value: function (e) {
                return function (t, n, o, a) {
                  e &&
                    t &&
                    n &&
                    p.a.event(
                      at({ category: o || e, action: t, label: n }, a || {}),
                    );
                };
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                et.a.getInstance().clearIdleTask();
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = Object(T.fb)(window.ABTest, {}),
                  n = t.pageVersion,
                  i = t.v0V1ExpId,
                  l = t.v0V1VarId,
                  s = this.props,
                  c = s.sections,
                  _ = s.components,
                  u = s.childern,
                  p = s.mobileMode,
                  f = s.productData,
                  m = s.pagePath,
                  y = s.newsMediaData,
                  b = s.newsMediaDetailData,
                  v = s.caseStudiesFilterData,
                  g = s.subdomainConfig,
                  w = s.sampleData,
                  x = s.ssrData,
                  k = s.isEdit,
                  O = void 0 !== k && k,
                  I = s.compatibilityData,
                  S = s.supportData,
                  j = s.eventAction,
                  C = s.omCompatibilityData,
                  M = s.ecologySideBarData,
                  P = s.ecologyDetailsData,
                  E = s.solutionDetailsData,
                  L = s.comparisonData,
                  B = s.guidesData,
                  N = s.isDesign,
                  D = void 0 !== N && N,
                  z = this.getGaSend,
                  A = c.map(function (t, s) {
                    var c;
                    if (!(t.slug && t.slug in _)) return null;
                    var u = _[t.slug],
                      d = t.data,
                      k = !1;
                    if (
                      "infoCardVertical" === t.slug ||
                      "mHeroVertical" === t.slug
                    ) {
                      var N = (d && d.component_data) || {},
                        A = N.needTiming,
                        R = N.onLineTimeSetting,
                        F = void 0 === R ? tt.f : R,
                        V = N.outLineTimeSetting,
                        H = void 0 === V ? tt.f : V,
                        W = new Date().getTime() / 1e3;
                      A &&
                        (W < Number(F) ? (k = !O) : W > Number(H) && (k = !O));
                    }
                    (d.component_data = d.component_data || void 0),
                      (d.componentId =
                        (null === (c = d.component_data) || void 0 === c
                          ? void 0
                          : c.componentId) || void 0);
                    var U = (d && d.component_data) || {},
                      G = U.component_version,
                      Y = U.related_v1_component_id,
                      q = U.related_exps_vars,
                      X = e.V1toV0doms[d.anchor_id] || e.V1toV0doms[d.id],
                      Z = Array.isArray(X) && X.length > 0,
                      K = "V0" === G && !!Y,
                      Q = K || Z,
                      J =
                        K &&
                        (q || [])
                          .filter(function (e) {
                            return e;
                          })
                          .find(function (e) {
                            var t = e.expId,
                              n = e.varId;
                            return i === t && l === n;
                          });
                    J && (e.isV1relatedV0Hit[Y] = !0);
                    var $ =
                        !!e.isV1relatedV0Hit[d.anchor_id] ||
                        !!e.isV1relatedV0Hit[d.id],
                      ee =
                        (K && !O && (n ? "V0" !== n : !J)) ||
                        (Z && !O && (n ? "V0" === n : $));
                    (d.isV0 = !!K),
                      (d.isV1 = !!Z),
                      (d.V0Dom = X || void 0),
                      (d.translation_data = d.translation_data || void 0),
                      (d.newsMediaData = y || void 0),
                      (d.newsMediaDetailData = b || void 0),
                      (d.caseStudiesFilterData = v || void 0),
                      (d.productData = f || void 0),
                      (d.subdomainConfig = g || void 0),
                      (d.sampleData = w || void 0),
                      (d.ssrData = x || void 0),
                      (d.isEdit = O),
                      (d.isDesign = D),
                      (d.compatibilityData = I || void 0),
                      (d.supportData = $e(S, t.slug)),
                      (d.eventAction = j || void 0),
                      (d.omCompatibilityData = C || void 0),
                      (d.ecologySideBarData = M || void 0),
                      (d.ecologyDetailsData = P || void 0),
                      (d.solutionDetailsData = E || void 0),
                      (d.comparisonData =
                        ("comparison" === t.slug && L) || void 0),
                      (d.guidesData = B || void 0);
                    var te = "".concat(m, "_").concat(d.anchor_id);
                    te = te.replace(/^\//, "");
                    var ne = h()({ "section-content": !0, "section-v0": K }),
                      oe = s < 2,
                      ae = s <= 2,
                      re = !1,
                      ie = (function (e, t) {
                        var n = !1;
                        "object" === typeof CSS &&
                          "function" === typeof CSS.supports &&
                          (n = CSS.supports("content-visibility", "auto"));
                        var o = [];
                        return (
                          t
                            ? (o.push(["idle"]),
                              o.push([
                                "visible",
                                function () {
                                  return { rootMargin: "3200px 1600px 1600px" };
                                },
                              ]))
                            : (o.push([
                                "visible",
                                function () {
                                  return {
                                    rootMargin: "999999px 1600px 1600px",
                                  };
                                },
                              ]),
                              o.push(
                                n
                                  ? ["stop-interact", 100 + 32 * e]
                                  : ["delay", 0],
                              )),
                          o
                        );
                      })(s, (re = 0 === window.scrollY)),
                      le = Object(We.a)({ on: ie })(u);
                    Object(T.T)(t.slug) && ((ae = !0), (oe = !0));
                    var se = nt(
                      le,
                      Object(a.a)(
                        {
                          forceHydration: ae,
                          visibleByDefault: oe,
                          mobileMode: p,
                          gaSend: z(te),
                          slug: t.slug,
                          key: d.id,
                          isV0V1Hide: ee && re,
                          hideCardComponent: k,
                          wrapperProps: at(
                            {
                              className: ne,
                              "data-ga-category": te,
                              "data-component": d.componentId,
                              id: d.anchor_id || d.id,
                            },
                            ee ? { style: { display: "none" } } : {},
                          ),
                          wrapperInitialProps: {
                            style: at(
                              {
                                display: "inherit",
                                contentVisibility: "auto",
                                containIntrinsicSize: "1px 800px",
                              },
                              Q ? { opacity: 1 } : {},
                            ),
                          },
                        },
                        d,
                      ),
                    );
                    if (K) {
                      var ce,
                        _e = d.anchor_id || d.id;
                      if (
                        !(null === (ce = e.V1toV0map[Y]) || void 0 === ce
                          ? void 0
                          : ce[_e])
                      ) {
                        var ue = nt(
                          le,
                          Object(a.a)(
                            {
                              forceHydration: ae,
                              visibleByDefault: oe,
                              mobileMode: p,
                              gaSend: z(te),
                              slug: t.slug,
                              key: "".concat(d.id, "_v1"),
                              isV0V1Hide: !1,
                              wrapperProps: {
                                className: ne,
                                "data-ga-category": te,
                                "data-component": d.componentId,
                                id: "".concat(d.id, "_v1"),
                                key: "".concat(d.id, "_v1"),
                              },
                              wrapperInitialProps: {
                                style: {
                                  display: "inherit",
                                  contentVisibility: "auto",
                                  containIntrinsicSize: "1px 800px",
                                },
                              },
                            },
                            d,
                          ),
                        );
                        (e.V1toV0map[Y] = at(
                          at({}, e.V1toV0map[Y] || {}),
                          {},
                          Object(r.a)({}, _e, !0),
                        )),
                          (e.V1toV0doms[Y] = [].concat(
                            Object(o.a)(e.V1toV0doms[Y] || []),
                            [ue],
                          ));
                      }
                    }
                    return se;
                  });
                return nt(
                  d.a.Fragment,
                  null,
                  nt(
                    "div",
                    { className: "sections-wrapper" },
                    Object(T.kb)(
                      f,
                      Object(T.kb)(
                        p,
                        nt(de, { productData: f, mobileMode: !0, gaSend: z }),
                        nt($, { productData: f, mobileMode: p, gaSend: z }),
                      ),
                      null,
                    ),
                    Object(T.kb)(
                      w,
                      nt(He, { sampleData: w, mobileMode: p, productData: f }),
                      null,
                    ),
                    A,
                    u,
                  ),
                );
              },
            },
          ]),
          t
        );
      })(d.a.PureComponent);
      it.defaultProps = {
        mobileMode: !1,
        newsMediaData: null,
        newsMediaDetailData: null,
        caseStudiesFilterData: null,
        subdomainConfig: null,
        localization: null,
        ssrData: null,
        ecologySideBarData: null,
        ecologyDetailsData: null,
        solutionDetailsData: null,
        comparisonData: null,
      };
      t.a = it;
    },
    "7gbh": function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o = (function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e)
          for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return (t.default = e), t;
      })(n("Aw7D"));
      t.default = function (e, t, n, a, r) {
        var i = "number" === typeof e.len,
          l = "number" === typeof e.min,
          s = "number" === typeof e.max,
          c = t,
          _ = null,
          u = "number" === typeof t,
          d = "string" === typeof t,
          p = Array.isArray(t);
        if ((u ? (_ = "number") : d ? (_ = "string") : p && (_ = "array"), !_))
          return !1;
        p && (c = t.length),
          d && (c = t.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "_").length),
          i
            ? c !== e.len &&
              a.push(o.format(r.messages[_].len, e.fullField, e.len))
            : l && !s && c < e.min
              ? a.push(o.format(r.messages[_].min, e.fullField, e.min))
              : s && !l && c > e.max
                ? a.push(o.format(r.messages[_].max, e.fullField, e.max))
                : l &&
                  s &&
                  (c < e.min || c > e.max) &&
                  a.push(
                    o.format(r.messages[_].range, e.fullField, e.min, e.max),
                  );
      };
    },
    "7v5W": function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("rePB"),
        c = n("q1tI"),
        _ = n.n(c),
        u = n("XnI8"),
        d = _.a.createElement;
      function p(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var f = (function (e) {
        function t() {
          return Object(o.default)(this, t), p(this, t, arguments);
        }
        return (
          Object(l.a)(t, e),
          Object(a.default)(t, [
            {
              key: "render",
              value: function () {
                var e = this.props.component_data;
                return ((e && e.customStyles) || []).map(function (e, t) {
                  return d("style", {
                    key: t,
                    dangerouslySetInnerHTML: { __html: e.customStyle },
                  });
                });
              },
            },
          ]),
          t
        );
      })(_.a.Component);
      Object(s.a)(f, "defaultProps", { component_data: {} }),
        Object(s.a)(f, "editSetting", {
          key: "hg703SetStyle",
          name: "hg703SetStyle",
          contentSetting: {
            styles: {
              label: "\u6837\u5f0f\u914d\u7f6e",
              props: {
                customStyles: {
                  type: "array",
                  label: "\u81ea\u5b9a\u4e49Style\u5217\u8868",
                  props: { customStyle: { label: "Style", type: "string" } },
                },
              },
            },
          },
          skinSetting: {},
        }),
        (t.a = Object(u.a)(f));
    },
    "7xG5": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return O;
      });
      var o = n("rePB"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("iKuz"),
        u = n.n(_),
        d = n("q1tI"),
        p = n.n(d),
        f = n("yWgo"),
        h = n("r7AC"),
        m = n("VJv2"),
        y = n("17x9"),
        b = n.n(y),
        v =
          (b.a.string,
          b.a.bool,
          b.a.number,
          b.a.object,
          b.a.array,
          b.a.func,
          n("Dyh2"),
          p.a.createElement);
      function g(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function w(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? g(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : g(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var x = {
        "./style.css": {
          "frame-container": "style__frame-container___3KU0U",
          "backup-frames": "style__backup-frames___1-Pfn",
          show: "style__show___HkbVf",
        },
      };
      function k(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var O = (function (e) {
        function t(e) {
          var n;
          return (
            Object(a.default)(this, t),
            ((n = k(this, t, [e])).state = {
              isSafari: !1,
              currentProgress: 0,
              hitBackup: 0,
            }),
            (n.eachPer = Object(f.Ab)(1 / +n.props.totalCount, 3)),
            (n.doneChunkCount = 0),
            (n.imageList = []),
            (n.doneIndexMap = {}),
            (n.chunkStartMap = {}),
            (n.frameProgress = 0),
            (n.currentIndex = 0),
            (n.currentPercent = 0),
            (n.targetPercent = 0),
            (n.backupKeyFrames = (e.backupKeyFrames || []).map(function (t) {
              return {
                index: t.index || 0,
                breakpoint:
                  t.breakpoint || ((+t.index || 0) + 1) / (e.totalCount || 1),
              };
            })),
            (n.chunkCount = Number(e.chunkCount) || 0),
            (n.hasLoaded = !1),
            (n.loadFirstFrameChunk = n.loadFirstFrameChunk.bind(
              Object(s.a)(n),
            )),
            (n.loadMoreFrameChunk = n.loadMoreFrameChunk.bind(Object(s.a)(n))),
            (n.startLoad = n.startLoad.bind(Object(s.a)(n))),
            (n.startLoadFrames = n.startLoadFrames.bind(Object(s.a)(n))),
            (n.checkIfResourceLoaded = n.checkIfResourceLoaded.bind(
              Object(s.a)(n),
            )),
            (n.getImgUrlByIndex = n.getImgUrlByIndex.bind(Object(s.a)(n))),
            (n.calcTargetFrameIndex = n.calcTargetFrameIndex.bind(
              Object(s.a)(n),
            )),
            (n.updatePercentbyProgress = n.updatePercentbyProgress.bind(
              Object(s.a)(n),
            )),
            (n.lerpPercent = n.lerpPercent.bind(Object(s.a)(n))),
            (n.updateCanvas = n.updateCanvas.bind(Object(s.a)(n))),
            (n.getImgIndexByPercent = n.getImgIndexByPercent.bind(
              Object(s.a)(n),
            )),
            (n.setCurrentIndexWhenPending = n.setCurrentIndexWhenPending.bind(
              Object(s.a)(n),
            )),
            n
          );
        }
        return (
          Object(c.a)(t, e),
          Object(r.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e, t;
                null === (e = (t = this.props).getRef) ||
                  void 0 === e ||
                  e.call(t, this, this.props.name),
                  this.checkIfResourceLoaded(),
                  this.setState({ isSafari: Object(f.p)() });
              },
            },
            {
              key: "UNSAFE_componentWillReceiveProps",
              value: function (e) {
                e &&
                  e.canLoad !== this.props.canLoad &&
                  e.canLoad &&
                  this.startLoad(),
                  this.props.name ||
                    (e &&
                      e.currentProgress !== this.props.currentProgress &&
                      (this.updatePercentbyProgress(e.currentProgress),
                      (this.currentProgress = e.currentProgress)));
              },
            },
            {
              key: "checkIfResourceLoaded",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.lazyLoad,
                  o = t.canLoad,
                  a = t.lazyLoadThreshold;
                "boolean" !== typeof o &&
                  (!1 === n
                    ? this.startLoad()
                    : Object(h.b)({
                        elm: this.frameBox,
                        offset: +(a || 2e3),
                        callback: function (t) {
                          t.inView && e.startLoad();
                        },
                      }));
              },
            },
            {
              key: "startLoad",
              value: function () {
                var e = this;
                this.hasLoaded ||
                  ((this.hasLoaded = !0),
                  Object(f.pb)(function () {
                    setTimeout(function () {
                      e.startLoadFrames();
                    }, 10);
                  }));
              },
            },
            {
              key: "startLoadFrames",
              value: function () {
                this.startLoadPoster ||
                  ((this.startLoadPoster = !0),
                  !this.chunkCount || this.chunkCount <= 1
                    ? this.loadFrameByInterpolation()
                    : this.loadFirstFrameChunk());
              },
            },
            {
              key: "getImgUrlByIndex",
              value: function (e) {
                var t = this.props,
                  n = t.address,
                  o = void 0 === n ? "" : n,
                  a = t.format,
                  r = t.webpAddress,
                  i = t.webpOn;
                if (!o || !a) return "";
                if (!this.address) {
                  var l = Object(f.c)();
                  (this.address = (l && i ? r : o) || o),
                    (this.format = (l && i ? "webp" : a) || a);
                }
                return ""
                  .concat(this.address)
                  .concat(e.toString().padStart(3, '0'), ".")
                  .concat(this.format);
              },
            },
            {
              key: "loadFirstFrameChunk",
              value: function () {
                var e = this,
                  t = [],
                  n = [],
                  o = this.props.totalCount,
                  a = this.chunkCount;
                if (!this.startLoadFrame && +o) {
                  this.startLoadFrame = !0;
                  for (
                    var r = function () {
                        if (e.doneIndexMap[i]) return 1;
                        var o = new Image();
                        o.src = e.getImgUrlByIndex(i);
                        var a = new Promise(function (e, t) {
                          (o.onload = e), (o.onerror = t);
                        });
                        (e.imageList[i] = o), n.push(i), t.push(a);
                      },
                      i = 0;
                    i < +o;
                    i += a
                  )
                    r();
                  Promise.all(t)
                    .then(function () {
                      (e.doneChunkCount += 1),
                        n.forEach(function (t) {
                          e.doneIndexMap[t] = !0;
                        }),
                        (e.firstFrameLoaded = !0),
                        e.props.onFirstChunkLoaded &&
                          e.props.onFirstChunkLoaded(),
                        e.onLoadChunkFinish(),
                        2 === a
                          ? e.loadMoreFrameChunk(1)
                          : 4 === a
                            ? e.loadMoreFrameChunk(2)
                            : 8 === a && e.loadMoreFrameChunk(4);
                    })
                    .catch(function () {});
                }
              },
            },
            {
              key: "loadMoreFrameChunk",
              value: function () {
                var e = this,
                  t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : 1;
                if (!this.chunkStartMap[t]) {
                  this.chunkStartMap[t] = !0;
                  for (
                    var n = [],
                      o = this.props.totalCount,
                      a = this.chunkCount,
                      r = function (t) {
                        if (e.doneIndexMap[t]) return 1;
                        var o = new Image();
                        o.src = e.getImgUrlByIndex(t);
                        var a = new Promise(function (n, a) {
                          (o.onload = function () {
                            (e.doneIndexMap[t] = !0), n();
                          }),
                            (o.onerror = a);
                        });
                        (e.imageList[t] = o), n.push(a);
                      },
                      i = t;
                    i < +o;
                    i += a
                  )
                    r(i);
                  Promise.all(n)
                    .then(function () {
                      (e.doneChunkCount += 1),
                        e.onLoadChunkFinish(),
                        4 === a
                          ? 2 === e.doneChunkCount &&
                            (e.loadMoreFrameChunk(1), e.loadMoreFrameChunk(3))
                          : 8 === a &&
                            (2 === e.doneChunkCount &&
                              (e.loadMoreFrameChunk(2),
                              e.loadMoreFrameChunk(6)),
                            4 === e.doneChunkCount &&
                              (e.loadMoreFrameChunk(1),
                              e.loadMoreFrameChunk(3),
                              e.loadMoreFrameChunk(5),
                              e.loadMoreFrameChunk(7)));
                    })
                    .catch(function () {});
                }
              },
            },
            {
              key: "onLoadChunkFinish",
              value: function () {
                var e = this.props.allLoadedPlayed;
                this.doneChunkCount === this.chunkCount &&
                  ((this.allFrameLoaded = !0),
                  this.props.onAllChunkLoaded && this.props.onAllChunkLoaded()),
                  (!e || (this.allFrameLoaded && e)) &&
                    (this.updateCanvas(!0),
                    this.backUpBox &&
                      ((this.backUpBox.style.transition = "none"),
                      (this.backUpBox.style.opacity = 0)),
                    this.canvas && (this.canvas.style.opacity = 1));
              },
            },
            {
              key: "loadFrameByInterpolation",
              value: function () {
                var e = this,
                  t = this.props.totalCount;
                if (!this.startLoadFrame && +t) {
                  this.startLoadFrame = !0;
                  var n = Object(f.S)(0, Number(t) - 1, !0),
                    o = n.length;
                  (this.chunkCount = o), this.loadInterpolationChunk(n[0], 0);
                  for (
                    var a = function (t) {
                        m.a.getInstance().addIdleTask(function () {
                          e.loadInterpolationChunk(n[t], t);
                        });
                      },
                      r = 1;
                    r < o;
                    r++
                  )
                    a(r);
                }
              },
            },
            {
              key: "loadInterpolationChunk",
              value: function (e, t) {
                for (
                  var n = this,
                    o = e.length,
                    a = [],
                    r = function (t) {
                      var o = new Image();
                      o.src = n.getImgUrlByIndex(e[t]);
                      var r = new Promise(function (a, r) {
                        (o.onload = function () {
                          (n.doneIndexMap[e[t]] = !0),
                            (n.imageList[e[t]] = o),
                            a();
                        }),
                          (o.onerror = r);
                      });
                      a.push(r);
                    },
                    i = 0;
                  i < o;
                  i++
                )
                  r(i);
                Promise.all(a)
                  .then(function () {
                    (n.doneChunkCount += 1),
                      (n.firstFrameLoaded = !0),
                      n.props.onFirstChunkLoaded &&
                        0 === t &&
                        n.props.onFirstChunkLoaded(),
                      n.onLoadChunkFinish();
                  })
                  .catch(function (t) {
                    console.log(
                      "loadInterpolationChunk fail:"
                        .concat(t, ", chunkArr:")
                        .concat(e),
                    );
                  });
              },
            },
            {
              key: "getImgIndexByPercent",
              value: function (e) {
                var t = this.props.totalCount,
                  n = Math.ceil(e * (+t - 1));
                return this.calcTargetFrameIndex(n);
              },
            },
            {
              key: "updateCanvas",
              value: function (e) {
                var t = this.getImgIndexByPercent(this.currentPercent),
                  n = this.props,
                  o = n.frameNaturalWidth,
                  a = n.frameNaturalHeight;
                this.imageList[t] &&
                  (t !== this.currentIndex || e) &&
                  (Object(f.Eb)(this.imageList[t], this.canvas, +o, +a),
                  (this.currentIndex = t));
              },
            },
            {
              key: "updatePercentbyProgress",
              value: function (e) {
                var t = this;
                f.Q &&
                  ((this.targetPercent = e),
                  (this.targetIndex = this.getImgIndexByPercent(e)),
                  this.firstFrameLoaded || this.setCurrentIndexWhenPending(),
                  this.RAF ||
                    (this.RAF = window.requestAnimationFrame(this.lerpPercent)),
                  this.props.name &&
                    (!this.doneChunkCount ||
                      (this.props.allLoadedPlayed &&
                        this.doneChunkCount !== this.chunkCount)) &&
                    this.backupKeyFrames.forEach(function (n, o) {
                      var a = o > 0 ? t.backupKeyFrames[o - 1].breakpoint : 0,
                        r = n.breakpoint;
                      e >= a &&
                        e < r &&
                        t.state.hitBackup !== o &&
                        t.setState({ hitBackup: o, currentProgress: e });
                    }));
              },
            },
            {
              key: "lerpPercent",
              value: function () {
                var e = this.state.isSafari;
                (this.lerpEase =
                  this.lerpEase || (e ? 0.5 : this.props.lerpEase || 0.15)),
                  Math.abs(this.currentPercent - this.targetPercent) >
                  this.eachPer
                    ? ((this.currentPercent +=
                        (this.targetPercent - this.currentPercent) *
                        this.lerpEase),
                      this.updateCanvas(),
                      (this.RAF = window.requestAnimationFrame(
                        this.lerpPercent,
                      )))
                    : (this.RAF = null);
              },
            },
            {
              key: "calcTargetFrameIndex",
              value: function (e) {
                var t = this.chunkCount,
                  n = this.doneChunkCount,
                  o = this.doneIndexMap,
                  a = e % t;
                return this.allFrameLoaded || o[e]
                  ? e
                  : n >= 2
                    ? e - (e % 2)
                    : 1 === n
                      ? o[e - (e % 2)]
                        ? e - (e % 2)
                        : e - a
                      : void 0;
              },
            },
            {
              key: "setCurrentIndexWhenPending",
              value: function () {
                var e = this.currentProgress,
                  t = this.backupKeyFrames,
                  n = t.find(function (n, o) {
                    var a = o > 0 ? t[o - 1].breakpoint : 0;
                    return e >= a && e <= t[o].breakpoint;
                  });
                n && (this.currentIndex = n.index);
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.format,
                  o = t.frameNaturalWidth,
                  a = t.frameNaturalHeight,
                  r = t.canvasStyle,
                  i = t.containerStyle,
                  l = t.backupStyle,
                  s = this.state.currentProgress,
                  c = this.backupKeyFrames.length > 0;
                return v(
                  "div",
                  {
                    className: "style__frame-container___3KU0U",
                    style: i,
                    ref: function (t) {
                      e.frameBox = t;
                    },
                  },
                  v("canvas", {
                    style: r,
                    ref: function (t) {
                      e.canvas = t;
                    },
                    width: +o,
                    height: +a,
                  }),
                  v(
                    "div",
                    {
                      className: "style__backup-frames___1-Pfn",
                      ref: function (t) {
                        e.backUpBox = t;
                      },
                    },
                    v("div", {
                      style: w(
                        w({}, l),
                        {},
                        {
                          backgroundImage: "url(".concat(
                            this.getImgUrlByIndex(0),
                            ")",
                          ),
                        },
                      ),
                      className:
                        "bg-cover " +
                        u()(c ? "" : "show", x, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                    }),
                    this.backupKeyFrames.map(function (t, o) {
                      var a = o > 0 ? e.backupKeyFrames[o - 1].breakpoint : 0;
                      return v("div", {
                        key: o,
                        style: w(
                          w({}, l),
                          {},
                          {
                            backgroundImage: "url(".concat(
                              e.getImgUrlByIndex(+t.index, n),
                              ")",
                            ),
                          },
                        ),
                        className:
                          "bg-cover " +
                          u()(
                            s >= a && s <= e.backupKeyFrames[o].breakpoint
                              ? "show"
                              : "",
                            x,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                      });
                    }),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(p.a.Component);
      O.defaultProps = {
        currentProgress: 0,
        address: "",
        format: "",
        frameNaturalWidth: 0,
        frameNaturalHeight: 0,
        totalCount: 0,
        chunkCount: 4,
        webpOn: !1,
        webpAddress: "",
        backupKeyFrameIndexs: [0],
        canvasStyle: {},
        lazyload: !0,
        lazyLoadThreshold: 2e3,
        onFirstChunkLoaded: function () {},
        onAllChunkLoaded: function () {},
      };
    },
    "82gj": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      }),
        n.d(t, "b", function () {
          return o;
        });
      var o = function () {},
        a = function () {};
    },
    "88Gu": function (e, t) {
      var n = 800,
        o = 16,
        a = Date.now;
      e.exports = function (e) {
        var t = 0,
          r = 0;
        return function () {
          var i = a(),
            l = o - (i - r);
          if (((r = i), l > 0)) {
            if (++t >= n) return arguments[0];
          } else t = 0;
          return e.apply(void 0, arguments);
        };
      };
    },
    "8L3h": function (e, t, n) {
      "use strict";
      e.exports = n("f/k9");
    },
    "8PcY": function (e, t, n) {
      "use strict";
      (t.__esModule = !0),
        (t.getChildMapping = a),
        (t.mergeChildMappings = r),
        (t.getInitialChildMapping = function (e, t) {
          return a(e.children, function (n) {
            return (0, o.cloneElement)(n, {
              onExited: t.bind(null, n),
              in: !0,
              appear: i(n, "appear", e),
              enter: i(n, "enter", e),
              exit: i(n, "exit", e),
            });
          });
        }),
        (t.getNextChildMapping = function (e, t, n) {
          var l = a(e.children),
            s = r(t, l);
          return (
            Object.keys(s).forEach(function (a) {
              var r = s[a];
              if ((0, o.isValidElement)(r)) {
                var c = a in t,
                  _ = a in l,
                  u = t[a],
                  d = (0, o.isValidElement)(u) && !u.props.in;
                !_ || (c && !d)
                  ? _ || !c || d
                    ? _ &&
                      c &&
                      (0, o.isValidElement)(u) &&
                      (s[a] = (0, o.cloneElement)(r, {
                        onExited: n.bind(null, r),
                        in: u.props.in,
                        exit: i(r, "exit", e),
                        enter: i(r, "enter", e),
                      }))
                    : (s[a] = (0, o.cloneElement)(r, { in: !1 }))
                  : (s[a] = (0, o.cloneElement)(r, {
                      onExited: n.bind(null, r),
                      in: !0,
                      exit: i(r, "exit", e),
                      enter: i(r, "enter", e),
                    }));
              }
            }),
            s
          );
        });
      var o = n("q1tI");
      function a(e, t) {
        var n = Object.create(null);
        return (
          e &&
            o.Children.map(e, function (e) {
              return e;
            }).forEach(function (e) {
              n[e.key] = (function (e) {
                return t && (0, o.isValidElement)(e) ? t(e) : e;
              })(e);
            }),
          n
        );
      }
      function r(e, t) {
        function n(n) {
          return n in t ? t[n] : e[n];
        }
        (e = e || {}), (t = t || {});
        var o,
          a = Object.create(null),
          r = [];
        for (var i in e)
          i in t ? r.length && ((a[i] = r), (r = [])) : r.push(i);
        var l = {};
        for (var s in t) {
          if (a[s])
            for (o = 0; o < a[s].length; o++) {
              var c = a[s][o];
              l[a[s][o]] = n(c);
            }
          l[s] = n(s);
        }
        for (o = 0; o < r.length; o++) l[r[o]] = n(r[o]);
        return l;
      }
      function i(e, t, n) {
        return null != n[t] ? n[t] : e.props[t];
      }
    },
    "8mTr": function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("rePB"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("XnI8"),
        m = n("xqva"),
        y = n("Ndxo"),
        b = n("bTu8"),
        v = n("Xchd"),
        g = n("0Xqd"),
        w = n("g0Ox"),
        x = n("r7AC"),
        k = n("TSYQ"),
        O = n.n(k),
        I = n("yWgo"),
        S = n("S5C5"),
        j = n("ub/+"),
        T = n("6AKW"),
        C = n("3vbH"),
        M = n("cKzW"),
        P = (n("Uy/O"), f.a.createElement),
        E = {
          "./style.css": {
            "wm330-section-carousel-groups":
              "style__wm330-section-carousel-groups___2CsmD",
            "is-safari": "style__is-safari___b39ZQ",
            "swiper-slide": "style__swiper-slide___D3Hkr",
            "text-wrapper": "style__text-wrapper___A3aUT",
            "text-desc": "style__text-desc___mSjkD",
            "carousel-mask": "style__carousel-mask___188Nv",
            "safari-hardware-acceleration":
              "style__safari-hardware-acceleration___1KnC5",
            "carousel-poster": "style__carousel-poster___2QKRe",
            "carousel-image": "style__carousel-image___2xI-0",
            "section-content": "style__section-content___FnWH1",
            "control-wrapper": "style__control-wrapper___3p0I8",
            "control-wrapper-white": "style__control-wrapper-white___NeUJr",
            "swiper-pagination-bullet":
              "style__swiper-pagination-bullet___3a9Ww",
            "swiper-pagination-bullet-active":
              "style__swiper-pagination-bullet-active___IHgh7",
            "navigation-wrapper-new": "style__navigation-wrapper-new___1i-_3",
            "swiper-btn-prev": "style__swiper-btn-prev___2B4FK",
            "swiper-btn-next": "style__swiper-btn-next___1BTeV",
            "swiper-button-disabled": "style__swiper-button-disabled___2bbTt",
            "navigation-wrapper": "style__navigation-wrapper___3Xmrx",
            "pagination-wrapper": "style__pagination-wrapper___1vVrY",
            "image-carousel-hidden": "style__image-carousel-hidden___3NroP",
            "carousel-desc-wrapper": "style__carousel-desc-wrapper___lDFda",
            "carousel-desc-wrapper-no-pagination":
              "style__carousel-desc-wrapper-no-pagination___I1MSN",
            "carousel-desc-wrapper-margin-top":
              "style__carousel-desc-wrapper-margin-top___2NAQJ",
            "carousel-desc-wrapper-no-datamargin-top":
              "style__carousel-desc-wrapper-no-datamargin-top___2xAuF",
            "click-area": "style__click-area___1F_k4",
            "left-click-area": "style__left-click-area___u7KKU",
            "right-click-area": "style__right-click-area___3mFe8",
            "carousel-button-wrapper": "style__carousel-button-wrapper___13YG4",
            "carousel-button-wrapper-ctn":
              "style__carousel-button-wrapper-ctn___H8gRd",
            "carousel-button": "style__carousel-button___BIlYp",
            "carousel-button-container":
              "style__carousel-button-container___3dzaL",
            "carousel-button-inner": "style__carousel-button-inner___2q4tr",
            "carousel-button-video-play":
              "style__carousel-button-video-play___28lvo",
            "video-play-light": "style__video-play-light___3xwXv",
            "carousel-video-play": "style__carousel-video-play___1ZcaT",
            "video-play-dark": "style__video-play-dark___1ZfBb",
            "wm330-section-carousel-groups-m":
              "style__wm330-section-carousel-groups-m___3Vzbt",
            "carousel-item-desc": "style__carousel-item-desc___122B3",
            "carousel-item-detail": "style__carousel-item-detail___2LWyx",
            "carousel-item-title": "style__carousel-item-title___1Hxcn",
            "downgrade-video-mobile": "style__downgrade-video-mobile___2-ere",
            "downgrade-play-btn-mobile":
              "style__downgrade-play-btn-mobile___2hiht",
            "downgrade-pic-mobile": "style__downgrade-pic-mobile___1mwcu",
            "swiper-container": "style__swiper-container___bmsvc",
            "swiper-wrapper": "style__swiper-wrapper___1PGtW",
            "swiper-slide-active": "style__swiper-slide-active___1NmGE",
            "carousel-pagination-wm330":
              "style__carousel-pagination-wm330___3aYQK",
            "carousel-item-desc-text": "style__carousel-item-desc-text___3_RdC",
            active: "style__active___esstc",
            "carousel-item-desc-width":
              "style__carousel-item-desc-width___28K9h",
            pc: "style__pc___766ZQ",
          },
        },
        L = function (e) {
          var t,
            n = e.mobileMode,
            o = e.data;
          if (n)
            return P(
              "div",
              { className: "style__downgrade-video-mobile___2-ere" },
              P("img", {
                src: o.videoDowngradeBgMobile,
                alt: "",
                className: "style__downgrade-pic-mobile___1mwcu",
              }),
              P(
                M.a,
                {
                  link:
                    null === (t = o.videoDowngradeVideoUrlMobile) ||
                    void 0 === t
                      ? void 0
                      : t.path,
                  isMobile: !0,
                },
                P("div", {
                  className: "style__downgrade-play-btn-mobile___2hiht",
                }),
              ),
            );
        },
        B = function (e) {
          var t,
            n,
            o,
            a = e.cardWidth,
            r = e.cardHeight,
            i = e.maskBackground,
            l = e.maskBackOpacity,
            s = e.mobileMode,
            c = e.backgroundVideoLoop,
            _ = e.data,
            u = e.checkIsSafari;
          return P(
            "div",
            {
              className: "style__carousel-poster___2QKRe",
              style: { backgroundImage: "url(".concat(_.videoPoster, ")") },
            },
            P(
              C.a,
              {
                visibleplay: !1,
                replayWhenRevisible: !1,
                videoLazyLoadDistance: 2e3,
                lazyload: !0,
                lazyLoadThreshold: 2e3,
                downgradeDom: L({ mobileMode: s, data: _ }),
                style: {
                  width: !s && "".concat(a, "px"),
                  height: !s && "".concat(r, "px"),
                },
              },
              P(
                "video",
                {
                  width: "100%",
                  height: "100%",
                  muted: !0,
                  loop: c,
                  playsInline: !0,
                  "x5-playsinline": !0,
                },
                (null === (t = _.videoWebmUrl) || void 0 === t
                  ? void 0
                  : t.path) &&
                  P("source", {
                    type: "video/webm",
                    src:
                      null === (n = _.videoWebmUrl) || void 0 === n
                        ? void 0
                        : n.path,
                  }),
                P("source", {
                  type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                  src:
                    null === (o = _.videoUrl) || void 0 === o ? void 0 : o.path,
                }),
              ),
              P("div", {
                style: { backgroundColor: i, opacity: l },
                className: d()(
                  "carousel-mask ".concat(
                    u() && "safari-hardware-acceleration",
                  ),
                  E,
                  {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  },
                ),
              }),
            ),
          );
        },
        N = n("QH4r"),
        D = f.a.createElement,
        z = {
          "./style.css": {
            "wm330-section-carousel-groups":
              "style__wm330-section-carousel-groups___2CsmD",
            "is-safari": "style__is-safari___b39ZQ",
            "swiper-slide": "style__swiper-slide___D3Hkr",
            "text-wrapper": "style__text-wrapper___A3aUT",
            "text-desc": "style__text-desc___mSjkD",
            "carousel-mask": "style__carousel-mask___188Nv",
            "safari-hardware-acceleration":
              "style__safari-hardware-acceleration___1KnC5",
            "carousel-poster": "style__carousel-poster___2QKRe",
            "carousel-image": "style__carousel-image___2xI-0",
            "section-content": "style__section-content___FnWH1",
            "control-wrapper": "style__control-wrapper___3p0I8",
            "control-wrapper-white": "style__control-wrapper-white___NeUJr",
            "swiper-pagination-bullet":
              "style__swiper-pagination-bullet___3a9Ww",
            "swiper-pagination-bullet-active":
              "style__swiper-pagination-bullet-active___IHgh7",
            "navigation-wrapper-new": "style__navigation-wrapper-new___1i-_3",
            "swiper-btn-prev": "style__swiper-btn-prev___2B4FK",
            "swiper-btn-next": "style__swiper-btn-next___1BTeV",
            "swiper-button-disabled": "style__swiper-button-disabled___2bbTt",
            "navigation-wrapper": "style__navigation-wrapper___3Xmrx",
            "pagination-wrapper": "style__pagination-wrapper___1vVrY",
            "image-carousel-hidden": "style__image-carousel-hidden___3NroP",
            "carousel-desc-wrapper": "style__carousel-desc-wrapper___lDFda",
            "carousel-desc-wrapper-no-pagination":
              "style__carousel-desc-wrapper-no-pagination___I1MSN",
            "carousel-desc-wrapper-margin-top":
              "style__carousel-desc-wrapper-margin-top___2NAQJ",
            "carousel-desc-wrapper-no-datamargin-top":
              "style__carousel-desc-wrapper-no-datamargin-top___2xAuF",
            "click-area": "style__click-area___1F_k4",
            "left-click-area": "style__left-click-area___u7KKU",
            "right-click-area": "style__right-click-area___3mFe8",
            "carousel-button-wrapper": "style__carousel-button-wrapper___13YG4",
            "carousel-button-wrapper-ctn":
              "style__carousel-button-wrapper-ctn___H8gRd",
            "carousel-button": "style__carousel-button___BIlYp",
            "carousel-button-container":
              "style__carousel-button-container___3dzaL",
            "carousel-button-inner": "style__carousel-button-inner___2q4tr",
            "carousel-button-video-play":
              "style__carousel-button-video-play___28lvo",
            "video-play-light": "style__video-play-light___3xwXv",
            "carousel-video-play": "style__carousel-video-play___1ZcaT",
            "video-play-dark": "style__video-play-dark___1ZfBb",
            "wm330-section-carousel-groups-m":
              "style__wm330-section-carousel-groups-m___3Vzbt",
            "carousel-item-desc": "style__carousel-item-desc___122B3",
            "carousel-item-detail": "style__carousel-item-detail___2LWyx",
            "carousel-item-title": "style__carousel-item-title___1Hxcn",
            "downgrade-video-mobile": "style__downgrade-video-mobile___2-ere",
            "downgrade-play-btn-mobile":
              "style__downgrade-play-btn-mobile___2hiht",
            "downgrade-pic-mobile": "style__downgrade-pic-mobile___1mwcu",
            "swiper-container": "style__swiper-container___bmsvc",
            "swiper-wrapper": "style__swiper-wrapper___1PGtW",
            "swiper-slide-active": "style__swiper-slide-active___1NmGE",
            "carousel-pagination-wm330":
              "style__carousel-pagination-wm330___3aYQK",
            "carousel-item-desc-text": "style__carousel-item-desc-text___3_RdC",
            active: "style__active___esstc",
            "carousel-item-desc-width":
              "style__carousel-item-desc-width___28K9h",
            pc: "style__pc___766ZQ",
          },
        },
        A = function (e) {
          var t = e.buttonLinkNew,
            n = e.buttonText,
            o = e.buttonType,
            a = e.buttonMinWidth,
            r = e.atomButtonSize,
            i = e.atomButtonType,
            l = e.t,
            s = e.btnGaLabel;
          return D(
            "div",
            { className: "style__carousel-button___BIlYp" },
            D(
              "div",
              null,
              D(
                "div",
                {
                  style: { minWidth: a, display: "inline-flex" },
                  "data-ga-category": "ImageCarouselBtn",
                  "data-ga-action": "click",
                  "data-ga-label": l(s),
                  className: "style__carousel-button-container___3dzaL",
                },
                D(
                  N.c,
                  {
                    size: r,
                    href: t,
                    target: "external-button" === o ? "_blank" : "_self",
                    style: { borderRadius: "60px", width: "100%", minWidth: a },
                    type: i,
                  },
                  D("div", {
                    className: "style__carousel-button-inner___2q4tr",
                    dangerouslySetInnerHTML: { __html: l(n) || "" },
                  }),
                ),
              ),
            ),
          );
        },
        R = function (e) {
          var t = e.data,
            n = e.localization,
            o = e.t;
          if (!t.hasButton) return null;
          var a = t.buttonType,
            r = void 0 === a ? "button" : a,
            i = t.buttonColor,
            l = t.buttonLink,
            s = t.buttonText,
            c = void 0 === s ? "button" : s,
            _ = t.butto,
            u = t.buttonMinWidth,
            p = t.buttonSize,
            f = t.btnGaLabel,
            h = p ? N.a[p] : N.a.large,
            m = i ? N.b[i] : N.b["secondary-light"],
            y = {
              buttonType: r,
              buttonColor: i,
              buttonLinkNew: null === l || void 0 === l ? void 0 : l.path,
              buttonText: c,
              butto: _,
              buttonMinWidth: u,
              atomButtonSize: h,
              atomButtonType: m,
              localization: n,
              t: o,
              btnGaLabel: f,
            };
          switch (r) {
            case "button":
            case "external-button":
              return A(y);
            case "store-button":
              return (function (e) {
                var t = e.buttonLinkNew,
                  n = e.buttonText,
                  o = e.buttonType,
                  a = e.buttonMinWidth,
                  r = e.atomButtonSize,
                  i = e.atomButtonType,
                  l = e.t,
                  s = e.localization,
                  c = e.btnGaLabel;
                return D(
                  "div",
                  { className: "style__carousel-button___BIlYp" },
                  D(
                    "div",
                    null,
                    D(
                      "div",
                      {
                        style: { minWidth: a, display: "inline-flex" },
                        "data-ga-category": "ImageCarouselBtn",
                        "data-ga-action": "click",
                        "data-ga-label": l(c),
                      },
                      D(
                        N.c,
                        {
                          size: r,
                          href: Object(S.e)(
                            Object(S.k)({
                              url: "/where-to-buy",
                              country:
                                null === s || void 0 === s ? void 0 : s.country,
                              locale:
                                null === s || void 0 === s
                                  ? void 0
                                  : s.language,
                            }),
                            t,
                            null === s || void 0 === s ? void 0 : s.country,
                          ),
                          target: "store-button" === o ? "_blank" : "_self",
                          style: {
                            borderRadius: "60px",
                            width: "100%",
                            minWidth: a,
                          },
                          type: i,
                        },
                        D("div", {
                          className: "style__carousel-button-inner___2q4tr",
                          dangerouslySetInnerHTML: { __html: l(n) || "" },
                        }),
                      ),
                    ),
                  ),
                );
              })(y);
            case "video-play":
              return (function (e) {
                var t = e.buttonLinkNew,
                  n = e.buttonText,
                  o = e.buttonMinWidth,
                  a = e.atomButtonSize,
                  r = e.atomButtonType,
                  i = e.buttonColor,
                  l = void 0 === i ? "secondary-light" : i,
                  s = e.t,
                  c = e.btnGaLabel,
                  _ = "video-play-light";
                return (
                  "secondary-dark" === l && (_ = "video-play-dark"),
                  D(
                    "div",
                    { className: "style__carousel-button___BIlYp" },
                    D(
                      "div",
                      null,
                      D(
                        "div",
                        {
                          style: { minWidth: o, display: "inline-flex" },
                          "data-ga-category": "ImageCarouselBtn",
                          "data-ga-action": "click",
                          "data-ga-label": s(c),
                        },
                        D(
                          M.a,
                          { link: t, style: { width: "100%" } },
                          D(
                            N.c,
                            {
                              size: a,
                              style: { borderRadius: "60px", minWidth: o },
                              type: r,
                            },
                            D(
                              "div",
                              {
                                className: d()(
                                  "carousel-button-inner carousel-button-video-play ".concat(
                                    _,
                                  ),
                                  z,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                              },
                              D("span", {
                                dangerouslySetInnerHTML: { __html: s(n) || "" },
                              }),
                              D("div", {
                                className: "style__carousel-video-play___1ZcaT",
                              }),
                            ),
                          ),
                        ),
                      ),
                    ),
                  )
                );
              })(y);
            default:
              return A(y);
          }
        },
        F = (n("u+OR"), f.a.createElement);
      function V(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function H(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? V(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : V(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var W = {
        "./style.css": {
          "wm330-section-carousel-groups":
            "style__wm330-section-carousel-groups___2CsmD",
          "is-safari": "style__is-safari___b39ZQ",
          "swiper-slide": "style__swiper-slide___D3Hkr",
          "text-wrapper": "style__text-wrapper___A3aUT",
          "text-desc": "style__text-desc___mSjkD",
          "carousel-mask": "style__carousel-mask___188Nv",
          "safari-hardware-acceleration":
            "style__safari-hardware-acceleration___1KnC5",
          "carousel-poster": "style__carousel-poster___2QKRe",
          "carousel-image": "style__carousel-image___2xI-0",
          "section-content": "style__section-content___FnWH1",
          "control-wrapper": "style__control-wrapper___3p0I8",
          "control-wrapper-white": "style__control-wrapper-white___NeUJr",
          "swiper-pagination-bullet": "style__swiper-pagination-bullet___3a9Ww",
          "swiper-pagination-bullet-active":
            "style__swiper-pagination-bullet-active___IHgh7",
          "navigation-wrapper-new": "style__navigation-wrapper-new___1i-_3",
          "swiper-btn-prev": "style__swiper-btn-prev___2B4FK",
          "swiper-btn-next": "style__swiper-btn-next___1BTeV",
          "swiper-button-disabled": "style__swiper-button-disabled___2bbTt",
          "navigation-wrapper": "style__navigation-wrapper___3Xmrx",
          "pagination-wrapper": "style__pagination-wrapper___1vVrY",
          "image-carousel-hidden": "style__image-carousel-hidden___3NroP",
          "carousel-desc-wrapper": "style__carousel-desc-wrapper___lDFda",
          "carousel-desc-wrapper-no-pagination":
            "style__carousel-desc-wrapper-no-pagination___I1MSN",
          "carousel-desc-wrapper-margin-top":
            "style__carousel-desc-wrapper-margin-top___2NAQJ",
          "carousel-desc-wrapper-no-datamargin-top":
            "style__carousel-desc-wrapper-no-datamargin-top___2xAuF",
          "click-area": "style__click-area___1F_k4",
          "left-click-area": "style__left-click-area___u7KKU",
          "right-click-area": "style__right-click-area___3mFe8",
          "carousel-button-wrapper": "style__carousel-button-wrapper___13YG4",
          "carousel-button-wrapper-ctn":
            "style__carousel-button-wrapper-ctn___H8gRd",
          "carousel-button": "style__carousel-button___BIlYp",
          "carousel-button-container":
            "style__carousel-button-container___3dzaL",
          "carousel-button-inner": "style__carousel-button-inner___2q4tr",
          "carousel-button-video-play":
            "style__carousel-button-video-play___28lvo",
          "video-play-light": "style__video-play-light___3xwXv",
          "carousel-video-play": "style__carousel-video-play___1ZcaT",
          "video-play-dark": "style__video-play-dark___1ZfBb",
          "wm330-section-carousel-groups-m":
            "style__wm330-section-carousel-groups-m___3Vzbt",
          "carousel-item-desc": "style__carousel-item-desc___122B3",
          "carousel-item-detail": "style__carousel-item-detail___2LWyx",
          "carousel-item-title": "style__carousel-item-title___1Hxcn",
          "downgrade-video-mobile": "style__downgrade-video-mobile___2-ere",
          "downgrade-play-btn-mobile":
            "style__downgrade-play-btn-mobile___2hiht",
          "downgrade-pic-mobile": "style__downgrade-pic-mobile___1mwcu",
          "swiper-container": "style__swiper-container___bmsvc",
          "swiper-wrapper": "style__swiper-wrapper___1PGtW",
          "swiper-slide-active": "style__swiper-slide-active___1NmGE",
          "carousel-pagination-wm330":
            "style__carousel-pagination-wm330___3aYQK",
          "carousel-item-desc-text": "style__carousel-item-desc-text___3_RdC",
          active: "style__active___esstc",
          "carousel-item-desc-width": "style__carousel-item-desc-width___28K9h",
          pc: "style__pc___766ZQ",
        },
        "swiper/swiper-bundle.css": {
          "swiper-container": "swiper-bundle__swiper-container___39bF_",
          "swiper-container-vertical":
            "swiper-bundle__swiper-container-vertical___3vCGJ",
          "swiper-wrapper": "swiper-bundle__swiper-wrapper___ZWMgF",
          "swiper-container-android":
            "swiper-bundle__swiper-container-android___1MyNZ",
          "swiper-slide": "swiper-bundle__swiper-slide___8Gsar",
          "swiper-container-multirow":
            "swiper-bundle__swiper-container-multirow___2n9mE",
          "swiper-container-multirow-column":
            "swiper-bundle__swiper-container-multirow-column___3fSZU",
          "swiper-container-free-mode":
            "swiper-bundle__swiper-container-free-mode___2WNAc",
          "swiper-container-pointer-events":
            "swiper-bundle__swiper-container-pointer-events___3vhJU",
          "swiper-slide-invisible-blank":
            "swiper-bundle__swiper-slide-invisible-blank___2NmM3",
          "swiper-container-autoheight":
            "swiper-bundle__swiper-container-autoheight___1QksJ",
          "swiper-container-3d": "swiper-bundle__swiper-container-3d___1dyl4",
          "swiper-slide-shadow-left":
            "swiper-bundle__swiper-slide-shadow-left___QXvhD",
          "swiper-slide-shadow-right":
            "swiper-bundle__swiper-slide-shadow-right___1ABTx",
          "swiper-slide-shadow-top":
            "swiper-bundle__swiper-slide-shadow-top___NAm4n",
          "swiper-slide-shadow-bottom":
            "swiper-bundle__swiper-slide-shadow-bottom___hhtw-",
          "swiper-cube-shadow": "swiper-bundle__swiper-cube-shadow___1q0yg",
          "swiper-container-css-mode":
            "swiper-bundle__swiper-container-css-mode___2Ggh5",
          "swiper-container-horizontal":
            "swiper-bundle__swiper-container-horizontal___dhJst",
          "swiper-button-prev": "swiper-bundle__swiper-button-prev___9tf0s",
          "swiper-button-next": "swiper-bundle__swiper-button-next___24tMo",
          "swiper-button-disabled":
            "swiper-bundle__swiper-button-disabled___238VZ",
          "swiper-container-rtl": "swiper-bundle__swiper-container-rtl___3PLNO",
          "swiper-button-white": "swiper-bundle__swiper-button-white___2P-1w",
          "swiper-button-black": "swiper-bundle__swiper-button-black___8l7Fy",
          "swiper-button-lock": "swiper-bundle__swiper-button-lock___pyqDZ",
          "swiper-pagination": "swiper-bundle__swiper-pagination___KaQ2A",
          "swiper-pagination-hidden":
            "swiper-bundle__swiper-pagination-hidden___21eIE",
          "swiper-pagination-fraction":
            "swiper-bundle__swiper-pagination-fraction___O2YKq",
          "swiper-pagination-custom":
            "swiper-bundle__swiper-pagination-custom___2MTFA",
          "swiper-pagination-bullets":
            "swiper-bundle__swiper-pagination-bullets___hzCkD",
          "swiper-pagination-bullets-dynamic":
            "swiper-bundle__swiper-pagination-bullets-dynamic___1lM9E",
          "swiper-pagination-bullet":
            "swiper-bundle__swiper-pagination-bullet___mWOSF",
          "swiper-pagination-bullet-active":
            "swiper-bundle__swiper-pagination-bullet-active___rSki9",
          "swiper-pagination-bullet-active-main":
            "swiper-bundle__swiper-pagination-bullet-active-main___3X_R_",
          "swiper-pagination-bullet-active-prev":
            "swiper-bundle__swiper-pagination-bullet-active-prev___2bBAC",
          "swiper-pagination-bullet-active-prev-prev":
            "swiper-bundle__swiper-pagination-bullet-active-prev-prev___3GSWa",
          "swiper-pagination-bullet-active-next":
            "swiper-bundle__swiper-pagination-bullet-active-next___1SqJr",
          "swiper-pagination-bullet-active-next-next":
            "swiper-bundle__swiper-pagination-bullet-active-next-next___2E0o-",
          "swiper-pagination-clickable":
            "swiper-bundle__swiper-pagination-clickable___2J1-V",
          "swiper-pagination-progressbar":
            "swiper-bundle__swiper-pagination-progressbar___2r-Lq",
          "swiper-pagination-progressbar-fill":
            "swiper-bundle__swiper-pagination-progressbar-fill___TzWX7",
          "swiper-pagination-progressbar-opposite":
            "swiper-bundle__swiper-pagination-progressbar-opposite___1FROb",
          "swiper-pagination-white":
            "swiper-bundle__swiper-pagination-white___XQ2Sb",
          "swiper-pagination-black":
            "swiper-bundle__swiper-pagination-black___Xplfw",
          "swiper-pagination-lock":
            "swiper-bundle__swiper-pagination-lock___4Ga6_",
          "swiper-scrollbar": "swiper-bundle__swiper-scrollbar___WGjnD",
          "swiper-scrollbar-drag":
            "swiper-bundle__swiper-scrollbar-drag___17TS3",
          "swiper-scrollbar-cursor-drag":
            "swiper-bundle__swiper-scrollbar-cursor-drag___1lFjh",
          "swiper-scrollbar-lock":
            "swiper-bundle__swiper-scrollbar-lock___2BnJ4",
          "swiper-zoom-container":
            "swiper-bundle__swiper-zoom-container___1vIrI",
          "swiper-slide-zoomed": "swiper-bundle__swiper-slide-zoomed___3qjkR",
          "swiper-lazy-preloader":
            "swiper-bundle__swiper-lazy-preloader___xiGl0",
          "swiper-preloader-spin":
            "swiper-bundle__swiper-preloader-spin___3rpW1",
          "swiper-lazy-preloader-white":
            "swiper-bundle__swiper-lazy-preloader-white___1TLuV",
          "swiper-lazy-preloader-black":
            "swiper-bundle__swiper-lazy-preloader-black___2VjFs",
          "swiper-notification": "swiper-bundle__swiper-notification___2n2c8",
          "swiper-container-fade":
            "swiper-bundle__swiper-container-fade___3fJAX",
          "swiper-slide-active": "swiper-bundle__swiper-slide-active___1r2Sx",
          "swiper-container-cube":
            "swiper-bundle__swiper-container-cube___3UnxH",
          "swiper-slide-next": "swiper-bundle__swiper-slide-next___2GUY4",
          "swiper-slide-prev": "swiper-bundle__swiper-slide-prev___3cKi2",
          "swiper-container-flip":
            "swiper-bundle__swiper-container-flip___3cElE",
        },
      };
      function U(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      b.a.use([v.a, g.a, w.a]);
      var G = (function (e) {
        function t(e) {
          var n;
          return (
            Object(r.default)(this, t),
            ((n = U(this, t, [e])).state = {
              imgloaded: !1,
              windowWidth: 1920,
            }),
            (n.desc = []),
            (n.button = []),
            (n.prev = n.prev.bind(Object(c.a)(n))),
            (n.next = n.next.bind(Object(c.a)(n))),
            (n.swiperRef = f.a.createRef()),
            (n.throttleScrollListener = {}),
            (n.listenersToRemove = []),
            (n.loadFlag = !0),
            (n.realIndex = 0),
            (n.carouselList = []),
            (n.videoList = []),
            (n.setVideoStatus = n.setVideoStatus.bind(Object(c.a)(n))),
            (n.calcWindowWidth = n.calcWindowWidth.bind(Object(c.a)(n))),
            (n.videoCanLoad = !1),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(i.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.component_data,
                  o = t.eventAction,
                  a = n.backgroundVideoVisiblePlay;
                Object(x.b)({
                  elm: this.section,
                  offset: 1800,
                  callback: function (t) {
                    t.inView &&
                      e.loadFlag &&
                      (e.setState({ imgloaded: !0 }), (e.loadFlag = !1));
                  },
                }),
                  this.carousel &&
                    (Object(x.b)({
                      elm: this.carousel,
                      offset: 0,
                      callback: function (t) {
                        var n = t.inView;
                        return (
                          e.setVideoStatus(n, a), n && (e.videoCanLoad = !0), !0
                        );
                      },
                    }),
                    this.calcWindowWidth(),
                    null === o ||
                      void 0 === o ||
                      o.addCustomEventListener("resize", this.calcWindowWidth));
              },
            },
            {
              key: "componentDidUpdate",
              value: function () {
                this.swiperRef.current &&
                  this.swiperRef.current.swiper &&
                  this.swiperRef.current.swiper.update();
              },
            },
            {
              key: "prev",
              value: function () {
                this.cousel && this.cousel.slidePrev();
              },
            },
            {
              key: "next",
              value: function () {
                this.cousel && this.cousel.slideNext();
              },
            },
            {
              key: "calcWindowWidth",
              value: function () {
                if (I.Q) {
                  var e = window.innerWidth;
                  this.setState({ windowWidth: e });
                }
              },
            },
            {
              key: "setVideoStatus",
              value: function (e) {
                for (
                  var t =
                      arguments.length > 1 &&
                      void 0 !== arguments[1] &&
                      arguments[1],
                    n = 0;
                  n < this.carouselList.length;
                  n++
                ) {
                  if (void 0 === this.videoList[n] && this.carouselList[n]) {
                    var o = this.carouselList[n].querySelector("video");
                    this.videoList[n] = o;
                  }
                  var a = this.videoList[n];
                  a &&
                    (n !== this.realIndex || !e || (this.videoCanLoad && !t)
                      ? Object(I.jb)(a)
                      : a.play());
                }
              },
            },
            {
              key: "getImageLink",
              value: function () {
                var e =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : "button",
                  t = arguments.length > 1 ? arguments[1] : void 0,
                  n = arguments.length > 2 ? arguments[2] : void 0,
                  o = arguments.length > 3 ? arguments[3] : void 0,
                  a = null === t || void 0 === t ? void 0 : t.path,
                  r = {
                    url: void 0,
                    target: "external-button" === e ? "_blank" : "_self",
                  };
                if (!o || !a) return r;
                if (
                  ((r.url = a),
                  "video-play" === e && (r.url = void 0),
                  "store-button" === e)
                ) {
                  var i = Object(S.e)(
                    Object(S.k)({
                      url: "/where-to-buy",
                      country: null === n || void 0 === n ? void 0 : n.country,
                      locale: null === n || void 0 === n ? void 0 : n.language,
                    }),
                    a,
                    null === n || void 0 === n ? void 0 : n.country,
                  );
                  r = { url: i, target: "_blank" };
                }
                return r;
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.t,
                  a = t.component_data,
                  r = t.id,
                  i = t.mobileMode,
                  l = a.desc,
                  s = a.imgList,
                  c = a.padding,
                  _ = a.hasPagination,
                  u = void 0 === _ || _,
                  p = a.hasNavigation,
                  h = void 0 === p || p,
                  b = a.cardHeight,
                  v = a.navigationStyle,
                  g = a.backgroundVideoLoop,
                  w = void 0 === g || g,
                  x = a.backgroundVideoHoverPlay,
                  k = void 0 !== x && x,
                  S = a.maskBackground,
                  C = a.maskBackOpacity,
                  M = a.descFont,
                  P = a.mainTitleFont,
                  E = a.titleFont,
                  L = a.detailIntroFont,
                  N = a.paginationMargin,
                  D = a.cardAlign,
                  z = a.bgColor,
                  A = a.themeSelect,
                  V = a.hasMainTitle,
                  U = a.hasTitle,
                  G = void 0 === U || U,
                  Y = a.hasDetailIntro,
                  q = a.hasDesc,
                  X = a.cardWidth,
                  Z = this.state,
                  K = Z.imgloaded,
                  Q = Z.windowWidth;
                X || (X = T.i), Number(X) > T.i && (X = T.i);
                var J,
                  $,
                  ee,
                  te,
                  ne = function (e, t, n) {
                    return e ? Number(t) || "" : n;
                  },
                  oe = Q && Q > 1440,
                  ae = ne(
                    oe,
                    X,
                    ((J = X),
                    ($ = b),
                    (ee = 480),
                    (te = T.i),
                    Number((Number(J) / Number($)) * ee) || te),
                  ),
                  re = ne(oe, b, 480),
                  ie = (function (e) {
                    var t = e.cardWidth,
                      n = e.cardAlign,
                      o = e.isBigScreen,
                      a = e.smallWidth,
                      r = o ? 1200 : t > a ? t : a,
                      i = "".concat(Number(t) - r, "px"),
                      l = "".concat(r - Number(t), "px"),
                      s = "".concat(r, "px"),
                      c = "calc(((100vw - "
                        .concat(r, "px)/2) + (")
                        .concat(r, "px - ")
                        .concat(t, "px))"),
                      _ = "".concat(r - Number(t), "px"),
                      u = "calc((100vw - ".concat(r, "px) / 2)");
                    return (
                      "center" === n &&
                        ((i = "0px"),
                        (l = "0px"),
                        (s = "".concat(t, "px")),
                        (c = "calc((100vw - ".concat(t, "px) / 2)")),
                        (_ = "0px"),
                        (u = "calc((100vw - ".concat(t, "px) / 2)"))),
                      {
                        swiperContainerMarginLeft: i,
                        navigationMarginRight: l,
                        controlWrapperWidth: s,
                        rightClickAreaWidth: c,
                        leftClickAreaMarginLeft: _,
                        leftClickAreaWidth: u,
                      }
                    );
                  })({
                    cardWidth: ae,
                    cardAlign: D,
                    isBigScreen: oe,
                    smallWidth: 960,
                  }),
                  le = ie.swiperContainerMarginLeft,
                  se = ie.navigationMarginRight,
                  ce = ie.controlWrapperWidth,
                  _e = ie.rightClickAreaWidth,
                  ue = ie.leftClickAreaMarginLeft,
                  de = ie.leftClickAreaWidth,
                  pe = {
                    initialSlide: 0,
                    speed: 600,
                    spaceBetween: i ? 8 : 16,
                    slidesPerView: "auto",
                    centeredSlides: !0,
                    preventClicks: !1,
                    preventClicksPropagation: !1,
                    slideToClickedSlide: !1,
                    navigation: {
                      nextEl: ".swiper-btn-next".concat(r),
                      prevEl: ".swiper-btn-prev".concat(r),
                    },
                    pagination: {
                      el: ".carousel-pagination-wm330".concat(r),
                      clickable: !0,
                    },
                    onSwiper: function (t) {
                      e.cousel = t;
                    },
                    onSlideChange: function (t) {
                      var n = t.realIndex;
                      e.realIndex = n;
                      for (var o = 0; o < e.carouselList.length; o++) {
                        var a = e.videoList[o];
                        if (void 0 === e.videoList[o] && e.carouselList[o]) {
                          var r = e.carouselList[o].querySelector("video");
                          e.videoList[o] = r;
                        }
                        a && (o === n ? a.play() : Object(I.jb)(a));
                      }
                      for (var i = 0; i < e.desc.length; i += 1)
                        e.desc[i].classList.contains("active") &&
                          e.desc[i].classList.remove("active");
                      e.desc[n].classList.add("active");
                      for (var l = 0; l < e.button.length; l += 1)
                        e.button[l].classList.contains("active") &&
                          e.button[l].classList.remove("active");
                      e.button[n].classList.add("active"),
                        (e.nextClickArea || e.prevClickArea) &&
                          (n === s.length - 1
                            ? ((e.nextClickArea.style.cursor = "default"),
                              (e.prevClickArea.style.cursor = "pointer"))
                            : 0 === n
                              ? ((e.prevClickArea.style.cursor = "default"),
                                (e.nextClickArea.style.cursor = "pointer"))
                              : ((e.prevClickArea.style.cursor = "pointer"),
                                (e.nextClickArea.style.cursor = "pointer")));
                    },
                  },
                  fe = O()("navigation-wrapper", {
                    "navigation-wrapper-new": "solid" === v,
                  }),
                  he = {
                    mobileCarouselWrap: i
                      ? "wm330-section-carousel-groups-m"
                      : "",
                    pcSafariCarouselWrap:
                      !i && Object(I.p)() ? "is-safari" : "",
                  };
                return F(
                  "section",
                  {
                    style: {
                      paddingTop: c,
                      paddingBottom: c,
                      backgroundColor: z || "#000",
                    },
                    ref: function (t) {
                      e.section = t;
                    },
                    id: r,
                    className:
                      "wm330-section-carousel-groups ".concat(
                        he.mobileCarouselWrap,
                      ) +
                      " " +
                      d()(
                        "wm330-section-carousel-groups "
                          .concat(he.pcSafariCarouselWrap, " ")
                          .concat(he.mobileCarouselWrap, " ")
                          .concat(i ? "" : "pc"),
                        W,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                  },
                  F(
                    "div",
                    {
                      className: "style__text-wrapper___A3aUT",
                      style: {
                        width: (function (e, t, n, o) {
                          return e || t ? "" : n > o ? n : o;
                        })(i, oe, ae, 960),
                      },
                    },
                    "" !== l && q
                      ? F(j.e, {
                          tagType:
                            (null === M || void 0 === M
                              ? void 0
                              : M.labelType) || "p",
                          style: H(
                            {},
                            null === M || void 0 === M ? void 0 : M.style,
                          ),
                          className: "style__text-desc___mSjkD",
                          dangerouslySetInnerHTML: { __html: n(l) },
                        })
                      : null,
                  ),
                  F(
                    "div",
                    {
                      className: "style__section-content___FnWH1",
                      ref: function (t) {
                        e.carousel = t;
                      },
                    },
                    F(
                      m.a,
                      Object(o.a)({}, pe, {
                        ref: this.swiperRef,
                        style: { marginLeft: !i && le },
                      }),
                      Array.isArray(s) &&
                        s.map(function (t, o) {
                          var a = i ? t.imgUrlMobile : t.imgUrl,
                            l = t.media,
                            s = t.btnGaLabel,
                            c = t.buttonType,
                            _ = t.buttonLink,
                            u = t.hasButton,
                            d = e.getImageLink(c, _, e.props.localization, u);
                          return F(
                            y.a,
                            {
                              key: "".concat(r, "-wm330-carsoule").concat(o),
                              style: {
                                width: !i && "".concat(ae, "px"),
                                maxWidth: !i && "".concat(ae, "px"),
                                height: !i && "".concat(re, "px"),
                              },
                              onMouseEnter: function () {
                                e.realIndex === o &&
                                  k &&
                                  !i &&
                                  e.setVideoStatus(!0, !0);
                              },
                              onMouseLeave: function () {
                                e.realIndex === o &&
                                  k &&
                                  !i &&
                                  e.setVideoStatus(!0, !1);
                              },
                            },
                            F(
                              "div",
                              {
                                className: "style__carousel-image___2xI-0",
                                ref: function (t) {
                                  e.carouselList[o] = t;
                                },
                              },
                              F(
                                "a",
                                {
                                  style: { display: "contents" },
                                  "data-ga-category": "ImageCarouselBtn",
                                  "data-ga-action": "click",
                                  "data-ga-label": n(s),
                                  href: d.url,
                                  target: d.target,
                                },
                                a && "video" !== l
                                  ? K &&
                                      F(
                                        f.a.Fragment,
                                        null,
                                        F("img", {
                                          style: {
                                            width: !i && "".concat(ae, "px"),
                                            height: !i && "".concat(re, "px"),
                                          },
                                          alt: Object(I.w)(n(t.imgAlt)),
                                          src: K ? a : "/",
                                        }),
                                        F("div", {
                                          className:
                                            "style__carousel-mask___188Nv",
                                          style: {
                                            backgroundColor: S,
                                            opacity: C,
                                          },
                                        }),
                                      )
                                  : F(B, {
                                      data: t,
                                      cardWidth: ae,
                                      cardHeight: re,
                                      backgroundVideoLoop: w,
                                      maskBackground: S,
                                      maskBackOpacity: C,
                                      mobileMode: i,
                                      checkIsSafari: I.p,
                                    }),
                              ),
                            ),
                          );
                        }),
                      i
                        ? null
                        : F("div", {
                            ref: function (t) {
                              e.prevClickArea = t;
                            },
                            style: {
                              height: !i && "".concat(re, "px"),
                              marginLeft: !i && ue,
                              width: !i && de,
                            },
                            className:
                              "style__left-click-area___u7KKU style__click-area___1F_k4",
                            onClick: this.prev,
                            onDragEnd: this.prev,
                          }),
                      i
                        ? null
                        : F("div", {
                            ref: function (t) {
                              e.nextClickArea = t;
                            },
                            style: {
                              height: !i && "".concat(re, "px"),
                              width: !i && _e,
                            },
                            className:
                              "style__right-click-area___3mFe8 style__click-area___1F_k4",
                            onClick: this.next,
                            onDragEnd: this.next,
                          }),
                    ),
                    F(
                      "div",
                      {
                        style: { width: !i && ce, marginTop: N },
                        className: d()(
                          "control-wrapper ".concat(
                            "black" === A ? "control-wrapper-white" : "",
                          ),
                          W,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      Array.isArray(s) && s.length > 1
                        ? F("div", {
                            className:
                              "carousel-pagination-wm330".concat(
                                r,
                                " carousel-pagination-wm330",
                              ) +
                              " " +
                              d()(
                                "pagination-wrapper ".concat(
                                  u ? "" : "image-carousel-hidden",
                                ),
                                W,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                          })
                        : null,
                      Array.isArray(s) && s.length > 1
                        ? F(
                            "div",
                            {
                              style: { marginRight: !i && se },
                              className:
                                (fe ? fe + " " : "") +
                                d()(
                                  "".concat(
                                    h ? "" : "image-carousel-hidden",
                                    " navigation-wrapper",
                                  ),
                                  W,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                            },
                            F("div", {
                              className: "swiper-btn-prev".concat(
                                r,
                                " swiper-btn-prev",
                              ),
                            }),
                            F(
                              "div",
                              {
                                className: "swiper-btn-next".concat(
                                  r,
                                  " swiper-btn-next",
                                ),
                              },
                              " ",
                            ),
                          )
                        : null,
                    ),
                    F(
                      "div",
                      {
                        style: { width: !i && ce },
                        className:
                          "carousel-desc-wrapper ".concat(
                            !u && "carousel-desc-wrapper-no-pagination",
                          ) +
                          " " +
                          d()(
                            "carousel-desc-wrapper ".concat(
                              !u && "carousel-desc-wrapper-no-pagination",
                            ),
                            W,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                      },
                      Array.isArray(s) && s.length > 1 && Array.isArray(s)
                        ? s.map(function (t, o) {
                            var a = !t.mainTitle && !t.title && !t.detailIntro;
                            return F(
                              "div",
                              {
                                style: {
                                  width: !i && "".concat(ae - 68, "px"),
                                },
                                ref: function (t) {
                                  e.desc[o] = t;
                                },
                                className:
                                  "carousel-item-desc "
                                    .concat(
                                      u ? "" : "carousel-item-desc-width",
                                      " ",
                                    )
                                    .concat(0 === o ? "active" : "") +
                                  " " +
                                  d()(
                                    "".concat(
                                      a || u
                                        ? ""
                                        : "carousel-desc-wrapper-margin-top",
                                    ),
                                    W,
                                    {
                                      autoResolveMultipleImports: !0,
                                      handleMissingStyleName: "warn",
                                    },
                                  ),
                              },
                              "" !== t.mainTitle && V
                                ? F(j.e, {
                                    tagType:
                                      (null === P || void 0 === P
                                        ? void 0
                                        : P.labelType) || "p",
                                    style: H(
                                      {},
                                      null === P || void 0 === P
                                        ? void 0
                                        : P.style,
                                    ),
                                    className:
                                      "style__carousel-item-title___1Hxcn",
                                    dangerouslySetInnerHTML: {
                                      __html: n(t.mainTitle),
                                    },
                                  })
                                : null,
                              G &&
                                F(j.e, {
                                  tagType:
                                    (null === E || void 0 === E
                                      ? void 0
                                      : E.labelType) || "p",
                                  style: H(
                                    {},
                                    null === E || void 0 === E
                                      ? void 0
                                      : E.style,
                                  ),
                                  key: "".concat(r, "-carousel-desc").concat(o),
                                  className:
                                    "carousel-item-desc-text style__carousel-item-desc___122B3",
                                  dangerouslySetInnerHTML: {
                                    __html: n(t.title),
                                  },
                                }),
                              Y &&
                                F(j.e, {
                                  tagType:
                                    (null === L || void 0 === L
                                      ? void 0
                                      : L.labelType) || "p",
                                  style: H(
                                    {},
                                    null === L || void 0 === L
                                      ? void 0
                                      : L.style,
                                  ),
                                  key: ""
                                    .concat(r, "-carousel-detail")
                                    .concat(o),
                                  className:
                                    "style__carousel-item-detail___2LWyx",
                                  dangerouslySetInnerHTML: {
                                    __html: n(t.detailIntro),
                                  },
                                }),
                            );
                          })
                        : null,
                    ),
                    F(
                      "div",
                      {
                        style: { width: !i && ce },
                        className: "style__carousel-button-wrapper___13YG4",
                      },
                      null === s || void 0 === s
                        ? void 0
                        : s.map(function (t, o) {
                            return F(
                              "div",
                              {
                                ref: function (t) {
                                  e.button[o] = t;
                                },
                                className:
                                  "".concat(
                                    0 === o ? "active" : "",
                                    " carousel-button-wrapper-ctn",
                                  ) +
                                  " style__carousel-button-wrapper-ctn___H8gRd",
                              },
                              F(R, {
                                data: t,
                                localization: e.props.localization,
                                t: n,
                              }),
                            );
                          }),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(f.a.Component);
      (G.defaultProps = {
        t: function () {},
        component_data: {
          backgroundVideoVisiblePlay: !1,
          backgroundVideoLoop: !0,
          backgroundVideoHoverPlay: !1,
          maskBackOpacity: 0,
          hasPagination: !0,
          hasNavigation: !0,
          hasTitle: !0,
          desc: "\u63cf\u8ff0",
          navigationStyle: "hollow",
          padding: "64px",
          paginationMargin: "16px",
          bgColor: "#000",
          themeSelect: "white",
        },
      }),
        (G.propSettings = {
          key: "wm330ImageCarousel",
          name: "wm330ImageCarousel",
          contentSetting: {
            section: {
              label: "section \u914d\u7f6e",
              props: {
                desc: {
                  label: "\u63cf\u8ff0",
                  type: "string",
                  content: "text",
                },
                backgroundVideoLoop: {
                  label: "\u89c6\u9891\u5faa\u73af\u64ad\u653e",
                  type: "boolean",
                },
                backgroundVideoVisiblePlay: {
                  label:
                    "\u9875\u9762\u6eda\u52a8\u540e\u89e6\u53d1\u64ad\u653e",
                  type: "boolean",
                },
                backgroundVideoHoverPlay: {
                  label: "\u9f20\u6807hover\u64ad\u653e",
                  type: "boolean",
                },
                maskBackground: {
                  label: "\u56fe\u7247/\u89c6\u9891\u906e\u7f69\u8272\u53f7",
                  type: "string",
                },
                maskBackOpacity: {
                  label:
                    "\u56fe\u7247/\u89c6\u9891\u906e\u7f69\u4e0d\u900f\u660e\u5ea6 (0-1, \u9ed8\u8ba40)",
                  type: "string",
                },
                imgList: {
                  label: "\u56fe\u7247/\u89c6\u9891\u96c6\u5408",
                  type: "array",
                  props: {
                    media: {
                      label:
                        "\u914d\u7f6e\u7d20\u6750\u7c7b\u578b\uff08\u56fe\u7247/\u89c6\u9891\uff09",
                      type: "select",
                      items: [
                        { value: "", label: "\u8bf7\u9009\u62e9" },
                        { value: "picture", label: "\u56fe\u7247" },
                        { value: "video", label: "\u89c6\u9891" },
                      ],
                    },
                    imgUrl: {
                      type: "image",
                      label: "pc\u7aef\u8f6e\u64ad\u56fe\u7247",
                      controlBy: "media",
                      controlValue: "picture",
                    },
                    imgUrlMobile: {
                      type: "image",
                      label: "\u79fb\u52a8\u7aef\u8f6e\u64ad\u56fe\u914d\u7f6e",
                      controlBy: "media",
                      controlValue: "picture",
                    },
                    imgAlt: {
                      type: "string",
                      content: "text",
                      label: "\u56fe\u7247\u81ea\u5b9a\u4e49alt\u6587\u6848",
                      controlBy: "media",
                      controlValue: "picture",
                    },
                    videoPoster: {
                      label: "\u89c6\u9891\u5c01\u9762",
                      type: "image",
                      controlBy: "media",
                      controlValue: "video",
                    },
                    videoUrl: {
                      label: "\u89c6\u9891",
                      type: "string",
                      content: "url",
                      controlBy: "media",
                      controlValue: "video",
                    },
                    videoWebmUrl: {
                      label:
                        "\u89c6\u9891(webm\u683c\u5f0f,\u5f00\u53d1\u914d\u7f6e)",
                      type: "string",
                      content: "url",
                      controlBy: "media",
                      controlValue: "video",
                    },
                    videoDowngradeVideoUrlMobile: {
                      label:
                        "\u3010\u79fb\u52a8\u7aef\u964d\u7ea7\u3011\u89c6\u9891\u4e2d\u5fc3\u5730\u5740",
                      type: "string",
                      content: "url",
                      controlBy: "media",
                      controlValue: "video",
                    },
                    videoDowngradeBgMobile: {
                      label:
                        "\u3010\u79fb\u52a8\u7aef\u964d\u7ea7\u3011\u89c6\u9891\u964d\u7ea7\u5c01\u9762\u56fe",
                      type: "image",
                      controlBy: "media",
                      controlValue: "video",
                    },
                    hasButton: {
                      type: "boolean",
                      label: "\u662f\u5426\u914d\u7f6e\u6309\u94ae",
                    },
                    buttonType: {
                      label: "\u6309\u94ae\u7c7b\u578b",
                      type: "select",
                      controlBy: "hasButton",
                      controlValue: !0,
                      items: [
                        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                        {
                          label: "\u89c6\u9891\u64ad\u653e",
                          value: "video-play",
                        },
                      ],
                    },
                    buttonColor: {
                      label: "\u6309\u94ae\u989c\u8272",
                      type: "select",
                      controlBy: "hasButton",
                      controlValue: !0,
                      items: [
                        { label: "\u767d\u8272", value: "secondary-light" },
                        { label: "\u9ed1\u8272", value: "secondary-dark" },
                      ],
                    },
                    buttonLink: {
                      label: "\u6309\u94ae\u94fe\u63a5",
                      type: "string",
                      content: "url",
                      controlBy: "hasButton",
                      controlValue: !0,
                    },
                    buttonText: {
                      label: "\u6309\u94ae\u6587\u6848",
                      type: "string",
                      key: "second-text",
                      content: "text",
                      controlBy: "hasButton",
                      controlValue: !0,
                    },
                    btnGaLabel: {
                      label: "\u6309\u94ae\u57cb\u70b9ga-label",
                      type: "string",
                      content: "text",
                      controlBy: "hasButton",
                      controlValue: !0,
                    },
                    buttonMinWidth: {
                      label:
                        "\u6309\u94ae\u6700\u5c0f\u5bbd\u5ea6\uff08\u5355\u4f4dpx\uff09",
                      type: "string",
                      controlBy: "hasButton",
                      controlValue: !0,
                    },
                    buttonSize: {
                      label: "\u6309\u94ae\u6309\u94ae\u5c3a\u5bf8",
                      type: "select",
                      controlBy: "hasButton",
                      controlValue: !0,
                      items: [
                        { label: "xl(48)", value: "x-large" },
                        { label: "l(40)", value: "large" },
                        { label: "m(32)", value: "medium" },
                        { label: "s(24)", value: "small" },
                      ],
                    },
                    mainTitle: {
                      type: "string",
                      label: "\u4e3b\u6807\u9898\u914d\u7f6e",
                      content: "text",
                      controlBy: "media",
                      controlValue: "video",
                    },
                    title: {
                      type: "string",
                      label: "\u526f\u6807\u9898\u914d\u7f6e",
                      content: "text",
                      controlBy: "media",
                      controlValue: "video",
                    },
                    detailIntro: {
                      type: "string",
                      label: "\u8be6\u7ec6\u4ecb\u7ecd",
                      content: "text",
                      controlBy: "media",
                      controlValue: "video",
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            section: {
              label: "\u6837\u5f0f\u914d\u7f6e",
              props: {
                padding: {
                  label:
                    "\u5f53\u524d\u6a21\u5757\u7684\u4e0a\u4e0b\u5185\u95f4\u8ddd(\u9ed8\u8ba4\u662f\u4e0a\u4e0b64px)",
                  type: "string",
                },
                bgColor: {
                  label: "\u7ec4\u4ef6\u80cc\u666f\u8272\u914d\u7f6e",
                  type: "string",
                },
                themeSelect: {
                  label: "\u7ec4\u4ef6\u4e3b\u9898",
                  type: "select",
                  items: [
                    { label: "\u8bf7\u9009\u62e9", value: "" },
                    {
                      label:
                        "\u767d\u8272\uff08\u9700\u914d\u7f6e\u6df1\u8272\u80cc\u666f\uff09",
                      value: "white",
                    },
                    {
                      label:
                        "\u9ed1\u8272\uff08\u9700\u914d\u7f6e\u6d45\u8272\u80cc\u666f\uff09",
                      value: "black",
                    },
                  ],
                },
              },
            },
            pagination: {
              label: "\u6307\u793a\u5668",
              switch: "hasPagination",
              props: {
                paginationMargin: {
                  label:
                    "\u6307\u793a\u5668\u548c\u5361\u7247\u95f4\u8ddd\uff08px\uff09",
                  type: "string",
                },
              },
            },
            navigation: {
              label: "\u8f6e\u64ad\u6309\u94ae",
              switch: "hasNavigation",
              props: {
                navigationStyle: {
                  type: "select",
                  items: [
                    { label: "\u7a7a\u5fc3", value: "hollow" },
                    { label: "\u5b9e\u5fc3", value: "solid" },
                  ],
                },
              },
            },
            cardStructor: {
              label: "PC\u7aef\u5361\u7247\u7ed3\u6784",
              props: {
                cardWidth: {
                  label:
                    "\u5361\u7247\u5bbd\u5ea6\uff08\u6700\u59271200px\uff09",
                  type: "number",
                },
                cardHeight: {
                  label: "\u5361\u7247\u9ad8\u5ea6",
                  type: "number",
                },
                cardAlign: {
                  label: "\u5361\u7247\u5c45\u5de6/\u5c45\u4e2d",
                  type: "select",
                  items: [
                    { label: "\u8bf7\u9009\u62e9", value: "" },
                    { label: "\u5c45\u4e2d", value: "center" },
                    { label: "\u5c45\u5de6", value: "left" },
                  ],
                },
              },
            },
            fontStyle: {
              label: "\u5b57\u4f53\u914d\u7f6e",
              props: {
                hasDesc: {
                  type: "boolean",
                  label: "\u662f\u5426\u6709\u63cf\u8ff0",
                },
                hasMainTitle: {
                  type: "boolean",
                  label: "\u662f\u5426\u6709\u4e3b\u6807\u9898",
                },
                hasTitle: {
                  type: "boolean",
                  label: "\u662f\u5426\u6709\u526f\u6807\u9898",
                },
                hasDetailIntro: {
                  type: "boolean",
                  label: "\u662f\u5426\u6709\u8be6\u7ec6\u4ecb\u7ecd",
                },
                descFont: {
                  label: "\u63cf\u8ff0\u5b57\u4f53\u914d\u7f6e",
                  type: "font",
                  controlBy: "hasDesc",
                  controlValue: !0,
                },
                mainTitleFont: {
                  type: "font",
                  label: "\u4e3b\u6807\u9898\u5b57\u4f53\u914d\u7f6e",
                  controlBy: "hasMainTitle",
                  controlValue: !0,
                },
                titleFont: {
                  type: "font",
                  label: "\u526f\u6807\u9898\u5b57\u4f53\u914d\u7f6e",
                  controlBy: "hasTitle",
                  controlValue: !0,
                },
                detailIntroFont: {
                  type: "font",
                  label: "\u8be6\u7ec6\u4ecb\u7ecd\u5b57\u4f53\u914d\u7f6e",
                  controlBy: "hasDetailIntro",
                  controlValue: !0,
                },
              },
            },
          },
        });
      t.a = Object(h.a)(G);
    },
    "8tV9": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return L;
      }),
        n.d(t, "b", function () {
          return P;
        });
      var o,
        a = n("q1tI"),
        r = n.n(a),
        i = n("z/o8"),
        l = n("TOwV");
      function s() {
        return (s =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      function c(e, t) {
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.__proto__ = t);
      }
      function _(e, t) {
        if (null == e) return {};
        var n,
          o,
          a = {},
          r = Object.keys(e);
        for (o = 0; o < r.length; o++)
          (n = r[o]), t.indexOf(n) >= 0 || (a[n] = e[n]);
        return a;
      }
      function u(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return e;
      }
      function d(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      function p(e, t) {
        var n;
        if ("undefined" === typeof Symbol || null == e[Symbol.iterator]) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (e) {
                if ("string" === typeof e) return d(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return (
                  "Object" === n && e.constructor && (n = e.constructor.name),
                  "Map" === n || "Set" === n
                    ? Array.from(e)
                    : "Arguments" === n ||
                        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                      ? d(e, t)
                      : void 0
                );
              }
            })(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var o = 0;
            return function () {
              return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        return (n = e[Symbol.iterator]()).next.bind(n);
      }
      !(function (e) {
        (e.play = "play"),
          (e.reverse = "reverse"),
          (e.stop = "stop"),
          (e.pause = "pause");
      })(o || (o = {}));
      var f,
        h,
        m,
        y = function (e, t, n) {
          void 0 === n && (n = null),
            n &&
              e &&
              e !== t &&
              (e === o.play
                ? t === o.pause || t === o.reverse
                  ? n.play()
                  : n.restart(!0)
                : e === o.reverse
                  ? t === o.pause || t === o.play
                    ? n.reverse()
                    : n.reverse(0)
                  : e === o.stop
                    ? n.pause(0)
                    : e === o.pause && n.pause());
        },
        b = function (e, t) {
          var n,
            o = t.duration,
            a = void 0 === o ? 1 : o,
            r = t.from,
            l = t.to,
            c = t.stagger,
            u = t.progress,
            d = t.totalProgress,
            p = t.playState,
            f = t.onCompleteAll,
            h = t.onCompleteAllParams,
            m = t.onCompleteAllScope,
            b = t.onStartAll,
            v = _(t, [
              "children",
              "wrapper",
              "duration",
              "from",
              "to",
              "stagger",
              "progress",
              "totalProgress",
              "playState",
              "disabled",
              "onlyInvalidateTo",
              "onCompleteAll",
              "onCompleteAllParams",
              "onCompleteAllScope",
              "onStartAll",
              "position",
              "target",
            ]);
          return (
            (n =
              r && l
                ? i.a.fromTo(e, r, s({ stagger: c, duration: a }, l, v))
                : l
                  ? i.a.to(e, s({ stagger: c, duration: a }, l, v))
                  : i.a.from(e, s({ stagger: c, duration: a }, r, v))),
            Array.isArray(n) &&
              (n.forEach(function (e) {
                e.paused(!1);
              }),
              (n = i.a.timeline(
                s({}, v, {
                  tweens: n,
                  smoothChildTiming: !0,
                  onComplete: f,
                  onCompleteParams: h,
                  onCompleteScope: m,
                  onStart: b,
                }),
              ))),
            u && n.progress(u),
            d && n.totalProgress(d),
            p && y(p, null, n),
            n
          );
        },
        v = function (e, t) {
          return e.props.innerRef
            ? {
                innerRef: function (n) {
                  t(n);
                  var o = e.props.innerRef;
                  "function" === typeof o ? o(n) : o && (o.current = n);
                },
              }
            : {
                ref: function (n) {
                  t(n);
                  var o = e.ref;
                  "function" === typeof o ? o(n) : o && (o.current = n);
                },
              };
        },
        g = function (e, t) {
          return null === e || "undefined" === typeof e ? t : e;
        },
        w = r.a.createContext({ registerConsumer: function () {} }),
        x = (function (e) {
          function t(t) {
            var n;
            return (
              ((n = e.call(this, t) || this).consumers = []),
              (n.registerConsumer = n.registerConsumer.bind(u(n))),
              (n.getContextValue = n.getContextValue.bind(u(n))),
              (n.renderWithProvider = n.renderWithProvider.bind(u(n))),
              n
            );
          }
          c(t, e);
          var n = t.prototype;
          return (
            (n.registerConsumer = function (e) {
              this.consumers.push(e);
            }),
            (n.getContextValue = function () {
              return { registerConsumer: this.registerConsumer };
            }),
            (n.renderWithProvider = function (e) {
              return r.a.createElement(
                w.Provider,
                { value: this.getContextValue() },
                e,
              );
            }),
            t
          );
        })(r.a.Component);
      function k(e, t) {
        return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
      }
      function O(e) {
        for (
          var t = e.points, n = 0, o = void 0, a = 0;
          a < t.numberOfItems;
          a++
        ) {
          var r = t.getItem(a);
          o && (n += k(o, r)), (o = r);
        }
        return n;
      }
      function I(e) {
        if (e.getTotalLength)
          return (function (e) {
            if (!e.hasAttribute("d")) return e.getTotalLength();
            var t = e.getAttribute("d"),
              n = t ? t.replace(/m/gi, "M") : null;
            if (!n) return e.getTotalLength();
            var o = n
              .split("M")
              .filter(function (e) {
                return "" !== e;
              })
              .map(function (e) {
                return "M" + e;
              });
            if (1 === o.length) return e.getTotalLength();
            var a = 0;
            return (
              o.forEach(function (e) {
                var t = document.createElementNS(
                  "http://www.w3.org/2000/svg",
                  "path",
                );
                t.setAttribute("d", e), (a = Math.max(a, t.getTotalLength()));
              }),
              a
            );
          })(e);
        switch (e.tagName.toLowerCase()) {
          case "circle":
            return (function (e) {
              return (
                2 * Math.PI * parseFloat(g(e.getAttribute("r"), "1") || "0")
              );
            })(e);
          case "rect":
            return (function (e) {
              return (
                2 * parseFloat(g(e.getAttribute("width"), "1") || "0") +
                2 * parseFloat(g(e.getAttribute("height"), "1") || "0")
              );
            })(e);
          case "line":
            return (function (e) {
              return k(
                {
                  x: parseFloat(g(e.getAttribute("x1"), "1") || "0"),
                  y: parseFloat(g(e.getAttribute("y1"), "1") || "0"),
                },
                {
                  x: parseFloat(g(e.getAttribute("x2"), "1") || "0"),
                  y: parseFloat(g(e.getAttribute("y2"), "1") || "0"),
                },
              );
            })(e);
          case "polyline":
            return O(e);
          case "polygon":
            return (function (e) {
              var t = e.points;
              return O(e) + k(t.getItem(t.numberOfItems - 1), t.getItem(0));
            })(e);
          default:
            return 0;
        }
      }
      var S,
        j,
        T,
        C = {
          version: "2.0.0",
          name: "svgDraw",
          register: function (e, t, n) {
            (h = (f = e).utils.interpolate), (m = f.getProperty);
          },
          init: function (e, t, n, o, a) {
            var r = I(e),
              i = t,
              l = 0;
            Array.isArray(t) && ((i = t[0]), t.length >= 2 && (l = -1 * t[1]));
            (this.target = e),
              (this.strokeDashoffset = h(m(e, "stroke-dashoffset"), r * l)),
              (this.strokeDasharray = h(m(e, "stroke-dasharray"), [i * r, r]));
          },
          render: function (e, t) {
            t.target.setAttribute("stroke-dashoffset", t.strokeDashoffset(e)),
              t.target.setAttribute("stroke-dasharray", t.strokeDasharray(e));
          },
        };
      (f ||
        ("undefined" !== typeof window &&
          (f = window.gsap) &&
          f.registerPlugin &&
          f)) &&
        f.registerPlugin(C);
      var M = {
        version: "1.0.0",
        name: "count",
        register: function (e, t, n) {
          (j = (S = e).utils.interpolate),
            (T = function (e) {
              return parseInt(e.toString(), 10);
            });
        },
        init: function (e, t, n, o, a) {
          var r = t,
            i = T;
          "object" === typeof t &&
            ((r = g(t.value, 0)), t.format && (i = t.format));
          var l = parseFloat(e.innerText);
          (this.target = e),
            (this.count = j(l, parseFloat(r.toString()))),
            (this.format = i);
        },
        render: function (e, t) {
          t.target.innerText = t.format(t.count(e));
        },
      };
      (S ||
        ("undefined" !== typeof window &&
          (S = window.gsap) &&
          S.registerPlugin &&
          S)) &&
        S.registerPlugin(M),
        i.a.registerPlugin(C),
        i.a.registerPlugin(M);
      var P = (function (e) {
        function t(t) {
          var n;
          return (
            ((n = e.call(this, t) || this).targets = []),
            (n.addTarget = n.addTarget.bind(u(n))),
            n
          );
        }
        c(t, e);
        var n = t.prototype;
        return (
          (n.setPlayState = function (e) {
            var t = this.props.playState;
            y(e, t, this.tween);
          }),
          (n.componentDidMount = function () {
            this.createTween();
          }),
          (n.componentWillUnmount = function () {
            this.tween && this.tween.kill();
          }),
          (n.getSnapshotBeforeUpdate = function () {
            return (this.targets = []), null;
          }),
          (n.componentDidUpdate = function (e) {
            var t = this.props,
              n = t.children,
              o = t.duration,
              a = t.to,
              i = t.progress,
              l = t.totalProgress,
              c = t.playState,
              u = t.disabled,
              d = t.onlyInvalidateTo,
              p = _(t, [
                "children",
                "wrapper",
                "duration",
                "from",
                "to",
                "stagger",
                "progress",
                "totalProgress",
                "playState",
                "disabled",
                "onlyInvalidateTo",
                "onCompleteAll",
                "onCompleteAllParams",
                "onCompleteAllScope",
                "onStartAll",
                "position",
                "target",
              ]);
            if (
              (r.a.Children.count(e.children) !== r.a.Children.count(n) &&
                this.createTween(),
              !u)
            ) {
              if (
                (i !== e.progress && this.tween.progress(i),
                l !== e.totalProgress && this.tween.totalProgress(l),
                o !== e.duration && this.tween.duration(o),
                (h = a),
                (m = e.to),
                JSON.stringify(h) !== JSON.stringify(m))
              ) {
                if (this.tween.getChildren) {
                  this.tween.getChildren(!1, !0, !1).forEach(function (e) {
                    (e.vars = s({}, a, p, { delay: 0 })), e.invalidate();
                  });
                } else if (((this.tween.vars = s({}, a, p)), d)) {
                  var f = this.tween.progress();
                  this.tween.progress(0).invalidate().progress(f);
                } else this.tween.invalidate();
                this.tween.paused() || this.tween.restart();
              }
              var h, m;
              y(c, e.playState, this.tween);
            }
          }),
          (n.createTween = function () {
            this.tween && this.tween.kill(),
              this.props.children
                ? (this.tween = b(this.targets, this.props))
                : (this.tween = function () {}),
              this.context.registerConsumer(this);
          }),
          (n.getGSAP = function () {
            return this.tween;
          }),
          (n.setGSAP = function (e) {
            this.tween = e;
          }),
          (n.addTarget = function (e) {
            null !== e && this.targets.push(e);
          }),
          (n.getTargets = function () {
            return this.targets;
          }),
          (n.render = function () {
            var e = this,
              t = this.props,
              n = t.children,
              o = t.wrapper,
              i = r.a.createElement(
                a.Fragment,
                null,
                r.a.Children.map(n, function (t) {
                  return r.a.cloneElement(t, v(t, e.addTarget));
                }),
              );
            return o ? r.a.cloneElement(o, [], i) : i;
          }),
          t
        );
      })(r.a.Component);
      (P.displayName = "Tween"), (P.contextType = w);
      var E,
        L = (function (e) {
          function t(t) {
            var n;
            return (
              ((n = e.call(this, t) || this).targets = new Map()),
              (n.addTarget = n.addTarget.bind(u(n))),
              (n.setTarget = n.setTarget.bind(u(n))),
              n
            );
          }
          c(t, e);
          var n = t.prototype;
          return (
            (n.setPlayState = function (e) {
              var t = this.props.playState;
              y(e, t, this.timeline);
            }),
            (n.componentDidMount = function () {
              this.createTimeline();
            }),
            (n.componentWillUnmount = function () {
              this.timeline.kill();
            }),
            (n.getSnapshotBeforeUpdate = function () {
              return (this.targets = new Map()), null;
            }),
            (n.componentDidUpdate = function (e) {
              var t = this.props,
                n = t.children,
                o = t.duration,
                a = t.progress,
                i = t.totalProgress,
                l = t.playState;
              r.a.Children.count(e.children) !== r.a.Children.count(n) &&
                this.createTimeline(),
                a !== e.progress && this.timeline.progress(a),
                i !== e.totalProgress && this.timeline.totalProgress(i),
                o !== e.duration && this.timeline.duration(o),
                y(l, e.playState, this.timeline);
            }),
            (n.createTimeline = function () {
              var e = this,
                t = this.props,
                n = t.duration,
                o = t.progress,
                a = t.totalProgress,
                r = t.playState,
                l = t.labels,
                c = _(t, [
                  "children",
                  "target",
                  "duration",
                  "progress",
                  "totalProgress",
                  "playState",
                  "labels",
                  "position",
                ]);
              this.timeline && this.timeline.kill(),
                (this.timeline = i.a.timeline(s({ smoothChildTiming: !0 }, c))),
                l &&
                  l.forEach(function (t) {
                    e.timeline.addLabel(t.label, t.position);
                  }),
                this.consumers.forEach(function (t) {
                  if (t.tween && !t.props.children) {
                    var n = t.props,
                      o = n.position,
                      a = n.target,
                      r = n.stagger,
                      i = _(n, ["position", "target", "stagger"]),
                      l = null;
                    null !== a &&
                      "undefined" !== typeof a &&
                      (l = e.targets.get(a));
                    var c = b(
                      g(l, Array.from(e.targets.values())),
                      s({ stagger: r }, i),
                    );
                    e.timeline.add(c, g(o, "+=0")), t.setGSAP(c);
                  } else {
                    var u = t.props.position;
                    e.timeline.add(t.getGSAP(), g(u, "+=0"));
                  }
                }),
                n && this.timeline.duration(n),
                o && this.timeline.progress(o),
                a && this.timeline.totalProgress(a),
                r && this.setPlayState(r),
                this.context.registerConsumer(this);
            }),
            (n.getGSAP = function () {
              return this.timeline;
            }),
            (n.addTarget = function (e) {
              null !== e && this.targets.set(this.targets.size, e);
            }),
            (n.setTarget = function (e, t) {
              if (null !== t) {
                if (this.targets.has(e)) {
                  var n = this.targets.get(e);
                  if (Array.isArray(n))
                    return void this.targets.set(e, [].concat(n, t));
                }
                this.targets.set(e, t);
              }
            }),
            (n.setTargets = function (e) {
              this.targets = e;
            }),
            (n.getTargets = function () {
              return this.targets;
            }),
            (n.cloneElement = function (e) {
              return r.a.cloneElement(e, v(e, this.addTarget));
            }),
            (n.renderTarget = function (e) {
              var t = this;
              return e
                ? Object(l.isForwardRef)(e)
                  ? r.a.cloneElement(e, { ref: { set: this.setTarget } })
                  : r.a.createElement(
                      a.Fragment,
                      null,
                      r.a.Children.map(e, function (e) {
                        return Object(l.isFragment)(e)
                          ? r.a.Children.map(e.props.children, function (e) {
                              return t.cloneElement(e);
                            })
                          : t.cloneElement(e);
                      }),
                    )
                : null;
            }),
            (n.render = function () {
              var e = this.props,
                t = e.target,
                n = e.children,
                o = e.wrapper,
                i = this.renderTarget(t),
                l = r.a.createElement(a.Fragment, null, i, n);
              return (
                o && (l = r.a.cloneElement(o, [], l)),
                this.renderWithProvider(l)
              );
            }),
            t
          );
        })(x);
      (L.displayName = "Timeline"),
        (L.contextType = w),
        (function (e) {
          (e[(e.unknown = 0)] = "unknown"),
            (e[(e.entered = 1)] = "entered"),
            (e[(e.exited = 2)] = "exited");
        })(E || (E = {}));
      var B = (function (e) {
        function t() {
          var t;
          return (
            ((t = e.apply(this, arguments) || this).triggerRef = null),
            (t.observer = null),
            (t.intersectionObserverCallback = function (e) {
              for (
                var n,
                  o = t.props,
                  a = o.repeat,
                  r = o.threshold,
                  i = E.unknown,
                  l = p(e);
                !(n = l()).done;

              ) {
                var s = n.value;
                if (s.isIntersecting && s.intersectionRatio >= r) {
                  t.timeline.play(), (i = E.entered);
                  break;
                }
                if (!s.isIntersecting) {
                  i = E.exited;
                  break;
                }
              }
              a || i !== E.entered
                ? a && i === E.exited && t.timeline.pause(0)
                : t.killIntersectionObserver();
            }),
            t
          );
        }
        c(t, e);
        var n = t.prototype;
        return (
          (n.init = function () {
            this.createTimeline(), this.createIntersectionObserver();
          }),
          (n.kill = function () {
            this.killTimeline(), this.killIntersectionObserver();
          }),
          (n.componentDidMount = function () {
            this.init();
          }),
          (n.componentWillUnmount = function () {
            this.kill();
          }),
          (n.componentDidUpdate = function (e) {
            var t = this.props,
              n = t.children,
              o = t.trigger;
            r.a.Children.count(e.children) !== r.a.Children.count(n) &&
              this.init(),
              e.trigger !== o && this.init();
          }),
          (n.createTimeline = function () {
            var e = this;
            this.killTimeline(),
              (this.timeline = i.a.timeline({
                smoothChildTiming: !0,
                paused: !0,
              })),
              this.consumers.forEach(function (t) {
                var n = t.props.position;
                e.timeline.add(t.getGSAP().play(), g(n, 0));
              });
          }),
          (n.killTimeline = function () {
            this.timeline && this.timeline.kill();
          }),
          (n.createIntersectionObserver = function () {
            var e = this,
              t = this.props,
              n = {
                root: t.root,
                rootMargin: t.rootMargin,
                threshold: [0, t.threshold],
              };
            (this.observer = new IntersectionObserver(
              this.intersectionObserverCallback,
              n,
            )),
              this.triggerRef
                ? this.observer && this.observer.observe(this.triggerRef)
                : this.consumers.forEach(function (t) {
                    t.getTargets().forEach(function (t) {
                      e.observer && e.observer.observe(t);
                    });
                  });
          }),
          (n.killIntersectionObserver = function () {
            this.unobserveAll(), (this.observer = null);
          }),
          (n.unobserveAll = function () {
            var e = this;
            this.observer &&
              (this.triggerRef
                ? this.observer && this.observer.unobserve(this.triggerRef)
                : this.consumers.forEach(function (t) {
                    t.getTargets().forEach(function (t) {
                      e.observer && e.observer.unobserve(t);
                    });
                  }));
          }),
          (n.getGSAP = function () {
            return this.timeline;
          }),
          (n.render = function () {
            var e = this,
              t = this.props,
              n = t.children,
              o = t.trigger,
              a = o
                ? r.a.createElement(
                    o.type,
                    Object.assign({}, o.props, {
                      ref: function (t) {
                        return (e.triggerRef = t);
                      },
                    }),
                    n,
                  )
                : n;
            return this.renderWithProvider(a);
          }),
          t
        );
      })(x);
      (B.displayName = "Reveal"),
        (B.defaultProps = {
          trigger: null,
          repeat: !1,
          root: null,
          rootMargin: "0px",
          threshold: 0.66,
        });
    },
    "8vI9": function (e, t, n) {
      e.exports = {
        "text-scroll-switch-video-component":
          "style__text-scroll-switch-video-component___1qCwg",
        sticky: "style__sticky___B3dWo",
        "adaptive-section": "style__adaptive-section___zZUEw",
        "adaptive-wrap": "style__adaptive-wrap___3IRWH",
        "adaptive-item": "style__adaptive-item___2I8F0",
        "sticky-dom-left": "style__sticky-dom-left___2x4BJ",
        "video-box": "style__video-box___2DM0L",
        "bg-box": "style__bg-box___2MB-L",
        "bg-style": "style__bg-style___3FRZX",
        "scroll-panel": "style__scroll-panel___3ypWy",
        "scroll-content": "style__scroll-content___2h3Mk",
        textRight: "style__textRight___bpCQ4",
        "will-change": "style__will-change___3CSVI",
        text: "style__text___1Ta0B",
        "item-title": "style__item-title___1EJem",
        "item-desc": "style__item-desc___3asy3",
        "downgrade-section": "style__downgrade-section___bXiaR",
        "downgrade-adaptive-item": "style__downgrade-adaptive-item___3gs5O",
        "downgrade-video-box": "style__downgrade-video-box___28aCq",
        "downgrade-text": "style__downgrade-text___1l6kj",
        "downgrade-img": "style__downgrade-img___1OrYA",
      };
    },
    "9/5/": function (e, t, n) {
      (function (t) {
        var n = "Expected a function",
          o = NaN,
          a = "[object Symbol]",
          r = /^\s+|\s+$/g,
          i = /^[-+]0x[0-9a-f]+$/i,
          l = /^0b[01]+$/i,
          s = /^0o[0-7]+$/i,
          c = parseInt,
          _ = "object" == typeof t && t && t.Object === Object && t,
          u = "object" == typeof self && self && self.Object === Object && self,
          d = _ || u || Function("return this")(),
          p = Object.prototype.toString,
          f = Math.max,
          h = Math.min,
          m = function () {
            return d.Date.now();
          };
        function y(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function b(e) {
          if ("number" == typeof e) return e;
          if (
            (function (e) {
              return (
                "symbol" == typeof e ||
                ((function (e) {
                  return !!e && "object" == typeof e;
                })(e) &&
                  p.call(e) == a)
              );
            })(e)
          )
            return o;
          if (y(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = y(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(r, "");
          var n = l.test(e);
          return n || s.test(e) ? c(e.slice(2), n ? 2 : 8) : i.test(e) ? o : +e;
        }
        e.exports = function (e, t, o) {
          var a,
            r,
            i,
            l,
            s,
            c,
            _ = 0,
            u = !1,
            d = !1,
            p = !0;
          if ("function" != typeof e) throw new TypeError(n);
          function v(t) {
            var n = a,
              o = r;
            return (a = r = void 0), (_ = t), (l = e.apply(o, n));
          }
          function g(e) {
            var n = e - c;
            return void 0 === c || n >= t || n < 0 || (d && e - _ >= i);
          }
          function w() {
            var e = m();
            if (g(e)) return x(e);
            s = setTimeout(
              w,
              (function (e) {
                var n = t - (e - c);
                return d ? h(n, i - (e - _)) : n;
              })(e),
            );
          }
          function x(e) {
            return (s = void 0), p && a ? v(e) : ((a = r = void 0), l);
          }
          function k() {
            var e = m(),
              n = g(e);
            if (((a = arguments), (r = this), (c = e), n)) {
              if (void 0 === s)
                return (function (e) {
                  return (_ = e), (s = setTimeout(w, t)), u ? v(e) : l;
                })(c);
              if (d) return (s = setTimeout(w, t)), v(c);
            }
            return void 0 === s && (s = setTimeout(w, t)), l;
          }
          return (
            (t = b(t) || 0),
            y(o) &&
              ((u = !!o.leading),
              (i = (d = "maxWait" in o) ? f(b(o.maxWait) || 0, t) : i),
              (p = "trailing" in o ? !!o.trailing : p)),
            (k.cancel = function () {
              void 0 !== s && clearTimeout(s),
                (_ = 0),
                (a = c = r = s = void 0);
            }),
            (k.flush = function () {
              return void 0 === s ? l : x(m());
            }),
            k
          );
        };
      }).call(this, n("yLpj"));
    },
    "90zR": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return l;
      });
      var o = n("C68Z"),
        a = n("tvYQ"),
        r = n("3T+G"),
        i = n("wFID"),
        l = {
          test: Object(i.a)("hsl", "hue"),
          parse: Object(i.b)("hue", "saturation", "lightness"),
          transform: function (e) {
            var t = e.hue,
              n = e.saturation,
              i = e.lightness,
              l = e.alpha,
              s = void 0 === l ? 1 : l;
            return (
              "hsla(" +
              Math.round(t) +
              ", " +
              a.b.transform(Object(r.e)(n)) +
              ", " +
              a.b.transform(Object(r.e)(i)) +
              ", " +
              Object(r.e)(o.a.transform(s)) +
              ")"
            );
          },
        };
    },
    "93I4": function (e, t) {
      e.exports = function (e) {
        return "object" === typeof e ? null !== e : "function" === typeof e;
      };
    },
    "9Nap": function (e, t, n) {
      var o = n("/9aa"),
        a = 1 / 0;
      e.exports = function (e) {
        if ("string" == typeof e || o(e)) return e;
        var t = e + "";
        return "0" == t && 1 / e == -a ? "-0" : t;
      };
    },
    "9Q1S": function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        r =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              },
        i = n("Aw7D"),
        l = n("Brax"),
        s = (o = l) && o.__esModule ? o : { default: o },
        c = n("ZRcJ");
      function _(e) {
        (this.rules = null), (this._messages = c.messages), this.define(e);
      }
      (_.prototype = {
        messages: function (e) {
          return (
            e && (this._messages = (0, i.deepMerge)((0, c.newMessages)(), e)),
            this._messages
          );
        },
        define: function (e) {
          if (!e) throw new Error("Cannot configure a schema with no rules");
          if (
            "object" !== ("undefined" === typeof e ? "undefined" : r(e)) ||
            Array.isArray(e)
          )
            throw new Error("Rules must be an object");
          this.rules = {};
          var t = void 0,
            n = void 0;
          for (t in e)
            e.hasOwnProperty(t) &&
              ((n = e[t]), (this.rules[t] = Array.isArray(n) ? n : [n]));
        },
        validate: function (e) {
          var t = this,
            n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {},
            o =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : function () {},
            l = e,
            s = n,
            u = o;
          if (
            ("function" === typeof s && ((u = s), (s = {})),
            !this.rules || 0 === Object.keys(this.rules).length)
          )
            return u && u(), Promise.resolve();
          function d(e) {
            var t = void 0,
              n = [],
              o = {};
            function a(e) {
              var t;
              Array.isArray(e) ? (n = (t = n).concat.apply(t, e)) : n.push(e);
            }
            for (t = 0; t < e.length; t++) a(e[t]);
            n.length
              ? (o = (0, i.convertFieldsError)(n))
              : ((n = null), (o = null)),
              u(n, o);
          }
          if (s.messages) {
            var p = this.messages();
            p === c.messages && (p = (0, c.newMessages)()),
              (0, i.deepMerge)(p, s.messages),
              (s.messages = p);
          } else s.messages = this.messages();
          var f = void 0,
            h = void 0,
            m = {},
            y = s.keys || Object.keys(this.rules);
          y.forEach(function (n) {
            (f = t.rules[n]),
              (h = l[n]),
              f.forEach(function (o) {
                var r = o;
                "function" === typeof r.transform &&
                  (l === e && (l = a({}, l)), (h = l[n] = r.transform(h))),
                  ((r =
                    "function" === typeof r
                      ? { validator: r }
                      : a({}, r)).validator = t.getValidationMethod(r)),
                  (r.field = n),
                  (r.fullField = r.fullField || n),
                  (r.type = t.getType(r)),
                  r.validator &&
                    ((m[n] = m[n] || []),
                    m[n].push({ rule: r, value: h, source: l, field: n }));
              });
          });
          var b = {};
          return (0, i.asyncMap)(
            m,
            s,
            function (e, t) {
              var n = e.rule,
                o =
                  ("object" === n.type || "array" === n.type) &&
                  ("object" === r(n.fields) || "object" === r(n.defaultField));
              function l(e, t) {
                return a({}, t, { fullField: n.fullField + "." + e });
              }
              function c() {
                var r =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : [];
                if (
                  (Array.isArray(r) || (r = [r]),
                  !s.suppressWarning &&
                    r.length &&
                    _.warning("async-validator:", r),
                  r.length && n.message && (r = [].concat(n.message)),
                  (r = r.map((0, i.complementError)(n))),
                  s.first && r.length)
                )
                  return (b[n.field] = 1), t(r);
                if (o) {
                  if (n.required && !e.value)
                    return (
                      (r = n.message
                        ? [].concat(n.message).map((0, i.complementError)(n))
                        : s.error
                          ? [
                              s.error(
                                n,
                                (0, i.format)(s.messages.required, n.field),
                              ),
                            ]
                          : []),
                      t(r)
                    );
                  var c = {};
                  if (n.defaultField)
                    for (var u in e.value)
                      e.value.hasOwnProperty(u) && (c[u] = n.defaultField);
                  for (var d in (c = a({}, c, e.rule.fields)))
                    if (c.hasOwnProperty(d)) {
                      var p = Array.isArray(c[d]) ? c[d] : [c[d]];
                      c[d] = p.map(l.bind(null, d));
                    }
                  var f = new _(c);
                  f.messages(s.messages),
                    e.rule.options &&
                      ((e.rule.options.messages = s.messages),
                      (e.rule.options.error = s.error)),
                    f.validate(e.value, e.rule.options || s, function (e) {
                      var n = [];
                      r && r.length && n.push.apply(n, r),
                        e && e.length && n.push.apply(n, e),
                        t(n.length ? n : null);
                    });
                } else t(r);
              }
              (o = o && (n.required || (!n.required && e.value))),
                (n.field = e.field);
              var u = void 0;
              n.asyncValidator
                ? (u = n.asyncValidator(n, e.value, c, e.source, s))
                : n.validator &&
                  (!0 === (u = n.validator(n, e.value, c, e.source, s))
                    ? c()
                    : !1 === u
                      ? c(n.message || n.field + " fails")
                      : u instanceof Array
                        ? c(u)
                        : u instanceof Error && c(u.message)),
                u &&
                  u.then &&
                  u.then(
                    function () {
                      return c();
                    },
                    function (e) {
                      return c(e);
                    },
                  );
            },
            function (e) {
              d(e);
            },
          );
        },
        getType: function (e) {
          if (
            (void 0 === e.type &&
              e.pattern instanceof RegExp &&
              (e.type = "pattern"),
            "function" !== typeof e.validator &&
              e.type &&
              !s.default.hasOwnProperty(e.type))
          )
            throw new Error((0, i.format)("Unknown rule type %s", e.type));
          return e.type || "string";
        },
        getValidationMethod: function (e) {
          if ("function" === typeof e.validator) return e.validator;
          var t = Object.keys(e),
            n = t.indexOf("message");
          return (
            -1 !== n && t.splice(n, 1),
            1 === t.length && "required" === t[0]
              ? s.default.required
              : s.default[this.getType(e)] || !1
          );
        },
      }),
        (_.register = function (e, t) {
          if ("function" !== typeof t)
            throw new Error(
              "Cannot register a validator by type, validator is not a function",
            );
          s.default[e] = t;
        }),
        (_.warning = i.warning),
        (_.messages = c.messages),
        (t.default = _);
    },
    "9Rgp": function (e, t, n) {
      "use strict";
      function o(e, t) {
        e &&
          "object" === typeof e &&
          t &&
          ((e.transform = t), (e.WebkitTransform = t), (e.MozTransform = t));
      }
      n.d(t, "a", function () {
        return o;
      });
    },
    "9TBn": function (e, t, n) {
      "use strict";
      n.r(t);
      var o = n("rePB"),
        a = n("6HgK"),
        r = n("2mql"),
        i = n.n(r),
        l = n("/NQ+"),
        s = n("ub/+"),
        c = n("fi7q"),
        _ = n("wx14"),
        u = n("1OyB"),
        d = n("vuIU"),
        p = n("md7G"),
        f = n("foSv"),
        h = n("JX7q"),
        m = n("Ji7U"),
        y = n("iKuz"),
        b = n.n(y),
        v = n("q1tI"),
        g = n("3vbH"),
        w = n("xk4V"),
        x = n.n(w),
        k = n("SBOM"),
        O = n("CBaM"),
        I = n("ZPPD"),
        S = n("tZZE"),
        j = n("yWgo"),
        T = (n("pR0O"), v.createElement),
        C = {
          "./style.css": {
            "hero-horizontal-component":
              "style__hero-horizontal-component___1c2xP",
            "background-video": "style__background-video___32EiK",
            "video-mask": "style__video-mask___3zvyy",
            "card-list": "style__card-list___XPXVu",
            "hero-horizontal-wrapper": "style__hero-horizontal-wrapper___3U6-D",
            "horizontal-card-list": "style__horizontal-card-list___3_oTU",
            "horizontal-card-col": "style__horizontal-card-col___2qRr9",
            "vertical-top-align": "style__vertical-top-align___2PCRs",
            "vertical-center-align": "style__vertical-center-align___2DhpN",
            "vertical-bottom-align": "style__vertical-bottom-align___1M56I",
            "has-media-screen": "style__has-media-screen___2s7Ms",
            "media-screen-1600": "style__media-screen-1600___1z6U8",
          },
        };
      function M(e, t, n) {
        return (
          (t = Object(f.a)(t)),
          Object(p.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(f.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var P = (function (e) {
          return (
            (e["auto-fit"] = "auto-fit"), (e["custom-css"] = "custom-css"), e
          );
        })({}),
        E = (function (e) {
          return (
            (e.repeat = "repeat"),
            (e["repeat-x"] = "repeat-x"),
            (e["repeat-y"] = "repeat-y"),
            (e["no-repeat"] = "no-repeat"),
            e
          );
        })({}),
        L = (function (e) {
          return (e.fix = "fix"), (e.normal = "normal"), e;
        })({}),
        B = (function (e) {
          return (
            (e["top-align"] = "top-align"),
            (e["center-align"] = "center-align"),
            (e["bottom-align"] = "bottom-align"),
            e
          );
        })({}),
        N = (function (e) {
          return (
            (e["fade-in"] = "fade-in"),
            (e["fade-up"] = "fade-up"),
            (e["zoom-in-up"] = "zoom-in-up"),
            (e.none = "none"),
            e
          );
        })({}),
        D = (function (e) {
          function t(e) {
            var n;
            Object(u.default)(this, t),
              (n = M(this, t, [e])),
              Object(o.a)(Object(h.a)(n), "cards", void 0),
              (n.state = { isIE: !1 }),
              (n.getProps = n.getProps.bind(Object(h.a)(n)));
            var a = n.props,
              r = a.localization,
              i = a.id;
            return (
              (n.cards = n.props.cardConfigList
                ? n.props.cardConfigList.map(function (e, t) {
                    return T(
                      "div",
                      {
                        key: x()(),
                        style: {
                          marginLeft: 0 === t ? 0 : n.props.cardGapWidth,
                        },
                        className: "style__horizontal-card-col___2qRr9",
                      },
                      T(
                        O.a,
                        Object(_.a)(
                          {
                            localization: r,
                            visibleByDefault: n.getProps("visibleByDefault"),
                            gaSend: n.getProps("gaSend"),
                            getFadeTransiation: function () {
                              return n.getProps("fadeTransiation");
                            },
                            getMediaTransiation: function () {
                              return n.getProps("mediaTransiation");
                            },
                            getGapWidth: function () {
                              return n.getProps("cardGapWidth");
                            },
                            getGridWidth: function () {
                              return n.getProps("gridWidth");
                            },
                            getTabPresentation: function () {
                              return n.getProps("tabPresentation");
                            },
                          },
                          e,
                          {
                            key: x()(),
                            index: t,
                            id: i,
                            hasMediaScreen: n.props.hasMediaScreen,
                            mediaPoint: n.props.mediaPoint,
                          },
                        ),
                      ),
                    );
                  })
                : null),
              n
            );
          }
          return (
            Object(m.a)(t, e),
            Object(d.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e =
                    window &&
                    !!window.MSInputMethodContext &&
                    !!document.documentMode;
                  this.setState({ isIE: e });
                },
              },
              {
                key: "getProps",
                value: function (e) {
                  return this.props[e];
                },
              },
              {
                key: "getHotZoneLink",
                value: function (e) {
                  var t = void 0;
                  if (
                    (e.hasBackgroundImage && e.backgroundImage) ||
                    (e.hasBackgroundVideo &&
                      (e.backgroundVideoWebm || e.backgroundVideo))
                  ) {
                    var n = e.cardConfigList;
                    n &&
                      1 === n.length &&
                      (n[0].hasBackgroundImage ||
                        n[0].hasBackgroundVideo ||
                        (t = Object(I.a)(n[0])));
                  }
                  return t;
                },
              },
              {
                key: "handleHotZoneClick",
                value: function (e, t) {
                  Object(S.b)(e, t, "media-modal-container");
                },
              },
              {
                key: "render",
                value: function () {
                  var e,
                    t = this,
                    n = this.props,
                    o = this.state.isIE,
                    a = n.visibleByDefault,
                    r = n.hasMediaScreen,
                    i = n.mediaPoint,
                    l = ""
                      .concat(
                        Object(j.kb)(r, "has-media-screen", ""),
                        " media-screen-",
                      )
                      .concat(i || "1440"),
                    s = "vertical-".concat(n.componentVerticalAlign),
                    c = n.fadeTransiation,
                    u = this.getHotZoneLink(n),
                    d = { backgroundColor: n.pureBackgroundColor };
                  n.hasBackgroundImage
                    ? ((e = n.backgroundImage),
                      (d.backgroundPosition = n.backgroundPosition),
                      (d.backgroundSize =
                        n.backgroundSize === P["auto-fit"]
                          ? "cover"
                          : n.backgroundSizeCustom),
                      (d.backgroundRepeat = n.backgroundRepeat),
                      (d.backgroundAttachment =
                        n.backgroundFixed !== L.fix || o ? "scroll" : "fixed"),
                      n.backgroundGradient &&
                        (e = "url('"
                          .concat(n.backgroundImage, "'), ")
                          .concat(n.backgroundGradient)))
                    : n.backgroundGradient && (e = n.backgroundGradient);
                  var p = {
                      minHeight: n.componentMinHeight,
                      paddingTop: n.paddingTop,
                      paddingBottom: n.paddingBottom,
                      paddingLeft: n.paddingLeft,
                      paddingRight: n.paddingRight,
                      width: n.gridWidth,
                    },
                    f = {};
                  f[a ? "poster" : "data-layzr-poster"] =
                    n.backgroundVideoPoster;
                  var h = [
                    n.hasBackgroundVideo
                      ? T(
                          "div",
                          {
                            key: "bgVideo",
                            className:
                              "background-video-wrapper style__background-video___32EiK",
                          },
                          T(
                            g.a,
                            {
                              visiblePlay: n.backgroundVideoVisiblePlay,
                              replayWhenRevisible: n.backgroundVideoVisiblePlay,
                              lazyLoad: !0,
                              lazyLoadThreshold: 2e3,
                              style: {
                                postion: "relative",
                                width: "100%",
                                height: "100%",
                              },
                            },
                            T(
                              "video",
                              Object(_.a)({ muted: !0 }, f, {
                                loop: n.backgroundVideoLoop,
                                autoPlay:
                                  !n.backgroundVideoVisiblePlay &&
                                  !n.backgroundVideoHoverPlay,
                              }),
                              n.backgroundVideoWebm &&
                                T("source", {
                                  type: "video/webm",
                                  "data-layzr-src": n.backgroundVideoWebm,
                                }),
                              T("source", {
                                type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                                "data-layzr-src": n.backgroundVideo,
                              }),
                            ),
                          ),
                          T("div", {
                            className: "style__video-mask___3zvyy",
                            style: {
                              backgroundColor: n.backgroundVideoMaskColor,
                              opacity: n.backgroundVideoMaskOpacity,
                            },
                          }),
                        )
                      : null,
                    T(
                      "div",
                      {
                        id: n.anchorId || "",
                        key: "cards",
                        style: p,
                        className: b()(
                          "hero-horizontal-wrapper ".concat(s, " ").concat(l),
                          C,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      T(
                        "div",
                        {
                          style: {
                            cursor: (
                              null === u || void 0 === u ? void 0 : u.url
                            )
                              ? "pointer"
                              : "initial",
                          },
                          onClick: function (e) {
                            return t.handleHotZoneClick(e, u);
                          },
                          "data-ga-label":
                            null === u || void 0 === u ? void 0 : u.gaLabel,
                          className: "style__horizontal-card-list___3_oTU",
                          "data-aos": c,
                          "data-aos-once": !0,
                        },
                        this.cards,
                      ),
                    ),
                  ];
                  return T(
                    k.a,
                    {
                      type: "bg",
                      visibleByDefault: a,
                      src: e,
                      bgWidth: n.backgroundImageWidth,
                      bgHeight: n.backgroundImageHeight,
                      parallax: n.hasBackgroundImage && n.backgroundParallax,
                      className:
                        "atom-design-v1 ".concat(n.customStyle) +
                        " style__hero-horizontal-component___1c2xP",
                      style: d,
                    },
                    h,
                  );
                },
              },
            ]),
            t
          );
        })(v.Component);
      function z(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function A(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? z(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : z(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      Object(o.a)(D, "defaultProps", {
        cardGapWidth: "16px",
        gridWidth: "1200px",
        componentMinHeight: "",
        pureBackgroundColor: "",
        backgroundGradient: "",
        customStyle: "",
        hasBackgroundImage: !1,
        backgroundImage: "",
        backgroundImageWidth: "",
        backgroundImageHeight: "",
        backgroundPosition: "",
        backgroundSize: P["auto-fit"],
        backgroundSizeCustom: "",
        backgroundRepeat: E["no-repeat"],
        backgroundFixed: L.normal,
        backgroundParallax: !1,
        hasBackgroundVideo: !1,
        backgroundVideoLoop: !0,
        backgroundVideoVisiblePlay: !0,
        backgroundVideoHoverPlay: !1,
        backgroundVideo: "",
        backgroundVideoWebm: "",
        backgroundVideoPoster: "",
        backgroundVideoMaskColor: "#000000",
        backgroundVideoMaskOpacity: "0",
        componentVerticalAlign: B["center-align"],
        paddingTop: "128px",
        paddingBottom: "128px",
        paddingLeft: "",
        paddingRight: "",
        fadeTransiation: N.none,
        mediaTransiation: N.none,
        cardConfigList: [O.a.defaultProps],
      });
      var R = { label: "ga-label", type: "string", content: "text" },
        F = {
          skinSetting: {
            structure: {
              label: "\u7ed3\u6784\u8bbe\u7f6e",
              props: {
                componentVerticalAlign: {
                  label: "\u5185\u5bb9\u5782\u76f4\u5bf9\u9f50",
                  type: "select",
                  items: [
                    { label: "\u5c45\u4e0a\u5bf9\u9f50", value: "top-align" },
                    {
                      label: "\u5c45\u4e2d\u5bf9\u9f50",
                      value: "center-align",
                    },
                    {
                      label: "\u5c45\u4e0b\u5bf9\u9f50",
                      value: "bottom-align",
                    },
                  ],
                },
                componentMinHeight: {
                  label: "\u6574\u5c4f\u6700\u5c0f\u9ad8\u5ea6",
                  type: "string",
                  content: "size",
                },
                cardGapWidth: {
                  label: "\u69fd\u5bbd",
                  type: "string",
                  content: "size",
                },
                gridWidth: {
                  label: "\u6805\u683c\u603b\u5bbd",
                  type: "string",
                  content: "size",
                },
              },
            },
            backgroundColor: {
              label: "\u80cc\u666f\u989c\u8272\u8bbe\u7f6e",
              props: {
                pureBackgroundColor: {
                  label: "\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
                backgroundGradient: {
                  label: "\u80cc\u666f\u6e10\u53d8\u989c\u8272",
                  type: "string",
                  content: "color",
                },
              },
            },
            background: {
              label: "\u80cc\u666f\u56fe\u7247\u8bbe\u7f6e",
              switch: "hasBackgroundImage",
              props: {
                backgroundImage: {
                  label: "\u80cc\u666f\u56fe\u7247",
                  type: "image",
                },
                backgroundPosition: {
                  label: "\u80cc\u666f\u4f4d\u7f6e",
                  type: "string",
                },
                backgroundSize: {
                  label: "\u80cc\u666f\u5c3a\u5bf8",
                  type: "select",
                  items: [
                    {
                      label: "\u5168\u5c4f\u81ea\u9002\u5e94",
                      value: "auto-fit",
                    },
                    {
                      label: "\u81ea\u5b9a\u4e49css\u5c5e\u6027",
                      value: "custom-css",
                    },
                  ],
                },
                backgroundSizeCustom: {
                  type: "string",
                  label: "\u80cc\u666f\u81ea\u5b9a\u4e49css\u5c5e\u6027",
                  controlBy: "backgroundSize",
                  controlValue: "custom-css",
                },
                backgroundRepeat: {
                  type: "select",
                  label: "\u80cc\u666f\u91cd\u590d\u65b9\u5f0f",
                  items: [
                    {
                      label: "\u6c34\u5e73\u5782\u76f4\u91cd\u590d",
                      value: "repeat",
                    },
                    { label: "\u6c34\u5e73\u91cd\u590d", value: "repeat-x" },
                    { label: "\u5782\u76f4\u91cd\u590d", value: "repeat-y" },
                    { label: "\u4e0d\u91cd\u590d", value: "no-repeat" },
                  ],
                },
                backgroundParallax: {
                  label: "\u80cc\u666f\u7eb5\u5411\u6eda\u52a8\u89c6\u5dee",
                  type: "boolean",
                },
                backgroundImageWidth: {
                  label: "\u80cc\u666f\u56fe\u672c\u8eab\u7684\u5bbd\u5ea6",
                  type: "string",
                  content: "size",
                },
                backgroundImageHeight: {
                  label: "\u80cc\u666f\u56fe\u672c\u8eab\u7684\u9ad8\u5ea6",
                  type: "string",
                  content: "size",
                },
              },
            },
            backgroundVideo: {
              label: "\u80cc\u666f\u89c6\u9891\u8bbe\u7f6e",
              switch: "hasBackgroundVideo",
              props: {
                backgroundVideoLoop: {
                  label: "\u5faa\u73af\u64ad\u653e",
                  type: "boolean",
                },
                backgroundVideoVisiblePlay: {
                  label:
                    "\u9875\u9762\u6eda\u52a8\u540e\u89e6\u53d1\u64ad\u653e",
                  type: "boolean",
                },
                backgroundVideo: {
                  label: "\u80cc\u666f\u89c6\u9891\u94fe\u63a5",
                  type: "string",
                  content: "url",
                },
                backgroundVideoWebm: {
                  label:
                    "\u80cc\u666f\u89c6\u9891\u94fe\u63a5\uff08webm\u683c\u5f0f, \u9009\u586b\uff09",
                  type: "string",
                  content: "url",
                },
                backgroundVideoPoster: {
                  label: "\u80cc\u666f\u89c6\u9891\u5c01\u9762\u56fe",
                  type: "image",
                },
                backgroundVideoMaskColor: {
                  label:
                    "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u8272\u53f7 (\u9ed8\u8ba4#000000)",
                  type: "string",
                },
                backgroundVideoMaskOpacity: {
                  label:
                    "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u4e0d\u900f\u660e\u5ea6 (0-1, \u9ed8\u8ba40)",
                  type: "string",
                },
              },
            },
            padding: {
              label: "\u5185\u8fb9\u8ddd\u8bbe\u7f6e",
              props: {
                paddingTop: {
                  type: "string",
                  content: "size",
                  label: "\u4e0a\u65b9\u5185\u8fb9\u8ddd",
                },
                paddingBottom: {
                  type: "string",
                  content: "size",
                  label: "\u4e0b\u65b9\u5185\u8fb9\u8ddd",
                },
                paddingLeft: {
                  type: "string",
                  content: "size",
                  label: "\u5de6\u65b9\u5185\u8fb9\u8ddd",
                },
                paddingRight: {
                  type: "string",
                  content: "size",
                  label: "\u53f3\u65b9\u5185\u8fb9\u8ddd",
                },
              },
            },
            effect: {
              label: "\u52a8\u6001\u6548\u679c",
              props: {
                fadeTransiation: {
                  label: "\u5165\u573a\u8fc7\u6e21",
                  type: "select",
                  items: [
                    { label: "fade-in", value: "fade-in" },
                    { label: "fade-up", value: "fade-up" },
                    { label: "zoom-in-up", value: "zoom-in-up" },
                    { label: "\u65e0\u6548\u679c", value: "none" },
                  ],
                },
                mediaTransiation: {
                  label: "\u56fe\u7247/\u89c6\u9891\u5165\u573a\u8fc7\u6e21",
                  type: "select",
                  items: [
                    { label: "fade-in", value: "fade-in" },
                    { label: "fade-up", value: "fade-up" },
                    { label: "zoom-in-up", value: "zoom-in-up" },
                    { label: "\u65e0\u6548\u679c", value: "none" },
                  ],
                },
              },
            },
            anchor: {
              label: "\u951a\u70b9\u8bbe\u7f6e",
              props: {
                anchorId: {
                  label: "\u951a\u70b9 id [\u9009\u586b, \u4e0d\u5e26#\u53f7]",
                  type: "string",
                },
              },
            },
            customStyle: {
              label: "\u81ea\u5b9a\u4e49\u7c7b\u540d",
              props: {
                customStyle: {
                  label: "\u81ea\u5b9a\u4e49\u7c7b\u540d",
                  type: "string",
                },
              },
            },
          },
          contentSetting: {
            smallScreenSetting: {
              label: "\u5c0f\u5c4f\u914d\u7f6e",
              switch: "hasMediaScreen",
              props: { mediaPoint: c.a },
            },
            cardList: {
              label: "\u5361\u7247",
              group_type: "array_card",
              group_prop_name: "cardConfigList",
              props: {
                layout: {
                  label: "\u7ed3\u6784\u6846\u67b6",
                  props: {
                    leftCols: {
                      type: "select",
                      label: "\u5de6\u8fb9\u5185\u5bb9\u6bd4\u4f8b",
                      items: [
                        { value: "0", label: "0" },
                        { value: "1", label: "1" },
                        { value: "2", label: "2" },
                        { value: "3", label: "3" },
                        { value: "4", label: "4" },
                        { value: "5", label: "5" },
                        { value: "6", label: "6" },
                        { value: "7", label: "7" },
                        { value: "8", label: "8" },
                        { value: "9", label: "9" },
                        { value: "10", label: "10" },
                        { value: "11", label: "11" },
                        { value: "12", label: "12" },
                      ],
                    },
                    headlineLevel: {
                      type: "select",
                      label: "headline\u5c42\u7ea7",
                      items: [
                        { value: "h1", label: "h1" },
                        { value: "h2", label: "h2" },
                        { value: "h3", label: "h3" },
                        { value: "h4", label: "h4" },
                        { value: "p", label: "p" },
                      ],
                    },
                    contentSize: {
                      type: "select",
                      label: "\u4fe1\u606f\u5757\u6587\u672c\u5c3a\u5bf8",
                      items: [
                        { value: "xxxxxl", label: "xxxxxl(headline=64)" },
                        { value: "xxxxl", label: "xxxxl(headline=56)" },
                        { value: "xxxl", label: "xxxl(headline=48)" },
                        { value: "xxl", label: "xxl(headline=40)" },
                        { value: "xl", label: "xl(headline=32)" },
                        { value: "l", label: "l(headline=28)" },
                        { value: "m", label: "m(headline=24)" },
                        { value: "s", label: "s(headline=20)" },
                        { value: "xs", label: "xs(headline=18)" },
                        { value: "xxs", label: "xxs(headline=16)" },
                      ],
                    },
                    verticalAlign: {
                      type: "select",
                      label: "\u5361\u7247\u5185\u5bb9\u5782\u76f4\u5bf9\u9f50",
                      items: [
                        {
                          value: "top-align",
                          label: "\u5c45\u4e0a\u5bf9\u9f50",
                        },
                        {
                          value: "center-align",
                          label: "\u5c45\u4e2d\u5bf9\u9f50",
                        },
                        {
                          value: "bottom-align",
                          label: "\u5c45\u4e0b\u5bf9\u9f50",
                        },
                      ],
                    },
                    horizontalAlign: {
                      type: "select",
                      label: "\u5361\u7247\u5185\u5bb9\u6c34\u5e73\u5bf9\u9f50",
                      items: [
                        {
                          value: "left-align",
                          label: "\u5c45\u5de6\u5bf9\u9f50",
                        },
                        {
                          value: "center-align",
                          label: "\u5c45\u4e2d\u5bf9\u9f50",
                        },
                        {
                          value: "right-align",
                          label: "\u5c45\u53f3\u5bf9\u9f50",
                        },
                      ],
                    },
                  },
                },
                size: {
                  label: "\u5c3a\u5bf8\u8bbe\u7f6e",
                  props: {
                    minHeight: {
                      type: "string",
                      content: "size",
                      label: "\u5361\u7247\u6700\u5c0f\u9ad8\u5ea6",
                    },
                    marginTop: {
                      type: "string",
                      content: "size",
                      label: "\u5361\u7247\u4e0a\u65b9\u5916\u8fb9\u8ddd",
                    },
                    marginBottom: {
                      type: "string",
                      content: "size",
                      label: "\u5361\u7247\u4e0b\u65b9\u5916\u8fb9\u8ddd",
                    },
                    paddingTop: {
                      type: "string",
                      content: "size",
                      label: "\u5361\u7247\u4e0a\u65b9\u5185\u8fb9\u8ddd",
                    },
                    paddingBottom: {
                      type: "string",
                      content: "size",
                      label: "\u5361\u7247\u4e0b\u65b9\u5185\u8fb9\u8ddd",
                    },
                    paddingLeft: {
                      type: "string",
                      content: "size",
                      label: "\u5361\u7247\u5de6\u65b9\u5185\u8fb9\u8ddd",
                    },
                    paddingRight: {
                      type: "string",
                      content: "size",
                      label: "\u5361\u7247\u53f3\u65b9\u5185\u8fb9\u8ddd",
                    },
                  },
                },
                style: {
                  label: "\u6837\u5f0f",
                  props: {
                    borderRadius: {
                      type: "string",
                      label: "\u5361\u7247\u5706\u89d2",
                    },
                    backgroundColor: {
                      type: "string",
                      label: "\u5361\u7247\u80cc\u666f\u989c\u8272",
                      content: "color",
                    },
                    backgroundGradient: {
                      type: "string",
                      label: "\u5361\u7247\u80cc\u666f\u6e10\u53d8\u989c\u8272",
                      content: "color",
                    },
                    textColor: {
                      type: "select",
                      label: "\u5361\u7247\u5168\u5c40\u6587\u6848\u989c\u8272",
                      items: [
                        { value: "black", label: "\u9ed1\u5b57" },
                        { value: "white", label: "\u767d\u5b57" },
                      ],
                    },
                    linkColor: {
                      type: "select",
                      label: "\u5361\u7247\u94fe\u63a5\u989c\u8272",
                      items: [
                        { value: "black", label: "black-main" },
                        { value: "white", label: "white-main" },
                        { value: "dark", label: "primary-on-dark(blue-4)" },
                        { value: "normal", label: "primary-on-light(blue-6)" },
                      ],
                    },
                    linkFontSize: {
                      label: "\u5361\u7247\u94fe\u63a5\u5b57\u53f7",
                      type: "select",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "10px", value: "10px" },
                        { label: "12px", value: "12px" },
                        { label: "14px", value: "14px" },
                        { label: "16px", value: "16px" },
                        { label: "18px", value: "18px" },
                        { label: "20px", value: "20px" },
                        { label: "24px", value: "24px" },
                        { label: "28px", value: "28px" },
                        { label: "32px", value: "32px" },
                        { label: "40px", value: "40px" },
                        { label: "48px", value: "48px" },
                        { label: "56px", value: "56px" },
                        { label: "64px", value: "64px" },
                        { label: "72px", value: "72px" },
                        { label: "80px", value: "80px" },
                      ],
                    },
                    linkLineHeight: {
                      label: "\u5361\u7247\u94fe\u63a5\u884c\u9ad8",
                      type: "select",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                        {
                          label: "\u6807\u51c6\u884c\u9ad8",
                          value: "standard",
                        },
                      ],
                    },
                  },
                },
                jump: {
                  switch: "hasJumpLink",
                  label: "\u8df3\u8f6c\u94fe\u63a5",
                  props: {
                    jumpType: {
                      type: "select",
                      label: "\u94fe\u63a5\u7c7b\u578b",
                      items: [
                        {
                          value: "internal",
                          label: "\u7ad9\u5185\u94fe\u63a5",
                        },
                        {
                          value: "external",
                          label: "\u7ad9\u5916\u94fe\u63a5",
                        },
                      ],
                    },
                    jumpLink: {
                      label: "\u94fe\u63a5\u5730\u5740",
                      type: "string",
                      content: "url",
                    },
                    jumpLinkGaLabel: A({}, R),
                  },
                },
                backgroundImage: {
                  label: "\u80cc\u666f\u56fe\u7247\u8bbe\u7f6e",
                  switch: "hasBackgroundImage",
                  props: {
                    backgroundImage: {
                      type: "image",
                      label: "\u80cc\u666f\u56fe\u7247",
                    },
                    backgroundPosition: {
                      type: "string",
                      label: "\u80cc\u666f\u4f4d\u7f6e",
                    },
                    backgroundSize: {
                      type: "select",
                      label: "\u80cc\u666f\u5c3a\u5bf8",
                      items: [
                        {
                          value: "auto-fit",
                          label: "\u5168\u5c4f\u81ea\u9002\u5e94",
                        },
                        {
                          value: "custom-css",
                          label: "\u81ea\u5b9a\u4e49css\u5c5e\u6027",
                        },
                      ],
                    },
                    backgroundSizeCustom: {
                      type: "string",
                      label:
                        "\u80cc\u666f\u5c3a\u5bf8\u81ea\u5b9a\u4e49\u5c5e\u6027\u503c",
                      controlBy: "backgroundSize",
                      controlValue: "custom-css",
                    },
                    backgroundRepeat: {
                      type: "select",
                      label: "\u80cc\u666f\u91cd\u590d",
                      items: [
                        {
                          value: "repeat",
                          label: "\u6c34\u5e73\u5782\u76f4\u91cd\u590d",
                        },
                        {
                          value: "repeat-x",
                          label: "\u6c34\u5e73\u91cd\u590d",
                        },
                        {
                          value: "repeat-y",
                          label: "\u5782\u76f4\u91cd\u590d",
                        },
                        { value: "no-repeat", label: "\u4e0d\u91cd\u590d" },
                      ],
                    },
                    backgroundParallax: {
                      type: "boolean",
                      label: "\u80cc\u666f\u7eb5\u5411\u89c6\u5dee",
                    },
                    backgroundImageWidth: {
                      label: "\u80cc\u666f\u56fe\u7684\u5bbd\u5ea6",
                      type: "string",
                      content: "size",
                    },
                    backgroundImageHeight: {
                      label: "\u80cc\u666f\u56fe\u7684\u9ad8\u5ea6",
                      type: "string",
                      content: "size",
                    },
                  },
                },
                backgroundVideo: {
                  label: "\u80cc\u666f\u89c6\u9891\u8bbe\u7f6e",
                  switch: "hasBackgroundVideo",
                  props: {
                    backgroundVideo: {
                      type: "string",
                      label: "\u80cc\u666f\u89c6\u9891\u5730\u5740",
                      content: "url",
                    },
                    backgroundVideoWebm: {
                      type: "string",
                      label:
                        "\u80cc\u666f\u89c6\u9891\u5730\u5740\uff08webm\u683c\u5f0f, \u9009\u586b\uff09",
                      content: "url",
                    },
                    backgroundVideoLoop: {
                      type: "boolean",
                      label: "\u5faa\u73af\u64ad\u653e",
                    },
                    backgroundVideoVisiblePlay: {
                      type: "boolean",
                      label: "\u9875\u9762\u6eda\u52a8\u89e6\u53d1\u64ad\u653e",
                    },
                    backgroundVideoPoster: {
                      type: "image",
                      label: "\u89c6\u9891\u5c01\u9762\u56fe",
                    },
                    backgroundVideoHoverPlay: {
                      type: "boolean",
                      label: "\u9f20\u6807hover\u64ad\u653e",
                    },
                    backgroundVideoMaskColor: {
                      label:
                        "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u8272\u53f7 (\u9ed8\u8ba4#000000)",
                      type: "string",
                    },
                    backgroundVideoMaskOpacity: {
                      label:
                        "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u4e0d\u900f\u660e\u5ea6 (0-1, \u9ed8\u8ba40)",
                      type: "string",
                    },
                  },
                },
                foreground: {
                  label: "\u524d\u666f\u8bbe\u7f6e",
                  switch: "hasMedia",
                  props: {
                    media: {
                      label: "\u524d\u666f\u5185\u5bb9\u9009\u62e9",
                      type: "select",
                      items: [
                        { value: "picture", label: "\u56fe\u7247" },
                        { value: "video", label: "\u89c6\u9891" },
                      ],
                    },
                    mediaBorderRadius: {
                      label:
                        "\u524d\u666f\u56fe\u7247/\u89c6\u9891\u5706\u89d2",
                      type: "string",
                      content: "size",
                    },
                    mediaDistance: {
                      label: "\u8ddd\u79bb\u6587\u672c\u8fb9\u8ddd",
                      type: "string",
                      content: "size",
                    },
                    cardLayout: {
                      type: "select",
                      label: "\u524d\u666f\u5185\u5bb9\u4f4d\u7f6e",
                      items: [
                        {
                          value: "media-text",
                          label: "\u5de6\u56fe\u53f3\u6587",
                        },
                        {
                          value: "text-media",
                          label: "\u5de6\u6587\u53f3\u56fe",
                        },
                      ],
                    },
                    foregroundImage: {
                      type: "image",
                      label:
                        "------------------------------------\u524d\u666f\u56fe\u7247------------------------------------",
                    },
                    foregroundImageAlt: {
                      label: "\u524d\u666f\u56fe\u7247 Alt",
                      type: "string",
                      key: "picture-alt",
                      content: "text",
                    },
                    foregroundHasParallax: {
                      type: "boolean",
                      label:
                        "\u524d\u666f\u89c6\u5dee(\u4ec5\u5728\u5355\u56fe\u6a21\u5f0f\u4e0b\u751f\u6548)",
                    },
                    foregroundParallax: {
                      type: "select",
                      label: "\u524d\u666f\u89c6\u5dee\u65b9\u5f0f",
                      controlBy: "foregroundHasParallax",
                      controlValue: "true",
                      items: [
                        {
                          value: "whole-item",
                          label: "\u6574\u4f53\u89c6\u5dee",
                        },
                        {
                          value: "inner-content",
                          label: "\u5185\u90e8\u89c6\u5dee",
                        },
                      ],
                    },
                    foregroundHeight: {
                      type: "string",
                      label:
                        "\u524d\u666f\u5185\u5bb9\u9ad8\u5ea6(\u5f53\u9009\u62e9\u524d\u666f\u5185\u90e8\u89c6\u5dee\u65f6\u624d\u751f\u6548)",
                      content: "size",
                      controlBy: "foregroundHasParallax",
                      controlValue: "true",
                    },
                    foregroundVideo: {
                      type: "string",
                      label:
                        "------------------------------------\u524d\u666f\u89c6\u9891------------------------------------",
                      content: "url",
                    },
                    foregroundVideoWebm: {
                      type: "string",
                      label:
                        "\u524d\u666f\u89c6\u9891(webm \u683c\u5f0f\uff0c\u9009\u586b\uff09",
                      content: "url",
                    },
                    foregroundVideoPoster: {
                      type: "image",
                      label: "\u524d\u666f\u89c6\u9891\u5c01\u9762",
                    },
                    foregroundVideoPlayType: {
                      type: "select",
                      label: "\u524d\u666f\u89c6\u9891\u64ad\u653e\u65b9\u5f0f",
                      items: [
                        { value: "loop", label: "\u5faa\u73af\u64ad\u653e" },
                        { value: "once", label: "\u64ad\u653e\u4e00\u6b21" },
                        {
                          value: "replayWhenRevisible",
                          label:
                            "\u64ad\u653e\u4e00\u6b21\u505c\u6b62\uff0c\u56de\u5230\u8be5\u5c4f\u81ea\u52a8\u64ad\u653e",
                        },
                        {
                          value: "withController",
                          label:
                            "\u53ef\u63a7\u5236\u505c\u6b62/\u64ad\u653e/\u91cd\u64ad",
                        },
                      ],
                    },
                    foregroundLayout: {
                      label: "\u524d\u666f\u5185\u5bb9\u5e03\u5c40",
                      type: "select",
                      items: [
                        {
                          value: "one",
                          label:
                            "\u5355\u56fe\u5e03\u5c40(\u65e0\u9700\u586b\u524d\u666f\u6570\u7ec4)",
                        },
                        {
                          value: "leftRight",
                          label: "\u5de6\u53f3\u5e03\u5c40",
                        },
                        {
                          value: "up1down2",
                          label: "\u4e0a\u4e00\u4e0b\u4e8c",
                        },
                        {
                          value: "left2right1",
                          label: "\u5de6\u4e8c\u53f3\u4e00",
                        },
                      ],
                    },
                    foregroundListGap: {
                      label:
                        "\u524d\u666f\u6570\u7ec4\u95f4\u8ddd(\u4ec5\u5728\u975e\u5355\u56fe\u6a21\u5f0f\u4e0b\u751f\u6548)",
                      type: "string",
                    },
                    foregroundList: {
                      type: "array",
                      label: "\u524d\u666f\u6570\u7ec4",
                      props: {
                        media: {
                          label: "\u524d\u666f\u5185\u5bb9\u9009\u62e9",
                          type: "select",
                          items: [
                            { value: "", label: "\u8bf7\u9009\u62e9" },
                            { value: "picture", label: "\u56fe\u7247" },
                            { value: "video", label: "\u89c6\u9891" },
                          ],
                        },
                        mediaBorderRadius: {
                          label:
                            "\u524d\u666f\u56fe\u7247/\u89c6\u9891\u5706\u89d2",
                          type: "string",
                          content: "size",
                        },
                        foregroundImage: {
                          type: "image",
                          label:
                            "--------------------------------\u524d\u666f\u56fe\u7247--------------------------------",
                        },
                        foregroundImageAlt: {
                          label: "\u524d\u666f\u56fe\u7247 Alt",
                          type: "string",
                          key: "picture-alt",
                          content: "text",
                        },
                        foregroundVideo: {
                          type: "string",
                          label:
                            "--------------------------------\u524d\u666f\u89c6\u9891--------------------------------",
                          content: "url",
                        },
                        foregroundVideoWebm: {
                          type: "string",
                          label:
                            "\u524d\u666f\u89c6\u9891(webm \u683c\u5f0f\uff0c\u9009\u586b\uff09",
                          content: "url",
                        },
                        foregroundVideoPoster: {
                          type: "image",
                          label: "\u524d\u666f\u89c6\u9891\u5c01\u9762",
                        },
                        foregroundVideoPlayType: {
                          type: "select",
                          label:
                            "\u524d\u666f\u89c6\u9891\u64ad\u653e\u65b9\u5f0f",
                          items: [
                            { value: "", label: "\u8bf7\u9009\u62e9" },
                            {
                              value: "loop",
                              label: "\u5faa\u73af\u64ad\u653e",
                            },
                            {
                              value: "once",
                              label: "\u64ad\u653e\u4e00\u6b21",
                            },
                            {
                              value: "replayWhenRevisible",
                              label:
                                "\u64ad\u653e\u4e00\u6b21\u505c\u6b62\uff0c\u56de\u5230\u8be5\u5c4f\u81ea\u52a8\u64ad\u653e",
                            },
                            {
                              value: "withController",
                              label:
                                "\u53ef\u63a7\u5236\u505c\u6b62/\u64ad\u653e/\u91cd\u64ad",
                            },
                          ],
                        },
                      },
                    },
                    foregroundCredit: {
                      type: "string",
                      label: "\u524d\u666fcredit\u4fe1\u606f",
                      content: "text",
                    },
                    foregroundCreditFont: {
                      type: "font",
                      label:
                        "\u524d\u666fcredit\u4fe1\u606f-\u5b57\u4f53\u914d\u7f6e",
                    },
                  },
                },
                content: {
                  label: "\u6587\u672c\u5185\u5bb9\u8fb9\u8ddd",
                  props: {
                    contentPaddingTop: {
                      type: "string",
                      content: "size",
                      label: "\u6587\u672c\u4e0a\u65b9\u5185\u8fb9\u8ddd",
                    },
                    contentPaddingBottom: {
                      type: "string",
                      content: "size",
                      label: "\u6587\u672c\u4e0b\u65b9\u5185\u8fb9\u8ddd",
                    },
                    contentPaddingLeft: {
                      type: "string",
                      content: "size",
                      label: "\u6587\u672c\u5de6\u65b9\u5185\u8fb9\u8ddd",
                    },
                    contentPaddingRight: {
                      type: "string",
                      content: "size",
                      label: "\u6587\u672c\u53f3\u65b9\u5185\u8fb9\u8ddd",
                    },
                  },
                },
                toppingImage: {
                  switch: "hasToppingImage",
                  label: "\u9876\u90e8\u56fe\u8bbe\u7f6e",
                  props: {
                    toppingImage: {
                      type: "image",
                      label: "\u9876\u90e8\u56fe",
                    },
                    toppingImageHeight: {
                      type: "string",
                      label: "\u9876\u90e8\u56fe\u9ad8\u5ea6",
                    },
                    toppingAlt: {
                      label:
                        "\u9876\u90e8\u56fe\u7247\u81ea\u5b9a\u4e49alt\u6587\u6848",
                      type: "string",
                      content: "text",
                    },
                  },
                },
                tag: {
                  switch: "hasTag",
                  label: "\u6807\u7b7e\u8bbe\u7f6e",
                  props: {
                    tagText: {
                      type: "string",
                      content: "text",
                      label: "\u6807\u7b7e\u6587\u6848",
                      key: "tagText",
                    },
                    tagTextFont: {
                      type: "font",
                      label: "\u6807\u7b7e-\u5b57\u4f53\u914d\u7f6e",
                    },
                    tagHeight: {
                      type: "string",
                      label: "\u6807\u7b7e\u9ad8\u5ea6",
                    },
                    tagWidth: {
                      type: "string",
                      label: "\u6807\u7b7e\u5bbd\u5ea6",
                    },
                    tagColor: {
                      type: "string",
                      label: "\u6807\u7b7e\u80cc\u666f\u8272",
                    },
                    tagRadius: {
                      type: "string",
                      label: "\u6807\u7b7e\u5706\u89d2",
                    },
                  },
                },
                eyeBrow: {
                  switch: "hasEyeBrow",
                  label: "\u7709\u5934\u8bbe\u7f6e",
                  props: {
                    eyeBrowType: {
                      type: "select",
                      label: "\u7709\u5934\u7c7b\u578b",
                      items: [
                        { value: "svg", label: "svg" },
                        {
                          value: "pure-text",
                          label: "\u7eaf\u8272\u6587\u6848",
                        },
                        {
                          value: "gradient-text",
                          label: "\u6e10\u53d8\u8272\u6587\u6848",
                        },
                      ],
                    },
                    eyeBrowSVG: {
                      type: "image",
                      label: "\u7709\u5934SVG",
                      controlBy: "eyeBrowType",
                      controlValue: "svg",
                    },
                    eyeBrowSVGHeight: {
                      type: "string",
                      label: "\u7709\u5934SVG\u56fe\u7247\u9ad8\u5ea6",
                      controlBy: "eyeBrowType",
                      controlValue: "svg",
                    },
                    eyeBrowSvgShowFirst: {
                      label:
                        "svg\u662f\u5426\u5728\u9996\u5c4f\u663e\u793a\uff0c\u5982\u52fe\u9009\uff0c\u4f1a\u4f18\u5148\u52a0\u8f7d svg",
                      type: "boolean",
                      controlBy: "eyeBrowType",
                      controlValue: "svg",
                    },
                    eyeBrowText: {
                      type: "string",
                      content: "text",
                      key: "eyebrow",
                      label: "\u7709\u5934\u6587\u6848",
                      controlBy: "eyeBrowType",
                      controlValue: ["pure-text", "gradient-text"],
                    },
                    eyeBrowTag: A({}, s.g),
                    eyeBrowPureColor: {
                      type: "string",
                      content: "color",
                      label: "\u7709\u5934\u6587\u5b57\u7eaf\u8272\u989c\u8272",
                      controlBy: "eyeBrowType",
                      controlValue: "pure-text",
                    },
                    eyeBrowGradientColor: {
                      type: "string",
                      content: "color",
                      label:
                        "\u7709\u5934\u6587\u5b57\u6e10\u53d8\u8272\u989c\u8272",
                      controlBy: "eyeBrowType",
                      controlValue: "gradient-text",
                    },
                    eyeBrowIEGradientColor: {
                      type: "string",
                      content: "color",
                      label:
                        "\u7709\u5934\u6587\u5b57\u6e10\u53d8\u8272\u989c\u8272-IE\u964d\u7ea7",
                      controlBy: "eyeBrowType",
                      controlValue: "gradient-text",
                    },
                    eyeBrowFontSize: {
                      label: "\u5b57\u53f7",
                      type: "select",
                      controlBy: "eyeBrowType",
                      controlValue: "pure-text gradient-text",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "10px", value: "10px" },
                        { label: "12px", value: "12px" },
                        { label: "14px", value: "14px" },
                        { label: "16px", value: "16px" },
                        { label: "18px", value: "18px" },
                        { label: "20px", value: "20px" },
                        { label: "24px", value: "24px" },
                        { label: "28px", value: "28px" },
                        { label: "32px", value: "32px" },
                        { label: "40px", value: "40px" },
                        { label: "48px", value: "48px" },
                        { label: "56px", value: "56px" },
                        { label: "64px", value: "64px" },
                        { label: "72px", value: "72px" },
                        { label: "80px", value: "80px" },
                      ],
                    },
                    eyeBrowFontWeight: {
                      label: "\u5b57\u91cd",
                      type: "select",
                      controlBy: "eyeBrowType",
                      controlValue: "pure-text gradient-text",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "Regular", value: "regular" },
                        { label: "SemiBold", value: "semibold" },
                      ],
                    },
                    eyeBrowLineHeight: {
                      label: "\u884c\u9ad8",
                      type: "select",
                      controlBy: "eyeBrowFontSize",
                      controlValue: !0,
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                        {
                          label: "\u6807\u51c6\u884c\u9ad8",
                          value: "standard",
                        },
                      ],
                    },
                  },
                },
                headline: {
                  switch: "hasHeadline",
                  label: "\u4e3b\u6807\u9898\u8bbe\u7f6e",
                  props: {
                    headlineType: {
                      type: "select",
                      label: "\u4e3b\u6807\u9898\u7c7b\u578b",
                      items: [
                        {
                          value: "svg",
                          label: "svg / SEO \u9690\u85cf\u5f0f\u6807\u9898",
                        },
                        {
                          value: "pure-text",
                          label: "\u7eaf\u8272\u6587\u6848",
                        },
                        {
                          value: "gradient-text",
                          label: "\u6e10\u53d8\u8272\u6587\u6848",
                        },
                      ],
                    },
                    headlineSVG: {
                      type: "image",
                      label: "\u4e3b\u6807\u9898SVG",
                      controlBy: "headlineType",
                      controlValue: "svg",
                    },
                    headlineSVGHeight: {
                      type: "string",
                      label: "\u4e3b\u6807\u9898SVG\u56fe\u7247\u9ad8\u5ea6",
                      controlBy: "headlineType",
                      controlValue: "svg",
                    },
                    headlineSvgShowFirst: {
                      label:
                        "svg\u662f\u5426\u5728\u9996\u5c4f\u663e\u793a\uff0c\u5982\u52fe\u9009\uff0c\u4f1a\u4f18\u5148\u52a0\u8f7d svg",
                      type: "boolean",
                      controlBy: "headlineType",
                      controlValue: "svg",
                    },
                    headlineText: {
                      type: "string",
                      content: "text",
                      label: "\u4e3b\u6807\u9898\u6587\u6848",
                      key: "headline",
                      controlBy: "headlineType",
                      controlValue: ["pure-text", "gradient-text"],
                    },
                    headlineTag: A({}, s.g),
                    headlinePureColor: {
                      type: "string",
                      content: "color",
                      label:
                        "\u4e3b\u6807\u9898\u6587\u5b57\u7eaf\u8272\u989c\u8272",
                      controlBy: "headlineType",
                      controlValue: "pure-text",
                    },
                    headlineGradientColor: {
                      type: "string",
                      content: "color",
                      label:
                        "\u4e3b\u6807\u9898\u6587\u5b57\u6e10\u53d8\u8272\u989c\u8272",
                      controlBy: "headlineType",
                      controlValue: "gradient-text",
                    },
                    headlineIEGradientColor: {
                      type: "string",
                      content: "color",
                      label:
                        "\u4e3b\u6807\u9898\u6587\u5b57\u6e10\u53d8\u8272\u989c\u8272-IE\u964d\u7ea7",
                      controlBy: "headlineType",
                      controlValue: "gradient-text",
                    },
                    headlineFontSize: {
                      label: "\u5b57\u53f7",
                      type: "select",
                      controlBy: "headlineType",
                      controlValue: "pure-text gradient-text",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "10px", value: "10px" },
                        { label: "12px", value: "12px" },
                        { label: "14px", value: "14px" },
                        { label: "16px", value: "16px" },
                        { label: "18px", value: "18px" },
                        { label: "20px", value: "20px" },
                        { label: "24px", value: "24px" },
                        { label: "28px", value: "28px" },
                        { label: "32px", value: "32px" },
                        { label: "40px", value: "40px" },
                        { label: "48px", value: "48px" },
                        { label: "56px", value: "56px" },
                        { label: "64px", value: "64px" },
                        { label: "72px", value: "72px" },
                        { label: "80px", value: "80px" },
                      ],
                    },
                    headlineFontWeight: {
                      label: "\u5b57\u91cd",
                      type: "select",
                      controlBy: "headlineType",
                      controlValue: "pure-text gradient-text",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "Regular", value: "regular" },
                        { label: "SemiBold", value: "semibold" },
                      ],
                    },
                    headlineLineHeight: {
                      label: "\u884c\u9ad8",
                      type: "select",
                      controlBy: "headlineFontSize",
                      controlValue: !0,
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                        {
                          label: "\u6807\u51c6\u884c\u9ad8",
                          value: "standard",
                        },
                      ],
                    },
                  },
                },
                subhead: {
                  switch: "hasSubHeadline",
                  label: "\u526f\u6807\u9898\u8bbe\u7f6e",
                  props: {
                    subHeadlineType: {
                      label: "\u526f\u6807\u9898\u7c7b\u578b",
                      type: "select",
                      items: [
                        {
                          label: "\u7eaf\u8272\u6587\u6848",
                          value: "pure-text",
                        },
                        {
                          label: "\u6e10\u53d8\u6587\u6848",
                          value: "gradient-text",
                        },
                      ],
                    },
                    subHeadlineText: {
                      type: "string",
                      content: "text",
                      label: "\u526f\u6807\u9898\u6587\u6848",
                      key: "subtitle",
                      controlBy: "subHeadlineType",
                      controlValue: ["pure-text", "gradient-text"],
                    },
                    subHeadlineTag: A({}, s.g),
                    subHeadlineColor: {
                      type: "string",
                      content: "color",
                      label: "\u526f\u6807\u9898\u6587\u5b57\u989c\u8272",
                      controlBy: "subHeadlineType",
                      controlValue: "pure-text",
                    },
                    subHeadlineGradientColor: {
                      type: "string",
                      content: "color",
                      label: "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c",
                      controlBy: "subHeadlineType",
                      controlValue: "gradient-text",
                    },
                    subHeadlineIEGradientColor: {
                      type: "string",
                      content: "color",
                      label:
                        "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c-IE\u964d\u7ea7",
                      controlBy: "subHeadlineType",
                      controlValue: "gradient-text",
                    },
                    subHeadlineFontSize: {
                      label: "\u5b57\u53f7",
                      type: "select",
                      controlBy: "subHeadlineType",
                      controlValue: ["pure-text", "gradient-text"],
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "10px", value: "10px" },
                        { label: "12px", value: "12px" },
                        { label: "14px", value: "14px" },
                        { label: "16px", value: "16px" },
                        { label: "18px", value: "18px" },
                        { label: "20px", value: "20px" },
                        { label: "24px", value: "24px" },
                        { label: "28px", value: "28px" },
                        { label: "32px", value: "32px" },
                        { label: "40px", value: "40px" },
                        { label: "48px", value: "48px" },
                        { label: "56px", value: "56px" },
                        { label: "64px", value: "64px" },
                        { label: "72px", value: "72px" },
                        { label: "80px", value: "80px" },
                      ],
                    },
                    subHeadlineFontWeight: {
                      label: "\u5b57\u91cd",
                      type: "select",
                      controlBy: "subHeadlineType",
                      controlValue: ["pure-text", "gradient-text"],
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "Regular", value: "regular" },
                        { label: "SemiBold", value: "semibold" },
                      ],
                    },
                    subHeadlineLineHeight: {
                      label: "\u884c\u9ad8",
                      type: "select",
                      controlBy: "subHeadlineFontSize",
                      controlValue: !0,
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                        {
                          label: "\u6807\u51c6\u884c\u9ad8",
                          value: "standard",
                        },
                      ],
                    },
                  },
                },
                divider: {
                  switch: "hasDividedLine",
                  label: "\u5206\u5272\u7ebf\u8bbe\u7f6e",
                  props: {
                    dividedBlockHeight: {
                      type: "string",
                      label: "\u6a21\u5757\u9ad8\u5ea6",
                    },
                    dividedLineWidth: {
                      type: "string",
                      label: "\u7ebf\u6761\u5bbd\u5ea6",
                    },
                    dividedLineHeight: {
                      type: "string",
                      label: "\u9ad8\u5ea6",
                    },
                    dividedLineRadius: {
                      type: "string",
                      label: "\u5706\u89d2",
                    },
                    dividedLineColor: {
                      type: "string",
                      content: "color",
                      label: "\u989c\u8272",
                    },
                    dividedLineGradientColor: {
                      type: "string",
                      content: "color",
                      label: "\u6e10\u53d8\u8272",
                    },
                  },
                },
                description: {
                  switch: "hasDescription",
                  label: "\u8be6\u7ec6\u4ecb\u7ecd\u8bbe\u7f6e",
                  props: {
                    descriptionColor: {
                      type: "string",
                      content: "color",
                      label: "\u8be6\u7ec6\u4ecb\u7ecd\u6587\u5b57\u989c\u8272",
                    },
                    descriptionText: {
                      type: "string",
                      content: "text",
                      key: "description",
                      label: "\u8be6\u7ec6\u4ecb\u7ecd\u6587\u6848",
                    },
                    descriptionFontSize: {
                      label: "\u5b57\u53f7",
                      type: "select",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "10px", value: "10px" },
                        { label: "12px", value: "12px" },
                        { label: "14px", value: "14px" },
                        { label: "16px", value: "16px" },
                        { label: "18px", value: "18px" },
                        { label: "20px", value: "20px" },
                        { label: "24px", value: "24px" },
                        { label: "28px", value: "28px" },
                        { label: "32px", value: "32px" },
                        { label: "40px", value: "40px" },
                        { label: "48px", value: "48px" },
                        { label: "56px", value: "56px" },
                        { label: "64px", value: "64px" },
                        { label: "72px", value: "72px" },
                        { label: "80px", value: "80px" },
                      ],
                    },
                    descriptionFontWeight: {
                      label: "\u5b57\u91cd",
                      type: "select",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "Regular", value: "regular" },
                        { label: "SemiBold", value: "semibold" },
                      ],
                    },
                    descriptionLineHeight: {
                      label: "\u884c\u9ad8",
                      type: "select",
                      controlBy: "descriptionFontSize",
                      controlValue: !0,
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                        {
                          label: "\u6807\u51c6\u884c\u9ad8",
                          value: "standard",
                        },
                      ],
                    },
                  },
                },
                relatedCommodity: {
                  switch: "hasRelatedCommodity",
                  label: "\u5173\u8054\u5546\u54c1\u8bbe\u7f6e",
                  props: {
                    commodityEan: {
                      type: "string",
                      label: "\u5173\u8054\u5546\u54c1ean\u7801",
                    },
                    commoditySlug: {
                      type: "string",
                      label: "\u5173\u8054\u5546\u54c1slug",
                    },
                    priceTextFont: {
                      type: "font",
                      label: "\u4ef7\u683c-\u5b57\u4f53\u914d\u7f6e",
                    },
                    originPriceTextFont: {
                      type: "font",
                      label: "\u539f\u4ef7\u683c-\u5b57\u4f53\u914d\u7f6e",
                    },
                  },
                },
                buttonListTypeColumn: {
                  label:
                    "\u6309\u94ae\u6392\u5217\u65b9\u5f0f(\u9ed8\u8ba4\u6a2a\u5411\u6392\u5217)",
                  props: {
                    buttonListTypeColumn: {
                      label:
                        "\u6309\u94ae\u6392\u5217\u65b9\u5f0f(\u9ed8\u8ba4\u6a2a\u5411\u6392\u5217)",
                      type: "boolean",
                    },
                  },
                },
                primaryButton: {
                  switch: "hasPrimaryButton",
                  label: "\u4e3b\u6309\u94ae\u8bbe\u7f6e",
                  props: {
                    primaryButtonType: {
                      type: "select",
                      label: "\u4e3b\u6309\u94ae\u7c7b\u578b",
                      items: [
                        { value: "button", label: "\u6309\u94ae" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                        {
                          value: "video-play",
                          label: "\u89c6\u9891\u64ad\u653e",
                        },
                      ],
                    },
                    primaryButtonColor: {
                      type: "select",
                      label: "\u989c\u8272",
                      items: [
                        { value: "dark", label: "\u9ed1\u8272" },
                        { value: "light", label: "\u767d\u8272" },
                        { value: "primary", label: "\u84dd\u8272" },
                      ],
                    },
                    primaryButtonLink: {
                      type: "string",
                      label: "\u94fe\u63a5",
                      content: "url",
                    },
                    primaryButtonText: {
                      type: "string",
                      label: "\u6587\u6848",
                      content: "text",
                      key: "button-text",
                    },
                    primaryButtonGaLabel: A({}, R),
                    primaryButtonSize: {
                      type: "select",
                      label: "\u4e3b\u6309\u94ae\u5c3a\u5bf8",
                      items: [
                        { value: "xl", label: "xl(48)" },
                        { value: "lg", label: "l(40)" },
                        { value: "md", label: "m(32)" },
                        { value: "sm", label: "s(24)" },
                      ],
                    },
                    primaryButtonMinWidth: {
                      type: "string",
                      label: "\u4e3b\u6309\u94ae\u6700\u5c0f\u5bbd\u5ea6",
                      content: "size",
                    },
                  },
                },
                secondaryButton: {
                  switch: "hasSecondaryButton",
                  label: "\u6b21\u6309\u94ae\u8bbe\u7f6e",
                  props: {
                    secondaryButtonType: {
                      type: "select",
                      label: "\u6b21\u6309\u94ae\u7c7b\u578b",
                      items: [
                        { value: "button", label: "\u6309\u94ae" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "video-play",
                          label: "\u89c6\u9891\u64ad\u653e",
                        },
                        {
                          value: "internal-link",
                          label: "\u7ad9\u5185\u94fe\u63a5",
                        },
                        {
                          value: "external-link",
                          label: "\u7ad9\u5916\u94fe\u63a5",
                        },
                        {
                          value: "download-link",
                          label: "\u4e0b\u8f7d\u94fe\u63a5",
                        },
                        {
                          value: "no-icon-link",
                          label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                        },
                        { value: "3Dtype", label: "3D \u6309\u94ae" },
                        { value: "ARtype", label: "AR \u6309\u94ae" },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                        {
                          value: "zoom-button",
                          label: "\u56fe\u7247\u5f39\u7a97\u6309\u94ae",
                        },
                      ],
                    },
                    secondaryButtonClickID: {
                      type: "string",
                      label: "button\u7ed1\u5b9a\u76843D/AR\u7ec4\u4ef6ID",
                      controlBy: "secondaryButtonType",
                      controlValue: ["3Dtype", "ARtype"],
                    },
                    secondaryButtonColor: {
                      type: "select",
                      label: "\u6b21\u6309\u94ae\u989c\u8272",
                      controlBy: "secondaryButtonType",
                      controlValue: [
                        "button",
                        "video-play",
                        "external-button",
                        "3Dtype",
                        "ARtype",
                        "zoom-button",
                      ],
                      items: [
                        { value: "secondary-dark", label: "\u9ed1\u8272" },
                        { value: "secondary-light", label: "\u767d\u8272" },
                      ],
                    },
                    secondaryButtonLink: {
                      type: "string",
                      label: "\u6b21\u6309\u94ae\u94fe\u63a5",
                      content: "url",
                    },
                    secondaryButtonText: {
                      type: "string",
                      label: "\u6b21\u6309\u94ae\u6587\u6848",
                      content: "text",
                      key: "second-text",
                    },
                    secondaryButtonGaLabel: A({}, R),
                    secondaryButtonSize: {
                      type: "select",
                      label: "\u6b21\u6309\u94ae\u5c3a\u5bf8",
                      items: [
                        { value: "xl", label: "xl(48)" },
                        { value: "lg", label: "l(40)" },
                        { value: "md", label: "m(32)" },
                        { value: "sm", label: "s(24)" },
                      ],
                    },
                    secondaryButtonMinWidth: {
                      type: "string",
                      label: "\u4e3b\u6309\u94ae\u6700\u5c0f\u5bbd\u5ea6",
                      content: "size",
                    },
                    secondaryButtonZoomImageRawWidth: {
                      label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u5bbd\u5ea6",
                      helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "secondaryButtonType",
                      controlValue: "zoom-button",
                    },
                    secondaryButtonZoomImageRawHeight: {
                      label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u9ad8\u5ea6",
                      helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "secondaryButtonType",
                      controlValue: "zoom-button",
                    },
                    secondaryButtonZoomTilesUrl: {
                      label: "\u56fe\u7247\u5408\u96c6\u5730\u5740",
                      helptext: "\u5fc5\u586b",
                      type: "string",
                      content: "url",
                      controlBy: "secondaryButtonType",
                      controlValue: "zoom-button",
                    },
                    secondaryButtonZoomDefaultZoomLevel: {
                      label: "\u9ed8\u8ba4\u653e\u5927\u500d\u6570",
                      helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "secondaryButtonType",
                      controlValue: "zoom-button",
                    },
                    secondaryButtonZoomMinZoomLevel: {
                      label: "\u6700\u5c0f\u653e\u5927\u500d\u6570",
                      helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "secondaryButtonType",
                      controlValue: "zoom-button",
                    },
                    secondaryButtonZoomMaxZoomLevel: {
                      label: "\u6700\u5927\u653e\u5927\u500d\u6570",
                      helptext: "\u9009\u586b\uff0c\u6570\u5b57 <= 6",
                      type: "number",
                      controlBy: "secondaryButtonType",
                      controlValue: "zoom-button",
                    },
                  },
                },
                thirdlyButton: {
                  switch: "hasThirdlyButton",
                  label: "\u6b21\u6309\u94ae2\u8bbe\u7f6e",
                  props: {
                    thirdlyButtonType: {
                      type: "select",
                      label: "\u6b21\u6309\u94ae2\u7c7b\u578b",
                      items: [
                        { value: "button", label: "\u6309\u94ae" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "video-play",
                          label: "\u89c6\u9891\u64ad\u653e",
                        },
                        {
                          value: "internal-link",
                          label: "\u7ad9\u5185\u94fe\u63a5",
                        },
                        {
                          value: "external-link",
                          label: "\u7ad9\u5916\u94fe\u63a5",
                        },
                        {
                          value: "download-link",
                          label: "\u4e0b\u8f7d\u94fe\u63a5",
                        },
                        {
                          value: "no-icon-link",
                          label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                        },
                        { value: "3Dtype", label: "3D \u6309\u94ae" },
                        { value: "ARtype", label: "AR \u6309\u94ae" },
                        {
                          value: "zoom-button",
                          label: "\u56fe\u7247\u5f39\u7a97\u6309\u94ae",
                        },
                      ],
                    },
                    thirdlyButtonClickID: {
                      type: "string",
                      label: "button\u7ed1\u5b9a\u76843D/AR\u7ec4\u4ef6ID",
                      controlBy: "thirdlyButtonType",
                      controlValue: ["3Dtype", "ARtype"],
                    },
                    thirdlyButtonColor: {
                      type: "select",
                      label: "\u6b21\u6309\u94ae2\u989c\u8272",
                      controlBy: "thirdlyButtonType",
                      controlValue: [
                        "button",
                        "video-play",
                        "external-button",
                        "3Dtype",
                        "ARtype",
                        "zoom-button",
                      ],
                      items: [
                        { value: "secondary-dark", label: "\u9ed1\u8272" },
                        { value: "secondary-light", label: "\u767d\u8272" },
                      ],
                    },
                    thirdlyButtonLink: {
                      type: "string",
                      label: "\u6b21\u6309\u94ae2\u94fe\u63a5",
                      content: "url",
                    },
                    thirdlyButtonText: {
                      type: "string",
                      label: "\u6b21\u6309\u94ae2\u6587\u6848",
                      content: "text",
                      key: "second-text",
                    },
                    thirdlyButtonGaLabel: A({}, R),
                    thirdlyButtonSize: {
                      type: "select",
                      label: "\u6b21\u6309\u94ae2\u5c3a\u5bf8",
                      items: [
                        { value: "xl", label: "xl(48)" },
                        { value: "lg", label: "l(40)" },
                        { value: "md", label: "m(32)" },
                        { value: "sm", label: "s(24)" },
                      ],
                    },
                    thirdlyButtonMinWidth: {
                      type: "string",
                      label: "\u4e3b\u6309\u94ae2\u6700\u5c0f\u5bbd\u5ea6",
                      content: "size",
                    },
                    thirdlyButtonZoomImageRawWidth: {
                      label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u5bbd\u5ea6",
                      helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "thirdlyButtonType",
                      controlValue: "zoom-button",
                    },
                    thirdlyButtonZoomImageRawHeight: {
                      label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u9ad8\u5ea6",
                      helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "thirdlyButtonType",
                      controlValue: "zoom-button",
                    },
                    thirdlyButtonZoomTilesUrl: {
                      label: "\u56fe\u7247\u5408\u96c6\u5730\u5740",
                      helptext: "\u5fc5\u586b",
                      type: "string",
                      content: "url",
                      controlBy: "thirdlyButtonType",
                      controlValue: "zoom-button",
                    },
                    thirdlyButtonZoomDefaultZoomLevel: {
                      label: "\u9ed8\u8ba4\u653e\u5927\u500d\u6570",
                      helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "thirdlyButtonType",
                      controlValue: "zoom-button",
                    },
                    thirdlyButtonZoomMinZoomLevel: {
                      label: "\u6700\u5c0f\u653e\u5927\u500d\u6570",
                      helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                      type: "number",
                      controlBy: "thirdlyButtonType",
                      controlValue: "zoom-button",
                    },
                    thirdlyButtonZoomMaxZoomLevel: {
                      label: "\u6700\u5927\u653e\u5927\u500d\u6570",
                      helptext: "\u9009\u586b\uff0c\u6570\u5b57, <= 6",
                      type: "number",
                      controlBy: "thirdlyButtonType",
                      controlValue: "zoom-button",
                    },
                  },
                },
                downloadButton: {
                  switch: "hasDownloadButton",
                  label: "\u4e0b\u8f7d\u6309\u94ae\u8bbe\u7f6e",
                  props: {
                    hasAppStoreButton: {
                      type: "boolean",
                      label: "App Store\u4e0b\u8f7d",
                    },
                    appStoreButtonLink: {
                      type: "string",
                      content: "url",
                      label: "App Store\u4e0b\u8f7d\u94fe\u63a5",
                      controlBy: "hasAppStoreButton",
                      controlValue: !0,
                    },
                    appStoreButtonGaLabel: A(
                      A({}, R),
                      {},
                      { controlBy: "hasAppStoreButton", controlValue: !0 },
                    ),
                    hasAndroidButton: {
                      type: "boolean",
                      label: "Android\u4e0b\u8f7d",
                    },
                    androidButtonLink: {
                      type: "string",
                      label: "Android\u4e0b\u8f7d\u94fe\u63a5",
                      content: "url",
                      controlBy: "hasAndroidButton",
                      controlValue: !0,
                    },
                    androidButtonGaLabel: A(
                      A({}, R),
                      {},
                      { controlBy: "hasAndroidButton", controlValue: !0 },
                    ),
                    hasGooglePlayButton: {
                      type: "boolean",
                      label: "Google Play\u4e0b\u8f7d",
                    },
                    googlePlayButtonLink: {
                      type: "string",
                      label: "Google Play\u4e0b\u8f7d\u94fe\u63a5",
                      content: "url",
                      controlBy: "hasGooglePlayButton",
                      controlValue: !0,
                    },
                    googlePlayButtonGaLabel: A(
                      A({}, R),
                      {},
                      { controlBy: "hasGooglePlayButton", controlValue: !0 },
                    ),
                  },
                },
                modalButton: l.k.modalButton,
                note: {
                  switch: "hasNote",
                  label: "\u5907\u6ce8\u8bbe\u7f6e",
                  props: {
                    noteMarginTop: {
                      type: "string",
                      label: "\u5907\u6ce8\u4e0a\u8fb9\u8ddd",
                    },
                    noteText: {
                      type: "string",
                      label: "\u5907\u6ce8\u6587\u6848",
                      content: "text",
                      key: "remark",
                    },
                    noteColor: {
                      type: "string",
                      label: "\u5907\u6ce8\u989c\u8272",
                      content: "color",
                    },
                    noteFontSize: {
                      label: "\u5b57\u53f7",
                      type: "select",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "10px", value: "10px" },
                        { label: "12px", value: "12px" },
                        { label: "14px", value: "14px" },
                        { label: "16px", value: "16px" },
                        { label: "18px", value: "18px" },
                        { label: "20px", value: "20px" },
                        { label: "24px", value: "24px" },
                        { label: "28px", value: "28px" },
                        { label: "32px", value: "32px" },
                        { label: "40px", value: "40px" },
                        { label: "48px", value: "48px" },
                        { label: "56px", value: "56px" },
                        { label: "64px", value: "64px" },
                        { label: "72px", value: "72px" },
                        { label: "80px", value: "80px" },
                      ],
                    },
                    noteFontWeight: {
                      label: "\u5b57\u91cd",
                      type: "select",
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "Regular", value: "regular" },
                        { label: "SemiBold", value: "semibold" },
                      ],
                    },
                    noteLineHeight: {
                      label: "\u884c\u9ad8",
                      type: "select",
                      controlBy: "noteFontSize",
                      controlValue: !0,
                      items: [
                        { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                        { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                        {
                          label: "\u6807\u51c6\u884c\u9ad8",
                          value: "standard",
                        },
                      ],
                    },
                  },
                },
                links: {
                  label: "\u94fe\u63a5",
                  switch: "hasCardLinks",
                  props: {
                    links: {
                      label: "\u94fe\u63a5",
                      type: "array",
                      props: {
                        linkType: {
                          label: "\u7c7b\u578b",
                          type: "select",
                          items: [
                            {
                              label: "\u7ad9\u5185\u94fe\u63a5",
                              value: "internal-link",
                            },
                            {
                              label: "\u7ad9\u5916\u94fe\u63a5",
                              value: "external-link",
                            },
                            {
                              label: "\u4e0b\u8f7d\u94fe\u63a5",
                              value: "download-link",
                            },
                            {
                              label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                              value: "no-icon-link",
                            },
                          ],
                        },
                        text: {
                          label: "\u94fe\u63a5url",
                          type: "string",
                          content: "url",
                        },
                        linkText: {
                          label: "\u94fe\u63a5\u6587\u6848",
                          type: "string",
                          content: "text",
                          key: "link-text",
                        },
                        linkGaLabel: A({}, R),
                      },
                    },
                  },
                },
                icons1: {
                  switch: "hasIcons1",
                  label: "\u7b2c\u4e00\u884cicon\u8bbe\u7f6e",
                  props: {
                    icons1MaxWidth: {
                      type: "string",
                      label:
                        "icon\u6240\u6709\u5185\u5bb9\u6700\u5927\u5bbd\u5ea6",
                      content: "size",
                      controlBy: "icons1Layout",
                      controlValue: "horizontal",
                    },
                    icons1Layout: {
                      label: "icon\u6392\u5217\u65b9\u5f0f",
                      type: "select",
                      items: [
                        {
                          label: "\u5782\u76f4\u5e03\u5c40",
                          value: "vertical",
                        },
                        {
                          label: "\u5de6\u53f3\u5e03\u5c40",
                          value: "horizontal",
                        },
                      ],
                    },
                    icons1Height: {
                      type: "string",
                      label: "icon\u56fe\u6807\u9ad8\u5ea6",
                      content: "size",
                    },
                    icons1: {
                      label: "icons",
                      key: "icons1",
                      type: "array",
                      props: {
                        title: {
                          switch: "hasTitle",
                          label: "\u6807\u9898",
                          type: "string",
                          key: "text",
                          content: "text",
                        },
                        pic: { switch: "hasPic", label: "icon", type: "image" },
                        iconAlt: {
                          label:
                            "icon\u56fe\u7247\u81ea\u5b9a\u4e49alt\u6587\u6848",
                          helptext:
                            "\u9009\u586b\uff0c\u4e3a\u7a7a\u65f6\u56fe\u7247alt\u9ed8\u8ba4\u53d6icon\u6807\u9898/\u63cf\u8ff0",
                          type: "string",
                          content: "text",
                        },
                        desc: {
                          switch: "hasDesc",
                          label: "\u63cf\u8ff0",
                          type: "string",
                          key: "description",
                          content: "text",
                        },
                        number: {
                          switch: "hasNumber",
                          label: "\u6570\u5b57",
                          type: "string",
                          key: "number",
                          content: "text",
                        },
                        unit: {
                          switch: "hasUnit",
                          label: "\u5355\u4f4d",
                          type: "string",
                          key: "unit",
                          content: "text",
                        },
                        titleColor: {
                          label:
                            "\u6807\u9898/\u6570\u5b57/\u5355\u4f4d\u989c\u8272",
                          type: "string",
                          content: "color",
                        },
                        descColor: {
                          label: "\u63cf\u8ff0\u989c\u8272",
                          type: "string",
                          content: "color",
                        },
                        titleFontSize: {
                          label: "\u6807\u9898\u5b57\u53f7",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "10px", value: "10px" },
                            { label: "12px", value: "12px" },
                            { label: "14px", value: "14px" },
                            { label: "16px", value: "16px" },
                            { label: "18px", value: "18px" },
                            { label: "20px", value: "20px" },
                            { label: "24px", value: "24px" },
                            { label: "28px", value: "28px" },
                            { label: "32px", value: "32px" },
                            { label: "40px", value: "40px" },
                            { label: "48px", value: "48px" },
                            { label: "56px", value: "56px" },
                            { label: "64px", value: "64px" },
                            { label: "72px", value: "72px" },
                            { label: "80px", value: "80px" },
                          ],
                        },
                        titleFontWeight: {
                          label: "\u6807\u9898\u5b57\u91cd",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "Regular", value: "regular" },
                            { label: "SemiBold", value: "semibold" },
                          ],
                        },
                        titleLineHeight: {
                          label: "\u6807\u9898\u884c\u9ad8",
                          type: "select",
                          controlBy: "titleFontSize",
                          controlValue: !0,
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            {
                              label: "\u7d27\u51d1\u884c\u9ad8",
                              value: "compact",
                            },
                            {
                              label: "\u6807\u51c6\u884c\u9ad8",
                              value: "standard",
                            },
                          ],
                        },
                        descFontSize: {
                          label: "\u63cf\u8ff0\u5b57\u53f7",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "10px", value: "10px" },
                            { label: "12px", value: "12px" },
                            { label: "14px", value: "14px" },
                            { label: "16px", value: "16px" },
                            { label: "18px", value: "18px" },
                            { label: "20px", value: "20px" },
                            { label: "24px", value: "24px" },
                            { label: "28px", value: "28px" },
                            { label: "32px", value: "32px" },
                            { label: "40px", value: "40px" },
                            { label: "48px", value: "48px" },
                            { label: "56px", value: "56px" },
                            { label: "64px", value: "64px" },
                            { label: "72px", value: "72px" },
                            { label: "80px", value: "80px" },
                          ],
                        },
                        descFontWeight: {
                          label: "\u63cf\u8ff0\u5b57\u91cd",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "Regular", value: "regular" },
                            { label: "SemiBold", value: "semibold" },
                          ],
                        },
                        descLineHeight: {
                          label: "\u63cf\u8ff0\u884c\u9ad8",
                          type: "select",
                          controlBy: "descFontSize",
                          controlValue: !0,
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            {
                              label: "\u7d27\u51d1\u884c\u9ad8",
                              value: "compact",
                            },
                            {
                              label: "\u6807\u51c6\u884c\u9ad8",
                              value: "standard",
                            },
                          ],
                        },
                      },
                    },
                  },
                },
                icons2: {
                  switch: "hasIcons2",
                  label: "\u7b2c\u4e8c\u884cicon\u8bbe\u7f6e",
                  props: {
                    icons2MaxWidth: {
                      type: "string",
                      label:
                        "icon\u6240\u6709\u5185\u5bb9\u6700\u5927\u5bbd\u5ea6",
                      content: "size",
                      controlBy: "icons2Layout",
                      controlValue: "horizontal",
                    },
                    icons2Layout: {
                      label: "icon\u6392\u5217\u65b9\u5f0f",
                      type: "select",
                      items: [
                        {
                          label: "\u5782\u76f4\u5e03\u5c40",
                          value: "vertical",
                        },
                        {
                          label: "\u5de6\u53f3\u5e03\u5c40",
                          value: "horizontal",
                        },
                      ],
                    },
                    icons2Height: {
                      type: "string",
                      label: "icon\u56fe\u6807\u9ad8\u5ea6",
                      content: "size",
                    },
                    icons2: {
                      label: "icons",
                      type: "array",
                      key: "icons2",
                      props: {
                        title: {
                          switch: "hasTitle",
                          label: "\u6807\u9898",
                          type: "string",
                          key: "text",
                          content: "text",
                        },
                        pic: { switch: "hasPic", label: "icon", type: "image" },
                        iconAlt: {
                          label: "icon\u81ea\u5b9a\u4e49alt\u6587\u6848",
                          helptext:
                            "\u9009\u586b\uff0c\u4e3a\u7a7a\u65f6\u56fe\u7247alt\u9ed8\u8ba4\u53d6icon\u6807\u9898/\u63cf\u8ff0",
                          type: "string",
                          content: "text",
                        },
                        desc: {
                          switch: "hasDesc",
                          label: "\u63cf\u8ff0",
                          type: "string",
                          key: "description",
                          content: "text",
                        },
                        number: {
                          switch: "hasNumber",
                          label: "\u6570\u5b57",
                          type: "string",
                          key: "number",
                          content: "text",
                        },
                        unit: {
                          switch: "hasUnit",
                          label: "\u5355\u4f4d",
                          type: "string",
                          key: "unit",
                          content: "text",
                        },
                        titleColor: {
                          label:
                            "\u6807\u9898/\u6570\u5b57/\u5355\u4f4d\u989c\u8272",
                          type: "string",
                          content: "color",
                        },
                        descColor: {
                          label: "\u63cf\u8ff0\u989c\u8272",
                          type: "string",
                          content: "color",
                        },
                        titleFontSize: {
                          label: "\u6807\u9898\u5b57\u53f7",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "10px", value: "10px" },
                            { label: "12px", value: "12px" },
                            { label: "14px", value: "14px" },
                            { label: "16px", value: "16px" },
                            { label: "18px", value: "18px" },
                            { label: "20px", value: "20px" },
                            { label: "24px", value: "24px" },
                            { label: "28px", value: "28px" },
                            { label: "32px", value: "32px" },
                            { label: "40px", value: "40px" },
                            { label: "48px", value: "48px" },
                            { label: "56px", value: "56px" },
                            { label: "64px", value: "64px" },
                            { label: "72px", value: "72px" },
                            { label: "80px", value: "80px" },
                          ],
                        },
                        titleFontWeight: {
                          label: "\u6807\u9898\u5b57\u91cd",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "Regular", value: "regular" },
                            { label: "SemiBold", value: "semibold" },
                          ],
                        },
                        titleLineHeight: {
                          label: "\u6807\u9898\u884c\u9ad8",
                          type: "select",
                          controlBy: "titleFontSize",
                          controlValue: !0,
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            {
                              label: "\u7d27\u51d1\u884c\u9ad8",
                              value: "compact",
                            },
                            {
                              label: "\u6807\u51c6\u884c\u9ad8",
                              value: "standard",
                            },
                          ],
                        },
                        descFontSize: {
                          label: "\u63cf\u8ff0\u5b57\u53f7",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "10px", value: "10px" },
                            { label: "12px", value: "12px" },
                            { label: "14px", value: "14px" },
                            { label: "16px", value: "16px" },
                            { label: "18px", value: "18px" },
                            { label: "20px", value: "20px" },
                            { label: "24px", value: "24px" },
                            { label: "28px", value: "28px" },
                            { label: "32px", value: "32px" },
                            { label: "40px", value: "40px" },
                            { label: "48px", value: "48px" },
                            { label: "56px", value: "56px" },
                            { label: "64px", value: "64px" },
                            { label: "72px", value: "72px" },
                            { label: "80px", value: "80px" },
                          ],
                        },
                        descFontWeight: {
                          label: "\u63cf\u8ff0\u5b57\u91cd",
                          type: "select",
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            { label: "Regular", value: "regular" },
                            { label: "SemiBold", value: "semibold" },
                          ],
                        },
                        descLineHeight: {
                          label: "\u63cf\u8ff0\u884c\u9ad8",
                          type: "select",
                          controlBy: "descFontSize",
                          controlValue: !0,
                          items: [
                            { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                            {
                              label: "\u7d27\u51d1\u884c\u9ad8",
                              value: "compact",
                            },
                            {
                              label: "\u6807\u51c6\u884c\u9ad8",
                              value: "standard",
                            },
                          ],
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        };
      t.default = i()(Object(a.a)(D, F), D);
    },
    "9ggG": function (e, t, n) {
      var o = n("Z0cm"),
        a = n("/9aa"),
        r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        i = /^\w*$/;
      e.exports = function (e, t) {
        if (o(e)) return !1;
        var n = typeof e;
        return (
          !(
            "number" != n &&
            "symbol" != n &&
            "boolean" != n &&
            null != e &&
            !a(e)
          ) ||
          i.test(e) ||
          !r.test(e) ||
          (null != t && e in Object(t))
        );
      };
    },
    "9jLN": function (e, t, n) {
      "use strict";
      var o = n("rePB"),
        a = n("iKuz"),
        r = n.n(a),
        i = n("q1tI"),
        l = n.n(i),
        s = n("SBOM"),
        c = n("XnI8"),
        _ = n("TSYQ"),
        u = n.n(_),
        d = n("ODXe"),
        p = n("wx14"),
        f = n("UYut"),
        h = n("3vbH"),
        m = (n("xA1j"), n("yWgo")),
        y = n("r7AC"),
        b = n("cKzW"),
        v = n("gn4A"),
        g = n.n(v),
        w = l.a.createElement;
      function x(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function k(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? x(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : x(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var O = {
          "./style.css": {
            "hero-vertical-card": "style__hero-vertical-card___R3WRK",
            "panotips-wrapper": "style__panotips-wrapper___2T5fP",
            show: "style__show___3iSKO",
            "is-move": "style__is-move___3DQ8I",
            "tips-icon": "style__tips-icon___1ifLe",
            "tips-text": "style__tips-text___3nyYn",
            "card-wrapper": "style__card-wrapper___1hfls",
            "content-wrapper": "style__content-wrapper___2Ps9G",
            "bg-style": "style__bg-style___xqb00",
            dark: "style__dark___2n_6f",
            "video-button": "style__video-button___ji2fq",
            "replay-button": "style__replay-button___3WFfv",
            "play-button": "style__play-button___1Z91X",
            "pause-button": "style__pause-button___1i4L6",
            light: "style__light___2PNSR",
            "section-pano-120": "style__section-pano-120___26ez7",
            "section-pano-360": "style__section-pano-360___1u9fh",
            "image-content": "style__image-content___MvRPF",
            "media-video": "style__media-video___1DQzO",
            "section-pano-120-180": "style__section-pano-120-180___iqrnq",
            mobile: "style__mobile___31bYL",
            "card-fore-video-poster": "style__card-fore-video-poster___2qNlV",
            "downgrade-img": "style__downgrade-img___tSJLn",
            "downgrade-pic": "style__downgrade-pic___1kIMS",
            "downgrade-play-btn": "style__downgrade-play-btn___3YauZ",
            "normal-wrapper": "style__normal-wrapper___3RNXF",
            "img-hidden": "style__img-hidden___1bfz2",
            "vertical-top-align": "style__vertical-top-align___2jeQ3",
            "vertical-center-align": "style__vertical-center-align___7v4yJ",
            "vertical-bottom-align": "style__vertical-bottom-align___2e5Ci",
            "horizontal-left-align": "style__horizontal-left-align___8l5OI",
            "horizontal-center-align": "style__horizontal-center-align___9jQo0",
            eyebrow: "style__eyebrow___1m8aa",
            headline: "style__headline___31vSf",
            subhead: "style__subhead___38WNz",
            description: "style__description___3mjSU",
            note: "style__note___31_lE",
            "icon-pic": "style__icon-pic___XCp85",
            "topping-img": "style__topping-img___1Yg6q",
            "icon-row-container": "style__icon-row-container___36k2n",
            "icon-item": "style__icon-item___300uK",
            horizontal: "style__horizontal___iFEgT",
            "icon-number-container": "style__icon-number-container___382U_",
            "buttons-container": "style__buttons-container___1b3pR",
            divider: "style__divider___1uY_-",
            "horizontal-right-align": "style__horizontal-right-align___2xeLz",
            "card-container": "style__card-container___17N6B",
            "video-content": "style__video-content___1sh4L",
            "parallax-fore-video": "style__parallax-fore-video___23uUS",
            "fore-controller-video-poster-bg":
              "style__fore-controller-video-poster-bg___2Ucs7",
            hidden: "style__hidden___3yVfJ",
            "fore-image": "style__fore-image___2bMOf",
            "parallax-fore-pic": "style__parallax-fore-pic___1QnWn",
            "divider-container": "style__divider-container___29WoK",
            link: "style__link___1E1u5",
            "button-wrapper": "style__button-wrapper___1PDIO",
            "button-inner": "style__button-inner___3CW1Z",
            "button-link": "style__button-link___3eGxD",
            "button-video-play": "style__button-video-play___q53VQ",
            "video-play": "style__video-play___3Ym34",
            "video-play-light": "style__video-play-light___3RBn2",
            "video-play-dark": "style__video-play-dark___dXNCV",
            "download-buttons-container":
              "style__download-buttons-container___3TEeg",
            download: "style__download___25YoI",
            "download-google-play": "style__download-google-play___10qbT",
            "background-video": "style__background-video___2N4SQ",
            "video-mask": "style__video-mask___1GM2x",
            "card-link": "style__card-link___3FwZf",
            "text-content-container": "style__text-content-container___e4g8E",
          },
        },
        I = function (e) {
          return w(
            "svg",
            e,
            w("path", {
              d: "M7.192 17.808c.974.98.974 2.563 0 3.538l-1.41 1.41 16.96-.014.014-16.96-1.355 1.355a2.508 2.508 0 0 1-3.538 0L24 1l6.192 6.192a2.508 2.508 0 0 1-3.538 0l-1.41-1.41.013 16.958 7.413-.008.066-.004 1.358.005 5.19-.005c.062.002.122.008.181.018l2.753.01-1.41-1.41a2.508 2.508 0 0 1 0-3.538L47 24l-6.137 6.137a2.508 2.508 0 0 1 0-3.538l1.355-1.355-2.75.01c-.06.01-.121.016-.184.018l-5.14-.005-1.408.005-.065-.007-7.411-.005.008 7.413.004.063-.005 1.41.005 5.138a1.311 1.311 0 0 1-.018.181l-.01 2.753 1.41-1.41a2.508 2.508 0 0 1 3.538 0L24 47l-6.137-6.137a2.508 2.508 0 0 1 3.538 0l1.355 1.355-.01-2.753c-.01-.059-.016-.12-.018-.18l.004-5.19-.004-1.36.005-.063.007-7.414-16.958-.014 1.355 1.355a2.508 2.508 0 0 1 0 3.538L1 24l6.192-6.192Z",
              fill: "#FFF",
              fillRule: "evenodd",
            }),
          );
        };
      I.defaultProps = {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var S = function (e) {
        return w(
          "svg",
          e,
          w(
            "g",
            { fill: "#FFF", fillRule: "evenodd" },
            w("path", {
              d: "M6.458 33.542v-7.227a2.088 2.088 0 0 1 2.084 2.083v1.595l5.566-5.598a1.095 1.095 0 0 1 1.497 0 1.095 1.095 0 0 1 0 1.497l-5.598 5.566h1.66a2.088 2.088 0 0 1 2.083 2.084H6.458ZM33.542 33.542h-7.227a2.088 2.088 0 0 1 2.083-2.084h1.595l-5.598-5.566a1.095 1.095 0 0 1 0-1.497 1.095 1.095 0 0 1 1.497 0l5.566 5.598v-1.66a2.088 2.088 0 0 1 2.084-2.083v7.292ZM6.458 13.685V6.458h7.292a2.088 2.088 0 0 1-2.083 2.084h-1.66l5.598 5.566c.395.42.395 1.079 0 1.497a1.095 1.095 0 0 1-1.497 0l-5.566-5.598v1.595a2.088 2.088 0 0 1-2.084 2.083ZM26.315 6.458h7.227v7.292a2.088 2.088 0 0 1-2.084-2.083v-1.66l-5.566 5.598a1.095 1.095 0 0 1-1.497 0 1.095 1.095 0 0 1 0-1.497l5.598-5.566h-1.595a2.088 2.088 0 0 1-2.083-2.084Z",
            }),
          ),
        );
      };
      S.defaultProps = {
        width: "40",
        height: "40",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var j = (function (e) {
          return (
            (e.picture = "picture"),
            (e.video = "video"),
            (e.wideAngle120 = "wideAngle120"),
            (e.wideAngle180 = "wideAngle180"),
            (e.pano = "pano"),
            e
          );
        })({}),
        T = (function (e) {
          return (
            (e.loop = "loop"),
            (e.once = "once"),
            (e.replayWhenRevisible = "replayWhenRevisible"),
            (e.withController = "withController"),
            e
          );
        })({}),
        C = function () {
          if (
            "undefined" !== typeof document &&
            document &&
            !(document.getElementById("embedpano-js")
              ? document.getElementById("embedpano-js")
              : null)
          ) {
            var e = document.createElement("script"),
              t = document.getElementsByTagName("script")[0];
            (e.id = "embedpano-js"),
              (e.type = "text/javascript"),
              (e.src =
                "https://www1.djicdn.com/assets/uploads/p/f06bbcb9-e633-427b-932e-288bee142901/embedpano-1.9.js"),
              (e.crossOrigin = "anonymous"),
              t.parentNode.insertBefore(e, t);
          }
        },
        M = function (e) {
          var t = e.width,
            n = e.mobileMode;
          return w(
            "div",
            {
              className:
                "style__content-wrapper___2Ps9G style__normal-wrapper___3RNXF",
              style: { width: t },
            },
            w(s.a, {
              type: "img",
              src: e.foregroundImage,
              style: e.getBorderRadius,
              className: r()("".concat(n ? "" : "bg-style"), O, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            }),
          );
        },
        P = function (e) {
          var t = e.foregroundVideoWebm,
            n = e.foregroundVideo,
            o = e.foregroundVideoPoster,
            a = e.cardForegroundVideoRef,
            l = e.tabPresentation,
            c = void 0 !== l && l,
            _ = e.inView,
            u = e.mobileMode,
            d = e.foregroundVideoDowngrade,
            f = e.foregroundVideoDowngradePic,
            m = e.visibleByDefault,
            y = e.foregroundVideoPlayType,
            v = void 0 === y ? "withController" : y,
            x = g.a.isDowngrade(),
            k = Object(i.useRef)(),
            I = Object(i.useRef)(),
            S = Object(i.useRef)(),
            j = Object(i.useState)(!1),
            C = j[0],
            M = j[1];
          Object(i.useEffect)(function () {
            var e = g.a.getIOSversion();
            "15.4.0" === (null === e || void 0 === e ? void 0 : e.info) &&
              M(!0);
          }, []);
          var P = {};
          P["data-layzr-poster"] = o;
          var E = w(
              "div",
              { className: "style__downgrade-img___tSJLn" },
              w(s.a, {
                style: {
                  borderRadius:
                    null === e || void 0 === e ? void 0 : e.mediaBorderRadius,
                },
                type: "img",
                visibleByDefault: m,
                className: "style__downgrade-pic___1kIMS",
                src: f || o,
                alt: "",
              }),
              w(
                b.a,
                {
                  link: null === d || void 0 === d ? void 0 : d.path,
                  isMobile: u,
                },
                w("div", { className: "style__downgrade-play-btn___3YauZ" }),
              ),
            ),
            L = v !== T.once && v !== T.withController,
            B = _ && v !== T.withController,
            N = !c && v === T.replayWhenRevisible,
            D = c || v !== T.loop ? "replay-button" : "",
            z = c || v !== T.withController ? "" : "play-button",
            A = (null === e || void 0 === e ? void 0 : e.mediaBorderRadius)
              ? "".concat(
                  parseInt(
                    null === e || void 0 === e ? void 0 : e.mediaBorderRadius,
                    10,
                  ) + 1,
                  "px",
                )
              : "";
          return x
            ? E
            : w(
                "div",
                { className: "style__image-content___MvRPF" },
                w(
                  h.a,
                  {
                    lazyLoad: !0,
                    lazyLoadThreshold: 2e3,
                    replayWhenRevisible: L,
                    visiblePlay: B,
                    showWholeElmPlay: N,
                    replayClassName: D,
                    playClassName: z,
                  },
                  w(
                    "div",
                    {
                      className: "style__media-video___1DQzO",
                      "data-video": c ? "once" : v,
                    },
                    c || v !== T.withController
                      ? null
                      : w("div", {
                          style: {
                            backgroundImage: "url(".concat(
                              e.foregroundVideoPoster,
                              ")",
                            ),
                            borderRadius: A,
                          },
                          className: r()(
                            "card-fore-video-poster ".concat(C ? "show" : ""),
                            O,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                        }),
                    w(
                      "video",
                      Object(p.a)(
                        { style: e.getBorderRadius, ref: a, muted: !0 },
                        P,
                        { loop: !c && v === T.loop },
                      ),
                      t &&
                        w("source", {
                          type: "video/webm",
                          "data-layzr-src":
                            null === t || void 0 === t ? void 0 : t.path,
                        }),
                      w("source", {
                        type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                        "data-layzr-src":
                          null === n || void 0 === n ? void 0 : n.path,
                      }),
                    ),
                    [
                      w("div", {
                        key: "pause",
                        style: { display: "none !important" },
                        "data-link": "ture",
                        className:
                          "pause-button style__video-button___ji2fq style__pause-button___1i4L6",
                        ref: I,
                      }),
                      w("div", {
                        key: "play",
                        style: { display: "none !important" },
                        "data-link": "ture",
                        className:
                          "play-button style__video-button___ji2fq style__play-button___1Z91X",
                        ref: S,
                      }),
                      w("div", {
                        key: "replay",
                        "data-link": "ture",
                        ref: k,
                        className:
                          "replay-button " +
                          r()(
                            "video-button replay-button ".concat(
                              c ? "hidden" : "",
                            ),
                            O,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                      }),
                    ],
                  ),
                ),
              );
        },
        E = function (e) {
          var t = e.mobileMode,
            n = e.canLoad,
            o = e.foregroundImage,
            a = e.cardHeight,
            r = e.windowWidth,
            i = e.getPanoBgStyle,
            l = { height: a, width: r },
            s = n && "url(".concat(o, ")");
          s && (l.backgroundImage = s);
          var c = { width: r },
            _ = t ? k({ commonStyle: c }, i(o)) : { commonStyle: c };
          return w(
            "div",
            {
              className:
                "section-pano-120 style__content-wrapper___2Ps9G style__section-pano-120___26ez7 style__normal-wrapper___3RNXF",
              style: _,
            },
            t
              ? w("img", {
                  className: "style__img-hidden___1bfz2",
                  src: n && o,
                  alt: "",
                })
              : w("div", { className: "style__bg-style___xqb00", style: l }),
          );
        },
        L = function (e) {
          var t = e.cardHeight,
            n = e.windowWidth,
            o = e.mobileMode,
            a = e.canLoad,
            i = e.foreground180,
            l = e.getPanoBgStyle,
            c = e.tips180,
            _ = e.t,
            u = e.cardTheme,
            d = e.openModal,
            p = e.mediaType,
            f = { height: t, width: n };
          return w(
            "div",
            {
              className:
                "section-pano-120-180 style__section-pano-120-180___iqrnq style__content-wrapper___2Ps9G",
              style: k({}, l(i)),
            },
            o
              ? w(
                  "div",
                  null,
                  w("img", {
                    className: "style__img-hidden___1bfz2",
                    src: a ? i : "",
                    alt: "",
                  }),
                  w(
                    "div",
                    {
                      onClick: function () {
                        return d(p);
                      },
                      className: r()(
                        "panotips-wrapper "
                          .concat(a ? "show" : "", " ")
                          .concat("dark" === u ? "dark" : ""),
                        O,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    w(
                      "p",
                      { className: "style__tips-icon___1ifLe" },
                      w(S, null),
                    ),
                    w("p", {
                      className: "style__tips-text___3nyYn",
                      dangerouslySetInnerHTML: { __html: _(c) },
                    }),
                  ),
                )
              : w(s.a, {
                  className: "wide-angle style__bg-style___xqb00",
                  type: "bg",
                  tagType: "div",
                  src: i,
                  style: f,
                }),
          );
        },
        B = function (e) {
          var t = e.tips360,
            n = e.t,
            o = e.init360Flag,
            a = e.mobileMode,
            l = e.foreground360IEPic,
            c = e.canLoad,
            _ = e.getPanoBgStyle,
            u = e.openModal,
            d = e.id,
            p = e.mediaType,
            f = e.krpanoRef,
            h = e.isRotate,
            m = { height: e.cardHeight, width: e.windowWidth },
            y = Object(i.useState)(!1),
            b = y[0],
            v = y[1],
            g = Object(i.useRef)();
          return w(
            "div",
            {
              className:
                "section-pano-360 style__section-pano-360___1u9fh style__content-wrapper___2Ps9G",
              id: "".concat(a ? "" : "pano360-".concat(d)),
              onClick: function () {
                a || v(!0);
              },
              style: k({}, _(l)),
            },
            a
              ? w("img", {
                  className: "style__img-hidden___1bfz2",
                  src: c ? l : "",
                  alt: "",
                })
              : w(s.a, {
                  className: "style__bg-style___xqb00",
                  type: "bg",
                  src: l,
                  style: m,
                }),
            w(
              "div",
              {
                ref: g,
                onClick: function () {
                  var e;
                  h
                    ? u(p)
                    : (null === f ||
                        void 0 === f ||
                        null === (e = f.current) ||
                        void 0 === e ||
                        e.call("cm_littleplanet_view"),
                      setTimeout(function () {
                        u(p);
                      }, 250));
                },
                className: r()(
                  "panotips-wrapper "
                    .concat("dark" === e.cardTheme ? "dark" : "", " ")
                    .concat(o || a ? "show" : "", " ")
                    .concat(b ? "is-move" : ""),
                  O,
                  {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  },
                ),
              },
              w(
                "p",
                { className: "style__tips-icon___1ifLe" },
                w(a ? S : I, null),
              ),
              w("p", {
                className: "style__tips-text___3nyYn",
                dangerouslySetInnerHTML: { __html: n(t) },
              }),
            ),
          );
        },
        N = function (e) {
          var t,
            n = e.cardWrapperRef,
            o = e.mobileMode,
            a = e.openModal,
            r = o
              ? ""
              : null === n || void 0 === n
                ? void 0
                : null === (t = n.current) || void 0 === t
                  ? void 0
                  : t.clientWidth,
            i = { borderRadius: e.mediaBorderRadius };
          switch (e.mediaType) {
            case j.video:
              return w(P, Object(p.a)({}, e, { getBorderRadius: i }));
            case j.wideAngle120:
              return w(E, e);
            case j.wideAngle180:
              return w(L, Object(p.a)({ openModal: a }, e));
            case j.pano:
              return w(B, Object(p.a)({ openModal: a }, e));
            default:
              return w(M, Object(p.a)({ width: r }, e, { getBorderRadius: i }));
          }
        },
        D = function (e) {
          var t,
            n,
            o = e.mobileMode,
            a = e.activeKey,
            l = e.tips360,
            s = e.tips180,
            c = e.tipsModal180,
            _ = e.tipsModal360,
            u = e.t,
            d = e.cardTheme,
            f = void 0 === d ? "light" : d,
            h = e.windowWidth,
            b = e.id,
            v = e.handleModalVisable,
            g = e.cardHeight,
            x = e.isFull,
            k = Object(i.useRef)(),
            I = Object(i.useRef)(),
            S = Object(i.useRef)(),
            j = Object(i.useRef)(),
            T = Object(i.useState)(!1),
            M = T[0],
            P = T[1],
            E = Object(i.useState)(!1),
            L = E[0],
            B = E[1],
            D = Object(i.useState)(Object(m.h)()),
            z = D[0],
            A = D[1],
            R = Object(i.useState)(!1),
            F = R[0],
            V = R[1],
            H =
              null === I || void 0 === I
                ? void 0
                : null === (t = I.current) || void 0 === t
                  ? void 0
                  : t.clientWidth,
            W = o ? 24 : (h - H) / 2,
            U = { height: o ? "" : g },
            G = function (e) {
              L ||
                setTimeout(function () {
                  j.current.call("normalview"),
                    j.current.set("autorotate.enabled", !0);
                }, e || 1e3);
            },
            Y = function (t) {
              var n,
                o,
                a = e.foreground360;
              (null === (n = window) || void 0 === n ? void 0 : n.embedpano) &&
                (null === (o = window) ||
                  void 0 === o ||
                  o.embedpano({
                    swf: "https://www1.djicdn.com/images/360/unicorn/krpano.swf",
                    xml: null === a || void 0 === a ? void 0 : a.path,
                    target: "pano360-".concat(b),
                    html5: "prefer",
                    mwheel: !1,
                    focus: !1,
                    consolelog: !1,
                    passQueryParameters: !0,
                    id: "panoViewer",
                    onready: function (e) {
                      t &&
                        (!(function (e) {
                          (j.current = e), P(!0);
                        })(e),
                        e.call("cm_littleplanet_view"),
                        e.set("autorotate.enabled", !1));
                    },
                    onerror: function (e) {
                      console.log("initEmbedpano error", e);
                      var t = document.getElementById("pano360-".concat(b)),
                        n = document.getElementById("panoViewer");
                      t && n && t.removeChild(n), A(!0);
                    },
                  }));
            },
            q = function (e) {
              M || z || Y(e);
            };
          Object(i.useEffect)(function () {
            Object(y.b)({
              elm: I.current,
              offset: 0,
              callback: function (e) {
                return !e.inView || (V(!0), !1);
              },
            }),
              "pano" === e.mediaType &&
                (window.requestIdleCallback
                  ? window.requestIdleCallback(function () {
                      C();
                    })
                  : C(),
                (S.current = setTimeout(function () {
                  q(!0);
                }, 5e3)));
          }, []),
            Object(i.useEffect)(
              function () {
                "pano" === e.mediaType &&
                  a === e.tabKey &&
                  (S.current && clearTimeout(S.current),
                  o ? M || q(!0) : (M || q(!0), L || (B(!0), G(1e3))));
              },
              [a],
            );
          return (
            null === I ||
              void 0 === I ||
              null === (n = I.current) ||
              void 0 === n ||
              n.style.setProperty("--pano-clip", "".concat(W, "px")),
            w(
              "div",
              {
                style: U,
                ref: I,
                className:
                  ("".concat(x ? "is-full" : "")
                    ? "".concat(x ? "is-full" : "") + " "
                    : "") +
                  r()(
                    "card-wrapper "
                      .concat(f, " ")
                      .concat(o ? "mobile" : "", " "),
                    O,
                    {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    },
                  ),
              },
              w(
                N,
                Object(p.a)({}, e, {
                  cardForegroundVideoRef: k,
                  cardWrapperRef: I,
                  clipPath: W,
                  windowWidth: h,
                  canLoad: F,
                  tips360: l,
                  tips180: s,
                  tipsModal360: _,
                  tipsModal180: c,
                  getPanoBgStyle: function (e) {
                    return {
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundImage: F ? "url(".concat(e, ")") : "",
                    };
                  },
                  t: u,
                  init360Flag: M,
                  openModal: function (e) {
                    "pano" === e && (M || q(!0), L || (B(!0), G(1e3))),
                      null === v || void 0 === v || v(!0);
                  },
                  krpanoRef: j,
                  isRotate: L,
                }),
              ),
            )
          );
        },
        z = (n("l6NK"), n("DdlN")),
        A = (n("ZLSR"), n("ZYh2")),
        R = l.a.createElement,
        F = {
          "./modal.css": {
            "media-modal-container": "modal__media-modal-container___wbEaJ",
            show: "modal__show___35ST7",
            "media-modal-close": "modal__media-modal-close___33NCY",
            "modal-content": "modal__modal-content___1mrw_",
            "media-tips": "modal__media-tips___2Z-0e",
            "is-move": "modal__is-move___3MOan",
            "tips-icon": "modal__tips-icon___48bWZ",
            "tips-text": "modal__tips-text___1bDwj",
            dark: "modal__dark___EzIc_",
            light: "modal__light___SrCfj",
            rotate90: "modal__rotate90___1TFLI",
            "media-modal-iframe": "modal__media-modal-iframe___1kwwp",
            "media-modal-iframe-360": "modal__media-modal-iframe-360___2ns1r",
            "link-button": "modal__link-button___2DHgq",
            wrapper: "modal__wrapper___2TNOe",
            "zoom-out-div": "modal__zoom-out-div___2WaJ9",
            "bg-style": "modal__bg-style___oL6Td",
            icon: "modal__icon___3OaHQ",
            "icon-more": "modal__icon-more___lwmzv",
            "icon-180": "modal__icon-180___4ojr8",
            "icon-360": "modal__icon-360___1wBxf",
            tip: "modal__tip___dASBf",
            "mask-360": "modal__mask-360___2YsMn",
          },
        },
        V = function (e) {
          return R(
            "svg",
            e,
            R("path", {
              d: "M7.192 17.808c.974.98.974 2.563 0 3.538l-1.41 1.41 16.96-.014.014-16.96-1.355 1.355a2.508 2.508 0 0 1-3.538 0L24 1l6.192 6.192a2.508 2.508 0 0 1-3.538 0l-1.41-1.41.013 16.958 7.413-.008.066-.004 1.358.005 5.19-.005c.062.002.122.008.181.018l2.753.01-1.41-1.41a2.508 2.508 0 0 1 0-3.538L47 24l-6.137 6.137a2.508 2.508 0 0 1 0-3.538l1.355-1.355-2.75.01c-.06.01-.121.016-.184.018l-5.14-.005-1.408.005-.065-.007-7.411-.005.008 7.413.004.063-.005 1.41.005 5.138a1.311 1.311 0 0 1-.018.181l-.01 2.753 1.41-1.41a2.508 2.508 0 0 1 3.538 0L24 47l-6.137-6.137a2.508 2.508 0 0 1 3.538 0l1.355 1.355-.01-2.753c-.01-.059-.016-.12-.018-.18l.004-5.19-.004-1.36.005-.063.007-7.414-16.958-.014 1.355 1.355a2.508 2.508 0 0 1 0 3.538L1 24l6.192-6.192Z",
              fill: "#FFF",
              fillRule: "evenodd",
            }),
          );
        };
      V.defaultProps = {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var H = function (e) {
        return R(
          "svg",
          e,
          R("path", {
            d: "M7.187 18c.973.979.973 2.56 0 3.536l-1.409 1.408 10.801-.017c.043-.006.086-.01.13-.01l3.88.004 2.664-.004.087.007 18.843.02-1.408-1.408a2.506 2.506 0 0 1 0-3.536l6.187 6.187-6.132 6.132a2.506 2.506 0 0 1 0-3.535l1.353-1.354-18.84.022-.09.006-2.664-.004-3.88.004-.13-.01-10.8-.018 1.353 1.354a2.506 2.506 0 0 1 0 3.535L1 24.187 7.187 18Z",
            fill: "#FFF",
            fillRule: "evenodd",
          }),
        );
      };
      H.defaultProps = {
        width: "40",
        height: "40",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var W = function (e) {
          var t = e.cardTheme,
            n = e.isMove,
            o = e.svgIcon,
            a = e.tipsText,
            i = e.isRotate,
            l = e.t;
          return R(
            "div",
            {
              className: r()(
                "media-tips "
                  .concat(i && "rotate90", " ")
                  .concat(t, " ")
                  .concat(n && "is-move"),
                F,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
            },
            R("p", { className: "modal__tips-icon___48bWZ" }, o),
            R("p", {
              className: "modal__tips-text___1bDwj",
              dangerouslySetInnerHTML: { __html: l(a) },
            }),
          );
        },
        U = function (e) {
          var t = e.activeItem,
            n = e.isShow,
            o = null === t || void 0 === t ? void 0 : t.foreground180Modal;
          return R(
            "div",
            {
              className: r()("modal-content ".concat(n && " show"), F, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            },
            n
              ? R(s.a, {
                  className: "modal__bg-style___oL6Td",
                  type: "img",
                  src: o,
                })
              : null,
          );
        },
        G = function (e) {
          var t = e.isShow,
            n = e.windowHeight,
            o = e.id;
          return R(
            "div",
            {
              className: r()("modal-content ".concat(t && " show"), F, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            },
            R("div", { id: "pano360-".concat(o), style: { height: t && n } }),
          );
        },
        Y = function (e) {
          var t,
            n,
            o,
            a,
            l,
            s,
            c,
            _,
            u = e.modalVisable,
            d = e.onHandleModalVisable,
            p = e.activeKey,
            f = e.cardConfigList,
            h = e.t,
            y = e.tipsModal360,
            b = e.tipsModal180,
            v = e.windowHeight,
            g = e.id,
            w = Object(i.useRef)(),
            x = Object(i.useState)(!1),
            k = x[0],
            O = x[1],
            I = Object(i.useState)(!1),
            S = I[0],
            j = I[1];
          return (
            null === f ||
              void 0 === f ||
              f.forEach(function (e) {
                (null === e || void 0 === e ? void 0 : e.tabKey) === p &&
                  (a = e);
              }),
            Object(i.useEffect)(function () {
              return function () {
                Object(A.a)();
              };
            }, []),
            Object(i.useEffect)(
              function () {
                u &&
                  (function () {
                    if ((d(!0), Object(A.b)(w.current), m.Q)) {
                      var e = document.querySelector(
                        ".universal-product-tip .universal-product-tip-container",
                      );
                      e && (e.style.zIndex = 9100);
                    }
                  })();
              },
              [u],
            ),
            "wideAngle180" ===
            (null === (t = a) || void 0 === t ? void 0 : t.mediaType)
              ? ((l = "180"), (c = b), (s = k), (_ = R(H, null)))
              : "pano" ===
                  (null === (n = a) || void 0 === n ? void 0 : n.mediaType) &&
                ((l = "360"), (c = y), (s = S), (_ = R(V, null))),
            R(
              "div",
              {
                ref: w,
                className: r()(
                  "media-modal-container ".concat(u ? "show" : ""),
                  F,
                  {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  },
                ),
              },
              R(
                "div",
                {
                  className: "",
                  onTouchMove: function () {
                    var e;
                    "180" === (e = l) ? O(!0) : "360" === e && j(!0);
                  },
                },
                R(U, { isShow: "180" === l && u, activeItem: a }),
                R(G, {
                  windowHeight: v,
                  isShow: "360" === l && u,
                  activeItem: a,
                  id: g,
                }),
                R(W, {
                  t: h,
                  cardTheme:
                    (null === (o = a) || void 0 === o ? void 0 : o.cardTheme) ||
                    "light",
                  isMove: s,
                  svgIcon: _,
                  tipsText: c,
                  isRotate: "180" === l,
                }),
              ),
              R("button", {
                type: "button",
                "aria-label": "close",
                className: "modal__media-modal-close___33NCY",
                onClick: function () {
                  d(!1), Object(A.c)(w.current);
                },
              }),
            )
          );
        },
        q = n("xwbB"),
        X = (function (e) {
          return (e.dark = "dark"), (e.light = "light"), e;
        })({}),
        Z = (function (e) {
          return (
            (e.withController = "withController"),
            (e.once = "once"),
            (e.replayWhenRevisible = "replayWhenRevisible"),
            (e.loop = "loop"),
            e
          );
        })({}),
        K = {
          t: function () {},
          gaSend: function () {},
          component_data: {
            backgroundType: "pure",
            cardConfigList: [],
            tabTheme: X.dark,
            cardTheme: X.light,
            tabKey: 1,
            gridWidth: "1200px",
          },
        },
        Q = {
          key: "tabSceneSwitch",
          name: "tabSceneSwitch",
          contentSetting: {
            cardList: {
              label: "\u5361\u7247",
              group_type: "array_card",
              group_prop_name: "cardConfigList",
              props: {
                titleSetting: {
                  label: "\u6807\u9898",
                  props: {
                    title: {
                      type: "string",
                      content: "text",
                      label: "\u6807\u9898",
                    },
                  },
                },
                descSetting: {
                  label: "\u63cf\u8ff0",
                  props: {
                    desc: {
                      type: "string",
                      content: "text",
                      label: "\u63cf\u8ff0",
                    },
                  },
                },
                foreground: {
                  label: "\u524d\u666f\u8bbe\u7f6e",
                  props: {
                    mediaType: {
                      label: "\u524d\u666f\u5185\u5bb9\u9009\u62e9",
                      type: "select",
                      items: [
                        { value: "picture", label: "\u56fe\u7247" },
                        { value: "video", label: "\u89c6\u9891" },
                        { value: "wideAngle180", label: "180\u5ea6" },
                        { value: "pano", label: "360\u5ea6" },
                      ],
                    },
                    mediaBorderRadius: {
                      label: "\u524d\u666f\u5706\u89d2",
                      helptext:
                        "\u4ec5\u5bf9 \u56fe\u7247/\u89c6\u9891 \u751f\u6548",
                      type: "string",
                      content: "size",
                    },
                    cardTheme: {
                      type: "select",
                      label: "\u524d\u666f\u4e3b\u9898\u8272",
                      items: [
                        { label: "\u767d", value: X.light },
                        { label: "\u9ed1", value: X.dark },
                      ],
                    },
                    foregroundImage: {
                      type: "image",
                      label: "-----------\u524d\u666f\u56fe\u7247-----------",
                      helptext: "\u524d\u666f\u56fe\u7247",
                    },
                    foregroundVideo: {
                      type: "string",
                      label: "-----------\u524d\u666f\u89c6\u9891-----------",
                      content: "url",
                    },
                    foregroundVideoWebm: {
                      type: "string",
                      label:
                        "\u524d\u666f\u89c6\u9891\uff08webm \u683c\u5f0f\uff0c\u9009\u586b\uff09",
                      content: "url",
                    },
                    foregroundVideoPoster: {
                      type: "image",
                      label: "\u524d\u666f\u89c6\u9891\u5c01\u9762",
                    },
                    foregroundVideoDowngradePic: {
                      type: "image",
                      helptext:
                        "\u3010\u79fb\u52a8\u7aef\u914d\u7f6e\u3011 \u79fb\u52a8\u7aef\u5fc5\u586b",
                      label: "\u524d\u666f\u89c6\u9891\u964d\u7ea7\u56fe",
                    },
                    foregroundVideoDowngrade: {
                      type: "string",
                      helptext:
                        "\u3010\u79fb\u52a8\u7aef\u914d\u7f6e\u3011 \u79fb\u52a8\u7aef\u5fc5\u586b",
                      label:
                        "\u524d\u666f\u89c6\u9891\u964d\u7ea7\u89c6\u9891 ",
                      content: "url",
                    },
                    foreground180: {
                      type: "image",
                      label:
                        "-----------180\u5ea6\u5168\u666f\u56fe\u7247-----------",
                    },
                    foreground180Modal: {
                      type: "image",
                      helptext:
                        "\u3010\u79fb\u52a8\u7aef\u914d\u7f6e\u3011 \u4ec5\u79fb\u52a8\u7aef\u751f\u6548",
                      label:
                        "180\u5ea6\u5168\u666f\u56fe\u7247\uff08\u5f39\u7a97\uff09",
                    },
                    foreground360: {
                      type: "string",
                      label:
                        "-----------360\u5ea6\u5168\u666f\u6587\u4ef6-----------",
                      content: "url",
                    },
                    foreground360IEPic: {
                      type: "image",
                      label:
                        "\u3010PC\u3011360\u5ea6\u5168\u666f\u964d\u7ea7\u56fe\u7247/\u3010M\u3011360\u5ea6\u5168\u666f\u56fe",
                    },
                    foregroundVideoPlayType: {
                      controlBy: "mediaType",
                      controlValue: "video",
                      type: "select",
                      label: "\u524d\u666f\u89c6\u9891\u64ad\u653e\u65b9\u5f0f",
                      items: [
                        {
                          value: Z.withController,
                          label: "\u70b9\u51fb\u64ad\u653e",
                        },
                        {
                          value: Z.once,
                          label:
                            "\u64ad\u653e\u4e00\u6b21, \u56de\u5c4f\u4e0d\u91cd\u64ad",
                        },
                        {
                          value: Z.replayWhenRevisible,
                          label:
                            "\u64ad\u653e\u4e00\u6b21\uff0c\u56de\u5c4f\u91cd\u64ad",
                        },
                        { value: Z.loop, label: "\u5faa\u73af\u64ad\u653e" },
                      ],
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            sectionSetting: {
              label: "\u7ed3\u6784\u8bbe\u7f6e",
              props: {
                gridWidth: {
                  label: "\u6805\u683c\u603b\u5bbd ",
                  helptext:
                    "\u3010PC\u914d\u7f6e\u3011\uff0c\u4ec5 PC \u751f\u6548",
                  type: "string",
                  content: "size",
                },
                wrapperHeight: {
                  label: "\u7ec4\u4ef6\u6700\u5c0f\u9ad8\u5ea6",
                  helptext:
                    "\u5fc5\u586b\uff0c\u907f\u514d\u61d2\u52a0\u8f7d\u9ad8\u5ea6\u574d\u584c",
                  type: "string",
                  content: "size",
                },
                cardHeight: {
                  label: "\u3010PC\u3011\u524d\u666f\u5361\u7247\u9ad8\u5ea6",
                  helptext:
                    "\u3010PC\u914d\u7f6e\u3011\uff0c\u4ec5 PC \u751f\u6548",
                  type: "string",
                  content: "size",
                },
                paddingTop: {
                  type: "string",
                  content: "size",
                  label: "\u4e0a\u65b9\u5185\u8fb9\u8ddd",
                },
                paddingBottom: {
                  type: "string",
                  content: "size",
                  label: "\u4e0b\u65b9\u5185\u8fb9\u8ddd",
                },
              },
            },
            backgroundSetting: {
              label: "\u80cc\u666f\u914d\u7f6e",
              props: {
                backgroundType: {
                  label: "\u80cc\u666f\u7c7b\u578b",
                  type: "select",
                  items: [
                    { label: "\u7eaf\u8272", value: "pure" },
                    { label: "\u6e10\u53d8\u8272", value: "gradient" },
                    { label: "\u80cc\u666f\u56fe", value: "image" },
                  ],
                },
                pureBackgroundColor: {
                  label: "\u7eaf\u8272\u80cc\u666f\u8272\u503c",
                  type: "string",
                  content: "color",
                  controlBy: "backgroundType",
                  controlValue: "pure",
                },
                backgroundGradient: {
                  label: "\u6e10\u53d8\u80cc\u666f\u8272\u503c",
                  type: "string",
                  content: "color",
                  controlBy: "backgroundType",
                  controlValue: "gradient",
                },
                backgroundImage: {
                  type: "image",
                  label: "-----------\u80cc\u666f\u56fe\u7247-----------",
                  controlBy: "backgroundType",
                  controlValue: "picture",
                },
              },
            },
            tabSetting: {
              label: "\u6307\u793a\u5668\u914d\u7f6e",
              props: {
                tabTheme: {
                  type: "select",
                  label: "\u4e3b\u9898\u8272",
                  items: [
                    { label: "\u9ed1", value: X.dark },
                    { label: "\u767d", value: X.light },
                  ],
                },
                tabKey: {
                  label: "\u9ed8\u8ba4\u7b2c\u51e0\u4e2aTab",
                  type: "string",
                },
                titleStyle: {
                  type: "font",
                  label: "\u6807\u9898-\u5b57\u4f53\u914d\u7f6e",
                },
                hasDesc: {
                  type: "boolean",
                  label: "\u662f\u5426\u663e\u793a\u63cf\u8ff0",
                },
                descStyle: {
                  type: "font",
                  label: "\u63cf\u8ff0-\u5b57\u4f53\u914d\u7f6e",
                  controlBy: "hasDesc",
                  controlValue: !0,
                },
                tips180: {
                  type: "string",
                  content: "text",
                  helptext:
                    "\u3010\u79fb\u52a8\u7aef\u914d\u7f6e\u3011 \u4ec5\u79fb\u52a8\u7aef\u751f\u6548",
                  label: "180\u63d0\u793a\u6587\u6848",
                },
                tips360: {
                  type: "string",
                  content: "text",
                  label: "360\u63d0\u793a\u6587\u6848",
                },
                tipsModal180: {
                  type: "string",
                  content: "text",
                  helptext:
                    "\u3010\u79fb\u52a8\u7aef\u914d\u7f6e\u3011 \u4ec5\u79fb\u52a8\u7aef\u751f\u6548",
                  label: "180\u63d0\u793a\u6587\u6848(\u5f39\u7a97)\u3011",
                },
                tipsModal360: {
                  type: "string",
                  content: "text",
                  helptext:
                    "\u3010\u79fb\u52a8\u7aef\u914d\u7f6e\u3011 \u4ec5\u79fb\u52a8\u7aef\u751f\u6548",
                  label: "360\u63d0\u793a\u6587\u6848\uff08\u5f39\u7a97\uff09",
                },
              },
            },
            tabLayout: {
              label: "\u6307\u793a\u5668\u5e03\u5c40",
              props: {
                spacingTabFromCard: {
                  label: "Tab\u548c\u5361\u7247\u95f4\u8ddd",
                  type: "string",
                  content: "size",
                },
              },
            },
          },
        },
        J = l.a.createElement;
      function $(e, t) {
        var n =
          ("undefined" !== typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" === typeof e) return ee(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return ee(e, t);
            })(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var o = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return o >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[o++] };
              },
              e: function (e) {
                throw e;
              },
              f: a,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var r,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (r = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw r;
            }
          },
        };
      }
      function ee(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      var te = {
          "./style.css": {
            "atom-horizontal-tabs": "style__atom-horizontal-tabs___3TqKI",
            "card-wrapper": "style__card-wrapper___3qAFX",
            mobile: "style__mobile___3r15Z",
            "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___AydlZ",
            "tab-bar-box": "style__tab-bar-box___3-e5c",
            "tab-item": "style__tab-item___1FMYw",
            "tab-content": "style__tab-content___34O_4",
            dark: "style__dark___Zy-jP",
            "tab-bar-wrap": "style__tab-bar-wrap___36K2U",
            light: "style__light___M5dzS",
            "atom-horizontal-tab-content":
              "style__atom-horizontal-tab-content___1b6xw",
            "atom-horizontal-tab-bisection":
              "style__atom-horizontal-tab-bisection___2Iejq",
            "atom-horizontal-tabs-left":
              "style__atom-horizontal-tabs-left___1AZgc",
            "atom-horizontal-tabs-center":
              "style__atom-horizontal-tabs-center___dMxey",
            "atom-horizontal-tabs-right":
              "style__atom-horizontal-tabs-right___32IDK",
            "tab-bar-wrapper": "style__tab-bar-wrapper___3Eodm",
            text: "style__text___3HqYI",
            "aotm-horizontal-tab-inkbar":
              "style__aotm-horizontal-tab-inkbar___13fHx",
            "atom-horizontal-tab-bar-theme-dark":
              "style__atom-horizontal-tab-bar-theme-dark___19ufo",
            "tab-item-active": "style__tab-item-active___JRqMK",
            "tab-hover-icon": "style__tab-hover-icon___xsD_s",
            "tab-icon": "style__tab-icon___2lHss",
            "atom-horizontal-tab-bar-theme-light":
              "style__atom-horizontal-tab-bar-theme-light___3xfW_",
            "atom-horizontal-tab-bar-left":
              "style__atom-horizontal-tab-bar-left___3Qt1H",
            "atom-horizontal-tab-bar-center":
              "style__atom-horizontal-tab-bar-center___1cgj1",
            "atom-horizontal-tab-content-left":
              "style__atom-horizontal-tab-content-left___lDl0k",
            "atom-horizontal-tab-content-center":
              "style__atom-horizontal-tab-content-center___AVe2v",
            "atom-horizontal-tab-content-right":
              "style__atom-horizontal-tab-content-right___1lRB-",
            "atom-horizontal-tabs-content-theme-dark":
              "style__atom-horizontal-tabs-content-theme-dark___2p08c",
            "tab-panel": "style__tab-panel___2BLpQ",
            "atom-horizontal-tabs-content-theme-light":
              "style__atom-horizontal-tabs-content-theme-light___1S7Ux",
            "tab-panel-active": "style__tab-panel-active___1DyaN",
            "scenario-tab-bar": "style__scenario-tab-bar___2M_X8",
            pc: "style__pc___2iq02",
          },
        },
        ne = function (e) {
          var t,
            n = e.tabCardRef,
            o = e.carouselRef,
            a = e.carouselCardRef,
            i = e.tabPresentation,
            l = e.tabCarouselInterval,
            s = e.activeKey,
            c = e.cardMargin,
            _ = e.cardHeight,
            u = e.mobileMode,
            d = e.t,
            h = e.tips360,
            m = e.tips180,
            y = e.inView,
            b = e.windowWidth,
            v = e.visibleByDefault,
            g = e.handleModalVisable,
            w = e.id,
            x = {
              fade: !0,
              speed: 600,
              autoplay: !1,
              autoplaySpeed: Number(l),
              touchMove: !1,
              beforeChange: function () {},
            },
            k =
              null === (t = e.cardConfigList) || void 0 === t
                ? void 0
                : t.map(function (e, t) {
                    return J(
                      "div",
                      {
                        ref: function (e) {
                          a.current[t] = e;
                        },
                        key: "tab".concat(t),
                      },
                      J(
                        D,
                        Object(p.a)({}, e, {
                          index: t,
                          cardHeight: _,
                          mobileMode: u,
                          activeKey: s,
                          tips360: h,
                          tips180: m,
                          t: d,
                          id: w,
                          tabPresentation: i,
                          inView: y,
                          windowWidth: b,
                          visibleByDefault: v,
                          handleModalVisable: g,
                          isFull:
                            ((n = e.mediaType),
                            "wideAngle180" === n || "pano" === n),
                        }),
                      ),
                    );
                    var n;
                  });
          return J(
            "div",
            {
              ref: n,
              style: c,
              className: r()("card-wrapper ".concat(u ? "mobile" : ""), te, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            },
            J(f.a, Object(p.a)({}, x, { ref: o }), k),
          );
        },
        oe = function (e) {
          var t = e.cardConfigList,
            n = e.defaultActiveKey,
            o = e.barContent,
            a = e.hasDesc,
            l = e.t,
            s = e.titleStyle,
            c = e.descStyle,
            _ = e.spacingTabFromCard,
            p = e.tabPresentation,
            f = e.tabCarouselInterval,
            h = e.cardHeight,
            m = e.mobileMode,
            b = e.eventAction,
            v = e.sectionRef,
            g = e.mediaBorderRadius,
            w = e.tips360,
            x = e.tips180,
            k = e.tipsModal180,
            O = e.tipsModal360,
            I = e.tabTheme,
            S = e.visibleByDefault,
            j = e.id,
            T = e.gaSend,
            C = Object(i.useState)(+n),
            M = C[0],
            P = C[1],
            E = Object(i.useState)(!1),
            L = E[0],
            B = E[1],
            N = Object(i.useRef)(),
            D = Object(i.useRef)(),
            A = Object(i.useRef)([]),
            R = Object(i.useRef)(),
            F = Object(i.useState)(!1),
            V = F[0],
            H = F[1],
            W = function (e) {
              H(e);
            },
            U = Object(z.a)({ mobileMode: m, mobileHeightChangable: !1 }),
            G = Object(d.a)(U, 2),
            X = G[0],
            K = G[1],
            Q = m ? X : Math.max(X, 1200),
            ee = { marginBottom: _, width: m ? X : "" },
            oe = u()(
              "atom-horizontal-tabs",
              "atom-horizontal-tabs-center",
              "".concat(m ? "mobile" : ""),
            ),
            ae = function (t, n, o, a) {
              var r,
                i,
                l,
                s,
                c = e.cardConfigList[t],
                _ =
                  "video" ===
                    (null === c || void 0 === c ? void 0 : c.mediaType) &&
                  (null === c || void 0 === c
                    ? void 0
                    : null === (r = c.foregroundVideo) || void 0 === r
                      ? void 0
                      : r.path),
                u =
                  null === A || void 0 === A
                    ? void 0
                    : null === (i = A.current) || void 0 === i
                      ? void 0
                      : null === (l = i[t]) || void 0 === l
                        ? void 0
                        : null === (s = l.getElementsByTagName("video")) ||
                            void 0 === s
                          ? void 0
                          : s[0];
              !(function e() {
                if (
                  _ &&
                  (a &&
                    u &&
                    Number.isNaN(u.duration) &&
                    requestAnimationFrame(e),
                  u && u.duration >= 0)
                ) {
                  var n, o, r, i, l, s;
                  cancelAnimationFrame(e);
                  var d =
                      null === c || void 0 === c
                        ? void 0
                        : c.foregroundVideoPlayType,
                    p =
                      null === A || void 0 === A
                        ? void 0
                        : null === (n = A.current) || void 0 === n
                          ? void 0
                          : null === (o = n[t]) || void 0 === o
                            ? void 0
                            : null ===
                                  (r =
                                    o.getElementsByClassName(
                                      "replay-button",
                                    )) || void 0 === r
                              ? void 0
                              : r[0],
                    f =
                      null === A || void 0 === A
                        ? void 0
                        : null === (i = A.current) || void 0 === i
                          ? void 0
                          : null === (l = i[t]) || void 0 === l
                            ? void 0
                            : null ===
                                  (s =
                                    l.getElementsByClassName("play-button")) ||
                                void 0 === s
                              ? void 0
                              : s[0],
                    h =
                      d === Z.once ||
                      d === Z.replayWhenRevisible ||
                      d === Z.withController,
                    m =
                      d === Z.once ||
                      d === Z.replayWhenRevisible ||
                      d === Z.loop,
                    y = d === Z.withController;
                  h && p && (p.style.display = "none"),
                    m &&
                      setTimeout(function () {
                        u.currentTime = 0;
                        var e = u.play();
                        e &&
                          e.then &&
                          "function" === typeof e.then &&
                          e
                            .then(
                              function () {
                                return null;
                              },
                              function () {
                                return null;
                              },
                            )
                            .catch(function () {
                              return null;
                            });
                      }, 0),
                    y &&
                      (u.pause(),
                      (u.currentTime = 0),
                      f && (f.style.display = "block"));
                }
              })();
            },
            re = function () {
              B(!0), ae(M - 1, 0, 0, !0);
            },
            ie = function (e) {
              P(e);
            };
          return (
            Object(i.useEffect)(function () {
              var t, n, o;
              (null === R ||
                void 0 === R ||
                null === (t = R.current) ||
                void 0 === t ||
                t.slickGoTo(M - 1),
              p && !L) &&
                (null === R ||
                  void 0 === R ||
                  null === (n = R.current) ||
                  void 0 === n ||
                  null === (o = n.slick) ||
                  void 0 === o ||
                  o.slickPause());
              !(function () {
                var t,
                  n,
                  o,
                  a,
                  r = M - 1,
                  i = e.cardConfigList[r],
                  l =
                    "video" ===
                      (null === i || void 0 === i ? void 0 : i.mediaType) &&
                    (null === i || void 0 === i
                      ? void 0
                      : null === (t = i.foregroundVideo) || void 0 === t
                        ? void 0
                        : t.path),
                  s =
                    null === A || void 0 === A
                      ? void 0
                      : null === (n = A.current) || void 0 === n
                        ? void 0
                        : null === (o = n[r]) || void 0 === o
                          ? void 0
                          : null === (a = o.getElementsByTagName("video")) ||
                              void 0 === a
                            ? void 0
                            : a[0];
                l && s && s.duration >= 0 && ((s.currentTime = 0), s.pause());
              })();
              Object(y.b)({
                elm: D.current,
                offset: 0,
                callback: function (e) {
                  return !e.inView || (re(), !1);
                },
              });
            }, []),
            J(
              "div",
              {
                className: r()(oe, te, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
              },
              J(ne, {
                cardConfigList: t,
                tabCardRef: N,
                carouselRef: R,
                carouselCardRef: A,
                tabPresentation: p,
                tabCarouselInterval: f,
                cardMargin: ee,
                cardHeight: h,
                mobileMode: m,
                eventAction: b,
                sectionRef: v,
                activeKey: M,
                mediaBorderRadius: g,
                tips360: w,
                tips180: x,
                tipsModal360: O,
                tipsModal180: k,
                t: l,
                onChange: ie,
                onHandleVideo: ae,
                inView: L,
                windowWidth: Q,
                visibleByDefault: S,
                handleModalVisable: W,
                id: j,
              }),
              J(q.a, {
                key: "tabBar",
                activeKey: M,
                tabTheme: I,
                windowWidth: Q,
                barContent: o,
                hasDesc: a,
                titleStyle: s,
                descStyle: c,
                onTabClick: function (e, t, n) {
                  if (e !== M) {
                    var o,
                      a,
                      r,
                      i,
                      l,
                      s,
                      c,
                      _,
                      u = null === A || void 0 === A ? void 0 : A.current,
                      d = $(u);
                    try {
                      for (d.s(); !(_ = d.n()).done; ) {
                        var p,
                          f = _.value;
                        if (
                          null === f || void 0 === f
                            ? void 0
                            : f.classList.contains("slick-active")
                        )
                          (i = f),
                            (l =
                              null === f || void 0 === f
                                ? void 0
                                : null === (p = f.children) || void 0 === p
                                  ? void 0
                                  : p[0]);
                        null === f ||
                          void 0 === f ||
                          f.classList.add("slick-hide"),
                          null === f ||
                            void 0 === f ||
                            f.classList.remove(
                              "slick-active",
                              "slick-current",
                              "slick-show",
                              "animation",
                            );
                      }
                    } catch (y) {
                      d.e(y);
                    } finally {
                      d.f();
                    }
                    var h,
                      m = null === u || void 0 === u ? void 0 : u[t];
                    if (
                      ((null === (o = l) || void 0 === o
                        ? void 0
                        : o.classList.contains("is-full")) && (s = !0),
                      (null === m || void 0 === m
                        ? void 0
                        : null === (a = m.children) || void 0 === a
                          ? void 0
                          : null === (r = a[0]) || void 0 === r
                            ? void 0
                            : r.classList.contains("is-full")) && (c = !0),
                      !s || !c)
                    )
                      null === (h = i) ||
                        void 0 === h ||
                        h.classList.add("animation"),
                        null === m ||
                          void 0 === m ||
                          m.classList.add("animation");
                    null === m ||
                      void 0 === m ||
                      m.classList.add(
                        "slick-active",
                        "slick-current",
                        "slick-show",
                      ),
                      null === m ||
                        void 0 === m ||
                        m.classList.remove("slick-hide"),
                      ae(t),
                      P(e);
                  }
                },
                onChange: ie,
                t: l,
                tabBarRef: D,
                inView: L,
                mobileMode: m,
                id: j,
                gaSend: T,
              }),
              m
                ? J(Y, {
                    tipsModal360: O,
                    tipsModal180: k,
                    activeKey: M,
                    cardConfigList: t,
                    modalVisable: V,
                    onHandleModalVisable: W,
                    mobileMode: m,
                    t: l,
                    id: j,
                    windowHeight: K,
                  })
                : null,
            )
          );
        },
        ae = (n("DGiJ"), l.a.createElement),
        re = {
          "./style.css": {
            "section-tab-sceneswitch": "style__section-tab-sceneswitch___2DRd_",
            "clip-hidden": "style__clip-hidden___vxjsB",
            "clip-active": "style__clip-active___3a7Do",
            "scale-active": "style__scale-active___3dAxl",
            "atom-horiozntal-tab-component":
              "style__atom-horiozntal-tab-component___2zeKn",
            mobile: "style__mobile___2mEuR",
            "background-video": "style__background-video___3FiYW",
            "video-mask": "style__video-mask___h_ecZ",
            "atom-horizontal-tab-align-center":
              "style__atom-horizontal-tab-align-center___3xpOs",
            "tab-horizontal-wrapper": "style__tab-horizontal-wrapper___1DWeV",
            "card-wrap": "style__card-wrap___2LDic",
            "vertical-left-align": "style__vertical-left-align___ULi5D",
            "vertical-center-align": "style__vertical-center-align___3u-MT",
            "vertical-right-align": "style__vertical-right-align___1dJPj",
            "tab-content": "style__tab-content___3xQIW",
            "tab-active-card": "style__tab-active-card___3LirV",
            "tab-card-item": "style__tab-card-item___2af9X",
          },
        };
      function ie(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function le(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? ie(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : ie(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var se = function (e) {
        var t,
          n = (e = le(
            le(le({}, K), e),
            {},
            { component_data: le(le({}, K.component_data), e.component_data) },
          )),
          o = n.mobileMode,
          a = n.component_data,
          l = n.t,
          c = n.visibleByDefault,
          _ = n.eventAction,
          d = n.id,
          p = n.gaSend,
          f = a.gridWidth,
          h = a.tabTheme,
          m = a.cardConfigList,
          y = a.hasDesc,
          b = a.tabPresentation,
          v = a.tabCarouselInterval,
          g = a.tabKey,
          w = a.pureBackgroundColor,
          x = a.backgroundGradient,
          k = a.backgroundImage,
          O = a.backgroundType,
          I = a.descStyle,
          S = a.titleStyle,
          j = a.cardHeight,
          T = a.spacingTabFromCard,
          C = a.paddingTop,
          M = a.paddingBottom,
          P = a.tips360,
          E = a.tips180,
          L = a.tipsModal180,
          B = a.tipsModal360,
          N = a.wrapperHeight,
          D = Object(i.useRef)(),
          z = u()("tab-horizontal-wrapper"),
          A = u()(
            "atom-horiozntal-tab-component",
            "vertical-center-align",
            "".concat(o ? "mobile" : ""),
          ),
          R = { backgroundColor: w };
        "gradient" === O
          ? (t = x)
          : "image" === O &&
            ((t = "url('".concat(k, "')")),
            (R.backgroundSize = "cover"),
            (R.backgroundRepeat = "no-repeat"),
            (R.backgroundPosition = "50%"));
        var F = {
          width: o ? "" : f,
          paddingTop: C,
          paddingBottom: M,
          minHeight: N,
        };
        null === m ||
          void 0 === m ||
          m.forEach(function (e, t) {
            e.tabKey = t + 1;
          });
        var V =
            null === m || void 0 === m
              ? void 0
              : m.map(function (e) {
                  return {
                    title: e.title,
                    desc: e.desc,
                    tabKey: e.tabKey,
                    type: e.mediaType,
                  };
                }),
          H = o ? "100%" : f;
        return ae(
          s.a,
          {
            type: "bg",
            visibleByDefault: c,
            src: t,
            style: R,
            className:
              "atom-design-v1 " +
              r()(A, re, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
          },
          ae(
            "div",
            {
              className: "style__section-tab-sceneswitch___2DRd_",
              id: "section-tab-sceneswitch section-tab-sceneswitch_".concat(d),
              ref: D,
            },
            ae(
              "div",
              {
                style: F,
                className: r()(z, re, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
              },
              ae(oe, {
                tabTheme: h,
                spacingTabFromCard: T,
                defaultActiveKey: +g,
                barContent: V,
                cardConfigList: m,
                gridWidth: H,
                tabPresentation: b,
                tabCarouselInterval: v,
                hasDesc: y,
                t: l,
                titleStyle: S,
                descStyle: I,
                cardHeight: j,
                mobileMode: o,
                eventAction: _,
                sectionRef: D,
                tips360: P,
                tips180: E,
                tipsModal180: L,
                tipsModal360: B,
                visibleByDefault: c,
                id: d,
                gaSend: p,
              }),
            ),
          ),
        );
      };
      (se.defaultProps = K), (se.editSetting = Q);
      t.a = Object(c.a)(se);
    },
    "9nLi": function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t) && !e.required) return n();
          r.default.required(e, t, o, l, a),
            void 0 !== t && r.default.type(e, t, o, l, a);
        }
        n(l);
      };
    },
    "9uj6": function (e, t, n) {
      "use strict";
      n.r(t);
      var o =
          /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
        a = (function (e) {
          var t = {};
          return function (n) {
            return void 0 === t[n] && (t[n] = e(n)), t[n];
          };
        })(function (e) {
          return (
            o.test(e) ||
            (111 === e.charCodeAt(0) &&
              110 === e.charCodeAt(1) &&
              e.charCodeAt(2) < 91)
          );
        });
      t.default = a;
    },
    A5Xg: function (e, t, n) {
      var o = n("NsO/"),
        a = n("ar/p").f,
        r = {}.toString,
        i =
          "object" == typeof window && window && Object.getOwnPropertyNames
            ? Object.getOwnPropertyNames(window)
            : [];
      e.exports.f = function (e) {
        return i && "[object Window]" == r.call(e)
          ? (function (e) {
              try {
                return a(e);
              } catch (t) {
                return i.slice();
              }
            })(e)
          : a(o(e));
      };
    },
    A90E: function (e, t, n) {
      var o = n("6sVZ"),
        a = n("V6Ve"),
        r = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        if (!o(e)) return a(e);
        var t = [];
        for (var n in Object(e))
          r.call(e, n) && "constructor" != n && t.push(n);
        return t;
      };
    },
    ALVP: function (e, t, n) {
      e.exports = {
        "modal-block-horizontal": "style__modal-block-horizontal___2q2M2",
        "modal-block-horizontal-active":
          "style__modal-block-horizontal-active___3FJ06",
        "popup-content-wrapper": "style__popup-content-wrapper___1YC4A",
        "pop-up-inner-wrapper": "style__pop-up-inner-wrapper___2UO12",
        "popup-content": "style__popup-content___25_ER",
        close: "style__close___gbUVW",
        "modal-block-container-mobile":
          "style__modal-block-container-mobile___1fCIk",
      };
    },
    AP2z: function (e, t, n) {
      var o = n("nmnc"),
        a = Object.prototype,
        r = a.hasOwnProperty,
        i = a.toString,
        l = o ? o.toStringTag : void 0;
      e.exports = function (e) {
        var t = r.call(e, l),
          n = e[l];
        try {
          e[l] = void 0;
          var o = !0;
        } catch (s) {}
        var a = i.call(e);
        return o && (t ? (e[l] = n) : delete e[l]), a;
      };
    },
    AQPw: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        a = c(n("q1tI")),
        r = n("w6RS"),
        i = c(n("pIsd")),
        l = c(n("iYzT")),
        s = n("GzxR");
      function c(e) {
        return e && e.__esModule ? e : { default: e };
      }
      var _ = (0, s.canUseDOM)() && n("jpXb"),
        u = (function (e) {
          function t(n) {
            !(function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, t);
            var o = (function (e, t) {
              if (!e)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return !t || ("object" !== typeof t && "function" !== typeof t)
                ? e
                : t;
            })(this, e.call(this, n));
            return (
              (o.innerSliderRefHandler = function (e) {
                return (o.innerSlider = e);
              }),
              (o.slickPrev = function () {
                return o.innerSlider.slickPrev();
              }),
              (o.slickNext = function () {
                return o.innerSlider.slickNext();
              }),
              (o.slickGoTo = function (e) {
                var t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1];
                return o.innerSlider.slickGoTo(e, t);
              }),
              (o.slickPause = function () {
                return o.innerSlider.pause("paused");
              }),
              (o.slickPlay = function () {
                return o.innerSlider.autoPlay("play");
              }),
              (o.state = { breakpoint: null }),
              (o._responsiveMediaHandlers = []),
              o
            );
          }
          return (
            (function (e, t) {
              if ("function" !== typeof t && null !== t)
                throw new TypeError(
                  "Super expression must either be null or a function, not " +
                    typeof t,
                );
              (e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
                t &&
                  (Object.setPrototypeOf
                    ? Object.setPrototypeOf(e, t)
                    : (e.__proto__ = t));
            })(t, e),
            (t.prototype.media = function (e, t) {
              _.register(e, t),
                this._responsiveMediaHandlers.push({ query: e, handler: t });
            }),
            (t.prototype.componentWillMount = function () {
              var e = this;
              if (this.props.responsive) {
                var t = this.props.responsive.map(function (e) {
                  return e.breakpoint;
                });
                t.sort(function (e, t) {
                  return e - t;
                }),
                  t.forEach(function (n, o) {
                    var a = void 0;
                    (a =
                      0 === o
                        ? (0, i.default)({ minWidth: 0, maxWidth: n })
                        : (0, i.default)({
                            minWidth: t[o - 1] + 1,
                            maxWidth: n,
                          })),
                      (0, s.canUseDOM)() &&
                        e.media(a, function () {
                          e.setState({ breakpoint: n });
                        });
                  });
                var n = (0, i.default)({ minWidth: t.slice(-1)[0] });
                (0, s.canUseDOM)() &&
                  this.media(n, function () {
                    e.setState({ breakpoint: null });
                  });
              }
            }),
            (t.prototype.componentWillUnmount = function () {
              this._responsiveMediaHandlers.forEach(function (e) {
                _.unregister(e.query, e.handler);
              });
            }),
            (t.prototype.render = function () {
              var e,
                t,
                n = this;
              (e = this.state.breakpoint
                ? "unslick" ===
                  (t = this.props.responsive.filter(function (e) {
                    return e.breakpoint === n.state.breakpoint;
                  }))[0].settings
                  ? "unslick"
                  : o({}, l.default, this.props, t[0].settings)
                : o({}, l.default, this.props)).centerMode &&
                (e.slidesToScroll, (e.slidesToScroll = 1)),
                e.fade &&
                  (e.slidesToShow,
                  e.slidesToScroll,
                  (e.slidesToShow = 1),
                  (e.slidesToScroll = 1));
              var i = a.default.Children.toArray(this.props.children);
              (i = i.filter(function (e) {
                return "string" === typeof e ? !!e.trim() : !!e;
              })),
                e.variableWidth &&
                  (e.rows > 1 || e.slidesPerRow > 1) &&
                  (console.warn(
                    "variableWidth is not supported in case of rows > 1 or slidesPerRow > 1",
                  ),
                  (e.variableWidth = !1));
              var s = [],
                c = null;
              if (1 === e.rows && 1 === e.slidesPerRow) s = i;
              else
                for (var _ = 0; _ < i.length; _ += e.rows * e.slidesPerRow) {
                  for (
                    var u = [], d = _;
                    d < _ + e.rows * e.slidesPerRow;
                    d += e.slidesPerRow
                  ) {
                    for (
                      var p = [], f = d;
                      f < d + e.slidesPerRow &&
                      (e.variableWidth &&
                        i[f].props.style &&
                        (c = i[f].props.style.width),
                      !(f >= i.length));
                      f += 1
                    )
                      p.push(
                        a.default.cloneElement(i[f], {
                          key: 100 * _ + 10 * d + f,
                          tabIndex: -1,
                          style: o(
                            {
                              width: 100 / e.slidesPerRow + "%",
                              display: "inline-block",
                            },
                            i[f].props.style,
                          ),
                        }),
                      );
                    u.push(
                      a.default.createElement("div", { key: 10 * _ + d }, p),
                    );
                  }
                  e.variableWidth
                    ? s.push(
                        a.default.createElement(
                          "div",
                          { key: _, style: { width: c } },
                          u,
                        ),
                      )
                    : s.push(a.default.createElement("div", { key: _ }, u));
                }
              if ("unslick" === e) {
                var h = "regular slider " + (this.props.className || "");
                return a.default.createElement("div", { className: h }, s);
              }
              return (
                s.length <= e.slidesToShow && (e.unslick = !0),
                a.default.createElement(
                  r.InnerSlider,
                  o({ ref: this.innerSliderRefHandler }, e),
                  s,
                )
              );
            }),
            t
          );
        })(a.default.Component);
      t.default = u;
    },
    ATyU: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return yr;
      });
      var o = n("mrSG"),
        a = n("q1tI"),
        r = n.n(a),
        i = function (e) {
          return {
            isEnabled: function (t) {
              return e.some(function (e) {
                return !!t[e];
              });
            },
          };
        },
        l = {
          measureLayout: i([
            "layout",
            "layoutId",
            "drag",
            "_layoutResetTransform",
          ]),
          animation: i([
            "animate",
            "exit",
            "variants",
            "whileHover",
            "whileTap",
            "whileFocus",
            "whileDrag",
          ]),
          exit: i(["exit"]),
          drag: i(["drag", "dragControls"]),
          focus: i(["whileFocus"]),
          hover: i(["whileHover", "onHoverStart", "onHoverEnd"]),
          tap: i(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
          pan: i(["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"]),
          layoutAnimation: i(["layout", "layoutId"]),
        };
      var s = n("82gj"),
        c = Object(a.createContext)({ strict: !1 }),
        _ = Object.keys(l),
        u = _.length;
      var d = n("e5U0"),
        p = Object(a.createContext)({});
      var f = Object(a.createContext)(null),
        h = n("J4/h");
      function m() {
        var e = Object(a.useContext)(f);
        if (null === e) return [!0, null];
        var t = e.isPresent,
          n = e.onExitComplete,
          o = e.register,
          r = g();
        Object(a.useEffect)(function () {
          return o(r);
        }, []);
        return !t && n
          ? [
              !1,
              function () {
                return null === n || void 0 === n ? void 0 : n(r);
              },
            ]
          : [!0];
      }
      function y(e) {
        return null === e || e.isPresent;
      }
      var b = 0,
        v = function () {
          return b++;
        },
        g = function () {
          return Object(h.a)(v);
        },
        w = Object(a.createContext)(null),
        x = "undefined" !== typeof window,
        k = x ? a.useLayoutEffect : a.useEffect;
      function O(e, t, n, r) {
        var i = Object(a.useContext)(d.a),
          l = Object(a.useContext)(c),
          s = Object(a.useContext)(p).visualElement,
          _ = Object(a.useContext)(f),
          u = (function (e) {
            var t = e.layoutId,
              n = Object(a.useContext)(w);
            return n && void 0 !== t ? n + "-" + t : t;
          })(n),
          h = Object(a.useRef)(void 0);
        r || (r = l.renderer),
          !h.current &&
            r &&
            (h.current = r(e, {
              visualState: t,
              parent: s,
              props: Object(o.a)(Object(o.a)({}, n), { layoutId: u }),
              presenceId: null === _ || void 0 === _ ? void 0 : _.id,
              blockInitialAnimation:
                !1 === (null === _ || void 0 === _ ? void 0 : _.initial),
            }));
        var m = h.current;
        return (
          k(function () {
            m &&
              (m.setProps(
                Object(o.a)(Object(o.a)(Object(o.a)({}, i), n), {
                  layoutId: u,
                }),
              ),
              (m.isPresent = y(_)),
              (m.isPresenceRoot =
                !s ||
                s.presenceId !== (null === _ || void 0 === _ ? void 0 : _.id)),
              m.syncRender());
          }),
          Object(a.useEffect)(function () {
            var e;
            m &&
              (null === (e = m.animationState) ||
                void 0 === e ||
                e.animateChanges());
          }),
          k(function () {
            return function () {
              return null === m || void 0 === m ? void 0 : m.notifyUnmount();
            };
          }, []),
          m
        );
      }
      function I(e) {
        return (
          "object" === typeof e &&
          Object.prototype.hasOwnProperty.call(e, "current")
        );
      }
      function S(e) {
        return Array.isArray(e);
      }
      function j(e) {
        return "string" === typeof e || S(e);
      }
      function T(e, t, n, o, a) {
        var r;
        return (
          void 0 === o && (o = {}),
          void 0 === a && (a = {}),
          "string" === typeof t &&
            (t = null === (r = e.variants) || void 0 === r ? void 0 : r[t]),
          "function" === typeof t
            ? t(null !== n && void 0 !== n ? n : e.custom, o, a)
            : t
        );
      }
      function C(e, t, n) {
        var o = e.getProps();
        return T(
          o,
          t,
          null !== n && void 0 !== n ? n : o.custom,
          (function (e) {
            var t = {};
            return (
              e.forEachValue(function (e, n) {
                return (t[n] = e.get());
              }),
              t
            );
          })(e),
          (function (e) {
            var t = {};
            return (
              e.forEachValue(function (e, n) {
                return (t[n] = e.getVelocity());
              }),
              t
            );
          })(e),
        );
      }
      function M(e) {
        var t;
        return (
          "function" ===
            typeof (null === (t = e.animate) || void 0 === t
              ? void 0
              : t.start) ||
          j(e.initial) ||
          j(e.animate) ||
          j(e.whileHover) ||
          j(e.whileDrag) ||
          j(e.whileTap) ||
          j(e.whileFocus) ||
          j(e.exit)
        );
      }
      function P(e) {
        return Boolean(M(e) || e.variants);
      }
      function E(e, t) {
        var n = (function (e, t) {
            if (M(e)) {
              var n = e.initial,
                o = e.animate;
              return {
                initial: !1 === n || j(n) ? n : void 0,
                animate: j(o) ? o : void 0,
              };
            }
            return !1 !== e.inherit ? t : {};
          })(e, Object(a.useContext)(p)),
          o = n.initial,
          r = n.animate;
        return Object(a.useMemo)(
          function () {
            return { initial: o, animate: r };
          },
          t ? [L(o), L(r)] : [],
        );
      }
      function L(e) {
        return Array.isArray(e) ? e.join(" ") : e;
      }
      function B(e) {
        var t = e.preloadedFeatures,
          n = e.createVisualElement,
          r = e.useRender,
          i = e.useVisualState,
          s = e.Component;
        return (
          t &&
            (function (e) {
              for (var t in e) {
                var n = e[t];
                null !== n && (l[t].Component = n);
              }
            })(t),
          Object(a.forwardRef)(function (e, t) {
            var f = Object(a.useContext)(d.a).isStatic,
              h = null,
              m = E(e, f),
              y = i(e, f);
            return (
              !f &&
                x &&
                ((m.visualElement = O(s, y, e, n)),
                (h = (function (e, t, n) {
                  var r = [];
                  if ((Object(a.useContext)(c), !t)) return null;
                  for (var i = 0; i < u; i++) {
                    var s = _[i],
                      d = l[s],
                      p = d.isEnabled,
                      f = d.Component;
                    p(e) &&
                      f &&
                      r.push(
                        a.createElement(
                          f,
                          Object(o.a)({ key: s }, e, { visualElement: t }),
                        ),
                      );
                  }
                  return r;
                })(e, m.visualElement))),
              a.createElement(
                a.Fragment,
                null,
                a.createElement(
                  p.Provider,
                  { value: m },
                  r(
                    s,
                    e,
                    (function (e, t, n) {
                      return Object(a.useCallback)(
                        function (o) {
                          var a;
                          o &&
                            (null === (a = e.mount) ||
                              void 0 === a ||
                              a.call(e, o)),
                            t && (o ? t.mount(o) : t.unmount()),
                            n &&
                              ("function" === typeof n
                                ? n(o)
                                : I(n) && (n.current = o));
                        },
                        [t],
                      );
                    })(y, m.visualElement, t),
                    y,
                    f,
                  ),
                ),
                h,
              )
            );
          })
        );
      }
      function N(e) {
        function t(t, n) {
          return void 0 === n && (n = {}), B(e(t, n));
        }
        var n = new Map();
        return new Proxy(t, {
          get: function (e, o) {
            return n.has(o) || n.set(o, t(o)), n.get(o);
          },
        });
      }
      var D = [
        "animate",
        "circle",
        "defs",
        "desc",
        "ellipse",
        "g",
        "image",
        "line",
        "filter",
        "marker",
        "mask",
        "metadata",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "rect",
        "stop",
        "svg",
        "switch",
        "symbol",
        "text",
        "tspan",
        "use",
        "view",
      ];
      function z(e) {
        return (
          "string" === typeof e &&
          !e.includes("-") &&
          !!(D.indexOf(e) > -1 || /[A-Z]/.test(e))
        );
      }
      var A = {};
      var R = ["", "X", "Y", "Z"],
        F = ["transformPerspective", "x", "y", "z"];
      function V(e, t) {
        return F.indexOf(e) - F.indexOf(t);
      }
      ["translate", "scale", "rotate", "skew"].forEach(function (e) {
        return R.forEach(function (t) {
          return F.push(e + t);
        });
      });
      var H = new Set(F);
      function W(e) {
        return H.has(e);
      }
      var U = new Set(["originX", "originY", "originZ"]);
      function G(e) {
        return U.has(e);
      }
      function Y(e, t) {
        var n = t.layout,
          o = t.layoutId;
        return (
          W(e) || G(e) || ((n || void 0 !== o) && (!!A[e] || "opacity" === e))
        );
      }
      var q = n("TLPt"),
        X = {
          x: "translateX",
          y: "translateY",
          z: "translateZ",
          transformPerspective: "perspective",
        };
      function Z(e) {
        return e.startsWith("--");
      }
      var K = function (e, t) {
          return t && "number" === typeof e ? t.transform(e) : e;
        },
        Q = n("tvYQ"),
        J = n("C68Z"),
        $ = Object(o.a)(Object(o.a)({}, J.b), { transform: Math.round }),
        ee = {
          borderWidth: Q.d,
          borderTopWidth: Q.d,
          borderRightWidth: Q.d,
          borderBottomWidth: Q.d,
          borderLeftWidth: Q.d,
          borderRadius: Q.d,
          radius: Q.d,
          borderTopLeftRadius: Q.d,
          borderTopRightRadius: Q.d,
          borderBottomRightRadius: Q.d,
          borderBottomLeftRadius: Q.d,
          width: Q.d,
          maxWidth: Q.d,
          height: Q.d,
          maxHeight: Q.d,
          size: Q.d,
          top: Q.d,
          right: Q.d,
          bottom: Q.d,
          left: Q.d,
          padding: Q.d,
          paddingTop: Q.d,
          paddingRight: Q.d,
          paddingBottom: Q.d,
          paddingLeft: Q.d,
          margin: Q.d,
          marginTop: Q.d,
          marginRight: Q.d,
          marginBottom: Q.d,
          marginLeft: Q.d,
          rotate: Q.a,
          rotateX: Q.a,
          rotateY: Q.a,
          rotateZ: Q.a,
          scale: J.c,
          scaleX: J.c,
          scaleY: J.c,
          scaleZ: J.c,
          skew: Q.a,
          skewX: Q.a,
          skewY: Q.a,
          distance: Q.d,
          translateX: Q.d,
          translateY: Q.d,
          translateZ: Q.d,
          x: Q.d,
          y: Q.d,
          z: Q.d,
          perspective: Q.d,
          transformPerspective: Q.d,
          opacity: J.a,
          originX: Q.c,
          originY: Q.c,
          originZ: Q.d,
          zIndex: $,
          fillOpacity: J.a,
          strokeOpacity: J.a,
          numOctaves: $,
        };
      function te(e, t, n, o, a, r, i, l) {
        var s,
          c = e.style,
          _ = e.vars,
          u = e.transform,
          d = e.transformKeys,
          p = e.transformOrigin;
        d.length = 0;
        var f = !1,
          h = !1,
          m = !0;
        for (var y in t) {
          var b = t[y];
          if (Z(y)) _[y] = b;
          else {
            var v = ee[y],
              g = K(b, v);
            if (W(y)) {
              if (((f = !0), (u[y] = g), d.push(y), !m)) continue;
              b !== (null !== (s = v.default) && void 0 !== s ? s : 0) &&
                (m = !1);
            } else if (G(y)) (p[y] = g), (h = !0);
            else if (
              (null === n || void 0 === n ? void 0 : n.isHydrated) &&
              (null === o || void 0 === o ? void 0 : o.isHydrated) &&
              A[y]
            ) {
              var w = A[y].process(b, o, n),
                x = A[y].applyTo;
              if (x) for (var k = x.length, O = 0; O < k; O++) c[x[O]] = w;
              else c[y] = w;
            } else c[y] = g;
          }
        }
        o && n && i && l
          ? ((c.transform = i(o.deltaFinal, o.treeScale, f ? u : void 0)),
            r && (c.transform = r(u, c.transform)),
            (c.transformOrigin = l(o)))
          : (f &&
              (c.transform = (function (e, t, n, o) {
                var a = e.transform,
                  r = e.transformKeys,
                  i = t.enableHardwareAcceleration,
                  l = void 0 === i || i,
                  s = t.allowTransformNone,
                  c = void 0 === s || s,
                  _ = "";
                r.sort(V);
                for (var u = !1, d = r.length, p = 0; p < d; p++) {
                  var f = r[p];
                  (_ += (X[f] || f) + "(" + a[f] + ") "), "z" === f && (u = !0);
                }
                return (
                  !u && l ? (_ += "translateZ(0)") : (_ = _.trim()),
                  o ? (_ = o(a, n ? "" : _)) : c && n && (_ = "none"),
                  _
                );
              })(e, a, m, r)),
            h &&
              (c.transformOrigin = (function (e) {
                var t = e.originX,
                  n = void 0 === t ? "50%" : t,
                  o = e.originY,
                  a = void 0 === o ? "50%" : o,
                  r = e.originZ;
                return n + " " + a + " " + (void 0 === r ? 0 : r);
              })(p)));
      }
      var ne = function () {
        return {
          style: {},
          transform: {},
          transformKeys: [],
          transformOrigin: {},
          vars: {},
        };
      };
      function oe(e, t, n) {
        for (var o in t) Object(q.a)(t[o]) || Y(o, n) || (e[o] = t[o]);
      }
      function ae(e, t, n) {
        var r = {};
        return (
          oe(r, e.style || {}, e),
          Object.assign(
            r,
            (function (e, t, n) {
              var r = e.transformTemplate;
              return Object(a.useMemo)(
                function () {
                  var e = ne();
                  te(
                    e,
                    t,
                    void 0,
                    void 0,
                    { enableHardwareAcceleration: !n },
                    r,
                  );
                  var a = e.vars,
                    i = e.style;
                  return Object(o.a)(Object(o.a)({}, a), i);
                },
                [t],
              );
            })(e, t, n),
          ),
          e.transformValues && (r = e.transformValues(r)),
          r
        );
      }
      function re(e, t, n) {
        var o = {},
          a = ae(e, t, n);
        return (
          Boolean(e.drag) &&
            ((o.draggable = !1),
            (a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none"),
            (a.touchAction =
              !0 === e.drag ? "none" : "pan-" + ("x" === e.drag ? "y" : "x"))),
          (o.style = a),
          o
        );
      }
      var ie = new Set([
        "initial",
        "animate",
        "exit",
        "style",
        "variants",
        "transition",
        "transformTemplate",
        "transformValues",
        "custom",
        "inherit",
        "layout",
        "layoutId",
        "_layoutResetTransform",
        "onLayoutAnimationComplete",
        "onViewportBoxUpdate",
        "onLayoutMeasure",
        "onBeforeLayoutMeasure",
        "onAnimationStart",
        "onAnimationComplete",
        "onUpdate",
        "onDragStart",
        "onDrag",
        "onDragEnd",
        "onMeasureDragConstraints",
        "onDirectionLock",
        "onDragTransitionEnd",
        "drag",
        "dragControls",
        "dragListener",
        "dragConstraints",
        "dragDirectionLock",
        "_dragX",
        "_dragY",
        "dragElastic",
        "dragMomentum",
        "dragPropagation",
        "dragTransition",
        "whileDrag",
        "onPan",
        "onPanStart",
        "onPanEnd",
        "onPanSessionStart",
        "onTap",
        "onTapStart",
        "onTapCancel",
        "onHoverStart",
        "onHoverEnd",
        "whileFocus",
        "whileTap",
        "whileHover",
      ]);
      function le(e) {
        return ie.has(e);
      }
      var se = function (e) {
        return !le(e);
      };
      try {
        var ce = n("9uj6").default;
        se = function (e) {
          return e.startsWith("on") ? !le(e) : ce(e);
        };
      } catch (br) {}
      function _e(e, t, n) {
        return "string" === typeof e ? e : Q.d.transform(t + n * e);
      }
      var ue = function (e, t) {
          return Q.d.transform(e * t);
        },
        de = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
        pe = { offset: "strokeDashoffset", array: "strokeDasharray" };
      function fe(e, t, n, a, r, i, l, s) {
        var c = t.attrX,
          _ = t.attrY,
          u = t.originX,
          d = t.originY,
          p = t.pathLength,
          f = t.pathSpacing,
          h = void 0 === f ? 1 : f,
          m = t.pathOffset,
          y = void 0 === m ? 0 : m;
        te(
          e,
          Object(o.d)(t, [
            "attrX",
            "attrY",
            "originX",
            "originY",
            "pathLength",
            "pathSpacing",
            "pathOffset",
          ]),
          n,
          a,
          r,
          i,
          l,
          s,
        ),
          (e.attrs = e.style),
          (e.style = {});
        var b = e.attrs,
          v = e.style,
          g = e.dimensions,
          w = e.totalPathLength;
        b.transform && (g && (v.transform = b.transform), delete b.transform),
          g &&
            (void 0 !== u || void 0 !== d || v.transform) &&
            (v.transformOrigin = (function (e, t, n) {
              return _e(t, e.x, e.width) + " " + _e(n, e.y, e.height);
            })(g, void 0 !== u ? u : 0.5, void 0 !== d ? d : 0.5)),
          void 0 !== c && (b.x = c),
          void 0 !== _ && (b.y = _),
          void 0 !== w &&
            void 0 !== p &&
            (function (e, t, n, o, a, r) {
              void 0 === o && (o = 1),
                void 0 === a && (a = 0),
                void 0 === r && (r = !0);
              var i = r ? de : pe;
              e[i.offset] = ue(-a, t);
              var l = ue(n, t),
                s = ue(o, t);
              e[i.array] = l + " " + s;
            })(b, w, p, h, y, !1);
      }
      var he = function () {
        return Object(o.a)(Object(o.a)({}, ne()), { attrs: {} });
      };
      function me(e, t) {
        var n = Object(a.useMemo)(
          function () {
            var n = he();
            return (
              fe(
                n,
                t,
                void 0,
                void 0,
                { enableHardwareAcceleration: !1 },
                e.transformTemplate,
              ),
              Object(o.a)(Object(o.a)({}, n.attrs), {
                style: Object(o.a)({}, n.style),
              })
            );
          },
          [t],
        );
        if (e.style) {
          var r = {};
          oe(r, e.style, e),
            (n.style = Object(o.a)(Object(o.a)({}, r), n.style));
        }
        return n;
      }
      function ye(e) {
        void 0 === e && (e = !1);
        return function (t, n, r, i, l) {
          var s = i.latestValues,
            c = (z(t) ? me : re)(n, s, l),
            _ = (function (e, t, n) {
              var o = {};
              for (var a in e)
                (se(a) || (!0 === n && le(a)) || (!t && !le(a))) &&
                  (o[a] = e[a]);
              return o;
            })(n, "string" === typeof t, e),
            u = Object(o.a)(Object(o.a)(Object(o.a)({}, _), c), { ref: r });
          return Object(a.createElement)(t, u);
        };
      }
      var be = /([a-z])([A-Z])/g,
        ve = function (e) {
          return e.replace(be, "$1-$2").toLowerCase();
        };
      function ge(e, t) {
        var n = t.style,
          o = t.vars;
        for (var a in (Object.assign(e.style, n), o))
          e.style.setProperty(a, o[a]);
      }
      var we = new Set([
        "baseFrequency",
        "diffuseConstant",
        "kernelMatrix",
        "kernelUnitLength",
        "keySplines",
        "keyTimes",
        "limitingConeAngle",
        "markerHeight",
        "markerWidth",
        "numOctaves",
        "targetX",
        "targetY",
        "surfaceScale",
        "specularConstant",
        "specularExponent",
        "stdDeviation",
        "tableValues",
        "viewBox",
        "gradientTransform",
      ]);
      function xe(e, t) {
        for (var n in (ge(e, t), t.attrs))
          e.setAttribute(we.has(n) ? n : ve(n), t.attrs[n]);
      }
      function ke(e) {
        var t = e.style,
          n = {};
        for (var o in t) (Object(q.a)(t[o]) || Y(o, e)) && (n[o] = t[o]);
        return n;
      }
      function Oe(e) {
        var t = ke(e);
        for (var n in e) {
          if (Object(q.a)(e[n]))
            t["x" === n || "y" === n ? "attr" + n.toUpperCase() : n] = e[n];
        }
        return t;
      }
      function Ie(e) {
        return "object" === typeof e && "function" === typeof e.start;
      }
      var Se = function (e) {
          return Array.isArray(e);
        },
        je = function (e) {
          return Boolean(e && "object" === typeof e && e.mix && e.toValue);
        },
        Te = function (e) {
          return Se(e) ? e[e.length - 1] || 0 : e;
        };
      function Ce(e) {
        var t = Object(q.a)(e) ? e.get() : e;
        return je(t) ? t.toValue() : t;
      }
      function Me(e, t, n, o) {
        var a = e.scrapeMotionValuesFromProps,
          r = e.createRenderState,
          i = e.onMount,
          l = { latestValues: Ee(t, n, o, a), renderState: r() };
        return (
          i &&
            (l.mount = function (e) {
              return i(t, e, l);
            }),
          l
        );
      }
      var Pe = function (e) {
        return function (t, n) {
          var o = Object(a.useContext)(p),
            r = Object(a.useContext)(f);
          return n
            ? Me(e, t, o, r)
            : Object(h.a)(function () {
                return Me(e, t, o, r);
              });
        };
      };
      function Ee(e, t, n, a) {
        var r = {},
          i = !1 === (null === n || void 0 === n ? void 0 : n.initial),
          l = a(e);
        for (var s in l) r[s] = Ce(l[s]);
        var c = e.initial,
          _ = e.animate,
          u = M(e),
          d = P(e);
        t &&
          d &&
          !u &&
          !1 !== e.inherit &&
          ((null !== c && void 0 !== c) || (c = t.initial),
          (null !== _ && void 0 !== _) || (_ = t.animate));
        var p = i || !1 === c ? _ : c;
        p &&
          "boolean" !== typeof p &&
          !Ie(p) &&
          (Array.isArray(p) ? p : [p]).forEach(function (t) {
            var n = T(e, t);
            if (n) {
              var a = n.transitionEnd;
              n.transition;
              var i = Object(o.d)(n, ["transitionEnd", "transition"]);
              for (var l in i) r[l] = i[l];
              for (var l in a) r[l] = a[l];
            }
          });
        return r;
      }
      var Le = {
        useVisualState: Pe({
          scrapeMotionValuesFromProps: Oe,
          createRenderState: he,
          onMount: function (e, t, n) {
            var o = n.renderState,
              a = n.latestValues;
            try {
              o.dimensions =
                "function" === typeof t.getBBox
                  ? t.getBBox()
                  : t.getBoundingClientRect();
            } catch (r) {
              o.dimensions = { x: 0, y: 0, width: 0, height: 0 };
            }
            "path" === t.tagName && (o.totalPathLength = t.getTotalLength()),
              fe(
                o,
                a,
                void 0,
                void 0,
                { enableHardwareAcceleration: !1 },
                e.transformTemplate,
              ),
              xe(t, o);
          },
        }),
      };
      var Be,
        Ne = {
          useVisualState: Pe({
            scrapeMotionValuesFromProps: ke,
            createRenderState: ne,
          }),
        };
      function De(e, t, n, a) {
        var r = t.forwardMotionProps,
          i = void 0 !== r && r,
          l = z(e) ? Le : Ne;
        return Object(o.a)(Object(o.a)({}, l), {
          preloadedFeatures: n,
          useRender: ye(i),
          createVisualElement: a,
          Component: e,
        });
      }
      function ze(e, t, n, o) {
        return (
          e.addEventListener(t, n, o),
          function () {
            return e.removeEventListener(t, n, o);
          }
        );
      }
      function Ae(e, t, n, o) {
        Object(a.useEffect)(
          function () {
            var a = e.current;
            if (n && a) return ze(a, t, n, o);
          },
          [e, t, n, o],
        );
      }
      function Re(e) {
        return "undefined" !== typeof PointerEvent && e instanceof PointerEvent
          ? !("mouse" !== e.pointerType)
          : e instanceof MouseEvent;
      }
      function Fe(e) {
        return !!e.touches;
      }
      !(function (e) {
        (e.Animate = "animate"),
          (e.Hover = "whileHover"),
          (e.Tap = "whileTap"),
          (e.Drag = "whileDrag"),
          (e.Focus = "whileFocus"),
          (e.Exit = "exit");
      })(Be || (Be = {}));
      var Ve = { pageX: 0, pageY: 0 };
      function He(e, t) {
        void 0 === t && (t = "page");
        var n = e.touches[0] || e.changedTouches[0] || Ve;
        return { x: n[t + "X"], y: n[t + "Y"] };
      }
      function We(e, t) {
        return void 0 === t && (t = "page"), { x: e[t + "X"], y: e[t + "Y"] };
      }
      function Ue(e, t) {
        return (
          void 0 === t && (t = "page"), { point: Fe(e) ? He(e, t) : We(e, t) }
        );
      }
      var Ge = function (e, t) {
          void 0 === t && (t = !1);
          var n,
            o = function (t) {
              return e(t, Ue(t));
            };
          return t
            ? ((n = o),
              function (e) {
                var t = e instanceof MouseEvent;
                (!t || (t && 0 === e.button)) && n(e);
              })
            : o;
        },
        Ye = function () {
          return x && null === window.onpointerdown;
        },
        qe = function () {
          return x && null === window.ontouchstart;
        },
        Xe = function () {
          return x && null === window.onmousedown;
        },
        Ze = {
          pointerdown: "mousedown",
          pointermove: "mousemove",
          pointerup: "mouseup",
          pointercancel: "mousecancel",
          pointerover: "mouseover",
          pointerout: "mouseout",
          pointerenter: "mouseenter",
          pointerleave: "mouseleave",
        },
        Ke = {
          pointerdown: "touchstart",
          pointermove: "touchmove",
          pointerup: "touchend",
          pointercancel: "touchcancel",
        };
      function Qe(e) {
        return Ye() ? e : qe() ? Ke[e] : Xe() ? Ze[e] : e;
      }
      function Je(e, t, n, o) {
        return ze(e, Qe(t), Ge(n, "pointerdown" === t), o);
      }
      function $e(e, t, n, o) {
        return Ae(e, Qe(t), n && Ge(n, "pointerdown" === t), o);
      }
      function et(e) {
        var t = null;
        return function () {
          return (
            null === t &&
            ((t = e),
            function () {
              t = null;
            })
          );
        };
      }
      var tt = et("dragHorizontal"),
        nt = et("dragVertical");
      function ot(e) {
        var t = !1;
        if ("y" === e) t = nt();
        else if ("x" === e) t = tt();
        else {
          var n = tt(),
            o = nt();
          n && o
            ? (t = function () {
                n(), o();
              })
            : (n && n(), o && o());
        }
        return t;
      }
      function at() {
        var e = ot(!0);
        return !e || (e(), !1);
      }
      function rt(e, t, n) {
        return function (o, a) {
          var r;
          Re(o) &&
            !at() &&
            (null === n || void 0 === n || n(o, a),
            null === (r = e.animationState) ||
              void 0 === r ||
              r.setActive(Be.Hover, t));
        };
      }
      var it = function (e, t) {
        return !!t && (e === t || it(e, t.parentElement));
      };
      function lt(e) {
        return Object(a.useEffect)(function () {
          return function () {
            return e();
          };
        }, []);
      }
      var st = n("NJgT");
      var ct = function (e) {
          return function (t) {
            return e(t), null;
          };
        },
        _t = {
          tap: ct(function (e) {
            var t = e.onTap,
              n = e.onTapStart,
              o = e.onTapCancel,
              r = e.whileTap,
              i = e.visualElement,
              l = t || n || o || r,
              s = Object(a.useRef)(!1),
              c = Object(a.useRef)(null);
            function _() {
              var e;
              null === (e = c.current) || void 0 === e || e.call(c),
                (c.current = null);
            }
            function u() {
              var e;
              return (
                _(),
                (s.current = !1),
                null === (e = i.animationState) ||
                  void 0 === e ||
                  e.setActive(Be.Tap, !1),
                !at()
              );
            }
            function d(e, n) {
              u() &&
                (it(i.getInstance(), e.target)
                  ? null === t || void 0 === t || t(e, n)
                  : null === o || void 0 === o || o(e, n));
            }
            function p(e, t) {
              u() && (null === o || void 0 === o || o(e, t));
            }
            $e(
              i,
              "pointerdown",
              l
                ? function (e, t) {
                    var o;
                    _(),
                      s.current ||
                        ((s.current = !0),
                        (c.current = Object(st.a)(
                          Je(window, "pointerup", d),
                          Je(window, "pointercancel", p),
                        )),
                        null === n || void 0 === n || n(e, t),
                        null === (o = i.animationState) ||
                          void 0 === o ||
                          o.setActive(Be.Tap, !0));
                  }
                : void 0,
            ),
              lt(_);
          }),
          focus: ct(function (e) {
            var t = e.whileFocus,
              n = e.visualElement;
            Ae(
              n,
              "focus",
              t
                ? function () {
                    var e;
                    null === (e = n.animationState) ||
                      void 0 === e ||
                      e.setActive(Be.Focus, !0);
                  }
                : void 0,
            ),
              Ae(
                n,
                "blur",
                t
                  ? function () {
                      var e;
                      null === (e = n.animationState) ||
                        void 0 === e ||
                        e.setActive(Be.Focus, !1);
                    }
                  : void 0,
              );
          }),
          hover: ct(function (e) {
            var t = e.onHoverStart,
              n = e.onHoverEnd,
              o = e.whileHover,
              a = e.visualElement;
            $e(a, "pointerenter", t || o ? rt(a, !0, t) : void 0),
              $e(a, "pointerleave", n || o ? rt(a, !1, n) : void 0);
          }),
        };
      function ut(e, t) {
        if (!Array.isArray(t)) return !1;
        var n = t.length;
        if (n !== e.length) return !1;
        for (var o = 0; o < n; o++) if (t[o] !== e[o]) return !1;
        return !0;
      }
      var dt = n("LUwM"),
        pt = 0.001,
        ft = 0.01,
        ht = 10,
        mt = 0.05,
        yt = 1;
      function bt(e) {
        var t,
          n,
          o = e.duration,
          a = void 0 === o ? 800 : o,
          r = e.bounce,
          i = void 0 === r ? 0.25 : r,
          l = e.velocity,
          c = void 0 === l ? 0 : l,
          _ = e.mass,
          u = void 0 === _ ? 1 : _;
        Object(s.b)(
          a <= 1e3 * ht,
          "Spring duration must be 10 seconds or less",
        );
        var d = 1 - i;
        (d = Object(dt.a)(mt, yt, d)),
          (a = Object(dt.a)(ft, ht, a / 1e3)),
          d < 1
            ? ((t = function (e) {
                var t = e * d,
                  n = t * a,
                  o = t - c,
                  r = gt(e, d),
                  i = Math.exp(-n);
                return pt - (o / r) * i;
              }),
              (n = function (e) {
                var n = e * d * a,
                  o = n * c + c,
                  r = Math.pow(d, 2) * Math.pow(e, 2) * a,
                  i = Math.exp(-n),
                  l = gt(Math.pow(e, 2), d);
                return ((-t(e) + pt > 0 ? -1 : 1) * ((o - r) * i)) / l;
              }))
            : ((t = function (e) {
                return Math.exp(-e * a) * ((e - c) * a + 1) - pt;
              }),
              (n = function (e) {
                return Math.exp(-e * a) * (a * a * (c - e));
              }));
        var p = (function (e, t, n) {
          for (var o = n, a = 1; a < vt; a++) o -= e(o) / t(o);
          return o;
        })(t, n, 5 / a);
        if (((a *= 1e3), isNaN(p)))
          return { stiffness: 100, damping: 10, duration: a };
        var f = Math.pow(p, 2) * u;
        return { stiffness: f, damping: 2 * d * Math.sqrt(u * f), duration: a };
      }
      var vt = 12;
      function gt(e, t) {
        return e * Math.sqrt(1 - t * t);
      }
      var wt = ["duration", "bounce"],
        xt = ["stiffness", "damping", "mass"];
      function kt(e, t) {
        return t.some(function (t) {
          return void 0 !== e[t];
        });
      }
      function Ot(e) {
        var t = e.from,
          n = void 0 === t ? 0 : t,
          a = e.to,
          r = void 0 === a ? 1 : a,
          i = e.restSpeed,
          l = void 0 === i ? 2 : i,
          s = e.restDelta,
          c = Object(o.d)(e, ["from", "to", "restSpeed", "restDelta"]),
          _ = { done: !1, value: n },
          u = (function (e) {
            var t = Object(o.a)(
              {
                velocity: 0,
                stiffness: 100,
                damping: 10,
                mass: 1,
                isResolvedFromDuration: !1,
              },
              e,
            );
            if (!kt(e, xt) && kt(e, wt)) {
              var n = bt(e);
              (t = Object(o.a)(Object(o.a)(Object(o.a)({}, t), n), {
                velocity: 0,
                mass: 1,
              })).isResolvedFromDuration = !0;
            }
            return t;
          })(c),
          d = u.stiffness,
          p = u.damping,
          f = u.mass,
          h = u.velocity,
          m = u.duration,
          y = u.isResolvedFromDuration,
          b = St,
          v = St;
        function g() {
          var e = h ? -h / 1e3 : 0,
            t = r - n,
            o = p / (2 * Math.sqrt(d * f)),
            a = Math.sqrt(d / f) / 1e3;
          if (
            ((null !== s && void 0 !== s) ||
              (s = Math.abs(r - n) <= 1 ? 0.01 : 0.4),
            o < 1)
          ) {
            var i = gt(a, o);
            (b = function (n) {
              var l = Math.exp(-o * a * n);
              return (
                r -
                l *
                  (((e + o * a * t) / i) * Math.sin(i * n) +
                    t * Math.cos(i * n))
              );
            }),
              (v = function (n) {
                var r = Math.exp(-o * a * n);
                return (
                  o *
                    a *
                    r *
                    ((Math.sin(i * n) * (e + o * a * t)) / i +
                      t * Math.cos(i * n)) -
                  r *
                    (Math.cos(i * n) * (e + o * a * t) -
                      i * t * Math.sin(i * n))
                );
              });
          } else if (1 === o)
            b = function (n) {
              return r - Math.exp(-a * n) * (t + (e + a * t) * n);
            };
          else {
            var l = a * Math.sqrt(o * o - 1);
            b = function (n) {
              var i = Math.exp(-o * a * n),
                s = Math.min(l * n, 300);
              return (
                r -
                (i * ((e + o * a * t) * Math.sinh(s) + l * t * Math.cosh(s))) /
                  l
              );
            };
          }
        }
        return (
          g(),
          {
            next: function (e) {
              var t = b(e);
              if (y) _.done = e >= m;
              else {
                var n = 1e3 * v(e),
                  o = Math.abs(n) <= l,
                  a = Math.abs(r - t) <= s;
                _.done = o && a;
              }
              return (_.value = _.done ? r : t), _;
            },
            flipTarget: function () {
              var e;
              (h = -h), (n = (e = [r, n])[0]), (r = e[1]), g();
            },
          }
        );
      }
      Ot.needsInterpolation = function (e, t) {
        return "string" === typeof e || "string" === typeof t;
      };
      var It,
        St = function (e) {
          return 0;
        },
        jt = n("1RGQ"),
        Tt = function (e) {
          return function (t) {
            return 1 - e(1 - t);
          };
        },
        Ct = function (e) {
          return function (t) {
            return t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2;
          };
        },
        Mt = function (e) {
          return function (t) {
            return t * t * ((e + 1) * t - e);
          };
        },
        Pt = function (e) {
          return e;
        },
        Et =
          ((It = 2),
          function (e) {
            return Math.pow(e, It);
          }),
        Lt = Tt(Et),
        Bt = Ct(Et),
        Nt = function (e) {
          return 1 - Math.sin(Math.acos(e));
        },
        Dt = Tt(Nt),
        zt = Ct(Dt),
        At = Mt(1.525),
        Rt = Tt(At),
        Ft = Ct(At),
        Vt = (function (e) {
          var t = Mt(e);
          return function (e) {
            return (e *= 2) < 1
              ? 0.5 * t(e)
              : 0.5 * (2 - Math.pow(2, -10 * (e - 1)));
          };
        })(1.525),
        Ht = function (e) {
          if (1 === e || 0 === e) return e;
          var t = e * e;
          return e < 4 / 11
            ? 7.5625 * t
            : e < 8 / 11
              ? 9.075 * t - 9.9 * e + 3.4
              : e < 0.9
                ? (4356 / 361) * t - (35442 / 1805) * e + 16061 / 1805
                : 10.8 * e * e - 20.52 * e + 10.72;
        },
        Wt = Tt(Ht);
      function Ut(e, t) {
        return e
          .map(function () {
            return t || Bt;
          })
          .splice(0, e.length - 1);
      }
      function Gt(e) {
        var t = e.from,
          n = void 0 === t ? 0 : t,
          o = e.to,
          a = void 0 === o ? 1 : o,
          r = e.ease,
          i = e.offset,
          l = e.duration,
          s = void 0 === l ? 300 : l,
          c = { done: !1, value: n },
          _ = Array.isArray(a) ? a : [n, a],
          u = (function (e, t) {
            return e.map(function (e) {
              return e * t;
            });
          })(
            i && i.length === _.length
              ? i
              : (function (e) {
                  var t = e.length;
                  return e.map(function (e, n) {
                    return 0 !== n ? n / (t - 1) : 0;
                  });
                })(_),
            s,
          );
        function d() {
          return Object(jt.a)(u, _, { ease: Array.isArray(r) ? r : Ut(_, r) });
        }
        var p = d();
        return {
          next: function (e) {
            return (c.value = p(e)), (c.done = e >= s), c;
          },
          flipTarget: function () {
            _.reverse(), (p = d());
          },
        };
      }
      var Yt = {
        keyframes: Gt,
        spring: Ot,
        decay: function (e) {
          var t = e.velocity,
            n = void 0 === t ? 0 : t,
            o = e.from,
            a = void 0 === o ? 0 : o,
            r = e.power,
            i = void 0 === r ? 0.8 : r,
            l = e.timeConstant,
            s = void 0 === l ? 350 : l,
            c = e.restDelta,
            _ = void 0 === c ? 0.5 : c,
            u = e.modifyTarget,
            d = { done: !1, value: a },
            p = i * n,
            f = a + p,
            h = void 0 === u ? f : u(f);
          return (
            h !== f && (p = h - a),
            {
              next: function (e) {
                var t = -p * Math.exp(-e / s);
                return (
                  (d.done = !(t > _ || t < -_)),
                  (d.value = d.done ? h : h + t),
                  d
                );
              },
              flipTarget: function () {},
            }
          );
        },
      };
      var qt = n("bQW5");
      function Xt(e, t, n) {
        return void 0 === n && (n = 0), e - t - n;
      }
      var Zt = function (e) {
        var t = function (t) {
          var n = t.delta;
          return e(n);
        };
        return {
          start: function () {
            return qt.b.update(t, !0);
          },
          stop: function () {
            return qt.a.update(t);
          },
        };
      };
      function Kt(e) {
        var t,
          n,
          a,
          r,
          i,
          l = e.from,
          s = e.autoplay,
          c = void 0 === s || s,
          _ = e.driver,
          u = void 0 === _ ? Zt : _,
          d = e.elapsed,
          p = void 0 === d ? 0 : d,
          f = e.repeat,
          h = void 0 === f ? 0 : f,
          m = e.repeatType,
          y = void 0 === m ? "loop" : m,
          b = e.repeatDelay,
          v = void 0 === b ? 0 : b,
          g = e.onPlay,
          w = e.onStop,
          x = e.onComplete,
          k = e.onRepeat,
          O = e.onUpdate,
          I = Object(o.d)(e, [
            "from",
            "autoplay",
            "driver",
            "elapsed",
            "repeat",
            "repeatType",
            "repeatDelay",
            "onPlay",
            "onStop",
            "onComplete",
            "onRepeat",
            "onUpdate",
          ]),
          S = I.to,
          j = 0,
          T = I.duration,
          C = !1,
          M = !0,
          P = (function (e) {
            if (Array.isArray(e.to)) return Gt;
            if (Yt[e.type]) return Yt[e.type];
            var t = new Set(Object.keys(e));
            return t.has("ease") ||
              (t.has("duration") && !t.has("dampingRatio"))
              ? Gt
              : t.has("dampingRatio") ||
                  t.has("stiffness") ||
                  t.has("mass") ||
                  t.has("damping") ||
                  t.has("restSpeed") ||
                  t.has("restDelta")
                ? Ot
                : Gt;
          })(I);
        (null === (n = (t = P).needsInterpolation) || void 0 === n
          ? void 0
          : n.call(t, l, S)) &&
          ((i = Object(jt.a)([0, 100], [l, S], { clamp: !1 })),
          (l = 0),
          (S = 100));
        var E = P(Object(o.a)(Object(o.a)({}, I), { from: l, to: S }));
        function L() {
          j++,
            "reverse" === y
              ? (p = (function (e, t, n, o) {
                  return (
                    void 0 === n && (n = 0),
                    void 0 === o && (o = !0),
                    o ? Xt(t + -e, t, n) : t - (e - t) + n
                  );
                })(p, T, v, (M = j % 2 === 0)))
              : ((p = Xt(p, T, v)), "mirror" === y && E.flipTarget()),
            (C = !1),
            k && k();
        }
        function B(e) {
          if ((M || (e = -e), (p += e), !C)) {
            var t = E.next(Math.max(0, p));
            (r = t.value), i && (r = i(r)), (C = M ? t.done : p <= 0);
          }
          null === O || void 0 === O || O(r),
            C &&
              (0 === j && ((null !== T && void 0 !== T) || (T = p)),
              j < h
                ? (function (e, t, n, o) {
                    return o ? e >= t + n : e <= -n;
                  })(p, T, v, M) && L()
                : (a.stop(), x && x()));
        }
        return (
          c && (null === g || void 0 === g || g(), (a = u(B)).start()),
          {
            stop: function () {
              null === w || void 0 === w || w(), a.stop();
            },
          }
        );
      }
      var Qt = n("mtL0");
      var Jt = function (e) {
          return 1e3 * e;
        },
        $t = function (e, t) {
          return 1 - 3 * t + 3 * e;
        },
        en = function (e, t) {
          return 3 * t - 6 * e;
        },
        tn = function (e) {
          return 3 * e;
        },
        nn = function (e, t, n) {
          return (($t(t, n) * e + en(t, n)) * e + tn(t)) * e;
        },
        on = function (e, t, n) {
          return 3 * $t(t, n) * e * e + 2 * en(t, n) * e + tn(t);
        },
        an = 1e-7,
        rn = 10;
      var ln = 8,
        sn = 0.001;
      var cn = 11,
        _n = 1 / (cn - 1);
      function un(e, t, n, o) {
        if (e === t && n === o) return Pt;
        for (var a = new Float32Array(cn), r = 0; r < cn; ++r)
          a[r] = nn(r * _n, e, n);
        function i(t) {
          for (var o = 0, r = 1, i = cn - 1; r !== i && a[r] <= t; ++r) o += _n;
          --r;
          var l = o + ((t - a[r]) / (a[r + 1] - a[r])) * _n,
            s = on(l, e, n);
          return s >= sn
            ? (function (e, t, n, o) {
                for (var a = 0; a < ln; ++a) {
                  var r = on(t, n, o);
                  if (0 === r) return t;
                  t -= (nn(t, n, o) - e) / r;
                }
                return t;
              })(t, l, e, n)
            : 0 === s
              ? l
              : (function (e, t, n, o, a) {
                  var r,
                    i,
                    l = 0;
                  do {
                    (r = nn((i = t + (n - t) / 2), o, a) - e) > 0
                      ? (n = i)
                      : (t = i);
                  } while (Math.abs(r) > an && ++l < rn);
                  return i;
                })(t, o, o + _n, e, n);
        }
        return function (e) {
          return 0 === e || 1 === e ? e : nn(i(e), t, o);
        };
      }
      var dn = {
          linear: Pt,
          easeIn: Et,
          easeInOut: Bt,
          easeOut: Lt,
          circIn: Nt,
          circInOut: zt,
          circOut: Dt,
          backIn: At,
          backInOut: Ft,
          backOut: Rt,
          anticipate: Vt,
          bounceIn: Wt,
          bounceInOut: function (e) {
            return e < 0.5
              ? 0.5 * (1 - Ht(1 - 2 * e))
              : 0.5 * Ht(2 * e - 1) + 0.5;
          },
          bounceOut: Ht,
        },
        pn = function (e) {
          if (Array.isArray(e)) {
            Object(s.a)(
              4 === e.length,
              "Cubic bezier arrays must contain four numerical values.",
            );
            var t = Object(o.c)(e, 4);
            return un(t[0], t[1], t[2], t[3]);
          }
          return "string" === typeof e
            ? (Object(s.a)(void 0 !== dn[e], "Invalid easing type '" + e + "'"),
              dn[e])
            : e;
        },
        fn = function (e) {
          return Array.isArray(e) && "number" !== typeof e[0];
        },
        hn = n("Epvc"),
        mn = function (e, t) {
          return (
            "zIndex" !== e &&
            (!("number" !== typeof t && !Array.isArray(t)) ||
              !("string" !== typeof t || !hn.a.test(t) || t.startsWith("url(")))
          );
        },
        yn = function () {
          return {
            type: "spring",
            stiffness: 500,
            damping: 25,
            restDelta: 0.5,
            restSpeed: 10,
          };
        },
        bn = function (e) {
          return {
            type: "spring",
            stiffness: 550,
            damping: 0 === e ? 2 * Math.sqrt(550) : 30,
            restDelta: 0.01,
            restSpeed: 10,
          };
        },
        vn = function () {
          return { type: "keyframes", ease: "linear", duration: 0.3 };
        },
        gn = function (e) {
          return { type: "keyframes", duration: 0.8, values: e };
        },
        wn = {
          x: yn,
          y: yn,
          z: yn,
          rotate: yn,
          rotateX: yn,
          rotateY: yn,
          rotateZ: yn,
          scaleX: bn,
          scaleY: bn,
          scale: bn,
          opacity: vn,
          backgroundColor: vn,
          color: vn,
          default: bn,
        },
        xn = function (e, t) {
          var n;
          return (
            (n = Se(t) ? gn : wn[e] || wn.default), Object(o.a)({ to: t }, n(t))
          );
        },
        kn = n("3T+G"),
        On = new Set(["brightness", "contrast", "saturate", "opacity"]);
      function In(e) {
        var t = e.slice(0, -1).split("("),
          n = t[0],
          o = t[1];
        if ("drop-shadow" === n) return e;
        var a = (o.match(kn.c) || [])[0];
        if (!a) return e;
        var r = o.replace(a, ""),
          i = On.has(n) ? 1 : 0;
        return a !== o && (i *= 100), n + "(" + i + r + ")";
      }
      var Sn = /([a-z-]*)\(.*?\)/g,
        jn = Object(o.a)(Object(o.a)({}, hn.a), {
          getAnimatableNone: function (e) {
            var t = e.match(Sn);
            return t ? t.map(In).join(" ") : e;
          },
        }),
        Tn = n("V6Gm"),
        Cn = Object(o.a)(Object(o.a)({}, ee), {
          color: Tn.a,
          backgroundColor: Tn.a,
          outlineColor: Tn.a,
          fill: Tn.a,
          stroke: Tn.a,
          borderColor: Tn.a,
          borderTopColor: Tn.a,
          borderRightColor: Tn.a,
          borderBottomColor: Tn.a,
          borderLeftColor: Tn.a,
          filter: jn,
          WebkitFilter: jn,
        }),
        Mn = function (e) {
          return Cn[e];
        };
      function Pn(e, t) {
        var n,
          o = Mn(e);
        return (
          o !== jn && (o = hn.a),
          null === (n = o.getAnimatableNone) || void 0 === n
            ? void 0
            : n.call(o, t)
        );
      }
      var En = !1;
      function Ln(e, t, n) {
        var a;
        return (
          Array.isArray(t.to) &&
            ((null !== (a = e.duration) && void 0 !== a) || (e.duration = 0.8)),
          (function (e) {
            Array.isArray(e.to) &&
              null === e.to[0] &&
              ((e.to = Object(o.e)([], Object(o.c)(e.to))), (e.to[0] = e.from));
          })(t),
          (function (e) {
            e.when,
              e.delay,
              e.delayChildren,
              e.staggerChildren,
              e.staggerDirection,
              e.repeat,
              e.repeatType,
              e.repeatDelay,
              e.from;
            var t = Object(o.d)(e, [
              "when",
              "delay",
              "delayChildren",
              "staggerChildren",
              "staggerDirection",
              "repeat",
              "repeatType",
              "repeatDelay",
              "from",
            ]);
            return !!Object.keys(t).length;
          })(e) || (e = Object(o.a)(Object(o.a)({}, e), xn(n, t.to))),
          Object(o.a)(
            Object(o.a)({}, t),
            (function (e) {
              var t = e.ease,
                n = e.times,
                a = e.yoyo,
                r = e.flip,
                i = e.loop,
                l = Object(o.d)(e, ["ease", "times", "yoyo", "flip", "loop"]),
                c = Object(o.a)({}, l);
              return (
                n && (c.offset = n),
                l.duration && (c.duration = Jt(l.duration)),
                l.repeatDelay && (c.repeatDelay = Jt(l.repeatDelay)),
                t && (c.ease = fn(t) ? t.map(pn) : pn(t)),
                "tween" === l.type && (c.type = "keyframes"),
                (a || i || r) &&
                  (Object(s.b)(
                    !En,
                    "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.",
                  ),
                  (En = !0),
                  a
                    ? (c.repeatType = "reverse")
                    : i
                      ? (c.repeatType = "loop")
                      : r && (c.repeatType = "mirror"),
                  (c.repeat = i || a || r || l.repeat)),
                "spring" !== l.type && (c.type = "keyframes"),
                c
              );
            })(e),
          )
        );
      }
      function Bn(e, t, n, a, r) {
        var i,
          l = zn(a, e),
          c = null !== (i = l.from) && void 0 !== i ? i : t.get(),
          _ = mn(e, n);
        "none" === c && _ && "string" === typeof n
          ? (c = Pn(e, n))
          : Nn(c) && "string" === typeof n
            ? (c = Dn(n))
            : !Array.isArray(n) &&
              Nn(n) &&
              "string" === typeof c &&
              (n = Dn(c));
        var u = mn(e, c);
        return (
          Object(s.b)(
            u === _,
            "You are trying to animate " +
              e +
              ' from "' +
              c +
              '" to "' +
              n +
              '". ' +
              c +
              " is not an animatable value - to enable this animation set " +
              c +
              " to a value animatable to " +
              n +
              " via the `style` property.",
          ),
          u && _ && !1 !== l.type
            ? function () {
                var a = {
                  from: c,
                  to: n,
                  velocity: t.getVelocity(),
                  onComplete: r,
                  onUpdate: function (e) {
                    return t.set(e);
                  },
                };
                return "inertia" === l.type || "decay" === l.type
                  ? (function (e) {
                      var t,
                        n = e.from,
                        a = void 0 === n ? 0 : n,
                        r = e.velocity,
                        i = void 0 === r ? 0 : r,
                        l = e.min,
                        s = e.max,
                        c = e.power,
                        _ = void 0 === c ? 0.8 : c,
                        u = e.timeConstant,
                        d = void 0 === u ? 750 : u,
                        p = e.bounceStiffness,
                        f = void 0 === p ? 500 : p,
                        h = e.bounceDamping,
                        m = void 0 === h ? 10 : h,
                        y = e.restDelta,
                        b = void 0 === y ? 1 : y,
                        v = e.modifyTarget,
                        g = e.driver,
                        w = e.onUpdate,
                        x = e.onComplete;
                      function k(e) {
                        return (
                          (void 0 !== l && e < l) || (void 0 !== s && e > s)
                        );
                      }
                      function O(e) {
                        return void 0 === l
                          ? s
                          : void 0 === s
                            ? l
                            : Math.abs(l - e) < Math.abs(s - e)
                              ? l
                              : s;
                      }
                      function I(e) {
                        null === t || void 0 === t || t.stop(),
                          (t = Kt(
                            Object(o.a)(Object(o.a)({}, e), {
                              driver: g,
                              onUpdate: function (t) {
                                var n;
                                null === w || void 0 === w || w(t),
                                  null === (n = e.onUpdate) ||
                                    void 0 === n ||
                                    n.call(e, t);
                              },
                              onComplete: x,
                            }),
                          ));
                      }
                      function S(e) {
                        I(
                          Object(o.a)(
                            {
                              type: "spring",
                              stiffness: f,
                              damping: m,
                              restDelta: b,
                            },
                            e,
                          ),
                        );
                      }
                      if (k(a)) S({ from: a, velocity: i, to: O(a) });
                      else {
                        var j = _ * i + a;
                        "undefined" !== typeof v && (j = v(j));
                        var T,
                          C,
                          M = O(j),
                          P = M === l ? -1 : 1;
                        I({
                          type: "decay",
                          from: a,
                          velocity: i,
                          timeConstant: d,
                          power: _,
                          restDelta: b,
                          modifyTarget: v,
                          onUpdate: k(j)
                            ? function (e) {
                                (T = C),
                                  (C = e),
                                  (i = Object(Qt.a)(
                                    e - T,
                                    Object(qt.d)().delta,
                                  )),
                                  ((1 === P && e > M) || (-1 === P && e < M)) &&
                                    S({ from: e, to: M, velocity: i });
                              }
                            : void 0,
                        });
                      }
                      return {
                        stop: function () {
                          return null === t || void 0 === t ? void 0 : t.stop();
                        },
                      };
                    })(Object(o.a)(Object(o.a)({}, a), l))
                  : Kt(
                      Object(o.a)(Object(o.a)({}, Ln(l, a, e)), {
                        onUpdate: function (e) {
                          var t;
                          a.onUpdate(e),
                            null === (t = l.onUpdate) ||
                              void 0 === t ||
                              t.call(l, e);
                        },
                        onComplete: function () {
                          var e;
                          a.onComplete(),
                            null === (e = l.onComplete) ||
                              void 0 === e ||
                              e.call(l);
                        },
                      }),
                    );
              }
            : function () {
                var e;
                return (
                  t.set(n),
                  r(),
                  null ===
                    (e = null === l || void 0 === l ? void 0 : l.onComplete) ||
                    void 0 === e ||
                    e.call(l),
                  { stop: function () {} }
                );
              }
        );
      }
      function Nn(e) {
        return (
          0 === e ||
          ("string" === typeof e &&
            0 === parseFloat(e) &&
            -1 === e.indexOf(" "))
        );
      }
      function Dn(e) {
        return "number" === typeof e ? 0 : Pn("", e);
      }
      function zn(e, t) {
        return e[t] || e.default || e;
      }
      function An(e, t, n, o) {
        return (
          void 0 === o && (o = {}),
          t.start(function (a) {
            var r,
              i,
              l = Bn(e, t, n, o, a),
              s = (function (e, t) {
                var n;
                return null !== (n = (zn(e, t) || {}).delay) && void 0 !== n
                  ? n
                  : 0;
              })(o, e),
              c = function () {
                return (i = l());
              };
            return (
              s ? (r = setTimeout(c, Jt(s))) : c(),
              function () {
                clearTimeout(r), null === i || void 0 === i || i.stop();
              }
            );
          })
        );
      }
      var Rn = function (e) {
          return /^\-?\d*\.?\d+$/.test(e);
        },
        Fn = n("IdKh"),
        Vn = function (e) {
          return function (t) {
            return t.test(e);
          };
        },
        Hn = [
          J.b,
          Q.d,
          Q.b,
          Q.a,
          Q.f,
          Q.e,
          {
            test: function (e) {
              return "auto" === e;
            },
            parse: function (e) {
              return e;
            },
          },
        ],
        Wn = function (e) {
          return Hn.find(Vn(e));
        },
        Un = Object(o.e)(Object(o.e)([], Object(o.c)(Hn)), [Tn.a, hn.a]),
        Gn = function (e) {
          return Un.find(Vn(e));
        };
      function Yn(e, t, n) {
        e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Object(Fn.a)(n));
      }
      function qn(e, t) {
        var n = C(e, t),
          a = n ? e.makeTargetAnimatable(n, !1) : {},
          r = a.transitionEnd,
          i = void 0 === r ? {} : r;
        a.transition;
        var l = Object(o.d)(a, ["transitionEnd", "transition"]);
        for (var s in (l = Object(o.a)(Object(o.a)({}, l), i))) {
          Yn(e, s, Te(l[s]));
        }
      }
      function Xn(e, t) {
        if (t) return (t[e] || t.default || t).from;
      }
      function Zn(e, t, n) {
        var a;
        void 0 === n && (n = {});
        var r = C(e, t, n.custom),
          i = (r || {}).transition,
          l = void 0 === i ? e.getDefaultTransition() || {} : i;
        n.transitionOverride && (l = n.transitionOverride);
        var s = r
            ? function () {
                return Kn(e, r, n);
              }
            : function () {
                return Promise.resolve();
              },
          c = (
            null === (a = e.variantChildren) || void 0 === a ? void 0 : a.size
          )
            ? function (a) {
                void 0 === a && (a = 0);
                var r = l.delayChildren,
                  i = void 0 === r ? 0 : r,
                  s = l.staggerChildren,
                  c = l.staggerDirection;
                return (function (e, t, n, a, r, i) {
                  void 0 === n && (n = 0);
                  void 0 === a && (a = 0);
                  void 0 === r && (r = 1);
                  var l = [],
                    s = (e.variantChildren.size - 1) * a,
                    c =
                      1 === r
                        ? function (e) {
                            return void 0 === e && (e = 0), e * a;
                          }
                        : function (e) {
                            return void 0 === e && (e = 0), s - e * a;
                          };
                  return (
                    Array.from(e.variantChildren)
                      .sort(Qn)
                      .forEach(function (e, a) {
                        l.push(
                          Zn(
                            e,
                            t,
                            Object(o.a)(Object(o.a)({}, i), {
                              delay: n + c(a),
                            }),
                          ).then(function () {
                            return e.notifyAnimationComplete(t);
                          }),
                        );
                      }),
                    Promise.all(l)
                  );
                })(e, t, i + a, s, c, n);
              }
            : function () {
                return Promise.resolve();
              },
          _ = l.when;
        if (_) {
          var u = Object(o.c)("beforeChildren" === _ ? [s, c] : [c, s], 2),
            d = u[0],
            p = u[1];
          return d().then(p);
        }
        return Promise.all([s(), c(n.delay)]);
      }
      function Kn(e, t, n) {
        var a,
          r = void 0 === n ? {} : n,
          i = r.delay,
          l = void 0 === i ? 0 : i,
          s = r.transitionOverride,
          c = r.type,
          _ = e.makeTargetAnimatable(t),
          u = _.transition,
          d = void 0 === u ? e.getDefaultTransition() : u,
          p = _.transitionEnd,
          f = Object(o.d)(_, ["transition", "transitionEnd"]);
        s && (d = s);
        var h = [],
          m =
            c &&
            (null === (a = e.animationState) || void 0 === a
              ? void 0
              : a.getState()[c]);
        for (var y in f) {
          var b = e.getValue(y),
            v = f[y];
          if (!(!b || void 0 === v || (m && Jn(m, y)))) {
            var g = An(y, b, v, Object(o.a)({ delay: l }, d));
            h.push(g);
          }
        }
        return Promise.all(h).then(function () {
          p && qn(e, p);
        });
      }
      function Qn(e, t) {
        return e.sortNodePosition(t);
      }
      function Jn(e, t) {
        var n = e.protectedKeys,
          o = e.needsAnimating,
          a = n.hasOwnProperty(t) && !0 !== o[t];
        return (o[t] = !1), a;
      }
      var $n = [Be.Animate, Be.Hover, Be.Tap, Be.Drag, Be.Focus, Be.Exit],
        eo = Object(o.e)([], Object(o.c)($n)).reverse(),
        to = $n.length;
      function no(e) {
        return function (t) {
          return Promise.all(
            t.map(function (t) {
              var n = t.animation,
                o = t.options;
              return (function (e, t, n) {
                var o;
                if (
                  (void 0 === n && (n = {}),
                  e.notifyAnimationStart(),
                  Array.isArray(t))
                ) {
                  var a = t.map(function (t) {
                    return Zn(e, t, n);
                  });
                  o = Promise.all(a);
                } else if ("string" === typeof t) o = Zn(e, t, n);
                else {
                  var r = "function" === typeof t ? C(e, t, n.custom) : t;
                  o = Kn(e, r, n);
                }
                return o.then(function () {
                  return e.notifyAnimationComplete(t);
                });
              })(e, n, o);
            }),
          );
        };
      }
      function oo(e) {
        var t = no(e),
          n = (function () {
            var e;
            return (
              ((e = {})[Be.Animate] = ao(!0)),
              (e[Be.Hover] = ao()),
              (e[Be.Tap] = ao()),
              (e[Be.Drag] = ao()),
              (e[Be.Focus] = ao()),
              (e[Be.Exit] = ao()),
              e
            );
          })(),
          a = {},
          r = !0,
          i = function (t, n) {
            var a = C(e, n);
            if (a) {
              a.transition;
              var r = a.transitionEnd,
                i = Object(o.d)(a, ["transition", "transitionEnd"]);
              t = Object(o.a)(Object(o.a)(Object(o.a)({}, t), i), r);
            }
            return t;
          };
        function l(l, s) {
          for (
            var c,
              _ = e.getProps(),
              u = e.getVariantContext(!0) || {},
              d = [],
              p = new Set(),
              f = {},
              h = 1 / 0,
              m = function (t) {
                var a = eo[t],
                  m = n[a],
                  y = null !== (c = _[a]) && void 0 !== c ? c : u[a],
                  b = j(y),
                  v = a === s ? m.isActive : null;
                !1 === v && (h = t);
                var g = y === u[a] && y !== _[a] && b;
                if (
                  (g && r && e.manuallyAnimateOnMount && (g = !1),
                  (m.protectedKeys = Object(o.a)({}, f)),
                  (!m.isActive && null === v) ||
                    (!y && !m.prevProp) ||
                    Ie(y) ||
                    "boolean" === typeof y)
                )
                  return "continue";
                var w =
                    (function (e, t) {
                      if ("string" === typeof t) return t !== e;
                      if (S(t)) return !ut(t, e);
                      return !1;
                    })(m.prevProp, y) ||
                    (a === s && m.isActive && !g && b) ||
                    (t > h && b),
                  x = Array.isArray(y) ? y : [y],
                  k = x.reduce(i, {});
                !1 === v && (k = {});
                var O = m.prevResolvedValues,
                  I = void 0 === O ? {} : O,
                  T = Object(o.a)(Object(o.a)({}, I), k),
                  C = function (e) {
                    (w = !0), p.delete(e), (m.needsAnimating[e] = !0);
                  };
                for (var M in T) {
                  var P = k[M],
                    E = I[M];
                  f.hasOwnProperty(M) ||
                    (P !== E
                      ? Se(P) && Se(E)
                        ? ut(P, E)
                          ? (m.protectedKeys[M] = !0)
                          : C(M)
                        : void 0 !== P
                          ? C(M)
                          : p.add(M)
                      : void 0 !== P && p.has(M)
                        ? C(M)
                        : (m.protectedKeys[M] = !0));
                }
                (m.prevProp = y),
                  (m.prevResolvedValues = k),
                  m.isActive && (f = Object(o.a)(Object(o.a)({}, f), k)),
                  r && e.blockInitialAnimation && (w = !1),
                  w &&
                    !g &&
                    d.push.apply(
                      d,
                      Object(o.e)(
                        [],
                        Object(o.c)(
                          x.map(function (e) {
                            return {
                              animation: e,
                              options: Object(o.a)({ type: a }, l),
                            };
                          }),
                        ),
                      ),
                    );
              },
              y = 0;
            y < to;
            y++
          )
            m(y);
          if (((a = Object(o.a)({}, f)), p.size)) {
            var b = {};
            p.forEach(function (t) {
              var n = e.getBaseTarget(t);
              void 0 !== n && (b[t] = n);
            }),
              d.push({ animation: b });
          }
          var v = Boolean(d.length);
          return (
            r && !1 === _.initial && !e.manuallyAnimateOnMount && (v = !1),
            (r = !1),
            v ? t(d) : Promise.resolve()
          );
        }
        return {
          isAnimated: function (e) {
            return void 0 !== a[e];
          },
          animateChanges: l,
          setActive: function (t, o, a) {
            var r;
            return n[t].isActive === o
              ? Promise.resolve()
              : (null === (r = e.variantChildren) ||
                  void 0 === r ||
                  r.forEach(function (e) {
                    var n;
                    return null === (n = e.animationState) || void 0 === n
                      ? void 0
                      : n.setActive(t, o);
                  }),
                (n[t].isActive = o),
                l(a, t));
          },
          setAnimateFunction: function (n) {
            t = n(e);
          },
          getState: function () {
            return n;
          },
        };
      }
      function ao(e) {
        return (
          void 0 === e && (e = !1),
          {
            isActive: e,
            protectedKeys: {},
            needsAnimating: {},
            prevResolvedValues: {},
          }
        );
      }
      var ro = {
          animation: ct(function (e) {
            var t = e.visualElement,
              n = e.animate;
            t.animationState || (t.animationState = oo(t)),
              Ie(n) &&
                Object(a.useEffect)(
                  function () {
                    return n.subscribe(t);
                  },
                  [n],
                );
          }),
          exit: ct(function (e) {
            var t = e.custom,
              n = e.visualElement,
              r = Object(o.c)(m(), 2),
              i = r[0],
              l = r[1],
              s = Object(a.useContext)(f);
            Object(a.useEffect)(
              function () {
                var e,
                  o,
                  a =
                    null === (e = n.animationState) || void 0 === e
                      ? void 0
                      : e.setActive(Be.Exit, !i, {
                          custom:
                            null !==
                              (o =
                                null === s || void 0 === s
                                  ? void 0
                                  : s.custom) && void 0 !== o
                              ? o
                              : t,
                        });
                !i && (null === a || void 0 === a || a.then(l));
              },
              [i],
            );
          }),
        },
        io = function (e) {
          return e.hasOwnProperty("x") && e.hasOwnProperty("y");
        },
        lo = function (e) {
          return io(e) && e.hasOwnProperty("z");
        },
        so = n("aqq1"),
        co = function (e, t) {
          return Math.abs(e - t);
        };
      function _o(e, t) {
        if (Object(so.a)(e) && Object(so.a)(t)) return co(e, t);
        if (io(e) && io(t)) {
          var n = co(e.x, t.x),
            o = co(e.y, t.y),
            a = lo(e) && lo(t) ? co(e.z, t.z) : 0;
          return Math.sqrt(Math.pow(n, 2) + Math.pow(o, 2) + Math.pow(a, 2));
        }
      }
      var uo = (function () {
        function e(e, t, n) {
          var a = this,
            r = (void 0 === n ? {} : n).transformPagePoint;
          if (
            ((this.startEvent = null),
            (this.lastMoveEvent = null),
            (this.lastMoveEventInfo = null),
            (this.handlers = {}),
            (this.updatePoint = function () {
              if (a.lastMoveEvent && a.lastMoveEventInfo) {
                var e = ho(a.lastMoveEventInfo, a.history),
                  t = null !== a.startEvent,
                  n = _o(e.offset, { x: 0, y: 0 }) >= 3;
                if (t || n) {
                  var r = e.point,
                    i = Object(qt.d)().timestamp;
                  a.history.push(
                    Object(o.a)(Object(o.a)({}, r), { timestamp: i }),
                  );
                  var l = a.handlers,
                    s = l.onStart,
                    c = l.onMove;
                  t ||
                    (s && s(a.lastMoveEvent, e),
                    (a.startEvent = a.lastMoveEvent)),
                    c && c(a.lastMoveEvent, e);
                }
              }
            }),
            (this.handlePointerMove = function (e, t) {
              (a.lastMoveEvent = e),
                (a.lastMoveEventInfo = po(t, a.transformPagePoint)),
                Re(e) && 0 === e.buttons
                  ? a.handlePointerUp(e, t)
                  : qt.b.update(a.updatePoint, !0);
            }),
            (this.handlePointerUp = function (e, t) {
              a.end();
              var n = a.handlers,
                o = n.onEnd,
                r = n.onSessionEnd,
                i = ho(po(t, a.transformPagePoint), a.history);
              a.startEvent && o && o(e, i), r && r(e, i);
            }),
            !(Fe(e) && e.touches.length > 1))
          ) {
            (this.handlers = t), (this.transformPagePoint = r);
            var i = po(Ue(e), this.transformPagePoint),
              l = i.point,
              s = Object(qt.d)().timestamp;
            this.history = [Object(o.a)(Object(o.a)({}, l), { timestamp: s })];
            var c = t.onSessionStart;
            c && c(e, ho(i, this.history)),
              (this.removeListeners = Object(st.a)(
                Je(window, "pointermove", this.handlePointerMove),
                Je(window, "pointerup", this.handlePointerUp),
                Je(window, "pointercancel", this.handlePointerUp),
              ));
          }
        }
        return (
          (e.prototype.updateHandlers = function (e) {
            this.handlers = e;
          }),
          (e.prototype.end = function () {
            this.removeListeners && this.removeListeners(),
              qt.a.update(this.updatePoint);
          }),
          e
        );
      })();
      function po(e, t) {
        return t ? { point: t(e.point) } : e;
      }
      function fo(e, t) {
        return { x: e.x - t.x, y: e.y - t.y };
      }
      function ho(e, t) {
        var n = e.point;
        return {
          point: n,
          delta: fo(n, yo(t)),
          offset: fo(n, mo(t)),
          velocity: bo(t, 0.1),
        };
      }
      function mo(e) {
        return e[0];
      }
      function yo(e) {
        return e[e.length - 1];
      }
      function bo(e, t) {
        if (e.length < 2) return { x: 0, y: 0 };
        for (
          var n = e.length - 1, o = null, a = yo(e);
          n >= 0 && ((o = e[n]), !(a.timestamp - o.timestamp > Jt(t)));

        )
          n--;
        if (!o) return { x: 0, y: 0 };
        var r = (a.timestamp - o.timestamp) / 1e3;
        if (0 === r) return { x: 0, y: 0 };
        var i = { x: (a.x - o.x) / r, y: (a.y - o.y) / r };
        return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
      }
      function vo(e) {
        return e;
      }
      function go(e) {
        var t = e.top;
        return {
          x: { min: e.left, max: e.right },
          y: { min: t, max: e.bottom },
        };
      }
      var wo = { translate: 0, scale: 1, origin: 0, originPoint: 0 };
      function xo() {
        return { x: Object(o.a)({}, wo), y: Object(o.a)({}, wo) };
      }
      function ko(e) {
        return [e("x"), e("y")];
      }
      var Oo = n("JKea");
      function Io(e, t, n) {
        var o = t.min,
          a = t.max;
        return (
          void 0 !== o && e < o
            ? (e = n ? Object(Oo.a)(o, e, n.min) : Math.max(e, o))
            : void 0 !== a &&
              e > a &&
              (e = n ? Object(Oo.a)(a, e, n.max) : Math.min(e, a)),
          e
        );
      }
      function So(e, t, n) {
        return {
          min: void 0 !== t ? e.min + t : void 0,
          max: void 0 !== n ? e.max + n - (e.max - e.min) : void 0,
        };
      }
      function jo(e, t) {
        var n,
          a = t.min - e.min,
          r = t.max - e.max;
        return (
          t.max - t.min < e.max - e.min &&
            ((a = (n = Object(o.c)([r, a], 2))[0]), (r = n[1])),
          { min: e.min + a, max: e.min + r }
        );
      }
      var To = 0.35;
      function Co(e, t, n) {
        return { min: Mo(e, t), max: Mo(e, n) };
      }
      function Mo(e, t) {
        var n;
        return "number" === typeof e
          ? e
          : null !== (n = e[t]) && void 0 !== n
            ? n
            : 0;
      }
      function Po(e, t) {
        return go(
          (function (e, t) {
            var n = e.top,
              o = e.left,
              a = e.bottom,
              r = e.right;
            void 0 === t && (t = vo);
            var i = t({ x: o, y: n }),
              l = t({ x: r, y: a });
            return { top: i.y, left: i.x, bottom: l.y, right: l.x };
          })(e.getBoundingClientRect(), t),
        );
      }
      var Eo = n("tm1d"),
        Lo = function (e) {
          return Object(dt.a)(0, 1, e);
        };
      function Bo(e, t, n) {
        return (
          void 0 === t && (t = 0), void 0 === n && (n = 0.01), _o(e, t) < n
        );
      }
      function No(e) {
        return e.max - e.min;
      }
      function Do(e, t, n, o) {
        void 0 === o && (o = 0.5),
          (e.origin = o),
          (e.originPoint = Object(Oo.a)(t.min, t.max, e.origin)),
          (e.scale = No(n) / No(t)),
          Bo(e.scale, 1, 1e-4) && (e.scale = 1),
          (e.translate = Object(Oo.a)(n.min, n.max, e.origin) - e.originPoint),
          Bo(e.translate) && (e.translate = 0);
      }
      function zo(e, t, n, o) {
        Do(e.x, t.x, n.x, Ao(o.originX)), Do(e.y, t.y, n.y, Ao(o.originY));
      }
      function Ao(e) {
        return "number" === typeof e ? e : 0.5;
      }
      function Ro(e, t, n) {
        (e.min = n.min + t.min), (e.max = e.min + No(t));
      }
      var Fo = function (e, t) {
        return e.depth - t.depth;
      };
      function Vo(e) {
        return e.projection.isEnabled || e.shouldResetTransform();
      }
      function Ho(e, t) {
        void 0 === t && (t = []);
        var n = e.parent;
        return n && Ho(n, t), Vo(e) && t.push(e), t;
      }
      function Wo(e) {
        if (!e.shouldResetTransform()) {
          var t,
            n = e.getLayoutState();
          e.notifyBeforeLayoutMeasure(n.layout),
            (n.isHydrated = !0),
            (n.layout = e.measureViewportBox()),
            (n.layoutCorrected =
              ((t = n.layout),
              { x: Object(o.a)({}, t.x), y: Object(o.a)({}, t.y) })),
            e.notifyLayoutMeasure(n.layout, e.prevViewportBox || n.layout),
            qt.b.update(function () {
              return e.rebaseProjectionTarget();
            });
        }
      }
      function Uo(e, t) {
        return { min: t.min - e.min, max: t.max - e.min };
      }
      function Go(e, t) {
        return { x: Uo(e.x, t.x), y: Uo(e.y, t.y) };
      }
      function Yo(e) {
        var t = e.getProps(),
          n = t.drag,
          o = t._dragX;
        return n && !o;
      }
      function qo(e, t) {
        (e.min = t.min), (e.max = t.max);
      }
      function Xo(e, t, n) {
        return n + t * (e - n);
      }
      function Zo(e, t, n, o, a) {
        return void 0 !== a && (e = Xo(e, a, o)), Xo(e, n, o) + t;
      }
      function Ko(e, t, n, o, a) {
        void 0 === t && (t = 0),
          void 0 === n && (n = 1),
          (e.min = Zo(e.min, t, n, o, a)),
          (e.max = Zo(e.max, t, n, o, a));
      }
      function Qo(e, t) {
        var n = t.x,
          o = t.y;
        Ko(e.x, n.translate, n.scale, n.originPoint),
          Ko(e.y, o.translate, o.scale, o.originPoint);
      }
      function Jo(e, t, n, a) {
        var r = Object(o.c)(a, 3),
          i = r[0],
          l = r[1],
          s = r[2];
        (e.min = t.min), (e.max = t.max);
        var c = void 0 !== n[s] ? n[s] : 0.5,
          _ = Object(Oo.a)(t.min, t.max, c);
        Ko(e, n[i], n[l], _, n.scale);
      }
      var $o = ["x", "scaleX", "originX"],
        ea = ["y", "scaleY", "originY"];
      function ta(e, t, n) {
        Jo(e.x, t.x, n, $o), Jo(e.y, t.y, n, ea);
      }
      function na(e, t, n, o, a) {
        return (
          (e = Xo((e -= t), 1 / n, o)), void 0 !== a && (e = Xo(e, 1 / a, o)), e
        );
      }
      function oa(e, t, n) {
        var a = Object(o.c)(n, 3),
          r = a[0],
          i = a[1],
          l = a[2];
        !(function (e, t, n, o, a) {
          void 0 === t && (t = 0),
            void 0 === n && (n = 1),
            void 0 === o && (o = 0.5);
          var r = Object(Oo.a)(e.min, e.max, o) - t;
          (e.min = na(e.min, t, n, r, a)), (e.max = na(e.max, t, n, r, a));
        })(e, t[r], t[i], t[l], t.scale);
      }
      function aa(e, t) {
        oa(e.x, t, $o), oa(e.y, t, ea);
      }
      var ra = new Set();
      function ia(e, t, n) {
        e[n] || (e[n] = []), e[n].push(t);
      }
      function la(e) {
        return (
          ra.add(e),
          function () {
            return ra.delete(e);
          }
        );
      }
      function sa() {
        if (ra.size) {
          var e = 0,
            t = [[]],
            n = [],
            o = function (n) {
              return ia(t, n, e);
            },
            a = function (t) {
              ia(n, t, e), e++;
            };
          ra.forEach(function (t) {
            t(o, a), (e = 0);
          }),
            ra.clear();
          for (var r = n.length, i = 0; i <= r; i++)
            t[i] && t[i].forEach(_a), n[i] && n[i].forEach(_a);
        }
      }
      var ca,
        _a = function (e) {
          return e();
        },
        ua = new WeakMap(),
        da = (function () {
          function e(e) {
            var t = e.visualElement;
            (this.isDragging = !1),
              (this.currentDirection = null),
              (this.constraints = !1),
              (this.elastic = { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } }),
              (this.props = {}),
              (this.hasMutatedConstraints = !1),
              (this.cursorProgress = { x: 0.5, y: 0.5 }),
              (this.originPoint = {}),
              (this.openGlobalLock = null),
              (this.panSession = null),
              (this.visualElement = t),
              this.visualElement.enableLayoutProjection(),
              ua.set(t, this);
          }
          return (
            (e.prototype.start = function (e, t) {
              var n = this,
                a = void 0 === t ? {} : t,
                r = a.snapToCursor,
                i = void 0 !== r && r,
                l = a.cursorProgress,
                s = this.props.transformPagePoint;
              this.panSession = new uo(
                e,
                {
                  onSessionStart: function (e) {
                    var t;
                    n.stopMotion();
                    var a = (function (e) {
                      return Ue(e, "client");
                    })(e).point;
                    null === (t = n.cancelLayout) || void 0 === t || t.call(n),
                      (n.cancelLayout = la(function (e, t) {
                        var r = Ho(n.visualElement),
                          s = (function (e) {
                            var t = [],
                              n = function (e) {
                                Vo(e) && t.push(e), e.children.forEach(n);
                              };
                            return e.children.forEach(n), t.sort(Fo);
                          })(n.visualElement),
                          c = Object(o.e)(
                            Object(o.e)([], Object(o.c)(r)),
                            Object(o.c)(s),
                          ),
                          _ = !1;
                        n.isLayoutDrag() &&
                          n.visualElement.lockProjectionTarget(),
                          t(function () {
                            c.forEach(function (e) {
                              return e.resetTransform();
                            });
                          }),
                          e(function () {
                            Wo(n.visualElement), s.forEach(Wo);
                          }),
                          t(function () {
                            c.forEach(function (e) {
                              return e.restoreTransform();
                            }),
                              i && (_ = n.snapToCursor(a));
                          }),
                          e(function () {
                            Boolean(
                              n.getAxisMotionValue("x") && !n.isExternalDrag(),
                            ) ||
                              n.visualElement.rebaseProjectionTarget(
                                !0,
                                n.visualElement.measureViewportBox(!1),
                              ),
                              n.visualElement.scheduleUpdateLayoutProjection();
                            var e = n.visualElement.projection;
                            ko(function (t) {
                              if (!_) {
                                var o = e.target[t],
                                  r = o.min,
                                  i = o.max;
                                n.cursorProgress[t] = l
                                  ? l[t]
                                  : Object(Eo.a)(r, i, a[t]);
                              }
                              var s = n.getAxisMotionValue(t);
                              s && (n.originPoint[t] = s.get());
                            });
                          }),
                          t(function () {
                            qt.c.update(),
                              qt.c.preRender(),
                              qt.c.render(),
                              qt.c.postRender();
                          }),
                          e(function () {
                            return n.resolveDragConstraints();
                          });
                      }));
                  },
                  onStart: function (e, t) {
                    var o,
                      a,
                      r,
                      i = n.props,
                      l = i.drag,
                      s = i.dragPropagation;
                    (!l ||
                      s ||
                      (n.openGlobalLock && n.openGlobalLock(),
                      (n.openGlobalLock = ot(l)),
                      n.openGlobalLock)) &&
                      (sa(),
                      (n.isDragging = !0),
                      (n.currentDirection = null),
                      null === (a = (o = n.props).onDragStart) ||
                        void 0 === a ||
                        a.call(o, e, t),
                      null === (r = n.visualElement.animationState) ||
                        void 0 === r ||
                        r.setActive(Be.Drag, !0));
                  },
                  onMove: function (e, t) {
                    var o,
                      a,
                      r,
                      i,
                      l = n.props,
                      s = l.dragPropagation,
                      c = l.dragDirectionLock;
                    if (s || n.openGlobalLock) {
                      var _ = t.offset;
                      if (c && null === n.currentDirection)
                        return (
                          (n.currentDirection = (function (e, t) {
                            void 0 === t && (t = 10);
                            var n = null;
                            Math.abs(e.y) > t
                              ? (n = "y")
                              : Math.abs(e.x) > t && (n = "x");
                            return n;
                          })(_)),
                          void (
                            null !== n.currentDirection &&
                            (null === (a = (o = n.props).onDirectionLock) ||
                              void 0 === a ||
                              a.call(o, n.currentDirection))
                          )
                        );
                      n.updateAxis("x", t.point, _),
                        n.updateAxis("y", t.point, _),
                        null === (i = (r = n.props).onDrag) ||
                          void 0 === i ||
                          i.call(r, e, t),
                        (ca = e);
                    }
                  },
                  onSessionEnd: function (e, t) {
                    return n.stop(e, t);
                  },
                },
                { transformPagePoint: s },
              );
            }),
            (e.prototype.resolveDragConstraints = function () {
              var e = this,
                t = this.props,
                n = t.dragConstraints,
                o = t.dragElastic,
                a = this.visualElement.getLayoutState().layoutCorrected;
              (this.constraints =
                !!n &&
                (I(n)
                  ? this.resolveRefConstraints(a, n)
                  : (function (e, t) {
                      var n = t.top,
                        o = t.left,
                        a = t.bottom,
                        r = t.right;
                      return { x: So(e.x, o, r), y: So(e.y, n, a) };
                    })(a, n))),
                (this.elastic = (function (e) {
                  return (
                    !1 === e ? (e = 0) : !0 === e && (e = To),
                    { x: Co(e, "left", "right"), y: Co(e, "top", "bottom") }
                  );
                })(o)),
                this.constraints &&
                  !this.hasMutatedConstraints &&
                  ko(function (t) {
                    e.getAxisMotionValue(t) &&
                      (e.constraints[t] = (function (e, t) {
                        var n = {};
                        return (
                          void 0 !== t.min && (n.min = t.min - e.min),
                          void 0 !== t.max && (n.max = t.max - e.min),
                          n
                        );
                      })(a[t], e.constraints[t]));
                  });
            }),
            (e.prototype.resolveRefConstraints = function (e, t) {
              var n = this.props,
                o = n.onMeasureDragConstraints,
                a = n.transformPagePoint,
                r = t.current;
              Object(s.a)(
                null !== r,
                "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.",
              ),
                (this.constraintsBox = Po(r, a));
              var i = (function (e, t) {
                return { x: jo(e.x, t.x), y: jo(e.y, t.y) };
              })(e, this.constraintsBox);
              if (o) {
                var l = o(
                  (function (e) {
                    var t = e.x,
                      n = e.y;
                    return {
                      top: n.min,
                      bottom: n.max,
                      left: t.min,
                      right: t.max,
                    };
                  })(i),
                );
                (this.hasMutatedConstraints = !!l), l && (i = go(l));
              }
              return i;
            }),
            (e.prototype.cancelDrag = function () {
              var e, t;
              this.visualElement.unlockProjectionTarget(),
                null === (e = this.cancelLayout) ||
                  void 0 === e ||
                  e.call(this),
                (this.isDragging = !1),
                this.panSession && this.panSession.end(),
                (this.panSession = null),
                !this.props.dragPropagation &&
                  this.openGlobalLock &&
                  (this.openGlobalLock(), (this.openGlobalLock = null)),
                null === (t = this.visualElement.animationState) ||
                  void 0 === t ||
                  t.setActive(Be.Drag, !1);
            }),
            (e.prototype.stop = function (e, t) {
              var n, o, a;
              null === (n = this.panSession) || void 0 === n || n.end(),
                (this.panSession = null);
              var r = this.isDragging;
              if ((this.cancelDrag(), r)) {
                var i = t.velocity;
                this.animateDragEnd(i),
                  null === (a = (o = this.props).onDragEnd) ||
                    void 0 === a ||
                    a.call(o, e, t);
              }
            }),
            (e.prototype.snapToCursor = function (e) {
              var t = this;
              return ko(function (n) {
                if (pa(n, t.props.drag, t.currentDirection)) {
                  var o = t.getAxisMotionValue(n);
                  if (!o) return (t.cursorProgress[n] = 0.5), !0;
                  var a = t.visualElement.getLayoutState().layout,
                    r = a[n].max - a[n].min,
                    i = a[n].min + r / 2,
                    l = e[n] - i;
                  (t.originPoint[n] = e[n]), o.set(l);
                }
              }).includes(!0);
            }),
            (e.prototype.updateAxis = function (e, t, n) {
              if (pa(e, this.props.drag, this.currentDirection))
                return this.getAxisMotionValue(e)
                  ? this.updateAxisMotionValue(e, n)
                  : this.updateVisualElementAxis(e, t);
            }),
            (e.prototype.updateAxisMotionValue = function (e, t) {
              var n = this.getAxisMotionValue(e);
              if (t && n) {
                var o = this.originPoint[e] + t[e],
                  a = this.constraints
                    ? Io(o, this.constraints[e], this.elastic[e])
                    : o;
                n.set(a);
              }
            }),
            (e.prototype.updateVisualElementAxis = function (e, t) {
              var n,
                o = this.visualElement.getLayoutState().layout[e],
                a = o.max - o.min,
                r = this.cursorProgress[e],
                i = (function (e, t, n, o, a) {
                  var r = e - t * n;
                  return o ? Io(r, o, a) : r;
                })(
                  t[e],
                  a,
                  r,
                  null === (n = this.constraints) || void 0 === n
                    ? void 0
                    : n[e],
                  this.elastic[e],
                );
              this.visualElement.setProjectionTargetAxis(e, i, i + a);
            }),
            (e.prototype.setProps = function (e) {
              var t = e.drag,
                n = void 0 !== t && t,
                a = e.dragDirectionLock,
                r = void 0 !== a && a,
                i = e.dragPropagation,
                l = void 0 !== i && i,
                s = e.dragConstraints,
                c = void 0 !== s && s,
                _ = e.dragElastic,
                u = void 0 === _ ? To : _,
                d = e.dragMomentum,
                p = void 0 === d || d,
                f = Object(o.d)(e, [
                  "drag",
                  "dragDirectionLock",
                  "dragPropagation",
                  "dragConstraints",
                  "dragElastic",
                  "dragMomentum",
                ]);
              this.props = Object(o.a)(
                {
                  drag: n,
                  dragDirectionLock: r,
                  dragPropagation: l,
                  dragConstraints: c,
                  dragElastic: u,
                  dragMomentum: p,
                },
                f,
              );
            }),
            (e.prototype.getAxisMotionValue = function (e) {
              var t = this.props,
                n = t.layout,
                o = t.layoutId,
                a = "_drag" + e.toUpperCase();
              return this.props[a]
                ? this.props[a]
                : n || void 0 !== o
                  ? void 0
                  : this.visualElement.getValue(e, 0);
            }),
            (e.prototype.isLayoutDrag = function () {
              return !this.getAxisMotionValue("x");
            }),
            (e.prototype.isExternalDrag = function () {
              var e = this.props,
                t = e._dragX,
                n = e._dragY;
              return t || n;
            }),
            (e.prototype.animateDragEnd = function (e) {
              var t = this,
                n = this.props,
                a = n.drag,
                r = n.dragMomentum,
                i = n.dragElastic,
                l = n.dragTransition,
                s = (function (e, t) {
                  void 0 === t && (t = !0);
                  var n,
                    o = e.getProjectionParent();
                  return (
                    !!o &&
                    (t
                      ? aa(
                          (n = Go(o.projection.target, e.projection.target)),
                          o.getLatestValues(),
                        )
                      : (n = Go(
                          o.getLayoutState().layout,
                          e.getLayoutState().layout,
                        )),
                    ko(function (t) {
                      return e.setProjectionTargetAxis(
                        t,
                        n[t].min,
                        n[t].max,
                        !0,
                      );
                    }),
                    !0)
                  );
                })(
                  this.visualElement,
                  this.isLayoutDrag() && !this.isExternalDrag(),
                ),
                c = this.constraints || {};
              if (s && Object.keys(c).length && this.isLayoutDrag()) {
                var _ = this.visualElement.getProjectionParent();
                if (_) {
                  var u = Go(_.projection.targetFinal, c);
                  ko(function (e) {
                    var t = u[e],
                      n = t.min,
                      o = t.max;
                    c[e] = {
                      min: isNaN(n) ? void 0 : n,
                      max: isNaN(o) ? void 0 : o,
                    };
                  });
                }
              }
              var d = ko(function (n) {
                var _;
                if (pa(n, a, t.currentDirection)) {
                  var u =
                      null !==
                        (_ = null === c || void 0 === c ? void 0 : c[n]) &&
                      void 0 !== _
                        ? _
                        : {},
                    d = i ? 200 : 1e6,
                    p = i ? 40 : 1e7,
                    f = Object(o.a)(
                      Object(o.a)(
                        {
                          type: "inertia",
                          velocity: r ? e[n] : 0,
                          bounceStiffness: d,
                          bounceDamping: p,
                          timeConstant: 750,
                          restDelta: 1,
                          restSpeed: 10,
                        },
                        l,
                      ),
                      u,
                    );
                  return t.getAxisMotionValue(n)
                    ? t.startAxisValueAnimation(n, f)
                    : t.visualElement.startLayoutAnimation(n, f, s);
                }
              });
              return Promise.all(d).then(function () {
                var e, n;
                null === (n = (e = t.props).onDragTransitionEnd) ||
                  void 0 === n ||
                  n.call(e);
              });
            }),
            (e.prototype.stopMotion = function () {
              var e = this;
              ko(function (t) {
                var n = e.getAxisMotionValue(t);
                n ? n.stop() : e.visualElement.stopLayoutAnimation();
              });
            }),
            (e.prototype.startAxisValueAnimation = function (e, t) {
              var n = this.getAxisMotionValue(e);
              if (n) {
                var o = n.get();
                return n.set(o), n.set(o), An(e, n, 0, t);
              }
            }),
            (e.prototype.scalePoint = function () {
              var e = this,
                t = this.props,
                n = t.drag;
              if (I(t.dragConstraints) && this.constraintsBox) {
                this.stopMotion();
                var o = { x: 0, y: 0 };
                ko(function (t) {
                  o[t] = (function (e, t) {
                    var n = 0.5,
                      o = No(e),
                      a = No(t);
                    return (
                      a > o
                        ? (n = Object(Eo.a)(t.min, t.max - o, e.min))
                        : o > a && (n = Object(Eo.a)(e.min, e.max - a, t.min)),
                      Lo(n)
                    );
                  })(e.visualElement.projection.target[t], e.constraintsBox[t]);
                }),
                  this.updateConstraints(function () {
                    ko(function (t) {
                      if (pa(t, n, null)) {
                        var a = (function (e, t, n) {
                            var o = e.max - e.min,
                              a = Object(Oo.a)(t.min, t.max - o, n);
                            return { min: a, max: a + o };
                          })(
                            e.visualElement.projection.target[t],
                            e.constraintsBox[t],
                            o[t],
                          ),
                          r = a.min,
                          i = a.max;
                        e.visualElement.setProjectionTargetAxis(t, r, i);
                      }
                    });
                  }),
                  setTimeout(sa, 1);
              }
            }),
            (e.prototype.updateConstraints = function (e) {
              var t = this;
              this.cancelLayout = la(function (n, o) {
                var a = Ho(t.visualElement);
                o(function () {
                  return a.forEach(function (e) {
                    return e.resetTransform();
                  });
                }),
                  n(function () {
                    return Wo(t.visualElement);
                  }),
                  o(function () {
                    return a.forEach(function (e) {
                      return e.restoreTransform();
                    });
                  }),
                  n(function () {
                    t.resolveDragConstraints();
                  }),
                  e && o(e);
              });
            }),
            (e.prototype.mount = function (e) {
              var t = this,
                n = Je(e.getInstance(), "pointerdown", function (e) {
                  var n = t.props,
                    o = n.drag,
                    a = n.dragListener;
                  o && (void 0 === a || a) && t.start(e);
                }),
                o = ze(window, "resize", function () {
                  t.scalePoint();
                }),
                a = e.onLayoutUpdate(function () {
                  t.isDragging && t.resolveDragConstraints();
                }),
                r = e.prevDragCursor;
              return (
                r && this.start(ca, { cursorProgress: r }),
                function () {
                  null === n || void 0 === n || n(),
                    null === o || void 0 === o || o(),
                    null === a || void 0 === a || a(),
                    t.cancelDrag();
                }
              );
            }),
            e
          );
        })();
      function pa(e, t, n) {
        return (!0 === t || t === e) && (null === n || n === e);
      }
      var fa,
        ha,
        ma = {
          pan: ct(function (e) {
            var t = e.onPan,
              n = e.onPanStart,
              o = e.onPanEnd,
              r = e.onPanSessionStart,
              i = e.visualElement,
              l = t || n || o || r,
              s = Object(a.useRef)(null),
              c = Object(a.useContext)(d.a).transformPagePoint,
              _ = {
                onSessionStart: r,
                onStart: n,
                onMove: t,
                onEnd: function (e, t) {
                  (s.current = null), o && o(e, t);
                },
              };
            Object(a.useEffect)(function () {
              null !== s.current && s.current.updateHandlers(_);
            }),
              $e(
                i,
                "pointerdown",
                l &&
                  function (e) {
                    s.current = new uo(e, _, { transformPagePoint: c });
                  },
              ),
              lt(function () {
                return s.current && s.current.end();
              });
          }),
          drag: ct(function (e) {
            var t = e.dragControls,
              n = e.visualElement,
              r = Object(a.useContext)(d.a).transformPagePoint,
              i = Object(h.a)(function () {
                return new da({ visualElement: n });
              });
            i.setProps(
              Object(o.a)(Object(o.a)({}, e), { transformPagePoint: r }),
            ),
              Object(a.useEffect)(
                function () {
                  return t && t.subscribe(i);
                },
                [i],
              ),
              Object(a.useEffect)(function () {
                return i.mount(n);
              }, []);
          }),
        };
      function ya(e) {
        return "string" === typeof e && e.startsWith("var(--");
      }
      !(function (e) {
        (e[(e.Entering = 0)] = "Entering"),
          (e[(e.Present = 1)] = "Present"),
          (e[(e.Exiting = 2)] = "Exiting");
      })(fa || (fa = {})),
        (function (e) {
          (e[(e.Hide = 0)] = "Hide"), (e[(e.Show = 1)] = "Show");
        })(ha || (ha = {}));
      var ba = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
      var va = 4;
      function ga(e, t, n) {
        void 0 === n && (n = 1),
          Object(s.a)(
            n <= va,
            'Max CSS variable fallback depth detected in property "' +
              e +
              '". This may indicate a circular fallback dependency.',
          );
        var a = Object(o.c)(
            (function (e) {
              var t = ba.exec(e);
              if (!t) return [,];
              var n = Object(o.c)(t, 3);
              return [n[1], n[2]];
            })(e),
            2,
          ),
          r = a[0],
          i = a[1];
        if (r) {
          var l = window.getComputedStyle(t).getPropertyValue(r);
          return l ? l.trim() : ya(i) ? ga(i, t, n + 1) : i;
        }
      }
      function wa(e, t) {
        return (e / (t.max - t.min)) * 100;
      }
      var xa = "_$css";
      var ka = {
          process: function (e, t, n) {
            var o = n.target;
            if ("string" === typeof e) {
              if (!Q.d.test(e)) return e;
              e = parseFloat(e);
            }
            return wa(e, o.x) + "% " + wa(e, o.y) + "%";
          },
        },
        Oa = {
          borderRadius: Object(o.a)(Object(o.a)({}, ka), {
            applyTo: [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
            ],
          }),
          borderTopLeftRadius: ka,
          borderTopRightRadius: ka,
          borderBottomLeftRadius: ka,
          borderBottomRightRadius: ka,
          boxShadow: {
            process: function (e, t) {
              var n = t.delta,
                o = t.treeScale,
                a = e,
                r = e.includes("var("),
                i = [];
              r &&
                (e = e.replace(ba, function (e) {
                  return i.push(e), xa;
                }));
              var l = hn.a.parse(e);
              if (l.length > 5) return a;
              var s = hn.a.createTransformer(e),
                c = "number" !== typeof l[0] ? 1 : 0,
                _ = n.x.scale * o.x,
                u = n.y.scale * o.y;
              (l[0 + c] /= _), (l[1 + c] /= u);
              var d = Object(Oo.a)(_, u, 0.5);
              "number" === typeof l[2 + c] && (l[2 + c] /= d),
                "number" === typeof l[3 + c] && (l[3 + c] /= d);
              var p = s(l);
              if (r) {
                var f = 0;
                p = p.replace(xa, function () {
                  var e = i[f];
                  return f++, e;
                });
              }
              return p;
            },
          },
        },
        Ia = (function (e) {
          function t() {
            var t = (null !== e && e.apply(this, arguments)) || this;
            return (
              (t.frameTarget = {
                x: { min: 0, max: 1 },
                y: { min: 0, max: 1 },
              }),
              (t.currentAnimationTarget = {
                x: { min: 0, max: 1 },
                y: { min: 0, max: 1 },
              }),
              (t.isAnimating = { x: !1, y: !1 }),
              (t.stopAxisAnimation = { x: void 0, y: void 0 }),
              (t.isAnimatingTree = !1),
              (t.animate = function (e, n, a) {
                void 0 === a && (a = {});
                var r = a.originBox,
                  i = a.targetBox,
                  l = a.visibilityAction,
                  s = a.shouldStackAnimate,
                  c = a.onComplete,
                  _ = a.prevParent,
                  u = Object(o.d)(a, [
                    "originBox",
                    "targetBox",
                    "visibilityAction",
                    "shouldStackAnimate",
                    "onComplete",
                    "prevParent",
                  ]),
                  d = t.props,
                  p = d.visualElement,
                  f = d.layout;
                if (!1 === s) return (t.isAnimatingTree = !1), t.safeToRemove();
                if (!t.isAnimatingTree || !0 === s) {
                  s && (t.isAnimatingTree = !0), (n = r || n), (e = i || e);
                  var h = !1,
                    m = p.getProjectionParent();
                  if (m) {
                    var y = m.prevViewportBox,
                      b = m.getLayoutState().layout;
                    _ &&
                      (i && (b = _.getLayoutState().layout),
                      r &&
                        !(function (e, t) {
                          var n = e.getLayoutId(),
                            o = t.getLayoutId();
                          return n !== o || (void 0 === o && e !== t);
                        })(_, m) &&
                        _.prevViewportBox &&
                        (y = _.prevViewportBox)),
                      y &&
                        (function (e, t, n) {
                          return e || (!e && !(t || n));
                        })(_, r, i) &&
                        ((h = !0), (n = Go(y, n)), (e = Go(b, e)));
                  }
                  var v,
                    g,
                    w =
                      ((g = e),
                      !ja((v = n)) &&
                        !ja(g) &&
                        (!Ta(v.x, g.x) || !Ta(v.y, g.y))),
                    x = ko(function (a) {
                      var r, i;
                      if ("position" === f) {
                        var s = e[a].max - e[a].min;
                        n[a].max = n[a].min + s;
                      }
                      if (!p.projection.isTargetLocked)
                        return void 0 === l
                          ? w
                            ? t.animateAxis(
                                a,
                                e[a],
                                n[a],
                                Object(o.a)(Object(o.a)({}, u), {
                                  isRelative: h,
                                }),
                              )
                            : (null === (i = (r = t.stopAxisAnimation)[a]) ||
                                void 0 === i ||
                                i.call(r),
                              p.setProjectionTargetAxis(
                                a,
                                e[a].min,
                                e[a].max,
                                h,
                              ))
                          : void p.setVisibility(l === ha.Show);
                    });
                  return (
                    p.syncRender(),
                    Promise.all(x).then(function () {
                      (t.isAnimatingTree = !1),
                        c && c(),
                        p.notifyLayoutAnimationComplete();
                    })
                  );
                }
              }),
              t
            );
          }
          return (
            Object(o.b)(t, e),
            (t.prototype.componentDidMount = function () {
              var e = this,
                t = this.props.visualElement;
              (t.animateMotionValue = An),
                t.enableLayoutProjection(),
                (this.unsubLayoutReady = t.onLayoutUpdate(this.animate)),
                (t.layoutSafeToRemove = function () {
                  return e.safeToRemove();
                }),
                (function (e) {
                  for (var t in e) A[t] = e[t];
                })(Oa);
            }),
            (t.prototype.componentWillUnmount = function () {
              var e = this;
              this.unsubLayoutReady(),
                ko(function (t) {
                  var n, o;
                  return null === (o = (n = e.stopAxisAnimation)[t]) ||
                    void 0 === o
                    ? void 0
                    : o.call(n);
                });
            }),
            (t.prototype.animateAxis = function (e, t, n, o) {
              var a,
                r,
                i = this,
                l = void 0 === o ? {} : o,
                s = l.transition,
                c = l.isRelative;
              if (
                !this.isAnimating[e] ||
                !Ta(t, this.currentAnimationTarget[e])
              ) {
                null === (r = (a = this.stopAxisAnimation)[e]) ||
                  void 0 === r ||
                  r.call(a),
                  (this.isAnimating[e] = !0);
                var _ = this.props.visualElement,
                  u = this.frameTarget[e],
                  d = _.getProjectionAnimationProgress()[e];
                d.clearListeners(), d.set(0), d.set(0);
                var p = function () {
                  var o = d.get() / 1e3;
                  !(function (e, t, n, o) {
                    (e.min = Object(Oo.a)(t.min, n.min, o)),
                      (e.max = Object(Oo.a)(t.max, n.max, o));
                  })(u, n, t, o),
                    _.setProjectionTargetAxis(e, u.min, u.max, c);
                };
                p();
                var f = d.onChange(p);
                (this.stopAxisAnimation[e] = function () {
                  (i.isAnimating[e] = !1), d.stop(), f();
                }),
                  (this.currentAnimationTarget[e] = t);
                var h = s || _.getDefaultTransition() || Ca;
                return An(
                  "x" === e ? "layoutX" : "layoutY",
                  d,
                  1e3,
                  h && zn(h, "layout"),
                ).then(this.stopAxisAnimation[e]);
              }
            }),
            (t.prototype.safeToRemove = function () {
              var e, t;
              null === (t = (e = this.props).safeToRemove) ||
                void 0 === t ||
                t.call(e);
            }),
            (t.prototype.render = function () {
              return null;
            }),
            t
          );
        })(a.Component);
      var Sa = { min: 0, max: 0 };
      function ja(e) {
        return Ta(e.x, Sa) && Ta(e.y, Sa);
      }
      function Ta(e, t) {
        return e.min === t.min && e.max === t.max;
      }
      var Ca = { duration: 0.45, ease: [0.4, 0, 0.1, 1] };
      var Ma = {
        layoutReady: function (e) {
          return e.notifyLayoutReady();
        },
      };
      function Pa() {
        var e = new Set();
        return {
          add: function (t) {
            return e.add(t);
          },
          flush: function (t) {
            var n = void 0 === t ? Ma : t,
              a = n.layoutReady,
              r = n.parent;
            la(function (t, n) {
              var i = Array.from(e).sort(Fo),
                l = r ? Ho(r) : [];
              n(function () {
                Object(o.e)(
                  Object(o.e)([], Object(o.c)(l)),
                  Object(o.c)(i),
                ).forEach(function (e) {
                  return e.resetTransform();
                });
              }),
                t(function () {
                  i.forEach(Wo);
                }),
                n(function () {
                  l.forEach(function (e) {
                    return e.restoreTransform();
                  }),
                    i.forEach(a);
                }),
                t(function () {
                  i.forEach(function (e) {
                    e.isPresent && (e.presence = fa.Present);
                  });
                }),
                n(function () {
                  qt.c.preRender(), qt.c.render();
                }),
                t(function () {
                  qt.b.postRender(function () {
                    return i.forEach(Ea);
                  }),
                    e.clear();
                });
            }),
              sa();
          },
        };
      }
      function Ea(e) {
        e.prevViewportBox = e.projection.target;
      }
      var La = Object(a.createContext)(Pa()),
        Ba = Object(a.createContext)(Pa());
      function Na(e) {
        return !!e.forceUpdate;
      }
      var Da = (function (e) {
        function t() {
          return (null !== e && e.apply(this, arguments)) || this;
        }
        return (
          Object(o.b)(t, e),
          (t.prototype.componentDidMount = function () {
            var e = this.props,
              t = e.syncLayout,
              n = e.framerSyncLayout,
              o = e.visualElement;
            Na(t) && t.register(o),
              Na(n) && n.register(o),
              o.onUnmount(function () {
                Na(t) && t.remove(o), Na(n) && n.remove(o);
              });
          }),
          (t.prototype.getSnapshotBeforeUpdate = function () {
            var e = this.props,
              t = e.syncLayout,
              n = e.visualElement;
            return (
              Na(t)
                ? t.syncUpdate()
                : (!(function (e) {
                    e.shouldResetTransform() ||
                      ((e.prevViewportBox = e.measureViewportBox(!1)),
                      e.rebaseProjectionTarget(!1, e.prevViewportBox));
                  })(n),
                  t.add(n)),
              null
            );
          }),
          (t.prototype.componentDidUpdate = function () {
            var e = this.props.syncLayout;
            Na(e) || e.flush();
          }),
          (t.prototype.render = function () {
            return null;
          }),
          t
        );
      })(r.a.Component);
      var za = {
        measureLayout: function (e) {
          var t = Object(a.useContext)(La),
            n = Object(a.useContext)(Ba);
          return r.a.createElement(
            Da,
            Object(o.a)({}, e, { syncLayout: t, framerSyncLayout: n }),
          );
        },
        layoutAnimation: function (e) {
          var t = Object(o.c)(m(), 2)[1];
          return a.createElement(Ia, Object(o.a)({}, e, { safeToRemove: t }));
        },
      };
      function Aa() {
        return {
          isHydrated: !1,
          layout: { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } },
          layoutCorrected: { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } },
          treeScale: { x: 1, y: 1 },
          delta: xo(),
          deltaFinal: xo(),
          deltaTransform: "",
        };
      }
      var Ra = Aa();
      function Fa(e, t, n) {
        var o = e.x,
          a = e.y,
          r =
            "translate3d(" +
            o.translate / t.x +
            "px, " +
            a.translate / t.y +
            "px, 0) ";
        if (n) {
          var i = n.rotate,
            l = n.rotateX,
            s = n.rotateY;
          i && (r += "rotate(" + i + ") "),
            l && (r += "rotateX(" + l + ") "),
            s && (r += "rotateY(" + s + ") ");
        }
        return (
          (r += "scale(" + o.scale + ", " + a.scale + ")"),
          n || r !== Ha ? r : ""
        );
      }
      function Va(e) {
        var t = e.deltaFinal;
        return 100 * t.x.origin + "% " + 100 * t.y.origin + "% 0";
      }
      var Ha = Fa(Ra.delta, Ra.treeScale, { x: 1, y: 1 }),
        Wa = n("mnEE"),
        Ua = [
          "LayoutMeasure",
          "BeforeLayoutMeasure",
          "LayoutUpdate",
          "ViewportBoxUpdate",
          "Update",
          "Render",
          "AnimationComplete",
          "LayoutAnimationComplete",
          "AnimationStart",
          "SetAxisTarget",
          "Unmount",
        ];
      function Ga(e, t, n, o) {
        var a,
          r,
          i = e.delta,
          l = e.layout,
          s = e.layoutCorrected,
          c = e.treeScale,
          _ = t.target;
        (r = l),
          qo((a = s).x, r.x),
          qo(a.y, r.y),
          (function (e, t, n) {
            var o = n.length;
            if (o) {
              var a, r;
              t.x = t.y = 1;
              for (var i = 0; i < o; i++)
                (r = (a = n[i]).getLayoutState().delta),
                  (t.x *= r.x.scale),
                  (t.y *= r.y.scale),
                  Qo(e, r),
                  Yo(a) && ta(e, e, a.getLatestValues());
            }
          })(s, c, n),
          zo(i, s, _, o);
      }
      var Ya = n("W3Nv"),
        qa = (function () {
          function e() {
            (this.children = []), (this.isDirty = !1);
          }
          return (
            (e.prototype.add = function (e) {
              Object(Ya.a)(this.children, e), (this.isDirty = !0);
            }),
            (e.prototype.remove = function (e) {
              Object(Ya.b)(this.children, e), (this.isDirty = !0);
            }),
            (e.prototype.forEach = function (e) {
              this.isDirty && this.children.sort(Fo),
                (this.isDirty = !1),
                this.children.forEach(e);
            }),
            e
          );
        })();
      var Xa = function (e) {
        var t = e.treeType,
          n = void 0 === t ? "" : t,
          a = e.build,
          r = e.getBaseTarget,
          i = e.makeTargetAnimatable,
          l = e.measureViewportBox,
          s = e.render,
          c = e.readValueFromInstance,
          _ = e.resetTransform,
          u = e.restoreTransform,
          d = e.removeValueFromRenderState,
          p = e.sortNodePosition,
          f = e.scrapeMotionValuesFromProps;
        return function (e, t) {
          var h = e.parent,
            m = e.props,
            y = e.presenceId,
            b = e.blockInitialAnimation,
            v = e.visualState;
          void 0 === t && (t = {});
          var g,
            w,
            x,
            k,
            O,
            I,
            S = v.latestValues,
            T = v.renderState,
            C = (function () {
              var e = Ua.map(function () {
                  return new Wa.a();
                }),
                t = {},
                n = {
                  clearAllListeners: function () {
                    return e.forEach(function (e) {
                      return e.clear();
                    });
                  },
                  updatePropListeners: function (e) {
                    return Ua.forEach(function (o) {
                      var a;
                      null === (a = t[o]) || void 0 === a || a.call(t);
                      var r = "on" + o,
                        i = e[r];
                      i && (t[o] = n[r](i));
                    });
                  },
                };
              return (
                e.forEach(function (e, t) {
                  (n["on" + Ua[t]] = function (t) {
                    return e.add(t);
                  }),
                    (n["notify" + Ua[t]] = function () {
                      for (var t = [], n = 0; n < arguments.length; n++)
                        t[n] = arguments[n];
                      return e.notify.apply(e, Object(o.e)([], Object(o.c)(t)));
                    });
                }),
                n
              );
            })(),
            E = {
              isEnabled: !1,
              isHydrated: !1,
              isTargetLocked: !1,
              target: { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } },
              targetFinal: { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } },
            },
            L = E,
            B = S,
            N = Aa(),
            D = !1,
            z = new Map(),
            A = new Map(),
            R = {},
            F = Object(o.a)({}, S);
          function V() {
            g &&
              (Q.isProjectionReady() &&
                (ta(L.targetFinal, L.target, B),
                zo(N.deltaFinal, N.layoutCorrected, L.targetFinal, S)),
              H(),
              s(g, T));
          }
          function H() {
            var e = S;
            if (k && k.isActive()) {
              var n = k.getCrossfadeState(Q);
              n && (e = n);
            }
            a(Q, T, e, L, N, t, m);
          }
          function W() {
            C.notifyUpdate(S);
          }
          function U() {
            Q.layoutTree.forEach(Ka);
          }
          var G = f(m);
          for (var Y in G) {
            var X = G[Y];
            void 0 !== S[Y] && Object(q.a)(X) && X.set(S[Y], !1);
          }
          var Z = M(m),
            K = P(m),
            Q = Object(o.a)(
              Object(o.a)(
                {
                  treeType: n,
                  current: null,
                  depth: h ? h.depth + 1 : 0,
                  parent: h,
                  children: new Set(),
                  path: h
                    ? Object(o.e)(Object(o.e)([], Object(o.c)(h.path)), [h])
                    : [],
                  layoutTree: h ? h.layoutTree : new qa(),
                  presenceId: y,
                  projection: E,
                  variantChildren: K ? new Set() : void 0,
                  isVisible: void 0,
                  manuallyAnimateOnMount: Boolean(
                    null === h || void 0 === h ? void 0 : h.isMounted(),
                  ),
                  blockInitialAnimation: b,
                  isMounted: function () {
                    return Boolean(g);
                  },
                  mount: function (e) {
                    (g = Q.current = e),
                      Q.pointTo(Q),
                      K &&
                        h &&
                        !Z &&
                        (I =
                          null === h || void 0 === h
                            ? void 0
                            : h.addVariantChild(Q)),
                      null === h || void 0 === h || h.children.add(Q);
                  },
                  unmount: function () {
                    qt.a.update(W),
                      qt.a.render(V),
                      qt.a.preRender(Q.updateLayoutProjection),
                      A.forEach(function (e) {
                        return e();
                      }),
                      Q.stopLayoutAnimation(),
                      Q.layoutTree.remove(Q),
                      null === I || void 0 === I || I(),
                      null === h || void 0 === h || h.children.delete(Q),
                      null === x || void 0 === x || x(),
                      C.clearAllListeners();
                  },
                  addVariantChild: function (e) {
                    var t,
                      n = Q.getClosestVariantNode();
                    if (n)
                      return (
                        null === (t = n.variantChildren) ||
                          void 0 === t ||
                          t.add(e),
                        function () {
                          return n.variantChildren.delete(e);
                        }
                      );
                  },
                  sortNodePosition: function (e) {
                    return p && n === e.treeType
                      ? p(Q.getInstance(), e.getInstance())
                      : 0;
                  },
                  getClosestVariantNode: function () {
                    return K
                      ? Q
                      : null === h || void 0 === h
                        ? void 0
                        : h.getClosestVariantNode();
                  },
                  scheduleUpdateLayoutProjection: h
                    ? h.scheduleUpdateLayoutProjection
                    : function () {
                        return qt.b.preRender(
                          Q.updateTreeLayoutProjection,
                          !1,
                          !0,
                        );
                      },
                  getLayoutId: function () {
                    return m.layoutId;
                  },
                  getInstance: function () {
                    return g;
                  },
                  getStaticValue: function (e) {
                    return S[e];
                  },
                  setStaticValue: function (e, t) {
                    return (S[e] = t);
                  },
                  getLatestValues: function () {
                    return S;
                  },
                  setVisibility: function (e) {
                    Q.isVisible !== e &&
                      ((Q.isVisible = e), Q.scheduleRender());
                  },
                  makeTargetAnimatable: function (e, t) {
                    return void 0 === t && (t = !0), i(Q, e, m, t);
                  },
                  addValue: function (e, t) {
                    Q.hasValue(e) && Q.removeValue(e),
                      z.set(e, t),
                      (S[e] = t.get()),
                      (function (e, t) {
                        var n = t.onChange(function (t) {
                            (S[e] = t), m.onUpdate && qt.b.update(W, !1, !0);
                          }),
                          o = t.onRenderRequest(Q.scheduleRender);
                        A.set(e, function () {
                          n(), o();
                        });
                      })(e, t);
                  },
                  removeValue: function (e) {
                    var t;
                    z.delete(e),
                      null === (t = A.get(e)) || void 0 === t || t(),
                      A.delete(e),
                      delete S[e],
                      d(e, T);
                  },
                  hasValue: function (e) {
                    return z.has(e);
                  },
                  getValue: function (e, t) {
                    var n = z.get(e);
                    return (
                      void 0 === n &&
                        void 0 !== t &&
                        ((n = Object(Fn.a)(t)), Q.addValue(e, n)),
                      n
                    );
                  },
                  forEachValue: function (e) {
                    return z.forEach(e);
                  },
                  readValue: function (e) {
                    var n;
                    return null !== (n = S[e]) && void 0 !== n ? n : c(g, e, t);
                  },
                  setBaseTarget: function (e, t) {
                    F[e] = t;
                  },
                  getBaseTarget: function (e) {
                    if (r) {
                      var t = r(m, e);
                      if (void 0 !== t && !Object(q.a)(t)) return t;
                    }
                    return F[e];
                  },
                },
                C,
              ),
              {
                build: function () {
                  return H(), T;
                },
                scheduleRender: function () {
                  qt.b.render(V, !1, !0);
                },
                syncRender: V,
                setProps: function (e) {
                  (m = e),
                    C.updatePropListeners(e),
                    (R = (function (e, t, n) {
                      var o;
                      for (var a in t) {
                        var r = t[a],
                          i = n[a];
                        if (Object(q.a)(r)) e.addValue(a, r);
                        else if (Object(q.a)(i)) e.addValue(a, Object(Fn.a)(r));
                        else if (i !== r)
                          if (e.hasValue(a)) {
                            var l = e.getValue(a);
                            !l.hasAnimated && l.set(r);
                          } else
                            e.addValue(
                              a,
                              Object(Fn.a)(
                                null !== (o = e.getStaticValue(a)) &&
                                  void 0 !== o
                                  ? o
                                  : r,
                              ),
                            );
                      }
                      for (var a in n) void 0 === t[a] && e.removeValue(a);
                      return t;
                    })(Q, f(m), R));
                },
                getProps: function () {
                  return m;
                },
                getVariant: function (e) {
                  var t;
                  return null === (t = m.variants) || void 0 === t
                    ? void 0
                    : t[e];
                },
                getDefaultTransition: function () {
                  return m.transition;
                },
                getVariantContext: function (e) {
                  if ((void 0 === e && (e = !1), e))
                    return null === h || void 0 === h
                      ? void 0
                      : h.getVariantContext();
                  if (!Z) {
                    var t =
                      (null === h || void 0 === h
                        ? void 0
                        : h.getVariantContext()) || {};
                    return void 0 !== m.initial && (t.initial = m.initial), t;
                  }
                  for (var n = {}, o = 0; o < $a; o++) {
                    var a = Ja[o],
                      r = m[a];
                    (j(r) || !1 === r) && (n[a] = r);
                  }
                  return n;
                },
                enableLayoutProjection: function () {
                  (E.isEnabled = !0), Q.layoutTree.add(Q);
                },
                lockProjectionTarget: function () {
                  E.isTargetLocked = !0;
                },
                unlockProjectionTarget: function () {
                  Q.stopLayoutAnimation(), (E.isTargetLocked = !1);
                },
                getLayoutState: function () {
                  return N;
                },
                setCrossfader: function (e) {
                  k = e;
                },
                isProjectionReady: function () {
                  return E.isEnabled && E.isHydrated && N.isHydrated;
                },
                startLayoutAnimation: function (e, t, n) {
                  void 0 === n && (n = !1);
                  var o = Q.getProjectionAnimationProgress()[e],
                    a = n ? E.relativeTarget[e] : E.target[e],
                    r = a.min,
                    i = a.max - r;
                  return (
                    o.clearListeners(),
                    o.set(r),
                    o.set(r),
                    o.onChange(function (t) {
                      Q.setProjectionTargetAxis(e, t, t + i, n);
                    }),
                    Q.animateMotionValue(e, o, 0, t)
                  );
                },
                stopLayoutAnimation: function () {
                  ko(function (e) {
                    return Q.getProjectionAnimationProgress()[e].stop();
                  });
                },
                measureViewportBox: function (e) {
                  void 0 === e && (e = !0);
                  var n = l(g, t);
                  return e || aa(n, S), n;
                },
                getProjectionAnimationProgress: function () {
                  return (
                    O || (O = { x: Object(Fn.a)(0), y: Object(Fn.a)(0) }), O
                  );
                },
                setProjectionTargetAxis: function (e, t, n, o) {
                  var a;
                  void 0 === o && (o = !1),
                    o
                      ? (E.relativeTarget ||
                          (E.relativeTarget = {
                            x: { min: 0, max: 1 },
                            y: { min: 0, max: 1 },
                          }),
                        (a = E.relativeTarget[e]))
                      : ((E.relativeTarget = void 0), (a = E.target[e])),
                    (E.isHydrated = !0),
                    (a.min = t),
                    (a.max = n),
                    (D = !0),
                    C.notifySetAxisTarget();
                },
                rebaseProjectionTarget: function (e, t) {
                  void 0 === t && (t = N.layout);
                  var n = Q.getProjectionAnimationProgress(),
                    o = n.x,
                    a = n.y,
                    r =
                      !E.relativeTarget &&
                      !E.isTargetLocked &&
                      !o.isAnimating() &&
                      !a.isAnimating();
                  (e || r) &&
                    ko(function (e) {
                      var n = t[e],
                        o = n.min,
                        a = n.max;
                      Q.setProjectionTargetAxis(e, o, a);
                    });
                },
                notifyLayoutReady: function (e) {
                  !(function (e) {
                    var t = e.getProjectionParent();
                    if (t) {
                      var n = Go(
                        t.getLayoutState().layout,
                        e.getLayoutState().layout,
                      );
                      ko(function (t) {
                        e.setProjectionTargetAxis(t, n[t].min, n[t].max, !0);
                      });
                    } else e.rebaseProjectionTarget();
                  })(Q),
                    Q.notifyLayoutUpdate(
                      N.layout,
                      Q.prevViewportBox || N.layout,
                      e,
                    );
                },
                resetTransform: function () {
                  return _(Q, g, m);
                },
                restoreTransform: function () {
                  return u(g, T);
                },
                updateLayoutProjection: function () {
                  if (Q.isProjectionReady()) {
                    var e = N.delta,
                      t = N.treeScale,
                      n = t.x,
                      o = t.y,
                      a = N.deltaTransform;
                    Ga(N, L, Q.path, S),
                      D && Q.notifyViewportBoxUpdate(L.target, e),
                      (D = !1);
                    var r = Fa(e, t);
                    (r === a && n === t.x && o === t.y) || Q.scheduleRender(),
                      (N.deltaTransform = r);
                  }
                },
                updateTreeLayoutProjection: function () {
                  Q.layoutTree.forEach(Za), qt.b.preRender(U, !1, !0);
                },
                getProjectionParent: function () {
                  if (void 0 === w) {
                    for (var e = !1, t = Q.path.length - 1; t >= 0; t--) {
                      var n = Q.path[t];
                      if (n.projection.isEnabled) {
                        e = n;
                        break;
                      }
                    }
                    w = e;
                  }
                  return w;
                },
                resolveRelativeTargetBox: function () {
                  var e = Q.getProjectionParent();
                  if (
                    E.relativeTarget &&
                    e &&
                    ((function (e, t) {
                      Ro(e.target.x, e.relativeTarget.x, t.target.x),
                        Ro(e.target.y, e.relativeTarget.y, t.target.y);
                    })(E, e.projection),
                    Yo(e))
                  ) {
                    var t = E.target;
                    ta(t, t, e.getLatestValues());
                  }
                },
                shouldResetTransform: function () {
                  return Boolean(m._layoutResetTransform);
                },
                pointTo: function (e) {
                  (L = e.projection),
                    (B = e.getLatestValues()),
                    null === x || void 0 === x || x(),
                    (x = Object(st.a)(
                      e.onSetAxisTarget(Q.scheduleUpdateLayoutProjection),
                      e.onLayoutAnimationComplete(function () {
                        var e;
                        Q.isPresent
                          ? (Q.presence = fa.Present)
                          : null === (e = Q.layoutSafeToRemove) ||
                            void 0 === e ||
                            e.call(Q);
                      }),
                    ));
                },
                isPresent: !0,
                presence: fa.Entering,
              },
            );
          return Q;
        };
      };
      function Za(e) {
        e.resolveRelativeTargetBox();
      }
      function Ka(e) {
        e.updateLayoutProjection();
      }
      var Qa,
        Ja = Object(o.e)(["initial"], Object(o.c)($n)),
        $a = Ja.length,
        er = new Set([
          "width",
          "height",
          "top",
          "left",
          "right",
          "bottom",
          "x",
          "y",
        ]),
        tr = function (e) {
          return er.has(e);
        },
        nr = function (e) {
          return Object.keys(e).some(tr);
        },
        or = function (e, t) {
          e.set(t, !1), e.set(t);
        },
        ar = function (e) {
          return e === J.b || e === Q.d;
        };
      !(function (e) {
        (e.width = "width"),
          (e.height = "height"),
          (e.left = "left"),
          (e.right = "right"),
          (e.top = "top"),
          (e.bottom = "bottom");
      })(Qa || (Qa = {}));
      var rr = function (e, t) {
          return parseFloat(e.split(", ")[t]);
        },
        ir = function (e, t) {
          return function (n, o) {
            var a = o.transform;
            if ("none" === a || !a) return 0;
            var r = a.match(/^matrix3d\((.+)\)$/);
            if (r) return rr(r[1], t);
            var i = a.match(/^matrix\((.+)\)$/);
            return i ? rr(i[1], e) : 0;
          };
        },
        lr = new Set(["x", "y", "z"]),
        sr = F.filter(function (e) {
          return !lr.has(e);
        });
      var cr = {
          width: function (e) {
            var t = e.x;
            return t.max - t.min;
          },
          height: function (e) {
            var t = e.y;
            return t.max - t.min;
          },
          top: function (e, t) {
            var n = t.top;
            return parseFloat(n);
          },
          left: function (e, t) {
            var n = t.left;
            return parseFloat(n);
          },
          bottom: function (e, t) {
            var n = e.y,
              o = t.top;
            return parseFloat(o) + (n.max - n.min);
          },
          right: function (e, t) {
            var n = e.x,
              o = t.left;
            return parseFloat(o) + (n.max - n.min);
          },
          x: ir(4, 13),
          y: ir(5, 14),
        },
        _r = function (e, t, n, a) {
          void 0 === n && (n = {}),
            void 0 === a && (a = {}),
            (t = Object(o.a)({}, t)),
            (a = Object(o.a)({}, a));
          var r = Object.keys(t).filter(tr),
            i = [],
            l = !1,
            c = [];
          if (
            (r.forEach(function (o) {
              var r = e.getValue(o);
              if (e.hasValue(o)) {
                var _,
                  u = n[o],
                  d = t[o],
                  p = Wn(u);
                if (Se(d))
                  for (var f = d.length, h = null === d[0] ? 1 : 0; h < f; h++)
                    _
                      ? Object(s.a)(
                          Wn(d[h]) === _,
                          "All keyframes must be of the same type",
                        )
                      : ((_ = Wn(d[h])),
                        Object(s.a)(
                          _ === p || (ar(p) && ar(_)),
                          "Keyframes must be of the same dimension as the current value",
                        ));
                else _ = Wn(d);
                if (p !== _)
                  if (ar(p) && ar(_)) {
                    var m = r.get();
                    "string" === typeof m && r.set(parseFloat(m)),
                      "string" === typeof d
                        ? (t[o] = parseFloat(d))
                        : Array.isArray(d) &&
                          _ === Q.d &&
                          (t[o] = d.map(parseFloat));
                  } else
                    (null === p || void 0 === p ? void 0 : p.transform) &&
                    (null === _ || void 0 === _ ? void 0 : _.transform) &&
                    (0 === u || 0 === d)
                      ? 0 === u
                        ? r.set(_.transform(u))
                        : (t[o] = p.transform(d))
                      : (l ||
                          ((i = (function (e) {
                            var t = [];
                            return (
                              sr.forEach(function (n) {
                                var o = e.getValue(n);
                                void 0 !== o &&
                                  (t.push([n, o.get()]),
                                  o.set(n.startsWith("scale") ? 1 : 0));
                              }),
                              t.length && e.syncRender(),
                              t
                            );
                          })(e)),
                          (l = !0)),
                        c.push(o),
                        (a[o] = void 0 !== a[o] ? a[o] : t[o]),
                        or(r, d));
              }
            }),
            c.length)
          ) {
            var _ = (function (e, t, n) {
              var o = t.measureViewportBox(),
                a = t.getInstance(),
                r = getComputedStyle(a),
                i = r.display,
                l = {
                  top: r.top,
                  left: r.left,
                  bottom: r.bottom,
                  right: r.right,
                  transform: r.transform,
                };
              "none" === i && t.setStaticValue("display", e.display || "block"),
                t.syncRender();
              var s = t.measureViewportBox();
              return (
                n.forEach(function (n) {
                  var a = t.getValue(n);
                  or(a, cr[n](o, l)), (e[n] = cr[n](s, r));
                }),
                e
              );
            })(t, e, c);
            return (
              i.length &&
                i.forEach(function (t) {
                  var n = Object(o.c)(t, 2),
                    a = n[0],
                    r = n[1];
                  e.getValue(a).set(r);
                }),
              e.syncRender(),
              { target: _, transitionEnd: a }
            );
          }
          return { target: t, transitionEnd: a };
        };
      var ur = function (e, t, n, a) {
        var r = (function (e, t, n) {
          var a,
            r = Object(o.d)(t, []),
            i = e.getInstance();
          if (!(i instanceof HTMLElement))
            return { target: r, transitionEnd: n };
          for (var l in (n && (n = Object(o.a)({}, n)),
          e.forEachValue(function (e) {
            var t = e.get();
            if (ya(t)) {
              var n = ga(t, i);
              n && e.set(n);
            }
          }),
          r)) {
            var s = r[l];
            if (ya(s)) {
              var c = ga(s, i);
              c &&
                ((r[l] = c),
                n && ((null !== (a = n[l]) && void 0 !== a) || (n[l] = s)));
            }
          }
          return { target: r, transitionEnd: n };
        })(e, t, a);
        return (function (e, t, n, o) {
          return nr(t) ? _r(e, t, n, o) : { target: t, transitionEnd: o };
        })(e, (t = r.target), n, (a = r.transitionEnd));
      };
      var dr = {
          treeType: "dom",
          readValueFromInstance: function (e, t) {
            if (W(t)) {
              var n = Mn(t);
              return (n && n.default) || 0;
            }
            var o,
              a = ((o = e), window.getComputedStyle(o));
            return (Z(t) ? a.getPropertyValue(t) : a[t]) || 0;
          },
          sortNodePosition: function (e, t) {
            return 2 & e.compareDocumentPosition(t) ? 1 : -1;
          },
          getBaseTarget: function (e, t) {
            var n;
            return null === (n = e.style) || void 0 === n ? void 0 : n[t];
          },
          measureViewportBox: function (e, t) {
            return Po(e, t.transformPagePoint);
          },
          resetTransform: function (e, t, n) {
            var o = n.transformTemplate;
            (t.style.transform = o ? o({}, "") : "none"), e.scheduleRender();
          },
          restoreTransform: function (e, t) {
            e.style.transform = t.style.transform;
          },
          removeValueFromRenderState: function (e, t) {
            var n = t.vars,
              o = t.style;
            delete n[e], delete o[e];
          },
          makeTargetAnimatable: function (e, t, n, a) {
            var r = n.transformValues;
            void 0 === a && (a = !0);
            var i = t.transition,
              l = t.transitionEnd,
              s = Object(o.d)(t, ["transition", "transitionEnd"]),
              c = (function (e, t, n) {
                var o,
                  a,
                  r = {};
                for (var i in e)
                  r[i] =
                    null !== (o = Xn(i, t)) && void 0 !== o
                      ? o
                      : null === (a = n.getValue(i)) || void 0 === a
                        ? void 0
                        : a.get();
                return r;
              })(s, i || {}, e);
            if ((r && (l && (l = r(l)), s && (s = r(s)), c && (c = r(c))), a)) {
              !(function (e, t, n) {
                var o,
                  a,
                  r,
                  i,
                  l = Object.keys(t).filter(function (t) {
                    return !e.hasValue(t);
                  }),
                  s = l.length;
                if (s)
                  for (var c = 0; c < s; c++) {
                    var _ = l[c],
                      u = t[_],
                      d = null;
                    Array.isArray(u) && (d = u[0]),
                      null === d &&
                        (d =
                          null !==
                            (a =
                              null !== (o = n[_]) && void 0 !== o
                                ? o
                                : e.readValue(_)) && void 0 !== a
                            ? a
                            : t[_]),
                      void 0 !== d &&
                        null !== d &&
                        ("string" === typeof d && Rn(d)
                          ? (d = parseFloat(d))
                          : !Gn(d) && hn.a.test(u) && (d = Pn(_, u)),
                        e.addValue(_, Object(Fn.a)(d)),
                        (null !== (r = (i = n)[_]) && void 0 !== r) ||
                          (i[_] = d),
                        e.setBaseTarget(_, d));
                  }
              })(e, s, c);
              var _ = ur(e, s, c, l);
              (l = _.transitionEnd), (s = _.target);
            }
            return Object(o.a)({ transition: i, transitionEnd: l }, s);
          },
          scrapeMotionValuesFromProps: ke,
          build: function (e, t, n, o, a, r, i) {
            void 0 !== e.isVisible &&
              (t.style.visibility = e.isVisible ? "visible" : "hidden");
            var l = o.isEnabled && a.isHydrated;
            te(
              t,
              n,
              o,
              a,
              r,
              i.transformTemplate,
              l ? Fa : void 0,
              l ? Va : void 0,
            );
          },
          render: ge,
        },
        pr = Xa(dr),
        fr = Xa(
          Object(o.a)(Object(o.a)({}, dr), {
            getBaseTarget: function (e, t) {
              return e[t];
            },
            readValueFromInstance: function (e, t) {
              var n;
              return W(t)
                ? (null === (n = Mn(t)) || void 0 === n ? void 0 : n.default) ||
                    0
                : ((t = we.has(t) ? t : ve(t)), e.getAttribute(t));
            },
            scrapeMotionValuesFromProps: Oe,
            build: function (e, t, n, o, a, r, i) {
              var l = o.isEnabled && a.isHydrated;
              fe(
                t,
                n,
                o,
                a,
                r,
                i.transformTemplate,
                l ? Fa : void 0,
                l ? Va : void 0,
              );
            },
            render: xe,
          }),
        ),
        hr = function (e, t) {
          return z(e)
            ? fr(t, { enableHardwareAcceleration: !1 })
            : pr(t, { enableHardwareAcceleration: !0 });
        },
        mr = Object(o.a)(
          Object(o.a)(Object(o.a)(Object(o.a)({}, ro), _t), ma),
          za,
        ),
        yr = N(function (e, t) {
          return De(e, t, mr, hr);
        });
    },
    AUvm: function (e, t, n) {
      "use strict";
      var o = n("5T2Y"),
        a = n("B+OT"),
        r = n("jmDH"),
        i = n("Y7ZC"),
        l = n("kTiW"),
        s = n("6/1s").KEY,
        c = n("KUxP"),
        _ = n("29s/"),
        u = n("RfKB"),
        d = n("YqAc"),
        p = n("UWiX"),
        f = n("zLkG"),
        h = n("Zxgi"),
        m = n("R+7+"),
        y = n("kAMH"),
        b = n("5K7Z"),
        v = n("93I4"),
        g = n("JB68"),
        w = n("NsO/"),
        x = n("G8Mo"),
        k = n("rr1i"),
        O = n("oVml"),
        I = n("A5Xg"),
        S = n("vwuL"),
        j = n("mqlF"),
        T = n("2faE"),
        C = n("w6GO"),
        M = S.f,
        P = T.f,
        E = I.f,
        L = o.Symbol,
        B = o.JSON,
        N = B && B.stringify,
        D = p("_hidden"),
        z = p("toPrimitive"),
        A = {}.propertyIsEnumerable,
        R = _("symbol-registry"),
        F = _("symbols"),
        V = _("op-symbols"),
        H = Object.prototype,
        W = "function" == typeof L && !!j.f,
        U = o.QObject,
        G = !U || !U.prototype || !U.prototype.findChild,
        Y =
          r &&
          c(function () {
            return (
              7 !=
              O(
                P({}, "a", {
                  get: function () {
                    return P(this, "a", { value: 7 }).a;
                  },
                }),
              ).a
            );
          })
            ? function (e, t, n) {
                var o = M(H, t);
                o && delete H[t], P(e, t, n), o && e !== H && P(H, t, o);
              }
            : P,
        q = function (e) {
          var t = (F[e] = O(L.prototype));
          return (t._k = e), t;
        },
        X =
          W && "symbol" == typeof L.iterator
            ? function (e) {
                return "symbol" == typeof e;
              }
            : function (e) {
                return e instanceof L;
              },
        Z = function (e, t, n) {
          return (
            e === H && Z(V, t, n),
            b(e),
            (t = x(t, !0)),
            b(n),
            a(F, t)
              ? (n.enumerable
                  ? (a(e, D) && e[D][t] && (e[D][t] = !1),
                    (n = O(n, { enumerable: k(0, !1) })))
                  : (a(e, D) || P(e, D, k(1, {})), (e[D][t] = !0)),
                Y(e, t, n))
              : P(e, t, n)
          );
        },
        K = function (e, t) {
          b(e);
          for (var n, o = m((t = w(t))), a = 0, r = o.length; r > a; )
            Z(e, (n = o[a++]), t[n]);
          return e;
        },
        Q = function (e) {
          var t = A.call(this, (e = x(e, !0)));
          return (
            !(this === H && a(F, e) && !a(V, e)) &&
            (!(t || !a(this, e) || !a(F, e) || (a(this, D) && this[D][e])) || t)
          );
        },
        J = function (e, t) {
          if (((e = w(e)), (t = x(t, !0)), e !== H || !a(F, t) || a(V, t))) {
            var n = M(e, t);
            return (
              !n || !a(F, t) || (a(e, D) && e[D][t]) || (n.enumerable = !0), n
            );
          }
        },
        $ = function (e) {
          for (var t, n = E(w(e)), o = [], r = 0; n.length > r; )
            a(F, (t = n[r++])) || t == D || t == s || o.push(t);
          return o;
        },
        ee = function (e) {
          for (
            var t, n = e === H, o = E(n ? V : w(e)), r = [], i = 0;
            o.length > i;

          )
            !a(F, (t = o[i++])) || (n && !a(H, t)) || r.push(F[t]);
          return r;
        };
      W ||
        (l(
          (L = function () {
            if (this instanceof L)
              throw TypeError("Symbol is not a constructor!");
            var e = d(arguments.length > 0 ? arguments[0] : void 0),
              t = function (n) {
                this === H && t.call(V, n),
                  a(this, D) && a(this[D], e) && (this[D][e] = !1),
                  Y(this, e, k(1, n));
              };
            return r && G && Y(H, e, { configurable: !0, set: t }), q(e);
          }).prototype,
          "toString",
          function () {
            return this._k;
          },
        ),
        (S.f = J),
        (T.f = Z),
        (n("ar/p").f = I.f = $),
        (n("NV0k").f = Q),
        (j.f = ee),
        r && !n("uOPS") && l(H, "propertyIsEnumerable", Q, !0),
        (f.f = function (e) {
          return q(p(e));
        })),
        i(i.G + i.W + i.F * !W, { Symbol: L });
      for (
        var te =
            "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
              ",",
            ),
          ne = 0;
        te.length > ne;

      )
        p(te[ne++]);
      for (var oe = C(p.store), ae = 0; oe.length > ae; ) h(oe[ae++]);
      i(i.S + i.F * !W, "Symbol", {
        for: function (e) {
          return a(R, (e += "")) ? R[e] : (R[e] = L(e));
        },
        keyFor: function (e) {
          if (!X(e)) throw TypeError(e + " is not a symbol!");
          for (var t in R) if (R[t] === e) return t;
        },
        useSetter: function () {
          G = !0;
        },
        useSimple: function () {
          G = !1;
        },
      }),
        i(i.S + i.F * !W, "Object", {
          create: function (e, t) {
            return void 0 === t ? O(e) : K(O(e), t);
          },
          defineProperty: Z,
          defineProperties: K,
          getOwnPropertyDescriptor: J,
          getOwnPropertyNames: $,
          getOwnPropertySymbols: ee,
        });
      var re = c(function () {
        j.f(1);
      });
      i(i.S + i.F * re, "Object", {
        getOwnPropertySymbols: function (e) {
          return j.f(g(e));
        },
      }),
        B &&
          i(
            i.S +
              i.F *
                (!W ||
                  c(function () {
                    var e = L();
                    return (
                      "[null]" != N([e]) ||
                      "{}" != N({ a: e }) ||
                      "{}" != N(Object(e))
                    );
                  })),
            "JSON",
            {
              stringify: function (e) {
                for (var t, n, o = [e], a = 1; arguments.length > a; )
                  o.push(arguments[a++]);
                if (((n = t = o[1]), (v(t) || void 0 !== e) && !X(e)))
                  return (
                    y(t) ||
                      (t = function (e, t) {
                        if (
                          ("function" == typeof n && (t = n.call(this, e, t)),
                          !X(t))
                        )
                          return t;
                      }),
                    (o[1] = t),
                    N.apply(B, o)
                  );
              },
            },
          ),
        L.prototype[z] || n("NegM")(L.prototype, z, L.prototype.valueOf),
        u(L, "Symbol"),
        u(Math, "Math", !0),
        u(o.JSON, "JSON", !0);
    },
    Agtg: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return _;
      }),
        n.d(t, "b", function () {
          return u;
        });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("rePB"),
        i = n("gn4A"),
        l = n.n(i),
        s = n("hKI/"),
        c = n.n(s),
        _ = (function (e) {
          return (e.UP = "up"), (e.DOWN = "down"), (e.NONE = "none"), e;
        })({}),
        u = (function () {
          function e() {
            Object(o.default)(this, e),
              Object(r.a)(this, "dimensionInfo", void 0),
              Object(r.a)(this, "fastScrollThreshold", 0),
              Object(r.a)(this, "isFastScroll", !1),
              Object(r.a)(this, "isAnchorScroll", !1),
              Object(r.a)(this, "scrollDirection", _.NONE),
              Object(r.a)(this, "scrollingTimeout", void 0),
              Object(r.a)(this, "anchor", ""),
              Object(r.a)(this, "listeners", new Map()),
              (this.dimensionInfo = {
                pageOffsetY: window.scrollY,
                pageOffsetX: window.scrollX,
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
                scrollDelta: 0,
                isOffsetValid: !0,
                isSizeValid: !0,
              }),
              (this.anchor = window.location.hash),
              (this.fastScrollThreshold = l.a.isMobile() ? 600 : 1e3),
              this.addListener();
          }
          return (
            Object(a.default)(e, [
              {
                key: "addDimensionListener",
                value: function (e, t) {
                  e && this.listeners.set(e, t);
                },
              },
              {
                key: "removeDimensionListener",
                value: function (e) {
                  this.listeners.delete(e);
                },
              },
              {
                key: "scrollDelta",
                get: function () {
                  return (
                    this.dimensionInfo.isOffsetValid || this.calcScrollOffset(),
                    this.dimensionInfo.scrollDelta
                  );
                },
              },
              {
                key: "isSizeValid",
                get: function () {
                  return this.dimensionInfo.isSizeValid;
                },
              },
              {
                key: "isOffsetValid",
                get: function () {
                  return this.dimensionInfo.isOffsetValid;
                },
              },
              {
                key: "pageOffsetX",
                get: function () {
                  return (
                    this.dimensionInfo.isOffsetValid ||
                      ((this.dimensionInfo.pageOffsetX = window.scrollX),
                      (this.dimensionInfo.isOffsetValid = !0)),
                    this.dimensionInfo.pageOffsetX
                  );
                },
              },
              {
                key: "pageOffsetY",
                get: function () {
                  return (
                    this.dimensionInfo.isOffsetValid || this.calcScrollOffset(),
                    this.dimensionInfo.pageOffsetY
                  );
                },
              },
              {
                key: "innerWidth",
                get: function () {
                  return (
                    this.dimensionInfo.isSizeValid ||
                      ((this.dimensionInfo.isSizeValid = !0),
                      (this.dimensionInfo.innerWidth = window.innerWidth)),
                    this.dimensionInfo.innerWidth
                  );
                },
                set: function (e) {
                  (this.dimensionInfo.isSizeValid = !0),
                    (this.dimensionInfo.innerWidth = e);
                },
              },
              {
                key: "innerHeight",
                get: function () {
                  return (
                    this.dimensionInfo.isSizeValid ||
                      ((this.dimensionInfo.isSizeValid = !0),
                      (this.dimensionInfo.innerHeight = window.innerHeight)),
                    this.dimensionInfo.innerHeight
                  );
                },
                set: function (e) {
                  (this.dimensionInfo.isSizeValid = !0),
                    (this.dimensionInfo.innerHeight = e);
                },
              },
              {
                key: "getDirection",
                value: function () {
                  return this.calcScrollOffset(), this.scrollDirection;
                },
              },
              {
                key: "updateOffset",
                value: function () {
                  (this.dimensionInfo.pageOffsetY = window.scrollY),
                    (this.dimensionInfo.pageOffsetX = window.scrollX),
                    (this.dimensionInfo.isOffsetValid = !0);
                },
              },
              {
                key: "calcScrollOffset",
                value: function () {
                  var e = window.scrollY,
                    t = e - this.dimensionInfo.pageOffsetY;
                  t > 0
                    ? (this.scrollDirection = _.DOWN)
                    : t < 0 && (this.scrollDirection = _.UP),
                    (this.dimensionInfo.scrollDelta = Math.abs(t)),
                    (this.dimensionInfo.pageOffsetY = e),
                    (this.dimensionInfo.isOffsetValid = !0),
                    this.dimensionInfo.scrollDelta > this.fastScrollThreshold
                      ? (this.isFastScroll = !0)
                      : (this.isFastScroll = !1);
                },
              },
              {
                key: "addListener",
                value: function () {
                  window.addEventListener(
                    "resize",
                    c()(this.onResize.bind(this), 300),
                    { passive: !0 },
                  ),
                    window.addEventListener(
                      "scroll",
                      this.onScroll.bind(this),
                      { passive: !0 },
                    ),
                    window.addEventListener(
                      "orientationchange",
                      this.onRotate.bind(this),
                      { passive: !0 },
                    ),
                    window.addEventListener(
                      "popstate",
                      this.onPageRestore.bind(this),
                      !1,
                    ),
                    window.addEventListener(
                      "pageshow",
                      this.onPageRestore.bind(this),
                    );
                },
              },
              {
                key: "onPageRestore",
                value: function () {
                  var e = this;
                  setTimeout(function () {
                    e.onScroll();
                  }, 1e3);
                },
              },
              {
                key: "onResize",
                value: function () {
                  (this.dimensionInfo.isSizeValid = !1),
                    requestAnimationFrame(this.handleResize.bind(this));
                },
              },
              {
                key: "onScroll",
                value: function () {
                  requestAnimationFrame(this.handleScroll.bind(this));
                },
              },
              {
                key: "onRotate",
                value: function () {
                  requestAnimationFrame(this.handleRotate.bind(this));
                },
              },
              {
                key: "handleScroll",
                value: function () {
                  var e = this;
                  this.dimensionInfo.isOffsetValid &&
                    (window.location.hash !== this.anchor &&
                      (this.isAnchorScroll = !0),
                    (this.dimensionInfo.isOffsetValid = !1),
                    this.listeners.forEach(function (t) {
                      var n;
                      null === (n = t.onScrollStart) ||
                        void 0 === n ||
                        n.call(t, e);
                    }));
                  this.listeners.forEach(function (t) {
                    var n;
                    null === (n = t.onScroll) || void 0 === n || n.call(t, e);
                  }),
                    clearTimeout(this.scrollingTimeout),
                    (this.scrollingTimeout = setTimeout(function () {
                      (e.isFastScroll = !1),
                        (e.dimensionInfo.isOffsetValid = !0),
                        (e.dimensionInfo.scrollDelta = 0),
                        (e.scrollDirection = _.NONE),
                        e.listeners.forEach(function (t) {
                          var n;
                          null === (n = t.onScrollEnd) ||
                            void 0 === n ||
                            n.call(t, e);
                        }),
                        (e.isAnchorScroll = !1),
                        (e.anchor = window.location.hash);
                    }, 1e3));
                },
              },
              {
                key: "handleResize",
                value: function () {
                  var e = this;
                  (this.dimensionInfo.isOffsetValid = !1),
                    this.listeners.forEach(function (t) {
                      var n;
                      null === (n = t.onResize) || void 0 === n || n.call(t, e);
                    });
                },
              },
              {
                key: "handleRotate",
                value: function () {
                  var e = this;
                  (this.dimensionInfo.isOffsetValid = !1),
                    this.listeners.forEach(function (t) {
                      var n;
                      null === (n = t.onRotate) || void 0 === n || n.call(t, e);
                    });
                },
              },
            ]),
            e
          );
        })();
    },
    Aw7D: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        a =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              };
      (t.convertFieldsError = i),
        (t.format = function () {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          var o = 1,
            a = t[0],
            i = t.length;
          if ("function" === typeof a) return a.apply(null, t.slice(1));
          if ("string" === typeof a) {
            for (
              var l = String(a).replace(r, function (e) {
                  if ("%%" === e) return "%";
                  if (o >= i) return e;
                  switch (e) {
                    case "%s":
                      return String(t[o++]);
                    case "%d":
                      return Number(t[o++]);
                    case "%j":
                      try {
                        return JSON.stringify(t[o++]);
                      } catch (n) {
                        return "[Circular]";
                      }
                      break;
                    default:
                      return e;
                  }
                }),
                s = t[o];
              o < i;
              s = t[++o]
            )
              l += " " + s;
            return l;
          }
          return a;
        }),
        (t.isEmptyValue = function (e, t) {
          if (void 0 === e || null === e) return !0;
          if ("array" === t && Array.isArray(e) && !e.length) return !0;
          if (
            (function (e) {
              return (
                "string" === e ||
                "url" === e ||
                "hex" === e ||
                "email" === e ||
                "pattern" === e
              );
            })(t) &&
            "string" === typeof e &&
            !e
          )
            return !0;
          return !1;
        }),
        (t.isEmptyObject = function (e) {
          return 0 === Object.keys(e).length;
        }),
        (t.asyncMap = function (e, t, n, o) {
          if (t.first) {
            return l(
              (function (e) {
                var t = [];
                return (
                  Object.keys(e).forEach(function (n) {
                    t.push.apply(t, e[n]);
                  }),
                  t
                );
              })(e),
              n,
              o,
            );
          }
          var a = t.firstFields || [];
          !0 === a && (a = Object.keys(e));
          var r = Object.keys(e),
            s = r.length,
            c = 0,
            _ = [],
            u = new Promise(function (t, u) {
              var d = function (e) {
                if ((_.push.apply(_, e), ++c === s))
                  return o(_), _.length ? u({ errors: _, fields: i(_) }) : t();
              };
              r.forEach(function (t) {
                var o = e[t];
                -1 !== a.indexOf(t)
                  ? l(o, n, d)
                  : (function (e, t, n) {
                      var o = [],
                        a = 0,
                        r = e.length;
                      function i(e) {
                        o.push.apply(o, e), ++a === r && n(o);
                      }
                      e.forEach(function (e) {
                        t(e, i);
                      });
                    })(o, n, d);
              });
            });
          return (
            u.catch(function (e) {
              return e;
            }),
            u
          );
        }),
        (t.complementError = function (e) {
          return function (t) {
            return t && t.message
              ? ((t.field = t.field || e.fullField), t)
              : {
                  message: "function" === typeof t ? t() : t,
                  field: t.field || e.fullField,
                };
          };
        }),
        (t.deepMerge = function (e, t) {
          if (t)
            for (var n in t)
              if (t.hasOwnProperty(n)) {
                var r = t[n];
                "object" === ("undefined" === typeof r ? "undefined" : a(r)) &&
                "object" === a(e[n])
                  ? (e[n] = o({}, e[n], r))
                  : (e[n] = r);
              }
          return e;
        });
      var r = /%[sdj%]/g;
      t.warning = function () {};
      function i(e) {
        if (!e || !e.length) return null;
        var t = {};
        return (
          e.forEach(function (e) {
            var n = e.field;
            (t[n] = t[n] || []), t[n].push(e);
          }),
          t
        );
      }
      function l(e, t, n) {
        var o = 0,
          a = e.length;
        !(function r(i) {
          if (i && i.length) n(i);
          else {
            var l = o;
            (o += 1), l < a ? t(e[l], r) : n([]);
          }
        })([]);
      }
    },
    AyUB: function (e, t, n) {
      e.exports = { default: n("3GJH"), __esModule: !0 };
    },
    "B+OT": function (e, t) {
      var n = {}.hasOwnProperty;
      e.exports = function (e, t) {
        return n.call(e, t);
      };
    },
    B8du: function (e, t) {
      e.exports = function () {
        return !1;
      };
    },
    BJfS: function (e, t) {
      e.exports = function (e) {
        return e
          .replace(/[A-Z]/g, function (e) {
            return "-" + e.toLowerCase();
          })
          .toLowerCase();
      };
    },
    Brax: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o = y(n("wOlv")),
        a = y(n("9nLi")),
        r = y(n("UrHs")),
        i = y(n("HICh")),
        l = y(n("dWbz")),
        s = y(n("D83i")),
        c = y(n("3PAf")),
        _ = y(n("fl7H")),
        u = y(n("LxhC")),
        d = y(n("ZkIW")),
        p = y(n("SGsF")),
        f = y(n("UnUH")),
        h = y(n("h/6u")),
        m = y(n("qhfP"));
      function y(e) {
        return e && e.__esModule ? e : { default: e };
      }
      t.default = {
        string: o.default,
        method: a.default,
        number: r.default,
        boolean: i.default,
        regexp: l.default,
        integer: s.default,
        float: c.default,
        array: _.default,
        object: u.default,
        enum: d.default,
        pattern: p.default,
        date: f.default,
        url: m.default,
        hex: m.default,
        email: m.default,
        required: h.default,
      };
    },
    C68Z: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return i;
      }),
        n.d(t, "b", function () {
          return r;
        }),
        n.d(t, "c", function () {
          return l;
        });
      var o = n("mrSG"),
        a = n("3T+G"),
        r = {
          test: function (e) {
            return "number" === typeof e;
          },
          parse: parseFloat,
          transform: function (e) {
            return e;
          },
        },
        i = Object(o.a)(Object(o.a)({}, r), { transform: Object(a.a)(0, 1) }),
        l = Object(o.a)(Object(o.a)({}, r), { default: 1 });
    },
    CBaM: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return je;
      });
      var o = n("wx14"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("rePB"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("QH4r"),
        m = n("3vbH"),
        y = n("SBOM"),
        b = n("ub/+"),
        v = n("8Kt/"),
        g = n.n(v),
        w = n("/NQ+"),
        x = n("pXgs"),
        k = n("yWgo"),
        O = n("ZPPD"),
        I = n("inn5"),
        S = n("ce2M"),
        j = n("k33e"),
        T = (n("z8P2"), f.a.createElement);
      function C(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function M(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? C(Object(n), !0).forEach(function (t) {
                Object(_.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : C(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var P = {
          "./style.css": {
            "card-link-container": "style__card-link-container___17v88",
            "card-container": "style__card-container___3mjN3",
            "card-wrapper": "style__card-wrapper___1DqOx",
            "vertical-top-align": "style__vertical-top-align___1s3Hj",
            "vertical-center-align": "style__vertical-center-align___3mf-F",
            "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
            "card-background-video": "style__card-background-video___1108n",
            "video-mask": "style__video-mask___3Z49h",
            "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
            "card-content": "style__card-content___vH0I2",
            "horizontal-left-align": "style__horizontal-left-align___1piH2",
            "horizontal-right-align": "style__horizontal-right-align___1k3dg",
            "tag-container": "style__tag-container___1t87X",
            "tag-content": "style__tag-content___2sjEO",
            eyebrow: "style__eyebrow___3767l",
            headline: "style__headline___1GB_U",
            subhead: "style__subhead___1-icl",
            description: "style__description___37V2m",
            note: "style__note___JDE7h",
            "icon-pic": "style__icon-pic___3-zqP",
            "topping-img": "style__topping-img___2_zBh",
            divider: "style__divider___k3dpz",
            "download-buttons-container":
              "style__download-buttons-container___25rLz",
            "icons-container": "style__icons-container___2fJmw",
            "icon-number-container": "style__icon-number-container___22BrE",
            "horizontal-center-align": "style__horizontal-center-align___3ggDc",
            "content-text-color-black":
              "style__content-text-color-black___38P05",
            "icon-title": "style__icon-title___bGMXt",
            "icon-desc": "style__icon-desc___1CQub",
            "content-text-color-white":
              "style__content-text-color-white___2nplh",
            "credit-wrapper": "style__credit-wrapper___31b8l",
            "credit-container": "style__credit-container___3BA6K",
            "credit-content": "style__credit-content___xOkfI",
            "size-xxxxxl": "style__size-xxxxxl___1VAz7",
            "connect-pic": "style__connect-pic___MDMRC",
            "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
            link: "style__link___36f7n",
            "card-icons-container": "style__card-icons-container___2FX2x",
            "card-icon-container": "style__card-icon-container___F6BCn",
            "icon-number": "style__icon-number___22dek",
            "icon-unit": "style__icon-unit___3iS0V",
            "size-xxxxl": "style__size-xxxxl___1FO2n",
            "size-xxxl": "style__size-xxxl___1Y--4",
            "size-xxl": "style__size-xxl___cbKEg",
            "size-xl": "style__size-xl___cmT-W",
            "size-l": "style__size-l___3xNLm",
            "size-m": "style__size-m___3_02b",
            "size-s": "style__size-s___2Qc-8",
            "size-xs": "style__size-xs___DThSi",
            "size-xxs": "style__size-xxs___10O36",
            "visual-hidden": "style__visual-hidden___2tPnU",
            "divider-container": "style__divider-container___3AxY_",
            "price-container": "style__price-container___sPpJJ",
            "real-price": "style__real-price___2CYaY",
            "origin-price": "style__origin-price___2TUsS",
            "buttons-container": "style__buttons-container___3cR_a",
            "button-wrapper": "style__button-wrapper___2sw2O",
            "button-inner": "style__button-inner___2d6iZ",
            "button-video-play": "style__button-video-play___usCnv",
            "zoom-button": "style__zoom-button___1HyFB",
            "video-play": "style__video-play___cjJlz",
            "video-play-light": "style__video-play-light___1T1v8",
            "video-play-dark": "style__video-play-dark___3PmPb",
            download: "style__download___2hSKC",
            "download-google-play": "style__download-google-play___1HiCP",
            "links-container": "style__links-container___1gH9d",
            horizontal: "style__horizontal___1K_GU",
            part: "style__part___eEtb1",
            left: "style__left___2NDSB",
            right: "style__right___2g_dT",
            "card-media": "style__card-media___AnYZC",
            "card-media-multi": "style__card-media-multi___1_28d",
            "card-media-multi-leftRight":
              "style__card-media-multi-leftRight___awTbn",
            "card-media-part": "style__card-media-part___3Rnlj",
            "card-media-multi-left2right1":
              "style__card-media-multi-left2right1___cYtEd",
            "card-media-item": "style__card-media-item___1tEYL",
            "card-media-multi-up1down2":
              "style__card-media-multi-up1down2___6dU4Q",
            "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
            "card-media-multi-up2down1":
              "style__card-media-multi-up2down1___2t2N0",
            "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
            "media-pic": "style__media-pic___3hS5Q",
            "media-sticker": "style__media-sticker___2vBF1",
            "media-video": "style__media-video___3Q0jo",
            "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
            "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
            "video-buttom": "style__video-buttom___2mMcP",
            "replay-buttom": "style__replay-buttom___3-axl",
            "play-buttom": "style__play-buttom___1YaPT",
            "pause-buttom": "style__pause-buttom___3stBv",
            "parallax-fore-video": "style__parallax-fore-video___3RGrL",
            "has-media-screen": "style__has-media-screen___2M2eq",
            "media-screen-1440": "style__media-screen-1440___3gmu4",
            "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
            "media-screen-1600": "style__media-screen-1600___2pukG",
          },
        },
        E = f.a.forwardRef(function (e, t) {
          var n = e.aosFade,
            a = e.visibleByDefault,
            r = e.leftCols,
            i = e.foregroundList,
            l = Object(O.a)(e),
            s = t.cardForegroundVideo,
            c = t.cardForegroundVideoReplay,
            u = t.cardForegroundVideoPlay,
            p = t.cardForegroundVideoPause,
            f = e.getMediaTransiation(),
            h = e.getTabPresentation(),
            b = (function (t) {
              var n = e.getGapWidth(),
                o = e.getGridWidth(),
                a = parseInt(n, 10),
                r = o;
              return (
                (((r = r.match(/vw|%/)
                  ? parseInt(r, 10) * window.innerWidth
                  : parseInt(r, 10)) -
                  11 * a) /
                  12) *
                  t +
                a * (t - 1)
              );
            })(e.leftCols),
            v = "calc(100% - ".concat(e.mediaDistance, " - ").concat(b, "px)"),
            g = e.foregroundLayout === I.j.one,
            w =
              g &&
              e.foregroundHasParallax &&
              e.foregroundParallax === I.k["whole-item"],
            x =
              g &&
              e.foregroundHasParallax &&
              e.foregroundParallax === I.k["inner-content"],
            C = function (e) {
              if (!e) return null;
              var t = Object(_.a)(
                  {},
                  a ? "poster" : "data-layzr-poster",
                  e.foregroundVideoPoster,
                ),
                n = { borderRadius: e.mediaBorderRadius, overflow: "hidden" },
                r = [
                  T("div", {
                    key: "replay",
                    "data-link": "ture",
                    className:
                      "replay-button style__video-buttom___2mMcP style__replay-buttom___3-axl",
                    ref: c,
                  }),
                  T("div", {
                    key: "pause",
                    "data-link": "ture",
                    className:
                      "pause-button style__video-buttom___2mMcP style__pause-buttom___3stBv",
                    ref: p,
                  }),
                  T("div", {
                    key: "play",
                    "data-link": "ture",
                    className:
                      "play-button style__video-buttom___2mMcP style__play-buttom___1YaPT",
                    ref: u,
                  }),
                ],
                i =
                  e.foregroundVideoPlayType === I.y.loop ||
                  ((e.foregroundVideoPlayType === I.y.once ||
                    e.foregroundVideoPlayType === I.y.replayWhenRevisible) &&
                    h === I.z.carousel),
                l = T(
                  "div",
                  {
                    "data-video": e.foregroundVideoPlayType,
                    className: d()(
                      "media-video".concat(x ? " parallax-fore-video" : ""),
                      P,
                      {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      },
                    ),
                  },
                  e.foregroundVideoPlayType === I.y.withController &&
                    T("div", {
                      style: {
                        backgroundImage: "url(".concat(
                          e.foregroundVideoPoster,
                          ")",
                        ),
                      },
                      className: "style__card-fore-video-poster___1GTJx",
                    }),
                  T(
                    "video",
                    Object(o.a)({ style: n, ref: s, muted: !0 }, t, {
                      loop: e.foregroundVideoPlayType === I.y.loop,
                    }),
                    e.foregroundVideoWebm &&
                      T("source", {
                        type: "video/webm",
                        "data-layzr-src": e.foregroundVideoWebm,
                      }),
                    T("source", {
                      type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                      "data-layzr-src": e.foregroundVideo,
                    }),
                  ),
                  x ? null : r,
                ),
                f = T(
                  m.a,
                  {
                    style: {
                      height: !g || x ? "100%" : "",
                      width: !g || x ? "100%" : "",
                    },
                    replayWhenRevisible:
                      e.foregroundVideoPlayType !== I.y.once &&
                      e.foregroundVideoPlayType !== I.y.withController,
                    visiblePlay:
                      e.foregroundVideoPlayType !== I.y.withController,
                    lazyLoad: !0,
                    lazyLoadThreshold: 2e3,
                    replayClassName: i ? "" : "replay-button",
                    pauseClassName:
                      e.foregroundVideoPlayType === I.y.withController
                        ? "pause-button"
                        : "",
                    playClassName:
                      e.foregroundVideoPlayType === I.y.withController
                        ? "play-button"
                        : "",
                  },
                  x
                    ? T(
                        S.a,
                        {
                          offset: "-100",
                          style: {
                            height: "calc(100% + 100px)",
                            marginTop: "-100px",
                          },
                        },
                        l,
                      )
                    : l,
                  x ? r : null,
                ),
                b = T(y.a, {
                  visibleByDefault: a,
                  parallax: x,
                  type: x ? "bg" : "img",
                  src: e.foregroundImage,
                  alt: Object(k.w)(e.foregroundImageAlt),
                  style: {
                    borderRadius: e.mediaBorderRadius,
                    overflow: "hidden",
                  },
                  className: d()(
                    "media-pic".concat(x ? " parallax-fore-pic" : ""),
                    P,
                    {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    },
                  ),
                });
              return (
                e.zoomSwitch &&
                  (b = T(
                    j.c,
                    { isInAtom: !0, component_data: M({}, e) },
                    T(
                      "div",
                      { className: "style__media-zoom-wrapper___mUYDF" },
                      b,
                      e.foregroundSticker &&
                        T(y.a, {
                          className: "style__media-sticker___2vBF1",
                          visibleByDefault: a,
                          type: "img",
                          src: e.foregroundSticker,
                        }),
                    ),
                  )),
                e.media === I.e.picture ? b : f
              );
            },
            E = Object(_.a)(
              Object(_.a)(
                Object(_.a)(
                  Object(_.a)(
                    Object(_.a)(
                      Object(_.a)({}, I.j.one, C(e)),
                      I.j.leftRight,
                      T(
                        "div",
                        {
                          className:
                            "style__card-media-multi___1_28d style__card-media-multi-leftRight___awTbn",
                        },
                        i.map(function (t, n) {
                          var o =
                            e.foregroundListGap && n !== i.length - 1
                              ? { marginRight: e.foregroundListGap }
                              : {};
                          return T(
                            "div",
                            {
                              className:
                                "style__card-media-part___3Rnlj style__card-media-item___1tEYL",
                              style: o,
                            },
                            C(t),
                          );
                        }),
                      ),
                    ),
                    I.j.upDown,
                    T(
                      "div",
                      {
                        className:
                          "style__card-media-multi___1_28d style__card-media-multi-updown___XkNiM",
                      },
                      i.map(function (t, n) {
                        var o =
                          e.foregroundListGap && n !== i.length - 1
                            ? { marginBottom: e.foregroundListGap }
                            : {};
                        return T(
                          "div",
                          {
                            className:
                              "style__card-media-part___3Rnlj style__card-media-item___1tEYL",
                            style: o,
                          },
                          C(t),
                        );
                      }),
                    ),
                  ),
                  I.j.left2right1,
                  T(
                    "div",
                    {
                      className:
                        "style__card-media-multi___1_28d style__card-media-multi-left2right1___cYtEd",
                    },
                    T(
                      "div",
                      {
                        className: "style__card-media-part___3Rnlj",
                        style: { marginRight: e.foregroundListGap },
                      },
                      T(
                        "div",
                        {
                          className: "style__card-media-item___1tEYL",
                          style: { marginBottom: e.foregroundListGap },
                        },
                        C(i[0]),
                      ),
                      T(
                        "div",
                        { className: "style__card-media-item___1tEYL" },
                        C(i[1]),
                      ),
                    ),
                    T(
                      "div",
                      { className: "style__card-media-part___3Rnlj" },
                      T(
                        "div",
                        { className: "style__card-media-item___1tEYL" },
                        C(i[2]),
                      ),
                    ),
                  ),
                ),
                I.j.up1down2,
                T(
                  "div",
                  {
                    className:
                      "style__card-media-multi___1_28d style__card-media-multi-up1down2___6dU4Q",
                  },
                  T(
                    "div",
                    {
                      className: "style__card-media-part___3Rnlj",
                      style: { marginBottom: e.foregroundListGap },
                    },
                    T(
                      "div",
                      { className: "style__card-media-item___1tEYL" },
                      C(i[0]),
                    ),
                  ),
                  T(
                    "div",
                    { className: "style__card-media-part___3Rnlj" },
                    T(
                      "div",
                      {
                        className: "style__card-media-item___1tEYL",
                        style: { marginRight: e.foregroundListGap },
                      },
                      C(i[1]),
                    ),
                    T(
                      "div",
                      { className: "style__card-media-item___1tEYL" },
                      C(i[2]),
                    ),
                  ),
                ),
              ),
              I.j.up2down1,
              T(
                "div",
                {
                  className:
                    "style__card-media-multi___1_28d style__card-media-multi-up2down1___2t2N0",
                  style: { flexDirection: "column" },
                },
                T(
                  "div",
                  {
                    className: "style__card-media-part___3Rnlj",
                    style: { marginBottom: e.foregroundListGap },
                  },
                  T(
                    "div",
                    {
                      className: "style__card-media-item___1tEYL",
                      style: { marginRight: e.foregroundListGap },
                    },
                    C(i[0]),
                  ),
                  T(
                    "div",
                    { className: "style__card-media-item___1tEYL" },
                    C(i[1]),
                  ),
                ),
                T(
                  "div",
                  { className: "style__card-media-part___3Rnlj" },
                  T(
                    "div",
                    { className: "style__card-media-item___1tEYL" },
                    C(i[2]),
                  ),
                ),
              ),
            )[e.foregroundLayout],
            L =
              !(e.cardLayout === I.d["media-text"] && "12" === r) &&
              !(e.cardLayout === I.d["text-media"] && "0" === r),
            B = {};
          (B =
            "100%" === e.foregroundHeight
              ? { "align-self": "stretch" }
              : { height: e.foregroundHeight }),
            (B = x ? B : {});
          var N = e.cardLayout === I.d["media-text"] ? "".concat(b, "px") : v;
          return (
            (N = L ? N : "100%"),
            T(
              "div",
              {
                key: "media",
                "data-aos": f || n,
                "data-aos-once": !0,
                className: "style__card-media___AnYZC",
                style: M(
                  M({}, B),
                  {},
                  {
                    width: N,
                    marginRight:
                      e.cardLayout === I.d["media-text"] ? e.mediaDistance : "",
                    borderRadius: e.mediaBorderRadius,
                    overflow: w ? "visible" : "hidden",
                  },
                ),
              },
              T(
                "a",
                {
                  style: { display: "contents" },
                  href: null === l || void 0 === l ? void 0 : l.url,
                  target: null === l || void 0 === l ? void 0 : l.target,
                  "data-ga-label":
                    null === l || void 0 === l ? void 0 : l.gaLabel,
                },
                w ? T(S.a, { offset: "-50" }, E) : E,
              ),
            )
          );
        }),
        L = f.a.createElement,
        B = {
          "./style.css": {
            "card-link-container": "style__card-link-container___17v88",
            "card-container": "style__card-container___3mjN3",
            "card-wrapper": "style__card-wrapper___1DqOx",
            "vertical-top-align": "style__vertical-top-align___1s3Hj",
            "vertical-center-align": "style__vertical-center-align___3mf-F",
            "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
            "card-background-video": "style__card-background-video___1108n",
            "video-mask": "style__video-mask___3Z49h",
            "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
            "card-content": "style__card-content___vH0I2",
            "horizontal-left-align": "style__horizontal-left-align___1piH2",
            "horizontal-right-align": "style__horizontal-right-align___1k3dg",
            "tag-container": "style__tag-container___1t87X",
            "tag-content": "style__tag-content___2sjEO",
            eyebrow: "style__eyebrow___3767l",
            headline: "style__headline___1GB_U",
            subhead: "style__subhead___1-icl",
            description: "style__description___37V2m",
            note: "style__note___JDE7h",
            "icon-pic": "style__icon-pic___3-zqP",
            "topping-img": "style__topping-img___2_zBh",
            divider: "style__divider___k3dpz",
            "download-buttons-container":
              "style__download-buttons-container___25rLz",
            "icons-container": "style__icons-container___2fJmw",
            "icon-number-container": "style__icon-number-container___22BrE",
            "horizontal-center-align": "style__horizontal-center-align___3ggDc",
            "content-text-color-black":
              "style__content-text-color-black___38P05",
            "icon-title": "style__icon-title___bGMXt",
            "icon-desc": "style__icon-desc___1CQub",
            "content-text-color-white":
              "style__content-text-color-white___2nplh",
            "credit-wrapper": "style__credit-wrapper___31b8l",
            "credit-container": "style__credit-container___3BA6K",
            "credit-content": "style__credit-content___xOkfI",
            "size-xxxxxl": "style__size-xxxxxl___1VAz7",
            "connect-pic": "style__connect-pic___MDMRC",
            "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
            link: "style__link___36f7n",
            "card-icons-container": "style__card-icons-container___2FX2x",
            "card-icon-container": "style__card-icon-container___F6BCn",
            "icon-number": "style__icon-number___22dek",
            "icon-unit": "style__icon-unit___3iS0V",
            "size-xxxxl": "style__size-xxxxl___1FO2n",
            "size-xxxl": "style__size-xxxl___1Y--4",
            "size-xxl": "style__size-xxl___cbKEg",
            "size-xl": "style__size-xl___cmT-W",
            "size-l": "style__size-l___3xNLm",
            "size-m": "style__size-m___3_02b",
            "size-s": "style__size-s___2Qc-8",
            "size-xs": "style__size-xs___DThSi",
            "size-xxs": "style__size-xxs___10O36",
            "visual-hidden": "style__visual-hidden___2tPnU",
            "divider-container": "style__divider-container___3AxY_",
            "price-container": "style__price-container___sPpJJ",
            "real-price": "style__real-price___2CYaY",
            "origin-price": "style__origin-price___2TUsS",
            "buttons-container": "style__buttons-container___3cR_a",
            "button-wrapper": "style__button-wrapper___2sw2O",
            "button-inner": "style__button-inner___2d6iZ",
            "button-video-play": "style__button-video-play___usCnv",
            "zoom-button": "style__zoom-button___1HyFB",
            "video-play": "style__video-play___cjJlz",
            "video-play-light": "style__video-play-light___1T1v8",
            "video-play-dark": "style__video-play-dark___3PmPb",
            download: "style__download___2hSKC",
            "download-google-play": "style__download-google-play___1HiCP",
            "links-container": "style__links-container___1gH9d",
            horizontal: "style__horizontal___1K_GU",
            part: "style__part___eEtb1",
            left: "style__left___2NDSB",
            right: "style__right___2g_dT",
            "card-media": "style__card-media___AnYZC",
            "card-media-multi": "style__card-media-multi___1_28d",
            "card-media-multi-leftRight":
              "style__card-media-multi-leftRight___awTbn",
            "card-media-part": "style__card-media-part___3Rnlj",
            "card-media-multi-left2right1":
              "style__card-media-multi-left2right1___cYtEd",
            "card-media-item": "style__card-media-item___1tEYL",
            "card-media-multi-up1down2":
              "style__card-media-multi-up1down2___6dU4Q",
            "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
            "card-media-multi-up2down1":
              "style__card-media-multi-up2down1___2t2N0",
            "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
            "media-pic": "style__media-pic___3hS5Q",
            "media-sticker": "style__media-sticker___2vBF1",
            "media-video": "style__media-video___3Q0jo",
            "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
            "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
            "video-buttom": "style__video-buttom___2mMcP",
            "replay-buttom": "style__replay-buttom___3-axl",
            "play-buttom": "style__play-buttom___1YaPT",
            "pause-buttom": "style__pause-buttom___3stBv",
            "parallax-fore-video": "style__parallax-fore-video___3RGrL",
            "has-media-screen": "style__has-media-screen___2M2eq",
            "media-screen-1440": "style__media-screen-1440___3gmu4",
            "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
            "media-screen-1600": "style__media-screen-1600___2pukG",
          },
        },
        N = function (e) {
          var t = e.aosFade,
            n = e.isIE,
            o = "eyebrow ".concat(e.hasToppingImage ? "connect-pic" : "");
          if (e.eyeBrowType === I.i.svg) {
            var a = L("h1", {
              key: "text",
              className: "style__visual-hidden___2tPnU",
              dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
            });
            if (null === e || void 0 === e ? void 0 : e.eyeBrowTag)
              a = L(b.e, {
                tagType: e.eyeBrowTag,
                key: "text",
                className: "style__visual-hidden___2tPnU",
                dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
              });
            else
              switch (e.headlineLevel) {
                case I.l.h1:
                  a = L("h1", {
                    key: "text",
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                  });
                  break;
                case I.l.h2:
                  a = L("h2", {
                    key: "text",
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                  });
                  break;
                case I.l.h3:
                  a = L("h3", {
                    key: "text",
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                  });
                  break;
                case I.l.h4:
                  a = L("h4", {
                    key: "text",
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                  });
                  break;
                case I.l.p:
                  a = L("p", {
                    key: "text",
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                  });
                  break;
                default:
                  a = L("h1", {
                    key: "text",
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                  });
              }
            return L(
              f.a.Fragment,
              null,
              L("img", {
                key: "img",
                "data-aos": t,
                "data-aos-once": !0,
                alt: Object(k.w)(e.eyeBrowText || ""),
                src: e.eyeBrowSVG,
                style: { height: e.eyeBrowSVGHeight },
                className: d()(o, B, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
              }),
              a,
            );
          }
          var r = {
            fontWeight:
              e.eyeBrowFontWeight && b.c[e.eyeBrowFontWeight]
                ? b.c[e.eyeBrowFontWeight]
                : void 0,
            fontSize: e.eyeBrowFontSize,
            lineHeight: Object(b.a)(e.eyeBrowFontSize, e.eyeBrowLineHeight),
          };
          e.eyeBrowType === I.i["pure-text"]
            ? (r.color = e.eyeBrowPureColor)
            : n
              ? (r.color = e.eyeBrowIEGradientColor)
              : ((r.color = "transparent"),
                (r.backgroundImage = e.eyeBrowGradientColor),
                (r.WebkitBackgroundClip = "text"),
                (r.paddingBottom = "0.1em"),
                (r.marginBottom = "-0.1em"));
          var i = Object(k.kb)(
            e.eyeBrowFontSize,
            "text-ms-".concat(Object(k.mb)(e.eyeBrowFontSize)),
            "",
          );
          if (null === e || void 0 === e ? void 0 : e.eyeBrowTag)
            return L(b.e, {
              tagType: e.eyeBrowTag,
              "data-aos": t,
              "data-aos-once": !0,
              style: r,
              dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
              className:
                (i ? i + " " : "") +
                d()(o, B, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
            });
          switch (e.headlineLevel) {
            case I.l.h1:
              return L("h1", {
                "data-aos": t,
                "data-aos-once": !0,
                style: r,
                dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                className:
                  (i ? i + " " : "") +
                  d()(o, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
            case I.l.h2:
              return L("h2", {
                "data-aos": t,
                "data-aos-once": !0,
                style: r,
                dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                className:
                  (i ? i + " " : "") +
                  d()(o, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
            case I.l.h3:
              return L("h3", {
                "data-aos": t,
                "data-aos-once": !0,
                style: r,
                dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                className:
                  (i ? i + " " : "") +
                  d()(o, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
            case I.l.h4:
              return L("h4", {
                "data-aos": t,
                "data-aos-once": !0,
                style: r,
                dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                className:
                  (i ? i + " " : "") +
                  d()(o, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
            case I.l.p:
              return L("p", {
                "data-aos": t,
                "data-aos-once": !0,
                style: r,
                dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                className:
                  (i ? i + " " : "") +
                  d()(o, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
            default:
              return L("h1", {
                "data-aos": t,
                "data-aos-once": !0,
                style: r,
                dangerouslySetInnerHTML: { __html: e.eyeBrowText || "" },
                className:
                  (i ? i + " " : "") +
                  d()(o, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
          }
        },
        D = f.a.createElement,
        z = {
          "./style.css": {
            "card-link-container": "style__card-link-container___17v88",
            "card-container": "style__card-container___3mjN3",
            "card-wrapper": "style__card-wrapper___1DqOx",
            "vertical-top-align": "style__vertical-top-align___1s3Hj",
            "vertical-center-align": "style__vertical-center-align___3mf-F",
            "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
            "card-background-video": "style__card-background-video___1108n",
            "video-mask": "style__video-mask___3Z49h",
            "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
            "card-content": "style__card-content___vH0I2",
            "horizontal-left-align": "style__horizontal-left-align___1piH2",
            "horizontal-right-align": "style__horizontal-right-align___1k3dg",
            "tag-container": "style__tag-container___1t87X",
            "tag-content": "style__tag-content___2sjEO",
            eyebrow: "style__eyebrow___3767l",
            headline: "style__headline___1GB_U",
            subhead: "style__subhead___1-icl",
            description: "style__description___37V2m",
            note: "style__note___JDE7h",
            "icon-pic": "style__icon-pic___3-zqP",
            "topping-img": "style__topping-img___2_zBh",
            divider: "style__divider___k3dpz",
            "download-buttons-container":
              "style__download-buttons-container___25rLz",
            "icons-container": "style__icons-container___2fJmw",
            "icon-number-container": "style__icon-number-container___22BrE",
            "horizontal-center-align": "style__horizontal-center-align___3ggDc",
            "content-text-color-black":
              "style__content-text-color-black___38P05",
            "icon-title": "style__icon-title___bGMXt",
            "icon-desc": "style__icon-desc___1CQub",
            "content-text-color-white":
              "style__content-text-color-white___2nplh",
            "credit-wrapper": "style__credit-wrapper___31b8l",
            "credit-container": "style__credit-container___3BA6K",
            "credit-content": "style__credit-content___xOkfI",
            "size-xxxxxl": "style__size-xxxxxl___1VAz7",
            "connect-pic": "style__connect-pic___MDMRC",
            "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
            link: "style__link___36f7n",
            "card-icons-container": "style__card-icons-container___2FX2x",
            "card-icon-container": "style__card-icon-container___F6BCn",
            "icon-number": "style__icon-number___22dek",
            "icon-unit": "style__icon-unit___3iS0V",
            "size-xxxxl": "style__size-xxxxl___1FO2n",
            "size-xxxl": "style__size-xxxl___1Y--4",
            "size-xxl": "style__size-xxl___cbKEg",
            "size-xl": "style__size-xl___cmT-W",
            "size-l": "style__size-l___3xNLm",
            "size-m": "style__size-m___3_02b",
            "size-s": "style__size-s___2Qc-8",
            "size-xs": "style__size-xs___DThSi",
            "size-xxs": "style__size-xxs___10O36",
            "visual-hidden": "style__visual-hidden___2tPnU",
            "divider-container": "style__divider-container___3AxY_",
            "price-container": "style__price-container___sPpJJ",
            "real-price": "style__real-price___2CYaY",
            "origin-price": "style__origin-price___2TUsS",
            "buttons-container": "style__buttons-container___3cR_a",
            "button-wrapper": "style__button-wrapper___2sw2O",
            "button-inner": "style__button-inner___2d6iZ",
            "button-video-play": "style__button-video-play___usCnv",
            "zoom-button": "style__zoom-button___1HyFB",
            "video-play": "style__video-play___cjJlz",
            "video-play-light": "style__video-play-light___1T1v8",
            "video-play-dark": "style__video-play-dark___3PmPb",
            download: "style__download___2hSKC",
            "download-google-play": "style__download-google-play___1HiCP",
            "links-container": "style__links-container___1gH9d",
            horizontal: "style__horizontal___1K_GU",
            part: "style__part___eEtb1",
            left: "style__left___2NDSB",
            right: "style__right___2g_dT",
            "card-media": "style__card-media___AnYZC",
            "card-media-multi": "style__card-media-multi___1_28d",
            "card-media-multi-leftRight":
              "style__card-media-multi-leftRight___awTbn",
            "card-media-part": "style__card-media-part___3Rnlj",
            "card-media-multi-left2right1":
              "style__card-media-multi-left2right1___cYtEd",
            "card-media-item": "style__card-media-item___1tEYL",
            "card-media-multi-up1down2":
              "style__card-media-multi-up1down2___6dU4Q",
            "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
            "card-media-multi-up2down1":
              "style__card-media-multi-up2down1___2t2N0",
            "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
            "media-pic": "style__media-pic___3hS5Q",
            "media-sticker": "style__media-sticker___2vBF1",
            "media-video": "style__media-video___3Q0jo",
            "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
            "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
            "video-buttom": "style__video-buttom___2mMcP",
            "replay-buttom": "style__replay-buttom___3-axl",
            "play-buttom": "style__play-buttom___1YaPT",
            "pause-buttom": "style__pause-buttom___3stBv",
            "parallax-fore-video": "style__parallax-fore-video___3RGrL",
            "has-media-screen": "style__has-media-screen___2M2eq",
            "media-screen-1440": "style__media-screen-1440___3gmu4",
            "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
            "media-screen-1600": "style__media-screen-1600___2pukG",
          },
        },
        A = function (e) {
          var t = e.aosFade,
            n = e.isIE,
            o = e.hasToppingImage && !e.hasEyeBrow,
            a = e.hasEyeBrow && e.eyeBrowType === I.i.svg,
            r = e.hasEyeBrow && e.eyeBrowType === I.i["pure-text"],
            i = "headline "
              .concat(o || a ? "connect-pic" : "", " ")
              .concat(r ? "connect-eyebrow-text" : "");
          if (e.headlineType === I.m.svg) {
            var l = D("h2", {
              className: "style__visual-hidden___2tPnU",
              dangerouslySetInnerHTML: { __html: e.headlineText || "" },
            });
            if (null === e || void 0 === e ? void 0 : e.headlineTag)
              l = D(b.e, {
                tagType: e.headlineTag,
                className: "style__visual-hidden___2tPnU",
                dangerouslySetInnerHTML: { __html: e.headlineText || "" },
              });
            else
              switch (e.headlineLevel) {
                case I.l.h1:
                  e.hasEyeBrow &&
                    (l = D("h2", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    })),
                    (l = D("h1", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    }));
                  break;
                case I.l.h2:
                  e.hasEyeBrow &&
                    (l = D("h3", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    })),
                    (l = D("h2", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    }));
                  break;
                case I.l.h3:
                  e.hasEyeBrow &&
                    (l = D("h4", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    })),
                    (l = D("h3", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    }));
                  break;
                case I.l.h4:
                  e.hasEyeBrow &&
                    (l = D("h5", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    })),
                    (l = D("h4", {
                      className: "style__visual-hidden___2tPnU",
                      dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    }));
                  break;
                case I.l.p:
                  l = D("p", {
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                  });
                  break;
                default:
                  l = D("h2", {
                    className: "style__visual-hidden___2tPnU",
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                  });
              }
            return D(
              f.a.Fragment,
              null,
              e.headlineSVG &&
                D("img", {
                  "data-aos": t,
                  "data-aos-once": !0,
                  src: e.headlineSVG,
                  style: { height: e.headlineSVGHeight },
                  alt: Object(k.w)(e.headlineText || ""),
                  className: d()(i, z, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
                }),
              l,
            );
          }
          var s = {
            fontWeight:
              e.headlineFontWeight && b.c[e.headlineFontWeight]
                ? b.c[e.headlineFontWeight]
                : void 0,
            fontSize: e.headlineFontSize,
            lineHeight: Object(b.a)(e.headlineFontSize, e.headlineLineHeight),
          };
          e.headlineType === I.m["pure-text"]
            ? (s.color = e.headlinePureColor)
            : n
              ? (s.color = e.headlineIEGradientColor)
              : ((s.backgroundImage = e.headlineGradientColor),
                (s.WebkitBackgroundClip = "text"),
                (s.color = "transparent"),
                (s.paddingBottom = "0.1em"),
                (s.marginBottom = "-0.1em"));
          var c = Object(k.kb)(
            e.headlineFontSize,
            "text-ms-".concat(Object(k.mb)(e.headlineFontSize)),
            "",
          );
          if (null === e || void 0 === e ? void 0 : e.headlineTag)
            return D(b.e, {
              tagType: e.headlineTag,
              "data-aos": t,
              "data-aos-once": !0,
              style: s,
              dangerouslySetInnerHTML: { __html: e.headlineText || "" },
              className:
                (c ? c + " " : "") +
                d()(i, z, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
            });
          switch (e.headlineLevel) {
            case I.l.h1:
              return e.hasEyeBrow
                ? D("h2", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  })
                : D("h1", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  });
            case I.l.h2:
              return e.hasEyeBrow
                ? D("h3", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  })
                : D("h2", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  });
            case I.l.h3:
              return e.hasEyeBrow
                ? D("h4", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  })
                : D("h3", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  });
            case I.l.h4:
              return e.hasEyeBrow
                ? D("h5", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  })
                : D("h4", {
                    "data-aos": t,
                    "data-aos-once": !0,
                    style: s,
                    dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                    className:
                      (c ? c + " " : "") +
                      d()(i, z, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  });
            case I.l.p:
              return D("p", {
                "data-aos": t,
                "data-aos-once": !0,
                style: s,
                dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                className:
                  (c ? c + " " : "") +
                  d()(i, z, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
            default:
              return D("h2", {
                "data-aos": t,
                "data-aos-once": !0,
                style: s,
                dangerouslySetInnerHTML: { __html: e.headlineText || "" },
                className:
                  (c ? c + " " : "") +
                  d()(i, z, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
              });
          }
        },
        R = f.a.createElement,
        F = function (e) {
          var t = e.aosFade,
            n = e.isIE,
            o = {
              color: e.subHeadlineColor,
              fontWeight:
                e.subHeadlineFontWeight && b.c[e.subHeadlineFontWeight]
                  ? b.c[e.subHeadlineFontWeight]
                  : void 0,
              fontSize: e.subHeadlineFontSize,
              lineHeight: Object(b.a)(
                e.subHeadlineFontSize,
                e.subHeadlineLineHeight,
              ),
            };
          e.subHeadlineType === I.m["gradient-text"]
            ? n
              ? (o.color = e.subHeadlineIEGradientColor)
              : ((o.backgroundImage = e.subHeadlineGradientColor),
                (o.WebkitBackgroundClip = "text"),
                (o.color = "transparent"),
                (o.paddingBottom = "0.1em"),
                (o.marginBottom = "-0.1em"))
            : (o.color = e.subHeadlineColor);
          var a = Object(k.kb)(
            e.subHeadlineFontSize,
            "text-ms-".concat(Object(k.mb)(e.subHeadlineFontSize)),
            "",
          );
          if (null === e || void 0 === e ? void 0 : e.subHeadlineTag)
            return R(b.e, {
              tagType: e.subHeadlineTag,
              "data-aos": t,
              "data-aos-once": !0,
              className: (a ? a + " " : "") + "style__subhead___1-icl",
              style: o,
              dangerouslySetInnerHTML: { __html: e.subHeadlineText || "" },
            });
          switch (e.headlineLevel) {
            case I.l.h1:
              return R("h2", {
                "data-aos": t,
                "data-aos-once": !0,
                className: (a ? a + " " : "") + "style__subhead___1-icl",
                style: o,
                dangerouslySetInnerHTML: { __html: e.subHeadlineText || "" },
              });
            case I.l.h2:
              return R("h3", {
                "data-aos": t,
                "data-aos-once": !0,
                className: (a ? a + " " : "") + "style__subhead___1-icl",
                style: o,
                dangerouslySetInnerHTML: { __html: e.subHeadlineText || "" },
              });
            case I.l.h3:
              return R("h4", {
                "data-aos": t,
                "data-aos-once": !0,
                className: (a ? a + " " : "") + "style__subhead___1-icl",
                style: o,
                dangerouslySetInnerHTML: { __html: e.subHeadlineText || "" },
              });
            case I.l.p:
              return R("p", {
                "data-aos": t,
                "data-aos-once": !0,
                className: (a ? a + " " : "") + "style__subhead___1-icl",
                style: o,
                dangerouslySetInnerHTML: { __html: e.subHeadlineText || "" },
              });
            default:
              return R("h4", {
                "data-aos": t,
                "data-aos-once": !0,
                className: (a ? a + " " : "") + "style__subhead___1-icl",
                style: o,
                dangerouslySetInnerHTML: { __html: e.subHeadlineText || "" },
              });
          }
        },
        V = f.a.createElement,
        H = function (e) {
          var t = e.aosFade,
            n = {
              height: e.dividedLineHeight,
              borderRadius: e.dividedLineRadius,
              width: e.dividedLineWidth,
              backgroundColor: e.dividedLineColor,
              backgroundImage: e.dividedLineGradientColor,
            };
          return V(
            "div",
            {
              "data-aos": t,
              "data-aos-once": !0,
              className: "style__divider-container___3AxY_",
              style: { height: e.dividedBlockHeight },
            },
            V("div", { className: "style__divider___k3dpz", style: n }),
          );
        },
        W = f.a.createElement,
        U = function (e) {
          var t = e.aosFade,
            n = {
              fontWeight:
                e.descriptionFontWeight && b.c[e.descriptionFontWeight]
                  ? b.c[e.descriptionFontWeight]
                  : void 0,
              fontSize: e.descriptionFontSize,
              lineHeight: Object(b.a)(
                e.descriptionFontSize,
                e.descriptionLineHeight,
              ),
              color: e.descriptionColor,
              marginTop: e.hasDividedLine ? "0" : "",
            },
            o = Object(k.kb)(
              e.descriptionFontSize,
              "text-ms-".concat(Object(k.mb)(e.descriptionFontSize)),
              "",
            );
          return W("p", {
            className: (o ? o + " " : "") + "style__description___37V2m",
            "data-aos": t,
            "data-aos-once": !0,
            style: n,
            dangerouslySetInnerHTML: { __html: e.descriptionText || "" },
          });
        },
        G = n("xk4V"),
        Y = n.n(G),
        q = n("cKzW"),
        X = n("S5C5"),
        Z = f.a.createElement,
        K = {
          "./style.css": {
            "card-link-container": "style__card-link-container___17v88",
            "card-container": "style__card-container___3mjN3",
            "card-wrapper": "style__card-wrapper___1DqOx",
            "vertical-top-align": "style__vertical-top-align___1s3Hj",
            "vertical-center-align": "style__vertical-center-align___3mf-F",
            "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
            "card-background-video": "style__card-background-video___1108n",
            "video-mask": "style__video-mask___3Z49h",
            "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
            "card-content": "style__card-content___vH0I2",
            "horizontal-left-align": "style__horizontal-left-align___1piH2",
            "horizontal-right-align": "style__horizontal-right-align___1k3dg",
            "tag-container": "style__tag-container___1t87X",
            "tag-content": "style__tag-content___2sjEO",
            eyebrow: "style__eyebrow___3767l",
            headline: "style__headline___1GB_U",
            subhead: "style__subhead___1-icl",
            description: "style__description___37V2m",
            note: "style__note___JDE7h",
            "icon-pic": "style__icon-pic___3-zqP",
            "topping-img": "style__topping-img___2_zBh",
            divider: "style__divider___k3dpz",
            "download-buttons-container":
              "style__download-buttons-container___25rLz",
            "icons-container": "style__icons-container___2fJmw",
            "icon-number-container": "style__icon-number-container___22BrE",
            "horizontal-center-align": "style__horizontal-center-align___3ggDc",
            "content-text-color-black":
              "style__content-text-color-black___38P05",
            "icon-title": "style__icon-title___bGMXt",
            "icon-desc": "style__icon-desc___1CQub",
            "content-text-color-white":
              "style__content-text-color-white___2nplh",
            "credit-wrapper": "style__credit-wrapper___31b8l",
            "credit-container": "style__credit-container___3BA6K",
            "credit-content": "style__credit-content___xOkfI",
            "size-xxxxxl": "style__size-xxxxxl___1VAz7",
            "connect-pic": "style__connect-pic___MDMRC",
            "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
            link: "style__link___36f7n",
            "card-icons-container": "style__card-icons-container___2FX2x",
            "card-icon-container": "style__card-icon-container___F6BCn",
            "icon-number": "style__icon-number___22dek",
            "icon-unit": "style__icon-unit___3iS0V",
            "size-xxxxl": "style__size-xxxxl___1FO2n",
            "size-xxxl": "style__size-xxxl___1Y--4",
            "size-xxl": "style__size-xxl___cbKEg",
            "size-xl": "style__size-xl___cmT-W",
            "size-l": "style__size-l___3xNLm",
            "size-m": "style__size-m___3_02b",
            "size-s": "style__size-s___2Qc-8",
            "size-xs": "style__size-xs___DThSi",
            "size-xxs": "style__size-xxs___10O36",
            "visual-hidden": "style__visual-hidden___2tPnU",
            "divider-container": "style__divider-container___3AxY_",
            "price-container": "style__price-container___sPpJJ",
            "real-price": "style__real-price___2CYaY",
            "origin-price": "style__origin-price___2TUsS",
            "buttons-container": "style__buttons-container___3cR_a",
            "button-wrapper": "style__button-wrapper___2sw2O",
            "button-inner": "style__button-inner___2d6iZ",
            "button-video-play": "style__button-video-play___usCnv",
            "zoom-button": "style__zoom-button___1HyFB",
            "video-play": "style__video-play___cjJlz",
            "video-play-light": "style__video-play-light___1T1v8",
            "video-play-dark": "style__video-play-dark___3PmPb",
            download: "style__download___2hSKC",
            "download-google-play": "style__download-google-play___1HiCP",
            "links-container": "style__links-container___1gH9d",
            horizontal: "style__horizontal___1K_GU",
            part: "style__part___eEtb1",
            left: "style__left___2NDSB",
            right: "style__right___2g_dT",
            "card-media": "style__card-media___AnYZC",
            "card-media-multi": "style__card-media-multi___1_28d",
            "card-media-multi-leftRight":
              "style__card-media-multi-leftRight___awTbn",
            "card-media-part": "style__card-media-part___3Rnlj",
            "card-media-multi-left2right1":
              "style__card-media-multi-left2right1___cYtEd",
            "card-media-item": "style__card-media-item___1tEYL",
            "card-media-multi-up1down2":
              "style__card-media-multi-up1down2___6dU4Q",
            "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
            "card-media-multi-up2down1":
              "style__card-media-multi-up2down1___2t2N0",
            "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
            "media-pic": "style__media-pic___3hS5Q",
            "media-sticker": "style__media-sticker___2vBF1",
            "media-video": "style__media-video___3Q0jo",
            "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
            "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
            "video-buttom": "style__video-buttom___2mMcP",
            "replay-buttom": "style__replay-buttom___3-axl",
            "play-buttom": "style__play-buttom___1YaPT",
            "pause-buttom": "style__pause-buttom___3stBv",
            "parallax-fore-video": "style__parallax-fore-video___3RGrL",
            "has-media-screen": "style__has-media-screen___2M2eq",
            "media-screen-1440": "style__media-screen-1440___3gmu4",
            "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
            "media-screen-1600": "style__media-screen-1600___2pukG",
          },
        },
        Q = function (e) {
          return Z(
            "svg",
            e,
            Z("path", {
              d: "M11.116 11.961a6.785 6.785 0 0 1-9.135-.403 6.776 6.776 0 0 1 0-9.577c2.648-2.641 6.936-2.641 9.577 0a6.765 6.765 0 0 1 .423 9.115L16 15.116c-.48.485-1.26.485-1.75 0l-3.134-3.155ZM7.385 6.135h2.461a.615.615 0 1 1 0 1.23H7.385v2.462a.615.615 0 0 1-1.23 0V7.365H3.692a.615.615 0 1 1 0-1.23h2.461V3.673a.615.615 0 0 1 1.231 0v2.462Zm3.308 4.557a5.567 5.567 0 0 0 0-7.846 5.567 5.567 0 0 0-7.846 0 5.567 5.567 0 0 0 0 7.846 5.567 5.567 0 0 0 7.846 0Z",
              fill: "#FFF",
              fillRule: "nonzero",
            }),
          );
        };
      Q.defaultProps = {
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var J = function (e) {
        return Z(
          "svg",
          e,
          Z("path", {
            d: "M11.116 11.961a6.785 6.785 0 0 1-9.135-.403 6.776 6.776 0 0 1 0-9.577c2.648-2.641 6.936-2.641 9.577 0a6.765 6.765 0 0 1 .423 9.115L16 15.116c-.48.485-1.26.485-1.75 0l-3.134-3.155ZM7.385 6.135h2.461a.615.615 0 1 1 0 1.23H7.385v2.462a.615.615 0 0 1-1.23 0V7.365H3.692a.615.615 0 1 1 0-1.23h2.461V3.673a.615.615 0 0 1 1.231 0v2.462Zm3.308 4.557a5.567 5.567 0 0 0 0-7.846 5.567 5.567 0 0 0-7.846 0 5.567 5.567 0 0 0 0 7.846 5.567 5.567 0 0 0 7.846 0Z",
            fill: "#262626",
            fillRule: "nonzero",
          }),
        );
      };
      J.defaultProps = {
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var $ = function (e) {
          var t = e.id,
            n = e.localization,
            o = e.aosFade,
            a = function (e, a, r, i, l, s, c, _, u, p, f, m, y, b, v, g) {
              var w = i ? h.b[i] : h.b.primary;
              if (!l) {
                var x = "zoom-button" === u,
                  k = I.h[i] || !1,
                  O = {
                    zoomSwitch: !0,
                    zoomImageRawWidth: f,
                    zoomImageRawHeight: m,
                    zoomTilesUrl: { path: y },
                    zoomDefaultZoomLevel: b,
                    zoomMinZoomLevel: v,
                    zoomMaxZoomLevel: g,
                  },
                  S = "".concat(t, "-info-card-horizontal-").concat(e);
                return Z(
                  "div",
                  {
                    style: { minWidth: c },
                    "data-aos": o,
                    "data-aos-once": !0,
                    className: "style__button-wrapper___2sw2O",
                    key: Y()(),
                  },
                  Z(
                    "div",
                    {
                      style: { width: "100%", display: "inline-flex" },
                      "data-ga-label": e,
                    },
                    x
                      ? Z(
                          j.c,
                          {
                            component_data: O,
                            zoomContainerId: S,
                            style: {
                              display: "block",
                              width: "100%",
                              height: "100%",
                              margin: "0 auto",
                            },
                            needDownload: !1,
                            wrapperProps: { visibleByDefault: !0 },
                          },
                          Z(
                            h.c,
                            {
                              size: s,
                              style: { borderRadius: "60px", width: "100%" },
                              type: w,
                            },
                            Z(
                              "div",
                              {
                                className:
                                  "style__button-inner___2d6iZ style__zoom-button___1HyFB",
                              },
                              Z("span", {
                                dangerouslySetInnerHTML: { __html: a || "" },
                              }),
                              Z(k ? Q : J, null),
                            ),
                          ),
                        )
                      : Z(
                          h.c,
                          {
                            id: p && "".concat(p, "-").concat(u),
                            size: s,
                            href:
                              "store-button" === u
                                ? Object(X.e)(
                                    Object(X.k)({
                                      url: "/where-to-buy",
                                      country:
                                        null === n || void 0 === n
                                          ? void 0
                                          : n.country,
                                      locale:
                                        null === n || void 0 === n
                                          ? void 0
                                          : n.language,
                                    }),
                                    r,
                                    null === n || void 0 === n
                                      ? void 0
                                      : n.country,
                                  )
                                : r,
                            target: _ ? "_blank" : "_self",
                            style: { borderRadius: "60px", width: "100%" },
                            type: w,
                          },
                          Z("div", {
                            className: "style__button-inner___2d6iZ",
                            id: p && "".concat(p, "-").concat(u),
                            dangerouslySetInnerHTML: { __html: a || "" },
                          }),
                        ),
                  ),
                );
              }
              var T = "video-play-light";
              return (
                ("dark" !== i && "primary" !== i && "secondary-light" !== i) ||
                  (T = "video-play-dark"),
                Z(
                  "div",
                  {
                    style: { minWidth: c },
                    "data-aos": o,
                    "data-aos-once": !0,
                    className: "style__button-wrapper___2sw2O",
                    key: Y()(),
                  },
                  Z(
                    "div",
                    {
                      style: { width: "100%", display: "inline-flex" },
                      "data-ga-label": e,
                    },
                    Z(
                      q.a,
                      { link: r, style: { width: "100%" } },
                      Z(
                        h.c,
                        {
                          size: s,
                          style: { borderRadius: "60px", width: "100%" },
                          type: w,
                        },
                        Z(
                          "div",
                          {
                            className: d()(
                              "button-inner button-video-play ".concat(T),
                              K,
                              {
                                autoResolveMultipleImports: !0,
                                handleMissingStyleName: "warn",
                              },
                            ),
                          },
                          Z("span", {
                            dangerouslySetInnerHTML: { __html: a || "" },
                          }),
                          Z("div", { className: "style__video-play___cjJlz" }),
                        ),
                      ),
                    ),
                  ),
                )
              );
            },
            r = function (t, n, o, r, i, l, s, c, _, u, d, p, f, h, m) {
              switch (t) {
                case I.t.button:
                  return a(
                    i || "card-".concat(e.index, "-first-button"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                  );
                case I.v.button:
                  return a(
                    i || "card-".concat(e.index, "-second-button"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                  );
                case I.t["external-button"]:
                  return a(
                    i || "card-".concat(e.index, "-first-button"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                    !0,
                  );
                case I.v["external-button"]:
                  return a(
                    i || "card-".concat(e.index, "-second-button"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                    !0,
                  );
                case I.t["video-play"]:
                  return a(
                    i || "card-".concat(e.index, "-first-video"),
                    r,
                    o,
                    n,
                    !0,
                    l,
                    s,
                  );
                case I.v["video-play"]:
                  return a(
                    i || "card-".concat(e.index, "-second-video"),
                    r,
                    o,
                    n,
                    !0,
                    l,
                    s,
                  );
                case I.v["3Dtype"]:
                case I.v.ARtype:
                  return a(
                    i || "card-".concat(e.index, "-second-button"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                    !1,
                    t,
                    c,
                  );
                case I.t["store-button"]:
                  return a(
                    (i && "".concat(i, "-buy-now")) ||
                      "card-".concat(e.index, "-first-button-buy-now"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                    !0,
                    t,
                  );
                case I.v["store-button"]:
                  return a(
                    (i && "".concat(i, "-buy-now")) ||
                      "card-".concat(e.index, "-second-button-buy-now"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                    !0,
                    t,
                  );
                case I.v["zoom-button"]:
                  return a(
                    i || "card-".concat(e.index, "-").concat(_, "-button"),
                    r,
                    o,
                    n,
                    !1,
                    l,
                    s,
                    !0,
                    t,
                    c,
                    u,
                    d,
                    p,
                    f,
                    h,
                    m,
                  );
                default:
                  return Object(O.c)(e, {
                    gaTextPrefix: i
                      ? "".concat(i, "-")
                      : "card-".concat(e.index, "-second-link-"),
                    linkType: t,
                    linkText: r,
                    link: o,
                  });
              }
            },
            i = e.hasPrimaryButton
              ? r(
                  e.primaryButtonType,
                  e.primaryButtonColor,
                  e.primaryButtonLink || "",
                  e.primaryButtonText || "",
                  e.primaryButtonGaLabel || "",
                  e.primaryButtonSize || h.a["x-large"],
                  e.primaryButtonMinWidth || "",
                )
              : null,
            l = e.hasSecondaryButton
              ? r(
                  e.secondaryButtonType,
                  e.secondaryButtonColor,
                  e.secondaryButtonLink || "",
                  e.secondaryButtonText || "",
                  e.secondaryButtonGaLabel || "",
                  e.secondaryButtonSize || h.a["x-large"],
                  e.secondaryButtonMinWidth || "",
                  e.secondaryButtonClickID || "",
                  "second",
                  e.secondaryButtonZoomImageRawWidth || "",
                  e.secondaryButtonZoomImageRawHeight || "",
                  e.secondaryButtonZoomTilesUrl || "",
                  e.secondaryButtonZoomDefaultZoomLevel || "",
                  e.secondaryButtonZoomMinZoomLevel || "",
                  e.secondaryButtonZoomMaxZoomLevel || "",
                )
              : null,
            s = e.hasThirdlyButton
              ? r(
                  e.thirdlyButtonType,
                  e.thirdlyButtonColor,
                  e.thirdlyButtonLink || "",
                  e.thirdlyButtonText || "",
                  e.thirdlyButtonGaLabel || "",
                  e.thirdlyButtonSize || h.a["x-large"],
                  e.thirdlyButtonMinWidth || "",
                  e.thirdlyButtonClickID || "",
                  "third",
                  e.thirdlyButtonZoomImageRawWidth || "",
                  e.thirdlyButtonZoomImageRawHeight || "",
                  e.thirdlyButtonZoomTilesUrl || "",
                  e.thirdlyButtonZoomDefaultZoomLevel || "",
                  e.thirdlyButtonZoomMinZoomLevel || "",
                  e.thirdlyButtonZoomMaxZoomLevel || "",
                )
              : null;
          return Z(
            f.a.Fragment,
            null,
            e.buttonListTypeColumn
              ? Z(
                  f.a.Fragment,
                  null,
                  Z(
                    "div",
                    { className: "style__buttons-container___3cR_a" },
                    i,
                  ),
                  Z(
                    "div",
                    {
                      className: "style__buttons-container___3cR_a",
                      style: { marginTop: 0 },
                    },
                    l,
                  ),
                  Z(
                    "div",
                    {
                      className: "style__buttons-container___3cR_a",
                      style: { marginTop: 0 },
                    },
                    s,
                  ),
                )
              : Z(
                  "div",
                  { className: "style__buttons-container___3cR_a" },
                  i,
                  l,
                  s,
                ),
          );
        },
        ee = f.a.createElement,
        te = function (e) {
          var t = e.aosFade,
            n = e.hasAppStoreButton
              ? ee(
                  "a",
                  {
                    "data-aos": t,
                    "data-aos-once": !0,
                    href: e.appStoreButtonLink,
                    className: "style__download___2hSKC",
                    key: "appstore",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "data-ga-label":
                      e.appStoreButtonGaLabel ||
                      "card-".concat(e.index, "-download-app"),
                  },
                  ee("img", {
                    src: "https://www1.djicdn.com/dps/d8962a855592fbdcfd989cb52866de8f.svg",
                    alt: "",
                  }),
                )
              : null,
            o = e.hasGooglePlayButton
              ? ee(
                  "a",
                  {
                    "data-aos": t,
                    "data-aos-once": !0,
                    href: e.googlePlayButtonLink,
                    className:
                      "style__download___2hSKC style__download-google-play___1HiCP",
                    key: "googleplay",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "data-ga-label":
                      e.googlePlayButtonGaLabel ||
                      "card-".concat(e.index, "-download-google"),
                  },
                  ee("img", {
                    src: "https://www1.djicdn.com/dps/4f1fabc4e78d0217098d38575a06f60a.svg",
                    alt: "",
                  }),
                )
              : null,
            a = e.hasAndroidButton
              ? ee(
                  "a",
                  {
                    "data-aos": t,
                    "data-aos-once": !0,
                    href: e.androidButtonLink,
                    className: "style__download___2hSKC",
                    key: "android",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "data-ga-label":
                      e.androidButtonGaLabel ||
                      "card-".concat(e.index, "-download-android"),
                  },
                  ee("img", {
                    src: "https://www1.djicdn.com/dps/e7b4e2a27522cb29c514ffc403fc781b.svg",
                    alt: "",
                  }),
                )
              : null;
          return ee(
            "div",
            { className: "style__download-buttons-container___25rLz" },
            [n, a, o],
          );
        },
        ne = f.a.createElement;
      function oe(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function ae(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? oe(Object(n), !0).forEach(function (t) {
                Object(_.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : oe(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var re = function (e) {
          return ne(w.l, {
            contentType: "F",
            lightThemeOn: e.modalBtnIsLightTheme,
            modalContent: {
              modalBtnContentTopImage: e.modalBtnContentTopImage,
              modalBtnContentTopImageHeight: e.modalBtnContentTopImageHeight,
              modalBtnContentList: e.modalBtnContentList,
              modal_OpenBtnFText: e.modalBtnText,
            },
            translateOff: !0,
            isMobile: !1,
            containerClassname: "info-card-horizontal-modal-container",
            contentStyle: { padding: 0 },
            btnStyle: ae(
              {
                fontSize: e.modalBtnFontSize || "16px",
                letterSpacing: "-0.02em",
                height: e.modalBtnHeight || "40px",
                display: "inline-flex",
                alignItems: "center",
                boxShadow: "none",
                background: "none",
                paddingLeft: "16px",
                paddingRight: "16px",
                paddingTop: e.modalBtnPaddingY || "8px",
                paddingBottom: e.modalBtnPaddingY || "8px",
              },
              e.modalBtnMarginTop ? { marginTop: e.modalBtnMarginTop } : {},
            ),
            gaSend: e.gaSend,
            gaLabel: e.modalBtnGaLabel,
          });
        },
        ie = f.a.createElement,
        le = function (e) {
          return ie(
            "div",
            { className: "style__links-container___1gH9d" },
            e.links &&
              e.links.map(function (t, n) {
                var o = (null === t || void 0 === t ? void 0 : t.linkGaLabel)
                  ? "".concat(t.linkGaLabel, "-")
                  : "card-".concat(e.index, "-link-").concat(n, "-link-");
                return Object(O.c)(e, {
                  gaTextPrefix: o,
                  linkType: t.linkType,
                  linkText: t.linkText,
                  link: t.text,
                });
              }),
          );
        },
        se = f.a.createElement,
        ce = function (e) {
          var t = e.aosFade,
            n = {
              fontWeight:
                e.noteFontWeight && b.c[e.noteFontWeight]
                  ? b.c[e.noteFontWeight]
                  : void 0,
              fontSize: e.noteFontSize,
              lineHeight: Object(b.a)(e.noteFontSize, e.noteLineHeight),
              color: e.noteColor,
              marginTop: e.noteMarginTop || void 0,
            },
            o = Object(k.kb)(
              e.noteFontSize,
              "text-ms-".concat(Object(k.mb)(e.noteFontSize)),
              "",
            );
          return se("p", {
            className: (o ? o + " " : "") + "style__note___JDE7h",
            "data-aos": t,
            "data-aos-once": !0,
            style: n,
            dangerouslySetInnerHTML: { __html: e.noteText || "" },
          });
        },
        _e = f.a.createElement,
        ue = {
          "./style.css": {
            "card-link-container": "style__card-link-container___17v88",
            "card-container": "style__card-container___3mjN3",
            "card-wrapper": "style__card-wrapper___1DqOx",
            "vertical-top-align": "style__vertical-top-align___1s3Hj",
            "vertical-center-align": "style__vertical-center-align___3mf-F",
            "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
            "card-background-video": "style__card-background-video___1108n",
            "video-mask": "style__video-mask___3Z49h",
            "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
            "card-content": "style__card-content___vH0I2",
            "horizontal-left-align": "style__horizontal-left-align___1piH2",
            "horizontal-right-align": "style__horizontal-right-align___1k3dg",
            "tag-container": "style__tag-container___1t87X",
            "tag-content": "style__tag-content___2sjEO",
            eyebrow: "style__eyebrow___3767l",
            headline: "style__headline___1GB_U",
            subhead: "style__subhead___1-icl",
            description: "style__description___37V2m",
            note: "style__note___JDE7h",
            "icon-pic": "style__icon-pic___3-zqP",
            "topping-img": "style__topping-img___2_zBh",
            divider: "style__divider___k3dpz",
            "download-buttons-container":
              "style__download-buttons-container___25rLz",
            "icons-container": "style__icons-container___2fJmw",
            "icon-number-container": "style__icon-number-container___22BrE",
            "horizontal-center-align": "style__horizontal-center-align___3ggDc",
            "content-text-color-black":
              "style__content-text-color-black___38P05",
            "icon-title": "style__icon-title___bGMXt",
            "icon-desc": "style__icon-desc___1CQub",
            "content-text-color-white":
              "style__content-text-color-white___2nplh",
            "credit-wrapper": "style__credit-wrapper___31b8l",
            "credit-container": "style__credit-container___3BA6K",
            "credit-content": "style__credit-content___xOkfI",
            "size-xxxxxl": "style__size-xxxxxl___1VAz7",
            "connect-pic": "style__connect-pic___MDMRC",
            "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
            link: "style__link___36f7n",
            "card-icons-container": "style__card-icons-container___2FX2x",
            "card-icon-container": "style__card-icon-container___F6BCn",
            "icon-number": "style__icon-number___22dek",
            "icon-unit": "style__icon-unit___3iS0V",
            "size-xxxxl": "style__size-xxxxl___1FO2n",
            "size-xxxl": "style__size-xxxl___1Y--4",
            "size-xxl": "style__size-xxl___cbKEg",
            "size-xl": "style__size-xl___cmT-W",
            "size-l": "style__size-l___3xNLm",
            "size-m": "style__size-m___3_02b",
            "size-s": "style__size-s___2Qc-8",
            "size-xs": "style__size-xs___DThSi",
            "size-xxs": "style__size-xxs___10O36",
            "visual-hidden": "style__visual-hidden___2tPnU",
            "divider-container": "style__divider-container___3AxY_",
            "price-container": "style__price-container___sPpJJ",
            "real-price": "style__real-price___2CYaY",
            "origin-price": "style__origin-price___2TUsS",
            "buttons-container": "style__buttons-container___3cR_a",
            "button-wrapper": "style__button-wrapper___2sw2O",
            "button-inner": "style__button-inner___2d6iZ",
            "button-video-play": "style__button-video-play___usCnv",
            "zoom-button": "style__zoom-button___1HyFB",
            "video-play": "style__video-play___cjJlz",
            "video-play-light": "style__video-play-light___1T1v8",
            "video-play-dark": "style__video-play-dark___3PmPb",
            download: "style__download___2hSKC",
            "download-google-play": "style__download-google-play___1HiCP",
            "links-container": "style__links-container___1gH9d",
            horizontal: "style__horizontal___1K_GU",
            part: "style__part___eEtb1",
            left: "style__left___2NDSB",
            right: "style__right___2g_dT",
            "card-media": "style__card-media___AnYZC",
            "card-media-multi": "style__card-media-multi___1_28d",
            "card-media-multi-leftRight":
              "style__card-media-multi-leftRight___awTbn",
            "card-media-part": "style__card-media-part___3Rnlj",
            "card-media-multi-left2right1":
              "style__card-media-multi-left2right1___cYtEd",
            "card-media-item": "style__card-media-item___1tEYL",
            "card-media-multi-up1down2":
              "style__card-media-multi-up1down2___6dU4Q",
            "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
            "card-media-multi-up2down1":
              "style__card-media-multi-up2down1___2t2N0",
            "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
            "media-pic": "style__media-pic___3hS5Q",
            "media-sticker": "style__media-sticker___2vBF1",
            "media-video": "style__media-video___3Q0jo",
            "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
            "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
            "video-buttom": "style__video-buttom___2mMcP",
            "replay-buttom": "style__replay-buttom___3-axl",
            "play-buttom": "style__play-buttom___1YaPT",
            "pause-buttom": "style__pause-buttom___3stBv",
            "parallax-fore-video": "style__parallax-fore-video___3RGrL",
            "has-media-screen": "style__has-media-screen___2M2eq",
            "media-screen-1440": "style__media-screen-1440___3gmu4",
            "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
            "media-screen-1600": "style__media-screen-1600___2pukG",
          },
        },
        de = function (e) {
          var t = e.aosFade,
            n = function (n, o, a, r, i) {
              return _e(
                "div",
                { className: "style__icons-container___2fJmw" },
                n.map(function (n) {
                  return (function (n, o, a, r, i) {
                    var l =
                        n.hasNumber || n.hasUnit
                          ? _e(
                              "div",
                              {
                                className:
                                  "style__icon-number-container___22BrE",
                              },
                              n.hasNumber
                                ? _e("span", {
                                    key: "number",
                                    className: "style__icon-number___22dek",
                                    style: { color: n.titleColor },
                                    dangerouslySetInnerHTML: {
                                      __html: n.number || "",
                                    },
                                  })
                                : null,
                              n.hasUnit
                                ? _e("span", {
                                    key: "unit",
                                    className: "style__icon-unit___3iS0V",
                                    style: { color: n.titleColor },
                                    dangerouslySetInnerHTML: {
                                      __html: n.unit || "",
                                    },
                                  })
                                : null,
                            )
                          : null,
                      s = Object(k.w)(
                        n.iconAlt ||
                          (n.hasTitle && n.title) ||
                          (n.hasDesc && n.desc) ||
                          "",
                      ),
                      c =
                        n.hasPic && n.pic
                          ? _e(y.a, {
                              visibleByDefault: e.visibleByDefault,
                              alt: s,
                              type: "img",
                              key: "pic",
                              src: n.pic,
                              className: "style__icon-pic___3-zqP",
                              style: { height: a },
                            })
                          : null,
                      _ = {
                        color: n.titleColor,
                        fontWeight:
                          n.titleFontWeight && b.c[n.titleFontWeight]
                            ? b.c[n.titleFontWeight]
                            : void 0,
                        fontSize: n.titleFontSize,
                        lineHeight: Object(b.a)(
                          n.titleFontSize,
                          n.titleLineHeight,
                        ),
                      },
                      u = {
                        color: n.descColor,
                        fontWeight:
                          n.descFontWeight && b.c[n.descFontWeight]
                            ? b.c[n.descFontWeight]
                            : void 0,
                        fontSize: n.descFontSize,
                        lineHeight: Object(b.a)(
                          n.descFontSize,
                          n.descLineHeight,
                        ),
                      },
                      p = Object(k.kb)(
                        n.titleFontSize,
                        "text-ms-".concat(Object(k.mb)(n.titleFontSize)),
                        "",
                      ),
                      f = Object(k.kb)(
                        n.descFontSize,
                        "text-ms-".concat(Object(k.mb)(n.descFontSize)),
                        "",
                      ),
                      h = n.hasTitle
                        ? _e("p", {
                            key: "title",
                            className:
                              (p ? p + " " : "") + "style__icon-title___bGMXt",
                            style: _,
                            dangerouslySetInnerHTML: { __html: n.title || "" },
                          })
                        : null,
                      m = n.hasDesc
                        ? _e("p", {
                            key: "desc",
                            className:
                              (f ? f + " " : "") + "style__icon-desc___1CQub",
                            style: u,
                            dangerouslySetInnerHTML: { __html: n.desc || "" },
                          })
                        : null;
                    return _e(
                      "div",
                      {
                        key: Y()(),
                        style: {
                          maxWidth: r === I.o.horizontal ? o : "none",
                          width: i,
                        },
                        "data-aos": t,
                        "data-aos-once": !0,
                        className: d()(
                          "card-icon-container".concat(
                            r === I.o.horizontal ? " horizontal" : "",
                          ),
                          ue,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      r === I.o.horizontal
                        ? [
                            _e(
                              "div",
                              {
                                className:
                                  "style__left___2NDSB style__part___eEtb1",
                                key: "left",
                              },
                              l,
                              c,
                            ),
                            _e(
                              "div",
                              {
                                className:
                                  "style__right___2g_dT style__part___eEtb1",
                                key: "right",
                              },
                              h,
                              m,
                            ),
                          ]
                        : [l, c, h, m],
                    );
                  })(n, o, a, r, i);
                }),
              );
            },
            o =
              e.hasIcons1 &&
              e.icons1 &&
              e.icons1.length > 0 &&
              n(
                e.icons1,
                e.icons1MaxWidth || "",
                e.icons1Height,
                e.icons1Layout,
                e.icons1width,
              ),
            a =
              e.hasIcons2 &&
              e.icons2 &&
              e.icons2.length > 0 &&
              n(
                e.icons2,
                e.icons2MaxWidth || "",
                e.icons2Height,
                e.icons2Layout,
                e.icons2width,
              );
          return _e(
            "div",
            { className: "style__card-icons-container___2FX2x" },
            o,
            a,
          );
        },
        pe = f.a.createElement;
      function fe(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      var he = function (e) {
          var t = e.aosFade,
            n = (function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2
                  ? fe(Object(n), !0).forEach(function (t) {
                      Object(_.a)(e, t, n[t]);
                    })
                  : Object.getOwnPropertyDescriptors
                    ? Object.defineProperties(
                        e,
                        Object.getOwnPropertyDescriptors(n),
                      )
                    : fe(Object(n)).forEach(function (t) {
                        Object.defineProperty(
                          e,
                          t,
                          Object.getOwnPropertyDescriptor(n, t),
                        );
                      });
              }
              return e;
            })(
              {
                minWidth: e.tagWidth,
                height: e.tagHeight,
                backgroundColor: e.tagColor,
                borderRadius: e.tagRadius,
              },
              e.tagTextFont.style || {},
            );
          return pe(
            "div",
            {
              "data-aos": t,
              "data-aos-once": !0,
              className: "style__tag-container___1t87X",
            },
            pe("p", {
              style: n,
              className: "style__tag-content___2sjEO",
              dangerouslySetInnerHTML: { __html: e.tagText || "" },
            }),
          );
        },
        me = n("xVxQ"),
        ye = f.a.createElement,
        be = function (e) {
          var t,
            n,
            o = e.aosFade,
            a = e.commodityEan,
            r = void 0 === a ? "" : a,
            i = Object(p.useState)(!1),
            l = i[0],
            s = i[1],
            c = Object(p.useState)(),
            _ = c[0],
            u = c[1],
            d = null === _ || void 0 === _ ? void 0 : _.has_discount,
            f = null === _ || void 0 === _ ? void 0 : _.original_price;
          return (
            Object(p.useEffect)(function () {
              r &&
                me.a.getInstance().addCallback(function (e) {
                  var t = null === e || void 0 === e ? void 0 : e[r];
                  (null === t || void 0 === t ? void 0 : t.price) &&
                    (null === t || void 0 === t ? void 0 : t.on_sale) &&
                    (u(t), s(!0));
                });
            }, []),
            l && _.price
              ? ye(
                  "div",
                  {
                    "data-aos": o,
                    "data-aos-once": !0,
                    className: "style__price-container___sPpJJ",
                  },
                  ye(
                    "div",
                    { className: "" },
                    ye("div", {
                      style:
                        null === (t = e.priceTextFont) || void 0 === t
                          ? void 0
                          : t.style,
                      className: "style__real-price___2CYaY",
                      dangerouslySetInnerHTML: { __html: _.price },
                    }),
                    d &&
                      f &&
                      ye(
                        "div",
                        {
                          style:
                            null === (n = e.originPriceTextFont) || void 0 === n
                              ? void 0
                              : n.style,
                          className: "style__origin-price___2TUsS",
                        },
                        f,
                      ),
                  ),
                )
              : null
          );
        },
        ve = f.a.createElement,
        ge = {
          "./style.css": {
            "card-link-container": "style__card-link-container___17v88",
            "card-container": "style__card-container___3mjN3",
            "card-wrapper": "style__card-wrapper___1DqOx",
            "vertical-top-align": "style__vertical-top-align___1s3Hj",
            "vertical-center-align": "style__vertical-center-align___3mf-F",
            "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
            "card-background-video": "style__card-background-video___1108n",
            "video-mask": "style__video-mask___3Z49h",
            "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
            "card-content": "style__card-content___vH0I2",
            "horizontal-left-align": "style__horizontal-left-align___1piH2",
            "horizontal-right-align": "style__horizontal-right-align___1k3dg",
            "tag-container": "style__tag-container___1t87X",
            "tag-content": "style__tag-content___2sjEO",
            eyebrow: "style__eyebrow___3767l",
            headline: "style__headline___1GB_U",
            subhead: "style__subhead___1-icl",
            description: "style__description___37V2m",
            note: "style__note___JDE7h",
            "icon-pic": "style__icon-pic___3-zqP",
            "topping-img": "style__topping-img___2_zBh",
            divider: "style__divider___k3dpz",
            "download-buttons-container":
              "style__download-buttons-container___25rLz",
            "icons-container": "style__icons-container___2fJmw",
            "icon-number-container": "style__icon-number-container___22BrE",
            "horizontal-center-align": "style__horizontal-center-align___3ggDc",
            "content-text-color-black":
              "style__content-text-color-black___38P05",
            "icon-title": "style__icon-title___bGMXt",
            "icon-desc": "style__icon-desc___1CQub",
            "content-text-color-white":
              "style__content-text-color-white___2nplh",
            "credit-wrapper": "style__credit-wrapper___31b8l",
            "credit-container": "style__credit-container___3BA6K",
            "credit-content": "style__credit-content___xOkfI",
            "size-xxxxxl": "style__size-xxxxxl___1VAz7",
            "connect-pic": "style__connect-pic___MDMRC",
            "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
            link: "style__link___36f7n",
            "card-icons-container": "style__card-icons-container___2FX2x",
            "card-icon-container": "style__card-icon-container___F6BCn",
            "icon-number": "style__icon-number___22dek",
            "icon-unit": "style__icon-unit___3iS0V",
            "size-xxxxl": "style__size-xxxxl___1FO2n",
            "size-xxxl": "style__size-xxxl___1Y--4",
            "size-xxl": "style__size-xxl___cbKEg",
            "size-xl": "style__size-xl___cmT-W",
            "size-l": "style__size-l___3xNLm",
            "size-m": "style__size-m___3_02b",
            "size-s": "style__size-s___2Qc-8",
            "size-xs": "style__size-xs___DThSi",
            "size-xxs": "style__size-xxs___10O36",
            "visual-hidden": "style__visual-hidden___2tPnU",
            "divider-container": "style__divider-container___3AxY_",
            "price-container": "style__price-container___sPpJJ",
            "real-price": "style__real-price___2CYaY",
            "origin-price": "style__origin-price___2TUsS",
            "buttons-container": "style__buttons-container___3cR_a",
            "button-wrapper": "style__button-wrapper___2sw2O",
            "button-inner": "style__button-inner___2d6iZ",
            "button-video-play": "style__button-video-play___usCnv",
            "zoom-button": "style__zoom-button___1HyFB",
            "video-play": "style__video-play___cjJlz",
            "video-play-light": "style__video-play-light___1T1v8",
            "video-play-dark": "style__video-play-dark___3PmPb",
            download: "style__download___2hSKC",
            "download-google-play": "style__download-google-play___1HiCP",
            "links-container": "style__links-container___1gH9d",
            horizontal: "style__horizontal___1K_GU",
            part: "style__part___eEtb1",
            left: "style__left___2NDSB",
            right: "style__right___2g_dT",
            "card-media": "style__card-media___AnYZC",
            "card-media-multi": "style__card-media-multi___1_28d",
            "card-media-multi-leftRight":
              "style__card-media-multi-leftRight___awTbn",
            "card-media-part": "style__card-media-part___3Rnlj",
            "card-media-multi-left2right1":
              "style__card-media-multi-left2right1___cYtEd",
            "card-media-item": "style__card-media-item___1tEYL",
            "card-media-multi-up1down2":
              "style__card-media-multi-up1down2___6dU4Q",
            "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
            "card-media-multi-up2down1":
              "style__card-media-multi-up2down1___2t2N0",
            "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
            "media-pic": "style__media-pic___3hS5Q",
            "media-sticker": "style__media-sticker___2vBF1",
            "media-video": "style__media-video___3Q0jo",
            "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
            "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
            "video-buttom": "style__video-buttom___2mMcP",
            "replay-buttom": "style__replay-buttom___3-axl",
            "play-buttom": "style__play-buttom___1YaPT",
            "pause-buttom": "style__pause-buttom___3stBv",
            "parallax-fore-video": "style__parallax-fore-video___3RGrL",
            "has-media-screen": "style__has-media-screen___2M2eq",
            "media-screen-1440": "style__media-screen-1440___3gmu4",
            "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
            "media-screen-1600": "style__media-screen-1600___2pukG",
          },
        },
        we = f.a.memo(function (e) {
          var t = e.hasToppingImage,
            n = e.hasEyeBrow,
            a = e.hasHeadline,
            r = e.hasSubHeadline,
            i = e.hasDividedLine,
            l = e.hasDescription,
            s = e.hasPrimaryButton,
            c = e.hasSecondaryButton,
            _ = e.hasThirdlyButton,
            u = e.hasDownloadButton,
            p = e.hasModalButton,
            f = e.hasCardLinks,
            h = e.hasNote,
            m = e.hasIcons1,
            y = e.hasIcons2,
            b = "horizontal-".concat(e.horizontalAlign),
            v = e.getFadeTransiation(),
            g = e.getMediaTransiation(),
            w = Object(k.h)(),
            x = {
              paddingTop: e.contentPaddingTop,
              paddingBottom: e.contentPaddingBottom,
              paddingLeft: e.contentPaddingLeft,
              paddingRight: e.contentPaddingRight,
              marginRight: "",
            };
          e.cardLayout === I.d["text-media"] &&
            (x.marginRight = e.mediaDistance),
            (x.width = e.contentWidth);
          var O = "content-text-color-".concat(e.textColor),
            S = e.hasTag && e.tagText,
            j = e.hasRelatedCommodity && (e.commodityEan || e.commoditySlug),
            T = s || c || _,
            C = m || y;
          return ve(
            "div",
            {
              key: "content",
              style: x,
              className: d()(
                "card-content size-"
                  .concat(e.contentSize, " ")
                  .concat(O, " ")
                  .concat(b),
                ge,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
            },
            t &&
              ve("img", {
                "data-aos": g,
                "data-aos-once": !0,
                src: e.toppingImage,
                className: "style__topping-img___2_zBh",
                style: { height: e.toppingImageHeight },
                alt: e.toppingImage ? Object(k.w)(e.toppingAlt) : "",
              }),
            S && ve(he, Object(o.a)({}, e, { aosFade: v })),
            n && ve(N, Object(o.a)({}, e, { aosFade: v, isIE: w })),
            a && ve(A, Object(o.a)({}, e, { aosFade: v, isIE: w })),
            r && ve(F, Object(o.a)({}, e, { aosFade: v, isIE: w })),
            i && ve(H, Object(o.a)({}, e, { aosFade: v })),
            l && ve(U, Object(o.a)({}, e, { aosFade: v })),
            j && ve(be, Object(o.a)({}, e, { aosFade: v })),
            T && ve($, Object(o.a)({}, e, { aosFade: v })),
            u && ve(te, Object(o.a)({}, e, { aosFade: v })),
            p && ve(re, e),
            f && ve(le, Object(o.a)({}, e, { aosFade: v })),
            h && ve(ce, Object(o.a)({}, e, { aosFade: v })),
            C && ve(de, Object(o.a)({}, e, { aosFade: v })),
          );
        }),
        xe = p.createElement;
      function ke(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function Oe(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? ke(Object(n), !0).forEach(function (t) {
                Object(_.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : ke(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var Ie = {
        "./style.css": {
          "card-link-container": "style__card-link-container___17v88",
          "card-container": "style__card-container___3mjN3",
          "card-wrapper": "style__card-wrapper___1DqOx",
          "vertical-top-align": "style__vertical-top-align___1s3Hj",
          "vertical-center-align": "style__vertical-center-align___3mf-F",
          "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
          "card-background-video": "style__card-background-video___1108n",
          "video-mask": "style__video-mask___3Z49h",
          "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
          "card-content": "style__card-content___vH0I2",
          "horizontal-left-align": "style__horizontal-left-align___1piH2",
          "horizontal-right-align": "style__horizontal-right-align___1k3dg",
          "tag-container": "style__tag-container___1t87X",
          "tag-content": "style__tag-content___2sjEO",
          eyebrow: "style__eyebrow___3767l",
          headline: "style__headline___1GB_U",
          subhead: "style__subhead___1-icl",
          description: "style__description___37V2m",
          note: "style__note___JDE7h",
          "icon-pic": "style__icon-pic___3-zqP",
          "topping-img": "style__topping-img___2_zBh",
          divider: "style__divider___k3dpz",
          "download-buttons-container":
            "style__download-buttons-container___25rLz",
          "icons-container": "style__icons-container___2fJmw",
          "icon-number-container": "style__icon-number-container___22BrE",
          "horizontal-center-align": "style__horizontal-center-align___3ggDc",
          "content-text-color-black": "style__content-text-color-black___38P05",
          "icon-title": "style__icon-title___bGMXt",
          "icon-desc": "style__icon-desc___1CQub",
          "content-text-color-white": "style__content-text-color-white___2nplh",
          "credit-wrapper": "style__credit-wrapper___31b8l",
          "credit-container": "style__credit-container___3BA6K",
          "credit-content": "style__credit-content___xOkfI",
          "size-xxxxxl": "style__size-xxxxxl___1VAz7",
          "connect-pic": "style__connect-pic___MDMRC",
          "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
          link: "style__link___36f7n",
          "card-icons-container": "style__card-icons-container___2FX2x",
          "card-icon-container": "style__card-icon-container___F6BCn",
          "icon-number": "style__icon-number___22dek",
          "icon-unit": "style__icon-unit___3iS0V",
          "size-xxxxl": "style__size-xxxxl___1FO2n",
          "size-xxxl": "style__size-xxxl___1Y--4",
          "size-xxl": "style__size-xxl___cbKEg",
          "size-xl": "style__size-xl___cmT-W",
          "size-l": "style__size-l___3xNLm",
          "size-m": "style__size-m___3_02b",
          "size-s": "style__size-s___2Qc-8",
          "size-xs": "style__size-xs___DThSi",
          "size-xxs": "style__size-xxs___10O36",
          "visual-hidden": "style__visual-hidden___2tPnU",
          "divider-container": "style__divider-container___3AxY_",
          "price-container": "style__price-container___sPpJJ",
          "real-price": "style__real-price___2CYaY",
          "origin-price": "style__origin-price___2TUsS",
          "buttons-container": "style__buttons-container___3cR_a",
          "button-wrapper": "style__button-wrapper___2sw2O",
          "button-inner": "style__button-inner___2d6iZ",
          "button-video-play": "style__button-video-play___usCnv",
          "zoom-button": "style__zoom-button___1HyFB",
          "video-play": "style__video-play___cjJlz",
          "video-play-light": "style__video-play-light___1T1v8",
          "video-play-dark": "style__video-play-dark___3PmPb",
          download: "style__download___2hSKC",
          "download-google-play": "style__download-google-play___1HiCP",
          "links-container": "style__links-container___1gH9d",
          horizontal: "style__horizontal___1K_GU",
          part: "style__part___eEtb1",
          left: "style__left___2NDSB",
          right: "style__right___2g_dT",
          "card-media": "style__card-media___AnYZC",
          "card-media-multi": "style__card-media-multi___1_28d",
          "card-media-multi-leftRight":
            "style__card-media-multi-leftRight___awTbn",
          "card-media-part": "style__card-media-part___3Rnlj",
          "card-media-multi-left2right1":
            "style__card-media-multi-left2right1___cYtEd",
          "card-media-item": "style__card-media-item___1tEYL",
          "card-media-multi-up1down2":
            "style__card-media-multi-up1down2___6dU4Q",
          "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
          "card-media-multi-up2down1":
            "style__card-media-multi-up2down1___2t2N0",
          "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
          "media-pic": "style__media-pic___3hS5Q",
          "media-sticker": "style__media-sticker___2vBF1",
          "media-video": "style__media-video___3Q0jo",
          "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
          "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
          "video-buttom": "style__video-buttom___2mMcP",
          "replay-buttom": "style__replay-buttom___3-axl",
          "play-buttom": "style__play-buttom___1YaPT",
          "pause-buttom": "style__pause-buttom___3stBv",
          "parallax-fore-video": "style__parallax-fore-video___3RGrL",
          "has-media-screen": "style__has-media-screen___2M2eq",
          "media-screen-1440": "style__media-screen-1440___3gmu4",
          "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
          "media-screen-1600": "style__media-screen-1600___2pukG",
        },
      };
      function Se(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var je = (function (e) {
        function t(e) {
          var n;
          return (
            Object(a.default)(this, t),
            (n = Se(this, t, [e])),
            Object(_.a)(Object(s.a)(n), "cardBgVideoDom", void 0),
            Object(_.a)(Object(s.a)(n), "cardForegroundVideo", void 0),
            Object(_.a)(Object(s.a)(n), "cardForegroundVideoReplay", void 0),
            Object(_.a)(Object(s.a)(n), "cardForegroundVideoPlay", void 0),
            Object(_.a)(Object(s.a)(n), "cardForegroundVideoPause", void 0),
            (n.state = { hovering: !1 }),
            (n.handleCardClick = n.handleCardClick.bind(Object(s.a)(n))),
            (n.cardBgVideoDom = null),
            (n.cardForegroundVideo = p.createRef()),
            (n.cardForegroundVideoReplay = p.createRef()),
            (n.cardForegroundVideoPlay = p.createRef()),
            (n.cardForegroundVideoPause = p.createRef()),
            n
          );
        }
        return (
          Object(c.a)(t, e),
          Object(r.default)(t, [
            { key: "componentDidMount", value: function () {} },
            {
              key: "colsToWidth",
              value: function (e) {
                var t = this.props.getGapWidth(),
                  n = this.props.getGridWidth(),
                  o = parseInt(t, 10),
                  a = n;
                return (
                  (((a = a.match(/vw|%/)
                    ? parseInt(a, 10) * window.innerWidth
                    : parseInt(a, 10)) -
                    11 * o) /
                    12) *
                    e +
                  o * (e - 1)
                );
              },
            },
            {
              key: "handleCardClick",
              value: function (e) {
                var t = this.props,
                  n = t.jumpLink,
                  o = t.jumpType;
                if (e && e.target) {
                  var a = e.target;
                  if (
                    !a.nodeName ||
                    ("A" !== a.nodeName &&
                      "BUTTON" !== a.nodeName &&
                      !a.className.includes("media-modal-container") &&
                      !a.getAttribute("data-link"))
                  ) {
                    for (; a.offsetParent; )
                      if (
                        "A" === (a = a.offsetParent).nodeName ||
                        "BUTTON" === a.nodeName ||
                        a.className.includes("media-modal-container") ||
                        a.getAttribute("data-link")
                      )
                        return;
                    n &&
                      "/" !== n &&
                      (o === I.p.external
                        ? window.open(n)
                        : (window.location.href = n));
                  }
                }
              },
            },
            {
              key: "renderCardInnerContent",
              value: function () {
                var e = this.props,
                  t = e.getFadeTransiation(),
                  n = {
                    marginTop: e.marginTop,
                    marginBottom: e.marginBottom,
                    paddingTop: e.paddingTop,
                    paddingBottom: e.paddingBottom,
                    paddingLeft: e.paddingLeft,
                    paddingRight: e.paddingRight,
                    overflow: "hidden",
                  };
                e.minHeight && (n.minHeight = e.minHeight);
                var a = this.colsToWidth(e.leftCols),
                  r = "calc(100% - "
                    .concat(e.mediaDistance, " - ")
                    .concat(a, "px)"),
                  i = "vertical-".concat(e.verticalAlign),
                  l = this.props.leftCols,
                  s =
                    e.hasMedia &&
                    !(e.cardLayout === I.d["media-text"] && "0" === l) &&
                    !(e.cardLayout === I.d["text-media"] && "12" === l),
                  c =
                    !(e.cardLayout === I.d["media-text"] && "12" === l) &&
                    !(e.cardLayout === I.d["text-media"] && "0" === l),
                  _ =
                    e.cardLayout === I.d["text-media"] ? "".concat(a, "px") : r,
                  u =
                    e.cardLayout === I.d["media-text"] ? "".concat(a, "px") : r;
                s || (_ = "100%"), c || (u = "100%");
                var f =
                    e.headlineSvgShowFirst || e.eyeBrowSvgShowFirst
                      ? xe(
                          g.a,
                          null,
                          e.headlineSvgShowFirst &&
                            e.headlineSVG &&
                            xe("link", {
                              rel: "preload",
                              href: e.headlineSVG,
                              as: "image",
                              type: "image/svg+xml",
                            }),
                          e.eyeBrowSvgShowFirst &&
                            e.eyeBrowSVG &&
                            xe("link", {
                              rel: "preload",
                              href: e.eyeBrowSVG,
                              as: "image",
                              type: "image/svg+xml",
                            }),
                        )
                      : null,
                  h = {
                    cardForegroundVideo: this.cardForegroundVideo,
                    cardForegroundVideoReplay: this.cardForegroundVideoReplay,
                    cardForegroundVideoPlay: this.cardForegroundVideoPlay,
                    cardForegroundVideoPause: this.cardForegroundVideoPause,
                  },
                  m = s
                    ? xe(E, Object(o.a)({}, e, { ref: h, aosFade: t }))
                    : null,
                  y = c
                    ? xe(
                        we,
                        Object(o.a)({}, e, { aosFade: t, contentWidth: _ }),
                      )
                    : null,
                  b = e.hasMediaScreen,
                  v = e.mediaPoint,
                  w =
                    e.customStyleName ||
                    ""
                      .concat(
                        Object(k.kb)(b, "has-media-screen", ""),
                        " media-screen-",
                      )
                      .concat(v || "1440"),
                  x = "card-wrapper ".concat(i, " ").concat(w);
                return xe(
                  p.Fragment,
                  null,
                  xe(
                    "div",
                    {
                      style: n,
                      className: d()(x, Ie, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    f,
                    e.cardLayout === I.d["media-text"] ? [m, y] : [y, m],
                  ),
                  e.foregroundCredit &&
                    (function () {
                      var t,
                        n = xe(
                          "div",
                          {
                            className: "style__credit-container___3BA6K",
                            style: {
                              width: u,
                              marginRight:
                                e.cardLayout === I.d["media-text"]
                                  ? e.mediaDistance
                                  : "",
                            },
                          },
                          xe("span", {
                            className: "style__credit-content___xOkfI",
                            style:
                              null === (t = e.foregroundCreditFont) ||
                              void 0 === t
                                ? void 0
                                : t.style,
                            dangerouslySetInnerHTML: {
                              __html: e.foregroundCredit || "",
                            },
                          }),
                        ),
                        o = xe("div", {
                          style: {
                            width: _,
                            marginRight:
                              e.cardLayout === I.d["text-media"]
                                ? e.mediaDistance
                                : "",
                          },
                        });
                      return xe(
                        "div",
                        { className: "style__credit-wrapper___31b8l" },
                        e.cardLayout === I.d["media-text"] ? [n, o] : [o, n],
                      );
                    })(),
                );
              },
            },
            {
              key: "render",
              value: function () {
                var e,
                  t = this,
                  n = this.props,
                  a =
                    window &&
                    !!window.MSInputMethodContext &&
                    !!document.documentMode,
                  r =
                    (n.hasBackgroundImage && n.backgroundImage) ||
                    (n.hasBackgroundVideo &&
                      (n.backgroundVideoWebm || n.backgroundVideo))
                      ? Object(O.a)(n)
                      : void 0,
                  i = n.visibleByDefault,
                  l = {
                    borderRadius: n.borderRadius,
                    backgroundColor: n.backgroundColor,
                  },
                  s = this.state.hovering;
                n.hasBackgroundImage
                  ? ((e = n.backgroundImage),
                    (l.backgroundPosition = n.backgroundPosition),
                    (l.backgroundSize =
                      n.backgroundSize === I.c["auto-fit"]
                        ? "cover"
                        : n.backgroundSizeCustom),
                    (l.backgroundRepeat = n.backgroundRepeat),
                    a ||
                      (l.backgroundAttachment =
                        n.backgroundFixed === I.a.fix ? "fixed" : "scroll"),
                    n.backgroundGradient &&
                      (e = "url('"
                        .concat(n.backgroundImage, "'), ")
                        .concat(n.backgroundGradient)))
                  : n.backgroundGradient && (e = n.backgroundGradient);
                var c = {};
                c[i ? "poster" : "data-layzr-poster"] = n.backgroundVideoPoster;
                var _ = n.hasBackgroundVideo
                    ? xe(
                        "div",
                        { className: "style__card-background-video___1108n" },
                        xe(
                          m.a,
                          {
                            visiblePlay: n.backgroundVideoVisiblePlay,
                            replayWhenRevisible: n.backgroundVideoVisiblePlay,
                            triggerPlay: n.backgroundVideoHoverPlay && s,
                            triggerPause: n.backgroundVideoHoverPlay && !s,
                            lazyLoad: !0,
                            lazyLoadThreshold: 2e3,
                            style: {
                              position: "relative",
                              width: "100%",
                              height: "100%",
                            },
                          },
                          xe(
                            "video",
                            Object(o.a)(
                              {
                                muted: !0,
                                ref: function (e) {
                                  t.cardBgVideoDom = e;
                                },
                              },
                              c,
                              {
                                loop: n.backgroundVideoLoop,
                                autoPlay:
                                  !n.backgroundVideoVisiblePlay &&
                                  !n.backgroundVideoHoverPlay,
                              },
                            ),
                            n.backgroundVideoWebm &&
                              xe("source", {
                                type: "video/webm",
                                "data-layzr-src": n.backgroundVideoWebm,
                              }),
                            xe("source", {
                              type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                              "data-layzr-src": n.backgroundVideo,
                            }),
                          ),
                        ),
                        xe("div", {
                          className: "style__video-mask___3Z49h",
                          style: {
                            backgroundColor: n.backgroundVideoMaskColor,
                            opacity: n.backgroundVideoMaskOpacity,
                          },
                        }),
                      )
                    : null,
                  u = {
                    type: "bg",
                    visibleByDefault: i,
                    parallax: n.hasBackgroundImage && n.backgroundParallax,
                    src: e,
                    bgWidth: n.backgroundImageWidth,
                    bgHeight: n.backgroundImageHeight,
                    style: l,
                    onMouseEnter: function () {
                      n.hasBackgroundVideo &&
                        n.backgroundVideoHoverPlay &&
                        t.setState({ hovering: !0 });
                    },
                    onMouseLeave: function () {
                      n.hasBackgroundVideo &&
                        n.backgroundVideoHoverPlay &&
                        t.setState({ hovering: !1 });
                    },
                  };
                return (
                  n.hasJumpLink &&
                    (u = Oe(
                      Oe({}, u),
                      {},
                      {
                        role: "button",
                        tabIndex: 0,
                        style: Oe(
                          Oe({}, l),
                          {},
                          {
                            cursor:
                              n.jumpLink && "/" !== n.jumpLink
                                ? "pointer"
                                : "normal",
                            outline: "none",
                          },
                        ),
                        "data-ga-label":
                          (null === n || void 0 === n
                            ? void 0
                            : n.jumpLinkGaLabel) ||
                          "card-".concat(n.index, "-link"),
                        onClick: this.handleCardClick,
                        onKeyDown: this.handleCardClick,
                      },
                    )),
                  xe(
                    y.a,
                    Object(o.a)(
                      {
                        className:
                          "style__card-container___3mjN3 " +
                          ((u && u.className) || ""),
                      },
                      u,
                    ),
                    xe(
                      "a",
                      {
                        style: { display: "contents" },
                        href: null === r || void 0 === r ? void 0 : r.url,
                        target: null === r || void 0 === r ? void 0 : r.target,
                        "data-ga-label":
                          null === r || void 0 === r ? void 0 : r.gaLabel,
                      },
                      _,
                      this.renderCardInnerContent(),
                    ),
                  )
                );
              },
            },
          ]),
          t
        );
      })(p.PureComponent);
      Object(_.a)(
        je,
        "defaultProps",
        Oe(
          Oe(
            {
              leftCols: I.q[3],
              headlineLevel: I.l.h1,
              contentSize: I.g.xl,
              verticalAlign: I.x["top-align"],
              horizontalAlign: I.n["center-align"],
              minHeight: "",
              marginTop: "0px",
              marginBottom: "0px",
              paddingTop: "0px",
              paddingBottom: "0px",
              paddingLeft: "0px",
              paddingRight: "0px",
              borderRadius: "0px",
              hasJumpLink: !1,
              jumpType: I.p.external,
              jumpLink: "",
              textColor: I.w.black,
              linkColor: I.r.normal,
              linkFontSize: b.b.default,
              linkLineHeight: b.d.default,
              backgroundColor: "",
              backgroundGradient: "",
              cardLayout: I.d["media-text"],
              hasBackgroundImage: !1,
              backgroundImageWidth: "",
              backgroundImageHeight: "",
              backgroundImage: "",
              backgroundPosition: "center",
              backgroundSize: I.c["auto-fit"],
              backgroundSizeCustom: "",
              backgroundRepeat: I.b["no-repeat"],
              backgroundFixed: I.a.normal,
              backgroundParallax: !1,
              hasBackgroundVideo: !1,
              backgroundVideoLoop: !0,
              backgroundVideoVisiblePlay: !1,
              backgroundVideoHoverPlay: !0,
              backgroundVideo: "",
              backgroundVideoWebm: "",
              backgroundVideoPoster: "",
              backgroundVideoMaskColor: "#000000",
              backgroundVideoMaskOpacity: "0",
              hasMedia: !0,
              media: I.e.picture,
              mediaborderRadius: "0px",
              mediaDistance: "32px",
              foregroundImage:
                "https://www1.djicdn.com/dps/b1d157029015f2ec9692fb865c362485.jpg",
              foregroundImageAlt: "",
              foregroundHasParallax: !1,
              foregroundParallax: I.k["inner-content"],
              foregroundHeight: "100%",
              foregroundVideo: "",
              foregroundVideoWebm: "",
              foregroundVideoPoster: "",
              foregroundVideoPlayType: I.y.loop,
              foregroundLayout: I.j.one,
              foregroundList: [Oe({}, x.a)],
              foregroundCredit: "",
              foregroundCreditFont: {},
              downgradeVideo: "",
              contentPaddingTop: "",
              contentPaddingBottom: "",
              contentPaddingLeft: "",
              contentPaddingRight: "",
              hasToppingImage: !1,
              toppingImage:
                "//www1.djicdn.com/dps/b10b501584ac0f7e81407bcb84b95947.svg",
              toppingImageHeight: "64px",
              hasTag: !1,
              tagText: "Tag",
              tagTextFont: {},
              tagHeight: "24px",
              tagWidth: "45px",
              tagColor: "#BE4E04",
              tagRadius: "4px",
              hasEyeBrow: !1,
              eyeBrowType: I.i["pure-text"],
              eyeBrowSVG: "",
              eyeBrowSVGHeight: "96px",
              eyeBrowText: "Eyebrow",
              eyeBrowPureColor: "rgba(0, 0, 0, 0.85)",
              eyeBrowGradientColor: "",
              eyeBrowIEGradientColor: "",
              eyeBrowFontSize: b.b.default,
              eyeBrowFontWeight: "",
              eyeBrowLineHeight: b.d.default,
              hasHeadline: !0,
              headlineType: I.m["pure-text"],
              headlineSVG: "",
              headlineText: "Headline",
              headlineSVGHeight: "32px",
              headlinePureColor: "rgba(0, 0, 0, 0.85)",
              headlineGradientColor: "",
              headlineIEGradientColor: "",
              headlineFontSize: b.b.default,
              headlineFontWeight: "",
              headlineLineHeight: b.d.default,
              hasSubHeadline: !1,
              subHeadlineType: I.m["pure-text"],
              subHeadlineText: "Subhead",
              subHeadlineColor: "rgba(0, 0, 0, 0.85)",
              subHeadlineGradientColor: "",
              subHeadlineIEGradientColor: "",
              subHeadlineFontSize: b.b.default,
              subHeadlineFontWeight: "",
              subHeadlineLineHeight: b.d.default,
              hasDescription: !0,
              descriptionColor: "rgba(0, 0, 0, 0.65)",
              descriptionText: "Description",
              descriptionFontSize: b.b.default,
              descriptionFontWeight: "",
              descriptionLineHeight: b.d.default,
              hasDividedLine: !1,
              dividedBlockHeight: "48px",
              dividedLineWidth: "48px",
              dividedLineHeight: "1px",
              dividedLineRadius: "0",
              dividedLineColor: "",
              dividedLineGradientColor: "",
              hasRelatedCommodity: !1,
              commodityEan: "",
              commoditySlug: "",
              priceTextFont: {},
              originPriceTextFont: {},
              hasPrimaryButton: !1,
              primaryButtonType: I.t.button,
              primaryButtonColor: I.s.dark,
              primaryButtonSize: h.a["x-large"],
              primaryButtonLink: "/",
              primaryButtonText: "Button",
              primaryButtonMinWidth: "100%",
              hasSecondaryButton: !1,
              secondaryButtonType: I.v["video-play"],
              secondaryButtonColor: I.u["secondary-light"],
              secondaryButtonSize: h.a["x-large"],
              secondaryButtonLink: "/",
              secondaryButtonText: "Button",
              secondaryButtonMinWidth: "100%",
              hasThirdlyButton: !1,
              thirdlyButtonType: I.v["video-play"],
              thirdlyButtonColor: I.u["secondary-light"],
              thirdlyButtonSize: h.a["x-large"],
              thirdlyButtonLink: "/",
              thirdlyButtonText: "Button",
              thirdlyButtonMinWidth: "100%",
              hasDownloadButton: !1,
              hasAppStoreButton: !1,
              appStoreButtonLink: "",
              hasAndroidButton: !1,
              androidButtonLink: "",
              hasGooglePlayButton: !1,
              googlePlayButtonLink: "",
            },
            w.j,
          ),
          {},
          {
            hasCardLinks: !1,
            buttonListTypeColumn: !1,
            secondaryButtonClickID: "",
            thirdlyButtonClickID: "",
            links: [
              { linkType: I.f["internal-link"], linkText: "link", text: "/" },
            ],
            hasNote: !1,
            noteMarginTop: "",
            noteText: "note",
            noteFontSize: b.b.default,
            noteFontWeight: "",
            noteLineHeight: b.d.default,
            noteColor: "rgba(0, 0, 0, 0.45)",
            hasIcons1: !1,
            icons1MaxWidth: "none",
            icons1Layout: I.o.vertical,
            icons1Height: "48px",
            icons1: [
              {
                hasTitle: !0,
                hasPic: !1,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                unit: "m/s",
                title: "title",
                titleFontSize: b.b.default,
                titleFontWeight: "",
                titleLineHeight: b.d.default,
                descFontSize: b.b.default,
                descFontWeight: "",
                descLineHeight: b.d.default,
                pic: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                desc: "desc",
              },
              {
                hasTitle: !0,
                hasPic: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                title: "title",
                titleFontSize: b.b.default,
                titleFontWeight: "",
                titleLineHeight: b.d.default,
                descFontSize: b.b.default,
                descFontWeight: "",
                descLineHeight: b.d.default,
                pic: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                desc: "desc",
              },
            ],
            hasIcons2: !1,
            icons2MaxWidth: "none",
            icons2Layout: I.o.vertical,
            icons2Height: "48px",
            icons2: [
              {
                hasTitle: !0,
                hasPic: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                title: "title",
                titleFontSize: b.b.default,
                titleFontWeight: "",
                titleLineHeight: b.d.default,
                descFontSize: b.b.default,
                descFontWeight: "",
                descLineHeight: b.d.default,
                pic: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                desc: "desc",
              },
              {
                hasTitle: !0,
                hasPic: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                title: "title",
                titleFontSize: b.b.default,
                titleFontWeight: "",
                titleLineHeight: b.d.default,
                descFontSize: b.b.default,
                descFontWeight: "",
                descLineHeight: b.d.default,
                pic: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                desc: "desc",
              },
            ],
          },
        ),
      );
    },
    CDV2: function (e, t, n) {},
    CElf: function (e, t, n) {
      e.exports = {
        "dropdown-switcher": "dropdown__dropdown-switcher___3gu-Y",
        "dropdown-mask": "dropdown__dropdown-mask___2S3xP",
        active: "dropdown__active___36qe5",
        "product-dropdown": "dropdown__product-dropdown___2hk-O",
        "dropdown-item": "dropdown__dropdown-item___3O-Rr",
        "series-dropdown": "dropdown__series-dropdown___2qsGE",
        "store-dropdown": "dropdown__store-dropdown___GAa4r",
      };
    },
    CH3K: function (e, t) {
      e.exports = function (e, t) {
        for (var n = -1, o = t.length, a = e.length; ++n < o; ) e[a + n] = t[n];
        return e;
      };
    },
    CRHi: function (e, t, n) {},
    Cc7j: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("q1tI"),
        u = n("XnI8"),
        d = (n("hyiO"), n("gn4A")),
        p = n.n(d),
        f = _.createElement;
      function h(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var m = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = h(this, t, [e])).state = { modalShow: !1, opened: !1 }),
            (n.handleCloseButtonClick = n.handleCloseButtonClick.bind(
              Object(l.a)(n),
            )),
            (n.handleShowButtonClick = n.handleShowButtonClick.bind(
              Object(l.a)(n),
            )),
            (n.handleWrapperClick = n.handleWrapperClick.bind(Object(l.a)(n))),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "handleCloseButtonClick",
              value: function (e) {
                if (
                  (this.props.isStopPropagation && e.stopPropagation(),
                  "undefined" !== typeof document && document)
                ) {
                  var t = document.querySelector("body"),
                    n = document.querySelector("html");
                  t &&
                    ((t.style.overflow = this.bodyInitialOverflow || ""),
                    (t.style.height = ""),
                    (n.style.overflow = this.htmlInitialOverflow || ""),
                    window.scrollTo(0, this.bodyInitialScroll),
                    this.setState({ modalShow: !1 }),
                    "function" === typeof this.props.onClose &&
                      this.props.onClose());
                }
              },
            },
            {
              key: "handleShowButtonClick",
              value: function (e) {
                var t = this.props,
                  n = t.isStopPropagation,
                  o = t.disabled;
                if (t.link && !o) {
                  n && e.stopPropagation(), e.preventDefault();
                  var a = this.modalDom;
                  if ("undefined" !== typeof document && document) {
                    var r = document.querySelector("body"),
                      i = document.querySelector("html");
                    this.state.opened
                      ? ((this.bodyInitialScroll =
                          window.scrollY || window.pageYOffset),
                        this.setState({ modalShow: !0 }))
                      : (a.removeNode
                          ? (a.removeNode(),
                            a.appendChild(this.closeDom),
                            a.appendChild(this.iframeDom),
                            r && r.appendChild(a))
                          : (a.remove(), r && r.append(a)),
                        (this.bodyInitialScroll =
                          window.scrollY || window.pageYOffset),
                        this.setState({ modalShow: !0, opened: !0 })),
                      r &&
                        ((this.bodyInitialOverflow = r.style.overflow),
                        p.a.isUC() &&
                          ((r.style.overflow = "hidden"),
                          (r.style.height = "100vh")),
                        (i.style.overflow = "hidden"),
                        "function" === typeof this.props.onShow &&
                          this.props.onShow());
                  }
                }
              },
            },
            {
              key: "handleWrapperClick",
              value: function (e) {
                e.stopPropagation();
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.link,
                  o = t.text,
                  a = t.style,
                  r = t.children,
                  i = t.isMobile,
                  l = this.state.modalShow;
                return f(
                  "div",
                  { style: a, className: "atom-design-v1" },
                  f(
                    "a",
                    {
                      className: "style__link-button___3Pj2w",
                      href: "javascript:;",
                      tabIndex: 0,
                      onClick: this.handleShowButtonClick,
                      style: { cursor: n ? "" : "default" },
                    },
                    o || r,
                  ),
                  f(
                    "div",
                    {
                      className: "style__media-modal-container___3m5la",
                      style: { display: l && n ? "block" : "none" },
                      ref: function (t) {
                        e.modalDom = t;
                      },
                      onClick: this.handleWrapperClick,
                    },
                    f("button", {
                      ref: function (t) {
                        e.closeDom = t;
                      },
                      type: "button",
                      "aria-label": "close",
                      className: "style__media-modal-close___1Y8ix",
                      onClick: this.handleCloseButtonClick,
                      onKeyDown: function () {},
                    }),
                    f(
                      "div",
                      {
                        ref: function (t) {
                          e.iframeDom = t;
                        },
                        className: "style__media-modal-iframe___2PyPJ",
                        style: {
                          height: i ? "210px" : "675px",
                          width: i ? "100vw" : "1200px",
                        },
                      },
                      l
                        ? f("iframe", {
                            key: n + l,
                            title: "media-modal",
                            src: n,
                            frameBorder: "0",
                            width: "100%",
                            height: "100%",
                            scrolling: "auto",
                            webkitallowfullscreen: "true",
                            mozallowfullscreen: "true",
                            allowFullScreen: "true",
                          })
                        : null,
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(_.Component);
      Object(c.a)(m, "defaultProps", {
        link: "",
        text: "",
        style: {},
        children: "",
        isMobile: !1,
        isStopPropagation: !1,
        disabled: !1,
        onShow: function () {},
        onClose: function () {},
      }),
        (t.a = Object(u.a)(m));
    },
    Cwc5: function (e, t, n) {
      var o = n("NKxu"),
        a = n("Npjl");
      e.exports = function (e, t) {
        var n = a(e, t);
        return o(n) ? n : void 0;
      };
    },
    D1y2: function (e, t, n) {
      var o = n("FZoo");
      e.exports = function (e, t, n) {
        return null == e ? e : o(e, t, n);
      };
    },
    D5mW: function (e, t) {
      var n = function (e) {
        return !(Array.isArray(e) && e.length);
      };
      function o(e, t) {
        return n(e) ? { switch: !1 } : { switch: !0, customTitle: t };
      }
      function a(e) {
        return {
          switch: !n(
            e.specs &&
              e.specs[0] &&
              e.specs[0].items &&
              e.specs[0].items[0] &&
              e.specs[0].items[0].specs,
          ),
        };
      }
      function r(e) {
        return { switch: !n(e.faq) };
      }
      function i(e) {
        return {
          switch:
            Array.isArray(e.group_videos) &&
            !n(
              e.group_videos.filter(function (e) {
                return e.video_link;
              }),
            ),
        };
      }
      var l = {
          dataKey: "elevator",
          transform: function (e) {
            return e
              ? {
                  hasPrimary: o(
                    e.recommendations &&
                      e.recommendations.primary &&
                      e.recommendations.primary.sections,
                    e.recommendations.primary.title,
                  ),
                  hasSecondary: o(
                    e.recommendations &&
                      e.recommendations.secondary &&
                      e.recommendations.secondary.sections,
                    e.recommendations.secondary.title,
                  ),
                  hasSpecs: a(e),
                  hasFaq: r(e),
                  hasVideo: i(e),
                }
              : {};
          },
        },
        s = {
          supportProductSupportDetail: [l],
          supportProductSupportDetailBanner: [l],
        };
      e.exports = {
        SUPPORT_DATA_KEY_MAP: {
          supportProductSupportDetailBanner: {
            slug: "supportProductSupportDetail",
            dataKeys: [
              "product_slug",
              "title",
              "cover",
              "links",
              "recommendations",
            ],
          },
          supportProductSupportDetailVideo: {
            slug: "supportProductSupportDetail",
            dataKeys: ["product_slug", "group_videos", "specs"],
          },
          supportProductSupportDetailFaq: {
            slug: "supportProductSupportDetail",
            dataKeys: ["product_slug", "faq"],
          },
          supportServicePlanSubNav: {
            slug: "supportServicePlanDetail",
            dataKeys: ["slug", "title", "sub_nav_theme", "sub_nav", "buylink"],
          },
          supportServicePlanSupportedProduct: {
            slug: "supportServicePlanDetail",
            dataKeys: ["slug", "supported_products"],
          },
          supportServicePlanFAQ: {
            slug: "supportServicePlanDetail",
            dataKeys: ["slug", "faq"],
          },
          supportServicePlanTerms: {
            slug: "supportServicePlanDetail",
            dataKeys: ["slug", "terms"],
          },
        },
        SUPPORT_CROSS_DATA_MAP: {},
        SUPPORT_TRANSFORM_DATA_MAP: s,
      };
    },
    D7K2: function (e, t, n) {
      "use strict";
      n.d(t, "g", function () {
        return c;
      }),
        n.d(t, "b", function () {
          return d;
        }),
        n.d(t, "a", function () {
          return f;
        }),
        n.d(t, "f", function () {
          return s;
        }),
        n.d(t, "d", function () {
          return l;
        }),
        n.d(t, "c", function () {
          return p;
        }),
        n.d(t, "e", function () {
          return _;
        }),
        n.d(t, "h", function () {
          return u;
        });
      var o = n("rePB");
      function a(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function r(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? a(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : a(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var i = function (e) {
          return {
            paddingLeft:
              (null === e || void 0 === e ? void 0 : e.paddingLeft) || "",
            paddingRight:
              (null === e || void 0 === e ? void 0 : e.paddingRight) || "",
            paddingTop:
              (null === e || void 0 === e ? void 0 : e.paddingTop) || "",
            paddingBottom:
              (null === e || void 0 === e ? void 0 : e.paddingBottom) || "",
          };
        },
        l = function (e) {
          return {
            marginLeft:
              (null === e || void 0 === e ? void 0 : e.marginLeft) || "",
            marginRight:
              (null === e || void 0 === e ? void 0 : e.marginRight) || "",
            marginTop:
              (null === e || void 0 === e ? void 0 : e.marginTop) || "",
            marginBottom:
              (null === e || void 0 === e ? void 0 : e.marginBottom) || "",
          };
        },
        s = function (e) {
          return {
            borderTopLeftRadius:
              (null === e || void 0 === e ? void 0 : e.RadiusLeftTop) ||
              (null === e || void 0 === e ? void 0 : e.RadiusAll) ||
              "",
            borderTopRightRadius:
              (null === e || void 0 === e ? void 0 : e.RadiusRightTop) ||
              (null === e || void 0 === e ? void 0 : e.RadiusAll) ||
              "",
            borderBottomLeftRadius:
              (null === e || void 0 === e ? void 0 : e.RadiusLeftBottom) ||
              (null === e || void 0 === e ? void 0 : e.RadiusAll) ||
              "",
            borderBottomRightRadius:
              (null === e || void 0 === e ? void 0 : e.RadiusRightBottom) ||
              (null === e || void 0 === e ? void 0 : e.RadiusAll) ||
              "",
          };
        },
        c = function (e) {
          var t = e.padding;
          return r({}, i(t));
        },
        _ = function (e) {
          return e
            ? { minHeight: "calc(100vh - 48px)" }
            : { minHeight: "100vh" };
        },
        u = function (e) {
          return { display: e ? "block" : "none" };
        },
        d = function (e) {
          var t = e.padding,
            n = e.margin,
            o = e.radius;
          return r(r(r({}, i(t)), l(n)), s(o));
        },
        p = function (e, t) {
          return { width: e, height: t };
        },
        f = function (e) {
          var t = e.padding,
            n = e.cardMinHeight;
          return r(r({}, i(t)), {}, { minHeight: n });
        };
    },
    D83i: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t) && !e.required) return n();
          r.default.required(e, t, o, l, a),
            void 0 !== t &&
              (r.default.type(e, t, o, l, a), r.default.range(e, t, o, l, a));
        }
        n(l);
      };
    },
    D8kY: function (e, t, n) {
      var o = n("Ojgd"),
        a = Math.max,
        r = Math.min;
      e.exports = function (e, t) {
        return (e = o(e)) < 0 ? a(e + t, 0) : r(e, t);
      };
    },
    DGiJ: function (e, t, n) {
      e.exports = {
        "section-tab-sceneswitch": "style__section-tab-sceneswitch___2DRd_",
        "clip-hidden": "style__clip-hidden___vxjsB",
        "clip-active": "style__clip-active___3a7Do",
        "scale-active": "style__scale-active___3dAxl",
        "atom-horiozntal-tab-component":
          "style__atom-horiozntal-tab-component___2zeKn",
        mobile: "style__mobile___2mEuR",
        "background-video": "style__background-video___3FiYW",
        "video-mask": "style__video-mask___h_ecZ",
        "atom-horizontal-tab-align-center":
          "style__atom-horizontal-tab-align-center___3xpOs",
        "tab-horizontal-wrapper": "style__tab-horizontal-wrapper___1DWeV",
        "card-wrap": "style__card-wrap___2LDic",
        "vertical-left-align": "style__vertical-left-align___ULi5D",
        "vertical-center-align": "style__vertical-center-align___3u-MT",
        "vertical-right-align": "style__vertical-right-align___1dJPj",
        "tab-content": "style__tab-content___3xQIW",
        "tab-active-card": "style__tab-active-card___3LirV",
        "tab-card-item": "style__tab-card-item___2af9X",
      };
    },
    DSRE: function (e, t, n) {
      (function (e) {
        var o = n("Kz5y"),
          a = n("B8du"),
          r = t && !t.nodeType && t,
          i = r && "object" == typeof e && e && !e.nodeType && e,
          l = i && i.exports === r ? o.Buffer : void 0,
          s = (l ? l.isBuffer : void 0) || a;
        e.exports = s;
      }).call(this, n("YuTi")(e));
    },
    DTFi: function (e, t, n) {
      e.exports = {
        "media-modal-container": "style__media-modal-container___t6IW3",
        "media-modal-close": "style__media-modal-close___1w4Vj",
        "media-modal-iframe": "style__media-modal-iframe___2aQ0n",
        "link-button": "style__link-button___1pM2o",
      };
    },
    DdlN: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return i;
      });
      var o = n("/+VL"),
        a = n("q1tI"),
        r = n("6AKW"),
        i = function (e) {
          var t = e.mobileMode,
            n = e.defaultWindowWidth,
            i = void 0 === n ? 0 : n,
            l = e.defaultWindowHeight,
            s = void 0 === l ? 0 : l,
            c = e.sectionRef,
            _ = e.mobileHeightChangable,
            u = void 0 === _ || _,
            d = Object(a.useState)(i || 0),
            p = d[0],
            f = d[1],
            h = Object(a.useState)(s || 0),
            m = h[0],
            y = h[1];
          return (
            Object(a.useEffect)(function () {
              var e,
                n = window.innerWidth,
                a = window.innerHeight,
                i = t ? (u ? a : window.screen.height) : a,
                l =
                  (null === c || void 0 === c
                    ? void 0
                    : null === (e = c.current) || void 0 === e
                      ? void 0
                      : e.clientWidth) || (t ? Math.min(n, r.g) : n);
              (o.a.getInstance().getDimension().innerWidth = l),
                (o.a.getInstance().getDimension().innerHeight = i),
                f(l),
                y(i);
            }, []),
            Object(a.useEffect)(
              function () {
                var e,
                  n = function () {
                    var e,
                      n = window.innerWidth,
                      a =
                        (null === c || void 0 === c
                          ? void 0
                          : null === (e = c.current) || void 0 === e
                            ? void 0
                            : e.clientWidth) || (t ? Math.min(n, r.g) : n);
                    (o.a.getInstance().getDimension().innerWidth = a), f(a);
                    var i = window.innerHeight;
                    t
                      ? u &&
                        i > m &&
                        ((o.a.getInstance().getDimension().innerHeight = i),
                        y(i))
                      : ((o.a.getInstance().getDimension().innerHeight = i),
                        y(i));
                  };
                (!u && t) ||
                  null === (e = window) ||
                  void 0 === e ||
                  e.addEventListener("resize", n);
                return function () {
                  var e;
                  (!u && t) ||
                    null === (e = window) ||
                    void 0 === e ||
                    e.removeEventListener("resize", n);
                };
              },
              [m],
            ),
            [p, m]
          );
        };
    },
    "Dw+G": function (e, t, n) {
      var o = n("juv8"),
        a = n("mTTR");
      e.exports = function (e, t) {
        return e && o(t, a(t), e);
      };
    },
    Dyh2: function (e, t, n) {
      e.exports = {
        "frame-container": "style__frame-container___3KU0U",
        "backup-frames": "style__backup-frames___1-Pfn",
        show: "style__show___HkbVf",
      };
    },
    DzJC: function (e, t, n) {
      var o = n("sEfC"),
        a = n("GoyQ"),
        r = "Expected a function";
      e.exports = function (e, t, n) {
        var i = !0,
          l = !0;
        if ("function" != typeof e) throw new TypeError(r);
        return (
          a(n) &&
            ((i = "leading" in n ? !!n.leading : i),
            (l = "trailing" in n ? !!n.trailing : l)),
          o(e, t, { leading: i, maxWait: t, trailing: l })
        );
      };
    },
    E0WF: function (e, t, n) {
      e.exports = {
        "section-common-sectionzoomout":
          "style__section-common-sectionzoomout___2oyFm",
        light: "style__light___2rt8k",
        eyebrow: "style__eyebrow___1voBD",
        headline: "style__headline___3Ke5a",
        "placeholder-box": "style__placeholder-box___3t5T4",
        dark: "style__dark___3Vzvf",
        "downgrade-mode": "style__downgrade-mode___2BPsU",
        video: "style__video___3Uzsk",
        "media-wrapper": "style__media-wrapper___12rMB",
        "normal-mode": "style__normal-mode___2X-fe",
        "main-titles": "style__main-titles___3iXzt",
        "sub-eyebrow": "style__sub-eyebrow___1gp-g",
        "sub-headline": "style__sub-headline___AZWDK",
        desc: "style__desc___2Xnjq",
        "box-wrapper": "style__box-wrapper___BCCF2",
        "button-inner": "style__button-inner____ZJgf",
        "button-text": "style__button-text___3jTY5",
        "button-link": "style__button-link___fh-sc",
        "link-inner": "style__link-inner___2h0Gq",
        "link-text": "style__link-text___6pTiw",
        container: "style__container___3Bqtc",
        top: "style__top___1n_VY",
        bottom: "style__bottom___1e4Cd",
        left: "style__left___3_Ni9",
        right: "style__right___2W_Ua",
        "media-container": "style__media-container___3Vx1b",
        figure: "style__figure___1df-2",
        "mask-container": "style__mask-container___1LqiX",
        mask: "style__mask___Z2Ldn",
        "text-wrapper": "style__text-wrapper___1h3ez",
        "scene-wrapper": "style__scene-wrapper___2njSe",
        "mobile-mode": "style__mobile-mode___1ReeI",
      };
    },
    E0u0: function (e, t, n) {
      "use strict";
      function o(e) {
        return e && e.__esModule ? e : { default: e };
      }
      Object.defineProperty(t, "__esModule", { value: !0 });
      var a = o(n("QDlc")),
        r = o(n("Qetd")),
        i = !0,
        l = !1,
        s = [
          "altKey",
          "bubbles",
          "cancelable",
          "ctrlKey",
          "currentTarget",
          "eventPhase",
          "metaKey",
          "shiftKey",
          "target",
          "timeStamp",
          "view",
          "type",
        ];
      function c(e) {
        return null === e || void 0 === e;
      }
      var _ = [
        {
          reg: /^key/,
          props: ["char", "charCode", "key", "keyCode", "which"],
          fix: function (e, t) {
            c(e.which) && (e.which = c(t.charCode) ? t.keyCode : t.charCode),
              void 0 === e.metaKey && (e.metaKey = e.ctrlKey);
          },
        },
        {
          reg: /^touch/,
          props: ["touches", "changedTouches", "targetTouches"],
        },
        { reg: /^hashchange$/, props: ["newURL", "oldURL"] },
        { reg: /^gesturechange$/i, props: ["rotation", "scale"] },
        {
          reg: /^(mousewheel|DOMMouseScroll)$/,
          props: [],
          fix: function (e, t) {
            var n = void 0,
              o = void 0,
              a = void 0,
              r = t.wheelDelta,
              i = t.axis,
              l = t.wheelDeltaY,
              s = t.wheelDeltaX,
              c = t.detail;
            r && (a = r / 120),
              c && (a = 0 - (c % 3 === 0 ? c / 3 : c)),
              void 0 !== i &&
                (i === e.HORIZONTAL_AXIS
                  ? ((o = 0), (n = 0 - a))
                  : i === e.VERTICAL_AXIS && ((n = 0), (o = a))),
              void 0 !== l && (o = l / 120),
              void 0 !== s && (n = (-1 * s) / 120),
              n || o || (o = a),
              void 0 !== n && (e.deltaX = n),
              void 0 !== o && (e.deltaY = o),
              void 0 !== a && (e.delta = a);
          },
        },
        {
          reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
          props: [
            "buttons",
            "clientX",
            "clientY",
            "button",
            "offsetX",
            "relatedTarget",
            "which",
            "fromElement",
            "toElement",
            "offsetY",
            "pageX",
            "pageY",
            "screenX",
            "screenY",
          ],
          fix: function (e, t) {
            var n = void 0,
              o = void 0,
              a = void 0,
              r = e.target,
              i = t.button;
            return (
              r &&
                c(e.pageX) &&
                !c(t.clientX) &&
                ((o = (n = r.ownerDocument || document).documentElement),
                (a = n.body),
                (e.pageX =
                  t.clientX +
                  ((o && o.scrollLeft) || (a && a.scrollLeft) || 0) -
                  ((o && o.clientLeft) || (a && a.clientLeft) || 0)),
                (e.pageY =
                  t.clientY +
                  ((o && o.scrollTop) || (a && a.scrollTop) || 0) -
                  ((o && o.clientTop) || (a && a.clientTop) || 0))),
              e.which ||
                void 0 === i ||
                (e.which = 1 & i ? 1 : 2 & i ? 3 : 4 & i ? 2 : 0),
              !e.relatedTarget &&
                e.fromElement &&
                (e.relatedTarget =
                  e.fromElement === r ? e.toElement : e.fromElement),
              e
            );
          },
        },
      ];
      function u() {
        return i;
      }
      function d() {
        return l;
      }
      function p(e) {
        var t = e.type,
          n =
            "function" === typeof e.stopPropagation ||
            "boolean" === typeof e.cancelBubble;
        a.default.call(this), (this.nativeEvent = e);
        var o = d;
        "defaultPrevented" in e
          ? (o = e.defaultPrevented ? u : d)
          : "getPreventDefault" in e
            ? (o = e.getPreventDefault() ? u : d)
            : "returnValue" in e && (o = e.returnValue === l ? u : d),
          (this.isDefaultPrevented = o);
        var r = [],
          i = void 0,
          c = void 0,
          p = s.concat();
        for (
          _.forEach(function (e) {
            t.match(e.reg) && ((p = p.concat(e.props)), e.fix && r.push(e.fix));
          }),
            i = p.length;
          i;

        )
          this[(c = p[--i])] = e[c];
        for (
          !this.target && n && (this.target = e.srcElement || document),
            this.target &&
              3 === this.target.nodeType &&
              (this.target = this.target.parentNode),
            i = r.length;
          i;

        )
          (0, r[--i])(this, e);
        this.timeStamp = e.timeStamp || Date.now();
      }
      var f = a.default.prototype;
      (0, r.default)(p.prototype, f, {
        constructor: p,
        preventDefault: function () {
          var e = this.nativeEvent;
          e.preventDefault ? e.preventDefault() : (e.returnValue = l),
            f.preventDefault.call(this);
        },
        stopPropagation: function () {
          var e = this.nativeEvent;
          e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = i),
            f.stopPropagation.call(this);
        },
      }),
        (t.default = p),
        (e.exports = t.default);
    },
    E2jh: function (e, t, n) {
      var o = n("2gN3"),
        a = (function () {
          var e = /[^.]+$/.exec((o && o.keys && o.keys.IE_PROTO) || "");
          return e ? "Symbol(src)_1." + e : "";
        })();
      e.exports = function (e) {
        return !!a && a in e;
      };
    },
    EA7m: function (e, t, n) {
      var o = n("zZ0H"),
        a = n("Ioao"),
        r = n("wclG");
      e.exports = function (e, t) {
        return r(a(e, t, o), e + "");
      };
    },
    EEGq: function (e, t, n) {
      var o = n("juv8"),
        a = n("oCl/");
      e.exports = function (e, t) {
        return o(e, a(e), t);
      };
    },
    EJiy: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o = i(n("F+2o")),
        a = i(n("+JPL")),
        r =
          "function" === typeof a.default && "symbol" === typeof o.default
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof a.default &&
                  e.constructor === a.default &&
                  e !== a.default.prototype
                  ? "symbol"
                  : typeof e;
              };
      function i(e) {
        return e && e.__esModule ? e : { default: e };
      }
      t.default =
        "function" === typeof a.default && "symbol" === r(o.default)
          ? function (e) {
              return "undefined" === typeof e ? "undefined" : r(e);
            }
          : function (e) {
              return e &&
                "function" === typeof a.default &&
                e.constructor === a.default &&
                e !== a.default.prototype
                ? "symbol"
                : "undefined" === typeof e
                  ? "undefined"
                  : r(e);
            };
    },
    EP0T: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("q1tI"),
        c = n.n(s),
        _ = c.a.createElement;
      function u(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var d = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = u(this, t, [e])).state = { hasError: !1 }),
            n
          );
        }
        return (
          Object(l.a)(t, e),
          Object(a.default)(
            t,
            [
              {
                key: "componentDidCatch",
                value: function (e, t) {
                  console.log({ error: e, errorInfo: t });
                },
              },
              {
                key: "render",
                value: function () {
                  return this.state.hasError
                    ? _(c.a.Fragment, null)
                    : this.props.children;
                },
              },
            ],
            [
              {
                key: "getDerivedStateFromError",
                value: function () {
                  return { hasError: !0 };
                },
              },
            ],
          ),
          t
        );
      })(c.a.Component);
      t.a = d;
    },
    EW6r: function (e, t, n) {
      var o, a, r, i, l;
      "undefined" != typeof self && self,
        (e.exports =
          ((o = n("q1tI")),
          (a = n("17x9")),
          (r = n("TSYQ")),
          (i = n("9/5/")),
          (l = n("0y5z")),
          (function (e) {
            function t(o) {
              if (n[o]) return n[o].exports;
              var a = (n[o] = { i: o, l: !1, exports: {} });
              return (
                e[o].call(a.exports, a, a.exports, t), (a.l = !0), a.exports
              );
            }
            var n = {};
            return (
              (t.m = e),
              (t.c = n),
              (t.d = function (e, n, o) {
                t.o(e, n) ||
                  Object.defineProperty(e, n, {
                    configurable: !1,
                    enumerable: !0,
                    get: o,
                  });
              }),
              (t.n = function (e) {
                var n =
                  e && e.__esModule
                    ? function () {
                        return e.default;
                      }
                    : function () {
                        return e;
                      };
                return t.d(n, "a", n), n;
              }),
              (t.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }),
              (t.p = ""),
              t((t.s = 150))
            );
          })([
            function (e, t) {
              var n = (e.exports =
                "undefined" != typeof window && window.Math == Math
                  ? window
                  : "undefined" != typeof self && self.Math == Math
                    ? self
                    : Function("return this")());
              "number" == typeof __g && (__g = n);
            },
            function (e, t) {
              var n = (e.exports = { version: "2.5.3" });
              "number" == typeof __e && (__e = n);
            },
            function (e, t, n) {
              e.exports = !n(8)(function () {
                return (
                  7 !=
                  Object.defineProperty({}, "a", {
                    get: function () {
                      return 7;
                    },
                  }).a
                );
              });
            },
            function (e, t) {
              e.exports = function (e) {
                return "object" == typeof e
                  ? null !== e
                  : "function" == typeof e;
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(32),
                r = n(21),
                i = Object.defineProperty;
              t.f = n(2)
                ? Object.defineProperty
                : function (e, t, n) {
                    if ((o(e), (t = r(t, !0)), o(n), a))
                      try {
                        return i(e, t, n);
                      } catch (e) {}
                    if ("get" in n || "set" in n)
                      throw TypeError("Accessors not supported!");
                    return "value" in n && (e[t] = n.value), e;
                  };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e) {
                if (!o(e)) throw TypeError(e + " is not an object!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(35),
                a = n(30);
              e.exports = function (e) {
                return o(a(e));
              };
            },
            function (e, t) {
              var n = {}.hasOwnProperty;
              e.exports = function (e, t) {
                return n.call(e, t);
              };
            },
            function (e, t) {
              e.exports = function (e) {
                try {
                  return !!e();
                } catch (e) {
                  return !0;
                }
              };
            },
            function (e, t) {
              e.exports = o;
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(27),
                i = n(18),
                l = "prototype",
                s = function (e, t, n) {
                  var c,
                    _,
                    u,
                    d = e & s.F,
                    p = e & s.G,
                    f = e & s.S,
                    h = e & s.P,
                    m = e & s.B,
                    y = e & s.W,
                    b = p ? a : a[t] || (a[t] = {}),
                    v = b[l],
                    g = p ? o : f ? o[t] : (o[t] || {})[l];
                  for (c in (p && (n = t), n))
                    ((_ = !d && g && void 0 !== g[c]) && c in b) ||
                      ((u = _ ? g[c] : n[c]),
                      (b[c] =
                        p && "function" != typeof g[c]
                          ? n[c]
                          : m && _
                            ? r(u, o)
                            : y && g[c] == u
                              ? (function (e) {
                                  var t = function (t, n, o) {
                                    if (this instanceof e) {
                                      switch (arguments.length) {
                                        case 0:
                                          return new e();
                                        case 1:
                                          return new e(t);
                                        case 2:
                                          return new e(t, n);
                                      }
                                      return new e(t, n, o);
                                    }
                                    return e.apply(this, arguments);
                                  };
                                  return (t[l] = e[l]), t;
                                })(u)
                              : h && "function" == typeof u
                                ? r(Function.call, u)
                                : u),
                      h &&
                        (((b.virtual || (b.virtual = {}))[c] = u),
                        e & s.R && v && !v[c] && i(v, c, u)));
                };
              (s.F = 1),
                (s.G = 2),
                (s.S = 4),
                (s.P = 8),
                (s.B = 16),
                (s.W = 32),
                (s.U = 64),
                (s.R = 128),
                (e.exports = s);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22);
              e.exports =
                Object.keys ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t) {
              e.exports = a;
            },
            function (e, t, n) {
              e.exports = { default: n(49), __esModule: !0 };
            },
            function (e, t, n) {
              e.exports = { default: n(51), __esModule: !0 };
            },
            function (e, t) {
              t.f = {}.propertyIsEnumerable;
            },
            function (e, t, n) {
              e.exports = { default: n(57), __esModule: !0 };
            },
            function (e, t) {
              var n = 0,
                o = Math.random();
              e.exports = function (e) {
                return "Symbol(".concat(
                  void 0 === e ? "" : e,
                  ")_",
                  (++n + o).toString(36),
                );
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(20);
              e.exports = n(2)
                ? function (e, t, n) {
                    return o.f(e, t, a(1, n));
                  }
                : function (e, t, n) {
                    return (e[t] = n), e;
                  };
            },
            function (e, t, n) {
              var o = n(25)("wks"),
                a = n(17),
                r = n(0).Symbol,
                i = "function" == typeof r;
              (e.exports = function (e) {
                return (
                  o[e] || (o[e] = (i && r[e]) || (i ? r : a)("Symbol." + e))
                );
              }).store = o;
            },
            function (e, t) {
              e.exports = function (e, t) {
                return {
                  enumerable: !(1 & e),
                  configurable: !(2 & e),
                  writable: !(4 & e),
                  value: t,
                };
              };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e, t) {
                if (!o(e)) return e;
                var n, a;
                if (
                  t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
                  return a;
                if (
                  !t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                throw TypeError("Can't convert object to primitive value");
              };
            },
            function (e, t) {
              e.exports =
                "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                  ",",
                );
            },
            function (e, t) {
              e.exports = r;
            },
            function (e, t, n) {
              e.exports = { default: n(60), __esModule: !0 };
            },
            function (e, t, n) {
              var o = n(0),
                a = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
              e.exports = function (e) {
                return a[e] || (a[e] = {});
              };
            },
            function (e, t) {
              t.f = Object.getOwnPropertySymbols;
            },
            function (e, t, n) {
              var o = n(42);
              e.exports = function (e, t, n) {
                if ((o(e), void 0 === t)) return e;
                switch (n) {
                  case 1:
                    return function (n) {
                      return e.call(t, n);
                    };
                  case 2:
                    return function (n, o) {
                      return e.call(t, n, o);
                    };
                  case 3:
                    return function (n, o, a) {
                      return e.call(t, n, o, a);
                    };
                }
                return function () {
                  return e.apply(t, arguments);
                };
              };
            },
            function (e, t) {
              var n = Math.ceil,
                o = Math.floor;
              e.exports = function (e) {
                return isNaN((e = +e)) ? 0 : (e > 0 ? o : n)(e);
              };
            },
            function (e, t, n) {
              var o = n(25)("keys"),
                a = n(17);
              e.exports = function (e) {
                return o[e] || (o[e] = a(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if (void 0 == e) throw TypeError("Can't call method on  " + e);
                return e;
              };
            },
            function (e, t, n) {
              var o = n(3),
                a = n(0).document,
                r = o(a) && o(a.createElement);
              e.exports = function (e) {
                return r ? a.createElement(e) : {};
              };
            },
            function (e, t, n) {
              e.exports =
                !n(2) &&
                !n(8)(function () {
                  return (
                    7 !=
                    Object.defineProperty(n(31)("div"), "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
            },
            function (e, t) {
              var n = {}.toString;
              e.exports = function (e) {
                return n.call(e).slice(8, -1);
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(48),
                r = n(22),
                i = n(29)("IE_PROTO"),
                l = function () {},
                s = function () {
                  var e,
                    t = n(31)("iframe"),
                    o = r.length;
                  for (
                    t.style.display = "none",
                      n(44).appendChild(t),
                      t.src = "javascript:",
                      (e = t.contentWindow.document).open(),
                      e.write("<script>document.F=Object</script>"),
                      e.close(),
                      s = e.F;
                    o--;

                  )
                    delete s.prototype[r[o]];
                  return s();
                };
              e.exports =
                Object.create ||
                function (e, t) {
                  var n;
                  return (
                    null !== e
                      ? ((l.prototype = o(e)),
                        (n = new l()),
                        (l.prototype = null),
                        (n[i] = e))
                      : (n = s()),
                    void 0 === t ? n : a(n, t)
                  );
                };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports = Object("z").propertyIsEnumerable(0)
                ? Object
                : function (e) {
                    return "String" == o(e) ? e.split("") : Object(e);
                  };
            },
            function (e, t, n) {
              var o = n(7),
                a = n(6),
                r = n(46)(!1),
                i = n(29)("IE_PROTO");
              e.exports = function (e, t) {
                var n,
                  l = a(e),
                  s = 0,
                  c = [];
                for (n in l) n != i && o(l, n) && c.push(n);
                for (; t.length > s; )
                  o(l, (n = t[s++])) && (~r(c, n) || c.push(n));
                return c;
              };
            },
            function (e, t, n) {
              var o = n(15),
                a = n(20),
                r = n(6),
                i = n(21),
                l = n(7),
                s = n(32),
                c = Object.getOwnPropertyDescriptor;
              t.f = n(2)
                ? c
                : function (e, t) {
                    if (((e = r(e)), (t = i(t, !0)), s))
                      try {
                        return c(e, t);
                      } catch (e) {}
                    if (l(e, t)) return a(!o.f.call(e, t), e[t]);
                  };
            },
            function (e, t) {
              e.exports = !0;
            },
            function (e, t, n) {
              t.f = n(19);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22).concat("length", "prototype");
              t.f =
                Object.getOwnPropertyNames ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t, n) {
              var o = n(30);
              e.exports = function (e) {
                return Object(o(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if ("function" != typeof e)
                  throw TypeError(e + " is not a function!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.min;
              e.exports = function (e) {
                return e > 0 ? a(o(e), 9007199254740991) : 0;
              };
            },
            function (e, t, n) {
              var o = n(0).document;
              e.exports = o && o.documentElement;
            },
            function (e, t, n) {
              var o = n(4).f,
                a = n(7),
                r = n(19)("toStringTag");
              e.exports = function (e, t, n) {
                e &&
                  !a((e = n ? e : e.prototype), r) &&
                  o(e, r, { configurable: !0, value: t });
              };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(43),
                r = n(47);
              e.exports = function (e) {
                return function (t, n, i) {
                  var l,
                    s = o(t),
                    c = a(s.length),
                    _ = r(i, c);
                  if (e && n != n) {
                    for (; c > _; ) if ((l = s[_++]) != l) return !0;
                  } else
                    for (; c > _; _++)
                      if ((e || _ in s) && s[_] === n) return e || _ || 0;
                  return !e && -1;
                };
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.max,
                r = Math.min;
              e.exports = function (e, t) {
                return (e = o(e)) < 0 ? a(e + t, 0) : r(e, t);
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(5),
                r = n(11);
              e.exports = n(2)
                ? Object.defineProperties
                : function (e, t) {
                    a(e);
                    for (var n, i = r(t), l = i.length, s = 0; l > s; )
                      o.f(e, (n = i[s++]), t[n]);
                    return e;
                  };
            },
            function (e, t, n) {
              n(50);
              var o = n(1).Object;
              e.exports = function (e, t) {
                return o.create(e, t);
              };
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { create: n(34) });
            },
            function (e, t, n) {
              n(52), (e.exports = n(1).Object.setPrototypeOf);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { setPrototypeOf: n(53).set });
            },
            function (e, t, n) {
              var o = n(3),
                a = n(5),
                r = function (e, t) {
                  if ((a(e), !o(t) && null !== t))
                    throw TypeError(t + ": can't set as prototype!");
                };
              e.exports = {
                set:
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function (e, t, o) {
                        try {
                          (o = n(27)(
                            Function.call,
                            n(37).f(Object.prototype, "__proto__").set,
                            2,
                          ))(e, []),
                            (t = !(e instanceof Array));
                        } catch (e) {
                          t = !0;
                        }
                        return function (e, n) {
                          return r(e, n), t ? (e.__proto__ = n) : o(e, n), e;
                        };
                      })({}, !1)
                    : void 0),
                check: r,
              };
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(38),
                i = n(39),
                l = n(4).f;
              e.exports = function (e) {
                var t = a.Symbol || (a.Symbol = r ? {} : o.Symbol || {});
                "_" == e.charAt(0) || e in t || l(t, e, { value: i.f(e) });
              };
            },
            function (e, t, n) {
              e.exports = n(18);
            },
            function (e, t, n) {
              "use strict";
              var o = n(0),
                a = n(7),
                r = n(2),
                i = n(10),
                l = n(55),
                s = n(61).KEY,
                c = n(8),
                _ = n(25),
                u = n(45),
                d = n(17),
                p = n(19),
                f = n(39),
                h = n(54),
                m = n(62),
                y = n(63),
                b = n(5),
                v = n(3),
                g = n(6),
                w = n(21),
                x = n(20),
                k = n(34),
                O = n(64),
                I = n(37),
                S = n(4),
                j = n(11),
                T = I.f,
                C = S.f,
                M = O.f,
                P = o.Symbol,
                E = o.JSON,
                L = E && E.stringify,
                B = "prototype",
                N = p("_hidden"),
                D = p("toPrimitive"),
                z = {}.propertyIsEnumerable,
                A = _("symbol-registry"),
                R = _("symbols"),
                F = _("op-symbols"),
                V = Object[B],
                H = "function" == typeof P,
                W = o.QObject,
                U = !W || !W[B] || !W[B].findChild,
                G =
                  r &&
                  c(function () {
                    return (
                      7 !=
                      k(
                        C({}, "a", {
                          get: function () {
                            return C(this, "a", { value: 7 }).a;
                          },
                        }),
                      ).a
                    );
                  })
                    ? function (e, t, n) {
                        var o = T(V, t);
                        o && delete V[t],
                          C(e, t, n),
                          o && e !== V && C(V, t, o);
                      }
                    : C,
                Y = function (e) {
                  var t = (R[e] = k(P[B]));
                  return (t._k = e), t;
                },
                q =
                  H && "symbol" == typeof P.iterator
                    ? function (e) {
                        return "symbol" == typeof e;
                      }
                    : function (e) {
                        return e instanceof P;
                      },
                X = function (e, t, n) {
                  return (
                    e === V && X(F, t, n),
                    b(e),
                    (t = w(t, !0)),
                    b(n),
                    a(R, t)
                      ? (n.enumerable
                          ? (a(e, N) && e[N][t] && (e[N][t] = !1),
                            (n = k(n, { enumerable: x(0, !1) })))
                          : (a(e, N) || C(e, N, x(1, {})), (e[N][t] = !0)),
                        G(e, t, n))
                      : C(e, t, n)
                  );
                },
                Z = function (e, t) {
                  b(e);
                  for (var n, o = m((t = g(t))), a = 0, r = o.length; r > a; )
                    X(e, (n = o[a++]), t[n]);
                  return e;
                },
                K = function (e) {
                  var t = z.call(this, (e = w(e, !0)));
                  return (
                    !(this === V && a(R, e) && !a(F, e)) &&
                    (!(
                      t ||
                      !a(this, e) ||
                      !a(R, e) ||
                      (a(this, N) && this[N][e])
                    ) ||
                      t)
                  );
                },
                Q = function (e, t) {
                  if (
                    ((e = g(e)), (t = w(t, !0)), e !== V || !a(R, t) || a(F, t))
                  ) {
                    var n = T(e, t);
                    return (
                      !n ||
                        !a(R, t) ||
                        (a(e, N) && e[N][t]) ||
                        (n.enumerable = !0),
                      n
                    );
                  }
                },
                J = function (e) {
                  for (var t, n = M(g(e)), o = [], r = 0; n.length > r; )
                    a(R, (t = n[r++])) || t == N || t == s || o.push(t);
                  return o;
                },
                $ = function (e) {
                  for (
                    var t, n = e === V, o = M(n ? F : g(e)), r = [], i = 0;
                    o.length > i;

                  )
                    !a(R, (t = o[i++])) || (n && !a(V, t)) || r.push(R[t]);
                  return r;
                };
              H ||
                (l(
                  (P = function () {
                    if (this instanceof P)
                      throw TypeError("Symbol is not a constructor!");
                    var e = d(arguments.length > 0 ? arguments[0] : void 0),
                      t = function (n) {
                        this === V && t.call(F, n),
                          a(this, N) && a(this[N], e) && (this[N][e] = !1),
                          G(this, e, x(1, n));
                      };
                    return (
                      r && U && G(V, e, { configurable: !0, set: t }), Y(e)
                    );
                  })[B],
                  "toString",
                  function () {
                    return this._k;
                  },
                ),
                (I.f = Q),
                (S.f = X),
                (n(40).f = O.f = J),
                (n(15).f = K),
                (n(26).f = $),
                r && !n(38) && l(V, "propertyIsEnumerable", K, !0),
                (f.f = function (e) {
                  return Y(p(e));
                })),
                i(i.G + i.W + i.F * !H, { Symbol: P });
              for (
                var ee =
                    "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
                      ",",
                    ),
                  te = 0;
                ee.length > te;

              )
                p(ee[te++]);
              for (var ne = j(p.store), oe = 0; ne.length > oe; ) h(ne[oe++]);
              i(i.S + i.F * !H, "Symbol", {
                for: function (e) {
                  return a(A, (e += "")) ? A[e] : (A[e] = P(e));
                },
                keyFor: function (e) {
                  if (!q(e)) throw TypeError(e + " is not a symbol!");
                  for (var t in A) if (A[t] === e) return t;
                },
                useSetter: function () {
                  U = !0;
                },
                useSimple: function () {
                  U = !1;
                },
              }),
                i(i.S + i.F * !H, "Object", {
                  create: function (e, t) {
                    return void 0 === t ? k(e) : Z(k(e), t);
                  },
                  defineProperty: X,
                  defineProperties: Z,
                  getOwnPropertyDescriptor: Q,
                  getOwnPropertyNames: J,
                  getOwnPropertySymbols: $,
                }),
                E &&
                  i(
                    i.S +
                      i.F *
                        (!H ||
                          c(function () {
                            var e = P();
                            return (
                              "[null]" != L([e]) ||
                              "{}" != L({ a: e }) ||
                              "{}" != L(Object(e))
                            );
                          })),
                    "JSON",
                    {
                      stringify: function (e) {
                        for (var t, n, o = [e], a = 1; arguments.length > a; )
                          o.push(arguments[a++]);
                        if (((n = t = o[1]), (v(t) || void 0 !== e) && !q(e)))
                          return (
                            y(t) ||
                              (t = function (e, t) {
                                if (
                                  ("function" == typeof n &&
                                    (t = n.call(this, e, t)),
                                  !q(t))
                                )
                                  return t;
                              }),
                            (o[1] = t),
                            L.apply(E, o)
                          );
                      },
                    },
                  ),
                P[B][D] || n(18)(P[B], D, P[B].valueOf),
                u(P, "Symbol"),
                u(Math, "Math", !0),
                u(o.JSON, "JSON", !0);
            },
            function (e, t, n) {
              n(58), (e.exports = n(1).Object.assign);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S + o.F, "Object", { assign: n(59) });
            },
            function (e, t, n) {
              "use strict";
              var o = n(11),
                a = n(26),
                r = n(15),
                i = n(41),
                l = n(35),
                s = Object.assign;
              e.exports =
                !s ||
                n(8)(function () {
                  var e = {},
                    t = {},
                    n = Symbol(),
                    o = "abcdefghijklmnopqrst";
                  return (
                    (e[n] = 7),
                    o.split("").forEach(function (e) {
                      t[e] = e;
                    }),
                    7 != s({}, e)[n] || Object.keys(s({}, t)).join("") != o
                  );
                })
                  ? function (e, t) {
                      for (
                        var n = i(e),
                          s = arguments.length,
                          c = 1,
                          _ = a.f,
                          u = r.f;
                        s > c;

                      )
                        for (
                          var d,
                            p = l(arguments[c++]),
                            f = _ ? o(p).concat(_(p)) : o(p),
                            h = f.length,
                            m = 0;
                          h > m;

                        )
                          u.call(p, (d = f[m++])) && (n[d] = p[d]);
                      return n;
                    }
                  : s;
            },
            function (e, t, n) {
              n(56), (e.exports = n(1).Object.getOwnPropertySymbols);
            },
            function (e, t, n) {
              var o = n(17)("meta"),
                a = n(3),
                r = n(7),
                i = n(4).f,
                l = 0,
                s =
                  Object.isExtensible ||
                  function () {
                    return !0;
                  },
                c = !n(8)(function () {
                  return s(Object.preventExtensions({}));
                }),
                _ = function (e) {
                  i(e, o, { value: { i: "O" + ++l, w: {} } });
                },
                u = (e.exports = {
                  KEY: o,
                  NEED: !1,
                  fastKey: function (e, t) {
                    if (!a(e))
                      return "symbol" == typeof e
                        ? e
                        : ("string" == typeof e ? "S" : "P") + e;
                    if (!r(e, o)) {
                      if (!s(e)) return "F";
                      if (!t) return "E";
                      _(e);
                    }
                    return e[o].i;
                  },
                  getWeak: function (e, t) {
                    if (!r(e, o)) {
                      if (!s(e)) return !0;
                      if (!t) return !1;
                      _(e);
                    }
                    return e[o].w;
                  },
                  onFreeze: function (e) {
                    return c && u.NEED && s(e) && !r(e, o) && _(e), e;
                  },
                });
            },
            function (e, t, n) {
              var o = n(11),
                a = n(26),
                r = n(15);
              e.exports = function (e) {
                var t = o(e),
                  n = a.f;
                if (n)
                  for (var i, l = n(e), s = r.f, c = 0; l.length > c; )
                    s.call(e, (i = l[c++])) && t.push(i);
                return t;
              };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports =
                Array.isArray ||
                function (e) {
                  return "Array" == o(e);
                };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(40).f,
                r = {}.toString,
                i =
                  "object" == typeof window &&
                  window &&
                  Object.getOwnPropertyNames
                    ? Object.getOwnPropertyNames(window)
                    : [];
              e.exports.f = function (e) {
                return i && "[object Window]" == r.call(e)
                  ? (function (e) {
                      try {
                        return a(e);
                      } catch (e) {
                        return i.slice();
                      }
                    })(e)
                  : a(o(e));
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = a(n(71)),
                p = o(n(73)),
                f = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                h =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                m = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                y = n(74),
                b = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    f(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        n = e.name,
                        o = e.className,
                        a = m(e, ["name", "className"]),
                        r = (0, u.default)(
                          (p || {})["" + t.classNamePrefix + n],
                          o,
                        );
                      return c.createElement(
                        d.default,
                        h({ className: r, fontFamily: y.fontFamily }, a),
                      );
                    }),
                    (t.classNamePrefix = "icon-"),
                    (t.propTypes = {
                      name: _.default.string.isRequired,
                      spin: _.default.bool,
                      className: _.default.string,
                    }),
                    t
                  );
                })(c.PureComponent);
              t.default = b;
            },
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = o(n(72)),
                p = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                m = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    p(t, e),
                    (t.prototype.render = function () {
                      var e,
                        t = this.props,
                        n = t.className,
                        o = t.fontFamily,
                        a = t.style,
                        r = t.spin,
                        l = h(t, ["className", "fontFamily", "style", "spin"]),
                        s = (0, u.default)(
                          n,
                          d.icon,
                          (((e = {})[d.spin] = !!r), e),
                        ),
                        _ = (0, i.default)({}, a, { fontFamily: o });
                      return c.createElement(
                        "i",
                        f({ className: s, style: _ }, l),
                      );
                    }),
                    (t.propTypes = {
                      classNames: _.default.object,
                      fontFamily: _.default.string,
                      spin: _.default.bool,
                    }),
                    (t.defaultProps = { fontFamily: "iconfont" }),
                    t
                  );
                })(c.PureComponent);
              t.default = m;
            },
            function (e, t) {
              e.exports = {
                icon: "_3c0Qz",
                spin: "_1j2v0",
                "icon-spin": "-lu88",
                iconSpin: "-lu88",
              };
            },
            function (e, t) {
              e.exports = {
                "icon-address-book": "_35bgc",
                iconAddressBook: "_35bgc",
                "icon-address-card": "byXrR",
                iconAddressCard: "byXrR",
                "icon-adjust": "_128ri",
                iconAdjust: "_128ri",
                "icon-check-alt-light": "_1KHsi",
                iconCheckAltLight: "_1KHsi",
                "icon-coins-light": "_2bT-Y",
                iconCoinsLight: "_2bT-Y",
                "icon-exclamation-circle-light": "_3UEZX",
                iconExclamationCircleLight: "_3UEZX",
                "icon-loading-alt-light": "_1fXKU",
                iconLoadingAltLight: "_1fXKU",
                "icon-instagram": "_2OZ_n",
                iconInstagram: "_2OZ_n",
                "icon-minus-light": "_6cr8a",
                iconMinusLight: "_6cr8a",
                "icon-ticket-alt": "ZAGKa",
                iconTicketAlt: "ZAGKa",
                "icon-ticket-alt-light": "_1lH5w",
                iconTicketAltLight: "_1lH5w",
                "icon-plus-light": "_3BSr4",
                iconPlusLight: "_3BSr4",
                "icon-truck": "_4wlbR",
                iconTruck: "_4wlbR",
                "icon-trash-alt-light": "_26SUY",
                iconTrashAltLight: "_26SUY",
                "icon-times-circle": "_30-mD",
                iconTimesCircle: "_30-mD",
                "icon-vimeo-v": "_1_xvC",
                iconVimeoV: "_1_xvC",
                "icon-twitter": "_17P2f",
                iconTwitter: "_17P2f",
                "icon-youtube": "_2I_EY",
                iconYoutube: "_2I_EY",
                "icon-caret-down": "_3qb3s",
                iconCaretDown: "_3qb3s",
                "icon-caret-up": "_2jwD5",
                iconCaretUp: "_2jwD5",
                "icon-comments-o": "_19X43",
                iconCommentsO: "_19X43",
                "icon-download-o": "_2WwM4",
                iconDownloadO: "_2WwM4",
                "icon-info-circle-o": "_1shcg",
                iconInfoCircleO: "_1shcg",
                "icon-external-link-o": "_1qLWd",
                iconExternalLinkO: "_1qLWd",
                "icon-globe-o": "Z8Prc",
                iconGlobeO: "Z8Prc",
                "icon-question-o": "_3MItB",
                iconQuestionO: "_3MItB",
                "icon-play-circle-o": "_2Bvn6",
                iconPlayCircleO: "_2Bvn6",
                "icon-angle-double-left": "_3IVo_",
                iconAngleDoubleLeft: "_3IVo_",
                "icon-angle-down": "_34FGS",
                iconAngleDown: "_34FGS",
                "icon-angle-double-right": "_3e62_",
                iconAngleDoubleRight: "_3e62_",
                "icon-angle-left": "_1zbhS",
                iconAngleLeft: "_1zbhS",
                "icon-angle-right": "_27RtX",
                iconAngleRight: "_27RtX",
                "icon-angle-up": "jhfcy",
                iconAngleUp: "jhfcy",
                "icon-arrival-reminder": "Q82xM",
                iconArrivalReminder: "Q82xM",
                "icon-ban": "_1vyf0",
                iconBan: "_1vyf0",
                "icon-bullhorn": "B0IHZ",
                iconBullhorn: "B0IHZ",
                "icon-bars": "_2cpQ_",
                iconBars: "_2cpQ_",
                "icon-caret-left-o": "_2FImd",
                iconCaretLeftO: "_2FImd",
                "icon-caret-down-o": "_3wXJB",
                iconCaretDownO: "_3wXJB",
                "icon-caret-right-o": "_2fXyR",
                iconCaretRightO: "_2fXyR",
                "icon-caret-up-o": "_2KLCQ",
                iconCaretUpO: "_2KLCQ",
                "icon-cart": "_-4DAY",
                iconCart: "_-4DAY",
                "icon-certificate": "_2I4g3",
                iconCertificate: "_2I4g3",
                "icon-check-circle-o": "_1m5z7",
                iconCheckCircleO: "_1m5z7",
                "icon-check-square-o": "_1vR3p",
                iconCheckSquareO: "_1vR3p",
                "icon-check": "_2LJ7o",
                iconCheck: "_2LJ7o",
                "icon-circle-notch": "_3AQSX",
                iconCircleNotch: "_3AQSX",
                "icon-clock": "_3ASBw",
                iconClock: "_3ASBw",
                "icon-cog": "_6eszT",
                iconCog: "_6eszT",
                "icon-cloud-upload": "_1WxHW",
                iconCloudUpload: "_1WxHW",
                "icon-coins": "_2uv1U",
                iconCoins: "_2uv1U",
                "icon-compare": "_3s-NW",
                iconCompare: "_3s-NW",
                "icon-comment-alt-smile": "_1ZzVY",
                iconCommentAltSmile: "_1ZzVY",
                "icon-copy": "OBwuW",
                iconCopy: "OBwuW",
                "icon-compress": "_2Ri-k",
                iconCompress: "_2Ri-k",
                "icon-coupon": "_1588m",
                iconCoupon: "_1588m",
                "icon-credit-card": "_2uIqb",
                iconCreditCard: "_2uIqb",
                "icon-download": "_1P5xZ",
                iconDownload: "_1P5xZ",
                "icon-edit": "_2iuBX",
                iconEdit: "_2iuBX",
                "icon-ellipsis-h": "_1exha",
                iconEllipsisH: "_1exha",
                "icon-education": "_3bokS",
                iconEducation: "_3bokS",
                "icon-envelope": "vMM-Y",
                iconEnvelope: "vMM-Y",
                "icon-ellipsis-v": "_3jZwp",
                iconEllipsisV: "_3jZwp",
                "icon-exclamation-circle": "_2SUQ-",
                iconExclamationCircle: "_2SUQ-",
                "icon-exclamation": "_1Piil",
                iconExclamation: "_1Piil",
                "icon-exclamation-square": "_20oXE",
                iconExclamationSquare: "_20oXE",
                "icon-external-link": "_2gTe8",
                iconExternalLink: "_2gTe8",
                "icon-expand": "okv_Y",
                iconExpand: "okv_Y",
                "icon-eye": "_3l-6g",
                iconEye: "_3l-6g",
                "icon-file-alt": "OhY9C",
                iconFileAlt: "OhY9C",
                "icon-facebook": "Cb5jY",
                iconFacebook: "Cb5jY",
                "icon-file": "_1ajFe",
                iconFile: "_1ajFe",
                "icon-file-pdf": "ve2KQ",
                iconFilePdf: "ve2KQ",
                "icon-frame": "_3OU3j",
                iconFrame: "_3OU3j",
                "icon-globe": "lgV2x",
                iconGlobe: "lgV2x",
                "icon-headset": "_1gQtG",
                iconHeadset: "_1gQtG",
                "icon-heart-o": "_3Zaag",
                iconHeartO: "_3Zaag",
                "icon-home": "_33jTA",
                iconHome: "_33jTA",
                "icon-image-view": "_1jJbn",
                iconImageView: "_1jJbn",
                "icon-info-square": "UuxAk",
                iconInfoSquare: "UuxAk",
                "icon-info-circle": "_1OEuY",
                iconInfoCircle: "_1OEuY",
                "icon-info": "Lm_MF",
                iconInfo: "Lm_MF",
                "icon-language": "_3LwbN",
                iconLanguage: "_3LwbN",
                "icon-link": "_2XN05",
                iconLink: "_2XN05",
                "icon-list-view": "_33OcX",
                iconListView: "_33OcX",
                "icon-location-arrow": "bMc_E",
                iconLocationArrow: "bMc_E",
                "icon-list": "IAlEP",
                iconList: "IAlEP",
                "icon-location": "_25GQ2",
                iconLocation: "_25GQ2",
                "icon-lock-alt": "_3t3HT",
                iconLockAlt: "_3t3HT",
                "icon-map-marked-alt": "_2W_XA",
                iconMapMarkedAlt: "_2W_XA",
                "icon-map-marker-alt": "_3NPLS",
                iconMapMarkerAlt: "_3NPLS",
                "icon-minus": "UhwjW",
                iconMinus: "UhwjW",
                "icon-paperclip": "_2hDpl",
                iconPaperclip: "_2hDpl",
                "icon-order": "dCZz2",
                iconOrder: "dCZz2",
                "icon-play-circle": "_1FMUV",
                iconPlayCircle: "_1FMUV",
                "icon-phone": "_2H8bj",
                iconPhone: "_2H8bj",
                "icon-plus": "_3KkpT",
                iconPlus: "_3KkpT",
                "icon-purchase": "_23p5a",
                iconPurchase: "_23p5a",
                "icon-question-circle": "_18A_e",
                iconQuestionCircle: "_18A_e",
                "icon-qrcode": "gf_rb",
                iconQrcode: "gf_rb",
                "icon-search-minus": "_1Djb6",
                iconSearchMinus: "_1Djb6",
                "icon-search": "_3d-6G",
                iconSearch: "_3d-6G",
                "icon-setup": "_1fawl",
                iconSetup: "_1fawl",
                "icon-search-plus": "_20uY7",
                iconSearchPlus: "_20uY7",
                "icon-tag": "_2Z6dE",
                iconTag: "_2Z6dE",
                "icon-share": "_1c3Qh",
                iconShare: "_1c3Qh",
                "icon-times-circle-o": "_1GlZx",
                iconTimesCircleO: "_1GlZx",
                "icon-times": "_3hG3b",
                iconTimes: "_3hG3b",
                "icon-times-square-o": "_15wCJ",
                iconTimesSquareO: "_15wCJ",
                "icon-trash-alt": "_1Rw_U",
                iconTrashAlt: "_1Rw_U",
                "icon-truck-moving": "_2Jlwc",
                iconTruckMoving: "_2Jlwc",
                "icon-unfold": "_1bahP",
                iconUnfold: "_1bahP",
                "icon-unlock-alt": "_27Nd-",
                iconUnlockAlt: "_27Nd-",
                "icon-user": "_3To44",
                iconUser: "_3To44",
                "icon-users": "_1O_Hy",
                iconUsers: "_1O_Hy",
                "icon-video": "W6H_f",
                iconVideo: "W6H_f",
                "icon-fa-light-redo": "_2_sls",
                iconFaLightRedo: "_2_sls",
                "icon-fa-solid-play": "_35BGQ",
                iconFaSolidPlay: "_35BGQ",
                "icon-download-black-main": "_3xfLM",
                iconDownloadBlackMain: "_3xfLM",
                "icon-plus-circle": "_1pvYF",
                iconPlusCircle: "_1pvYF",
              };
            },
            function (e, t) {
              e.exports = {
                icons: [
                  { name: "address-book", unicode: "f2b9" },
                  { name: "address-card", unicode: "f2bb" },
                  { name: "adjust", unicode: "f042" },
                  { name: "check-alt-light", unicode: "e917" },
                  { name: "coins-light", unicode: "e348" },
                  { name: "exclamation-circle-light", unicode: "eca2" },
                  { name: "loading-alt-light", unicode: "ee57" },
                  { name: "instagram", unicode: "f16d" },
                  { name: "minus-light", unicode: "e719" },
                  { name: "ticket-alt", unicode: "f3ff" },
                  { name: "ticket-alt-light", unicode: "ebad" },
                  { name: "plus-light", unicode: "e8b5" },
                  { name: "truck", unicode: "f0d1" },
                  { name: "trash-alt-light", unicode: "e3a8" },
                  { name: "times-circle", unicode: "f057" },
                  { name: "vimeo-v", unicode: "f27d" },
                  { name: "twitter", unicode: "f099" },
                  { name: "youtube", unicode: "f167" },
                  { name: "caret-down", unicode: "f0d7" },
                  { name: "caret-up", unicode: "f0d8" },
                  { name: "comments-o", unicode: "ecde" },
                  { name: "download-o", unicode: "e6c0" },
                  { name: "info-circle-o", unicode: "ed3f" },
                  { name: "external-link-o", unicode: "ebd6" },
                  { name: "globe-o", unicode: "efe0" },
                  { name: "question-o", unicode: "e65f" },
                  { name: "play-circle-o", unicode: "e0ca" },
                  { name: "angle-double-left", unicode: "f100" },
                  { name: "angle-down", unicode: "f107" },
                  { name: "angle-double-right", unicode: "f101" },
                  { name: "angle-left", unicode: "f104" },
                  { name: "angle-right", unicode: "f105" },
                  { name: "angle-up", unicode: "f106" },
                  { name: "arrival-reminder", unicode: "e386" },
                  { name: "ban", unicode: "f05e" },
                  { name: "bullhorn", unicode: "f0a1" },
                  { name: "bars", unicode: "f0c9" },
                  { name: "caret-left-o", unicode: "eb68" },
                  { name: "caret-down-o", unicode: "ec02" },
                  { name: "caret-right-o", unicode: "ef8e" },
                  { name: "caret-up-o", unicode: "edd8" },
                  { name: "cart", unicode: "e540" },
                  { name: "certificate", unicode: "f0a3" },
                  { name: "check-circle-o", unicode: "e753" },
                  { name: "check-square-o", unicode: "ee6b" },
                  { name: "check", unicode: "f00c" },
                  { name: "circle-notch", unicode: "f1ce" },
                  { name: "clock", unicode: "f017" },
                  { name: "cog", unicode: "f013" },
                  { name: "cloud-upload", unicode: "f0ee" },
                  { name: "coins", unicode: "e688" },
                  { name: "compare", unicode: "e1f8" },
                  { name: "comment-alt-smile", unicode: "e7e4" },
                  { name: "copy", unicode: "f0c5" },
                  { name: "compress", unicode: "f066" },
                  { name: "coupon", unicode: "ed6e" },
                  { name: "credit-card", unicode: "f09d" },
                  { name: "download", unicode: "f019" },
                  { name: "edit", unicode: "f044" },
                  { name: "ellipsis-h", unicode: "f141" },
                  { name: "education", unicode: "ed0b" },
                  { name: "envelope", unicode: "f0e0" },
                  { name: "ellipsis-v", unicode: "f142" },
                  { name: "exclamation-circle", unicode: "f06a" },
                  { name: "exclamation", unicode: "f12a" },
                  { name: "exclamation-square", unicode: "f321" },
                  { name: "external-link", unicode: "f08e" },
                  { name: "expand", unicode: "f065" },
                  { name: "eye", unicode: "f06e" },
                  { name: "file-alt", unicode: "f15c" },
                  { name: "facebook", unicode: "f09a" },
                  { name: "file", unicode: "f15b" },
                  { name: "file-pdf", unicode: "f1c1" },
                  { name: "frame", unicode: "edcf" },
                  { name: "globe", unicode: "f0ac" },
                  { name: "headset", unicode: "e902" },
                  { name: "heart-o", unicode: "ee55" },
                  { name: "home", unicode: "f015" },
                  { name: "image-view", unicode: "e348" },
                  { name: "info-square", unicode: "f30f" },
                  { name: "info-circle", unicode: "f05a" },
                  { name: "info", unicode: "f129" },
                  { name: "language", unicode: "f1ab" },
                  { name: "link", unicode: "f0c1" },
                  { name: "list-view", unicode: "e8c1" },
                  { name: "location-arrow", unicode: "f124" },
                  { name: "list", unicode: "f03a" },
                  { name: "location", unicode: "ed51" },
                  { name: "lock-alt", unicode: "f30d" },
                  { name: "map-marked-alt", unicode: "ee36" },
                  { name: "map-marker-alt", unicode: "f3c5" },
                  { name: "minus", unicode: "f068" },
                  { name: "paperclip", unicode: "f0c6" },
                  { name: "order", unicode: "e70a" },
                  { name: "play-circle", unicode: "f144" },
                  { name: "phone", unicode: "f095" },
                  { name: "plus", unicode: "f067" },
                  { name: "purchase", unicode: "e85d" },
                  { name: "question-circle", unicode: "f059" },
                  { name: "qrcode", unicode: "f029" },
                  { name: "search-minus", unicode: "f010" },
                  { name: "search", unicode: "f002" },
                  { name: "setup", unicode: "ea0f" },
                  { name: "search-plus", unicode: "f00e" },
                  { name: "tag", unicode: "f02b" },
                  { name: "share", unicode: "f064" },
                  { name: "times-circle-o", unicode: "e200" },
                  { name: "times", unicode: "f00d" },
                  { name: "times-square-o", unicode: "eea2" },
                  { name: "trash-alt", unicode: "f2ed" },
                  { name: "truck-moving", unicode: "eaaa" },
                  { name: "unfold", unicode: "e872" },
                  { name: "unlock-alt", unicode: "f13e" },
                  { name: "user", unicode: "f007" },
                  { name: "users", unicode: "f0c0" },
                  { name: "video", unicode: "f03d" },
                  { name: "fa-light-redo", unicode: "e087" },
                  { name: "fa-solid-play", unicode: "e665" },
                  { name: "download-black-main", unicode: "e111" },
                  { name: "plus-circle", unicode: "f055" },
                ],
                total: 120,
                cssPrefix: "icon-",
                fontFamily: "quark",
              };
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t) {
              e.exports = i;
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(16)),
                r = o(n(13)),
                i = o(n(14)),
                l = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                s = o(n(12)),
                c = o(n(151)),
                _ = n(153),
                u = (function () {
                  var e =
                    i.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, r.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                d =
                  a.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                p = (function (e) {
                  function t() {
                    var t = (null !== e && e.apply(this, arguments)) || this;
                    return (
                      (t.saveSlick = function (e) {
                        t.slick = e;
                      }),
                      t
                    );
                  }
                  return (
                    u(t, e),
                    (t.prototype.slickNext = function () {
                      this.slick.slickNext();
                    }),
                    (t.prototype.slickPrev = function () {
                      this.slick.slickPrev();
                    }),
                    (t.prototype.slickGoTo = function (e, t) {
                      this.slick.slickGoTo(e, t);
                    }),
                    (t.prototype.render = function () {
                      var e = this.props;
                      return l.createElement(
                        c.default,
                        d({ ref: this.saveSlick }, e),
                      );
                    }),
                    (t.propTypes = {
                      prevArrow: s.default.node,
                      nextArrow: s.default.node,
                    }),
                    (t.defaultProps = {
                      prevArrow: l.createElement(_.PrevArrow, null),
                      nextArrow: l.createElement(_.NextArrow, null),
                    }),
                    t
                  );
                })(l.Component);
              t.default = p;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(16)),
                r = o(n(13)),
                i = o(n(14)),
                l = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                s = o(n(12)),
                c = o(n(91)),
                _ = o(n(23)),
                u = (function () {
                  var e =
                    i.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, r.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                d =
                  a.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  };
              "undefined" != typeof window &&
                (window.matchMedia =
                  window.matchMedia ||
                  function (e) {
                    return {
                      media: e,
                      matches: !1,
                      addListener: function () {},
                      removeListener: function () {},
                    };
                  });
              var p = n(152).default,
                f = (function (e) {
                  function t(t) {
                    var n = e.call(this, t) || this;
                    return (
                      (n.onWindowResized = function () {
                        n.props.autoplay &&
                          n.slick &&
                          n.slick.innerSlider &&
                          n.slick.innerSlider.autoPlay &&
                          n.slick.innerSlider.autoPlay();
                      }),
                      (n.saveSlick = function (e) {
                        n.slick = e;
                      }),
                      (n.onWindowResized = (0, c.default)(
                        n.onWindowResized,
                        500,
                        { leading: !1 },
                      )),
                      n
                    );
                  }
                  return (
                    u(t, e),
                    (t.prototype.componentDidMount = function () {
                      this.props.autoplay &&
                        window.addEventListener("resize", this.onWindowResized),
                        (this.innerSlider =
                          this.slick && this.slick.innerSlider);
                    }),
                    (t.prototype.componentWillUnmount = function () {
                      this.props.autoplay &&
                        window.removeEventListener(
                          "resize",
                          this.onWindowResized,
                        );
                    }),
                    (t.prototype.slickNext = function () {
                      this.slick.slickNext();
                    }),
                    (t.prototype.slickPrev = function () {
                      this.slick.slickPrev();
                    }),
                    (t.prototype.slickGoTo = function (e, t) {
                      this.slick.slickGoTo(e, t);
                    }),
                    (t.prototype.render = function () {
                      var e = d({}, this.props);
                      "fade" === e.effect && (e.fade = !0);
                      var t = e.vertical ? "carousel-vertical" : "carousel",
                        n = (0, _.default)(e.className, t);
                      return l.createElement(
                        "div",
                        { className: n },
                        l.createElement(p, d({ ref: this.saveSlick }, e)),
                      );
                    }),
                    (t.propTypes = { className: s.default.string }),
                    (t.defaultProps = {
                      dots: !1,
                      arrows: !1,
                      draggable: !0,
                      infinite: !0,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      speed: 500,
                    }),
                    t
                  );
                })(l.PureComponent);
              t.default = f;
            },
            function (e, t) {
              e.exports = l;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 }),
                (t.NextArrow = t.PrevArrow = void 0);
              var a = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                r = o(n(65)),
                i = o(n(154));
              (t.PrevArrow = function (e) {
                var t = e.className,
                  n = e.onClick;
                return a.createElement(
                  "div",
                  { className: t, onClick: n },
                  a.createElement(r.default, {
                    name: "angle-left",
                    className: i.default.angleLeft,
                  }),
                );
              }),
                (t.NextArrow = function (e) {
                  var t = e.className,
                    n = e.onClick;
                  return a.createElement(
                    "div",
                    { className: t, onClick: n },
                    a.createElement(r.default, {
                      name: "angle-right",
                      className: i.default.angleRight,
                    }),
                  );
                });
            },
            function (e, t) {
              e.exports = {
                "slick-loading": "_1dFgn",
                slickLoading: "_1dFgn",
                "angle-left": "ZJnnz",
                angleLeft: "ZJnnz",
                "angle-right": "_3ctaf",
                angleRight: "_3ctaf",
              };
            },
          ])));
    },
    Enrl: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return ee;
      });
      var o = n("wx14"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("rePB"),
        u = n("q1tI"),
        d = n.n(u),
        p = n("17x9"),
        f = n.n(p),
        h = f.a.string,
        m = (f.a.bool, f.a.number, f.a.oneOfType),
        y =
          (f.a.object,
          f.a.func,
          f.a.node,
          f.a.array,
          f.a.element,
          h || m([h]),
          function () {}),
        b = {
          url: "https://www1.djicdn.com/assets/uploads/367aeda57cc2ddasd/5e9812ec6728934647dd022584974c07.mp4",
          playing: !1,
          loop: !1,
          muted: !0,
          width: "100%",
          height: "100%",
          style: { margin: "0 auto" },
          light: !1,
          poster: "",
          frameAddress: "",
          frameCount: 60,
          frameFormat: "jpg",
          canvasWidth: 360,
          canvasHeight: 360,
          fps: 24,
          lazyload: !0,
          lazyLoadThreshold: 1200,
          visibleplay: !0,
          showWholeElmplay: !1,
          replayWhenRevisbile: !1,
          resetFirstFrame: !1,
          fixIOSVideoBorder: !1,
          mDowngradeDomStyle: {},
          mDowngradeVideoLink: "",
          mdowngradeVideoPoster: "",
          mdowngradeVideoHoldPoster: "",
          playClassName: void 0,
          pauseClassName: void 0,
          loadingClassName: void 0,
          replayClassName: null,
          replayIconDom: null,
          onReady: y,
          onStart: y,
          onPlay: y,
          onPause: y,
          onEnded: y,
          onError: y,
        },
        v = n("r7AC"),
        g = n("/+VL"),
        w = n("gn4A"),
        x = n.n(w),
        k = d.a.createElement;
      function O(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var I = "PAUSE",
        S = "PLAY",
        j = "END",
        T = "INIT",
        C = ["webm", "mp4"],
        M = (function (e) {
          function t(e) {
            var n;
            return (
              Object(a.default)(this, t),
              ((n = O(this, t, [e])).state = {
                isIOS: !1,
                videoLazyLoad: !1 === e.lazyload,
              }),
              (n.mounted = !1),
              (n.isReady = !1),
              (n.isPlaying = !1),
              (n.isLoading = !0),
              (n.loadOnReady = null),
              (n.startOnPlay = !0),
              (n.played = !1),
              (n.removeVideoSrcAttr = !1),
              (n.videoPlayed = !1),
              (n.listenEvent = null),
              (n.listenersToRemove = []),
              (n.handlePlayerMount = n.handlePlayerMount.bind(Object(s.a)(n))),
              (n.handleReady = n.handleReady.bind(Object(s.a)(n))),
              (n.handlePlay = n.handlePlay.bind(Object(s.a)(n))),
              (n.handlePause = n.handlePause.bind(Object(s.a)(n))),
              (n.handleEnded = n.handleEnded.bind(Object(s.a)(n))),
              (n.handleLoaded = n.handleLoaded.bind(Object(s.a)(n))),
              (n.handleError = n.handleError.bind(Object(s.a)(n))),
              (n.lazyLoadVideo = n.lazyLoadVideo.bind(Object(s.a)(n))),
              (n.triggerPlay = n.triggerPlay.bind(Object(s.a)(n))),
              (n.triggerPause = n.triggerPause.bind(Object(s.a)(n))),
              (n.handleReplay = n.handleReplay.bind(Object(s.a)(n))),
              (n.handleReplayWhenVisibleplayOnce =
                n.handleReplayWhenVisibleplayOnce.bind(Object(s.a)(n))),
              (n.setVideoLazyload = n.setVideoLazyload.bind(Object(s.a)(n))),
              n
            );
          }
          return (
            Object(c.a)(t, e),
            Object(r.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this;
                  this.mounted = !0;
                  var t = window.navigator.userAgent,
                    n = !!t.match(/iPad/i) || !!t.match(/iPhone/i);
                  this.setState({ isIOS: n }, function () {
                    var t = e.props,
                      n = t.pauseClassName,
                      o = t.playClassName,
                      a = t.loadingClassName;
                    n && e.initPauseBtn(),
                      o && e.initPlayBtn(),
                      a && e.initLoadingState();
                  });
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  (this.mounted = !1),
                    this.listenersToRemove.forEach(function (e) {
                      "function" === typeof e && e();
                    });
                },
              },
              {
                key: "UNSAFE_componentWillReceiveProps",
                value: function (e) {
                  e &&
                    e.lazyload !== this.props.lazyload &&
                    !e.lazyload &&
                    this.setVideoLazyload(!0);
                },
              },
              {
                key: "setVideoLazyload",
                value: function (e) {
                  this.setState({ videoLazyLoad: e });
                },
              },
              {
                key: "handlePlayerMount",
                value: function (e) {
                  var t = this.props,
                    n = t.url,
                    o = t.lazyload;
                  (this.player = e),
                    o ? this.lazyLoadVideo() : this.player.load(n);
                },
              },
              {
                key: "lazyLoadVideo",
                value: function () {
                  var e = this,
                    t = this.props.lazyLoadThreshold;
                  Object(v.b)({
                    elm: this.player.videoDom,
                    offset: t,
                    callback: function (t) {
                      t.inView && e.setState({ videoLazyLoad: !0 });
                    },
                  });
                },
              },
              {
                key: "handleReady",
                value: function () {
                  if (this.mounted) {
                    (this.isReady = !0), (this.isLoading = !1);
                    var e = this.props,
                      t = e.onReady,
                      n = e.playing,
                      o = e.visibleplay,
                      a = e.showWholeElmPlay,
                      r = e.replayClassName;
                    t(),
                      this.loadOnReady
                        ? (this.player.load(this.loadOnReady, !0),
                          (this.loadOnReady = null))
                        : n
                          ? (this.player.play(), this.setButtons(S))
                          : (o || a) && this.addScrollEventListener(),
                      r && this.handleReplay();
                  }
                },
              },
              {
                key: "triggerPlay",
                value: function () {
                  this.player.play();
                },
              },
              {
                key: "triggerPause",
                value: function () {
                  this.player.pause();
                },
              },
              {
                key: "handlePlay",
                value: function () {
                  (this.isPlaying = !0), (this.isLoading = !1);
                  var e = this.props,
                    t = e.onStart,
                    n = e.onPlay;
                  this.startOnPlay && (t(), (this.startOnPlay = !1)), n();
                },
              },
              {
                key: "handlePause",
                value: function (e) {
                  this.isPlaying = !1;
                  var t = this.props.onPause;
                  this.isLoading || t(e);
                },
              },
              {
                key: "handleEnded",
                value: function () {
                  var e = this.props,
                    t = e.loop,
                    n = e.onEnded;
                  e.resetFirstFrame &&
                    this.player &&
                    this.player.videoDom &&
                    (this.player.videoDom.currentTime = 0),
                    t && this.player.seekTo(0),
                    t || ((this.isPlaying = !1), n());
                },
              },
              {
                key: "handleLoaded",
                value: function () {
                  this.isLoading = !1;
                },
              },
              {
                key: "handleError",
                value: function () {
                  var e = this.props.onError;
                  (this.isLoading = !1), e.apply(void 0, arguments);
                },
              },
              {
                key: "handleReplayWhenVisibleplayOnce",
                value: function () {
                  if (
                    !this.replayBtnSet &&
                    ((this.replayBtnSet = !0), this.props.replayClassName)
                  ) {
                    var e = this.player && this.player.videoDom;
                    e && e.currentTime && (e.currentTime = 0),
                      this.setButtons(j);
                  }
                },
              },
              {
                key: "addScrollEventListener",
                value: function () {
                  var e = this,
                    t = this,
                    n = this.props,
                    o = n.replayWhenRevisible,
                    a = n.showWholeElmPlay,
                    r = n.resetFirstFrame;
                  g.a.getInstance().addNode(
                    t.player.videoDom,
                    {
                      scrollIntoView: function () {
                        if (
                          ((e.notVisibleSet = !1),
                          (e.replayBtnSet = !1),
                          !r || !e.played)
                        )
                          if (o)
                            t.isPlaying ||
                              (t.player.play(),
                              (t.videoPlayed = !0),
                              (t.played = !0),
                              t.setButtons(S));
                          else {
                            if (t.videoPlayed) return;
                            t.player.play(),
                              (t.videoPlayed = !0),
                              (t.played = !0),
                              t.setButtons(S);
                          }
                      },
                      scrollOutOfWiew: function () {
                        e.notVisibleSet ||
                          ((e.notVisibleSet = !0),
                          o && (t.played = !1),
                          t.player.pause(),
                          e.setButtons(I),
                          t.player.videoDom &&
                            t.player.videoDom.currentTime &&
                            r &&
                            (t.player.videoDom.currentTime = 0)),
                          (r && e.played) ||
                            o ||
                            (t.videoPlayed &&
                              e.handleReplayWhenVisibleplayOnce());
                      },
                    },
                    void 0,
                    100,
                    !1,
                    a ? 1 : 0,
                  );
                },
              },
              {
                key: "handleReplay",
                value: function () {
                  var e = this,
                    t = this,
                    n = t.player.videoDom,
                    o = n && n.nextSibling;
                  if (o) {
                    var a = function () {
                        e.setButtons(j), n.pause();
                      },
                      r = function () {
                        (n.currentTime = 0), t.triggerPlay(), t.setButtons(S);
                      };
                    n.addEventListener("ended", a),
                      o.addEventListener("click", r),
                      t.listenersToRemove.push(function () {
                        n.removeEventListener("ended", a),
                          o.removeEventListener("click", r);
                      });
                  }
                },
              },
              {
                key: "setButtons",
                value: function (e) {
                  var t = this.player,
                    n = t.replayBtn,
                    o = t.pauseBtn,
                    a = t.playBtn,
                    r = function (e, t) {
                      e && (e.style.display = t ? "block" : "none");
                    };
                  e === j
                    ? (r(n, !0), r(a, !1), r(o, !1))
                    : e === S
                      ? (r(n, !1), r(a, !1), r(o, !0))
                      : e === I
                        ? (r(n, !1), r(a, !0), r(o, !1))
                        : e === T && r(a, !0);
                },
              },
              {
                key: "initPauseBtn",
                value: function () {
                  var e = this,
                    t = this.player,
                    n = t.videoDom,
                    o = t.pauseBtn;
                  if (o) {
                    var a = function () {
                      n.pause(), e.setButtons(I);
                    };
                    o.addEventListener("click", a),
                      this.listenersToRemove.push(function () {
                        o.removeEventListener("click", a);
                      });
                  }
                },
              },
              {
                key: "initPlayBtn",
                value: function () {
                  var e = this,
                    t = this,
                    n = t.player.playBtn;
                  if (n) {
                    this.setButtons(T);
                    var o = function () {
                      t.triggerPlay(), e.setButtons(S);
                    };
                    n.addEventListener("click", o),
                      this.listenersToRemove.push(function () {
                        n.removeEventListener("click", o);
                      });
                  }
                },
              },
              {
                key: "initLoadingState",
                value: function () {
                  var e = this.player,
                    t = e.videoDom,
                    n = e.replayBtn,
                    o = e.pauseBtn,
                    a = e.playBtn,
                    r = e.loadingBtn,
                    i = function (e, t) {
                      e &&
                        (t
                          ? ((e.style.opacity = ""),
                            (e.style.pointerEvents = "auto"))
                          : ((e.style.opacity = 0),
                            (e.style.pointerEvents = "none")));
                    },
                    l = function () {
                      (r.style.opacity = 1), i(a, !1), i(o, !1), i(n, !1);
                    },
                    s = function () {
                      l();
                    },
                    c = function () {
                      (r.style.opacity = 0), i(a, !0), i(o, !0), i(n, !0);
                    };
                  t.addEventListener("loadstart", function e() {
                    l(), t.removeEventListener("loadstart", e);
                  }),
                    t.addEventListener("waiting", s),
                    t.addEventListener("canplay", c),
                    this.listenersToRemove.push(function () {
                      t.removeEventListener("waiting", s),
                        t.removeEventListener("canplay", c);
                    });
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this.props.activePlayer;
                  if (!e) return null;
                  var t = this.state,
                    n = t.videoLazyLoad,
                    a = t.isIOS,
                    r =
                      this.props.url instanceof Array
                        ? this.props.url.sort(function (e, t) {
                            return (
                              C.indexOf(x.a.getFileExtendingName(e)) -
                              C.indexOf(x.a.getFileExtendingName(t))
                            );
                          })
                        : [this.props.url],
                    i = this.props.fixIOSVideoBorder && a;
                  return k(
                    e,
                    Object(o.a)({}, this.props, {
                      sortUrl: r,
                      videoLazyLoad: n,
                      onMount: this.handlePlayerMount,
                      onReady: this.handleReady,
                      onPlay: this.handlePlay,
                      onPause: this.handlePause,
                      onEnded: this.handleEnded,
                      onLoaded: this.handleLoaded,
                      onError: this.handleError,
                      fixVideoBorder: i,
                    }),
                  );
                },
              },
            ]),
            t
          );
        })(u.Component);
      (M.displayName = "Player"), (M.defaultProps = b);
      var P = n("iKuz"),
        E = n.n(P),
        L = n("Cc7j"),
        B = n("XrJB"),
        N = n.n(B),
        D = (n("bck3"), d.a.createElement);
      function z(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function A(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? z(Object(n), !0).forEach(function (t) {
                Object(_.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : z(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function R(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var F = (function (e) {
          function t(e) {
            var n;
            return (
              Object(a.default)(this, t),
              (n = R(this, t, [e])),
              Object(_.a)(Object(s.a)(n), "renderNextFrame", function () {
                var e = n.state,
                  t = e.isPlaying,
                  o = e.currentFrame,
                  a = e.showWholeElmPlay,
                  r = n.props,
                  i = r.loop,
                  l = r.resetFirstFrame;
                if (t) {
                  var s = a
                    ? x.a.showWholeElm(n.canvas)
                    : Object(v.d)(n.canvas);
                  (((o !== n.frames.length - 1 || i) && s) || (n.pause(), l)) &&
                    n.setState({ currentFrame: n.getNextFrame() }, n.drawFrame);
                }
              }),
              Object(_.a)(Object(s.a)(n), "pause", function () {
                n.setState({ isPlaying: !1, pause: !0, currentFrame: 0 });
              }),
              Object(_.a)(Object(s.a)(n), "play", function (e) {
                var t = n.state,
                  o = t.isPlaying,
                  a = t.fps;
                if (o) {
                  var r,
                    i,
                    l,
                    s = performance.now();
                  !(function t() {
                    (r = performance.now()), (i = r - s);
                    var o = Math.round(1e3 / a);
                    i > o && (e(), (s = r)),
                      n.state.isPlaying
                        ? (l = requestAnimationFrame(t))
                        : l && window.cancelAnimationFrame(t);
                  })();
                }
              }),
              (n.frames = []),
              (n.htmlImageElements = []),
              (n.state = {
                canvasWidth: e.canvasWidth,
                canvasHeight: e.canvasHeight,
                pause: !1,
                currentFrame: 0,
                fps: e.fps,
                loading: !0,
                isPlaying: !1,
                htmlImageElements: null,
                loadingProgress: {
                  loadingComplete: !1,
                  totalLoaded: 0,
                  totalFramesToLoad: 0,
                },
              }),
              (n.preloadImage = n.preloadImage.bind(Object(s.a)(n))),
              (n.loadPoster = n.loadPoster.bind(Object(s.a)(n))),
              (n.resizeCanvas = n.resizeCanvas.bind(Object(s.a)(n))),
              n
            );
          }
          return (
            Object(c.a)(t, e),
            Object(r.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this.props,
                    t = e.onPlayerMount;
                  e.canvasHeight, e.canvasWidth;
                  t && t(this),
                    this.canvas && (this.ctx = this.canvas.getContext("2d"));
                },
              },
              {
                key: "onLoad",
                value: function () {
                  var e = this.props.onLoad;
                  e.apply(void 0, arguments);
                },
              },
              {
                key: "getNextFrame",
                value: function () {
                  var e = this.state.currentFrame;
                  return e === this.frames.length - 1 ? 0 : e + 1;
                },
              },
              {
                key: "resizeCanvas",
                value: function () {
                  var e = this.props,
                    t = e.canvasWidth / e.canvasHeight,
                    n = window.innerWidth,
                    o = n / t,
                    a = n;
                  this.setState({ canvasHeight: o, canvasWidth: a });
                },
              },
              {
                key: "handlePlay",
                value: function () {
                  var e = this;
                  this.setState({ isPlaying: !0, pause: !1 }, function () {
                    e.play(e.renderNextFrame);
                  });
                },
              },
              {
                key: "togglePlay",
                value: function () {
                  var e = this;
                  this.setState(
                    { isPlaying: !this.state.isPlaying },
                    function () {
                      e.state.isPlaying && e.play(e.renderNextFrame);
                    },
                  );
                },
              },
              {
                key: "drawFrame",
                value: function () {
                  var e,
                    t = this.state,
                    n = t.currentFrame,
                    o = t.htmlImageElements,
                    a = t.posterImg,
                    r = this.props,
                    i = r.canvasHeight,
                    l = r.canvasWidth;
                  a &&
                    this.canvas &&
                    ((e = o ? o[n] : a),
                    this.canvas &&
                      this.ctx &&
                      ((this.canvas.width = l),
                      (this.canvas.height = i),
                      this.ctx.drawImage(e, 0, 0, l, i)));
                },
              },
              {
                key: "loadPoster",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.frameAddress,
                    o = t.frameFormat,
                    a = new Image();
                  (a.src = "".concat(n, 0, ".").concat(o)),
                    (a.onload = function () {
                      e.setState({ posterImg: a }), e.drawFrame(a);
                    });
                },
              },
              {
                key: "preloadImage",
                value: function (e) {
                  var t = this,
                    n = this.props,
                    o = n.canvasHeight,
                    a = n.canvasWidth,
                    r = this.state.loadingProgress,
                    i = [];
                  (this.frames = e),
                    this.frames.forEach(function (e, n) {
                      var r = new Image();
                      (r.src = e), t.htmlImageElements.push(r);
                      var l = new Promise(function (e, t) {
                        (r.onload = function () {
                          return e(r);
                        }),
                          (r.onerror = t);
                      }).then(function (e) {
                        0 === n && (t.framesSize = { width: a, height: o });
                      });
                      i.push(l);
                    }),
                    Promise.all(i).then(function () {
                      t.setState(
                        {
                          loadingProgress: A(
                            A({}, r),
                            {},
                            {
                              totalLoaded: t.htmlImageElements.length,
                              loadingComplete: !0,
                            },
                          ),
                          loading: !0,
                          htmlImageElements: t.htmlImageElements,
                        },
                        t.drawFrame,
                      ),
                        t.onLoad(!0);
                    });
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props.render,
                    n = function (t) {
                      e.canvas = t;
                    };
                  return t({
                    renderViewer: D("canvas", { ref: n }),
                    getCanvasRef: n,
                  });
                },
              },
            ]),
            t
          );
        })(u.Component),
        V = d.a.createElement;
      function H(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var W = (function (e) {
        function t(e) {
          var n;
          return (
            Object(a.default)(this, t),
            ((n = H(this, t)).imageList = []),
            (n.listenersToRemove = []),
            (n.handleCanvasPlayerMount = n.handleCanvasPlayerMount.bind(
              Object(s.a)(n),
            )),
            (n.handleLoad = n.handleLoad.bind(Object(s.a)(n))),
            (n.listenWindowOnLoad = n.listenWindowOnLoad.bind(Object(s.a)(n))),
            n
          );
        }
        return (
          Object(c.a)(t, e),
          Object(r.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                this.listenWindowOnLoad();
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                this.listenersToRemove.forEach(function (e) {
                  "function" === typeof e && e();
                });
              },
            },
            {
              key: "listenWindowOnLoad",
              value: function () {
                var e = this,
                  t = !1;
                "complete" !== document.readyState
                  ? (window.addEventListener("load", function () {
                      t ||
                        (e.canvasPlayer.loadPoster(),
                        e.canvasPlayer.preloadImage(e.imageList),
                        (t = !0));
                    }),
                    setTimeout(function () {
                      t ||
                        (e.canvasPlayer.loadPoster(),
                        e.canvasPlayer.preloadImage(e.imageList),
                        (t = !0));
                    }, 3e3))
                  : (this.canvasPlayer.loadPoster(),
                    this.canvasPlayer.preloadImage(this.imageList));
              },
            },
            {
              key: "handleCanvasPlayerMount",
              value: function (e) {
                for (
                  var t = this.props,
                    n = t.frameCount,
                    o = t.frameAddress,
                    a = t.frameFormat,
                    r = [],
                    i = 0;
                  i < n;
                  i += 1
                ) {
                  var l = "".concat(o).concat(i, ".").concat(a);
                  r.push(l);
                }
                (this.imageList = r), (this.canvasPlayer = e);
              },
            },
            {
              key: "handleLoad",
              value: function (e) {
                var t = this.props,
                  n = t.playing,
                  o = t.visibleplay,
                  a = t.showWholeElmPlay;
                n
                  ? this.canvasPlayer.handlePlay()
                  : (o || a) && this.addScrollEventListener();
              },
            },
            {
              key: "addScrollEventListener",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.replayWhenRevisible,
                  o = t.showWholeElmPlay,
                  a = !1,
                  r = !1;
                if (e.canvasPlayer || e.canvasPlayer.canvas) {
                  var i = function (t) {
                    var o = t.inView,
                      i = t.observer;
                    if ((o || e.canvasPlayer.pause(), n))
                      o && !a && (e.canvasPlayer.handlePlay(), (r = !0)),
                        (a = o);
                    else {
                      if (r || !o) return;
                      e.canvasPlayer.handlePlay(), (r = !0), i.disconnect();
                    }
                    return !0;
                  };
                  o
                    ? Object(v.b)({
                        elm: e.canvasPlayer.canvas,
                        threshold: 1,
                        callback: i,
                      })
                    : Object(v.b)({ elm: e.canvasPlayer.canvas, callback: i });
                }
              },
            },
            {
              key: "render",
              value: function () {
                return V(
                  "div",
                  null,
                  V(
                    F,
                    Object(o.a)({}, this.props, {
                      onPlayerMount: this.handleCanvasPlayerMount,
                      onLoad: this.handleLoad,
                      render: function (e) {
                        var t = e.getCanvasRef;
                        e.loadingProgress;
                        return V(
                          "div",
                          null,
                          V(
                            "div",
                            { style: { maxWidth: 274 } },
                            V("canvas", { ref: t }),
                          ),
                        );
                      },
                    }),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(u.Component);
      Object(_.a)(W, "defaultProps", b);
      n("aiR1");
      var U = n("yWgo"),
        G = (n("qJuD"), d.a.createElement),
        Y = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "video-player-component": "style__video-player-component___1LtC2",
            "video-player-box": "style__video-player-box___2yF0u",
            "video-player-wrapper": "style__video-player-wrapper___1AN4l",
            "fix-video-border": "style__fix-video-border___s6bUG",
            "video-player-poster": "style__video-player-poster___aDPVq",
            "video-player-downgrade-m":
              "style__video-player-downgrade-m___1uETX",
            "video-player-downgrade-m-btn":
              "style__video-player-downgrade-m-btn___1vWvy",
            "video-player-dom": "style__video-player-dom___FGbd_",
            "video-player-box-m": "style__video-player-box-m___3ogLP",
            "replay-btn": "style__replay-btn___2zwuY",
            "pause-btn": "style__pause-btn___zsEID",
            "play-btn": "style__play-btn___3bu6r",
            "loading-btn": "style__loading-btn___3ngla",
            "replay-btn-icon": "style__replay-btn-icon___27gnm",
          },
        };
      function q(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function X(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var Z = (function (e) {
          function t(e) {
            var n;
            return (
              Object(a.default)(this, t),
              ((n = X(this, t, [e])).state = {
                downgrade: !1,
                isMobile: !1,
                videoSource: e.sortUrl,
                isIE: !1,
              }),
              (n.lazyloaded = !1),
              (n.onReady = n.onReady.bind(Object(s.a)(n))),
              (n.onPlay = n.onPlay.bind(Object(s.a)(n))),
              (n.onPause = n.onPause.bind(Object(s.a)(n))),
              (n.onEnded = n.onEnded.bind(Object(s.a)(n))),
              (n.onError = n.onError.bind(Object(s.a)(n))),
              (n.renderSourceElement = n.renderSourceElement.bind(
                Object(s.a)(n),
              )),
              (n.weixinVideoAutoPlay = n.weixinVideoAutoPlay.bind(
                Object(s.a)(n),
              )),
              (n.playing = !1),
              n
            );
          }
          return (
            Object(c.a)(t, e),
            Object(r.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this.props,
                    t = e.onMount,
                    n = e.sortUrl;
                  t && t(this),
                    this.videoDom && this.addListeners(this.videoDom);
                  var o = x.a.isDowngrade(),
                    a = x.a.isMobile();
                  this.setState({
                    downgrade: o,
                    isMobile: a,
                    videoSource: n,
                    isIE: Object(U.h)(),
                  });
                },
              },
              {
                key: "UNSAFE_componentWillReceiveProps",
                value: function (e) {
                  var t, n;
                  e &&
                    ((t = e.sortUrl),
                    (n = this.props.sortUrl),
                    Array.isArray(t) &&
                      Array.isArray(n) &&
                      t.join("|") !== n.join("|")) &&
                    this.setState({ videoSource: e.sortUrl });
                },
              },
              {
                key: "componentDidUpdate",
                value: function (e) {
                  this.videoDom &&
                    e &&
                    e.videoLazyLoad !== this.props.videoLazyLoad &&
                    this.videoDom.load();
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  this.videoDom && this.removeListeners(this.videoDom);
                },
              },
              {
                key: "addListeners",
                value: function (e) {
                  e.addEventListener("canplay", this.onReady),
                    e.addEventListener("play", this.onPlay),
                    e.addEventListener("pause", this.onPause),
                    e.addEventListener("ended", this.onEnded),
                    e.addEventListener("error", this.onError),
                    x.a.isMobile() &&
                      (e.setAttribute("playsinline", "true"),
                      e.setAttribute("webkit-playsinline", "true"),
                      e.setAttribute("x5-playsinline", "true"));
                },
              },
              {
                key: "removeListeners",
                value: function (e) {
                  e.removeEventListener("canplay", this.onReady),
                    e.removeEventListener("play", this.onPlay),
                    e.removeEventListener("pause", this.onPause),
                    e.removeEventListener("ended", this.onEnded),
                    e.removeEventListener("error", this.onError);
                },
              },
              {
                key: "onReady",
                value: function () {
                  var e = this.props.onReady;
                  e.apply(void 0, arguments);
                },
              },
              {
                key: "onPlay",
                value: function () {
                  var e = this.props.onPlay;
                  e.apply(void 0, arguments);
                },
              },
              {
                key: "onPause",
                value: function () {
                  var e = this.props.onPause;
                  e.apply(void 0, arguments);
                },
              },
              {
                key: "onEnded",
                value: function () {
                  var e = this.props.onEnded;
                  e.apply(void 0, arguments);
                },
              },
              {
                key: "onError",
                value: function () {
                  var e = this.props.onError;
                  e.apply(void 0, arguments);
                },
              },
              {
                key: "load",
                value: function (e) {
                  e && this.videoDom && this.videoDom.load();
                },
              },
              {
                key: "weixinVideoAutoPlay",
                value: function () {
                  var e = this;
                  "object" === typeof WeixinJSBridge &&
                  "function" === typeof WeixinJSBridge.invoke
                    ? e.videoDom.play()
                    : document.addEventListener
                      ? document.addEventListener(
                          "WeixinJSBridgeReady",
                          function () {
                            e.videoDom.play();
                          },
                          !1,
                        )
                      : document.attachEvent &&
                        document.attachEvent(
                          "WeixinJSBridgeReady",
                          function () {
                            e.videoDom.play();
                          },
                        );
                },
              },
              {
                key: "play",
                value: function () {
                  var e = this.props.onError;
                  ((this.videoDom.style.opacity = 1), x.a.isWx())
                    ? this.weixinVideoAutoPlay()
                    : this.videoDom
                        .play()
                        .then()
                        .catch(function (t) {
                          e(t);
                        });
                },
              },
              {
                key: "pause",
                value: function () {
                  this.playing && this.videoDom && this.videoDom.pause();
                },
              },
              {
                key: "stop",
                value: function () {
                  var e = this;
                  this.videoDom &&
                    this.setState({ videoSource: [] }, function () {
                      e.videoDom.load();
                    });
                },
              },
              {
                key: "addSrc",
                value: function () {
                  var e = this,
                    t = this.props.sortUrl;
                  this.videoDom &&
                    this.setState({ videoSource: t }, function () {
                      e.videoDom.load();
                    });
                },
              },
              {
                key: "seekTo",
                value: function (e) {
                  this.videoDom && (this.videoDom.currentTime = e);
                },
              },
              {
                key: "renderSourceElement",
                value: function (e, t) {
                  var n = this.props,
                    a = n.lazyload,
                    r = n.videoLazyLoad,
                    i = {};
                  if (this.videoDom)
                    return r
                      ? "" !== e && void 0 !== e
                        ? G("source", {
                            key: t,
                            src: e,
                            type: "video/".concat(x.a.getFileExtendingName(e)),
                          })
                        : null
                      : ((i[a ? "data-lazy-src" : "src"] = e),
                        (this.lazyloaded = !0),
                        "" !== e && void 0 !== e
                          ? G(
                              "source",
                              Object(o.a)({ key: t }, i, {
                                type: "video/".concat(
                                  x.a.getFileExtendingName(e),
                                ),
                              }),
                            )
                          : null);
                },
              },
              {
                key: "renderDowngradeElement",
                value: function () {
                  var e = this.props,
                    t = e.frameAddress,
                    n = e.frameCount,
                    o = e.frameFormat,
                    a = e.mDowngradeDomStyle,
                    r = e.mDowngradeVideoLink,
                    i = e.mdowngradeVideoPoster,
                    l = e.downgradeDom,
                    s = G(W, this.props),
                    c = G(
                      "div",
                      {
                        style: a,
                        className: "style__video-player-downgrade-m___1uETX",
                      },
                      G("img", { src: i, alt: "" }),
                      G(
                        L.a,
                        { link: r, isMobile: !0 },
                        G("div", {
                          className:
                            "style__video-player-downgrade-m-btn___1vWvy",
                        }),
                      ),
                    );
                  return l || ("" !== r ? c : t && n && o ? s : null);
                },
              },
              {
                key: "getPosterStyle",
                value: function () {
                  var e = this.props,
                    t = e.hidePosterWhenPlayingInIE,
                    n = e.height,
                    o = e.videoLazyLoad,
                    a = e.poster,
                    r = this.state.isIE,
                    i =
                      t && r
                        ? {
                            transform: "translateX(-50%) scale(0.99)",
                            transformOrigin: "center",
                          }
                        : {};
                  return (function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n = null != arguments[t] ? arguments[t] : {};
                      t % 2
                        ? q(Object(n), !0).forEach(function (t) {
                            Object(_.a)(e, t, n[t]);
                          })
                        : Object.getOwnPropertyDescriptors
                          ? Object.defineProperties(
                              e,
                              Object.getOwnPropertyDescriptors(n),
                            )
                          : q(Object(n)).forEach(function (t) {
                              Object.defineProperty(
                                e,
                                t,
                                Object.getOwnPropertyDescriptor(n, t),
                              );
                            });
                    }
                    return e;
                  })(
                    {
                      backgroundImage: o ? "url('".concat(a, "')") : "",
                      height: n,
                    },
                    i,
                  );
                },
              },
              {
                key: "getVideoBoxStyle",
                value: function () {
                  return this.state.isMobile
                    ? "video-player-box-m"
                    : "video-player-box";
                },
              },
              {
                key: "getVideoBorderStyle",
                value: function () {
                  return this.props.fixVideoBorder
                    ? "video-player-wrapper fix-video-border"
                    : "video-player-wrapper";
                },
              },
              {
                key: "getVideoStyle",
                value: function () {
                  return this.props.fixVideoBorder
                    ? "video-player-dom fix-video-border"
                    : "video-player-dom";
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.playing,
                    o = t.loop,
                    a = t.poster,
                    r = t.className,
                    i = t.wrapperStyle,
                    l = t.replayClassName,
                    s = t.replayIconDom,
                    c = t.pauseClassName,
                    _ = t.playClassName,
                    u = t.loadingClassName,
                    d = this.state,
                    p = d.downgrade,
                    f = d.videoSource,
                    h = this.getPosterStyle(),
                    m = this.getVideoBoxStyle(),
                    y = this.getVideoStyle(),
                    b = this.getVideoBorderStyle();
                  return G(
                    "div",
                    {
                      style: { position: "relative" },
                      className:
                        "video-player-box " +
                        E()(m, Y, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                    },
                    p
                      ? this.renderDowngradeElement()
                      : G(
                          "div",
                          {
                            style: i || {},
                            className:
                              (r ? r + " " : "") +
                              E()(b, Y, {
                                autoResolveMultipleImports: !0,
                                handleMissingStyleName: "warn",
                              }),
                          },
                          G("div", {
                            className: "style__video-player-poster___aDPVq",
                            "data-lazy-bg": a,
                            style: h,
                            ref: function (t) {
                              e.videoPosterDom = t;
                            },
                          }),
                          G(
                            "video",
                            {
                              muted: !0,
                              ref: function (t) {
                                e.videoDom = t;
                              },
                              onPlaying: function () {
                                e.playing = !0;
                              },
                              onPause: function () {
                                e.playing = !1;
                              },
                              autoPlay: n || void 0,
                              loop: o,
                              className: E()(y, Y, {
                                autoResolveMultipleImports: !0,
                                handleMissingStyleName: "warn",
                              }),
                            },
                            f instanceof Array &&
                              f.map(this.renderSourceElement),
                          ),
                          l &&
                            G(
                              "div",
                              {
                                className:
                                  (l ? l + " " : "") +
                                  "style__replay-btn___2zwuY",
                                ref: function (t) {
                                  e.replayBtn = t;
                                },
                              },
                              s ||
                                G(N.a, {
                                  name: "fa-light-redo",
                                  className: "style__replay-btn-icon___27gnm",
                                }),
                            ),
                          c &&
                            G("div", {
                              className:
                                (c ? c + " " : "") + "style__pause-btn___zsEID",
                              ref: function (t) {
                                e.pauseBtn = t;
                              },
                            }),
                          _ &&
                            G("div", {
                              className:
                                (_ ? _ + " " : "") + "style__play-btn___3bu6r",
                              ref: function (t) {
                                e.playBtn = t;
                              },
                            }),
                          u &&
                            G(
                              "div",
                              {
                                className:
                                  (u ? u + " " : "") +
                                  "style__loading-btn___3ngla",
                                ref: function (t) {
                                  e.loadingBtn = t;
                                },
                              },
                              G(N.a, { name: "circle-notch", spin: !0 }),
                            ),
                        ),
                  );
                },
              },
            ]),
            t
          );
        })(u.Component),
        K = d.a.createElement;
      function Q(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function J(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Q(Object(n), !0).forEach(function (t) {
                Object(_.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : Q(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function $(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ee = (function (e) {
        function t(e) {
          var n;
          return (
            Object(a.default)(this, t),
            (n = $(this, t, [e])),
            Object(_.a)(Object(s.a)(n), "handleReady", function () {
              (0, n.props.onReady)(Object(s.a)(n));
            }),
            (n.state = { showPreview: !!e.light }),
            (n.handleOnEnded = n.handleOnEnded.bind(Object(s.a)(n))),
            n
          );
        }
        return (
          Object(c.a)(t, e),
          Object(r.default)(t, [
            {
              key: "showPreview",
              value: function () {
                this.setState({ showPreview: !0 });
              },
            },
            {
              key: "handleClickPreview",
              value: function () {
                this.setState({ showPreview: !1 });
              },
            },
            {
              key: "handleOnEnded",
              value: function () {
                (0, this.props.onEnded)(this);
              },
            },
            {
              key: "renderActivePlayer",
              value: function (e) {
                var t = this;
                return e && Z
                  ? K(
                      M,
                      Object(o.a)({}, this.props, {
                        ref: function (e) {
                          t.player = e;
                        },
                        activePlayer: Z,
                        onReady: this.handleReady,
                        onEnded: this.handleOnEnded,
                      }),
                    )
                  : null;
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.url,
                  o = t.style,
                  a = t.width,
                  r = t.height,
                  i = this.state.showPreview;
                return K(
                  "div",
                  {
                    className: "style__video-player-component___1LtC2",
                    ref: function (t) {
                      e.wrapper = t;
                    },
                    style: J({ width: a, height: r }, o),
                  },
                  i ? null : this.renderActivePlayer(n),
                );
              },
            },
          ]),
          t
        );
      })(u.Component);
      Object(_.a)(ee, "defaultProps", b);
    },
    EpBk: function (e, t) {
      e.exports = function (e) {
        var t = typeof e;
        return "string" == t || "number" == t || "symbol" == t || "boolean" == t
          ? "__proto__" !== e
          : null === e;
      };
    },
    Epvc: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return d;
      });
      var o = n("V6Gm"),
        a = n("C68Z"),
        r = n("3T+G"),
        i = "${c}",
        l = "${n}";
      function s(e) {
        var t = [],
          n = 0,
          s = e.match(r.b);
        s &&
          ((n = s.length),
          (e = e.replace(r.b, i)),
          t.push.apply(t, s.map(o.a.parse)));
        var c = e.match(r.c);
        return (
          c && ((e = e.replace(r.c, l)), t.push.apply(t, c.map(a.b.parse))),
          { values: t, numColors: n, tokenised: e }
        );
      }
      function c(e) {
        return s(e).values;
      }
      function _(e) {
        var t = s(e),
          n = t.values,
          a = t.numColors,
          c = t.tokenised,
          _ = n.length;
        return function (e) {
          for (var t = c, n = 0; n < _; n++)
            t = t.replace(
              n < a ? i : l,
              n < a ? o.a.transform(e[n]) : Object(r.e)(e[n]),
            );
          return t;
        };
      }
      var u = function (e) {
        return "number" === typeof e ? 0 : e;
      };
      var d = {
        test: function (e) {
          var t, n, o, a;
          return (
            isNaN(e) &&
            Object(r.d)(e) &&
            (null !==
              (n =
                null === (t = e.match(r.c)) || void 0 === t
                  ? void 0
                  : t.length) && void 0 !== n
              ? n
              : 0) +
              (null !==
                (a =
                  null === (o = e.match(r.b)) || void 0 === o
                    ? void 0
                    : o.length) && void 0 !== a
                ? a
                : 0) >
              0
          );
        },
        parse: c,
        createTransformer: _,
        getAnimatableNone: function (e) {
          var t = c(e);
          return _(e)(t.map(u));
        },
      };
    },
    EuhU: function (e, t, n) {
      "use strict";
      n.r(t);
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("rePB"),
        c = n("iKuz"),
        _ = n.n(c),
        u = n("q1tI"),
        d = n.n(u),
        p = n("XnI8"),
        f = n("xk4V"),
        h = n.n(f),
        m = n("TSYQ"),
        y = n.n(m),
        b = (n("7/Y7"), d.a.createElement),
        v = {
          "./style.css": {
            "section-comments-component":
              "style__section-comments-component___bQMLM",
            container: "style__container___1pbF3",
            "horizontal-line": "style__horizontal-line___1pQNn",
            "comment-title": "style__comment-title___1LkaH",
            "comment-item": "style__comment-item___1ZFK5",
            "section-comment-dark": "style__section-comment-dark___2PMSj",
            "section-comment-light": "style__section-comment-light___1GO2f",
          },
        };
      function g(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var w = (function (e) {
        function t() {
          return Object(o.default)(this, t), g(this, t, arguments);
        }
        return (
          Object(l.a)(t, e),
          Object(a.default)(t, [
            {
              key: "render",
              value: function () {
                var e = this.props,
                  t = e.component_data,
                  n = e.t,
                  o = y()("section-comments-component", {
                    "section-comment-dark": "dark" === t.theme,
                    "section-comment-light": "light" === t.theme,
                  });
                return b(
                  "section",
                  {
                    className: _()(o, v, {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    }),
                  },
                  b(
                    "div",
                    { className: "style__container___1pbF3" },
                    t.hasTitle
                      ? b("p", {
                          className: "style__comment-title___1LkaH",
                          dangerouslySetInnerHTML: {
                            __html: n(t.commentTitle),
                          },
                        })
                      : null,
                    t && Array.isArray(t.commentList)
                      ? t.commentList.map(function (e) {
                          return b("p", {
                            key: h()(),
                            className: "style__comment-item___1ZFK5",
                            dangerouslySetInnerHTML: { __html: n(e.comment) },
                          });
                        })
                      : null,
                  ),
                  "dark" === t.theme
                    ? b("div", { className: "style__horizontal-line___1pQNn" })
                    : null,
                );
              },
            },
          ]),
          t
        );
      })(d.a.Component);
      Object(s.a)(w, "defaultProps", {
        t: function () {},
        component_data: {
          hasTitle: !0,
          theme: "dark",
          commentTitle:
            "* To identify your model number, see https://support.dji.com/. You can easily modify any block data to fits your need; image, title, text, etc.",
          commentList: [
            { comment: "\u4f5c\u54c1\u540d\u79f01" },
            { comment: "\u4f5c\u54c1\u540d\u79f01" },
          ],
        },
      }),
        Object(s.a)(w, "propSettings", {
          key: "sectionComments",
          name: "sectionComments",
          contentSetting: {
            title: {
              switch: "hasTitle",
              label: "\u5907\u6ce8\u6807\u9898",
              props: {
                commentTitle: {
                  label: "\u5907\u6ce8\u6807\u9898",
                  type: "string",
                  content: "text",
                },
              },
            },
            comments: {
              label: "\u5907\u6ce8\u5217\u8868",
              props: {
                commentList: {
                  label: "\u5907\u6ce8\u5217\u8868",
                  type: "array",
                  props: {
                    comment: {
                      type: "string",
                      content: "text",
                      label: "\u5907\u6ce8",
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            section: {
              label: "section \u4e3b\u9898\u8272\u914d\u7f6e",
              props: {
                theme: {
                  type: "select",
                  label: "\u6807\u9898\u5b57\u53f7",
                  items: [
                    { value: "light", label: "\u4eae\u8272" },
                    { value: "dark", label: "\u6697\u8272" },
                  ],
                },
              },
            },
          },
        }),
        (t.default = Object(p.a)(w));
    },
    EvnD: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return r;
      }),
        n.d(t, "d", function () {
          return s;
        }),
        n.d(t, "c", function () {
          return c;
        }),
        n.d(t, "e", function () {
          return _;
        }),
        n.d(t, "b", function () {
          return u;
        }),
        n.d(t, "f", function () {
          return d;
        }),
        n.d(t, "h", function () {
          return p;
        }),
        n.d(t, "g", function () {
          return f;
        });
      var o = (function (e) {
          return (
            (e.LEFT = "left"), (e.CENTER = "center"), (e.RIGHT = "right"), e
          );
        })({}),
        a = (function (e) {
          return (
            (e.TOP = "top"), (e.CENTER = "center"), (e.BOTTOM = "bottom"), e
          );
        })({}),
        r = (function (e) {
          return (
            (e.TEXT = "TEXT"),
            (e.IMAGE = "IMAGE"),
            (e.VIDEO = "VIDEO"),
            (e.ANCHOR = "ANCHOR"),
            (e.LINK = "LINK"),
            (e.DIVIDE_LINE = "DIVIDE_LINE"),
            (e.ICON = "ICON"),
            e
          );
        })({}),
        i = (function (e) {
          return (e.WHITE = "secondary-light"), (e.BLACK = "secondary-dark"), e;
        })({}),
        l = (function (e) {
          return (
            (e.CENTER = "center"),
            (e.LEFTBOTTOM = "left-bottom"),
            (e.RIGHTBOTTOM = "right-bottom"),
            e
          );
        })({}),
        s = { padding: { type: "padding", label: "\u5185\u8fb9\u8ddd" } },
        c = { margin: { type: "margin", label: "\u5916\u8fb9\u8ddd" } },
        _ = { radius: { type: "radius", label: "\u5706\u89d2" } },
        u = [
          { value: o.LEFT, label: "\u5c45\u5de6\u5bf9\u9f50" },
          { value: o.CENTER, label: "\u5c45\u4e2d\u5bf9\u9f50" },
          { value: o.RIGHT, label: "\u5c45\u53f3\u5bf9\u9f50" },
        ],
        d = [
          { value: a.TOP, label: "\u5c45\u4e0a\u5bf9\u9f50" },
          { value: a.CENTER, label: "\u5c45\u4e2d\u5bf9\u9f50" },
          { value: a.BOTTOM, label: "\u5c45\u4e0b\u5bf9\u9f50" },
        ],
        p = [
          { value: i.WHITE, label: "\u767d\u8272" },
          { value: i.BLACK, label: "\u9ed1\u8272" },
        ],
        f = [
          { value: l.CENTER, label: "\u5c45\u4e2d" },
          { value: l.LEFTBOTTOM, label: "\u5de6\u4e0b" },
          { value: l.RIGHTBOTTOM, label: "\u53f3\u4e0b" },
        ];
    },
    ExA7: function (e, t) {
      e.exports = function (e) {
        return null != e && "object" == typeof e;
      };
    },
    "F+2o": function (e, t, n) {
      e.exports = { default: n("2Nb0"), __esModule: !0 };
    },
    FCep: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("Ff2n"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("rePB"),
        d = n("q1tI"),
        p = n("UUyv"),
        f = ["children", "type", "src", "tagType", "visibleByDefault"],
        h = d.createElement;
      function m(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function y(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? m(Object(n), !0).forEach(function (t) {
                Object(u.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : m(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function b(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var v = { threshold: 2e3 };
      function g(e) {
        return e
          ? !/\burl\s*\(/i.test(e) && /^\s*(\.|(\/)|http)/.test(e)
            ? 'url("'.concat(e, '")')
            : e
          : e;
      }
      var w = (function (e) {
        function t(e) {
          var n;
          return (
            Object(r.default)(this, t),
            (n = b(this, t, [e])),
            Object(u.a)(Object(c.a)(n), "targetDom", void 0),
            Object(u.a)(Object(c.a)(n), "animationFrame", void 0),
            Object(u.a)(Object(c.a)(n), "listenersToRemove", void 0),
            (n.state = {}),
            (n.listenersToRemove = []),
            (n.setBackgroundImageAfterLoad = n.setBackgroundImageAfterLoad.bind(
              Object(c.a)(n),
            )),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(i.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this.props,
                  t = e.parallax;
                e.visibleByDefault && t && this.parallaxScroll();
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                this.animationFrame &&
                  window &&
                  window.cancelAnimationFrame(this.animationFrame),
                  this.listenersToRemove.forEach(function (e) {
                    "function" === typeof e && e();
                  });
              },
            },
            {
              key: "setBackgroundImageAfterLoad",
              value: function () {
                var e = this.props,
                  t = e.src,
                  n = e.parallax;
                if (t) {
                  var o = g(t);
                  this.setState({ backgroundImage: o }),
                    n && this.parallaxScroll();
                }
              },
            },
            {
              key: "parallaxScroll",
              value: function () {
                var e = 0.1,
                  t = 0,
                  n = this.targetDom,
                  o = this;
                if (n) {
                  var a = window.innerHeight,
                    r = this.computeBgSize().backgroundSize,
                    i = this.computeBgSize().backgroundOffset,
                    l = this;
                  s(),
                    window.addEventListener("resize", s),
                    l.listenersToRemove.push(function () {
                      window.removeEventListener("resize", s);
                    }),
                    (function l() {
                      var s = window.scrollY || window.pageYOffset;
                      if (n) {
                        for (var c = n, _ = n.offsetTop; c.offsetParent; )
                          _ += (c = c.offsetParent).offsetTop;
                        var u = n.offsetHeight;
                        if (s >= _ - a && s <= _ + u) {
                          var d = "".concat(
                            (t += ((_ - a - s) / (a + u) - t) * e) * i,
                            "px",
                          );
                          (n.style["background-position-y"] = d),
                            (n.style["background-size"] = r),
                            (n.style["background-position-x"] = "center");
                        }
                        o.animationFrame = requestAnimationFrame(l);
                      }
                    })();
                }
                function s() {
                  (a = window.innerHeight),
                    (r = l.computeBgSize().backgroundSize),
                    (i =
                      l.computeBgSize().backgroundOffset >= 200
                        ? 200
                        : l.computeBgSize().backgroundOffset);
                }
              },
            },
            {
              key: "computeBgSize",
              value: function () {
                var e = this.targetDom,
                  t = "auto calc(100% + 200px)",
                  n = 200;
                if (!e) return {};
                var o = this.props,
                  a = o.bgWidth,
                  r = o.bgHeight;
                if ((!a && !r) || ("" === a && "" === r))
                  return { backgroundSize: t, backgroundOffset: n };
                var i = parseInt(a, 10) / parseInt(r, 10),
                  l = e.clientWidth,
                  s = e.clientHeight;
                if (i > l / s) {
                  (t = "calc(100% + ".concat(s * i - l, "px) 100%")), (n = 0);
                } else {
                  var c = l / i - s;
                  (t = "100% calc(100% + ".concat(c, "px)")), (n = c);
                }
                return { backgroundSize: t, backgroundOffset: n };
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.children,
                  r = t.type,
                  i = t.src,
                  l = t.tagType,
                  s = void 0 === l ? "div" : l,
                  c = t.visibleByDefault,
                  _ = Object(a.a)(t, f);
                if ("img" === r) {
                  var u = this.props.placeholder,
                    m =
                      void 0 === u
                        ? h("i", {
                            style: {
                              color: "transparent",
                              display: "inline-block",
                              minWidth: "1px",
                            },
                          })
                        : u,
                    b = y(y({}, v), _);
                  return h(
                    p.LazyLoadImage,
                    Object(o.a)({ visibleByDefault: c }, b, {
                      placeholder: m,
                      src: i,
                    }),
                  );
                }
                if ("bg" === r) {
                  var w = _.style,
                    x = void 0 === w ? {} : w,
                    k = this.state.backgroundImage,
                    O = h(
                      p.LazyLoadComponent,
                      {
                        afterLoad: this.setBackgroundImageAfterLoad,
                        threshold: _.threshold || v.threshold,
                        style: { display: "block !important" },
                      },
                      h("span", { style: { display: "none" } }),
                    );
                  return c
                    ? d.createElement(
                        s,
                        y(
                          y({}, _),
                          {},
                          {
                            ref: function (t) {
                              e.targetDom = t;
                            },
                            style: y(y({}, x), {}, { backgroundImage: g(i) }),
                          },
                        ),
                        n,
                      )
                    : d.createElement(
                        s,
                        y(
                          y({}, _),
                          {},
                          {
                            ref: function (t) {
                              e.targetDom = t;
                            },
                            style: y(y({}, x), {}, { backgroundImage: k }),
                          },
                        ),
                        O,
                        n,
                      );
                }
                return h(
                  p.LazyLoadComponent,
                  Object(o.a)({ visibleByDefault: c }, _),
                  n,
                );
              },
            },
          ]),
          t
        );
      })(d.Component);
      Object(u.a)(w, "defaultProps", void 0),
        (w.defaultProps = {
          type: "component",
          src: "",
          tagType: "div",
          style: {},
          parallax: !1,
        }),
        (t.a = w);
    },
    FYw3: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o,
        a = n("EJiy"),
        r = (o = a) && o.__esModule ? o : { default: o };
      t.default = function (e, t) {
        if (!e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return !t ||
          ("object" !==
            ("undefined" === typeof t ? "undefined" : (0, r.default)(t)) &&
            "function" !== typeof t)
          ? e
          : t;
      };
    },
    FZoo: function (e, t, n) {
      var o = n("MrPd"),
        a = n("4uTw"),
        r = n("wJg7"),
        i = n("GoyQ"),
        l = n("9Nap");
      e.exports = function (e, t, n, s) {
        if (!i(e)) return e;
        for (
          var c = -1, _ = (t = a(t, e)).length, u = _ - 1, d = e;
          null != d && ++c < _;

        ) {
          var p = l(t[c]),
            f = n;
          if ("__proto__" === p || "constructor" === p || "prototype" === p)
            return e;
          if (c != u) {
            var h = d[p];
            void 0 === (f = s ? s(h, p, d) : void 0) &&
              (f = i(h) ? h : r(t[c + 1]) ? [] : {});
          }
          o(d, p, f), (d = d[p]);
        }
        return e;
      };
    },
    Fe7O: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 }),
        (t.default = void 0);
      var o = {
        attributeNames: { styleName: "className" },
        generateScopedName: "[path]___[name]__[local]___[hash:base64:5]",
        handleMissingStyleName: "throw",
      };
      t.default = o;
    },
    FlQf: function (e, t, n) {
      "use strict";
      var o = n("ccE7")(!0);
      n("MPFp")(
        String,
        "String",
        function (e) {
          (this._t = String(e)), (this._i = 0);
        },
        function () {
          var e,
            t = this._t,
            n = this._i;
          return n >= t.length
            ? { value: void 0, done: !0 }
            : ((e = o(t, n)), (this._i += e.length), { value: e, done: !1 });
        },
      );
    },
    Fm6t: function (e, t, n) {
      e.exports = {
        "section-table": "style__section-table___utKeR",
        container: "style__container___2M6Za",
        "table-title": "style__table-title___3GDQG",
        "table-content": "style__table-content___1AasU",
        table: "style__table___1V8J3",
        "table-cell": "style__table-cell___1DNeV",
        "table-cell-title-text": "style__table-cell-title-text___2u3Hy",
        "table-cell-desc-text": "style__table-cell-desc-text___lFC-0",
        "table-thead": "style__table-thead___1upwD",
        "table-head": "style__table-head___3x_Jn",
        headline: "style__headline___2g18C",
        description: "style__description___23-AE",
        "table-row": "style__table-row___3kucA",
        "table-cell-btn": "style__table-cell-btn___jvh3l",
        "icon-on": "style__icon-on___2-HU8",
        "icon-off": "style__icon-off___3noM4",
        "section-table-light": "style__section-table-light___3Spy7",
        "section-table-dark": "style__section-table-dark___20ie2",
      };
    },
    FpHa: function (e, t) {
      e.exports =
        "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
          ",",
        );
    },
    "G/Zc": function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("rePB"),
        c = n("iKuz"),
        _ = n.n(c),
        u = n("q1tI"),
        d = n.n(u),
        p = n("XnI8"),
        f = n("yWgo"),
        h = (n("zOXz"), d.a.createElement);
      function m(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var y = {
          "./style.css": {
            "ie-modal": "style__ie-modal___2aV8J",
            mask: "style__mask___QUaGp",
            "modal-warpper": "style__modal-warpper___2dLEO",
            show: "style__show___9YNMF",
            "modal-box": "style__modal-box___2-MRo",
            close: "style__close___1vxmD",
            icon: "style__icon___37RjH",
            title: "style__title___2sCdf",
            desc: "style__desc___ru-0k",
            button: "style__button___3Fyz1",
          },
        },
        b = function (e) {
          var t,
            n,
            o = e.t,
            a = Object(u.useRef)(),
            r =
              f.Q &&
              (null === (t = document) || void 0 === t
                ? void 0
                : t.documentElement.style),
            i =
              f.Q &&
              window.innerWidth -
                (null === (n = document) || void 0 === n
                  ? void 0
                  : n.body.clientWidth),
            l = Object(u.useState)(!1),
            s = l[0],
            c = l[1],
            d = function () {
              localStorage.ie_modal_has_click > new Date().getTime() ||
                ((r.overflow = "hidden"), (r.paddingRight = i), c(!0));
            },
            p = function () {
              (r.overflow = ""),
                (r.paddingRight = ""),
                (function () {
                  var e = new Date(Date.now() + 864e5).getTime();
                  window.localStorage.ie_modal_has_click = e;
                })(),
                c(!1);
            };
          return (
            Object(u.useEffect)(function () {
              d();
            }, []),
            h(
              "div",
              { className: "style__ie-modal___2aV8J" },
              h("div", {
                className: _()("mask ".concat(s ? "show" : ""), y, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
              }),
              h(
                "div",
                {
                  onClick: function (e) {
                    a.current && !a.current.contains(e.target) && p();
                  },
                  className: _()("modal-warpper ".concat(s ? "show" : ""), y, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
                },
                h(
                  "div",
                  {
                    ref: function (e) {
                      a.current = e;
                    },
                    className: _()("modal-box ".concat(s ? "show" : ""), y, {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    }),
                  },
                  h("div", { className: "style__close___1vxmD", onClick: p }),
                  h("div", { className: "style__icon___37RjH" }),
                  h(
                    "h1",
                    { className: "style__title___2sCdf" },
                    o("v1.iemodal.title"),
                  ),
                  h(
                    "p",
                    { className: "style__desc___ru-0k" },
                    o("v1.iemodal.desc"),
                  ),
                  h(
                    "div",
                    { className: "style__button___3Fyz1", onClick: p },
                    o("v1.iemodal.button"),
                  ),
                ),
              ),
            )
          );
        },
        v = (function (e) {
          function t() {
            return Object(o.default)(this, t), m(this, t, arguments);
          }
          return (
            Object(l.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = Object(f.h)();
                  return h(
                    "section",
                    { className: "ie-modal" },
                    e && h(b, this.props),
                  );
                },
              },
            ]),
            t
          );
        })(d.a.PureComponent);
      Object(s.a)(v, "defaultProps", { t: function () {} }),
        (t.a = Object(p.a)(v));
    },
    G6z8: function (e, t, n) {
      var o = n("fR/l"),
        a = n("oCl/"),
        r = n("mTTR");
      e.exports = function (e) {
        return o(e, r, a);
      };
    },
    G8Mo: function (e, t, n) {
      var o = n("93I4");
      e.exports = function (e, t) {
        if (!o(e)) return e;
        var n, a;
        if (t && "function" == typeof (n = e.toString) && !o((a = n.call(e))))
          return a;
        if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
          return a;
        if (!t && "function" == typeof (n = e.toString) && !o((a = n.call(e))))
          return a;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    GIHP: function (e, t, n) {
      "use strict";
      var o = n("KQm4"),
        a = n("ODXe"),
        r = n("rePB"),
        i = n("iKuz"),
        l = n.n(i),
        s = n("q1tI"),
        c = n.n(s),
        _ = n("IdKh"),
        u = n("ATyU"),
        d = n("XnI8"),
        p = n("FCep"),
        f = n("3vbH"),
        h = n("Cc7j"),
        m = n("QH4r"),
        y = n("r7AC"),
        b = n("jCXQ"),
        v = n("DdlN"),
        g = n("IrEl"),
        w = {
          t: function () {},
          gaSend: function () {},
          component_data: {
            theme: "light",
            hasMainTitle: !0,
            hasSubTitle: !0,
            mediaType: "video",
            picture: "",
            video_mp4: { path: "" },
            videoPoster: "",
            showMask: !0,
            maskColor: "#000",
          },
        },
        x = (n("E0WF"), c.a.createElement),
        k = {
          "./style.css": {
            "section-common-sectionzoomout":
              "style__section-common-sectionzoomout___2oyFm",
            light: "style__light___2rt8k",
            eyebrow: "style__eyebrow___1voBD",
            headline: "style__headline___3Ke5a",
            "placeholder-box": "style__placeholder-box___3t5T4",
            dark: "style__dark___3Vzvf",
            "downgrade-mode": "style__downgrade-mode___2BPsU",
            video: "style__video___3Uzsk",
            "media-wrapper": "style__media-wrapper___12rMB",
            "normal-mode": "style__normal-mode___2X-fe",
            "main-titles": "style__main-titles___3iXzt",
            "sub-eyebrow": "style__sub-eyebrow___1gp-g",
            "sub-headline": "style__sub-headline___AZWDK",
            desc: "style__desc___2Xnjq",
            "box-wrapper": "style__box-wrapper___BCCF2",
            "button-inner": "style__button-inner____ZJgf",
            "button-text": "style__button-text___3jTY5",
            "button-link": "style__button-link___fh-sc",
            "link-inner": "style__link-inner___2h0Gq",
            "link-text": "style__link-text___6pTiw",
            container: "style__container___3Bqtc",
            top: "style__top___1n_VY",
            bottom: "style__bottom___1e4Cd",
            left: "style__left___3_Ni9",
            right: "style__right___2W_Ua",
            "media-container": "style__media-container___3Vx1b",
            figure: "style__figure___1df-2",
            "mask-container": "style__mask-container___1LqiX",
            mask: "style__mask___Z2Ldn",
            "text-wrapper": "style__text-wrapper___1h3ez",
            "scene-wrapper": "style__scene-wrapper___2njSe",
            "mobile-mode": "style__mobile-mode___1ReeI",
          },
        };
      function O(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function I(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? O(Object(n), !0).forEach(function (t) {
                Object(r.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : O(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var S = function (e) {
        var t = (e = I(
            I(I({}, w), e),
            {},
            { component_data: I(I({}, w.component_data), e.component_data) },
          )),
          n = t.mobileMode,
          r = t.t,
          i = t.component_data,
          d = t.eventAction,
          O = t.gaSend,
          S = i.theme,
          j = i.mainTitlePadding,
          T = i.hasMainTitle,
          C = i.eyebrow,
          M = i.eyebrowStyle,
          P = void 0 === M ? {} : M,
          E = i.eyebrowWidth,
          L = i.headline,
          B = i.headlineStyle,
          N = void 0 === B ? {} : B,
          D = i.headlineWidth,
          z = i.hasSubTitle,
          A = i.subEyebrow,
          R = i.subHeadline,
          F = i.subHeadlineStyle,
          V = void 0 === F ? {} : F,
          H = i.hasDesc1,
          W = i.description1,
          U = i.description1Style,
          G = void 0 === U ? {} : U,
          Y = i.hasSubTitle2,
          q = i.subEyebrow2,
          X = i.subHeadline2,
          Z = i.subHeadline2Style,
          K = void 0 === Z ? {} : Z,
          Q = i.hasDesc2,
          J = i.description2,
          $ = i.description2Style,
          ee = void 0 === $ ? {} : $,
          te = i.hasPage3,
          ne = i.subEyebrow3,
          oe = i.subHeadline3,
          ae = i.subHeadline3Style,
          re = void 0 === ae ? {} : ae,
          ie = i.description3,
          le = i.description3Style,
          se = void 0 === le ? {} : le,
          ce = i.hasWathVideo,
          _e = i.watchVideoText,
          ue = i.watchVideoLink,
          de = i.hasWathVideoMore,
          pe = i.watchVideoText2,
          fe = i.watchVideoLink2,
          he = i.hasDownloadImg,
          me = i.DownloadImgLink,
          ye = i.DownloadImgText,
          be = i.videoBtnMarginTop,
          ve = i.mediaType,
          ge = i.picture,
          we = i.video_mp4,
          xe = i.video_webm,
          ke = i.videoPoster,
          Oe = i.downgradeImage,
          Ie = i.showMask,
          Se = void 0 === Ie || Ie,
          je = i.maskColor,
          Te = i.maskOpacity,
          Ce = Object(s.useState)(n ? 2e3 : 4e3),
          Me = Ce[0],
          Pe = Ce[1],
          Ee = Object(s.useState)(0),
          Le = Ee[0],
          Be = Ee[1],
          Ne = Object(s.useState)(0),
          De = Ne[0],
          ze = Ne[1],
          Ae = Object(s.useState)(0),
          Re = Ae[0],
          Fe = Ae[1],
          Ve = Object(s.useState)(n ? 300 : 1200),
          He = Ve[0],
          We = Ve[1],
          Ue = Object(s.useState)(n ? 300 : 800),
          Ge = Ue[0],
          Ye = Ue[1],
          qe = Object(s.useRef)(),
          Xe = Object(s.useRef)(),
          Ze = Object(s.useRef)(),
          Ke = Object(s.useRef)(null),
          Qe = Object(s.useRef)([]),
          Je = Object(s.useRef)(),
          $e = Object(b.c)({ mobileMode: n }),
          et = Object(a.a)($e, 1)[0],
          tt = Object(v.a)({
            mobileMode: n,
            sectionRef: qe,
            eventAction: d,
            mobileHeightChangable: !1,
          }),
          nt = Object(a.a)(tt, 2),
          ot = nt[0],
          at = nt[1],
          rt = function (e) {
            if (
              !(e.currentTime > 0 && !e.paused && !e.ended && e.readyState > 2)
            ) {
              var t = e.play();
              t &&
                t.then &&
                "function" === typeof t.then &&
                t.then(
                  function () {},
                  function () {},
                );
            }
          },
          it = function () {
            var e = Je.current;
            if (e) {
              Object(y.b)({
                elm: Je.current,
                offset: 0,
                callback: function (t) {
                  var o, a;
                  return (
                    t.inView
                      ? n
                        ? rt(e)
                        : ((o = e),
                          (a = function () {
                            rt(e);
                          }),
                          window &&
                          window.MSInputMethodContext &&
                          document.documentMode
                            ? (o.load && o.load(),
                              o.addEventListener("canplay", function e() {
                                a(), o.removeEventListener("canplay", e);
                              }))
                            : a(o))
                      : (e.pause(), (e.currentTime = 0)),
                    !0
                  );
                },
              });
            }
          };
        Object(s.useEffect)(function () {
          it();
          var e = [z, Q, te].filter(function (e) {
              return e;
            }).length,
            t = 1500;
          n && (t = 2e3), Pe(Math.max(1500 * e, t));
        }, []),
          Object(s.useEffect)(
            function () {
              !(function () {
                var e = (qe.current && qe.current.clientWidth) || ot,
                  t = e < 1920 ? 960 : 1200,
                  o = e < 1920 ? 640 : 800;
                n &&
                  ((t = ot - 48),
                  (o = at < (o = (368 / 312) * (ot - 48)) ? at : o)),
                  Be(Me - at),
                  We(t),
                  Ye(o),
                  ze(n ? 24 : (e - t) / 2),
                  Fe(at > o ? (at - o) / 2 : 0);
              })();
            },
            [ot, at],
          );
        var lt = !z || !Q,
          st = n
            ? {}
            : {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
              },
          ct = "dark" === S ? "dark" : "light",
          _t = T ? Le + Re : Le,
          ut = Object(g.a)({
            target: Xe,
            offset: ["start start", "".concat(_t, "px start")],
            customDefaultValues: function () {
              return {
                mainOpacityProgress: Object(_.a)(0),
                subOpacityProgress: Object(_.a)(0),
                subOpacity2Progress: Object(_.a)(0),
                mainTopProgress: Object(_.a)(0),
                subTopProgress: Object(_.a)(0),
                subTop2Progress: Object(_.a)(0),
              };
            },
            customCB: function (e, t) {
              var o,
                a,
                r,
                i,
                l,
                s,
                c = e.y;
              c.progress > 0
                ? (null === (o = Ze.current) ||
                    void 0 === o ||
                    o.classList.add("container-active"),
                  null === (a = Ke.current) ||
                    void 0 === a ||
                    a.classList.remove("maintitle-active"),
                  null === (r = Qe.current) ||
                    void 0 === r ||
                    r.forEach(function (e) {
                      return null === e || void 0 === e
                        ? void 0
                        : e.classList.add("text-active");
                    }))
                : (null === (i = Ze.current) ||
                    void 0 === i ||
                    i.classList.remove("container-active"),
                  null === (l = Ke.current) ||
                    void 0 === l ||
                    l.classList.add("maintitle-active"),
                  null === (s = Qe.current) ||
                    void 0 === s ||
                    s.forEach(function (e) {
                      return null === e || void 0 === e
                        ? void 0
                        : e.classList.remove("text-active");
                    }));
              if (!lt) {
                var _ = (function (e) {
                    var t,
                      o = 0,
                      a = 0,
                      r = 0,
                      i = 0,
                      l = 0;
                    if (te) {
                      var s = 0.4 + (1 / 15) * 5;
                      if (0 === e) (a = 0), (o = 0), (t = 0);
                      else if (e < 0.4)
                        (o = 0),
                          (t = 0),
                          (r = -200),
                          (l = -200),
                          (i =
                            e < 0.2
                              ? 200 * (1 - e / 0.2)
                              : e < 0.2 + 150 / 4500
                                ? 0
                                : (-200 * (e - (0.2 + 150 / 4500))) /
                                  (750 / 4500)),
                          (a =
                            e < 300 / 4500
                              ? e / (300 / 4500)
                              : e < 0.4 - 300 / 4500
                                ? 1
                                : 1 - (e - (0.4 - 300 / 4500)) / (300 / 4500));
                      else if (e < s) {
                        if (
                          ((a = 0),
                          (i = -200),
                          (t = 0),
                          (l = 200),
                          (o = 1),
                          e < s)
                        )
                          r = 200 - 400 * ((e - 0.4) / (s - 0.4));
                        if (e < 0.4 + 300 / 4500) o = (e - 0.4) / (300 / 4500);
                        else
                          o =
                            e < s - 300 / 4500
                              ? 1
                              : 1 - (e - (s - 300 / 4500)) / (300 / 4500);
                      } else {
                        if (
                          ((a = 0),
                          (i = -200),
                          (o = 0),
                          (r = -200),
                          (t = 1),
                          e < s + 600 / 4500)
                        )
                          l = 200 * (1 - (e - s) / (600 / 4500));
                        else l = 0;
                        if (e < 0.8) t = (e - s) / (300 / 4500);
                        else t = 1;
                      }
                    } else if (0 === e) (a = 0), (o = 0);
                    else if (e < (n ? 0.5 : 0.6))
                      (o = 0),
                        (r = -200),
                        (i =
                          e < 0.3
                            ? 200 * (1 - e / 0.3)
                            : e < 0.35
                              ? 0
                              : (-200 * (e - 0.35)) / 0.25),
                        (a =
                          e < 0.1
                            ? e / 0.1
                            : e < 0.5
                              ? 1
                              : 1 - (e - 0.5) / 0.1);
                    else {
                      if (((a = 0), (i = -200), (o = 1), e < 0.8))
                        r = 200 * (1 - (e - 0.6) / 0.2);
                      else r = 0;
                      if (e < 0.7) o = (e - 0.6) / 0.1;
                      else o = 1;
                    }
                    return {
                      mainOpacity: a,
                      subOpacity: o,
                      subOpacity2: t,
                      mainTop: i,
                      subTop: r,
                      subTop2: l,
                    };
                  })(c.progress),
                  u = _.mainOpacity,
                  d = _.subOpacity,
                  p = _.subOpacity2,
                  f = _.mainTop,
                  h = _.subTop,
                  m = _.subTop2;
                t.mainOpacityProgress.set(u),
                  t.subOpacityProgress.set(d),
                  t.subOpacity2Progress.set(p),
                  t.mainTopProgress.set(f),
                  t.subTopProgress.set(h),
                  t.subTop2Progress.set(m);
              }
            },
          }),
          dt = ut.mainOpacityProgress,
          pt = ut.subOpacityProgress,
          ft = ut.subOpacity2Progress,
          ht = ut.mainTopProgress,
          mt = ut.subTopProgress,
          yt = ut.subTop2Progress,
          bt =
            T &&
            x(
              "div",
              {
                className: "maintitle-active style__main-titles___3iXzt",
                ref: Ke,
                style: { padding: j },
              },
              x(
                "div",
                { "data-aos-once": !0, "data-aos": et ? "" : "fade-up" },
                x("h2", {
                  className: "style__eyebrow___1voBD",
                  dangerouslySetInnerHTML: { __html: r(C) },
                  style: I(I({}, P.style), {}, { width: E }),
                }),
              ),
              x(
                "div",
                { "data-aos-once": !0, "data-aos": et ? "" : "fade-up" },
                x("h3", {
                  className: "style__headline___3Ke5a",
                  dangerouslySetInnerHTML: { __html: r(L) },
                  style: I(I({}, N.style), {}, { width: D }),
                }),
              ),
            ),
          vt = function (e) {
            return x(p.a, {
              type: "bg",
              src: e,
              style: { width: He, height: Ge },
              className: "style__figure___1df-2",
            });
          },
          gt =
            "video" === ve
              ? x(
                  f.a,
                  {
                    downgradeDom: vt(Oe || ke || ge),
                    lazyLoad: !0,
                    lazyLoadThreshold: n ? 1200 : 2400,
                    visiblePlay: !0,
                    style: st,
                  },
                  x(
                    "video",
                    {
                      muted: !0,
                      loop: !0,
                      ref: Je,
                      className: "style__video___3Uzsk",
                      "data-layzr-poster": ke,
                    },
                    (null === xe || void 0 === xe ? void 0 : xe.path) &&
                      x("source", {
                        type: "video/webm",
                        "data-layzr-src": xe.path,
                      }),
                    x("source", {
                      type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                      "data-layzr-src":
                        null === we || void 0 === we ? void 0 : we.path,
                    }),
                  ),
                )
              : vt(ge || ke),
          wt = x(
            "div",
            null,
            ce
              ? x(
                  "div",
                  { className: "style__box-wrapper___BCCF2" },
                  x(
                    h.a,
                    {
                      link: null === ue || void 0 === ue ? void 0 : ue.path,
                      style: { margin: "".concat(be || "24px", " auto 0") },
                    },
                    x(
                      m.c,
                      {
                        size: m.a.medium,
                        type: m.b["secondary-light"],
                        style: { borderRadius: "60px" },
                        onClick: function () {
                          return O("click", "banner-intro-video");
                        },
                      },
                      x(
                        "div",
                        { className: "style__button-inner____ZJgf" },
                        x("span", {
                          className: "style__button-text___3jTY5",
                          dangerouslySetInnerHTML: { __html: r(_e) },
                        }),
                      ),
                    ),
                  ),
                )
              : null,
            de
              ? x(
                  "div",
                  { className: "style__box-wrapper___BCCF2" },
                  x(
                    h.a,
                    {
                      link: null === fe || void 0 === fe ? void 0 : fe.path,
                      style: { margin: "".concat(be || "24px", " auto 0") },
                    },
                    x(
                      m.c,
                      {
                        size: m.a.medium,
                        type: m.b["secondary-light"],
                        style: { borderRadius: "60px" },
                        onClick: function () {
                          return O("click", "banner-intro-video2");
                        },
                      },
                      x(
                        "div",
                        { className: "style__button-inner____ZJgf" },
                        x("span", {
                          className: "style__button-text___3jTY5",
                          dangerouslySetInnerHTML: { __html: r(pe) },
                        }),
                      ),
                    ),
                  ),
                )
              : null,
            he
              ? x(
                  "a",
                  {
                    className: "style__button-link___fh-sc",
                    href: null === me || void 0 === me ? void 0 : me.path,
                    download: null === me || void 0 === me ? void 0 : me.path,
                  },
                  x(
                    "div",
                    { className: "style__link-inner___2h0Gq" },
                    x("span", {
                      className: "style__link-text___6pTiw",
                      dangerouslySetInnerHTML: { __html: r(ye) },
                    }),
                  ),
                )
              : null,
          ),
          xt = x(
            c.a.Fragment,
            null,
            A &&
              x("h4", {
                className: "style__sub-eyebrow___1gp-g",
                dangerouslySetInnerHTML: { __html: r(A) },
              }),
            x("h5", {
              className: "style__sub-headline___AZWDK",
              dangerouslySetInnerHTML: { __html: r(R) },
              style: V.style,
            }),
            H &&
              x("p", {
                className: "style__desc___2Xnjq",
                dangerouslySetInnerHTML: { __html: r(W) },
                style: G.style,
              }),
            lt && wt,
          ),
          kt = x(
            c.a.Fragment,
            null,
            Y &&
              x(
                c.a.Fragment,
                null,
                q &&
                  x("h4", {
                    className: "style__sub-eyebrow___1gp-g",
                    dangerouslySetInnerHTML: { __html: r(q) },
                  }),
                x("h5", {
                  className: "style__sub-headline___AZWDK",
                  dangerouslySetInnerHTML: { __html: r(X) },
                  style: K.style,
                }),
              ),
            Q &&
              x("p", {
                className: "style__desc___2Xnjq",
                dangerouslySetInnerHTML: { __html: r(J) },
                style: ee.style,
              }),
            wt,
          ),
          Ot = x(
            c.a.Fragment,
            null,
            ne &&
              x("h4", {
                className: "style__sub-eyebrow___1gp-g",
                dangerouslySetInnerHTML: { __html: r(ne) },
              }),
            oe &&
              x("h5", {
                className: "style__sub-headline___AZWDK",
                dangerouslySetInnerHTML: { __html: r(oe) },
                style: re.style,
              }),
            x("p", {
              className: "style__desc___2Xnjq",
              dangerouslySetInnerHTML: { __html: r(ie) },
              style: se.style,
            }),
            wt,
          );
        return x(
          "section",
          {
            id: "section-common-sectionzoomout section-common-sectionzoomout_".concat(
              e.id,
            ),
            ref: qe,
            className:
              "section-common-sectionzoomout " +
              l()(
                "section-common-sectionzoomout "
                  .concat(et ? "downgrade-mode" : "normal-mode", " ")
                  .concat(n && "mobile-mode", " ")
                  .concat(ct),
                k,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
          },
          bt,
          x(
            "div",
            {
              className: "style__scene-wrapper___2njSe",
              style: { height: Me, top: T ? -Re : 0 },
              ref: Xe,
            },
            x(
              "div",
              { style: et && !n ? {} : { height: "".concat(_t + at, "px") } },
              x(
                "div",
                {
                  className: "style__container___3Bqtc",
                  style: {
                    height: at,
                    position: et && !n ? "relative" : "sticky",
                  },
                  ref: Ze,
                },
                n || ("video" === ve && !et)
                  ? [
                      x("div", {
                        key: "top",
                        className:
                          "style__placeholder-box___3t5T4 style__top___1n_VY",
                        style: { height: Re },
                      }),
                      x("div", {
                        key: "bottom",
                        className:
                          "style__placeholder-box___3t5T4 style__bottom___1e4Cd",
                        style: { height: Re },
                      }),
                      x("div", {
                        key: "left",
                        className:
                          "style__placeholder-box___3t5T4 style__left___3_Ni9",
                        style: { width: De },
                      }),
                      x("div", {
                        key: "right",
                        className:
                          "style__placeholder-box___3t5T4 style__right___2W_Ua",
                        style: { width: De },
                      }),
                    ]
                  : null,
                x(
                  "div",
                  { className: "style__media-container___3Vx1b" },
                  x(
                    "div",
                    {
                      className: "style__media-wrapper___12rMB",
                      "data-aos-once": !0,
                      "data-aos": et ? "" : "fade-up",
                    },
                    gt,
                  ),
                  lt
                    ? x(
                        "div",
                        {
                          className: "style__text-wrapper___1h3ez",
                          ref: function (e) {
                            Qe.current[0] = e;
                          },
                        },
                        z ? xt : kt,
                      )
                    : [
                        x(
                          "div",
                          {
                            className: "style__text-wrapper___1h3ez",
                            ref: function (e) {
                              Qe.current[0] = e;
                            },
                            key: "subtitle",
                          },
                          x(u.a.div, { style: { opacity: dt, y: ht } }, xt),
                        ),
                        x(
                          "div",
                          {
                            className: "style__text-wrapper___1h3ez",
                            ref: function (e) {
                              Qe.current[1] = e;
                            },
                            key: "desc",
                          },
                          x(u.a.div, { style: { opacity: pt, y: mt } }, kt),
                        ),
                      ].concat(
                        Object(o.a)(
                          te
                            ? [
                                x(
                                  "div",
                                  {
                                    className: "style__text-wrapper___1h3ez",
                                    ref: function (e) {
                                      Qe.current[2] = e;
                                    },
                                    key: "desc3",
                                  },
                                  x(
                                    u.a.div,
                                    { style: { opacity: ft, y: yt } },
                                    Ot,
                                  ),
                                ),
                              ]
                            : [],
                        ),
                      ),
                ),
                Se &&
                  x(
                    "div",
                    { className: "style__mask-container___1LqiX" },
                    x("div", {
                      className: "style__mask___Z2Ldn",
                      style: {
                        backgroundColor: je || "#000",
                        opacity: Te || (n ? 0.2 : 0.55),
                      },
                    }),
                  ),
              ),
            ),
          ),
        );
      };
      (S.defaultProps = w),
        (S.editSetting = {
          key: "SectionZoomOut",
          name: "SectionZoomOut",
          contentSetting: {
            mainTitle: {
              switch: "hasMainTitle",
              label: "\u6807\u9898\u4e0e\u7709\u5934",
              props: {
                eyebrow: {
                  type: "string",
                  label: "\u5927\u6807\u9898\u7709\u5934",
                  content: "text",
                },
                eyebrowStyle: {
                  type: "font",
                  label: "\u7709\u5934-\u5b57\u4f53\u914d\u7f6e",
                },
                eyebrowWidth: {
                  type: "string",
                  label: "\u7709\u5934-\u5bbd\u5ea6 [px]",
                },
                headline: {
                  type: "string",
                  label: "\u5927\u6807\u9898\u6807\u9898",
                  content: "text",
                },
                headlineStyle: {
                  type: "font",
                  label: "\u6807\u9898-\u5b57\u4f53\u914d\u7f6e",
                },
                headlineWidth: {
                  type: "string",
                  label: "\u6807\u9898-\u5bbd\u5ea6 [px]",
                },
              },
            },
            subTitle: {
              switch: "hasSubTitle",
              label: "\u7b2c\u4e00\u5c4f-\u7709\u5934\u4e0e\u6807\u9898",
              props: {
                subEyebrow: {
                  type: "string",
                  label: "\u7709\u5934",
                  content: "text",
                },
                subHeadline: {
                  type: "string",
                  label: "\u6807\u9898",
                  content: "text",
                },
                subHeadlineStyle: {
                  type: "font",
                  label: "\u6807\u9898-\u5b57\u4f53\u914d\u7f6e",
                },
              },
            },
            description1: {
              switch: "hasDesc1",
              label: "\u7b2c\u4e00\u5c4f-\u63cf\u8ff0",
              props: {
                description1: {
                  type: "string",
                  label: "\u63cf\u8ff0",
                  content: "text",
                },
                description1Style: {
                  type: "font",
                  label: "\u63cf\u8ff0-\u5b57\u4f53\u914d\u7f6e",
                },
              },
            },
            subTitle2: {
              switch: "hasSubTitle2",
              label: "\u7b2c\u4e8c\u5c4f-\u7709\u5934\u4e0e\u6807\u9898",
              props: {
                subEyebrow2: {
                  type: "string",
                  label: "\u7709\u5934",
                  content: "text",
                },
                subHeadline2: {
                  type: "string",
                  label: "\u6807\u9898",
                  content: "text",
                },
                subHeadline2Style: {
                  type: "font",
                  label: "\u6807\u9898-\u5b57\u4f53\u914d\u7f6e",
                },
              },
            },
            description2: {
              switch: "hasDesc2",
              label: "\u7b2c\u4e8c\u5c4f-\u63cf\u8ff0",
              props: {
                description2: {
                  type: "string",
                  label: "\u63cf\u8ff0",
                  content: "text",
                },
                description2Style: {
                  type: "font",
                  label: "\u63cf\u8ff0-\u5b57\u4f53\u914d\u7f6e",
                },
              },
            },
            page3: {
              switch: "hasPage3",
              label: "\u7b2c\u4e09\u5c4f-\u6807\u9898\u4e0e\u63cf\u8ff0",
              props: {
                subEyebrow3: {
                  type: "string",
                  label: "\u7709\u5934",
                  content: "text",
                },
                subHeadline3: {
                  type: "string",
                  label: "\u6807\u9898",
                  content: "text",
                },
                subHeadline3Style: {
                  type: "font",
                  label: "\u6807\u9898-\u5b57\u4f53\u914d\u7f6e",
                },
                description3: {
                  type: "string",
                  label: "\u63cf\u8ff0",
                  content: "text",
                },
                description3Style: {
                  type: "font",
                  label: "\u63cf\u8ff0-\u5b57\u4f53\u914d\u7f6e",
                },
              },
            },
            watchVideo: {
              switch: "hasWathVideo",
              label: "\u7b2c\u4e00\u4e2a\u89c2\u770b\u89c6\u9891\u6309\u94ae",
              props: {
                watchVideoText: {
                  type: "string",
                  label: "\u6309\u94ae\u6587\u6848",
                  content: "text",
                },
                watchVideoLink: {
                  type: "string",
                  label: "\u89c2\u770b\u89c6\u9891\u7684\u94fe\u63a5",
                  content: "url",
                },
              },
            },
            watchVideo2: {
              switch: "hasWathVideoMore",
              label: "\u7b2c\u4e8c\u4e2a\u89c2\u770b\u89c6\u9891\u6309\u94ae",
              props: {
                watchVideoText2: {
                  type: "string",
                  label:
                    "\u7b2c\u4e8c\u4e2a\u89c2\u770b\u89c6\u9891\u6309\u94ae\u6587\u6848",
                  content: "text",
                },
                watchVideoLink2: {
                  type: "string",
                  label:
                    "\u7b2c\u4e8c\u4e2a\u89c2\u770b\u89c6\u9891\u6309\u94ae\u7684\u94fe\u63a5",
                  content: "url",
                },
              },
            },
            DownloadImg: {
              switch: "hasDownloadImg",
              label: "\u4e0b\u8f7d\u539f\u7247",
              props: {
                DownloadImgText: {
                  type: "string",
                  label: "\u6309\u94ae\u6587\u6848",
                  content: "text",
                },
                DownloadImgLink: {
                  type: "string",
                  label: "\u4e0b\u8f7d\u56fe\u7247\u7684\u94fe\u63a5",
                  content: "url",
                },
                videoBtnMarginTop: {
                  type: "string",
                  label:
                    "\u89c6\u9891\u6309\u94ae\u4e0a\u8fb9\u8ddd, \u9009\u586b, \u9700\u5e26\u5355\u4f4d, \u9ed8\u8ba4 24px",
                },
              },
            },
            media: {
              label: "\u56fe\u7247/\u89c6\u9891\u7d20\u6750",
              props: {
                mediaType: {
                  label: "\u7c7b\u578b",
                  type: "select",
                  items: [
                    { label: "\u56fe\u7247", value: "picture" },
                    { label: "\u89c6\u9891", value: "video" },
                  ],
                },
                picture: {
                  label: "\u56fe\u7247",
                  type: "image",
                  controlBy: "mediaType",
                  controlValue: "photo",
                },
                video_mp4: {
                  label: "\u89c6\u9891\u94fe\u63a5_mp4\u683c\u5f0f",
                  type: "string",
                  content: "url",
                  controlBy: "mediaType",
                  controlValue: "video",
                },
                video_webm: {
                  label:
                    "\u89c6\u9891\u94fe\u63a5_webm\u683c\u5f0f\uff0c\u53ef\u4e0d\u586b",
                  type: "string",
                  content: "url",
                  controlBy: "mediaType",
                  controlValue: "video",
                },
                videoPoster: {
                  label: "\u89c6\u9891\u5c01\u9762",
                  type: "image",
                  controlBy: "mediaType",
                  controlValue: "video",
                },
                downgradeImage: {
                  type: "image",
                  label: "\u89c6\u9891\u964d\u7ea7\u9759\u6001\u56fe",
                },
              },
            },
          },
          skinSetting: {
            theme: {
              label: "\u4e3b\u9898",
              props: {
                theme: {
                  label:
                    "\u4e3b\u9898\uff08\u9ed8\u8ba4\u767d\u5e95\u9ed1\u5b57\uff09",
                  type: "select",
                  items: [
                    { label: "\u767d\u5e95\u9ed1\u5b57", value: "light" },
                    { label: "\u9ed1\u5e95\u767d\u5b57", value: "dark" },
                  ],
                },
                showMask: {
                  label: "\u662f\u5426\u5c55\u793a\u906e\u7f69",
                  type: "boolean",
                },
                maskColor: {
                  label: "\u906e\u7f69\u989c\u8272",
                  helptext: "\u9ed8\u8ba4\u4e3a\u9ed1\u8272",
                  type: "string",
                  controlBy: "showMask",
                  controlValue: !0,
                },
                maskOpacity: {
                  label: "\u906e\u7f69\u900f\u660e\u5ea6",
                  helptext:
                    "\u900f\u660e\u5ea6\u8303\u56f4\u4e3a 0-1,\u4e0d\u914d\u7f6e\u65f6,PC\u9ed8\u8ba40.55,M\u9ed8\u8ba40.2",
                  type: "string",
                  controlBy: "showMask",
                  controlValue: !0,
                },
              },
            },
            mainTitle: {
              label:
                "\u6807\u9898\u4e0e\u7709\u5934\u533a\u57df\u7684\u95f4\u8ddd",
              props: {
                mainTitlePadding: {
                  label:
                    "\u5185\u8fb9\u8ddd(\u4e0a \u53f3 \u4e0b \u5de6\uff0c\u5355\u4f4dpx)",
                  type: "string",
                  content: "size",
                },
              },
            },
          },
        });
      t.a = Object(d.a)(S);
    },
    GNiM: function (e, t, n) {
      var o = n("I01J"),
        a =
          /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        r = /\\(\\)?/g,
        i = o(function (e) {
          var t = [];
          return (
            46 === e.charCodeAt(0) && t.push(""),
            e.replace(a, function (e, n, o, a) {
              t.push(o ? a.replace(r, "$1") : n || e);
            }),
            t
          );
        });
      e.exports = i;
    },
    GOrF: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.NextArrow = t.PrevArrow = void 0);
      var o =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        a = l(n("q1tI")),
        r = l(n("TSYQ")),
        i = n("GzxR");
      function l(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function s(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      }
      function c(e, t) {
        if (!e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return !t || ("object" !== typeof t && "function" !== typeof t) ? e : t;
      }
      function _(e, t) {
        if ("function" !== typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              typeof t,
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          t &&
            (Object.setPrototypeOf
              ? Object.setPrototypeOf(e, t)
              : (e.__proto__ = t));
      }
      (t.PrevArrow = (function (e) {
        function t() {
          return s(this, t), c(this, e.apply(this, arguments));
        }
        return (
          _(t, e),
          (t.prototype.clickHandler = function (e, t) {
            t && t.preventDefault(), this.props.clickHandler(e, t);
          }),
          (t.prototype.render = function () {
            var e = { "slick-arrow": !0, "slick-prev": !0 },
              t = this.clickHandler.bind(this, { message: "previous" });
            !this.props.infinite &&
              (0 === this.props.currentSlide ||
                this.props.slideCount <= this.props.slidesToShow) &&
              ((e["slick-disabled"] = !0), (t = null));
            var n = {
                key: "0",
                "data-role": "none",
                className: (0, r.default)(e),
                style: { display: "block" },
                onClick: t,
              },
              i = {
                currentSlide: this.props.currentSlide,
                slideCount: this.props.slideCount,
              };
            return this.props.prevArrow
              ? a.default.cloneElement(this.props.prevArrow, o({}, n, i))
              : a.default.createElement(
                  "button",
                  o({ key: "0", type: "button" }, n),
                  " ",
                  "Previous",
                );
          }),
          t
        );
      })(a.default.PureComponent)),
        (t.NextArrow = (function (e) {
          function t() {
            return s(this, t), c(this, e.apply(this, arguments));
          }
          return (
            _(t, e),
            (t.prototype.clickHandler = function (e, t) {
              t && t.preventDefault(), this.props.clickHandler(e, t);
            }),
            (t.prototype.render = function () {
              var e = { "slick-arrow": !0, "slick-next": !0 },
                t = this.clickHandler.bind(this, { message: "next" });
              (0, i.canGoNext)(this.props) ||
                ((e["slick-disabled"] = !0), (t = null));
              var n = {
                  key: "1",
                  "data-role": "none",
                  className: (0, r.default)(e),
                  style: { display: "block" },
                  onClick: t,
                },
                l = {
                  currentSlide: this.props.currentSlide,
                  slideCount: this.props.slideCount,
                };
              return this.props.nextArrow
                ? a.default.cloneElement(this.props.nextArrow, o({}, n, l))
                : a.default.createElement(
                    "button",
                    o({ key: "1", type: "button" }, n),
                    " ",
                    "Next",
                  );
            }),
            t
          );
        })(a.default.PureComponent));
    },
    Gi0A: function (e, t, n) {
      var o = n("QqLw"),
        a = n("ExA7"),
        r = "[object Map]";
      e.exports = function (e) {
        return a(e) && o(e) == r;
      };
    },
    GoyQ: function (e, t) {
      e.exports = function (e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      };
    },
    Gsew: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return m;
      });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("rePB"),
        c = n("iKuz"),
        _ = n.n(c),
        u = n("q1tI"),
        d = (n("LMt4"), u.createElement),
        p = {
          "./style.css": {
            "font-weight-light": "style__font-weight-light___1nuXd",
            "font-weight-solid": "style__font-weight-solid___169j4",
            "dji-atom-icon": "style__dji-atom-icon___3W0ny",
            "icon-search-minus": "style__icon-search-minus___cOhwY",
            "icon-play-circle": "style__icon-play-circle___1RUrX",
            "icon-caret-down-o": "style__icon-caret-down-o___19bV8",
            "icon-search": "style__icon-search___1Ff6s",
            "icon-list": "style__icon-list___n0DRN",
            "icon-info-square": "style__icon-info-square___2rWdR",
            "icon-cog": "style__icon-cog___10AHG",
            "icon-hourglass": "style__icon-hourglass___3usQu",
            "icon-angle-double-left": "style__icon-angle-double-left___1JUyB",
            "icon-user": "style__icon-user___1Arby",
            "icon-home": "style__icon-home___3tA8p",
            "icon-map-marked-alt": "style__icon-map-marked-alt___3B3tR",
            "icon-box-alt": "style__icon-box-alt___3v1jN",
            "icon-check-circle-o": "style__icon-check-circle-o___LO8cK",
            "icon-tag": "style__icon-tag___1aPnN",
            "icon-file-export": "style__icon-file-export___18_bm",
            "icon-exclamation-square": "style__icon-exclamation-square___2RZH6",
            "icon-arrow-circle-up": "style__icon-arrow-circle-up___2SNcq",
            "icon-pen-square": "style__icon-pen-square___3cBEx",
            "icon-comments": "style__icon-comments___1EhlO",
            "icon-headset": "style__icon-headset___1Kkbh",
            "icon-angle-down": "style__icon-angle-down___2nYYy",
            "icon-database": "style__icon-database___1lgX-",
            "icon-truck-moving": "style__icon-truck-moving___2Djgp",
            "icon-file": "style__icon-file___3dhUu",
            "icon-control": "style__icon-control___2GVe1",
            "icon-signal": "style__icon-signal___3cYsp",
            "icon-signal-alt": "style__icon-signal-alt___20EfS",
            "icon-purchase": "style__icon-purchase___y3Ehv",
            "icon-angle-up": "style__icon-angle-up___3UTd1",
            "icon-exclamation-triangle":
              "style__icon-exclamation-triangle___1tl03",
            "icon-lock": "style__icon-lock___rMhIy",
            "icon-question-circle": "style__icon-question-circle___39Qyy",
            "icon-cloud-upload": "style__icon-cloud-upload___4ouGV",
            "icon-pen": "style__icon-pen___1n6Ql",
            "icon-ban": "style__icon-ban___2TdFo",
            "icon-certificate": "style__icon-certificate___3coCT",
            "icon-link": "style__icon-link___QMFWG",
            "icon-order": "style__icon-order___qjH16",
            "icon-ellipsis-h": "style__icon-ellipsis-h___3YCTe",
            "icon-noun-Empty": "style__icon-noun-Empty___37h7X",
            "icon-caret-left-o": "style__icon-caret-left-o___U8vkb",
            "icon-qrcode": "style__icon-qrcode___WzUrd",
            "icon-calendar-plus": "style__icon-calendar-plus___TO9cY",
            "icon-calendar-check": "style__icon-calendar-check___3VftT",
            "icon-yen-sign": "style__icon-yen-sign___A4uN_",
            "icon-times-circle-o": "style__icon-times-circle-o___1rETg",
            "icon-cart": "style__icon-cart___1s7d-",
            "icon-compress": "style__icon-compress___X8FC1",
            "icon-envelope": "style__icon-envelope___3GvFc",
            "icon-location-arrow": "style__icon-location-arrow___2Qsvz",
            "icon-download": "style__icon-download___2ATGw",
            "icon-shield": "style__icon-shield___2MI7O",
            "icon-expand": "style__icon-expand___yJ4dD",
            "icon-bolt": "style__icon-bolt___am4uf",
            "icon-file-import": "style__icon-file-import___1tiq4",
            "icon-angle-double-right": "style__icon-angle-double-right___3nOBe",
            "icon-book": "style__icon-book___3d4_3",
            "icon-bell": "style__icon-bell___3C4r6",
            "icon-caret-right-o": "style__icon-caret-right-o___1ocjx",
            "icon-flag": "style__icon-flag___JJ2SB",
            "icon-update": "style__icon-update___6xv-n",
            "icon-map-marker-alt": "style__icon-map-marker-alt___3d5-J",
            "icon-clipboard-list": "style__icon-clipboard-list___8G1Rl",
            "icon-paper": "style__icon-paper___1Gk6t",
            "icon-trophy": "style__icon-trophy___1c8qG",
            "icon-check": "style__icon-check___1mTaG",
            "icon-plus": "style__icon-plus___1EUr-",
            "icon-angle-right": "style__icon-angle-right___3xpZK",
            "icon-info": "style__icon-info___2jXQH",
            "icon-bullhorn": "style__icon-bullhorn___2JHU8",
            "icon-info-circle": "style__icon-info-circle___3Pzft",
            "icon-list-view": "style__icon-list-view___3vq7f",
            "icon-copy": "style__icon-copy___ibsaS",
            "icon-coins": "style__icon-coins___1GSK5",
            "icon-signal-slash": "style__icon-signal-slash___1D1FC",
            "icon-compare": "style__icon-compare___23VVi",
            "icon-ellipsis-v": "style__icon-ellipsis-v___QanOQ",
            "icon-calendar-alt": "style__icon-calendar-alt___1nnws",
            "icon-images": "style__icon-images___3w3pn",
            "icon-search-plus": "style__icon-search-plus___286MF",
            "icon-paperclip": "style__icon-paperclip___2So3v",
            "icon-file-alt": "style__icon-file-alt___3XiA3",
            "icon-shutter": "style__icon-shutter___2Tc1F",
            "icon-box": "style__icon-box___2ffxD",
            "icon-crown": "style__icon-crown___2tewJ",
            "icon-check-square-o": "style__icon-check-square-o___3ErpE",
            "icon-coupon": "style__icon-coupon___1oj5a",
            "icon-logic": "style__icon-logic___mHbnr",
            "icon-facebook": "style__icon-facebook___r6Swk",
            "icon-camera": "style__icon-camera___qfAbZ",
            "icon-redo": "style__icon-redo___qPzKM",
            "icon-user-friends": "style__icon-user-friends___Dg7v8",
            "icon-wechat": "style__icon-wechat___2s-xj",
            "icon-exclamation-circle": "style__icon-exclamation-circle___1E3TC",
            "icon-vr": "style__icon-vr___pY-ln",
            "icon-star": "style__icon-star___wgetm",
            "icon-arrow-circle-down": "style__icon-arrow-circle-down___3v2S8",
            "icon-edit": "style__icon-edit___yRC27",
            "icon-circle-notch": "style__icon-circle-notch___3chsk",
            "icon-unlink": "style__icon-unlink___2ZKtt",
            "icon-comment-smile": "style__icon-comment-smile___1tvoM",
            "icon-comment-alt-smile": "style__icon-comment-alt-smile___28OPN",
            "icon-education": "style__icon-education___2eWRb",
            "icon-unlock": "style__icon-unlock___2k17U",
            "icon-plus-circle": "style__icon-plus-circle___1v9Py",
            "icon-frame": "style__icon-frame___1jyki",
            "icon-credit-card": "style__icon-credit-card___2VI6o",
            "icon-user-tie": "style__icon-user-tie___1E59_",
            "icon-language": "style__icon-language___ukU5k",
            "icon-setup": "style__icon-setup___3ERjO",
            "icon-trash-alt": "style__icon-trash-alt___L5mR4",
            "icon-phone": "style__icon-phone___2_BA5",
            "icon-clock": "style__icon-clock___1XFPJ",
            "icon-drone": "style__icon-drone___H5kYV",
            "icon-eye": "style__icon-eye___2qE7M",
            "icon-location": "style__icon-location___1Molc",
            "icon-image-view": "style__icon-image-view___2Azg1",
            "icon-external-link": "style__icon-external-link___nq6Kx",
            "icon-gift": "style__icon-gift___38Nw4",
            "icon-share": "style__icon-share___3fukp",
            "icon-balance-scale": "style__icon-balance-scale___LJf4g",
            "icon-heart-o": "style__icon-heart-o___1OnuG",
            "icon-calendar-minus": "style__icon-calendar-minus___1MXLn",
            "icon-video": "style__icon-video___2Ha1b",
            "icon-filter": "style__icon-filter___3g5QP",
            "icon-bell-slash": "style__icon-bell-slash___1igoy",
            "icon-comment": "style__icon-comment___1i2VS",
            "icon-calendar": "style__icon-calendar___1CIbD",
            "icon-globe": "style__icon-globe___2cY0K",
            "icon-minus-circle": "style__icon-minus-circle___25fd3",
            "icon-arrival-reminder": "style__icon-arrival-reminder___6jNov",
            "icon-calendar-times": "style__icon-calendar-times___2zEPo",
            "icon-bars": "style__icon-bars___2Bc6K",
            "icon-upload": "style__icon-upload___1YDdR",
            "icon-bookmark": "style__icon-bookmark___2KZeu",
            "icon-times-square-o": "style__icon-times-square-o___3eEE7",
            "icon-unfold": "style__icon-unfold___14jzK",
            "icon-angle-left": "style__icon-angle-left___2EBCm",
            "icon-cloud-download": "style__icon-cloud-download___2pl9j",
            "icon-mouse": "style__icon-mouse___3AHth",
            "icon-shield-check": "style__icon-shield-check___26CHo",
            "icon-caret-up-o": "style__icon-caret-up-o___29i_6",
            "icon-users": "style__icon-users___1GIj8",
            "icon-file-pdf": "style__icon-file-pdf___V8a6k",
            "icon-minus": "style__icon-minus___3FPzD",
            "icon-times": "style__icon-times___I2P-K",
            "icon-exclamation": "style__icon-exclamation___2Vyv2",
            "icon-user-shield": "style__icon-user-shield___Dlv8J",
            "icon-caret-down": "style__icon-caret-down___20jAQ",
            "icon-check-square": "style__icon-check-square___2aHW_",
            "icon-play-visual-center": "style__icon-play-visual-center___EEDkz",
            "icon-times-square": "style__icon-times-square___HD-gf",
            "icon-caret-up": "style__icon-caret-up___Kesms",
            "icon-caret-right": "style__icon-caret-right___3R5CT",
            "icon-star-half": "style__icon-star-half___1wDSr",
            "icon-check-circle": "style__icon-check-circle___1bUq-",
            "icon-eye-slash": "style__icon-eye-slash___3dCqb",
            "icon-play": "style__icon-play___3VHLE",
            "icon-textarea": "style__icon-textarea___29I4u",
            "icon-caret-left": "style__icon-caret-left___3p0Oo",
            "icon-times-circle": "style__icon-times-circle___3ztOM",
            "icon-heart": "style__icon-heart___3e9UT",
          },
        };
      function f(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var h = (function (e) {
          return (e.light = "light"), (e.solid = "solid"), e;
        })({}),
        m = (function (e) {
          function t() {
            return Object(o.default)(this, t), f(this, t, arguments);
          }
          return (
            Object(l.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props;
                  return d("i", {
                    style: e.style,
                    className: _()(
                      "dji-atom-icon icon-"
                        .concat(e.name, " font-weight-")
                        .concat(e.weight),
                      p,
                      {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      },
                    ),
                  });
                },
              },
            ]),
            t
          );
        })(u.Component);
      Object(s.a)(m, "defaultProps", { weight: h.light, style: {} });
    },
    Gytx: function (e, t) {
      e.exports = function (e, t, n, o) {
        var a = n ? n.call(o, e, t) : void 0;
        if (void 0 !== a) return !!a;
        if (e === t) return !0;
        if ("object" !== typeof e || !e || "object" !== typeof t || !t)
          return !1;
        var r = Object.keys(e),
          i = Object.keys(t);
        if (r.length !== i.length) return !1;
        for (
          var l = Object.prototype.hasOwnProperty.bind(t), s = 0;
          s < r.length;
          s++
        ) {
          var c = r[s];
          if (!l(c)) return !1;
          var _ = e[c],
            u = t[c];
          if (
            !1 === (a = n ? n.call(o, _, u, c) : void 0) ||
            (void 0 === a && _ !== u)
          )
            return !1;
        }
        return !0;
      };
    },
    GzxR: function (e, t, n) {
      "use strict";
      (t.__esModule = !0),
        (t.canUseDOM =
          t.slidesOnLeft =
          t.slidesOnRight =
          t.siblingDirection =
          t.getTotalSlides =
          t.getPostClones =
          t.getPreClones =
          t.getTrackLeft =
          t.getTrackAnimateCSS =
          t.getTrackCSS =
          t.checkSpecKeys =
          t.getSlideCount =
          t.checkNavigable =
          t.getNavigableIndexes =
          t.swipeEnd =
          t.swipeMove =
          t.swipeStart =
          t.keyHandler =
          t.changeSlide =
          t.slideHandler =
          t.initializedState =
          t.extractObject =
          t.canGoNext =
          t.getSwipeDirection =
          t.getHeight =
          t.getWidth =
          t.lazySlidesOnRight =
          t.lazySlidesOnLeft =
          t.lazyEndIndex =
          t.lazyStartIndex =
          t.getRequiredLazySlides =
          t.getOnDemandLazySlides =
            void 0);
      var o =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        a = i(n("q1tI")),
        r = i(n("i8i4"));
      function i(e) {
        return e && e.__esModule ? e : { default: e };
      }
      var l = (t.getOnDemandLazySlides = function (e) {
          for (var t = [], n = s(e), o = c(e), a = n; a < o; a++)
            e.lazyLoadedList.indexOf(a) < 0 && t.push(a);
          return t;
        }),
        s =
          ((t.getRequiredLazySlides = function (e) {
            for (var t = [], n = s(e), o = c(e), a = n; a < o; a++) t.push(a);
            return t;
          }),
          (t.lazyStartIndex = function (e) {
            return e.currentSlide - _(e);
          })),
        c = (t.lazyEndIndex = function (e) {
          return e.currentSlide + u(e);
        }),
        _ = (t.lazySlidesOnLeft = function (e) {
          return e.centerMode
            ? Math.floor(e.slidesToShow / 2) +
                (parseInt(e.centerPadding) > 0 ? 1 : 0)
            : 0;
        }),
        u = (t.lazySlidesOnRight = function (e) {
          return e.centerMode
            ? Math.floor((e.slidesToShow - 1) / 2) +
                1 +
                (parseInt(e.centerPadding) > 0 ? 1 : 0)
            : e.slidesToShow;
        }),
        d = (t.getWidth = function (e) {
          return (e && e.offsetWidth) || 0;
        }),
        p = (t.getHeight = function (e) {
          return (e && e.offsetHeight) || 0;
        }),
        f = (t.getSwipeDirection = function (e) {
          var t,
            n,
            o,
            a,
            r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          return (
            (t = e.startX - e.curX),
            (n = e.startY - e.curY),
            (o = Math.atan2(n, t)),
            (a = Math.round((180 * o) / Math.PI)) < 0 &&
              (a = 360 - Math.abs(a)),
            (a <= 45 && a >= 0) || (a <= 360 && a >= 315)
              ? "left"
              : a >= 135 && a <= 225
                ? "right"
                : !0 === r
                  ? a >= 35 && a <= 135
                    ? "up"
                    : "down"
                  : "vertical"
          );
        }),
        h = (t.canGoNext = function (e) {
          var t = !0;
          return (
            e.infinite ||
              (e.centerMode && e.currentSlide >= e.slideCount - 1
                ? (t = !1)
                : (e.slideCount <= e.slidesToShow ||
                    e.currentSlide >= e.slideCount - e.slidesToShow) &&
                  (t = !1)),
            t
          );
        }),
        m =
          ((t.extractObject = function (e, t) {
            var n = {};
            return (
              t.forEach(function (t) {
                return (n[t] = e[t]);
              }),
              n
            );
          }),
          (t.initializedState = function (e) {
            var t = a.default.Children.count(e.children),
              n = Math.ceil(d(r.default.findDOMNode(e.listRef))),
              o = Math.ceil(d(r.default.findDOMNode(e.trackRef))),
              i = void 0;
            if (e.vertical) i = n;
            else {
              var s = e.centerMode && 2 * parseInt(e.centerPadding);
              "string" === typeof e.centerPadding &&
                "%" === e.centerPadding.slice(-1) &&
                (s *= n / 100),
                (i = Math.ceil((n - s) / e.slidesToShow));
            }
            var c =
                r.default.findDOMNode(e.listRef) &&
                p(
                  r.default
                    .findDOMNode(e.listRef)
                    .querySelector('[data-index="0"]'),
                ),
              _ = c * e.slidesToShow,
              u = void 0 === e.currentSlide ? e.initialSlide : e.currentSlide;
            e.rtl && void 0 === e.currentSlide && (u = t - 1 - e.initialSlide);
            var f = e.lazyLoadedList || [],
              h = l({ currentSlide: u, lazyLoadedList: f }, e);
            f.concat(h);
            var m = {
              slideCount: t,
              slideWidth: i,
              listWidth: n,
              trackWidth: o,
              currentSlide: u,
              slideHeight: c,
              listHeight: _,
              lazyLoadedList: f,
            };
            return (
              null === e.autoplaying &&
                e.autoplay &&
                (m.autoplaying = "playing"),
              m
            );
          }),
          (t.slideHandler = function (e) {
            var t = e.waitForAnimate,
              n = e.animating,
              a = e.fade,
              r = e.infinite,
              i = e.index,
              s = e.slideCount,
              c = e.lazyLoadedList,
              _ = e.lazyLoad,
              u = e.currentSlide,
              d = e.centerMode,
              p = e.slidesToScroll,
              f = e.slidesToShow,
              m = e.useCSS;
            if (t && n) return {};
            var y = i,
              b = void 0,
              v = void 0,
              k = void 0,
              O = {},
              I = {};
            if (a) {
              if (!r && (i < 0 || i >= s)) return {};
              i < 0 ? (y = i + s) : i >= s && (y = i - s),
                _ && c.indexOf(y) < 0 && c.push(y),
                (O = { animating: !0, currentSlide: y, lazyLoadedList: c }),
                (I = { animating: !1 });
            } else
              (b = y),
                y < 0
                  ? ((b = y + s),
                    r ? s % p !== 0 && (b = s - (s % p)) : (b = 0))
                  : !h(e) && y > u
                    ? (y = b = u)
                    : d && y >= s
                      ? ((y = r ? s : s - 1), (b = r ? 0 : s - 1))
                      : y >= s &&
                        ((b = y - s), r ? s % p !== 0 && (b = 0) : (b = s - f)),
                (v = x(o({}, e, { slideIndex: y }))),
                (k = x(o({}, e, { slideIndex: b }))),
                r || (v === k && (y = b), (v = k)),
                _ && c.concat(l(o({}, e, { currentSlide: y }))),
                m
                  ? ((O = {
                      animating: !0,
                      currentSlide: b,
                      trackStyle: w(o({}, e, { left: v })),
                      lazyLoadedList: c,
                    }),
                    (I = {
                      animating: !1,
                      currentSlide: b,
                      trackStyle: g(o({}, e, { left: k })),
                      swipeLeft: null,
                    }))
                  : (O = {
                      currentSlide: b,
                      trackStyle: g(o({}, e, { left: k })),
                      lazyLoadedList: c,
                    });
            return { state: O, nextState: I };
          }),
          (t.changeSlide = function (e, t) {
            var n,
              a,
              r,
              i,
              l = e.slidesToScroll,
              s = e.slidesToShow,
              c = e.slideCount,
              _ = e.currentSlide,
              u = e.lazyLoad,
              d = e.infinite;
            if (((n = c % l !== 0 ? 0 : (c - _) % l), "previous" === t.message))
              (i = _ - (r = 0 === n ? l : s - n)),
                u && !d && (i = -1 === (a = _ - r) ? c - 1 : a);
            else if ("next" === t.message)
              (i = _ + (r = 0 === n ? l : n)),
                u && !d && (i = ((_ + l) % c) + n);
            else if ("dots" === t.message) {
              if ((i = t.index * t.slidesToScroll) === t.currentSlide)
                return null;
            } else if ("children" === t.message) {
              if ((i = t.index) === t.currentSlide) return null;
              if (d) {
                var p = S(o({}, e, { targetSlide: i }));
                i > t.currentSlide && "left" === p
                  ? (i -= c)
                  : i < t.currentSlide && "right" === p && (i += c);
              }
            } else if (
              "index" === t.message &&
              (i = Number(t.index)) === t.currentSlide
            )
              return null;
            return i;
          }),
          (t.keyHandler = function (e, t, n) {
            return e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !t
              ? ""
              : 37 === e.keyCode
                ? n
                  ? "next"
                  : "previous"
                : 39 === e.keyCode
                  ? n
                    ? "previous"
                    : "next"
                  : "";
          }),
          (t.swipeStart = function (e, t, n) {
            return (
              "IMG" === e.target.tagName && e.preventDefault(),
              !t || (!n && -1 !== e.type.indexOf("mouse"))
                ? ""
                : {
                    dragging: !0,
                    touchObject: {
                      startX: e.touches ? e.touches[0].pageX : e.clientX,
                      startY: e.touches ? e.touches[0].pageY : e.clientY,
                      curX: e.touches ? e.touches[0].pageX : e.clientX,
                      curY: e.touches ? e.touches[0].pageY : e.clientY,
                    },
                  }
            );
          }),
          (t.swipeMove = function (e, t) {
            var n = t.scrolling,
              a = t.animating,
              r = t.vertical,
              i = t.swipeToSlide,
              l = t.verticalSwiping,
              s = t.rtl,
              c = t.currentSlide,
              _ = t.edgeFriction,
              u = t.edgeDragged,
              d = t.onEdge,
              p = t.swiped,
              m = t.swiping,
              y = t.slideCount,
              b = t.slidesToScroll,
              v = t.infinite,
              w = t.touchObject,
              k = t.swipeEvent,
              O = t.listHeight,
              I = t.listWidth;
            if (!n) {
              if (a) return e.preventDefault();
              r && i && l && e.preventDefault();
              var S = void 0,
                j = {},
                T = x(t);
              (w.curX = e.touches ? e.touches[0].pageX : e.clientX),
                (w.curY = e.touches ? e.touches[0].pageY : e.clientY),
                (w.swipeLength = Math.round(
                  Math.sqrt(Math.pow(w.curX - w.startX, 2)),
                ));
              var C = Math.round(Math.sqrt(Math.pow(w.curY - w.startY, 2)));
              if (!m && w.swipeLength * w.swipeLength + C * C >= 25) {
                var M =
                  (180 * Math.atan2(Math.abs(C), Math.abs(w.swipeLength))) /
                  Math.PI;
                if (l ? 90 - M > 45 : M > 45) return { scrolling: !0 };
              }
              l && (w.swipeLength = C);
              var P = (s ? -1 : 1) * (w.curX > w.startX ? 1 : -1);
              l && (P = w.curY > w.startY ? 1 : -1);
              var E = Math.ceil(y / b),
                L = f(t.touchObject, l),
                B = w.swipeLength;
              return (
                v ||
                  (((0 === c && "right" === L) ||
                    (c + 1 >= E && "left" === L) ||
                    (!h(t) && "left" === L)) &&
                    ((B = w.swipeLength * _),
                    !1 === u && d && (d(L), (j.edgeDragged = !0)))),
                !p && k && (k(L), (j.swiped = !0)),
                (S = r ? T + B * (O / I) * P : s ? T - B * P : T + B * P),
                l && (S = T + B * P),
                (j = o({}, j, {
                  touchObject: w,
                  swipeLeft: S,
                  trackStyle: g(o({}, t, { left: S })),
                })),
                Math.abs(w.curX - w.startX) < 0.8 * Math.abs(w.curY - w.startY)
                  ? j
                  : (w.swipeLength > 5 &&
                      ((j.swiping = !0), e.preventDefault()),
                    j)
              );
            }
          }),
          (t.swipeEnd = function (e, t) {
            var n = t.dragging,
              a = t.swipe,
              r = t.touchObject,
              i = t.listWidth,
              l = t.touchThreshold,
              s = t.verticalSwiping,
              c = t.listHeight,
              _ = t.currentSlide,
              u = t.swipeToSlide,
              d = t.scrolling,
              p = t.onSwipe;
            if (!n) return a && e.preventDefault(), {};
            var h = s ? c / l : i / l,
              m = f(r, s),
              v = {
                dragging: !1,
                edgeDragged: !1,
                scrolling: !1,
                swiping: !1,
                swiped: !1,
                swipeLeft: null,
                touchObject: {},
              };
            if (d) return v;
            if (!r.swipeLength) return v;
            if (r.swipeLength > h) {
              e.preventDefault(), p && p(m);
              var g = void 0,
                k = void 0;
              switch (m) {
                case "left":
                case "up":
                  (k = _ + b(t)),
                    (g = u ? y(t, k) : k),
                    (v.currentDirection = 0);
                  break;
                case "right":
                case "down":
                  (k = _ - b(t)),
                    (g = u ? y(t, k) : k),
                    (v.currentDirection = 1);
                  break;
                default:
                  g = _;
              }
              v.triggerSlideHandler = g;
            } else {
              var O = x(t);
              v.trackStyle = w(o({}, t, { left: O }));
            }
            return v;
          }),
          (t.getNavigableIndexes = function (e) {
            for (
              var t = e.infinite ? 2 * e.slideCount : e.slideCount,
                n = e.infinite ? -1 * e.slidesToShow : 0,
                o = e.infinite ? -1 * e.slidesToShow : 0,
                a = [];
              n < t;

            )
              a.push(n),
                (n = o + e.slidesToScroll),
                (o += Math.min(e.slidesToScroll, e.slidesToShow));
            return a;
          })),
        y = (t.checkNavigable = function (e, t) {
          var n = m(e),
            o = 0;
          if (t > n[n.length - 1]) t = n[n.length - 1];
          else
            for (var a in n) {
              if (t < n[a]) {
                t = o;
                break;
              }
              o = n[a];
            }
          return t;
        }),
        b = (t.getSlideCount = function (e) {
          var t = e.centerMode
            ? e.slideWidth * Math.floor(e.slidesToShow / 2)
            : 0;
          if (e.swipeToSlide) {
            var n = void 0,
              o = r.default
                .findDOMNode(e.listRef)
                .querySelectorAll(".slick-slide");
            if (
              (Array.from(o).every(function (o) {
                if (e.vertical) {
                  if (o.offsetTop + p(o) / 2 > -1 * e.swipeLeft)
                    return (n = o), !1;
                } else if (o.offsetLeft - t + d(o) / 2 > -1 * e.swipeLeft)
                  return (n = o), !1;
                return !0;
              }),
              !n)
            )
              return 0;
            var a =
              !0 === e.rtl ? e.slideCount - e.currentSlide : e.currentSlide;
            return Math.abs(n.dataset.index - a) || 1;
          }
          return e.slidesToScroll;
        }),
        v = (t.checkSpecKeys = function (e, t) {
          return t.reduce(function (t, n) {
            return t && e.hasOwnProperty(n);
          }, !0)
            ? null
            : console.error("Keys Missing:", e);
        }),
        g = (t.getTrackCSS = function (e) {
          v(e, [
            "left",
            "variableWidth",
            "slideCount",
            "slidesToShow",
            "slideWidth",
          ]);
          var t = void 0,
            n = void 0,
            a = e.slideCount + 2 * e.slidesToShow;
          e.vertical ? (n = a * e.slideHeight) : (t = I(e) * e.slideWidth);
          var r = { opacity: 1, transition: "", WebkitTransition: "" };
          if (e.useTransform) {
            var i = e.vertical
                ? "translate3d(0px, " + e.left + "px, 0px)"
                : "translate3d(" + e.left + "px, 0px, 0px)",
              l = e.vertical
                ? "translate3d(0px, " + e.left + "px, 0px)"
                : "translate3d(" + e.left + "px, 0px, 0px)",
              s = e.vertical
                ? "translateY(" + e.left + "px)"
                : "translateX(" + e.left + "px)";
            r = o({}, r, { WebkitTransform: i, transform: l, msTransform: s });
          } else e.vertical ? (r.top = e.left) : (r.left = e.left);
          return (
            e.fade && (r = { opacity: 1 }),
            t && (r.width = t),
            n && (r.height = n),
            window &&
              !window.addEventListener &&
              window.attachEvent &&
              (e.vertical
                ? (r.marginTop = e.left + "px")
                : (r.marginLeft = e.left + "px")),
            r
          );
        }),
        w = (t.getTrackAnimateCSS = function (e) {
          v(e, [
            "left",
            "variableWidth",
            "slideCount",
            "slidesToShow",
            "slideWidth",
            "speed",
            "cssEase",
          ]);
          var t = g(e);
          return (
            e.useTransform
              ? ((t.WebkitTransition =
                  "-webkit-transform " + e.speed + "ms " + e.cssEase),
                (t.transition = "transform " + e.speed + "ms " + e.cssEase))
              : e.vertical
                ? (t.transition = "top " + e.speed + "ms " + e.cssEase)
                : (t.transition = "left " + e.speed + "ms " + e.cssEase),
            t
          );
        }),
        x = (t.getTrackLeft = function (e) {
          if (e.unslick) return 0;
          v(e, [
            "slideIndex",
            "trackRef",
            "infinite",
            "centerMode",
            "slideCount",
            "slidesToShow",
            "slidesToScroll",
            "slideWidth",
            "listWidth",
            "variableWidth",
            "slideHeight",
          ]);
          var t,
            n,
            o = e.slideIndex,
            a = e.trackRef,
            i = e.infinite,
            l = e.centerMode,
            s = e.slideCount,
            c = e.slidesToShow,
            _ = e.slidesToScroll,
            u = e.slideWidth,
            d = e.listWidth,
            p = e.variableWidth,
            f = e.slideHeight,
            h = e.fade,
            m = e.vertical;
          if (h || 1 === e.slideCount) return 0;
          var y = 0;
          if (
            (i
              ? ((y = -k(e)),
                s % _ !== 0 &&
                  o + _ > s &&
                  (y = -(o > s ? c - (o - s) : s % _)),
                l && (y += parseInt(c / 2)))
              : (s % _ !== 0 && o + _ > s && (y = c - (s % _)),
                l && (y = parseInt(c / 2))),
            (t = m ? o * f * -1 + y * f : o * u * -1 + y * u),
            !0 === p)
          ) {
            var b,
              g = r.default.findDOMNode(a);
            if (
              ((b = o + k(e)),
              (t = (n = g && g.childNodes[b]) ? -1 * n.offsetLeft : 0),
              !0 === l)
            ) {
              (b = i ? o + k(e) : o), (n = g && g.children[b]), (t = 0);
              for (var w = 0; w < b; w++)
                t -= g && g.children[w] && g.children[w].offsetWidth;
              (t -= parseInt(e.centerPadding)),
                (t += n && (d - n.offsetWidth) / 2);
            }
          }
          return t;
        }),
        k = (t.getPreClones = function (e) {
          return e.unslick || !e.infinite
            ? 0
            : e.variableWidth
              ? e.slideCount
              : e.slidesToShow + (e.centerMode ? 1 : 0);
        }),
        O = (t.getPostClones = function (e) {
          return e.unslick || !e.infinite ? 0 : e.slideCount;
        }),
        I = (t.getTotalSlides = function (e) {
          return 1 === e.slideCount ? 1 : k(e) + e.slideCount + O(e);
        }),
        S = (t.siblingDirection = function (e) {
          return e.targetSlide > e.currentSlide
            ? e.targetSlide > e.currentSlide + j(e)
              ? "left"
              : "right"
            : e.targetSlide < e.currentSlide - T(e)
              ? "right"
              : "left";
        }),
        j = (t.slidesOnRight = function (e) {
          var t = e.slidesToShow,
            n = e.centerMode,
            o = e.rtl,
            a = e.centerPadding;
          if (n) {
            var r = (t - 1) / 2 + 1;
            return parseInt(a) > 0 && (r += 1), o && t % 2 === 0 && (r += 1), r;
          }
          return o ? 0 : t - 1;
        }),
        T = (t.slidesOnLeft = function (e) {
          var t = e.slidesToShow,
            n = e.centerMode,
            o = e.rtl,
            a = e.centerPadding;
          if (n) {
            var r = (t - 1) / 2 + 1;
            return parseInt(a) > 0 && (r += 1), o || t % 2 !== 0 || (r += 1), r;
          }
          return o ? t - 1 : 0;
        });
      t.canUseDOM = function () {
        return !(
          "undefined" === typeof window ||
          !window.document ||
          !window.document.createElement
        );
      };
    },
    "H+zn": function (e, t, n) {
      e.exports = {
        "atom-horizontal-tabs": "style__atom-horizontal-tabs___1W_2y",
        "tab-item": "style__tab-item___2XPNc",
        "aotm-horizontal-tab-inkbar":
          "style__aotm-horizontal-tab-inkbar___2J6Hn",
        "atom-horizontal-tab-bisection":
          "style__atom-horizontal-tab-bisection___1TFaE",
        "tab-bar-box": "style__tab-bar-box___1n6tq",
        "tab-bar-wrap": "style__tab-bar-wrap___9MHND",
        "atom-horizontal-tabs-left": "style__atom-horizontal-tabs-left___3c2ZI",
        "atom-horizontal-tabs-center":
          "style__atom-horizontal-tabs-center___2rprk",
        "atom-horizontal-tabs-right":
          "style__atom-horizontal-tabs-right___2qoMi",
        "atom-horizontal-tab-bar-theme-dark":
          "style__atom-horizontal-tab-bar-theme-dark___21hHN",
        "tab-item-active": "style__tab-item-active___2Xb8y",
        "tab-hover-icon": "style__tab-hover-icon___11q9a",
        "tab-icon": "style__tab-icon___1IqCU",
        "atom-horizontal-tab-bar-theme-light":
          "style__atom-horizontal-tab-bar-theme-light___23hzn",
        "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___1f_vc",
        "icon-text": "style__icon-text___1YrCe",
        "icon-title": "style__icon-title___14Ntw",
        "icon-box": "style__icon-box___T6GmX",
        "atom-horizontal-tab-bar-left":
          "style__atom-horizontal-tab-bar-left___2Mb87",
        "atom-horizontal-tab-bar-center":
          "style__atom-horizontal-tab-bar-center___1Fa3k",
        "atom-horizontal-tab-bar-right":
          "style__atom-horizontal-tab-bar-right___1GXp6",
        "atom-horizontal-tab-content":
          "style__atom-horizontal-tab-content___2dnfl",
        "atom-horizontal-tab-content-left":
          "style__atom-horizontal-tab-content-left___19LcX",
        "atom-horizontal-tab-content-center":
          "style__atom-horizontal-tab-content-center___32l3i",
        "atom-horizontal-tab-content-right":
          "style__atom-horizontal-tab-content-right___3M0YU",
        "atom-horizontal-tabs-content-theme-dark":
          "style__atom-horizontal-tabs-content-theme-dark___14w_n",
        "tab-panel": "style__tab-panel___2lHpo",
        "atom-horizontal-tabs-content-theme-light":
          "style__atom-horizontal-tabs-content-theme-light___FiDv6",
        "tab-panel-active": "style__tab-panel-active___1yZh_",
        "atom-horizontal-tab-bar-none":
          "style__atom-horizontal-tab-bar-none___RD3De",
        "tab-line": "style__tab-line___1UScG",
      };
    },
    H5DZ: function (e, t, n) {
      "use strict";
      var o = n("rePB"),
        a = n("wx14"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("XnI8"),
        m = n("/MKj"),
        y = n("TSYQ"),
        b = n.n(y),
        v = n("EW6r"),
        g = n.n(v),
        w = (n("eDQT"), n("XrJB")),
        x = n.n(w),
        k = (n("aiR1"), n("YRpl")),
        O = n.n(k),
        I = n("/+VL"),
        S = n("SBOM"),
        j = n("ub/+"),
        T = n("9Rgp"),
        C = (n("O0hh"), f.a.createElement);
      function M(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function P(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? M(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : M(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var E = {
        "./style.css": {
          "section-vertical-tab-component":
            "style__section-vertical-tab-component___3WQ4B",
          "text-box": "style__text-box___vbOl_",
          title: "style__title___2VH5C",
          "horizontal-line": "style__horizontal-line___3Ik3a",
          desc: "style__desc___2MDwx",
          "link-btn": "style__link-btn___2f9zc",
          "angle-right-icon": "style__angle-right-icon___1vJXg",
          "text-box-light": "style__text-box-light___eA8gy",
          "text-box-dark": "style__text-box-dark___1Erd4",
          container: "style__container____p2J2",
          "tab-container": "style__tab-container___dyPyP",
          "tab-box": "style__tab-box___369jU",
          "desc-box-theme-light": "style__desc-box-theme-light___2Kd9Y",
          "desc-box-theme-dark": "style__desc-box-theme-dark___2vWH5",
          "desc-box": "style__desc-box___1-Xk2",
          "tab-bar": "style__tab-bar___i4WUj",
          "tab-bar-theme-dark": "style__tab-bar-theme-dark___2PIu5",
          "tab-slider": "style__tab-slider___12p1o",
          "tab-item": "style__tab-item___3pixS",
          "item-title": "style__item-title___1Ig0D",
          "item-content": "style__item-content___2TwrZ",
          "tab-item-active": "style__tab-item-active___31OJL",
          "tab-bar-theme-light": "style__tab-bar-theme-light___3esM7",
          "item-title-hide": "style__item-title-hide___OeVxN",
          "hide-item-content": "style__hide-item-content___23iMw",
          "carousel-box": "style__carousel-box___3nh75",
          "replay-btn": "style__replay-btn___LtIZx",
          "replay-btn-icon": "style__replay-btn-icon___3eRBB",
          "dji-ag": "style__dji-ag___100zs",
          "tem-content": "style__tem-content___1bBHi",
          "slick-slide": "style__slick-slide___2-SFC",
          "no-radius-slide": "style__no-radius-slide___1xNn_",
          "slick-active": "style__slick-active___2Vqvg",
        },
      };
      function L(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var B = (function (e) {
          function t(e) {
            var n;
            return (
              Object(r.default)(this, t),
              ((n = L(this, t, [e])).state = {
                inkBarStyle: {},
                contentStyle: {},
              }),
              (n.tabTitleArray = []),
              (n.updateInkBarStyle = n.updateInkBarStyle.bind(Object(c.a)(n))),
              (n.computeHeight = n.computeHeight.bind(Object(c.a)(n))),
              (n.calculateSliderTranslateY = n.calculateSliderTranslateY.bind(
                Object(c.a)(n),
              )),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this;
                  setTimeout(function () {
                    e.computeHeight(), e.updateInkBarStyle();
                  }, 500);
                },
              },
              {
                key: "componentDidUpdate",
                value: function (e) {
                  e.activeKey !== this.props.activeKey &&
                    (this.updateInkBarStyle(), this.computeHeight());
                },
              },
              {
                key: "computeHeight",
                value: function () {
                  if (this.activeTabContent) {
                    var e = this.activeTabContent.clientHeight,
                      t = { height: "" };
                    (t.height = "".concat(e, "px")),
                      (t.marginBottom = e ? "16px" : 0),
                      this.setState({ contentStyle: t });
                  }
                },
              },
              {
                key: "calculateSliderTranslateY",
                value: function () {
                  for (var e = 0, t = 0; t < this.activeIdx; t += 1)
                    e += Number(this.tabTitleArray[t].clientHeight);
                  return e;
                },
              },
              {
                key: "updateInkBarStyle",
                value: function () {
                  if (this.activeTab && this.tabBar) {
                    var e,
                      t,
                      n = { height: "" },
                      o = this.activeTab.offsetTop,
                      a = this.activeTab.clientHeight;
                    if (this.activeTabContent) {
                      var r =
                        this.activeIdx > 0
                          ? this.calculateSliderTranslateY()
                          : "0";
                      (t =
                        a +
                        ((e = this.activeTabContent.clientHeight)
                          ? e + 16
                          : 0)),
                        Object(T.a)(n, "translate3d(0,".concat(r, "px,0)"));
                    } else
                      (t = a),
                        Object(T.a)(n, "translate3d(0,".concat(o, "px,0)"));
                    (n.height = "".concat(t, "px")),
                      this.setState({ inkBarStyle: n });
                  }
                },
              },
              {
                key: "handleTabClick",
                value: function (e) {
                  var t = this.props.onTabClick;
                  t && t(e);
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.activeKey,
                    o = t.component_data,
                    a = t.t,
                    r = this.state,
                    i = r.inkBarStyle,
                    l = r.contentStyle,
                    s = {
                      fontSize: o.tabItemDescFontSize,
                      lineHeight: o.tabItemDescLineHeight,
                    };
                  return C(
                    "div",
                    { className: "style__tab-container___dyPyP" },
                    C(
                      "div",
                      {
                        className: "style__tab-box___369jU",
                        "data-aos": "fade-in",
                      },
                      C(
                        "div",
                        {
                          ref: function (t) {
                            e.tabBar = t;
                          },
                          className: d()(
                            "tab-bar ".concat(
                              "light" === o.theme
                                ? "tab-bar-theme-light"
                                : "tab-bar-theme-dark",
                            ),
                            E,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                        },
                        C("div", {
                          className: "style__tab-slider___12p1o",
                          style: i,
                        }),
                        o.tabList && Array.isArray(o.tabList)
                          ? o.tabList.map(function (t, r) {
                              var i = b()({
                                "tab-item": !0,
                                "tab-item-active": n === a(t.tabTitle),
                              });
                              return C(
                                "div",
                                {
                                  onClick: e.handleTabClick.bind(e, r),
                                  key: a(t.tabTitle),
                                  className: d()(i, E, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                                },
                                C("h3", {
                                  className: "style__item-title___1Ig0D",
                                  ref: function (o) {
                                    n === a(t.tabTitle) &&
                                      ((e.activeTab = o), (e.activeIdx = r));
                                  },
                                  dangerouslySetInnerHTML: {
                                    __html: a(t.tabTitle),
                                  },
                                  style: {
                                    fontSize: o.tabItemTitleFontSize,
                                    lineHeight: o.tabItemTitleLineHeight,
                                  },
                                }),
                                C("h3", {
                                  className: "style__item-title-hide___OeVxN",
                                  ref: function (t) {
                                    e.tabTitleArray[r] = t;
                                  },
                                  dangerouslySetInnerHTML: {
                                    __html: a(t.tabTitle),
                                  },
                                  style: {
                                    fontSize: o.tabItemTitleFontSize,
                                    lineHeight: o.tabItemTitleLineHeight,
                                  },
                                }),
                                C("div", {
                                  className: "style__item-content___2TwrZ",
                                  style: P(
                                    P({}, s),
                                    n === a(t.tabTitle) ? l : {},
                                  ),
                                  dangerouslySetInnerHTML: {
                                    __html: a(t.tabContent),
                                  },
                                }),
                                C("div", {
                                  className: "style__hide-item-content___23iMw",
                                  ref: function (o) {
                                    n === a(t.tabTitle) &&
                                      (e.activeTabContent = o);
                                  },
                                  dangerouslySetInnerHTML: {
                                    __html: a(t.tabContent),
                                  },
                                  style: {
                                    fontSize: o.tabItemDescFontSize,
                                    lineHeight: o.tabItemDescLineHeight,
                                  },
                                }),
                              );
                            })
                          : null,
                      ),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(f.a.Component),
        N = Object(h.a)(B),
        D = f.a.createElement;
      function z(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function A(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? z(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : z(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var R = {
        "@dji/quark/dist/Carousel.css": {
          _3c0Qz: "Carousel___3c0Qz___1koDA",
          _1j2v0: "Carousel___1j2v0___2FIeI",
          "-lu88": "Carousel__-lu88___NLyCF",
          _35bgc: "Carousel___35bgc___2aHAn",
          byXrR: "Carousel__byXrR___3dgtc",
          _128ri: "Carousel___128ri___2yC4h",
          _1KHsi: "Carousel___1KHsi___3W7DU",
          "_2bT-Y": "Carousel___2bT-Y___1R9af",
          _3UEZX: "Carousel___3UEZX___26El7",
          _1fXKU: "Carousel___1fXKU___2ZV3F",
          _2OZ_n: "Carousel___2OZ_n___2Evhp",
          _6cr8a: "Carousel___6cr8a___3iaKo",
          ZAGKa: "Carousel__ZAGKa___AIVrJ",
          _1lH5w: "Carousel___1lH5w___3v_jP",
          _3BSr4: "Carousel___3BSr4___utmNF",
          _4wlbR: "Carousel___4wlbR___3uZph",
          _26SUY: "Carousel___26SUY___3fpPP",
          "_30-mD": "Carousel___30-mD___2lsAo",
          _1_xvC: "Carousel___1_xvC___1puxH",
          _17P2f: "Carousel___17P2f___2tLDA",
          _2I_EY: "Carousel___2I_EY___3c2YO",
          _3qb3s: "Carousel___3qb3s___3qzk-",
          _2jwD5: "Carousel___2jwD5___34tTr",
          _19X43: "Carousel___19X43___1ZxfJ",
          _2WwM4: "Carousel___2WwM4___2577-",
          _1shcg: "Carousel___1shcg___1C4CY",
          _1qLWd: "Carousel___1qLWd___2AtJP",
          Z8Prc: "Carousel__Z8Prc___EmT2Y",
          _3MItB: "Carousel___3MItB___3PVnd",
          _2Bvn6: "Carousel___2Bvn6___1sMeQ",
          _3IVo_: "Carousel___3IVo____2SUdp",
          _34FGS: "Carousel___34FGS___1wZ70",
          _3e62_: "Carousel___3e62____2Ukhi",
          _1zbhS: "Carousel___1zbhS___rCCDy",
          _27RtX: "Carousel___27RtX____jMUy",
          jhfcy: "Carousel__jhfcy___37OPc",
          Q82xM: "Carousel__Q82xM___2wN2z",
          _1vyf0: "Carousel___1vyf0___2xp5e",
          B0IHZ: "Carousel__B0IHZ___Sfdjp",
          _2cpQ_: "Carousel___2cpQ____30SEa",
          _2FImd: "Carousel___2FImd___32DX2",
          _3wXJB: "Carousel___3wXJB___2ZUOk",
          _2fXyR: "Carousel___2fXyR___1NBzg",
          _2KLCQ: "Carousel___2KLCQ___p-qKh",
          "_-4DAY": "Carousel___-4DAY___BAqWN",
          _2I4g3: "Carousel___2I4g3___LP0n2",
          _1m5z7: "Carousel___1m5z7___xFT4_",
          _1vR3p: "Carousel___1vR3p___ctwn1",
          _2LJ7o: "Carousel___2LJ7o___1llMA",
          _3AQSX: "Carousel___3AQSX___nUz7C",
          _3ASBw: "Carousel___3ASBw___zTpBO",
          _6eszT: "Carousel___6eszT___tqNdR",
          _1WxHW: "Carousel___1WxHW___1qalH",
          _2uv1U: "Carousel___2uv1U___1Kuv_",
          "_3s-NW": "Carousel___3s-NW___lqf5a",
          _1ZzVY: "Carousel___1ZzVY___1wAfR",
          OBwuW: "Carousel__OBwuW___1n6qX",
          "_2Ri-k": "Carousel___2Ri-k___6Rxia",
          _1588m: "Carousel___1588m___1mtyO",
          _2uIqb: "Carousel___2uIqb___10Laf",
          _1P5xZ: "Carousel___1P5xZ___2L4HS",
          _2iuBX: "Carousel___2iuBX___2RsBh",
          _1exha: "Carousel___1exha___1wlQE",
          _3bokS: "Carousel___3bokS___3GBdE",
          "vMM-Y": "Carousel__vMM-Y___3V4hC",
          _3jZwp: "Carousel___3jZwp___1hTt7",
          "_2SUQ-": "Carousel___2SUQ-___201rT",
          _1Piil: "Carousel___1Piil___2MJLy",
          _20oXE: "Carousel___20oXE___1lWyp",
          _2gTe8: "Carousel___2gTe8___2VolV",
          okv_Y: "Carousel__okv_Y___3o72d",
          "_3l-6g": "Carousel___3l-6g___1eTKZ",
          OhY9C: "Carousel__OhY9C___VypyG",
          Cb5jY: "Carousel__Cb5jY___XD4W6",
          _1ajFe: "Carousel___1ajFe___2iKaa",
          ve2KQ: "Carousel__ve2KQ___wygxm",
          _3OU3j: "Carousel___3OU3j___2U-ZH",
          lgV2x: "Carousel__lgV2x___1TAq8",
          _1gQtG: "Carousel___1gQtG___xY1JQ",
          _3Zaag: "Carousel___3Zaag___1izoe",
          _33jTA: "Carousel___33jTA___2zaLW",
          _1jJbn: "Carousel___1jJbn___7OrbF",
          UuxAk: "Carousel__UuxAk___2M1Kk",
          _1OEuY: "Carousel___1OEuY___ll6Vw",
          Lm_MF: "Carousel__Lm_MF___3g5kk",
          _3LwbN: "Carousel___3LwbN___VVPyn",
          _2XN05: "Carousel___2XN05___fbIIV",
          _33OcX: "Carousel___33OcX___2zq_N",
          bMc_E: "Carousel__bMc_E___JYTQu",
          IAlEP: "Carousel__IAlEP___3Aawe",
          _25GQ2: "Carousel___25GQ2___RgYfK",
          _3t3HT: "Carousel___3t3HT___3bnxN",
          _2W_XA: "Carousel___2W_XA___2iwE2",
          _3NPLS: "Carousel___3NPLS___1qAjS",
          UhwjW: "Carousel__UhwjW___1X-c8",
          _2hDpl: "Carousel___2hDpl___1JB4-",
          dCZz2: "Carousel__dCZz2___1qCZC",
          _1FMUV: "Carousel___1FMUV___1HK0Z",
          _2H8bj: "Carousel___2H8bj___1I8jM",
          _3KkpT: "Carousel___3KkpT___85-_W",
          _23p5a: "Carousel___23p5a___2DqoR",
          _18A_e: "Carousel___18A_e___3WiMU",
          gf_rb: "Carousel__gf_rb___3Molo",
          _1Djb6: "Carousel___1Djb6___1KSpD",
          "_3d-6G": "Carousel___3d-6G___3N2fO",
          _1fawl: "Carousel___1fawl___LVhgy",
          _20uY7: "Carousel___20uY7___1djx1",
          _2Z6dE: "Carousel___2Z6dE___YQjOO",
          _1c3Qh: "Carousel___1c3Qh___3XVp_",
          _1GlZx: "Carousel___1GlZx___1XNjo",
          _3hG3b: "Carousel___3hG3b___pVVDw",
          _15wCJ: "Carousel___15wCJ___vlf5_",
          _1Rw_U: "Carousel___1Rw_U___3_X0z",
          _2Jlwc: "Carousel___2Jlwc___gQw5f",
          _1bahP: "Carousel___1bahP___2pB9b",
          "_27Nd-": "Carousel___27Nd-___keArV",
          _3To44: "Carousel___3To44___Nu5k7",
          _1O_Hy: "Carousel___1O_Hy___1a_d0",
          W6H_f: "Carousel__W6H_f___IUygO",
          _2_sls: "Carousel___2_sls___30LcM",
          _35BGQ: "Carousel___35BGQ___38UD4",
          _3xfLM: "Carousel___3xfLM___1cMwM",
          _1pvYF: "Carousel___1pvYF___1Oks8",
          carousel: "Carousel__carousel___2w_ln",
          "slick-slider": "Carousel__slick-slider___U9V9E",
          "slick-list": "Carousel__slick-list___1qBfH",
          dragging: "Carousel__dragging___3D3EX",
          "slick-track": "Carousel__slick-track___2kw5f",
          _1dFgn: "Carousel___1dFgn___1XfWi",
          "slick-slide": "Carousel__slick-slide___3uyAJ",
          "slick-loading": "Carousel__slick-loading___33N7b",
          "slick-initialized": "Carousel__slick-initialized___24qWZ",
          "slick-vertical": "Carousel__slick-vertical___BLHjr",
          "slick-arrow": "Carousel__slick-arrow___3rSmU",
          "slick-hidden": "Carousel__slick-hidden___qSm3K",
          "slick-next": "Carousel__slick-next___CsI-L",
          "slick-prev": "Carousel__slick-prev___1PENf",
          "slick-disabled": "Carousel__slick-disabled___1aXun",
          "slick-dots": "Carousel__slick-dots___1lsQ8",
          "slick-active": "Carousel__slick-active___1IeSs",
          "carousel-vertical": "Carousel__carousel-vertical___3xnHn",
          ZJnnz: "Carousel__ZJnnz___n7eEb",
          _3ctaf: "Carousel___3ctaf___Qgc98",
        },
        "@dji/quark/dist/Icon.css": {
          _3c0Qz: "Icon___3c0Qz___FIJlG",
          _1j2v0: "Icon___1j2v0___3n4_L",
          "-lu88": "Icon__-lu88___3d46C",
          _35bgc: "Icon___35bgc___3GNZF",
          byXrR: "Icon__byXrR___1RkT6",
          _128ri: "Icon___128ri___2tmqj",
          _1KHsi: "Icon___1KHsi___3Eodi",
          "_2bT-Y": "Icon___2bT-Y___2I6pp",
          _3UEZX: "Icon___3UEZX___2thwC",
          _1fXKU: "Icon___1fXKU___2BRJU",
          _2OZ_n: "Icon___2OZ_n___2RThy",
          _6cr8a: "Icon___6cr8a___IijMS",
          ZAGKa: "Icon__ZAGKa___1VXdb",
          _1lH5w: "Icon___1lH5w___1Fjc9",
          _3BSr4: "Icon___3BSr4___1Kmz0",
          _4wlbR: "Icon___4wlbR___3byTz",
          _26SUY: "Icon___26SUY___d0HAN",
          "_30-mD": "Icon___30-mD___3ZamP",
          _1_xvC: "Icon___1_xvC___2A-8f",
          _17P2f: "Icon___17P2f___rSHoE",
          _2I_EY: "Icon___2I_EY___2xSLv",
          _3qb3s: "Icon___3qb3s___rJOmo",
          _2jwD5: "Icon___2jwD5___2QGsT",
          _19X43: "Icon___19X43___3Kun2",
          _2WwM4: "Icon___2WwM4___1gBlP",
          _1shcg: "Icon___1shcg___3hDFq",
          _1qLWd: "Icon___1qLWd___2iuQy",
          Z8Prc: "Icon__Z8Prc___1Dms6",
          _3MItB: "Icon___3MItB___3_bo8",
          _2Bvn6: "Icon___2Bvn6___WbeJB",
          _3IVo_: "Icon___3IVo____3wyxI",
          _34FGS: "Icon___34FGS___33RR0",
          _3e62_: "Icon___3e62____92ZgY",
          _1zbhS: "Icon___1zbhS___2r2qq",
          _27RtX: "Icon___27RtX___27B0l",
          jhfcy: "Icon__jhfcy___16aAv",
          Q82xM: "Icon__Q82xM___oUbgj",
          _1vyf0: "Icon___1vyf0___1Q36k",
          B0IHZ: "Icon__B0IHZ___2i7iu",
          _2cpQ_: "Icon___2cpQ____1m_c2",
          _2FImd: "Icon___2FImd___3DKZV",
          _3wXJB: "Icon___3wXJB___kIf5S",
          _2fXyR: "Icon___2fXyR___I8f9m",
          _2KLCQ: "Icon___2KLCQ___20KdM",
          "_-4DAY": "Icon___-4DAY___3ZpEm",
          _2I4g3: "Icon___2I4g3___32bHH",
          _1m5z7: "Icon___1m5z7___1qVyd",
          _1vR3p: "Icon___1vR3p___2yoW_",
          _2LJ7o: "Icon___2LJ7o___jCzSa",
          _3AQSX: "Icon___3AQSX___1f3qw",
          _3ASBw: "Icon___3ASBw___1lGu0",
          _6eszT: "Icon___6eszT___2t_u2",
          _1WxHW: "Icon___1WxHW___GiKUo",
          _2uv1U: "Icon___2uv1U___1JiUZ",
          "_3s-NW": "Icon___3s-NW___1I_EX",
          _1ZzVY: "Icon___1ZzVY___2rvYH",
          OBwuW: "Icon__OBwuW___2fQc2",
          "_2Ri-k": "Icon___2Ri-k___2kk-7",
          _1588m: "Icon___1588m___9NDr4",
          _2uIqb: "Icon___2uIqb___1FdOg",
          _1P5xZ: "Icon___1P5xZ___2f_T2",
          _2iuBX: "Icon___2iuBX___L1dph",
          _1exha: "Icon___1exha___1m37C",
          _3bokS: "Icon___3bokS___1OYm4",
          "vMM-Y": "Icon__vMM-Y___3QgfP",
          _3jZwp: "Icon___3jZwp___3d5u1",
          "_2SUQ-": "Icon___2SUQ-___6nEm6",
          _1Piil: "Icon___1Piil___VvBSt",
          _20oXE: "Icon___20oXE___1xwx0",
          _2gTe8: "Icon___2gTe8___2yipi",
          okv_Y: "Icon__okv_Y___1Pe9p",
          "_3l-6g": "Icon___3l-6g___TPS6y",
          OhY9C: "Icon__OhY9C___23GW6",
          Cb5jY: "Icon__Cb5jY___2uZGR",
          _1ajFe: "Icon___1ajFe___HugcL",
          ve2KQ: "Icon__ve2KQ___t5XNa",
          _3OU3j: "Icon___3OU3j___xivTQ",
          lgV2x: "Icon__lgV2x___h-CeN",
          _1gQtG: "Icon___1gQtG___3bGQ2",
          _3Zaag: "Icon___3Zaag___Sa23k",
          _33jTA: "Icon___33jTA___2TKV5",
          _1jJbn: "Icon___1jJbn___1sLs7",
          UuxAk: "Icon__UuxAk___19lCZ",
          _1OEuY: "Icon___1OEuY___3iBjU",
          Lm_MF: "Icon__Lm_MF___3yQbY",
          _3LwbN: "Icon___3LwbN___3Kj8n",
          _2XN05: "Icon___2XN05___1rny3",
          _33OcX: "Icon___33OcX___394mm",
          bMc_E: "Icon__bMc_E___H5L8W",
          IAlEP: "Icon__IAlEP___2I8pV",
          _25GQ2: "Icon___25GQ2___2lovm",
          _3t3HT: "Icon___3t3HT___n_YD6",
          _2W_XA: "Icon___2W_XA___3qZb3",
          _3NPLS: "Icon___3NPLS___3Dm9I",
          UhwjW: "Icon__UhwjW___3Bath",
          _2hDpl: "Icon___2hDpl___3V_-b",
          dCZz2: "Icon__dCZz2___11T7f",
          _1FMUV: "Icon___1FMUV___LlZ0V",
          _2H8bj: "Icon___2H8bj___27UMO",
          _3KkpT: "Icon___3KkpT___1PPrL",
          _23p5a: "Icon___23p5a___1EP34",
          _18A_e: "Icon___18A_e___7QC5E",
          gf_rb: "Icon__gf_rb___2PXNg",
          _1Djb6: "Icon___1Djb6___2pUir",
          "_3d-6G": "Icon___3d-6G___14ssX",
          _1fawl: "Icon___1fawl___KUcfA",
          _20uY7: "Icon___20uY7___18OZm",
          _2Z6dE: "Icon___2Z6dE___1ik2v",
          _1c3Qh: "Icon___1c3Qh___2essq",
          _1GlZx: "Icon___1GlZx___1NCg-",
          _3hG3b: "Icon___3hG3b___2gAhc",
          _15wCJ: "Icon___15wCJ___X5oB6",
          _1Rw_U: "Icon___1Rw_U___16Osz",
          _2Jlwc: "Icon___2Jlwc___de1R5",
          _1bahP: "Icon___1bahP___3btKO",
          "_27Nd-": "Icon___27Nd-___2hUt0",
          _3To44: "Icon___3To44___1U_3e",
          _1O_Hy: "Icon___1O_Hy___3okVL",
          W6H_f: "Icon__W6H_f___3gCiH",
          _2_sls: "Icon___2_sls___yPeTY",
          _35BGQ: "Icon___35BGQ___jWjx9",
          _3xfLM: "Icon___3xfLM___3zQYM",
          _1pvYF: "Icon___1pvYF___1VGpm",
        },
        "./style.css": {
          "section-vertical-tab-component":
            "style__section-vertical-tab-component___3WQ4B",
          "text-box": "style__text-box___vbOl_",
          title: "style__title___2VH5C",
          "horizontal-line": "style__horizontal-line___3Ik3a",
          desc: "style__desc___2MDwx",
          "link-btn": "style__link-btn___2f9zc",
          "angle-right-icon": "style__angle-right-icon___1vJXg",
          "text-box-light": "style__text-box-light___eA8gy",
          "text-box-dark": "style__text-box-dark___1Erd4",
          container: "style__container____p2J2",
          "tab-container": "style__tab-container___dyPyP",
          "tab-box": "style__tab-box___369jU",
          "desc-box-theme-light": "style__desc-box-theme-light___2Kd9Y",
          "desc-box-theme-dark": "style__desc-box-theme-dark___2vWH5",
          "desc-box": "style__desc-box___1-Xk2",
          "tab-bar": "style__tab-bar___i4WUj",
          "tab-bar-theme-dark": "style__tab-bar-theme-dark___2PIu5",
          "tab-slider": "style__tab-slider___12p1o",
          "tab-item": "style__tab-item___3pixS",
          "item-title": "style__item-title___1Ig0D",
          "item-content": "style__item-content___2TwrZ",
          "tab-item-active": "style__tab-item-active___31OJL",
          "tab-bar-theme-light": "style__tab-bar-theme-light___3esM7",
          "item-title-hide": "style__item-title-hide___OeVxN",
          "hide-item-content": "style__hide-item-content___23iMw",
          "carousel-box": "style__carousel-box___3nh75",
          "replay-btn": "style__replay-btn___LtIZx",
          "replay-btn-icon": "style__replay-btn-icon___3eRBB",
          "dji-ag": "style__dji-ag___100zs",
          "tem-content": "style__tem-content___1bBHi",
          "slick-slide": "style__slick-slide___2-SFC",
          "no-radius-slide": "style__no-radius-slide___1xNn_",
          "slick-active": "style__slick-active___2Vqvg",
        },
      };
      function F(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var V = (function (e) {
          function t(e) {
            var n;
            Object(r.default)(this, t), (n = F(this, t, [e]));
            var o = e.component_data,
              a = o.activeKey,
              i = o.tabList,
              l = e.t,
              s = (Array.isArray(i) && i[0] && i[0].tabTitle) || "";
            return (
              (n.state = { activeKey: l(a || s) }),
              (n.handleTabClick = n.handleTabClick.bind(Object(c.a)(n))),
              (n.onIndexChange = n.onIndexChange.bind(Object(c.a)(n))),
              (n.playActiveVideo = n.playActiveVideo.bind(Object(c.a)(n))),
              (n.playVideo = n.playVideo.bind(Object(c.a)(n))),
              (n.pauseCarousel = n.pauseCarousel.bind(Object(c.a)(n))),
              (n.playCarousel = n.playCarousel.bind(Object(c.a)(n))),
              (n.replayWhenVisible = n.replayWhenVisible.bind(Object(c.a)(n))),
              (n.tabInView = !1),
              (n.carouselDom = []),
              (n.carouselItemDom = []),
              (n.replayBtn = []),
              (n.carouselListener = []),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this,
                    t =
                      (new O.a({
                        containerClassName: "dbv",
                        visiblePlay: !1,
                        lazyLoad: !0,
                        lazyLoadThreshold: 1200,
                        replayWhenRevisible: !1,
                        replayClassName: "",
                      }),
                      new O.a({
                        containerClassName: "dbv-replay",
                        visiblePlay: !1,
                        lazyLoad: !0,
                        lazyLoadThreshold: 1200,
                        replayWhenRevisible: !1,
                        replayClassName: "replay-btn",
                      }),
                      this);
                  I.a.getInstance().addNode(this.carouselBox, {
                    scrollIntoView: function () {
                      (t.tabInView = !0), e.replayWhenVisible();
                    },
                    scrollOutOfWiew: function () {
                      var n, o;
                      (t.tabInView = !1),
                        null === (n = e.carousel) ||
                          void 0 === n ||
                          null === (o = n.slick) ||
                          void 0 === o ||
                          o.slick.slickPause();
                    },
                  });
                },
              },
              {
                key: "playVideo",
                value: function (e, t) {
                  if (
                    ((t = t || function () {}),
                    !(
                      e.currentTime > 0 &&
                      !e.paused &&
                      !e.ended &&
                      e.readyState > 2
                    ))
                  ) {
                    var n = e.play();
                    n && n.then && "function" === typeof n.then
                      ? n.then(
                          function () {
                            t();
                          },
                          function () {},
                        )
                      : t();
                  }
                },
              },
              {
                key: "playActiveVideo",
                value: function (e, t) {
                  var n = this,
                    o = this.props,
                    a = o.component_data,
                    r = o.t;
                  !(function o() {
                    if (t && n.tabInView) {
                      for (var i = 0; i < n.carouselDom.length; i++)
                        n.carouselDom[i].poster &&
                          !n.carouselDom[i].src &&
                          n.carouselDom[i] !== n.carouselDom[e] &&
                          n.carouselDom[i].pause();
                      n.carouselDom[e].duration >= 0 &&
                        ((n.carouselDom[e].currentTime = 0),
                        a.autoPlay || (n.replayBtn[e].style.display = "none"),
                        n.playVideo(n.carouselDom[e]),
                        (t = !1)),
                        n.carouselListener[e] ||
                          ((n.carouselListener[e] = function () {
                            var t,
                              o,
                              i =
                                -1 ===
                                n.carouselItemDom[e].className.indexOf(
                                  "slick-hover",
                                ),
                              l =
                                -1 !==
                                n.carouselItemDom[e].className.indexOf(
                                  "slick-active",
                                );
                            a.autoPlay &&
                              n.carouselItemDom[e] &&
                              n.carouselItemDom[e].className &&
                              i &&
                              l &&
                              (null === (t = n.carousel) ||
                                void 0 === t ||
                                null === (o = t.slick) ||
                                void 0 === o ||
                                o.slick.slickNext(),
                              n.setState({
                                activeKey:
                                  e === a.tabList.length - 1
                                    ? r(a.tabList[0].tabTitle)
                                    : r(a.tabList[e + 1].tabTitle),
                              }));
                            n.carouselDom[e] &&
                              n.carouselDom[e].getAttribute("replay") &&
                              "replay" ===
                                n.carouselDom[e].getAttribute("replay") &&
                              n.replayBtn[e] &&
                              (n.replayBtn[e].style.display = "block");
                          }),
                          n.carouselDom[e].addEventListener(
                            "ended",
                            n.carouselListener[e],
                          ));
                    }
                    requestAnimationFrame(o);
                  })();
                },
              },
              {
                key: "handleTabClick",
                value: function (e) {
                  var t = this.props,
                    n = t.gaSend,
                    o = t.component_data.gaLabelGroup;
                  n("click", "".concat(o, "-section-vertical-tab-").concat(e)),
                    this.carousel.slickGoTo(e);
                },
              },
              {
                key: "pauseCarousel",
                value: function () {
                  for (var e = 0; e < this.carouselItemDom.length; e++)
                    if (
                      -1 !==
                      this.carouselItemDom[e].className.indexOf("slick-active")
                    ) {
                      this.carouselItemDom[e].classList.add("slick-hover");
                      var t,
                        n,
                        o = Number(
                          this.carouselItemDom[e].getAttribute("data-index"),
                        );
                      if (
                        !this.carouselItemDom[o].poster &&
                        this.carouselItemDom[o].src
                      )
                        null === (t = this.carousel) ||
                          void 0 === t ||
                          null === (n = t.slick) ||
                          void 0 === n ||
                          n.slick.slickPause();
                    }
                },
              },
              {
                key: "playCarousel",
                value: function () {
                  var e = this.props,
                    t = e.component_data,
                    n = e.t;
                  if (t.autoPlay)
                    for (var o = 0; o < this.carouselItemDom.length; o++)
                      if (
                        -1 !==
                        this.carouselItemDom[o].className.indexOf(
                          "slick-active",
                        )
                      ) {
                        this.carouselItemDom[o].classList.remove("slick-hover");
                        var a = Number(
                            this.carouselItemDom[o].getAttribute("data-index"),
                          ),
                          r =
                            this.carouselDom[a].paused &&
                            this.carouselDom[a].duration ===
                              this.carouselDom[a].currentTime,
                          i =
                            !this.carouselDom[a].poster &&
                            this.carouselDom[a].src;
                        if (r) {
                          var l, s;
                          null === (l = this.carousel) ||
                            void 0 === l ||
                            null === (s = l.slick) ||
                            void 0 === s ||
                            s.slick.slickNext();
                          var c =
                            a === t.tabList.length - 1
                              ? n(t.tabList[0].tabTitle)
                              : n(t.tabList[a + 1].tabTitle);
                          this.setState({ activeKey: c });
                        } else if (i) {
                          var _, u;
                          null === (_ = this.carousel) ||
                            void 0 === _ ||
                            null === (u = _.slick) ||
                            void 0 === u ||
                            u.slick.slickPlay();
                        }
                      }
                },
              },
              {
                key: "replayWhenVisible",
                value: function () {
                  var e,
                    t,
                    n,
                    o,
                    a,
                    r = this.newIndex || 0,
                    i = this.props.component_data.autoPlay;
                  "img" ===
                  (null === (e = this.carouselDom[r]) || void 0 === e
                    ? void 0
                    : e.getAttribute("type"))
                    ? i &&
                      (null === (t = this.carousel) ||
                        void 0 === t ||
                        null === (n = t.slick) ||
                        void 0 === n ||
                        n.slick.slickPlay())
                    : (null === (o = this.carousel) ||
                        void 0 === o ||
                        null === (a = o.slick) ||
                        void 0 === a ||
                        a.slick.slickPause(),
                      this.playActiveVideo(r, !0));
                },
              },
              {
                key: "onIndexChange",
                value: function (e) {
                  var t, n, o, a, r, i, l;
                  "img" ===
                  (null === (t = this.carouselDom[e]) || void 0 === t
                    ? void 0
                    : t.getAttribute("type"))
                    ? (null === (n = this.carousel) ||
                        void 0 === n ||
                        null === (o = n.slick) ||
                        void 0 === o ||
                        o.slick.slickPlay(),
                      null === (a = this.carousel) ||
                        void 0 === a ||
                        null === (r = a.slick) ||
                        void 0 === r ||
                        r.slick.slickNext())
                    : (null === (i = this.carousel) ||
                        void 0 === i ||
                        null === (l = i.slick) ||
                        void 0 === l ||
                        l.slick.slickPause(),
                      this.playActiveVideo(e, !0));
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.component_data,
                    o = void 0 === n ? {} : n,
                    r = t.t,
                    i = t.context.subdomain,
                    l = this.state.activeKey,
                    s = {
                      fade: !0,
                      speed: 600,
                      autoplay: o && o.autoPlay,
                      autoplaySpeed: 5e3,
                      touchMove: !1,
                      beforeChange: function (t, n) {
                        (e.newIndex = n),
                          o.tabList[n] &&
                            e.tabInView &&
                            (e.setState({
                              activeKey: r(o.tabList[n].tabTitle),
                            }),
                            e.onIndexChange(n));
                      },
                    },
                    c = {
                      fontWeight:
                        o.headlineFontWeight && j.c[o.headlineFontWeight]
                          ? j.c[o.headlineFontWeight]
                          : void 0,
                      fontSize: o.headlineFontSize,
                      lineHeight: Object(j.a)(
                        o.headlineFontSize,
                        o.headlineLineHeight,
                      ),
                    },
                    _ = {
                      fontWeight:
                        o.headlineDescFontWeight &&
                        j.c[o.headlineDescFontWeight]
                          ? j.c[o.headlineDescFontWeight]
                          : void 0,
                      fontSize: o.headllineDescFontSize,
                      lineHeight: Object(j.a)(
                        o.headllineDescFontSize,
                        o.headlineDescLineHeight,
                      ),
                    },
                    u = {
                      paddingTop: "".concat(o.paddingTop, "px"),
                      paddingBottom: "".concat(o.paddingBottom, "px"),
                      background: o.background,
                    },
                    p = b()({
                      "section-vertical-tab-component": !0,
                      "dji-ag": i && "ag" === i,
                    }),
                    h = D(
                      "div",
                      {
                        className: "style__tab-box___369jU",
                        style: {
                          width: o.tabContentWidth,
                          marginLeft: o.tabContentMarginLeft,
                          marginRight: o.tabContentMarginRight,
                        },
                      },
                      o.hasTabDescBox &&
                        D(
                          "div",
                          {
                            style: { paddingBottom: o.tabMainTitleSpacing },
                            className: d()(
                              "desc-box ".concat(
                                "light" === o.theme
                                  ? "desc-box-theme-light"
                                  : "desc-box-theme-dark",
                              ),
                              R,
                              {
                                autoResolveMultipleImports: !0,
                                handleMissingStyleName: "warn",
                              },
                            ),
                          },
                          "" === o.tabBoxTitle
                            ? null
                            : D("div", {
                                className: "style__title___2VH5C",
                                style: c,
                                dangerouslySetInnerHTML: {
                                  __html: r(o.tabBoxTitle),
                                },
                              }),
                          "" === o.tabBoxDesc
                            ? null
                            : D("div", {
                                className: "style__desc___2MDwx",
                                style: _,
                                dangerouslySetInnerHTML: {
                                  __html: r(o.tabBoxDesc),
                                },
                              }),
                        ),
                      D(N, {
                        component_data: o,
                        t: r,
                        activeKey: l,
                        onTabClick: this.handleTabClick,
                        onMouseEnter: this.pauseCarousel,
                        onMouseLeave: this.playCarousel,
                      }),
                    ),
                    m = D(
                      "div",
                      {
                        className: "style__carousel-box___3nh75",
                        style: {
                          cursor: o.autoPlay ? "pointer" : "",
                          width: o.imgContentWidth,
                          marginLeft: o.imgContentMarginLeft,
                          marginRight: o.imgContentMarginRight,
                        },
                        "data-aos": "fade-in",
                        ref: function (t) {
                          e.carouselBox = t;
                        },
                      },
                      D(
                        g.a,
                        Object(a.a)({}, s, {
                          ref: function (t) {
                            e.carousel = t;
                          },
                        }),
                        o.carouselList && Array.isArray(o.carouselList)
                          ? o.carouselList.map(function (t, n) {
                              return D(
                                "div",
                                {
                                  ref: function (t) {
                                    e.carouselItemDom[n] = t;
                                  },
                                  onMouseEnter: e.pauseCarousel,
                                  onMouseLeave: e.playCarousel,
                                  key: o.tabList[n] ? o.tabList[n].title : "",
                                  className: o.closeRadius
                                    ? "no-radius-slide"
                                    : "",
                                },
                                t.hasVideo
                                  ? D(
                                      "div",
                                      {
                                        className: t.isReplay
                                          ? "dbv-replay"
                                          : "dbv",
                                      },
                                      D(
                                        "video",
                                        {
                                          muted: !0,
                                          name: "media",
                                          "data-layzr-poster": t.poster,
                                          ref: function (t) {
                                            e.carouselDom[n] = t;
                                          },
                                          replay: t.isReplay
                                            ? "replay"
                                            : "no-replay",
                                        },
                                        D("source", {
                                          "data-layzr-src":
                                            t.videoLink && t.videoLink.path,
                                        }),
                                      ),
                                      D(
                                        "div",
                                        {
                                          className:
                                            "replay-btn style__replay-btn___LtIZx",
                                          ref: function (t) {
                                            e.replayBtn[n] = t;
                                          },
                                        },
                                        D(x.a, {
                                          name: "fa-solid-play",
                                          className:
                                            "style__replay-btn-icon___3eRBB",
                                        }),
                                      ),
                                    )
                                  : null,
                                t.hasImg
                                  ? D(
                                      "div",
                                      {
                                        ref: function (t) {
                                          e.carouselDom[n] = t;
                                        },
                                        type: "img",
                                      },
                                      D(S.a, {
                                        type: "img",
                                        src: t.img,
                                        alt: "",
                                      }),
                                    )
                                  : null,
                              );
                            })
                          : null,
                      ),
                    );
                  return D(
                    "section",
                    {
                      style: u,
                      className:
                        "section-vertical-tab-component " +
                        d()(p, R, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                    },
                    o.hasMainTitleBox &&
                      D(
                        "div",
                        {
                          className: d()(
                            "text-box ".concat(
                              "light" === o.theme
                                ? "text-box-light"
                                : "text-box-dark",
                            ),
                            R,
                            {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            },
                          ),
                        },
                        D("h2", {
                          className: "style__title___2VH5C",
                          dangerouslySetInnerHTML: { __html: r(o.title) },
                        }),
                        D("p", { className: "style__horizontal-line___3Ik3a" }),
                        D("p", {
                          className: "style__desc___2MDwx",
                          dangerouslySetInnerHTML: { __html: r(o.desc) },
                        }),
                        o.hasLearnMoreLink
                          ? D(
                              "a",
                              {
                                className: "style__link-btn___2f9zc",
                                "data-aos": "fade-in",
                                href: o.linkUrl && o.linkUrl.path,
                                target: o.linkTarget,
                              },
                              r(o.linkText),
                              D(x.a, {
                                name: "angle-right",
                                className: "style__angle-right-icon___1vJXg",
                              }),
                            )
                          : null,
                      ),
                    D(
                      "div",
                      {
                        className: "style__container____p2J2",
                        style: A(
                          { marginTop: o.verticalTabMargin },
                          o.flexJustifyContentCenter
                            ? { justifyContent: "center" }
                            : {},
                        ),
                      },
                      "rightText" === o.layout
                        ? D(f.a.Fragment, null, m, h)
                        : D(f.a.Fragment, null, h, m),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(f.a.Component),
        H = Object(m.b)(function (e) {
          var t = e.localization,
            n = e.context;
          return { localization: t, context: n };
        })(V),
        W = (function (e) {
          function t() {
            return Object(r.default)(this, t), F(this, t, arguments);
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "render",
                value: function () {
                  return D(H, this.props);
                },
              },
            ]),
            t
          );
        })(f.a.Component);
      Object(o.a)(W, "defaultProps", {
        t: function () {},
        gaSend: function () {},
        component_data: {
          tabContentWidth: "592px",
          imgContentWidth: "592px",
          layout: "leftText",
          gaLabelGroup: "s1edu",
          hasMainTitleBox: !0,
          hasLearnMoreLink: !0,
          hasTabDescBox: !1,
          linkTarget: "_self",
          linkUrl: { path: "/" },
          linkText: "\u5f00\u53d1\u8005\u6587\u6863",
          activeKey: "\u9ad8\u6027\u80fd\u8235\u673a",
          autoPlay: !1,
          videoReplay: !1,
          paddingTop: "64",
          paddingBottom: "64",
          background: "#FFF",
          title: "\u66f4\u591a\u6837\u7684\u7f16\u7a0b\u73a9\u6cd5",
          desc: "S1 EDU \u652f\u6301 Scratch \u4e0e Python \u4e24\u79cd\u7f16\u7a0b\u8bed\u8a00\u3002\u65e0\u8bba\u662f\u521d\u6b21\u63a5\u89e6\u7f16\u7a0b\u7684\u65b0\u624b\uff0c\u8fd8\u662f\u7f16\u7a0b\u8fbe\u4eba\uff0c\u90fd\u80fd\u5728\u5b83\u8eab\u4e0a\u65bd\u5c55\u624d\u534e",
          headlineFontSize: j.b.default,
          headlineFontWeight: "",
          headlineLineHeight: j.d.default,
          headllineDescFontSize: j.b.default,
          headlineDescFontWeight: "",
          headlineDescLineHeight: j.d.default,
          tabBoxTitle: "tab\u6807\u9898",
          tabBoxDesc: "tab\u63cf\u8ff0",
          tabList: [
            {
              tabTitle: "\u9ad8\u6027\u80fd\u8235\u673a",
              tabContent:
                "RoboMaster EP \u7684\u52a8\u529b\u90e8\u4ef6\uff0c\u652f\u6301\u901a\u8fc7 S1 \u4e3b\u63a7\u677f\u8fdb\u884c\u81ea\u5b9a\u4e49\u63a7\u5236\u3002\u4fa7\u9699\u5c0f\uff0c\u63a7\u5236\u7cbe\u5ea6\u9ad8\uff0c\u8f93\u51fa\u626d\u77e9\u5927\u3002\u9664\u4e86\u80fd\u9a71\u52a8\u673a\u68b0\u81c2\uff0c\u8fd8\u652f\u6301\u51cf\u901f\u7bb1\u6a21\u5f0f\uff0c\u5e2e\u52a9\u5b66\u751f\u642d\u5efa\u5347\u964d\u7ed3\u6784\uff0c\u5b9e\u8df5\u76f8\u5173\u7269\u7406\u77e5\u8bc6\u3002",
            },
            {
              tabTitle: "\u673a\u68b0\u81c2",
              tabContent:
                "\u63d0\u4f9b\u7ecf\u4e91\u53f0\u589e\u7a33\u7684\u9ad8\u6e05\u89c6\u9891\u6d41\u548c\u97f3\u9891\u6d41\u6570\u636e\uff0c\u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI \u529f\u80fd\u30022",
            },
            {
              tabTitle: "\u673a\u68b0\u722a",
              tabContent:
                "\u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI \u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI \u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI 3",
            },
            {
              tabTitle: "\u7ea2\u5916\u6df1\u5ea6\u4f20\u611f\u5668",
              tabContent:
                "\u63d0\u4f9b\u7ecf\u4e91\u53f0\u589e\u7a33\u7684\u9ad8\u6e05\u89c6\u9891\u6d41\u548c\u97f3\u9891\u6d41\u6570\u636e\uff0c\u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI \u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI \u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI 4",
            },
            {
              tabTitle: "\u8f6c\u63a5\u6a21\u5757",
              tabContent:
                "\u63d0\u4f9b\u7ecf\u4e91\u53f0\u589e\u7a33\u7684\u9ad8\u6e05\u89c6\u9891\u6d41\u548c\u97f3\u9891\u6d41\u6570\u636e\uff0c\u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI \u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI \u53ef\u914d\u5408\u7b2c\u4e09\u65b9\u5e73\u53f0\u5f00\u53d1\u4e2a\u6027\u5316 AI 5 ",
            },
          ],
          carouselList: [
            {
              hasVideo: !0,
              videoLink: {
                path: "https://www1.djicdn.com/assets/uploads/367aeda57cc2ddasd/32b10419031683303598c89c7471637d.mp4",
              },
              poster:
                "https://vg-ec-www-dbeta.s3.amazonaws.com/dps/61f0e667bc13d7a9318e447d6c640074.png",
              img: "/",
              hasImg: !1,
              isReplay: !0,
            },
            {
              hasVideo: !1,
              videoLink: { path: "/" },
              poster: "/",
              img: "https://www1.djicdn.com/dps/c916e30f6784703b61da7c164ceadecc.jpg",
              hasImg: !0,
              isReplay: !1,
            },
            {
              hasVideo: !0,
              videoLink: {
                path: "https://www1.djicdn.com/assets/uploads/367aeda57cc2ddasd/32b10419031683303598c89c7471637d.mp4",
              },
              poster:
                "https://vg-ec-www-dbeta.s3.amazonaws.com/dps/4a4c8d42f82ed7f839e3b587040990a6.png",
              img: "/",
              hasImg: !1,
              isReplay: !1,
            },
            {
              hasVideo: !0,
              videoLink: {
                path: "https://www1.djicdn.com/assets/uploads/367aeda57cc2ddasd/32b10419031683303598c89c7471637d.mp4",
              },
              poster:
                "https://vg-ec-www-dbeta.s3.amazonaws.com/dps/4a4c8d42f82ed7f839e3b587040990a6.png",
              img: "/",
              hasImg: !1,
              isReplay: !1,
            },
            {
              hasVideo: !0,
              videoLink: {
                path: "https://www1.djicdn.com/assets/uploads/367aeda57cc2ddasd/32b10419031683303598c89c7471637d.mp4",
              },
              poster:
                "https://vg-ec-www-dbeta.s3.amazonaws.com/dps/4a4c8d42f82ed7f839e3b587040990a6.png",
              img: "/",
              hasImg: !1,
              isReplay: !0,
            },
          ],
        },
      }),
        Object(o.a)(W, "propSettings", {
          key: "sectionVerticalTab",
          name: "sectionVerticalTab",
          contentSetting: {
            ga: {
              label: "ga\u76f8\u5173",
              props: {
                gaLabelGroup: {
                  type: "string",
                  content: "text",
                  label: "ga label\u524d\u7f00",
                },
              },
            },
            text: {
              label: "\u6807\u9898\u63cf\u8ff0",
              props: {
                title: {
                  type: "string",
                  content: "text",
                  label: "\u5927\u6807\u9898",
                },
                desc: {
                  type: "string",
                  content: "text",
                  label: "\u63cf\u8ff0",
                },
              },
            },
            titleBox: {
              label: "\u6709\u6ca1\u6709section\u5934\u90e8\u914d\u7f6e",
              switch: "hasMainTitleBox",
              props: {},
            },
            learnMoreLink: {
              label: "\u4e86\u89e3\u66f4\u591a\u94fe\u63a5",
              switch: "hasLearnMoreLink",
              props: {
                linkUrl: {
                  type: "string",
                  content: "url",
                  label: "\u94fe\u63a5",
                },
                linkText: {
                  type: "string",
                  content: "text",
                  label: "\u94fe\u63a5\u6587\u6848",
                },
                linkTarget: {
                  type: "select",
                  label: "\u94fe\u63a5\u6253\u5f00\u65b9\u5f0f",
                  items: [
                    {
                      label: "\u65b0\u7a97\u53e3\u6253\u5f00",
                      value: "_blank",
                    },
                    {
                      label: "\u9ed8\u8ba4\u5f53\u524d\u7a97\u53e3\u6253\u5f00",
                      value: "_self",
                    },
                  ],
                },
              },
            },
            other: {
              label: "\u5176\u4ed6\u5b57\u6bb5",
              props: {
                activeKey: {
                  type: "string",
                  content: "text",
                  label: "tab \u6fc0\u6d3bkey",
                },
                autoPlay: {
                  type: "boolean",
                  label: "\u662f\u5426\u81ea\u52a8\u8f6e\u64ad\u5f00\u5173",
                },
              },
            },
            tabDescBox: {
              label:
                "\u7ffb\u9875tab\u7ec4\u4ef6\u662f\u5426\u9700\u8981\u63cf\u8ff0",
              switch: "hasTabDescBox",
              props: {
                tabBoxTitle: {
                  type: "string",
                  content: "text",
                  label: "\u6807\u9898",
                },
                headlineFontSize: {
                  label: "tab \u6807\u9898\u5b57\u53f7",
                  type: "select",
                  items: [
                    { label: "10px", value: "10px" },
                    { label: "12px", value: "12px" },
                    { label: "14px", value: "14px" },
                    { label: "16px", value: "16px" },
                    { label: "18px", value: "18px" },
                    { label: "20px", value: "20px" },
                    { label: "24px", value: "24px" },
                    { label: "28px", value: "28px" },
                    { label: "32px", value: "32px" },
                    { label: "40px", value: "40px" },
                    { label: "48px", value: "48px" },
                    { label: "56px", value: "56px" },
                    { label: "64px", value: "64px" },
                    { label: "72px", value: "72px" },
                    { label: "80px", value: "80px" },
                  ],
                },
                headlineFontWeight: {
                  label: "tab \u6807\u9898\u5b57\u91cd",
                  type: "select",
                  items: [
                    { label: "Regular", value: "regular" },
                    { label: "SemiBold", value: "semibold" },
                  ],
                },
                headlineLineHeight: {
                  label: "tab \u6807\u9898\u884c\u9ad8",
                  type: "select",
                  controlValue: !0,
                  items: [
                    { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                    { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                  ],
                },
                tabBoxDesc: {
                  type: "string",
                  content: "text",
                  label: "\u6587\u6848",
                },
                headllineDescFontSize: {
                  label: "tab \u63cf\u8ff0\u5b57\u53f7",
                  type: "select",
                  items: [
                    { label: "10px", value: "10px" },
                    { label: "12px", value: "12px" },
                    { label: "14px", value: "14px" },
                    { label: "16px", value: "16px" },
                    { label: "18px", value: "18px" },
                    { label: "20px", value: "20px" },
                    { label: "24px", value: "24px" },
                    { label: "28px", value: "28px" },
                    { label: "32px", value: "32px" },
                    { label: "40px", value: "40px" },
                    { label: "48px", value: "48px" },
                    { label: "56px", value: "56px" },
                    { label: "64px", value: "64px" },
                    { label: "72px", value: "72px" },
                    { label: "80px", value: "80px" },
                  ],
                },
                headlineDescFontWeight: {
                  label: "tab \u63cf\u8ff0\u5b57\u91cd",
                  type: "select",
                  items: [
                    { label: "Regular", value: "regular" },
                    { label: "SemiBold", value: "semibold" },
                  ],
                },
                headlineDescLineHeight: {
                  label: "tab \u63cf\u8ff0\u884c\u9ad8",
                  type: "select",
                  controlValue: !0,
                  items: [
                    { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                    { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                  ],
                },
              },
            },
            tab: {
              label: "tab \u5217\u8868",
              props: {
                tabList: {
                  type: "array",
                  label: "tab \u5217\u8868",
                  props: {
                    tabTitle: {
                      type: "string",
                      content: "text",
                      label: "tab title",
                    },
                    tabContent: {
                      type: "string",
                      content: "text",
                      label: "tab \u5185\u5bb9",
                    },
                  },
                },
              },
            },
            carousel: {
              label: "\u8f6e\u64ad\u5217\u8868",
              props: {
                carouselList: {
                  type: "array",
                  label: "\u8f6e\u64ad\u5217\u8868",
                  props: {
                    videoLink: {
                      switch: "hasVideo",
                      type: "string",
                      content: "url",
                      label: "\u8f6e\u64ad\u89c6\u9891\u94fe\u63a5",
                    },
                    poster: {
                      type: "image",
                      label: "\u89c6\u9891\u5360\u4f4d\u56fe",
                    },
                    img: {
                      switch: "hasImg",
                      type: "image",
                      label: "\u8f6e\u64ad\u56fe",
                    },
                    isReplay: {
                      type: "boolean",
                      label: "\u89c6\u9891\u662f\u91cd\u64ad",
                      controlBy: "autoPlay",
                      controlValue: !1,
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            section: {
              label: "section \u5185\u8fb9\u8ddd",
              props: {
                tabContentWidth: {
                  label:
                    "tab \u533a\u57df\u5bbd\u5ea6(\u9ed8\u8ba4\uff1a 592px)",
                  type: "string",
                  content: "size",
                },
                tabContentMarginLeft: {
                  label:
                    "tab \u533a\u57df \u5de6\u8fb9\u8ddd\uff08\u9ed8\u8ba4\uff1a0px\uff09",
                  type: "string",
                },
                tabContentMarginRight: {
                  label:
                    "tab \u533a\u57df \u53f3\u8fb9\u8ddd\uff08\u9ed8\u8ba4\uff1a0px\uff09",
                  type: "string",
                },
                imgContentWidth: {
                  label:
                    "\u89c6\u9891/\u56fe\u7247 \u533a\u57df\u5bbd\u5ea6\uff08\u9ed8\u8ba4\uff1a 592px\uff09",
                  type: "string",
                  content: "size",
                },
                imgContentMarginLeft: {
                  label:
                    "\u89c6\u9891/\u56fe\u7247 \u5de6\u8fb9\u8ddd\uff08\u9ed8\u8ba4\uff1a0px\uff09",
                  type: "string",
                },
                imgContentMarginRight: {
                  label:
                    "\u89c6\u9891/\u56fe\u7247 \u53f3\u8fb9\u8ddd\uff08\u9ed8\u8ba4\uff1a0px\uff09",
                  type: "string",
                },
                flexJustifyContentCenter: {
                  label: "\u5e03\u5c40\u662f\u5426\u6c34\u5e73\u5c45\u4e2d",
                  type: "boolean",
                },
                layout: {
                  type: "select",
                  label: "\u5e03\u5c40",
                  items: [
                    { label: "\u5de6\u6587\u53f3\u56fe", value: "leftText" },
                    { label: "\u5de6\u56fe\u53f3\u6587", value: "rightText" },
                  ],
                },
                closeRadius: {
                  type: "boolean",
                  label:
                    "\u53f3\u4fa7\u89c6\u9891\u5173\u95ed\u5706\u89d2\u6548\u679c",
                },
                theme: {
                  type: "select",
                  label: "\u4e3b\u9898\u8272",
                  items: [
                    { label: "\u4eae\u8272", value: "light" },
                    { label: "\u6697\u8272", value: "dark" },
                  ],
                },
                paddingTop: {
                  label: "\u6a21\u5757\u4e0a\u8fb9\u8ddd",
                  type: "string",
                  content: "size",
                },
                paddingBottom: {
                  label: "\u6a21\u5757\u4e0b\u8fb9\u8ddd",
                  type: "string",
                  content: "size",
                },
                background: {
                  label: "\u6a21\u5757\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
                verticalTabMargin: {
                  label: "tab \u8ddd\u79bbheader\u9876\u90e8\u7684\u8ddd\u79bb",
                  type: "string",
                  content: "size",
                },
                tabItemTitleFontSize: {
                  label:
                    "tab item \u6807\u9898\u5b57\u4f53\u5927\u5c0f(\u9ed8\u8ba4\uff1a24px)",
                  type: "string",
                  content: "size",
                },
                tabItemTitleLineHeight: {
                  label:
                    "tab item \u6807\u9898\u5b57\u4f53\u884c\u9ad8(\u9ed8\u8ba4\uff1a28px)",
                  type: "string",
                  content: "size",
                },
                tabItemDescFontSize: {
                  label:
                    "tab item \u6807\u9898\u5b57\u4f53\u5927\u5c0f(\u9ed8\u8ba4\uff1a16px)",
                  type: "string",
                  content: "size",
                },
                tabItemDescLineHeight: {
                  label:
                    "tab item \u6807\u9898\u5b57\u4f53\u884c\u9ad8(\u9ed8\u8ba4\uff1a24px)",
                  type: "string",
                  content: "size",
                },
                tabMainTitleSpacing: {
                  label:
                    "tab \u4e0a\u9762\u6807\u9898\u63cf\u8ff0\u548ctab\u4e4b\u95f4\u7684\u95f4\u8ddd\uff08\u9ed8\u8ba4\u662f32px\uff09",
                  type: "string",
                },
              },
            },
          },
        });
      t.a = Object(h.a)(W);
    },
    H8j4: function (e, t, n) {
      var o = n("QkVE");
      e.exports = function (e, t) {
        var n = o(this, e),
          a = n.size;
        return n.set(e, t), (this.size += n.size == a ? 0 : 1), this;
      };
    },
    HICh: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("Aw7D"),
        r = n("WCV8"),
        i = (o = r) && o.__esModule ? o : { default: o };
      t.default = function (e, t, n, o, r) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, a.isEmptyValue)(t) && !e.required) return n();
          i.default.required(e, t, o, l, r),
            void 0 !== t && i.default.type(e, t, o, l, r);
        }
        n(l);
      };
    },
    HL8k: function (e, t, n) {
      e.exports = {
        "area-linkage": "style__area-linkage___UcXvr",
        "form-group": "style__form-group___uFcrd",
        hide: "style__hide___2Vks2",
        "select-box": "style__select-box___1Ez_H",
        select: "style__select___1jXjt",
        icon: "style__icon___2hy01",
      };
    },
    HOxn: function (e, t, n) {
      var o = n("Cwc5")(n("Kz5y"), "Promise");
      e.exports = o;
    },
    HaZN: function (e, t, n) {
      "use strict";
      var o = n("ODXe"),
        a = n("rePB"),
        r = n("q1tI"),
        i = n.n(r),
        l = n("iKuz"),
        s = n.n(l),
        c = n("TSYQ"),
        _ = n.n(c),
        u = n("ZYh2"),
        d = n("5suc"),
        p = n("1icT"),
        f = n("yWgo"),
        h = n("9/5/"),
        m = n.n(h),
        y = n("D7K2"),
        b = (n("ALVP"), i.a.createElement),
        v = {
          "./style.css": {
            "modal-block-horizontal": "style__modal-block-horizontal___2q2M2",
            "modal-block-horizontal-active":
              "style__modal-block-horizontal-active___3FJ06",
            "popup-content-wrapper": "style__popup-content-wrapper___1YC4A",
            "pop-up-inner-wrapper": "style__pop-up-inner-wrapper___2UO12",
            "popup-content": "style__popup-content___25_ER",
            close: "style__close___gbUVW",
            "modal-block-container-mobile":
              "style__modal-block-container-mobile___1fCIk",
          },
        };
      function g(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function w(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? g(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : g(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var x = "undefined" !== typeof document,
        k = function (e) {
          var t = e.handleClosePopUp,
            n = e.isModalCloseLight ? "#fff" : "#000";
          return b(
            "div",
            { className: "modal-close-btn style__close___gbUVW", onClick: t },
            b(p.b, { fill: n, stroke: "none" }),
          );
        },
        O = function (e) {
          var t = e.handleClosePopUp,
            n = e.children,
            o = e.modalRef,
            a = e.showModal,
            r = e.isModalCloseLight;
          return b(
            "div",
            { ref: o, className: "style__pop-up-inner-wrapper___2UO12" },
            b(
              "div",
              { className: "style__popup-content-wrapper___1YC4A" },
              b(k, { handleClosePopUp: t, isModalCloseLight: r }),
              b(
                "div",
                {
                  className:
                    "sale-point-popup-content style__popup-content___25_ER",
                  style: w({}, Object(y.h)(a)),
                },
                n,
              ),
            ),
          );
        };
      t.a = function (e) {
        var t = e.children,
          n = e.id,
          a = e.mobileMode,
          i = e.component_data,
          l = e.anchor_id,
          c = e.componentName,
          p = e.className,
          h = e.parentNodeLevel,
          y = e.modalClick,
          g = e.hiddenDomWhenOpen,
          w = void 0 === g || g,
          k = Object(r.useState)(!1),
          I = k[0],
          S = k[1],
          j = Object(r.useRef)(null),
          T = x && document.body,
          C = x && document.querySelector("html"),
          M = Object(d.a)(T),
          P = Object(o.a)(M, 2),
          E = P[0],
          L = P[1],
          B = i.modalTopMask,
          N = i.isModalCloseLight,
          D = l || n;
        Object(r.useEffect)(function () {
          T &&
            T.addEventListener("click", function (e) {
              (h
                ? Object(f.I)(e.target, 6)
                : [e.target.id, e.target.parentElement.id]
              ).indexOf("".concat(c, "-Modal-Type-").concat(D)) > -1 &&
                (e.stopPropagation(),
                S(!0),
                a || (E(), C && w && C.style.setProperty("overflow", "hidden")),
                a && Object(u.b)(j.current));
            });
        }, []);
        var z = m()(function () {
            a || (L(), C && w && C.style.removeProperty("overflow")),
              S(!1),
              a && Object(u.c)(j.current);
          }, 200),
          A = _()({
            "modal-block-horizontal": !0,
            "modal-block-horizontal-active": I,
            "modal-block-container-mobile": a,
          });
        return b(
          "div",
          {
            id: "modal-block-".concat(l || n),
            onClick: function (e) {
              y && "close" === y(e) && I && (console.log("slug close "), z());
            },
            style: { backgroundColor: B },
            className:
              (p ? p + " " : "") +
              s()(A, v, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
          },
          b(
            O,
            {
              isModalCloseLight: N,
              handleClosePopUp: z,
              modalRef: j,
              showModal: I,
            },
            t,
          ),
        );
      };
    },
    HcE9: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return h;
      }),
        n.d(t, "b", function () {
          return m;
        }),
        n.d(t, "c", function () {
          return y;
        });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("iKuz"),
        c = n.n(s),
        _ = n("q1tI"),
        u = (n("IcIN"), n("S5C5")),
        d = _.createElement,
        p = {
          "./style.css": {
            "dji-link": "style__dji-link___3Bxkg",
            "white-main": "style__white-main___3jpqZ",
            "black-main": "style__black-main___yosGt",
            "blue-link-on-dark": "style__blue-link-on-dark___5X5Q_",
            danger: "style__danger___3aqMu",
            "dji-link-normal": "style__dji-link-normal___Drppd",
            "dji-link-more": "style__dji-link-more___34EJc",
            "dji-link-modal": "style__dji-link-modal___Ae1GS",
            "dji-link-video": "style__dji-link-video___3S6vF",
            "dji-link-image": "style__dji-link-image___2wd0I",
            "dji-link-download": "style__dji-link-download___74hhr",
            "dji-link-replay": "style__dji-link-replay___2H2ns",
            "dji-link-refresh": "style__dji-link-refresh___1rnlz",
            "dji-link-external": "style__dji-link-external___F_OpW",
          },
        };
      function f(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var h = (function (e) {
          return (
            (e.normal = ""),
            (e.white = "white-main"),
            (e.black = "black-main"),
            (e.dark = "blue-link-on-dark"),
            (e.danger = "danger"),
            e
          );
        })({}),
        m = (function (e) {
          return (
            (e.normal = "normal"),
            (e.more = "more"),
            (e.modal = "modal"),
            (e.video = "video"),
            (e.image = "image"),
            (e.download = "download"),
            (e.replay = "replay"),
            (e.refresh = "refresh"),
            (e.external = "external"),
            e
          );
        })({}),
        y = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t), ((n = f(this, t, [e])).state = {}), n
            );
          }
          return (
            Object(l.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = "".concat(e.theme),
                    n = "dji-link-".concat(m[e.type]),
                    o =
                      "download" === e.type || "external" === e.type
                        ? "_blank"
                        : "_self";
                  return (
                    (o = e.autoTarget ? Object(u.h)(e.href) : o),
                    d(
                      "a",
                      {
                        id: e.id,
                        href: e.href,
                        target: e.target || o,
                        style: e.style,
                        onClick: e.onClick,
                        className:
                          "atom-design-v1 " +
                          c()("dji-link ".concat(t, " ").concat(n), p, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                      },
                      e.children,
                    )
                  );
                },
              },
            ]),
            t
          );
        })(_.Component);
    },
    Hfiw: function (e, t, n) {
      var o = n("Y7ZC");
      o(o.S, "Object", { setPrototypeOf: n("6tYh").set });
    },
    Hsns: function (e, t, n) {
      var o = n("93I4"),
        a = n("5T2Y").document,
        r = o(a) && o(a.createElement);
      e.exports = function (e) {
        return r ? a.createElement(e) : {};
      };
    },
    Hvzi: function (e, t) {
      e.exports = function (e) {
        var t = this.has(e) && delete this.__data__[e];
        return (this.size -= t ? 1 : 0), t;
      };
    },
    HyXp: function (e, t, n) {
      "use strict";
      var o = n("rePB"),
        a = n("6HgK"),
        r = n("2mql"),
        i = n.n(r),
        l = n("pXgs"),
        s = n("fi7q"),
        c = n("wx14"),
        _ = n("1OyB"),
        u = n("vuIU"),
        d = n("md7G"),
        p = n("foSv"),
        f = n("JX7q"),
        h = n("Ji7U"),
        m = n("iKuz"),
        y = n.n(m),
        b = n("q1tI"),
        v = n.n(b),
        g = n("3vbH"),
        w = n("SBOM"),
        x = n("TSYQ"),
        k = n.n(x),
        O = n("/+VL"),
        I = n("r7AC"),
        S = (n("H+zn"), v.a.createElement),
        j = {
          "./style.css": {
            "atom-horizontal-tabs": "style__atom-horizontal-tabs___1W_2y",
            "tab-item": "style__tab-item___2XPNc",
            "aotm-horizontal-tab-inkbar":
              "style__aotm-horizontal-tab-inkbar___2J6Hn",
            "atom-horizontal-tab-bisection":
              "style__atom-horizontal-tab-bisection___1TFaE",
            "tab-bar-box": "style__tab-bar-box___1n6tq",
            "tab-bar-wrap": "style__tab-bar-wrap___9MHND",
            "atom-horizontal-tabs-left":
              "style__atom-horizontal-tabs-left___3c2ZI",
            "atom-horizontal-tabs-center":
              "style__atom-horizontal-tabs-center___2rprk",
            "atom-horizontal-tabs-right":
              "style__atom-horizontal-tabs-right___2qoMi",
            "atom-horizontal-tab-bar-theme-dark":
              "style__atom-horizontal-tab-bar-theme-dark___21hHN",
            "tab-item-active": "style__tab-item-active___2Xb8y",
            "tab-hover-icon": "style__tab-hover-icon___11q9a",
            "tab-icon": "style__tab-icon___1IqCU",
            "atom-horizontal-tab-bar-theme-light":
              "style__atom-horizontal-tab-bar-theme-light___23hzn",
            "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___1f_vc",
            "icon-text": "style__icon-text___1YrCe",
            "icon-title": "style__icon-title___14Ntw",
            "icon-box": "style__icon-box___T6GmX",
            "atom-horizontal-tab-bar-left":
              "style__atom-horizontal-tab-bar-left___2Mb87",
            "atom-horizontal-tab-bar-center":
              "style__atom-horizontal-tab-bar-center___1Fa3k",
            "atom-horizontal-tab-bar-right":
              "style__atom-horizontal-tab-bar-right___1GXp6",
            "atom-horizontal-tab-content":
              "style__atom-horizontal-tab-content___2dnfl",
            "atom-horizontal-tab-content-left":
              "style__atom-horizontal-tab-content-left___19LcX",
            "atom-horizontal-tab-content-center":
              "style__atom-horizontal-tab-content-center___32l3i",
            "atom-horizontal-tab-content-right":
              "style__atom-horizontal-tab-content-right___3M0YU",
            "atom-horizontal-tabs-content-theme-dark":
              "style__atom-horizontal-tabs-content-theme-dark___14w_n",
            "tab-panel": "style__tab-panel___2lHpo",
            "atom-horizontal-tabs-content-theme-light":
              "style__atom-horizontal-tabs-content-theme-light___FiDv6",
            "tab-panel-active": "style__tab-panel-active___1yZh_",
            "atom-horizontal-tab-bar-none":
              "style__atom-horizontal-tab-bar-none___RD3De",
            "tab-line": "style__tab-line___1UScG",
            "slick-slide": "style__slick-slide___3rGlL",
            "slick-active": "style__slick-active___1Jdo-",
          },
        };
      function T(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function C(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? T(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : T(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function M(e, t, n) {
        return (
          (t = Object(p.a)(t)),
          Object(d.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(p.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var P = (function (e) {
          function t(e) {
            var n;
            return (
              Object(_.default)(this, t),
              (n = M(this, t, [e])),
              Object(o.a)(Object(f.a)(n), "tabBar", void 0),
              Object(o.a)(Object(f.a)(n), "activeTab", void 0),
              (n.state = { inkBarStyle: { transition: "none" } }),
              (n.renderTabs = n.renderTabs.bind(Object(f.a)(n))),
              (n.handleTabClick = n.handleTabClick.bind(Object(f.a)(n))),
              (n.updateInkBarStyle = n.updateInkBarStyle.bind(Object(f.a)(n))),
              (n.renderBar = n.renderBar.bind(Object(f.a)(n))),
              n
            );
          }
          return (
            Object(h.a)(t, e),
            Object(u.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  this.updateInkBarStyle({ transition: "none" });
                },
              },
              {
                key: "componentDidUpdate",
                value: function (e) {
                  e.activeKey !== this.props.activeKey &&
                    this.updateInkBarStyle();
                },
              },
              {
                key: "handleTabClick",
                value: function (e, t) {
                  var n = this.props.onTabClick;
                  n && n(e, t);
                },
              },
              {
                key: "updateInkBarStyle",
                value: function (e) {
                  if (this.activeTab && this.tabBar) {
                    var t = C(C({}, e || {}), {}, { width: "0px" }),
                      n = this.activeTab.offsetLeft - this.tabBar.offsetLeft,
                      o = this.activeTab.clientWidth;
                    !(function (e, t) {
                      var n = e;
                      e &&
                        "object" === typeof e &&
                        t &&
                        ((n.transform = t),
                        (n.WebkitTransform = t),
                        (n.MozTransform = t));
                    })(t, "translate3d(".concat(n, "px,0,0)")),
                      (t.width = "".concat(o, "px")),
                      this.setState({ inkBarStyle: t });
                  }
                },
              },
              {
                key: "renderBar",
                value: function () {
                  var e = this.state.inkBarStyle;
                  return S("div", {
                    style: e,
                    className: "style__aotm-horizontal-tab-inkbar___2J6Hn",
                  });
                },
              },
              {
                key: "renderTabs",
                value: function () {
                  var e = this,
                    t = this.props;
                  return v.a.Children.map(t.panels, function (n, o) {
                    var a,
                      r = n.key,
                      i = k()("tab-item", {
                        "tab-item-active": t.activeKey === r,
                      }),
                      l = { onClick: e.handleTabClick.bind(e, r, o) },
                      s = { height: t.tabBarIconHeight, display: "block" };
                    switch (t.tabBarContent) {
                      case "headline":
                        a = S("div", {
                          dangerouslySetInnerHTML: { __html: n.props.tab },
                        });
                        break;
                      case "icon":
                        a = S(
                          "div",
                          { className: "style__icon-box___T6GmX", style: s },
                          S("img", {
                            className: "style__tab-icon___1IqCU",
                            src: n.props.tabBarIcon,
                            alt: "",
                            style: s,
                          }),
                          S("img", {
                            className: "style__tab-hover-icon___11q9a",
                            src: n.props.tabBarHoverIcon,
                            alt: "",
                            style: s,
                          }),
                        );
                        break;
                      case "none":
                        a = S("div", { className: "style__tab-line___1UScG" });
                        break;
                      default:
                        a = S(
                          "div",
                          { className: "style__icon-text___1YrCe" },
                          S(
                            "div",
                            { className: "style__icon-box___T6GmX", style: s },
                            S("img", {
                              className: "style__tab-icon___1IqCU",
                              src: n.props.tabBarIcon,
                              alt: "",
                              style: s,
                            }),
                            S("img", {
                              className: "style__tab-hover-icon___11q9a",
                              src: n.props.tabBarHoverIcon,
                              alt: "",
                              style: s,
                            }),
                          ),
                          S("div", {
                            className: "style__icon-title___14Ntw",
                            dangerouslySetInnerHTML: { __html: n.props.tab },
                          }),
                        );
                    }
                    return S(
                      "div",
                      Object(c.a)(
                        { style: { display: "inline-block" }, key: r },
                        l,
                        {
                          ref: function (n) {
                            t.activeKey === r && (e.activeTab = n);
                          },
                          "data-ga-label": "all-".concat(o, "-tab-button"),
                          className:
                            y()(i, j, {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            }) +
                            " " +
                            ((l && l.className) || ""),
                        },
                      ),
                      a,
                    );
                  });
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = this.renderTabs(),
                    o = this.renderBar(),
                    a = k()(
                      "atom-horizontal-tab-bar",
                      "atom-horizontal-tab-bar-".concat(t.tabAlign),
                      "atom-horizontal-tab-bar-".concat(t.tabBarContent),
                      "atom-horizontal-tab-bar-theme-".concat(t.tabTheme),
                      {
                        "atom-horizontal-tab-bisection":
                          "none" !== t.tabBarContent &&
                          t.intervalBisection &&
                          t.tabOverallWidth,
                      },
                    ),
                    r = { width: t.tabOverallWidth },
                    i = "none" !== t.tabBarContent ? o : null;
                  return S(
                    "div",
                    {
                      style:
                        "none" !== t.tabBarContent && t.intervalBisection
                          ? r
                          : {},
                      className: y()(a, j, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    S(
                      "div",
                      {
                        ref: function (t) {
                          e.tabBar = t;
                        },
                        className: "style__tab-bar-box___1n6tq",
                      },
                      i,
                      S("div", { className: "style__tab-bar-wrap___9MHND" }, n),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(v.a.PureComponent),
        E = n("Ff2n"),
        L = v.a.createElement,
        B = {
          "./style.css": {
            "atom-horizontal-tabs": "style__atom-horizontal-tabs___1W_2y",
            "tab-item": "style__tab-item___2XPNc",
            "aotm-horizontal-tab-inkbar":
              "style__aotm-horizontal-tab-inkbar___2J6Hn",
            "atom-horizontal-tab-bisection":
              "style__atom-horizontal-tab-bisection___1TFaE",
            "tab-bar-box": "style__tab-bar-box___1n6tq",
            "tab-bar-wrap": "style__tab-bar-wrap___9MHND",
            "atom-horizontal-tabs-left":
              "style__atom-horizontal-tabs-left___3c2ZI",
            "atom-horizontal-tabs-center":
              "style__atom-horizontal-tabs-center___2rprk",
            "atom-horizontal-tabs-right":
              "style__atom-horizontal-tabs-right___2qoMi",
            "atom-horizontal-tab-bar-theme-dark":
              "style__atom-horizontal-tab-bar-theme-dark___21hHN",
            "tab-item-active": "style__tab-item-active___2Xb8y",
            "tab-hover-icon": "style__tab-hover-icon___11q9a",
            "tab-icon": "style__tab-icon___1IqCU",
            "atom-horizontal-tab-bar-theme-light":
              "style__atom-horizontal-tab-bar-theme-light___23hzn",
            "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___1f_vc",
            "icon-text": "style__icon-text___1YrCe",
            "icon-title": "style__icon-title___14Ntw",
            "icon-box": "style__icon-box___T6GmX",
            "atom-horizontal-tab-bar-left":
              "style__atom-horizontal-tab-bar-left___2Mb87",
            "atom-horizontal-tab-bar-center":
              "style__atom-horizontal-tab-bar-center___1Fa3k",
            "atom-horizontal-tab-bar-right":
              "style__atom-horizontal-tab-bar-right___1GXp6",
            "atom-horizontal-tab-content":
              "style__atom-horizontal-tab-content___2dnfl",
            "atom-horizontal-tab-content-left":
              "style__atom-horizontal-tab-content-left___19LcX",
            "atom-horizontal-tab-content-center":
              "style__atom-horizontal-tab-content-center___32l3i",
            "atom-horizontal-tab-content-right":
              "style__atom-horizontal-tab-content-right___3M0YU",
            "atom-horizontal-tabs-content-theme-dark":
              "style__atom-horizontal-tabs-content-theme-dark___14w_n",
            "tab-panel": "style__tab-panel___2lHpo",
            "atom-horizontal-tabs-content-theme-light":
              "style__atom-horizontal-tabs-content-theme-light___FiDv6",
            "tab-panel-active": "style__tab-panel-active___1yZh_",
            "atom-horizontal-tab-bar-none":
              "style__atom-horizontal-tab-bar-none___RD3De",
            "tab-line": "style__tab-line___1UScG",
            "slick-slide": "style__slick-slide___3rGlL",
            "slick-active": "style__slick-active___1Jdo-",
          },
        };
      function N(e, t, n) {
        return (
          (t = Object(p.a)(t)),
          Object(d.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(p.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var D = (function (e) {
          function t() {
            return Object(_.default)(this, t), N(this, t, arguments);
          }
          return (
            Object(h.a)(t, e),
            Object(u.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.active,
                    n = e.children,
                    o = k()("tab-panel", { "tab-panel-active": t });
                  return L(
                    "div",
                    {
                      className: y()(o, B, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    n,
                  );
                },
              },
            ]),
            t
          );
        })(v.a.PureComponent),
        z = ["children", "height"],
        A = v.a.createElement,
        R = {
          "./style.css": {
            "atom-horizontal-tabs": "style__atom-horizontal-tabs___1W_2y",
            "tab-item": "style__tab-item___2XPNc",
            "aotm-horizontal-tab-inkbar":
              "style__aotm-horizontal-tab-inkbar___2J6Hn",
            "atom-horizontal-tab-bisection":
              "style__atom-horizontal-tab-bisection___1TFaE",
            "tab-bar-box": "style__tab-bar-box___1n6tq",
            "tab-bar-wrap": "style__tab-bar-wrap___9MHND",
            "atom-horizontal-tabs-left":
              "style__atom-horizontal-tabs-left___3c2ZI",
            "atom-horizontal-tabs-center":
              "style__atom-horizontal-tabs-center___2rprk",
            "atom-horizontal-tabs-right":
              "style__atom-horizontal-tabs-right___2qoMi",
            "atom-horizontal-tab-bar-theme-dark":
              "style__atom-horizontal-tab-bar-theme-dark___21hHN",
            "tab-item-active": "style__tab-item-active___2Xb8y",
            "tab-hover-icon": "style__tab-hover-icon___11q9a",
            "tab-icon": "style__tab-icon___1IqCU",
            "atom-horizontal-tab-bar-theme-light":
              "style__atom-horizontal-tab-bar-theme-light___23hzn",
            "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___1f_vc",
            "icon-text": "style__icon-text___1YrCe",
            "icon-title": "style__icon-title___14Ntw",
            "icon-box": "style__icon-box___T6GmX",
            "atom-horizontal-tab-bar-left":
              "style__atom-horizontal-tab-bar-left___2Mb87",
            "atom-horizontal-tab-bar-center":
              "style__atom-horizontal-tab-bar-center___1Fa3k",
            "atom-horizontal-tab-bar-right":
              "style__atom-horizontal-tab-bar-right___1GXp6",
            "atom-horizontal-tab-content":
              "style__atom-horizontal-tab-content___2dnfl",
            "atom-horizontal-tab-content-left":
              "style__atom-horizontal-tab-content-left___19LcX",
            "atom-horizontal-tab-content-center":
              "style__atom-horizontal-tab-content-center___32l3i",
            "atom-horizontal-tab-content-right":
              "style__atom-horizontal-tab-content-right___3M0YU",
            "atom-horizontal-tabs-content-theme-dark":
              "style__atom-horizontal-tabs-content-theme-dark___14w_n",
            "tab-panel": "style__tab-panel___2lHpo",
            "atom-horizontal-tabs-content-theme-light":
              "style__atom-horizontal-tabs-content-theme-light___FiDv6",
            "tab-panel-active": "style__tab-panel-active___1yZh_",
            "atom-horizontal-tab-bar-none":
              "style__atom-horizontal-tab-bar-none___RD3De",
            "tab-line": "style__tab-line___1UScG",
            "slick-slide": "style__slick-slide___3rGlL",
            "slick-active": "style__slick-active___1Jdo-",
          },
        };
      function F(e, t, n) {
        return (
          (t = Object(p.a)(t)),
          Object(d.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(p.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var V = (function (e) {
          function t(e) {
            var n;
            return (
              Object(_.default)(this, t),
              ((n = F(this, t, [e])).state = { minHeight: 0 }),
              n
            );
          }
          return (
            Object(h.a)(t, e),
            Object(u.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = this.state,
                    o = v.a.Children.map(t.panels, function (o) {
                      var a = o.key,
                        r = n.minHeight,
                        i = o.props,
                        l = i.children,
                        s = i.height,
                        _ = Object(E.a)(i, z);
                      return (
                        s && s > r && e.setState({ minHeight: s }),
                        A(
                          D,
                          Object(c.a)(
                            {
                              key: "tab-panel-".concat(a),
                              active: t.activeKey === a,
                            },
                            _,
                          ),
                          l,
                        )
                      );
                    }),
                    a = k()(
                      "atom-horizontal-tab-content",
                      "atom-horizontal-tab-content-".concat(t.tabAlign),
                      "atom-horizontal-tabs-content-theme-".concat(t.tabTheme),
                    );
                  return A(
                    "div",
                    {
                      style: { minHeight: n.minHeight },
                      className: y()(a, R, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    o,
                  );
                },
              },
            ]),
            t
          );
        })(v.a.Component),
        H = n("xk4V"),
        W = n.n(H),
        U = n("UYut"),
        G = n("CBaM"),
        Y = v.a.createElement;
      function q(e, t, n) {
        return (
          (t = Object(p.a)(t)),
          Object(d.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(p.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var X = (function (e) {
          function t(e) {
            var n;
            return (
              Object(_.default)(this, t),
              (n = q(this, t, [e])),
              Object(o.a)(Object(f.a)(n), "cardDom", void 0),
              Object(o.a)(Object(f.a)(n), "carousel", void 0),
              Object(o.a)(Object(f.a)(n), "carouselCard", void 0),
              (n.state = {}),
              (n.getProps = n.getProps.bind(Object(f.a)(n))),
              (n.cardDom = []),
              (n.carouselCard = []),
              n
            );
          }
          return (
            Object(h.a)(t, e),
            Object(u.default)(t, [
              {
                key: "shouldComponentUpdate",
                value: function () {
                  return !1;
                },
              },
              {
                key: "getProps",
                value: function (e) {
                  return this.props[e];
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = "tab-card-wrapper ".concat(t.customStyleName),
                    o = this.props.cardConfigList
                      ? this.props.cardConfigList.map(function (o, a) {
                          return Y(
                            "div",
                            {
                              key: W()(),
                              ref: function (t) {
                                e.carouselCard[a] = t;
                              },
                            },
                            Y(
                              G.a,
                              Object(c.a)(
                                {
                                  id: t.id,
                                  gaSend: function () {
                                    return e.getProps("gaSend");
                                  },
                                },
                                o,
                                {
                                  key: W()(),
                                  index: a,
                                  getFadeTransiation: function () {
                                    return e.getProps("fadeTransiation");
                                  },
                                  getMediaTransiation: function () {
                                    return e.getProps("mediaTransiation");
                                  },
                                  getGapWidth: function () {
                                    return e.getProps("cardGapWidth");
                                  },
                                  getGridWidth: function () {
                                    return e.getProps("gridWidth");
                                  },
                                  getTabPresentation: function () {
                                    return e.getProps("tabPresentation");
                                  },
                                  ref: function (t) {
                                    e.cardDom[a] = t;
                                  },
                                  customStyleName: n,
                                },
                              ),
                            ),
                          );
                        })
                      : null;
                  return Y(
                    U.a,
                    Object(c.a)({}, t.parameter, {
                      ref: function (t) {
                        e.carousel = t;
                      },
                    }),
                    o,
                  );
                },
              },
            ]),
            t
          );
        })(v.a.Component),
        Z = n("tZZE"),
        K = n("yWgo"),
        Q = v.a.createElement,
        J = {
          "./style.css": {
            "atom-horizontal-tabs": "style__atom-horizontal-tabs___1W_2y",
            "tab-item": "style__tab-item___2XPNc",
            "aotm-horizontal-tab-inkbar":
              "style__aotm-horizontal-tab-inkbar___2J6Hn",
            "atom-horizontal-tab-bisection":
              "style__atom-horizontal-tab-bisection___1TFaE",
            "tab-bar-box": "style__tab-bar-box___1n6tq",
            "tab-bar-wrap": "style__tab-bar-wrap___9MHND",
            "atom-horizontal-tabs-left":
              "style__atom-horizontal-tabs-left___3c2ZI",
            "atom-horizontal-tabs-center":
              "style__atom-horizontal-tabs-center___2rprk",
            "atom-horizontal-tabs-right":
              "style__atom-horizontal-tabs-right___2qoMi",
            "atom-horizontal-tab-bar-theme-dark":
              "style__atom-horizontal-tab-bar-theme-dark___21hHN",
            "tab-item-active": "style__tab-item-active___2Xb8y",
            "tab-hover-icon": "style__tab-hover-icon___11q9a",
            "tab-icon": "style__tab-icon___1IqCU",
            "atom-horizontal-tab-bar-theme-light":
              "style__atom-horizontal-tab-bar-theme-light___23hzn",
            "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___1f_vc",
            "icon-text": "style__icon-text___1YrCe",
            "icon-title": "style__icon-title___14Ntw",
            "icon-box": "style__icon-box___T6GmX",
            "atom-horizontal-tab-bar-left":
              "style__atom-horizontal-tab-bar-left___2Mb87",
            "atom-horizontal-tab-bar-center":
              "style__atom-horizontal-tab-bar-center___1Fa3k",
            "atom-horizontal-tab-bar-right":
              "style__atom-horizontal-tab-bar-right___1GXp6",
            "atom-horizontal-tab-content":
              "style__atom-horizontal-tab-content___2dnfl",
            "atom-horizontal-tab-content-left":
              "style__atom-horizontal-tab-content-left___19LcX",
            "atom-horizontal-tab-content-center":
              "style__atom-horizontal-tab-content-center___32l3i",
            "atom-horizontal-tab-content-right":
              "style__atom-horizontal-tab-content-right___3M0YU",
            "atom-horizontal-tabs-content-theme-dark":
              "style__atom-horizontal-tabs-content-theme-dark___14w_n",
            "tab-panel": "style__tab-panel___2lHpo",
            "atom-horizontal-tabs-content-theme-light":
              "style__atom-horizontal-tabs-content-theme-light___FiDv6",
            "tab-panel-active": "style__tab-panel-active___1yZh_",
            "atom-horizontal-tab-bar-none":
              "style__atom-horizontal-tab-bar-none___RD3De",
            "tab-line": "style__tab-line___1UScG",
            "slick-slide": "style__slick-slide___3rGlL",
            "slick-active": "style__slick-active___1Jdo-",
          },
        };
      function $(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function ee(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? $(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : $(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function te(e, t) {
        var n =
          ("undefined" !== typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" === typeof e) return ne(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return ne(e, t);
            })(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var o = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return o >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[o++] };
              },
              e: function (e) {
                throw e;
              },
              f: a,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var r,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (r = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw r;
            }
          },
        };
      }
      function ne(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      function oe(e, t, n) {
        return (
          (t = Object(p.a)(t)),
          Object(d.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(p.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ae = (function (e) {
        function t(e) {
          var n, a;
          return (
            Object(_.default)(this, t),
            (n = oe(this, t, [e])),
            Object(o.a)(Object(f.a)(n), "carousel", void 0),
            Object(o.a)(Object(f.a)(n), "cardDom", void 0),
            Object(o.a)(Object(f.a)(n), "tabCardDom", void 0),
            Object(o.a)(Object(f.a)(n), "tabDom", void 0),
            Object(o.a)(Object(f.a)(n), "cards", void 0),
            Object(o.a)(Object(f.a)(n), "activeIndex", void 0),
            Object(o.a)(Object(f.a)(n), "videoFlag", void 0),
            Object(o.a)(Object(f.a)(n), "videoListenerAdded", void 0),
            Object(o.a)(Object(f.a)(n), "tabVisible", void 0),
            Object(o.a)(Object(f.a)(n), "visualDom", void 0),
            Object(o.a)(Object(f.a)(n), "defaultActiveIndex", void 0),
            (n.state = {}),
            (n.defaultActiveIndex = 0),
            "activeKey" in e
              ? (a = e.activeKey)
              : "defaultActiveKey" in e
                ? ((a = e.defaultActiveKey),
                  e.tabContent.forEach(function (e, t) {
                    e.tabKey === a && (n.defaultActiveIndex = t);
                  }))
                : (a = (function (e) {
                    var t;
                    return (
                      v.a.Children.forEach(e.children, function (e) {
                        e && !t && (t = e.key);
                      }),
                      t
                    );
                  })(e)),
            (n.state = { activeKey: a }),
            (n.videoListenerAdded = !1),
            (n.handleTabClick = n.handleTabClick.bind(Object(f.a)(n))),
            (n.renderCard = n.renderCard.bind(Object(f.a)(n))),
            (n.getFadeTransiation = n.getFadeTransiation.bind(Object(f.a)(n))),
            (n.handleVideo = n.handleVideo.bind(Object(f.a)(n))),
            (n.getProps = n.getProps.bind(Object(f.a)(n))),
            (n.bindScroll = n.bindScroll.bind(Object(f.a)(n))),
            (n.cardDom = []),
            (n.tabVisible = !0),
            (n.visualDom = !1),
            n
          );
        }
        return (
          Object(h.a)(t, e),
          Object(u.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.cardConfigList,
                  o = t.tabContent,
                  a = t.defaultActiveKey;
                this.tabVisible &&
                  window.addEventListener("scroll", this.bindScroll),
                  (this.cardDom = this.tabCardDom.cardDom),
                  (n[0].hasBackgroundVideo ||
                    (n[0].hasMedia &&
                      "video" === n[0].media &&
                      n[0].foregroundVideo)) &&
                    (this.handleVideo(0, !0),
                    this.tabCardDom.carousel.slick.slickPause()),
                  this.bindScroll(),
                  "defaultActiveKey" in this.props &&
                    o.forEach(function (t, n) {
                      0 !== n && t.tabKey === a && e.handleTabClick(a, n);
                    });
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                this.tabVisible &&
                  window.removeEventListener("scroll", this.bindScroll);
              },
            },
            {
              key: "getFadeTransiation",
              value: function () {
                return this.props.fadeTransiation;
              },
            },
            {
              key: "getProps",
              value: function (e) {
                return this.props[e];
              },
            },
            {
              key: "handleTabClick",
              value: function (e, t) {
                this.setState({ activeKey: e }), this.handleVideo(t, !0);
                var n,
                  o = this.tabCardDom.carouselCard,
                  a = te(o);
                try {
                  for (a.s(); !(n = a.n()).done; ) {
                    var r = n.value;
                    r.classList.add("slick-hide"),
                      r.classList.remove(
                        "slick-active",
                        "slick-current",
                        "slick-show",
                      );
                  }
                } catch (i) {
                  a.e(i);
                } finally {
                  a.f();
                }
                o[t].classList.add(
                  "slick-active",
                  "slick-current",
                  "slick-show",
                ),
                  o[t].classList.remove("slick-hide"),
                  this.tabCardDom.carousel.slickGoTo(t);
              },
            },
            {
              key: "handleVideo",
              value: function (e, t) {
                var n,
                  o = this,
                  a = this,
                  r = this.props;
                (this.videoFlag = t), (this.activeIndex = e);
                var i = r.cardConfigList[this.activeIndex],
                  l = i.hasBackgroundVideo && i.backgroundVideo,
                  s = i.hasMedia && "video" === i.media && i.foregroundVideo;
                if (!this.videoListenerAdded) {
                  O.a.getInstance().addNode(a.tabDom, {}, [
                    function () {
                      if (l)
                        n =
                          a.cardDom[o.activeIndex] &&
                          a.cardDom[o.activeIndex].cardBgVideoDom;
                      else if (s) {
                        var e;
                        n =
                          a.cardDom[o.activeIndex] &&
                          (null ===
                            (e =
                              a.cardDom[o.activeIndex].cardForegroundVideo) ||
                          void 0 === e
                            ? void 0
                            : e.current);
                      }
                      if (
                        o.videoFlag &&
                        O.a.getInstance().checkElementInView(a.tabDom) &&
                        n &&
                        n.poster
                      ) {
                        var t, i, c, _, u, d;
                        (null === (t = a.cardDom[o.activeIndex]) || void 0 === t
                          ? void 0
                          : null === (i = t.cardForegroundVideoReplay) ||
                              void 0 === i
                            ? void 0
                            : i.current) &&
                          (a.cardDom[
                            o.activeIndex
                          ].cardForegroundVideoReplay.current.style.display =
                            "none");
                        for (var p = 0; p < a.cardDom.length; p += 1) {
                          var f;
                          a.cardDom[p].cardBgVideoDom &&
                            a.cardDom[p].cardBgVideoDom.poster &&
                            a.cardDom[p] !== a.cardDom[o.activeIndex] &&
                            Object(K.jb)(a.cardDom[p].cardBgVideoDom),
                            (null === (f = a.cardDom[p].cardForegroundVideo) ||
                            void 0 === f
                              ? void 0
                              : f.current) &&
                              a.cardDom[p] !== a.cardDom[o.activeIndex] &&
                              Object(K.jb)(
                                a.cardDom[p].cardForegroundVideo.current,
                              );
                        }
                        var h =
                          null === (c = a.cardDom[o.activeIndex]) ||
                          void 0 === c
                            ? void 0
                            : null === (_ = c.props) || void 0 === _
                              ? void 0
                              : _.foregroundVideoPlayType;
                        if (
                          ((null === (u = a.cardDom[o.activeIndex]) ||
                          void 0 === u
                            ? void 0
                            : null === (d = u.cardForegroundVideoPlay) ||
                                void 0 === d
                              ? void 0
                              : d.current) &&
                            "withController" === h &&
                            (a.cardDom[
                              o.activeIndex
                            ].cardForegroundVideoPlay.current.style.display =
                              "none"),
                          n.duration >= 0)
                        ) {
                          n.currentTime = 0;
                          var m,
                            y,
                            b = n.play();
                          if (b && b.then && "function" === typeof b.then)
                            b
                              .then(
                                function () {
                                  return null;
                                },
                                function () {
                                  return null;
                                },
                              )
                              .catch(function () {
                                return null;
                              }),
                              (null === (m = a.cardDom[o.activeIndex]) ||
                              void 0 === m
                                ? void 0
                                : null === (y = m.cardForegroundVideoPause) ||
                                    void 0 === y
                                  ? void 0
                                  : y.current) &&
                                "withController" === h &&
                                (a.cardDom[
                                  o.activeIndex
                                ].cardForegroundVideoPause.current.style.display =
                                  "block");
                          o.videoFlag = !1;
                        }
                        n.addEventListener("ended", function () {
                          "carousel" === r.tabPresentation &&
                            (a.tabCardDom.carousel.slick.slickNext(),
                            a.setState({
                              activeKey: r.tabContent[o.activeIndex].tabKey,
                            }));
                        });
                      }
                      O.a.getInstance().checkElementInView(a.tabDom) ||
                        !n ||
                        n.paused ||
                        (n.pause(), (o.videoFlag = !0));
                    },
                  ]),
                    (this.videoListenerAdded = !0);
                }
              },
            },
            {
              key: "bindScroll",
              value: function () {
                var e = this.props,
                  t = e.cardConfigList[0],
                  n = Object(I.d)(this.tabDom, 0, 0);
                this.tabVisible &&
                  n &&
                  "carousel" === e.tabPresentation &&
                  !t.hasBackgroundVideo &&
                  ("picture" === t.media || !t.hasMedia) &&
                  ((this.visualDom = !0), (this.tabVisible = !1));
              },
            },
            {
              key: "handleHotZoneClick",
              value: function (e, t) {
                Object(Z.b)(e, t, "media-modal-container");
              },
            },
            {
              key: "renderCard",
              value: function (e, t) {
                var n = this,
                  o = this.props,
                  a = o.hotLink,
                  r = o.cardConfigList[0],
                  i = Number(o.tabCarouselInterval),
                  l = ee(
                    ee(
                      {
                        fade: !0,
                        speed: 600,
                        autoplay:
                          "carousel" === o.tabPresentation &&
                          !r.hasBackgroundVideo &&
                          ("picture" === r.media || !r.hasMedia),
                        autoplaySpeed: i,
                        touchMove: !1,
                      },
                      this.defaultActiveIndex
                        ? { initialSlide: this.defaultActiveIndex }
                        : {},
                    ),
                    {},
                    {
                      beforeChange: function (e, t) {
                        var a,
                          r =
                            n.cardDom &&
                            n.cardDom[t] &&
                            null !== n.cardDom[t].cardBgVideoDom,
                          i =
                            n.cardDom &&
                            n.cardDom[t] &&
                            null !==
                              (null ===
                                (a = n.cardDom[t].cardForegroundVideo) ||
                              void 0 === a
                                ? void 0
                                : a.current);
                        n.tabCardDom.carousel &&
                          n.tabCardDom.carousel.slick &&
                          "carousel" === o.tabPresentation &&
                          (r || i
                            ? (n.tabCardDom.carousel.slick.slickPause(),
                              n.handleVideo(t, !0),
                              n.setState({ activeKey: o.tabContent[t].tabKey }))
                            : n.visualDom
                              ? (n.setState({
                                  activeKey: o.tabContent[t].tabKey,
                                }),
                                n.tabCardDom.carousel.slick.slickPlay(),
                                n.tabCardDom.carousel.slick.slickNext())
                              : n.tabCardDom.carousel.slick.slickGoTo(0));
                      },
                    },
                  );
                return Q(
                  "div",
                  {
                    onClick: function (e) {
                      return n.handleHotZoneClick(e, a);
                    },
                    "data-ga-label":
                      null === a || void 0 === a ? void 0 : a.gaLabel,
                    className: "",
                    style: ee(
                      {
                        cursor: (null === a || void 0 === a ? void 0 : a.url)
                          ? "pointer"
                          : "initial",
                      },
                      e,
                    ),
                  },
                  Q(X, {
                    id: o.id,
                    parameter: l,
                    cardConfigList: o.cardConfigList,
                    fadeTransiation: o.fadeTransiation,
                    mediaTransiation: o.mediaTransiation,
                    cardGapWidth: o.cardGapWidth,
                    gridWidth: o.gridWidth,
                    tabPresentation: o.tabPresentation,
                    ref: function (e) {
                      n.tabCardDom = e;
                    },
                    customStyleName: t,
                  }),
                );
              },
            },
            {
              key: "render",
              value: function () {
                var e,
                  t = this,
                  n = this.props,
                  o = this.state.activeKey,
                  a = k()(
                    "atom-horizontal-tabs",
                    "atom-horizontal-tabs-".concat(n.tabAlign),
                  );
                switch (n.tabPosition) {
                  case "top":
                    e = { marginTop: n.spacingFromTheCard };
                    break;
                  default:
                    e = { marginBottom: n.spacingFromTheCard };
                }
                var r = k()(
                  "".concat(
                    Object(K.kb)(n.hasMediaScreen, "has-media-screen", ""),
                  ),
                  "media-screen-".concat(n.mediaPoint || "1440", " "),
                );
                return Q(
                  "div",
                  {
                    ref: function (e) {
                      t.tabDom = e;
                    },
                    className: y()(a, J, {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    }),
                  },
                  "center" === n.tabPosition ? this.renderCard(e, r) : null,
                  Q(P, {
                    key: "tabBar",
                    panels: n.children,
                    activeKey: o,
                    tabAlign: n.tabAlign,
                    tabTheme: n.tabTheme,
                    tabBarIconHeight: n.tabBarIconHeight,
                    tabBarContent: n.tabBarContent,
                    tabOverallWidth: n.tabOverallWidth,
                    intervalBisection: n.intervalBisection,
                    onTabClick: this.handleTabClick,
                  }),
                  "top" === n.tabPosition ? this.renderCard(e, r) : null,
                  Q(V, {
                    panels: n.children,
                    activeKey: o,
                    tabAlign: n.tabAlign,
                    tabTheme: n.tabTheme,
                    key: "tabContent",
                  }),
                );
              },
            },
          ]),
          t
        );
      })(v.a.PureComponent);
      Object(o.a)(ae, "TabPanel", D);
      var re = n("ZPPD"),
        ie = (n("OymH"), v.a.createElement);
      function le(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function se(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? le(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : le(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var ce = {
        "./style.css": {
          "atom-horiozntal-tab-component":
            "style__atom-horiozntal-tab-component___2bLOd",
          "background-video": "style__background-video___s6HOR",
          "atom-horizontal-tab-align-left":
            "style__atom-horizontal-tab-align-left___1FYqA",
          "atom-horizontal-tab-align-center":
            "style__atom-horizontal-tab-align-center___1Vp3B",
          "atom-horizontal-tab-align-right":
            "style__atom-horizontal-tab-align-right___3slvT",
          "tab-horizontal-wrapper": "style__tab-horizontal-wrapper___n9XZl",
          "card-wrap": "style__card-wrap___1RCGt",
          "vertical-left-align": "style__vertical-left-align___3HE8L",
          "vertical-center-align": "style__vertical-center-align___2_kLx",
          "vertical-right-align": "style__vertical-right-align___875-p",
          "tab-content": "style__tab-content___3rb2F",
          "tab-active-card": "style__tab-active-card___1ff3a",
          "tab-card-item": "style__tab-card-item___3wlch",
        },
      };
      function _e(e, t, n) {
        return (
          (t = Object(p.a)(t)),
          Object(d.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(p.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var ue = (function (e) {
          return (e.top = "top"), (e.center = "center"), e;
        })({}),
        de = (function (e) {
          return (
            (e.left = "left"), (e.center = "center"), (e.right = "right"), e
          );
        })({}),
        pe = (function (e) {
          return (
            (e.none = "none"),
            (e.icon = "icon"),
            (e.headline = "headline"),
            (e.all = "all"),
            e
          );
        })({}),
        fe = (function (e) {
          return (
            (e.carousel = "carousel"), (e["manual-switch"] = "manual-switch"), e
          );
        })({}),
        he = (function (e) {
          return (
            (e["fade-in"] = "fade-in"),
            (e["fade-up"] = "fade-up"),
            (e["zoom-in-up"] = "zoom-in-up"),
            (e.none = "none"),
            e
          );
        })({}),
        me = (function (e) {
          return (
            (e["auto-fit"] = "auto-fit"), (e["custom-css"] = "custom-css"), e
          );
        })({}),
        ye = (function (e) {
          return (
            (e.repeat = "repeat"),
            (e["repeat-x"] = "repeat-x"),
            (e["repeat-y"] = "repeat-y"),
            (e["no-repeat"] = "no-repeat"),
            e
          );
        })({}),
        be = (function (e) {
          return (e.fix = "fix"), (e.normal = "normal"), e;
        })({}),
        ve = (function (e) {
          return (
            (e["left-align"] = "left-align"),
            (e["center-align"] = "center-align"),
            (e["right-align"] = "right-align"),
            e
          );
        })({}),
        ge = (function (e) {
          function t(e) {
            var n;
            return (
              Object(_.default)(this, t),
              (n = _e(this, t, [e])),
              Object(o.a)(Object(f.a)(n), "activeCard", void 0),
              Object(o.a)(Object(f.a)(n), "content", void 0),
              (n.state = { isIE: !1, hovering: !1, contentHeight: 0 }),
              (n.content = []),
              n
            );
          }
          return (
            Object(h.a)(t, e),
            Object(u.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e =
                    window &&
                    !!window.MSInputMethodContext &&
                    !!document.documentMode;
                  this.setState({ isIE: e });
                },
              },
              {
                key: "setContentHeight",
                value: function (e) {
                  e > this.state.contentHeight &&
                    this.setState({ contentHeight: e });
                },
              },
              {
                key: "getHotZoneLink",
                value: function (e) {
                  var t;
                  if (
                    (e.hasBackgroundImage && e.backgroundImage) ||
                    (e.hasBackgroundVideo &&
                      (e.backgroundVideoWebm || e.backgroundVideo))
                  ) {
                    var n = e.cardConfigList;
                    n &&
                      1 === n.length &&
                      (n[0].hasBackgroundImage ||
                        n[0].hasBackgroundVideo ||
                        (t = Object(re.a)(n[0])));
                  }
                  return t;
                },
              },
              {
                key: "render",
                value: function () {
                  var e,
                    t = this,
                    n = ae.TabPanel,
                    o = this.props,
                    a = this.state,
                    r = a.hovering,
                    i = a.isIE,
                    l = o.fadeTransiation,
                    s = o.visibleByDefault,
                    _ = (o.id, { backgroundColor: o.pureBackgroundColor });
                  o.hasBackgroundImage
                    ? ((e = "url('".concat(o.backgroundImage, "')")),
                      (_.backgroundPosition = o.backgroundPosition),
                      (_.backgroundSize =
                        o.backgroundSize === me["auto-fit"]
                          ? "cover"
                          : o.backgroundSizeCustom),
                      (_.backgroundRepeat = o.backgroundRepeat),
                      (_.backgroundAttachment =
                        o.backgroundFixed !== be.fix || i ? "scroll" : "fixed"),
                      o.backgroundGradient &&
                        (e = "url('"
                          .concat(o.backgroundImage, "'), ")
                          .concat(o.backgroundGradient)))
                    : o.backgroundGradient && (e = o.backgroundGradient);
                  var u = {
                      minHeight: o.componentMinHeight,
                      paddingTop: o.paddingTop,
                      paddingBottom: o.paddingBottom,
                      paddingLeft: o.paddingLeft,
                      paddingRight: o.paddingRight,
                      width: o.gridWidth,
                    },
                    d = k()("tab-horizontal-wrapper"),
                    p = k()(
                      "atom-horiozntal-tab-component",
                      "vertical-".concat(o.componentHorizontalAlign),
                    ),
                    f = {};
                  f[s ? "poster" : "data-layzr-poster"] =
                    o.backgroundVideoPoster;
                  var h = (o.cardConfigList || []).map(function (e) {
                      return {
                        tabBarIcon: e.tabBarIcon,
                        tabBarHoverIcon: e.tabBarHoverIcon,
                        tabBarTitle: e.tabBarTitle,
                        tabDesc: e.tabDesc,
                        tabKey: e.tabKey,
                        tabDescFont: e.tabDescFont,
                      };
                    }),
                    m = h.length,
                    b = isNaN(+o.tabDefaultActiveIndex)
                      ? 0
                      : parseInt(String(+o.tabDefaultActiveIndex)),
                    v = b <= m && b >= 1 ? b - 1 : 0;
                  null === h ||
                    void 0 === h ||
                    h.forEach(function (e, t) {
                      e.tabKey = e.tabKey || "tab".concat(t);
                    });
                  var x = this.getHotZoneLink(o);
                  return ie(
                    w.a,
                    {
                      type: "bg",
                      visibleByDefault: s,
                      src: e,
                      style: _,
                      className:
                        "atom-design-v1 " +
                        y()(p, ce, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                    },
                    o.hasBackgroundVideo
                      ? ie(
                          "div",
                          {
                            className:
                              "background-video-wrapper style__background-video___s6HOR",
                          },
                          ie(
                            g.a,
                            {
                              visiblePlay: o.backgroundVideoVisiblePlay,
                              replayWhenRevisible: o.backgroundVideoVisiblePlay,
                              triggerPlay: o.backgroundVideoHoverPlay && r,
                              triggerPause: o.backgroundVideoHoverPlay && !r,
                              style: {
                                postion: "relative",
                                width: "100%",
                                height: "100%",
                              },
                            },
                            ie(
                              "video",
                              Object(c.a)({ muted: !0 }, f, {
                                loop: o.backgroundVideoLoop,
                                autoPlay:
                                  !o.backgroundVideoVisiblePlay &&
                                  !o.backgroundVideoHoverPlay,
                              }),
                              o.backgroundVideoWebm &&
                                ie("source", {
                                  type: "video/webm",
                                  "data-layzr-src": o.backgroundVideoWebm,
                                }),
                              ie("source", {
                                type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                                src: o.backgroundVideo,
                              }),
                            ),
                          ),
                        )
                      : null,
                    ie(
                      "div",
                      {
                        style: u,
                        "data-aos": l,
                        "data-aos-once": !0,
                        className: y()(d, ce, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      ie(
                        ae,
                        {
                          id: o.id,
                          tabAlign: o.tabAlign,
                          tabTheme: o.tabTheme,
                          tabPosition: o.tabPosition,
                          spacingFromTheCard: o.spacingFromTheCard,
                          tabBarIconHeight: o.tabBarIconHeight,
                          tabBarContent: o.tabBarContent,
                          intervalBisection: o.intervalBisection,
                          tabOverallWidth: o.tabOverallWidth,
                          defaultActiveKey: h[v].tabKey,
                          tabContent: h,
                          cardConfigList: o.cardConfigList,
                          tabPresentation: o.tabPresentation,
                          tabCarouselInterval: o.tabCarouselInterval,
                          fadeTransiation: o.fadeTransiation,
                          mediaTransiation: o.mediaTransiation,
                          cardGapWidth: o.cardGapWidth,
                          gridWidth: o.gridWidth,
                          hotLink: x,
                          hasMediaScreen: o.hasMediaScreen,
                          mediaPoint: o.mediaPoint,
                        },
                        h.map(function (e, a) {
                          var r,
                            i =
                              t.content &&
                              t.content[a] &&
                              t.content[a].offsetHeight;
                          return ie(
                            n,
                            {
                              defaultActiveKey: h[v].tabKey,
                              height: i,
                              tab:
                                "none" !== o.tabBarContent
                                  ? e.tabBarTitle
                                  : null,
                              tabBarIcon:
                                "none" !== o.tabBarContent
                                  ? e.tabBarIcon
                                  : null,
                              tabBarHoverIcon:
                                "none" !== o.tabBarContent
                                  ? e.tabBarHoverIcon
                                  : null,
                              key: e.tabKey,
                            },
                            "none" !== o.tabBarContent
                              ? ie("div", {
                                  className: "style__tab-content___3rb2F",
                                  ref: function (e) {
                                    t.content[a] = e;
                                  },
                                  style: se(
                                    {},
                                    null === (r = o.tabDescFont) || void 0 === r
                                      ? void 0
                                      : r.style,
                                  ),
                                  dangerouslySetInnerHTML: {
                                    __html: o.tabDesc ? e.tabDesc : null,
                                  },
                                })
                              : null,
                          );
                        }),
                      ),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(v.a.Component);
      function we(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      Object(o.a)(ge, "defaultProps", {
        cardGapWidth: "16px",
        componentMinHeight: "",
        pureBackgroundColor: "",
        backgroundGradient: "",
        gridWidth: "1200px",
        hasBackgroundImage: !1,
        backgroundImage: "",
        backgroundPosition: "",
        backgroundSize: me["auto-fit"],
        backgroundSizeCustom: "",
        backgroundRepeat: ye["no-repeat"],
        backgroundFixed: be.normal,
        hasBackgroundVideo: !1,
        backgroundVideoLoop: !0,
        backgroundVideoVisiblePlay: !0,
        backgroundVideoHoverPlay: !1,
        backgroundVideo: "",
        backgroundVideoWebm: "",
        backgroundVideoPoster: "",
        componentHorizontalAlign: ve["center-align"],
        paddingTop: "128px",
        paddingBottom: "128px",
        paddingLeft: "",
        paddingRight: "",
        fadeTransiation: he.none,
        mediaTransiation: he.none,
        cardConfigList: [
          se(se({}, G.a.defaultProps), {
            tabBarIcon: "",
            tabBarHoverIcon: "",
            tabBarTitle: "tab name1",
            tabDesc: "tab desc1",
            tabKey: "tab1",
          }),
          se(se({}, G.a.defaultProps), {
            tabBarIcon: "",
            tabBarHoverIcon: "",
            tabBarTitle: "tab name2",
            tabDesc: "tab desc2",
            tabKey: "tab2",
          }),
          se(se({}, G.a.defaultProps), {
            tabBarIcon: "",
            tabBarHoverIcon: "",
            tabBarTitle: "tab name3",
            tabDesc: "tab desc3",
            tabKey: "tab3",
          }),
        ],
        tabPosition: ue.center,
        tabAlign: de.center,
        intervalBisection: !1,
        tabOverallWidth: "1200px",
        spacingFromTheCard: "32px",
        tabBarContent: pe.headline,
        tabBarIconHeight: "48px",
        tabTheme: "dark",
        tabDesc: !0,
        tabPresentation: fe["manual-switch"],
        tabCarouselInterval: "5000",
        tabDefaultActiveIndex: 1,
      });
      var xe = {
        skinSetting: {
          structure: {
            label: "\u7ed3\u6784\u8bbe\u7f6e",
            props: {
              componentHorizontalAlign: {
                label: "\u5185\u5bb9\u6c34\u5e73\u5bf9\u9f50",
                type: "select",
                items: [
                  { label: "\u5c45\u5de6\u5bf9\u9f50", value: "left-align" },
                  { label: "\u5c45\u4e2d\u5bf9\u9f50", value: "center-align" },
                  { label: "\u5c45\u53f3\u5bf9\u9f50", value: "right-align" },
                ],
              },
              componentMinHeight: {
                label: "\u6574\u5c4f\u6700\u5c0f\u9ad8\u5ea6",
                type: "string",
                content: "size",
              },
              cardGapWidth: {
                label: "\u69fd\u5bbd",
                type: "string",
                content: "size",
              },
              gridWidth: {
                label: "\u6805\u683c\u603b\u5bbd",
                type: "string",
                content: "size",
              },
            },
          },
          backgroundColor: {
            label: "\u80cc\u666f\u989c\u8272\u8bbe\u7f6e",
            props: {
              pureBackgroundColor: {
                label: "\u80cc\u666f\u989c\u8272",
                type: "string",
                content: "color",
              },
              backgroundGradient: {
                label: "\u80cc\u666f\u6e10\u53d8\u989c\u8272",
                type: "string",
                content: "color",
              },
            },
          },
          background: {
            label: "\u80cc\u666f\u56fe\u7247\u8bbe\u7f6e",
            switch: "hasBackgroundImage",
            props: {
              backgroundImage: {
                label: "\u80cc\u666f\u56fe\u7247",
                type: "image",
              },
              backgroundPosition: {
                label: "\u80cc\u666f\u4f4d\u7f6e",
                type: "string",
              },
              backgroundSize: {
                label: "\u80cc\u666f\u5c3a\u5bf8",
                type: "select",
                items: [
                  {
                    label: "\u5168\u5c4f\u81ea\u9002\u5e94",
                    value: "auto-fit",
                  },
                  {
                    label: "\u81ea\u5b9a\u4e49css\u5c5e\u6027",
                    value: "custom-css",
                  },
                ],
              },
              backgroundSizeCustom: {
                type: "string",
                label: "\u80cc\u666f\u81ea\u5b9a\u4e49css\u5c5e\u6027",
                controlBy: "backgroundSize",
                controlValue: "custom-css",
              },
              backgroundRepeat: {
                type: "select",
                label: "\u80cc\u666f\u91cd\u590d\u65b9\u5f0f",
                items: [
                  {
                    label: "\u6c34\u5e73\u5782\u76f4\u91cd\u590d",
                    value: "repeat",
                  },
                  { label: "\u6c34\u5e73\u91cd\u590d", value: "repeat-x" },
                  { label: "\u5782\u76f4\u91cd\u590d", value: "repeat-y" },
                  { label: "\u4e0d\u91cd\u590d", value: "no-repeat" },
                ],
              },
            },
          },
          backgroundVideo: {
            label: "\u80cc\u666f\u89c6\u9891\u8bbe\u7f6e",
            switch: "hasBackgroundVideo",
            props: {
              backgroundVideoLoop: {
                label: "\u5faa\u73af\u64ad\u653e",
                type: "boolean",
              },
              backgroundVideoVisiblePlay: {
                label: "\u9875\u9762\u6eda\u52a8\u540e\u89e6\u53d1\u64ad\u653e",
                type: "boolean",
              },
              backgroundVideo: {
                label: "\u80cc\u666f\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              backgroundVideoWebm: {
                label:
                  "\u80cc\u666f\u89c6\u9891\u94fe\u63a5 (webm \u683c\u5f0f\uff0c\u9009\u586b\uff09",
                type: "string",
                content: "url",
              },
              backgroundVideoPoster: {
                label: "\u80cc\u666f\u89c6\u9891\u5c01\u9762\u56fe",
                type: "image",
              },
            },
          },
          padding: {
            label: "\u5185\u8fb9\u8ddd\u8bbe\u7f6e",
            props: {
              paddingTop: {
                type: "string",
                content: "size",
                label: "\u4e0a\u65b9\u5185\u8fb9\u8ddd",
              },
              paddingBottom: {
                type: "string",
                content: "size",
                label: "\u4e0b\u65b9\u5185\u8fb9\u8ddd",
              },
              paddingLeft: {
                type: "string",
                content: "size",
                label: "\u5de6\u65b9\u5185\u8fb9\u8ddd",
              },
              paddingRight: {
                type: "string",
                content: "size",
                label: "\u53f3\u65b9\u5185\u8fb9\u8ddd",
              },
            },
          },
          effect: {
            label: "\u52a8\u6001\u6548\u679c",
            props: {
              fadeTransiation: {
                label: "\u5165\u573a\u8fc7\u6e21",
                type: "select",
                items: [
                  { label: "fade-in", value: "fade-in" },
                  { label: "fade-up", value: "fade-up" },
                  { label: "zoom-in-up", value: "zoom-in-up" },
                  { label: "\u65e0\u6548\u679c", value: "none" },
                ],
              },
              mediaTransiation: {
                label: "\u56fe\u7247/\u89c6\u9891\u5165\u573a\u8fc7\u6e21",
                type: "select",
                items: [
                  { label: "fade-in", value: "fade-in" },
                  { label: "fade-up", value: "fade-up" },
                  { label: "zoom-in-up", value: "zoom-in-up" },
                  { label: "\u65e0\u6548\u679c", value: "none" },
                ],
              },
            },
          },
          tabStructure: {
            label: "tab\u7ed3\u6784\u8bbe\u7f6e",
            props: {
              tabDefaultActiveIndex: {
                label:
                  '\u521d\u59cb\u9009\u4e2dTab\u5e8f\u53f7 (\u9ed8\u8ba4"1")',
                type: "number",
              },
              tabPosition: {
                label: "tab\u7684\u4f4d\u7f6e",
                type: "select",
                items: [
                  { label: "\u5361\u7247\u4e0a\u65b9", value: "top" },
                  { label: "\u5361\u7247\u4e0b\u65b9", value: "center" },
                ],
              },
              tabAlign: {
                label: "tab \u5bf9\u9f50\u65b9\u5f0f",
                type: "select",
                items: [
                  { label: "\u5411\u5de6\u5bf9\u9f50", value: "left" },
                  { label: "\u5c45\u4e2d\u5bf9\u9f50", value: "center" },
                  { label: "\u5411\u53f3\u8fb9\u5bf9\u9f50", value: "right" },
                ],
              },
              intervalBisection: {
                label: "\u95f4\u8ddd\u5e73\u5206",
                type: "boolean",
                controlBy: "tabBarContent",
                controlValue: ["icon", "headline", "all"],
              },
              tabOverallWidth: {
                label: "tabbar \u603b\u5bbd\u5ea6",
                type: "string",
                content: "size",
                controlBy: "intervalBisection",
                controlValue: !0,
              },
              spacingFromTheCard: {
                label: "tabbar\u548c\u5361\u7247\u7684\u95f4\u8ddd",
                type: "string",
                content: "size",
              },
              tabTheme: {
                type: "select",
                label: "tab \u4e3b\u9898\u8272",
                items: [
                  { label: "dark", value: "dark" },
                  { label: "light", value: "light" },
                ],
              },
              tabDesc: {
                label: "\u662f\u5426\u663e\u793a\u63cf\u8ff0",
                type: "boolean",
                controlBy: "tabBarContent",
                controlValue: ["icon", "headline", "all"],
              },
              tabDescFont: {
                label: "\u63cf\u8ff0\u5b57\u4f53\u914d\u7f6e",
                type: "font",
                controlBy: "tabDesc",
                controlValue: !0,
              },
              tabPresentation: {
                type: "select",
                label: "tab \u5c55\u793a\u65b9\u5f0f",
                items: [
                  { label: "\u81ea\u52a8\u8f6e\u64ad", value: "carousel" },
                  { label: "\u624b\u52a8\u5207\u6362", value: "manual-switch" },
                ],
              },
              tabCarouselInterval: {
                label:
                  "\u8f6e\u64ad\u95f4\u9694\u65f6\u957f(\u4ee5\u6beb\u79d2\u4e3a\u5355\u4f4d)",
                type: "string",
                content: "size",
                controlBy: "tabPresentation",
                controlValue: "carousel",
              },
              tabBarContent: {
                type: "select",
                label: "tabbar\u7684\u5185\u5bb9",
                items: [
                  {
                    label: "\u65e0\uff08\u663e\u793a\u5206\u6bb5\u7ebf\uff09",
                    value: "none",
                  },
                  { label: "\u56fe\u6807", value: "icon" },
                  { label: "\u6587\u6848", value: "headline" },
                  { label: "\u56fe\u6807\u548c\u6587\u6848", value: "all" },
                ],
              },
              tabBarIconHeight: {
                label: "\u56fe\u6807\u9ad8\u5ea6",
                type: "string",
                content: "size",
                controlBy: "tabBarContent",
                controlValue: ["icon", "all"],
              },
            },
          },
        },
        contentSetting: {
          smallScreenSetting: {
            label: "\u5c0f\u5c4f\u914d\u7f6e",
            switch: "hasMediaScreen",
            props: { mediaPoint: s.a },
          },
          cardList: {
            label: "\u5361\u7247",
            group_type: "array_card",
            group_prop_name: "cardConfigList",
            props: {
              tabContent: {
                label: "Tab \u5185\u5bb9\u914d\u7f6e",
                props: {
                  tabBarIcon: { label: "\u56fe\u6807", type: "image" },
                  tabBarHoverIcon: {
                    label: "hover\u56fe\u6807",
                    type: "image",
                  },
                  tabBarTitle: {
                    label: "\u6587\u6848",
                    type: "string",
                    content: "text",
                    key: "button-title",
                  },
                  tabDesc: {
                    label: "\u63cf\u8ff0",
                    type: "string",
                    content: "text",
                    key: "description",
                  },
                  tabKey: {
                    label:
                      "tab key(\u6bcf\u4e2atab\u9879\u90fd\u6709\u4e00\u4e2a\u9ed8\u8ba4key,\u53ea\u9700\u5f55\u5165\u82f1\u6587\u7ffb\u8bd1\u5373\u53ef)",
                    helptext: "\u3010!!!\u5df2\u5e9f\u5f03\u3011",
                    type: "string",
                    content: "text",
                    key: "tab-key",
                  },
                },
              },
              layout: {
                label: "\u7ed3\u6784\u6846\u67b6",
                props: {
                  leftCols: {
                    type: "select",
                    label: "\u5de6\u8fb9\u5185\u5bb9\u6bd4\u4f8b",
                    items: [
                      { value: "0", label: "0" },
                      { value: "1", label: "1" },
                      { value: "2", label: "2" },
                      { value: "3", label: "3" },
                      { value: "4", label: "4" },
                      { value: "5", label: "5" },
                      { value: "6", label: "6" },
                      { value: "7", label: "7" },
                      { value: "8", label: "8" },
                      { value: "9", label: "9" },
                      { value: "10", label: "10" },
                      { value: "11", label: "11" },
                      { value: "12", label: "12" },
                    ],
                  },
                  headlineLevel: {
                    type: "select",
                    label: "headline\u5c42\u7ea7",
                    items: [
                      { value: "h1", label: "h1" },
                      { value: "h2", label: "h2" },
                      { value: "h3", label: "h3" },
                      { value: "h4", label: "h4" },
                    ],
                  },
                  contentSize: {
                    type: "select",
                    label: "\u4fe1\u606f\u5757\u6587\u672c\u5c3a\u5bf8",
                    items: [
                      { value: "xxxl", label: "xxxl(headline=48)" },
                      { value: "xxl", label: "xxl(headline=40)" },
                      { value: "xl", label: "xl(headline=32)" },
                      { value: "l", label: "l(headline=28)" },
                      { value: "m", label: "m(headline=24)" },
                      { value: "s", label: "s(headline=20)" },
                      { value: "xs", label: "xs(headline=16)" },
                    ],
                  },
                  verticalAlign: {
                    type: "select",
                    label: "\u5361\u7247\u5185\u5bb9\u5782\u76f4\u5bf9\u9f50",
                    items: [
                      { value: "top-align", label: "\u5c45\u4e0a\u5bf9\u9f50" },
                      {
                        value: "center-align",
                        label: "\u5c45\u4e2d\u5bf9\u9f50",
                      },
                      {
                        value: "bottom-align",
                        label: "\u5c45\u4e0b\u5bf9\u9f50",
                      },
                    ],
                  },
                  horizontalAlign: {
                    type: "select",
                    label: "\u5361\u7247\u5185\u5bb9\u6c34\u5e73\u5bf9\u9f50",
                    items: [
                      {
                        value: "left-align",
                        label: "\u5c45\u5de6\u5bf9\u9f50",
                      },
                      {
                        value: "center-align",
                        label: "\u5c45\u4e2d\u5bf9\u9f50",
                      },
                      {
                        value: "right-align",
                        label: "\u5c45\u53f3\u5bf9\u9f50",
                      },
                    ],
                  },
                },
              },
              size: {
                label: "\u5c3a\u5bf8\u8bbe\u7f6e",
                props: {
                  minHeight: {
                    type: "string",
                    content: "size",
                    label: "\u5361\u7247\u6700\u5c0f\u9ad8\u5ea6",
                  },
                  marginTop: {
                    type: "string",
                    content: "size",
                    label: "\u5361\u7247\u4e0a\u65b9\u5916\u8fb9\u8ddd",
                  },
                  marginBottom: {
                    type: "string",
                    content: "size",
                    label: "\u5361\u7247\u4e0b\u65b9\u5916\u8fb9\u8ddd",
                  },
                  paddingTop: {
                    type: "string",
                    content: "size",
                    label: "\u5361\u7247\u4e0a\u65b9\u5185\u8fb9\u8ddd",
                  },
                  paddingBottom: {
                    type: "string",
                    content: "size",
                    label: "\u5361\u7247\u4e0b\u65b9\u5185\u8fb9\u8ddd",
                  },
                  paddingLeft: {
                    type: "string",
                    content: "size",
                    label: "\u5361\u7247\u5de6\u65b9\u5185\u8fb9\u8ddd",
                  },
                  paddingRight: {
                    type: "string",
                    content: "size",
                    label: "\u5361\u7247\u53f3\u65b9\u5185\u8fb9\u8ddd",
                  },
                },
              },
              style: {
                label: "\u6837\u5f0f",
                props: {
                  borderRadius: {
                    type: "string",
                    label: "\u5361\u7247\u5706\u89d2",
                  },
                  backgroundColor: {
                    type: "string",
                    label: "\u5361\u7247\u80cc\u666f\u989c\u8272",
                    content: "color",
                  },
                  backgroundGradient: {
                    type: "string",
                    label: "\u5361\u7247\u80cc\u666f\u6e10\u53d8\u989c\u8272",
                    content: "color",
                  },
                  textColor: {
                    type: "select",
                    label: "\u5361\u7247\u5168\u5c40\u6587\u6848\u989c\u8272",
                    items: [
                      { value: "black", label: "\u9ed1\u5b57" },
                      { value: "white", label: "\u767d\u5b57" },
                    ],
                  },
                  linkColor: {
                    type: "select",
                    label: "\u5361\u7247\u94fe\u63a5\u989c\u8272",
                    items: [
                      { value: "black", label: "black-main" },
                      { value: "white", label: "white-main" },
                      { value: "dark", label: "primary-on-dark(blue-4)" },
                      { value: "normal", label: "primary-on-light(blue-6)" },
                    ],
                  },
                },
              },
              jump: {
                switch: "hasJumpLink",
                label: "\u8df3\u8f6c\u94fe\u63a5",
                props: {
                  jumpType: {
                    type: "select",
                    label: "\u94fe\u63a5\u7c7b\u578b",
                    items: [
                      { value: "internal", label: "\u7ad9\u5185\u94fe\u63a5" },
                      { value: "external", label: "\u7ad9\u5916\u94fe\u63a5" },
                    ],
                  },
                  jumpLink: {
                    label: "\u94fe\u63a5\u5730\u5740",
                    type: "string",
                    content: "url",
                  },
                },
              },
              backgroundImage: {
                label: "\u80cc\u666f\u56fe\u7247\u8bbe\u7f6e",
                switch: "hasBackgroundImage",
                props: {
                  backgroundImage: {
                    type: "image",
                    label: "\u80cc\u666f\u56fe\u7247",
                  },
                  backgroundPosition: {
                    type: "string",
                    label: "\u80cc\u666f\u4f4d\u7f6e",
                  },
                  backgroundSize: {
                    type: "select",
                    label: "\u80cc\u666f\u5c3a\u5bf8",
                    items: [
                      {
                        value: "auto-fit",
                        label: "\u5168\u5c4f\u81ea\u9002\u5e94",
                      },
                      {
                        value: "custom-css",
                        label: "\u81ea\u5b9a\u4e49css\u5c5e\u6027",
                      },
                    ],
                  },
                  backgroundSizeCustom: {
                    type: "string",
                    label:
                      "\u80cc\u666f\u5c3a\u5bf8\u81ea\u5b9a\u4e49\u5c5e\u6027\u503c",
                    controlBy: "backgroundSize",
                    controlValue: "custom-css",
                  },
                  backgroundRepeat: {
                    type: "select",
                    label: "\u80cc\u666f\u91cd\u590d",
                    items: [
                      {
                        value: "repeat",
                        label: "\u6c34\u5e73\u5782\u76f4\u91cd\u590d",
                      },
                      { value: "repeat-x", label: "\u6c34\u5e73\u91cd\u590d" },
                      { value: "repeat-y", label: "\u5782\u76f4\u91cd\u590d" },
                      { value: "no-repeat", label: "\u4e0d\u91cd\u590d" },
                    ],
                  },
                },
              },
              backgroundVideo: {
                label: "\u80cc\u666f\u89c6\u9891\u8bbe\u7f6e",
                switch: "hasBackgroundVideo",
                props: {
                  backgroundVideo: {
                    type: "string",
                    label: "\u80cc\u666f\u89c6\u9891\u5730\u5740",
                    content: "url",
                  },
                  backgroundVideoWebm: {
                    type: "string",
                    label:
                      "\u80cc\u666f\u89c6\u9891\u5730\u5740 (webm \u683c\u5f0f\uff0c\u9009\u586b\uff09",
                    content: "url",
                  },
                  backgroundVideoLoop: {
                    type: "boolean",
                    label: "\u5faa\u73af\u64ad\u653e",
                  },
                  backgroundVideoVisiblePlay: {
                    type: "boolean",
                    label: "\u9875\u9762\u6eda\u52a8\u89e6\u53d1\u64ad\u653e",
                  },
                  backgroundVideoPoster: {
                    type: "image",
                    label: "\u89c6\u9891\u5c01\u9762\u56fe",
                  },
                  backgroundVideoHoverPlay: {
                    type: "boolean",
                    label: "\u9f20\u6807hover\u64ad\u653e",
                  },
                },
              },
              foreground: {
                label: "\u524d\u666f\u8bbe\u7f6e",
                switch: "hasMedia",
                props: {
                  media: {
                    label: "\u524d\u666f\u5185\u5bb9\u9009\u62e9",
                    type: "select",
                    items: [
                      { value: "picture", label: "\u56fe\u7247" },
                      { value: "video", label: "\u89c6\u9891" },
                    ],
                  },
                  mediaBorderRadius: {
                    label: "\u524d\u666f\u56fe\u7247/\u89c6\u9891\u5706\u89d2",
                    type: "string",
                    content: "size",
                  },
                  mediaDistance: {
                    label: "\u8ddd\u79bb\u6587\u672c\u8fb9\u8ddd",
                    type: "string",
                    content: "size",
                  },
                  cardLayout: {
                    type: "select",
                    label: "\u524d\u666f\u5185\u5bb9\u4f4d\u7f6e",
                    items: [
                      {
                        value: "media-text",
                        label: "\u5de6\u56fe\u53f3\u6587",
                      },
                      {
                        value: "text-media",
                        label: "\u5de6\u6587\u53f3\u56fe",
                      },
                    ],
                  },
                  foregroundImage: {
                    type: "image",
                    label: "\u524d\u666f\u56fe\u7247",
                    controlBy: "media",
                    controlValue: "picture",
                  },
                  foregroundImageAlt: {
                    type: "string",
                    content: "text",
                    key: "picture-alt",
                    label: "\u524d\u666f\u56fe\u7247 Alt",
                  },
                  foregroundVideo: {
                    type: "string",
                    label: "\u524d\u666f\u89c6\u9891",
                    content: "url",
                    controlBy: "media",
                    controlValue: "video",
                  },
                  foregroundVideoWebm: {
                    type: "string",
                    label:
                      "\u524d\u666f\u89c6\u9891\uff08webm \u683c\u5f0f\uff0c\u9009\u586b\uff09",
                    content: "url",
                    controlBy: "media",
                    controlValue: "video",
                  },
                  foregroundVideoPoster: {
                    type: "image",
                    label: "\u524d\u666f\u89c6\u9891\u5c01\u9762",
                    controlBy: "media",
                    controlValue: "video",
                  },
                  foregroundVideoPlayType: {
                    type: "select",
                    label: "\u524d\u666f\u89c6\u9891\u64ad\u653e\u65b9\u5f0f",
                    controlBy: "media",
                    controlValue: "video",
                    items: [
                      { value: "loop", label: "\u5faa\u73af\u64ad\u653e" },
                      { value: "once", label: "\u64ad\u653e\u4e00\u6b21" },
                      {
                        value: "replayWhenRevisible",
                        label:
                          "\u64ad\u653e\u4e00\u6b21\u505c\u6b62\uff0c\u56de\u5230\u8be5\u5c4f\u81ea\u52a8\u64ad\u653e",
                      },
                      {
                        value: "withController",
                        label:
                          "\u53ef\u63a7\u5236\u505c\u6b62/\u64ad\u653e/\u91cd\u64ad",
                      },
                    ],
                  },
                  foregroundLayout: {
                    label: "\u524d\u666f\u5185\u5bb9\u5e03\u5c40",
                    type: "select",
                    items: [
                      {
                        value: "one",
                        label:
                          "\u5355\u56fe\u5e03\u5c40(\u65e0\u9700\u586b\u524d\u666f\u6570\u7ec4)",
                      },
                      { value: "leftRight", label: "\u5de6\u53f3\u5e03\u5c40" },
                      { value: "upDown", label: "\u4e0a\u4e0b\u5e03\u5c40" },
                      { value: "up1down2", label: "\u4e0a\u4e00\u4e0b\u4e8c" },
                      { value: "up2down1", label: "\u4e0a\u4e8c\u4e0b1" },
                      {
                        value: "left2right1",
                        label: "\u5de6\u4e8c\u53f3\u4e00",
                      },
                    ],
                  },
                  foregroundListGap: {
                    label:
                      "\u524d\u666f\u6570\u7ec4\u95f4\u8ddd(\u4ec5\u5728\u975e\u5355\u56fe\u6a21\u5f0f\u4e0b\u751f\u6548)",
                    type: "string",
                  },
                  foregroundList: {
                    type: "array",
                    label: "\u524d\u666f\u6570\u7ec4",
                    props: (function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                          ? we(Object(n), !0).forEach(function (t) {
                              Object(o.a)(e, t, n[t]);
                            })
                          : Object.getOwnPropertyDescriptors
                            ? Object.defineProperties(
                                e,
                                Object.getOwnPropertyDescriptors(n),
                              )
                            : we(Object(n)).forEach(function (t) {
                                Object.defineProperty(
                                  e,
                                  t,
                                  Object.getOwnPropertyDescriptor(n, t),
                                );
                              });
                      }
                      return e;
                    })(
                      {
                        media: {
                          label: "\u524d\u666f\u5185\u5bb9\u9009\u62e9",
                          type: "select",
                          items: [
                            { value: "", label: "\u8bf7\u9009\u62e9" },
                            { value: "picture", label: "\u56fe\u7247" },
                            { value: "video", label: "\u89c6\u9891" },
                          ],
                        },
                        mediaBorderRadius: {
                          label:
                            "\u524d\u666f\u56fe\u7247/\u89c6\u9891\u5706\u89d2",
                          type: "string",
                          content: "size",
                        },
                        foregroundImage: {
                          type: "image",
                          label:
                            "--------------------------------\u524d\u666f\u56fe\u7247--------------------------------",
                        },
                        foregroundImageAlt: {
                          label: "\u524d\u666f\u56fe\u7247 Alt",
                          type: "string",
                          key: "picture-alt",
                          content: "text",
                        },
                        foregroundSticker: {
                          label:
                            "\u5de6\u4e0b\u89d2\u524d\u666f\u8d34\u56fe(\u5f53\u524d\u53ea\u5728\u5f00\u542f\u653e\u5927\u529f\u80fd\u624d\u652f\u6301)",
                          type: "image",
                        },
                        foregroundVideo: {
                          type: "string",
                          label:
                            "--------------------------------\u524d\u666f\u89c6\u9891--------------------------------",
                          content: "url",
                        },
                        foregroundVideoWebm: {
                          type: "string",
                          label:
                            "\u524d\u666f\u89c6\u9891(webm \u683c\u5f0f\uff0c\u9009\u586b\uff09",
                          content: "url",
                        },
                        foregroundVideoPoster: {
                          type: "image",
                          label: "\u524d\u666f\u89c6\u9891\u5c01\u9762",
                        },
                        foregroundVideoPlayType: {
                          type: "select",
                          label:
                            "\u524d\u666f\u89c6\u9891\u64ad\u653e\u65b9\u5f0f",
                          items: [
                            { value: "", label: "\u8bf7\u9009\u62e9" },
                            {
                              value: "loop",
                              label: "\u5faa\u73af\u64ad\u653e",
                            },
                            {
                              value: "once",
                              label: "\u64ad\u653e\u4e00\u6b21",
                            },
                            {
                              value: "replayWhenRevisible",
                              label:
                                "\u64ad\u653e\u4e00\u6b21\u505c\u6b62\uff0c\u56de\u5230\u8be5\u5c4f\u81ea\u52a8\u64ad\u653e",
                            },
                            {
                              value: "withController",
                              label:
                                "\u53ef\u63a7\u5236\u505c\u6b62/\u64ad\u653e/\u91cd\u64ad",
                            },
                          ],
                        },
                      },
                      l.b.props,
                    ),
                  },
                },
              },
              content: {
                label: "\u6587\u672c\u5185\u5bb9\u8fb9\u8ddd",
                props: {
                  contentPaddingTop: {
                    type: "string",
                    content: "size",
                    label: "\u6587\u672c\u4e0a\u65b9\u5185\u8fb9\u8ddd",
                  },
                  contentPaddingBottom: {
                    type: "string",
                    content: "size",
                    label: "\u6587\u672c\u4e0b\u65b9\u5185\u8fb9\u8ddd",
                  },
                  contentPaddingLeft: {
                    type: "string",
                    content: "size",
                    label: "\u6587\u672c\u5de6\u65b9\u5185\u8fb9\u8ddd",
                  },
                  contentPaddingRight: {
                    type: "string",
                    content: "size",
                    label: "\u6587\u672c\u53f3\u65b9\u5185\u8fb9\u8ddd",
                  },
                },
              },
              toppingImage: {
                switch: "hasToppingImage",
                label: "\u9876\u90e8\u56fe\u8bbe\u7f6e",
                props: {
                  toppingImage: { type: "image", label: "\u9876\u90e8\u56fe" },
                  toppingImageHeight: {
                    type: "string",
                    label: "\u9876\u90e8\u56fe\u9ad8\u5ea6",
                  },
                },
              },
              eyeBrow: {
                switch: "hasEyeBrow",
                label: "\u7709\u5934\u8bbe\u7f6e",
                props: {
                  eyeBrowType: {
                    type: "select",
                    label: "\u7709\u5934\u7c7b\u578b",
                    items: [
                      { value: "svg", label: "svg" },
                      { value: "pure-text", label: "\u7eaf\u8272\u6587\u6848" },
                      {
                        value: "gradient-text",
                        label: "\u6e10\u53d8\u8272\u6587\u6848",
                      },
                    ],
                  },
                  eyeBrowSVG: {
                    type: "image",
                    label: "\u7709\u5934SVG",
                    controlBy: "eyeBrowType",
                    controlValue: "svg",
                  },
                  eyeBrowSVGHeight: {
                    type: "string",
                    label: "\u7709\u5934SVG\u56fe\u7247\u9ad8\u5ea6",
                    controlBy: "eyeBrowType",
                    controlValue: "svg",
                  },
                  eyeBrowText: {
                    type: "string",
                    content: "text",
                    key: "eyebrow",
                    label: "\u7709\u5934\u6587\u6848",
                    controlBy: "eyeBrowType",
                    controlValue: ["pure-text", "gradient-text"],
                  },
                  eyeBrowPureColor: {
                    type: "string",
                    content: "color",
                    label: "\u7709\u5934\u6587\u5b57\u7eaf\u8272\u989c\u8272",
                    controlBy: "eyeBrowType",
                    controlValue: "pure-text",
                  },
                  eyeBrowGradientColor: {
                    type: "string",
                    content: "color",
                    label:
                      "\u7709\u5934\u6587\u5b57\u6e10\u53d8\u8272\u989c\u8272",
                    controlBy: "eyeBrowType",
                    controlValue: "gradient-text",
                  },
                  eyeBrowFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    controlBy: "eyeBrowType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                    ],
                  },
                  eyeBrowFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    controlBy: "eyeBrowType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  eyeBrowLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "eyeBrowFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              headline: {
                switch: "hasHeadline",
                label: "\u4e3b\u6807\u9898\u8bbe\u7f6e",
                props: {
                  headlineType: {
                    type: "select",
                    label: "\u4e3b\u6807\u9898\u7c7b\u578b",
                    items: [
                      { value: "svg", label: "svg" },
                      { value: "pure-text", label: "\u7eaf\u8272\u6587\u6848" },
                      {
                        value: "gradient-text",
                        label: "\u6e10\u53d8\u8272\u6587\u6848",
                      },
                    ],
                  },
                  headlineSVG: {
                    type: "image",
                    label: "\u4e3b\u6807\u9898SVG",
                    controlBy: "headlineType",
                    controlValue: "svg",
                  },
                  headlineSVGHeight: {
                    type: "string",
                    label: "\u4e3b\u6807\u9898SVG\u56fe\u7247\u9ad8\u5ea6",
                    controlBy: "headlineType",
                    controlValue: "svg",
                  },
                  headlineText: {
                    type: "string",
                    content: "text",
                    key: "headline",
                    label: "\u4e3b\u6807\u9898\u6587\u6848",
                    controlBy: "headlineType",
                    controlValue: ["pure-text", "gradient-text"],
                  },
                  headlinePureColor: {
                    type: "string",
                    content: "color",
                    label:
                      "\u4e3b\u6807\u9898\u6587\u5b57\u7eaf\u8272\u989c\u8272",
                    controlBy: "headlineType",
                    controlValue: "pure-text",
                  },
                  headlineGradientColor: {
                    type: "string",
                    content: "color",
                    label:
                      "\u4e3b\u6807\u9898\u6587\u5b57\u6e10\u53d8\u8272\u989c\u8272",
                    controlBy: "headlineType",
                    controlValue: "gradient-text",
                  },
                  headlineFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    controlBy: "headlineType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                    ],
                  },
                  headlineFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    controlBy: "headlineType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  headlineLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "headlineFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              subhead: {
                switch: "hasSubHeadline",
                label: "\u526f\u6807\u9898\u8bbe\u7f6e",
                props: {
                  subHeadlineColor: {
                    type: "string",
                    content: "color",
                    label: "\u526f\u6807\u9898\u6587\u5b57\u989c\u8272",
                  },
                  subHeadlineText: {
                    type: "string",
                    content: "text",
                    key: "subtitle",
                    label: "\u526f\u6807\u9898\u6587\u6848",
                  },
                  subHeadlineFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                    ],
                  },
                  subHeadlineFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  subHeadlineLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "subHeadlineFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              divider: {
                switch: "hasDividedLine",
                label: "\u5206\u5272\u7ebf\u8bbe\u7f6e",
                props: {
                  dividedBlockHeight: {
                    type: "string",
                    label: "\u6a21\u5757\u9ad8\u5ea6",
                  },
                  dividedLineWidth: {
                    type: "string",
                    label: "\u7ebf\u6761\u5bbd\u5ea6",
                  },
                  dividedLineHeight: { type: "string", label: "\u9ad8\u5ea6" },
                  dividedLineRadius: { type: "string", label: "\u5706\u89d2" },
                  dividedLineColor: {
                    type: "string",
                    content: "color",
                    label: "\u989c\u8272",
                  },
                  dividedLineGradientColor: {
                    type: "string",
                    content: "color",
                    label: "\u6e10\u53d8\u8272",
                  },
                },
              },
              description: {
                switch: "hasDescription",
                label: "\u8be6\u7ec6\u4ecb\u7ecd\u8bbe\u7f6e",
                props: {
                  descriptionColor: {
                    type: "string",
                    content: "color",
                    label: "\u8be6\u7ec6\u4ecb\u7ecd\u6587\u5b57\u989c\u8272",
                  },
                  descriptionText: {
                    type: "string",
                    content: "text",
                    key: "description",
                    label: "\u8be6\u7ec6\u4ecb\u7ecd\u6587\u6848",
                  },
                  descriptionFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                    ],
                  },
                  descriptionFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  descriptionLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "descriptionFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              primaryButton: {
                switch: "hasPrimaryButton",
                label: "\u4e3b\u6309\u94ae\u8bbe\u7f6e",
                props: {
                  primaryButtonType: {
                    type: "select",
                    label: "\u4e3b\u6309\u94ae\u7c7b\u578b",
                    items: [
                      { value: "button", label: "\u6309\u94ae" },
                      {
                        value: "external-button",
                        label: "\u7ad9\u5916\u6309\u94ae",
                      },
                      {
                        value: "video-play",
                        label: "\u89c6\u9891\u64ad\u653e",
                      },
                    ],
                  },
                  primaryButtonColor: {
                    type: "select",
                    label: "\u989c\u8272",
                    items: [
                      { value: "dark", label: "\u9ed1\u8272" },
                      { value: "light", label: "\u767d\u8272" },
                      { value: "primary", label: "\u84dd\u8272" },
                    ],
                  },
                  primaryButtonLink: {
                    type: "string",
                    label: "\u94fe\u63a5",
                    content: "url",
                  },
                  primaryButtonText: {
                    type: "string",
                    label: "\u6587\u6848",
                    content: "text",
                    key: "button-text",
                  },
                  primaryButtonSize: {
                    type: "select",
                    label: "\u4e3b\u6309\u94ae\u5c3a\u5bf8",
                    items: [
                      { value: "xl", label: "xl(48)" },
                      { value: "lg", label: "l(40)" },
                      { value: "md", label: "m(32)" },
                      { value: "sm", label: "s(24)" },
                    ],
                  },
                  primaryButtonMinWidth: {
                    type: "string",
                    label: "\u4e3b\u6309\u94ae\u6700\u5c0f\u5bbd\u5ea6",
                    content: "size",
                  },
                },
              },
              secondaryButton: {
                switch: "hasSecondaryButton",
                label: "\u6b21\u6309\u94ae\u8bbe\u7f6e",
                props: {
                  secondaryButtonType: {
                    type: "select",
                    label: "\u6b21\u6309\u94ae\u7c7b\u578b",
                    items: [
                      { value: "button", label: "\u6309\u94ae" },
                      {
                        value: "external-button",
                        label: "\u7ad9\u5916\u6309\u94ae",
                      },
                      {
                        value: "video-play",
                        label: "\u89c6\u9891\u64ad\u653e",
                      },
                      {
                        value: "internal-link",
                        label: "\u7ad9\u5185\u94fe\u63a5",
                      },
                      {
                        value: "external-link",
                        label: "\u7ad9\u5916\u94fe\u63a5",
                      },
                      {
                        value: "download-link",
                        label: "\u4e0b\u8f7d\u94fe\u63a5",
                      },
                      {
                        value: "no-icon-link",
                        label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                      },
                      {
                        value: "zoom-button",
                        label: "\u56fe\u7247\u5f39\u7a97\u6309\u94ae",
                      },
                    ],
                  },
                  secondaryButtonColor: {
                    type: "select",
                    label: "\u6b21\u6309\u94ae\u989c\u8272",
                    controlBy: "secondaryButtonType",
                    controlValue: [
                      "button",
                      "video-play",
                      "external-button",
                      "zoom-button",
                    ],
                    items: [
                      { value: "secondary-dark", label: "\u9ed1\u8272" },
                      { value: "secondary-light", label: "\u767d\u8272" },
                    ],
                  },
                  secondaryButtonLink: {
                    type: "string",
                    label: "\u6b21\u6309\u94ae\u94fe\u63a5",
                    content: "url",
                  },
                  secondaryButtonText: {
                    type: "string",
                    label: "\u6b21\u6309\u94ae\u6587\u6848",
                    content: "text",
                    key: "second-text",
                  },
                  secondaryButtonSize: {
                    type: "select",
                    label: "\u6b21\u6309\u94ae\u5c3a\u5bf8",
                    items: [
                      { value: "xl", label: "xl(48)" },
                      { value: "lg", label: "l(40)" },
                      { value: "md", label: "m(32)" },
                      { value: "sm", label: "s(24)" },
                    ],
                  },
                  secondaryButtonMinWidth: {
                    type: "string",
                    label: "\u4e3b\u6309\u94ae\u6700\u5c0f\u5bbd\u5ea6",
                    content: "size",
                  },
                  secondaryButtonZoomImageRawWidth: {
                    label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u5bbd\u5ea6",
                    helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "secondaryButtonType",
                    controlValue: "zoom-button",
                  },
                  secondaryButtonZoomImageRawHeight: {
                    label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u9ad8\u5ea6",
                    helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "secondaryButtonType",
                    controlValue: "zoom-button",
                  },
                  secondaryButtonZoomTilesUrl: {
                    label: "\u56fe\u7247\u5408\u96c6\u5730\u5740",
                    helptext: "\u5fc5\u586b",
                    type: "string",
                    content: "url",
                    controlBy: "secondaryButtonType",
                    controlValue: "zoom-button",
                  },
                  secondaryButtonZoomDefaultZoomLevel: {
                    label: "\u9ed8\u8ba4\u653e\u5927\u500d\u6570",
                    helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "secondaryButtonType",
                    controlValue: "zoom-button",
                  },
                  secondaryButtonZoomMinZoomLevel: {
                    label: "\u6700\u5c0f\u653e\u5927\u500d\u6570",
                    helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "secondaryButtonType",
                    controlValue: "zoom-button",
                  },
                  secondaryButtonZoomMaxZoomLevel: {
                    label: "\u6700\u5927\u653e\u5927\u500d\u6570",
                    helptext: "\u9009\u586b\uff0c\u6570\u5b57 <= 6",
                    type: "number",
                    controlBy: "secondaryButtonType",
                    controlValue: "zoom-button",
                  },
                },
              },
              thirdlyButton: {
                switch: "hasThirdlyButton",
                label: "\u6b21\u6309\u94ae2\u8bbe\u7f6e",
                props: {
                  thirdlyButtonType: {
                    type: "select",
                    label: "\u6b21\u6309\u94ae\u7c7b\u578b",
                    items: [
                      { value: "button", label: "\u6309\u94ae" },
                      {
                        value: "external-button",
                        label: "\u7ad9\u5916\u6309\u94ae",
                      },
                      {
                        value: "video-play",
                        label: "\u89c6\u9891\u64ad\u653e",
                      },
                      {
                        value: "internal-link",
                        label: "\u7ad9\u5185\u94fe\u63a5",
                      },
                      {
                        value: "external-link",
                        label: "\u7ad9\u5916\u94fe\u63a5",
                      },
                      {
                        value: "download-link",
                        label: "\u4e0b\u8f7d\u94fe\u63a5",
                      },
                      {
                        value: "no-icon-link",
                        label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                      },
                      {
                        value: "zoom-button",
                        label: "\u56fe\u7247\u5f39\u7a97\u6309\u94ae",
                      },
                    ],
                  },
                  thirdlyButtonColor: {
                    type: "select",
                    label: "\u6b21\u6309\u94ae\u989c\u8272",
                    controlBy: "thirdlyButtonType",
                    controlValue: [
                      "button",
                      "video-play",
                      "external-button",
                      "zoom-button",
                    ],
                    items: [
                      { value: "secondary-dark", label: "\u9ed1\u8272" },
                      { value: "secondary-light", label: "\u767d\u8272" },
                    ],
                  },
                  thirdlyButtonLink: {
                    type: "string",
                    label: "\u6b21\u6309\u94ae\u94fe\u63a5",
                    content: "url",
                  },
                  thirdlyButtonText: {
                    type: "string",
                    label: "\u6b21\u6309\u94ae\u6587\u6848",
                    content: "text",
                    key: "second-text",
                  },
                  thirdlyButtonSize: {
                    type: "select",
                    label: "\u6b21\u6309\u94ae\u5c3a\u5bf8",
                    items: [
                      { value: "xl", label: "xl(48)" },
                      { value: "lg", label: "l(40)" },
                      { value: "md", label: "m(32)" },
                      { value: "sm", label: "s(24)" },
                    ],
                  },
                  thirdlyButtonMinWidth: {
                    type: "string",
                    label: "\u4e3b\u6309\u94ae\u6700\u5c0f\u5bbd\u5ea6",
                    content: "size",
                  },
                  thirdlyButtonZoomImageRawWidth: {
                    label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u5bbd\u5ea6",
                    helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "thirdlyButtonType",
                    controlValue: "zoom-button",
                  },
                  thirdlyButtonZoomImageRawHeight: {
                    label: "\u539f\u59cb\u56fe\u7247\u6700\u5927\u9ad8\u5ea6",
                    helptext: "\u5fc5\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "thirdlyButtonType",
                    controlValue: "zoom-button",
                  },
                  thirdlyButtonZoomTilesUrl: {
                    label: "\u56fe\u7247\u5408\u96c6\u5730\u5740",
                    helptext: "\u5fc5\u586b",
                    type: "string",
                    content: "url",
                    controlBy: "thirdlyButtonType",
                    controlValue: "zoom-button",
                  },
                  thirdlyButtonZoomDefaultZoomLevel: {
                    label: "\u9ed8\u8ba4\u653e\u5927\u500d\u6570",
                    helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "thirdlyButtonType",
                    controlValue: "zoom-button",
                  },
                  thirdlyButtonZoomMinZoomLevel: {
                    label: "\u6700\u5c0f\u653e\u5927\u500d\u6570",
                    helptext: "\u9009\u586b\uff0c\u6570\u5b57",
                    type: "number",
                    controlBy: "thirdlyButtonType",
                    controlValue: "zoom-button",
                  },
                  thirdlyButtonZoomMaxZoomLevel: {
                    label: "\u6700\u5927\u653e\u5927\u500d\u6570",
                    helptext: "\u9009\u586b\uff0c\u6570\u5b57 <= 6",
                    type: "number",
                    controlBy: "thirdlyButtonType",
                    controlValue: "zoom-button",
                  },
                },
              },
              downloadButton: {
                switch: "hasDownloadButton",
                label: "\u4e0b\u8f7d\u6309\u94ae\u8bbe\u7f6e",
                props: {
                  hasAppStoreButton: {
                    type: "boolean",
                    label: "App Store\u4e0b\u8f7d",
                  },
                  appStoreButtonLink: {
                    type: "string",
                    content: "url",
                    label: "App Store\u4e0b\u8f7d\u94fe\u63a5",
                    controlBy: "hasAppStoreButton",
                    controlValue: !0,
                  },
                  hasAndroidButton: {
                    type: "boolean",
                    label: "Android\u4e0b\u8f7d",
                  },
                  androidButtonLink: {
                    type: "string",
                    label: "Android\u4e0b\u8f7d\u94fe\u63a5",
                    content: "url",
                    controlBy: "hasAndroidButton",
                    controlValue: !0,
                  },
                  hasGooglePlayButton: {
                    type: "boolean",
                    label: "Google Play\u4e0b\u8f7d",
                  },
                  googlePlayButtonLink: {
                    type: "string",
                    label: "Google Play\u4e0b\u8f7d\u94fe\u63a5",
                    content: "url",
                    controlBy: "hasGooglePlayButton",
                    controlValue: !0,
                  },
                },
              },
              note: {
                switch: "hasNote",
                label: "\u5907\u6ce8\u8bbe\u7f6e",
                props: {
                  noteText: {
                    type: "string",
                    label: "\u5907\u6ce8\u6587\u6848",
                    content: "text",
                    key: "remark",
                  },
                  noteColor: {
                    type: "string",
                    label: "\u5907\u6ce8\u989c\u8272",
                    content: "color",
                  },
                  noteFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                    ],
                  },
                  noteFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  noteLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "noteFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              links: {
                label: "\u94fe\u63a5",
                switch: "hasCardLinks",
                props: {
                  links: {
                    label: "\u94fe\u63a5",
                    type: "array",
                    props: {
                      linkType: {
                        label: "\u7c7b\u578b",
                        type: "select",
                        items: [
                          {
                            label: "\u7ad9\u5185\u94fe\u63a5",
                            value: "internal-link",
                          },
                          {
                            label: "\u7ad9\u5916\u94fe\u63a5",
                            value: "external-link",
                          },
                          {
                            label: "\u4e0b\u8f7d\u94fe\u63a5",
                            value: "download-link",
                          },
                          {
                            label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                            value: "no-icon-link",
                          },
                        ],
                      },
                      text: {
                        label: "\u94fe\u63a5url",
                        type: "string",
                        content: "url",
                      },
                      linkText: {
                        label: "\u94fe\u63a5\u6587\u6848",
                        type: "string",
                        content: "text",
                        key: "link-text",
                      },
                    },
                  },
                },
              },
              icons1: {
                switch: "hasIcons1",
                label: "\u7b2c\u4e00\u884cicon\u8bbe\u7f6e",
                props: {
                  icons1width: {
                    type: "string",
                    label: "icon\u5bbd\u5ea6",
                    content: "size",
                  },
                  icons1: {
                    label: "icons",
                    type: "array",
                    key: "icons1",
                    props: {
                      title: {
                        switch: "hasTitle",
                        label: "\u6807\u9898",
                        type: "string",
                        key: "text",
                        content: "text",
                      },
                      pic: { switch: "hasPic", label: "icon", type: "image" },
                      desc: {
                        switch: "hasDesc",
                        label: "\u63cf\u8ff0",
                        type: "string",
                        key: "description",
                        content: "text",
                      },
                      number: {
                        switch: "hasNumber",
                        label: "\u6570\u5b57",
                        type: "string",
                        key: "number",
                        content: "text",
                      },
                      unit: {
                        switch: "hasUnit",
                        label: "\u5355\u4f4d",
                        type: "string",
                        key: "unit",
                        content: "text",
                      },
                      titleColor: {
                        label:
                          "\u6807\u9898/\u6570\u5b57/\u5355\u4f4d\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      descColor: {
                        label: "\u63cf\u8ff0\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      titleFontSize: {
                        label: "\u6807\u9898\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                        ],
                      },
                      titleFontWeight: {
                        label: "\u6807\u9898\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      titleLineHeight: {
                        label: "\u6807\u9898\u884c\u9ad8",
                        type: "select",
                        controlBy: "titleFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                      descFontSize: {
                        label: "\u63cf\u8ff0\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                        ],
                      },
                      descFontWeight: {
                        label: "\u63cf\u8ff0\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      descLineHeight: {
                        label: "\u63cf\u8ff0\u884c\u9ad8",
                        type: "select",
                        controlBy: "descFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                    },
                  },
                },
              },
              icons2: {
                switch: "hasIcons2",
                label: "\u7b2c\u4e8c\u884cicon\u8bbe\u7f6e",
                props: {
                  icons2width: {
                    type: "string",
                    label: "icon\u5bbd\u5ea6",
                    content: "size",
                  },
                  icons2: {
                    label: "icons",
                    type: "array",
                    key: "icons2",
                    props: {
                      title: {
                        switch: "hasTitle",
                        label: "\u6807\u9898",
                        type: "string",
                        key: "text",
                        content: "text",
                      },
                      pic: { switch: "hasPic", label: "icon", type: "image" },
                      desc: {
                        switch: "hasDesc",
                        label: "\u63cf\u8ff0",
                        type: "string",
                        key: "description",
                        content: "text",
                      },
                      number: {
                        switch: "hasNumber",
                        label: "\u6570\u5b57",
                        type: "string",
                        key: "number",
                        content: "text",
                      },
                      unit: {
                        switch: "hasUnit",
                        label: "\u5355\u4f4d",
                        type: "string",
                        key: "unit",
                        content: "text",
                      },
                      titleColor: {
                        label:
                          "\u6807\u9898/\u6570\u5b57/\u5355\u4f4d\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      descColor: {
                        label: "\u63cf\u8ff0\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      titleFontSize: {
                        label: "\u6807\u9898\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                        ],
                      },
                      titleFontWeight: {
                        label: "\u6807\u9898\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      titleLineHeight: {
                        label: "\u6807\u9898\u884c\u9ad8",
                        type: "select",
                        controlBy: "titleFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                      descFontSize: {
                        label: "\u63cf\u8ff0\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                        ],
                      },
                      descFontWeight: {
                        label: "\u63cf\u8ff0\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      descLineHeight: {
                        label: "\u63cf\u8ff0\u884c\u9ad8",
                        type: "select",
                        controlBy: "descFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
      t.a = i()(Object(a.a)(ge, xe), ge);
    },
    I01J: function (e, t, n) {
      var o = n("44Ds"),
        a = 500;
      e.exports = function (e) {
        var t = o(e, function (e) {
            return n.size === a && n.clear(), e;
          }),
          n = t.cache;
        return t;
      };
    },
    IP1Z: function (e, t, n) {
      "use strict";
      var o = n("2faE"),
        a = n("rr1i");
      e.exports = function (e, t, n) {
        t in e ? o.f(e, t, a(0, n)) : (e[t] = n);
      };
    },
    IQvP: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return r;
      });
      var o = n("1bLc"),
        a = n("wFID");
      var r = {
        test: Object(a.a)("#"),
        parse: function (e) {
          var t = "",
            n = "",
            o = "",
            a = "";
          return (
            e.length > 5
              ? ((t = e.substr(1, 2)),
                (n = e.substr(3, 2)),
                (o = e.substr(5, 2)),
                (a = e.substr(7, 2)))
              : ((t = e.substr(1, 1)),
                (n = e.substr(2, 1)),
                (o = e.substr(3, 1)),
                (a = e.substr(4, 1)),
                (t += t),
                (n += n),
                (o += o),
                (a += a)),
            {
              red: parseInt(t, 16),
              green: parseInt(n, 16),
              blue: parseInt(o, 16),
              alpha: a ? parseInt(a, 16) / 255 : 1,
            }
          );
        },
        transform: o.a.transform,
      };
    },
    ISdw: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return Te;
      }),
        n.d(t, "b", function () {
          return Ne;
        });
      var o = n("wx14"),
        a = n("Ff2n"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("rePB"),
        d = n("iKuz"),
        p = n.n(d),
        f = n("q1tI"),
        h = n.n(f),
        m = n("17x9"),
        y = n.n(m),
        b = n("TSYQ"),
        v = n.n(b),
        g = n("jo6Y"),
        w = n.n(g),
        x = n("YEIV"),
        k = n.n(x),
        O = n("QbLZ"),
        I = n.n(O),
        S = n("m1cH"),
        j = n.n(S),
        T = n("fhzG"),
        C = n.n(T),
        M = n("aGtg"),
        P = n("9Q1S"),
        E = n.n(P),
        L = n("2W6z"),
        B = n.n(L),
        N = n("mwIZ"),
        D = n.n(N),
        z = n("D1y2"),
        A = n.n(z),
        R = n("ljhN"),
        F = n.n(R),
        V = n("iCc5"),
        H = n.n(V),
        W = n("V7oC"),
        U = n.n(W),
        G = function e(t) {
          H()(this, e), I()(this, t);
        };
      function Y(e) {
        return e instanceof G;
      }
      function q(e) {
        return Y(e) ? e : new G(e);
      }
      var X = n("2mql"),
        Z = n.n(X),
        K = n("TOwV");
      function Q(e) {
        return e;
      }
      function J(e, t, n) {
        var o = {};
        return (
          (function e() {
            var t =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : "",
              n = arguments[1],
              o = arguments[2],
              a = arguments[3],
              r = arguments[4];
            if (o(t, n)) r(t, n);
            else if (void 0 === n || null === n);
            else if (Array.isArray(n))
              n.forEach(function (n, i) {
                return e(t + "[" + i + "]", n, o, a, r);
              });
            else {
              if ("object" !== typeof n) return void B()(!1, a);
              Object.keys(n).forEach(function (i) {
                var l = n[i];
                e(t + (t ? "." : "") + i, l, o, a, r);
              });
            }
          })(void 0, e, t, n, function (e, t) {
            o[e] = t;
          }),
          o
        );
      }
      function $(e, t, n) {
        var o = e.map(function (e) {
          var t = I()({}, e, { trigger: e.trigger || [] });
          return "string" === typeof t.trigger && (t.trigger = [t.trigger]), t;
        });
        return t && o.push({ trigger: n ? [].concat(n) : [], rules: t }), o;
      }
      function ee(e) {
        return e
          .filter(function (e) {
            return !!e.rules && e.rules.length;
          })
          .map(function (e) {
            return e.trigger;
          })
          .reduce(function (e, t) {
            return e.concat(t);
          }, []);
      }
      function te(e) {
        if (!e || !e.target) return e;
        var t = e.target;
        return "checkbox" === t.type ? t.checked : t.value;
      }
      function ne(e, t, n) {
        var o = e,
          a = t,
          r = n;
        return (
          void 0 === n &&
            ("function" === typeof o
              ? ((r = o), (a = {}), (o = void 0))
              : Array.isArray(o)
                ? "function" === typeof a
                  ? ((r = a), (a = {}))
                  : (a = a || {})
                : ((r = a), (a = o || {}), (o = void 0))),
          { names: o, options: a, callback: r }
        );
      }
      function oe(e) {
        return 0 === Object.keys(e).length;
      }
      function ae(e) {
        return (
          !!e &&
          e.some(function (e) {
            return e.rules && e.rules.length;
          })
        );
      }
      function re(e, t) {
        return 0 === t.indexOf(e) && -1 !== [".", "["].indexOf(t[e.length]);
      }
      function ie(e) {
        return J(
          e,
          function (e, t) {
            return Y(t);
          },
          "You must wrap field data with `createFormField`.",
        );
      }
      var le = (function () {
          function e(t) {
            H()(this, e),
              se.call(this),
              (this.fields = ie(t)),
              (this.fieldsMeta = {});
          }
          return (
            U()(e, [
              {
                key: "updateFields",
                value: function (e) {
                  this.fields = ie(e);
                },
              },
              {
                key: "flattenRegisteredFields",
                value: function (e) {
                  var t = this.getAllFieldsName();
                  return J(
                    e,
                    function (e) {
                      return t.indexOf(e) >= 0;
                    },
                    "You cannot set a form field before rendering a field associated with the value.",
                  );
                },
              },
              {
                key: "setFields",
                value: function (e) {
                  var t = this,
                    n = this.fieldsMeta,
                    o = I()({}, this.fields, e),
                    a = {};
                  Object.keys(n).forEach(function (e) {
                    a[e] = t.getValueFromFields(e, o);
                  }),
                    Object.keys(a).forEach(function (e) {
                      var n = a[e],
                        r = t.getFieldMeta(e);
                      if (r && r.normalize) {
                        var i = r.normalize(
                          n,
                          t.getValueFromFields(e, t.fields),
                          a,
                        );
                        i !== n && (o[e] = I()({}, o[e], { value: i }));
                      }
                    }),
                    (this.fields = o);
                },
              },
              {
                key: "resetFields",
                value: function (e) {
                  var t = this.fields;
                  return (
                    e ? this.getValidFieldsFullName(e) : this.getAllFieldsName()
                  ).reduce(function (e, n) {
                    var o = t[n];
                    return o && "value" in o && (e[n] = {}), e;
                  }, {});
                },
              },
              {
                key: "setFieldMeta",
                value: function (e, t) {
                  this.fieldsMeta[e] = t;
                },
              },
              {
                key: "setFieldsAsDirty",
                value: function () {
                  var e = this;
                  Object.keys(this.fields).forEach(function (t) {
                    var n = e.fields[t],
                      o = e.fieldsMeta[t];
                    n &&
                      o &&
                      ae(o.validate) &&
                      (e.fields[t] = I()({}, n, { dirty: !0 }));
                  });
                },
              },
              {
                key: "getFieldMeta",
                value: function (e) {
                  return (
                    (this.fieldsMeta[e] = this.fieldsMeta[e] || {}),
                    this.fieldsMeta[e]
                  );
                },
              },
              {
                key: "getValueFromFields",
                value: function (e, t) {
                  var n = t[e];
                  if (n && "value" in n) return n.value;
                  var o = this.getFieldMeta(e);
                  return o && o.initialValue;
                },
              },
              {
                key: "getValidFieldsName",
                value: function () {
                  var e = this,
                    t = this.fieldsMeta;
                  return t
                    ? Object.keys(t).filter(function (t) {
                        return !e.getFieldMeta(t).hidden;
                      })
                    : [];
                },
              },
              {
                key: "getAllFieldsName",
                value: function () {
                  var e = this.fieldsMeta;
                  return e ? Object.keys(e) : [];
                },
              },
              {
                key: "getValidFieldsFullName",
                value: function (e) {
                  var t = Array.isArray(e) ? e : [e];
                  return this.getValidFieldsName().filter(function (e) {
                    return t.some(function (t) {
                      return (
                        e === t ||
                        ((n = t),
                        0 === e.lastIndexOf(n, 0) &&
                          [".", "["].indexOf(e[t.length]) >= 0)
                      );
                      var n;
                    });
                  });
                },
              },
              {
                key: "getFieldValuePropValue",
                value: function (e) {
                  var t = e.name,
                    n = e.getValueProps,
                    o = e.valuePropName,
                    a = this.getField(t),
                    r = "value" in a ? a.value : e.initialValue;
                  return n ? n(r) : k()({}, o, r);
                },
              },
              {
                key: "getField",
                value: function (e) {
                  return I()({}, this.fields[e], { name: e });
                },
              },
              {
                key: "getNotCollectedFields",
                value: function () {
                  var e = this;
                  return this.getValidFieldsName()
                    .filter(function (t) {
                      return !e.fields[t];
                    })
                    .map(function (t) {
                      return {
                        name: t,
                        dirty: !1,
                        value: e.getFieldMeta(t).initialValue,
                      };
                    })
                    .reduce(function (e, t) {
                      return A()(e, t.name, q(t));
                    }, {});
                },
              },
              {
                key: "getNestedAllFields",
                value: function () {
                  var e = this;
                  return Object.keys(this.fields).reduce(function (t, n) {
                    return A()(t, n, q(e.fields[n]));
                  }, this.getNotCollectedFields());
                },
              },
              {
                key: "getFieldMember",
                value: function (e, t) {
                  return this.getField(e)[t];
                },
              },
              {
                key: "getNestedFields",
                value: function (e, t) {
                  return (e || this.getValidFieldsName()).reduce(function (
                    e,
                    n,
                  ) {
                    return A()(e, n, t(n));
                  }, {});
                },
              },
              {
                key: "getNestedField",
                value: function (e, t) {
                  var n = this.getValidFieldsFullName(e);
                  if (0 === n.length || (1 === n.length && n[0] === e))
                    return t(e);
                  var o = "[" === n[0][e.length],
                    a = o ? e.length : e.length + 1;
                  return n.reduce(
                    function (e, n) {
                      return A()(e, n.slice(a), t(n));
                    },
                    o ? [] : {},
                  );
                },
              },
              {
                key: "isValidNestedFieldName",
                value: function (e) {
                  return this.getAllFieldsName().every(function (t) {
                    return !re(t, e) && !re(e, t);
                  });
                },
              },
              {
                key: "clearField",
                value: function (e) {
                  delete this.fields[e], delete this.fieldsMeta[e];
                },
              },
            ]),
            e
          );
        })(),
        se = function () {
          var e = this;
          (this.setFieldsInitialValue = function (t) {
            var n = e.flattenRegisteredFields(t),
              o = e.fieldsMeta;
            Object.keys(n).forEach(function (t) {
              o[t] &&
                e.setFieldMeta(
                  t,
                  I()({}, e.getFieldMeta(t), { initialValue: n[t] }),
                );
            });
          }),
            (this.getAllValues = function () {
              var t = e.fieldsMeta,
                n = e.fields;
              return Object.keys(t).reduce(function (t, o) {
                return A()(t, o, e.getValueFromFields(o, n));
              }, {});
            }),
            (this.getFieldsValue = function (t) {
              return e.getNestedFields(t, e.getFieldValue);
            }),
            (this.getFieldValue = function (t) {
              var n = e.fields;
              return e.getNestedField(t, function (t) {
                return e.getValueFromFields(t, n);
              });
            }),
            (this.getFieldsError = function (t) {
              return e.getNestedFields(t, e.getFieldError);
            }),
            (this.getFieldError = function (t) {
              return e.getNestedField(t, function (t) {
                return (n = e.getFieldMember(t, "errors"))
                  ? n.map(function (e) {
                      return e && e.message ? e.message : e;
                    })
                  : n;
                var n;
              });
            }),
            (this.isFieldValidating = function (t) {
              return e.getFieldMember(t, "validating");
            }),
            (this.isFieldsValidating = function (t) {
              return (t || e.getValidFieldsName()).some(function (t) {
                return e.isFieldValidating(t);
              });
            }),
            (this.isFieldTouched = function (t) {
              return e.getFieldMember(t, "touched");
            }),
            (this.isFieldsTouched = function (t) {
              return (t || e.getValidFieldsName()).some(function (t) {
                return e.isFieldTouched(t);
              });
            });
        };
      var ce = n("FYw3"),
        _e = n.n(ce),
        ue = n("mRg0"),
        de = n.n(ue),
        pe = (function (e) {
          function t() {
            return (
              H()(this, t),
              _e()(
                this,
                (t.__proto__ || Object.getPrototypeOf(t)).apply(
                  this,
                  arguments,
                ),
              )
            );
          }
          return (
            de()(t, e),
            U()(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this.props,
                    t = e.name,
                    n = e.form;
                  (n.domFields[t] = !0), n.recoverClearedField(t);
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  var e = this.props,
                    t = e.name,
                    n = e.form,
                    o = n.fieldsStore.getFieldMeta(t);
                  o.preserve ||
                    ((n.clearedFieldMetaCache[t] = {
                      field: n.fieldsStore.getField(t),
                      meta: o,
                    }),
                    n.clearField(t)),
                    delete n.domFields[t];
                },
              },
              {
                key: "render",
                value: function () {
                  return this.props.children;
                },
              },
            ]),
            t
          );
        })(h.a.Component),
        fe = pe;
      pe.propTypes = {
        name: y.a.string,
        form: y.a.shape({
          domFields: y.a.objectOf(y.a.bool),
          recoverClearedField: y.a.func,
          fieldsStore: y.a.shape({
            getFieldMeta: y.a.func,
            getField: y.a.func,
          }),
          clearedFieldMetaCache: y.a.objectOf(
            y.a.shape({ field: y.a.object, meta: y.a.object }),
          ),
          clearField: y.a.func,
        }),
        children: y.a.node,
      };
      var he = "onChange";
      var me = function () {
          var e =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {},
            t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : [],
            n = e.validateMessages,
            o = e.onFieldsChange,
            a = e.onValuesChange,
            r = e.mapProps,
            i = void 0 === r ? Q : r,
            l = e.mapPropsToFields,
            s = e.fieldNameProp,
            c = e.fieldMetaProp,
            _ = e.fieldDataProp,
            u = e.formPropName,
            d = void 0 === u ? "form" : u,
            p = e.name,
            f = e.withRef;
          return function (e) {
            var r = C()({
              displayName: "Form",
              mixins: t,
              getInitialState: function () {
                var e = this,
                  t = l && l(this.props);
                return (
                  (this.fieldsStore = (function (e) {
                    return new le(e);
                  })(t || {})),
                  (this.instances = {}),
                  (this.cachedBind = {}),
                  (this.clearedFieldMetaCache = {}),
                  (this.renderFields = {}),
                  (this.domFields = {}),
                  [
                    "getFieldsValue",
                    "getFieldValue",
                    "setFieldsInitialValue",
                    "getFieldsError",
                    "getFieldError",
                    "isFieldValidating",
                    "isFieldsValidating",
                    "isFieldsTouched",
                    "isFieldTouched",
                  ].forEach(function (t) {
                    e[t] = function () {
                      var n;
                      return (n = e.fieldsStore)[t].apply(n, arguments);
                    };
                  }),
                  { submitting: !1 }
                );
              },
              componentDidMount: function () {
                this.cleanUpUselessFields();
              },
              componentWillReceiveProps: function (e) {
                l && this.fieldsStore.updateFields(l(e));
              },
              componentDidUpdate: function () {
                this.cleanUpUselessFields();
              },
              onCollectCommon: function (e, t, n) {
                var o = this.fieldsStore.getFieldMeta(e);
                if (o[t]) o[t].apply(o, j()(n));
                else if (o.originalProps && o.originalProps[t]) {
                  var r;
                  (r = o.originalProps)[t].apply(r, j()(n));
                }
                var i = o.getValueFromEvent
                  ? o.getValueFromEvent.apply(o, j()(n))
                  : te.apply(void 0, j()(n));
                if (a && i !== this.fieldsStore.getFieldValue(e)) {
                  var l = this.fieldsStore.getAllValues(),
                    s = {};
                  (l[e] = i),
                    Object.keys(l).forEach(function (e) {
                      return A()(s, e, l[e]);
                    }),
                    a(
                      I()(k()({}, d, this.getForm()), this.props),
                      A()({}, e, i),
                      s,
                    );
                }
                var c = this.fieldsStore.getField(e);
                return {
                  name: e,
                  field: I()({}, c, { value: i, touched: !0 }),
                  fieldMeta: o,
                };
              },
              onCollect: function (e, t) {
                for (
                  var n = arguments.length, o = Array(n > 2 ? n - 2 : 0), a = 2;
                  a < n;
                  a++
                )
                  o[a - 2] = arguments[a];
                var r = this.onCollectCommon(e, t, o),
                  i = r.name,
                  l = r.field,
                  s = r.fieldMeta,
                  c = s.validate;
                this.fieldsStore.setFieldsAsDirty();
                var _ = I()({}, l, { dirty: ae(c) });
                this.setFields(k()({}, i, _));
              },
              onCollectValidate: function (e, t) {
                for (
                  var n = arguments.length, o = Array(n > 2 ? n - 2 : 0), a = 2;
                  a < n;
                  a++
                )
                  o[a - 2] = arguments[a];
                var r = this.onCollectCommon(e, t, o),
                  i = r.field,
                  l = r.fieldMeta,
                  s = I()({}, i, { dirty: !0 });
                this.fieldsStore.setFieldsAsDirty(),
                  this.validateFieldsInternal([s], {
                    action: t,
                    options: { firstFields: !!l.validateFirst },
                  });
              },
              getCacheBind: function (e, t, n) {
                this.cachedBind[e] || (this.cachedBind[e] = {});
                var o = this.cachedBind[e];
                return (
                  (o[t] && o[t].oriFn === n) ||
                    (o[t] = { fn: n.bind(this, e, t), oriFn: n }),
                  o[t].fn
                );
              },
              getFieldDecorator: function (e, t) {
                var n = this,
                  o = this.getFieldProps(e, t);
                return function (t) {
                  n.renderFields[e] = !0;
                  var a = n.fieldsStore.getFieldMeta(e),
                    r = t.props;
                  (a.originalProps = r), (a.ref = t.ref);
                  var i = h.a.cloneElement(
                    t,
                    I()({}, o, n.fieldsStore.getFieldValuePropValue(a)),
                  );
                  return (function (e) {
                    var t = Object(K.isMemo)(e) ? e.type.type : e.type;
                    return (
                      !!(
                        "function" !== typeof t ||
                        (t.prototype && t.prototype.render)
                      ) &&
                      !!(
                        "function" !== typeof e ||
                        (e.prototype && e.prototype.render)
                      )
                    );
                  })(t)
                    ? i
                    : h.a.createElement(fe, { name: e, form: n }, i);
                };
              },
              getFieldProps: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                if (!e)
                  throw new Error(
                    "Must call `getFieldProps` with valid name string!",
                  );
                delete this.clearedFieldMetaCache[e];
                var o = I()(
                    {
                      name: e,
                      trigger: he,
                      valuePropName: "value",
                      validate: [],
                    },
                    n,
                  ),
                  a = o.rules,
                  r = o.trigger,
                  i = o.validateTrigger,
                  l = void 0 === i ? r : i,
                  u = o.validate,
                  d = this.fieldsStore.getFieldMeta(e);
                "initialValue" in o && (d.initialValue = o.initialValue);
                var f = I()({}, this.fieldsStore.getFieldValuePropValue(o), {
                  ref: this.getCacheBind(e, e + "__ref", this.saveRef),
                });
                s && (f[s] = p ? p + "_" + e : e);
                var h = $(u, a, l),
                  m = ee(h);
                m.forEach(function (n) {
                  f[n] || (f[n] = t.getCacheBind(e, n, t.onCollectValidate));
                }),
                  r &&
                    -1 === m.indexOf(r) &&
                    (f[r] = this.getCacheBind(e, r, this.onCollect));
                var y = I()({}, d, o, { validate: h });
                return (
                  this.fieldsStore.setFieldMeta(e, y),
                  c && (f[c] = y),
                  _ && (f[_] = this.fieldsStore.getField(e)),
                  (this.renderFields[e] = !0),
                  f
                );
              },
              getFieldInstance: function (e) {
                return this.instances[e];
              },
              getRules: function (e, t) {
                var n,
                  o = e.validate
                    .filter(function (e) {
                      return !t || e.trigger.indexOf(t) >= 0;
                    })
                    .map(function (e) {
                      return e.rules;
                    });
                return (n = o), Array.prototype.concat.apply([], n);
              },
              setFields: function (e, t) {
                var n = this,
                  a = this.fieldsStore.flattenRegisteredFields(e);
                if ((this.fieldsStore.setFields(a), o)) {
                  var r = Object.keys(a).reduce(function (e, t) {
                    return A()(e, t, n.fieldsStore.getField(t));
                  }, {});
                  o(
                    I()(k()({}, d, this.getForm()), this.props),
                    r,
                    this.fieldsStore.getNestedAllFields(),
                  );
                }
                this.forceUpdate(t);
              },
              setFieldsValue: function (e, t) {
                var n = this.fieldsStore.fieldsMeta,
                  o = this.fieldsStore.flattenRegisteredFields(e),
                  r = Object.keys(o).reduce(function (e, t) {
                    if (n[t]) {
                      var a = o[t];
                      e[t] = { value: a };
                    }
                    return e;
                  }, {});
                if ((this.setFields(r, t), a)) {
                  var i = this.fieldsStore.getAllValues();
                  a(I()(k()({}, d, this.getForm()), this.props), e, i);
                }
              },
              saveRef: function (e, t, n) {
                if (!n) {
                  var o = this.fieldsStore.getFieldMeta(e);
                  return (
                    o.preserve ||
                      ((this.clearedFieldMetaCache[e] = {
                        field: this.fieldsStore.getField(e),
                        meta: o,
                      }),
                      this.clearField(e)),
                    void delete this.domFields[e]
                  );
                }
                (this.domFields[e] = !0), this.recoverClearedField(e);
                var a = this.fieldsStore.getFieldMeta(e);
                if (a) {
                  var r = a.ref;
                  if (r) {
                    if ("string" === typeof r)
                      throw new Error("can not set ref string for " + e);
                    "function" === typeof r
                      ? r(n)
                      : Object.prototype.hasOwnProperty.call(r, "current") &&
                        (r.current = n);
                  }
                }
                this.instances[e] = n;
              },
              cleanUpUselessFields: function () {
                var e = this,
                  t = this.fieldsStore.getAllFieldsName().filter(function (t) {
                    var n = e.fieldsStore.getFieldMeta(t);
                    return !e.renderFields[t] && !e.domFields[t] && !n.preserve;
                  });
                t.length && t.forEach(this.clearField),
                  (this.renderFields = {});
              },
              clearField: function (e) {
                this.fieldsStore.clearField(e),
                  delete this.instances[e],
                  delete this.cachedBind[e];
              },
              resetFields: function (e) {
                var t = this,
                  n = this.fieldsStore.resetFields(e);
                (Object.keys(n).length > 0 && this.setFields(n), e)
                  ? (Array.isArray(e) ? e : [e]).forEach(function (e) {
                      return delete t.clearedFieldMetaCache[e];
                    })
                  : (this.clearedFieldMetaCache = {});
              },
              recoverClearedField: function (e) {
                this.clearedFieldMetaCache[e] &&
                  (this.fieldsStore.setFields(
                    k()({}, e, this.clearedFieldMetaCache[e].field),
                  ),
                  this.fieldsStore.setFieldMeta(
                    e,
                    this.clearedFieldMetaCache[e].meta,
                  ),
                  delete this.clearedFieldMetaCache[e]);
              },
              validateFieldsInternal: function (e, t, o) {
                var a = this,
                  r = t.fieldNames,
                  i = t.action,
                  l = t.options,
                  s = void 0 === l ? {} : l,
                  c = {},
                  _ = {},
                  u = {},
                  d = {};
                if (
                  (e.forEach(function (e) {
                    var t = e.name;
                    if (!0 === s.force || !1 !== e.dirty) {
                      var n = a.fieldsStore.getFieldMeta(t),
                        o = I()({}, e);
                      (o.errors = void 0),
                        (o.validating = !0),
                        (o.dirty = !0),
                        (c[t] = a.getRules(n, i)),
                        (_[t] = o.value),
                        (u[t] = o);
                    } else e.errors && A()(d, t, { errors: e.errors });
                  }),
                  this.setFields(u),
                  Object.keys(_).forEach(function (e) {
                    _[e] = a.fieldsStore.getFieldValue(e);
                  }),
                  o && oe(u))
                )
                  o(oe(d) ? null : d, this.fieldsStore.getFieldsValue(r));
                else {
                  var p = new E.a(c);
                  n && p.messages(n),
                    p.validate(_, s, function (e) {
                      var t = I()({}, d);
                      e &&
                        e.length &&
                        e.forEach(function (e) {
                          var n = e.field,
                            o = n;
                          Object.keys(c).some(function (e) {
                            var t = c[e] || [];
                            if (e === n) return (o = e), !0;
                            if (
                              t.every(function (e) {
                                return "array" !== e.type;
                              }) ||
                              0 !== n.indexOf(e + ".")
                            )
                              return !1;
                            var a = n.slice(e.length + 1);
                            return !!/^\d+$/.test(a) && ((o = e), !0);
                          });
                          var a = D()(t, o);
                          ("object" !== typeof a || Array.isArray(a)) &&
                            A()(t, o, { errors: [] }),
                            D()(t, o.concat(".errors")).push(e);
                        });
                      var n = [],
                        i = {};
                      Object.keys(c).forEach(function (e) {
                        var o = D()(t, e),
                          r = a.fieldsStore.getField(e);
                        F()(r.value, _[e])
                          ? ((r.errors = o && o.errors),
                            (r.value = _[e]),
                            (r.validating = !1),
                            (r.dirty = !1),
                            (i[e] = r))
                          : n.push({ name: e });
                      }),
                        a.setFields(i),
                        o &&
                          (n.length &&
                            n.forEach(function (e) {
                              var n = e.name,
                                o = [
                                  {
                                    message: n + " need to revalidate",
                                    field: n,
                                  },
                                ];
                              A()(t, n, { expired: !0, errors: o });
                            }),
                          o(oe(t) ? null : t, a.fieldsStore.getFieldsValue(r)));
                    });
                }
              },
              validateFields: function (e, t, n) {
                var o = this,
                  a = new Promise(function (a, r) {
                    var i = ne(e, t, n),
                      l = i.names,
                      s = i.options,
                      c = ne(e, t, n).callback;
                    if (!c || "function" === typeof c) {
                      var _ = c;
                      c = function (e, t) {
                        _ && _(e, t), e ? r({ errors: e, values: t }) : a(t);
                      };
                    }
                    var u = l
                        ? o.fieldsStore.getValidFieldsFullName(l)
                        : o.fieldsStore.getValidFieldsName(),
                      d = u
                        .filter(function (e) {
                          return ae(o.fieldsStore.getFieldMeta(e).validate);
                        })
                        .map(function (e) {
                          var t = o.fieldsStore.getField(e);
                          return (t.value = o.fieldsStore.getFieldValue(e)), t;
                        });
                    d.length
                      ? ("firstFields" in s ||
                          (s.firstFields = u.filter(function (e) {
                            return !!o.fieldsStore.getFieldMeta(e)
                              .validateFirst;
                          })),
                        o.validateFieldsInternal(
                          d,
                          { fieldNames: u, options: s },
                          c,
                        ))
                      : c(null, o.fieldsStore.getFieldsValue(u));
                  });
                return (
                  a.catch(function (e) {
                    return console.error, e;
                  }),
                  a
                );
              },
              isSubmitting: function () {
                return this.state.submitting;
              },
              submit: function (e) {
                var t = this;
                this.setState({ submitting: !0 }),
                  e(function () {
                    t.setState({ submitting: !1 });
                  });
              },
              render: function () {
                var t = this.props,
                  n = t.wrappedComponentRef,
                  o = w()(t, ["wrappedComponentRef"]),
                  a = k()({}, d, this.getForm());
                f ? (a.ref = "wrappedComponent") : n && (a.ref = n);
                var r = i.call(this, I()({}, a, o));
                return h.a.createElement(e, r);
              },
            });
            return (function (e, t) {
              return (
                (e.displayName =
                  "Form(" +
                  (function (e) {
                    return e.displayName || e.name || "WrappedComponent";
                  })(t) +
                  ")"),
                (e.WrappedComponent = t),
                Z()(e, t)
              );
            })(Object(M.a)(r), e);
          };
        },
        ye = {
          getForm: function () {
            return {
              getFieldsValue: this.fieldsStore.getFieldsValue,
              getFieldValue: this.fieldsStore.getFieldValue,
              getFieldInstance: this.getFieldInstance,
              setFieldsValue: this.setFieldsValue,
              setFields: this.setFields,
              setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
              getFieldDecorator: this.getFieldDecorator,
              getFieldProps: this.getFieldProps,
              getFieldsError: this.fieldsStore.getFieldsError,
              getFieldError: this.fieldsStore.getFieldError,
              isFieldValidating: this.fieldsStore.isFieldValidating,
              isFieldsValidating: this.fieldsStore.isFieldsValidating,
              isFieldsTouched: this.fieldsStore.isFieldsTouched,
              isFieldTouched: this.fieldsStore.isFieldTouched,
              isSubmitting: this.isSubmitting,
              submit: this.submit,
              validateFields: this.validateFields,
              resetFields: this.resetFields,
            };
          },
        };
      var be = function (e) {
          return me(e, [ye]);
        },
        ve = y.a.shape({
          getFieldsValue: y.a.func,
          getFieldValue: y.a.func,
          getFieldInstance: y.a.func,
          setFieldsValue: y.a.func,
          setFields: y.a.func,
          setFieldsInitialValue: y.a.func,
          getFieldDecorator: y.a.func,
          getFieldProps: y.a.func,
          getFieldsError: y.a.func,
          getFieldError: y.a.func,
          isFieldValidating: y.a.func,
          isFieldsValidating: y.a.func,
          isFieldsTouched: y.a.func,
          isFieldTouched: y.a.func,
          isSubmitting: y.a.func,
          submit: y.a.func,
          validateFields: y.a.func,
          resetFields: y.a.func,
        }),
        ge = n("2SQs"),
        we = n.n(ge),
        xe = (n("53h+"), ["className", "prefixCls", "children", "onSubmit"]),
        ke = h.a.createElement,
        Oe = {
          "./style.css": {
            form: "style__form___1smfs",
            "form-item": "style__form-item____HyRV",
            "form-item-margin": "style__form-item-margin___yDrps",
            "form-item-label": "style__form-item-label___3RoYq",
            button: "style__button___29kjB",
            "form-error": "style__form-error___1S7vw",
            "form-error-height": "style__form-error-height___11O7x",
            "form-item-control-wrapper":
              "style__form-item-control-wrapper___3S24U",
            "form-hide": "style__form-hide___3vFRM",
            "form-error-wrapper": "style__form-error-wrapper___3thdL",
          },
        };
      function Ie(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var Se = {
          prefixCls: y.a.string,
          children: y.a.node,
          onSubmit: y.a.func,
          style: y.a.string,
          create: y.a.func,
        },
        je = (function (e) {
          function t(e) {
            var n;
            return (
              Object(r.default)(this, t),
              (n = Ie(this, t, [e])),
              Object(u.a)(Object(c.a)(n), "onSubmit", function (e) {
                var t = n.props.onSubmit;
                "function" === typeof t && t(e);
              }),
              (n.state = {}),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "getChildContext",
                value: function () {
                  return { formObj: this.props.form };
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.className,
                    n = e.prefixCls,
                    r = e.children,
                    i = (e.onSubmit, Object(a.a)(e, xe)),
                    l = v()(n, t),
                    s = we()(i, Object.keys(Se));
                  return ke(
                    "form",
                    Object(o.a)({}, s, {
                      onSubmit: this.onSubmit,
                      autoComplete: "off",
                      className:
                        (l ? l + " " : "") +
                        p()(l, Oe, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }) +
                        " " +
                        ((s && s.className) || ""),
                    }),
                    r,
                  );
                },
              },
            ]),
            t
          );
        })(h.a.PureComponent);
      Object(u.a)(je, "create", function () {
        return be();
      }),
        Object(u.a)(je, "childContextTypes", { formObj: y.a.object }),
        Object(u.a)(je, "formShape", ve),
        (je.defaultProps = {
          prefixCls: "form",
          children: "",
          style: "",
          onSubmit: function (e) {
            e.preventDefault();
          },
          create: function () {},
        });
      var Te = je,
        Ce = n("XrJB"),
        Me = n.n(Ce),
        Pe = (n("aiR1"), h.a.createElement),
        Ee = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            form: "style__form___1smfs",
            "form-item": "style__form-item____HyRV",
            "form-item-margin": "style__form-item-margin___yDrps",
            "form-item-label": "style__form-item-label___3RoYq",
            button: "style__button___29kjB",
            "form-error": "style__form-error___1S7vw",
            "form-error-height": "style__form-error-height___11O7x",
            "form-item-control-wrapper":
              "style__form-item-control-wrapper___3S24U",
            "form-hide": "style__form-hide___3vFRM",
            "form-error-wrapper": "style__form-error-wrapper___3thdL",
          },
        };
      function Le(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var Be = (function (e) {
        function t(e) {
          var n;
          return (
            Object(r.default)(this, t), ((n = Le(this, t, [e])).state = {}), n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(i.default)(t, [
            {
              key: "getHelpMessage",
              value: function (e) {
                var t = e.props,
                  n = t.error,
                  o = t.errorMsg,
                  a = t.warningMsg,
                  r = this.props.prefixCls,
                  i = this.context.formObj,
                  l = (n ? i.getFieldError(n) : "") || o || a || "",
                  s = !!a,
                  c = s ? "exclamation-circle" : "times-circle",
                  _ = v()(
                    Object(u.a)(
                      Object(u.a)(
                        Object(u.a)({}, "".concat(r, "-error-height"), !0),
                        "".concat(r, "-error"),
                        !!l,
                      ),
                      "".concat(r, "-warning-wrapper"),
                      s,
                    ),
                  );
                return l
                  ? Pe(
                      "div",
                      {
                        key: "error",
                        className:
                          (_ ? _ + " " : "") +
                          p()(_, Ee, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                      },
                      Pe(Me.a, { name: c }),
                      Pe("span", { dangerouslySetInnerHTML: { __html: l } }),
                    )
                  : Pe(
                      "div",
                      {
                        key: "error",
                        className: p()("".concat(r, "-error"), Ee, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      " ",
                    );
              },
            },
            {
              key: "renderLabel",
              value: function () {
                var e = this.props,
                  t = e.prefixCls,
                  n = e.label,
                  o = e.id,
                  a = v()(Object(u.a)({}, "".concat(t, "-item-required"), !1)),
                  r = n;
                return n
                  ? Pe(
                      "div",
                      {
                        key: "label",
                        className: p()("".concat(t, "-item-label"), Ee, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      Pe(
                        "label",
                        {
                          htmlFor: o,
                          className: p()(a, Ee, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                        },
                        r,
                      ),
                    )
                  : null;
              },
            },
            {
              key: "renderWrapper",
              value: function (e) {
                var t = this.props.prefixCls,
                  n = v()(["".concat(t, "-item-control-wrapper")]);
                return Pe(
                  "div",
                  {
                    key: "wrapper",
                    className:
                      (n ? n + " " : "") +
                      p()(n, Ee, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  },
                  e,
                );
              },
            },
            {
              key: "renderChildren",
              value: function () {
                var e = this.props.children;
                return [
                  this.renderLabel(),
                  this.renderWrapper(e),
                  this.getHelpMessage(e),
                ];
              },
            },
            {
              key: "renderFormItem",
              value: function (e) {
                var t = this.props,
                  n = t.prefixCls,
                  o = t.className,
                  a = t.style,
                  r = t.hide,
                  i = t.children.props,
                  l = i.error,
                  s = i.errorMsg,
                  c = i.warningMsg,
                  _ = this.context.formObj,
                  d = (l ? _.getFieldError(l) : "") || s || c || "",
                  f = v()(
                    Object(u.a)(
                      Object(u.a)(
                        Object(u.a)(
                          Object(u.a)({}, "".concat(n, "-item"), !0),
                          "".concat(n, "-hide"),
                          r,
                        ),
                        "".concat(n, "-error-wrapper"),
                        !!d,
                      ),
                      "".concat(n, "-warning-wrapper"),
                      !!c,
                    ),
                    o,
                  );
                return Pe(
                  "div",
                  {
                    style: a,
                    className:
                      (f ? f + " " : "") +
                      p()(f, Ee, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  },
                  e,
                );
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.renderChildren();
                return this.renderFormItem(e);
              },
            },
          ]),
          t
        );
      })(h.a.PureComponent);
      Object(u.a)(Be, "contextTypes", { formObj: y.a.object }),
        (Be.defaultProps = {
          prefixCls: "form",
          label: "",
          children: {},
          className: "",
          id: "",
          style: {},
          hide: !1,
        });
      var Ne = Be;
    },
    IX3V: function (e, t) {
      e.exports = {
        isFunction: function (e) {
          return "function" === typeof e;
        },
        isArray: function (e) {
          return "[object Array]" === Object.prototype.toString.apply(e);
        },
        each: function (e, t) {
          for (var n = 0, o = e.length; n < o && !1 !== t(e[n], n); n++);
        },
      };
    },
    IcIN: function (e, t, n) {
      e.exports = {
        "dji-link": "style__dji-link___3Bxkg",
        "white-main": "style__white-main___3jpqZ",
        "black-main": "style__black-main___yosGt",
        "blue-link-on-dark": "style__blue-link-on-dark___5X5Q_",
        danger: "style__danger___3aqMu",
        "dji-link-normal": "style__dji-link-normal___Drppd",
        "dji-link-more": "style__dji-link-more___34EJc",
        "dji-link-modal": "style__dji-link-modal___Ae1GS",
        "dji-link-video": "style__dji-link-video___3S6vF",
        "dji-link-image": "style__dji-link-image___2wd0I",
        "dji-link-download": "style__dji-link-download___74hhr",
        "dji-link-replay": "style__dji-link-replay___2H2ns",
        "dji-link-refresh": "style__dji-link-refresh___1rnlz",
        "dji-link-external": "style__dji-link-external___F_OpW",
      };
    },
    IdKh: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return s;
      });
      var o = n("bQW5"),
        a = n("mtL0"),
        r = n("mnEE"),
        i = function (e) {
          return !isNaN(parseFloat(e));
        },
        l = (function () {
          function e(e) {
            var t = this;
            (this.timeDelta = 0),
              (this.lastUpdated = 0),
              (this.updateSubscribers = new r.a()),
              (this.velocityUpdateSubscribers = new r.a()),
              (this.renderSubscribers = new r.a()),
              (this.canTrackVelocity = !1),
              (this.updateAndNotify = function (e, n) {
                void 0 === n && (n = !0), (t.prev = t.current), (t.current = e);
                var a = Object(o.d)(),
                  r = a.delta,
                  i = a.timestamp;
                t.lastUpdated !== i &&
                  ((t.timeDelta = r),
                  (t.lastUpdated = i),
                  o.b.postRender(t.scheduleVelocityCheck)),
                  t.prev !== t.current && t.updateSubscribers.notify(t.current),
                  t.velocityUpdateSubscribers.getSize() &&
                    t.velocityUpdateSubscribers.notify(t.getVelocity()),
                  n && t.renderSubscribers.notify(t.current);
              }),
              (this.scheduleVelocityCheck = function () {
                return o.b.postRender(t.velocityCheck);
              }),
              (this.velocityCheck = function (e) {
                e.timestamp !== t.lastUpdated &&
                  ((t.prev = t.current),
                  t.velocityUpdateSubscribers.notify(t.getVelocity()));
              }),
              (this.hasAnimated = !1),
              (this.prev = this.current = e),
              (this.canTrackVelocity = i(this.current));
          }
          return (
            (e.prototype.onChange = function (e) {
              return this.updateSubscribers.add(e);
            }),
            (e.prototype.clearListeners = function () {
              this.updateSubscribers.clear();
            }),
            (e.prototype.onRenderRequest = function (e) {
              return e(this.get()), this.renderSubscribers.add(e);
            }),
            (e.prototype.attach = function (e) {
              this.passiveEffect = e;
            }),
            (e.prototype.set = function (e, t) {
              void 0 === t && (t = !0),
                t && this.passiveEffect
                  ? this.passiveEffect(e, this.updateAndNotify)
                  : this.updateAndNotify(e, t);
            }),
            (e.prototype.get = function () {
              return this.current;
            }),
            (e.prototype.getPrevious = function () {
              return this.prev;
            }),
            (e.prototype.getVelocity = function () {
              return this.canTrackVelocity
                ? Object(a.a)(
                    parseFloat(this.current) - parseFloat(this.prev),
                    this.timeDelta,
                  )
                : 0;
            }),
            (e.prototype.start = function (e) {
              var t = this;
              return (
                this.stop(),
                new Promise(function (n) {
                  (t.hasAnimated = !0), (t.stopAnimation = e(n));
                }).then(function () {
                  return t.clearAnimation();
                })
              );
            }),
            (e.prototype.stop = function () {
              this.stopAnimation && this.stopAnimation(), this.clearAnimation();
            }),
            (e.prototype.isAnimating = function () {
              return !!this.stopAnimation;
            }),
            (e.prototype.clearAnimation = function () {
              this.stopAnimation = null;
            }),
            (e.prototype.destroy = function () {
              this.updateSubscribers.clear(),
                this.renderSubscribers.clear(),
                this.stop();
            }),
            e
          );
        })();
      function s(e) {
        return new l(e);
      }
    },
    Ioao: function (e, t, n) {
      var o = n("heNW"),
        a = Math.max;
      e.exports = function (e, t, n) {
        return (
          (t = a(void 0 === t ? e.length - 1 : t, 0)),
          function () {
            for (
              var r = arguments, i = -1, l = a(r.length - t, 0), s = Array(l);
              ++i < l;

            )
              s[i] = r[t + i];
            i = -1;
            for (var c = Array(t + 1); ++i < t; ) c[i] = r[i];
            return (c[t] = n(s)), o(e, this, c);
          }
        );
      };
    },
    IrEl: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return q;
      });
      var o = n("rePB"),
        a = n("Ff2n"),
        r = n("q1tI"),
        i = n("IdKh"),
        l = n("/+VL"),
        s = n("mrSG");
      const c = (e, t, n) => (t - e === 0 ? 1 : (n - e) / (t - e));
      var _ = 50,
        u = function () {
          return {
            time: 0,
            x: {
              current: 0,
              offset: [],
              progress: 0,
              scrollLength: 0,
              targetOffset: 0,
              targetLength: 0,
              containerLength: 0,
              velocity: 0,
            },
            y: {
              current: 0,
              offset: [],
              progress: 0,
              scrollLength: 0,
              targetOffset: 0,
              targetLength: 0,
              containerLength: 0,
              velocity: 0,
            },
          };
        },
        d = {
          x: { length: "Width", position: "Left" },
          y: { length: "Height", position: "Top" },
        };
      function p(e, t, n, o) {
        var a = n[t],
          r = d[t],
          i = r.length,
          l = r.position,
          s = a.current,
          u = n.time;
        (a.current = e["scroll" + l]),
          "y" === t &&
            e === document.documentElement &&
            (a.current =
              document.documentElement.scrollTop + document.body.scrollTop),
          (a.scrollLength = e["scroll" + i] - e["client" + i]),
          (a.offset.length = 0),
          (a.offset[0] = 0),
          (a.offset[1] = a.scrollLength),
          (a.progress = c(0, a.scrollLength, a.current));
        var p,
          f,
          h = o - u;
        a.velocity =
          h > _ ? 0 : ((p = a.current - s), (f = h) ? p * (1e3 / f) : 0);
      }
      const f = (e) => "function" === typeof e,
        h = (e) => e;
      var m = n("KQm4");
      const y = (e, t, n) => -n * e + n * t + e;
      function b(e, t) {
        const n = e[e.length - 1];
        for (let o = 1; o <= t; o++) {
          const a = c(0, t, o);
          e.push(y(n, 1, a));
        }
      }
      function v(e) {
        const t = [0];
        return b(t, e - 1), t;
      }
      const g = (e) => "number" === typeof e,
        w = (e) => Array.isArray(e) && !g(e[0]),
        x = (e, t, n) => {
          const o = t - e;
          return ((((n - e) % o) + o) % o) + e;
        };
      const k = (e, t, n) => Math.min(Math.max(n, e), t);
      function O(e, t = v(e.length), n = h) {
        const o = e.length,
          a = o - t.length;
        return (
          a > 0 && b(t, a),
          (a) => {
            let r = 0;
            for (; r < o - 2 && !(a < t[r + 1]); r++);
            let i = k(0, 1, c(t[r], t[r + 1], a));
            return (
              (i = (function (e, t) {
                return w(e) ? e[x(0, e.length, t)] : e;
              })(
                n,
                r,
              )(i)),
              y(e[r], e[r + 1], i)
            );
          }
        );
      }
      var I = {
        Enter: [
          [0, 1],
          [1, 1],
        ],
        Exit: [
          [0, 0],
          [1, 0],
        ],
        Any: [
          [1, 0],
          [0, 1],
        ],
        All: [
          [0, 0],
          [1, 1],
        ],
      };
      const S = (e) => "string" === typeof e;
      var j = { start: 0, center: 0.5, end: 1 };
      function T(e, t) {
        var n =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
          o = 0;
        if ((void 0 !== j[e] && (e = j[e]), S(e))) {
          var a = parseFloat(e);
          e.endsWith("px")
            ? (o = a)
            : e.endsWith("%")
              ? (e = a / 100)
              : e.endsWith("vw")
                ? (o = (a / 100) * document.documentElement.clientWidth)
                : e.endsWith("vh")
                  ? (o = (a / 100) * document.documentElement.clientHeight)
                  : (e = a);
        }
        return g(e) && (o = t * e), n + o;
      }
      var C = [0, 0];
      function M(e, t, n, o) {
        var a = Array.isArray(e) ? e : C;
        return (
          g(e)
            ? (a = [e, e])
            : S(e) &&
              (a = (e = e.trim()).includes(" ")
                ? e.split(" ")
                : [e, j[e] ? e : "0"]),
          T(a[0], n, o) - T(a[1], t)
        );
      }
      var P = { x: 0, y: 0 };
      function E(e, t, n) {
        var o = n.offset,
          a = void 0 === o ? I.All : o,
          r = n.target,
          i = void 0 === r ? e : r,
          l = n.axis,
          s = void 0 === l ? "y" : l,
          c = "y" === s ? "height" : "width",
          _ =
            i !== e
              ? (function (e, t) {
                  for (var n = { x: 0, y: 0 }, o = e; o && o !== t; )
                    if (o instanceof HTMLElement)
                      (n.x += o.offsetLeft),
                        (n.y += o.offsetTop),
                        (o = o.offsetParent);
                    else if (
                      o instanceof SVGGraphicsElement &&
                      "getBBox" in o
                    ) {
                      var a = o.getBBox(),
                        r = a.top,
                        i = a.left;
                      for (n.x += i, n.y += r; o && "svg" !== o.tagName; )
                        o = o.parentNode;
                    }
                  return n;
                })(i, e)
              : P,
          u =
            i === e
              ? { width: e.scrollWidth, height: e.scrollHeight }
              : { width: i.clientWidth, height: i.clientHeight },
          d = { width: e.clientWidth, height: e.clientHeight };
        t[s].offset.length = 0;
        for (var p = !t[s].interpolate, f = a.length, h = 0; h < f; h++) {
          var y = M(a[h], d[c], u[c], _[s]);
          p || y === t[s].interpolatorOffsets[h] || (p = !0),
            (t[s].offset[h] = y);
        }
        p &&
          ((t[s].interpolate = O(v(f), t[s].offset)),
          (t[s].interpolatorOffsets = Object(m.a)(t[s].offset))),
          (t[s].progress = t[s].interpolate(t[s].current));
      }
      function L(e, t, n) {
        var o =
            arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          a = o.axis || "y";
        return {
          measure: function () {
            return (function (e) {
              var t =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : e,
                n = arguments.length > 2 ? arguments[2] : void 0;
              if (((n.x.targetOffset = 0), (n.y.targetOffset = 0), t !== e))
                for (var o = t; o && o != e; )
                  (n.x.targetOffset += o.offsetLeft),
                    (n.y.targetOffset += o.offsetTop),
                    (o = o.offsetParent);
              (n.x.targetLength = t === e ? t.scrollWidth : t.clientWidth),
                (n.y.targetLength = t === e ? t.scrollHeight : t.clientHeight),
                (n.x.containerLength = e.clientWidth),
                (n.y.containerLength = e.clientHeight);
            })(e, o.target, n);
          },
          update: function (t) {
            !(function (e, t, n) {
              p(e, "x", t, n), p(e, "y", t, n), (t.time = n);
            })(e, n, t),
              (o.offset || o.target) && E(e, n, o);
          },
          notify: f(t)
            ? function () {
                return t(n);
              }
            : B(t, n[a]),
          scrollNode: o.scrollNode,
        };
      }
      function B(e, t) {
        return (
          e.pause(),
          e.forEachNative(function (e, t) {
            var n,
              o,
              a = t.easing;
            if (e.updateDuration) a || (e.easing = h), e.updateDuration(1);
            else {
              var r = { duration: 1e3 };
              a || (r.easing = "linear"),
                null ===
                  (o =
                    null === (n = e.effect) || void 0 === n
                      ? void 0
                      : n.updateTiming) ||
                  void 0 === o ||
                  o.call(n, r);
            }
          }),
          function () {
            e.currentTime = t.progress;
          }
        );
      }
      function N(e, t) {
        var n =
          ("undefined" !== typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" === typeof e) return D(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return D(e, t);
            })(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var o = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return o >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[o++] };
              },
              e: function (e) {
                throw e;
              },
              f: a,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var r,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (r = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw r;
            }
          },
        };
      }
      function D(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      var z = "useScroll",
        A = new WeakMap(),
        R = new WeakMap(),
        F = function (e) {
          return e === document.documentElement ? window : e;
        };
      var V = [
        "container",
        "target",
        "downgrade",
        "customCB",
        "customDefaultValues",
      ];
      function H(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function W(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? H(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : H(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var U = r.useLayoutEffect;
      function G(e) {
        var t = Object(r.useRef)(null);
        return null === t.current && (t.current = e()), t.current;
      }
      var Y = function () {
        return {
          scrollX: Object(i.a)(0),
          scrollY: Object(i.a)(0),
          scrollXProgress: Object(i.a)(0),
          scrollYProgress: Object(i.a)(0),
        };
      };
      function q() {
        var e =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.container,
          n = e.target,
          o = e.downgrade,
          r = e.customCB,
          i = e.customDefaultValues,
          c = Object(a.a)(e, V),
          _ = G(Y),
          d = i && G(i);
        return (
          U(function () {
            var e;
            if (!o)
              return (
                (null === n || void 0 === n ? void 0 : n.current) &&
                  (e = l.a
                    .getInstance()
                    .addNode(n.current, void 0, void 0, 500, !0)),
                (function (e) {
                  var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    n = t.container,
                    o = void 0 === n ? document.documentElement : n,
                    a = Object(s.d)(t, ["container"]),
                    r = a.target,
                    i = R.get(o);
                  i || ((i = new Set()), R.set(o, i));
                  var c = u(),
                    _ = L(o, e, c, a);
                  if ((i.add(_), !A.has(o))) {
                    var d = function () {
                      var e,
                        t = performance.now(),
                        n = N(i);
                      try {
                        for (n.s(); !(e = n.n()).done; ) {
                          var o,
                            a = e.value;
                          (null === (o = a.scrollNode) || void 0 === o
                            ? void 0
                            : o.inView) && a.measure();
                        }
                      } catch (f) {
                        n.e(f);
                      } finally {
                        n.f();
                      }
                      var r,
                        l = N(i);
                      try {
                        for (l.s(); !(r = l.n()).done; ) {
                          var s,
                            c = r.value;
                          (null === (s = c.scrollNode) || void 0 === s
                            ? void 0
                            : s.inView) && c.update(t);
                        }
                      } catch (f) {
                        l.e(f);
                      } finally {
                        l.f();
                      }
                      var _,
                        u = N(i);
                      try {
                        for (u.s(); !(_ = u.n()).done; ) {
                          var d,
                            p = _.value;
                          (null === (d = p.scrollNode) || void 0 === d
                            ? void 0
                            : d.inView) && p.notify();
                        }
                      } catch (f) {
                        u.e(f);
                      } finally {
                        u.f();
                      }
                    };
                    A.set(o, d),
                      l.a
                        .getInstance()
                        .getDimension()
                        .addDimensionListener(z, {
                          onScroll: d,
                          onScrollEnd: d,
                          onResize: d,
                        });
                  }
                  var p = A.get(o),
                    f = requestAnimationFrame(p);
                  return function () {
                    "function" !== typeof e && e.stop(),
                      cancelAnimationFrame(f);
                    var t = R.get(o);
                    if (t && (t.delete(_), !t.size)) {
                      var n = A.get(o);
                      A.delete(o),
                        l.a.getInstance().removeNode(r),
                        l.a
                          .getInstance()
                          .getDimension()
                          .removeDimensionListener(z),
                        n &&
                          (F(o).removeEventListener("scroll", n),
                          window.removeEventListener("resize", n));
                    }
                  };
                })(
                  function (e) {
                    var t = e.x,
                      n = e.y;
                    d && (null === r || void 0 === r || r({ x: t, y: n }, d)),
                      _.scrollX.set(t.current),
                      _.scrollXProgress.set(t.progress),
                      _.scrollY.set(n.current),
                      _.scrollYProgress.set(n.progress);
                  },
                  W(
                    W({}, c),
                    {},
                    {
                      container:
                        (null === t || void 0 === t ? void 0 : t.current) ||
                        void 0,
                      target:
                        (null === n || void 0 === n ? void 0 : n.current) ||
                        void 0,
                      scrollNode: e,
                    },
                  ),
                )
              );
          }),
          d ? W(W({}, _), d) : _
        );
      }
    },
    "J4/h": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      });
      var o = n("q1tI");
      function a(e) {
        var t = Object(o.useRef)(null);
        return null === t.current && (t.current = e()), t.current;
      }
    },
    JB68: function (e, t, n) {
      var o = n("Jes0");
      e.exports = function (e) {
        return Object(o(e));
      };
    },
    JHRd: function (e, t, n) {
      var o = n("Kz5y").Uint8Array;
      e.exports = o;
    },
    JHgL: function (e, t, n) {
      var o = n("QkVE");
      e.exports = function (e) {
        return o(this, e).get(e);
      };
    },
    JKea: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = function (e, t, n) {
        return -n * e + n * t + e;
      };
    },
    JSQU: function (e, t, n) {
      var o = n("YESw"),
        a = "__lodash_hash_undefined__";
      e.exports = function (e, t) {
        var n = this.__data__;
        return (
          (this.size += this.has(e) ? 0 : 1),
          (n[e] = o && void 0 === t ? a : t),
          this
        );
      };
    },
    JTzB: function (e, t, n) {
      var o = n("NykK"),
        a = n("ExA7"),
        r = "[object Arguments]";
      e.exports = function (e) {
        return a(e) && o(e) == r;
      };
    },
    JbBM: function (e, t, n) {
      n("Hfiw"), (e.exports = n("WEpk").Object.setPrototypeOf);
    },
    Jes0: function (e, t) {
      e.exports = function (e) {
        if (void 0 == e) throw TypeError("Can't call method on  " + e);
        return e;
      };
    },
    Jq2x: function (e, t, n) {
      "use strict";
      var o = n("/xfr");
      function a(e) {
        return (a = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
      }
      function r(e, t) {
        return (r =
          Object.setPrototypeOf ||
          function (e, t) {
            return (e.__proto__ = t), e;
          })(e, t);
      }
      function i(e, t, n) {
        return (i = (function () {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })()
          ? Reflect.construct
          : function (e, t, n) {
              var o = [null];
              o.push.apply(o, t);
              var a = new (Function.bind.apply(e, o))();
              return n && r(a, n.prototype), a;
            }).apply(null, arguments);
      }
      function l(e) {
        var t = "function" === typeof Map ? new Map() : void 0;
        return (l = function (e) {
          if (
            null === e ||
            ((n = e), -1 === Function.toString.call(n).indexOf("[native code]"))
          )
            return e;
          var n;
          if ("function" !== typeof e)
            throw new TypeError(
              "Super expression must either be null or a function",
            );
          if ("undefined" !== typeof t) {
            if (t.has(e)) return t.get(e);
            t.set(e, o);
          }
          function o() {
            return i(e, arguments, a(this).constructor);
          }
          return (
            (o.prototype = Object.create(e.prototype, {
              constructor: {
                value: o,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
            r(o, e)
          );
        })(e);
      }
      var s = (function (e) {
        var t, n;
        function o(t) {
          var n;
          return (
            (function (e) {
              var t = e.__proto__;
              Object.defineProperty(e, "__proto__", {
                get: function () {
                  return t;
                },
                set: function (e) {
                  t.__proto__ = e;
                },
              });
            })(
              (function (e) {
                if (void 0 === e)
                  throw new ReferenceError(
                    "this hasn't been initialised - super() hasn't been called",
                  );
                return e;
              })((n = e.call.apply(e, [this].concat(t)) || this)),
            ),
            n
          );
        }
        return (
          (n = e),
          ((t = o).prototype = Object.create(n.prototype)),
          (t.prototype.constructor = t),
          (t.__proto__ = n),
          o
        );
      })(l(Array));
      function c(e) {
        void 0 === e && (e = []);
        var t = [];
        return (
          e.forEach(function (e) {
            Array.isArray(e) ? t.push.apply(t, c(e)) : t.push(e);
          }),
          t
        );
      }
      function _(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function u(e, t) {
        var n = Object(o.b)(),
          a = Object(o.a)(),
          r = [];
        if (!t && e instanceof s) return e;
        if (!e) return new s(r);
        if ("string" === typeof e) {
          var i = e.trim();
          if (i.indexOf("<") >= 0 && i.indexOf(">") >= 0) {
            var l = "div";
            0 === i.indexOf("<li") && (l = "ul"),
              0 === i.indexOf("<tr") && (l = "tbody"),
              (0 !== i.indexOf("<td") && 0 !== i.indexOf("<th")) || (l = "tr"),
              0 === i.indexOf("<tbody") && (l = "table"),
              0 === i.indexOf("<option") && (l = "select");
            var c = a.createElement(l);
            c.innerHTML = i;
            for (var _ = 0; _ < c.childNodes.length; _ += 1)
              r.push(c.childNodes[_]);
          } else
            r = (function (e, t) {
              if ("string" !== typeof e) return [e];
              for (
                var n = [], o = t.querySelectorAll(e), a = 0;
                a < o.length;
                a += 1
              )
                n.push(o[a]);
              return n;
            })(e.trim(), t || a);
        } else if (e.nodeType || e === n || e === a) r.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof s) return e;
          r = e;
        }
        return new s(
          (function (e) {
            for (var t = [], n = 0; n < e.length; n += 1)
              -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
          })(r),
        );
      }
      u.fn = s.prototype;
      var d = "resize scroll".split(" ");
      function p(e) {
        return function () {
          for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
            n[o] = arguments[o];
          if ("undefined" === typeof n[0]) {
            for (var a = 0; a < this.length; a += 1)
              d.indexOf(e) < 0 &&
                (e in this[a] ? this[a][e]() : u(this[a]).trigger(e));
            return this;
          }
          return this.on.apply(this, [e].concat(n));
        };
      }
      p("click"),
        p("blur"),
        p("focus"),
        p("focusin"),
        p("focusout"),
        p("keyup"),
        p("keydown"),
        p("keypress"),
        p("submit"),
        p("change"),
        p("mousedown"),
        p("mousemove"),
        p("mouseup"),
        p("mouseenter"),
        p("mouseleave"),
        p("mouseout"),
        p("mouseover"),
        p("touchstart"),
        p("touchend"),
        p("touchmove"),
        p("resize"),
        p("scroll");
      var f = {
        addClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          var o = c(
            t.map(function (e) {
              return e.split(" ");
            }),
          );
          return (
            this.forEach(function (e) {
              var t;
              (t = e.classList).add.apply(t, o);
            }),
            this
          );
        },
        removeClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          var o = c(
            t.map(function (e) {
              return e.split(" ");
            }),
          );
          return (
            this.forEach(function (e) {
              var t;
              (t = e.classList).remove.apply(t, o);
            }),
            this
          );
        },
        hasClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          var o = c(
            t.map(function (e) {
              return e.split(" ");
            }),
          );
          return (
            _(this, function (e) {
              return (
                o.filter(function (t) {
                  return e.classList.contains(t);
                }).length > 0
              );
            }).length > 0
          );
        },
        toggleClass: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          var o = c(
            t.map(function (e) {
              return e.split(" ");
            }),
          );
          this.forEach(function (e) {
            o.forEach(function (t) {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" === typeof e)
            return this[0] ? this[0].getAttribute(e) : void 0;
          for (var n = 0; n < this.length; n += 1)
            if (2 === arguments.length) this[n].setAttribute(e, t);
            else
              for (var o in e)
                (this[n][o] = e[o]), this[n].setAttribute(o, e[o]);
          return this;
        },
        removeAttr: function (e) {
          for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (var t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (var t = 0; t < this.length; t += 1)
            this[t].style.transitionDuration =
              "string" !== typeof e ? e + "ms" : e;
          return this;
        },
        on: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          var o = t[0],
            a = t[1],
            r = t[2],
            i = t[3];
          function l(e) {
            var t = e.target;
            if (t) {
              var n = e.target.dom7EventData || [];
              if ((n.indexOf(e) < 0 && n.unshift(e), u(t).is(a))) r.apply(t, n);
              else
                for (var o = u(t).parents(), i = 0; i < o.length; i += 1)
                  u(o[i]).is(a) && r.apply(o[i], n);
            }
          }
          function s(e) {
            var t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
          }
          "function" === typeof t[1] &&
            ((o = t[0]), (r = t[1]), (i = t[2]), (a = void 0)),
            i || (i = !1);
          for (var c, _ = o.split(" "), d = 0; d < this.length; d += 1) {
            var p = this[d];
            if (a)
              for (c = 0; c < _.length; c += 1) {
                var f = _[c];
                p.dom7LiveListeners || (p.dom7LiveListeners = {}),
                  p.dom7LiveListeners[f] || (p.dom7LiveListeners[f] = []),
                  p.dom7LiveListeners[f].push({
                    listener: r,
                    proxyListener: l,
                  }),
                  p.addEventListener(f, l, i);
              }
            else
              for (c = 0; c < _.length; c += 1) {
                var h = _[c];
                p.dom7Listeners || (p.dom7Listeners = {}),
                  p.dom7Listeners[h] || (p.dom7Listeners[h] = []),
                  p.dom7Listeners[h].push({ listener: r, proxyListener: s }),
                  p.addEventListener(h, s, i);
              }
          }
          return this;
        },
        off: function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          var o = t[0],
            a = t[1],
            r = t[2],
            i = t[3];
          "function" === typeof t[1] &&
            ((o = t[0]), (r = t[1]), (i = t[2]), (a = void 0)),
            i || (i = !1);
          for (var l = o.split(" "), s = 0; s < l.length; s += 1)
            for (var c = l[s], _ = 0; _ < this.length; _ += 1) {
              var u = this[_],
                d = void 0;
              if (
                (!a && u.dom7Listeners
                  ? (d = u.dom7Listeners[c])
                  : a && u.dom7LiveListeners && (d = u.dom7LiveListeners[c]),
                d && d.length)
              )
                for (var p = d.length - 1; p >= 0; p -= 1) {
                  var f = d[p];
                  r && f.listener === r
                    ? (u.removeEventListener(c, f.proxyListener, i),
                      d.splice(p, 1))
                    : r &&
                        f.listener &&
                        f.listener.dom7proxy &&
                        f.listener.dom7proxy === r
                      ? (u.removeEventListener(c, f.proxyListener, i),
                        d.splice(p, 1))
                      : r ||
                        (u.removeEventListener(c, f.proxyListener, i),
                        d.splice(p, 1));
                }
            }
          return this;
        },
        trigger: function () {
          for (
            var e = Object(o.b)(),
              t = arguments.length,
              n = new Array(t),
              a = 0;
            a < t;
            a++
          )
            n[a] = arguments[a];
          for (var r = n[0].split(" "), i = n[1], l = 0; l < r.length; l += 1)
            for (var s = r[l], c = 0; c < this.length; c += 1) {
              var _ = this[c];
              if (e.CustomEvent) {
                var u = new e.CustomEvent(s, {
                  detail: i,
                  bubbles: !0,
                  cancelable: !0,
                });
                (_.dom7EventData = n.filter(function (e, t) {
                  return t > 0;
                })),
                  _.dispatchEvent(u),
                  (_.dom7EventData = []),
                  delete _.dom7EventData;
              }
            }
          return this;
        },
        transitionEnd: function (e) {
          var t = this;
          return (
            e &&
              t.on("transitionend", function n(o) {
                o.target === this &&
                  (e.call(this, o), t.off("transitionend", n));
              }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              var t = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(t.getPropertyValue("margin-right")) +
                parseFloat(t.getPropertyValue("margin-left"))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              var t = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(t.getPropertyValue("margin-top")) +
                parseFloat(t.getPropertyValue("margin-bottom"))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          var e = Object(o.b)();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            var e = Object(o.b)(),
              t = Object(o.a)(),
              n = this[0],
              a = n.getBoundingClientRect(),
              r = t.body,
              i = n.clientTop || r.clientTop || 0,
              l = n.clientLeft || r.clientLeft || 0,
              s = n === e ? e.scrollY : n.scrollTop,
              c = n === e ? e.scrollX : n.scrollLeft;
            return { top: a.top + s - i, left: a.left + c - l };
          }
          return null;
        },
        css: function (e, t) {
          var n,
            a = Object(o.b)();
          if (1 === arguments.length) {
            if ("string" !== typeof e) {
              for (n = 0; n < this.length; n += 1)
                for (var r in e) this[n].style[r] = e[r];
              return this;
            }
            if (this[0])
              return a.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" === typeof e) {
            for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach(function (t, n) {
                e.apply(t, [t, n]);
              }),
              this)
            : this;
        },
        html: function (e) {
          if ("undefined" === typeof e)
            return this[0] ? this[0].innerHTML : null;
          for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if ("undefined" === typeof e)
            return this[0] ? this[0].textContent.trim() : null;
          for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          var t,
            n,
            a = Object(o.b)(),
            r = Object(o.a)(),
            i = this[0];
          if (!i || "undefined" === typeof e) return !1;
          if ("string" === typeof e) {
            if (i.matches) return i.matches(e);
            if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
            if (i.msMatchesSelector) return i.msMatchesSelector(e);
            for (t = u(e), n = 0; n < t.length; n += 1)
              if (t[n] === i) return !0;
            return !1;
          }
          if (e === r) return i === r;
          if (e === a) return i === a;
          if (e.nodeType || e instanceof s) {
            for (t = e.nodeType ? [e] : e, n = 0; n < t.length; n += 1)
              if (t[n] === i) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          var e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling); )
              1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if ("undefined" === typeof e) return this;
          var t = this.length;
          if (e > t - 1) return u([]);
          if (e < 0) {
            var n = t + e;
            return u(n < 0 ? [] : [this[n]]);
          }
          return u([this[e]]);
        },
        append: function () {
          for (var e, t = Object(o.a)(), n = 0; n < arguments.length; n += 1) {
            e = n < 0 || arguments.length <= n ? void 0 : arguments[n];
            for (var a = 0; a < this.length; a += 1)
              if ("string" === typeof e) {
                var r = t.createElement("div");
                for (r.innerHTML = e; r.firstChild; )
                  this[a].appendChild(r.firstChild);
              } else if (e instanceof s)
                for (var i = 0; i < e.length; i += 1) this[a].appendChild(e[i]);
              else this[a].appendChild(e);
          }
          return this;
        },
        prepend: function (e) {
          var t,
            n,
            a = Object(o.a)();
          for (t = 0; t < this.length; t += 1)
            if ("string" === typeof e) {
              var r = a.createElement("div");
              for (r.innerHTML = e, n = r.childNodes.length - 1; n >= 0; n -= 1)
                this[t].insertBefore(r.childNodes[n], this[t].childNodes[0]);
            } else if (e instanceof s)
              for (n = 0; n < e.length; n += 1)
                this[t].insertBefore(e[n], this[t].childNodes[0]);
            else this[t].insertBefore(e, this[t].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling &&
                u(this[0].nextElementSibling).is(e)
                ? u([this[0].nextElementSibling])
                : u([])
              : this[0].nextElementSibling
                ? u([this[0].nextElementSibling])
                : u([])
            : u([]);
        },
        nextAll: function (e) {
          var t = [],
            n = this[0];
          if (!n) return u([]);
          for (; n.nextElementSibling; ) {
            var o = n.nextElementSibling;
            e ? u(o).is(e) && t.push(o) : t.push(o), (n = o);
          }
          return u(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            var t = this[0];
            return e
              ? t.previousElementSibling && u(t.previousElementSibling).is(e)
                ? u([t.previousElementSibling])
                : u([])
              : t.previousElementSibling
                ? u([t.previousElementSibling])
                : u([]);
          }
          return u([]);
        },
        prevAll: function (e) {
          var t = [],
            n = this[0];
          if (!n) return u([]);
          for (; n.previousElementSibling; ) {
            var o = n.previousElementSibling;
            e ? u(o).is(e) && t.push(o) : t.push(o), (n = o);
          }
          return u(t);
        },
        parent: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            null !== this[n].parentNode &&
              (e
                ? u(this[n].parentNode).is(e) && t.push(this[n].parentNode)
                : t.push(this[n].parentNode));
          return u(t);
        },
        parents: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            for (var o = this[n].parentNode; o; )
              e ? u(o).is(e) && t.push(o) : t.push(o), (o = o.parentNode);
          return u(t);
        },
        closest: function (e) {
          var t = this;
          return "undefined" === typeof e
            ? u([])
            : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            for (
              var o = this[n].querySelectorAll(e), a = 0;
              a < o.length;
              a += 1
            )
              t.push(o[a]);
          return u(t);
        },
        children: function (e) {
          for (var t = [], n = 0; n < this.length; n += 1)
            for (var o = this[n].children, a = 0; a < o.length; a += 1)
              (e && !u(o[a]).is(e)) || t.push(o[a]);
          return u(t);
        },
        filter: function (e) {
          return u(_(this, e));
        },
        remove: function () {
          for (var e = 0; e < this.length; e += 1)
            this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(f).forEach(function (e) {
        Object.defineProperty(u.fn, e, { value: f[e], writable: !0 });
      });
      t.a = u;
    },
    KMkd: function (e, t) {
      e.exports = function () {
        (this.__data__ = []), (this.size = 0);
      };
    },
    "KT+k": function (e, t, n) {
      e.exports = {
        "section-sale-point": "style__section-sale-point___2Qhfg",
        "layout-wrapper": "style__layout-wrapper___2uDlY",
        rasterisation: "style__rasterisation____7mzy",
        "card-wrapper": "style__card-wrapper___2eSM6",
        "video-player-button-position":
          "style__video-player-button-position___3tb8Q",
        "card-vertical-center": "style__card-vertical-center___2-S8K",
        "card-vertical-top": "style__card-vertical-top___ix6Qq",
        "card-vertical-bottom": "style__card-vertical-bottom___1QxNM",
        "card-horizontal-center": "style__card-horizontal-center___2jDA1",
        "card-content": "style__card-content___2Xnq1",
        "foreground-pic": "style__foreground-pic___3IOU9",
        "card-horizontal-left": "style__card-horizontal-left___1YUWY",
        "card-horizontal-right": "style__card-horizontal-right___2vqs3",
        "video-player-button-container":
          "style__video-player-button-container___5mhHI",
        "video-btn-text": "style__video-btn-text___1U_rD",
        "salepoint-video-play": "style__salepoint-video-play___RkMLz",
        "video-player-button-center":
          "style__video-player-button-center___1w_w-",
        "video-player-button-left-bottom":
          "style__video-player-button-left-bottom___2qE05",
        "video-player-button-right-bottom":
          "style__video-player-button-right-bottom___fTQ3L",
        "video-player-button-secondary-light":
          "style__video-player-button-secondary-light___2Eotl",
        "video-player-button-secondary-dark":
          "style__video-player-button-secondary-dark___3DBlb",
        "video-player-button-with-text":
          "style__video-player-button-with-text___L2Nvk",
        "divide-line": "style__divide-line___zLRkK",
        "amount-icon": "style__amount-icon___f81AR",
        "card-wrapper-product-bundle":
          "style__card-wrapper-product-bundle___6qMvi",
      };
    },
    KUxP: function (e, t) {
      e.exports = function (e) {
        try {
          return !!e();
        } catch (t) {
          return !0;
        }
      };
    },
    KfNM: function (e, t) {
      var n = Object.prototype.toString;
      e.exports = function (e) {
        return n.call(e);
      };
    },
    KkZl: function (e, t, n) {
      e.exports = {
        "slick-loading": "style__slick-loading___bUE7o",
        "angle-left": "style__angle-left___OF2gR",
        "angle-right": "style__angle-right___bH8Pi",
      };
    },
    KxSJ: function (e, t, n) {
      "use strict";
      var o = n("mAH3"),
        a = n("H5DZ"),
        r = n("HyXp"),
        i = n("9TBn"),
        l = n("L6Wy"),
        s = n("GIHP"),
        c = n("1d9b"),
        _ = n("8mTr"),
        u = n("gb4I"),
        d = n("L9fC"),
        p = n("b+vk"),
        f = n("kI75"),
        h = n("Rf4w"),
        m = n("rMj0"),
        y = n("cN7M"),
        b = n("EuhU"),
        v = n("7v5W"),
        g = n("q5jV"),
        w = n("9jLN"),
        x = n("p8LG"),
        k = n("MNWt"),
        O = n("eZTX"),
        I = {
          ac103ChangeColor: c.a,
          wm330ImageCarousel: _.a,
          wm330TextScrollSwitchVideo: u.a,
          infoCardVertical: l.default,
          infoCardHorizontal: i.default,
          infoTabHorizontal: r.a,
          "common-BgZoomOut": o.a,
          "common-SectionZoomOut": s.a,
          sectionVerticalTab: a.a,
          accessories: f.a,
          accessoriesBattery: h.a,
          wm161ModelViewer: m.default,
          shoppingGuide: y.default,
          sectionComments: b.default,
          hg703SetStyle: v.a,
          comparison: g.a,
          tabSceneSwitch: w.a,
          setScript: x.a,
          productElevator: k.a,
          terraTable: d.a,
          customForm: p.a,
          salePoint: O.a,
        };
      t.a = I;
    },
    Kz5y: function (e, t, n) {
      var o = n("WFqU"),
        a = "object" == typeof self && self && self.Object === Object && self,
        r = o || a || Function("return this")();
      e.exports = r;
    },
    L6Wy: function (e, t, n) {
      "use strict";
      n.r(t);
      var o = n("rePB"),
        a = n("KQm4"),
        r = n("6HgK"),
        i = n("2mql"),
        l = n.n(i),
        s = n("/NQ+"),
        c = n("ub/+"),
        _ = n("fi7q"),
        u = n("wx14"),
        d = n("1OyB"),
        p = n("vuIU"),
        f = n("md7G"),
        h = n("foSv"),
        m = n("JX7q"),
        y = n("Ji7U"),
        b = n("iKuz"),
        v = n.n(b),
        g = n("q1tI"),
        w = n("3vbH"),
        x = n("SBOM"),
        k = n("r7AC"),
        O = n("yWgo"),
        I = n("xk4V"),
        S = n.n(I),
        j = n("xTuV"),
        T = (n("rxEf"), n("eKi2")),
        C = n("nPaQ"),
        M = g.createElement,
        P = {
          "./style.css": {
            "hero-vertical-component": "style__hero-vertical-component___2JEHR",
            "background-video": "style__background-video___1extI",
            "video-mask": "style__video-mask___1DemG",
            "video-wrapper": "style__video-wrapper___JVagE",
            "card-list": "style__card-list___3Bphf",
            "hero-vertical-wrapper": "style__hero-vertical-wrapper___2mUEj",
            "hot-zone-link": "style__hot-zone-link___2d31i",
            "vertical-card-list": "style__vertical-card-list___LceQJ",
            "vertical-card-col": "style__vertical-card-col___3agtC",
            "vertical-top-align": "style__vertical-top-align___3JPlu",
            "vertical-center-align": "style__vertical-center-align___39Pu3",
            "vertical-bottom-align": "style__vertical-bottom-align___4Jy20",
            "has-media-screen": "style__has-media-screen___dOgoS",
            "media-screen-1440": "style__media-screen-1440___2Mhdb",
            "media-screen-1600": "style__media-screen-1600___1_p1O",
          },
        };
      function E(e, t) {
        var n =
          ("undefined" !== typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" === typeof e) return L(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return L(e, t);
            })(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var o = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return o >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[o++] };
              },
              e: function (e) {
                throw e;
              },
              f: a,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var r,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (r = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw r;
            }
          },
        };
      }
      function L(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      function B(e, t, n) {
        return (
          (t = Object(h.a)(t)),
          Object(f.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(h.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var N = (function (e) {
          return (
            (e["auto-fit"] = "auto-fit"), (e["custom-css"] = "custom-css"), e
          );
        })({}),
        D = (function (e) {
          return (
            (e.repeat = "repeat"),
            (e["repeat-x"] = "repeat-x"),
            (e["repeat-y"] = "repeat-y"),
            (e["no-repeat"] = "no-repeat"),
            e
          );
        })({}),
        z = (function (e) {
          return (e.fix = "fix"), (e.normal = "normal"), e;
        })({}),
        A = (function (e) {
          return (
            (e["top-align"] = "top-align"),
            (e["center-align"] = "center-align"),
            (e["bottom-align"] = "bottom-align"),
            e
          );
        })({}),
        R = (function (e) {
          return (
            (e["fade-in"] = "fade-in"),
            (e["fade-up"] = "fade-up"),
            (e["zoom-in-up"] = "zoom-in-up"),
            (e.none = "none"),
            e
          );
        })({}),
        F = (function (e) {
          function t(e) {
            var n;
            Object(d.default)(this, t),
              (n = B(this, t, [e])),
              Object(o.a)(Object(m.a)(n), "cards", void 0),
              Object(o.a)(Object(m.a)(n), "videoDom", void 0),
              Object(o.a)(Object(m.a)(n), "videoWrapper", void 0),
              (n.state = {
                hovering: !1,
                isIE: !1,
                videoWidth: null,
                videoHeight: null,
                videoEnded: !1,
              }),
              (n.getProps = n.getProps.bind(Object(m.a)(n))),
              (n.onResize = n.onResize.bind(Object(m.a)(n)));
            var a = n.getHotZoneLink(n.props);
            return (
              (n.cards = n.props.cardConfigList
                ? n.props.cardConfigList.map(function (t, o) {
                    return M(
                      "div",
                      {
                        key: S()(),
                        style: {
                          marginLeft: 0 === o ? 0 : n.props.cardGapWidth,
                          height: e.cardsStretch ? "100%" : "",
                        },
                        className: "style__vertical-card-col___3agtC",
                      },
                      M(
                        j.c,
                        Object(u.a)({}, t, {
                          visibleByDefault: n.getProps("visibleByDefault"),
                          gaSend: n.getProps("gaSend"),
                          getFadeTransiation: function () {
                            return n.getProps("fadeTransiation");
                          },
                          getMediaTransiation: function () {
                            return n.getProps("mediaTransiation");
                          },
                          getCardsStretch: function () {
                            return n.getProps("cardsStretch");
                          },
                          localization: n.getProps("localization"),
                          key: S()(),
                          index: o,
                          videoLazyLoadDistance: e.videoLazyLoadDistance,
                          hotZoneLink: 0 === o ? a : null,
                          hasMediaScreen: n.props.hasMediaScreen,
                          mediaPoint: n.props.mediaPoint,
                          elementDistance: n.props.elementDistance,
                          hasContentMedia: n.props.cardConfigList.length <= 1,
                        }),
                      ),
                    );
                  })
                : null),
              n
            );
          }
          return (
            Object(y.a)(t, e),
            Object(p.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this,
                    t =
                      window &&
                      !!window.MSInputMethodContext &&
                      !!document.documentMode;
                  if ((this.setState({ isIE: t }), this.videoDom)) {
                    var n,
                      o = E(this.videoDom.querySelectorAll("source"));
                    try {
                      for (o.s(); !(n = o.n()).done; ) {
                        var a = n.value,
                          r = a.dataset.layzrSrc;
                        a.setAttribute("src", r);
                      }
                    } catch (_) {
                      o.e(_);
                    } finally {
                      o.f();
                    }
                    this.videoDom.load(),
                      (this.videoDom.currentTime = 0),
                      this.videoDom.play();
                    var i = this.props,
                      l = i.bannerVideoReplayOff,
                      s = i.eventAction,
                      c = i.hasBannerVideo;
                    c &&
                      (this.onResize(),
                      null === s ||
                        void 0 === s ||
                        s.addCustomEventListener("resize", this.onResize)),
                      c &&
                        l &&
                        Object(k.b)({
                          elm: this.videoDom,
                          offset: 20,
                          callback: function (t) {
                            var n = t.inView;
                            return (
                              e.videoDom &&
                                (n
                                  ? e.videoDom.play()
                                  : (e.videoDom.currentTime = 0)),
                              !0
                            );
                          },
                        });
                  }
                  Object(T.a)(this.props);
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  var e = this.props,
                    t = e.eventAction;
                  e.hasBannerVideo &&
                    (null === t ||
                      void 0 === t ||
                      t.removeCustomEventListener("resize", this.onResize));
                },
              },
              {
                key: "getProps",
                value: function (e) {
                  return this.props[e];
                },
              },
              {
                key: "onResize",
                value: function () {
                  if (O.Q) {
                    var e =
                        document.documentElement.clientWidth ||
                        window.innerWidth,
                      t = window.innerHeight,
                      n = this.props,
                      o = n.bannerVideoWidth,
                      a = void 0 === o ? 2560 : o,
                      r = n.bannerVideoHeight,
                      i = +a / +(void 0 === r ? 1440 : r),
                      l = t * i,
                      s = e / i,
                      c = Math.max(e, l),
                      _ = Math.max(t, s);
                    this.setState({ videoWidth: c, videoHeight: _ });
                  }
                },
              },
              {
                key: "getHotZoneLink",
                value: function (e) {
                  var t;
                  if (
                    (e.hasBackgroundImage && e.backgroundImage) ||
                    (e.hasBackgroundVideo &&
                      (e.backgroundVideoWebm || e.backgroundVideo))
                  ) {
                    var n = e.cardConfigList;
                    n &&
                      1 === n.length &&
                      (n[0].hasBackgroundImage ||
                        n[0].hasBackgroundVideo ||
                        (t = Object(C.a)(n[0])));
                  }
                  return t;
                },
              },
              {
                key: "render",
                value: function () {
                  var e,
                    t = this,
                    n = this.props,
                    o = this.state,
                    a = o.hovering,
                    r = o.isIE,
                    i = o.videoWidth,
                    l = o.videoHeight,
                    s = o.videoEnded,
                    c = "vertical-".concat(n.componentVerticalAlign),
                    _ = n.fadeTransiation,
                    d = n.visibleByDefault,
                    p = { backgroundColor: n.backgroundColor };
                  n.hasBackgroundImage
                    ? ((e = n.backgroundImage),
                      (p.backgroundPosition = n.backgroundPosition),
                      (p.backgroundSize =
                        n.backgroundSize === N["auto-fit"]
                          ? "cover"
                          : n.backgroundSizeCustom),
                      (p.backgroundRepeat = n.backgroundRepeat),
                      (p.backgroundAttachment =
                        n.backgroundFixed !== z.fix || r ? "scroll" : "fixed"),
                      n.backgroundGradient &&
                        (e = "url('"
                          .concat(n.backgroundImage, "'), ")
                          .concat(n.backgroundGradient)))
                    : n.backgroundGradient && (e = n.backgroundGradient);
                  var f = s ? "" : n.backgroundVideoPoster,
                    h = {
                      minHeight: n.componentMinHeight,
                      paddingTop: n.paddingTop,
                      paddingBottom: n.paddingBottom,
                      paddingLeft: n.paddingLeft,
                      paddingRight: n.paddingRight,
                      width: n.gridWidth,
                    },
                    m = {};
                  m[d ? "poster" : "data-layzr-poster"] =
                    n.backgroundVideoPoster;
                  var y = {};
                  y.style =
                    "cover" !== n.backgroundVideoBackgroundSize || r
                      ? {}
                      : { width: "100%", height: "100%", objectFit: "cover" };
                  var b = n.hasMediaScreen,
                    g = "hero-vertical-wrapper ".concat(
                      Object(O.kb)(b, "has-media-screen", ""),
                      " ",
                      "media-screen-".concat(n.mediaPoint || "1440"),
                    );
                  return M(
                    x.a,
                    {
                      type: "bg",
                      src: e,
                      visibleByDefault: d,
                      bgWidth: n.backgroundImageWidth,
                      bgHeight: n.backgroundImageHeight,
                      parallax: n.hasBackgroundImage && n.backgroundParallax,
                      className:
                        "atom-design-v1 style__hero-vertical-component___2JEHR",
                      style: p,
                      onMouseEnter: function () {
                        n.backgroundVideoHoverPlay &&
                          t.setState({ hovering: !0 });
                      },
                      onMouseLeave: function () {
                        n.backgroundVideoHoverPlay &&
                          t.setState({ hovering: !1 });
                      },
                    },
                    n.hasBackgroundVideo &&
                      n.hasBannerVideo &&
                      M(
                        "div",
                        {
                          ref: function (e) {
                            t.videoWrapper = e;
                          },
                          className:
                            "background-video-wrapper style__background-video___1extI style__video-wrapper___JVagE",
                          style: {
                            backgroundImage: "url(".concat(f, ")"),
                            backgroundPosition: l ? "center" : "top left",
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            width: i || "100%",
                            height: l || "100vh",
                            minHeight: n.componentMinHeight,
                          },
                        },
                        M(
                          "video",
                          {
                            loop: n.backgroundVideoLoop,
                            style: {
                              width: i || "100%",
                              height: l || "100vh",
                              maxWidth: n.preventScale
                                ? "100%"
                                : "none !important",
                              objectFit: n.preventScale ? "cover" : "contain",
                            },
                            muted: !0,
                            playsInline: !0,
                            "x5-playsinline": "true",
                            ref: function (e) {
                              t.videoDom = e;
                            },
                            onCanPlayThrough: function () {
                              n.backgroundVideoPoster &&
                                t.setState({ videoEnded: !0 });
                            },
                            className: v()(r ? "isIE" : "", P, {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            }),
                          },
                          n.backgroundVideoWebm &&
                            M("source", {
                              type: "video/webm",
                              "data-layzr-src": n.backgroundVideoWebm,
                            }),
                          n.backgroundVideo &&
                            M("source", {
                              type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                              "data-layzr-src": n.backgroundVideo,
                            }),
                        ),
                        M("div", {
                          className: "style__video-mask___1DemG",
                          style: {
                            backgroundColor: n.backgroundVideoMaskColor,
                            opacity: n.backgroundVideoMaskOpacity,
                          },
                        }),
                      ),
                    n.hasBackgroundVideo &&
                      !n.hasBannerVideo &&
                      M(
                        "div",
                        {
                          className:
                            "background-video-wrapper style__background-video___1extI",
                        },
                        M(
                          w.a,
                          {
                            visiblePlay: n.backgroundVideoVisiblePlay,
                            replayWhenRevisible: n.backgroundVideoVisiblePlay,
                            triggerPlay: n.backgroundVideoHoverPlay && a,
                            triggerPause: n.backgroundVideoHoverPlay && !a,
                            videoLazyLoadDistance: n.videoLazyLoadDistance,
                            lazyLoad: !0,
                            lazyLoadThreshold: 2e3,
                            style: { width: "100%", height: "100%" },
                          },
                          M(
                            "video",
                            Object(u.a)({ muted: !0 }, m, y, {
                              loop: n.backgroundVideoLoop,
                              autoPlay:
                                !n.backgroundVideoVisiblePlay &&
                                !n.backgroundVideoHoverPlay,
                            }),
                            n.backgroundVideoWebm &&
                              M("source", {
                                type: "video/webm",
                                "data-layzr-src": n.backgroundVideoWebm,
                              }),
                            M("source", {
                              type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                              "data-layzr-src": n.backgroundVideo,
                            }),
                          ),
                        ),
                        M("div", {
                          className: "style__video-mask___1DemG",
                          style: {
                            backgroundColor: n.backgroundVideoMaskColor,
                            opacity: n.backgroundVideoMaskOpacity,
                          },
                        }),
                      ),
                    M(
                      "div",
                      {
                        id: n.anchorId || "",
                        style: h,
                        className: v()(g, P, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      M(
                        "div",
                        {
                          "data-aos": _,
                          "data-aos-once": !0,
                          className: v()("vertical-card-list ".concat(c), P, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                        },
                        this.cards,
                      ),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(g.Component);
      Object(o.a)(F, "defaultProps", {
        cardGapWidth: "16px",
        gridWidth: "1200px",
        componentMinHeight: "",
        backgroundColor: "",
        backgroundGradient: "",
        videoLazyLoadDistance: !1,
        hasBackgroundImage: !1,
        backgroundImage: "",
        backgroundImageWidth: "",
        backgroundImageHeight: "",
        backgroundPosition: "",
        backgroundSize: N["auto-fit"],
        backgroundSizeCustom: "",
        backgroundRepeat: D["no-repeat"],
        backgroundFixed: z.normal,
        backgroundParallax: !1,
        hasBackgroundVideo: !1,
        hasBannerVideo: !1,
        bannerVideoReplayOff: !1,
        backgroundVideoLoop: !1,
        backgroundVideoVisiblePlay: !1,
        backgroundVideoHoverPlay: !1,
        backgroundVideo: "",
        backgroundVideoWebm: "",
        backgroundVideoPoster: "",
        backgroundVideoMaskColor: "#000000",
        backgroundVideoMaskOpacity: "0",
        backgroundVideoBackgroundSize: "",
        componentVerticalAlign: A["center-align"],
        cardsStretch: !1,
        paddingTop: "128px",
        paddingBottom: "128px",
        paddingLeft: "",
        paddingRight: "",
        fadeTransiation: R.none,
        mediaTransiation: R.none,
        cardConfigList: [j.c.defaultProps],
        preventScale: !1,
        mediaPoint: "",
        mediaModuleType: "",
      });
      var V = [
        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
        { label: "\u7ad9\u5916\u6309\u94ae", value: "external-button" },
        { label: "\u5546\u57ce\u6309\u94ae", value: "store-button" },
        { label: "\u89c6\u9891\u64ad\u653e", value: "video-play" },
        { label: "SalesPoint\u5f39\u7a97", value: "salesPointPop" },
      ];
      function H(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function W(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? H(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : H(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var U = { label: "ga-label", type: "string", content: "text" },
        G = [];
      ["primaryButton", "secondaryButton"].forEach(function (e) {
        var t = {};
        (t["".concat(e, "ModalID")] = {
          label: "\u3010*\u5fc5\u586b\u3011\u5f39\u7a97\u7ec4\u4ef6ID",
          type: "string",
          helptext:
            "\u8bf7\u786e\u4fdd\u586b\u5199\u9700\u5173\u8054\u7ec4\u4ef6\u76845\u4f4d\u6570\u5b57ID\uff0c \uff08\u76ee\u524d\u4ec5\u652f\u6301\u7ed1\u5b9aSalePoint\u7ec4\u4ef6\uff09",
          controlBy: "".concat(e, "Type"),
          controlValue: "salesPointPop",
        }),
          G.push(t);
      });
      var Y = {
        contentSetting: {
          smallScreenSetting: {
            label: "\u5c0f\u5c4f\u914d\u7f6e",
            switch: "hasMediaScreen",
            props: {
              mediaPoint: _.a,
              elementDistance: {
                label: "\u7ec4\u4ef6\u95f4\u8ddd",
                type: "select",
                items: Object(a.a)([
                  { label: "\u9ed8\u8ba4 - \u65e0", value: "" },
                  {
                    label:
                      "\u56fe\u7247/\u89c6\u9891\u4e0e\u6587\u6848\u4e0a\u8fb9\u8ddd24",
                    value: "24",
                  },
                  {
                    label:
                      "\u56fe\u7247/\u89c6\u9891\u4e0e\u6587\u6848\u4e0a\u8fb9\u8ddd32",
                    value: "32",
                  },
                  {
                    label:
                      "\u56fe\u7247/\u89c6\u9891\u4e0e\u6587\u6848\u4e0a\u8fb9\u8ddd40",
                    value: "40",
                  },
                  {
                    label:
                      "\u56fe\u7247/\u89c6\u9891\u4e0e\u6587\u6848\u4e0a\u8fb9\u8ddd48",
                    value: "48",
                  },
                ]),
              },
            },
          },
          cardConfigList: {
            label: "\u5361\u7247",
            group_type: "array_card",
            group_prop_name: "cardConfigList",
            props: {
              cardlink: {
                label: "\u5361\u7247\u94fe\u63a5",
                switch: "hasCardLink",
                props: {
                  cardLink: {
                    label: "\u5361\u7247\u94fe\u63a5url",
                    type: "string",
                    content: "url",
                  },
                  cardLinkGaLabel: W({}, U),
                  jumpType: {
                    type: "select",
                    label: "\u94fe\u63a5\u7c7b\u578b",
                    items: [
                      { value: "internal", label: "\u7ad9\u5185\u94fe\u63a5" },
                      { value: "external", label: "\u7ad9\u5916\u94fe\u63a5" },
                    ],
                  },
                },
              },
              layout: {
                label: "\u5361\u7247\u5e03\u5c40\u6548\u679c",
                props: {
                  cardHeadlineSize: {
                    label: "headline\u5c42\u7ea7",
                    type: "select",
                    items: [
                      { label: "h1", value: "h1" },
                      { label: "h2", value: "h2" },
                      { label: "h3", value: "h3" },
                      { label: "h4", value: "h4" },
                      { label: "p", value: "p" },
                    ],
                  },
                  cardContentSize: {
                    label: "\u4fe1\u606f\u5757\u6587\u672c\u5c3a\u5bf8",
                    type: "select",
                    items: [
                      { label: "xxxxxl(headline=64)", value: "xxxxxl" },
                      { label: "xxxxl(headline=56)", value: "xxxxl" },
                      { label: "xxxl(headline=48)", value: "xxxl" },
                      { label: "xxl(headline=40)", value: "xxl" },
                      { label: "xl(headline=32)", value: "xl" },
                      { label: "l(headline=28)", value: "l" },
                      { label: "m(headline=24)", value: "m" },
                      { label: "s(headline=20)", value: "s" },
                      { label: "xs(headline=18)", value: "xs" },
                      { label: "xxs(headline=16)", value: "xxs" },
                    ],
                  },
                  cardVerticalAlign: {
                    label: "\u5361\u7247\u5185\u5bb9\u5782\u76f4\u5bf9\u9f50",
                    type: "select",
                    items: [
                      { label: "\u5c45\u4e0a\u5bf9\u9f50", value: "top-align" },
                      {
                        label: "\u5c45\u4e2d\u5bf9\u9f50",
                        value: "center-align",
                      },
                      {
                        label: "\u5c45\u4e0b\u5bf9\u9f50",
                        value: "bottom-align",
                      },
                    ],
                  },
                  cardHorizonalAlign: {
                    label: "\u5361\u7247\u5185\u5bb9\u6c34\u5e73\u5bf9\u9f50",
                    type: "select",
                    items: [
                      { label: "\u5de6\u5bf9\u9f50", value: "left-align" },
                      {
                        label: "\u5c45\u4e2d\u5bf9\u9f50",
                        value: "center-align",
                      },
                      { label: "\u53f3\u5bf9\u9f50", value: "right-align" },
                    ],
                  },
                  paddingTop: {
                    label: "\u5361\u7247\u4e0a\u8fb9\u8ddd",
                    type: "string",
                  },
                  paddingBottom: {
                    label: "\u5361\u7247\u4e0b\u8fb9\u8ddd",
                    type: "string",
                  },
                  paddingLeft: {
                    label: "\u5361\u7247\u5de6\u8fb9\u8ddd",
                    type: "string",
                  },
                  paddingRight: {
                    label: "\u5361\u7247\u53f3\u8fb9\u8ddd",
                    type: "string",
                  },
                  cardMinHeight: {
                    label: "\u5361\u7247\u6700\u5c0f\u9ad8\u5ea6",
                    type: "string",
                  },
                  cardRadius: {
                    label: "\u5361\u7247\u5706\u89d2",
                    type: "string",
                  },
                  pureBackgroundColor: {
                    label: "\u5361\u7247\u80cc\u666f\u8272",
                    type: "string",
                    content: "color",
                  },
                  backgroundGradient: {
                    label: "\u5361\u7247\u80cc\u666f\u6e10\u53d8\u8272",
                    type: "string",
                    content: "color",
                  },
                },
              },
              backgroudImage: {
                label: "\u5361\u7247\u80cc\u666f\u56fe\u7247",
                switch: "hasBackgroundImage",
                props: {
                  backgroundImage: {
                    label: "\u80cc\u666f\u56fe",
                    type: "image",
                  },
                  backgroundPosition: {
                    label: "\u80cc\u666f\u4f4d\u7f6e",
                    type: "string",
                  },
                  backgroundSize: {
                    label: "\u80cc\u666f\u5c3a\u5bf8",
                    type: "select",
                    items: [
                      {
                        label: "\u5168\u5c4f\u81ea\u9002\u5e94",
                        value: "auto-fit",
                      },
                      { label: "\u81ea\u5b9a\u4e49css", value: "custom-css" },
                    ],
                  },
                  backgroundSizeCustom: {
                    label: "\u80cc\u666f\u5c3a\u5bf8\u81ea\u5b9a\u4e49css",
                    type: "string",
                    controlBy: "backgroundSize",
                    controlValue: "custom-css",
                  },
                  backgroundRepeat: {
                    label: "\u80cc\u666f\u91cd\u590d\u65b9\u5f0f",
                    type: "select",
                    items: [
                      {
                        label: "\u6c34\u5e73\u5782\u76f4\u91cd\u590d",
                        value: "repeat",
                      },
                      { label: "\u6c34\u5e73\u91cd\u590d", value: "repeat-x" },
                      { label: "\u5782\u76f4\u91cd\u590d", value: "repeat-y" },
                      { label: "\u4e0d\u91cd\u590d", value: "no-repeat" },
                    ],
                  },
                  backgroundParallax: {
                    label: "\u80cc\u666f\u7eb5\u5411\u6eda\u52a8\u89c6\u5dee",
                    type: "boolean",
                  },
                  backgroundImageWidth: {
                    label: "\u80cc\u666f\u56fe\u672c\u8eab\u7684\u5bbd\u5ea6",
                    type: "string",
                    content: "size",
                  },
                  backgroundImageHeight: {
                    label: "\u80cc\u666f\u56fe\u672c\u8eab\u7684\u9ad8\u5ea6",
                    type: "string",
                    content: "size",
                  },
                },
              },
              backgroudVideo: {
                label: "\u5361\u7247\u80cc\u666f\u89c6\u9891",
                switch: "hasBackgroundVideo",
                props: {
                  backgroundVideoLoop: {
                    label: "\u80cc\u666f\u89c6\u9891\u5faa\u73af\u64ad\u653e",
                    type: "boolean",
                  },
                  backgroundVideoVisiblePlay: {
                    label:
                      "\u9875\u9762\u6eda\u52a8\u540e\u89e6\u53d1\u64ad\u653e",
                    type: "boolean",
                  },
                  backgroundVideoHoverPlay: {
                    label: "\u9f20\u6807hover\u64ad\u653e",
                    type: "boolean",
                  },
                  backgroundVideo: {
                    label: "\u80cc\u666f\u89c6\u9891\u94fe\u63a5",
                    type: "string",
                    content: "url",
                  },
                  backgroundVideoWebm: {
                    label:
                      "\u80cc\u666f\u89c6\u9891\u94fe\u63a5\uff08webm\u683c\u5f0f, \u9009\u586b\uff09",
                    type: "string",
                    content: "url",
                  },
                  backgroundVideoPoster: {
                    label: "\u80cc\u666f\u89c6\u9891poster",
                    type: "image",
                  },
                  backgroundVideoMaskColor: {
                    label:
                      "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u8272\u53f7 (\u9ed8\u8ba4#000000)",
                    type: "string",
                  },
                  backgroundVideoMaskOpacity: {
                    label:
                      "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u4e0d\u900f\u660e\u5ea6 (0-1, \u9ed8\u8ba40)",
                    type: "string",
                  },
                },
              },
              foreContent: {
                label: "\u524d\u666f\u5185\u5bb9",
                switch: "hasForeContent",
                props: {
                  foreContentType: {
                    label: "\u524d\u666f\u5185\u5bb9\u9009\u62e9",
                    type: "select",
                    items: [
                      { label: "\u56fe\u7247", value: "image" },
                      { label: "\u89c6\u9891", value: "video" },
                    ],
                  },
                  foreVideo: {
                    label:
                      "------------------------------------\u524d\u666f\u89c6\u9891------------------------------------",
                    type: "string",
                    content: "url",
                    controlBy: "foreContentType",
                    controlValue: "video",
                  },
                  foreVideoColor: {
                    label:
                      "\u524d\u666f\u89c6\u9891\u989c\u8272\u6309\u94ae\u9009\u62e9",
                    type: "select",
                    items: [
                      { label: "\u767d\u8272", value: "light" },
                      { label: "\u9ed1\u8272", value: "dark" },
                    ],
                    controlBy: "foreContentType",
                    controlValue: "video",
                  },
                  foreVideoWebm: {
                    label:
                      "\u524d\u666f\u89c6\u9891\u683c\u5f0f\uff08webm\u683c\u5f0f, \u9009\u586b\uff09",
                    type: "string",
                    content: "url",
                    controlBy: "foreContentType",
                    controlValue: "video",
                  },
                  foreVideoPoster: {
                    label: "\u524d\u666f\u89c6\u9891\u5c01\u9762\u56fe",
                    type: "image",
                    controlBy: "foreContentType",
                    controlValue: "video",
                  },
                  foreVideoPlay: {
                    label: " \u89c6\u9891\u64ad\u653e\u65b9\u5f0f",
                    type: "select",
                    items: [
                      { label: "\u5faa\u73af\u64ad\u653e", value: "repeat" },
                      { label: "\u64ad\u653e\u4e00\u6b21", value: "once" },
                      {
                        label:
                          "\u64ad\u653e\u4e00\u6b21\u505c\u6b62\uff0c\u56de\u5230\u8be5\u5c4f\u81ea\u52a8\u64ad\u653e",
                        value: "every",
                      },
                      {
                        value: "withController",
                        label:
                          "\u53ef\u63a7\u5236\u505c\u6b62/\u64ad\u653e/\u91cd\u64ad",
                      },
                    ],
                    controlBy: "foreContentType",
                    controlValue: "video",
                  },
                  foreImage: {
                    label:
                      "------------------------------------\u524d\u666f\u56fe\u7247------------------------------------",
                    type: "image",
                    controlBy: "foreContentType",
                    controlValue: "image",
                  },
                  foreImageAlt: {
                    label: "\u524d\u666f\u56fe\u7247 Alt",
                    type: "string",
                    key: "picture-alt",
                    content: "text",
                    controlBy: "foreContentType",
                    controlValue: "image",
                  },
                  foregroundHasParallax: {
                    type: "boolean",
                    label: "\u524d\u666f\u89c6\u5dee",
                    controlBy: "foreContentType",
                    controlValue: "image",
                  },
                  foregroundParallax: {
                    type: "select",
                    label: "\u524d\u666f\u89c6\u5dee\u65b9\u5f0f",
                    controlBy: "foregroundHasParallax",
                    controlValue: "true",
                    items: [
                      {
                        value: "whole-item",
                        label: "\u6574\u4f53\u89c6\u5dee",
                      },
                      {
                        value: "inner-content",
                        label: "\u5185\u90e8\u89c6\u5dee",
                      },
                    ],
                  },
                  foregroundHeight: {
                    type: "string",
                    label:
                      "\u524d\u666f\u5185\u5bb9\u9ad8\u5ea6(\u5f53\u9009\u62e9\u524d\u666f\u5185\u90e8\u89c6\u5dee\u65f6\u624d\u751f\u6548)",
                    content: "size",
                    controlBy: "foregroundHasParallax",
                    controlValue: "true",
                  },
                  foreContentGap: {
                    label: "\u8ddd\u6587\u672c\u8ddd\u79bb",
                    type: "string",
                  },
                  foreContentPosition: {
                    label: "\u524d\u666f\u5185\u5bb9\u9009\u62e9",
                    type: "select",
                    items: [
                      {
                        label: "\u4e0a\u56fe\u4e0b\u6587",
                        value: "image-text",
                      },
                      {
                        label: "\u4e0a\u6587\u4e0b\u56fe",
                        value: "text-image",
                      },
                    ],
                  },
                  foreContentRadius: {
                    label: "\u524d\u666f\u56fe\u7247/\u89c6\u9891\u5706\u89d2",
                    type: "string",
                  },
                },
              },
              textContent: {
                label: "\u6587\u672c\u5185\u5bb9\u5e03\u5c40",
                props: {
                  contentPaddingTop: {
                    label: "\u6587\u672c\u5185\u5bb9\u4e0a\u8fb9\u8ddd",
                    type: "string",
                  },
                  contentPaddingBottom: {
                    label: "\u6587\u672c\u5185\u5bb9\u4e0b\u8fb9\u8ddd",
                    type: "string",
                  },
                  contentPaddingLeft: {
                    label: "\u6587\u672c\u5185\u5bb9\u5de6\u8fb9\u8ddd",
                    type: "string",
                  },
                  contentPaddingRight: {
                    label: "\u6587\u672c\u5185\u5bb9\u53f3\u8fb9\u8ddd",
                    type: "string",
                  },
                },
              },
              toppingImage: {
                label: "\u9876\u90e8\u56fe\u7247",
                switch: "hasToppingImage",
                props: {
                  toppingImage: {
                    label: "\u9876\u90e8\u56fe\u7247",
                    type: "image",
                  },
                  toppingImageHeight: {
                    label: "\u56fe\u7247\u9ad8\u5ea6",
                    type: "string",
                  },
                  toppingAlt: {
                    label:
                      "\u9876\u90e8\u56fe\u7247\u81ea\u5b9a\u4e49alt\u6587\u6848",
                    type: "string",
                    content: "text",
                  },
                },
              },
              eyebrow: {
                label: "\u7709\u5934",
                switch: "hasEyeBrow",
                props: {
                  eyeBrowText: {
                    label: "\u7709\u5934",
                    type: "string",
                    key: "eyebrow",
                    content: "text",
                  },
                  eyeBrowType: {
                    label: "\u7709\u5934\u7c7b\u578b",
                    type: "select",
                    items: [
                      { label: "svg", value: "svg" },
                      { label: "\u7eaf\u8272\u6587\u6848", value: "pure-text" },
                      {
                        label: "\u6e10\u53d8\u6587\u6848",
                        value: "gradient-text",
                      },
                    ],
                  },
                  eyeBrowTag: W({}, c.g),
                  eyeBrowMaxWidth: {
                    label: "eyebrow\u5bb9\u5668\u7684\u6700\u5927\u5bbd\u5ea6",
                    type: "string",
                    content: "size",
                  },
                  eyeBrowSVG: {
                    label: "svg",
                    type: "image",
                    controlBy: "eyeBrowType",
                    controlValue: "svg",
                  },
                  eyeBrowSVGHeight: {
                    label: "svg\u9ad8\u5ea6",
                    type: "string",
                    controlBy: "eyeBrowType",
                    controlValue: "svg",
                  },
                  eyeBrowSvgShowFirst: {
                    label:
                      "svg\u662f\u5426\u5728\u9996\u5c4f\u663e\u793a\uff0c\u5982\u52fe\u9009\uff0c\u4f1a\u4f18\u5148\u52a0\u8f7d svg",
                    type: "boolean",
                    controlBy: "eyeBrowType",
                    controlValue: "svg",
                  },
                  eyeBrowPureColor: {
                    label: "\u7eaf\u8272\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                    content: "color",
                    controlBy: "eyeBrowType",
                    controlValue: "pure-text",
                  },
                  eyeBrowGradientColor: {
                    label: "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                    content: "color",
                    controlBy: "eyeBrowType",
                    controlValue: "gradient-text",
                  },
                  eyeBrowIEGradientColor: {
                    label:
                      "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c-IE\u964d\u7ea7",
                    type: "string",
                    content: "color",
                    controlBy: "eyeBrowType",
                    controlValue: "gradient-text",
                  },
                  eyeBrowFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    controlBy: "eyeBrowType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                      { label: "88px", value: "88px" },
                      { label: "96px", value: "96px" },
                      { label: "104px", value: "104px" },
                      { label: "112px", value: "112px" },
                      { label: "120px", value: "120px" },
                    ],
                  },
                  eyeBrowFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    controlBy: "eyeBrowType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  eyeBrowLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "eyeBrowFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              headline: {
                label: "\u4e3b\u6807\u9898\u8bbe\u7f6e",
                switch: "hasHeadline",
                props: {
                  headlineType: {
                    label: "\u4e3b\u6807\u9898\u7c7b\u578b",
                    type: "select",
                    items: [
                      {
                        label: "svg / SEO \u9690\u85cf\u5f0f\u6807\u9898",
                        value: "svg",
                      },
                      { label: "\u7eaf\u8272\u6587\u6848", value: "pure-text" },
                      {
                        label: "\u6e10\u53d8\u6587\u6848",
                        value: "gradient-text",
                      },
                    ],
                  },
                  headlineText: {
                    label: "\u4e3b\u6807\u9898",
                    type: "string",
                    key: "headline",
                    content: "text",
                    controlBy: "headlineType",
                    controlValue: ["pure-text", "gradient-text"],
                  },
                  headlineTag: W({}, c.g),
                  headlineMaxWidth: {
                    label: "\u4e3b\u6807\u9898\u6700\u5927\u5bbd\u5ea6",
                    type: "string",
                    content: "size",
                  },
                  headlineSVG: {
                    label: "svg",
                    type: "image",
                    controlBy: "headlineType",
                    controlValue: "svg",
                  },
                  headlineSVGHeight: {
                    label: "svg\u9ad8\u5ea6",
                    type: "string",
                    controlBy: "headlineType",
                    controlValue: "svg",
                  },
                  headlineSvgShowFirst: {
                    label:
                      "svg\u662f\u5426\u5728\u9996\u5c4f\u663e\u793a\uff0c\u5982\u52fe\u9009\uff0c\u4f1a\u4f18\u5148\u52a0\u8f7d svg",
                    type: "boolean",
                    controlBy: "headlineType",
                    controlValue: "svg",
                  },
                  headlinePureColor: {
                    label: "\u7eaf\u8272\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                    content: "color",
                    controlBy: "headlineType",
                    controlValue: "pure-text",
                  },
                  headlineGradientColor: {
                    label: "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                    content: "color",
                    controlBy: "headlineType",
                    controlValue: "gradient-text",
                  },
                  headlineIEGradientColor: {
                    label:
                      "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c-IE\u964d\u7ea7",
                    type: "string",
                    content: "color",
                    controlBy: "headlineType",
                    controlValue: "gradient-text",
                  },
                  headlineFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    controlBy: "headlineType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                      { label: "88px", value: "88px" },
                      { label: "96px", value: "96px" },
                      { label: "104px", value: "104px" },
                      { label: "112px", value: "112px" },
                      { label: "120px", value: "120px" },
                    ],
                  },
                  headlineFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    controlBy: "headlineType",
                    controlValue: "pure-text gradient-text",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  headlineLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "headlineFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              subHeadline: {
                label: "\u526f\u6807\u9898",
                switch: "hasSubHeadline",
                props: {
                  subHeadlineType: {
                    label: "\u526f\u6807\u9898\u7c7b\u578b",
                    type: "select",
                    items: [
                      { label: "\u7eaf\u8272\u6587\u6848", value: "pure-text" },
                      {
                        label: "\u6e10\u53d8\u6587\u6848",
                        value: "gradient-text",
                      },
                    ],
                  },
                  subHeadlineText: {
                    label: "\u526f\u6807\u9898",
                    type: "string",
                    key: "subtitle",
                    content: "text",
                    controlBy: "subHeadlineType",
                    controlValue: ["pure-text", "gradient-text"],
                  },
                  subHeadlineTag: W({}, c.g),
                  subHeadlineMaxWidth: {
                    label: "\u526f\u6807\u9898\u6700\u5927\u5bbd\u5ea6",
                    type: "string",
                    content: "size",
                  },
                  subHeadlineColor: {
                    label: "\u7eaf\u8272\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                    content: "color",
                    controlBy: "subHeadlineType",
                    controlValue: "pure-text",
                  },
                  subHeadlineGradientColor: {
                    label: "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                    content: "color",
                    controlBy: "subHeadlineType",
                    controlValue: "gradient-text",
                  },
                  subHeadlineIEGradientColor: {
                    label:
                      "\u6e10\u53d8\u6587\u6848\u989c\u8272\u503c-IE\u964d\u7ea7",
                    type: "string",
                    content: "color",
                    controlBy: "subHeadlineType",
                    controlValue: "gradient-text",
                  },
                  subHeadlineFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    controlBy: "subHeadlineType",
                    controlValue: ["pure-text", "gradient-text"],
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                      { label: "88px", value: "88px" },
                      { label: "96px", value: "96px" },
                      { label: "104px", value: "104px" },
                      { label: "112px", value: "112px" },
                      { label: "120px", value: "120px" },
                    ],
                  },
                  subHeadlineFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    controlBy: "subHeadlineType",
                    controlValue: ["pure-text", "gradient-text"],
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  subHeadlineLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "subHeadlineFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              devide: {
                label: "\u5206\u5272\u7ebf",
                switch: "hasDividedLine",
                props: {
                  dividedBlockHeight: {
                    label: "\u6a21\u5757\u9ad8\u5ea6",
                    type: "string",
                  },
                  dividedLineWidth: {
                    label: "\u7ebf\u6761\u5bbd\u5ea6",
                    type: "string",
                  },
                  dividedLineHeight: { label: "\u9ad8\u5ea6", type: "string" },
                  dividedLineRadius: { label: "\u5706\u89d2", type: "string" },
                  dividedLineColor: { label: "\u989c\u8272", type: "string" },
                  dividedLineGradientColor: {
                    label: "\u6e10\u53d8\u8272",
                    type: "string",
                  },
                },
              },
              description: {
                label: "\u8be6\u7ec6\u4ecb\u7ecd",
                switch: "hasDescription",
                props: {
                  descriptionText: {
                    label: "\u8be6\u7ec6\u4ecb\u7ecd",
                    type: "string",
                    key: "description",
                    content: "text",
                  },
                  descriptionColor: {
                    label: "\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                  },
                  descriptionMinHeight: {
                    label: "\u6587\u6848\u6700\u5c0f\u9ad8\u5ea6",
                    type: "string",
                  },
                  descriptionMaxWidth: {
                    label: "\u8be6\u7ec6\u4ecb\u7ecd\u6700\u5927\u5bbd\u5ea6",
                    type: "string",
                    content: "size",
                  },
                  descriptionFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                      { label: "88px", value: "88px" },
                      { label: "96px", value: "96px" },
                      { label: "104px", value: "104px" },
                      { label: "112px", value: "112px" },
                      { label: "120px", value: "120px" },
                    ],
                  },
                  descriptionFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  descriptionLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "descriptionFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              primaryButton: {
                label: "\u4e3b\u6309\u94ae",
                switch: "hasPrimaryButton",
                props: W(
                  W(
                    {
                      primaryButtonType: {
                        label: "\u7c7b\u578b",
                        type: "select",
                        items: V,
                      },
                    },
                    G[0],
                  ),
                  {},
                  {
                    primaryButtonColor: {
                      label: "\u989c\u8272",
                      type: "select",
                      helptext:
                        "SalesPoint\u5f39\u7a97\u8bbe\u7f6e\u84dd\u8272\u4e0d\u751f\u6548",
                      items: [
                        { label: "\u9ed1\u8272", value: "dark" },
                        { label: "\u767d\u8272", value: "light" },
                        { label: "\u84dd\u8272", value: "primary" },
                      ],
                    },
                    primaryButtonLink: {
                      label: "url",
                      type: "string",
                      content: "url",
                    },
                    primaryButtonText: {
                      label: "\u6587\u6848",
                      type: "string",
                      key: "button-text",
                      content: "text",
                    },
                    primaryButtonGaLabel: W({}, U),
                    primaryButtonMinWidth: {
                      label: "\u6700\u5c0f\u5bbd\u5ea6",
                      type: "string",
                    },
                    primaryButtonSize: {
                      label: "\u6309\u94ae\u5c3a\u5bf8",
                      type: "select",
                      items: [
                        { label: "xl(48)", value: "x-large" },
                        { label: "l(40)", value: "large" },
                        { label: "m(32)", value: "medium" },
                        { label: "s(24)", value: "small" },
                      ],
                    },
                  },
                ),
              },
              secondaryButton: {
                label: "\u6b21\u6309\u94ae",
                switch: "hasSecondaryButton",
                props: W(
                  W(
                    {
                      secondaryButtonType: {
                        label: "\u7c7b\u578b",
                        type: "select",
                        items: V,
                      },
                    },
                    G[1],
                  ),
                  {},
                  {
                    secondaryButtonColor: {
                      label: "\u989c\u8272",
                      type: "select",
                      items: [
                        { label: "\u9ed1\u8272", value: "secondary-dark" },
                        { label: "\u767d\u8272", value: "secondary-light" },
                      ],
                    },
                    secondaryButtonLink: {
                      label: "url",
                      type: "string",
                      content: "url",
                    },
                    secondaryButtonText: {
                      label: "\u6587\u6848",
                      type: "string",
                      key: "second-text",
                      content: "text",
                    },
                    secondaryButtonGaLabel: W({}, U),
                    secondaryButtonMinWidth: {
                      label: "\u6700\u5c0f\u5bbd\u5ea6",
                      type: "string",
                    },
                    secondaryButtonSize: {
                      label: "\u6309\u94ae\u5c3a\u5bf8",
                      type: "select",
                      items: [
                        { label: "xl(48)", value: "x-large" },
                        { label: "l(40)", value: "large" },
                        { label: "m(32)", value: "medium" },
                        { label: "s(24)", value: "small" },
                      ],
                    },
                  },
                ),
              },
              downloadButton: {
                label: "\u4e0b\u8f7d\u6309\u94ae",
                switch: "hasDownloadButton",
                props: {
                  hasAppStoreButton: {
                    label: "app store\u4e0b\u8f7d",
                    type: "boolean",
                  },
                  hasAndroidButton: {
                    label: "android\u4e0b\u8f7d",
                    type: "boolean",
                  },
                  hasGooglePlayButton: {
                    label: "google play\u4e0b\u8f7d",
                    type: "boolean",
                  },
                  appStoreButtonLink: {
                    label: "app store\u4e0b\u8f7durl",
                    type: "string",
                    content: "url",
                  },
                  appStoreButtonGaLabel: W({}, U),
                  androidButtonLink: {
                    label: "android\u4e0b\u8f7durl",
                    type: "string",
                    content: "url",
                  },
                  androidButtonGaLabel: W({}, U),
                  googlePlayButtonLink: {
                    label: "google\u4e0b\u8f7durl",
                    type: "string",
                    content: "url",
                  },
                  googlePlayButtonGaLabel: W({}, U),
                },
              },
              modalButton: s.k.modalButton,
              noteText: {
                label: "\u5907\u6ce8",
                switch: "hasNote",
                props: {
                  noteText: {
                    label: "\u5907\u6ce8",
                    type: "string",
                    key: "remark",
                    content: "text",
                  },
                  noteMarginTop: {
                    type: "string",
                    label: "\u5907\u6ce8\u4e0a\u8fb9\u8ddd",
                  },
                  noteColor: {
                    label: "\u6587\u6848\u989c\u8272\u503c",
                    type: "string",
                  },
                  noteFontSize: {
                    label: "\u5b57\u53f7",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                      { label: "88px", value: "88px" },
                      { label: "96px", value: "96px" },
                      { label: "104px", value: "104px" },
                      { label: "112px", value: "112px" },
                      { label: "120px", value: "120px" },
                    ],
                  },
                  noteFontWeight: {
                    label: "\u5b57\u91cd",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "Regular", value: "regular" },
                      { label: "SemiBold", value: "semibold" },
                    ],
                  },
                  noteLineHeight: {
                    label: "\u884c\u9ad8",
                    type: "select",
                    controlBy: "noteFontSize",
                    controlValue: !0,
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              links: {
                label: "\u94fe\u63a5",
                switch: "hasLinks",
                props: {
                  links: {
                    label: "\u94fe\u63a5",
                    type: "array",
                    props: {
                      linkType: {
                        label: "\u7c7b\u578b",
                        type: "select",
                        items: [
                          {
                            label: "\u7ad9\u5185\u94fe\u63a5",
                            value: "internal-link",
                          },
                          {
                            label: "\u7ad9\u5916\u94fe\u63a5",
                            value: "external-link",
                          },
                          {
                            label: "\u4e0b\u8f7d\u94fe\u63a5",
                            value: "download-link",
                          },
                          {
                            label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                            value: "no-icon-link",
                          },
                        ],
                      },
                      linkUrl: {
                        label: "\u94fe\u63a5url",
                        type: "string",
                        content: "url",
                      },
                      linkText: {
                        label: "\u94fe\u63a5\u6587\u6848",
                        type: "string",
                        key: "link-text",
                        content: "text",
                      },
                      linkGaLabel: {
                        label: "ga-label",
                        type: "string",
                        content: "text",
                      },
                    },
                  },
                  linkColor: {
                    label: "\u94fe\u63a5\u989c\u8272",
                    type: "select",
                    items: [
                      { label: "black-main", value: "black" },
                      { label: "white-main", value: "white" },
                      { label: "primary-on-dark(blue-4)", value: "dark" },
                      { label: "primary-on-light(blue-6)", value: "normal" },
                    ],
                  },
                  linkFontSize: {
                    label: "\u94fe\u63a5\u5b57\u53f7",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "10px", value: "10px" },
                      { label: "12px", value: "12px" },
                      { label: "14px", value: "14px" },
                      { label: "16px", value: "16px" },
                      { label: "18px", value: "18px" },
                      { label: "20px", value: "20px" },
                      { label: "24px", value: "24px" },
                      { label: "28px", value: "28px" },
                      { label: "32px", value: "32px" },
                      { label: "40px", value: "40px" },
                      { label: "48px", value: "48px" },
                      { label: "56px", value: "56px" },
                      { label: "64px", value: "64px" },
                      { label: "72px", value: "72px" },
                      { label: "80px", value: "80px" },
                      { label: "88px", value: "88px" },
                      { label: "96px", value: "96px" },
                      { label: "104px", value: "104px" },
                      { label: "112px", value: "112px" },
                      { label: "120px", value: "120px" },
                    ],
                  },
                  linkLineHeight: {
                    label: "\u94fe\u63a5\u884c\u9ad8",
                    type: "select",
                    items: [
                      { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                      { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
                      { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
                    ],
                  },
                },
              },
              iconsFirstRow: {
                label: "\u7b2c\u4e00\u884cIcon",
                switch: "hasIconsFirstRow",
                props: {
                  iconsLayoutFirstRow: {
                    label: "icon\u5e03\u5c40",
                    type: "select",
                    items: [
                      {
                        label: "\u4e0a\u56fe\u4e0b\u6587",
                        value: "image-text",
                      },
                      {
                        label: "\u4e0a\u6587\u4e0b\u56fe",
                        value: "text-image",
                      },
                      {
                        label: "\u5de6\u56fe\u53f3\u6587",
                        value: "horizontal",
                      },
                    ],
                  },
                  iconsFirstMaxWidth: {
                    type: "string",
                    label:
                      "icon\u6240\u6709\u5185\u5bb9\u6700\u5927\u5bbd\u5ea6",
                    content: "size",
                  },
                  iconsFirstHeight: {
                    type: "string",
                    label: "icon\u9ad8\u5ea6",
                    content: "size",
                  },
                  iconsFirstRow: {
                    label: "icons",
                    type: "array",
                    key: "icons1",
                    props: {
                      title: {
                        label: "\u6807\u9898",
                        type: "string",
                        content: "text",
                        key: "text",
                        switch: "hasTitle",
                      },
                      icon: { label: "icon", type: "image", switch: "hasIcon" },
                      iconAlt: {
                        label: "icon\u81ea\u5b9a\u4e49alt\u6587\u6848",
                        helptext:
                          "\u9009\u586b\uff0c\u4e3a\u7a7a\u65f6\u56fe\u7247alt\u9ed8\u8ba4\u53d6icon\u6807\u9898/\u63cf\u8ff0",
                        type: "string",
                        content: "text",
                      },
                      desc: {
                        label: "\u63cf\u8ff0",
                        type: "string",
                        key: "description",
                        content: "text",
                        switch: "hasDesc",
                      },
                      number: {
                        switch: "hasNumber",
                        label: "\u6570\u5b57",
                        type: "string",
                        key: "number",
                        content: "text",
                      },
                      unit: {
                        switch: "hasUnit",
                        label: "\u5355\u4f4d",
                        type: "string",
                        key: "unit",
                        content: "text",
                      },
                      titleColor: {
                        label:
                          "\u6807\u9898/\u6570\u5b57/\u5355\u4f4d\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      descColor: {
                        label: "\u63cf\u8ff0\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      titleFontSize: {
                        label: "\u6807\u9898\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                          { label: "88px", value: "88px" },
                          { label: "96px", value: "96px" },
                          { label: "104px", value: "104px" },
                          { label: "112px", value: "112px" },
                          { label: "120px", value: "120px" },
                        ],
                      },
                      titleFontWeight: {
                        label: "\u6807\u9898\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      titleLineHeight: {
                        label: "\u6807\u9898\u884c\u9ad8",
                        type: "select",
                        controlBy: "titleFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                      descFontSize: {
                        label: "\u63cf\u8ff0\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                          { label: "88px", value: "88px" },
                          { label: "96px", value: "96px" },
                          { label: "104px", value: "104px" },
                          { label: "112px", value: "112px" },
                          { label: "120px", value: "120px" },
                        ],
                      },
                      descFontWeight: {
                        label: "\u63cf\u8ff0\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      descLineHeight: {
                        label: "\u63cf\u8ff0\u884c\u9ad8",
                        type: "select",
                        controlBy: "descFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                    },
                  },
                },
              },
              iconsSecondRow: {
                label: "\u7b2c\u4e8c\u884cIcon",
                switch: "hasIconsSecondRow",
                props: {
                  iconsLayoutSecondRow: {
                    label: "icon\u5e03\u5c40",
                    type: "select",
                    items: [
                      {
                        label: "\u4e0a\u56fe\u4e0b\u6587",
                        value: "image-text",
                      },
                      {
                        label: "\u4e0a\u6587\u4e0b\u56fe",
                        value: "text-image",
                      },
                      {
                        label: "\u5de6\u56fe\u53f3\u6587",
                        value: "horizontal",
                      },
                    ],
                  },
                  iconsSecondMaxWidth: {
                    type: "string",
                    label:
                      "icon\u6240\u6709\u5185\u5bb9\u6700\u5927\u5bbd\u5ea6",
                    content: "size",
                  },
                  iconsSecondHeight: {
                    type: "string",
                    label: "icon\u9ad8\u5ea6",
                    content: "size",
                  },
                  iconsSecondRow: {
                    label: "icons",
                    type: "array",
                    key: "icons2",
                    props: {
                      title: {
                        label: "\u6807\u9898",
                        type: "string",
                        content: "text",
                        key: "text",
                        switch: "hasTitle",
                      },
                      icon: { label: "icon", type: "image", switch: "hasIcon" },
                      iconAlt: {
                        label: "icon\u81ea\u5b9a\u4e49alt\u6587\u6848",
                        helptext:
                          "\u9009\u586b\uff0c\u4e3a\u7a7a\u65f6\u56fe\u7247alt\u9ed8\u8ba4\u53d6icon\u6807\u9898/\u63cf\u8ff0",
                        type: "string",
                        content: "text",
                      },
                      desc: {
                        label: "\u63cf\u8ff0",
                        type: "string",
                        content: "text",
                        key: "description",
                        switch: "hasDesc",
                      },
                      number: {
                        switch: "hasNumber",
                        label: "\u6570\u5b57",
                        type: "string",
                        content: "text",
                        key: "number",
                      },
                      unit: {
                        switch: "hasUnit",
                        label: "\u5355\u4f4d",
                        type: "string",
                        content: "text",
                        key: "unit",
                      },
                      titleColor: {
                        label:
                          "\u6807\u9898/\u6570\u5b57/\u5355\u4f4d\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      descColor: {
                        label: "\u63cf\u8ff0\u989c\u8272",
                        type: "string",
                        content: "color",
                      },
                      titleFontSize: {
                        label: "\u6807\u9898\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                          { label: "88px", value: "88px" },
                          { label: "96px", value: "96px" },
                          { label: "104px", value: "104px" },
                          { label: "112px", value: "112px" },
                          { label: "120px", value: "120px" },
                        ],
                      },
                      titleFontWeight: {
                        label: "\u6807\u9898\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      titleLineHeight: {
                        label: "\u6807\u9898\u884c\u9ad8",
                        type: "select",
                        controlBy: "titleFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                      descFontSize: {
                        label: "\u63cf\u8ff0\u5b57\u53f7",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "10px", value: "10px" },
                          { label: "12px", value: "12px" },
                          { label: "14px", value: "14px" },
                          { label: "16px", value: "16px" },
                          { label: "18px", value: "18px" },
                          { label: "20px", value: "20px" },
                          { label: "24px", value: "24px" },
                          { label: "28px", value: "28px" },
                          { label: "32px", value: "32px" },
                          { label: "40px", value: "40px" },
                          { label: "48px", value: "48px" },
                          { label: "56px", value: "56px" },
                          { label: "64px", value: "64px" },
                          { label: "72px", value: "72px" },
                          { label: "80px", value: "80px" },
                          { label: "88px", value: "88px" },
                          { label: "96px", value: "96px" },
                          { label: "104px", value: "104px" },
                          { label: "112px", value: "112px" },
                          { label: "120px", value: "120px" },
                        ],
                      },
                      descFontWeight: {
                        label: "\u63cf\u8ff0\u5b57\u91cd",
                        type: "select",
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          { label: "Regular", value: "regular" },
                          { label: "SemiBold", value: "semibold" },
                        ],
                      },
                      descLineHeight: {
                        label: "\u63cf\u8ff0\u884c\u9ad8",
                        type: "select",
                        controlBy: "descFontSize",
                        controlValue: !0,
                        items: [
                          { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
                          {
                            label: "\u7d27\u51d1\u884c\u9ad8",
                            value: "compact",
                          },
                          {
                            label: "\u6807\u51c6\u884c\u9ad8",
                            value: "standard",
                          },
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
        skinSetting: {
          timing: {
            label: "\u5b9a\u65f6\u5668\u8bbe\u7f6e",
            props: {
              needTiming: {
                label: "\u662f\u5426\u5f00\u542f\u5b9a\u65f6\u5668",
                type: "boolean",
              },
              onLineTimeSetting: {
                label: "\u4e0a\u7ebf\u65f6\u95f4",
                type: "date",
                controlBy: "needTiming",
                controlValue: !0,
              },
              outLineTimeSetting: {
                label: "\u4e0b\u7ebf\u65f6\u95f4",
                type: "date",
                controlBy: "needTiming",
                controlValue: !0,
              },
            },
          },
          layout: {
            label: "\u5e03\u5c40",
            props: {
              cardGapWidth: { label: "\u69fd\u5bbd", type: "string" },
              gridWidth: { label: "\u6805\u683c\u603b\u5bbd", type: "string" },
              componentMinHeight: {
                label: "\u6a21\u5757\u6700\u5c0f\u9ad8\u5ea6",
                type: "string",
              },
              componentVerticalAlign: {
                label: "\u5361\u7247\u5782\u76f4\u5bf9\u9f50",
                type: "select",
                items: [
                  { label: "\u5c45\u4e0a\u5bf9\u9f50", value: "top-align" },
                  { label: "\u5c45\u4e2d\u5bf9\u9f50", value: "center-align" },
                  { label: "\u5c45\u4e0b\u5bf9\u9f50", value: "bottom-align" },
                ],
              },
              cardsStretch: {
                label:
                  "\u5361\u7247\u9ad8\u5ea6\u7edf\u4e00\u6491\u6ee1(\u52fe\u4e0a\u540e\u5782\u76f4\u5bf9\u9f50\u5931\u6548)",
                type: "boolean",
              },
              paddingTop: {
                label: "\u6a21\u5757\u4e0a\u8fb9\u8ddd",
                type: "string",
              },
              paddingBottom: {
                label: "\u6a21\u5757\u4e0b\u8fb9\u8ddd",
                type: "string",
              },
              paddingLeft: {
                label: "\u6a21\u5757\u5de6\u8fb9\u8ddd",
                type: "string",
              },
              paddingRight: {
                label: "\u6a21\u5757\u53f3\u8fb9\u8ddd",
                type: "string",
              },
            },
          },
          backgroundColor: {
            label: "\u80cc\u666f\u989c\u8272\u8bbe\u7f6e",
            props: {
              backgroundColor: {
                label: "\u80cc\u666f\u989c\u8272",
                type: "string",
                content: "color",
              },
              backgroundGradient: {
                label: "\u80cc\u666f\u6e10\u53d8\u8272",
                type: "string",
                content: "color",
              },
            },
          },
          backgroud: {
            label: "\u80cc\u666f\u56fe\u7247\u8bbe\u7f6e",
            switch: "hasBackgroundImage",
            props: {
              backgroundImage: { label: "\u80cc\u666f\u56fe", type: "image" },
              backgroundPosition: {
                label: "\u80cc\u666f\u4f4d\u7f6e",
                type: "string",
              },
              backgroundSize: {
                label: "\u80cc\u666f\u5c3a\u5bf8",
                type: "select",
                items: [
                  {
                    label: "\u5168\u5c4f\u81ea\u9002\u5e94",
                    value: "auto-fit",
                  },
                  {
                    label: "\u81ea\u5b9a\u4e49css\u5c5e\u6027",
                    value: "custom-css",
                  },
                ],
              },
              backgroundSizeCustom: {
                label: "\u80cc\u666f\u81ea\u5b9a\u4e49css",
                type: "string",
                controlBy: "backgroundSize",
                controlValue: "custom-css",
              },
              backgroundRepeat: {
                label: "\u80cc\u666f\u91cd\u590d\u65b9\u5f0f",
                type: "select",
                items: [
                  {
                    label: "\u6c34\u5e73\u5782\u76f4\u91cd\u590d",
                    value: "repeat",
                  },
                  { label: "\u6c34\u5e73\u91cd\u590d", value: "repeat-x" },
                  { label: "\u5782\u76f4\u91cd\u590d", value: "repeat-y" },
                  { label: "\u4e0d\u91cd\u590d", value: "no-repeat" },
                ],
              },
              backgroundParallax: {
                label: "\u80cc\u666f\u7eb5\u5411\u6eda\u52a8\u89c6\u5dee",
                type: "boolean",
              },
              backgroundImageWidth: {
                label: "\u80cc\u666f\u56fe\u7684\u5bbd\u5ea6",
                type: "string",
                content: "size",
              },
              backgroundImageHeight: {
                label: "\u80cc\u666f\u56fe\u7684\u9ad8\u5ea6",
                type: "string",
                content: "size",
              },
              hasBackgroundVideo: {
                label: "\u80cc\u666f\u89c6\u9891",
                type: "boolean",
              },
            },
          },
          backgroundVideo: {
            label: "\u80cc\u666f\u89c6\u9891\u8bbe\u7f6e",
            switch: "hasBackgroundVideo",
            props: {
              hasBannerVideo: {
                label:
                  "\u3010\u9996\u5c4f\u914d\u7f6e\u3011\u662f\u5426\u9996\u5c4f",
                type: "boolean",
              },
              bannerVideoReplayOff: {
                label:
                  "\u3010\u9996\u5c4f\u914d\u7f6e\u3011\u662f\u5426\u89c6\u9891\u56de\u5c4f\u81ea\u52a8\u64ad - \u52fe\u9009\u9996\u5c4f\u751f\u6548",
                switch: "hasBannerVideo",
                type: "boolean",
              },
              bannerVideoWidth: {
                label:
                  "\u3010\u9996\u5c4f\u914d\u7f6e\u3011\u89c6\u9891\u5bbd\u5ea6 - \u52fe\u9009\u9996\u5c4f\u751f\u6548",
                switch: "hasBannerVideo",
                type: "string",
              },
              bannerVideoHeight: {
                label:
                  "\u3010\u9996\u5c4f\u914d\u7f6e\u3011\u89c6\u9891\u9ad8\u5ea6 - \u52fe\u9009\u9996\u5c4f\u751f\u6548",
                switch: "hasBannerVideo",
                type: "string",
              },
              backgroundVideoLoop: {
                label:
                  "\u80cc\u666f/\u9996\u5c4f\u89c6\u9891\u5faa\u73af\u64ad\u653e",
                type: "boolean",
              },
              backgroundVideoVisiblePlay: {
                label: "\u9875\u9762\u6eda\u52a8\u540e\u89e6\u53d1\u64ad\u653e",
                type: "boolean",
              },
              backgroundVideoHoverPlay: {
                label: "\u9f20\u6807hover\u64ad\u653e",
                type: "boolean",
              },
              backgroundVideo: {
                label: "\u80cc\u666f\u89c6\u9891\u94fe\u63a5",
                type: "string",
                content: "url",
              },
              backgroundVideoWebm: {
                label:
                  "\u80cc\u666f\u89c6\u9891\u94fe\u63a5 (Webm\u683c\u5f0f\uff0c\u9009\u586b)",
                type: "string",
                content: "url",
              },
              backgroundVideoPoster: {
                label: "\u80cc\u666f\u89c6\u9891poster",
                type: "image",
              },
              backgroundVideoMaskColor: {
                label:
                  "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u8272\u53f7 (\u9ed8\u8ba4#000000)",
                type: "string",
              },
              backgroundVideoMaskOpacity: {
                label:
                  "\u80cc\u666f\u89c6\u9891\u906e\u7f69\u4e0d\u900f\u660e\u5ea6 (0-1, \u9ed8\u8ba40)",
                type: "string",
              },
              backgroundVideoBackgroundSize: {
                label: "\u80cc\u666f\u91cd\u590d\u65b9\u5f0f",
                type: "select",
                items: [
                  { label: "\u5168\u5c4f\u81ea\u9002\u5e94", value: "" },
                  {
                    label: "\u5168\u5c4f\u81ea\u9002\u5e94\u7f29\u653e",
                    value: "cover",
                  },
                ],
              },
              preventScale: {
                label: "\u80cc\u666f\u89c6\u9891\u7981\u6b62\u7f29\u653e",
                type: "boolean",
              },
            },
          },
          effect: {
            label: "\u52a8\u6001\u6548\u679c",
            props: {
              fadeTransiation: {
                label: "\u5165\u573a\u8fc7\u6e21",
                type: "select",
                items: [
                  { label: "fade-in", value: "fade-in" },
                  { label: "fade-up", value: "fade-up" },
                  { label: "zoom-in-up", value: "zoom-in-up" },
                  { label: "\u65e0\u6548\u679c", value: "none" },
                ],
              },
              mediaTransiation: {
                label: "\u56fe\u7247/\u89c6\u9891\u5165\u573a\u8fc7\u6e21",
                type: "select",
                items: [
                  { label: "fade-in", value: "fade-in" },
                  { label: "fade-up", value: "fade-up" },
                  { label: "zoom-in-up", value: "zoom-in-up" },
                  { label: "\u65e0\u6548\u679c", value: "none" },
                ],
              },
            },
          },
          videoSetting: {
            label: "video \u914d\u7f6e",
            props: {
              videoLazyLoadDistance: {
                label: "video\u8d85\u957f\u8ddd\u79bb\u61d2\u52a0\u8f7d",
                type: "boolean",
              },
            },
          },
          anchor: {
            label: "\u951a\u70b9\u8bbe\u7f6e",
            props: {
              anchorId: {
                label: "\u951a\u70b9 id [\u9009\u586b, \u4e0d\u5e26#\u53f7]",
                type: "string",
              },
            },
          },
        },
      };
      t.default = l()(Object(r.a)(F, Y), F);
    },
    L770: function (e, t, n) {
      e.exports = {
        "accessories-sticky-component":
          "style__accessories-sticky-component___2AB9m",
        "section-title": "style__section-title___3lJq2",
        "section-container": "style__section-container___3Ie95",
        "sticky-wrap": "style__sticky-wrap___25ESB",
        "sticky-box": "style__sticky-box___MZVF2",
        "sticky-content": "style__sticky-content___1-MF2",
        "sticky-content-ceiling": "style__sticky-content-ceiling___3z48V",
        "sticky-content-ie": "style__sticky-content-ie___msrwl",
        "scroll-content": "style__scroll-content___1RCDt",
        "accessories-ul": "style__accessories-ul___25WD5",
        waterfall: "style__waterfall___1fY8Y",
        "accessories-item-last": "style__accessories-item-last___16bvL",
        "img-box": "style__img-box___3Jb2b",
        "accessories-item": "style__accessories-item___2203_",
        title: "style__title___3PVHo",
        "accessories-video-ul": "style__accessories-video-ul___RikAL",
        "accessories-item-video": "style__accessories-item-video___2xKfg",
        "accessories-video": "style__accessories-video___2oSYm",
        "replay-btn": "style__replay-btn___FPpI8",
        icon: "style__icon___35vr-",
        "text-box": "style__text-box___2PZbN",
        introduce: "style__introduce___tf26r",
        "btn-wrapper": "style__btn-wrapper___V8x-t",
        desc: "style__desc___1pBU4",
        "replay-btn-box": "style__replay-btn-box___TH-9V",
        "accessories-sticky-component-special":
          "style__accessories-sticky-component-special___314Dg",
        "accessories-item-special": "style__accessories-item-special___7Zgpc",
      };
    },
    L8xA: function (e, t) {
      e.exports = function (e) {
        var t = this.__data__,
          n = t.delete(e);
        return (this.size = t.size), n;
      };
    },
    L9fC: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("rePB"),
        c = n("iKuz"),
        _ = n.n(c),
        u = n("q1tI"),
        d = n.n(u),
        p = n("XnI8"),
        f = (n("Fm6t"), n("atyN")),
        h = n.n(f),
        m = (n("VsOx"), d.a.createElement);
      function y(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var b = {
          "./style.css": {
            "section-table": "style__section-table___utKeR",
            container: "style__container___2M6Za",
            "table-title": "style__table-title___3GDQG",
            "table-content": "style__table-content___1AasU",
            table: "style__table___1V8J3",
            "table-cell": "style__table-cell___1DNeV",
            "table-cell-title-text": "style__table-cell-title-text___2u3Hy",
            "table-cell-desc-text": "style__table-cell-desc-text___lFC-0",
            "table-thead": "style__table-thead___1upwD",
            "table-head": "style__table-head___3x_Jn",
            headline: "style__headline___2g18C",
            description: "style__description___23-AE",
            "table-row": "style__table-row___3kucA",
            "table-cell-btn": "style__table-cell-btn___jvh3l",
            "icon-on": "style__icon-on___2-HU8",
            "icon-off": "style__icon-off___3noM4",
            "section-table-light": "style__section-table-light___3Spy7",
            "section-table-dark": "style__section-table-dark___20ie2",
          },
          "@dji/quark/dist/Button.css": {
            _3c0Qz: "Button___3c0Qz___3_YsB",
            _1j2v0: "Button___1j2v0___1pv-M",
            "-lu88": "Button__-lu88___2GQjh",
            _35bgc: "Button___35bgc___3n8Rj",
            byXrR: "Button__byXrR___1rGCj",
            _128ri: "Button___128ri___cMk_M",
            _1KHsi: "Button___1KHsi___3zDhv",
            "_2bT-Y": "Button___2bT-Y___1BQim",
            _3UEZX: "Button___3UEZX___34LNn",
            _1fXKU: "Button___1fXKU___2p1SZ",
            _2OZ_n: "Button___2OZ_n___YkVy4",
            _6cr8a: "Button___6cr8a___1Yfq-",
            ZAGKa: "Button__ZAGKa___1dwyB",
            _1lH5w: "Button___1lH5w___21_9c",
            _3BSr4: "Button___3BSr4___35AVQ",
            _4wlbR: "Button___4wlbR___2ZD_N",
            _26SUY: "Button___26SUY___1S1ah",
            "_30-mD": "Button___30-mD___18GAM",
            _1_xvC: "Button___1_xvC___1As6M",
            _17P2f: "Button___17P2f___1PWRA",
            _2I_EY: "Button___2I_EY___1kVmM",
            _3qb3s: "Button___3qb3s___1VKTa",
            _2jwD5: "Button___2jwD5___34QGU",
            _19X43: "Button___19X43___1bIzm",
            _2WwM4: "Button___2WwM4___3DLDq",
            _1shcg: "Button___1shcg___xYyCK",
            _1qLWd: "Button___1qLWd___3xAFl",
            Z8Prc: "Button__Z8Prc___3Y6cV",
            _3MItB: "Button___3MItB___2GmVw",
            _2Bvn6: "Button___2Bvn6___1ZN51",
            _3IVo_: "Button___3IVo____37Zlk",
            _34FGS: "Button___34FGS___19x0T",
            _3e62_: "Button___3e62____1kXjH",
            _1zbhS: "Button___1zbhS___1e1Z9",
            _27RtX: "Button___27RtX___1EMvI",
            jhfcy: "Button__jhfcy___aBpb9",
            Q82xM: "Button__Q82xM___1HSjO",
            _1vyf0: "Button___1vyf0___GWMBB",
            B0IHZ: "Button__B0IHZ___DG2N7",
            _2cpQ_: "Button___2cpQ____2btfh",
            _2FImd: "Button___2FImd___2-tY9",
            _3wXJB: "Button___3wXJB___2yeXW",
            _2fXyR: "Button___2fXyR___Rjv-D",
            _2KLCQ: "Button___2KLCQ___BFWbF",
            "_-4DAY": "Button___-4DAY___2ioyI",
            _2I4g3: "Button___2I4g3___3Eaa-",
            _1m5z7: "Button___1m5z7___1MkYM",
            _1vR3p: "Button___1vR3p___2p5DE",
            _2LJ7o: "Button___2LJ7o___28N0F",
            _3AQSX: "Button___3AQSX___7_7y3",
            _3ASBw: "Button___3ASBw___2Y-VE",
            _6eszT: "Button___6eszT___3mq5H",
            _1WxHW: "Button___1WxHW___2xO4X",
            _2uv1U: "Button___2uv1U___3ZHoj",
            "_3s-NW": "Button___3s-NW___1zAS9",
            _1ZzVY: "Button___1ZzVY___3SJE5",
            OBwuW: "Button__OBwuW___3xvOP",
            "_2Ri-k": "Button___2Ri-k___Sly51",
            _1588m: "Button___1588m___XB3VC",
            _2uIqb: "Button___2uIqb___2sh69",
            _1P5xZ: "Button___1P5xZ___1zouk",
            _2iuBX: "Button___2iuBX___2bjKy",
            _1exha: "Button___1exha___3RWAJ",
            _3bokS: "Button___3bokS___2ePXE",
            "vMM-Y": "Button__vMM-Y___8IgyG",
            _3jZwp: "Button___3jZwp___1Ev6Q",
            "_2SUQ-": "Button___2SUQ-___3lLH9",
            _1Piil: "Button___1Piil___1QyQw",
            _20oXE: "Button___20oXE___ElSIH",
            _2gTe8: "Button___2gTe8___2xBdm",
            okv_Y: "Button__okv_Y___1ubHf",
            "_3l-6g": "Button___3l-6g___2KJmk",
            OhY9C: "Button__OhY9C___ZT6G_",
            Cb5jY: "Button__Cb5jY___9nnVH",
            _1ajFe: "Button___1ajFe___1tm_G",
            ve2KQ: "Button__ve2KQ___3RJJm",
            _3OU3j: "Button___3OU3j___2kvsA",
            lgV2x: "Button__lgV2x___3MLDY",
            _1gQtG: "Button___1gQtG___3qZq1",
            _3Zaag: "Button___3Zaag___2musd",
            _33jTA: "Button___33jTA___25uDV",
            _1jJbn: "Button___1jJbn___E5qyl",
            UuxAk: "Button__UuxAk___1y9FB",
            _1OEuY: "Button___1OEuY___2ApAD",
            Lm_MF: "Button__Lm_MF___2UiBr",
            _3LwbN: "Button___3LwbN___3NRup",
            _2XN05: "Button___2XN05___2oonD",
            _33OcX: "Button___33OcX___3U-s2",
            bMc_E: "Button__bMc_E___Errdw",
            IAlEP: "Button__IAlEP___2OxlB",
            _25GQ2: "Button___25GQ2___2Cy9i",
            _3t3HT: "Button___3t3HT___2ItHs",
            _2W_XA: "Button___2W_XA___18R0_",
            _3NPLS: "Button___3NPLS___2kmEj",
            UhwjW: "Button__UhwjW___3t6jI",
            _2hDpl: "Button___2hDpl___G-xHk",
            dCZz2: "Button__dCZz2___3zTk3",
            _1FMUV: "Button___1FMUV___19Yjz",
            _2H8bj: "Button___2H8bj___3QJ_5",
            _3KkpT: "Button___3KkpT___34Sn5",
            _23p5a: "Button___23p5a___1Zcup",
            _18A_e: "Button___18A_e___1Cd-X",
            gf_rb: "Button__gf_rb___QDm63",
            _1Djb6: "Button___1Djb6___2V3dX",
            "_3d-6G": "Button___3d-6G___1MXwX",
            _1fawl: "Button___1fawl___I7NdV",
            _20uY7: "Button___20uY7___2hDdw",
            _2Z6dE: "Button___2Z6dE___3tJRR",
            _1c3Qh: "Button___1c3Qh___1HVho",
            _1GlZx: "Button___1GlZx___1flj5",
            _3hG3b: "Button___3hG3b___2Q80A",
            _15wCJ: "Button___15wCJ___KdW5M",
            _1Rw_U: "Button___1Rw_U___2GLMY",
            _2Jlwc: "Button___2Jlwc___2VzvV",
            _1bahP: "Button___1bahP___C4-1_",
            "_27Nd-": "Button___27Nd-___1KCCP",
            _3To44: "Button___3To44___3KOU7",
            _1O_Hy: "Button___1O_Hy___1zbxZ",
            W6H_f: "Button__W6H_f___xYs0p",
            _2_sls: "Button___2_sls___1k3Nb",
            _35BGQ: "Button___35BGQ___3N9zl",
            _3xfLM: "Button___3xfLM___2XcWP",
            _1pvYF: "Button___1pvYF___3oKsk",
            _3TvKd: "Button___3TvKd___2VIEV",
            xnv6R: "Button__xnv6R___2cBTA",
            "_3e-BG": "Button___3e-BG___2ZOCl",
            _3RO_K: "Button___3RO_K___3-4UL",
            _19X_H: "Button___19X_H___3bvjE",
            _8oCtR: "Button___8oCtR___1W4rm",
            _1bpad: "Button___1bpad___3AT8k",
            "_27-6k": "Button___27-6k___2eKen",
            _2QwEc: "Button___2QwEc___1HW_3",
            "_3IIr-": "Button___3IIr-___31mOV",
            _16fYW: "Button___16fYW___OEeVD",
            upL7u: "Button__upL7u___Yy3v0",
            _3oax7: "Button___3oax7___2c1CL",
            _958V1: "Button___958V1___3twpf",
            _22qIt: "Button___22qIt___1aIOI",
            mrbT4: "Button__mrbT4___1NRK4",
            _1i5fk: "Button___1i5fk___1zH_K",
            _1FsY1: "Button___1FsY1___xNXOo",
            p8s4W: "Button__p8s4W___1JDPQ",
            "_27-yu": "Button___27-yu___1vw79",
            _2ghvt: "Button___2ghvt___3koQZ",
            _21L3I: "Button___21L3I___1O4m3",
            _1wazg: "Button___1wazg___3BzGo",
            j7iyJ: "Button__j7iyJ___SXP4U",
          },
        },
        v = function (e) {
          var t = e.on;
          return m("span", {
            className: _()(t ? "icon-on" : "icon-off", b, {
              autoResolveMultipleImports: !0,
              handleMissingStyleName: "warn",
            }),
          });
        },
        g = (function (e) {
          function t() {
            return Object(o.default)(this, t), y(this, t, arguments);
          }
          return (
            Object(l.a)(t, e),
            Object(a.default)(t, [
              {
                key: "sendGa",
                value: function (e) {
                  var t = this;
                  return function () {
                    var n = t.props,
                      o = n.gaSend,
                      a = n.productData,
                      r = "table-".concat(e);
                    a && a.slug && o("click", r, "".concat(a.slug, "_detail"));
                  };
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props.component_data,
                    n = t.theme,
                    o = void 0 === n ? "dark" : n,
                    a = t.columnHeadline,
                    r = t.lineList,
                    i = t.columnList,
                    l = t.sectionMarginTop,
                    s = t.sectionMarginBottom,
                    c = t.leftWidth,
                    u = t.lastRowlineText,
                    p = t.lastRowlineIcon,
                    f = t.cardItemList,
                    y = this.props.t,
                    g = r.length || 1,
                    w = l || "64px",
                    x = s || "104px",
                    k = (i || []).length + 1,
                    O = "".concat(Math.floor(100 / k), "%"),
                    I = Array.from(new Array(17))
                      .map(function (e, t) {
                        return "line".concat(t + 1);
                      })
                      .slice(0, g),
                    S = "section-table section-table-".concat(o);
                  return m(
                    "section",
                    {
                      style: { paddingTop: w, paddingBottom: x },
                      className: _()(S, b, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    m(
                      "div",
                      { className: "style__container___2M6Za" },
                      m(
                        "div",
                        { className: "style__table-content___1AasU" },
                        m(
                          "table",
                          {
                            style: { tableLayout: "auto" },
                            className: "style__table___1V8J3",
                          },
                          m(
                            "colgroup",
                            null,
                            m("col", { width: c || "auto" }),
                            i.map(function () {
                              return m("col", {
                                span: c ? 1 : void 0,
                                width: c ? void 0 : O,
                              });
                            }),
                          ),
                          m(
                            "thead",
                            { className: "style__table-thead___1upwD" },
                            m(
                              "tr",
                              null,
                              m("th", {
                                className: "style__table-cell___1DNeV",
                                dangerouslySetInnerHTML: { __html: y(a) },
                              }),
                              i.map(function (e) {
                                var t = e.headline,
                                  n = e.desc;
                                return m(
                                  "th",
                                  { className: "style__table-cell___1DNeV" },
                                  m("div", {
                                    className: "style__headline___2g18C",
                                    dangerouslySetInnerHTML: { __html: y(t) },
                                  }),
                                  m("p", {
                                    className: "style__description___23-AE",
                                    dangerouslySetInnerHTML: { __html: y(n) },
                                  }),
                                );
                              }),
                            ),
                          ),
                          m(
                            "tbody",
                            null,
                            I.map(function (e, t) {
                              return m(
                                "tr",
                                {
                                  key: e,
                                  className: "style__table-row___3kucA",
                                },
                                m("td", {
                                  className: "style__table-cell___1DNeV",
                                  style:
                                    r[t] && r[t].lineIcon
                                      ? {
                                          backgroundImage: "url(".concat(
                                            r[t].lineIcon,
                                            ")",
                                          ),
                                          paddingLeft: "56px",
                                        }
                                      : { paddingLeft: "16px" },
                                  dangerouslySetInnerHTML: {
                                    __html: y(r[t] ? r[t].lineText : ""),
                                  },
                                }),
                                i.map(function (t) {
                                  return m(
                                    "td",
                                    { className: "style__table-cell___1DNeV" },
                                    m(v, { on: t[e] }),
                                  );
                                }),
                              );
                            }),
                            f &&
                              f.map(function (e, t) {
                                return m(
                                  "tr",
                                  {
                                    key: "line".concat(t + 17),
                                    className: "AA1 style__table-row___3kucA",
                                  },
                                  m("td", {
                                    className: "style__table-cell___1DNeV",
                                    style: e.iconImg
                                      ? {
                                          backgroundImage: "url(".concat(
                                            e.iconImg,
                                            ")",
                                          ),
                                          paddingLeft: "56px",
                                        }
                                      : { paddingLeft: "16px" },
                                    dangerouslySetInnerHTML: {
                                      __html: y(
                                        e.headerText ? e.headerText : "",
                                      ),
                                    },
                                  }),
                                  e &&
                                    e.items &&
                                    e.items.map(function (e) {
                                      return m(
                                        "td",
                                        {
                                          className:
                                            "style__table-cell___1DNeV",
                                          colSpan: e.sizeContent,
                                        },
                                        "boolean" === e.contentType
                                          ? m(v, { on: e.isSelected })
                                          : m(
                                              d.a.Fragment,
                                              null,
                                              e.itemTitle &&
                                                m("div", {
                                                  className:
                                                    "style__table-cell-title-text___2u3Hy",
                                                  dangerouslySetInnerHTML: {
                                                    __html: y(e.itemTitle),
                                                  },
                                                }),
                                              e.itemDesc &&
                                                m("div", {
                                                  className:
                                                    "style__table-cell-desc-text___lFC-0",
                                                  dangerouslySetInnerHTML: {
                                                    __html: y(e.itemDesc),
                                                  },
                                                }),
                                            ),
                                      );
                                    }),
                                );
                              }),
                            m(
                              "tr",
                              { className: "style__table-row___3kucA" },
                              m("td", {
                                className: "style__table-cell___1DNeV",
                                style: p
                                  ? { backgroundImage: "url(".concat(p, ")") }
                                  : { paddingLeft: "16px" },
                                dangerouslySetInnerHTML: { __html: y(u) },
                              }),
                              i.map(function (t) {
                                var n = t.buttonText,
                                  o = t.buttonLink;
                                return m(
                                  "td",
                                  { className: "style__table-cell___1DNeV" },
                                  n && o && o.path
                                    ? m(
                                        "a",
                                        {
                                          href: o.path,
                                          target: "_blank",
                                          className:
                                            "style__table-cell-btn___jvh3l",
                                        },
                                        m(
                                          h.a,
                                          {
                                            onClick: function () {
                                              return e.sendGa(
                                                "button-".concat(n),
                                              );
                                            },
                                            type: "primary",
                                            size: "small",
                                          },
                                          y(n),
                                        ),
                                      )
                                    : null,
                                );
                              }),
                            ),
                          ),
                        ),
                      ),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(d.a.Component);
      Object(s.a)(g, "defaultProps", {
        t: function () {},
        gaSend: function () {},
        component_data: {
          theme: "light",
          lineList: [
            { lineIcon: "", lineText: "Item Name" },
            {
              lineIcon: "",
              lineText:
                "Item NameItem NameItem NameItem NameItem NameItem NameItem NameItem NameItem NameItem NameItem NameItem NameItem NameItem NameItem Name",
            },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
            { lineIcon: "", lineText: "Item Name" },
          ],
          lastRowlineIcon: "",
          lastRowlineText: "",
          columnList: [
            {
              headline: "headline",
              desc: "$999999999.99",
              buttonText: "\u7acb\u5373\u8d2d\u4e70",
              buttonLink: "https://www.dji.com",
              line1: !0,
              line2: !0,
              line3: !0,
              line4: !0,
              line5: !1,
              line6: !1,
              line7: !1,
              line8: !1,
              line9: !1,
              line10: !1,
              line11: !1,
              line12: !1,
              line13: !1,
              line14: !1,
              line15: !1,
              line16: !1,
              line17: !1,
            },
            {
              headline: "headline",
              desc: "",
              buttonText: "\u8054\u7cfb\u6211\u4eec",
              buttonLink: "",
              line1: !0,
              line2: !0,
              line3: !0,
              line4: !0,
              line5: !0,
              line6: !0,
              line7: !0,
              line8: !0,
              line9: !0,
              line10: !0,
              line11: !0,
              line12: !0,
              line13: !0,
              line14: !0,
              line15: !1,
              line16: !1,
              line17: !1,
            },
            {
              headline: "headline",
              desc: "",
              buttonText: "",
              buttonLink: "",
              line1: !0,
              line2: !0,
              line3: !0,
              line4: !0,
              line5: !0,
              line6: !0,
              line7: !0,
              line8: !0,
              line9: !0,
              line10: !0,
              line11: !0,
              line12: !0,
              line13: !0,
              line14: !0,
              line15: !1,
              line16: !1,
              line17: !1,
            },
            {
              headline: "headline",
              desc: "",
              buttonText: "\u8054\u7cfb\u6211\u4eec",
              buttonLink: "",
              line1: !0,
              line2: !0,
              line3: !0,
              line4: !0,
              line5: !0,
              line6: !0,
              line7: !0,
              line8: !0,
              line9: !0,
              line10: !0,
              line11: !0,
              line12: !0,
              line13: !0,
              line14: !0,
              line15: !1,
              line16: !1,
              line17: !1,
            },
            {
              headline: "headline",
              desc: "",
              buttonText: "\u8054\u7cfb\u6211\u4eec",
              buttonLink: "",
              line1: !0,
              line2: !0,
              line3: !0,
              line4: !0,
              line5: !0,
              line6: !0,
              line7: !0,
              line8: !0,
              line9: !0,
              line10: !0,
              line11: !0,
              line12: !0,
              line13: !0,
              line14: !0,
              line15: !1,
              line16: !1,
              line17: !1,
            },
          ],
          cardItemList: [
            {
              headerText: "\u65b0\u6dfb\u52a0\u6807\u9898",
              items: [{ itemTitle: "\u6807\u9898", itemDesc: "\u63cf\u8ff0" }],
            },
          ],
        },
      }),
        Object(s.a)(g, "editSetting", {
          key: "terraTable",
          name: "terraTable",
          contentSetting: {
            size: {
              label: "\u6837\u5f0f\u914d\u7f6e",
              props: {
                theme: {
                  label: "\u4e3b\u9898\u8272",
                  type: "select",
                  items: [
                    { label: "on-dark", value: "dark" },
                    { label: "on-light", value: "light" },
                  ],
                },
                sectionMarginTop: {
                  label: '\u4e0a\u95f4\u8ddd (\u9ed8\u8ba4 "64px")',
                  type: "string",
                },
                sectionMarginBottom: {
                  label: '\u4e0b\u95f4\u8ddd (\u9ed8\u8ba4 "104px")',
                  type: "string",
                },
                leftWidth: {
                  label:
                    '\u6700\u5de6\u5217\u5bbd\u5ea6 (\u82e5\u4e0d\u586b\uff0c\u6240\u6709\u5217\u5bbd\u5ea6\u5e73\u5206\uff0c\u683c\u5f0f:"200px" )',
                  type: "string",
                },
              },
            },
            context: {
              label: "\u6587\u6848\u914d\u7f6e",
              props: {
                columnHeadline: {
                  label: "\u8868\u683c\u5de6\u4e0a\u89d2\u63cf\u8ff0",
                  type: "string",
                  content: "text",
                },
                lineList: {
                  label: "\u5de6\u4fa7\u884c\u63cf\u8ff0",
                  type: "array",
                  props: {
                    lineIcon: { label: "\u884cicon", type: "image" },
                    lineText: {
                      label: "\u884c\u6807\u9898",
                      type: "string",
                      content: "text",
                    },
                  },
                },
                lastRowlineIcon: {
                  label: "\u5e95\u90e8\u6309\u94ae\u884c icon",
                  type: "image",
                },
                lastRowlineText: {
                  label:
                    "\u5e95\u90e8\u6309\u94ae\u884c \u6587\u6848 \uff08\u9009\u586b\uff09",
                  type: "string",
                  content: "text",
                },
              },
            },
            third: {
              label: "\u8868\u683c\u5217\u5185\u5bb9\u914d\u7f6e",
              props: {
                columnList: {
                  label: "\u8868\u683c\u5217",
                  type: "array",
                  props: {
                    headline: {
                      label: "\u5217\u5934\u6807\u9898",
                      type: "string",
                      content: "text",
                    },
                    desc: {
                      label: "\u5217\u5934\u63cf\u8ff0",
                      type: "string",
                      content: "text",
                    },
                    line1: {
                      label: "\u7b2c 1 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line2: {
                      label: "\u7b2c 2 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line3: {
                      label: "\u7b2c 3 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line4: {
                      label: "\u7b2c 4 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line5: {
                      label: "\u7b2c 5 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line6: {
                      label: "\u7b2c 6 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line7: {
                      label: "\u7b2c 7 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line8: {
                      label: "\u7b2c 8 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line9: {
                      label: "\u7b2c 9 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line10: {
                      label: "\u7b2c 10 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line11: {
                      label: "\u7b2c 11 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line12: {
                      label: "\u7b2c 12 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line13: {
                      label: "\u7b2c 13 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line14: {
                      label: "\u7b2c 14 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line15: {
                      label: "\u7b2c 15 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line16: {
                      label: "\u7b2c 16 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    line17: {
                      label: "\u7b2c 17 \u884c\u6570\u636e",
                      type: "boolean",
                    },
                    buttonText: {
                      label: "\u5e95\u90e8\u6309\u94ae\u6587\u6848",
                      type: "string",
                      content: "text",
                    },
                    buttonLink: {
                      label: "\u5e95\u90e8\u6309\u94ae\u94fe\u63a5",
                      type: "string",
                      content: "url",
                    },
                  },
                },
              },
            },
            cardItemList: {
              label: "\u5361\u7247",
              group_type: "array_card",
              group_prop_name: "cardItemList",
              props: {
                itemHeader: {
                  label: "\u5355\u5143\u683c\u5934\u90e8 \u8bbe\u7f6e",
                  props: {
                    iconImg: { type: "image", label: "\u5934\u90e8\u5c0ficon" },
                    headerText: {
                      type: "string",
                      label: "\u5217\u8868\u5934\u90e8\u63cf\u8ff0\u4fe1\u606f",
                      content: "text",
                    },
                  },
                },
                itemContent: {
                  label: "\u8868\u683c\u5185\u5bb9\u8bbe\u7f6e",
                  props: {
                    items: {
                      label: "\u5185\u5bb9\u5217\u8868",
                      type: "array",
                      props: {
                        contentType: {
                          label: "\u8868\u683c\u5185\u5bb9\u683c\u5f0f",
                          type: "select",
                          items: [
                            { label: "text", value: "text" },
                            { label: "bool", value: "boolean" },
                          ],
                        },
                        isSelected: {
                          label: "\u662f\u5426\u52fe\u9009\u4fe1\u606f",
                          type: "boolean",
                        },
                        itemTitle: {
                          label: "\u5185\u5bb9",
                          content: "text",
                          type: "string",
                        },
                        itemDesc: {
                          label: "\u63cf\u8ff0",
                          content: "text",
                          type: "string",
                        },
                        sizeContent: {
                          label:
                            "\u8fd9\u4e00\u4e2a\u5355\u5143\u683c\u6240\u5360\u5230\u4f4d\u7f6e",
                          type: "number",
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          skinSetting: {},
        }),
        (t.a = Object(p.a)(g));
    },
    LIAx: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 }),
        (t.default = function (e, t, n, o) {
          function a(t) {
            var o = new r.default(t);
            n.call(e, o);
          }
          if (e.addEventListener) {
            var i = (function () {
              var n = !1;
              return (
                "object" === typeof o
                  ? (n = o.capture || !1)
                  : "boolean" === typeof o && (n = o),
                e.addEventListener(t, a, o || !1),
                {
                  v: {
                    remove: function () {
                      e.removeEventListener(t, a, n);
                    },
                  },
                }
              );
            })();
            if ("object" === typeof i) return i.v;
          } else if (e.attachEvent)
            return (
              e.attachEvent("on" + t, a),
              {
                remove: function () {
                  e.detachEvent("on" + t, a);
                },
              }
            );
        });
      var o,
        a = n("E0u0"),
        r = (o = a) && o.__esModule ? o : { default: o };
      e.exports = t.default;
    },
    LMt4: function (e, t, n) {
      e.exports = {
        "font-weight-light": "style__font-weight-light___1nuXd",
        "font-weight-solid": "style__font-weight-solid___169j4",
        "dji-atom-icon": "style__dji-atom-icon___3W0ny",
        "icon-search-minus": "style__icon-search-minus___cOhwY",
        "icon-play-circle": "style__icon-play-circle___1RUrX",
        "icon-caret-down-o": "style__icon-caret-down-o___19bV8",
        "icon-search": "style__icon-search___1Ff6s",
        "icon-list": "style__icon-list___n0DRN",
        "icon-info-square": "style__icon-info-square___2rWdR",
        "icon-cog": "style__icon-cog___10AHG",
        "icon-hourglass": "style__icon-hourglass___3usQu",
        "icon-angle-double-left": "style__icon-angle-double-left___1JUyB",
        "icon-user": "style__icon-user___1Arby",
        "icon-home": "style__icon-home___3tA8p",
        "icon-map-marked-alt": "style__icon-map-marked-alt___3B3tR",
        "icon-box-alt": "style__icon-box-alt___3v1jN",
        "icon-check-circle-o": "style__icon-check-circle-o___LO8cK",
        "icon-tag": "style__icon-tag___1aPnN",
        "icon-file-export": "style__icon-file-export___18_bm",
        "icon-exclamation-square": "style__icon-exclamation-square___2RZH6",
        "icon-arrow-circle-up": "style__icon-arrow-circle-up___2SNcq",
        "icon-pen-square": "style__icon-pen-square___3cBEx",
        "icon-comments": "style__icon-comments___1EhlO",
        "icon-headset": "style__icon-headset___1Kkbh",
        "icon-angle-down": "style__icon-angle-down___2nYYy",
        "icon-database": "style__icon-database___1lgX-",
        "icon-truck-moving": "style__icon-truck-moving___2Djgp",
        "icon-file": "style__icon-file___3dhUu",
        "icon-control": "style__icon-control___2GVe1",
        "icon-signal": "style__icon-signal___3cYsp",
        "icon-signal-alt": "style__icon-signal-alt___20EfS",
        "icon-purchase": "style__icon-purchase___y3Ehv",
        "icon-angle-up": "style__icon-angle-up___3UTd1",
        "icon-exclamation-triangle": "style__icon-exclamation-triangle___1tl03",
        "icon-lock": "style__icon-lock___rMhIy",
        "icon-question-circle": "style__icon-question-circle___39Qyy",
        "icon-cloud-upload": "style__icon-cloud-upload___4ouGV",
        "icon-pen": "style__icon-pen___1n6Ql",
        "icon-ban": "style__icon-ban___2TdFo",
        "icon-certificate": "style__icon-certificate___3coCT",
        "icon-link": "style__icon-link___QMFWG",
        "icon-order": "style__icon-order___qjH16",
        "icon-ellipsis-h": "style__icon-ellipsis-h___3YCTe",
        "icon-noun-Empty": "style__icon-noun-Empty___37h7X",
        "icon-caret-left-o": "style__icon-caret-left-o___U8vkb",
        "icon-qrcode": "style__icon-qrcode___WzUrd",
        "icon-calendar-plus": "style__icon-calendar-plus___TO9cY",
        "icon-calendar-check": "style__icon-calendar-check___3VftT",
        "icon-yen-sign": "style__icon-yen-sign___A4uN_",
        "icon-times-circle-o": "style__icon-times-circle-o___1rETg",
        "icon-cart": "style__icon-cart___1s7d-",
        "icon-compress": "style__icon-compress___X8FC1",
        "icon-envelope": "style__icon-envelope___3GvFc",
        "icon-location-arrow": "style__icon-location-arrow___2Qsvz",
        "icon-download": "style__icon-download___2ATGw",
        "icon-shield": "style__icon-shield___2MI7O",
        "icon-expand": "style__icon-expand___yJ4dD",
        "icon-bolt": "style__icon-bolt___am4uf",
        "icon-file-import": "style__icon-file-import___1tiq4",
        "icon-angle-double-right": "style__icon-angle-double-right___3nOBe",
        "icon-book": "style__icon-book___3d4_3",
        "icon-bell": "style__icon-bell___3C4r6",
        "icon-caret-right-o": "style__icon-caret-right-o___1ocjx",
        "icon-flag": "style__icon-flag___JJ2SB",
        "icon-update": "style__icon-update___6xv-n",
        "icon-map-marker-alt": "style__icon-map-marker-alt___3d5-J",
        "icon-clipboard-list": "style__icon-clipboard-list___8G1Rl",
        "icon-paper": "style__icon-paper___1Gk6t",
        "icon-trophy": "style__icon-trophy___1c8qG",
        "icon-check": "style__icon-check___1mTaG",
        "icon-plus": "style__icon-plus___1EUr-",
        "icon-angle-right": "style__icon-angle-right___3xpZK",
        "icon-info": "style__icon-info___2jXQH",
        "icon-bullhorn": "style__icon-bullhorn___2JHU8",
        "icon-info-circle": "style__icon-info-circle___3Pzft",
        "icon-list-view": "style__icon-list-view___3vq7f",
        "icon-copy": "style__icon-copy___ibsaS",
        "icon-coins": "style__icon-coins___1GSK5",
        "icon-signal-slash": "style__icon-signal-slash___1D1FC",
        "icon-compare": "style__icon-compare___23VVi",
        "icon-ellipsis-v": "style__icon-ellipsis-v___QanOQ",
        "icon-calendar-alt": "style__icon-calendar-alt___1nnws",
        "icon-images": "style__icon-images___3w3pn",
        "icon-search-plus": "style__icon-search-plus___286MF",
        "icon-paperclip": "style__icon-paperclip___2So3v",
        "icon-file-alt": "style__icon-file-alt___3XiA3",
        "icon-shutter": "style__icon-shutter___2Tc1F",
        "icon-box": "style__icon-box___2ffxD",
        "icon-crown": "style__icon-crown___2tewJ",
        "icon-check-square-o": "style__icon-check-square-o___3ErpE",
        "icon-coupon": "style__icon-coupon___1oj5a",
        "icon-logic": "style__icon-logic___mHbnr",
        "icon-facebook": "style__icon-facebook___r6Swk",
        "icon-camera": "style__icon-camera___qfAbZ",
        "icon-redo": "style__icon-redo___qPzKM",
        "icon-user-friends": "style__icon-user-friends___Dg7v8",
        "icon-wechat": "style__icon-wechat___2s-xj",
        "icon-exclamation-circle": "style__icon-exclamation-circle___1E3TC",
        "icon-vr": "style__icon-vr___pY-ln",
        "icon-star": "style__icon-star___wgetm",
        "icon-arrow-circle-down": "style__icon-arrow-circle-down___3v2S8",
        "icon-edit": "style__icon-edit___yRC27",
        "icon-circle-notch": "style__icon-circle-notch___3chsk",
        "icon-unlink": "style__icon-unlink___2ZKtt",
        "icon-comment-smile": "style__icon-comment-smile___1tvoM",
        "icon-comment-alt-smile": "style__icon-comment-alt-smile___28OPN",
        "icon-education": "style__icon-education___2eWRb",
        "icon-unlock": "style__icon-unlock___2k17U",
        "icon-plus-circle": "style__icon-plus-circle___1v9Py",
        "icon-frame": "style__icon-frame___1jyki",
        "icon-credit-card": "style__icon-credit-card___2VI6o",
        "icon-user-tie": "style__icon-user-tie___1E59_",
        "icon-language": "style__icon-language___ukU5k",
        "icon-setup": "style__icon-setup___3ERjO",
        "icon-trash-alt": "style__icon-trash-alt___L5mR4",
        "icon-phone": "style__icon-phone___2_BA5",
        "icon-clock": "style__icon-clock___1XFPJ",
        "icon-drone": "style__icon-drone___H5kYV",
        "icon-eye": "style__icon-eye___2qE7M",
        "icon-location": "style__icon-location___1Molc",
        "icon-image-view": "style__icon-image-view___2Azg1",
        "icon-external-link": "style__icon-external-link___nq6Kx",
        "icon-gift": "style__icon-gift___38Nw4",
        "icon-share": "style__icon-share___3fukp",
        "icon-balance-scale": "style__icon-balance-scale___LJf4g",
        "icon-heart-o": "style__icon-heart-o___1OnuG",
        "icon-calendar-minus": "style__icon-calendar-minus___1MXLn",
        "icon-video": "style__icon-video___2Ha1b",
        "icon-filter": "style__icon-filter___3g5QP",
        "icon-bell-slash": "style__icon-bell-slash___1igoy",
        "icon-comment": "style__icon-comment___1i2VS",
        "icon-calendar": "style__icon-calendar___1CIbD",
        "icon-globe": "style__icon-globe___2cY0K",
        "icon-minus-circle": "style__icon-minus-circle___25fd3",
        "icon-arrival-reminder": "style__icon-arrival-reminder___6jNov",
        "icon-calendar-times": "style__icon-calendar-times___2zEPo",
        "icon-bars": "style__icon-bars___2Bc6K",
        "icon-upload": "style__icon-upload___1YDdR",
        "icon-bookmark": "style__icon-bookmark___2KZeu",
        "icon-times-square-o": "style__icon-times-square-o___3eEE7",
        "icon-unfold": "style__icon-unfold___14jzK",
        "icon-angle-left": "style__icon-angle-left___2EBCm",
        "icon-cloud-download": "style__icon-cloud-download___2pl9j",
        "icon-mouse": "style__icon-mouse___3AHth",
        "icon-shield-check": "style__icon-shield-check___26CHo",
        "icon-caret-up-o": "style__icon-caret-up-o___29i_6",
        "icon-users": "style__icon-users___1GIj8",
        "icon-file-pdf": "style__icon-file-pdf___V8a6k",
        "icon-minus": "style__icon-minus___3FPzD",
        "icon-times": "style__icon-times___I2P-K",
        "icon-exclamation": "style__icon-exclamation___2Vyv2",
        "icon-user-shield": "style__icon-user-shield___Dlv8J",
        "icon-caret-down": "style__icon-caret-down___20jAQ",
        "icon-check-square": "style__icon-check-square___2aHW_",
        "icon-play-visual-center": "style__icon-play-visual-center___EEDkz",
        "icon-times-square": "style__icon-times-square___HD-gf",
        "icon-caret-up": "style__icon-caret-up___Kesms",
        "icon-caret-right": "style__icon-caret-right___3R5CT",
        "icon-star-half": "style__icon-star-half___1wDSr",
        "icon-check-circle": "style__icon-check-circle___1bUq-",
        "icon-eye-slash": "style__icon-eye-slash___3dCqb",
        "icon-play": "style__icon-play___3VHLE",
        "icon-textarea": "style__icon-textarea___29I4u",
        "icon-caret-left": "style__icon-caret-left___3p0Oo",
        "icon-times-circle": "style__icon-times-circle___3ztOM",
        "icon-heart": "style__icon-heart___3e9UT",
      };
    },
    LPlb: function (e, t, n) {
      "use strict";
      n.d(t, "c", function () {
        return i;
      }),
        n.d(t, "b", function () {
          return l;
        }),
        n.d(t, "a", function () {
          return s;
        });
      var o = n("ZO6J"),
        a = "prod",
        r = {
          en: "",
          "zh-CN": "cn",
          "zh-TW": "zh-tw",
          ja: "jp",
          ko: "kr",
          "pt-BR": "pt-br",
        };
      function i(e, t, n, i) {
        var l = JSON.parse(
            '{"official_api":{"test":{"host":"//test-www-api.dbeta.me"},"dev":{"host":"//test-www-api.dbeta.me"},"stag":{"host":"//test-www-api.dbeta.me"},"production":{"host":"//www-api.dji.com"},"master":{"host":"//www-api.dji.com"},"host":"//www-api.dji.com"},"official":{"host":"https://www.dji.com"},"product_center":{"dev":{"host":"https://product.dbeta.me"},"test":{"host":"https://product.dbeta.me"},"stag":{"host":"https://r-product.dbeta.me"},"prod":{"host":"https://product.dji.com"},"host":"https://product.dji.com"},"store-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"store-pc":{"dev":{"host":"store.dbeta.me"},"test":{"host":"store.dbeta.me"},"stag":{"host":"r-store.dbeta.me"},"prod":{"host":"store.dji.com"},"host":"store.dji.com"},"account-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"account-pc":{"dev":{"host":"accounts.dbeta.me"},"test":{"host":"accounts.dbeta.me"},"stag":{"host":"r-accounts.dbeta.me"},"prod":{"host":"accounts.dji.com"},"host":"accounts.dji.com"},"repair":{"dev":{"host":"repair.dbeta.me"},"test":{"host":"repair.dbeta.me"},"stag":{"host":"support.dji.com"},"prod":{"host":"support.dji.com"},"host":"support.dji.com"},"stormsend":{"dev":{"host":"https://stormsend.dbeta.me"},"test":{"host":"https://stormsend.dbeta.me","host_bak":"https://stormsend.dbeta.me"},"stag":{"host":"https://stag-stormsend-api.dbeta.me"},"prod":{"host":"https://stormsend-api.djiits.com"},"host":"https://stormsend-api.djiits.com"}}',
          ),
          s = l["store-mobile"],
          c = l["store-pc"],
          _ = r[n];
        _ || "" === _ || (_ = n),
          (e = "/" !== e.substring(0, 1) ? "/".concat(e) : e);
        var u = i
          ? (s[a] && s[a].host) || "m.dji.com"
          : (c[a] && c[a].host) || "store.dji.com";
        return "ru" === _ && "/ru/shopping-flow" === e
          ? u + e.replace("/ru", "")
          : -1 !== o.a.indexOf(t)
            ? "/where-to-buy"
            : _
              ? "//".concat(u, "/").concat(_).concat(e)
              : "//".concat(u).concat(_).concat(e);
      }
      function l(e, t, n, o) {
        var i = JSON.parse(
            '{"official_api":{"test":{"host":"//test-www-api.dbeta.me"},"dev":{"host":"//test-www-api.dbeta.me"},"stag":{"host":"//test-www-api.dbeta.me"},"production":{"host":"//www-api.dji.com"},"master":{"host":"//www-api.dji.com"},"host":"//www-api.dji.com"},"official":{"host":"https://www.dji.com"},"product_center":{"dev":{"host":"https://product.dbeta.me"},"test":{"host":"https://product.dbeta.me"},"stag":{"host":"https://r-product.dbeta.me"},"prod":{"host":"https://product.dji.com"},"host":"https://product.dji.com"},"store-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"store-pc":{"dev":{"host":"store.dbeta.me"},"test":{"host":"store.dbeta.me"},"stag":{"host":"r-store.dbeta.me"},"prod":{"host":"store.dji.com"},"host":"store.dji.com"},"account-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"account-pc":{"dev":{"host":"accounts.dbeta.me"},"test":{"host":"accounts.dbeta.me"},"stag":{"host":"r-accounts.dbeta.me"},"prod":{"host":"accounts.dji.com"},"host":"accounts.dji.com"},"repair":{"dev":{"host":"repair.dbeta.me"},"test":{"host":"repair.dbeta.me"},"stag":{"host":"support.dji.com"},"prod":{"host":"support.dji.com"},"host":"support.dji.com"},"stormsend":{"dev":{"host":"https://stormsend.dbeta.me"},"test":{"host":"https://stormsend.dbeta.me","host_bak":"https://stormsend.dbeta.me"},"stag":{"host":"https://stag-stormsend-api.dbeta.me"},"prod":{"host":"https://stormsend-api.djiits.com"},"host":"https://stormsend-api.djiits.com"}}',
          ),
          l = i["account-mobile"],
          s = i["account-pc"],
          c = o ? l[a] && l[a].host : s[a] && s[a].host;
        e = "/" !== e.substring(0, 1) ? "/".concat(e) : e;
        var _ = r[n] || n;
        return (
          (_ = "it" === _ || "pt-br" === _ || "ru" === _ ? "" : _),
          "//"
            .concat(c)
            .concat(_ ? "/".concat(_) : "")
            .concat(e)
        );
      }
      function s(e) {
        var t = window.location.host;
        if (!e) return !1;
        var n =
            !e.match(/^http/gi) &&
            !e.match(/www\./gi) &&
            !e.match(/\.com/gi) &&
            !e.match(/^\/\//),
          o = new RegExp(t, "gi").test(e);
        return n || o ? "_self" : "_blank";
      }
    },
    LUwM: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = function (e, t, n) {
        return Math.min(Math.max(n, e), t);
      };
    },
    LXxW: function (e, t) {
      e.exports = function (e, t) {
        for (
          var n = -1, o = null == e ? 0 : e.length, a = 0, r = [];
          ++n < o;

        ) {
          var i = e[n];
          t(i, n, e) && (r[a++] = i);
        }
        return r;
      };
    },
    LcsW: function (e, t, n) {
      var o = n("kekF")(Object.getPrototypeOf, Object);
      e.exports = o;
    },
    Lf8g: function (e, t, n) {
      e.exports = {
        "download-wrapper-box": "style__download-wrapper-box___1oBL6",
        "pop-up-action-btn-wrapper": "style__pop-up-action-btn-wrapper___cuUhx",
        text: "style__text___1W9Sc",
        "zoom-image-wrapper": "style__zoom-image-wrapper___1NAWn",
        "zoom-image": "style__zoom-image___3Ik1u",
        glass: "style__glass___37Ch6",
      };
    },
    LpSC: function (e, t, n) {
      n("K64n"), (e.exports = self.fetch.bind(self));
    },
    LsHQ: function (e, t, n) {
      var o = n("EA7m"),
        a = n("mv/X");
      e.exports = function (e) {
        return o(function (t, n) {
          var o = -1,
            r = n.length,
            i = r > 1 ? n[r - 1] : void 0,
            l = r > 2 ? n[2] : void 0;
          for (
            i = e.length > 3 && "function" == typeof i ? (r--, i) : void 0,
              l && a(n[0], n[1], l) && ((i = r < 3 ? void 0 : i), (r = 1)),
              t = Object(t);
            ++o < r;

          ) {
            var s = n[o];
            s && e(t, s, o, i);
          }
          return t;
        });
      };
    },
    "Lu0/": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return h;
      });
      var o = n("HaE+"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("u11H"),
        l = "FFFF0N4N000000005F55",
        s = "FFFF0N4N000000005F55",
        c = "nc_other_h5",
        _ = "nc_other",
        u = {
          cn: "cn",
          en: "en",
          "zh-TW": "tw",
          ja: "ja_JP",
          de: "de_DE",
          fr: "fr_FR",
          ko: "ko_KR",
          es: "es_ES",
          ru: "ru_RU",
          it: "it_IT",
          "pt-BR": "pt_BR",
          th: "th_TH",
        },
        d = { cn: "cn", en: "en", "zh-tw": "tw", th: "th_TH" },
        p = {
          LOADING: "v3.ali.captcha.loading",
          SLIDER_LABEL: "v3.ali.captcha.slider.label",
          CHECK_Y: "v3.ali.captcha.check.pass",
          ERROR_TITLE: "v3.ali.captcha.error.title",
          CHECK_N: "v3.ali.captcha.check.nopass",
          OVERLAY_INFORM: "v3.ali.captcha.overlay.inform",
          TIPS_TITLE: "v3.ali.captcha.tips.title",
        };
      function f() {
        f = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof b ? t : b,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          h = "executing",
          m = "completed",
          y = {};
        function b() {}
        function v() {}
        function g() {}
        var w = {};
        c(w, i, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, i) && (w = k);
        var O = (g.prototype = b.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === h) throw new Error("Generator is already running");
            if (a === m) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = m), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = h;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? m : p), c.arg === y)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = m), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              y
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), y
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                y)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (v.prototype = g),
          a(O, "constructor", { value: g, configurable: !0 }),
          a(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = c(g, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          c(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          c(O, s, "Generator"),
          c(O, i, function () {
            return this;
          }),
          c(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), y)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                y
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                y
              );
            },
          }),
          t
        );
      }
      var h = (function () {
        function e(t) {
          Object(a.default)(this, e),
            (this.Captcha = null),
            (this.isCaptchaNeeded = !0),
            (this.validateParams = {}),
            (this._options = t),
            (this.pass = !1);
        }
        return (
          Object(r.default)(e, [
            {
              key: "init",
              value: function (e, t) {
                var n = this,
                  o = t || "captcha-input";
                this._getCaptchaNeeded(function (t) {
                  t
                    ? n._loadScript(function () {
                        n._init(e, o);
                      })
                    : (n.hide(),
                      "undefined" !== typeof document &&
                        document &&
                        document.getElementById(o) &&
                        (document.getElementById(o).style.display = "none")),
                    e(t);
                });
              },
            },
            {
              key: "_getCaptchaNeeded",
              value: (function () {
                var e = Object(o.default)(
                  f().mark(function e(t) {
                    var n, o;
                    return f().wrap(
                      function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (e.prev = 0),
                                (e.next = 3),
                                i.default.request(
                                  { name: "captchaNeeded", method: "GET" },
                                  this._options.localization,
                                )
                              );
                            case 3:
                              return (n = e.sent), (e.next = 6), n.json();
                            case 6:
                              return (
                                (o = e.sent),
                                (this.isCaptchaNeeded = o && o.needed),
                                e.abrupt("return", t && t(o.needed))
                              );
                            case 11:
                              (e.prev = 11), (e.t0 = e.catch(0));
                            case 13:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this,
                      [[0, 11]],
                    );
                  }),
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })(),
            },
            {
              key: "hide",
              value: function () {
                this.Captcha && this.Captcha.hide();
              },
            },
            {
              key: "show",
              value: function () {
                this.Captcha && this.Captcha.show();
              },
            },
            {
              key: "destory",
              value: function () {
                this.Captcha && this.Captcha.destroy();
              },
            },
            {
              key: "getResult",
              value: function () {
                return !1 === this.isCaptchaNeeded || this.pass;
              },
            },
            {
              key: "reload",
              value: function () {
                this.Captcha &&
                  (this._options.isMobile
                    ? this.Captcha.reset()
                    : this.Captcha.reload());
              },
            },
            {
              key: "getValidateParams",
              value: function () {
                return this.validateParams;
              },
            },
            {
              key: "getLocation",
              value: (function () {
                var e = Object(o.default)(
                  f().mark(function e(t) {
                    var n, o;
                    return f().wrap(
                      function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (e.prev = 0),
                                (e.next = 3),
                                i.default.request(
                                  { name: "flySafeIpLocation", method: "GET" },
                                  this._options.localization,
                                )
                              );
                            case 3:
                              return (n = e.sent), (e.next = 6), n.json();
                            case 6:
                              return (o = e.sent), e.abrupt("return", t(o));
                            case 10:
                              (e.prev = 10), (e.t0 = e.catch(0));
                            case 12:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this,
                      [[0, 10]],
                    );
                  }),
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })(),
            },
            {
              key: "_init",
              value: function (e, t) {
                var n = this;
                n.pass = !1;
                var o = n._options,
                  a = o.localization,
                  r = o.isMobile,
                  i = o.t,
                  f = a.language,
                  h = r ? l : s,
                  m = r ? c : _,
                  y = [h, new Date().getTime(), Math.random()].join(":"),
                  b =
                    "string" === typeof o.recordDomsId
                      ? [o.recordDomsId]
                      : o.recordDomsId,
                  v = {
                    renderTo: o.renderDom,
                    appkey: h,
                    scene: m,
                    token: y,
                    elementID: b,
                    timeout: 8e3,
                    callback: function (e) {
                      var o = {
                          token: y,
                          sessionid: e.csessionid,
                          scene: m,
                          appkey: h,
                          sig: e.sig,
                        },
                        a = document.createEvent("HTMLEvents");
                      a.initEvent("keyup", !1, !1);
                      var r = null;
                      if (
                        ("function" === typeof Event
                          ? (r = new Event("\u03bfnblur"))
                          : (r = document.createEvent("Event")).initEvent(
                              "\u03bfnblur",
                              !0,
                              !0,
                            ),
                        "pass" === e.value || 0 === e.code)
                      ) {
                        n.pass = !0;
                        var i =
                          "undefined" !== typeof document &&
                          document.querySelector("#".concat(t));
                        i &&
                          ((i.value = "pass"),
                          i.dispatchEvent
                            ? (i.dispatchEvent(a), i.dispatchEvent(r))
                            : i.fireEvent("keyup") && i.fireEvent("keyup"));
                      }
                      n.validateParams = o;
                    },
                  };
                if (r) {
                  if (
                    ((v.language = d[f] ? d[f] : f),
                    (v.bannerHidden = !1),
                    (n.Captcha = NoCaptcha.init(v)),
                    NoCaptcha.setEnabled(!0),
                    n.Captcha.reset(),
                    !d[f])
                  ) {
                    var g = {};
                    Object.keys(p).forEach(function (e) {
                      g[e] = i(p[e]);
                    }),
                      NoCaptcha.upLang(f, g || {}),
                      n.Captcha.reset();
                  }
                } else
                  (v.timeout = 3e3),
                    (v.times = 5),
                    (v.customWidth = o.width || 320),
                    (v.language = u[f]),
                    (n.Captcha = new noCaptcha(v));
              },
            },
            {
              key: "_loadScript",
              value: function (e) {
                var t = this._options.isMobile,
                  n = new Date(),
                  o = n.getFullYear(),
                  a = n.getMonth() + 1,
                  r = n.getDate(),
                  i = n.getHours();
                (a = 1 === a.toString().length ? "0".concat(a) : a),
                  (r = 1 === r.toString().length ? "0".concat(r) : r),
                  (i = 1 === i.toString().length ? "0".concat(i) : i);
                var l = "".concat(o).concat(a).concat(r).concat(i),
                  s = {
                    "cn-pc": "//g.alicdn.com/sd/ncpc/nc.js",
                    "foreign-pc": "//aeis.alicdn.com/sd/ncpc/nc.js",
                    "cn-m": "//g.alicdn.com/sd/nch5/index.js",
                    "foreign-m": "//aeis.alicdn.com/sd/nch5/index.js",
                  };
                this.getLocation(function (n) {
                  var o = "CN" === n.country ? "cn-" : "foreign-";
                  o = "".concat(o).concat(t ? "m" : "pc");
                  var a = "".concat(s[o], "?t=").concat(l),
                    r = document.createElement("script"),
                    i = document.getElementsByTagName("script")[0];
                  (r.async = 1),
                    i.parentNode.insertBefore(r, i),
                    (r.onload = e),
                    (r.src = a);
                });
              },
            },
          ]),
          e
        );
      })();
    },
    LxhC: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t) && !e.required) return n();
          r.default.required(e, t, o, l, a),
            void 0 !== t && r.default.type(e, t, o, l, a);
        }
        n(l);
      };
    },
    M1xp: function (e, t, n) {
      var o = n("a0xu");
      e.exports = Object("z").propertyIsEnumerable(0)
        ? Object
        : function (e) {
            return "String" == o(e) ? e.split("") : Object(e);
          };
    },
    MMmD: function (e, t, n) {
      var o = n("lSCD"),
        a = n("shjB");
      e.exports = function (e) {
        return null != e && a(e.length) && !o(e);
      };
    },
    MNWt: function (e, t, n) {
      "use strict";
      var o = n("KQm4"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("iKuz"),
        u = n.n(_),
        d = n("q1tI"),
        p = n.n(d),
        f = n("TSYQ"),
        h = n.n(f),
        m = n("XnI8"),
        y = (n("aFXD"), n("hKI/")),
        b = n.n(y),
        v = n("9/5/"),
        g = n.n(v),
        w = p.a.createElement,
        x = {
          "./style.css": {
            "product-elevator": "style__product-elevator___191VM",
            "elevator-details": "style__elevator-details___n3VyO",
            "elevator-item": "style__elevator-item___2SXkY",
            "elevator-item-active": "style__elevator-item-active___1oZBv",
            "elevator-stop": "style__elevator-stop___3SUjz",
            "icon-line": "style__icon-line___2CemJ",
            "elevator-mode-circle": "style__elevator-mode-circle___1Z1Fn",
            "elevator-mode-dark": "style__elevator-mode-dark___20Qx3",
            "elevator-show": "style__elevator-show___1gArh",
            "elevator-mode-edit": "style__elevator-mode-edit___1rucl",
          },
        };
      function k(e, t) {
        var n =
          ("undefined" !== typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" === typeof e) return O(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return O(e, t);
            })(e)) ||
            (t && e && "number" === typeof e.length)
          ) {
            n && (e = n);
            var o = 0,
              a = function () {};
            return {
              s: a,
              n: function () {
                return o >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[o++] };
              },
              e: function (e) {
                throw e;
              },
              f: a,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
          );
        }
        var r,
          i = !0,
          l = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (i = e.done), e;
          },
          e: function (e) {
            (l = !0), (r = e);
          },
          f: function () {
            try {
              i || null == n.return || n.return();
            } finally {
              if (l) throw r;
            }
          },
        };
      }
      function O(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      function I(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var S = /^\/edit\//.test(window.location.pathname),
        j = (function (e) {
          function t(e) {
            var n;
            return (
              Object(a.default)(this, t),
              ((n = I(this, t, [e])).state = {
                dark: !1,
                currentIndex: -1,
                isShow: !1,
                abTestShow: !0,
                isClick: !1,
                elem: null,
                innerHeight: 0,
                scrollIntoViewBottom: "",
              }),
              (n.scrollEventLister = b()(
                n.scrollEventListener.bind(Object(s.a)(n)),
                300,
              )),
              (n.sendGa = n.sendGa.bind(Object(s.a)(n))),
              (n.includesModuleList = []),
              n
            );
          }
          return (
            Object(c.a)(t, e),
            Object(r.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  this.calcIncludesModuleList(),
                    this.calcRealTimeWindowHeight(),
                    this.scrollEventListener(),
                    window.addEventListener("scroll", this.scrollEventLister);
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  window.addEventListener("scroll", this.scrollEventLister);
                },
              },
              {
                key: "calcRealTimeWindowHeight",
                value: function () {
                  var e = this,
                    t = function () {
                      var t = e.state.innerHeight,
                        n = window.innerHeight;
                      t !== n && e.setState({ innerHeight: n / 2 });
                    };
                  t();
                  var n = g()(t, 50);
                  window.addEventListener("resize", n);
                },
              },
              {
                key: "scrollEventListener",
                value: function () {
                  var e = this;
                  if (this.state.abTestShow) {
                    var t = this,
                      n = document.documentElement.scrollTop;
                    if (this.state.isClick)
                      setTimeout(function () {
                        n === document.documentElement.scrollTop &&
                          (e.state.elem.scrollIntoView(
                            e.state.scrollIntoViewBottom,
                          ),
                          t.setState({ isClick: !1 }));
                      }, 300);
                    else {
                      for (
                        var a,
                          r =
                            document.getElementsByClassName("section-content"),
                          i = document.getElementById("site-footer"),
                          l = Object(o.a)(r).filter(function (e) {
                            return "none" !== e.style.display;
                          }),
                          s = 0;
                        s < l.length;
                        s++
                      ) {
                        var c = l[s].offsetTop;
                        if (!(n >= c - t.state.innerHeight)) break;
                        a = l[s].id.replace("_v1", "");
                      }
                      var _ = null === i || void 0 === i ? void 0 : i.offsetTop;
                      _ && n > _ - 1.2 * t.state.innerHeight && (a = i.id);
                      var u = t.includesModuleList;
                      if (u && u.length > 0) {
                        var d = u.some(function (e) {
                          if (e.moduleId === a) return !0;
                        });
                        t.setState({ isShow: d }),
                          d &&
                            u.forEach(function (e) {
                              e &&
                                a === e.moduleId &&
                                t.setState({ dark: e.hasDark });
                            }),
                          d && this.calcCurrentIndex(a);
                      }
                    }
                  }
                },
              },
              {
                key: "abTestToShowElevator",
                value: function () {
                  var e = this;
                  window.ABTest || (window.ABTest = {}),
                    (window.ABTest.showElevator = function () {
                      e.setState({ abTestShow: !0 }),
                        e.scrollEventListener(),
                        window.addEventListener("scroll", e.scrollEventLister);
                    }),
                    (window.ABTest.hideElevator = function () {
                      e.setState({ abTestShow: !1 }),
                        window.removeEventListener(
                          "scroll",
                          e.scrollEventLister,
                        );
                    });
                },
              },
              {
                key: "moduleIdStrToList",
                value: function (e) {
                  var t = null === e || void 0 === e ? void 0 : e.split(",");
                  return (t = (t = t.filter(function (e) {
                    return "" !== e;
                  })).map(function (e) {
                    return e.trim();
                  }));
                },
              },
              {
                key: "handleClick",
                value: function (e, t) {
                  var n = this,
                    o = e && e.elevatorId ? e.elevatorId : "";
                  if ("" !== o) {
                    var a = document.getElementById(o);
                    if (a) {
                      e &&
                        e.elevatorDetails &&
                        e.elevatorDetails.forEach(function (e) {
                          var t = n.moduleIdStrToList(
                            null === e || void 0 === e ? void 0 : e.moduleId,
                          );
                          if (t && t.length > 0) {
                            var a,
                              r = k(t);
                            try {
                              for (r.s(); !(a = r.n()).done; ) {
                                a.value === o &&
                                  n.setState({ dark: e.hasDark });
                              }
                            } catch (i) {
                              r.e(i);
                            } finally {
                              r.f();
                            }
                          } else
                            e &&
                              e.moduleId === o &&
                              n.setState({ dark: e.hasDark });
                        });
                      var r = !a.querySelector(".elevator-bottom"),
                        i = a.querySelector(".elevator-bottom") || a;
                      this.setState({
                        currentIndex: t,
                        isClick: !0,
                        elem: i,
                        scrollIntoViewBottom: r,
                      }),
                        i.scrollIntoView(r);
                    }
                  }
                },
              },
              {
                key: "calcIncludesModuleList",
                value: function () {
                  var e = this,
                    t =
                      this.props.component_data &&
                      this.props.component_data.elevatorList
                        ? this.props.component_data.elevatorList
                        : [],
                    n = [];
                  t &&
                    t.length > 0 &&
                    (t.forEach(function (t) {
                      if (t && t.elevatorDetails) {
                        var o,
                          a = k(t.elevatorDetails);
                        try {
                          for (a.s(); !(o = a.n()).done; ) {
                            var r = o.value,
                              i = e.moduleIdStrToList(
                                null === r || void 0 === r
                                  ? void 0
                                  : r.moduleId,
                              );
                            if (i && i.length > 0) {
                              var l,
                                s = k(i);
                              try {
                                for (s.s(); !(l = s.n()).done; ) {
                                  var c = {
                                    moduleId: l.value,
                                    hasDark: r.hasDark,
                                  };
                                  n.push(c);
                                }
                              } catch (_) {
                                s.e(_);
                              } finally {
                                s.f();
                              }
                            } else n.push(r);
                          }
                        } catch (_) {
                          a.e(_);
                        } finally {
                          a.f();
                        }
                      }
                    }),
                    (this.includesModuleList = n));
                },
              },
              {
                key: "calcCurrentIndex",
                value: function (e) {
                  var t = this,
                    n =
                      this.props.component_data &&
                      this.props.component_data.elevatorList
                        ? this.props.component_data.elevatorList
                        : [];
                  n &&
                    n.length > 0 &&
                    n.forEach(function (n, o) {
                      if (n && n.elevatorDetails) {
                        var a,
                          r = k(n.elevatorDetails);
                        try {
                          for (r.s(); !(a = r.n()).done; ) {
                            var i = a.value,
                              l = t.moduleIdStrToList(
                                null === i || void 0 === i
                                  ? void 0
                                  : i.moduleId,
                              );
                            if (l && l.length > 0) {
                              var s,
                                c = k(l);
                              try {
                                for (c.s(); !(s = c.n()).done; ) {
                                  s.value === e &&
                                    t.setState({ currentIndex: o });
                                }
                              } catch (_) {
                                c.e(_);
                              } finally {
                                c.f();
                              }
                            } else
                              i.moduleId === e &&
                                t.setState({ currentIndex: o });
                          }
                        } catch (_) {
                          r.e(_);
                        } finally {
                          r.f();
                        }
                      }
                    });
                },
              },
              {
                key: "sendGa",
                value: function (e, t, n) {
                  this.state.isShow && (0, this.props.gaSend)(e, n, t);
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.component_data,
                    o = t.t,
                    a = this.state,
                    r = a.dark,
                    i = a.isShow,
                    l = a.currentIndex,
                    s = a.abTestShow,
                    c = n.elevatorTheme,
                    _ = n.elevatorList;
                  return w(
                    "div",
                    {
                      style: { display: S || s ? "block" : "none" },
                      className: u()(
                        h()("product-elevator", {
                          "elevator-mode-edit": S,
                          "elevator-mode-dark": r,
                          "elevator-show": i,
                          "elevator-mode-circle": "circle" === c,
                        }),
                        x,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    w(
                      "ul",
                      {
                        className: u()(h()("elevator-details"), x, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      null === _ || void 0 === _
                        ? void 0
                        : _.map(function (t, n) {
                            return w(
                              "div",
                              {
                                onClick: function () {
                                  e.handleClick(t, n),
                                    e.sendGa(
                                      "click",
                                      "side-nav",
                                      o(t.elevatorTitle),
                                    );
                                },
                                onMouseEnter: function () {
                                  e.sendGa(
                                    "hover",
                                    "side-nav",
                                    o(t.elevatorTitle),
                                  );
                                },
                                key: "elevator_".concat(n),
                                id: "elevator_".concat(t.elevatorId),
                                className: u()(
                                  h()("elevator-item", {
                                    "elevator-item-active": l === n,
                                  }),
                                  x,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                              },
                              w("span", {
                                dangerouslySetInnerHTML: {
                                  __html: o(t.elevatorTitle),
                                },
                              }),
                            );
                          }),
                    ),
                    "circle" === c
                      ? null
                      : w("i", {
                          className: "style__icon-line___2CemJ",
                          style: {
                            top: 0 === l ? "0px" : "".concat(32 * l, "px"),
                          },
                        }),
                  );
                },
              },
            ]),
            t
          );
        })(p.a.Component);
      (j.defaultProps = {
        t: function () {},
        gaSend: function () {},
        component_data: {
          elevatorList: [
            {
              elevatorTitle: "",
              elevatorId: "",
              elevatorDetails: [{ moduleId: "", hasDark: !0 }],
            },
          ],
        },
      }),
        (j.propSettings = {
          key: "Elevator",
          name: "Elevator",
          contentSetting: {
            cardList: {
              label: "\u5361\u7247",
              group_type: "array_card",
              group_prop_name: "elevatorList",
              props: {
                elevatorDetailsList: {
                  label: "\u4ea7\u54c1\u9875\u7535\u68af",
                  props: {
                    elevatorTitle: {
                      label: "\u6587\u6848",
                      type: "string",
                      content: "text",
                    },
                    elevatorId: {
                      label: "\u951a\u70b9Id",
                      helptext:
                        "*\u5fc5\u586b\uff0c\u4ec5\u586b\u5199\u4e00\u4e2aId",
                      type: "string",
                    },
                    elevatorDetails: {
                      label: "\u6a21\u5757\u5217\u8868",
                      type: "array",
                      props: {
                        moduleId: {
                          label: "\u6a21\u5757Id",
                          type: "string",
                          helptext:
                            "\u53ef\u4f7f\u7528\u82f1\u6587,\u62fc\u63a5\u591a\u4e2a\u6a21\u5757Id",
                        },
                        hasDark: {
                          type: "boolean",
                          label: "\u6df1\u8272\u6a21\u5f0f",
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            styleSetting: {
              label: "\u6837\u5f0f\u914d\u7f6e",
              props: {
                elevatorTheme: {
                  type: "select",
                  label: "\u4e3b\u9898",
                  items: [
                    { label: "\u7ad6\u7ebf", value: "line" },
                    { label: "\u5706\u70b9", value: "circle" },
                  ],
                },
              },
            },
          },
        });
      t.a = Object(m.a)(j);
    },
    MPFp: function (e, t, n) {
      "use strict";
      var o = n("uOPS"),
        a = n("Y7ZC"),
        r = n("kTiW"),
        i = n("NegM"),
        l = n("SBuE"),
        s = n("j2DC"),
        c = n("RfKB"),
        _ = n("U+KD"),
        u = n("UWiX")("iterator"),
        d = !([].keys && "next" in [].keys()),
        p = function () {
          return this;
        };
      e.exports = function (e, t, n, f, h, m, y) {
        s(n, t, f);
        var b,
          v,
          g,
          w = function (e) {
            if (!d && e in I) return I[e];
            switch (e) {
              case "keys":
              case "values":
                return function () {
                  return new n(this, e);
                };
            }
            return function () {
              return new n(this, e);
            };
          },
          x = t + " Iterator",
          k = "values" == h,
          O = !1,
          I = e.prototype,
          S = I[u] || I["@@iterator"] || (h && I[h]),
          j = S || w(h),
          T = h ? (k ? w("entries") : j) : void 0,
          C = ("Array" == t && I.entries) || S;
        if (
          (C &&
            (g = _(C.call(new e()))) !== Object.prototype &&
            g.next &&
            (c(g, x, !0), o || "function" == typeof g[u] || i(g, u, p)),
          k &&
            S &&
            "values" !== S.name &&
            ((O = !0),
            (j = function () {
              return S.call(this);
            })),
          (o && !y) || (!d && !O && I[u]) || i(I, u, j),
          (l[t] = j),
          (l[x] = p),
          h)
        )
          if (
            ((b = {
              values: k ? j : w("values"),
              keys: m ? j : w("keys"),
              entries: T,
            }),
            y)
          )
            for (v in b) v in I || r(I, v, b[v]);
          else a(a.P + a.F * (d || O), t, b);
        return b;
      };
    },
    MTB2: function (e, t, n) {
      "use strict";
      n.r(t),
        n.d(t, "listen", function () {
          return J;
        }),
        n.d(t, "subscribe", function () {
          return $;
        }),
        n.d(t, "unsubscribe", function () {
          return ee;
        });
      var o = n("3OWR"),
        a = n.n(o),
        r = n("uF6l"),
        i = n.n(r),
        l = !1;
      if ("undefined" !== typeof window)
        try {
          var s = Object.defineProperty({}, "passive", {
            get: function () {
              l = !0;
            },
          });
          window.addEventListener("test", null, s),
            window.removeEventListener("test", null, s);
        } catch (te) {}
      var c = l,
        _ = {
          connections: {},
          EE: new i.a(),
          enableResizeInfo: !1,
          enableScrollInfo: !1,
          listeners: {},
          removers: [],
          supportPassiveEvent: c,
        },
        u = _.supportPassiveEvent,
        d = { capture: !1, passive: !1 };
      var p = function (e, t, n, o) {
          var r = "addEventListener",
            i = "removeEventListener",
            l = t,
            s = !!u && a()({}, d, o);
          return (
            !e.addEventListener &&
              e.attachEvent &&
              ((r = "attachEvent"), (i = "detachEvent"), (l = "on" + t)),
            e[r](l, n, s),
            {
              remove: function () {
                e[i](t, n);
              },
            }
          );
        },
        f = !1;
      if ("undefined" !== typeof navigator) {
        var h = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
        h && (f = parseFloat(h[1], 10) < 9);
      }
      var m = f,
        y = n("uM7l"),
        b = n.n(y),
        v = n("DzJC"),
        g = n.n(v),
        w = n("vN+2"),
        x = n.n(w),
        k = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              (o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                "value" in o && (o.writable = !0),
                Object.defineProperty(e, o.key, o);
            }
          }
          return function (t, n, o) {
            return n && e(t.prototype, n), o && e(t, o), t;
          };
        })();
      var O = { width: 0, height: 0 },
        I = { delta: 0, top: 0 },
        S = { axisIntention: "", startX: 0, startY: 0, deltaX: 0, deltaY: 0 },
        j = function (e) {
          var t = { x: 0, y: 0 },
            n = document.body,
            o = document.documentElement;
          return (
            e.pageX || e.pageY
              ? ((t.x = e.pageX), (t.y = e.pageY))
              : ((t.x = e.clientX + n.scrollLeft + o.scrollLeft),
                (t.y = e.clientY + n.scrollTop + o.scrollTop)),
            t
          );
        },
        T = (function () {
          function e() {
            var t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {};
            !(function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, e);
            var n = (t.mainType || "").toLowerCase(),
              o = (t.subType || "").toLowerCase();
            (this.mainType = n),
              (this.subType = o),
              (this.type = n + o.charAt(0).toUpperCase() + o.slice(1) || ""),
              (this.scroll = I),
              (this.resize = O),
              (this.touch = S);
          }
          return (
            k(e, [
              {
                key: "update",
                value: function (e) {
                  var t = this.mainType,
                    n = this.subType,
                    o = document.documentElement;
                  if (
                    _.enableScrollInfo &&
                    ("scroll" === t || "touchmove" === t)
                  ) {
                    var a = o.scrollTop + document.body.scrollTop;
                    a !== this.scroll.top &&
                      ((this.scroll.delta = a - this.scroll.top),
                      (this.scroll.top = a));
                  }
                  if (
                    (_.enableResizeInfo &&
                      "resize" === t &&
                      ((this.resize.width = window.innerWidth || o.clientWidth),
                      (this.resize.height =
                        window.innerHeight || o.clientHeight)),
                    _.enableTouchInfo &&
                      e.touches &&
                      ("touchstart" === t ||
                        "touchmove" === t ||
                        "touchend" === t))
                  ) {
                    var r = void 0,
                      i = void 0,
                      l = void 0;
                    "touchstart" === t || "start" === n
                      ? ((r = j(e.touches[0])),
                        (this.touch.axisIntention = ""),
                        (this.touch.startX = r.x),
                        (this.touch.startY = r.y),
                        (this.touch.deltaX = 0),
                        (this.touch.deltaY = 0))
                      : "touchmove" === t &&
                        ((r = j(e.touches[0])),
                        (this.touch.deltaX = r.x - this.touch.startX),
                        (this.touch.deltaY = r.y - this.touch.startY),
                        "" === this.touch.axisIntention &&
                          ((i = Math.abs(this.touch.deltaX)),
                          (l = Math.abs(this.touch.deltaY)),
                          i > 5 && i >= l
                            ? (this.touch.axisIntention = "x")
                            : l > 5 &&
                              l > i &&
                              (this.touch.axisIntention = "y")));
                  }
                },
              },
            ]),
            e
          );
        })(),
        C = n("xEkU"),
        M = n.n(C),
        P =
          Date.now ||
          function () {
            return new Date().getTime();
          };
      var E = function (e) {
          var t =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : 15,
            n = void 0,
            o = void 0,
            a = 0,
            r = 0,
            i = function i() {
              var l = P();
              t - (l - a) <= 0
                ? ((a = l), (r = 0), e.apply(n, o))
                : (r = M()(i));
            };
          return function () {
            (n = this), (o = arguments), r || (r = M()(i));
          };
        },
        L = 100,
        B = 50,
        N = _.connections,
        D = _.EE,
        z = _.listeners,
        A = _.removers,
        R = void 0,
        F = void 0,
        V = void 0,
        H = 0;
      function W(e) {
        return e.id || "target-id-" + H++;
      }
      function U(e, t, n, o) {
        return (
          D.on(e, t || x.a, n),
          (N[(o = o || e)] = (N[o] || 0) + 1),
          {
            _type: e,
            _cb: t,
            _ctx: n,
            unsubscribe: function () {
              if (this._type) {
                D.removeListener(e, t, n),
                  N[o]--,
                  0 === N[o] && (z[o].remove(), (z[o] = void 0)),
                  (this._type = void 0),
                  (this._cb = void 0),
                  (this._ctx = void 0);
                for (var a = A.length - 1; a >= 0; a--) {
                  if (A[a] === this) {
                    A.splice(a, 1);
                    break;
                  }
                }
              }
            },
          }
        );
      }
      function G(e, t, n) {
        return function (o, a, r, i) {
          var l = r.context,
            s = r.target,
            c = s && W(s),
            _ = c ? ":" + c : "",
            u = t + "Start:" + o + _,
            d = t + "End:" + o + _,
            f = t + ":" + o + _,
            h = U(n + ":" + o + _, a, l, f);
          if ((A.push(h), z[f])) return h;
          var y = {
            start: new T({ mainType: t, subType: "start" }),
            main: new T({ mainType: t }),
            end: new T({ mainType: t, subType: "end" }),
          };
          "raf" === o ? ((o = 16), (x = E(x))) : o > 0 && (x = g()(x, o));
          var v = void 0;
          function w(e) {
            y.end.update(e), D.emit(d, e, y.end), (v = null);
          }
          function x(e) {
            v || (y.start.update(e), D.emit(u, e, y.start)),
              clearTimeout(v),
              y.main.update(e),
              D.emit(f, e, y.main),
              (v = m
                ? setTimeout(function () {
                    w(b()(e));
                  }, o + L)
                : setTimeout(w.bind(null, e), o + L));
          }
          return (z[f] = p(s || e, t, x, i)), h;
        };
      }
      function Y(e, t) {
        return function (n, o, a, r) {
          var i = a.context,
            l = a.target,
            s = l && W(l),
            c = t + ":0" + (s ? ":" + s : ""),
            _ = U(c, o, i);
          if ((A.push(_), z[c])) return _;
          var u = new T({ mainType: t });
          return (
            (z[c] = p(
              l || e,
              t,
              function (e) {
                u.update(e), D.emit(c, e, u);
              },
              r,
            )),
            _
          );
        };
      }
      "undefined" !== typeof window &&
        (V = (R = (F = window).document || document).body);
      var q = {
        scrollStart: G(F, "scroll", "scrollStart"),
        scrollEnd: G(F, "scroll", "scrollEnd"),
        scroll: G(F, "scroll", "scroll"),
        resizeStart: G(F, "resize", "resizeStart"),
        resizeEnd: G(F, "resize", "resizeEnd"),
        resize: G(F, "resize", "resize"),
        visibilitychange: Y(R, "visibilitychange"),
        touchmoveStart: G(V, "touchmove", "touchmoveStart"),
        touchmoveEnd: G(V, "touchmove", "touchmoveEnd"),
        touchmove: G(V, "touchmove", "touchmove"),
        touchstart: Y(V, "touchstart"),
        touchend: Y(V, "touchend"),
      };
      var X = function (e, t) {
          var n =
              arguments.length > 2 && void 0 !== arguments[2]
                ? arguments[2]
                : {},
            o = n.useRAF || !1,
            a = parseInt(n.throttleRate, 10),
            r = n.eventOptions;
          return (
            isNaN(a) && (a = B),
            o && (a = "raf"),
            m && (a = 0),
            (_.enableScrollInfo =
              _.enableScrollInfo || n.enableScrollInfo || !1),
            (_.enableResizeInfo =
              _.enableResizeInfo || n.enableResizeInfo || !1),
            (_.enableTouchInfo = _.enableTouchInfo || n.enableTouchInfo || !1),
            q[e](a, t, n, r)
          );
        },
        Z = _.removers;
      var K = "undefined" !== typeof window;
      function Q() {
        0;
      }
      var J = K ? p : Q,
        $ = K ? X : Q,
        ee = K
          ? function (e, t) {
              for (var n = void 0, o = Z.length - 1; o >= 0; o -= 1)
                (n = Z[o])._cb === t &&
                  n._type.indexOf(e) >= 0 &&
                  (n.unsubscribe(), Z.splice(o, 1));
            }
          : Q;
    },
    MrPd: function (e, t, n) {
      var o = n("hypo"),
        a = n("ljhN"),
        r = Object.prototype.hasOwnProperty;
      e.exports = function (e, t, n) {
        var i = e[t];
        (r.call(e, t) && a(i, n) && (void 0 !== n || t in e)) || o(e, t, n);
      };
    },
    MvSz: function (e, t, n) {
      var o = n("LXxW"),
        a = n("0ycA"),
        r = Object.prototype.propertyIsEnumerable,
        i = Object.getOwnPropertySymbols,
        l = i
          ? function (e) {
              return null == e
                ? []
                : ((e = Object(e)),
                  o(i(e), function (t) {
                    return r.call(e, t);
                  }));
            }
          : a;
      e.exports = l;
    },
    MvwC: function (e, t, n) {
      var o = n("5T2Y").document;
      e.exports = o && o.documentElement;
    },
    N2pn: function (e, t, n) {
      e.exports = {
        "click-modal-btns-m": "style__click-modal-btns-m___z6y8Q",
        "click-modal-btn": "style__click-modal-btn___2kQB_",
        content: "style__content___F2UYA",
        "click-modal-btns-pc": "style__click-modal-btns-pc___5fE5V",
        "modal-close": "style__modal-close___1rrwL",
        "modal-container": "style__modal-container___3BmKX",
        "light-theme": "style__light-theme___1IuEt",
        "modal-content-box": "style__modal-content-box___3d7ut",
        "model-box": "style__model-box___2d8qp",
        disabled: "style__disabled___2HBnj",
        active: "style__active___flIqM",
        "modal-frame": "style__modal-frame___1wf1B",
        "modal-container-m": "style__modal-container-m___2Wolb",
        "modal-arModel": "style__modal-arModel___vNyxR",
        "modal-3dModel": "style__modal-3dModel___1DlT8",
      };
    },
    NJgT: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      });
      var o = function (e, t) {
          return function (n) {
            return t(e(n));
          };
        },
        a = function () {
          for (var e = [], t = 0; t < arguments.length; t++)
            e[t] = arguments[t];
          return e.reduce(o);
        };
    },
    NKxu: function (e, t, n) {
      var o = n("lSCD"),
        a = n("E2jh"),
        r = n("GoyQ"),
        i = n("3Fdi"),
        l = /^\[object .+?Constructor\]$/,
        s = Function.prototype,
        c = Object.prototype,
        _ = s.toString,
        u = c.hasOwnProperty,
        d = RegExp(
          "^" +
            _.call(u)
              .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
              .replace(
                /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                "$1.*?",
              ) +
            "$",
        );
      e.exports = function (e) {
        return !(!r(e) || a(e)) && (o(e) ? d : l).test(i(e));
      };
    },
    NMkd: function (e, t, n) {
      "use strict";
      var o = n("ODXe"),
        a = n("wx14"),
        r = n("rePB"),
        i = n("iKuz"),
        l = n.n(i),
        s = n("q1tI"),
        c = n.n(s),
        _ = n("XnI8"),
        u = n("IrEl"),
        d = n("j0XM"),
        p = n("ATyU"),
        f = n("DdlN"),
        h = n("jCXQ"),
        m = n("6AKW"),
        y = n("/+VL"),
        b = n("7xG5"),
        v = [
          {
            textTitle: "1/2 \u82f1\u5bf8 \u957f\u7126\u76f8\u673a",
            textDesc: "166 mm \u7b49\u6548\u7126\u8ddd",
            textWidth: "200",
            textAppearShot: "220",
            textFullAppearShot: "230",
            textDisappearShot: "240",
            textFullDisappearShot: "250",
            topPos: "300",
            leftPos: "100",
            textAlign: "left",
            lineLengthStart: "0",
            lineLengthEnd: "400",
          },
          {
            textTitle: "1/1.3 \u82f1\u5bf8 \u4e2d\u957f\u7126\u76f8\u673a",
            textDesc: "70 mm \u7b49\u6548\u7126\u8ddd",
            textWidth: "200",
            textAppearShot: "250",
            textFullAppearShot: "260",
            textDisappearShot: "270",
            textFullDisappearShot: "280",
            topPos: "300",
            leftPos: "100",
            textAlign: "left",
            lineLengthStart: "0",
            lineLengthEnd: "400",
          },
          {
            textTitle: "4/3 CMOS \u54c8\u82cf\u76f8\u673a",
            textDesc: "24 mm \u7b49\u6548\u7126\u8ddd",
            textWidth: "200",
            textAppearShot: "280",
            textFullAppearShot: "290",
            textDisappearShot: "",
            topPos: "300",
            leftPos: "100",
            textAlign: "left",
            lineLengthStart: "0",
            lineLengthEnd: "400",
          },
        ],
        g = {
          style: {
            fontSize: "80px",
            lineHeight: "88px",
            fontWeight: "500",
            letterSpacing: "-0.03em",
            color: "transparent",
            margin: "",
            padding: "",
            backgroundImage:
              "linear-gradient(90deg, rgba(78,78,82,1) 0%, rgba(136,136,139,1) 25%, rgba(255,255,255,1) 50%, rgba(125,125,128,1) 75%, rgba(78,78,82,1) 100%)",
            WebkitBackgroundClip: "text",
          },
          type: "",
          checkedSelf: !0,
          fontType: "gradient-text",
        },
        w = {
          style: {
            fontSize: "48px",
            lineHeight: "56px",
            fontWeight: "500",
            letterSpacing: "-0.03em",
            color: "transparent",
            margin: "",
            padding: "",
            backgroundImage:
              "linear-gradient(90deg, rgba(78,78,82,1) 0%, rgba(136,136,139,1) 25%, rgba(255,255,255,1) 50%, rgba(125,125,128,1) 75%, rgba(78,78,82,1) 100%)",
            WebkitBackgroundClip: "text",
          },
          type: "",
          checkedSelf: !0,
          fontType: "pure-text",
        },
        x = {
          style: {
            fontSize: "24px",
            lineHeight: "32px",
            fontWeight: "400",
            letterSpacing: "-0.03em",
            color: "rgba(255,255,255,0.65)",
            margin: "",
            padding: "",
            backgroundImage: "",
            WebkitBackgroundClip: "",
          },
          type: "",
          checkedSelf: !0,
          fontType: "pure-text",
        },
        k = {
          style: {
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "400",
            letterSpacing: "-0.02em",
            color: "rgba(255,255,255,0.65)",
            margin: "",
            padding: "",
            backgroundImage: "",
            WebkitBackgroundClip: "",
          },
          type: "",
          checkedSelf: !0,
          fontType: "pure-text",
        },
        O = {
          style: {
            fontSize: "32px",
            lineHeight: "40px",
            fontWeight: "500",
            letterSpacing: "-0.03em",
            color: "#FA8C16",
            margin: "",
            padding: "",
            backgroundImage: "",
            WebkitBackgroundClip: "",
          },
          type: "",
          fontType: "pure-text",
          checkedSelf: !0,
        },
        I = {
          style: {
            fontSize: "20px",
            lineHeight: "28px",
            fontWeight: "500",
            letterSpacing: "-0.03em",
            color: "#FA8C16",
            margin: "",
            padding: "",
            backgroundImage: "",
            WebkitBackgroundClip: "",
          },
          type: "",
          checkedSelf: !0,
          fontType: "pure-text",
        },
        S = {
          frameNaturalWidth: "1920",
          frameNaturalHeight: "1080",
          webpOn: !1,
          webpAddress: "",
          totalCount: "301",
          format: "jpg",
          address:
            "https://www1.djicdn.com/reactor/assets/_next/static/sequence-frames/d4f472eb-c352-4f53-8440-52b3381702c0/",
          chunkCount: "2",
          backupKeyFrames: [
            { index: "60", breakpoint: "0.05" },
            { index: "160", breakpoint: "0.5" },
            { index: "240", breakpoint: "1" },
          ],
        },
        j = {
          frameNaturalWidth: "1080",
          frameNaturalHeight: "1920",
          webpOn: !1,
          webpAddress: "",
          totalCount: "301",
          format: "jpg",
          address:
            "https://www1.djicdn.com/reactor/assets/_next/static/sequence-frames/a21b7295-d588-43d2-948b-0ffd02c5bef8/",
          chunkCount: "2",
          backupKeyFrames: [
            { index: "60", breakpoint: "0.05" },
            { index: "160", breakpoint: "0.5" },
            { index: "240", breakpoint: "1" },
          ],
        },
        T = {
          title:
            "\u4e09\u6444\u65d7\u8230\u5f71\u50cf \u72ec\u6811\u4e00\u5e1c",
          desc: "\u4e00\u53f0\u822a\u62cd\u673a\uff0c\u4e09\u9897\u955c\u5934\uff0c\u65e0\u5c3d\u60f3\u8c61\u3002\u591a\u7126\u6bb5\u6240\u80fd\u5b9e\u73b0\u7684\u955c\u5934\u8bed\u8a00\u66f4\u80dc\u4ee5\u5f80\uff0c\u7115\u65b0\u5149\u5f71\u8868\u8fbe\uff0c\u4e5f\u4ee4 Mavic 3 Pro \u62e5\u6709\u8d85\u7fa4\u7684\u591a\u573a\u666f\x05\u5e94\u5bf9\u80fd\u529b\u3002\u8f7b\u89e6\u5c4f\u5e55\uff0c\u8f7b\u677e\u5207\u6362\u955c\u5934\uff0c\u65e0\u8bba\u5728\u4f55\u79cd\u62cd\u6444\u73af\u5883\u4e0b\uff0c\u90fd\u80fd\u6536\u83b7\u5404\u5177\u98ce\u683c\u7684\u6784\u56fe\uff0c\u521b\u610f\u987a\u7545\u5b9e\u73b0\uff0c\u822a\u62cd\u6548\u7387\u4e00\u8dc3\u800c\u8d77\u3002",
          textList: v,
          textDescFont: {
            style: {
              fontSize: "16px",
              lineHeight: "20px",
              fontWeight: "400",
              letterSpacing: "-0.02em",
              color: "rgba(255,255,255,0.65)",
              margin: "",
              padding: "",
              backgroundImage: "",
              WebkitBackgroundClip: "",
            },
            type: "",
            fontType: "pure-text",
            checkedSelf: !0,
          },
          lineColor: "#FFFFFF",
          titleScale: 3,
          titleDisappearShot: 30,
          descAppearShot: 40,
          descFullAppearShot: 70,
          descDisappearShot: 100,
          endDuration: 200,
          frameDuration: 5e3,
          descTranslate: 200,
        },
        C = function (e, t, n, o) {
          var a = e.component_data,
            r = void 0 === a ? {} : a,
            i = 0 === t ? 1200 : t,
            l = r.frameDuration,
            s = void 0 === l ? 5e3 : l,
            c = r.titleScale,
            _ = void 0 === c ? 3 : c,
            u = r.frameConfig,
            d = void 0 === u ? S : u,
            p = r.titleDisappearShot,
            f = void 0 === p ? 30 : p,
            h = r.descAppearShot,
            m = void 0 === h ? 40 : h,
            y = r.descFullAppearShot,
            b = void 0 === y ? 70 : y,
            g = r.descDisappearShot,
            w = void 0 === g ? 100 : g,
            x = r.textList,
            k = void 0 === x ? v : x,
            O = r.descTranslate,
            I = (function (e, t, n) {
              return {
                frameDurationNum: Number(e) || 5e3,
                titleScaleNum: Number(t) || 3,
                descTranslateNum: Number(n) || 200,
              };
            })(s, _, void 0 === O ? 200 : O),
            j = I.frameDurationNum,
            T = I.titleScaleNum,
            C = I.descTranslateNum,
            M = Number(d.totalCount),
            P = (Number(f) / M) * j,
            E = (Number(m) / M) * j,
            L = (Number(b) / M) * j,
            B = (Number(w) / M) * j,
            N = {
              cameraPlay: {
                label: "\u5e8f\u5217\u5e27\u64ad\u653e",
                actions: [{ start: 0, end: j }],
              },
              titleTextScale: {
                label: "\u4e3b\u6807\u9898\u653e\u5927",
                change: "scale",
                actions: [{ from: 1, to: T, start: 0, end: P }],
              },
              titleTextOpacity: {
                label: "\u4e3b\u6807\u9898\u900f\u660e\u5ea6",
                change: "opacity",
                actions: [{ from: 1, to: 0, start: 0, end: P }],
              },
              descOpacity: {
                label: "\u4e3b\u6807\u9898\u63cf\u8ff0\u900f\u660e\u5ea6",
                change: "opacity",
                actions: [
                  { from: 0, to: 1, start: E, end: L },
                  { from: 1, to: 0, start: L, end: B },
                ],
              },
            };
          return (
            null === k ||
              void 0 === k ||
              k.map(function (e, t) {
                var a = (Number(e.textAppearShot) / M) * j,
                  r = (Number(e.textFullAppearShot) / M) * j,
                  l = (Number(e.textDisappearShot) / M) * j,
                  s = (Number(e.textFullDisappearShot) / M) * j,
                  c = Number(e.lineLengthStart || 0) * (i / 1920),
                  _ = Number(e.lineLengthEnd || 0) * (i / 1920);
                t === k.length - 1
                  ? ((N["frameText-".concat(t)] = {
                      label: "\u7b2c".concat(
                        t + 1,
                        "\u4e2a\u62c9\u7ebf\u52a8\u753b",
                      ),
                      change: "opacity",
                      actions: [{ from: 0, to: 1, start: a, end: r }],
                    }),
                    o &&
                      (N["frameTextTranslate-".concat(t)] = {
                        label: "\u7b2c".concat(
                          t + 1,
                          "\u4e2a\u6587\u6848\u8fdb\u9000\u573a",
                        ),
                        change: "y",
                        actions: [
                          {
                            from: Number(C * (n / 1920)),
                            to: 0,
                            start: a,
                            end: r,
                          },
                        ],
                      }))
                  : ((N["frameText-".concat(t)] = {
                      label: "\u7b2c".concat(
                        t + 1,
                        "\u4e2a\u62c9\u7ebf\u52a8\u753b",
                      ),
                      change: "opacity",
                      actions: [
                        { from: 0, to: 1, start: a, end: r },
                        { from: 1, to: 0, start: l, end: s },
                      ],
                    }),
                    o &&
                      (N["frameTextTranslate-".concat(t)] = {
                        label: "\u7b2c".concat(
                          t + 1,
                          "\u4e2a\u6587\u6848\u8fdb\u9000\u573a",
                        ),
                        change: "y",
                        actions: [
                          {
                            from: Number(C * (n / 1920)),
                            to: 0,
                            start: a,
                            end: r,
                          },
                          {
                            from: 0,
                            to: -Number(C * (n / 1920)),
                            start: l,
                            end: s,
                          },
                        ],
                      })),
                  (N["frameDesc-".concat(t)] = {
                    label: "\u7b2c".concat(
                      t + 1,
                      "\u4e2a\u62c9\u7ebf\u52a8\u753b\u63cf\u8ff0y\u8f74\u79fb\u52a8",
                    ),
                    change: "y",
                    actions: [{ from: 5, to: 0, start: a, end: r }],
                  }),
                  (N["frameLine-".concat(t)] = {
                    label: "\u7b2c".concat(
                      t + 1,
                      "\u4e2a\u62c9\u7ebf\u7ebf\u957f\u5ea6\u53d8\u5316",
                    ),
                    change: "width",
                    actions: [{ from: c, to: _, start: a, end: r }],
                  });
              }),
            N
          );
        },
        M = function (e, t, n, o, a, r, i, l, s, c) {
          var _,
            u,
            d = a ? 1080 : 1920,
            p = a ? 1920 : 1080,
            f = l[c],
            h = s[c],
            m =
              null === f || void 0 === f
                ? void 0
                : null === (_ = f.current) || void 0 === _
                  ? void 0
                  : _.getBoundingClientRect().height,
            y =
              null === (u = h.current) || void 0 === u
                ? void 0
                : u.getBoundingClientRect().height,
            b = e ? "".concat(e * (i / p) - m, "px") : "",
            v = o ? "".concat(o * (r / d), "px") : "",
            g = n ? "".concat(n * (i / p) - y, "px") : "";
          return {
            top: b,
            right: t ? "".concat(t * (r / d), "px") : "",
            bottom: g,
            left: v,
          };
        },
        P = (n("erpB"), c.a.createElement);
      function E(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function L(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? E(Object(n), !0).forEach(function (t) {
                Object(r.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : E(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var B = {
          "./style.css": {
            banner: "style__banner___3GU3j",
            sticky: "style__sticky___3ThWK",
            "sticky-wrapper": "style__sticky-wrapper___3yU69",
            "frame-wrapper": "style__frame-wrapper___QWr92",
            "title-text": "style__title-text___2BqSS",
            "title-text-content": "style__title-text-content___1OCu_",
            "title-text-mobile-width": "style__title-text-mobile-width___3Zezk",
            "desc-text": "style__desc-text___1yKdX",
            "frame-text-wrapper": "style__frame-text-wrapper___33gS-",
            line: "style__line___1h1bo",
            "line-text-box": "style__line-text-box___2lKKl",
            "line-text-box-mobile": "style__line-text-box-mobile___1cvEN",
            "line-text-title": "style__line-text-title___3heSp",
            "line-text-title-mobile": "style__line-text-title-mobile___3l73K",
            "line-text-desc": "style__line-text-desc___10dbc",
            "line-text-desc-mobile": "style__line-text-desc-mobile___1xQzQ",
          },
        },
        // N = function (e) {
        //   var t,
        //     n,
        //     o,
        //     a = e.component_data,
        //     r = e.titleTextRef,
        //     i = e.drivers,
        //     s = e.t,
        //     c = e.mobileMode,
        //     _ = e.windowWidth,
        //     u = e.windowHeight;
        //   return P(
        //     "div",
        //     {
        //       ref: r,
        //       style: {
        //         width: "".concat(_, "px"),
        //         height: "".concat(u, "px"),
        //         pointerEvents: "none",
        //       },
        //       className: l()(
        //         "title-text ".concat(c && "title-text-mobile-width"),
        //         B,
        //         {
        //           autoResolveMultipleImports: !0,
        //           handleMissingStyleName: "warn",
        //         },
        //       ),
        //     },
        //     P(
        //       p.a.div,
        //       {
        //         style: {
        //           scale:
        //             null === (t = i.titleTextScale) || void 0 === t
        //               ? void 0
        //               : t.moto,
        //           opacity:
        //             null === (n = i.titleTextOpacity) || void 0 === n
        //               ? void 0
        //               : n.moto,
        //         },
        //         className: "style__title-text-content___1OCu_",
        //       },
        //       P("h2", {
        //         style: L(
        //           {},
        //           null === (o = a.titleFont) || void 0 === o ? void 0 : o.style,
        //         ),
        //         dangerouslySetInnerHTML: { __html: s(a.title) },
        //       }),
        //     ),
        //   );
        // },
        // D = function (e) {
        //   var t,
        //     n,
        //     o = e.component_data,
        //     a = e.drivers,
        //     r = e.t,
        //     i = e.mobileMode;
        //   return P(
        //     "div",
        //     {
        //       className: l()(
        //         "desc-text ".concat(i && "title-text-mobile-width"),
        //         B,
        //         {
        //           autoResolveMultipleImports: !0,
        //           handleMissingStyleName: "warn",
        //         },
        //       ),
        //     },
        //     P(p.a.div, {
        //       style: L(
        //         {
        //           opacity:
        //             null === (t = a.descOpacity) || void 0 === t
        //               ? void 0
        //               : t.moto,
        //         },
        //         null === (n = o.descFont) || void 0 === n ? void 0 : n.style,
        //       ),
        //       dangerouslySetInnerHTML: { __html: r(o.desc) },
        //     }),
        //   );
        // },
        z = function (e) {
          var t,
            n = e.drivers,
            o = e.component_data,
            r = e.getRef;
          return P(
            "div",
            { className: "style__frame-wrapper___QWr92" },
            P(
              b.a,
              Object(a.a)(
                {
                  getRef: r,
                  name: "cameraPlay",
                  lerpEase: 0.2,
                  currentProgress:
                    (null === (t = n.cameraPlay) || void 0 === t
                      ? void 0
                      : t.progress) || 0,
                },
                o.frameConfig,
                { containerStyle: { zIndex: 0 } },
              ),
            ),
          );
        },
        A = function (e) {
          var t,
            n = e.mobileMode,
            o = e.drivers,
            a = e.index,
            r = e.text,
            i = e.d;
          return P(p.a.div, {
            style: {
              display: n && "none",
              width:
                null === (t = o["frameLine-".concat(a)]) || void 0 === t
                  ? void 0
                  : t.moto,
              backgroundColor: i.lineColor,
              right: "right" === r.textAlign && 0,
              left: "right" !== r.textAlign && 0,
            },
            className: "style__line___1h1bo",
          });
        },
        R = function (e) {
          var t,
            n,
            o,
            a,
            r,
            i = e.d,
            _ = e.mobileMode,
            u = e.text,
            d = e.drivers,
            f = e.index,
            h = e.t,
            m = e.lineTitleRefArr,
            y = e.lineDescRefArr,
            b = e.windowWidth,
            v = e.windowHeight,
            g = Object(s.useRef)(),
            w = Object(s.useRef)();
          (m[f] = g), (y[f] = w);
          var x = (function (e) {
              return {
                outSiteBoxStyle: e ? "line-text-box-mobile" : "line-text-box",
                lineTitleStyle: e
                  ? "line-text-title-mobile"
                  : "line-text-title",
                lineDescStyle: e ? "line-text-desc-mobile" : "line-text-desc",
              };
            })(_),
            k = x.outSiteBoxStyle,
            O = x.lineTitleStyle,
            I = x.lineDescStyle;
          return P(
            c.a.Fragment,
            null,
            P(
              p.a.div,
              {
                style: L(
                  L(
                    {},
                    M(
                      u.topPos,
                      u.rightPos,
                      u.bottomPos,
                      u.leftPos,
                      _,
                      b,
                      v,
                      m,
                      y,
                      f,
                    ),
                  ),
                  {},
                  {
                    opacity:
                      null === (t = d["frameText-".concat(f)]) || void 0 === t
                        ? void 0
                        : t.moto,
                    y:
                      _ &&
                      (null === (n = d["frameTextTranslate-".concat(f)]) ||
                      void 0 === n
                        ? void 0
                        : n.moto),
                  },
                ),
                className: l()(k, B, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
              },
              P(
                "p",
                { style: { textAlign: u.textAlign || "left" } },
                P(p.a.div, {
                  ref: g,
                  style: L(
                    L(
                      {},
                      null === (o = i.textTitleFont) || void 0 === o
                        ? void 0
                        : o.style,
                    ),
                    {},
                    { width: "".concat(u.textWidth, "px") },
                  ),
                  dangerouslySetInnerHTML: { __html: h(u.textTitle) },
                  className: l()(O, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
                }),
                P(A, { mobileMode: _, drivers: d, index: f, text: u, d: i }),
                P(p.a.div, {
                  ref: w,
                  style: L(
                    L(
                      {},
                      null === (a = i.textDescFont) || void 0 === a
                        ? void 0
                        : a.style,
                    ),
                    {},
                    {
                      width: "".concat(u.textWidth, "px"),
                      y:
                        !_ &&
                        (null === (r = d["frameDesc-".concat(f)]) ||
                        void 0 === r
                          ? void 0
                          : r.moto),
                    },
                  ),
                  dangerouslySetInnerHTML: { __html: h(u.textDesc) },
                  className: l()(I, B, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
                }),
              ),
            ),
          );
        },
        // F = function (e) {
        //   var t = e.component_data,
        //     n = e.drivers,
        //     o = e.windowWidth,
        //     a = e.windowHeight,
        //     r = e.t,
        //     i = e.mobileMode,
        //     l = t.textList,
        //     s = new Array(l.length),
        //     c = new Array(l.length);
        //   return P(
        //     "div",
        //     { className: "style__frame-text-wrapper___33gS-" },
        //     null === l || void 0 === l
        //       ? void 0
        //       : l.map(function (e, l) {
        //           return P(R, {
        //             d: t,
        //             lineTitleRefArr: s,
        //             lineDescRefArr: c,
        //             mobileMode: i,
        //             text: e,
        //             drivers: n,
        //             index: l,
        //             t: r,
        //             windowHeight: a,
        //             windowWidth: o,
        //           });
        //         }),
        //   );
        // },
        V = function (e) {
          var t = e.sectionRef,
            n = e.titleTextRef,
            o = e.drivers,
            a = e.mobileMode,
            r = e.windowHeight,
            i = e.windowWidth,
            l = e.stickyContainerHeight,
            s = e.d,
            c = e.getRef,
            _ = e.t;
          return P(
            "section",
            {
              className: "style__banner___3GU3j",
              ref: t,
              style: { height: l },
            },
            P(
              "div",
              { className: "style__sticky___3ThWK" },
              P(
                "div",
                {
                  className: "style__sticky-wrapper___3yU69",
                  style: {
                    width: s.hasFramePosition
                      ? (null === s || void 0 === s ? void 0 : s.gridWidth) ||
                        m.e
                      : "",
                  },
                },
                P(z, { component_data: s, getRef: c, drivers: o }),
                // P(D, { component_data: s, t: _, drivers: o, mobileMode: a });
                // P(F, {
                //   component_data: s,
                //   t: _,
                //   drivers: o,
                //   mobileMode: a,
                //   windowHeight: r,
                //   windowWidth: i,
                // }),
              ),
            ),
            // P(N, {
            //   component_data: s,
            //   t: _,
            //   mobileMode: a,
            //   drivers: o,
            //   titleTextRef: n,
            //   windowWidth: i,
            //   windowHeight: r,
            // }),
          );
        },
        H = function (e, t, n, o, a, r, i, l, s, c, _) {
          var p = C({ component_data: e }, t, n, o),
            f = Object(d.a)({ animationConfig: p, rawDuration: a }),
            h = Object(u.a)({
              target: r,
              offset: ["start start", "end end"],
              downgrade: s,
              customCB: function (e, t) {
                console.log("xxxxxxx")
                var o = e.y;
                if (c || _ !== o.progress) {
                  // if (y.a.getInstance().getDimension().isFastScroll) return;
                  f(o.progress, t.drivers),
                    (function (e, t, n, o, a) {
                      var r,
                        i,
                        l,
                        s,
                        c,
                        _,
                        u =
                          null === (r = t.current) || void 0 === r
                            ? void 0
                            : r.getBoundingClientRect(),
                        d = null === u || void 0 === u ? void 0 : u.top,
                        p = (0.25 * o - Number(d)) / (0.25 * o),
                        f = p < 0 ? 0 : p > 1 ? 1 : p,
                        h = !0;
                      f >= 1
                        ? (h =
                            null === (l = e.titleTextOpacity) || void 0 === l
                              ? void 0
                              : l.progress)
                        : (h =
                            null === (s = e.titleTextOpacity) || void 0 === s
                              ? void 0
                              : s.moto.current);
                      (null === (i = n.current) ||
                        void 0 === i ||
                        i.style.setProperty("--title-text-opacity", f),
                      f > 0 && h && a)
                        ? null === (c = n.current) ||
                          void 0 === c ||
                          c.style.setProperty("display", "")
                        : null === (_ = n.current) ||
                          void 0 === _ ||
                          _.style.setProperty("display", "none");
                    })(h, r, i, n, c);
                  var a = t.drivers;
                  Object.keys(l.current).forEach(function (e) {
                    l.current[e].updatePercentbyProgress(a[e].progress || 0);
                  }),
                    (_ = o.progress);
                }
              },
              customDefaultValues: function () {
                return { drivers: f(0) };
              },
            }).drivers;
          return h;
        },
        W = function (e) {
          var t = e.mobileMode,
            n = e.V0Dom,
            a = e.t,
            r = (function (e, t) {
              return (
                e || (e = {}),
                [
                  { key: "titleFont", pcConfig: g, mobileConfig: w },
                  { key: "descFont", pcConfig: x, mobileConfig: k },
                  { key: "textTitleFont", pcConfig: O, mobileConfig: I },
                  { key: "frameConfig", pcConfig: S, mobileConfig: j },
                ].map(function (n) {
                  t
                    ? !e[n.key] && (e[n.key] = n.mobileConfig)
                    : !e[n.key] && (e[n.key] = n.pcConfig);
                }),
                e
              );
            })(e.component_data, e.mobileMode),
            i = L(L({}, T), r),
            l = i.forceDowngrade,
            c =
              (Number(i.frameDuration) || 5e3) + (Number(i.endDuration) || 200),
            _ = Object(s.useState)(c),
            u = _[0],
            d = _[1],
            p = Object(s.useState)(!1),
            m = p[0],
            b = p[1],
            v = Object(s.useRef)(),
            C = Object(s.useRef)({}),
            M = Object(s.useRef)(),
            E = Object(s.useRef)(-1),
            B = Object(h.c)({ mobileMode: t, forceDowngrade: l }),
            N = Object(o.a)(B, 1)[0],
            D = N,
            z = Object(f.a)({ mobileMode: t, sectionRef: v }),
            A = Object(o.a)(z, 2),
            R = A[0],
            F = A[1];
          Object(s.useEffect)(
            function () {
              var e = (F / 1080) * c;
              d(Math.floor(e));
            },
            [F],
          ),
            Object(s.useEffect)(function () {
              !(function (e, t) {
                y.a.getInstance().addNode(
                  e.current,
                  {
                    scrollIntoView: function () {
                      t(!0);
                    },
                    scrollOutOfWiew: function () {
                      t(!1);
                    },
                  },
                  void 0,
                  0,
                  !0,
                );
              })(v, b);
            }, []);
          var W = H(i, R, F, t, c, v, M, C, N, m, E);
          return D
            ? n || "V0\u7ec4\u4ef6\u672a\u914d\u7f6e"
            : P(V, {
                sectionRef: v,
                d: i,
                titleTextRef: M,
                drivers: W,
                mobileMode: t,
                windowHeight: F,
                windowWidth: R,
                stickyContainerHeight: u + F,
                getRef: function (e, t) {
                  C.current[t] = e;
                },
                t: a,
              });
        };
      (W.defaultProps = T),
        (W.propSettings = {
          key: "wm261TripleCamera",
          name: "wm261TripleCamera",
          contentSetting: {
            downgrade: {
              label: "\u662f\u5426\u964d\u7ea7",
              props: {
                forceDowngrade: {
                  label: "\u662f\u5426\u964d\u7ea7",
                  type: "boolean",
                },
              },
            },
            frame: {
              label: "\u5e8f\u5217\u5e27\u914d\u7f6e",
              props: {
                frameConfig: { type: "frame", label: "\u5e8f\u5217\u5e27" },
              },
            },
            textData: {
              label: "\u6587\u6848\u914d\u7f6e",
              props: {
                title: {
                  label: "\u4e3b\u6807\u9898\u6587\u6848\u5185\u5bb9",
                  type: "string",
                  content: "text",
                },
                desc: {
                  label:
                    "\u4e3b\u6807\u9898\u63cf\u8ff0\u6587\u6848\u5185\u5bb9",
                  type: "string",
                  content: "text",
                },
                textList: {
                  label: "\u5361\u7247\u6587\u6848\u5217\u8868",
                  type: "array",
                  props: {
                    textTitle: {
                      label: "\u6807\u9898\u6587\u6848\u5185\u5bb9",
                      type: "string",
                      content: "text",
                    },
                    textDesc: {
                      label: "\u63cf\u8ff0\u6587\u6848\u5185\u5bb9",
                      type: "string",
                      content: "text",
                    },
                    textWidth: {
                      label: "\u6587\u6848\u5bbd\u5ea6",
                      type: "number",
                    },
                    textAlign: {
                      label: "\u6587\u6848\u5bf9\u9f50\u65b9\u5f0f",
                      type: "select",
                      items: [
                        { label: "\u5de6\u5bf9\u9f50", value: "left" },
                        { label: "\u53f3\u5bf9\u9f50", value: "right" },
                      ],
                    },
                    textAppearShot: {
                      label: "\u6587\u6848\u5f00\u59cb\u51fa\u73b0\u5e27\u6570",
                      type: "number",
                    },
                    textFullAppearShot: {
                      label: "\u6587\u6848\u5b8c\u5168\u51fa\u73b0\u5e27\u6570",
                      type: "number",
                    },
                    textDisappearShot: {
                      label: "\u6587\u6848\u5f00\u59cb\u6d88\u5931\u5e27\u6570",
                      type: "number",
                    },
                    textFullDisappearShot: {
                      label: "\u6587\u6848\u5b8c\u5168\u6d88\u5931\u5e27\u6570",
                      type: "number",
                    },
                    lineLengthStart: {
                      label: "\u3010\u5f00\u59cb\u3011\u7ebf\u957f\u5ea6",
                      type: "number",
                      helptext: "\u4ec5\u4f5c\u7528\u4e8epc\u7aef",
                    },
                    lineLengthEnd: {
                      label: "\u3010\u7ed3\u675f\u3011\u7ebf\u957f\u5ea6",
                      type: "number",
                      helptext: "\u4ec5\u4f5c\u7528\u4e8epc\u7aef",
                    },
                    topPos: {
                      label:
                        "\u3010\u4e0a\u95f4\u8ddd\u3011\u6587\u6848\u4f4d\u7f6e",
                      type: "number",
                    },
                    rightPos: {
                      label:
                        "\u3010\u53f3\u95f4\u8ddd\u3011\u6587\u6848\u4f4d\u7f6e",
                      type: "number",
                    },
                    bottomPos: {
                      label:
                        "\u3010\u4e0b\u95f4\u8ddd\u3011\u6587\u6848\u4f4d\u7f6e",
                      type: "number",
                    },
                    leftPos: {
                      label:
                        "\u3010\u5de6\u95f4\u8ddd\u3011\u6587\u6848\u4f4d\u7f6e",
                      type: "number",
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            styleSetting: {
              label: "\u4e3b\u9898\u914d\u7f6e",
              props: {
                lineColor: {
                  label: "\u7ebf\u989c\u8272",
                  type: "string",
                  helptext: "\u4ec5\u4f5c\u7528\u4e8epc\u7aef",
                },
                titleFont: {
                  type: "font",
                  label: "\u4e3b\u6807\u9898\u5b57\u4f53\u914d\u7f6e",
                },
                descFont: {
                  type: "font",
                  label:
                    "\u4e3b\u6807\u9898\u63cf\u8ff0\u5b57\u4f53\u914d\u7f6e",
                },
                textTitleFont: {
                  type: "font",
                  label: "\u62c9\u7ebf-\u6807\u9898\u5b57\u4f53\u914d\u7f6e",
                },
                textDescFont: {
                  type: "font",
                  label: "\u62c9\u7ebf-\u63cf\u8ff0\u5b57\u4f53\u914d\u7f6e",
                },
              },
            },
            animationSetting: {
              label: "\u52a8\u6548\u914d\u7f6e",
              props: {
                frameDuration: {
                  label:
                    "\u5e8f\u5217\u5e27\u6ed1\u52a8\u8ddd\u79bb\uff08\u9ed8\u8ba4\uff1a5000\uff09",
                  type: "number",
                },
                titleScale: {
                  label:
                    "\u4e3b\u6807\u9898\u653e\u5927\u500d\u7387\uff08\u9ed8\u8ba4\uff1a3\uff09",
                  type: "number",
                },
                titleDisappearShot: {
                  label:
                    "\u4e3b\u6807\u9898\u5b8c\u5168\u6d88\u5931\u5e27\u6570",
                  type: "number",
                },
                descAppearShot: {
                  label: "\u63cf\u8ff0\u5f00\u59cb\u51fa\u73b0\u5e27\u6570",
                  type: "number",
                },
                descFullAppearShot: {
                  label: "\u63cf\u8ff0\u5b8c\u5168\u51fa\u73b0\u5e27\u6570",
                  type: "number",
                },
                descDisappearShot: {
                  label: "\u63cf\u8ff0\u5b8c\u5168\u6d88\u5931\u5e27\u6570",
                  type: "number",
                },
                descTranslate: {
                  label:
                    "\u955c\u5934-\u6587\u6848\u8fdb\u9000\u573a\u4f4d\u79fb\uff08\u9ed8\u8ba4\uff1a200\uff09",
                  helptext: "\u4ec5\u4f5c\u7528\u4e8em\u7aef",
                  type: "number",
                },
                endDuration: {
                  label:
                    "\u505c\u987f\u8ddd\u79bb\uff08\u9ed8\u8ba4\uff1a200\uff09",
                  type: "number",
                },
              },
            },
          },
        });
      t.a = Object(_.a)(W);
    },
    NV0k: function (e, t) {
      t.f = {}.propertyIsEnumerable;
    },
    Ndxo: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return c;
      });
      var o = n("q1tI"),
        a = n.n(o),
        r = n("tu8O"),
        i = n("/Pgi"),
        l = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];
      function s() {
        return (s =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      var c = Object(o.forwardRef)(function (e, t) {
        var n,
          c = void 0 === e ? {} : e,
          _ = c.tag,
          u = void 0 === _ ? "div" : _,
          d = c.children,
          p = c.className,
          f = void 0 === p ? "" : p,
          h = c.swiper,
          m = c.zoom,
          y = c.virtualIndex,
          b = (function (e, t) {
            if (null == e) return {};
            var n,
              o,
              a = {},
              r = Object.keys(e);
            for (o = 0; o < r.length; o++)
              (n = r[o]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(c, l),
          v = Object(o.useRef)(null),
          g = Object(o.useState)("swiper-slide"),
          w = g[0],
          x = g[1];
        function k(e, t, n) {
          t === v.current && x(n);
        }
        Object(i.a)(function () {
          if ((t && (t.current = v.current), v.current && h)) {
            if (!h.destroyed)
              return (
                h.on("_slideClass", k),
                function () {
                  h && h.off("_slideClass", k);
                }
              );
            "swiper-slide" !== w && x("swiper-slide");
          }
        }),
          Object(i.a)(
            function () {
              h && v.current && x(h.getSlideClasses(v.current));
            },
            [h],
          ),
          "function" === typeof d &&
            (n = {
              isActive:
                w.indexOf("swiper-slide-active") >= 0 ||
                w.indexOf("swiper-slide-duplicate-active") >= 0,
              isVisible: w.indexOf("swiper-slide-visible") >= 0,
              isDuplicate: w.indexOf("swiper-slide-duplicate") >= 0,
              isPrev:
                w.indexOf("swiper-slide-prev") >= 0 ||
                w.indexOf("swiper-slide-duplicate-prev") >= 0,
              isNext:
                w.indexOf("swiper-slide-next") >= 0 ||
                w.indexOf("swiper-slide-duplicate-next") >= 0,
            });
        var O = function () {
          return "function" === typeof d ? d(n) : d;
        };
        return a.a.createElement(
          u,
          s(
            {
              ref: v,
              className: Object(r.f)(w + (f ? " " + f : "")),
              "data-swiper-slide-index": y,
            },
            b,
          ),
          m
            ? a.a.createElement(
                "div",
                {
                  className: "swiper-zoom-container",
                  "data-swiper-zoom": "number" === typeof m ? m : void 0,
                },
                O(),
              )
            : O(),
        );
      });
      c.displayName = "SwiperSlide";
    },
    NegM: function (e, t, n) {
      var o = n("2faE"),
        a = n("rr1i");
      e.exports = n("jmDH")
        ? function (e, t, n) {
            return o.f(e, t, a(1, n));
          }
        : function (e, t, n) {
            return (e[t] = n), e;
          };
    },
    Npjl: function (e, t) {
      e.exports = function (e, t) {
        return null == e ? void 0 : e[t];
      };
    },
    "NsO/": function (e, t, n) {
      var o = n("M1xp"),
        a = n("Jes0");
      e.exports = function (e) {
        return o(a(e));
      };
    },
    Ntax: function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return i;
      }),
        n.d(t, "c", function () {
          return l;
        });
      var o = n("wCCn"),
        a = n.n(o),
        r = "https://www1.djicdn.com";
      function i(e) {
        return "".concat(r, "/dps/").concat(e);
      }
      function l(e) {
        return { backgroundImage: "url('".concat(i(e), "')") };
      }
      t.a = function () {
        return new a.a({
          cdn: "www1.djicdn.com",
          path: "dps",
          lazyLoad: !0,
          combo: [
            { name: "default_" },
            { name: "default_webp" },
            { name: "default_1x" },
            { name: "default_1x_webp" },
            { name: "origin" },
          ],
        });
      };
    },
    NwJ3: function (e, t, n) {
      var o = n("SBuE"),
        a = n("UWiX")("iterator"),
        r = Array.prototype;
      e.exports = function (e) {
        return void 0 !== e && (o.Array === e || r[a] === e);
      };
    },
    NykK: function (e, t, n) {
      var o = n("nmnc"),
        a = n("AP2z"),
        r = n("KfNM"),
        i = "[object Null]",
        l = "[object Undefined]",
        s = o ? o.toStringTag : void 0;
      e.exports = function (e) {
        return null == e
          ? void 0 === e
            ? l
            : i
          : s && s in Object(e)
            ? a(e)
            : r(e);
      };
    },
    O0hh: function (e, t, n) {
      e.exports = {
        "section-vertical-tab-component":
          "style__section-vertical-tab-component___3WQ4B",
        "text-box": "style__text-box___vbOl_",
        title: "style__title___2VH5C",
        "horizontal-line": "style__horizontal-line___3Ik3a",
        desc: "style__desc___2MDwx",
        "link-btn": "style__link-btn___2f9zc",
        "angle-right-icon": "style__angle-right-icon___1vJXg",
        "text-box-light": "style__text-box-light___eA8gy",
        "text-box-dark": "style__text-box-dark___1Erd4",
        container: "style__container____p2J2",
        "tab-container": "style__tab-container___dyPyP",
        "tab-box": "style__tab-box___369jU",
        "desc-box-theme-light": "style__desc-box-theme-light___2Kd9Y",
        "desc-box-theme-dark": "style__desc-box-theme-dark___2vWH5",
        "desc-box": "style__desc-box___1-Xk2",
        "tab-bar": "style__tab-bar___i4WUj",
        "tab-bar-theme-dark": "style__tab-bar-theme-dark___2PIu5",
        "tab-slider": "style__tab-slider___12p1o",
        "tab-item": "style__tab-item___3pixS",
        "item-title": "style__item-title___1Ig0D",
        "item-content": "style__item-content___2TwrZ",
        "tab-item-active": "style__tab-item-active___31OJL",
        "tab-bar-theme-light": "style__tab-bar-theme-light___3esM7",
        "item-title-hide": "style__item-title-hide___OeVxN",
        "hide-item-content": "style__hide-item-content___23iMw",
        "carousel-box": "style__carousel-box___3nh75",
        "replay-btn": "style__replay-btn___LtIZx",
        "replay-btn-icon": "style__replay-btn-icon___3eRBB",
        "dji-ag": "style__dji-ag___100zs",
        "tem-content": "style__tem-content___1bBHi",
      };
    },
    O0oS: function (e, t, n) {
      var o = n("Cwc5"),
        a = (function () {
          try {
            var e = o(Object, "defineProperty");
            return e({}, "", {}), e;
          } catch (t) {}
        })();
      e.exports = a;
    },
    OBhP: function (e, t, n) {
      var o = n("fmRc"),
        a = n("gFfm"),
        r = n("MrPd"),
        i = n("WwFo"),
        l = n("Dw+G"),
        s = n("5Tg0"),
        c = n("Q1l4"),
        _ = n("VOtZ"),
        u = n("EEGq"),
        d = n("qZTm"),
        p = n("G6z8"),
        f = n("QqLw"),
        h = n("yHx3"),
        m = n("wrZu"),
        y = n("+iFO"),
        b = n("Z0cm"),
        v = n("DSRE"),
        g = n("zEVN"),
        w = n("GoyQ"),
        x = n("1+5i"),
        k = n("7GkX"),
        O = n("mTTR"),
        I = 1,
        S = 2,
        j = 4,
        T = "[object Arguments]",
        C = "[object Function]",
        M = "[object GeneratorFunction]",
        P = "[object Object]",
        E = {};
      (E[T] =
        E["[object Array]"] =
        E["[object ArrayBuffer]"] =
        E["[object DataView]"] =
        E["[object Boolean]"] =
        E["[object Date]"] =
        E["[object Float32Array]"] =
        E["[object Float64Array]"] =
        E["[object Int8Array]"] =
        E["[object Int16Array]"] =
        E["[object Int32Array]"] =
        E["[object Map]"] =
        E["[object Number]"] =
        E[P] =
        E["[object RegExp]"] =
        E["[object Set]"] =
        E["[object String]"] =
        E["[object Symbol]"] =
        E["[object Uint8Array]"] =
        E["[object Uint8ClampedArray]"] =
        E["[object Uint16Array]"] =
        E["[object Uint32Array]"] =
          !0),
        (E["[object Error]"] = E[C] = E["[object WeakMap]"] = !1),
        (e.exports = function e(t, n, L, B, N, D) {
          var z,
            A = n & I,
            R = n & S,
            F = n & j;
          if ((L && (z = N ? L(t, B, N, D) : L(t)), void 0 !== z)) return z;
          if (!w(t)) return t;
          var V = b(t);
          if (V) {
            if (((z = h(t)), !A)) return c(t, z);
          } else {
            var H = f(t),
              W = H == C || H == M;
            if (v(t)) return s(t, A);
            if (H == P || H == T || (W && !N)) {
              if (((z = R || W ? {} : y(t)), !A))
                return R ? u(t, l(z, t)) : _(t, i(z, t));
            } else {
              if (!E[H]) return N ? t : {};
              z = m(t, H, A);
            }
          }
          D || (D = new o());
          var U = D.get(t);
          if (U) return U;
          D.set(t, z),
            x(t)
              ? t.forEach(function (o) {
                  z.add(e(o, n, L, o, t, D));
                })
              : g(t) &&
                t.forEach(function (o, a) {
                  z.set(a, e(o, n, L, a, t, D));
                });
          var G = V ? void 0 : (F ? (R ? p : d) : R ? O : k)(t);
          return (
            a(G || t, function (o, a) {
              G && (o = t[(a = o)]), r(z, a, e(o, n, L, a, t, D));
            }),
            z
          );
        });
    },
    OLES: function (e, t, n) {
      "use strict";
      n.r(t);
      var o = n("QbLZ"),
        a = n.n(o),
        r = n("jo6Y"),
        i = n.n(r),
        l = n("iCc5"),
        s = n.n(l),
        c = n("FYw3"),
        _ = n.n(c),
        u = n("mRg0"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("17x9"),
        m = n.n(h),
        y = n("i8i4"),
        b = n.n(y),
        v = n("VCL8");
      function g(e, t) {
        for (var n = t; n; ) {
          if (n === e) return !0;
          n = n.parentNode;
        }
        return !1;
      }
      var w = n("LIAx"),
        x = n.n(w);
      function k(e, t, n, o) {
        var a = b.a.unstable_batchedUpdates
          ? function (e) {
              b.a.unstable_batchedUpdates(n, e);
            }
          : n;
        return x()(e, t, a, o);
      }
      function O(e) {
        return (O =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              })(e);
      }
      function I(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          (o.enumerable = o.enumerable || !1),
            (o.configurable = !0),
            "value" in o && (o.writable = !0),
            Object.defineProperty(e, o.key, o);
        }
      }
      function S(e, t) {
        return (S =
          Object.setPrototypeOf ||
          function (e, t) {
            return (e.__proto__ = t), e;
          })(e, t);
      }
      function j(e) {
        var t = (function () {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })();
        return function () {
          var n,
            o = C(e);
          if (t) {
            var a = C(this).constructor;
            n = Reflect.construct(o, arguments, a);
          } else n = o.apply(this, arguments);
          return T(this, n);
        };
      }
      function T(e, t) {
        return !t || ("object" !== O(t) && "function" !== typeof t)
          ? (function (e) {
              if (void 0 === e)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return e;
            })(e)
          : t;
      }
      function C(e) {
        return (C = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
      }
      var M = (function (e) {
        !(function (e, t) {
          if ("function" !== typeof t && null !== t)
            throw new TypeError(
              "Super expression must either be null or a function",
            );
          (e.prototype = Object.create(t && t.prototype, {
            constructor: { value: e, writable: !0, configurable: !0 },
          })),
            t && S(e, t);
        })(r, e);
        var t,
          n,
          o,
          a = j(r);
        function r() {
          var e;
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, r);
          for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
            n[o] = arguments[o];
          return (
            ((e = a.call.apply(a, [this].concat(n))).removeContainer =
              function () {
                e.container &&
                  (b.a.unmountComponentAtNode(e.container),
                  e.container.parentNode.removeChild(e.container),
                  (e.container = null));
              }),
            (e.renderComponent = function (t, n) {
              var o = e.props,
                a = o.visible,
                r = o.getComponent,
                i = o.forceRender,
                l = o.getContainer,
                s = o.parent;
              (a || s._component || i) &&
                (e.container || (e.container = l()),
                b.a.unstable_renderSubtreeIntoContainer(
                  s,
                  r(t),
                  e.container,
                  function () {
                    n && n.call(this);
                  },
                ));
            }),
            e
          );
        }
        return (
          (t = r),
          (n = [
            {
              key: "componentDidMount",
              value: function () {
                this.props.autoMount && this.renderComponent();
              },
            },
            {
              key: "componentDidUpdate",
              value: function () {
                this.props.autoMount && this.renderComponent();
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                this.props.autoDestroy && this.removeContainer();
              },
            },
            {
              key: "render",
              value: function () {
                return this.props.children({
                  renderComponent: this.renderComponent,
                  removeContainer: this.removeContainer,
                });
              },
            },
          ]) && I(t.prototype, n),
          o && I(t, o),
          r
        );
      })(f.a.Component);
      function P(e) {
        return (P =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              })(e);
      }
      function E(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          (o.enumerable = o.enumerable || !1),
            (o.configurable = !0),
            "value" in o && (o.writable = !0),
            Object.defineProperty(e, o.key, o);
        }
      }
      function L(e, t) {
        return (L =
          Object.setPrototypeOf ||
          function (e, t) {
            return (e.__proto__ = t), e;
          })(e, t);
      }
      function B(e) {
        var t = (function () {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;
          try {
            return (
              Date.prototype.toString.call(
                Reflect.construct(Date, [], function () {}),
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })();
        return function () {
          var n,
            o = D(e);
          if (t) {
            var a = D(this).constructor;
            n = Reflect.construct(o, arguments, a);
          } else n = o.apply(this, arguments);
          return N(this, n);
        };
      }
      function N(e, t) {
        return !t || ("object" !== P(t) && "function" !== typeof t)
          ? (function (e) {
              if (void 0 === e)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return e;
            })(e)
          : t;
      }
      function D(e) {
        return (D = Object.setPrototypeOf
          ? Object.getPrototypeOf
          : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
      }
      (M.propTypes = {
        autoMount: m.a.bool,
        autoDestroy: m.a.bool,
        visible: m.a.bool,
        forceRender: m.a.bool,
        parent: m.a.any,
        getComponent: m.a.func.isRequired,
        getContainer: m.a.func.isRequired,
        children: m.a.func.isRequired,
      }),
        (M.defaultProps = { autoMount: !0, autoDestroy: !0, forceRender: !1 });
      var z = (function (e) {
        !(function (e, t) {
          if ("function" !== typeof t && null !== t)
            throw new TypeError(
              "Super expression must either be null or a function",
            );
          (e.prototype = Object.create(t && t.prototype, {
            constructor: { value: e, writable: !0, configurable: !0 },
          })),
            t && L(e, t);
        })(r, e);
        var t,
          n,
          o,
          a = B(r);
        function r() {
          return (
            (function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, r),
            a.apply(this, arguments)
          );
        }
        return (
          (t = r),
          (n = [
            {
              key: "componentDidMount",
              value: function () {
                this.createContainer();
              },
            },
            {
              key: "componentDidUpdate",
              value: function (e) {
                var t = this.props.didUpdate;
                t && t(e);
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                this.removeContainer();
              },
            },
            {
              key: "createContainer",
              value: function () {
                (this._container = this.props.getContainer()),
                  this.forceUpdate();
              },
            },
            {
              key: "removeContainer",
              value: function () {
                this._container &&
                  this._container.parentNode.removeChild(this._container);
              },
            },
            {
              key: "render",
              value: function () {
                return this._container
                  ? b.a.createPortal(this.props.children, this._container)
                  : null;
              },
            },
          ]) && E(t.prototype, n),
          o && E(t, o),
          r
        );
      })(f.a.Component);
      z.propTypes = {
        getContainer: m.a.func.isRequired,
        children: m.a.node.isRequired,
        didUpdate: m.a.func,
      };
      var A = n("TSYQ"),
        R = n.n(A);
      function F(e, t, n) {
        return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
      }
      function V(e, t) {
        this[e] = t;
      }
      var H,
        W = n("V7oC"),
        U = n.n(W);
      function G(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function Y(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? G(Object(n), !0).forEach(function (t) {
                X(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : G(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function q(e) {
        return (q =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              })(e);
      }
      function X(e, t, n) {
        return (
          t in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      var Z = { Webkit: "-webkit-", Moz: "-moz-", ms: "-ms-", O: "-o-" };
      function K() {
        if (void 0 !== H) return H;
        H = "";
        var e = document.createElement("p").style;
        for (var t in Z) t + "Transform" in e && (H = t);
        return H;
      }
      function Q() {
        return K()
          ? "".concat(K(), "TransitionProperty")
          : "transitionProperty";
      }
      function J() {
        return K() ? "".concat(K(), "Transform") : "transform";
      }
      function $(e, t) {
        var n = Q();
        n &&
          ((e.style[n] = t),
          "transitionProperty" !== n && (e.style.transitionProperty = t));
      }
      function ee(e, t) {
        var n = J();
        n && ((e.style[n] = t), "transform" !== n && (e.style.transform = t));
      }
      var te,
        ne = /matrix\((.*)\)/,
        oe = /matrix3d\((.*)\)/;
      function ae(e) {
        var t = e.style.display;
        (e.style.display = "none"), e.offsetHeight, (e.style.display = t);
      }
      function re(e, t, n) {
        var o = n;
        if ("object" !== q(t))
          return "undefined" !== typeof o
            ? ("number" === typeof o && (o = "".concat(o, "px")),
              void (e.style[t] = o))
            : te(e, t);
        for (var a in t) t.hasOwnProperty(a) && re(e, a, t[a]);
      }
      function ie(e, t) {
        var n = e["page".concat(t ? "Y" : "X", "Offset")],
          o = "scroll".concat(t ? "Top" : "Left");
        if ("number" !== typeof n) {
          var a = e.document;
          "number" !== typeof (n = a.documentElement[o]) && (n = a.body[o]);
        }
        return n;
      }
      function le(e) {
        return ie(e);
      }
      function se(e) {
        return ie(e, !0);
      }
      function ce(e) {
        var t = (function (e) {
            var t,
              n,
              o,
              a = e.ownerDocument,
              r = a.body,
              i = a && a.documentElement;
            return (
              (t = e.getBoundingClientRect()),
              (n = Math.floor(t.left)),
              (o = Math.floor(t.top)),
              {
                left: (n -= i.clientLeft || r.clientLeft || 0),
                top: (o -= i.clientTop || r.clientTop || 0),
              }
            );
          })(e),
          n = e.ownerDocument,
          o = n.defaultView || n.parentWindow;
        return (t.left += le(o)), (t.top += se(o)), t;
      }
      function _e(e) {
        return null !== e && void 0 !== e && e == e.window;
      }
      function ue(e) {
        return _e(e) ? e.document : 9 === e.nodeType ? e : e.ownerDocument;
      }
      var de = new RegExp(
          "^(".concat(
            /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source,
            ")(?!px)[a-z%]+$",
          ),
          "i",
        ),
        pe = /^(top|right|bottom|left)$/,
        fe = "currentStyle",
        he = "runtimeStyle",
        me = "left",
        ye = "px";
      function be(e, t) {
        return "left" === e
          ? t.useCssRight
            ? "right"
            : e
          : t.useCssBottom
            ? "bottom"
            : e;
      }
      function ve(e) {
        return "left" === e
          ? "right"
          : "right" === e
            ? "left"
            : "top" === e
              ? "bottom"
              : "bottom" === e
                ? "top"
                : void 0;
      }
      function ge(e, t, n) {
        "static" === re(e, "position") && (e.style.position = "relative");
        var o = -999,
          a = -999,
          r = be("left", n),
          i = be("top", n),
          l = ve(r),
          s = ve(i);
        "left" !== r && (o = 999), "top" !== i && (a = 999);
        var c,
          _ = "",
          u = ce(e);
        ("left" in t || "top" in t) &&
          ((_ = (c = e).style.transitionProperty || c.style[Q()] || ""),
          $(e, "none")),
          "left" in t && ((e.style[l] = ""), (e.style[r] = "".concat(o, "px"))),
          "top" in t && ((e.style[s] = ""), (e.style[i] = "".concat(a, "px"))),
          ae(e);
        var d = ce(e),
          p = {};
        for (var f in t)
          if (t.hasOwnProperty(f)) {
            var h = be(f, n),
              m = "left" === f ? o : a,
              y = u[f] - d[f];
            p[h] = h === f ? m + y : m - y;
          }
        re(e, p), ae(e), ("left" in t || "top" in t) && $(e, _);
        var b = {};
        for (var v in t)
          if (t.hasOwnProperty(v)) {
            var g = be(v, n),
              w = t[v] - u[v];
            b[g] = v === g ? p[g] + w : p[g] - w;
          }
        re(e, b);
      }
      function we(e, t) {
        var n = ce(e),
          o = (function (e) {
            var t = window.getComputedStyle(e, null),
              n = t.getPropertyValue("transform") || t.getPropertyValue(J());
            if (n && "none" !== n) {
              var o = n.replace(/[^0-9\-.,]/g, "").split(",");
              return {
                x: parseFloat(o[12] || o[4], 0),
                y: parseFloat(o[13] || o[5], 0),
              };
            }
            return { x: 0, y: 0 };
          })(e),
          a = { x: o.x, y: o.y };
        "left" in t && (a.x = o.x + t.left - n.left),
          "top" in t && (a.y = o.y + t.top - n.top),
          (function (e, t) {
            var n = window.getComputedStyle(e, null),
              o = n.getPropertyValue("transform") || n.getPropertyValue(J());
            if (o && "none" !== o) {
              var a,
                r = o.match(ne);
              if (r)
                ((a = (r = r[1]).split(",").map(function (e) {
                  return parseFloat(e, 10);
                }))[4] = t.x),
                  (a[5] = t.y),
                  ee(e, "matrix(".concat(a.join(","), ")"));
              else
                ((a = o
                  .match(oe)[1]
                  .split(",")
                  .map(function (e) {
                    return parseFloat(e, 10);
                  }))[12] = t.x),
                  (a[13] = t.y),
                  ee(e, "matrix3d(".concat(a.join(","), ")"));
            } else
              ee(
                e,
                "translateX("
                  .concat(t.x, "px) translateY(")
                  .concat(t.y, "px) translateZ(0)"),
              );
          })(e, a);
      }
      function xe(e, t) {
        for (var n = 0; n < e.length; n++) t(e[n]);
      }
      function ke(e) {
        return "border-box" === te(e, "boxSizing");
      }
      "undefined" !== typeof window &&
        (te = window.getComputedStyle
          ? function (e, t, n) {
              var o = n,
                a = "",
                r = ue(e);
              return (
                (o = o || r.defaultView.getComputedStyle(e, null)) &&
                  (a = o.getPropertyValue(t) || o[t]),
                a
              );
            }
          : function (e, t) {
              var n = e[fe] && e[fe][t];
              if (de.test(n) && !pe.test(t)) {
                var o = e.style,
                  a = o[me],
                  r = e[he][me];
                (e[he][me] = e[fe][me]),
                  (o[me] = "fontSize" === t ? "1em" : n || 0),
                  (n = o.pixelLeft + ye),
                  (o[me] = a),
                  (e[he][me] = r);
              }
              return "" === n ? "auto" : n;
            });
      var Oe = ["margin", "border", "padding"],
        Ie = -1,
        Se = 2,
        je = 1;
      function Te(e, t, n) {
        var o,
          a,
          r,
          i = 0;
        for (a = 0; a < t.length; a++)
          if ((o = t[a]))
            for (r = 0; r < n.length; r++) {
              var l = void 0;
              (l =
                "border" === o ? "".concat(o).concat(n[r], "Width") : o + n[r]),
                (i += parseFloat(te(e, l)) || 0);
            }
        return i;
      }
      var Ce = {
        getParent: function (e) {
          var t = e;
          do {
            t = 11 === t.nodeType && t.host ? t.host : t.parentNode;
          } while (t && 1 !== t.nodeType && 9 !== t.nodeType);
          return t;
        },
      };
      function Me(e, t, n) {
        var o = n;
        if (_e(e))
          return "width" === t ? Ce.viewportWidth(e) : Ce.viewportHeight(e);
        if (9 === e.nodeType)
          return "width" === t ? Ce.docWidth(e) : Ce.docHeight(e);
        var a = "width" === t ? ["Left", "Right"] : ["Top", "Bottom"],
          r =
            "width" === t
              ? Math.floor(e.getBoundingClientRect().width)
              : Math.floor(e.getBoundingClientRect().height),
          i = ke(e),
          l = 0;
        (null === r || void 0 === r || r <= 0) &&
          ((r = void 0),
          (null === (l = te(e, t)) || void 0 === l || Number(l) < 0) &&
            (l = e.style[t] || 0),
          (l = Math.floor(parseFloat(l)) || 0)),
          void 0 === o && (o = i ? je : Ie);
        var s = void 0 !== r || i,
          c = r || l;
        return o === Ie
          ? s
            ? c - Te(e, ["border", "padding"], a)
            : l
          : s
            ? o === je
              ? c
              : c + (o === Se ? -Te(e, ["border"], a) : Te(e, ["margin"], a))
            : l + Te(e, Oe.slice(o), a);
      }
      xe(["Width", "Height"], function (e) {
        (Ce["doc".concat(e)] = function (t) {
          var n = t.document;
          return Math.max(
            n.documentElement["scroll".concat(e)],
            n.body["scroll".concat(e)],
            Ce["viewport".concat(e)](n),
          );
        }),
          (Ce["viewport".concat(e)] = function (t) {
            var n = "client".concat(e),
              o = t.document,
              a = o.body,
              r = o.documentElement[n];
            return ("CSS1Compat" === o.compatMode && r) || (a && a[n]) || r;
          });
      });
      var Pe = { position: "absolute", visibility: "hidden", display: "block" };
      function Ee() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        var o,
          a = t[0];
        return (
          0 !== a.offsetWidth
            ? (o = Me.apply(void 0, t))
            : (function (e, t, n) {
                var o,
                  a = {},
                  r = e.style;
                for (o in t)
                  t.hasOwnProperty(o) && ((a[o] = r[o]), (r[o] = t[o]));
                for (o in (n.call(e), t)) t.hasOwnProperty(o) && (r[o] = a[o]);
              })(a, Pe, function () {
                o = Me.apply(void 0, t);
              }),
          o
        );
      }
      function Le(e, t) {
        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        return e;
      }
      xe(["width", "height"], function (e) {
        var t = e.charAt(0).toUpperCase() + e.slice(1);
        Ce["outer".concat(t)] = function (t, n) {
          return t && Ee(t, e, n ? 0 : je);
        };
        var n = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"];
        Ce[e] = function (t, o) {
          var a = o;
          return void 0 !== a
            ? t
              ? (ke(t) && (a += Te(t, ["padding", "border"], n)), re(t, e, a))
              : void 0
            : t && Ee(t, e, Ie);
        };
      });
      var Be = {
        getWindow: function (e) {
          if (e && e.document && e.setTimeout) return e;
          var t = e.ownerDocument || e;
          return t.defaultView || t.parentWindow;
        },
        getDocument: ue,
        offset: function (e, t, n) {
          if ("undefined" === typeof t) return ce(e);
          !(function (e, t, n) {
            if (n.ignoreShake) {
              var o = ce(e),
                a = o.left.toFixed(0),
                r = o.top.toFixed(0),
                i = t.left.toFixed(0),
                l = t.top.toFixed(0);
              if (a === i && r === l) return;
            }
            n.useCssRight || n.useCssBottom
              ? ge(e, t, n)
              : n.useCssTransform && J() in document.body.style
                ? we(e, t)
                : ge(e, t, n);
          })(e, t, n || {});
        },
        isWindow: _e,
        each: xe,
        css: re,
        clone: function (e) {
          var t,
            n = {};
          for (t in e) e.hasOwnProperty(t) && (n[t] = e[t]);
          if (e.overflow)
            for (t in e) e.hasOwnProperty(t) && (n.overflow[t] = e.overflow[t]);
          return n;
        },
        mix: Le,
        getWindowScrollLeft: function (e) {
          return le(e);
        },
        getWindowScrollTop: function (e) {
          return se(e);
        },
        merge: function () {
          for (var e = {}, t = 0; t < arguments.length; t++)
            Be.mix(e, t < 0 || arguments.length <= t ? void 0 : arguments[t]);
          return e;
        },
        viewportWidth: 0,
        viewportHeight: 0,
      };
      Le(Be, Ce);
      var Ne = Be.getParent;
      function De(e) {
        if (Be.isWindow(e) || 9 === e.nodeType) return null;
        var t,
          n = Be.getDocument(e).body,
          o = Be.css(e, "position");
        if (!("fixed" === o || "absolute" === o))
          return "html" === e.nodeName.toLowerCase() ? null : Ne(e);
        for (t = Ne(e); t && t !== n && 9 !== t.nodeType; t = Ne(t))
          if ("static" !== (o = Be.css(t, "position"))) return t;
        return null;
      }
      var ze = Be.getParent;
      function Ae(e, t) {
        for (
          var n = { left: 0, right: 1 / 0, top: 0, bottom: 1 / 0 },
            o = De(e),
            a = Be.getDocument(e),
            r = a.defaultView || a.parentWindow,
            i = a.body,
            l = a.documentElement;
          o;

        ) {
          if (
            (-1 !== navigator.userAgent.indexOf("MSIE") &&
              0 === o.clientWidth) ||
            o === i ||
            o === l ||
            "visible" === Be.css(o, "overflow")
          ) {
            if (o === i || o === l) break;
          } else {
            var s = Be.offset(o);
            (s.left += o.clientLeft),
              (s.top += o.clientTop),
              (n.top = Math.max(n.top, s.top)),
              (n.right = Math.min(n.right, s.left + o.clientWidth)),
              (n.bottom = Math.min(n.bottom, s.top + o.clientHeight)),
              (n.left = Math.max(n.left, s.left));
          }
          o = De(o);
        }
        var c = null;
        Be.isWindow(e) ||
          9 === e.nodeType ||
          ((c = e.style.position),
          "absolute" === Be.css(e, "position") && (e.style.position = "fixed"));
        var _ = Be.getWindowScrollLeft(r),
          u = Be.getWindowScrollTop(r),
          d = Be.viewportWidth(r),
          p = Be.viewportHeight(r),
          f = l.scrollWidth,
          h = l.scrollHeight,
          m = window.getComputedStyle(i);
        if (
          ("hidden" === m.overflowX && (f = r.innerWidth),
          "hidden" === m.overflowY && (h = r.innerHeight),
          e.style && (e.style.position = c),
          t ||
            (function (e) {
              if (Be.isWindow(e) || 9 === e.nodeType) return !1;
              var t = Be.getDocument(e),
                n = t.body,
                o = null;
              for (o = ze(e); o && o !== n && o !== t; o = ze(o)) {
                if ("fixed" === Be.css(o, "position")) return !0;
              }
              return !1;
            })(e))
        )
          (n.left = Math.max(n.left, _)),
            (n.top = Math.max(n.top, u)),
            (n.right = Math.min(n.right, _ + d)),
            (n.bottom = Math.min(n.bottom, u + p));
        else {
          var y = Math.max(f, _ + d);
          n.right = Math.min(n.right, y);
          var b = Math.max(h, u + p);
          n.bottom = Math.min(n.bottom, b);
        }
        return n.top >= 0 && n.left >= 0 && n.bottom > n.top && n.right > n.left
          ? n
          : null;
      }
      function Re(e) {
        var t, n, o;
        if (Be.isWindow(e) || 9 === e.nodeType) {
          var a = Be.getWindow(e);
          (t = {
            left: Be.getWindowScrollLeft(a),
            top: Be.getWindowScrollTop(a),
          }),
            (n = Be.viewportWidth(a)),
            (o = Be.viewportHeight(a));
        } else
          (t = Be.offset(e)), (n = Be.outerWidth(e)), (o = Be.outerHeight(e));
        return (t.width = n), (t.height = o), t;
      }
      function Fe(e, t) {
        var n = t.charAt(0),
          o = t.charAt(1),
          a = e.width,
          r = e.height,
          i = e.left,
          l = e.top;
        return (
          "c" === n ? (l += r / 2) : "b" === n && (l += r),
          "c" === o ? (i += a / 2) : "r" === o && (i += a),
          { left: i, top: l }
        );
      }
      function Ve(e, t, n, o, a) {
        var r = Fe(t, n[1]),
          i = Fe(e, n[0]),
          l = [i.left - r.left, i.top - r.top];
        return {
          left: Math.round(e.left - l[0] + o[0] - a[0]),
          top: Math.round(e.top - l[1] + o[1] - a[1]),
        };
      }
      function He(e, t, n) {
        return e.left < n.left || e.left + t.width > n.right;
      }
      function We(e, t, n) {
        return e.top < n.top || e.top + t.height > n.bottom;
      }
      function Ue(e, t, n) {
        var o = [];
        return (
          Be.each(e, function (e) {
            o.push(
              e.replace(t, function (e) {
                return n[e];
              }),
            );
          }),
          o
        );
      }
      function Ge(e, t) {
        return (e[t] = -e[t]), e;
      }
      function Ye(e, t) {
        return (
          (/%$/.test(e)
            ? (parseInt(e.substring(0, e.length - 1), 10) / 100) * t
            : parseInt(e, 10)) || 0
        );
      }
      function qe(e, t) {
        (e[0] = Ye(e[0], t.width)), (e[1] = Ye(e[1], t.height));
      }
      function Xe(e, t, n, o) {
        var a = n.points,
          r = n.offset || [0, 0],
          i = n.targetOffset || [0, 0],
          l = n.overflow,
          s = n.source || e;
        (r = [].concat(r)), (i = [].concat(i));
        var c = {},
          _ = 0,
          u = Ae(s, !(!(l = l || {}) || !l.alwaysByViewport)),
          d = Re(s);
        qe(r, d), qe(i, t);
        var p = Ve(d, t, a, r, i),
          f = Be.merge(d, p);
        if (u && (l.adjustX || l.adjustY) && o) {
          if (l.adjustX && He(p, d, u)) {
            var h = Ue(a, /[lr]/gi, { l: "r", r: "l" }),
              m = Ge(r, 0),
              y = Ge(i, 0);
            (function (e, t, n) {
              return e.left > n.right || e.left + t.width < n.left;
            })(Ve(d, t, h, m, y), d, u) || ((_ = 1), (a = h), (r = m), (i = y));
          }
          if (l.adjustY && We(p, d, u)) {
            var b = Ue(a, /[tb]/gi, { t: "b", b: "t" }),
              v = Ge(r, 1),
              g = Ge(i, 1);
            (function (e, t, n) {
              return e.top > n.bottom || e.top + t.height < n.top;
            })(Ve(d, t, b, v, g), d, u) || ((_ = 1), (a = b), (r = v), (i = g));
          }
          _ && ((p = Ve(d, t, a, r, i)), Be.mix(f, p));
          var w = He(p, d, u),
            x = We(p, d, u);
          if (w || x) {
            var k = a;
            w && (k = Ue(a, /[lr]/gi, { l: "r", r: "l" })),
              x && (k = Ue(a, /[tb]/gi, { t: "b", b: "t" })),
              (a = k),
              (r = n.offset || [0, 0]),
              (i = n.targetOffset || [0, 0]);
          }
          (c.adjustX = l.adjustX && w),
            (c.adjustY = l.adjustY && x),
            (c.adjustX || c.adjustY) &&
              (f = (function (e, t, n, o) {
                var a = Be.clone(e),
                  r = { width: t.width, height: t.height };
                return (
                  o.adjustX && a.left < n.left && (a.left = n.left),
                  o.resizeWidth &&
                    a.left >= n.left &&
                    a.left + r.width > n.right &&
                    (r.width -= a.left + r.width - n.right),
                  o.adjustX &&
                    a.left + r.width > n.right &&
                    (a.left = Math.max(n.right - r.width, n.left)),
                  o.adjustY && a.top < n.top && (a.top = n.top),
                  o.resizeHeight &&
                    a.top >= n.top &&
                    a.top + r.height > n.bottom &&
                    (r.height -= a.top + r.height - n.bottom),
                  o.adjustY &&
                    a.top + r.height > n.bottom &&
                    (a.top = Math.max(n.bottom - r.height, n.top)),
                  Be.mix(a, r)
                );
              })(p, d, u, c));
        }
        return (
          f.width !== d.width &&
            Be.css(s, "width", Be.width(s) + f.width - d.width),
          f.height !== d.height &&
            Be.css(s, "height", Be.height(s) + f.height - d.height),
          Be.offset(
            s,
            { left: f.left, top: f.top },
            {
              useCssRight: n.useCssRight,
              useCssBottom: n.useCssBottom,
              useCssTransform: n.useCssTransform,
              ignoreShake: n.ignoreShake,
            },
          ),
          { points: a, offset: r, targetOffset: i, overflow: c }
        );
      }
      function Ze(e, t, n) {
        var o = n.target || t;
        return Xe(
          e,
          Re(o),
          n,
          !(function (e, t) {
            var n = Ae(e, t),
              o = Re(e);
            return (
              !n ||
              o.left + o.width <= n.left ||
              o.top + o.height <= n.top ||
              o.left >= n.right ||
              o.top >= n.bottom
            );
          })(o, n.overflow && n.overflow.alwaysByViewport),
        );
      }
      (Ze.__getOffsetParent = De), (Ze.__getVisibleRectForElement = Ae);
      function Ke(e) {
        return e && "object" === typeof e && e.window === e;
      }
      function Qe(e, t) {
        var n = Math.floor(e),
          o = Math.floor(t);
        return Math.abs(n - o) <= 1;
      }
      function Je(e) {
        return "function" === typeof e && e ? e() : null;
      }
      function $e(e) {
        return "object" === typeof e && e ? e : null;
      }
      var et = (function (e) {
        function t() {
          var e, n, o, a;
          s()(this, t);
          for (var r = arguments.length, i = Array(r), l = 0; l < r; l++)
            i[l] = arguments[l];
          return (
            (n = o =
              _()(
                this,
                (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(
                  e,
                  [this].concat(i),
                ),
              )),
            (o.forceAlign = function () {
              var e = o.props,
                t = e.disabled,
                n = e.target,
                a = e.align,
                r = e.onAlign;
              if (!t && n) {
                var i = b.a.findDOMNode(o),
                  l = void 0,
                  s = Je(n),
                  c = $e(n),
                  _ = document.activeElement;
                s
                  ? (l = Ze(i, s, a))
                  : c &&
                    (l = (function (e, t, n) {
                      var o,
                        a,
                        r = Be.getDocument(e),
                        i = r.defaultView || r.parentWindow,
                        l = Be.getWindowScrollLeft(i),
                        s = Be.getWindowScrollTop(i),
                        c = Be.viewportWidth(i),
                        _ = Be.viewportHeight(i),
                        u = {
                          left: (o = "pageX" in t ? t.pageX : l + t.clientX),
                          top: (a = "pageY" in t ? t.pageY : s + t.clientY),
                          width: 0,
                          height: 0,
                        },
                        d = o >= 0 && o <= l + c && a >= 0 && a <= s + _,
                        p = [n.points[0], "cc"];
                      return Xe(e, u, Y(Y({}, n), {}, { points: p }), d);
                    })(i, c, a)),
                  (function (e, t) {
                    e !== document.activeElement && g(t, e) && e.focus();
                  })(_, i),
                  r && r(i, l);
              }
            }),
            (a = n),
            _()(o, a)
          );
        }
        return (
          d()(t, e),
          U()(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this.props;
                this.forceAlign(),
                  !e.disabled &&
                    e.monitorWindowResize &&
                    this.startMonitorWindowResize();
              },
            },
            {
              key: "componentDidUpdate",
              value: function (e) {
                var t,
                  n,
                  o = !1,
                  a = this.props;
                if (!a.disabled) {
                  var r = b.a.findDOMNode(this),
                    i = r ? r.getBoundingClientRect() : null;
                  if (e.disabled) o = !0;
                  else {
                    var l = Je(e.target),
                      s = Je(a.target),
                      c = $e(e.target),
                      _ = $e(a.target);
                    Ke(l) && Ke(s)
                      ? (o = !1)
                      : (l !== s ||
                          (l && !s && _) ||
                          (c && _ && s) ||
                          (_ &&
                            !(
                              (t = c) === (n = _) ||
                              (t &&
                                n &&
                                ("pageX" in n && "pageY" in n
                                  ? t.pageX === n.pageX && t.pageY === n.pageY
                                  : "clientX" in n &&
                                    "clientY" in n &&
                                    t.clientX === n.clientX &&
                                    t.clientY === n.clientY))
                            ))) &&
                        (o = !0);
                    var u = this.sourceRect || {};
                    o ||
                      !r ||
                      (Qe(u.width, i.width) && Qe(u.height, i.height)) ||
                      (o = !0);
                  }
                  this.sourceRect = i;
                }
                o && this.forceAlign(),
                  a.monitorWindowResize && !a.disabled
                    ? this.startMonitorWindowResize()
                    : this.stopMonitorWindowResize();
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                this.stopMonitorWindowResize();
              },
            },
            {
              key: "startMonitorWindowResize",
              value: function () {
                this.resizeHandler ||
                  ((this.bufferMonitor = (function (e, t) {
                    var n = void 0;
                    function o() {
                      n && (clearTimeout(n), (n = null));
                    }
                    function a() {
                      o(), (n = setTimeout(e, t));
                    }
                    return (a.clear = o), a;
                  })(this.forceAlign, this.props.monitorBufferTime)),
                  (this.resizeHandler = k(
                    window,
                    "resize",
                    this.bufferMonitor,
                  )));
              },
            },
            {
              key: "stopMonitorWindowResize",
              value: function () {
                this.resizeHandler &&
                  (this.bufferMonitor.clear(),
                  this.resizeHandler.remove(),
                  (this.resizeHandler = null));
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.childrenProps,
                  o = t.children,
                  a = f.a.Children.only(o);
                if (n) {
                  var r = {};
                  return (
                    Object.keys(n).forEach(function (t) {
                      r[t] = e.props[n[t]];
                    }),
                    f.a.cloneElement(a, r)
                  );
                }
                return a;
              },
            },
          ]),
          t
        );
      })(p.Component);
      (et.propTypes = {
        childrenProps: m.a.object,
        align: m.a.object.isRequired,
        target: m.a.oneOfType([
          m.a.func,
          m.a.shape({
            clientX: m.a.number,
            clientY: m.a.number,
            pageX: m.a.number,
            pageY: m.a.number,
          }),
        ]),
        onAlign: m.a.func,
        monitorBufferTime: m.a.number,
        monitorWindowResize: m.a.bool,
        disabled: m.a.bool,
        children: m.a.any,
      }),
        (et.defaultProps = {
          target: function () {
            return window;
          },
          monitorBufferTime: 50,
          monitorWindowResize: !1,
          disabled: !1,
        });
      var tt = et,
        nt = n("YEIV"),
        ot = n.n(nt),
        at = n("aGtg");
      function rt(e) {
        var t = [];
        return (
          f.a.Children.forEach(e, function (e) {
            t.push(e);
          }),
          t
        );
      }
      function it(e, t) {
        var n = null;
        return (
          e &&
            e.forEach(function (e) {
              n || (e && e.key === t && (n = e));
            }),
          n
        );
      }
      function lt(e, t, n) {
        var o = null;
        return (
          e &&
            e.forEach(function (e) {
              if (e && e.key === t && e.props[n]) {
                if (o)
                  throw new Error(
                    "two child with same key for <rc-animate> children",
                  );
                o = e;
              }
            }),
          o
        );
      }
      var st = n("EJiy"),
        ct = n.n(st),
        _t = {
          transitionstart: {
            transition: "transitionstart",
            WebkitTransition: "webkitTransitionStart",
            MozTransition: "mozTransitionStart",
            OTransition: "oTransitionStart",
            msTransition: "MSTransitionStart",
          },
          animationstart: {
            animation: "animationstart",
            WebkitAnimation: "webkitAnimationStart",
            MozAnimation: "mozAnimationStart",
            OAnimation: "oAnimationStart",
            msAnimation: "MSAnimationStart",
          },
        },
        ut = {
          transitionend: {
            transition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "mozTransitionEnd",
            OTransition: "oTransitionEnd",
            msTransition: "MSTransitionEnd",
          },
          animationend: {
            animation: "animationend",
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "mozAnimationEnd",
            OAnimation: "oAnimationEnd",
            msAnimation: "MSAnimationEnd",
          },
        },
        dt = [],
        pt = [];
      function ft(e, t, n) {
        e.addEventListener(t, n, !1);
      }
      function ht(e, t, n) {
        e.removeEventListener(t, n, !1);
      }
      "undefined" !== typeof window &&
        "undefined" !== typeof document &&
        (function () {
          var e = document.createElement("div").style;
          function t(t, n) {
            for (var o in t)
              if (t.hasOwnProperty(o)) {
                var a = t[o];
                for (var r in a)
                  if (r in e) {
                    n.push(a[r]);
                    break;
                  }
              }
          }
          "AnimationEvent" in window ||
            (delete _t.animationstart.animation,
            delete ut.animationend.animation),
            "TransitionEvent" in window ||
              (delete _t.transitionstart.transition,
              delete ut.transitionend.transition),
            t(_t, dt),
            t(ut, pt);
        })();
      var mt = {
          startEvents: dt,
          addStartEventListener: function (e, t) {
            0 !== dt.length
              ? dt.forEach(function (n) {
                  ft(e, n, t);
                })
              : window.setTimeout(t, 0);
          },
          removeStartEventListener: function (e, t) {
            0 !== dt.length &&
              dt.forEach(function (n) {
                ht(e, n, t);
              });
          },
          endEvents: pt,
          addEndEventListener: function (e, t) {
            0 !== pt.length
              ? pt.forEach(function (n) {
                  ft(e, n, t);
                })
              : window.setTimeout(t, 0);
          },
          removeEndEventListener: function (e, t) {
            0 !== pt.length &&
              pt.forEach(function (n) {
                ht(e, n, t);
              });
          },
        },
        yt = n("PFWz"),
        bt = n.n(yt),
        vt = 0 !== mt.endEvents.length,
        gt = ["Webkit", "Moz", "O", "ms"],
        wt = ["-webkit-", "-moz-", "-o-", "ms-", ""];
      function xt(e, t) {
        for (
          var n = window.getComputedStyle(e, null), o = "", a = 0;
          a < wt.length && !(o = n.getPropertyValue(wt[a] + t));
          a++
        );
        return o;
      }
      function kt(e) {
        if (vt) {
          var t = parseFloat(xt(e, "transition-delay")) || 0,
            n = parseFloat(xt(e, "transition-duration")) || 0,
            o = parseFloat(xt(e, "animation-delay")) || 0,
            a = parseFloat(xt(e, "animation-duration")) || 0,
            r = Math.max(n + t, a + o);
          e.rcEndAnimTimeout = setTimeout(
            function () {
              (e.rcEndAnimTimeout = null), e.rcEndListener && e.rcEndListener();
            },
            1e3 * r + 200,
          );
        }
      }
      function Ot(e) {
        e.rcEndAnimTimeout &&
          (clearTimeout(e.rcEndAnimTimeout), (e.rcEndAnimTimeout = null));
      }
      var It = function (e, t, n) {
        var o = "object" === ("undefined" === typeof t ? "undefined" : ct()(t)),
          a = o ? t.name : t,
          r = o ? t.active : t + "-active",
          i = n,
          l = void 0,
          s = void 0,
          c = bt()(e);
        return (
          n &&
            "[object Object]" === Object.prototype.toString.call(n) &&
            ((i = n.end), (l = n.start), (s = n.active)),
          e.rcEndListener && e.rcEndListener(),
          (e.rcEndListener = function (t) {
            (t && t.target !== e) ||
              (e.rcAnimTimeout &&
                (clearTimeout(e.rcAnimTimeout), (e.rcAnimTimeout = null)),
              Ot(e),
              c.remove(a),
              c.remove(r),
              mt.removeEndEventListener(e, e.rcEndListener),
              (e.rcEndListener = null),
              i && i());
          }),
          mt.addEndEventListener(e, e.rcEndListener),
          l && l(),
          c.add(a),
          (e.rcAnimTimeout = setTimeout(function () {
            (e.rcAnimTimeout = null), c.add(r), s && setTimeout(s, 0), kt(e);
          }, 30)),
          {
            stop: function () {
              e.rcEndListener && e.rcEndListener();
            },
          }
        );
      };
      (It.style = function (e, t, n) {
        e.rcEndListener && e.rcEndListener(),
          (e.rcEndListener = function (t) {
            (t && t.target !== e) ||
              (e.rcAnimTimeout &&
                (clearTimeout(e.rcAnimTimeout), (e.rcAnimTimeout = null)),
              Ot(e),
              mt.removeEndEventListener(e, e.rcEndListener),
              (e.rcEndListener = null),
              n && n());
          }),
          mt.addEndEventListener(e, e.rcEndListener),
          (e.rcAnimTimeout = setTimeout(function () {
            for (var n in t) t.hasOwnProperty(n) && (e.style[n] = t[n]);
            (e.rcAnimTimeout = null), kt(e);
          }, 0));
      }),
        (It.setTransition = function (e, t, n) {
          var o = t,
            a = n;
          void 0 === n && ((a = o), (o = "")),
            (o = o || ""),
            gt.forEach(function (t) {
              e.style[t + "Transition" + o] = a;
            });
        }),
        (It.isCssAnimationSupported = vt);
      var St = It,
        jt = {
          isAppearSupported: function (e) {
            return (
              (e.transitionName && e.transitionAppear) || e.animation.appear
            );
          },
          isEnterSupported: function (e) {
            return (e.transitionName && e.transitionEnter) || e.animation.enter;
          },
          isLeaveSupported: function (e) {
            return (e.transitionName && e.transitionLeave) || e.animation.leave;
          },
          allowAppearCallback: function (e) {
            return e.transitionAppear || e.animation.appear;
          },
          allowEnterCallback: function (e) {
            return e.transitionEnter || e.animation.enter;
          },
          allowLeaveCallback: function (e) {
            return e.transitionLeave || e.animation.leave;
          },
        },
        Tt = {
          enter: "transitionEnter",
          appear: "transitionAppear",
          leave: "transitionLeave",
        },
        Ct = (function (e) {
          function t() {
            return (
              s()(this, t),
              _()(
                this,
                (t.__proto__ || Object.getPrototypeOf(t)).apply(
                  this,
                  arguments,
                ),
              )
            );
          }
          return (
            d()(t, e),
            U()(t, [
              {
                key: "componentWillUnmount",
                value: function () {
                  this.stop();
                },
              },
              {
                key: "componentWillEnter",
                value: function (e) {
                  jt.isEnterSupported(this.props)
                    ? this.transition("enter", e)
                    : e();
                },
              },
              {
                key: "componentWillAppear",
                value: function (e) {
                  jt.isAppearSupported(this.props)
                    ? this.transition("appear", e)
                    : e();
                },
              },
              {
                key: "componentWillLeave",
                value: function (e) {
                  jt.isLeaveSupported(this.props)
                    ? this.transition("leave", e)
                    : e();
                },
              },
              {
                key: "transition",
                value: function (e, t) {
                  var n = this,
                    o = b.a.findDOMNode(this),
                    a = this.props,
                    r = a.transitionName,
                    i = "object" === typeof r;
                  this.stop();
                  var l = function () {
                    (n.stopper = null), t();
                  };
                  if ((vt || !a.animation[e]) && r && a[Tt[e]]) {
                    var s = i ? r[e] : r + "-" + e,
                      c = s + "-active";
                    i && r[e + "Active"] && (c = r[e + "Active"]),
                      (this.stopper = St(o, { name: s, active: c }, l));
                  } else this.stopper = a.animation[e](o, l);
                },
              },
              {
                key: "stop",
                value: function () {
                  var e = this.stopper;
                  e && ((this.stopper = null), e.stop());
                },
              },
              {
                key: "render",
                value: function () {
                  return this.props.children;
                },
              },
            ]),
            t
          );
        })(f.a.Component);
      Ct.propTypes = {
        children: m.a.any,
        animation: m.a.any,
        transitionName: m.a.any,
      };
      var Mt = Ct,
        Pt = "rc_animate_" + Date.now();
      function Et(e) {
        var t = e.children;
        return f.a.isValidElement(t) && !t.key
          ? f.a.cloneElement(t, { key: Pt })
          : t;
      }
      function Lt() {}
      var Bt = (function (e) {
        function t(e) {
          s()(this, t);
          var n = _()(
            this,
            (t.__proto__ || Object.getPrototypeOf(t)).call(this, e),
          );
          return (
            Nt.call(n),
            (n.currentlyAnimatingKeys = {}),
            (n.keysToEnter = []),
            (n.keysToLeave = []),
            (n.state = { children: rt(Et(e)) }),
            (n.childrenRefs = {}),
            n
          );
        }
        return (
          d()(t, e),
          U()(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this,
                  t = this.props.showProp,
                  n = this.state.children;
                t &&
                  (n = n.filter(function (e) {
                    return !!e.props[t];
                  })),
                  n.forEach(function (t) {
                    t && e.performAppear(t.key);
                  });
              },
            },
            {
              key: "componentWillReceiveProps",
              value: function (e) {
                var t = this;
                this.nextProps = e;
                var n = rt(Et(e)),
                  o = this.props;
                o.exclusive &&
                  Object.keys(this.currentlyAnimatingKeys).forEach(
                    function (e) {
                      t.stop(e);
                    },
                  );
                var a = o.showProp,
                  r = this.currentlyAnimatingKeys,
                  i = o.exclusive ? rt(Et(o)) : this.state.children,
                  l = [];
                a
                  ? (i.forEach(function (e) {
                      var t = e && it(n, e.key),
                        o = void 0;
                      (o =
                        (t && t.props[a]) || !e.props[a]
                          ? t
                          : f.a.cloneElement(t || e, ot()({}, a, !0))) &&
                        l.push(o);
                    }),
                    n.forEach(function (e) {
                      (e && it(i, e.key)) || l.push(e);
                    }))
                  : (l = (function (e, t) {
                      var n = [],
                        o = {},
                        a = [];
                      return (
                        e.forEach(function (e) {
                          e && it(t, e.key)
                            ? a.length && ((o[e.key] = a), (a = []))
                            : a.push(e);
                        }),
                        t.forEach(function (e) {
                          e &&
                            Object.prototype.hasOwnProperty.call(o, e.key) &&
                            (n = n.concat(o[e.key])),
                            n.push(e);
                        }),
                        (n = n.concat(a))
                      );
                    })(i, n)),
                  this.setState({ children: l }),
                  n.forEach(function (e) {
                    var n = e && e.key;
                    if (!e || !r[n]) {
                      var o = e && it(i, n);
                      if (a) {
                        var l = e.props[a];
                        if (o) !lt(i, n, a) && l && t.keysToEnter.push(n);
                        else l && t.keysToEnter.push(n);
                      } else o || t.keysToEnter.push(n);
                    }
                  }),
                  i.forEach(function (e) {
                    var o = e && e.key;
                    if (!e || !r[o]) {
                      var i = e && it(n, o);
                      if (a) {
                        var l = e.props[a];
                        if (i) !lt(n, o, a) && l && t.keysToLeave.push(o);
                        else l && t.keysToLeave.push(o);
                      } else i || t.keysToLeave.push(o);
                    }
                  });
              },
            },
            {
              key: "componentDidUpdate",
              value: function () {
                var e = this.keysToEnter;
                (this.keysToEnter = []), e.forEach(this.performEnter);
                var t = this.keysToLeave;
                (this.keysToLeave = []), t.forEach(this.performLeave);
              },
            },
            {
              key: "isValidChildByKey",
              value: function (e, t) {
                var n = this.props.showProp;
                return n ? lt(e, t, n) : it(e, t);
              },
            },
            {
              key: "stop",
              value: function (e) {
                delete this.currentlyAnimatingKeys[e];
                var t = this.childrenRefs[e];
                t && t.stop();
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props;
                this.nextProps = t;
                var n = this.state.children,
                  o = null;
                n &&
                  (o = n.map(function (n) {
                    if (null === n || void 0 === n) return n;
                    if (!n.key)
                      throw new Error("must set key for <rc-animate> children");
                    return f.a.createElement(
                      Mt,
                      {
                        key: n.key,
                        ref: function (t) {
                          e.childrenRefs[n.key] = t;
                        },
                        animation: t.animation,
                        transitionName: t.transitionName,
                        transitionEnter: t.transitionEnter,
                        transitionAppear: t.transitionAppear,
                        transitionLeave: t.transitionLeave,
                      },
                      n,
                    );
                  }));
                var r = t.component;
                if (r) {
                  var i = t;
                  return (
                    "string" === typeof r &&
                      (i = a()(
                        { className: t.className, style: t.style },
                        t.componentProps,
                      )),
                    f.a.createElement(r, i, o)
                  );
                }
                return o[0] || null;
              },
            },
          ]),
          t
        );
      })(f.a.Component);
      (Bt.isAnimate = !0),
        (Bt.propTypes = {
          className: m.a.string,
          style: m.a.object,
          component: m.a.any,
          componentProps: m.a.object,
          animation: m.a.object,
          transitionName: m.a.oneOfType([m.a.string, m.a.object]),
          transitionEnter: m.a.bool,
          transitionAppear: m.a.bool,
          exclusive: m.a.bool,
          transitionLeave: m.a.bool,
          onEnd: m.a.func,
          onEnter: m.a.func,
          onLeave: m.a.func,
          onAppear: m.a.func,
          showProp: m.a.string,
          children: m.a.node,
        }),
        (Bt.defaultProps = {
          animation: {},
          component: "span",
          componentProps: {},
          transitionEnter: !0,
          transitionLeave: !0,
          transitionAppear: !1,
          onEnd: Lt,
          onEnter: Lt,
          onLeave: Lt,
          onAppear: Lt,
        });
      var Nt = function () {
          var e = this;
          (this.performEnter = function (t) {
            e.childrenRefs[t] &&
              ((e.currentlyAnimatingKeys[t] = !0),
              e.childrenRefs[t].componentWillEnter(
                e.handleDoneAdding.bind(e, t, "enter"),
              ));
          }),
            (this.performAppear = function (t) {
              e.childrenRefs[t] &&
                ((e.currentlyAnimatingKeys[t] = !0),
                e.childrenRefs[t].componentWillAppear(
                  e.handleDoneAdding.bind(e, t, "appear"),
                ));
            }),
            (this.handleDoneAdding = function (t, n) {
              var o = e.props;
              if (
                (delete e.currentlyAnimatingKeys[t],
                !o.exclusive || o === e.nextProps)
              ) {
                var a = rt(Et(o));
                e.isValidChildByKey(a, t)
                  ? "appear" === n
                    ? jt.allowAppearCallback(o) &&
                      (o.onAppear(t), o.onEnd(t, !0))
                    : jt.allowEnterCallback(o) && (o.onEnter(t), o.onEnd(t, !0))
                  : e.performLeave(t);
              }
            }),
            (this.performLeave = function (t) {
              e.childrenRefs[t] &&
                ((e.currentlyAnimatingKeys[t] = !0),
                e.childrenRefs[t].componentWillLeave(
                  e.handleDoneLeaving.bind(e, t),
                ));
            }),
            (this.handleDoneLeaving = function (t) {
              var n = e.props;
              if (
                (delete e.currentlyAnimatingKeys[t],
                !n.exclusive || n === e.nextProps)
              ) {
                var o = rt(Et(n));
                if (e.isValidChildByKey(o, t)) e.performEnter(t);
                else {
                  var a = function () {
                    jt.allowLeaveCallback(n) && (n.onLeave(t), n.onEnd(t, !1));
                  };
                  !(function (e, t, n) {
                    var o = e.length === t.length;
                    return (
                      o &&
                        e.forEach(function (e, a) {
                          var r = t[a];
                          e &&
                            r &&
                            ((e && !r) || (!e && r)
                              ? (o = !1)
                              : e.key !== r.key
                                ? (o = !1)
                                : n && e.props[n] !== r.props[n] && (o = !1));
                        }),
                      o
                    );
                  })(e.state.children, o, n.showProp)
                    ? e.setState({ children: o }, a)
                    : a();
                }
              }
            });
        },
        Dt = Object(at.a)(Bt),
        zt = (function (e) {
          function t() {
            return s()(this, t), _()(this, e.apply(this, arguments));
          }
          return (
            d()(t, e),
            (t.prototype.shouldComponentUpdate = function (e) {
              return e.hiddenClassName || e.visible;
            }),
            (t.prototype.render = function () {
              var e = this.props,
                t = e.hiddenClassName,
                n = e.visible,
                o = i()(e, ["hiddenClassName", "visible"]);
              return t || f.a.Children.count(o.children) > 1
                ? (!n && t && (o.className += " " + t),
                  f.a.createElement("div", o))
                : f.a.Children.only(o.children);
            }),
            t
          );
        })(p.Component);
      zt.propTypes = {
        children: m.a.any,
        className: m.a.string,
        visible: m.a.bool,
        hiddenClassName: m.a.string,
      };
      var At = zt,
        Rt = (function (e) {
          function t() {
            return s()(this, t), _()(this, e.apply(this, arguments));
          }
          return (
            d()(t, e),
            (t.prototype.render = function () {
              var e = this.props,
                t = e.className;
              return (
                e.visible || (t += " " + e.hiddenClassName),
                f.a.createElement(
                  "div",
                  {
                    className: t,
                    onMouseEnter: e.onMouseEnter,
                    onMouseLeave: e.onMouseLeave,
                    onMouseDown: e.onMouseDown,
                    onTouchStart: e.onTouchStart,
                    style: e.style,
                  },
                  f.a.createElement(
                    At,
                    { className: e.prefixCls + "-content", visible: e.visible },
                    e.children,
                  ),
                )
              );
            }),
            t
          );
        })(p.Component);
      Rt.propTypes = {
        hiddenClassName: m.a.string,
        className: m.a.string,
        prefixCls: m.a.string,
        onMouseEnter: m.a.func,
        onMouseLeave: m.a.func,
        onMouseDown: m.a.func,
        onTouchStart: m.a.func,
        children: m.a.any,
      };
      var Ft = Rt,
        Vt = (function (e) {
          function t(n) {
            s()(this, t);
            var o = _()(this, e.call(this, n));
            return (
              Ht.call(o),
              (o.state = {
                stretchChecked: !1,
                targetWidth: void 0,
                targetHeight: void 0,
              }),
              (o.savePopupRef = V.bind(o, "popupInstance")),
              (o.saveAlignRef = V.bind(o, "alignInstance")),
              o
            );
          }
          return (
            d()(t, e),
            (t.prototype.componentDidMount = function () {
              (this.rootNode = this.getPopupDomNode()), this.setStretchSize();
            }),
            (t.prototype.componentDidUpdate = function () {
              this.setStretchSize();
            }),
            (t.prototype.getPopupDomNode = function () {
              return b.a.findDOMNode(this.popupInstance);
            }),
            (t.prototype.getMaskTransitionName = function () {
              var e = this.props,
                t = e.maskTransitionName,
                n = e.maskAnimation;
              return !t && n && (t = e.prefixCls + "-" + n), t;
            }),
            (t.prototype.getTransitionName = function () {
              var e = this.props,
                t = e.transitionName;
              return (
                !t && e.animation && (t = e.prefixCls + "-" + e.animation), t
              );
            }),
            (t.prototype.getClassName = function (e) {
              return (
                this.props.prefixCls + " " + this.props.className + " " + e
              );
            }),
            (t.prototype.getPopupElement = function () {
              var e = this,
                t = this.savePopupRef,
                n = this.state,
                o = n.stretchChecked,
                r = n.targetHeight,
                i = n.targetWidth,
                l = this.props,
                s = l.align,
                c = l.visible,
                _ = l.prefixCls,
                u = l.style,
                d = l.getClassNameFromAlign,
                p = l.destroyPopupOnHide,
                h = l.stretch,
                m = l.children,
                y = l.onMouseEnter,
                b = l.onMouseLeave,
                v = l.onMouseDown,
                g = l.onTouchStart,
                w = this.getClassName(this.currentAlignClassName || d(s)),
                x = _ + "-hidden";
              c || (this.currentAlignClassName = null);
              var k = {};
              h &&
                (-1 !== h.indexOf("height")
                  ? (k.height = r)
                  : -1 !== h.indexOf("minHeight") && (k.minHeight = r),
                -1 !== h.indexOf("width")
                  ? (k.width = i)
                  : -1 !== h.indexOf("minWidth") && (k.minWidth = i),
                o ||
                  ((k.visibility = "hidden"),
                  setTimeout(function () {
                    e.alignInstance && e.alignInstance.forceAlign();
                  }, 0)));
              var O = {
                className: w,
                prefixCls: _,
                ref: t,
                onMouseEnter: y,
                onMouseLeave: b,
                onMouseDown: v,
                onTouchStart: g,
                style: a()({}, k, u, this.getZIndexStyle()),
              };
              return p
                ? f.a.createElement(
                    Dt,
                    {
                      component: "",
                      exclusive: !0,
                      transitionAppear: !0,
                      transitionName: this.getTransitionName(),
                    },
                    c
                      ? f.a.createElement(
                          tt,
                          {
                            target: this.getAlignTarget(),
                            key: "popup",
                            ref: this.saveAlignRef,
                            monitorWindowResize: !0,
                            align: s,
                            onAlign: this.onAlign,
                          },
                          f.a.createElement(Ft, a()({ visible: !0 }, O), m),
                        )
                      : null,
                  )
                : f.a.createElement(
                    Dt,
                    {
                      component: "",
                      exclusive: !0,
                      transitionAppear: !0,
                      transitionName: this.getTransitionName(),
                      showProp: "xVisible",
                    },
                    f.a.createElement(
                      tt,
                      {
                        target: this.getAlignTarget(),
                        key: "popup",
                        ref: this.saveAlignRef,
                        monitorWindowResize: !0,
                        xVisible: c,
                        childrenProps: { visible: "xVisible" },
                        disabled: !c,
                        align: s,
                        onAlign: this.onAlign,
                      },
                      f.a.createElement(Ft, a()({ hiddenClassName: x }, O), m),
                    ),
                  );
            }),
            (t.prototype.getZIndexStyle = function () {
              var e = {},
                t = this.props;
              return void 0 !== t.zIndex && (e.zIndex = t.zIndex), e;
            }),
            (t.prototype.getMaskElement = function () {
              var e = this.props,
                t = void 0;
              if (e.mask) {
                var n = this.getMaskTransitionName();
                (t = f.a.createElement(At, {
                  style: this.getZIndexStyle(),
                  key: "mask",
                  className: e.prefixCls + "-mask",
                  hiddenClassName: e.prefixCls + "-mask-hidden",
                  visible: e.visible,
                })),
                  n &&
                    (t = f.a.createElement(
                      Dt,
                      {
                        key: "mask",
                        showProp: "visible",
                        transitionAppear: !0,
                        component: "",
                        transitionName: n,
                      },
                      t,
                    ));
              }
              return t;
            }),
            (t.prototype.render = function () {
              return f.a.createElement(
                "div",
                null,
                this.getMaskElement(),
                this.getPopupElement(),
              );
            }),
            t
          );
        })(p.Component);
      Vt.propTypes = {
        visible: m.a.bool,
        style: m.a.object,
        getClassNameFromAlign: m.a.func,
        onAlign: m.a.func,
        getRootDomNode: m.a.func,
        align: m.a.any,
        destroyPopupOnHide: m.a.bool,
        className: m.a.string,
        prefixCls: m.a.string,
        onMouseEnter: m.a.func,
        onMouseLeave: m.a.func,
        onMouseDown: m.a.func,
        onTouchStart: m.a.func,
        stretch: m.a.string,
        children: m.a.node,
        point: m.a.shape({ pageX: m.a.number, pageY: m.a.number }),
      };
      var Ht = function () {
          var e = this;
          (this.onAlign = function (t, n) {
            var o = e.props,
              a = o.getClassNameFromAlign(n);
            e.currentAlignClassName !== a &&
              ((e.currentAlignClassName = a),
              (t.className = e.getClassName(a))),
              o.onAlign(t, n);
          }),
            (this.setStretchSize = function () {
              var t = e.props,
                n = t.stretch,
                o = t.getRootDomNode,
                a = t.visible,
                r = e.state,
                i = r.stretchChecked,
                l = r.targetHeight,
                s = r.targetWidth;
              if (n && a) {
                var c = o();
                if (c) {
                  var _ = c.offsetHeight,
                    u = c.offsetWidth;
                  (l === _ && s === u && i) ||
                    e.setState({
                      stretchChecked: !0,
                      targetHeight: _,
                      targetWidth: u,
                    });
                }
              } else i && e.setState({ stretchChecked: !1 });
            }),
            (this.getTargetElement = function () {
              return e.props.getRootDomNode();
            }),
            (this.getAlignTarget = function () {
              var t = e.props.point;
              return t || e.getTargetElement;
            });
        },
        Wt = Vt;
      function Ut() {}
      var Gt = [
          "onClick",
          "onMouseDown",
          "onTouchStart",
          "onMouseEnter",
          "onMouseLeave",
          "onFocus",
          "onBlur",
          "onContextMenu",
        ],
        Yt = !!y.createPortal,
        qt = { rcTrigger: m.a.shape({ onPopupMouseDown: m.a.func }) },
        Xt = (function (e) {
          function t(n) {
            s()(this, t);
            var o = _()(this, e.call(this, n));
            Zt.call(o);
            var a = void 0;
            return (
              (a =
                "popupVisible" in n
                  ? !!n.popupVisible
                  : !!n.defaultPopupVisible),
              (o.state = { prevPopupVisible: a, popupVisible: a }),
              Gt.forEach(function (e) {
                o["fire" + e] = function (t) {
                  o.fireEvents(e, t);
                };
              }),
              o
            );
          }
          return (
            d()(t, e),
            (t.prototype.getChildContext = function () {
              return { rcTrigger: { onPopupMouseDown: this.onPopupMouseDown } };
            }),
            (t.prototype.componentDidMount = function () {
              this.componentDidUpdate(
                {},
                { popupVisible: this.state.popupVisible },
              );
            }),
            (t.prototype.componentDidUpdate = function (e, t) {
              var n = this.props,
                o = this.state;
              if (
                (Yt ||
                  this.renderComponent(null, function () {
                    t.popupVisible !== o.popupVisible &&
                      n.afterPopupVisibleChange(o.popupVisible);
                  }),
                o.popupVisible)
              ) {
                var a = void 0;
                return (
                  this.clickOutsideHandler ||
                    (!this.isClickToHide() && !this.isContextMenuToShow()) ||
                    ((a = n.getDocument()),
                    (this.clickOutsideHandler = k(
                      a,
                      "mousedown",
                      this.onDocumentClick,
                    ))),
                  this.touchOutsideHandler ||
                    ((a = a || n.getDocument()),
                    (this.touchOutsideHandler = k(
                      a,
                      "touchstart",
                      this.onDocumentClick,
                    ))),
                  !this.contextMenuOutsideHandler1 &&
                    this.isContextMenuToShow() &&
                    ((a = a || n.getDocument()),
                    (this.contextMenuOutsideHandler1 = k(
                      a,
                      "scroll",
                      this.onContextMenuClose,
                    ))),
                  void (
                    !this.contextMenuOutsideHandler2 &&
                    this.isContextMenuToShow() &&
                    (this.contextMenuOutsideHandler2 = k(
                      window,
                      "blur",
                      this.onContextMenuClose,
                    ))
                  )
                );
              }
              this.clearOutsideHandler();
            }),
            (t.prototype.componentWillUnmount = function () {
              this.clearDelayTimer(),
                this.clearOutsideHandler(),
                clearTimeout(this.mouseDownTimeout);
            }),
            (t.getDerivedStateFromProps = function (e, t) {
              var n = e.popupVisible,
                o = {};
              return (
                void 0 !== n &&
                  t.popupVisible !== n &&
                  ((o.popupVisible = n), (o.prevPopupVisible = t.popupVisible)),
                o
              );
            }),
            (t.prototype.getPopupDomNode = function () {
              return this._component && this._component.getPopupDomNode
                ? this._component.getPopupDomNode()
                : null;
            }),
            (t.prototype.getPopupAlign = function () {
              var e = this.props,
                t = e.popupPlacement,
                n = e.popupAlign,
                o = e.builtinPlacements;
              return t && o
                ? (function (e, t, n) {
                    var o = e[t] || {};
                    return a()({}, o, n);
                  })(o, t, n)
                : n;
            }),
            (t.prototype.setPopupVisible = function (e, t) {
              var n = this.props.alignPoint,
                o = this.state.popupVisible;
              this.clearDelayTimer(),
                o !== e &&
                  ("popupVisible" in this.props ||
                    this.setState({ popupVisible: e, prevPopupVisible: o }),
                  this.props.onPopupVisibleChange(e)),
                n && t && this.setPoint(t);
            }),
            (t.prototype.delaySetPopupVisible = function (e, t, n) {
              var o = this,
                a = 1e3 * t;
              if ((this.clearDelayTimer(), a)) {
                var r = n ? { pageX: n.pageX, pageY: n.pageY } : null;
                this.delayTimer = setTimeout(function () {
                  o.setPopupVisible(e, r), o.clearDelayTimer();
                }, a);
              } else this.setPopupVisible(e, n);
            }),
            (t.prototype.clearDelayTimer = function () {
              this.delayTimer &&
                (clearTimeout(this.delayTimer), (this.delayTimer = null));
            }),
            (t.prototype.clearOutsideHandler = function () {
              this.clickOutsideHandler &&
                (this.clickOutsideHandler.remove(),
                (this.clickOutsideHandler = null)),
                this.contextMenuOutsideHandler1 &&
                  (this.contextMenuOutsideHandler1.remove(),
                  (this.contextMenuOutsideHandler1 = null)),
                this.contextMenuOutsideHandler2 &&
                  (this.contextMenuOutsideHandler2.remove(),
                  (this.contextMenuOutsideHandler2 = null)),
                this.touchOutsideHandler &&
                  (this.touchOutsideHandler.remove(),
                  (this.touchOutsideHandler = null));
            }),
            (t.prototype.createTwoChains = function (e) {
              var t = this.props.children.props,
                n = this.props;
              return t[e] && n[e] ? this["fire" + e] : t[e] || n[e];
            }),
            (t.prototype.isClickToShow = function () {
              var e = this.props,
                t = e.action,
                n = e.showAction;
              return -1 !== t.indexOf("click") || -1 !== n.indexOf("click");
            }),
            (t.prototype.isContextMenuToShow = function () {
              var e = this.props,
                t = e.action,
                n = e.showAction;
              return (
                -1 !== t.indexOf("contextMenu") ||
                -1 !== n.indexOf("contextMenu")
              );
            }),
            (t.prototype.isClickToHide = function () {
              var e = this.props,
                t = e.action,
                n = e.hideAction;
              return -1 !== t.indexOf("click") || -1 !== n.indexOf("click");
            }),
            (t.prototype.isMouseEnterToShow = function () {
              var e = this.props,
                t = e.action,
                n = e.showAction;
              return (
                -1 !== t.indexOf("hover") || -1 !== n.indexOf("mouseEnter")
              );
            }),
            (t.prototype.isMouseLeaveToHide = function () {
              var e = this.props,
                t = e.action,
                n = e.hideAction;
              return (
                -1 !== t.indexOf("hover") || -1 !== n.indexOf("mouseLeave")
              );
            }),
            (t.prototype.isFocusToShow = function () {
              var e = this.props,
                t = e.action,
                n = e.showAction;
              return -1 !== t.indexOf("focus") || -1 !== n.indexOf("focus");
            }),
            (t.prototype.isBlurToHide = function () {
              var e = this.props,
                t = e.action,
                n = e.hideAction;
              return -1 !== t.indexOf("focus") || -1 !== n.indexOf("blur");
            }),
            (t.prototype.forcePopupAlign = function () {
              this.state.popupVisible &&
                this._component &&
                this._component.alignInstance &&
                this._component.alignInstance.forceAlign();
            }),
            (t.prototype.fireEvents = function (e, t) {
              var n = this.props.children.props[e];
              n && n(t);
              var o = this.props[e];
              o && o(t);
            }),
            (t.prototype.close = function () {
              this.setPopupVisible(!1);
            }),
            (t.prototype.render = function () {
              var e = this,
                t = this.state.popupVisible,
                n = this.props,
                o = n.children,
                a = n.forceRender,
                r = n.alignPoint,
                i = n.className,
                l = f.a.Children.only(o),
                s = { key: "trigger" };
              this.isContextMenuToShow()
                ? (s.onContextMenu = this.onContextMenu)
                : (s.onContextMenu = this.createTwoChains("onContextMenu")),
                this.isClickToHide() || this.isClickToShow()
                  ? ((s.onClick = this.onClick),
                    (s.onMouseDown = this.onMouseDown),
                    (s.onTouchStart = this.onTouchStart))
                  : ((s.onClick = this.createTwoChains("onClick")),
                    (s.onMouseDown = this.createTwoChains("onMouseDown")),
                    (s.onTouchStart = this.createTwoChains("onTouchStart"))),
                this.isMouseEnterToShow()
                  ? ((s.onMouseEnter = this.onMouseEnter),
                    r && (s.onMouseMove = this.onMouseMove))
                  : (s.onMouseEnter = this.createTwoChains("onMouseEnter")),
                this.isMouseLeaveToHide()
                  ? (s.onMouseLeave = this.onMouseLeave)
                  : (s.onMouseLeave = this.createTwoChains("onMouseLeave")),
                this.isFocusToShow() || this.isBlurToHide()
                  ? ((s.onFocus = this.onFocus), (s.onBlur = this.onBlur))
                  : ((s.onFocus = this.createTwoChains("onFocus")),
                    (s.onBlur = this.createTwoChains("onBlur")));
              var c = R()(l && l.props && l.props.className, i);
              c && (s.className = c);
              var _ = f.a.cloneElement(l, s);
              if (!Yt)
                return f.a.createElement(
                  M,
                  {
                    parent: this,
                    visible: t,
                    autoMount: !1,
                    forceRender: a,
                    getComponent: this.getComponent,
                    getContainer: this.getContainer,
                  },
                  function (t) {
                    var n = t.renderComponent;
                    return (e.renderComponent = n), _;
                  },
                );
              var u = void 0;
              return (
                (t || this._component || a) &&
                  (u = f.a.createElement(
                    z,
                    {
                      key: "portal",
                      getContainer: this.getContainer,
                      didUpdate: this.handlePortalUpdate,
                    },
                    this.getComponent(),
                  )),
                [_, u]
              );
            }),
            t
          );
        })(f.a.Component);
      (Xt.propTypes = {
        children: m.a.any,
        action: m.a.oneOfType([m.a.string, m.a.arrayOf(m.a.string)]),
        showAction: m.a.any,
        hideAction: m.a.any,
        getPopupClassNameFromAlign: m.a.any,
        onPopupVisibleChange: m.a.func,
        afterPopupVisibleChange: m.a.func,
        popup: m.a.oneOfType([m.a.node, m.a.func]).isRequired,
        popupStyle: m.a.object,
        prefixCls: m.a.string,
        popupClassName: m.a.string,
        className: m.a.string,
        popupPlacement: m.a.string,
        builtinPlacements: m.a.object,
        popupTransitionName: m.a.oneOfType([m.a.string, m.a.object]),
        popupAnimation: m.a.any,
        mouseEnterDelay: m.a.number,
        mouseLeaveDelay: m.a.number,
        zIndex: m.a.number,
        focusDelay: m.a.number,
        blurDelay: m.a.number,
        getPopupContainer: m.a.func,
        getDocument: m.a.func,
        forceRender: m.a.bool,
        destroyPopupOnHide: m.a.bool,
        mask: m.a.bool,
        maskClosable: m.a.bool,
        onPopupAlign: m.a.func,
        popupAlign: m.a.object,
        popupVisible: m.a.bool,
        defaultPopupVisible: m.a.bool,
        maskTransitionName: m.a.oneOfType([m.a.string, m.a.object]),
        maskAnimation: m.a.string,
        stretch: m.a.string,
        alignPoint: m.a.bool,
      }),
        (Xt.contextTypes = qt),
        (Xt.childContextTypes = qt),
        (Xt.defaultProps = {
          prefixCls: "rc-trigger-popup",
          getPopupClassNameFromAlign: function () {
            return "";
          },
          getDocument: function () {
            return window.document;
          },
          onPopupVisibleChange: Ut,
          afterPopupVisibleChange: Ut,
          onPopupAlign: Ut,
          popupClassName: "",
          mouseEnterDelay: 0,
          mouseLeaveDelay: 0.1,
          focusDelay: 0,
          blurDelay: 0.15,
          popupStyle: {},
          destroyPopupOnHide: !1,
          popupAlign: {},
          defaultPopupVisible: !1,
          mask: !1,
          maskClosable: !0,
          action: [],
          showAction: [],
          hideAction: [],
        });
      var Zt = function () {
        var e = this;
        (this.onMouseEnter = function (t) {
          var n = e.props.mouseEnterDelay;
          e.fireEvents("onMouseEnter", t),
            e.delaySetPopupVisible(!0, n, n ? null : t);
        }),
          (this.onMouseMove = function (t) {
            e.fireEvents("onMouseMove", t), e.setPoint(t);
          }),
          (this.onMouseLeave = function (t) {
            e.fireEvents("onMouseLeave", t),
              e.delaySetPopupVisible(!1, e.props.mouseLeaveDelay);
          }),
          (this.onPopupMouseEnter = function () {
            e.clearDelayTimer();
          }),
          (this.onPopupMouseLeave = function (t) {
            (t.relatedTarget &&
              !t.relatedTarget.setTimeout &&
              e._component &&
              e._component.getPopupDomNode &&
              g(e._component.getPopupDomNode(), t.relatedTarget)) ||
              e.delaySetPopupVisible(!1, e.props.mouseLeaveDelay);
          }),
          (this.onFocus = function (t) {
            e.fireEvents("onFocus", t),
              e.clearDelayTimer(),
              e.isFocusToShow() &&
                ((e.focusTime = Date.now()),
                e.delaySetPopupVisible(!0, e.props.focusDelay));
          }),
          (this.onMouseDown = function (t) {
            e.fireEvents("onMouseDown", t), (e.preClickTime = Date.now());
          }),
          (this.onTouchStart = function (t) {
            e.fireEvents("onTouchStart", t), (e.preTouchTime = Date.now());
          }),
          (this.onBlur = function (t) {
            e.fireEvents("onBlur", t),
              e.clearDelayTimer(),
              e.isBlurToHide() && e.delaySetPopupVisible(!1, e.props.blurDelay);
          }),
          (this.onContextMenu = function (t) {
            t.preventDefault(),
              e.fireEvents("onContextMenu", t),
              e.setPopupVisible(!0, t);
          }),
          (this.onContextMenuClose = function () {
            e.isContextMenuToShow() && e.close();
          }),
          (this.onClick = function (t) {
            if ((e.fireEvents("onClick", t), e.focusTime)) {
              var n = void 0;
              if (
                (e.preClickTime && e.preTouchTime
                  ? (n = Math.min(e.preClickTime, e.preTouchTime))
                  : e.preClickTime
                    ? (n = e.preClickTime)
                    : e.preTouchTime && (n = e.preTouchTime),
                Math.abs(n - e.focusTime) < 20)
              )
                return;
              e.focusTime = 0;
            }
            (e.preClickTime = 0),
              (e.preTouchTime = 0),
              e.isClickToShow() &&
                (e.isClickToHide() || e.isBlurToHide()) &&
                t &&
                t.preventDefault &&
                t.preventDefault();
            var o = !e.state.popupVisible;
            ((e.isClickToHide() && !o) || (o && e.isClickToShow())) &&
              e.setPopupVisible(!e.state.popupVisible, t);
          }),
          (this.onPopupMouseDown = function () {
            var t = e.context.rcTrigger,
              n = void 0 === t ? {} : t;
            (e.hasPopupMouseDown = !0),
              clearTimeout(e.mouseDownTimeout),
              (e.mouseDownTimeout = setTimeout(function () {
                e.hasPopupMouseDown = !1;
              }, 0)),
              n.onPopupMouseDown && n.onPopupMouseDown.apply(n, arguments);
          }),
          (this.onDocumentClick = function (t) {
            if (!e.props.mask || e.props.maskClosable) {
              var n = t.target;
              g(Object(y.findDOMNode)(e), n) ||
                e.hasPopupMouseDown ||
                e.close();
            }
          }),
          (this.getRootDomNode = function () {
            return Object(y.findDOMNode)(e);
          }),
          (this.getPopupClassNameFromAlign = function (t) {
            var n = [],
              o = e.props,
              a = o.popupPlacement,
              r = o.builtinPlacements,
              i = o.prefixCls,
              l = o.alignPoint,
              s = o.getPopupClassNameFromAlign;
            return (
              a &&
                r &&
                n.push(
                  (function (e, t, n, o) {
                    var a = n.points;
                    for (var r in e)
                      if (e.hasOwnProperty(r) && F(e[r].points, a, o))
                        return t + "-placement-" + r;
                    return "";
                  })(r, i, t, l),
                ),
              s && n.push(s(t)),
              n.join(" ")
            );
          }),
          (this.getComponent = function () {
            var t = e.props,
              n = t.prefixCls,
              o = t.destroyPopupOnHide,
              r = t.popupClassName,
              i = t.action,
              l = t.onPopupAlign,
              s = t.popupAnimation,
              c = t.popupTransitionName,
              _ = t.popupStyle,
              u = t.mask,
              d = t.maskAnimation,
              p = t.maskTransitionName,
              h = t.zIndex,
              m = t.popup,
              y = t.stretch,
              b = t.alignPoint,
              v = e.state,
              g = v.popupVisible,
              w = v.point,
              x = e.getPopupAlign(),
              k = {};
            return (
              e.isMouseEnterToShow() && (k.onMouseEnter = e.onPopupMouseEnter),
              e.isMouseLeaveToHide() && (k.onMouseLeave = e.onPopupMouseLeave),
              (k.onMouseDown = e.onPopupMouseDown),
              (k.onTouchStart = e.onPopupMouseDown),
              f.a.createElement(
                Wt,
                a()(
                  {
                    prefixCls: n,
                    destroyPopupOnHide: o,
                    visible: g,
                    point: b && w,
                    className: r,
                    action: i,
                    align: x,
                    onAlign: l,
                    animation: s,
                    getClassNameFromAlign: e.getPopupClassNameFromAlign,
                  },
                  k,
                  {
                    stretch: y,
                    getRootDomNode: e.getRootDomNode,
                    style: _,
                    mask: u,
                    zIndex: h,
                    transitionName: c,
                    maskAnimation: d,
                    maskTransitionName: p,
                    ref: e.savePopup,
                  },
                ),
                "function" === typeof m ? m() : m,
              )
            );
          }),
          (this.getContainer = function () {
            var t = e.props,
              n = document.createElement("div");
            return (
              (n.style.position = "absolute"),
              (n.style.top = "0"),
              (n.style.left = "0"),
              (n.style.width = "100%"),
              (t.getPopupContainer
                ? t.getPopupContainer(Object(y.findDOMNode)(e))
                : t.getDocument().body
              ).appendChild(n),
              n
            );
          }),
          (this.setPoint = function (t) {
            e.props.alignPoint &&
              t &&
              e.setState({ point: { pageX: t.pageX, pageY: t.pageY } });
          }),
          (this.handlePortalUpdate = function () {
            e.state.prevPopupVisible !== e.state.popupVisible &&
              e.props.afterPopupVisibleChange(e.state.popupVisible);
          }),
          (this.savePopup = function (t) {
            e._component = t;
          });
      };
      Object(v.polyfill)(Xt);
      var Kt = Xt,
        Qt = { adjustX: 1, adjustY: 1 },
        Jt = [0, 0],
        $t = {
          left: {
            points: ["cr", "cl"],
            overflow: Qt,
            offset: [-4, 0],
            targetOffset: Jt,
          },
          right: {
            points: ["cl", "cr"],
            overflow: Qt,
            offset: [4, 0],
            targetOffset: Jt,
          },
          top: {
            points: ["bc", "tc"],
            overflow: Qt,
            offset: [0, -4],
            targetOffset: Jt,
          },
          bottom: {
            points: ["tc", "bc"],
            overflow: Qt,
            offset: [0, 4],
            targetOffset: Jt,
          },
          topLeft: {
            points: ["bl", "tl"],
            overflow: Qt,
            offset: [0, -4],
            targetOffset: Jt,
          },
          leftTop: {
            points: ["tr", "tl"],
            overflow: Qt,
            offset: [-4, 0],
            targetOffset: Jt,
          },
          topRight: {
            points: ["br", "tr"],
            overflow: Qt,
            offset: [0, -4],
            targetOffset: Jt,
          },
          rightTop: {
            points: ["tl", "tr"],
            overflow: Qt,
            offset: [4, 0],
            targetOffset: Jt,
          },
          bottomRight: {
            points: ["tr", "br"],
            overflow: Qt,
            offset: [0, 4],
            targetOffset: Jt,
          },
          rightBottom: {
            points: ["bl", "br"],
            overflow: Qt,
            offset: [4, 0],
            targetOffset: Jt,
          },
          bottomLeft: {
            points: ["tl", "bl"],
            overflow: Qt,
            offset: [0, 4],
            targetOffset: Jt,
          },
          leftBottom: {
            points: ["br", "bl"],
            overflow: Qt,
            offset: [-4, 0],
            targetOffset: Jt,
          },
        },
        en = (function (e) {
          function t() {
            return s()(this, t), _()(this, e.apply(this, arguments));
          }
          return (
            d()(t, e),
            (t.prototype.componentDidUpdate = function () {
              var e = this.props.trigger;
              e && e.forcePopupAlign();
            }),
            (t.prototype.render = function () {
              var e = this.props,
                t = e.overlay,
                n = e.prefixCls,
                o = e.id;
              return f.a.createElement(
                "div",
                { className: n + "-inner", id: o, role: "tooltip" },
                "function" === typeof t ? t() : t,
              );
            }),
            t
          );
        })(f.a.Component);
      en.propTypes = {
        prefixCls: m.a.string,
        overlay: m.a.oneOfType([m.a.node, m.a.func]).isRequired,
        id: m.a.string,
        trigger: m.a.any,
      };
      var tn = en,
        nn = (function (e) {
          function t() {
            var n, o, a;
            s()(this, t);
            for (var r = arguments.length, i = Array(r), l = 0; l < r; l++)
              i[l] = arguments[l];
            return (
              (n = o = _()(this, e.call.apply(e, [this].concat(i)))),
              (o.getPopupElement = function () {
                var e = o.props,
                  t = e.arrowContent,
                  n = e.overlay,
                  a = e.prefixCls,
                  r = e.id;
                return [
                  f.a.createElement(
                    "div",
                    { className: a + "-arrow", key: "arrow" },
                    t,
                  ),
                  f.a.createElement(tn, {
                    key: "content",
                    trigger: o.trigger,
                    prefixCls: a,
                    id: r,
                    overlay: n,
                  }),
                ];
              }),
              (o.saveTrigger = function (e) {
                o.trigger = e;
              }),
              (a = n),
              _()(o, a)
            );
          }
          return (
            d()(t, e),
            (t.prototype.getPopupDomNode = function () {
              return this.trigger.getPopupDomNode();
            }),
            (t.prototype.render = function () {
              var e = this.props,
                t = e.overlayClassName,
                n = e.trigger,
                o = e.mouseEnterDelay,
                r = e.mouseLeaveDelay,
                l = e.overlayStyle,
                s = e.prefixCls,
                c = e.children,
                _ = e.onVisibleChange,
                u = e.afterVisibleChange,
                d = e.transitionName,
                p = e.animation,
                h = e.placement,
                m = e.align,
                y = e.destroyTooltipOnHide,
                b = e.defaultVisible,
                v = e.getTooltipContainer,
                g = i()(e, [
                  "overlayClassName",
                  "trigger",
                  "mouseEnterDelay",
                  "mouseLeaveDelay",
                  "overlayStyle",
                  "prefixCls",
                  "children",
                  "onVisibleChange",
                  "afterVisibleChange",
                  "transitionName",
                  "animation",
                  "placement",
                  "align",
                  "destroyTooltipOnHide",
                  "defaultVisible",
                  "getTooltipContainer",
                ]),
                w = a()({}, g);
              return (
                "visible" in this.props &&
                  (w.popupVisible = this.props.visible),
                f.a.createElement(
                  Kt,
                  a()(
                    {
                      popupClassName: t,
                      ref: this.saveTrigger,
                      prefixCls: s,
                      popup: this.getPopupElement,
                      action: n,
                      builtinPlacements: $t,
                      popupPlacement: h,
                      popupAlign: m,
                      getPopupContainer: v,
                      onPopupVisibleChange: _,
                      afterPopupVisibleChange: u,
                      popupTransitionName: d,
                      popupAnimation: p,
                      defaultPopupVisible: b,
                      destroyPopupOnHide: y,
                      mouseLeaveDelay: r,
                      popupStyle: l,
                      mouseEnterDelay: o,
                    },
                    w,
                  ),
                  c,
                )
              );
            }),
            t
          );
        })(p.Component);
      (nn.propTypes = {
        trigger: m.a.any,
        children: m.a.any,
        defaultVisible: m.a.bool,
        visible: m.a.bool,
        placement: m.a.string,
        transitionName: m.a.oneOfType([m.a.string, m.a.object]),
        animation: m.a.any,
        onVisibleChange: m.a.func,
        afterVisibleChange: m.a.func,
        overlay: m.a.oneOfType([m.a.node, m.a.func]).isRequired,
        overlayStyle: m.a.object,
        overlayClassName: m.a.string,
        prefixCls: m.a.string,
        mouseEnterDelay: m.a.number,
        mouseLeaveDelay: m.a.number,
        getTooltipContainer: m.a.func,
        destroyTooltipOnHide: m.a.bool,
        align: m.a.object,
        arrowContent: m.a.any,
        id: m.a.string,
      }),
        (nn.defaultProps = {
          prefixCls: "rc-tooltip",
          mouseEnterDelay: 0,
          destroyTooltipOnHide: !1,
          mouseLeaveDelay: 0.1,
          align: {},
          placement: "right",
          trigger: ["hover"],
          arrowContent: null,
        });
      var on = nn;
      t.default = on;
    },
    "Of+w": function (e, t, n) {
      var o = n("Cwc5")(n("Kz5y"), "WeakMap");
      e.exports = o;
    },
    Ojgd: function (e, t) {
      var n = Math.ceil,
        o = Math.floor;
      e.exports = function (e) {
        return isNaN((e = +e)) ? 0 : (e > 0 ? o : n)(e);
      };
    },
    Oujc: function (e, t, n) {
      (window.__NEXT_P = window.__NEXT_P || []).push([
        "/page/wm261",
        function () {
          return n("Pz5i");
        },
      ]);
    },
    OymH: function (e, t, n) {
      e.exports = {
        "atom-horiozntal-tab-component":
          "style__atom-horiozntal-tab-component___2bLOd",
        "background-video": "style__background-video___s6HOR",
        "atom-horizontal-tab-align-left":
          "style__atom-horizontal-tab-align-left___1FYqA",
        "atom-horizontal-tab-align-center":
          "style__atom-horizontal-tab-align-center___1Vp3B",
        "atom-horizontal-tab-align-right":
          "style__atom-horizontal-tab-align-right___3slvT",
        "tab-horizontal-wrapper": "style__tab-horizontal-wrapper___n9XZl",
        "card-wrap": "style__card-wrap___1RCGt",
        "vertical-left-align": "style__vertical-left-align___3HE8L",
        "vertical-center-align": "style__vertical-center-align___2_kLx",
        "vertical-right-align": "style__vertical-right-align___875-p",
        "tab-content": "style__tab-content___3rb2F",
        "tab-active-card": "style__tab-active-card___1ff3a",
        "tab-card-item": "style__tab-card-item___3wlch",
      };
    },
    P2sY: function (e, t, n) {
      e.exports = { default: n("UbbE"), __esModule: !0 };
    },
    P5sE: function (e, t) {
      var n = JSON.parse(
          '{"cn":"RMB","us":"USD","hk":"HKD","kr":"KRW","jp":"JPY","au":"AUD","nz":"AUD","uk":"GBP","gb":"GBP","tw":"TWD","id":"USD","mo":"USD","sg":"USD","at":"EUR","be":"EUR","bg":"EUR","hr":"EUR","cy":"EUR","cz":"EUR","dk":"EUR","ee":"EUR","fi":"EUR","fr":"EUR","de":"EUR","gr":"EUR","hu":"EUR","ie":"EUR","it":"EUR","lv":"EUR","li":"EUR","lt":"EUR","lu":"EUR","mt":"EUR","mc":"EUR","no":"EUR","nl":"EUR","pl":"EUR","pt":"EUR","ro":"EUR","sk":"EUR","si":"EUR","es":"EUR","se":"EUR","ch":"EUR","ae":"USD","ca":"USD","pr":"USD"}',
        ),
        o = {
          setOptions: function (e) {
            if (
              ((this.currency = e.currency),
              (this.country = e.country),
              (this.hidePrefix = e.hideCountrySign),
              !this.currency &&
                this.country &&
                ((this.currency = n[this.country]), !this.currency))
            )
              throw new Error("currency not supported");
            this.exactOptions();
          },
          exactOptions: function () {
            var e = "",
              t = "",
              n = ",",
              o = ".",
              a = 2;
            switch (this.currency) {
              case "CNY":
              case "RMB":
                (e = "\xa5"), (n = "");
                break;
              case "JPY":
                (t = "\u5186"), (o = ""), (a = 0);
                break;
              case "KRW":
                (e = "\u20a9"), (o = ""), (a = 0);
                break;
              case "GBP":
                e = "\xa3";
                break;
              case "TWD":
                e = this.hidePrefix ? "$" : "NT $";
                break;
              case "AUD":
                e = this.hidePrefix ? "$" : "AUD $";
                break;
              case "HKD":
                e = this.hidePrefix ? "$" : "HKD $";
                break;
              case "USD":
                e = this.hidePrefix ? "$" : "USD $";
                break;
              case "EUR":
                (t = " \u20ac"),
                  -1 !== ["ie", "lv", "mt"].indexOf(this.country) &&
                    ((t = ""), (e = "\u20ac")),
                  (n =
                    -1 !== ["at", "de", "it", "no", "es"].indexOf(this.country)
                      ? "."
                      : " "),
                  -1 === ["ie", "ch"].indexOf(this.country) && (o = ",");
            }
            (this.prefix = e),
              (this.suffix = t),
              (this.seps = n),
              (this.decimalPoint = o),
              (this.decimalPlaces = a);
          },
          format: function (e, t) {
            if (isNaN(e)) return e;
            t && this.setOptions(t);
            var n = this.prefix,
              o = this.suffix,
              a = this.seps,
              r = this.decimalPoint,
              i = this.decimalPlaces,
              l = "".concat(Math.round(e)),
              s = "",
              c = "",
              _ = "".concat(Math.round(e));
            i &&
              (1 == (s = _.substr(-i, i)).length && (s = "0".concat(s)),
              (l = _.substring(0, _.length - i)),
              (c = s - 0 === 0 ? "" : "".concat(r).concat(s)));
            var u = l
              ? l.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1".concat(a))
              : 0;
            return "".concat(n).concat(u).concat(c).concat(o);
          },
        };
      e.exports = o;
    },
    PAGr: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.default = void 0);
      i(n("17x9"));
      var o = i(n("q1tI")),
        a = n("i8i4"),
        r = i(n("UnXY"));
      function i(e) {
        return e && e.__esModule ? e : { default: e };
      }
      var l = (function (e) {
        var t, n;
        function i() {
          for (var t, n = arguments.length, o = new Array(n), a = 0; a < n; a++)
            o[a] = arguments[a];
          return (
            ((t = e.call.apply(e, [this].concat(o)) || this).handleEnter =
              function () {
                for (
                  var e = arguments.length, n = new Array(e), o = 0;
                  o < e;
                  o++
                )
                  n[o] = arguments[o];
                return t.handleLifecycle("onEnter", 0, n);
              }),
            (t.handleEntering = function () {
              for (
                var e = arguments.length, n = new Array(e), o = 0;
                o < e;
                o++
              )
                n[o] = arguments[o];
              return t.handleLifecycle("onEntering", 0, n);
            }),
            (t.handleEntered = function () {
              for (
                var e = arguments.length, n = new Array(e), o = 0;
                o < e;
                o++
              )
                n[o] = arguments[o];
              return t.handleLifecycle("onEntered", 0, n);
            }),
            (t.handleExit = function () {
              for (
                var e = arguments.length, n = new Array(e), o = 0;
                o < e;
                o++
              )
                n[o] = arguments[o];
              return t.handleLifecycle("onExit", 1, n);
            }),
            (t.handleExiting = function () {
              for (
                var e = arguments.length, n = new Array(e), o = 0;
                o < e;
                o++
              )
                n[o] = arguments[o];
              return t.handleLifecycle("onExiting", 1, n);
            }),
            (t.handleExited = function () {
              for (
                var e = arguments.length, n = new Array(e), o = 0;
                o < e;
                o++
              )
                n[o] = arguments[o];
              return t.handleLifecycle("onExited", 1, n);
            }),
            t
          );
        }
        (n = e),
          ((t = i).prototype = Object.create(n.prototype)),
          (t.prototype.constructor = t),
          (t.__proto__ = n);
        var l = i.prototype;
        return (
          (l.handleLifecycle = function (e, t, n) {
            var r,
              i = this.props.children,
              l = o.default.Children.toArray(i)[t];
            l.props[e] && (r = l.props)[e].apply(r, n),
              this.props[e] && this.props[e]((0, a.findDOMNode)(this));
          }),
          (l.render = function () {
            var e = this.props,
              t = e.children,
              n = e.in,
              a = (function (e, t) {
                if (null == e) return {};
                var n,
                  o,
                  a = {},
                  r = Object.keys(e);
                for (o = 0; o < r.length; o++)
                  (n = r[o]), t.indexOf(n) >= 0 || (a[n] = e[n]);
                return a;
              })(e, ["children", "in"]),
              i = o.default.Children.toArray(t),
              l = i[0],
              s = i[1];
            return (
              delete a.onEnter,
              delete a.onEntering,
              delete a.onEntered,
              delete a.onExit,
              delete a.onExiting,
              delete a.onExited,
              o.default.createElement(
                r.default,
                a,
                n
                  ? o.default.cloneElement(l, {
                      key: "first",
                      onEnter: this.handleEnter,
                      onEntering: this.handleEntering,
                      onEntered: this.handleEntered,
                    })
                  : o.default.cloneElement(s, {
                      key: "second",
                      onEnter: this.handleExit,
                      onEntering: this.handleExiting,
                      onEntered: this.handleExited,
                    }),
              )
            );
          }),
          i
        );
      })(o.default.Component);
      l.propTypes = {};
      var s = l;
      (t.default = s), (e.exports = t.default);
    },
    PFWz: function (e, t, n) {
      try {
        var o = n("zs13");
      } catch (l) {
        o = n("zs13");
      }
      var a = /\s+/,
        r = Object.prototype.toString;
      function i(e) {
        if (!e || !e.nodeType)
          throw new Error("A DOM element reference is required");
        (this.el = e), (this.list = e.classList);
      }
      (e.exports = function (e) {
        return new i(e);
      }),
        (i.prototype.add = function (e) {
          if (this.list) return this.list.add(e), this;
          var t = this.array();
          return ~o(t, e) || t.push(e), (this.el.className = t.join(" ")), this;
        }),
        (i.prototype.remove = function (e) {
          if ("[object RegExp]" == r.call(e)) return this.removeMatching(e);
          if (this.list) return this.list.remove(e), this;
          var t = this.array(),
            n = o(t, e);
          return ~n && t.splice(n, 1), (this.el.className = t.join(" ")), this;
        }),
        (i.prototype.removeMatching = function (e) {
          for (var t = this.array(), n = 0; n < t.length; n++)
            e.test(t[n]) && this.remove(t[n]);
          return this;
        }),
        (i.prototype.toggle = function (e, t) {
          return this.list
            ? ("undefined" !== typeof t
                ? t !== this.list.toggle(e, t) && this.list.toggle(e)
                : this.list.toggle(e),
              this)
            : ("undefined" !== typeof t
                ? t
                  ? this.add(e)
                  : this.remove(e)
                : this.has(e)
                  ? this.remove(e)
                  : this.add(e),
              this);
        }),
        (i.prototype.array = function () {
          var e = (this.el.getAttribute("class") || "")
            .replace(/^\s+|\s+$/g, "")
            .split(a);
          return "" === e[0] && e.shift(), e;
        }),
        (i.prototype.has = i.prototype.contains =
          function (e) {
            return this.list ? this.list.contains(e) : !!~o(this.array(), e);
          });
    },
    PlRC: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      t.default = {
        animating: !1,
        autoplaying: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        dragging: !1,
        edgeDragged: !1,
        initialized: !1,
        lazyLoadedList: [],
        listHeight: null,
        listWidth: null,
        scrolling: !1,
        slideCount: null,
        slideHeight: null,
        slideWidth: null,
        swipeLeft: null,
        swiped: !1,
        swiping: !1,
        touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
        trackStyle: {},
        trackWidth: 0,
      };
    },
    Pz5i: function (e, t, n) {
      "use strict";
      n.r(t);
      var o = n("rePB"),
        a = n("Ud1t"),
        r = n("zwpK"),
        l = n("G/Zc"),
        s = n("KxSJ"),
        c = n("3utc"),
        _ = n("NMkd"),
        u = n("8mTr");
      n("0eaO");
      function d(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function p(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? d(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : d(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var f = p(
        p({}, s.a),
        {},
        {
          wm261ScrollText: c.a,
          wm261TripleCamera: _.a,
          wm330ImageCarousel: u.a,
        },
      );
      t.default = Object(a.a)(f, r.a,l.a);
    },
    Q1l4: function (e, t) {
      e.exports = function (e, t) {
        var n = -1,
          o = e.length;
        for (t || (t = Array(o)); ++n < o; ) t[n] = e[n];
        return t;
      };
    },
    QDlc: function (e, t, n) {
      "use strict";
      function o() {
        return !1;
      }
      function a() {
        return !0;
      }
      function r() {
        (this.timeStamp = Date.now()),
          (this.target = void 0),
          (this.currentTarget = void 0);
      }
      Object.defineProperty(t, "__esModule", { value: !0 }),
        (r.prototype = {
          isEventObject: 1,
          constructor: r,
          isDefaultPrevented: o,
          isPropagationStopped: o,
          isImmediatePropagationStopped: o,
          preventDefault: function () {
            this.isDefaultPrevented = a;
          },
          stopPropagation: function () {
            this.isPropagationStopped = a;
          },
          stopImmediatePropagation: function () {
            (this.isImmediatePropagationStopped = a), this.stopPropagation();
          },
          halt: function (e) {
            e ? this.stopImmediatePropagation() : this.stopPropagation(),
              this.preventDefault();
          },
        }),
        (t.default = r),
        (e.exports = t.default);
    },
    QH4r: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return f;
      }),
        n.d(t, "b", function () {
          return h;
        }),
        n.d(t, "c", function () {
          return m;
        });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("iKuz"),
        c = n.n(s),
        _ = n("q1tI"),
        u = (n("cc/H"), _.createElement),
        d = {
          "./style.css": {
            "button-anchor": "style__button-anchor___24tVB",
            "button-anchor-disabled": "style__button-anchor-disabled___2OZkt",
            "dji-btn-col": "style__dji-btn-col___dgT5s",
            "dji-btn": "style__dji-btn___ILmHs",
            "dji-btn-btn": "style__dji-btn-btn___1ZdY_",
            fab: "style__fab___3S5X1",
            loading: "style__loading___yeduE",
            block: "style__block___KTkFd",
            icon: "style__icon___3D424",
            "dji-btn-xl": "style__dji-btn-xl___20iJH",
            "dji-btn-lg": "style__dji-btn-lg___2BnLT",
            "dji-btn-md": "style__dji-btn-md___3XnI3",
            "dji-btn-sm": "style__dji-btn-sm___1wC1v",
            "dji-btn-disabled-solid-dark":
              "style__dji-btn-disabled-solid-dark___nsNj-",
            "dji-btn-disabled-outline-dark":
              "style__dji-btn-disabled-outline-dark___VZHH9",
            "dji-btn-disabled-flat-dark":
              "style__dji-btn-disabled-flat-dark___2d-0N",
            "dji-btn-disabled-solid-light":
              "style__dji-btn-disabled-solid-light___2yTxf",
            "dji-btn-disabled-outline-light":
              "style__dji-btn-disabled-outline-light___3nSbF",
            "dji-btn-disabled-flat-light":
              "style__dji-btn-disabled-flat-light___3GaV_",
            "dji-btn-primary": "style__dji-btn-primary___3tFe2",
            "dji-btn-dark": "style__dji-btn-dark___3vZGF",
            "dji-btn-danger": "style__dji-btn-danger___3L8sd",
            "dji-btn-light": "style__dji-btn-light___3oAJz",
            "dji-btn-secondary-danger":
              "style__dji-btn-secondary-danger___38EhR",
            "dji-btn-secondary-dark": "style__dji-btn-secondary-dark___30qIM",
            "dji-btn-secondary-light": "style__dji-btn-secondary-light___1Lf7g",
            "dji-btn-tertiary-light": "style__dji-btn-tertiary-light___3KGv_",
            "dji-btn-variant": "style__dji-btn-variant___1AMwc",
            "dji-btn-variant-danger": "style__dji-btn-variant-danger___cf_5S",
            "dji-btn-variant-light": "style__dji-btn-variant-light___9BBSd",
            "dji-btn-variant-dark": "style__dji-btn-variant-dark___zscvz",
            "dji-btn-tertiary": "style__dji-btn-tertiary___1-c1j",
            "dji-btn-tertiary-dark": "style__dji-btn-tertiary-dark___3_xGb",
            "dji-btn-group": "style__dji-btn-group___1_bC1",
            active: "style__active___2kYCH",
          },
        };
      function p(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var f = (function (e) {
          return (
            (e["x-large"] = "xl"),
            (e.large = "lg"),
            (e.medium = "md"),
            (e.small = "sm"),
            e
          );
        })({}),
        h = (function (e) {
          return (
            (e.primary = "primary"),
            (e.danger = "danger"),
            (e.dark = "dark"),
            (e.light = "light"),
            (e.btn = "btn"),
            (e["secondary-danger"] = "secondary-danger"),
            (e["secondary-dark"] = "secondary-dark"),
            (e["secondary-light"] = "secondary-light"),
            (e.variant = "variant"),
            (e["variant-danger"] = "variant-danger"),
            (e["variant-dark"] = "variant-dark"),
            (e["variant-light"] = "variant-light"),
            (e.tertiary = "tertiary"),
            (e["tertiary-dark"] = "tertiary-dark"),
            (e["tertiary-light"] = "tertiary-light"),
            (e["disabled-solid-dark"] = "disabled-solid-dark"),
            (e["disabled-solid-light"] = "disabled-solid-light"),
            (e["disabled-outline-dark"] = "disabled-outline-dark"),
            (e["disabled-flat-dark"] = "disabled-flat-dark"),
            (e["disabled-flat-light"] = "disabled-flat-light"),
            e
          );
        })({}),
        m = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t), ((n = p(this, t, [e])).state = {}), n
            );
          }
          return (
            Object(l.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = "dji-btn-".concat(e.size),
                    n = e.disabled ? "button-anchor-disabled" : "",
                    o = "dji-btn-".concat(h[e.type]),
                    a = u(
                      "button",
                      {
                        id: e.id,
                        style: e.style,
                        type: "button",
                        disabled: e.disabled,
                        onClick: e.onClick,
                        className:
                          "atom-design-v1 " +
                          c()("dji-btn ".concat(t, " ").concat(o), d, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                      },
                      e.children,
                    );
                  return (
                    e.href &&
                      (a = u(
                        "a",
                        {
                          href: e.href,
                          target: e.target,
                          className: c()("button-anchor ".concat(n), d, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                        },
                        a,
                      )),
                    a
                  );
                },
              },
            ]),
            t
          );
        })(_.Component);
      m.defaultProps = {
        disabled: !1,
        href: "",
        size: f.medium,
        target: "",
        type: h.btn,
        onClick: function () {},
        children: "",
        style: {},
        id: "",
      };
    },
    QIyF: function (e, t, n) {
      var o = n("Kz5y");
      e.exports = function () {
        return o.Date.now();
      };
    },
    QMMT: function (e, t, n) {
      var o = n("a0xu"),
        a = n("UWiX")("toStringTag"),
        r =
          "Arguments" ==
          o(
            (function () {
              return arguments;
            })(),
          );
      e.exports = function (e) {
        var t, n, i;
        return void 0 === e
          ? "Undefined"
          : null === e
            ? "Null"
            : "string" ==
                typeof (n = (function (e, t) {
                  try {
                    return e[t];
                  } catch (n) {}
                })((t = Object(e)), a))
              ? n
              : r
                ? o(t)
                : "Object" == (i = o(t)) && "function" == typeof t.callee
                  ? "Arguments"
                  : i;
      };
    },
    QbLZ: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o,
        a = n("P2sY"),
        r = (o = a) && o.__esModule ? o : { default: o };
      t.default =
        r.default ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var o in n)
              Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
          return e;
        };
    },
    QcOe: function (e, t, n) {
      var o = n("GoyQ"),
        a = n("6sVZ"),
        r = n("7Ix3"),
        i = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        if (!o(e)) return r(e);
        var t = a(e),
          n = [];
        for (var l in e)
          ("constructor" != l || (!t && i.call(e, l))) && n.push(l);
        return n;
      };
    },
    QkVE: function (e, t, n) {
      var o = n("EpBk");
      e.exports = function (e, t) {
        var n = e.__data__;
        return o(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
      };
    },
    QqLw: function (e, t, n) {
      var o = n("tadb"),
        a = n("ebwN"),
        r = n("HOxn"),
        i = n("yGk4"),
        l = n("Of+w"),
        s = n("NykK"),
        c = n("3Fdi"),
        _ = c(o),
        u = c(a),
        d = c(r),
        p = c(i),
        f = c(l),
        h = s;
      ((o && "[object DataView]" != h(new o(new ArrayBuffer(1)))) ||
        (a && "[object Map]" != h(new a())) ||
        (r && "[object Promise]" != h(r.resolve())) ||
        (i && "[object Set]" != h(new i())) ||
        (l && "[object WeakMap]" != h(new l()))) &&
        (h = function (e) {
          var t = s(e),
            n = "[object Object]" == t ? e.constructor : void 0,
            o = n ? c(n) : "";
          if (o)
            switch (o) {
              case _:
                return "[object DataView]";
              case u:
                return "[object Map]";
              case d:
                return "[object Promise]";
              case p:
                return "[object Set]";
              case f:
                return "[object WeakMap]";
            }
          return t;
        }),
        (e.exports = h);
    },
    "R+7+": function (e, t, n) {
      var o = n("w6GO"),
        a = n("mqlF"),
        r = n("NV0k");
      e.exports = function (e) {
        var t = o(e),
          n = a.f;
        if (n)
          for (var i, l = n(e), s = r.f, c = 0; l.length > c; )
            s.call(e, (i = l[c++])) && t.push(i);
        return t;
      };
    },
    "RU/L": function (e, t, n) {
      n("Rqdy");
      var o = n("WEpk").Object;
      e.exports = function (e, t, n) {
        return o.defineProperty(e, t, n);
      };
    },
    RXnR: function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return r;
      }),
        n.d(t, "a", function () {
          return i;
        });
      var o = [0, 1, 2, 3, 4],
        a = {
          0: ["au", "nz"],
          1: ["kr"],
          2: ["hk", "mo", "sg", "gb", "ae"],
          3: ["jp", "tw", "ca", "pr", "us", "mx", "br"],
          4: [
            "id",
            "at",
            "ru",
            "be",
            "bg",
            "hr",
            "cz",
            "dk",
            "ee",
            "fi",
            "fr",
            "de",
            "gr",
            "hu",
            "ie",
            "it",
            "lv",
            "li",
            "lt",
            "lu",
            "mt",
            "mc",
            "nl",
            "no",
            "pl",
            "pt",
            "sk",
            "si",
            "es",
            "se",
            "ch",
          ],
        },
        r = function (e) {
          var t = (function (e) {
            for (var t = 0; t < o.length; t++)
              for (var n = a[o[t]], r = 0; r < n.length; r++)
                if (n[r].toUpperCase() === e) return o[t];
          })(e);
          return "CN" === e ? -1 : t;
        },
        i = function (e, t, n, o) {
          var a;
          return -1 === t ||
            !(null === n || void 0 === n ? void 0 : n.length) ||
            (null === n || void 0 === n ? void 0 : n.length) - 1 < t
            ? e
            : (null === (a = n[t]) || void 0 === a ? void 0 : a[o]) || e;
        };
    },
    RXxH: function (e, t, n) {
      "use strict";
      n.d(t, "c", function () {
        return r;
      }),
        n.d(t, "b", function () {
          return i;
        }),
        n.d(t, "a", function () {
          return l;
        }),
        n.d(t, "d", function () {
          return s;
        });
      var o = n("q1tI"),
        a = n.n(o).a.createElement,
        r = function (e) {
          return a(
            "svg",
            e,
            a("path", {
              d: "M13.975 1.72h-1.182a.3.3 0 0 0-.299.313l.1 2.062A6.166 6.166 0 0 0 7.886 1.92c-3.406 0-6.184 2.78-6.181 6.185a6.18 6.18 0 0 0 10.322 4.584.3.3 0 0 0 .012-.435l-.847-.847a.3.3 0 0 0-.408-.014 4.386 4.386 0 1 1 .743-5.74l-2.53-.121a.3.3 0 0 0-.314.299v1.182a.3.3 0 0 0 .3.299h4.992a.3.3 0 0 0 .299-.3V2.02a.3.3 0 0 0-.3-.3Z",
            }),
          );
        };
      r.defaultProps = {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
      };
      var i = function (e) {
        return a(
          "svg",
          e,
          a("path", {
            d: "m14.627 8.655-9.542 5.33a.75.75 0 0 1-1.116-.655V2.67a.75.75 0 0 1 1.116-.655l9.542 5.33a.75.75 0 0 1 0 1.31Z",
          }),
        );
      };
      i.defaultProps = {
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var l = function (e) {
        return a(
          "svg",
          e,
          a("path", {
            d: "M6.006 13.583H3.614c-.66 0-1.197-.536-1.197-1.197V3.614c0-.66.536-1.197 1.197-1.197h2.392c.66 0 1.196.536 1.196 1.197v8.772c0 .66-.535 1.197-1.196 1.197Zm7.577-1.197V3.614c0-.66-.536-1.197-1.197-1.197H9.994c-.66 0-1.196.536-1.196 1.197v8.772c0 .66.535 1.197 1.196 1.197h2.392c.66 0 1.197-.536 1.197-1.197Z",
            fill: "#000",
            fillRule: "evenodd",
            fillOpacity: ".85",
          }),
        );
      };
      l.defaultProps = {
        width: "16",
        height: "16",
        xmlns: "http://www.w3.org/2000/svg",
      };
      var s = function (e) {
        return a(
          "svg",
          e,
          a("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.105 13a1.002 1.002 0 0 1 0-1.416L9.684 8 6.105 4.416a1.002 1.002 0 0 1 0-1.416l4.64 4.646a.501.501 0 0 1 0 .708L6.104 13Z",
            fill: "#000",
            fillOpacity: ".85",
          }),
        );
      };
      s.defaultProps = {
        width: "16",
        height: "16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      };
    },
    Ra6f: function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return f;
      }),
        n.d(t, "a", function () {
          return y;
        });
      var o = n("q1tI"),
        a = n.n(o),
        r = n("xk4V"),
        i = n.n(r),
        l = n("HcE9"),
        s = n("ub/+"),
        c = n("nPaQ"),
        _ = n("tZZE"),
        u = n("ZPPD"),
        d = n("frqK"),
        p = (n("Z4y5"), a.a.createElement),
        f = function (e, t) {
          var n = t.gaTextPrefix,
            o = t.linkType,
            a = t.linkText,
            r = t.link,
            c = t.gaCategory,
            _ = t.gaAction,
            u = l.b.normal,
            d = n;
          switch (o) {
            case "internal-link":
              (u = l.b.more), (d = "".concat(d, "in"));
              break;
            case "external-link":
              (u = l.b.external), (d = "".concat(d, "out"));
              break;
            case "download-link":
              (u = l.b.download), (d = "".concat(d, "download"));
              break;
            case "no-icon-link":
              (u = l.b.normal), (d = "".concat(d, "normal"));
              break;
            default:
              (u = l.b.more), (d = "".concat(d, "in"));
          }
          var f = l.a[e.linkColor],
            h = {
              fontSize: e.linkFontSize || "16px",
              lineHeight: Object(s.a)(e.linkFontSize, e.linkLineHeight),
            };
          return p(
            "div",
            {
              "data-aos": e.aosFade,
              "data-aos-once": !0,
              className: "style__link___2-YIH",
              key: i()(),
              "data-ga-category": c,
              "data-ga-action": _,
              "data-ga-label": d,
            },
            p(
              l.c,
              { theme: f, type: u, style: h, href: r },
              p("span", {
                "data-link": "true",
                dangerouslySetInnerHTML: { __html: a || "" },
              }),
            ),
          );
        },
        h = function (e) {
          var t = _.a.SELF;
          return (
            (e !== d.q["store-button"] && e !== d.q["external-button"]) ||
              (t = _.a.BLANK),
            e === d.s["external-link"] && (t = _.a.BLANK),
            t
          );
        },
        m = function (e, t, n) {
          var o = !1;
          return e && t && "/" !== t
            ? ((n !== d.q.button &&
                n !== d.q["external-button"] &&
                n !== d.q["store-button"]) ||
                (o = !0),
              (n !== d.s.button &&
                n !== d.s["internal-link"] &&
                n !== d.s["external-link"] &&
                n !== d.s["store-button"]) ||
                (o = !0),
              o)
            : o;
        },
        y = function (e) {
          var t = "",
            n = _.a.SELF,
            o = { url: void 0, target: n, gaLabel: "" };
          if (e.hasJumpLink && e.jumpLink && "/" !== e.jumpLink) return o;
          if (m(e.hasPrimaryButton, e.primaryButtonLink, e.primaryButtonType))
            return (
              (n = h(e.primaryButtonType)),
              (t = Object(c.b)(e.primaryButtonGaLabel, e.index)),
              (o = { url: e.primaryButtonLink, target: n, gaLabel: t })
            );
          if (
            m(
              e.hasSecondaryButton,
              e.secondaryButtonLink,
              e.secondaryButtonType,
            )
          )
            return (
              (n = h(e.secondaryButtonType)),
              (t = Object(c.b)(e.secondaryButtonGaLabel, e.index)),
              (o = { url: e.secondaryButtonLink, target: n, gaLabel: t })
            );
          if (m(e.hasThirdlyButton, e.thirdlyButtonLink, e.thirdlyButtonType))
            return (
              (n = h(e.thirdlyButtonType)),
              (t = Object(c.b)(e.thirdlyButtonGaLabel, e.index)),
              (o = { url: e.thirdlyButtonLink, target: n, gaLabel: t })
            );
          if (e.hasCardLinks && e.links) {
            var a = Object(u.b)(e.links);
            if (a > -1) {
              var r = e.links[a],
                i = "card-".concat(e.index, "-link-0-link-"),
                l = r.linkGaLabel ? "".concat(r.linkGaLabel, "-") : i;
              return (
                "internal-link" === r.linkType &&
                  (o = {
                    url: r.text,
                    target: _.a.SELF,
                    gaLabel: "".concat(l, "in"),
                  }),
                "external-link" === r.linkType &&
                  (o = {
                    url: r.text,
                    target: _.a.BLANK,
                    gaLabel: "".concat(l, "out"),
                  }),
                o
              );
            }
          }
          return (
            o.url ||
              (e.hasAnchor &&
                e.anchorId &&
                (o = {
                  url: "#".concat(e.anchorId),
                  target: _.a.SELF,
                  gaLabel: "card-".concat(e.index, "-anchor-link"),
                })),
            o
          );
        };
    },
    Rf4w: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("KQm4"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("XnI8"),
        m = n("SBOM"),
        y = n("xk4V"),
        b = n.n(y),
        v = n("TSYQ"),
        g = n.n(v),
        w = n("XrJB"),
        x = n.n(w),
        k = n("QH4r"),
        O = n("S5C5"),
        I = n("/+VL"),
        S = n("RXnR"),
        j = (n("aiR1"), n("L770"), f.a.createElement);
      function T(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var C = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t),
              ((n = T(this, t, [e])).videoDom = []),
              (n.videos = []),
              (n.replayBtn = []),
              (n.showActive = n.showActive.bind(Object(l.a)(n))),
              (n.initLayzrVideo = n.initLayzrVideo.bind(Object(l.a)(n))),
              (n.playVideo = n.playVideo.bind(Object(l.a)(n))),
              (n.videoData = []),
              Array.isArray(e.component_data.waterfallLeft) &&
                (n.videoData = n.videoData.concat(
                  e.component_data.waterfallLeft,
                )),
              Array.isArray(e.component_data.waterfallCenter) &&
                (n.videoData = n.videoData.concat(
                  e.component_data.waterfallCenter,
                )),
              Array.isArray(e.component_data.waterfallRight) &&
                (n.videoData = n.videoData.concat(
                  e.component_data.waterfallRight,
                )),
              n
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "scheduleVideoLoad",
                value: function (e) {
                  var t = this,
                    n = this.videoDom[e];
                  n &&
                    void 0 === n.videoLoaded &&
                    ((n.videoLoaded = !1),
                    I.a.getInstance().addNode(n, {}, [
                      function () {
                        if (n.videoLoaded) return !0;
                        t.initLayzrVideo(n);
                      },
                    ]));
                },
              },
              {
                key: "componentDidMount",
                value: function () {
                  var e = this;
                  this.props.showVideo(this), this.scheduleVideoLoad(0);
                  var t = !1;
                  I.a.getInstance().addNode(
                    this.videoDom[0],
                    {},
                    [
                      function () {
                        var n = e.videoDom[0],
                          o = n.querySelectorAll("source"),
                          a = o[0].dataset.layzrSrc,
                          r = o[0].dataset.src,
                          i =
                            void 0 === a ||
                            "" === a ||
                            "/" === a ||
                            void 0 === r ||
                            "" === r ||
                            "/" === r;
                        return (
                          !(!Number.isNaN(n.duration) || !i) ||
                          (n && !t ? (e.playVideo(n, 0), (t = !0), !0) : void 0)
                        );
                      },
                    ],
                    500,
                    !0,
                  );
                },
              },
              {
                key: "initLayzrVideo",
                value: function (e) {
                  var t = e.querySelectorAll("source"),
                    n = t[0].dataset.layzrSrc;
                  t[0].setAttribute("src", n);
                  var o = e.dataset.layzrPoster;
                  o && e.setAttribute("poster", o),
                    e.load(),
                    (e.videoLoaded = !0);
                },
              },
              {
                key: "showActive",
                value: function (e, t) {
                  this.scheduleVideoLoad(e);
                  for (var n = 0; n < this.videos.length; n += 1)
                    this.videos[n].classList.remove("active"),
                      t === this.videos[n].getAttribute("tag") &&
                        ((this.replayBtn[n].style.display = "none"),
                        this.videos[n].classList.add("active"),
                        this.playVideo(this.videoDom[n], n));
                },
              },
              {
                key: "playVideo",
                value: function (e, t) {
                  var n = this;
                  if (e && !Number.isNaN(e.duration)) {
                    var o = !1;
                    !(function a() {
                      o ||
                        (!(function (e, t) {
                          !!window.MSInputMethodContext &&
                          !!document.documentMode
                            ? (e.load && e.load(),
                              e.addEventListener("canplay", function n() {
                                t(e), e.removeEventListener("canplay", n);
                              }))
                            : t(e);
                        })(e, function (e) {
                          (e.currentTime = 0),
                            (function (e) {
                              var t = e.play();
                              t &&
                                t.then &&
                                "function" === typeof t.then &&
                                t.then(
                                  function () {},
                                  function () {},
                                );
                            })(e);
                        }),
                        (o = !0),
                        e.addEventListener("ended", function () {
                          n.replayBtn[t] &&
                            (n.replayBtn[t].style.display = "block");
                        }),
                        n.replayBtn[t] &&
                          n.replayBtn[t].addEventListener("click", function () {
                            var o = e.play();
                            void 0 !== o &&
                              o.then(function () {}).catch(function () {}),
                              (n.replayBtn[t].style.display = "none");
                          }));
                      var r = window.requestAnimationFrame(a);
                      o && r && window.cancelAnimationFrame(r);
                    })();
                  }
                },
              },
              {
                key: "renderVideoContent",
                value: function (e, t) {
                  var n,
                    o,
                    a = this,
                    r = this.props,
                    i = r.t,
                    l = r.component_data,
                    s = r.localization,
                    c = r.gaSend,
                    _ = r.productData,
                    u = l.themsColor,
                    d = l.leftTitleSize,
                    p = l.leftTitleLineHeight,
                    h = l.leftDescSize,
                    m = l.leftDescLineHeight,
                    y = l.leftBorderRedis,
                    b = l.btnSize,
                    v = l.btnColor,
                    g = l.btnRadius,
                    w = l.btnMinWidth,
                    I = l.width,
                    T = l.leftGridproportion,
                    C = l.batteryList,
                    M = Object(S.b)(
                      null === s || void 0 === s ? void 0 : s.country,
                    ),
                    P = (T / 12) * ((I || 1200) - 176) + 16 * (T - 1);
                  return j(
                    f.a.Fragment,
                    null,
                    j(
                      "video",
                      {
                        muted: !0,
                        name: "media",
                        style: { borderRadius: y },
                        "data-layzr-poster": (
                          null === e || void 0 === e ? void 0 : e.isBattery
                        )
                          ? Object(S.a)(
                              null === e || void 0 === e
                                ? void 0
                                : e.videoPoster,
                              M,
                              C,
                              "batteryVideoPoster",
                            )
                          : null === e || void 0 === e
                            ? void 0
                            : e.videoPoster,
                        className: "style__accessories-video___2oSYm",
                        ref: function (e) {
                          a.videoDom[t] = e;
                        },
                      },
                      j("source", {
                        type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                        "data-layzr-src":
                          e && e.videoLink && e.videoLink.path
                            ? e.videoLink.path
                            : "",
                      }),
                    ),
                    j(
                      "div",
                      { className: "style__text-box___2PZbN" },
                      j(
                        "div",
                        {
                          style: { width: "".concat(P - 40, "px") },
                          className: "style__introduce___tf26r",
                        },
                        j("h5", {
                          style: { color: u, fontSize: d, lineHeight: p },
                          className: "style__title___3PVHo",
                          dangerouslySetInnerHTML: { __html: i(e.title) },
                        }),
                        j("p", {
                          style: { fontSize: h, lineHeight: m },
                          className: "style__desc___1pBU4",
                          dangerouslySetInnerHTML: { __html: i(e.desc) },
                        }),
                        e.hasBtn
                          ? j(
                              "div",
                              { className: "style__btn-wrapper___V8x-t" },
                              j(
                                k.c,
                                {
                                  size: k.a[b],
                                  onClick:
                                    "store-button" === e.btnType &&
                                    function () {
                                      return c(
                                        "click",
                                        "Accessories-".concat(
                                          i(e.title),
                                          "-Buy-Now",
                                        ),
                                        "".concat(
                                          null === _ || void 0 === _
                                            ? void 0
                                            : _.slug,
                                          "_detail",
                                        ),
                                      );
                                    },
                                  href:
                                    "store-button" === e.btnType
                                      ? Object(O.e)(
                                          Object(O.k)({
                                            url: "/where-to-buy",
                                            country:
                                              null === s || void 0 === s
                                                ? void 0
                                                : s.country,
                                            locale:
                                              null === s || void 0 === s
                                                ? void 0
                                                : s.language,
                                          }),
                                          null === (n = e.btnLink) ||
                                            void 0 === n
                                            ? void 0
                                            : n.path,
                                          null === s || void 0 === s
                                            ? void 0
                                            : s.country,
                                        )
                                      : null === (o = e.btnLink) || void 0 === o
                                        ? void 0
                                        : o.path,
                                  target:
                                    "external-button" === e.btnType ||
                                    "store-button" === e.btnType
                                      ? "_blank"
                                      : "_self",
                                  style: {
                                    borderRadius: g || "60px",
                                    minWidth: w || "auto",
                                  },
                                  type: v,
                                },
                                j("div", {
                                  className: "",
                                  dangerouslySetInnerHTML: {
                                    __html: i(e.btnText) || "",
                                  },
                                }),
                              ),
                            )
                          : null,
                      ),
                      j(
                        "div",
                        {
                          className:
                            "accessories-replay-btn style__replay-btn-box___TH-9V",
                          ref: function (e) {
                            a.replayBtn[t] = e;
                          },
                        },
                        j(
                          "div",
                          {
                            style: { borderColor: u },
                            className:
                              "accessories-replay-btn style__replay-btn___FPpI8",
                          },
                          j(x.a, {
                            name: "fa-light-redo",
                            className: "style__icon___35vr-",
                          }),
                        ),
                      ),
                    ),
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props.component_data.leftBorderRedis,
                    n = this.videoData.map(function (n, o) {
                      return j(
                        "li",
                        {
                          key: b()(),
                          style: { borderRadius: t },
                          className:
                            "".concat(
                              0 === o ? "active" : "",
                              " dbv-accessories",
                            ) + " style__accessories-item-video___2xKfg",
                          tag: "accessories-video".concat(o),
                          ref: function (t) {
                            e.videos[o] = t;
                          },
                        },
                        e.renderVideoContent(n, o),
                      );
                    });
                  return j(
                    "ul",
                    {
                      className:
                        "accessores-dbv style__accessories-video-ul___RikAL",
                      ref: function (t) {
                        e.stickyDom = t;
                      },
                      tag: "sticky",
                    },
                    n,
                  );
                },
              },
            ]),
            t
          );
        })(f.a.Component),
        M = Object(h.a)(C),
        P = f.a.createElement,
        E = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "accessories-sticky-component":
              "style__accessories-sticky-component___2AB9m",
            "section-title": "style__section-title___3lJq2",
            "section-container": "style__section-container___3Ie95",
            "sticky-wrap": "style__sticky-wrap___25ESB",
            "sticky-box": "style__sticky-box___MZVF2",
            "sticky-content": "style__sticky-content___1-MF2",
            "sticky-content-ceiling": "style__sticky-content-ceiling___3z48V",
            "sticky-content-ie": "style__sticky-content-ie___msrwl",
            "scroll-content": "style__scroll-content___1RCDt",
            "accessories-ul": "style__accessories-ul___25WD5",
            waterfall: "style__waterfall___1fY8Y",
            "accessories-item-last": "style__accessories-item-last___16bvL",
            "img-box": "style__img-box___3Jb2b",
            "accessories-item": "style__accessories-item___2203_",
            title: "style__title___3PVHo",
            "accessories-video-ul": "style__accessories-video-ul___RikAL",
            "accessories-item-video": "style__accessories-item-video___2xKfg",
            "accessories-video": "style__accessories-video___2oSYm",
            "replay-btn": "style__replay-btn___FPpI8",
            icon: "style__icon___35vr-",
            "text-box": "style__text-box___2PZbN",
            introduce: "style__introduce___tf26r",
            "btn-wrapper": "style__btn-wrapper___V8x-t",
            desc: "style__desc___1pBU4",
            "replay-btn-box": "style__replay-btn-box___TH-9V",
            "accessories-sticky-component-special":
              "style__accessories-sticky-component-special___314Dg",
            "accessories-item-special":
              "style__accessories-item-special___7Zgpc",
            active: "style__active___1IfHH",
            "card-active-li": "style__card-active-li___-oXlB",
          },
        };
      function L(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      function B(e) {
        var t = e.itemType,
          n = e.extra,
          o = void 0 === n ? [] : n,
          a = "";
        return (
          "accessory" === t && (a = g()({ "accessories-item": !0 })),
          (a = g.a.apply(void 0, [a].concat(Object(_.a)(o))))
        );
      }
      var N = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = L(this, t, [e])).accessories = []),
            (n.showVideo = n.showVideo.bind(Object(l.a)(n))),
            (n.showVideoDom = n.showVideoDom.bind(Object(l.a)(n))),
            "undefined" === typeof document
              ? (n.isIE11 = !1)
              : (n.isIE11 =
                  !!window.MSInputMethodContext && !!document.documentMode),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "showVideoDom",
              value: function (e) {
                this.child = e;
              },
            },
            {
              key: "showVideo",
              value: function (e, t, n) {
                var o = this;
                var a = this.props,
                  r = a.gaSend,
                  i = a.productData,
                  l = a.component_data,
                  s = a.t,
                  c = l.cardActiveColor,
                  _ = l.cardBackgroundColor;
                return function () {
                  i &&
                    i.slug &&
                    r(
                      "click",
                      "accessories-".concat(s(e.title)),
                      "".concat(i.slug, "_detail"),
                    );
                  for (
                    var t = document.getElementsByClassName("accessories-item"),
                      a = 0,
                      l = 0;
                    l < t.length;
                    l += 1
                  )
                    t[l].classList.remove("card-active-li"),
                      (t[l].style.backgroundColor = _ || null),
                      t[l].getAttribute("tag") === n &&
                        ((a = l),
                        t[l].classList.add("card-active-li"),
                        (t[l].style.backgroundColor = c || null));
                  o.child.showActive(a, "accessories-video".concat(a));
                };
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.t,
                  o = t.component_data,
                  a = t.localization,
                  r = t.gaSend,
                  i = t.productData,
                  l = o.backgroundColorStart,
                  s = o.themsColor,
                  c = o.paddingTop,
                  _ = o.paddingBottom,
                  u = o.width,
                  p = o.leftGridproportion,
                  f = o.rightGridproportion,
                  h = o.rightTitleSize,
                  y = o.rightTitleLineHeigh,
                  v = o.rightCardDistance,
                  w = o.rightCardPadding,
                  x = o.rightBorderRedis,
                  k = o.rightTitleTop,
                  O = o.cardBackgroundColor,
                  I = o.cardActiveColor,
                  j = o.cardOverColor,
                  T = o.batteryList,
                  C = o.ceiling,
                  L = g()({ "accessories-sticky-component": !0 }),
                  N = {
                    backgroundColor: l || "#000000",
                    color: s || "#ffffff",
                    paddingTop: c,
                    paddingBottom: _,
                  },
                  D = {
                    color: s || "#ffffff",
                    fontSize: h,
                    lineHeight: y,
                    top: k,
                  },
                  z = Object(S.b)(
                    null === a || void 0 === a ? void 0 : a.country,
                  ),
                  A = {
                    width: "".concat(
                      (p / 12) * ((u || 1200) - 176) + 16 * (p - 1),
                      "px",
                    ),
                  },
                  R = {
                    width: "".concat(
                      (f / 12) * ((u || 1200) - 176) + 16 * (f - 1),
                      "px",
                    ),
                  },
                  F = function (e, t, n) {
                    return P(m.a, {
                      type: "img",
                      src: (null === e || void 0 === e ? void 0 : e.isBattery)
                        ? Object(S.a)(
                            null === e || void 0 === e ? void 0 : e.productImg,
                            z,
                            n,
                            "batteryProductPic",
                          )
                        : null === e || void 0 === e
                          ? void 0
                          : e.productImg,
                      tag: "accessories-video".concat(t),
                    });
                  },
                  V =
                    o && Array.isArray(o.waterfallLeft)
                      ? o.waterfallLeft.map(function (t, o) {
                          return P(
                            "div",
                            {
                              key: b()(),
                              style: {
                                marginBottom: v,
                                borderRadius: x,
                                backgroundColor: "".concat(0 === o ? I : O),
                              },
                              onClick: e.showVideo(
                                t,
                                o,
                                "accessories-left-video".concat(o),
                              ),
                              ref: function (t) {
                                (e.accessories[o] = t),
                                  t &&
                                    (t.addEventListener(
                                      "mouseover",
                                      function () {
                                        !t.classList.contains(
                                          "card-active-li",
                                        ) &&
                                          j &&
                                          (t.style.backgroundColor = j);
                                      },
                                    ),
                                    t.addEventListener("mouseout", function () {
                                      !t.classList.contains("card-active-li") &&
                                        O &&
                                        (t.style.backgroundColor = O);
                                    }));
                              },
                              tag: "accessories-left-video".concat(o),
                              className:
                                "".concat(
                                  0 === o ? "card-active-li" : "",
                                  " item accessories-item",
                                ) +
                                " " +
                                d()(B({ itemType: "accessory" }), E, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            },
                            P("h5", {
                              className: "style__title___3PVHo",
                              style: D,
                              tag: "accessories-video".concat(o),
                              dangerouslySetInnerHTML: { __html: n(t.title) },
                            }),
                            P(
                              "div",
                              {
                                className: "style__img-box___3Jb2b",
                                style: {
                                  padding: "".concat(w),
                                  minHeight: t.productImgMinHeight,
                                },
                              },
                              F(t, o, T),
                            ),
                          );
                        })
                      : null,
                  H =
                    o && Array.isArray(o.waterfallCenter)
                      ? o.waterfallCenter.map(function (t, o) {
                          return P(
                            "div",
                            {
                              key: b()(),
                              style: {
                                marginBottom: v,
                                borderRadius: x,
                                backgroundColor: O,
                              },
                              onClick: e.showVideo(
                                t,
                                o,
                                "accessories-center-video".concat(o),
                              ),
                              ref: function (t) {
                                (e.accessories[o] = t),
                                  t &&
                                    (t.addEventListener(
                                      "mouseover",
                                      function () {
                                        !t.classList.contains(
                                          "card-active-li",
                                        ) &&
                                          j &&
                                          (t.style.backgroundColor = j);
                                      },
                                    ),
                                    t.addEventListener("mouseout", function () {
                                      !t.classList.contains("card-active-li") &&
                                        O &&
                                        (t.style.backgroundColor = O);
                                    }));
                              },
                              tag: "accessories-center-video".concat(o),
                              className:
                                "accessories-item " +
                                d()(B({ itemType: "accessory" }), E, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            },
                            P("h5", {
                              className: "style__title___3PVHo",
                              style: D,
                              tag: "accessories-video".concat(o),
                              dangerouslySetInnerHTML: { __html: n(t.title) },
                            }),
                            P(
                              "div",
                              {
                                className: "style__img-box___3Jb2b",
                                style: {
                                  padding: "".concat(w),
                                  minHeight: t.productImgMinHeight,
                                },
                              },
                              F(t, o, T),
                            ),
                          );
                        })
                      : null,
                  W =
                    o && Array.isArray(o.waterfallRight)
                      ? o.waterfallRight.map(function (t, o) {
                          return P(
                            "div",
                            {
                              key: b()(),
                              style: {
                                marginBottom: v,
                                borderRadius: x,
                                backgroundColor: O,
                              },
                              onClick: e.showVideo(
                                t,
                                o,
                                "accessories-right-video".concat(o),
                              ),
                              ref: function (t) {
                                (e.accessories[o] = t),
                                  t &&
                                    (t.addEventListener(
                                      "mouseover",
                                      function () {
                                        !t.classList.contains(
                                          "card-active-li",
                                        ) &&
                                          j &&
                                          (t.style.backgroundColor = j);
                                      },
                                    ),
                                    t.addEventListener("mouseout", function () {
                                      !t.classList.contains("card-active-li") &&
                                        O &&
                                        (t.style.backgroundColor = O);
                                    }));
                              },
                              tag: "accessories-right-video".concat(o),
                              className:
                                "accessories-item " +
                                d()(B({ itemType: "accessory" }), E, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            },
                            P("h5", {
                              className: "style__title___3PVHo",
                              style: D,
                              tag: "accessories-video".concat(o),
                              dangerouslySetInnerHTML: { __html: n(t.title) },
                            }),
                            P(
                              "div",
                              {
                                className: "style__img-box___3Jb2b",
                                style: {
                                  padding: "".concat(w),
                                  minHeight: t.productImgMinHeight,
                                },
                              },
                              F(t, o, T),
                            ),
                          );
                        })
                      : null;
                return P(
                  "section",
                  {
                    id: o.anchor,
                    ref: function (t) {
                      e.component = t;
                    },
                    style: N,
                    className:
                      "accessories-sticky-component " +
                      d()(L, E, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  },
                  P(
                    "div",
                    {
                      style: { width: "".concat(u, "px") },
                      className: "style__section-container___3Ie95",
                      id: "accessories-container",
                    },
                    P(
                      "div",
                      { style: A, className: "style__sticky-wrap___25ESB" },
                      this.isIE11
                        ? P(
                            "div",
                            {
                              className: "style__sticky-content-ie___msrwl",
                              style: { marginTop: c },
                            },
                            P(M, {
                              t: n,
                              component_data: o,
                              showVideo: this.showVideoDom,
                              gaSend: r,
                              productData: i,
                            }),
                          )
                        : P(
                            "div",
                            {
                              style: { top: c },
                              className: d()(
                                "sticky-content ".concat(
                                  C && "sticky-content-ceiling",
                                ),
                                E,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            P(M, {
                              t: n,
                              component_data: o,
                              showVideo: this.showVideoDom,
                              gaSend: r,
                              productData: i,
                            }),
                          ),
                    ),
                    P(
                      "div",
                      { style: R, className: "style__scroll-content___1RCDt" },
                      P(
                        "div",
                        { className: "style__accessories-ul___25WD5" },
                        o &&
                          Array.isArray(o.waterfallLeft) &&
                          o.waterfallLeft.length > 0 &&
                          P(
                            "div",
                            {
                              className: "style__waterfall___1fY8Y",
                              style: { marginRight: v },
                            },
                            V,
                          ),
                        o &&
                          Array.isArray(o.waterfallCenter) &&
                          o.waterfallCenter.length > 0 &&
                          P(
                            "div",
                            {
                              className: "style__waterfall___1fY8Y",
                              style: { marginRight: v },
                            },
                            H,
                          ),
                        o &&
                          Array.isArray(o.waterfallRight) &&
                          o.waterfallRight.length > 0 &&
                          P(
                            "div",
                            {
                              className: "style__waterfall___1fY8Y",
                              style: { marginRight: v },
                            },
                            W,
                          ),
                      ),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(f.a.Component);
      Object(c.a)(N, "defaultProps", {
        t: function () {},
        gaSend: function () {},
        component_data: {
          rightCardPadding: "56px 16px 16px 16px",
          leftGridproportion: 5,
          rightGridproportion: 6,
          btnSize: "medium",
          btnColor: "primary",
          paddingTop: "128px",
          paddingBottom: "128px",
          cardBackgroundColor: "rgba(255, 255, 255, 0.09)",
          leftTitleSize: "16px",
          leftTitleLineHeight: "24px",
          leftDescSize: "16px",
          leftDescLineHeight: "20px",
          rightTitleSize: "14px",
          rightTitleLineHeigh: "20px",
          rightTitleTop: "16px",
          rightCardDistance: "8px",
          waterfallLeft: [
            {
              title: "\u5361\u7247\u4e3b\u6807\u9898",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff0",
              videoLink: { path: "/" },
              videoPoster:
                "//www5.djicdn.com/assets/images/products/tiny/pc_8_4_cover-85b53891b1ae6fc93b37eb2faa16b811.jpg?from=cdnMap",
              productImg:
                "//www1.djicdn.com/dps/4a18e81586d84926d0ca73632546e46c.png",
              hasBtn: !1,
              isBattery: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u9898",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff0",
              videoLink: { path: "/" },
              videoPoster:
                "//www5.djicdn.com/assets/images/products/tiny/pc_8_9_cover-4316bf2d98ec6c825d019494d3b3e2c8.jpg?from=cdnMap",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
              isBattery: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u9898",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff0",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
              isBattery: !1,
            },
          ],
          waterfallCenter: [
            {
              title: "\u5361\u7247\u4e3b\u6807\u98982",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff02",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
              isBattery: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u98982",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff02",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
              isBattery: !1,
            },
            {
              ttitle: "\u5361\u7247\u4e3b\u6807\u98982",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff02",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
              isBattery: !1,
            },
          ],
          waterfallRight: [
            {
              ttitle: "\u5361\u7247\u4e3b\u6807\u98983",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff03",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
              isBattery: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u98983",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff03",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
              isBattery: !1,
            },
          ],
        },
      }),
        Object(c.a)(N, "editSetting", {
          key: "Accessories",
          name: "Accessories",
          contentSetting: {
            stickySetting: {
              label: "\u5de6\u5217\u914d\u4ef6\u6a21\u5757\u5438\u9876",
              props: {
                ceiling: {
                  label:
                    "\u5de6\u5217\u914d\u4ef6\u6a21\u5757\u5438\u9876\u914d\u7f6e\uff08\u9ed8\u8ba4\u4e0d\u5438\u9876\uff09",
                  type: "boolean",
                },
              },
            },
            waterfallLeft: {
              label: "\u5de6\u5217\u914d\u4ef6\u914d\u7f6e",
              props: {
                waterfallLeft: {
                  type: "array",
                  label: "\u5de6\u5217\u914d\u4ef6",
                  props: {
                    title: {
                      label: "\u914d\u4ef6title",
                      type: "string",
                      content: "text",
                    },
                    desc: {
                      label: "\u914d\u4ef6\u63cf\u8ff0",
                      type: "string",
                      content: "text",
                    },
                    isBattery: {
                      type: "boolean",
                      label:
                        "\u5de6\u5217\u914d\u4ef6\u662f\u5426\u662f\u7535\u6e90\u914d\u4ef6(\u4e0a\u4f20\u4e2d\u7248\u56fe)",
                    },
                    videoLink: {
                      label: "\u914d\u4ef6\u89c6\u9891",
                      type: "string",
                      content: "url",
                    },
                    videoPoster: {
                      type: "image",
                      label: "\u89c6\u9891\u5360\u4f4d\u56fe",
                    },
                    videoPosterMinHeight: {
                      label:
                        "\u89c6\u9891\u5360\u4f4d\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    productImg: { type: "image", label: "\u4ea7\u54c1\u56fe" },
                    productImgMinHeight: {
                      label:
                        "\u4ea7\u54c1\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    hasBtn: {
                      type: "boolean",
                      label:
                        "\u5de6\u5217\u914d\u4ef6\u662f\u5426\u6709\u6309\u94ae",
                    },
                    btnText: {
                      label: "\u5de6\u5217\u914d\u4ef6\u6309\u94ae\u6587\u6848",
                      type: "string",
                      content: "text",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                    btnType: {
                      label: "\u5de6\u5217\u914d\u4ef6\u6309\u94ae\u7c7b\u578b",
                      type: "select",
                      controlBy: "hasBtn",
                      controlValue: !0,
                      items: [
                        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                      ],
                    },
                    btnLink: {
                      type: "string",
                      content: "url",
                      label: "\u5de6\u5217\u914d\u4ef6\u6309\u94ae\u94fe\u63a5",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                  },
                },
              },
            },
            waterfallCenter: {
              label: "\u4e2d\u5217\u6a21\u5757\u914d\u7f6e",
              props: {
                waterfallCenter: {
                  type: "array",
                  label: "\u4e2d\u5217\u914d\u4ef6",
                  props: {
                    title: {
                      label: "\u914d\u4ef6title",
                      type: "string",
                      content: "text",
                    },
                    desc: {
                      label: "\u914d\u4ef6\u63cf\u8ff0",
                      type: "string",
                      content: "text",
                    },
                    isBattery: {
                      type: "boolean",
                      label:
                        "\u4e2d\u5217\u914d\u4ef6\u662f\u5426\u662f\u7535\u6e90\u914d\u4ef6(\u4e0a\u4f20\u4e2d\u7248\u56fe)",
                    },
                    videoLink: {
                      label: "\u89c6\u9891",
                      type: "string",
                      content: "url",
                    },
                    videoPoster: {
                      type: "image",
                      label: "\u89c6\u9891\u5360\u4f4d\u56fe",
                    },
                    videoPosterMinHeight: {
                      label:
                        "\u89c6\u9891\u5360\u4f4d\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    productImg: { type: "image", label: "\u4ea7\u54c1\u56fe" },
                    productImgMinHeight: {
                      label:
                        "\u4ea7\u54c1\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    hasBtn: {
                      type: "boolean",
                      label:
                        "\u4e2d\u5217\u914d\u4ef6\u662f\u5426\u6709\u6309\u94ae",
                    },
                    btnText: {
                      label: "\u4e2d\u5217\u914d\u4ef6\u6309\u94ae\u6587\u6848",
                      type: "string",
                      content: "text",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                    btnType: {
                      label: "\u4e2d\u5217\u914d\u4ef6\u6309\u94ae\u7c7b\u578b",
                      type: "select",
                      controlBy: "hasBtn",
                      controlValue: !0,
                      items: [
                        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                      ],
                    },
                    btnLink: {
                      type: "string",
                      content: "url",
                      label: "\u4e2d\u5217\u914d\u4ef6\u6309\u94ae\u94fe\u63a5",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                  },
                },
              },
            },
            waterfallRight: {
              label: "\u53f3\u5217\u914d\u4ef6\u914d\u7f6e",
              props: {
                waterfallRight: {
                  type: "array",
                  label: "\u53f3\u5217\u914d\u4ef6",
                  props: {
                    title: {
                      label: "\u914d\u4ef6title",
                      type: "string",
                      content: "text",
                    },
                    desc: {
                      label: "\u914d\u4ef6\u63cf\u8ff0",
                      type: "string",
                      content: "text",
                    },
                    isBattery: {
                      type: "boolean",
                      label:
                        "\u53f3\u5217\u914d\u4ef6\u662f\u5426\u662f\u7535\u6e90\u914d\u4ef6(\u4e0a\u4f20\u4e2d\u7248\u56fe)",
                    },
                    videoLink: {
                      label: "\u89c6\u9891",
                      type: "string",
                      content: "url",
                    },
                    videoPoster: {
                      type: "image",
                      label: "\u89c6\u9891\u5360\u4f4d\u56fe",
                    },
                    videoPosterMinHeight: {
                      label:
                        "\u89c6\u9891\u5360\u4f4d\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    productImg: { type: "image", label: "\u4ea7\u54c1\u56fe" },
                    productImgMinHeight: {
                      label:
                        "\u4ea7\u54c1\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    hasBtn: {
                      type: "boolean",
                      label:
                        "\u53f3\u5217\u914d\u4ef6\u662f\u5426\u6709\u6309\u94ae",
                    },
                    btnText: {
                      label: "\u53f3\u5217\u914d\u4ef6\u6309\u94ae\u6587\u6848",
                      type: "string",
                      content: "text",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                    btnType: {
                      label: "\u53f3\u5217\u914d\u4ef6\u6309\u94ae\u7c7b\u578b",
                      type: "select",
                      controlBy: "hasBtn",
                      controlValue: !0,
                      items: [
                        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                      ],
                    },
                    btnLink: {
                      type: "string",
                      content: "url",
                      label: "\u53f3\u5217\u914d\u4ef6\u6309\u94ae\u94fe\u63a5",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                  },
                },
              },
            },
            batterySetting: {
              label: "\u7535\u6e90\u914d\u4ef6\u914d\u7f6e",
              props: {
                batteryList: {
                  type: "array",
                  label:
                    "\u7535\u6e90\u914d\u4ef6\u914d\u7f6e - (\u8bf7\u6309\u987a\u5e8f\u4e0a\u4f20\uff1a \u6fb3\u3001\u97e9\u3001\u82f1\u3001\u7f8e\u3001\u6b27)",
                  props: {
                    batteryVideoPoster: {
                      type: "image",
                      label:
                        "\u89c6\u9891\u5360\u4f4d\u56fe - \u7535\u6e90\u914d\u4ef6",
                    },
                    batteryProductPic: {
                      type: "image",
                      label: "\u4ea7\u54c1\u56fe - \u7535\u6e90\u914d\u4ef6",
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            themsSeting: {
              label: "\u7ec4\u4ef6\u4e3b\u9898\u81ea\u5b9a\u4e49\u8bbe\u7f6e",
              props: {
                themsColor: {
                  label:
                    "\u5b57\u4f53\u989c\u8272\uff08\u5b57\u4f53\u548c\u64ad\u653e\u6309\u94ae\u7684\u989c\u8272)",
                  type: "string",
                  content: "color",
                },
                backgroundColorStart: {
                  label: "\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
              },
            },
            layoutSeting: {
              label: "\u7ec4\u4ef6\u5e03\u5c40\u8bbe\u7f6e",
              props: {
                paddingTop: {
                  label: "\u6a21\u5757\u4e0a\u8fb9\u8ddd",
                  type: "string",
                },
                paddingBottom: {
                  label: "\u6a21\u5757\u4e0b\u8fb9\u8ddd",
                  type: "string",
                },
                width: {
                  label:
                    "\u5bbd\u5ea6 \u9ed8\u8ba4\uff081200\uff09\u4e0d\u5e26\u5355\u4f4d",
                  type: "number",
                },
                leftGridproportion: {
                  label:
                    "\u5de6\u4fa7\u7684\u6805\u683c\u5360\u6bd4\uff081-11\uff09",
                  type: "select",
                  items: [
                    { label: "1", value: 1 },
                    { label: "2", value: 2 },
                    { label: "3", value: 3 },
                    { label: "4", value: 4 },
                    { label: "5", value: 5 },
                    { label: "6", value: 6 },
                    { label: "7", value: 7 },
                    { label: "8", value: 8 },
                    { label: "9", value: 9 },
                    { label: "10", value: 10 },
                    { label: "11", value: 11 },
                  ],
                },
                rightGridproportion: {
                  label:
                    "\u53f3\u4fa7\u7684\u6805\u683c\u5360\u6bd4 \uff081-11\uff09",
                  type: "select",
                  items: [
                    { label: "1", value: 1 },
                    { label: "2", value: 2 },
                    { label: "3", value: 3 },
                    { label: "4", value: 4 },
                    { label: "5", value: 5 },
                    { label: "6", value: 6 },
                    { label: "7", value: 7 },
                    { label: "8", value: 8 },
                    { label: "9", value: 9 },
                    { label: "10", value: 10 },
                    { label: "11", value: 11 },
                  ],
                },
                anchor: {
                  type: "string",
                  content: "size",
                  label: "\u951a\u70b9",
                },
              },
            },
            cardSeting: {
              label: "\u914d\u4ef6\u4ea7\u54c1\u56fe\u8bbe\u7f6e",
              props: {
                cardBackgroundColor: {
                  label: "\u914d\u4ef6\u5361\u7247\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
                cardActiveColor: {
                  label:
                    "\u5361\u7247\u9009\u4e2d\u65f6\u7684\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
                cardOverColor: {
                  label:
                    "\u9f20\u6807\u60ac\u6d6e\u5361\u7247\u80cc\u666f\u8272",
                  type: "string",
                  content: "color",
                },
                rightCardDistance: {
                  label: "\u5361\u7247\u95f4\u7684\u8ddd\u79bb",
                  type: "string",
                },
                rightCardPadding: {
                  label: "\u5361\u7247\u56fe\u7247\u5185\u95f4\u8ddd",
                  type: "string",
                },
                rightBorderRedis: {
                  label: "\u5361\u7247\u5706\u89d2",
                  type: "string",
                },
                rightTitleSize: {
                  label: "\u5361\u7247\u6807\u9898\u5b57\u4f53\u5927\u5c0f",
                  type: "string",
                },
                rightTitleLineHeigh: {
                  label: "\u5361\u7247\u6807\u9898\u884c\u9ad8",
                  type: "string",
                },
                rightTitleTop: {
                  label:
                    "\u5361\u7247\u6807\u9898\u8ddd\u79bb\u9876\u7aef\u5b9a\u4f4d",
                  type: "string",
                },
              },
            },
            videoSeting: {
              label: "\u89c6\u9891\u6a21\u5757\u8bbe\u7f6e",
              props: {
                leftTitleSize: {
                  label: "\u6807\u9898\u5b57\u4f53\u5927\u5c0f",
                  type: "string",
                },
                leftTitleLineHeight: {
                  label: "\u6807\u9898\u884c\u9ad8",
                  type: "string",
                },
                leftDescSize: {
                  label: "\u63cf\u8ff0\u5b57\u4f53\u5927\u5c0f",
                  type: "string",
                },
                leftDescLineHeight: {
                  label: "\u63cf\u8ff0\u884c\u9ad8",
                  type: "string",
                },
                leftBorderRedis: {
                  label: "\u89c6\u9891\u5706\u89d2",
                  type: "string",
                },
              },
            },
            btnStyle: {
              label: "\u6309\u94ae\u6837\u5f0f\u914d\u7f6e",
              props: {
                btnColor: {
                  label: "\u6309\u94ae\u4e3b\u9898\u8272",
                  type: "select",
                  items: [
                    {
                      label:
                        "\u4e00\u7ea7\u4e3b\u8981\u6309\u94ae\uff08\u84dd\u8272\uff09",
                      value: "primary",
                    },
                    {
                      label:
                        "\u4e00\u7ea7\u6df1\u8272\u6309\u94ae\uff08\u5b9e\u5fc3\u9ed1\u8272\uff09",
                      value: "dark",
                    },
                    {
                      label:
                        "\u4e00\u7ea7\u6d45\u8272\u6309\u94ae\uff08\u5b9e\u5fc3\u767d\u8272\uff09",
                      value: "light",
                    },
                    {
                      label:
                        "\u4e8c\u7ea7\u6df1\u8272\u6309\u94ae\uff08\u7a7a\u5fc3\u9ed1\u8272\uff09",
                      value: "secondary-dark",
                    },
                    {
                      label:
                        "\u4e8c\u7ea7\u6d45\u8272\u6309\u94ae\uff08\u7a7a\u5fc3\u767d\u8272\uff09",
                      value: "secondary-light",
                    },
                  ],
                },
                btnMinWidth: {
                  label:
                    "\u6700\u5c0f\u5bbd\u5ea6(\u9700\u201cpx\u201d), \u9ed8\u8ba4auto",
                  type: "string",
                },
                btnRadius: {
                  label: "\u6309\u94ae\u5706\u89d2",
                  type: "string",
                },
                btnSize: {
                  label: "\u6309\u94ae\u5c3a\u5bf8",
                  type: "select",
                  items: [
                    { value: "x-large", label: "xl(48)" },
                    { value: "large", label: "l(40)" },
                    { value: "medium", label: "m(32)" },
                    { value: "ProductPic", label: "s(24)" },
                  ],
                },
              },
            },
          },
        });
      t.a = Object(h.a)(N);
    },
    RfKB: function (e, t, n) {
      var o = n("2faE").f,
        a = n("B+OT"),
        r = n("UWiX")("toStringTag");
      e.exports = function (e, t, n) {
        e &&
          !a((e = n ? e : e.prototype), r) &&
          o(e, r, { configurable: !0, value: t });
      };
    },
    Rqdy: function (e, t, n) {
      var o = n("Y7ZC");
      o(o.S + o.F * !n("jmDH"), "Object", { defineProperty: n("2faE").f });
    },
    S3Uj: function (e, t, n) {
      "use strict";
      (t.__esModule = !0),
        (t.default =
          t.EXITING =
          t.ENTERED =
          t.ENTERING =
          t.EXITED =
          t.UNMOUNTED =
            void 0);
      var o = (function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e)
            for (var n in e)
              if (Object.prototype.hasOwnProperty.call(e, n)) {
                var o =
                  Object.defineProperty && Object.getOwnPropertyDescriptor
                    ? Object.getOwnPropertyDescriptor(e, n)
                    : {};
                o.get || o.set ? Object.defineProperty(t, n, o) : (t[n] = e[n]);
              }
          return (t.default = e), t;
        })(n("17x9")),
        a = l(n("q1tI")),
        r = l(n("i8i4")),
        i = n("VCL8");
      n("xfxO");
      function l(e) {
        return e && e.__esModule ? e : { default: e };
      }
      var s = "unmounted";
      t.UNMOUNTED = s;
      var c = "exited";
      t.EXITED = c;
      var _ = "entering";
      t.ENTERING = _;
      var u = "entered";
      t.ENTERED = u;
      t.EXITING = "exiting";
      var d = (function (e) {
        var t, n;
        function o(t, n) {
          var o;
          o = e.call(this, t, n) || this;
          var a,
            r = n.transitionGroup,
            i = r && !r.isMounting ? t.enter : t.appear;
          return (
            (o.appearStatus = null),
            t.in
              ? i
                ? ((a = c), (o.appearStatus = _))
                : (a = u)
              : (a = t.unmountOnExit || t.mountOnEnter ? s : c),
            (o.state = { status: a }),
            (o.nextCallback = null),
            o
          );
        }
        (n = e),
          ((t = o).prototype = Object.create(n.prototype)),
          (t.prototype.constructor = t),
          (t.__proto__ = n);
        var i = o.prototype;
        return (
          (i.getChildContext = function () {
            return { transitionGroup: null };
          }),
          (o.getDerivedStateFromProps = function (e, t) {
            return e.in && t.status === s ? { status: c } : null;
          }),
          (i.componentDidMount = function () {
            this.updateStatus(!0, this.appearStatus);
          }),
          (i.componentDidUpdate = function (e) {
            var t = null;
            if (e !== this.props) {
              var n = this.state.status;
              this.props.in
                ? n !== _ && n !== u && (t = _)
                : (n !== _ && n !== u) || (t = "exiting");
            }
            this.updateStatus(!1, t);
          }),
          (i.componentWillUnmount = function () {
            this.cancelNextCallback();
          }),
          (i.getTimeouts = function () {
            var e,
              t,
              n,
              o = this.props.timeout;
            return (
              (e = t = n = o),
              null != o &&
                "number" !== typeof o &&
                ((e = o.exit),
                (t = o.enter),
                (n = void 0 !== o.appear ? o.appear : t)),
              { exit: e, enter: t, appear: n }
            );
          }),
          (i.updateStatus = function (e, t) {
            if ((void 0 === e && (e = !1), null !== t)) {
              this.cancelNextCallback();
              var n = r.default.findDOMNode(this);
              t === _ ? this.performEnter(n, e) : this.performExit(n);
            } else
              this.props.unmountOnExit &&
                this.state.status === c &&
                this.setState({ status: s });
          }),
          (i.performEnter = function (e, t) {
            var n = this,
              o = this.props.enter,
              a = this.context.transitionGroup
                ? this.context.transitionGroup.isMounting
                : t,
              r = this.getTimeouts(),
              i = a ? r.appear : r.enter;
            t || o
              ? (this.props.onEnter(e, a),
                this.safeSetState({ status: _ }, function () {
                  n.props.onEntering(e, a),
                    n.onTransitionEnd(e, i, function () {
                      n.safeSetState({ status: u }, function () {
                        n.props.onEntered(e, a);
                      });
                    });
                }))
              : this.safeSetState({ status: u }, function () {
                  n.props.onEntered(e);
                });
          }),
          (i.performExit = function (e) {
            var t = this,
              n = this.props.exit,
              o = this.getTimeouts();
            n
              ? (this.props.onExit(e),
                this.safeSetState({ status: "exiting" }, function () {
                  t.props.onExiting(e),
                    t.onTransitionEnd(e, o.exit, function () {
                      t.safeSetState({ status: c }, function () {
                        t.props.onExited(e);
                      });
                    });
                }))
              : this.safeSetState({ status: c }, function () {
                  t.props.onExited(e);
                });
          }),
          (i.cancelNextCallback = function () {
            null !== this.nextCallback &&
              (this.nextCallback.cancel(), (this.nextCallback = null));
          }),
          (i.safeSetState = function (e, t) {
            (t = this.setNextCallback(t)), this.setState(e, t);
          }),
          (i.setNextCallback = function (e) {
            var t = this,
              n = !0;
            return (
              (this.nextCallback = function (o) {
                n && ((n = !1), (t.nextCallback = null), e(o));
              }),
              (this.nextCallback.cancel = function () {
                n = !1;
              }),
              this.nextCallback
            );
          }),
          (i.onTransitionEnd = function (e, t, n) {
            this.setNextCallback(n);
            var o = null == t && !this.props.addEndListener;
            e && !o
              ? (this.props.addEndListener &&
                  this.props.addEndListener(e, this.nextCallback),
                null != t && setTimeout(this.nextCallback, t))
              : setTimeout(this.nextCallback, 0);
          }),
          (i.render = function () {
            var e = this.state.status;
            if (e === s) return null;
            var t = this.props,
              n = t.children,
              o = (function (e, t) {
                if (null == e) return {};
                var n,
                  o,
                  a = {},
                  r = Object.keys(e);
                for (o = 0; o < r.length; o++)
                  (n = r[o]), t.indexOf(n) >= 0 || (a[n] = e[n]);
                return a;
              })(t, ["children"]);
            if (
              (delete o.in,
              delete o.mountOnEnter,
              delete o.unmountOnExit,
              delete o.appear,
              delete o.enter,
              delete o.exit,
              delete o.timeout,
              delete o.addEndListener,
              delete o.onEnter,
              delete o.onEntering,
              delete o.onEntered,
              delete o.onExit,
              delete o.onExiting,
              delete o.onExited,
              "function" === typeof n)
            )
              return n(e, o);
            var r = a.default.Children.only(n);
            return a.default.cloneElement(r, o);
          }),
          o
        );
      })(a.default.Component);
      function p() {}
      (d.contextTypes = { transitionGroup: o.object }),
        (d.childContextTypes = { transitionGroup: function () {} }),
        (d.propTypes = {}),
        (d.defaultProps = {
          in: !1,
          mountOnEnter: !1,
          unmountOnExit: !1,
          appear: !1,
          enter: !0,
          exit: !0,
          onEnter: p,
          onEntering: p,
          onEntered: p,
          onExit: p,
          onExiting: p,
          onExited: p,
        }),
        (d.UNMOUNTED = 0),
        (d.EXITED = 1),
        (d.ENTERING = 2),
        (d.ENTERED = 3),
        (d.EXITING = 4);
      var f = (0, i.polyfill)(d);
      t.default = f;
    },
    S5C5: function (e, t, n) {
      "use strict";
      n.d(t, "d", function () {
        return d;
      }),
        n.d(t, "e", function () {
          return p;
        }),
        n.d(t, "a", function () {
          return f;
        }),
        n.d(t, "l", function () {
          return h;
        }),
        n.d(t, "j", function () {
          return m;
        }),
        n.d(t, "i", function () {
          return y;
        }),
        n.d(t, "m", function () {
          return b;
        }),
        n.d(t, "k", function () {
          return v;
        }),
        n.d(t, "f", function () {
          return g;
        }),
        n.d(t, "b", function () {
          return w;
        }),
        n.d(t, "h", function () {
          return x;
        }),
        n.d(t, "c", function () {
          return k;
        }),
        n.d(t, "g", function () {
          return O;
        });
      var o = n("ODXe"),
        a = n("yWgo"),
        r = n("ZO6J"),
        i = "https://terminator.djiits.com",
        l = "https://dji-official-fe.djicdn.com",
        s = "true",
        c = "https://www1.djicdn.com",
        _ = JSON.parse(
          '{"official_api":{"test":{"host":"//test-www-api.dbeta.me"},"dev":{"host":"//test-www-api.dbeta.me"},"stag":{"host":"//test-www-api.dbeta.me"},"production":{"host":"//www-api.dji.com"},"master":{"host":"//www-api.dji.com"},"host":"//www-api.dji.com"},"official":{"host":"https://www.dji.com"},"product_center":{"dev":{"host":"https://product.dbeta.me"},"test":{"host":"https://product.dbeta.me"},"stag":{"host":"https://r-product.dbeta.me"},"prod":{"host":"https://product.dji.com"},"host":"https://product.dji.com"},"store-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"store-pc":{"dev":{"host":"store.dbeta.me"},"test":{"host":"store.dbeta.me"},"stag":{"host":"r-store.dbeta.me"},"prod":{"host":"store.dji.com"},"host":"store.dji.com"},"account-mobile":{"dev":{"host":"m.dbeta.me"},"test":{"host":"m.dbeta.me"},"stag":{"host":"r-m.dbeta.me"},"prod":{"host":"m.dji.com"},"host":"m.dji.com"},"account-pc":{"dev":{"host":"accounts.dbeta.me"},"test":{"host":"accounts.dbeta.me"},"stag":{"host":"r-accounts.dbeta.me"},"prod":{"host":"accounts.dji.com"},"host":"accounts.dji.com"},"repair":{"dev":{"host":"repair.dbeta.me"},"test":{"host":"repair.dbeta.me"},"stag":{"host":"support.dji.com"},"prod":{"host":"support.dji.com"},"host":"support.dji.com"},"stormsend":{"dev":{"host":"https://stormsend.dbeta.me"},"test":{"host":"https://stormsend.dbeta.me","host_bak":"https://stormsend.dbeta.me"},"stag":{"host":"https://stag-stormsend-api.dbeta.me"},"prod":{"host":"https://stormsend-api.djiits.com"},"host":"https://stormsend-api.djiits.com"}}',
        ),
        u = !1;
      if (!i) throw new Error("apiHost undefined!");
      function d(e, t, n, o) {
        return -1 !== r.a.indexOf(t)
          ? n(
              "nav" === o
                ? "v4.common.button.wheretobuy_text.nav"
                : "v4.common.button.wheretobuy_text",
            )
          : e;
      }
      function p(e, t, n) {
        return -1 !== r.a.indexOf(n) ? e : t;
      }
      function f(e) {
        return "".concat(i).concat(e);
      }
      function h(e) {
        var t = ""
          .concat(window.location.protocol, "//")
          .concat(window.location.host);
        return "".concat(t).concat(e);
      }
      function m(e) {
        return u
          ? /^(https?:)?\/\/(store|m|stag-store|r-store|stag-m|test-store|test-m)\.((dbeta\.me)|(dji\.com))/.test(
              e,
            )
          : /^(https?:)?\/\/(store|m)\.(dji\.com)/.test(e);
      }
      function y(e) {
        arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (((e = e.trim()), /^(https?:)?\/\//.test(e)))
          return e.replace(/^https?:/, "");
        var t =
          "https://www.dji.com" +
          (/some_hard_condition/.test(e) ? "" : "/") +
          e;
        return (
          /\b\/\/+/.test(t) && (t = t.replace(/\b\/\/+/g, "/")),
          "/" !== t && /\/$/g.test(t) && (t = t.substring(0, t.length - 1)),
          t
        );
      }
      function b(e) {
        if (/(s3\.amazonaws|djicdn\.com)/gi.test(e)) return e;
        var t = c || "";
        return s && l && (t = l), "".concat(t, "/").concat(e);
      }
      function v(e) {
        var t = e.domain,
          n = e.url,
          o = e.country,
          i = void 0 === o ? "" : o,
          l = e.locale,
          s = void 0 === l ? "" : l,
          c = e.mobileMode,
          u = void 0 !== c && c,
          d = "",
          p = n,
          f = u ? "/mobile" : "";
        if (!!/^(https?:)?\/\//.test(n)) return n;
        t &&
          (d = (function (e) {
            var t = e.domain,
              n = e.mobileMode;
            "store" === t && n && (t = "m");
            var o = _.official;
            return ((o.production && o.production.host) || o.host).replace(
              /w{3,}/,
              t,
            );
          })(e));
        var h = "";
        /^[A-Za-z]/.test(p) && (p = "/".concat(p)),
          "store" === t
            ? ((h = a.db.getLangUrlPrefix(s)),
              (f = ""),
              "ru" === s && "/shopping-flow" === p
                ? ((d = ""), (p = h + p.replace("/ru", "")))
                : "it" === s && "it" === i.toLowerCase()
                  ? (h = "")
                  : -1 !== r.a.indexOf(i) &&
                    ((d = ""),
                    (h = a.db.getCountryUrlPrefix({ country: i, locale: s })),
                    (f = u ? "/mobile" : ""),
                    (p = "/where-to-buy")))
            : (h = t
                ? a.db.getLangUrlPrefix(s)
                : a.db.getCountryUrlPrefix({ country: i, locale: s }));
        var m = "".concat(d).concat(h).concat(f).concat(p);
        return (
          "/" !== m && /\/$/g.test(m) && (m = m.substring(0, m.length - 1)), m
        );
      }
      function g(e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "image",
          n = {};
        if (!e || /\.svg$/.test(e))
          return "bg" === t ? "url(".concat(e, ")") : ((n.src = e), n);
        var a = /(http|https):\/\/([^/]+)\/(.+)\/(.+)\.(.+)$/.exec(e),
          r = Object(o.a)(a, 6),
          i = r[1],
          l = r[2],
          s = r[3],
          c = r[4],
          _ = r[5],
          u = ""
            .concat(i, "://")
            .concat(l, "/")
            .concat(s, "/")
            .concat(c, "@1x.")
            .concat(_);
        return "bg" === t
          ? "\n    background-image: url("
              .concat(u, "); \n    background-image:-webkit-image-set( url(")
              .concat(u, ") 1x, url(")
              .concat(e, ") 2x); \n    background-image: image-set( url(")
              .concat(u, ") 1x, url(")
              .concat(e, ") 2x)")
          : ((n.src = u),
            (n.srcSet = "".concat(u, " 1x, ").concat(e, " 2x")),
            n);
      }
      function w(e) {
        if (!e) return !1;
        if (
          !(
            !e.match(/^http/gi) &&
            !e.match(/www/gi) &&
            !e.match(/\.com/gi) &&
            !e.match(/^\/\//)
          )
        ) {
          var t = new URL(e).host,
            n = new RegExp(t, "gi"),
            o = new RegExp(window.location.host, "gi");
          if (!(n.test(e) && o.test(e))) return !0;
        }
        return !1;
      }
      function x(e) {
        return w(e) ? "_blank" : "_self";
      }
      function k(e, t) {
        var n = (e = (e = e.replace(/\/$/, "")).replace(
          /(&|\?)?from=buy_now/g,
          "",
        )).split("#")[1];
        return (
          (e = e.split("#")[0]).indexOf("?") > -1 ? (e += "&") : (e += "?"),
          (e += "site=brandsite").indexOf("from=") < 0 &&
            t &&
            (e = "".concat(e, "&from=").concat(t)),
          n && (e = "".concat(e, "#").concat(n)),
          e
        );
      }
      function O(e) {
        var t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = /(.+)(\..+)$/,
          a = "";
        if (
          e &&
          "" !== e &&
          n.exec(e) &&
          n.exec(e).length &&
          3 === n.exec(e).length
        ) {
          var r = n.exec(e),
            i = Object(o.a)(r, 3),
            l = i[1],
            s = i[2];
          a = "".concat(l).concat(t).concat(s);
        }
        return a;
      }
    },
    S8lS: function (e, t, n) {
      e.exports = {
        "nav-bar": "style__nav-bar___2jDiV",
        "navbar-searching": "style__navbar-searching___3sXIA",
        "nav-brand": "style__nav-brand___2GZL5",
        "hover-logo": "style__hover-logo___Kfmu6",
        logo: "style__logo___1rTym",
        "subdomain-placeholder": "style__subdomain-placeholder___CNF1B",
        "dji-subdomain": "style__dji-subdomain___19h9Q",
        "navbar-left": "style__navbar-left___21csv",
        "dropdown-menu": "style__dropdown-menu___3bKmE",
        single: "style__single____ROH8",
        "subitem-a": "style__subitem-a___3qBvJ",
        "category-item": "style__category-item___1cjD0",
        "category-item-link": "style__category-item-link___1OlOz",
        "category-item-unclickable": "style__category-item-unclickable___4elUm",
        "columns-menu": "style__columns-menu___2JYv6",
        center: "style__center___3Af-M",
        "navbar-right": "style__navbar-right___2zo17",
        columns: "style__columns___IVMej",
        "with-pic": "style__with-pic___3cW58",
        "without-pic": "style__without-pic___301Zf",
        "column-right": "style__column-right___1rVP-",
        "product-list": "style__product-list___t0q6I",
        "product-link": "style__product-link___2AaY9",
        title: "style__title___2yXSb",
        desc: "style__desc___m43p-",
        "navbar-contact": "style__navbar-contact___2_Psy",
        "contact-btn": "style__contact-btn___-4dGT",
        "contact-btn-text": "style__contact-btn-text___IUF2M",
        "store-btn": "style__store-btn___1iBNH",
        "contact-btn-new": "style__contact-btn-new___1IGWY",
        "dji-subdomain-cn": "style__dji-subdomain-cn___2rJvi",
        "dji-enterprise": "style__dji-enterprise___25kSn",
        "bottom-menu": "style__bottom-menu___2S2du",
        cell: "style__cell___3mOKW",
        "subitem-ul": "style__subitem-ul___1OMfg",
        "full-screen": "style__full-screen___2S2Cs",
        "columns-dropdown": "style__columns-dropdown___CSU-M",
        "column-item": "style__column-item___BC4Em",
        "home-navbar": "style__home-navbar___2_0O9",
        "navbar-main": "style__navbar-main___3RWcj",
        "user-icon": "style__user-icon___vEILH",
        "user-icon-hover": "style__user-icon-hover___3W2RW",
        "search-icon": "style__search-icon___3C9vR",
        "search-icon-hover": "style__search-icon-hover___3NGSM",
        "common-navbar": "style__common-navbar___83P30",
        "nav-container": "style__nav-container___1LprZ",
        "navbar-header": "style__navbar-header___1GWWc",
        "navbar-category": "style__navbar-category___26cPV",
        "nav-store": "style__nav-store___1aMzR",
        "nav-user": "style__nav-user___252k4",
        "nav-account": "style__nav-account___1JCxy",
        "user-name": "style__user-name___2an5C",
        "nav-drop-active": "style__nav-drop-active___VBQYy",
        active: "style__active___3GdgW",
        "header-search": "style__header-search___2hIE6",
        show: "style__show___x5Z51",
        "search-box": "style__search-box___a_UJ0",
        "search-tips": "style__search-tips___29yx4",
        "search-box-cover": "style__search-box-cover___3GgCo",
        "search-form": "style__search-form___1RrLb",
        "search-btn": "style__search-btn___2ab3B",
        silde_to_left: "style__silde_to_left___kQDhC",
        "search-input": "style__search-input___39Gow",
        "close-btn": "style__close-btn___dFgkX",
        "search-list": "style__search-list___2rFF4",
        hidden: "style__hidden___3oW3d",
        "quick-link": "style__quick-link___WGlJE",
        relative: "style__relative___3ENam",
        "subitem-li": "style__subitem-li___1N90c",
        "right-icon": "style__right-icon___2W5mI",
        "subitem-div": "style__subitem-div___2CTWv",
        "menu-container": "style__menu-container___2Kghk",
        "compare-pill": "style__compare-pill____GqLH",
        "top-menu": "style__top-menu___dpzy_",
        "top-menu-wrapper": "style__top-menu-wrapper___rs49l",
        pill: "style__pill___VaMMq",
        "site-icon": "style__site-icon___O4rOJ",
        "enter-site": "style__enter-site___2OEY7",
        "horizontal-divider": "style__horizontal-divider___1Lc7K",
        lite: "style__lite___3FPPy",
        last: "style__last___e3LiG",
        "column-left": "style__column-left___EE1fv",
        "product-cover": "style__product-cover___1Pwns",
        "nav-item": "style__nav-item___MmuJ6",
        "nav-item-link": "style__nav-item-link___3lD4V",
        "cart-container": "style__cart-container___32k3P",
        cart: "style__cart___gvLQw",
        "product-item": "style__product-item___1NcAt",
        "product-wrap": "style__product-wrap___3sAOw",
        text: "style__text___1nFAw",
        photo: "style__photo___23IWy",
        name: "style__name___3NL2r",
        quantity: "style__quantity___1Smz4",
        "left-tips": "style__left-tips___3Pu6S",
        checkout: "style__checkout___1s6Ve",
        "checkout-btn": "style__checkout-btn___1w6Lw",
        "bottom-horizontal-divider": "style__bottom-horizontal-divider___3SxUZ",
        "nav-header-wrapper": "style__nav-header-wrapper___29QHC",
        "nav-header": "style__nav-header___2t2MJ",
        "nav-menu-wrapper": "style__nav-menu-wrapper___2rTvL",
        "explore-menu": "style__explore-menu___2TN65",
        "disable-pointer-events": "style__disable-pointer-events___2CCyV",
        "dji-menu-list": "style__dji-menu-list___2uS42",
        "show-up": "style__show-up___114aV",
        "dji-menu-link": "style__dji-menu-link___35kQc",
        "nav-menu": "style__nav-menu___1BBsm",
        "img-box": "style__img-box___3jsax",
        "close-menu": "style__close-menu___zmc1z",
        "dji-tab-container": "style__dji-tab-container___vgjah",
        "enterprise-tab": "style__enterprise-tab___1L4OP",
        "dji-tab": "style__dji-tab___1qtC7",
        "dji-tab-list": "style__dji-tab-list___x9wLY",
        "dji-tab-item": "style__dji-tab-item___fOEhk",
        "dji-tab-link": "style__dji-tab-link___Q4vTh",
        container: "style__container___2i1Jx",
        commercial: "style__commercial___3ikuU",
        row: "style__row___2KaA8",
        support: "style__support___b7dyF",
        "series-list": "style__series-list___1USBX",
        "series-list-divider": "style__series-list-divider___3DMUW",
        hide: "style__hide___2CmXA",
        "link-list": "style__link-list___14-fM",
        "content-wrapper": "style__content-wrapper___-m5VK",
        "dji-link": "style__dji-link___1tHR3",
        suffix: "style__suffix___xpNfl",
        "vertical-divider": "style__vertical-divider___1_815",
        "serieslist-row": "style__serieslist-row___2Tyjw",
        "row-top": "style__row-top___3cvKK",
        "row-bot": "style__row-bot___13e6r",
        "col-3": "style__col-3___1M822",
        "series-list-item": "style__series-list-item___1koeo",
        "series-name": "style__series-name___3drhG",
        solutions: "style__solutions___2qspo",
        "solution-list": "style__solution-list___1v-QU",
        "solution-list-item": "style__solution-list-item___zOVfu",
        intro: "style__intro___ZDfTM",
        "no-cursor": "style__no-cursor___3hNlv",
        "col-xs-12": "style__col-xs-12___2owFL",
        "dji-divider": "style__dji-divider___2y_vT",
        "series-name-link": "style__series-name-link___1uQ5t",
        "series-intro": "style__series-intro___dajmK",
        "product-list-wrapper": "style__product-list-wrapper___34oY1",
        "series-cover": "style__series-cover___2ZeaB",
        "product-item-cover": "style__product-item-cover___2HUX4",
        "img-has-second": "style__img-has-second___3xJNh",
        second: "style__second___AiIGM",
        first: "style__first___c4V4q",
        "img-product-name": "style__img-product-name___2-rg5",
        "product-list-item": "style__product-list-item___nqjqQ",
        "product-name": "style__product-name___saKN6",
        new: "style__new___qCOp3",
        "dji-btn": "style__dji-btn___lIxI4",
        external: "style__external___1IWdZ",
        "btn-wrapper": "style__btn-wrapper___1dTaB",
        "close-menu-wrapper": "style__close-menu-wrapper___1HklX",
        "icon-close": "style__icon-close___MXGAM",
        "shopping-bag": "style__shopping-bag___NTAk_",
      };
    },
    SBOM: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("Ff2n"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("rePB");
      function d(e) {
        return e
          ? !/\burl\s*\(/i.test(e) && /^\s*(\.|(\/)|http)/.test(e)
            ? 'url("'.concat(e, '")')
            : e
          : e;
      }
      var p = n("/+VL"),
        f = n("q1tI"),
        h = n.n(f),
        m = h.a.createElement;
      function y(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function b(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var v = (function (e) {
        function t() {
          var e;
          Object(r.default)(this, t);
          for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++)
            o[a] = arguments[a];
          return (
            (e = b(this, t, [].concat(o))),
            Object(u.a)(Object(c.a)(e), "placeholderElm", void 0),
            e
          );
        }
        return (
          Object(_.a)(t, e),
          Object(i.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this;
                this.placeholderElm &&
                  p.a.getInstance().addNode(
                    this.placeholderElm,
                    {
                      scrollIntoView: function () {
                        e.props.onVisible();
                      },
                    },
                    void 0,
                    1e3,
                  );
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                p.a.getInstance().removeNode(this.placeholderElm);
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.className,
                  o = t.height,
                  a = t.placeholder,
                  r = t.style,
                  i = t.width,
                  l = (function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n = null != arguments[t] ? arguments[t] : {};
                      t % 2
                        ? y(Object(n), !0).forEach(function (t) {
                            Object(u.a)(e, t, n[t]);
                          })
                        : Object.getOwnPropertyDescriptors
                          ? Object.defineProperties(
                              e,
                              Object.getOwnPropertyDescriptors(n),
                            )
                          : y(Object(n)).forEach(function (t) {
                              Object.defineProperty(
                                e,
                                t,
                                Object.getOwnPropertyDescriptor(n, t),
                              );
                            });
                    }
                    return e;
                  })(
                    {
                      display: "block",
                      width: "1px",
                      height: "1px",
                      opacity: 0,
                    },
                    r,
                  );
                return (
                  "undefined" !== typeof i && (l.width = i),
                  "undefined" !== typeof o && (l.height = o),
                  m(
                    "span",
                    {
                      className: n,
                      ref: function (t) {
                        e.placeholderElm = t;
                      },
                      style: l,
                    },
                    a,
                  )
                );
              },
            },
          ]),
          t
        );
      })(h.a.Component);
      v.defaultProps = { className: "", placeholder: null, style: {} };
      var g = v,
        w = h.a.createElement;
      function x(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var k = (function (e) {
        function t(e) {
          var n;
          Object(r.default)(this, t), (n = x(this, t, [e]));
          var o = e.afterLoad,
            a = e.beforeLoad,
            i = e.visibleByDefault;
          return (
            (n.state = { visible: i }),
            i && (a(), o()),
            (n.onVisible = n.onVisible.bind(Object(c.a)(n))),
            n
          );
        }
        return (
          Object(_.a)(t, e),
          Object(i.default)(t, [
            {
              key: "componentDidUpdate",
              value: function (e, t) {
                t.visible !== this.state.visible && this.props.afterLoad();
              },
            },
            {
              key: "onVisible",
              value: function () {
                this.props.beforeLoad(), this.setState({ visible: !0 });
              },
            },
            {
              key: "render",
              value: function () {
                if (this.state.visible) return this.props.children;
                var e = this.props,
                  t = e.className,
                  n = e.height,
                  o = e.placeholder,
                  a = e.style,
                  r = e.threshold,
                  i = e.width;
                return w(g, {
                  className: t,
                  height: n,
                  onVisible: this.onVisible,
                  placeholder: o,
                  style: a,
                  threshold: r,
                  width: i,
                });
              },
            },
          ]),
          t
        );
      })(h.a.Component);
      k.defaultProps = {
        afterLoad: function () {
          return {};
        },
        beforeLoad: function () {
          return {};
        },
        visibleByDefault: !1,
        threshold: 100,
        className: "",
        placeholder: null,
        style: {},
        height: void 0,
        width: void 0,
      };
      var O = k,
        I = n("yWgo"),
        S = (n("pzan"), n("gn4A")),
        j = n.n(S),
        T = [
          "afterLoad",
          "beforeLoad",
          "delayMethod",
          "delayTime",
          "effect",
          "placeholder",
          "placeholderSrc",
          "threshold",
          "visibleByDefault",
          "wrapperClassName",
          "wrapperProps",
          "style",
        ],
        C = h.a.createElement;
      function M(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function P(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? M(Object(n), !0).forEach(function (t) {
                Object(u.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : M(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function E(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var L = (function (e) {
          function t(e) {
            var n;
            return (
              Object(r.default)(this, t),
              ((n = E(this, t, [e])).state = { loaded: !1, error: !1 }),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "onImageLoad",
                value: function () {
                  if (this.state.loaded) return null;
                  this.props.afterLoad(), this.setState({ loaded: !0 });
                },
              },
              {
                key: "onImageError",
                value: function () {
                  this.setState({ error: !0 });
                },
              },
              {
                key: "getImg",
                value: function () {
                  var e = this.props,
                    t =
                      (e.afterLoad,
                      e.beforeLoad,
                      e.delayMethod,
                      e.delayTime,
                      e.effect,
                      e.placeholder,
                      e.placeholderSrc,
                      e.threshold,
                      e.visibleByDefault,
                      e.wrapperClassName,
                      e.wrapperProps,
                      e.style),
                    n = Object(a.a)(e, T);
                  if (this.state.error)
                    return C(
                      "img",
                      Object(o.a)(
                        { alt: "", decoding: "async", loading: "lazy" },
                        n,
                        { style: { opacity: 0 } },
                      ),
                    );
                  var r = P(
                    {
                      minHeight:
                        Object(I.p)() || Object(I.s)() || j.a.isHuaweiBrowser()
                          ? "4px"
                          : "auto",
                    },
                    t,
                  );
                  return C(
                    "img",
                    Object(o.a)(
                      {
                        alt: "",
                        decoding: "async",
                        loading: "lazy",
                        onLoad: this.onImageLoad.bind(this),
                        onError: this.onImageError.bind(this),
                      },
                      n,
                      { style: P({}, r) },
                    ),
                  );
                },
              },
              {
                key: "getLazyLoadImage",
                value: function () {
                  return C(h.a.Fragment, null, this.getImg());
                },
              },
              {
                key: "getWrappedLazyLoadImage",
                value: function (e) {
                  var t = this.props,
                    n = t.effect,
                    a = t.height,
                    r = t.placeholderSrc,
                    i = t.width,
                    l = t.wrapperClassName,
                    s = t.wrapperProps,
                    c = this.state.loaded,
                    _ = c ? " lazy-load-image-loaded" : "",
                    u =
                      c || !r
                        ? {}
                        : {
                            backgroundImage: "url(".concat(r, ")"),
                            backgroundSize: "100% 100%",
                          };
                  return C(
                    "span",
                    Object(o.a)(
                      {
                        className: ""
                          .concat(l, " lazy-load-image-background ")
                          .concat(n)
                          .concat(_),
                        style: P(
                          P({}, u),
                          {},
                          {
                            color: "transparent",
                            display: "inline-block",
                            height: a,
                            width: i,
                          },
                        ),
                      },
                      s,
                    ),
                    e,
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.effect,
                    n = e.placeholderSrc,
                    o = e.visibleByDefault,
                    a = e.wrapperClassName,
                    r = e.wrapperProps,
                    i = this.getLazyLoadImage();
                  return ((t || n) && !o) || a || r
                    ? this.getWrappedLazyLoadImage(i)
                    : i;
                },
              },
            ]),
            t
          );
        })(h.a.Component),
        B = {
          afterLoad: function () {
            return {};
          },
          beforeLoad: function () {
            return {};
          },
          placeholder: null,
          threshold: 100,
          className: "",
          wrapperClassName: "",
          style: {},
          height: void 0,
          width: void 0,
        };
      L.defaultProps = B;
      var N = L,
        D = [
          "children",
          "type",
          "src",
          "tagType",
          "visibleByDefault",
          "forwardRef",
        ],
        z = f.createElement;
      function A(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function R(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? A(Object(n), !0).forEach(function (t) {
                Object(u.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : A(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function F(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var V = { threshold: 2e3 },
        H = (function (e) {
          function t(e) {
            var n;
            return (
              Object(r.default)(this, t),
              (n = F(this, t, [e])),
              Object(u.a)(Object(c.a)(n), "targetDom", void 0),
              Object(u.a)(Object(c.a)(n), "animationFrame", void 0),
              Object(u.a)(Object(c.a)(n), "listenersToRemove", void 0),
              Object(u.a)(Object(c.a)(n), "loop", !1),
              (n.state = {}),
              (n.listenersToRemove = []),
              (n.setBackgroundImageAfterLoad =
                n.setBackgroundImageAfterLoad.bind(Object(c.a)(n))),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this.props,
                    t = e.parallax;
                  e.visibleByDefault && t && this.parallaxScroll();
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  this.animationFrame &&
                    window &&
                    window.cancelAnimationFrame(this.animationFrame),
                    this.listenersToRemove.forEach(function (e) {
                      "function" === typeof e && e();
                    });
                },
              },
              {
                key: "setBackgroundImageAfterLoad",
                value: function () {
                  var e = this.props,
                    t = e.src,
                    n = e.parallax;
                  if (t) {
                    var o = d(t);
                    this.setState({ backgroundImage: o }),
                      n && this.parallaxScroll();
                  }
                },
              },
              {
                key: "parallaxScroll",
                value: function () {
                  var e = 0.1,
                    t = 0,
                    n = 0,
                    o = this.targetDom,
                    a = this;
                  if (o) {
                    var r = this.computeBgSize().backgroundSize,
                      i = this.computeBgSize().backgroundOffset;
                    l(),
                      window.addEventListener("resize", l),
                      a.listenersToRemove.push(function () {
                        window.removeEventListener("resize", l);
                      }),
                      p.a.getInstance().addNode(this.targetDom, {
                        scrollIntoView: function () {
                          (a.loop = !0), s();
                        },
                        scrollOutOfWiew: function () {
                          a.loop = !1;
                        },
                      });
                  }
                  function l() {
                    (r = a.computeBgSize().backgroundSize),
                      (i =
                        a.computeBgSize().backgroundOffset >= 200
                          ? 200
                          : a.computeBgSize().backgroundOffset);
                  }
                  function s() {
                    if (a.loop) {
                      var l = p.a.getInstance().getDimension(),
                        c = l.pageOffsetY,
                        _ = l.innerHeight;
                      if (o) {
                        for (var u = o, d = o.offsetTop; u.offsetParent; )
                          d += (u = u.offsetParent).offsetTop;
                        var f = o.offsetHeight;
                        if (c >= d - _ && c <= d + f) {
                          var h = (t += ((d - _ - c) / (_ + f) - t) * e) * i;
                          if (Math.abs(n - h) >= 0.5) {
                            n = h;
                            var m = "".concat(h, "px");
                            o.style["background-position-y"] = m;
                          }
                          (o.style["background-size"] = r),
                            (o.style["background-position-x"] = "center");
                        }
                        a.animationFrame = requestAnimationFrame(s);
                      }
                    } else window.cancelAnimationFrame(a.animationFrame);
                  }
                },
              },
              {
                key: "computeBgSize",
                value: function () {
                  var e = this.targetDom,
                    t = "auto calc(100% + 200px)",
                    n = 200;
                  if (!e) return {};
                  var o = this.props,
                    a = o.bgWidth,
                    r = o.bgHeight;
                  if ((!a && !r) || ("" === a && "" === r))
                    return { backgroundSize: t, backgroundOffset: n };
                  var i = parseInt(a, 10) / parseInt(r, 10),
                    l = e.clientWidth,
                    s = e.clientHeight;
                  if (i > l / s) {
                    (t = "calc(100% + ".concat(s * i - l, "px) 100%")), (n = 0);
                  } else {
                    var c = l / i - s;
                    (t = "100% calc(100% + ".concat(c, "px)")), (n = c);
                  }
                  return { backgroundSize: t, backgroundOffset: n };
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.children,
                    r = t.type,
                    i = t.src,
                    l = t.tagType,
                    s = void 0 === l ? "div" : l,
                    c = t.visibleByDefault,
                    _ = (t.forwardRef, Object(a.a)(t, D));
                  if ("img" === r) {
                    var u = this.props.placeholder,
                      p =
                        void 0 === u
                          ? z("i", {
                              style: {
                                color: "transparent",
                                display: "inline-block",
                                minWidth: "1px",
                              },
                            })
                          : u,
                      h = R(R({}, V), _);
                    return z(
                      N,
                      Object(o.a)({ visibleByDefault: c }, h, {
                        placeholder: p,
                        src: i,
                      }),
                    );
                  }
                  if ("bg" === r) {
                    var m = _.style,
                      y = void 0 === m ? {} : m,
                      b = this.state.backgroundImage,
                      v = z(
                        O,
                        {
                          afterLoad: this.setBackgroundImageAfterLoad,
                          threshold: _.threshold || V.threshold,
                        },
                        z("span", { style: { display: "none" } }),
                      );
                    return c
                      ? f.createElement(
                          s,
                          R(
                            R({}, _),
                            {},
                            {
                              ref: function (t) {
                                e.targetDom = t;
                              },
                              style: R(R({}, y), {}, { backgroundImage: d(i) }),
                            },
                          ),
                          n,
                        )
                      : f.createElement(
                          s,
                          R(
                            R({}, _),
                            {},
                            {
                              ref: function (t) {
                                e.targetDom = t;
                              },
                              style: R(R({}, y), {}, { backgroundImage: b }),
                            },
                          ),
                          v,
                          n,
                        );
                  }
                  return z(O, Object(o.a)({ visibleByDefault: c }, _), n);
                },
              },
            ]),
            t
          );
        })(f.Component);
      Object(u.a)(H, "defaultProps", void 0),
        (H.defaultProps = {
          tagType: "div",
          style: {},
          type: "component",
          parallax: !1,
        });
      t.a = H;
    },
    SBuE: function (e, t) {
      e.exports = {};
    },
    SEkw: function (e, t, n) {
      e.exports = { default: n("RU/L"), __esModule: !0 };
    },
    SGsF: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t, "string") && !e.required) return n();
          r.default.required(e, t, o, l, a),
            (0, i.isEmptyValue)(t, "string") ||
              r.default.pattern(e, t, o, l, a);
        }
        n(l);
      };
    },
    SfRM: function (e, t, n) {
      var o = n("YESw");
      e.exports = function () {
        (this.__data__ = o ? o(null) : {}), (this.size = 0);
      };
    },
    Sggk: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return w;
      }),
        n.d(t, "b", function () {
          return E;
        });
      var o = n("rePB"),
        a = n("Ff2n"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("Ji7U"),
        _ = n("q1tI"),
        u = n.n(_),
        d = n("WCLa"),
        p = n("VJv2"),
        f = n("/+VL"),
        h = (function (e, t) {
          var n = function () {
            r.log(
              2,
              "(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use 'new ScrollMagic.Controller()' to create a new controller instance. Use 'new ScrollMagic.Scene()' to instance a scene.",
            );
          };
          n.version = "2.0.7";
          n.Controller = function (a) {
            var i,
              l = "ScrollMagic.Controller",
              s = o.defaults,
              c = this,
              _ = r.extend({}, s, a),
              u = [],
              d = !1,
              h = 0,
              m = "PAUSED",
              y = !0,
              b = 0,
              v = !0,
              g = function () {
                return _.vertical
                  ? r.get.scrollTop(_.container)
                  : r.get.scrollLeft(_.container);
              },
              w = function () {
                return _.vertical
                  ? r.get.height(_.container)
                  : r.get.width(_.container);
              },
              x = (this._setScrollPos = function (t) {
                _.vertical
                  ? y
                    ? e.scrollTo(r.get.scrollLeft(), t)
                    : (_.container.scrollTop = t)
                  : y
                    ? e.scrollTo(t, r.get.scrollTop())
                    : (_.container.scrollLeft = t);
              }),
              k = function () {
                if (v && d) {
                  var e = (r.type.Array(d) ? d : u.slice(0)).filter(
                    function (e) {
                      return !e.outOfView;
                    },
                  );
                  if (((d = !1), 0 === e.length)) return;
                  var t = h,
                    n = (h = c.scrollPos()) - t;
                  0 !== n && (m = n > 0 ? "FORWARD" : "REVERSE"),
                    "REVERSE" === m && e.reverse(),
                    e.forEach(function (t, n) {
                      j(
                        3,
                        "updating Scene " +
                          (n + 1) +
                          "/" +
                          e.length +
                          " (" +
                          u.length +
                          " total)",
                      ),
                        t.update(!0);
                    }),
                    0 === e.length &&
                      _.loglevel >= 3 &&
                      j(3, "updating 0 Scenes (nothing added to controller)");
                }
              },
              O = function () {
                k();
              },
              I = function (e) {
                j(3, "event fired causing an update:", e.type),
                  "resize" == e.type && ((b = w()), (m = "PAUSED")),
                  !0 !== d && ((d = !0), O());
              },
              S = function () {
                if (!y && b != w()) {
                  var e;
                  try {
                    e = new Event("resize", { bubbles: !1, cancelable: !1 });
                  } catch (o) {
                    (e = t.createEvent("Event")).initEvent("resize", !1, !1);
                  }
                  _.container.dispatchEvent(e);
                }
                var n = p.a.getInstance().allTaskFinished();
                u.forEach(function (e) {
                  (e.outOfView && n) || e.refresh();
                });
              };
            this.refresh = S;
            var j = (this._log = function (t, n) {
              _.loglevel >= t &&
                (Array.prototype.splice.call(arguments, 1, 0, "(" + l + ") ->"),
                r.log.apply(e, arguments));
            });
            this._options = _;
            var T = function (e) {
              if (e.length <= 1) return e;
              var t = e.slice(0);
              return (
                t.sort(function (e, t) {
                  return e.scrollOffset() > t.scrollOffset() ? 1 : -1;
                }),
                t
              );
            };
            return (
              (this.addScene = function (e) {
                if (r.type.Array(e))
                  e.forEach(function (e, t) {
                    c.addScene(e);
                  });
                else if (e instanceof n.Scene) {
                  if (e.controller() !== c) e.addTo(c);
                  else if (u.indexOf(e) < 0) {
                    for (var t in (u.push(e),
                    (u = T(u)),
                    e.on("shift.controller_sort", function () {
                      u = T(u);
                    }),
                    _.globalSceneOptions))
                      e[t] && e[t].call(e, _.globalSceneOptions[t]);
                    j(3, "adding Scene (now " + u.length + " total)");
                  }
                } else
                  j(1, "ERROR: invalid argument supplied for '.addScene()'");
                return c;
              }),
              (this.removeScene = function (e) {
                if (r.type.Array(e))
                  e.forEach(function (e, t) {
                    c.removeScene(e);
                  });
                else {
                  var t = u.indexOf(e);
                  t > -1 &&
                    (e.off("shift.controller_sort"),
                    u.splice(t, 1),
                    j(3, "removing Scene (now " + u.length + " left)"),
                    e.remove());
                }
                return c;
              }),
              (this.updateScene = function (e, t) {
                return (
                  r.type.Array(e)
                    ? e.forEach(function (e, n) {
                        c.updateScene(e, t);
                      })
                    : t
                      ? e.update(!0)
                      : !0 !== d &&
                        e instanceof n.Scene &&
                        (-1 == (d = d || []).indexOf(e) && d.push(e),
                        (d = T(d)),
                        O()),
                  c
                );
              }),
              (this.update = function (e) {
                return I({ type: "resize" }), e && k(), c;
              }),
              (this.scrollTo = function (e, t) {
                if (r.type.Number(e)) x.call(_.container, e, t);
                else if (e instanceof n.Scene)
                  e.controller() === c
                    ? c.scrollTo(e.scrollOffset(), t)
                    : j(
                        2,
                        "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.",
                        e,
                      );
                else if (r.type.Function(e)) x = e;
                else {
                  var o = r.get.elements(e)[0];
                  if (o) {
                    for (
                      ;
                      o.parentNode.hasAttribute("data-scrollmagic-pin-spacer");

                    )
                      o = o.parentNode;
                    var a = _.vertical ? "top" : "left",
                      i = r.get.offset(_.container),
                      l = r.get.offset(o);
                    y || (i[a] -= c.scrollPos()), c.scrollTo(l[a] - i[a], t);
                  } else
                    j(
                      2,
                      "scrollTo(): The supplied argument is invalid. Scroll cancelled.",
                      e,
                    );
                }
                return c;
              }),
              (this.scrollPos = function (e) {
                return arguments.length
                  ? (r.type.Function(e)
                      ? (g = e)
                      : j(
                          2,
                          "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'.",
                        ),
                    c)
                  : g.call(c);
              }),
              (this.info = function (e) {
                var t = {
                  size: b,
                  vertical: _.vertical,
                  scrollPos: h,
                  scrollDirection: m,
                  container: _.container,
                  isDocument: y,
                };
                return arguments.length
                  ? void 0 !== t[e]
                    ? t[e]
                    : void j(1, 'ERROR: option "' + e + '" is not available')
                  : t;
              }),
              (this.loglevel = function (e) {
                return arguments.length
                  ? (_.loglevel != e && (_.loglevel = e), c)
                  : _.loglevel;
              }),
              (this.enabled = function (e) {
                return arguments.length
                  ? (v != e && ((v = !!e), c.updateScene(u, !0)), c)
                  : v;
              }),
              (this.destroy = function (t) {
                e.clearTimeout(i);
                for (var n = u.length; n--; ) u[n].destroy(t);
                return (
                  j(
                    3,
                    "destroyed " +
                      l +
                      " (reset: " +
                      (t ? "true" : "false") +
                      ")",
                  ),
                  null
                );
              }),
              (function () {
                for (var o in _)
                  s.hasOwnProperty(o) ||
                    (j(2, 'WARNING: Unknown option "' + o + '"'), delete _[o]);
                if (
                  ((_.container = r.get.elements(_.container)[0]), !_.container)
                )
                  throw (
                    (j(
                      1,
                      "ERROR creating object " +
                        l +
                        ": No valid scroll container supplied",
                    ),
                    l + " init failed.")
                  );
                (y =
                  _.container === e ||
                  _.container === t.body ||
                  !t.body.contains(_.container)) && (_.container = e),
                  (b = w()),
                  f.a
                    .getInstance()
                    .getDimension()
                    .addDimensionListener("scrollmagic", {
                      onScroll: I,
                      onScrollEnd: I,
                      onResize: I({ type: "resize" }),
                    });
                var a = parseInt(_.refreshInterval, 10);
                (_.refreshInterval = r.type.Number(a) ? a : s.refreshInterval),
                  setTimeout(S, _.refreshInterval),
                  j(3, "added new " + l + " controller (v" + n.version + ")");
              })(),
              c
            );
          };
          var o = {
            defaults: {
              container: e,
              vertical: !0,
              globalSceneOptions: {},
              loglevel: 2,
              refreshInterval: 100,
            },
          };
          (n.Controller.addOption = function (e, t) {
            o.defaults[e] = t;
          }),
            (n.Controller.extend = function (e) {
              var t = this;
              (n.Controller = function () {
                return (
                  t.apply(this, arguments),
                  (this.$super = r.extend({}, this)),
                  e.apply(this, arguments) || this
                );
              }),
                r.extend(n.Controller, t),
                (n.Controller.prototype = t.prototype),
                (n.Controller.prototype.constructor = n.Controller);
            }),
            (n.Scene = function (o) {
              var i,
                l,
                s = "ScrollMagic.Scene",
                c = a.defaults,
                _ = this,
                u = r.extend({}, c, o),
                d = "BEFORE",
                h = 0,
                m = { start: 0, end: 0 },
                y = 0,
                b = !0,
                v = {};
              (this.on = function (e, t) {
                return (
                  r.type.Function(t)
                    ? (e = e.trim().split(" ")).forEach(function (e) {
                        var n = e.split("."),
                          o = n[0],
                          a = n[1];
                        "*" != o &&
                          (v[o] || (v[o] = []),
                          v[o].push({ namespace: a || "", callback: t }));
                      })
                    : g(
                        1,
                        "ERROR when calling '.on()': Supplied callback for '" +
                          e +
                          "' is not a valid function!",
                      ),
                  _
                );
              }),
                (this.off = function (e, t) {
                  return e
                    ? ((e = e.trim().split(" ")).forEach(function (e, n) {
                        var o = e.split("."),
                          a = o[0],
                          r = o[1] || "";
                        ("*" === a ? Object.keys(v) : [a]).forEach(
                          function (e) {
                            for (var n = v[e] || [], o = n.length; o--; ) {
                              var a = n[o];
                              !a ||
                                (r !== a.namespace && "*" !== r) ||
                                (t && t != a.callback) ||
                                n.splice(o, 1);
                            }
                            n.length || delete v[e];
                          },
                        );
                      }),
                      _)
                    : (g(1, "ERROR: Invalid event name supplied."), _);
                }),
                (this.trigger = function (e, t) {
                  if (e) {
                    var o = e.trim().split("."),
                      a = o[0],
                      r = o[1],
                      i = v[a];
                    g(3, "event fired:", a, t ? "->" : "", t || ""),
                      i &&
                        i.forEach(function (e, o) {
                          (r && r !== e.namespace) ||
                            e.callback.call(
                              _,
                              new n.Event(a, e.namespace, _, t),
                            );
                        });
                  } else g(1, "ERROR: Invalid event name supplied.");
                  return _;
                }),
                _.on("change.internal", function (e) {
                  "loglevel" !== e.what &&
                    "tweenChanges" !== e.what &&
                    ("triggerElement" === e.what
                      ? I()
                      : "reverse" === e.what && _.update());
                }).on("shift.internal", function (e) {
                  k(), _.update();
                });
              var g = (this._log = function (t, n) {
                u.loglevel >= t &&
                  (Array.prototype.splice.call(
                    arguments,
                    1,
                    0,
                    "(" + s + ") ->",
                  ),
                  r.log.apply(e, arguments));
              });
              (this.addTo = function (e) {
                return (
                  e instanceof n.Controller
                    ? l != e &&
                      (l && l.removeScene(_),
                      (l = e),
                      T(),
                      O(!0),
                      I(!0),
                      k(),
                      l.info("container").addEventListener("resize", S),
                      e.addScene(_),
                      _.trigger("add", { controller: l }),
                      g(3, "added " + s + " to controller"),
                      _.update())
                    : g(
                        1,
                        "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller",
                      ),
                  _
                );
              }),
                (this.enabled = function (e) {
                  return arguments.length
                    ? (b != e && ((b = !!e), _.update(!0)), _)
                    : b;
                }),
                (this.remove = function () {
                  if (l) {
                    l.info("container").removeEventListener("resize", S);
                    var e = l;
                    (l = void 0),
                      e.removeScene(_),
                      _.trigger("remove"),
                      g(3, "removed " + s + " from controller");
                  }
                  return _;
                }),
                (this.destroy = function (e) {
                  return (
                    _.trigger("destroy", { reset: e }),
                    _.remove(),
                    _.off("*.*"),
                    g(
                      3,
                      "destroyed " +
                        s +
                        " (reset: " +
                        (e ? "true" : "false") +
                        ")",
                    ),
                    null
                  );
                }),
                (this.update = function (e) {
                  if (l)
                    if (e) {
                      var t = p.a.getInstance().allTaskFinished();
                      if (_.outOfView && t) return;
                      if (l.enabled() && b) {
                        var n,
                          o = l.info("scrollPos");
                        (n =
                          u.duration > 0
                            ? (o - m.start) / (m.end - m.start)
                            : o >= m.start
                              ? 1
                              : 0),
                          _.trigger("update", {
                            startPos: m.start,
                            endPos: m.end,
                            scrollPos: o,
                          }),
                          _.progress(n);
                      } else w && "DURING" === d && P(!0);
                    } else l.updateScene(_, !1);
                  return _;
                }),
                (this.refresh = function () {
                  return O(), I(), _;
                }),
                (this.progress = function (e) {
                  if (arguments.length) {
                    var t = !1,
                      n = d,
                      o = l ? l.info("scrollDirection") : "PAUSED",
                      a = u.reverse || e >= h;
                    if (
                      (0 === u.duration
                        ? ((t = h != e),
                          (d =
                            0 === (h = e < 1 && a ? 0 : 1)
                              ? "BEFORE"
                              : "DURING"))
                        : e < 0 && "BEFORE" !== d && a
                          ? ((h = 0), (d = "BEFORE"), (t = !0))
                          : e >= 0 && e < 1 && a
                            ? ((h = e), (d = "DURING"), (t = !0))
                            : e >= 1 && "AFTER" !== d
                              ? ((h = 1), (d = "AFTER"), (t = !0))
                              : "DURING" !== d || a || P(),
                      t)
                    ) {
                      var r = { progress: h, state: d, scrollDirection: o },
                        i = d != n,
                        s = function (e) {
                          _.trigger(e, r);
                        };
                      i &&
                        "DURING" !== n &&
                        (s("enter"), s("BEFORE" === n ? "start" : "end")),
                        s("progress"),
                        i &&
                          "DURING" !== d &&
                          (s("BEFORE" === d ? "start" : "end"), s("leave"));
                    }
                    return _;
                  }
                  return h;
                });
              var w,
                x,
                k = function () {
                  (m = { start: y + u.offset }),
                    l &&
                      u.triggerElement &&
                      (m.start -= l.info("size") * u.triggerHook),
                    (m.end = m.start + u.duration);
                },
                O = function (e) {
                  if (i) {
                    C("duration", i.call(_)) &&
                      !e &&
                      (_.trigger("change", {
                        what: "duration",
                        newval: u.duration,
                      }),
                      _.trigger("shift", { reason: "duration" }));
                  }
                },
                I = function (e) {
                  var t = 0,
                    n = u.triggerElement;
                  if (l && (n || y > 0)) {
                    if (n)
                      if (n.parentNode) {
                        for (
                          var o = l.info(),
                            a = r.get.offset(o.container),
                            i = o.vertical ? "top" : "left";
                          n.parentNode.hasAttribute(
                            "data-scrollmagic-pin-spacer",
                          );

                        )
                          n = n.parentNode;
                        var s = r.get.offset(n);
                        o.isDocument || (a[i] -= l.scrollPos()),
                          (t = s[i] - a[i]);
                      } else
                        g(
                          2,
                          "WARNING: triggerElement was removed from DOM and will be reset to",
                          void 0,
                        ),
                          _.triggerElement(void 0);
                    var c = t != y;
                    (y = t),
                      c &&
                        !e &&
                        _.trigger("shift", {
                          reason: "triggerElementPosition",
                        });
                  }
                },
                S = function (e) {
                  u.triggerHook > 0 &&
                    _.trigger("shift", { reason: "containerResize" });
                },
                j = r.extend(a.validate, {
                  duration: function (e) {
                    if (r.type.String(e) && e.match(/^(\.|\d)*\d+%$/)) {
                      var t = parseFloat(e) / 100;
                      e = function () {
                        return l ? l.info("size") * t : 0;
                      };
                    }
                    if (r.type.Function(e)) {
                      i = e;
                      try {
                        e = parseFloat(i.call(_));
                      } catch (n) {
                        e = -1;
                      }
                    }
                    if (((e = parseFloat(e)), !r.type.Number(e) || e < 0))
                      throw i
                        ? ((i = void 0),
                          [
                            'Invalid return value of supplied function for option "duration":',
                            e,
                          ])
                        : ['Invalid value for option "duration":', e];
                    return e;
                  },
                }),
                T = function (e) {
                  (e = arguments.length ? [e] : Object.keys(j)).forEach(
                    function (e, t) {
                      var n;
                      if (j[e])
                        try {
                          n = j[e](u[e]);
                        } catch (a) {
                          n = c[e];
                          var o = r.type.String(a) ? [a] : a;
                          r.type.Array(o)
                            ? ((o[0] = "ERROR: " + o[0]),
                              o.unshift(1),
                              g.apply(this, o))
                            : g(
                                1,
                                "ERROR: Problem executing validation callback for option '" +
                                  e +
                                  "':",
                                a.message,
                              );
                        } finally {
                          u[e] = n;
                        }
                    },
                  );
                },
                C = function (e, t) {
                  var n = !1,
                    o = u[e];
                  return u[e] != t && ((u[e] = t), T(e), (n = o != u[e])), n;
                },
                M = function (e) {
                  _[e] ||
                    (_[e] = function (t) {
                      return arguments.length
                        ? ("duration" === e && (i = void 0),
                          C(e, t) &&
                            (_.trigger("change", { what: e, newval: u[e] }),
                            a.shifts.indexOf(e) > -1 &&
                              _.trigger("shift", { reason: e })),
                          _)
                        : u[e];
                    });
                };
              (this.controller = function () {
                return l;
              }),
                (this.state = function () {
                  return d;
                }),
                (this.scrollOffset = function () {
                  return m.start;
                }),
                (this.triggerPosition = function () {
                  var e = u.offset;
                  return (
                    l &&
                      (u.triggerElement
                        ? (e += y)
                        : (e += l.info("size") * _.triggerHook())),
                    e
                  );
                }),
                _.on("shift.internal", function (e) {
                  var t = "duration" === e.reason;
                  (("AFTER" === d && t) ||
                    ("DURING" === d && 0 === u.duration)) &&
                    P(),
                    t && E();
                })
                  .on("progress.internal", function (e) {
                    P();
                  })
                  .on("add.internal", function (e) {
                    E();
                  })
                  .on("destroy.internal", function (e) {
                    _.removePin(e.reset);
                  });
              var P = function (e) {
                  if (w && l) {
                    var t = l.info(),
                      n = x.spacer.firstChild;
                    if (e || "DURING" !== d) {
                      var o = {
                          position: x.inFlow ? "relative" : "absolute",
                          top: 0,
                          left: 0,
                        },
                        a = r.css(n, "position") != o.position;
                      x.pushFollowers
                        ? u.duration > 0 &&
                          ("AFTER" === d &&
                          0 === parseFloat(r.css(x.spacer, "padding-top"))
                            ? (a = !0)
                            : "BEFORE" === d &&
                              0 ===
                                parseFloat(r.css(x.spacer, "padding-bottom")) &&
                              (a = !0))
                        : (o[t.vertical ? "top" : "left"] = u.duration * h),
                        r.css(n, o),
                        a && E();
                    } else {
                      "fixed" != r.css(n, "position") &&
                        (r.css(n, { position: "fixed" }), E());
                      var i = r.get.offset(x.spacer, !0),
                        s =
                          u.reverse || 0 === u.duration
                            ? t.scrollPos - m.start
                            : Math.round(h * u.duration * 10) / 10;
                      (i[t.vertical ? "top" : "left"] += s),
                        r.css(x.spacer.firstChild, {
                          top: i.top,
                          left: i.left,
                        });
                    }
                  }
                },
                E = function () {
                  if (w && l && x.inFlow) {
                    var e = "DURING" === d,
                      t = l.info("vertical"),
                      n = x.spacer.firstChild,
                      o = r.isMarginCollapseType(r.css(x.spacer, "display")),
                      a = {};
                    x.relSize.width || x.relSize.autoFullWidth
                      ? e
                        ? r.css(w, { width: r.get.width(x.spacer) })
                        : r.css(w, { width: "100%" })
                      : ((a["min-width"] = r.get.width(t ? w : n, !0, !0)),
                        (a.width = e ? a["min-width"] : "auto")),
                      x.relSize.height
                        ? e
                          ? r.css(w, {
                              height:
                                r.get.height(x.spacer) -
                                (x.pushFollowers ? u.duration : 0),
                            })
                          : r.css(w, { height: "100%" })
                        : ((a["min-height"] = r.get.height(t ? n : w, !0, !o)),
                          (a.height = e ? a["min-height"] : "auto")),
                      x.pushFollowers &&
                        ((a["padding" + (t ? "Top" : "Left")] = u.duration * h),
                        (a["padding" + (t ? "Bottom" : "Right")] =
                          u.duration * (1 - h))),
                      r.css(x.spacer, a);
                  }
                },
                L = function () {
                  l && w && "DURING" === d && !l.info("isDocument") && P();
                },
                B = function () {
                  l &&
                    w &&
                    "DURING" === d &&
                    (((x.relSize.width || x.relSize.autoFullWidth) &&
                      r.get.width(e) != r.get.width(x.spacer.parentNode)) ||
                      (x.relSize.height &&
                        r.get.height(e) !=
                          r.get.height(x.spacer.parentNode))) &&
                    E();
                },
                N = function (e) {
                  l &&
                    w &&
                    "DURING" === d &&
                    !l.info("isDocument") &&
                    (e.preventDefault(),
                    l._setScrollPos(
                      l.info("scrollPos") -
                        ((e.wheelDelta ||
                          e[
                            l.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"
                          ]) / 3 || 30 * -e.detail),
                    ));
                };
              (this.setPin = function (n, o) {
                var a = o && o.hasOwnProperty("pushFollowers");
                if (
                  ((o = r.extend(
                    {},
                    {
                      pushFollowers: !0,
                      spacerClass: "scrollmagic-pin-spacer",
                    },
                    o,
                  )),
                  !(n = r.get.elements(n)[0]))
                )
                  return (
                    g(
                      1,
                      "ERROR calling method 'setPin()': Invalid pin element supplied.",
                    ),
                    _
                  );
                if ("fixed" === r.css(n, "position"))
                  return (
                    g(
                      1,
                      "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'.",
                    ),
                    _
                  );
                if (w) {
                  if (w === n) return _;
                  _.removePin();
                }
                var i = (w = n).parentNode.style.display,
                  l = [
                    "top",
                    "left",
                    "bottom",
                    "right",
                    "margin",
                    "marginLeft",
                    "marginRight",
                    "marginTop",
                    "marginBottom",
                  ];
                w.parentNode.style.display = "none";
                var s = "absolute" != r.css(w, "position"),
                  c = r.css(w, l.concat(["display"])),
                  d = r.css(w, ["width", "height"]);
                (w.parentNode.style.display = i),
                  !s &&
                    o.pushFollowers &&
                    (g(
                      2,
                      "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled.",
                    ),
                    (o.pushFollowers = !1)),
                  e.setTimeout(function () {
                    w &&
                      0 === u.duration &&
                      a &&
                      o.pushFollowers &&
                      g(
                        2,
                        "WARNING: pushFollowers =",
                        !0,
                        "has no effect, when scene duration is 0.",
                      );
                  }, 0);
                var p = w.parentNode.insertBefore(t.createElement("div"), w),
                  h = r.extend(c, {
                    position: s ? "relative" : "absolute",
                    boxSizing: "content-box",
                    mozBoxSizing: "content-box",
                    webkitBoxSizing: "content-box",
                  });
                if (
                  (s || r.extend(h, r.css(w, ["width", "height"])),
                  r.css(p, h),
                  p.setAttribute("data-scrollmagic-pin-spacer", ""),
                  r.addClass(p, o.spacerClass),
                  (x = {
                    spacer: p,
                    relSize: {
                      width: "%" === d.width.slice(-1),
                      height: "%" === d.height.slice(-1),
                      autoFullWidth:
                        "auto" === d.width &&
                        s &&
                        r.isMarginCollapseType(c.display),
                    },
                    pushFollowers: o.pushFollowers,
                    inFlow: s,
                  }),
                  !w.___origStyle)
                ) {
                  w.___origStyle = {};
                  var m = w.style;
                  l.concat([
                    "width",
                    "height",
                    "position",
                    "boxSizing",
                    "mozBoxSizing",
                    "webkitBoxSizing",
                  ]).forEach(function (e) {
                    w.___origStyle[e] = m[e] || "";
                  });
                }
                x.relSize.width && r.css(p, { width: d.width }),
                  x.relSize.height && r.css(p, { height: d.height }),
                  p.appendChild(w),
                  r.css(w, {
                    position: s ? "relative" : "absolute",
                    margin: "auto",
                    top: "auto",
                    left: "auto",
                    bottom: "auto",
                    right: "auto",
                  }),
                  (x.relSize.width || x.relSize.autoFullWidth) &&
                    r.css(w, {
                      boxSizing: "border-box",
                      mozBoxSizing: "border-box",
                      webkitBoxSizing: "border-box",
                    }),
                  w.addEventListener("mousewheel", N),
                  w.addEventListener("DOMMouseScroll", N);
                var y = f.a.getInstance().getDimension();
                return (
                  y.addDimensionListener("scrollmagic_pin_container", {
                    onScroll: L,
                    onResize: L,
                  }),
                  y.addDimensionListener("scrollmagic_pin_spacer", {
                    onResize: B,
                  }),
                  g(3, "added pin"),
                  P(),
                  _
                );
              }),
                (this.removePin = function (e) {
                  if (w) {
                    if (("DURING" === d && P(!0), e || !l)) {
                      var t = x.spacer.firstChild;
                      if (t.hasAttribute("data-scrollmagic-pin-spacer")) {
                        var n = x.spacer.style,
                          o = {};
                        [
                          "margin",
                          "marginLeft",
                          "marginRight",
                          "marginTop",
                          "marginBottom",
                        ].forEach(function (e) {
                          o[e] = n[e] || "";
                        }),
                          r.css(t, o);
                      }
                      x.spacer.parentNode.insertBefore(t, x.spacer),
                        x.spacer.parentNode.removeChild(x.spacer),
                        w.parentNode.hasAttribute(
                          "data-scrollmagic-pin-spacer",
                        ) || (r.css(w, w.___origStyle), delete w.___origStyle);
                    }
                    w.removeEventListener("mousewheel", N),
                      w.removeEventListener("DOMMouseScroll", N),
                      dimension.removeDimensionListener(
                        "scrollmagic_pin_container",
                      ),
                      dimension.removeDimensionListener(
                        "scrollmagic_pin_spacer",
                      ),
                      (w = void 0),
                      g(
                        3,
                        "removed pin (reset: " + (e ? "true" : "false") + ")",
                      );
                  }
                  return _;
                });
              var D,
                z = [];
              return (
                _.on("destroy.internal", function (e) {
                  _.removeClassToggle(e.reset);
                }),
                (this.setClassToggle = function (e, t) {
                  var n = r.get.elements(e);
                  return 0 !== n.length && r.type.String(t)
                    ? (z.length > 0 && _.removeClassToggle(),
                      (D = t),
                      (z = n),
                      _.on(
                        "enter.internal_class leave.internal_class",
                        function (e) {
                          var t =
                            "enter" === e.type ? r.addClass : r.removeClass;
                          z.forEach(function (e, n) {
                            t(e, D);
                          });
                        },
                      ),
                      _)
                    : (g(
                        1,
                        "ERROR calling method 'setClassToggle()': Invalid " +
                          (0 === n.length ? "element" : "classes") +
                          " supplied.",
                      ),
                      _);
                }),
                (this.removeClassToggle = function (e) {
                  return (
                    e &&
                      z.forEach(function (e, t) {
                        r.removeClass(e, D);
                      }),
                    _.off("start.internal_class end.internal_class"),
                    (D = void 0),
                    (z = []),
                    _
                  );
                }),
                (function () {
                  for (var e in u)
                    c.hasOwnProperty(e) ||
                      (g(2, 'WARNING: Unknown option "' + e + '"'),
                      delete u[e]);
                  for (var t in c) M(t);
                  T();
                })(),
                _
              );
            });
          var a = {
            defaults: {
              duration: 0,
              offset: 0,
              triggerElement: void 0,
              triggerHook: 0.5,
              reverse: !0,
              loglevel: 2,
              lazyUpdate: !1,
              updateProgress: void 0,
              lazyUpdateIntersection: void 0,
            },
            validate: {
              offset: function (e) {
                if (((e = parseFloat(e)), !r.type.Number(e)))
                  throw ['Invalid value for option "offset":', e];
                return e;
              },
              triggerElement: function (e) {
                if ((e = e || void 0)) {
                  var t = r.get.elements(e)[0];
                  if (!t || !t.parentNode)
                    throw [
                      'Element defined in option "triggerElement" was not found:',
                      e,
                    ];
                  e = t;
                }
                return e;
              },
              triggerHook: function (e) {
                var t = { onCenter: 0.5, onEnter: 1, onLeave: 0 };
                if (r.type.Number(e))
                  e = Math.max(0, Math.min(parseFloat(e), 1));
                else {
                  if (!(e in t))
                    throw ['Invalid value for option "triggerHook": ', e];
                  e = t[e];
                }
                return e;
              },
              reverse: function (e) {
                return !!e;
              },
              loglevel: function (e) {
                if (((e = parseInt(e)), !r.type.Number(e) || e < 0 || e > 3))
                  throw ['Invalid value for option "loglevel":', e];
                return e;
              },
            },
            shifts: ["duration", "offset", "triggerHook"],
          };
          (n.Scene.addOption = function (e, t, o, r) {
            e in a.defaults
              ? n._util.log(
                  1,
                  "[static] ScrollMagic.Scene -> Cannot add Scene option '" +
                    e +
                    "', because it already exists.",
                )
              : ((a.defaults[e] = t),
                (a.validate[e] = o),
                r && a.shifts.push(e));
          }),
            (n.Scene.extend = function (e) {
              var t = this;
              (n.Scene = function () {
                return (
                  t.apply(this, arguments),
                  (this.$super = r.extend({}, this)),
                  e.apply(this, arguments) || this
                );
              }),
                r.extend(n.Scene, t),
                (n.Scene.prototype = t.prototype),
                (n.Scene.prototype.constructor = n.Scene);
            }),
            (n.Event = function (e, t, n, o) {
              for (var a in (o = o || {})) this[a] = o[a];
              return (
                (this.type = e),
                (this.target = this.currentTarget = n),
                (this.namespace = t || ""),
                (this.timeStamp = this.timestamp = Date.now()),
                this
              );
            });
          var r = (n._util = (function (e) {
            var n,
              o = {},
              a = function (e) {
                return parseFloat(e) || 0;
              },
              r = function (t) {
                return t.currentStyle ? t.currentStyle : e.getComputedStyle(t);
              },
              i = function (n, o, i, l) {
                if ((o = o === t ? e : o) === e) l = !1;
                else if (!u.DomElement(o)) return 0;
                n = n.charAt(0).toUpperCase() + n.substr(1).toLowerCase();
                var s =
                  (i
                    ? o["offset" + n] || o["outer" + n]
                    : o["client" + n] || o["inner" + n]) || 0;
                if (i && l) {
                  var c = r(o);
                  s +=
                    "Height" === n
                      ? a(c.marginTop) + a(c.marginBottom)
                      : a(c.marginLeft) + a(c.marginRight);
                }
                return s;
              },
              l = function (e) {
                return e
                  .replace(/^[^a-z]+([a-z])/g, "$1")
                  .replace(/-([a-z])/g, function (e) {
                    return e[1].toUpperCase();
                  });
              };
            (o.extend = function (e) {
              for (e = e || {}, n = 1; n < arguments.length; n++)
                if (arguments[n])
                  for (var t in arguments[n])
                    arguments[n].hasOwnProperty(t) && (e[t] = arguments[n][t]);
              return e;
            }),
              (o.isMarginCollapseType = function (e) {
                return (
                  [
                    "block",
                    "flex",
                    "list-item",
                    "table",
                    "-webkit-box",
                  ].indexOf(e) > -1
                );
              });
            var s = ["error", "warn", "log"],
              c = e.console || {};
            for (c.log = c.log || function () {}, n = 0; n < s.length; n++) {
              var _ = s[n];
              c[_] || (c[_] = c.log);
            }
            o.log = function (e) {
              (e > s.length || e <= 0) && (e = s.length);
              var t = new Date(),
                n =
                  ("0" + t.getHours()).slice(-2) +
                  ":" +
                  ("0" + t.getMinutes()).slice(-2) +
                  ":" +
                  ("0" + t.getSeconds()).slice(-2) +
                  ":" +
                  ("00" + t.getMilliseconds()).slice(-3),
                o = s[e - 1],
                a = Array.prototype.splice.call(arguments, 1),
                r = Function.prototype.bind.call(c[o], c);
              a.unshift(n), r.apply(c, a);
            };
            var u = (o.type = function (e) {
              return Object.prototype.toString
                .call(e)
                .replace(/^\[object (.+)\]$/, "$1")
                .toLowerCase();
            });
            (u.String = function (e) {
              return "string" === u(e);
            }),
              (u.Function = function (e) {
                return "function" === u(e);
              }),
              (u.Array = function (e) {
                return Array.isArray(e);
              }),
              (u.Number = function (e) {
                return !u.Array(e) && e - parseFloat(e) + 1 >= 0;
              }),
              (u.DomElement = function (e) {
                return "object" === typeof HTMLElement ||
                  "function" === typeof HTMLElement
                  ? e instanceof HTMLElement || e instanceof SVGElement
                  : e &&
                      "object" === typeof e &&
                      null !== e &&
                      1 === e.nodeType &&
                      "string" === typeof e.nodeName;
              });
            var d = (o.get = {});
            return (
              (d.elements = function (n) {
                var o = [];
                if (u.String(n))
                  try {
                    n = t.querySelectorAll(n);
                  } catch (l) {
                    return o;
                  }
                if ("nodelist" === u(n) || u.Array(n) || n instanceof NodeList)
                  for (var a = 0, r = (o.length = n.length); a < r; a++) {
                    var i = n[a];
                    o[a] = u.DomElement(i) ? i : d.elements(i);
                  }
                else (u.DomElement(n) || n === t || n === e) && (o = [n]);
                return o;
              }),
              (d.scrollTop = function (t) {
                return t && t !== e && "number" === typeof t.scrollTop
                  ? t.scrollTop
                  : f.a.getInstance().getDimension().pageOffsetY;
              }),
              (d.scrollLeft = function (t) {
                return t && t !== e && "number" === typeof t.scrollLeft
                  ? t.scrollLeft
                  : f.a.getInstance().getDimension().pageOffsetX;
              }),
              (d.width = function (e, t, n) {
                return i("width", e, t, n);
              }),
              (d.height = function (e, t, n) {
                return i("height", e, t, n);
              }),
              (d.offset = function (e, t) {
                var n = { top: 0, left: 0 };
                if (e && e.getBoundingClientRect) {
                  var o = e.getBoundingClientRect();
                  (n.top = o.top),
                    (n.left = o.left),
                    t || ((n.top += d.scrollTop()), (n.left += d.scrollLeft()));
                }
                return n;
              }),
              (o.addClass = function (e, t) {
                t &&
                  (e.classList ? e.classList.add(t) : (e.className += " " + t));
              }),
              (o.removeClass = function (e, t) {
                t &&
                  (e.classList
                    ? e.classList.remove(t)
                    : (e.className = e.className.replace(
                        new RegExp(
                          "(^|\\b)" + t.split(" ").join("|") + "(\\b|$)",
                          "gi",
                        ),
                        " ",
                      )));
              }),
              (o.css = function (e, t) {
                if (u.String(t)) return r(e)[l(t)];
                if (u.Array(t)) {
                  var n = {},
                    o = r(e);
                  return (
                    t.forEach(function (e, t) {
                      n[e] = o[l(e)];
                    }),
                    n
                  );
                }
                for (var a in t) {
                  var i = t[a];
                  i == parseFloat(i) && (i += "px"), (e.style[l(a)] = i);
                }
              }),
              o
            );
          })(e || {}));
          return n;
        })(window, "undefined" === typeof document ? {} : document),
        m = ["children", "forceIndividual"],
        y = u.a.createElement;
      function b(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function v(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? b(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : b(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function g(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var w = (function (e) {
          function t() {
            var e;
            return (
              Object(r.default)(this, t),
              ((e = g(this, t)).state = { controller: null }),
              e
            );
          }
          return (
            Object(c.a)(t, e),
            Object(i.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e,
                    t = this.props,
                    n = (t.children, t.forceIndividual),
                    o = Object(a.a)(t, m);
                  !window || n || o.container
                    ? (e = new h.Controller(o))
                    : window._ScrollMagicController
                      ? (e = window._ScrollMagicController)
                      : ((e = new h.Controller(o)),
                        (window._ScrollMagicController = e)),
                    this.setState({ controller: e });
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  this.controller = null;
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this.props.children,
                    t = this.state.controller;
                  return t
                    ? u.a.Children.map(e, function (e) {
                        if ("Scene" !== e.type.displayName) return e;
                        var n = v(v({}, e.props), {}, { controller: t });
                        return y(e.type, n);
                      })
                    : e;
                },
              },
            ]),
            t
          );
        })(u.a.Component),
        x =
          (Object(d.a)({
            on: [
              [
                "visible",
                function () {
                  return { rootMargin: "900000px 2000px 2000px" };
                },
              ],
              ["delay", 5e3],
            ],
            removeWrapperOnHydration: !0,
          })(w),
          [
            "children",
            "controller",
            "classToggle",
            "pin",
            "pinSettings",
            "indicators",
            "enabled",
            "lazyMargin",
          ]),
        k = u.a.createElement;
      function O(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      function I(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function S(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? I(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : I(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var j = function (e) {
          return !(
            1 !== u.a.Children.count(e) ||
            !e.type ||
            ("Tween" !== e.type.displayName &&
              "Timeline" !== e.type.displayName)
          );
        },
        T = function (e, t, n) {
          return e && "function" === typeof e ? e(t, n) : e;
        },
        C = function (e, t, n) {
          return (
            (e = (function (e, t) {
              if (j(e)) {
                var n = S(S({}, e.props), {}, { totalProgress: t, paused: !0 });
                return k("div", null, k(e.type, n));
              }
              return e;
            })(e, t)),
            (e = T(e, t, n)),
            u.a.Children.only(e)
          );
        },
        M = (function (e) {
          function t() {
            var e;
            return (
              Object(r.default)(this, t),
              ((e = O(this, t)).state = { event: "init", progress: 0 }),
              (e.ref = u.a.createRef()),
              e
            );
          }
          return (
            Object(c.a)(t, e),
            Object(i.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = (t.children, t.controller),
                    o = t.classToggle,
                    r = t.pin,
                    i = t.pinSettings,
                    l = t.indicators,
                    s = t.enabled,
                    c = t.lazyMargin,
                    _ = Object(a.a)(t, x),
                    u = this.ref;
                  _.triggerElement =
                    null === _.triggerElement ? null : _.triggerElement || u;
                  var d = h._util.get.elements(_.triggerElement)[0],
                    p = _.lazyUpdate;
                  ((this.scene = new h.Scene(_)),
                  d && d instanceof Element && !0 === p) &&
                    f.a.getInstance().addNode(
                      d,
                      {
                        scrollIntoView: function () {
                          e.scene && ((e.scene.outOfView = !1), n.refresh());
                        },
                        scrollOutOfWiew: function () {
                          e.scene && ((e.scene.outOfView = !0), n.refresh());
                        },
                      },
                      void 0,
                      c || 500,
                      !0,
                    );
                  this.initEventHandlers(),
                    o && this.setClassToggle(this.scene, u, o),
                    (r || i) && this.setPin(this.scene, u, r, i),
                    l && isDev && this.scene.addIndicators({ name: " " }),
                    void 0 !== s && this.scene.enabled(s),
                    this.scene.addTo(n);
                },
              },
              {
                key: "componentDidUpdate",
                value: function (e) {
                  var t = this.props,
                    n = t.duration,
                    o = t.offset,
                    a = t.triggerElement,
                    r = t.triggerHook,
                    i = t.reverse,
                    l = t.enabled;
                  void 0 !== n && n !== e.duration && this.scene.duration(n),
                    void 0 !== o && o !== e.offset && this.scene.offset(o),
                    void 0 !== a && e.triggerElement,
                    void 0 !== r &&
                      r !== e.triggerHook &&
                      this.scene.triggerHook(r),
                    void 0 !== i && i !== e.reverse && this.scene.reverse(i),
                    void 0 !== l && l !== e.enabled && this.scene.enabled(l);
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  this.scene.destroy();
                },
              },
              {
                key: "setClassToggle",
                value: function (e, t, n) {
                  Array.isArray(n) && 2 === n.length
                    ? e.setClassToggle(n[0], n[1])
                    : e.setClassToggle(t, n);
                },
              },
              {
                key: "setPin",
                value: function (e, t, n, o) {
                  (t = (function (e) {
                    return "string" === typeof e || e instanceof String;
                  })(n)
                    ? n
                    : t),
                    e.setPin(t, o);
                },
              },
              {
                key: "initEventHandlers",
                value: function () {
                  var e = this,
                    t = this.props.children;
                  ("function" === typeof t || j(T(t, 0, "init"))) &&
                    (this.scene.on("start end enter leave", function (t) {
                      e.props.lazyUpdateIntersection ||
                        e.setState({ event: t });
                    }),
                    this.scene.on("progress", function (t) {
                      var n = e.props.updateProgress;
                      n ? n(t.progress) : e.setState({ progress: t.progress });
                    }));
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props.children,
                    n = this.state,
                    a = n.progress,
                    r = n.event,
                    i = C(t, a, r);
                  return u.a.cloneElement(
                    i,
                    Object(o.a)(
                      {},
                      (function (e) {
                        return e.type &&
                          e.type.$$typeof &&
                          "Symbol(react.forward_ref)" ===
                            e.type.$$typeof.toString()
                          ? "ref"
                          : e.type && e.type.styledComponentId
                            ? "innerRef"
                            : "ref";
                      })(i),
                      function (t) {
                        e.ref = t;
                      },
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(u.a.PureComponent),
        P = (function (e) {
          function t() {
            return Object(r.default)(this, t), O(this, t, arguments);
          }
          return (
            Object(c.a)(t, e),
            Object(i.default)(t, [
              {
                key: "render",
                value: function () {
                  if (!this.props.controller) {
                    var e = this.props.children;
                    return C(e, 0, "init");
                  }
                  return k(M, this.props);
                },
              },
            ]),
            t
          );
        })(u.a.PureComponent);
      Object(o.a)(P, "displayName", "Scene");
      var E = P;
    },
    Si88: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.default = void 0);
      !(function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e)
          for (var n in e)
            if (Object.prototype.hasOwnProperty.call(e, n)) {
              var o =
                Object.defineProperty && Object.getOwnPropertyDescriptor
                  ? Object.getOwnPropertyDescriptor(e, n)
                  : {};
              o.get || o.set ? Object.defineProperty(t, n, o) : (t[n] = e[n]);
            }
        t.default = e;
      })(n("17x9"));
      var o = l(n("ycFn")),
        a = l(n("VOcB")),
        r = l(n("q1tI")),
        i = l(n("S3Uj"));
      n("xfxO");
      function l(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function s() {
        return (s =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      var c = function (e, t) {
          return (
            e &&
            t &&
            t.split(" ").forEach(function (t) {
              return (0, o.default)(e, t);
            })
          );
        },
        _ = function (e, t) {
          return (
            e &&
            t &&
            t.split(" ").forEach(function (t) {
              return (0, a.default)(e, t);
            })
          );
        },
        u = (function (e) {
          var t, n;
          function o() {
            for (
              var t, n = arguments.length, o = new Array(n), a = 0;
              a < n;
              a++
            )
              o[a] = arguments[a];
            return (
              ((t = e.call.apply(e, [this].concat(o)) || this).onEnter =
                function (e, n) {
                  var o = t.getClassNames(n ? "appear" : "enter").className;
                  t.removeClasses(e, "exit"),
                    c(e, o),
                    t.props.onEnter && t.props.onEnter(e, n);
                }),
              (t.onEntering = function (e, n) {
                var o = t.getClassNames(n ? "appear" : "enter").activeClassName;
                t.reflowAndAddClass(e, o),
                  t.props.onEntering && t.props.onEntering(e, n);
              }),
              (t.onEntered = function (e, n) {
                var o = t.getClassNames("appear").doneClassName,
                  a = t.getClassNames("enter").doneClassName,
                  r = n ? o + " " + a : a;
                t.removeClasses(e, n ? "appear" : "enter"),
                  c(e, r),
                  t.props.onEntered && t.props.onEntered(e, n);
              }),
              (t.onExit = function (e) {
                var n = t.getClassNames("exit").className;
                t.removeClasses(e, "appear"),
                  t.removeClasses(e, "enter"),
                  c(e, n),
                  t.props.onExit && t.props.onExit(e);
              }),
              (t.onExiting = function (e) {
                var n = t.getClassNames("exit").activeClassName;
                t.reflowAndAddClass(e, n),
                  t.props.onExiting && t.props.onExiting(e);
              }),
              (t.onExited = function (e) {
                var n = t.getClassNames("exit").doneClassName;
                t.removeClasses(e, "exit"),
                  c(e, n),
                  t.props.onExited && t.props.onExited(e);
              }),
              (t.getClassNames = function (e) {
                var n = t.props.classNames,
                  o = "string" === typeof n,
                  a = o ? (o && n ? n + "-" : "") + e : n[e];
                return {
                  className: a,
                  activeClassName: o ? a + "-active" : n[e + "Active"],
                  doneClassName: o ? a + "-done" : n[e + "Done"],
                };
              }),
              t
            );
          }
          (n = e),
            ((t = o).prototype = Object.create(n.prototype)),
            (t.prototype.constructor = t),
            (t.__proto__ = n);
          var a = o.prototype;
          return (
            (a.removeClasses = function (e, t) {
              var n = this.getClassNames(t),
                o = n.className,
                a = n.activeClassName,
                r = n.doneClassName;
              o && _(e, o), a && _(e, a), r && _(e, r);
            }),
            (a.reflowAndAddClass = function (e, t) {
              t && (e && e.scrollTop, c(e, t));
            }),
            (a.render = function () {
              var e = s({}, this.props);
              return (
                delete e.classNames,
                r.default.createElement(
                  i.default,
                  s({}, e, {
                    onEnter: this.onEnter,
                    onEntered: this.onEntered,
                    onEntering: this.onEntering,
                    onExit: this.onExit,
                    onExiting: this.onExiting,
                    onExited: this.onExited,
                  }),
                )
              );
            }),
            o
          );
        })(r.default.Component);
      (u.defaultProps = { classNames: "" }), (u.propTypes = {});
      var d = u;
      (t.default = d), (e.exports = t.default);
    },
    SxVx: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              },
        r = (function (e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e)
            for (var n in e)
              Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          return (t.default = e), t;
        })(n("Aw7D")),
        i = n("zWvU"),
        l = (o = i) && o.__esModule ? o : { default: o };
      var s = {
          email:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          url: new RegExp(
            "^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$",
            "i",
          ),
          hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i,
        },
        c = {
          integer: function (e) {
            return c.number(e) && parseInt(e, 10) === e;
          },
          float: function (e) {
            return c.number(e) && !c.integer(e);
          },
          array: function (e) {
            return Array.isArray(e);
          },
          regexp: function (e) {
            if (e instanceof RegExp) return !0;
            try {
              return !!new RegExp(e);
            } catch (t) {
              return !1;
            }
          },
          date: function (e) {
            return (
              "function" === typeof e.getTime &&
              "function" === typeof e.getMonth &&
              "function" === typeof e.getYear
            );
          },
          number: function (e) {
            return !isNaN(e) && "number" === typeof e;
          },
          object: function (e) {
            return (
              "object" === ("undefined" === typeof e ? "undefined" : a(e)) &&
              !c.array(e)
            );
          },
          method: function (e) {
            return "function" === typeof e;
          },
          email: function (e) {
            return (
              "string" === typeof e && !!e.match(s.email) && e.length < 255
            );
          },
          url: function (e) {
            return "string" === typeof e && !!e.match(s.url);
          },
          hex: function (e) {
            return "string" === typeof e && !!e.match(s.hex);
          },
        };
      t.default = function (e, t, n, o, i) {
        if (e.required && void 0 === t) (0, l.default)(e, t, n, o, i);
        else {
          var s = e.type;
          [
            "integer",
            "float",
            "array",
            "regexp",
            "object",
            "method",
            "email",
            "number",
            "date",
            "url",
            "hex",
          ].indexOf(s) > -1
            ? c[s](t) ||
              o.push(r.format(i.messages.types[s], e.fullField, e.type))
            : s &&
              ("undefined" === typeof t ? "undefined" : a(t)) !== e.type &&
              o.push(r.format(i.messages.types[s], e.fullField, e.type));
        }
      };
    },
    TLPt: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = function (e) {
        return null !== e && "object" === typeof e && e.getVelocity;
      };
    },
    TO8r: function (e, t) {
      var n = /\s/;
      e.exports = function (e) {
        for (var t = e.length; t-- && n.test(e.charAt(t)); );
        return t;
      };
    },
    TSYQ: function (e, t, n) {
      var o;
      !(function () {
        "use strict";
        var n = {}.hasOwnProperty;
        function a() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            var o = arguments[t];
            if (o) {
              var r = typeof o;
              if ("string" === r || "number" === r) e.push(o);
              else if (Array.isArray(o)) {
                if (o.length) {
                  var i = a.apply(null, o);
                  i && e.push(i);
                }
              } else if ("object" === r) {
                if (
                  o.toString !== Object.prototype.toString &&
                  !o.toString.toString().includes("[native code]")
                ) {
                  e.push(o.toString());
                  continue;
                }
                for (var l in o) n.call(o, l) && o[l] && e.push(l);
              }
            }
          }
          return e.join(" ");
        }
        e.exports
          ? ((a.default = a), (e.exports = a))
          : void 0 ===
              (o = function () {
                return a;
              }.apply(t, [])) || (e.exports = o);
      })();
    },
    TeTh: function (e, t, n) {
      e.exports = {
        "bg-wrapper": "background__bg-wrapper___3nICL",
        "bg-video-wrapper": "background__bg-video-wrapper___Xalaj",
        "bg-image": "background__bg-image___3lzI8",
      };
    },
    TmCs: function (e, t, n) {
      "use strict";
      var o = n("HaE+"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("rePB"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("gn4A"),
        m = n.n(h),
        y = n("XnI8"),
        b = n("XrJB"),
        v = n.n(b),
        g = (n("aiR1"), n("/MKj")),
        w = n("yWgo"),
        x = (n("nUpg"), n("TSYQ")),
        k = n.n(x),
        O = n("u11H"),
        I = n("UtvM"),
        S = n("ku9G"),
        j = n("vtNx"),
        T = f.a.createElement,
        C = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./subcribeModal.css": {
            "subscribe-modal-wrapper":
              "subcribeModal__subscribe-modal-wrapper___--Mxt",
            mask: "subcribeModal__mask___1U31N",
            unlocked: "subcribeModal__unlocked___2tVsU",
            active: "subcribeModal__active___jlUlh",
            "modal-container": "subcribeModal__modal-container___34fz1",
            "close-btn": "subcribeModal__close-btn___wHYxI",
            "close-icon": "subcribeModal__close-icon___jGbYH",
            "activity-modal-open-area":
              "subcribeModal__activity-modal-open-area___2Snt8",
            "modal-content": "subcribeModal__modal-content___10Q2_",
            envelope: "subcribeModal__envelope___lnmda",
            "envelope-video-svg": "subcribeModal__envelope-video-svg___2feIv",
            "activity-modal-container":
              "subcribeModal__activity-modal-container___1CfLW",
            "activity-modal-link": "subcribeModal__activity-modal-link___3ygMM",
            "submit-btn": "subcribeModal__submit-btn___KPyZB",
            "close-btn-new-light": "subcribeModal__close-btn-new-light___3ReKN",
            "close-btn-new-dark": "subcribeModal__close-btn-new-dark___3Ct7W",
            "activity-modal-link-no-show":
              "subcribeModal__activity-modal-link-no-show___EWBwV",
            "email-input": "subcribeModal__email-input___1SI4L",
            "subscribe-content": "subcribeModal__subscribe-content___2-wb7",
            note: "subcribeModal__note___mkiOO",
            btn: "subcribeModal__btn___3cqpO",
            success: "subcribeModal__success___1CSEs",
            "success-icon": "subcribeModal__success-icon___2vich",
            intro: "subcribeModal__intro___34zlx",
            "ok-btn": "subcribeModal__ok-btn___1St4G",
            hide: "subcribeModal__hide___1rscX",
            eyebrow: "subcribeModal__eyebrow___1VLd0",
            inputgroup: "subcribeModal__inputgroup___2BHRP",
            "input-theme-light": "subcribeModal__input-theme-light___1shlK",
            "input-theme-dark": "subcribeModal__input-theme-dark___1nOAh",
            "email-input-error": "subcribeModal__email-input-error___1zOgz",
            "spin-icon": "subcribeModal__spin-icon___wd1mz",
            "submit-text": "subcribeModal__submit-text___3Ne4j",
            "btn-margin-top": "subcribeModal__btn-margin-top___zL5Ze",
            "email-input-error-tip":
              "subcribeModal__email-input-error-tip___1TM74",
            show: "subcribeModal__show___3cD1X",
            "subscribe-modal-wrapper-pc":
              "subcribeModal__subscribe-modal-wrapper-pc___2CFgW",
            "success-content": "subcribeModal__success-content___2yfMl",
            "subscribe-modal-wrapper-mobile":
              "subcribeModal__subscribe-modal-wrapper-mobile___3gwVI",
            "success-content-wrapper":
              "subcribeModal__success-content-wrapper___2Kotc",
            "content-wrapper": "subcribeModal__content-wrapper___oqZNM",
            "hidden-text": "subcribeModal__hidden-text___1zSs9",
            "shown-text": "subcribeModal__shown-text___35eZ1",
          },
        };
      function M() {
        M = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: S(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var g = {};
        c(g, i, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          x = w && w(w(E([])));
        x && x !== n && o.call(x, i) && (g = x);
        var k = (v.prototype = y.prototype = Object.create(g));
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function I(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function S(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = j(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function j(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                j(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function T(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function C(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(T, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(k, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(k)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          O(I.prototype),
          c(I.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = I),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new I(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          O(k),
          c(k, s, "Generator"),
          c(k, i, function () {
            return this;
          }),
          c(k, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(C),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), C(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    C(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      function P(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      function E(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function L(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? E(Object(n), !0).forEach(function (t) {
                Object(_.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : E(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var B = function (e) {
          var t = e.btnStyle,
            n = e.textStyle,
            o = e.buttonText,
            a = e.width,
            r = e.onBtnClick;
          return T(
            "button",
            {
              className:
                "subcribeModal__btn___3cqpO subcribeModal__submit-btn___KPyZB subcribeModal__btn-margin-top___zL5Ze",
              type: "button",
              style: L(L({}, t), {}, { width: a }),
              onClick: r,
            },
            T(
              "span",
              { className: "subcribeModal__submit-text___3Ne4j", style: n },
              o,
            ),
          );
        },
        N = (function (e) {
          function t(e) {
            var n;
            return (
              Object(a.default)(this, t),
              (n = P(this, t, [e])),
              Object(_.a)(
                Object(s.a)(n),
                "handleCloseActivityModal",
                function () {
                  n.handleModalVisible({
                    visible: !1,
                    modalType: "activity",
                    category: "campaign_modal",
                    action: "click",
                    label: "store-or-login",
                  });
                },
              ),
              Object(_.a)(
                Object(s.a)(n),
                "handleActivityModalBtnClick",
                function () {
                  var e = (n.state.modalData.activityModalData || {})
                    .activityLink;
                  n.handleCloseActivityModal(), e && window.open(e);
                },
              ),
              Object(_.a)(Object(s.a)(n), "handleModalClose", function () {
                var e = n.state.modalData.modalType,
                  t = "activity" === e ? "campaign_modal" : "subscribe_modal";
                n.handleModalVisible({
                  visible: !1,
                  modalType: e,
                  category: t,
                  action: "click",
                  label: "close",
                });
              }),
              (n.state = {
                subscribeModalDisplayable: !1,
                subscribeModalUnlocked: !1,
                subscribeModalVisible: !1,
                subscribeModalEmail: "",
                subscribeModalCheckValid: !0,
                subscribeModalLoading: !1,
                subscribeModalSuccess: !1,
                inputBlurring: !0,
                errorTipHeight: 0,
                modalData: {},
              }),
              (n.setSubscribeModalVisible = n.setSubscribeModalVisible.bind(
                Object(s.a)(n),
              )),
              (n.handleModalInputKeyUp = n.handleModalInputKeyUp.bind(
                Object(s.a)(n),
              )),
              (n.timeout = null),
              n
            );
          }
          return (
            Object(c.a)(t, e),
            Object(r.default)(t, [
              {
                key: "isCn",
                get: function () {
                  return "zh-CN" === (this.props.localization || {}).language;
                },
              },
              {
                key: "handleData",
                value: (function () {
                  var e = Object(o.default)(
                    M().mark(function e() {
                      var t, n;
                      return M().wrap(
                        function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                return (
                                  (e.prev = 0),
                                  (e.next = 3),
                                  O.default.request(
                                    {
                                      name: "getSubscribeCompaign",
                                      method: "GET",
                                    },
                                    this.props.localization || {},
                                  )
                                );
                              case 3:
                                return (t = e.sent), (e.next = 6), t.json();
                              case 6:
                                return (n = e.sent), e.abrupt("return", n);
                              case 10:
                                return (
                                  (e.prev = 10),
                                  (e.t0 = e.catch(0)),
                                  this.sendGaAndCDP(
                                    "campaign_or_subscribe_modal",
                                    "request",
                                    "fail",
                                  ),
                                  e.abrupt("return", null)
                                );
                              case 14:
                              case "end":
                                return e.stop();
                            }
                        },
                        e,
                        this,
                        [[0, 10]],
                      );
                    }),
                  );
                  return function () {
                    return e.apply(this, arguments);
                  };
                })(),
              },
              {
                key: "handleModalType",
                value: (function () {
                  var e = Object(o.default)(
                    M().mark(function e() {
                      var t, n, o, a, r, i, l, s, c, _, u, d;
                      return M().wrap(
                        function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                if (
                                  ((t = this.props.context),
                                  (n = t.subdomain),
                                  (o = t.mobileMode),
                                  (a =
                                    /teaser|trailer/.test(
                                      window.location.href,
                                    ) ||
                                    (n && "enterprise" !== n)),
                                  (r = m.a.isStoreApp()),
                                  !(a || r || (n && this.isCn)))
                                ) {
                                  e.next = 5;
                                  break;
                                }
                                return e.abrupt("return");
                              case 5:
                                if (!n) {
                                  e.next = 8;
                                  break;
                                }
                                return (
                                  this.listenWhenToShowSubscribeModal(),
                                  e.abrupt("return")
                                );
                              case 8:
                                return (e.next = 10), this.handleData();
                              case 10:
                                if (
                                  ((i = e.sent),
                                  (l = (i || {}).items) &&
                                    Array.isArray(l) &&
                                    l.length)
                                ) {
                                  e.next = 14;
                                  break;
                                }
                                return e.abrupt("return");
                              case 14:
                                if (
                                  ((s = l[0]),
                                  (c = s.modalType),
                                  (_ = void 0 === c ? "subscribe" : c),
                                  (u = s.modalSlug),
                                  (d = s.showPC),
                                  (s.showMobile || !o) && (d || o))
                                ) {
                                  e.next = 18;
                                  break;
                                }
                                return e.abrupt("return");
                              case 18:
                                this.setState({ modalData: s }),
                                  "activity" === _
                                    ? this.listenWhenToShowActivityModal(u)
                                    : this.listenWhenToShowSubscribeModal();
                              case 20:
                              case "end":
                                return e.stop();
                            }
                        },
                        e,
                        this,
                      );
                    }),
                  );
                  return function () {
                    return e.apply(this, arguments);
                  };
                })(),
              },
              {
                key: "componentDidMount",
                value: function () {
                  var e = this;
                  this.handleModalType(),
                    (window.showModalImmediately = function () {
                      var t = e.state.modalData.modalType;
                      e.handleModalVisible({ visible: !0, modalType: t }),
                        clearTimeout(e.timeout);
                    });
                },
              },
              {
                key: "handleSubscribeOptimize",
                value: function () {
                  var e = this;
                  this.setState({ subscribeModalDisplayable: !0 });
                  var t;
                  this.unlockModal(),
                    (t = 5e4),
                    (e.timeout = setTimeout(function () {
                      e.setSubscribeModalVisible(!0, "countdown-".concat(t));
                    }, t));
                },
              },
              {
                key: "handleActivityOptimize",
                value: function () {
                  var e = this;
                  this.setState({ subscribeModalDisplayable: !0 });
                  var t;
                  this.unlockModal(),
                    (t = 5e4),
                    (e.timeout = setTimeout(function () {
                      e.setActivityModalVisible(!0);
                    }, t));
                },
              },
              {
                key: "listenWhenToShowSubscribeModal",
                value: function () {
                  Object(w.z)("subscribe-modal-show-flag") ||
                    Object(w.D)("subscribe-modal-submit-flag") ||
                    this.handleSubscribeOptimize();
                },
              },
              {
                key: "listenWhenToShowActivityModal",
                value: function (e) {
                  var t = Object(w.z)(e),
                    n = Object(w.D)(e);
                  t || n || this.handleActivityOptimize();
                },
              },
              {
                key: "sendGaAndCDP",
                value: function (e, t, n) {
                  (0, this.props.gaSend)(e, t, n);
                  var o =
                    "open" === t || "show" === t
                      ? j.a.SUBSCRIBE_MODAL_SHOW
                      : j.a.SUBSCRIBE_MODAL_CLICK;
                  Object(S.a)(o, { category: e, action: t, label: n });
                },
              },
              {
                key: "setSubscribeModalVisible",
                value: function (e, t) {
                  var n = this.state.subscribeModalSuccess;
                  e
                    ? (Object(w.ub)("subscribe-modal-show-flag", !0, 7),
                      this.sendGaAndCDP(
                        "subscribe_modal",
                        "open",
                        "when-".concat(t),
                      ))
                    : this.sendGaAndCDP(
                        "subscribe_modal",
                        "close",
                        "when-".concat(n ? "success" : "no-submit"),
                      ),
                    (document.querySelector("html").style.overflow = e
                      ? "hidden"
                      : ""),
                    this.setState({ subscribeModalVisible: e });
                },
              },
              {
                key: "setActivityModalVisible",
                value: function (e) {
                  var t = this.state.modalData.modalSlug,
                    n = void 0 === t ? "" : t;
                  e
                    ? (Object(w.ub)(n, !0, 7),
                      this.sendGaAndCDP(
                        "campaign_modal",
                        "show",
                        "when-countdown-".concat(5e4),
                      ))
                    : Object(w.vb)(n, !0),
                    (document.querySelector("html").style.overflow = e
                      ? "hidden"
                      : ""),
                    this.setState({ subscribeModalVisible: e });
                },
              },
              {
                key: "handleModalVisible",
                value: function (e) {
                  var t = e.modalType,
                    n = void 0 === t ? "subscribe" : t,
                    o = e.visible,
                    a = e.openTiming,
                    r = void 0 === a ? "countdown-".concat(5e4) : a,
                    i = e.category,
                    l = e.action,
                    s = e.label;
                  i && l && s && this.sendGaAndCDP(i, l, s),
                    "activity" === n
                      ? this.setActivityModalVisible(o)
                      : this.setSubscribeModalVisible(o, r);
                },
              },
              {
                key: "unlockModal",
                value: function () {
                  this.setState({ subscribeModalUnlocked: !0 });
                },
              },
              {
                key: "handleModalInputKeyUp",
                value: function () {
                  var e,
                    t = (this.props.localization || {}).language,
                    n = this.state.subscribeModalEmail;
                  (e = this.isCn ? Object(w.Fb)(n, t) : Object(w.Gb)(n)),
                    this.setState({ subscribeModalCheckValid: !n || e });
                },
              },
              {
                key: "handleModalSubmitClick",
                value: (function () {
                  var e = Object(o.default)(
                    M().mark(function e(t) {
                      var n,
                        o,
                        a,
                        r,
                        i,
                        l,
                        s,
                        c,
                        _,
                        u,
                        d,
                        p,
                        f,
                        h,
                        m,
                        y,
                        b,
                        v,
                        g,
                        x;
                      return M().wrap(
                        function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                if (
                                  ((r = this.props),
                                  (i = r.localization),
                                  (l = r.subdomainConfig),
                                  (s = r.context.subdomain),
                                  (_ = (c = i || {}).country),
                                  (u = c.language),
                                  w.Q &&
                                    window.ga &&
                                    window.ga(
                                      "send",
                                      "event",
                                      "subscribe_modal",
                                      "submit",
                                      "modal_subscribe",
                                    ),
                                  (d = this.state.subscribeModalEmail),
                                  this.isCn
                                    ? Object(w.Fb)(d, u)
                                    : Object(w.Gb)(d))
                                ) {
                                  e.next = 7;
                                  break;
                                }
                                return e.abrupt("return");
                              case 7:
                                return (
                                  (p = {}),
                                  (p = s
                                    ? {
                                        activity_activity_type: "".concat(
                                          s,
                                          "_subscribe",
                                        ),
                                        activity_email: d,
                                        activity_subscribe_source: "".concat(
                                          s,
                                          "_popup",
                                        ),
                                      }
                                    : L(
                                        L(
                                          {},
                                          this.isCn
                                            ? { activity_phone: d }
                                            : void 0,
                                        ),
                                        {},
                                        {
                                          email: this.isCn
                                            ? "".concat(
                                                new Date().getTime(),
                                                "@placeholder.com",
                                              )
                                            : d,
                                          subscribe_source: "official_popup",
                                          fMap: l && l.subscribeMap,
                                          activity_activity_type: t,
                                        },
                                      )),
                                  (f =
                                    w.Q &&
                                    (null === (n = window) || void 0 === n
                                      ? void 0
                                      : null === (o = n.ABTest) || void 0 === o
                                        ? void 0
                                        : null === (a = o.mapKeyToVar) ||
                                            void 0 === a
                                          ? void 0
                                          : a.subscribe_de_exp)),
                                  (h = ""),
                                  (m = "B" === f) &&
                                    ((p.exp_hit = f), (h = Object(w.xb)())),
                                  this.setState({ subscribeModalLoading: !0 }),
                                  (e.prev = 14),
                                  (e.next = 17),
                                  O.default.request(
                                    {
                                      name: s ? "createActivity" : "subscribe",
                                      method: "POST",
                                      data: p,
                                    },
                                    i,
                                  )
                                );
                              case 17:
                                return (y = e.sent), (e.next = 20), y.json();
                              case 20:
                                if (((b = e.sent), !m)) {
                                  e.next = 28;
                                  break;
                                }
                                return (
                                  (e.next = 24),
                                  I.a.request(
                                    {
                                      name: "subscribe",
                                      method: "POST",
                                      data: {
                                        country: _.toLowerCase(),
                                        language: u,
                                        source: "official_popup",
                                        email: d,
                                      },
                                    },
                                    {},
                                  )
                                );
                              case 24:
                                return (v = e.sent), (e.next = 27), v.json();
                              case 27:
                                g = e.sent;
                              case 28:
                                (x = !m || (g && 200 === g.status)),
                                  b && "200" == b.status && x
                                    ? (this.setState({
                                        subscribeModalLoading: !1,
                                        subscribeModalSuccess: !0,
                                      }),
                                      Object(w.vb)(
                                        "subscribe-modal-submit-flag",
                                        !0,
                                      ),
                                      this.sendGaAndCDP(
                                        "subscribe_modal",
                                        "submit",
                                        "email-ok",
                                      ))
                                    : (this.setState({
                                        subscribeModalLoading: !1,
                                      }),
                                      this.sendGaAndCDP(
                                        "subscribe_modal",
                                        "submit",
                                        "email-fail",
                                      )),
                                  Object(w.ob)(h),
                                  (e.next = 38);
                                break;
                              case 33:
                                (e.prev = 33),
                                  (e.t0 = e.catch(14)),
                                  this.setState({ subscribeModalLoading: !1 }),
                                  Object(w.ob)(h),
                                  this.sendGaAndCDP(
                                    "subscribe_modal",
                                    "submit",
                                    "email-fail",
                                  );
                              case 38:
                              case "end":
                                return e.stop();
                            }
                        },
                        e,
                        this,
                        [[14, 33]],
                      );
                    }),
                  );
                  return function (t) {
                    return e.apply(this, arguments);
                  };
                })(),
              },
              {
                key: "handleFontColor",
                value: function () {
                  var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : "prue",
                    t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : "#FFF",
                    n = {};
                  return (
                    "prue" === e
                      ? (n = { color: t })
                      : "gradient" === e &&
                        (n = {
                          color: "transparent",
                          backgroundImage: t,
                          WebkitBackgroundClip: "text",
                        }),
                    n
                  );
                },
              },
              {
                key: "handleBgColor",
                value: function () {
                  var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : "prue",
                    t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : "#FFF",
                    n = {};
                  return (
                    "prue" === e
                      ? (n = { backgroundColor: t })
                      : "gradient" === e && (n = { backgroundImage: t }),
                    n
                  );
                },
              },
              {
                key: "renderCommonContent",
                value: function (e) {
                  var t = e.t,
                    n = e.subdomain;
                  return T(
                    f.a.Fragment,
                    null,
                    T("h3", {
                      className: "subcribeModal__shown-text___35eZ1",
                      dangerouslySetInnerHTML: {
                        __html: t("subscribe-modal-info-title"),
                      },
                    }),
                    T("h3", {
                      className: "subcribeModal__hidden-text___1zSs9",
                      dangerouslySetInnerHTML: {
                        __html: t("v3.footer.subscribe_with_gift.t"),
                      },
                    }),
                    T("p", {
                      className:
                        "subcribeModal__intro___34zlx subcribeModal__shown-text___35eZ1",
                      dangerouslySetInnerHTML: {
                        __html: t("subscribe-modal-info-intro.".concat(n)),
                      },
                    }),
                    T("p", {
                      className:
                        "subcribeModal__intro___34zlx subcribeModal__hidden-text___1zSs9",
                      dangerouslySetInnerHTML: {
                        __html: t("v3.footer.subscribe_with_gift.p"),
                      },
                    }),
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.state,
                    n = t.subscribeModalDisplayable,
                    o = t.subscribeModalVisible,
                    a = t.subscribeModalEmail,
                    r = t.subscribeModalCheckValid,
                    i = t.subscribeModalLoading,
                    l = t.subscribeModalSuccess,
                    s = t.subscribeModalUnlocked,
                    c = t.inputBlurring,
                    _ = t.errorTipHeight,
                    u = t.modalData;
                  if (!n) return null;
                  var p = u.modalType,
                    h = u.showMobile,
                    m = u.showPC,
                    y = u.commonSetting,
                    b = void 0 === y ? {} : y,
                    g = u.styleSetting,
                    w = u.subscribeModalData,
                    x = u.activityModalData,
                    O = b || {},
                    I = O.bgImage,
                    S = O.bgImageMobile,
                    j = O.eyebrow,
                    M = O.title,
                    P = O.desc,
                    E = O.globalButtonText,
                    N = void 0 === E ? "" : E,
                    D = g || {},
                    z = D.eyebrowColorSelect,
                    A = D.eyebrowColor,
                    R = D.titleColorSelect,
                    F = D.titleColor,
                    V = D.descColorSelect,
                    H = D.descColor,
                    W = D.btnColorSelect,
                    U = D.btnColor,
                    G = D.btnTextColorSelect,
                    Y = D.btnTextColor,
                    q = D.closeBtnTheme,
                    X = D.btnWidthMobile,
                    Z = D.btnWidth,
                    K = x || {},
                    Q = K.containerHeight,
                    J = K.textHeight,
                    $ = K.paddingBottom,
                    ee = K.buttonText,
                    te = K.activityLink,
                    ne = (w || {}).activity_type,
                    oe = (w || {}).inputTheme,
                    ae = this.props,
                    re = ae.t,
                    ie = ae.maskCloseDisabled,
                    le = ae.context,
                    se = le.subdomain,
                    ce = le.mobileMode,
                    _e = ce ? S : I,
                    ue = "".concat(ce ? X : Z, "px"),
                    de = k()("subscribe-modal-wrapper", {
                      active: o,
                      unlocked: s,
                      "subscribe-modal-wrapper-mobile": ce,
                      "subscribe-modal-wrapper-pc": !ce,
                    }),
                    pe = i || l,
                    fe = k()("submit-text", { active: !pe }),
                    he = k()("spin-icon", { active: pe }),
                    me = k()("subscribe-content", { hide: l }),
                    ye = k()("success", {
                      active: l && o,
                      "success-content-wrapper": ce && J,
                    }),
                    be = c && !r,
                    ve = k()("modal-container", {
                      "activity-modal-container": p,
                    }),
                    ge = k()("close-btn", {
                      "close-btn-new-light": ce || "light" === q,
                      "close-btn-new-dark": !ce && "dark" === q,
                    }),
                    we = k()({
                      "email-input-error": !r,
                      "input-theme-light": "light" === oe,
                      "input-theme-dark": "dark" === oe,
                    });
                  if (!se && ((!h && ce) || (!m && !ce))) return null;
                  var xe = N || ee || re("subscribe-modal-submit-btn");
                  return T(
                    "div",
                    {
                      id: "subscribe__modal__wrapper",
                      className: d()(de, C, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    T("div", {
                      className: "subcribeModal__mask___1U31N",
                      onClick: function () {
                        ie || e.handleModalClose();
                      },
                    }),
                    T(
                      "div",
                      {
                        className: d()(ve, C, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      T(
                        "button",
                        {
                          type: "button",
                          onClick: this.handleModalClose,
                          className: d()(ge, C, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                        },
                        T(v.a, {
                          name: "times",
                          className: "subcribeModal__close-icon___jGbYH",
                        }),
                      ),
                      te &&
                        "activity" === p &&
                        T("a", {
                          href: te && "activity" === p ? te : "",
                          className:
                            "subcribeModal__activity-modal-link___3ygMM",
                          target: "_blank",
                          onClick: this.handleCloseActivityModal,
                        }),
                      T(
                        "div",
                        {
                          className: "subcribeModal__modal-content___10Q2_",
                          style: {
                            backgroundImage: _e && "url(".concat(_e, ")"),
                            height: ce && !se && "".concat(Q, "px"),
                          },
                        },
                        T(
                          "div",
                          { className: "subcribeModal__envelope___lnmda" },
                          se &&
                            T("div", {
                              className:
                                "subcribeModal__envelope-video-svg___2feIv",
                            }),
                        ),
                        T(
                          "div",
                          {
                            style: se
                              ? {}
                              : {
                                  minHeight:
                                    ce && J ? "".concat(J, "px") : "auto",
                                },
                            className: d()(ye, C, {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            }),
                          },
                          T(
                            "div",
                            {
                              className:
                                "subcribeModal__success-content___2yfMl",
                            },
                            T("div", {
                              className: "subcribeModal__success-icon___2vich",
                            }),
                            T("h3", {
                              dangerouslySetInnerHTML: {
                                __html: re("subscribe-modal-success-title"),
                              },
                              style: L(
                                {},
                                se ? {} : this.handleFontColor(R, F),
                              ),
                            }),
                            T("p", {
                              className:
                                "subcribeModal__intro___34zlx subcribeModal__shown-text___35eZ1",
                              dangerouslySetInnerHTML: {
                                __html: re("subscribe-modal-success-intro"),
                              },
                              style: L(
                                {},
                                se ? {} : this.handleFontColor(V, H),
                              ),
                            }),
                            T("p", {
                              className:
                                "subcribeModal__intro___34zlx subcribeModal__hidden-text___1zSs9",
                              dangerouslySetInnerHTML: {
                                __html: re(
                                  "v3.footer.subscribe_with_gift.modal_desc.success",
                                ),
                              },
                            }),
                            T(
                              "button",
                              {
                                className:
                                  "subcribeModal__btn___3cqpO subcribeModal__ok-btn___1St4G",
                                type: "button",
                                style: L(
                                  { marginTop: "24px" },
                                  se ? {} : this.handleBgColor(W, U),
                                ),
                                onClick: this.handleModalClose,
                              },
                              T(
                                "span",
                                {
                                  style: L(
                                    {},
                                    se ? {} : this.handleFontColor(G, Y),
                                  ),
                                },
                                re("subscribe-modal-ok-btn"),
                              ),
                            ),
                          ),
                        ),
                        T(
                          "div",
                          {
                            style: se
                              ? {}
                              : {
                                  minHeight:
                                    ce && J ? "".concat(J, "px") : "auto",
                                },
                            className: d()(me, C, {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            }),
                          },
                          T(
                            "div",
                            {
                              className:
                                "subcribeModal__content-wrapper___oqZNM",
                              style:
                                $ && ce
                                  ? { paddingBottom: "".concat($, "px") }
                                  : void 0,
                            },
                            se
                              ? this.renderCommonContent({
                                  t: re,
                                  subdomain: se,
                                })
                              : T(
                                  f.a.Fragment,
                                  null,
                                  j &&
                                    T(
                                      "p",
                                      {
                                        className:
                                          "subcribeModal__eyebrow___1VLd0",
                                        style: L(
                                          {},
                                          this.handleFontColor(z, A),
                                        ),
                                      },
                                      j,
                                    ),
                                  T(
                                    "h3",
                                    {
                                      className:
                                        "subcribeModal__shown-text___35eZ1",
                                      style: L({}, this.handleFontColor(R, F)),
                                    },
                                    M,
                                  ),
                                  T("h3", {
                                    className:
                                      "subcribeModal__hidden-text___1zSs9",
                                    dangerouslySetInnerHTML: {
                                      __html: re(
                                        "v3.footer.subscribe_with_gift.t",
                                      ),
                                    },
                                  }),
                                  T(
                                    "p",
                                    {
                                      className:
                                        "subcribeModal__intro___34zlx subcribeModal__shown-text___35eZ1",
                                      style: L({}, this.handleFontColor(V, H)),
                                    },
                                    P,
                                  ),
                                  T("p", {
                                    className:
                                      "subcribeModal__intro___34zlx subcribeModal__hidden-text___1zSs9",
                                    dangerouslySetInnerHTML: {
                                      __html: re(
                                        "v3.footer.subscribe_with_gift.p",
                                      ),
                                    },
                                  }),
                                ),
                            "activity" === p
                              ? T(B, {
                                  btnStyle: L({}, this.handleBgColor(W, U)),
                                  textStyle: L({}, this.handleFontColor(G, Y)),
                                  buttonText: xe,
                                  width: ue,
                                  onBtnClick: this.handleActivityModalBtnClick,
                                })
                              : T(
                                  f.a.Fragment,
                                  null,
                                  T(
                                    "div",
                                    {
                                      className:
                                        "subcribeModal__inputgroup___2BHRP",
                                    },
                                    T(
                                      "div",
                                      {
                                        className:
                                          "subcribeModal__email-input___1SI4L",
                                      },
                                      T("input", {
                                        placeholder: this.isCn
                                          ? re(
                                              "subscribe-modal-phone-input-placeholder",
                                            )
                                          : re(
                                              "subscribe-modal-email-input-placeholder",
                                            ),
                                        type: "input",
                                        value: a,
                                        onChange: function (t) {
                                          return e.setState({
                                            subscribeModalEmail: t.target.value,
                                          });
                                        },
                                        onFocus: function () {
                                          return e.setState({
                                            inputBlurring: !1,
                                          });
                                        },
                                        onBlur: function () {
                                          return e.setState({
                                            inputBlurring: !0,
                                          });
                                        },
                                        onKeyUp: this.handleModalInputKeyUp,
                                        autoComplete: "off",
                                        className: d()(we, C, {
                                          autoResolveMultipleImports: !0,
                                          handleMissingStyleName: "warn",
                                        }),
                                      }),
                                    ),
                                    T(
                                      "button",
                                      {
                                        className:
                                          "subcribeModal__btn___3cqpO subcribeModal__submit-btn___KPyZB",
                                        type: "button",
                                        style: L(
                                          L(
                                            {},
                                            se ? {} : this.handleBgColor(W, U),
                                          ),
                                          {},
                                          { width: ue },
                                        ),
                                        onClick: function () {
                                          return e.handleModalSubmitClick(ne);
                                        },
                                      },
                                      T(
                                        "span",
                                        null,
                                        T(v.a, {
                                          name: "circle-notch",
                                          spin: !0,
                                          className: d()(he, C, {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          }),
                                        }),
                                        T(
                                          "span",
                                          {
                                            style: L(
                                              {},
                                              se
                                                ? {}
                                                : this.handleFontColor(G, Y),
                                            ),
                                            className: d()(fe, C, {
                                              autoResolveMultipleImports: !0,
                                              handleMissingStyleName: "warn",
                                            }),
                                          },
                                          se
                                            ? re("subscribe-modal-submit-btn")
                                            : xe,
                                        ),
                                      ),
                                    ),
                                  ),
                                  T(
                                    "div",
                                    {
                                      style: {
                                        maxHeight: be
                                          ? _
                                            ? "".concat(_ + 8, "px")
                                            : "40px"
                                          : 0,
                                      },
                                      className: d()(
                                        "email-input-error-tip".concat(
                                          be ? " show" : "",
                                        ),
                                        C,
                                        {
                                          autoResolveMultipleImports: !0,
                                          handleMissingStyleName: "warn",
                                        },
                                      ),
                                    },
                                    T(v.a, { name: "times-circle" }),
                                    T("span", {
                                      dangerouslySetInnerHTML: {
                                        __html: this.isCn
                                          ? re(
                                              "subscribe-modal-phone-input-error-tip",
                                            )
                                          : re(
                                              "subscribe-modal-email-input-error-tip",
                                            ),
                                      },
                                      ref: function (t) {
                                        t &&
                                          !e.errorHeightSet &&
                                          t.offsetHeight &&
                                          ((e.errorHeightSet = !0),
                                          e.setState({
                                            errorTipHeight: t.offsetHeight,
                                          }));
                                      },
                                    }),
                                  ),
                                  T("p", {
                                    className: "subcribeModal__note___mkiOO",
                                    dangerouslySetInnerHTML: {
                                      __html: re(
                                        se
                                          ? "subscribe-modal-info-privacy-note"
                                          : "subscribe-modal-info-privacy-note-color",
                                      ),
                                    },
                                  }),
                                ),
                          ),
                        ),
                      ),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(f.a.Component);
      N.defaultProps = {
        maskCloseDisabled: !1,
        t: function (e) {
          return "".concat(e);
        },
        gaSend: function () {},
      };
      var D = Object(g.b)(function (e) {
        return { localization: e.localization, context: e.context };
      })(N);
      t.a = Object(y.a)(D);
    },
    TuGD: function (e, t, n) {
      var o = n("UWiX")("iterator"),
        a = !1;
      try {
        var r = [7][o]();
        (r.return = function () {
          a = !0;
        }),
          Array.from(r, function () {
            throw 2;
          });
      } catch (i) {}
      e.exports = function (e, t) {
        if (!t && !a) return !1;
        var n = !1;
        try {
          var r = [7],
            l = r[o]();
          (l.next = function () {
            return { done: (n = !0) };
          }),
            (r[o] = function () {
              return l;
            }),
            e(r);
        } catch (i) {}
        return n;
      };
    },
    "U+KD": function (e, t, n) {
      var o = n("B+OT"),
        a = n("JB68"),
        r = n("VVlx")("IE_PROTO"),
        i = Object.prototype;
      e.exports =
        Object.getPrototypeOf ||
        function (e) {
          return (
            (e = a(e)),
            o(e, r)
              ? e[r]
              : "function" == typeof e.constructor && e instanceof e.constructor
                ? e.constructor.prototype
                : e instanceof Object
                  ? i
                  : null
          );
        };
    },
    UG0I: function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return o;
      }),
        n.d(t, "c", function () {
          return a;
        }),
        n.d(t, "a", function () {
          return r;
        });
      var o = {
          showModal: {
            label: "\u662f\u5426\u5c55\u793a\u5f39\u7a97",
            props: {
              showModal: {
                label: "\u662f\u5426\u5c55\u793a\u4e3a\u5f39\u7a97",
                type: "boolean",
              },
            },
          },
          fadeAnimation: {
            label: "\u8fdb\u573a\u6548\u679c",
            props: {
              disableFadeAnimation: {
                label:
                  "\u7981\u6b62\u9ed8\u8ba4\u6e10\u663e(fade-in)\u52a8\u6548",
                type: "boolean",
              },
            },
          },
          pcContentSetting3dStyle: {
            label: "\u964d\u7ea7/\u6a21\u578b\u6570\u91cf\u914d\u7f6e",
            props: {
              closeFold: {
                label: "\u662f\u5426\u53ea\u5c55\u793a\u4e00\u4e2a\u6a21\u578b",
                type: "boolean",
              },
              qqDowngrade: {
                type: "boolean",
                label: "QQ\u6d4f\u89c8\u5668\u662f\u5426\u964d\u7ea7",
              },
            },
          },
          unfold: {
            label: "\u6a21\u5f0f\u4e00\u914d\u7f6e",
            props: {
              unfoldNormalArModelUrl: {
                type: "string",
                label: "3d-\u6a21\u578b\u6587\u4ef6 [.glb]",
                content: "url",
              },
              unfoldModelLightUrl: {
                type: "string",
                label: "3d-\u73af\u5883\u5149\u6587\u4ef6 [.hdr]",
                content: "url",
              },
              ieUnfoldModelImg: {
                type: "image",
                label: "3d-\u6a21\u578bIE\u964d\u7ea7\u56fe",
              },
              unfoldArQcImg: {
                type: "image",
                label: "AR-\u9884\u89c8\u4e8c\u7ef4\u7801",
                helptext:
                  "\u4e8c\u7ef4\u7801\u5bf9\u5e94\u94fe\u63a5\uff1ahttps://www.dji.com/[\u4ea7\u54c1slug]/3d?modelType=unfold",
              },
              arUnfoldModelPosterUrl: {
                type: "image",
                label: "AR-\u793a\u610f\u56fe",
              },
              unfoldModelCameraOrbit: {
                type: "string",
                label: "3d-\u521d\u59cb\u89d2\u5ea6\u8c03\u6574",
                helptext:
                  '\uff08\u683c\u5f0f\uff1a"\u6a2a\u5411\u89d2\u5ea6 \u7eb5\u5411\u89d2\u5ea6 \u5230\u76f8\u673a\u7684\u8ddd\u79bb"\uff0c\u53c2\u8003\uff1a"40deg 75deg 100%"\uff09\u5efa\u8bae\u4ec5\u4fee\u6539\u524d\u4e24\u4e2a\u89d2\u5ea6\u53d8\u91cf',
              },
              unfoldModelCameraDist: {
                type: "string",
                label: "3d-\u5230\u76f8\u673a\u7684\u8ddd\u79bb",
                helptext:
                  "\uff08\u5355\u4f4d\uff1am, \u6839\u636e\u4e0d\u540c\u6a21\u578b\u8bbe\u8ba1\u5e08\u6216\u5f00\u53d1\u624b\u52a8\u8c03\u6574\u5927\u5c0f\uff0c\u53c2\u8003\u683c\u5f0f: 500m\uff09",
              },
              unfoldModelExposure: {
                type: "string",
                label: "3d-\u66dd\u5149\uff080.0\uff5e1.0\uff09",
              },
            },
          },
          fold: {
            label: "\u6a21\u5f0f\u4e8c\u914d\u7f6e",
            props: {
              foldNormalArModelUrl: {
                type: "string",
                label: "3d-\u6a21\u578b\u6587\u4ef6 [.glb]",
                content: "url",
              },
              foldModelLightUrl: {
                type: "string",
                label: "3d-\u73af\u5883\u5149\u6587\u4ef6 [.hdr]",
                content: "url",
              },
              ieFoldModelImg: {
                type: "image",
                label: "3d-\u6a21\u578bIE\u964d\u7ea7\u56fe",
              },
              foldArQcImg: {
                type: "image",
                label: "AR-\u9884\u89c8\u4e8c\u7ef4\u7801",
                helptext:
                  "\u4e8c\u7ef4\u7801\u5bf9\u5e94\u94fe\u63a5\uff1ahttps://www.dji.com/[\u4ea7\u54c1slug]/3d?modelType=fold",
              },
              arFoldModelPosterUrl: {
                type: "image",
                label: "AR-\u793a\u610f\u56fe",
              },
              foldModelCameraOrbit: {
                type: "string",
                label: "3d-\u521d\u59cb\u89d2\u5ea6\u8c03\u6574",
                helptext:
                  '\uff08\u683c\u5f0f\uff1a"\u6a2a\u5411\u89d2\u5ea6 \u7eb5\u5411\u89d2\u5ea6 \u5230\u76f8\u673a\u7684\u8ddd\u79bb"\uff0c\u53c2\u8003\uff1a"40deg 75deg 100%"\uff09\u5efa\u8bae\u4ec5\u4fee\u6539\u524d\u4e24\u4e2a\u89d2\u5ea6\u53d8\u91cf',
              },
              foldModelCameraDist: {
                type: "string",
                label: "3d-\u5230\u76f8\u673a\u7684\u8ddd\u79bb",
                helptext:
                  "\uff08\u5355\u4f4d\uff1am, \u6839\u636e\u4e0d\u540c\u6a21\u578b\u8bbe\u8ba1\u5e08\u6216\u5f00\u53d1\u624b\u52a8\u8c03\u6574\u5927\u5c0f\uff0c\u53c2\u8003\u683c\u5f0f: 500m\uff09",
              },
              foldModelExposure: {
                type: "string",
                label: "3d-\u66dd\u5149\uff080.0\uff5e1.0\uff09",
              },
            },
          },
          thirdModel: {
            label: "\u6a21\u5f0f\u4e09\u914d\u7f6e",
            switch: "hasThirdMode",
            props: {
              thirdTabsName: {
                type: "string",
                content: "text",
                label: "\u6a21\u5f0f\u4e09 Tab/Button \u6587\u6848",
              },
              thirdNormalArModelUrl: {
                type: "string",
                label: "3d-\u6a21\u578b\u6587\u4ef6 [.glb]",
                content: "url",
              },
              thirdModelLightUrl: {
                type: "string",
                label: "3d-\u73af\u5883\u5149\u6587\u4ef6 [.hdr]",
                content: "url",
              },
              ieThirdModelImg: {
                type: "image",
                label: "3d-\u6a21\u578bIE\u964d\u7ea7\u56fe",
              },
              thirdArQcImg: {
                type: "image",
                label: "AR-\u9884\u89c8\u4e8c\u7ef4\u7801",
                helptext:
                  "\u4e8c\u7ef4\u7801\u5bf9\u5e94\u94fe\u63a5\uff1ahttps://www.dji.com/[\u4ea7\u54c1slug]/3d?modelType=third",
              },
              arThirdModelPosterUrl: {
                type: "image",
                label: "AR-\u793a\u610f\u56fe",
              },
              thirdModelCameraOrbit: {
                type: "string",
                label: "3d-\u521d\u59cb\u89d2\u5ea6\u8c03\u6574",
                helptext:
                  '\uff08\u683c\u5f0f\uff1a"\u6a2a\u5411\u89d2\u5ea6 \u7eb5\u5411\u89d2\u5ea6 \u5230\u76f8\u673a\u7684\u8ddd\u79bb"\uff0c\u53c2\u8003\uff1a"40deg 75deg 100%"\uff09\u5efa\u8bae\u4ec5\u4fee\u6539\u524d\u4e24\u4e2a\u89d2\u5ea6\u53d8\u91cf',
              },
              thirdModelCameraDist: {
                type: "string",
                label: "3d-\u5230\u76f8\u673a\u7684\u8ddd\u79bb",
                helptext:
                  "\uff08\u5355\u4f4d\uff1am, \u6839\u636e\u4e0d\u540c\u6a21\u578b\u8bbe\u8ba1\u5e08\u6216\u5f00\u53d1\u624b\u52a8\u8c03\u6574\u5927\u5c0f\uff0c\u53c2\u8003\u683c\u5f0f: 500m\uff09",
              },
              thirdModelExposure: {
                type: "string",
                label: "3d-\u66dd\u5149\uff080.0\uff5e1.0\uff09",
              },
            },
          },
          sectionTopText: {
            label: "\u6807\u9898\u6587\u6848",
            props: {
              mainTitle: {
                type: "string",
                content: "text",
                label: "\u5927\u6807\u9898",
              },
              mainDesc: {
                type: "string",
                content: "text",
                label: "\u63cf\u8ff0",
              },
            },
          },
          text3dar: {
            label: "3D/AR Tab/Button \u6587\u6848",
            props: {
              modelTabsName: { type: "string", content: "text", label: "3d" },
              modelArTabsName: { type: "string", content: "text", label: "AR" },
            },
          },
          modelText: {
            label: "\u6a21\u5f0f\u6587\u6848",
            props: {
              unfoldTabsName: {
                type: "string",
                content: "text",
                label: "\u6a21\u5f0f\u4e00 Tab/Button \u6587\u6848",
              },
              foldTabsName: {
                type: "string",
                content: "text",
                label: "\u6a21\u5f0f\u4e8c Tab/Button \u6587\u6848",
              },
            },
          },
          text3d: {
            label: "3D \u6a21\u5757\u5185\u6587\u6848",
            props: {
              modelFirstTitle: {
                type: "string",
                content: "text",
                label: "3d\u6a21\u578b-\u6807\u9898",
              },
              modelDesc: {
                type: "string",
                content: "text",
                label: "3d\u6a21\u578b-\u63cf\u8ff0\u6587\u5b57",
              },
              modelLoadDesc: {
                type: "string",
                content: "text",
                label: "3d\u6a21\u578b-loading\u52a0\u8f7d\u4e2d\u63d0\u793a",
              },
            },
          },
          textAr: {
            label: "AR \u6a21\u5757\u5185\u6587\u6848",
            props: {
              modelArFirstTitle: {
                type: "string",
                content: "text",
                label: "AR-\u6a21\u5757\u5185\u6807\u9898",
              },
              modelArDesc: {
                type: "string",
                content: "text",
                label: "AR-\u63cf\u8ff0\u6587\u5b57",
              },
              arModelSizeTips: {
                type: "string",
                content: "text",
                label:
                  "AR-\u63d0\u793a\u7b2c1\u884c-\u6a21\u578b\u5c3a\u5bf8\u63d0\u793a",
              },
              arModelSupportTips: {
                type: "string",
                content: "text",
                label:
                  "AR-\u63d0\u793a\u7b2c2\u884c-\u6a21\u578b\u652f\u6301\u60c5\u51b5\u63d0\u793a",
              },
            },
          },
        },
        a = {
          themeForModelViewer: {
            label: "3D \u4e3b\u9898\u914d\u7f6e",
            props: {
              theme: {
                type: "select",
                label: "\u4e3b\u9898\u8272",
                items: [
                  { label: "\u9ed1\u5e95\u767d\u5b57", value: "dark" },
                  { label: "\u767d\u5e95\u9ed1\u5b57", value: "light" },
                ],
              },
            },
          },
        },
        r = {
          mainTitle: "v4.product_161.modelviewer.mainTitle",
          mainDesc: "v4.product_161.modelviewer.mainDesc",
          modelTabsName: "v4.product_161.modelviewer.modelTabsName",
          modelFirstTitle: "v4.product_161.modelviewer.modelFirstTitle",
          modelDesc: "v4.product_161.modelviewer.modelDesc",
          foldTabsName: "v4.product_161.modelviewer.foldTabsName",
          foldNormalArModelUrl: {
            path: "v4.product_161.modelviewer.foldNormalArModelUrl",
          },
          foldModelLightUrl: { path: "" },
          foldArQcImg: "v4.product_161.modelviewer.foldArQcImg",
          foldModelCameraOrbit:
            "v4.product_161.modelviewer.foldModelCameraOrbit",
          foldModelCameraDist: "v4.product_161.modelviewer.foldModelCameraDist",
          foldModelExposure: "v4.product_161.modelviewer.foldModelExposure",
          ieFoldModelImg: "v4.product_161.modelviewer.ieFoldModelImg",
          arFoldModelPosterUrl:
            "v4.product_161.modelviewer.arFoldModelPosterUrl",
          unfoldTabsName: "v4.product_161.modelviewer.unfoldTabsName",
          arUnfoldModelPosterUrl:
            "v4.product_161.modelviewer.arUnfoldModelPosterUrl",
          unfoldNormalArModelUrl: {
            path: "v4.product_161.modelviewer.unfoldNormalArModelUrl",
          },
          unfoldModelLightUrl: { path: "" },
          unfoldArQcImg: "v4.product_161.modelviewer.unfoldArQcImg",
          unfoldModelCameraOrbit:
            "v4.product_161.modelviewer.unfoldModelCameraOrbit",
          unfoldModelCameraDist:
            "v4.product_161.modelviewer.unfoldModelCameraDist",
          unfoldModelExposure: "v4.product_161.modelviewer.unfoldModelExposure",
          ieUnfoldModelImg: "v4.product_161.modelviewer.ieUnfoldModelImg",
          thirdTabsName: "v4.product_161.modelviewer.thirdTabsName",
          arThirdModelPosterUrl:
            "v4.product_161.modelviewer.arThirdModelPosterUrl",
          thirdNormalArModelUrl: {
            path: "v4.product_161.modelviewer.thirdNormalArModelUrl",
          },
          thirdModelLightUrl: { path: "" },
          thirdArQcImg: "v4.product_161.modelviewer.thirdArQcImg",
          thirdModelCameraOrbit:
            "v4.product_161.modelviewer.thirdModelCameraOrbit",
          thirdModelCameraDist:
            "v4.product_161.modelviewer.thirdModelCameraDist",
          thirdModelExposure: "v4.product_161.modelviewer.thirdModelExposure",
          ieThirdModelImg: "v4.product_161.modelviewer.ieThirdModelImg",
          modelLoadDesc: "v4.product_161.modelviewer.modelLoadDesc",
          modelArTabsName: "v4.product_161.modelviewer.modelArTabsName",
          modelArFirstTitle: "v4.product_161.modelviewer.modelArFirstTitle",
          modelArDesc: "v4.product_161.modelviewer.modelArDesc",
          arModelSizeTips: "v4.product_161.modelviewer.arModelSizeTips",
          arModelSupportTips: "v4.product_161.modelviewer.arModelSupportTips",
          customBackgroundColor: "",
          theme: "dark",
          showModal: !0,
        };
    },
    "UNi/": function (e, t) {
      e.exports = function (e, t) {
        for (var n = -1, o = Array(e); ++n < e; ) o[n] = t(n);
        return o;
      };
    },
    UO39: function (e, t) {
      e.exports = function (e, t) {
        return { value: t, done: !!e };
      };
    },
    UUyv: function (e, t, n) {
      (() => {
        var t = {
            296: (e, t, n) => {
              var o = /^\s+|\s+$/g,
                a = /^[-+]0x[0-9a-f]+$/i,
                r = /^0b[01]+$/i,
                i = /^0o[0-7]+$/i,
                l = parseInt,
                s =
                  "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
                c =
                  "object" == typeof self &&
                  self &&
                  self.Object === Object &&
                  self,
                _ = s || c || Function("return this")(),
                u = Object.prototype.toString,
                d = Math.max,
                p = Math.min,
                f = function () {
                  return _.Date.now();
                };
              function h(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
              }
              function m(e) {
                if ("number" == typeof e) return e;
                if (
                  (function (e) {
                    return (
                      "symbol" == typeof e ||
                      ((function (e) {
                        return !!e && "object" == typeof e;
                      })(e) &&
                        "[object Symbol]" == u.call(e))
                    );
                  })(e)
                )
                  return NaN;
                if (h(e)) {
                  var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                  e = h(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var n = r.test(e);
                return n || i.test(e)
                  ? l(e.slice(2), n ? 2 : 8)
                  : a.test(e)
                    ? NaN
                    : +e;
              }
              e.exports = function (e, t, n) {
                var o,
                  a,
                  r,
                  i,
                  l,
                  s,
                  c = 0,
                  _ = !1,
                  u = !1,
                  y = !0;
                if ("function" != typeof e)
                  throw new TypeError("Expected a function");
                function b(t) {
                  var n = o,
                    r = a;
                  return (o = a = void 0), (c = t), (i = e.apply(r, n));
                }
                function v(e) {
                  var n = e - s;
                  return void 0 === s || n >= t || n < 0 || (u && e - c >= r);
                }
                function g() {
                  var e = f();
                  if (v(e)) return w(e);
                  l = setTimeout(
                    g,
                    (function (e) {
                      var n = t - (e - s);
                      return u ? p(n, r - (e - c)) : n;
                    })(e),
                  );
                }
                function w(e) {
                  return (l = void 0), y && o ? b(e) : ((o = a = void 0), i);
                }
                function x() {
                  var e = f(),
                    n = v(e);
                  if (((o = arguments), (a = this), (s = e), n)) {
                    if (void 0 === l)
                      return (function (e) {
                        return (c = e), (l = setTimeout(g, t)), _ ? b(e) : i;
                      })(s);
                    if (u) return (l = setTimeout(g, t)), b(s);
                  }
                  return void 0 === l && (l = setTimeout(g, t)), i;
                }
                return (
                  (t = m(t) || 0),
                  h(n) &&
                    ((_ = !!n.leading),
                    (r = (u = "maxWait" in n) ? d(m(n.maxWait) || 0, t) : r),
                    (y = "trailing" in n ? !!n.trailing : y)),
                  (x.cancel = function () {
                    void 0 !== l && clearTimeout(l),
                      (c = 0),
                      (o = s = a = l = void 0);
                  }),
                  (x.flush = function () {
                    return void 0 === l ? i : w(f());
                  }),
                  x
                );
              };
            },
            96: (e, t, n) => {
              var o = "Expected a function",
                a = NaN,
                r = "[object Symbol]",
                i = /^\s+|\s+$/g,
                l = /^[-+]0x[0-9a-f]+$/i,
                s = /^0b[01]+$/i,
                c = /^0o[0-7]+$/i,
                _ = parseInt,
                u =
                  "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
                d =
                  "object" == typeof self &&
                  self &&
                  self.Object === Object &&
                  self,
                p = u || d || Function("return this")(),
                f = Object.prototype.toString,
                h = Math.max,
                m = Math.min,
                y = function () {
                  return p.Date.now();
                };
              function b(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
              }
              function v(e) {
                if ("number" == typeof e) return e;
                if (
                  (function (e) {
                    return (
                      "symbol" == typeof e ||
                      ((function (e) {
                        return !!e && "object" == typeof e;
                      })(e) &&
                        f.call(e) == r)
                    );
                  })(e)
                )
                  return a;
                if (b(e)) {
                  var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                  e = b(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(i, "");
                var n = s.test(e);
                return n || c.test(e)
                  ? _(e.slice(2), n ? 2 : 8)
                  : l.test(e)
                    ? a
                    : +e;
              }
              e.exports = function (e, t, n) {
                var a = !0,
                  r = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return (
                  b(n) &&
                    ((a = "leading" in n ? !!n.leading : a),
                    (r = "trailing" in n ? !!n.trailing : r)),
                  (function (e, t, n) {
                    var a,
                      r,
                      i,
                      l,
                      s,
                      c,
                      _ = 0,
                      u = !1,
                      d = !1,
                      p = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function f(t) {
                      var n = a,
                        o = r;
                      return (a = r = void 0), (_ = t), (l = e.apply(o, n));
                    }
                    function g(e) {
                      var n = e - c;
                      return (
                        void 0 === c || n >= t || n < 0 || (d && e - _ >= i)
                      );
                    }
                    function w() {
                      var e = y();
                      if (g(e)) return x(e);
                      s = setTimeout(
                        w,
                        (function (e) {
                          var n = t - (e - c);
                          return d ? m(n, i - (e - _)) : n;
                        })(e),
                      );
                    }
                    function x(e) {
                      return (
                        (s = void 0), p && a ? f(e) : ((a = r = void 0), l)
                      );
                    }
                    function k() {
                      var e = y(),
                        n = g(e);
                      if (((a = arguments), (r = this), (c = e), n)) {
                        if (void 0 === s)
                          return (function (e) {
                            return (
                              (_ = e), (s = setTimeout(w, t)), u ? f(e) : l
                            );
                          })(c);
                        if (d) return (s = setTimeout(w, t)), f(c);
                      }
                      return void 0 === s && (s = setTimeout(w, t)), l;
                    }
                    return (
                      (t = v(t) || 0),
                      b(n) &&
                        ((u = !!n.leading),
                        (i = (d = "maxWait" in n)
                          ? h(v(n.maxWait) || 0, t)
                          : i),
                        (p = "trailing" in n ? !!n.trailing : p)),
                      (k.cancel = function () {
                        void 0 !== s && clearTimeout(s),
                          (_ = 0),
                          (a = c = r = s = void 0);
                      }),
                      (k.flush = function () {
                        return void 0 === s ? l : x(y());
                      }),
                      k
                    );
                  })(e, t, { leading: a, maxWait: t, trailing: r })
                );
              };
            },
            703: (e, t, n) => {
              "use strict";
              var o = n(414);
              function a() {}
              function r() {}
              (r.resetWarningCache = a),
                (e.exports = function () {
                  function e(e, t, n, a, r, i) {
                    if (i !== o) {
                      var l = new Error(
                        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types",
                      );
                      throw ((l.name = "Invariant Violation"), l);
                    }
                  }
                  function t() {
                    return e;
                  }
                  e.isRequired = e;
                  var n = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: r,
                    resetWarningCache: a,
                  };
                  return (n.PropTypes = n), n;
                });
            },
            697: (e, t, n) => {
              e.exports = n(703)();
            },
            414: (e) => {
              "use strict";
              e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            },
          },
          o = {};
        function a(e) {
          var n = o[e];
          if (void 0 !== n) return n.exports;
          var r = (o[e] = { exports: {} });
          return t[e](r, r.exports, a), r.exports;
        }
        (a.n = (e) => {
          var t = e && e.__esModule ? () => e.default : () => e;
          return a.d(t, { a: t }), t;
        }),
          (a.d = (e, t) => {
            for (var n in t)
              a.o(t, n) &&
                !a.o(e, n) &&
                Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
          }),
          (a.g = (function () {
            if ("object" == typeof globalThis) return globalThis;
            try {
              return this || new Function("return this")();
            } catch (t) {
              if ("object" == typeof window) return window;
            }
          })()),
          (a.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
          (a.r = (e) => {
            "undefined" != typeof Symbol &&
              Symbol.toStringTag &&
              Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
              Object.defineProperty(e, "__esModule", { value: !0 });
          });
        var r = {};
        (() => {
          "use strict";
          a.r(r),
            a.d(r, {
              LazyLoadComponent: () => Y,
              LazyLoadImage: () => oe,
              trackWindowScroll: () => N,
            });
          const e = n("q1tI");
          var t = a.n(e),
            o = a(697);
          const i = n("i8i4");
          var l = a.n(i);
          function s() {
            return (
              "undefined" != typeof window &&
              "IntersectionObserver" in window &&
              "isIntersecting" in window.IntersectionObserverEntry.prototype
            );
          }
          function c(e) {
            return (c =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function _(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);
              t &&
                (o = o.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, o);
            }
            return n;
          }
          function u(e, t, n) {
            return (
              (t = p(t)) in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function d(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              (o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                "value" in o && (o.writable = !0),
                Object.defineProperty(e, p(o.key), o);
            }
          }
          function p(e) {
            var t = (function (e, t) {
              if ("object" !== c(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 !== n) {
                var o = n.call(e, "string");
                if ("object" !== c(o)) return o;
                throw new TypeError(
                  "@@toPrimitive must return a primitive value.",
                );
              }
              return String(e);
            })(e);
            return "symbol" === c(t) ? t : String(t);
          }
          function f(e, t) {
            return (f = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
          }
          function h(e) {
            return (h = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          var m = function (e) {
              e.forEach(function (e) {
                e.isIntersecting && e.target.onVisible();
              });
            },
            y = {},
            b = (function (e) {
              !(function (e, t) {
                if ("function" != typeof t && null !== t)
                  throw new TypeError(
                    "Super expression must either be null or a function",
                  );
                (e.prototype = Object.create(t && t.prototype, {
                  constructor: { value: e, writable: !0, configurable: !0 },
                })),
                  Object.defineProperty(e, "prototype", { writable: !1 }),
                  t && f(e, t);
              })(p, e);
              var n,
                o,
                a,
                r,
                i =
                  ((a = p),
                  (r = (function () {
                    if ("undefined" == typeof Reflect || !Reflect.construct)
                      return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                      return (
                        Boolean.prototype.valueOf.call(
                          Reflect.construct(Boolean, [], function () {}),
                        ),
                        !0
                      );
                    } catch (e) {
                      return !1;
                    }
                  })()),
                  function () {
                    var e,
                      t = h(a);
                    if (r) {
                      var n = h(this).constructor;
                      e = Reflect.construct(t, arguments, n);
                    } else e = t.apply(this, arguments);
                    return (function (e, t) {
                      if (t && ("object" === c(t) || "function" == typeof t))
                        return t;
                      if (void 0 !== t)
                        throw new TypeError(
                          "Derived constructors may only return object or undefined",
                        );
                      return (function (e) {
                        if (void 0 === e)
                          throw new ReferenceError(
                            "this hasn't been initialised - super() hasn't been called",
                          );
                        return e;
                      })(e);
                    })(this, e);
                  });
              function p(e) {
                var t;
                if (
                  ((function (e, t) {
                    if (!(e instanceof t))
                      throw new TypeError("Cannot call a class as a function");
                  })(this, p),
                  ((t = i.call(this, e)).supportsObserver =
                    !e.scrollPosition && e.useIntersectionObserver && s()),
                  t.supportsObserver)
                ) {
                  var n = e.threshold;
                  t.observer = (function (e) {
                    return (
                      (y[e] =
                        y[e] ||
                        new IntersectionObserver(m, { rootMargin: e + "px" })),
                      y[e]
                    );
                  })(n);
                }
                return t;
              }
              return (
                (n = p),
                (o = [
                  {
                    key: "componentDidMount",
                    value: function () {
                      this.placeholder &&
                        this.observer &&
                        ((this.placeholder.onVisible = this.props.onVisible),
                        this.observer.observe(this.placeholder)),
                        this.supportsObserver || this.updateVisibility();
                    },
                  },
                  {
                    key: "componentWillUnmount",
                    value: function () {
                      this.observer &&
                        this.placeholder &&
                        this.observer.unobserve(this.placeholder);
                    },
                  },
                  {
                    key: "componentDidUpdate",
                    value: function () {
                      this.supportsObserver || this.updateVisibility();
                    },
                  },
                  {
                    key: "getPlaceholderBoundingBox",
                    value: function () {
                      var e =
                          arguments.length > 0 && void 0 !== arguments[0]
                            ? arguments[0]
                            : this.props.scrollPosition,
                        t = this.placeholder.getBoundingClientRect(),
                        n = l().findDOMNode(this.placeholder).style,
                        o =
                          parseInt(n.getPropertyValue("margin-left"), 10) || 0,
                        a = parseInt(n.getPropertyValue("margin-top"), 10) || 0;
                      return {
                        bottom: e.y + t.bottom + a,
                        left: e.x + t.left + o,
                        right: e.x + t.right + o,
                        top: e.y + t.top + a,
                      };
                    },
                  },
                  {
                    key: "isPlaceholderInViewport",
                    value: function () {
                      if ("undefined" == typeof window || !this.placeholder)
                        return !1;
                      var e = this.props,
                        t = e.scrollPosition,
                        n = e.threshold,
                        o = this.getPlaceholderBoundingBox(t),
                        a = t.y + window.innerHeight,
                        r = t.x,
                        i = t.x + window.innerWidth,
                        l = t.y;
                      return Boolean(
                        l - n <= o.bottom &&
                          a + n >= o.top &&
                          r - n <= o.right &&
                          i + n >= o.left,
                      );
                    },
                  },
                  {
                    key: "updateVisibility",
                    value: function () {
                      this.isPlaceholderInViewport() && this.props.onVisible();
                    },
                  },
                  {
                    key: "render",
                    value: function () {
                      var e = this,
                        n = this.props,
                        o = n.className,
                        a = n.height,
                        r = n.placeholder,
                        i = n.style,
                        l = n.width;
                      if (r && "function" != typeof r.type)
                        return t().cloneElement(r, {
                          ref: function (t) {
                            return (e.placeholder = t);
                          },
                        });
                      var s = (function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                          var n = null != arguments[t] ? arguments[t] : {};
                          t % 2
                            ? _(Object(n), !0).forEach(function (t) {
                                u(e, t, n[t]);
                              })
                            : Object.getOwnPropertyDescriptors
                              ? Object.defineProperties(
                                  e,
                                  Object.getOwnPropertyDescriptors(n),
                                )
                              : _(Object(n)).forEach(function (t) {
                                  Object.defineProperty(
                                    e,
                                    t,
                                    Object.getOwnPropertyDescriptor(n, t),
                                  );
                                });
                        }
                        return e;
                      })({ display: "inline-block" }, i);
                      return (
                        void 0 !== l && (s.width = l),
                        void 0 !== a && (s.height = a),
                        t().createElement(
                          "span",
                          {
                            className: o,
                            ref: function (t) {
                              return (e.placeholder = t);
                            },
                            style: s,
                          },
                          r,
                        )
                      );
                    },
                  },
                ]) && d(n.prototype, o),
                Object.defineProperty(n, "prototype", { writable: !1 }),
                p
              );
            })(t().Component);
          (b.propTypes = {
            onVisible: o.PropTypes.func.isRequired,
            className: o.PropTypes.string,
            height: o.PropTypes.oneOfType([
              o.PropTypes.number,
              o.PropTypes.string,
            ]),
            placeholder: o.PropTypes.element,
            threshold: o.PropTypes.number,
            useIntersectionObserver: o.PropTypes.bool,
            scrollPosition: o.PropTypes.shape({
              x: o.PropTypes.number.isRequired,
              y: o.PropTypes.number.isRequired,
            }),
            width: o.PropTypes.oneOfType([
              o.PropTypes.number,
              o.PropTypes.string,
            ]),
          }),
            (b.defaultProps = {
              className: "",
              placeholder: null,
              threshold: 100,
              useIntersectionObserver: !0,
            });
          const v = b;
          var g = a(296),
            w = a.n(g),
            x = a(96),
            k = a.n(x),
            O = function (e) {
              var t = getComputedStyle(e, null);
              return (
                t.getPropertyValue("overflow") +
                t.getPropertyValue("overflow-y") +
                t.getPropertyValue("overflow-x")
              );
            };
          const I = function (e) {
            if (!(e instanceof HTMLElement)) return window;
            for (var t = e; t && t instanceof HTMLElement; ) {
              if (/(scroll|auto)/.test(O(t))) return t;
              t = t.parentNode;
            }
            return window;
          };
          function S(e) {
            return (S =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          var j = ["delayMethod", "delayTime"];
          function T() {
            return (T = Object.assign
              ? Object.assign.bind()
              : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var o in n)
                      Object.prototype.hasOwnProperty.call(n, o) &&
                        (e[o] = n[o]);
                  }
                  return e;
                }).apply(this, arguments);
          }
          function C(e, t) {
            return (C = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
          }
          function M(e, t) {
            if (t && ("object" === S(t) || "function" == typeof t)) return t;
            if (void 0 !== t)
              throw new TypeError(
                "Derived constructors may only return object or undefined",
              );
            return P(e);
          }
          function P(e) {
            if (void 0 === e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called",
              );
            return e;
          }
          function E(e) {
            return (E = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          var L = function () {
              return "undefined" == typeof window
                ? 0
                : window.scrollX || window.pageXOffset;
            },
            B = function () {
              return "undefined" == typeof window
                ? 0
                : window.scrollY || window.pageYOffset;
            };
          const N = function (e) {
            var n = (function (n) {
              !(function (e, t) {
                if ("function" != typeof t && null !== t)
                  throw new TypeError(
                    "Super expression must either be null or a function",
                  );
                (e.prototype = Object.create(t && t.prototype, {
                  constructor: { value: e, writable: !0, configurable: !0 },
                })),
                  Object.defineProperty(e, "prototype", { writable: !1 }),
                  t && C(e, t);
              })(_, n);
              var o,
                a,
                r,
                i,
                c =
                  ((r = _),
                  (i = (function () {
                    if ("undefined" == typeof Reflect || !Reflect.construct)
                      return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                      return (
                        Boolean.prototype.valueOf.call(
                          Reflect.construct(Boolean, [], function () {}),
                        ),
                        !0
                      );
                    } catch (e) {
                      return !1;
                    }
                  })()),
                  function () {
                    var e,
                      t = E(r);
                    if (i) {
                      var n = E(this).constructor;
                      e = Reflect.construct(t, arguments, n);
                    } else e = t.apply(this, arguments);
                    return M(this, e);
                  });
              function _(e) {
                var n;
                if (
                  ((function (e, t) {
                    if (!(e instanceof t))
                      throw new TypeError("Cannot call a class as a function");
                  })(this, _),
                  ((n = c.call(this, e)).useIntersectionObserver =
                    e.useIntersectionObserver && s()),
                  n.useIntersectionObserver)
                )
                  return M(n);
                var o = n.onChangeScroll.bind(P(n));
                return (
                  "debounce" === e.delayMethod
                    ? (n.delayedScroll = w()(o, e.delayTime))
                    : "throttle" === e.delayMethod &&
                      (n.delayedScroll = k()(o, e.delayTime)),
                  (n.state = { scrollPosition: { x: L(), y: B() } }),
                  (n.baseComponentRef = t().createRef()),
                  n
                );
              }
              return (
                (o = _),
                (a = [
                  {
                    key: "componentDidMount",
                    value: function () {
                      this.addListeners();
                    },
                  },
                  {
                    key: "componentWillUnmount",
                    value: function () {
                      this.removeListeners();
                    },
                  },
                  {
                    key: "componentDidUpdate",
                    value: function () {
                      "undefined" == typeof window ||
                        this.useIntersectionObserver ||
                        (I(l().findDOMNode(this.baseComponentRef.current)) !==
                          this.scrollElement &&
                          (this.removeListeners(), this.addListeners()));
                    },
                  },
                  {
                    key: "addListeners",
                    value: function () {
                      "undefined" == typeof window ||
                        this.useIntersectionObserver ||
                        ((this.scrollElement = I(
                          l().findDOMNode(this.baseComponentRef.current),
                        )),
                        this.scrollElement.addEventListener(
                          "scroll",
                          this.delayedScroll,
                          { passive: !0 },
                        ),
                        window.addEventListener("resize", this.delayedScroll, {
                          passive: !0,
                        }),
                        this.scrollElement !== window &&
                          window.addEventListener(
                            "scroll",
                            this.delayedScroll,
                            { passive: !0 },
                          ));
                    },
                  },
                  {
                    key: "removeListeners",
                    value: function () {
                      "undefined" == typeof window ||
                        this.useIntersectionObserver ||
                        (this.scrollElement.removeEventListener(
                          "scroll",
                          this.delayedScroll,
                        ),
                        window.removeEventListener(
                          "resize",
                          this.delayedScroll,
                        ),
                        this.scrollElement !== window &&
                          window.removeEventListener(
                            "scroll",
                            this.delayedScroll,
                          ));
                    },
                  },
                  {
                    key: "onChangeScroll",
                    value: function () {
                      this.useIntersectionObserver ||
                        this.setState({ scrollPosition: { x: L(), y: B() } });
                    },
                  },
                  {
                    key: "render",
                    value: function () {
                      var n = this.props,
                        o =
                          (n.delayMethod,
                          n.delayTime,
                          (function (e, t) {
                            if (null == e) return {};
                            var n,
                              o,
                              a = (function (e, t) {
                                if (null == e) return {};
                                var n,
                                  o,
                                  a = {},
                                  r = Object.keys(e);
                                for (o = 0; o < r.length; o++)
                                  (n = r[o]),
                                    t.indexOf(n) >= 0 || (a[n] = e[n]);
                                return a;
                              })(e, t);
                            if (Object.getOwnPropertySymbols) {
                              var r = Object.getOwnPropertySymbols(e);
                              for (o = 0; o < r.length; o++)
                                (n = r[o]),
                                  t.indexOf(n) >= 0 ||
                                    (Object.prototype.propertyIsEnumerable.call(
                                      e,
                                      n,
                                    ) &&
                                      (a[n] = e[n]));
                            }
                            return a;
                          })(n, j)),
                        a = this.useIntersectionObserver
                          ? null
                          : this.state.scrollPosition;
                      return t().createElement(
                        e,
                        T(
                          {
                            forwardRef: this.baseComponentRef,
                            scrollPosition: a,
                          },
                          o,
                        ),
                      );
                    },
                  },
                ]) &&
                  (function (e, t) {
                    for (var n = 0; n < t.length; n++) {
                      var o = t[n];
                      (o.enumerable = o.enumerable || !1),
                        (o.configurable = !0),
                        "value" in o && (o.writable = !0),
                        Object.defineProperty(
                          e,
                          ((a = (function (e, t) {
                            if ("object" !== S(e) || null === e) return e;
                            var n = e[Symbol.toPrimitive];
                            if (void 0 !== n) {
                              var o = n.call(e, "string");
                              if ("object" !== S(o)) return o;
                              throw new TypeError(
                                "@@toPrimitive must return a primitive value.",
                              );
                            }
                            return String(e);
                          })(o.key)),
                          "symbol" === S(a) ? a : String(a)),
                          o,
                        );
                    }
                    var a;
                  })(o.prototype, a),
                Object.defineProperty(o, "prototype", { writable: !1 }),
                _
              );
            })(t().Component);
            return (
              (n.propTypes = {
                delayMethod: o.PropTypes.oneOf(["debounce", "throttle"]),
                delayTime: o.PropTypes.number,
                useIntersectionObserver: o.PropTypes.bool,
              }),
              (n.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0,
              }),
              n
            );
          };
          function D(e) {
            return (D =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function z(e, t) {
            return (z = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
          }
          function A(e) {
            return (A = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          var R = (function (e) {
            !(function (e, t) {
              if ("function" != typeof t && null !== t)
                throw new TypeError(
                  "Super expression must either be null or a function",
                );
              (e.prototype = Object.create(t && t.prototype, {
                constructor: { value: e, writable: !0, configurable: !0 },
              })),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                t && z(e, t);
            })(l, e);
            var n,
              o,
              a,
              r,
              i =
                ((a = l),
                (r = (function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return (
                      Boolean.prototype.valueOf.call(
                        Reflect.construct(Boolean, [], function () {}),
                      ),
                      !0
                    );
                  } catch (e) {
                    return !1;
                  }
                })()),
                function () {
                  var e,
                    t = A(a);
                  if (r) {
                    var n = A(this).constructor;
                    e = Reflect.construct(t, arguments, n);
                  } else e = t.apply(this, arguments);
                  return (function (e, t) {
                    if (t && ("object" === D(t) || "function" == typeof t))
                      return t;
                    if (void 0 !== t)
                      throw new TypeError(
                        "Derived constructors may only return object or undefined",
                      );
                    return (function (e) {
                      if (void 0 === e)
                        throw new ReferenceError(
                          "this hasn't been initialised - super() hasn't been called",
                        );
                      return e;
                    })(e);
                  })(this, e);
                });
            function l(e) {
              return (
                (function (e, t) {
                  if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function");
                })(this, l),
                i.call(this, e)
              );
            }
            return (
              (n = l),
              (o = [
                {
                  key: "render",
                  value: function () {
                    return t().createElement(v, this.props);
                  },
                },
              ]) &&
                (function (e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var o = t[n];
                    (o.enumerable = o.enumerable || !1),
                      (o.configurable = !0),
                      "value" in o && (o.writable = !0),
                      Object.defineProperty(
                        e,
                        ((a = (function (e, t) {
                          if ("object" !== D(e) || null === e) return e;
                          var n = e[Symbol.toPrimitive];
                          if (void 0 !== n) {
                            var o = n.call(e, "string");
                            if ("object" !== D(o)) return o;
                            throw new TypeError(
                              "@@toPrimitive must return a primitive value.",
                            );
                          }
                          return String(e);
                        })(o.key)),
                        "symbol" === D(a) ? a : String(a)),
                        o,
                      );
                  }
                  var a;
                })(n.prototype, o),
              Object.defineProperty(n, "prototype", { writable: !1 }),
              l
            );
          })(t().Component);
          const F = N(R);
          function V(e) {
            return (V =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          function H(e, t) {
            return (H = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
          }
          function W(e) {
            if (void 0 === e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called",
              );
            return e;
          }
          function U(e) {
            return (U = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          var G = (function (e) {
            !(function (e, t) {
              if ("function" != typeof t && null !== t)
                throw new TypeError(
                  "Super expression must either be null or a function",
                );
              (e.prototype = Object.create(t && t.prototype, {
                constructor: { value: e, writable: !0, configurable: !0 },
              })),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                t && H(e, t);
            })(l, e);
            var n,
              o,
              a,
              r,
              i =
                ((a = l),
                (r = (function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return (
                      Boolean.prototype.valueOf.call(
                        Reflect.construct(Boolean, [], function () {}),
                      ),
                      !0
                    );
                  } catch (e) {
                    return !1;
                  }
                })()),
                function () {
                  var e,
                    t = U(a);
                  if (r) {
                    var n = U(this).constructor;
                    e = Reflect.construct(t, arguments, n);
                  } else e = t.apply(this, arguments);
                  return (function (e, t) {
                    if (t && ("object" === V(t) || "function" == typeof t))
                      return t;
                    if (void 0 !== t)
                      throw new TypeError(
                        "Derived constructors may only return object or undefined",
                      );
                    return W(e);
                  })(this, e);
                });
            function l(e) {
              var t;
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, l),
                (t = i.call(this, e));
              var n = e.afterLoad,
                o = e.beforeLoad,
                a = e.scrollPosition,
                r = e.visibleByDefault;
              return (
                (t.state = { visible: r }),
                r && (o(), n()),
                (t.onVisible = t.onVisible.bind(W(t))),
                (t.isScrollTracked = Boolean(
                  a &&
                    Number.isFinite(a.x) &&
                    a.x >= 0 &&
                    Number.isFinite(a.y) &&
                    a.y >= 0,
                )),
                t
              );
            }
            return (
              (n = l),
              (o = [
                {
                  key: "componentDidUpdate",
                  value: function (e, t) {
                    t.visible !== this.state.visible && this.props.afterLoad();
                  },
                },
                {
                  key: "onVisible",
                  value: function () {
                    this.props.beforeLoad(), this.setState({ visible: !0 });
                  },
                },
                {
                  key: "render",
                  value: function () {
                    if (this.state.visible) return this.props.children;
                    var e = this.props,
                      n = e.className,
                      o = e.delayMethod,
                      a = e.delayTime,
                      r = e.height,
                      i = e.placeholder,
                      l = e.scrollPosition,
                      c = e.style,
                      _ = e.threshold,
                      u = e.useIntersectionObserver,
                      d = e.width;
                    return this.isScrollTracked || (u && s())
                      ? t().createElement(v, {
                          className: n,
                          height: r,
                          onVisible: this.onVisible,
                          placeholder: i,
                          scrollPosition: l,
                          style: c,
                          threshold: _,
                          useIntersectionObserver: u,
                          width: d,
                        })
                      : t().createElement(F, {
                          className: n,
                          delayMethod: o,
                          delayTime: a,
                          height: r,
                          onVisible: this.onVisible,
                          placeholder: i,
                          style: c,
                          threshold: _,
                          width: d,
                        });
                  },
                },
              ]) &&
                (function (e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var o = t[n];
                    (o.enumerable = o.enumerable || !1),
                      (o.configurable = !0),
                      "value" in o && (o.writable = !0),
                      Object.defineProperty(
                        e,
                        ((a = (function (e, t) {
                          if ("object" !== V(e) || null === e) return e;
                          var n = e[Symbol.toPrimitive];
                          if (void 0 !== n) {
                            var o = n.call(e, "string");
                            if ("object" !== V(o)) return o;
                            throw new TypeError(
                              "@@toPrimitive must return a primitive value.",
                            );
                          }
                          return String(e);
                        })(o.key)),
                        "symbol" === V(a) ? a : String(a)),
                        o,
                      );
                  }
                  var a;
                })(n.prototype, o),
              Object.defineProperty(n, "prototype", { writable: !1 }),
              l
            );
          })(t().Component);
          (G.propTypes = {
            afterLoad: o.PropTypes.func,
            beforeLoad: o.PropTypes.func,
            useIntersectionObserver: o.PropTypes.bool,
            visibleByDefault: o.PropTypes.bool,
          }),
            (G.defaultProps = {
              afterLoad: function () {
                return {};
              },
              beforeLoad: function () {
                return {};
              },
              useIntersectionObserver: !0,
              visibleByDefault: !1,
            });
          const Y = G;
          function q(e) {
            return (q =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(e);
          }
          var X = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps",
          ];
          function Z(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);
              t &&
                (o = o.filter(function (t) {
                  return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                n.push.apply(n, o);
            }
            return n;
          }
          function K(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? Z(Object(n), !0).forEach(function (t) {
                    Q(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                  ? Object.defineProperties(
                      e,
                      Object.getOwnPropertyDescriptors(n),
                    )
                  : Z(Object(n)).forEach(function (t) {
                      Object.defineProperty(
                        e,
                        t,
                        Object.getOwnPropertyDescriptor(n, t),
                      );
                    });
            }
            return e;
          }
          function Q(e, t, n) {
            return (
              (t = $(t)) in e
                ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                  })
                : (e[t] = n),
              e
            );
          }
          function J() {
            return (J = Object.assign
              ? Object.assign.bind()
              : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var o in n)
                      Object.prototype.hasOwnProperty.call(n, o) &&
                        (e[o] = n[o]);
                  }
                  return e;
                }).apply(this, arguments);
          }
          function $(e) {
            var t = (function (e, t) {
              if ("object" !== q(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 !== n) {
                var o = n.call(e, "string");
                if ("object" !== q(o)) return o;
                throw new TypeError(
                  "@@toPrimitive must return a primitive value.",
                );
              }
              return String(e);
            })(e);
            return "symbol" === q(t) ? t : String(t);
          }
          function ee(e, t) {
            return (ee = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (e, t) {
                  return (e.__proto__ = t), e;
                })(e, t);
          }
          function te(e) {
            return (te = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
          }
          var ne = (function (e) {
            !(function (e, t) {
              if ("function" != typeof t && null !== t)
                throw new TypeError(
                  "Super expression must either be null or a function",
                );
              (e.prototype = Object.create(t && t.prototype, {
                constructor: { value: e, writable: !0, configurable: !0 },
              })),
                Object.defineProperty(e, "prototype", { writable: !1 }),
                t && ee(e, t);
            })(l, e);
            var n,
              o,
              a,
              r,
              i =
                ((a = l),
                (r = (function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return (
                      Boolean.prototype.valueOf.call(
                        Reflect.construct(Boolean, [], function () {}),
                      ),
                      !0
                    );
                  } catch (e) {
                    return !1;
                  }
                })()),
                function () {
                  var e,
                    t = te(a);
                  if (r) {
                    var n = te(this).constructor;
                    e = Reflect.construct(t, arguments, n);
                  } else e = t.apply(this, arguments);
                  return (function (e, t) {
                    if (t && ("object" === q(t) || "function" == typeof t))
                      return t;
                    if (void 0 !== t)
                      throw new TypeError(
                        "Derived constructors may only return object or undefined",
                      );
                    return (function (e) {
                      if (void 0 === e)
                        throw new ReferenceError(
                          "this hasn't been initialised - super() hasn't been called",
                        );
                      return e;
                    })(e);
                  })(this, e);
                });
            function l(e) {
              var t;
              return (
                (function (e, t) {
                  if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function");
                })(this, l),
                ((t = i.call(this, e)).state = { loaded: !1 }),
                t
              );
            }
            return (
              (n = l),
              (o = [
                {
                  key: "onImageLoad",
                  value: function () {
                    var e = this;
                    return this.state.loaded
                      ? null
                      : function (t) {
                          e.props.onLoad(t),
                            e.props.afterLoad(),
                            e.setState({ loaded: !0 });
                        };
                  },
                },
                {
                  key: "getImg",
                  value: function () {
                    var e = this.props,
                      n =
                        (e.afterLoad,
                        e.beforeLoad,
                        e.delayMethod,
                        e.delayTime,
                        e.effect,
                        e.placeholder,
                        e.placeholderSrc,
                        e.scrollPosition,
                        e.threshold,
                        e.useIntersectionObserver,
                        e.visibleByDefault,
                        e.wrapperClassName,
                        e.wrapperProps,
                        (function (e, t) {
                          if (null == e) return {};
                          var n,
                            o,
                            a = (function (e, t) {
                              if (null == e) return {};
                              var n,
                                o,
                                a = {},
                                r = Object.keys(e);
                              for (o = 0; o < r.length; o++)
                                (n = r[o]), t.indexOf(n) >= 0 || (a[n] = e[n]);
                              return a;
                            })(e, t);
                          if (Object.getOwnPropertySymbols) {
                            var r = Object.getOwnPropertySymbols(e);
                            for (o = 0; o < r.length; o++)
                              (n = r[o]),
                                t.indexOf(n) >= 0 ||
                                  (Object.prototype.propertyIsEnumerable.call(
                                    e,
                                    n,
                                  ) &&
                                    (a[n] = e[n]));
                          }
                          return a;
                        })(e, X));
                    return t().createElement(
                      "img",
                      J({}, n, { onLoad: this.onImageLoad() }),
                    );
                  },
                },
                {
                  key: "getLazyLoadImage",
                  value: function () {
                    var e = this.props,
                      n = e.beforeLoad,
                      o = e.className,
                      a = e.delayMethod,
                      r = e.delayTime,
                      i = e.height,
                      l = e.placeholder,
                      s = e.scrollPosition,
                      c = e.style,
                      _ = e.threshold,
                      u = e.useIntersectionObserver,
                      d = e.visibleByDefault,
                      p = e.width;
                    return t().createElement(
                      Y,
                      {
                        beforeLoad: n,
                        className: o,
                        delayMethod: a,
                        delayTime: r,
                        height: i,
                        placeholder: l,
                        scrollPosition: s,
                        style: c,
                        threshold: _,
                        useIntersectionObserver: u,
                        visibleByDefault: d,
                        width: p,
                      },
                      this.getImg(),
                    );
                  },
                },
                {
                  key: "getWrappedLazyLoadImage",
                  value: function (e) {
                    var n = this.props,
                      o = n.effect,
                      a = n.height,
                      r = n.placeholderSrc,
                      i = n.width,
                      l = n.wrapperClassName,
                      s = n.wrapperProps,
                      c = this.state.loaded,
                      _ = c ? " lazy-load-image-loaded" : "",
                      u =
                        c || !r
                          ? {}
                          : {
                              backgroundImage: "url(".concat(r, ")"),
                              backgroundSize: "100% 100%",
                            };
                    return t().createElement(
                      "span",
                      J(
                        {
                          className: l + " lazy-load-image-background " + o + _,
                          style: K(
                            K({}, u),
                            {},
                            {
                              color: "transparent",
                              display: "inline-block",
                              height: a,
                              width: i,
                            },
                          ),
                        },
                        s,
                      ),
                      e,
                    );
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var e = this.props,
                      t = e.effect,
                      n = e.placeholderSrc,
                      o = e.visibleByDefault,
                      a = e.wrapperClassName,
                      r = e.wrapperProps,
                      i = this.getLazyLoadImage();
                    return ((t || n) && !o) || a || r
                      ? this.getWrappedLazyLoadImage(i)
                      : i;
                  },
                },
              ]) &&
                (function (e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var o = t[n];
                    (o.enumerable = o.enumerable || !1),
                      (o.configurable = !0),
                      "value" in o && (o.writable = !0),
                      Object.defineProperty(e, $(o.key), o);
                  }
                })(n.prototype, o),
              Object.defineProperty(n, "prototype", { writable: !1 }),
              l
            );
          })(t().Component);
          (ne.propTypes = {
            onLoad: o.PropTypes.func,
            afterLoad: o.PropTypes.func,
            beforeLoad: o.PropTypes.func,
            delayMethod: o.PropTypes.string,
            delayTime: o.PropTypes.number,
            effect: o.PropTypes.string,
            placeholderSrc: o.PropTypes.string,
            threshold: o.PropTypes.number,
            useIntersectionObserver: o.PropTypes.bool,
            visibleByDefault: o.PropTypes.bool,
            wrapperClassName: o.PropTypes.string,
            wrapperProps: o.PropTypes.object,
          }),
            (ne.defaultProps = {
              onLoad: function () {},
              afterLoad: function () {
                return {};
              },
              beforeLoad: function () {
                return {};
              },
              delayMethod: "throttle",
              delayTime: 300,
              effect: "",
              placeholderSrc: null,
              threshold: 100,
              useIntersectionObserver: !0,
              visibleByDefault: !1,
              wrapperClassName: "",
            });
          const oe = ne;
        })(),
          (e.exports = r);
      })();
    },
    UWiX: function (e, t, n) {
      var o = n("29s/")("wks"),
        a = n("YqAc"),
        r = n("5T2Y").Symbol,
        i = "function" == typeof r;
      (e.exports = function (e) {
        return o[e] || (o[e] = (i && r[e]) || (i ? r : a)("Symbol." + e));
      }).store = o;
    },
    UYut: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return g;
      });
      var o = n("wx14"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("rePB"),
        u = n("q1tI"),
        d = n("9/5/"),
        p = n.n(d),
        f = n("TSYQ"),
        h = n.n(f),
        m = (n("KkZl"), u.createElement);
      function y(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function b(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      window.matchMedia =
        window.matchMedia ||
        function (e) {
          return {
            media: e,
            matches: !1,
            addListener: function () {},
            removeListener: function () {},
          };
        };
      var v = n("0y5z").default,
        g = (function (e) {
          function t(e) {
            var n;
            return (
              Object(a.default)(this, t),
              (n = b(this, t, [e])),
              Object(_.a)(Object(s.a)(n), "innerSlider", void 0),
              Object(_.a)(Object(s.a)(n), "slick", void 0),
              Object(_.a)(Object(s.a)(n), "onWindowResized", function () {
                n.props.autoplay &&
                  n.slick &&
                  n.slick.innerSlider &&
                  n.slick.innerSlider.autoPlay &&
                  n.slick.innerSlider.autoPlay();
              }),
              Object(_.a)(Object(s.a)(n), "saveSlick", function (e) {
                n.slick = e;
              }),
              (n.onWindowResized = p()(n.onWindowResized, 500, {
                leading: !1,
              })),
              n
            );
          }
          return (
            Object(c.a)(t, e),
            Object(r.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  this.props.autoplay &&
                    window.addEventListener("resize", this.onWindowResized),
                    (this.innerSlider = this.slick && this.slick.innerSlider);
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  this.props.autoplay &&
                    window.removeEventListener("resize", this.onWindowResized);
                },
              },
              {
                key: "slickNext",
                value: function () {
                  this.slick.slickNext();
                },
              },
              {
                key: "slickPrev",
                value: function () {
                  this.slick.slickPrev();
                },
              },
              {
                key: "slickGoTo",
                value: function (e, t) {
                  this.slick.slickGoTo(e, t);
                },
              },
              {
                key: "render",
                value: function () {
                  var e = (function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n = null != arguments[t] ? arguments[t] : {};
                      t % 2
                        ? y(Object(n), !0).forEach(function (t) {
                            Object(_.a)(e, t, n[t]);
                          })
                        : Object.getOwnPropertyDescriptors
                          ? Object.defineProperties(
                              e,
                              Object.getOwnPropertyDescriptors(n),
                            )
                          : y(Object(n)).forEach(function (t) {
                              Object.defineProperty(
                                e,
                                t,
                                Object.getOwnPropertyDescriptor(n, t),
                              );
                            });
                    }
                    return e;
                  })({}, this.props);
                  "fade" === e.effect && (e.fade = !0);
                  var t = e.vertical ? "carousel-vertical" : "carousel",
                    n = h()(e.className, t);
                  return m(
                    "div",
                    { className: n },
                    m(v, Object(o.a)({ ref: this.saveSlick }, e)),
                  );
                },
              },
            ]),
            t
          );
        })(u.PureComponent);
      Object(_.a)(g, "defaultProps", {
        dots: !1,
        arrows: !1,
        draggable: !0,
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
      });
    },
    UbbE: function (e, t, n) {
      n("o8NH"), (e.exports = n("WEpk").Object.assign);
    },
    Ud1t: function (e, t, n) {
      "use strict";
      var o = n("HaE+"),
        a = n("rePB"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("Ji7U"),
        _ = n("q1tI"),
        u = n.n(_),
        d = n("ANjH"),
        p = n("/MKj"),
        f = n("7bI+"),
        h = n("Ukc1"),
        m = n("xcIm"),
        y = n("xVxQ"),
        b = n("Ntax"),
        v = (n("cAZH"), n("0b+E")),
        g = n("hKI/"),
        w = n.n(g),
        x = n("9/5/"),
        k = n.n(x),
        O = u.a.createElement;
      function I() {
        I = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var g = {};
        c(g, i, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          x = w && w(w(E([])));
        x && x !== n && o.call(x, i) && (g = x);
        var k = (v.prototype = y.prototype = Object.create(g));
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(k, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(k)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          O(S.prototype),
          c(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          O(k),
          c(k, s, "Generator"),
          c(k, i, function () {
            return this;
          }),
          c(k, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      function S(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function j(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var T = function (e, t, n, l) {
        var s = (function (s) {
          function _(e) {
            var t;
            Object(r.default)(this, _),
              ((t = j(this, _, [e])).customEventList = {});
            var n = t.props.customEventList || {};
            return (
              Object.keys(n).forEach(function (e) {
                var o = function (t) {
                  n[e].forEach(function (e) {
                    return e(t);
                  });
                };
                t.customEventList[e] =
                  "scroll" === e
                    ? w()(o, 500)
                    : "resize" === e
                      ? k()(o, 500)
                      : o;
              }),
              t
            );
          }
          return (
            Object(c.a)(_, s),
            Object(i.default)(
              _,
              [
                {
                  key: "componentDidMount",
                  value: function () {
                    (this.dps = Object(b.a)()), this.initPriceLoader();
                    var e = this.customEventList;
                    Object.keys(e).forEach(function (t) {
                      var n = {};
                      "scroll" === t && (n.passive = !0),
                        window.addEventListener(t, e[t], n);
                    });
                  },
                },
                {
                  key: "componentDidUpdate",
                  value: function () {
                    var e = this.dps;
                    "function" === typeof e.checkImageVisibilityAndLoad &&
                      e.checkImageVisibilityAndLoad();
                  },
                },
                {
                  key: "componentWillUnmount",
                  value: function () {
                    var e = this.customEventList;
                    Object.keys(e).forEach(function (t) {
                      window.removeEventListener(t, e[t]);
                    });
                  },
                },
                {
                  key: "initPriceLoader",
                  value: function () {
                    Array.isArray(this.props.eans) &&
                      this.props.eans.length &&
                      y.a
                        .getInstance()
                        .init(this.props.eans, this.props.localization);
                  },
                },
                {
                  key: "getGaSend",
                  value: function (e, t, n, o) {
                    e &&
                      t &&
                      n &&
                      v.a.event(
                        (function (e) {
                          for (var t = 1; t < arguments.length; t++) {
                            var n = null != arguments[t] ? arguments[t] : {};
                            t % 2
                              ? S(Object(n), !0).forEach(function (t) {
                                  Object(a.a)(e, t, n[t]);
                                })
                              : Object.getOwnPropertyDescriptors
                                ? Object.defineProperties(
                                    e,
                                    Object.getOwnPropertyDescriptors(n),
                                  )
                                : S(Object(n)).forEach(function (t) {
                                    Object.defineProperty(
                                      e,
                                      t,
                                      Object.getOwnPropertyDescriptor(n, t),
                                    );
                                  });
                          }
                          return e;
                        })({ category: e, action: t, label: n }, o || {}),
                      );
                  },
                },
                {
                  key: "render",
                  value: function () {
                    var o = this.props,
                      a = o.page,
                      r = o.product,
                      i = o.context.mobileMode,
                      s = o.subdomain,
                      c = o.subdomainConfig,
                      _ = o.pagePath,
                      u = o.newsMediaData,
                      d = o.newsMediaDetailData,
                      p = o.caseStudiesFilterData,
                      h = o.showHeader,
                      m = o.showFooter,
                      y = o.localization,
                      b = o.sampleData,
                      v = o.ssrData,
                      g = o.compatibilityData,
                      w = o.supportData,
                      x = o.eventAction,
                      k = o.omCompatibilityData,
                      I = o.ecologySideBarData,
                      S = o.ecologyDetailsData,
                      j = o.solutionDetailsData,
                      T = o.comparisonData,
                      C = o.guidesData,
                      M = a.data.components_data;
                    return O(
                      "div",
                      { className: "page-wrapper" },
                      t && h
                        ? O(t, { productData: r, gaSend: this.getGaSend })
                        : null,
                      O(f.a, {
                        sections: M,
                        components: e,
                        mobileMode: i,
                        productData: r,
                        newsMediaData: u,
                        pagePath: _,
                        newsMediaDetailData: d,
                        caseStudiesFilterData: p,
                        subdomainConfig: c,
                        localization: y,
                        sampleData: b,
                        ssrData: v,
                        compatibilityData: g,
                        supportData: w,
                        eventAction: x,
                        omCompatibilityData: k,
                        ecologySideBarData: I,
                        ecologyDetailsData: S,
                        solutionDetailsData: j,
                        comparisonData: T,
                        guidesData: C,
                      }),
                      n && m
                        ? O(n, {
                            subdomain: s,
                            subdomainConfig: c,
                            gaSend: this.getGaSend,
                          })
                        : null,
                      l && !i && O(l, null),
                    );
                  },
                },
              ],
              [
                {
                  key: "getInitialProps",
                  value: (function () {
                    var e = Object(o.default)(
                      I().mark(function e(t) {
                        var n, o;
                        return I().wrap(function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                return (
                                  (n = t.store),
                                  (o = t.state.pageData),
                                  (e.next = 4),
                                  n.dispatch(h.c(o))
                                );
                              case 4:
                                return (e.next = 6), n.dispatch(h.a());
                              case 6:
                                return e.abrupt("return", {
                                  product: t.state.productData,
                                  subdomain: t.state.subdomain,
                                  subdomainConfig: t.state.subdomainConfig,
                                  pagePath: t.state.originPath,
                                  newsMediaData: t.state.newsMediaData,
                                  newsMediaDetailData:
                                    t.state.newsMediaDetailData,
                                  caseStudiesFilterData:
                                    t.state.caseStudiesFilterData,
                                  showHeader: t.state.showHeader,
                                  showFooter: t.state.showFooter,
                                  localization: t.state.localization,
                                  sampleData: t.state.sampleData,
                                  ssrData: t.state.ssrData,
                                  compatibilityData: t.state.compatibilityData,
                                  supportData: t.state.supportData,
                                  omCompatibilityData:
                                    t.state.omCompatibilityData,
                                  ecologySideBarData:
                                    t.state.ecologySideBarData,
                                  ecologyDetailsData:
                                    t.state.ecologyDetailsData,
                                  solutionDetailsData:
                                    t.state.solutionDetailsData,
                                  comparisonData: t.state.comparisonData,
                                  guidesData: t.state.guidesData,
                                  eans: t.state.eans,
                                });
                              case 7:
                              case "end":
                                return e.stop();
                            }
                        }, e);
                      }),
                    );
                    return function (t) {
                      return e.apply(this, arguments);
                    };
                  })(),
                },
              ],
            ),
            _
          );
        })(u.a.Component);
        return Object(p.b)(
          function (e) {
            return {
              page: e.page,
              context: e.context,
              localization: e.localization,
              customEventList: e.customEventList,
            };
          },
          function (e) {
            return { eventAction: Object(d.b)(m, e) };
          },
        )(s);
      };
      (T.defaultProps = {
        showHeader: !0,
        showFooter: !0,
        product: null,
        newsMediaData: null,
        newsMediaDetailData: null,
        caseStudiesFilterData: null,
        localization: null,
        sampleData: null,
        ssrData: null,
        compatibilityData: null,
        supportData: null,
        omCompatibilityData: null,
        ecologySideBarData: null,
        ecologyDetailsData: null,
        solutionDetailsData: null,
        comparisonData: null,
        eans: null,
      }),
        (t.a = T);
    },
    UiZK: function (e, t, n) {
      (function (t) {
        var n = 1 / 0,
          o = "[object Symbol]",
          a = /^\s+|\s+$/g,
          r = "[\\ud800-\\udfff]",
          i = "[\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0]",
          l = "\\ud83c[\\udffb-\\udfff]",
          s = "[^\\ud800-\\udfff]",
          c = "(?:\\ud83c[\\udde6-\\uddff]){2}",
          _ = "[\\ud800-\\udbff][\\udc00-\\udfff]",
          u = "(?:" + i + "|" + l + ")" + "?",
          d =
            "[\\ufe0e\\ufe0f]?" +
            u +
            ("(?:\\u200d(?:" +
              [s, c, _].join("|") +
              ")[\\ufe0e\\ufe0f]?" +
              u +
              ")*"),
          p = "(?:" + [s + i + "?", i, c, _, r].join("|") + ")",
          f = RegExp(l + "(?=" + l + ")|" + p + d, "g"),
          h = RegExp(
            "[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe23\\u20d0-\\u20f0\\ufe0e\\ufe0f]",
          ),
          m = "object" == typeof t && t && t.Object === Object && t,
          y = "object" == typeof self && self && self.Object === Object && self,
          b = m || y || Function("return this")();
        function v(e, t, n) {
          if (t !== t)
            return (function (e, t, n, o) {
              for (var a = e.length, r = n + (o ? 1 : -1); o ? r-- : ++r < a; )
                if (t(e[r], r, e)) return r;
              return -1;
            })(e, g, n);
          for (var o = n - 1, a = e.length; ++o < a; ) if (e[o] === t) return o;
          return -1;
        }
        function g(e) {
          return e !== e;
        }
        function w(e) {
          return (function (e) {
            return h.test(e);
          })(e)
            ? (function (e) {
                return e.match(f) || [];
              })(e)
            : (function (e) {
                return e.split("");
              })(e);
        }
        var x = Object.prototype.toString,
          k = b.Symbol,
          O = k ? k.prototype : void 0,
          I = O ? O.toString : void 0;
        function S(e) {
          if ("string" == typeof e) return e;
          if (
            (function (e) {
              return (
                "symbol" == typeof e ||
                ((function (e) {
                  return !!e && "object" == typeof e;
                })(e) &&
                  x.call(e) == o)
              );
            })(e)
          )
            return I ? I.call(e) : "";
          var t = e + "";
          return "0" == t && 1 / e == -n ? "-0" : t;
        }
        function j(e, t, n) {
          var o = e.length;
          return (
            (n = void 0 === n ? o : n),
            !t && n >= o
              ? e
              : (function (e, t, n) {
                  var o = -1,
                    a = e.length;
                  t < 0 && (t = -t > a ? 0 : a + t),
                    (n = n > a ? a : n) < 0 && (n += a),
                    (a = t > n ? 0 : (n - t) >>> 0),
                    (t >>>= 0);
                  for (var r = Array(a); ++o < a; ) r[o] = e[o + t];
                  return r;
                })(e, t, n)
          );
        }
        e.exports = function (e, t, n) {
          var o;
          if ((e = null == (o = e) ? "" : S(o)) && (n || void 0 === t))
            return e.replace(a, "");
          if (!e || !(t = S(t))) return e;
          var r = w(e),
            i = w(t);
          return j(
            r,
            (function (e, t) {
              for (var n = -1, o = e.length; ++n < o && v(t, e[n], 0) > -1; );
              return n;
            })(r, i),
            (function (e, t) {
              for (var n = e.length; n-- && v(t, e[n], 0) > -1; );
              return n;
            })(r, i) + 1,
          ).join("");
        };
      }).call(this, n("yLpj"));
    },
    UnUH: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t) && !e.required) return n();
          if ((r.default.required(e, t, o, l, a), !(0, i.isEmptyValue)(t))) {
            var s = void 0;
            (s = "number" === typeof t ? new Date(t) : t),
              r.default.type(e, s, o, l, a),
              s && r.default.range(e, s.getTime(), o, l, a);
          }
        }
        n(l);
      };
    },
    UnXY: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.default = void 0);
      var o = l(n("17x9")),
        a = l(n("q1tI")),
        r = n("VCL8"),
        i = n("8PcY");
      function l(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function s() {
        return (s =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      function c(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return e;
      }
      var _ =
          Object.values ||
          function (e) {
            return Object.keys(e).map(function (t) {
              return e[t];
            });
          },
        u = (function (e) {
          var t, n;
          function o(t, n) {
            var o,
              a = (o = e.call(this, t, n) || this).handleExited.bind(c(c(o)));
            return (o.state = { handleExited: a, firstRender: !0 }), o;
          }
          (n = e),
            ((t = o).prototype = Object.create(n.prototype)),
            (t.prototype.constructor = t),
            (t.__proto__ = n);
          var r = o.prototype;
          return (
            (r.getChildContext = function () {
              return { transitionGroup: { isMounting: !this.appeared } };
            }),
            (r.componentDidMount = function () {
              (this.appeared = !0), (this.mounted = !0);
            }),
            (r.componentWillUnmount = function () {
              this.mounted = !1;
            }),
            (o.getDerivedStateFromProps = function (e, t) {
              var n = t.children,
                o = t.handleExited;
              return {
                children: t.firstRender
                  ? (0, i.getInitialChildMapping)(e, o)
                  : (0, i.getNextChildMapping)(e, n, o),
                firstRender: !1,
              };
            }),
            (r.handleExited = function (e, t) {
              var n = (0, i.getChildMapping)(this.props.children);
              e.key in n ||
                (e.props.onExited && e.props.onExited(t),
                this.mounted &&
                  this.setState(function (t) {
                    var n = s({}, t.children);
                    return delete n[e.key], { children: n };
                  }));
            }),
            (r.render = function () {
              var e = this.props,
                t = e.component,
                n = e.childFactory,
                o = (function (e, t) {
                  if (null == e) return {};
                  var n,
                    o,
                    a = {},
                    r = Object.keys(e);
                  for (o = 0; o < r.length; o++)
                    (n = r[o]), t.indexOf(n) >= 0 || (a[n] = e[n]);
                  return a;
                })(e, ["component", "childFactory"]),
                r = _(this.state.children).map(n);
              return (
                delete o.appear,
                delete o.enter,
                delete o.exit,
                null === t ? r : a.default.createElement(t, o, r)
              );
            }),
            o
          );
        })(a.default.Component);
      (u.childContextTypes = { transitionGroup: o.default.object.isRequired }),
        (u.propTypes = {}),
        (u.defaultProps = {
          component: "div",
          childFactory: function (e) {
            return e;
          },
        });
      var d = (0, r.polyfill)(u);
      (t.default = d), (e.exports = t.default);
    },
    Upok: function (e, t, n) {
      e.exports = {
        "tab-bar-out-wrapper": "tab__tab-bar-out-wrapper___3_Vhg",
        "tab-bar-wrapper": "tab__tab-bar-wrapper___3QL_W",
        "tab-bar-nav-box": "tab__tab-bar-nav-box___35mcF",
        "tab-bar-nav": "tab__tab-bar-nav___3Yu3Z",
        "tab-bar-items": "tab__tab-bar-items___2OxSW",
        "tab-bar-item-line": "tab__tab-bar-item-line___2E9vU",
        "tab-bar-item": "tab__tab-bar-item___1xnyp",
        active: "tab__active___2YY4g",
        "tab-bar-item-content": "tab__tab-bar-item-content___R8JyK",
        "tab-content-wrapper": "tab__tab-content-wrapper___1q5Vj",
        "tab-content": "tab__tab-content___3dlKz",
        "sample-list-box": "tab__sample-list-box___2kpJs",
        "sample-list-inner-box": "tab__sample-list-inner-box___8gr2v",
        "sub-type-list": "tab__sub-type-list___15XFl",
        "sub-type-item": "tab__sub-type-item___2eqef",
        "sample-item": "tab__sample-item___XNv9X",
        "left-sec": "tab__left-sec___20aHQ",
        "right-sec": "tab__right-sec___2HV3j",
        "main-title": "tab__main-title___2QyPs",
        "sub-title": "tab__sub-title___3FjVd",
        desc: "tab__desc___jLJpT",
        "spec-list-box-margin-top": "tab__spec-list-box-margin-top___3R4b0",
        "spec-list-box": "tab__spec-list-box___10vOA",
        "spec-item-margin-bottom": "tab__spec-item-margin-bottom___3Raf4",
        "spec-item": "tab__spec-item___34gA0",
        key: "tab__key___bSUC1",
        value: "tab__value___37vgB",
        "download-box": "tab__download-box___1LhiB",
        "download-box-margin-top": "tab__download-box-margin-top___leY8u",
        btn: "tab__btn___2JzKz",
        "btn-desc": "tab__btn-desc___3etZz",
        divider: "tab__divider___3himh",
        "empty-mask": "tab__empty-mask___2Ftu0",
        "empty-icon": "tab__empty-icon___uBD8R",
        text: "tab__text___3my1N",
      };
    },
    UrHs: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if (("" === t && (t = void 0), (0, i.isEmptyValue)(t) && !e.required))
            return n();
          r.default.required(e, t, o, l, a),
            void 0 !== t &&
              (r.default.type(e, t, o, l, a), r.default.range(e, t, o, l, a));
        }
        n(l);
      };
    },
    UtvM: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return c;
      });
      var o = n("HaE+"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("rePB"),
        l = n("t3Un");
      function s() {
        s = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          c = r.toStringTag || "@@toStringTag";
        function _(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          _({}, "");
        } catch (e) {
          _ = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function u(e, t, n, o) {
          var r = t && t.prototype instanceof b ? t : b,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function d(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = u;
        var p = "suspendedStart",
          f = "suspendedYield",
          h = "executing",
          m = "completed",
          y = {};
        function b() {}
        function v() {}
        function g() {}
        var w = {};
        _(w, i, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, i) && (w = k);
        var O = (g.prototype = b.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            _(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = d(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = p;
          return function (r, i) {
            if (a === h) throw new Error("Generator is already running");
            if (a === m) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === p) throw ((a = m), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = h;
              var c = d(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? m : f), c.arg === y)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = m), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              y
            );
          var r = d(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), y
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                y)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (v.prototype = g),
          a(O, "constructor", { value: g, configurable: !0 }),
          a(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = _(g, c, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), _(e, c, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          _(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(u(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          _(O, c, "Generator"),
          _(O, i, function () {
            return this;
          }),
          _(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), y)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                y
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                y
              );
            },
          }),
          t
        );
      }
      var c = (function () {
        function e() {
          Object(a.default)(this, e);
        }
        return (
          Object(r.default)(e, null, [
            {
              key: "renderAPI",
              value: function (t) {
                if ("string" !== typeof t) return t;
                var n = "";
                return (
                  e.apiHostList.store_api.prod &&
                    (n = e.apiHostList.store_api.prod.host),
                  n + t
                );
              },
            },
            {
              key: "request",
              value: (function () {
                var t = Object(o.default)(
                  s().mark(function t(n, o) {
                    var a, r, i;
                    return s().wrap(function (t) {
                      for (;;)
                        switch ((t.prev = t.next)) {
                          case 0:
                            return (
                              (a = n.name),
                              (r = ""),
                              (i = ""),
                              e.apiList[a] && (i = e.apiList[a]),
                              e.apiHostList.store_api.prod &&
                                (r = e.apiHostList.store_api.prod.host),
                              i &&
                                (n = Object.assign(n, {
                                  url: "".concat(r).concat(i),
                                })),
                              t.abrupt("return", Object(l.a)(n, o))
                            );
                          case 7:
                          case "end":
                            return t.stop();
                        }
                    }, t);
                  }),
                );
                return function (e, n) {
                  return t.apply(this, arguments);
                };
              })(),
            },
          ]),
          e
        );
      })();
      Object(i.a)(c, "apiHostList", {
        store_api: {
          test: { host: "//r-store.dbeta.me" },
          dev: { host: "//r-store.dbeta.me" },
          stag: { host: "//r-store.dbeta.me" },
          prod: { host: "//store.dji.com" },
          master: { host: "//store.dji.com" },
          host: "//store.dji.com",
        },
      }),
        Object(i.a)(c, "apiList", { subscribe: "/api/v8/subscribes" });
    },
    UvRJ: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o = (function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e)
          for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return (t.default = e), t;
      })(n("Aw7D"));
      var a = "enum";
      t.default = function (e, t, n, r, i) {
        (e[a] = Array.isArray(e[a]) ? e[a] : []),
          -1 === e[a].indexOf(t) &&
            r.push(o.format(i.messages[a], e.fullField, e[a].join(", ")));
      };
    },
    "Uy/O": function (e, t, n) {
      e.exports = {
        "wm330-section-carousel-groups":
          "style__wm330-section-carousel-groups___2CsmD",
        "is-safari": "style__is-safari___b39ZQ",
        "text-wrapper": "style__text-wrapper___A3aUT",
        "text-desc": "style__text-desc___mSjkD",
        "carousel-mask": "style__carousel-mask___188Nv",
        "safari-hardware-acceleration":
          "style__safari-hardware-acceleration___1KnC5",
        "carousel-poster": "style__carousel-poster___2QKRe",
        "carousel-image": "style__carousel-image___2xI-0",
        "section-content": "style__section-content___FnWH1",
        "control-wrapper": "style__control-wrapper___3p0I8",
        "control-wrapper-white": "style__control-wrapper-white___NeUJr",
        "pagination-wrapper": "style__pagination-wrapper___1vVrY",
        "image-carousel-hidden": "style__image-carousel-hidden___3NroP",
        "carousel-desc-wrapper": "style__carousel-desc-wrapper___lDFda",
        "carousel-desc-wrapper-no-pagination":
          "style__carousel-desc-wrapper-no-pagination___I1MSN",
        "carousel-desc-wrapper-margin-top":
          "style__carousel-desc-wrapper-margin-top___2NAQJ",
        "carousel-desc-wrapper-no-datamargin-top":
          "style__carousel-desc-wrapper-no-datamargin-top___2xAuF",
        "click-area": "style__click-area___1F_k4",
        "left-click-area": "style__left-click-area___u7KKU",
        "right-click-area": "style__right-click-area___3mFe8",
        "carousel-button-wrapper": "style__carousel-button-wrapper___13YG4",
        "carousel-button-wrapper-ctn":
          "style__carousel-button-wrapper-ctn___H8gRd",
        "carousel-button": "style__carousel-button___BIlYp",
        "carousel-button-container": "style__carousel-button-container___3dzaL",
        "carousel-button-inner": "style__carousel-button-inner___2q4tr",
        "carousel-button-video-play":
          "style__carousel-button-video-play___28lvo",
        "video-play-light": "style__video-play-light___3xwXv",
        "carousel-video-play": "style__carousel-video-play___1ZcaT",
        "video-play-dark": "style__video-play-dark___1ZfBb",
        "wm330-section-carousel-groups-m":
          "style__wm330-section-carousel-groups-m___3Vzbt",
        "carousel-item-desc": "style__carousel-item-desc___122B3",
        "carousel-item-detail": "style__carousel-item-detail___2LWyx",
        "carousel-item-title": "style__carousel-item-title___1Hxcn",
        "downgrade-video-mobile": "style__downgrade-video-mobile___2-ere",
        "downgrade-play-btn-mobile": "style__downgrade-play-btn-mobile___2hiht",
        "downgrade-pic-mobile": "style__downgrade-pic-mobile___1mwcu",
        pc: "style__pc___766ZQ",
      };
    },
    V6Gm: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return l;
      });
      var o = n("3T+G"),
        a = n("IQvP"),
        r = n("90zR"),
        i = n("1bLc"),
        l = {
          test: function (e) {
            return i.a.test(e) || a.a.test(e) || r.a.test(e);
          },
          parse: function (e) {
            return i.a.test(e)
              ? i.a.parse(e)
              : r.a.test(e)
                ? r.a.parse(e)
                : a.a.parse(e);
          },
          transform: function (e) {
            return Object(o.d)(e)
              ? e
              : e.hasOwnProperty("red")
                ? i.a.transform(e)
                : r.a.transform(e);
          },
        };
    },
    V6Ve: function (e, t, n) {
      var o = n("kekF")(Object.keys, Object);
      e.exports = o;
    },
    V7oC: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o,
        a = n("SEkw"),
        r = (o = a) && o.__esModule ? o : { default: o };
      t.default = (function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n];
            (o.enumerable = o.enumerable || !1),
              (o.configurable = !0),
              "value" in o && (o.writable = !0),
              (0, r.default)(e, o.key, o);
          }
        }
        return function (t, n, o) {
          return n && e(t.prototype, n), o && e(t, o), t;
        };
      })();
    },
    VCL8: function (e, t, n) {
      "use strict";
      function o() {
        var e = this.constructor.getDerivedStateFromProps(
          this.props,
          this.state,
        );
        null !== e && void 0 !== e && this.setState(e);
      }
      function a(e) {
        this.setState(
          function (t) {
            var n = this.constructor.getDerivedStateFromProps(e, t);
            return null !== n && void 0 !== n ? n : null;
          }.bind(this),
        );
      }
      function r(e, t) {
        try {
          var n = this.props,
            o = this.state;
          (this.props = e),
            (this.state = t),
            (this.__reactInternalSnapshotFlag = !0),
            (this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(n, o));
        } finally {
          (this.props = n), (this.state = o);
        }
      }
      function i(e) {
        var t = e.prototype;
        if (!t || !t.isReactComponent)
          throw new Error("Can only polyfill class components");
        if (
          "function" !== typeof e.getDerivedStateFromProps &&
          "function" !== typeof t.getSnapshotBeforeUpdate
        )
          return e;
        var n = null,
          i = null,
          l = null;
        if (
          ("function" === typeof t.componentWillMount
            ? (n = "componentWillMount")
            : "function" === typeof t.UNSAFE_componentWillMount &&
              (n = "UNSAFE_componentWillMount"),
          "function" === typeof t.componentWillReceiveProps
            ? (i = "componentWillReceiveProps")
            : "function" === typeof t.UNSAFE_componentWillReceiveProps &&
              (i = "UNSAFE_componentWillReceiveProps"),
          "function" === typeof t.componentWillUpdate
            ? (l = "componentWillUpdate")
            : "function" === typeof t.UNSAFE_componentWillUpdate &&
              (l = "UNSAFE_componentWillUpdate"),
          null !== n || null !== i || null !== l)
        ) {
          var s = e.displayName || e.name,
            c =
              "function" === typeof e.getDerivedStateFromProps
                ? "getDerivedStateFromProps()"
                : "getSnapshotBeforeUpdate()";
          throw Error(
            "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" +
              s +
              " uses " +
              c +
              " but also contains the following legacy lifecycles:" +
              (null !== n ? "\n  " + n : "") +
              (null !== i ? "\n  " + i : "") +
              (null !== l ? "\n  " + l : "") +
              "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks",
          );
        }
        if (
          ("function" === typeof e.getDerivedStateFromProps &&
            ((t.componentWillMount = o), (t.componentWillReceiveProps = a)),
          "function" === typeof t.getSnapshotBeforeUpdate)
        ) {
          if ("function" !== typeof t.componentDidUpdate)
            throw new Error(
              "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype",
            );
          t.componentWillUpdate = r;
          var _ = t.componentDidUpdate;
          t.componentDidUpdate = function (e, t, n) {
            var o = this.__reactInternalSnapshotFlag
              ? this.__reactInternalSnapshot
              : n;
            _.call(this, e, t, o);
          };
        }
        return e;
      }
      n.r(t),
        n.d(t, "polyfill", function () {
          return i;
        }),
        (o.__suppressDeprecationWarning = !0),
        (a.__suppressDeprecationWarning = !0),
        (r.__suppressDeprecationWarning = !0);
    },
    VJsP: function (e, t, n) {
      "use strict";
      var o = n("2GTP"),
        a = n("Y7ZC"),
        r = n("JB68"),
        i = n("sNwI"),
        l = n("NwJ3"),
        s = n("tEej"),
        c = n("IP1Z"),
        _ = n("fNZA");
      a(
        a.S +
          a.F *
            !n("TuGD")(function (e) {
              Array.from(e);
            }),
        "Array",
        {
          from: function (e) {
            var t,
              n,
              a,
              u,
              d = r(e),
              p = "function" == typeof this ? this : Array,
              f = arguments.length,
              h = f > 1 ? arguments[1] : void 0,
              m = void 0 !== h,
              y = 0,
              b = _(d);
            if (
              (m && (h = o(h, f > 2 ? arguments[2] : void 0, 2)),
              void 0 == b || (p == Array && l(b)))
            )
              for (n = new p((t = s(d.length))); t > y; y++)
                c(n, y, m ? h(d[y], y) : d[y]);
            else
              for (u = b.call(d), n = new p(); !(a = u.next()).done; y++)
                c(n, y, m ? i(u, h, [a.value, y], !0) : a.value);
            return (n.length = y), n;
          },
        },
      );
    },
    VJv2: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return i;
      });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("rePB"),
        i = (function () {
          function e() {
            Object(o.default)(this, e),
              Object(r.a)(this, "idleTaskList", void 0),
              Object(r.a)(this, "runnerTimeout", void 0),
              (this.idleTaskList = []);
          }
          return (
            Object(a.default)(
              e,
              [
                {
                  key: "addIdleTask",
                  value: function (e) {
                    var t = this;
                    (this.idleTaskList = this.idleTaskList.concat(e)),
                      clearTimeout(this.runnerTimeout),
                      (this.runnerTimeout = setTimeout(function () {
                        t.runTask();
                      }, 1e3));
                  },
                },
                {
                  key: "clearIdleTask",
                  value: function () {
                    this.idleTaskList = [];
                  },
                },
                {
                  key: "allTaskFinished",
                  value: function () {
                    return 0 === this.idleTaskList.length;
                  },
                },
                {
                  key: "runTask",
                  value: function () {
                    0 !== this.idleTaskList.length &&
                      (window.requestIdleCallback
                        ? this.runIdleCallback()
                        : this.runTimeout());
                  },
                },
                {
                  key: "runIdleCallback",
                  value: function () {
                    var e = this;
                    0 !== this.idleTaskList.length &&
                      window.requestIdleCallback(function () {
                        var t = e.idleTaskList.shift();
                        null === t || void 0 === t || t(), e.runIdleCallback();
                      });
                  },
                },
                {
                  key: "runTimeout",
                  value: function () {
                    var e = this;
                    setTimeout(function () {
                      0 !== e.idleTaskList.length &&
                        (e.idleTaskList.shift()(), e.runTimeout());
                    }, 100);
                  },
                },
              ],
              [
                {
                  key: "getInstance",
                  value: function () {
                    return (
                      this.instance || (this.instance = new e()), this.instance
                    );
                  },
                },
              ],
            ),
            e
          );
        })();
      Object(r.a)(i, "instance", void 0);
    },
    VOcB: function (e, t, n) {
      "use strict";
      function o(e, t) {
        return e
          .replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1")
          .replace(/\s+/g, " ")
          .replace(/^\s*|\s*$/g, "");
      }
      e.exports = function (e, t) {
        e.classList
          ? e.classList.remove(t)
          : "string" === typeof e.className
            ? (e.className = o(e.className, t))
            : e.setAttribute(
                "class",
                o((e.className && e.className.baseVal) || "", t),
              );
      };
    },
    VOtZ: function (e, t, n) {
      var o = n("juv8"),
        a = n("MvSz");
      e.exports = function (e, t) {
        return o(e, a(e), t);
      };
    },
    VVlx: function (e, t, n) {
      var o = n("29s/")("keys"),
        a = n("YqAc");
      e.exports = function (e) {
        return o[e] || (o[e] = a(e));
      };
    },
    VaNO: function (e, t) {
      e.exports = function (e) {
        return this.__data__.has(e);
      };
    },
    VsOx: function (e, t, n) {},
    W070: function (e, t, n) {
      var o = n("NsO/"),
        a = n("tEej"),
        r = n("D8kY");
      e.exports = function (e) {
        return function (t, n, i) {
          var l,
            s = o(t),
            c = a(s.length),
            _ = r(i, c);
          if (e && n != n) {
            for (; c > _; ) if ((l = s[_++]) != l) return !0;
          } else
            for (; c > _; _++)
              if ((e || _ in s) && s[_] === n) return e || _ || 0;
          return !e && -1;
        };
      };
    },
    W0Nb: function (e, t, n) {
      e.exports = {
        "form-group-zh-enterprise": "style__form-group-zh-enterprise___3XhEO",
        "form-group": "style__form-group___3qY25",
        hide: "style__hide___11I_N",
        "form-group-zh-enterprise-input-error":
          "style__form-group-zh-enterprise-input-error___LEAPm",
        "arealinkage-cn-box": "style__arealinkage-cn-box___1kasu",
        icon: "style__icon___2zsCg",
        "icon-show": "style__icon-show___2PyzX",
        "icon-no-show": "style__icon-no-show___3cKAt",
        "arealinkage-cn-input-label":
          "style__arealinkage-cn-input-label___3k2tv",
        "arealinkage-cn-input-label-focussend":
          "style__arealinkage-cn-input-label-focussend___1K6ur",
        "arealinkage-cn-box-mobile-margin":
          "style__arealinkage-cn-box-mobile-margin___3p_nH",
        "arealinkage-cn-input-modal-pc":
          "style__arealinkage-cn-input-modal-pc___DnWem",
        "arealinkage-cn-input-modal-mobile":
          "style__arealinkage-cn-input-modal-mobile___5ISl0",
        "arealinkage-cn-input-modal-pc-city-box":
          "style__arealinkage-cn-input-modal-pc-city-box___3cXF3",
        "arealinkage-cn-modal-normal":
          "style__arealinkage-cn-modal-normal___2rtFr",
        "arealinkage-cn-modal-height-change":
          "style__arealinkage-cn-modal-height-change___2p0tQ",
        "arealinkage-cn-input-modal-mobile-city-box":
          "style__arealinkage-cn-input-modal-mobile-city-box___1GG7O",
        "arealinkage-cn-input-modal-pc-item":
          "style__arealinkage-cn-input-modal-pc-item___AoWr9",
        "arealinkage-cn-input-modal-mobile-item":
          "style__arealinkage-cn-input-modal-mobile-item___3Ihzf",
        "arealinkage-cn-input-modal-pc-item-active":
          "style__arealinkage-cn-input-modal-pc-item-active___3lIcV",
        "arealinkage-cn-form-item-position":
          "style__arealinkage-cn-form-item-position___20kjp",
        "form-error-height-normal": "style__form-error-height-normal___2T9ai",
        "form-error-height-change-box":
          "style__form-error-height-change-box___3eNCV",
        "arealinkage-cn-form-item-no-show":
          "style__arealinkage-cn-form-item-no-show___2l2Up",
        "zh-enterprise-pop-up-wrapper-mobile":
          "style__zh-enterprise-pop-up-wrapper-mobile___37s7E",
        "zh-enterprise-pop-up-wrapper-mobile-active":
          "style__zh-enterprise-pop-up-wrapper-mobile-active___2yKNz",
        "pop-up-mask": "style__pop-up-mask___3mJQh",
        "popup-content-wrapper": "style__popup-content-wrapper___3HiOh",
        "zh-enterprise-display-none":
          "style__zh-enterprise-display-none___1KXC_",
        "no-live": "style__no-live___3Ze9t",
        "pop-up-inner-wrapper": "style__pop-up-inner-wrapper___-kkEm",
        "pop-up-content": "style__pop-up-content___31rR1",
        close: "style__close___25CBc",
        "pop-up-title": "style__pop-up-title___2nV0F",
        "line-box": "style__line-box___2gK2j",
        "line-text": "style__line-text___dh3Qe",
        line: "style__line___2RQLd",
        "platform-list-wrapper": "style__platform-list-wrapper___2NS9V",
        "platform-item": "style__platform-item___yKYdZ",
        "platform-logo": "style__platform-logo___3EMtr",
      };
    },
    W3Nv: function (e, t, n) {
      "use strict";
      function o(e, t) {
        -1 === e.indexOf(t) && e.push(t);
      }
      function a(e, t) {
        var n = e.indexOf(t);
        n > -1 && e.splice(n, 1);
      }
      n.d(t, "a", function () {
        return o;
      }),
        n.d(t, "b", function () {
          return a;
        });
    },
    WCLa: function (e, t, n) {
      "use strict";
      var o = n("KQm4"),
        a = n("ODXe"),
        r = n("HaE+"),
        i = n("Ff2n"),
        l = n("wx14"),
        s = n("VJv2"),
        c = n("/+VL"),
        _ = n("1OyB"),
        u = n("vuIU"),
        d = n("rePB"),
        p = n("Agtg"),
        f = n("yWgo");
      function h() {
        h = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof b ? t : b,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          m = "completed",
          y = {};
        function b() {}
        function v() {}
        function g() {}
        var w = {};
        c(w, i, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, i) && (w = k);
        var O = (g.prototype = b.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === m) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = m), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? m : p), c.arg === y)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = m), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              y
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), y
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                y)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (v.prototype = g),
          a(O, "constructor", { value: g, configurable: !0 }),
          a(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = c(g, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          c(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          c(O, s, "Generator"),
          c(O, i, function () {
            return this;
          }),
          c(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), y)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                y
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                y
              );
            },
          }),
          t
        );
      }
      var m = (function () {
        function e() {
          var t = this;
          Object(_.default)(this, e),
            Object(d.a)(this, "dimension", void 0),
            Object(d.a)(this, "scrollManager", void 0),
            Object(d.a)(this, "nodes", []),
            Object(d.a)(this, "pixelRatio", 1),
            Object(d.a)(this, "windowHeight", void 0),
            Object(d.a)(this, "dimensionListenerKey", "ScrollRecycler"),
            Object(d.a)(
              this,
              "doRecycle",
              (function () {
                var e = Object(r.default)(
                  h().mark(function e(n, o) {
                    var a, r, i, l, s;
                    return h().wrap(function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            (a = n.element),
                              (r = t.dimension.pageOffsetY),
                              (i = a.offsetTop),
                              (l = t.dimension.scrollDirection),
                              o
                                ? (t.shouldShow(l, r, i) ||
                                    t.dimension.isAnchorScroll) &&
                                  t.showNode(n)
                                : t.shouldHide(l, r, i) &&
                                  ((s =
                                    a.offsetHeight -
                                    Math.max(2, Math.ceil(t.pixelRatio))) >
                                    n.renderedHeight && (n.renderedHeight = s),
                                  t.hideNode(n));
                          case 5:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  }),
                );
                return function (t, n) {
                  return e.apply(this, arguments);
                };
              })(),
            ),
            (this.scrollManager = c.a.getInstance()),
            (this.dimension = this.scrollManager.getDimension()),
            (this.windowHeight =
              this.dimension.innerHeight || e.DEFAULT_WINDOW_HEIGHT),
            this.dimension.addDimensionListener(this.dimensionListenerKey, {
              onScrollEnd: this.onScrollEnd.bind(this),
            }),
            window && (this.pixelRatio = window.devicePixelRatio);
        }
        return (
          Object(u.default)(
            e,
            [
              {
                key: "add",
                value: function (e) {
                  var t = this;
                  if (e && e.firstChild) {
                    var n = getComputedStyle(e.firstChild).display,
                      o = {
                        element: e,
                        renderedHeight:
                          e.offsetHeight -
                          Math.max(2, Math.ceil(this.pixelRatio)),
                        offsetHeight: -1,
                        retain: !0,
                        displayStyle: n,
                      };
                    this.nodes.push(o),
                      new IntersectionObserver(
                        function (e) {
                          var n = Object(a.a)(e, 1)[0];
                          n.isIntersecting && n.intersectionRatio > 0
                            ? ((o.retain = !0), t.doRecycle(o, !0))
                            : ((o.retain = !1), t.doRecycle(o, !1));
                        },
                        {
                          rootMargin: ""
                            .concat(4 * this.windowHeight, "px 0px ")
                            .concat(4 * this.windowHeight, "px 0px"),
                        },
                      ).observe(e);
                  }
                },
              },
              {
                key: "onScrollEnd",
                value: function () {
                  var e = this;
                  this.nodes.forEach(function (t, n, o) {
                    var a, r;
                    (t.retain ||
                      (!t.retain &&
                        (null === (a = o[n - 1]) || void 0 === a
                          ? void 0
                          : a.retain) &&
                        (null === (r = o[n + 1]) || void 0 === r
                          ? void 0
                          : r.retain))) &&
                      e.showNode(t);
                  });
                },
              },
              {
                key: "showNode",
                value: function (e) {
                  var t = e.element,
                    n = e.renderedHeight;
                  (t.firstChild.style.display = e.displayStyle),
                    Object(f.s)()
                      ? t.setAttribute("style", "height: auto;")
                      : t.setAttribute(
                          "style",
                          "height: auto; min-height:".concat(n, "px;"),
                        );
                },
              },
              {
                key: "hideNode",
                value: function (e) {
                  var t = e.element,
                    n = e.renderedHeight;
                  t.setAttribute(
                    "style",
                    "height: ".concat(n, "px; min-height:").concat(n, "px;"),
                  ),
                    (t.firstChild.style.display = "none");
                },
              },
              {
                key: "shouldShow",
                value: function (e, t, n) {
                  return (e === p.a.UP && t >= n) || (e === p.a.DOWN && t <= n);
                },
              },
              {
                key: "shouldHide",
                value: function (e, t, n) {
                  return (e === p.a.UP && t <= n) || (e === p.a.DOWN && t >= n);
                },
              },
            ],
            [
              {
                key: "enableScrollRecycler",
                value: function () {
                  return (
                    window &&
                    window.location &&
                    (window.location.pathname.endsWith("mobile/avata-2") ||
                      window.location.pathname.endsWith("mobile/rs-4-pro") ||
                      window.location.pathname.endsWith("mobile/ronin-4d") ||
                      window.location.pathname.endsWith(
                        "mobile/osmo-action-4",
                      ) ||
                      window.location.pathname.endsWith("mobile/inspire-3"))
                  );
                },
              },
              {
                key: "getInstance",
                value: function () {
                  return (
                    this.instance || (this.instance = new e()), this.instance
                  );
                },
              },
            ],
          ),
          e
        );
      })();
      Object(d.a)(m, "instance", void 0),
        Object(d.a)(m, "DEFAULT_WINDOW_HEIGHT", 800);
      n("Wr5T");
      var y = n("q1tI"),
        b = [
          "Wrapper",
          "forceHydration",
          "wrapperProps",
          "wrapperInitialProps",
          "wrapperClientInitialProps",
          "isV0V1Hide",
          "hideCardComponent",
        ],
        v = n.n(y).a.createElement;
      function g() {
        g = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var w = {};
        c(w, i, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, i) && (w = k);
        var O = (v.prototype = y.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(O, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          c(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          c(O, s, "Generator"),
          c(O, i, function () {
            return this;
          }),
          c(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      var w = { once: !0, capture: !0, passive: !0 },
        x = function (e) {
          var t = e.Wrapper,
            n = void 0 === t ? "div" : t,
            o = e.wrapperProps,
            a = e.wrapperInitialProps;
          return v(
            n,
            Object(l.a)(
              {
                dangerouslySetInnerHTML: { __html: "" },
                suppressHydrationWarning: !0,
              },
              o,
              a,
              { style: { display: "none" } },
            ),
          );
        },
        k = function (e) {
          var t = e.disableFallback,
            n = void 0 !== t && t,
            _ = e.onBefore,
            u = void 0 === _ ? Function.prototype : _,
            d = e.removeWrapperOnHydration,
            p = void 0 !== d && d,
            f = e.on,
            h = void 0 === f ? [] : f;
          return function (e) {
            var t = function (t) {
              var _ = t.Wrapper,
                d = void 0 === _ ? "div" : _,
                f = t.forceHydration,
                k = void 0 !== f && f,
                O = t.wrapperProps,
                I = t.wrapperInitialProps,
                S = (t.wrapperClientInitialProps, t.isV0V1Hide),
                j = t.hideCardComponent,
                T = void 0 !== j && j,
                C = Object(i.a)(t, b),
                M = Object(y.useRef)(null),
                P = Object(y.useRef)([]),
                E = Object(y.useState)(!1),
                L = E[0],
                B = E[1],
                N = Object(y.useRef)(!1),
                D = function () {
                  P.current.forEach(function (e) {
                    return e();
                  }),
                    (P.current = []);
                },
                z = (function () {
                  var e = Object(r.default)(
                    g().mark(function e() {
                      return g().wrap(function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              if ((D(), !L)) {
                                e.next = 3;
                                break;
                              }
                              return e.abrupt("return");
                            case 3:
                              if (!N.current) {
                                e.next = 5;
                                break;
                              }
                              return e.abrupt("return");
                            case 5:
                              if (
                                !c.a.getInstance().getDimension().isAnchorScroll
                              ) {
                                e.next = 9;
                                break;
                              }
                              return (
                                s.a.getInstance().addIdleTask([
                                  function () {
                                    z();
                                  },
                                ]),
                                e.abrupt("return")
                              );
                            case 9:
                              return (e.next = 11), u();
                            case 11:
                              (N.current = !0),
                                B(!0),
                                m.enableScrollRecycler() &&
                                  setTimeout(function () {
                                    N.current && m.getInstance().add(M.current);
                                  }, 1e3);
                            case 14:
                            case "end":
                              return e.stop();
                          }
                      }, e);
                    }),
                  );
                  return function () {
                    return e.apply(this, arguments);
                  };
                })(),
                A = function () {
                  var e =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : 2e3;
                  if (!(e < 0)) {
                    var t = setTimeout(z, e);
                    P.current.push(function () {
                      return clearTimeout(t);
                    });
                  }
                },
                R = function (e, t) {
                  switch (e) {
                    case "delay":
                      A(t);
                      break;
                    case "visible":
                      !(function () {
                        var e =
                            arguments.length > 0 && void 0 !== arguments[0]
                              ? arguments[0]
                              : Function.prototype,
                          t =
                            !!window.MSInputMethodContext &&
                            !!document.documentMode;
                        if ("IntersectionObserver" in window && !t) {
                          var n = e(),
                            o = new IntersectionObserver(function (e, t) {
                              var n = Object(a.a)(e, 1)[0];
                              n.isIntersecting &&
                                n.intersectionRatio > 0 &&
                                z();
                            }, n);
                          P.current.push(function () {
                            o && o.disconnect();
                          }),
                            o.observe(M.current);
                        } else z();
                      })(t);
                      break;
                    case "idle":
                      "requestIdleCallback" in window
                        ? s.a.getInstance().addIdleTask([
                            function () {
                              z();
                            },
                          ])
                        : A();
                      break;
                    case "stop-interact":
                      !(function (e) {
                        var t,
                          n = !1,
                          o = function () {
                            l();
                          },
                          a = function () {
                            i();
                          },
                          r = function () {
                            l(), i();
                          };
                        function i() {
                          t = setTimeout(function () {
                            window.removeEventListener("touchstart", o),
                              window.removeEventListener("touchend", a),
                              window.removeEventListener("scroll", r),
                              n || ((n = !0), z());
                          }, e);
                        }
                        function l() {
                          t && (clearTimeout(t), (t = null));
                        }
                        window.addEventListener("touchstart", o, {
                          passive: !0,
                        }),
                          window.addEventListener("touchend", a, {
                            passive: !0,
                          }),
                          window.addEventListener("scroll", r, { passive: !0 });
                      })(t);
                      break;
                    default:
                      !(function (e) {
                        var t =
                            arguments.length > 1 && void 0 !== arguments[1]
                              ? arguments[1]
                              : function () {
                                  return M.current;
                                },
                          n = t();
                        n.addEventListener(e, z, w),
                          P.current.push(function () {
                            n && n.removeEventListener(e, z, w);
                          });
                      })(e, t);
                  }
                };
              return (
                Object(y.useLayoutEffect)(function () {
                  L ||
                    (((!!!M.current.getAttribute("data-hydration-on-demand") &&
                      !n) ||
                      k) &&
                      z());
                }),
                Object(y.useEffect)(function () {
                  if (!L && !k)
                    return (
                      h.forEach(function (e) {
                        return Array.isArray(e)
                          ? R.apply(void 0, Object(o.a)(e))
                          : R(e);
                      }),
                      D
                    );
                }, []),
                L
                  ? L && S
                    ? x({ wrapperProps: O, wrapperInitialProps: I })
                    : L && T
                      ? v(
                          d,
                          Object(l.a)({ ref: M }, O, {
                            style: { opacity: 0, height: 0 },
                          }),
                          v(e, C),
                        )
                      : p
                        ? v(e, Object(l.a)({ ref: M }, C))
                        : v(d, Object(l.a)({ ref: M }, O), v(e, C))
                  : v(
                      d,
                      Object(l.a)(
                        {
                          ref: M,
                          dangerouslySetInnerHTML: { __html: "" },
                          suppressHydrationWarning: !0,
                        },
                        O,
                        I,
                      ),
                    )
              );
            };
            return (
              (t.displayName = "withHydrationOnDemand(".concat(
                (function (e) {
                  return e.displayName || e.name || "Component";
                })(e),
                ")",
              )),
              t
            );
          };
        };
      t.a = function () {
        var e =
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return k(e);
      };
    },
    WCV8: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o = c(n("zWvU")),
        a = c(n("/Nsm")),
        r = c(n("SxVx")),
        i = c(n("7gbh")),
        l = c(n("UvRJ")),
        s = c(n("XP4N"));
      function c(e) {
        return e && e.__esModule ? e : { default: e };
      }
      t.default = {
        required: o.default,
        whitespace: a.default,
        type: r.default,
        range: i.default,
        enum: l.default,
        pattern: s.default,
      };
    },
    WDec: function (e, t, n) {
      e.exports = {
        "sub-nav-wrap-common": "style__sub-nav-wrap-common___3PVba",
        "sub-nav-right": "style__sub-nav-right___ruIrR",
        "sub-nav": "style__sub-nav___AjIC_",
        "sub-nav-wrap-dark": "style__sub-nav-wrap-dark___LJNeE",
        "product-title": "style__product-title___29p40",
        "sub-nav-wrap-light": "style__sub-nav-wrap-light___1ECG_",
        "sub-nav-container": "style__sub-nav-container___21l4Q",
        "sub-nav-display-none": "style__sub-nav-display-none___nMoeI",
        "sub-nav-btn": "style__sub-nav-btn___fguHS",
        "buy-now": "style__buy-now___2TgCR",
        "buy-now-box": "style__buy-now-box___1nqqw",
        "buy-now-store-point": "style__buy-now-store-point___3DBaA",
        point: "style__point___2bNPa",
        "product-price": "style__product-price___wyUEp",
        origin: "style__origin___29TtQ",
      };
    },
    WEpk: function (e, t) {
      var n = (e.exports = { version: "2.6.12" });
      "number" == typeof __e && (__e = n);
    },
    WFqU: function (e, t, n) {
      (function (t) {
        var n = "object" == typeof t && t && t.Object === Object && t;
        e.exports = n;
      }).call(this, n("yLpj"));
    },
    Wr5T: function (e, t) {
      !(function () {
        "use strict";
        if ("object" === typeof window)
          if (
            "IntersectionObserver" in window &&
            "IntersectionObserverEntry" in window &&
            "intersectionRatio" in window.IntersectionObserverEntry.prototype
          )
            "isIntersecting" in window.IntersectionObserverEntry.prototype ||
              Object.defineProperty(
                window.IntersectionObserverEntry.prototype,
                "isIntersecting",
                {
                  get: function () {
                    return this.intersectionRatio > 0;
                  },
                },
              );
          else {
            var e = (function (e) {
                for (var t = window.document, n = a(t); n; )
                  n = a((t = n.ownerDocument));
                return t;
              })(),
              t = [],
              n = null,
              o = null;
            (i.prototype.THROTTLE_TIMEOUT = 100),
              (i.prototype.POLL_INTERVAL = null),
              (i.prototype.USE_MUTATION_OBSERVER = !0),
              (i._setupCrossOriginUpdater = function () {
                return (
                  n ||
                    (n = function (e, n) {
                      (o =
                        e && n
                          ? d(e, n)
                          : {
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              width: 0,
                              height: 0,
                            }),
                        t.forEach(function (e) {
                          e._checkForIntersections();
                        });
                    }),
                  n
                );
              }),
              (i._resetCrossOriginUpdater = function () {
                (n = null), (o = null);
              }),
              (i.prototype.observe = function (e) {
                if (
                  !this._observationTargets.some(function (t) {
                    return t.element == e;
                  })
                ) {
                  if (!e || 1 != e.nodeType)
                    throw new Error("target must be an Element");
                  this._registerInstance(),
                    this._observationTargets.push({ element: e, entry: null }),
                    this._monitorIntersections(e.ownerDocument),
                    this._checkForIntersections();
                }
              }),
              (i.prototype.unobserve = function (e) {
                (this._observationTargets = this._observationTargets.filter(
                  function (t) {
                    return t.element != e;
                  },
                )),
                  this._unmonitorIntersections(e.ownerDocument),
                  0 == this._observationTargets.length &&
                    this._unregisterInstance();
              }),
              (i.prototype.disconnect = function () {
                (this._observationTargets = []),
                  this._unmonitorAllIntersections(),
                  this._unregisterInstance();
              }),
              (i.prototype.takeRecords = function () {
                var e = this._queuedEntries.slice();
                return (this._queuedEntries = []), e;
              }),
              (i.prototype._initThresholds = function (e) {
                var t = e || [0];
                return (
                  Array.isArray(t) || (t = [t]),
                  t.sort().filter(function (e, t, n) {
                    if ("number" != typeof e || isNaN(e) || e < 0 || e > 1)
                      throw new Error(
                        "threshold must be a number between 0 and 1 inclusively",
                      );
                    return e !== n[t - 1];
                  })
                );
              }),
              (i.prototype._parseRootMargin = function (e) {
                var t = (e || "0px").split(/\s+/).map(function (e) {
                  var t = /^(-?\d*\.?\d+)(px|%)$/.exec(e);
                  if (!t)
                    throw new Error(
                      "rootMargin must be specified in pixels or percent",
                    );
                  return { value: parseFloat(t[1]), unit: t[2] };
                });
                return (
                  (t[1] = t[1] || t[0]),
                  (t[2] = t[2] || t[0]),
                  (t[3] = t[3] || t[1]),
                  t
                );
              }),
              (i.prototype._monitorIntersections = function (t) {
                var n = t.defaultView;
                if (n && -1 == this._monitoringDocuments.indexOf(t)) {
                  var o = this._checkForIntersections,
                    r = null,
                    i = null;
                  this.POLL_INTERVAL
                    ? (r = n.setInterval(o, this.POLL_INTERVAL))
                    : (l(n, "resize", o, !0),
                      l(t, "scroll", o, !0),
                      this.USE_MUTATION_OBSERVER &&
                        "MutationObserver" in n &&
                        (i = new n.MutationObserver(o)).observe(t, {
                          attributes: !0,
                          childList: !0,
                          characterData: !0,
                          subtree: !0,
                        })),
                    this._monitoringDocuments.push(t),
                    this._monitoringUnsubscribes.push(function () {
                      var e = t.defaultView;
                      e && (r && e.clearInterval(r), s(e, "resize", o, !0)),
                        s(t, "scroll", o, !0),
                        i && i.disconnect();
                    });
                  var c =
                    (this.root && (this.root.ownerDocument || this.root)) || e;
                  if (t != c) {
                    var _ = a(t);
                    _ && this._monitorIntersections(_.ownerDocument);
                  }
                }
              }),
              (i.prototype._unmonitorIntersections = function (t) {
                var n = this._monitoringDocuments.indexOf(t);
                if (-1 != n) {
                  var o =
                    (this.root && (this.root.ownerDocument || this.root)) || e;
                  if (
                    !this._observationTargets.some(function (e) {
                      var n = e.element.ownerDocument;
                      if (n == t) return !0;
                      for (; n && n != o; ) {
                        var r = a(n);
                        if ((n = r && r.ownerDocument) == t) return !0;
                      }
                      return !1;
                    })
                  ) {
                    var r = this._monitoringUnsubscribes[n];
                    if (
                      (this._monitoringDocuments.splice(n, 1),
                      this._monitoringUnsubscribes.splice(n, 1),
                      r(),
                      t != o)
                    ) {
                      var i = a(t);
                      i && this._unmonitorIntersections(i.ownerDocument);
                    }
                  }
                }
              }),
              (i.prototype._unmonitorAllIntersections = function () {
                var e = this._monitoringUnsubscribes.slice(0);
                (this._monitoringDocuments.length = 0),
                  (this._monitoringUnsubscribes.length = 0);
                for (var t = 0; t < e.length; t++) e[t]();
              }),
              (i.prototype._checkForIntersections = function () {
                if (this.root || !n || o) {
                  var e = this._rootIsInDom(),
                    t = e
                      ? this._getRootRect()
                      : {
                          top: 0,
                          bottom: 0,
                          left: 0,
                          right: 0,
                          width: 0,
                          height: 0,
                        };
                  this._observationTargets.forEach(function (o) {
                    var a = o.element,
                      i = _(a),
                      l = this._rootContainsTarget(a),
                      s = o.entry,
                      c =
                        e &&
                        l &&
                        this._computeTargetAndRootIntersection(a, i, t),
                      u = null;
                    this._rootContainsTarget(a)
                      ? (n && !this.root) || (u = t)
                      : (u = {
                          top: 0,
                          bottom: 0,
                          left: 0,
                          right: 0,
                          width: 0,
                          height: 0,
                        });
                    var d = (o.entry = new r({
                      time:
                        window.performance &&
                        performance.now &&
                        performance.now(),
                      target: a,
                      boundingClientRect: i,
                      rootBounds: u,
                      intersectionRect: c,
                    }));
                    s
                      ? e && l
                        ? this._hasCrossedThreshold(s, d) &&
                          this._queuedEntries.push(d)
                        : s && s.isIntersecting && this._queuedEntries.push(d)
                      : this._queuedEntries.push(d);
                  }, this),
                    this._queuedEntries.length &&
                      this._callback(this.takeRecords(), this);
                }
              }),
              (i.prototype._computeTargetAndRootIntersection = function (
                t,
                a,
                r,
              ) {
                if ("none" != window.getComputedStyle(t).display) {
                  for (var i = a, l = f(t), s = !1; !s && l; ) {
                    var u = null,
                      p = 1 == l.nodeType ? window.getComputedStyle(l) : {};
                    if ("none" == p.display) return null;
                    if (l == this.root || 9 == l.nodeType)
                      if (((s = !0), l == this.root || l == e))
                        n && !this.root
                          ? !o || (0 == o.width && 0 == o.height)
                            ? ((l = null), (u = null), (i = null))
                            : (u = o)
                          : (u = r);
                      else {
                        var h = f(l),
                          m = h && _(h),
                          y =
                            h &&
                            this._computeTargetAndRootIntersection(h, m, r);
                        m && y
                          ? ((l = h), (u = d(m, y)))
                          : ((l = null), (i = null));
                      }
                    else {
                      var b = l.ownerDocument;
                      l != b.body &&
                        l != b.documentElement &&
                        "visible" != p.overflow &&
                        (u = _(l));
                    }
                    if ((u && (i = c(u, i)), !i)) break;
                    l = l && f(l);
                  }
                  return i;
                }
              }),
              (i.prototype._getRootRect = function () {
                var t;
                if (this.root && !h(this.root)) t = _(this.root);
                else {
                  var n = h(this.root) ? this.root : e,
                    o = n.documentElement,
                    a = n.body;
                  t = {
                    top: 0,
                    left: 0,
                    right: o.clientWidth || a.clientWidth,
                    width: o.clientWidth || a.clientWidth,
                    bottom: o.clientHeight || a.clientHeight,
                    height: o.clientHeight || a.clientHeight,
                  };
                }
                return this._expandRectByRootMargin(t);
              }),
              (i.prototype._expandRectByRootMargin = function (e) {
                var t = this._rootMarginValues.map(function (t, n) {
                    return "px" == t.unit
                      ? t.value
                      : (t.value * (n % 2 ? e.width : e.height)) / 100;
                  }),
                  n = {
                    top: e.top - t[0],
                    right: e.right + t[1],
                    bottom: e.bottom + t[2],
                    left: e.left - t[3],
                  };
                return (
                  (n.width = n.right - n.left), (n.height = n.bottom - n.top), n
                );
              }),
              (i.prototype._hasCrossedThreshold = function (e, t) {
                var n = e && e.isIntersecting ? e.intersectionRatio || 0 : -1,
                  o = t.isIntersecting ? t.intersectionRatio || 0 : -1;
                if (n !== o)
                  for (var a = 0; a < this.thresholds.length; a++) {
                    var r = this.thresholds[a];
                    if (r == n || r == o || r < n !== r < o) return !0;
                  }
              }),
              (i.prototype._rootIsInDom = function () {
                return !this.root || p(e, this.root);
              }),
              (i.prototype._rootContainsTarget = function (t) {
                var n =
                  (this.root && (this.root.ownerDocument || this.root)) || e;
                return p(n, t) && (!this.root || n == t.ownerDocument);
              }),
              (i.prototype._registerInstance = function () {
                t.indexOf(this) < 0 && t.push(this);
              }),
              (i.prototype._unregisterInstance = function () {
                var e = t.indexOf(this);
                -1 != e && t.splice(e, 1);
              }),
              (window.IntersectionObserver = i),
              (window.IntersectionObserverEntry = r);
          }
        function a(e) {
          try {
            return (e.defaultView && e.defaultView.frameElement) || null;
          } catch (t) {
            return null;
          }
        }
        function r(e) {
          (this.time = e.time),
            (this.target = e.target),
            (this.rootBounds = u(e.rootBounds)),
            (this.boundingClientRect = u(e.boundingClientRect)),
            (this.intersectionRect = u(
              e.intersectionRect || {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: 0,
                height: 0,
              },
            )),
            (this.isIntersecting = !!e.intersectionRect);
          var t = this.boundingClientRect,
            n = t.width * t.height,
            o = this.intersectionRect,
            a = o.width * o.height;
          this.intersectionRatio = n
            ? Number((a / n).toFixed(4))
            : this.isIntersecting
              ? 1
              : 0;
        }
        function i(e, t) {
          var n = t || {};
          if ("function" != typeof e)
            throw new Error("callback must be a function");
          if (n.root && 1 != n.root.nodeType && 9 != n.root.nodeType)
            throw new Error("root must be a Document or Element");
          (this._checkForIntersections = (function (e, t) {
            var n = null;
            return function () {
              n ||
                (n = setTimeout(function () {
                  e(), (n = null);
                }, t));
            };
          })(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT)),
            (this._callback = e),
            (this._observationTargets = []),
            (this._queuedEntries = []),
            (this._rootMarginValues = this._parseRootMargin(n.rootMargin)),
            (this.thresholds = this._initThresholds(n.threshold)),
            (this.root = n.root || null),
            (this.rootMargin = this._rootMarginValues
              .map(function (e) {
                return e.value + e.unit;
              })
              .join(" ")),
            (this._monitoringDocuments = []),
            (this._monitoringUnsubscribes = []);
        }
        function l(e, t, n, o) {
          "function" == typeof e.addEventListener
            ? e.addEventListener(t, n, o || !1)
            : "function" == typeof e.attachEvent && e.attachEvent("on" + t, n);
        }
        function s(e, t, n, o) {
          "function" == typeof e.removeEventListener
            ? e.removeEventListener(t, n, o || !1)
            : "function" == typeof e.detachEvent && e.detachEvent("on" + t, n);
        }
        function c(e, t) {
          var n = Math.max(e.top, t.top),
            o = Math.min(e.bottom, t.bottom),
            a = Math.max(e.left, t.left),
            r = Math.min(e.right, t.right),
            i = r - a,
            l = o - n;
          return (
            (i >= 0 &&
              l >= 0 && {
                top: n,
                bottom: o,
                left: a,
                right: r,
                width: i,
                height: l,
              }) ||
            null
          );
        }
        function _(e) {
          var t;
          try {
            t = e.getBoundingClientRect();
          } catch (n) {}
          return t
            ? ((t.width && t.height) ||
                (t = {
                  top: t.top,
                  right: t.right,
                  bottom: t.bottom,
                  left: t.left,
                  width: t.right - t.left,
                  height: t.bottom - t.top,
                }),
              t)
            : { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
        }
        function u(e) {
          return !e || "x" in e
            ? e
            : {
                top: e.top,
                y: e.top,
                bottom: e.bottom,
                left: e.left,
                x: e.left,
                right: e.right,
                width: e.width,
                height: e.height,
              };
        }
        function d(e, t) {
          var n = t.top - e.top,
            o = t.left - e.left;
          return {
            top: n,
            left: o,
            height: t.height,
            width: t.width,
            bottom: n + t.height,
            right: o + t.width,
          };
        }
        function p(e, t) {
          for (var n = t; n; ) {
            if (n == e) return !0;
            n = f(n);
          }
          return !1;
        }
        function f(t) {
          var n = t.parentNode;
          return 9 == t.nodeType && t != e
            ? a(t)
            : (n && n.assignedSlot && (n = n.assignedSlot.parentNode),
              n && 11 == n.nodeType && n.host ? n.host : n);
        }
        function h(e) {
          return e && 9 === e.nodeType;
        }
      })();
    },
    WwFo: function (e, t, n) {
      var o = n("juv8"),
        a = n("7GkX");
      e.exports = function (e, t) {
        return e && o(t, a(t), e);
      };
    },
    XP4N: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o = (function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e)
          for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return (t.default = e), t;
      })(n("Aw7D"));
      t.default = function (e, t, n, a, r) {
        if (e.pattern)
          if (e.pattern instanceof RegExp)
            (e.pattern.lastIndex = 0),
              e.pattern.test(t) ||
                a.push(
                  o.format(
                    r.messages.pattern.mismatch,
                    e.fullField,
                    t,
                    e.pattern,
                  ),
                );
          else if ("string" === typeof e.pattern) {
            new RegExp(e.pattern).test(t) ||
              a.push(
                o.format(
                  r.messages.pattern.mismatch,
                  e.fullField,
                  t,
                  e.pattern,
                ),
              );
          }
      };
    },
    XYm9: function (e, t, n) {
      var o = n("+K+b");
      e.exports = function (e, t) {
        var n = t ? o(e.buffer) : e.buffer;
        return new e.constructor(n, e.byteOffset, e.byteLength);
      };
    },
    Xchd: function (e, t, n) {
      "use strict";
      var o = n("Jq2x"),
        a = n("cKS0");
      function r() {
        return (r =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      var i = {
        update: function () {
          var e = this.rtl,
            t = this.params.pagination;
          if (
            t.el &&
            this.pagination.el &&
            this.pagination.$el &&
            0 !== this.pagination.$el.length
          ) {
            var n,
              r =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              i = this.pagination.$el,
              l = this.params.loop
                ? Math.ceil(
                    (r - 2 * this.loopedSlides) / this.params.slidesPerGroup,
                  )
                : this.snapGrid.length;
            if (
              (this.params.loop
                ? ((n = Math.ceil(
                    (this.activeIndex - this.loopedSlides) /
                      this.params.slidesPerGroup,
                  )) >
                    r - 1 - 2 * this.loopedSlides &&
                    (n -= r - 2 * this.loopedSlides),
                  n > l - 1 && (n -= l),
                  n < 0 &&
                    "bullets" !== this.params.paginationType &&
                    (n = l + n))
                : (n =
                    "undefined" !== typeof this.snapIndex
                      ? this.snapIndex
                      : this.activeIndex || 0),
              "bullets" === t.type &&
                this.pagination.bullets &&
                this.pagination.bullets.length > 0)
            ) {
              var s,
                c,
                _,
                u = this.pagination.bullets;
              if (
                (t.dynamicBullets &&
                  ((this.pagination.bulletSize = u
                    .eq(0)
                    [this.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                  i.css(
                    this.isHorizontal() ? "width" : "height",
                    this.pagination.bulletSize * (t.dynamicMainBullets + 4) +
                      "px",
                  ),
                  t.dynamicMainBullets > 1 &&
                    void 0 !== this.previousIndex &&
                    ((this.pagination.dynamicBulletIndex +=
                      n - this.previousIndex),
                    this.pagination.dynamicBulletIndex >
                    t.dynamicMainBullets - 1
                      ? (this.pagination.dynamicBulletIndex =
                          t.dynamicMainBullets - 1)
                      : this.pagination.dynamicBulletIndex < 0 &&
                        (this.pagination.dynamicBulletIndex = 0)),
                  (s = n - this.pagination.dynamicBulletIndex),
                  (_ =
                    ((c = s + (Math.min(u.length, t.dynamicMainBullets) - 1)) +
                      s) /
                    2)),
                u.removeClass(
                  t.bulletActiveClass +
                    " " +
                    t.bulletActiveClass +
                    "-next " +
                    t.bulletActiveClass +
                    "-next-next " +
                    t.bulletActiveClass +
                    "-prev " +
                    t.bulletActiveClass +
                    "-prev-prev " +
                    t.bulletActiveClass +
                    "-main",
                ),
                i.length > 1)
              )
                u.each(function (e) {
                  var a = Object(o.a)(e),
                    r = a.index();
                  r === n && a.addClass(t.bulletActiveClass),
                    t.dynamicBullets &&
                      (r >= s &&
                        r <= c &&
                        a.addClass(t.bulletActiveClass + "-main"),
                      r === s &&
                        a
                          .prev()
                          .addClass(t.bulletActiveClass + "-prev")
                          .prev()
                          .addClass(t.bulletActiveClass + "-prev-prev"),
                      r === c &&
                        a
                          .next()
                          .addClass(t.bulletActiveClass + "-next")
                          .next()
                          .addClass(t.bulletActiveClass + "-next-next"));
                });
              else {
                var d = u.eq(n),
                  p = d.index();
                if ((d.addClass(t.bulletActiveClass), t.dynamicBullets)) {
                  for (var f = u.eq(s), h = u.eq(c), m = s; m <= c; m += 1)
                    u.eq(m).addClass(t.bulletActiveClass + "-main");
                  if (this.params.loop)
                    if (p >= u.length - t.dynamicMainBullets) {
                      for (var y = t.dynamicMainBullets; y >= 0; y -= 1)
                        u.eq(u.length - y).addClass(
                          t.bulletActiveClass + "-main",
                        );
                      u.eq(u.length - t.dynamicMainBullets - 1).addClass(
                        t.bulletActiveClass + "-prev",
                      );
                    } else
                      f
                        .prev()
                        .addClass(t.bulletActiveClass + "-prev")
                        .prev()
                        .addClass(t.bulletActiveClass + "-prev-prev"),
                        h
                          .next()
                          .addClass(t.bulletActiveClass + "-next")
                          .next()
                          .addClass(t.bulletActiveClass + "-next-next");
                  else
                    f
                      .prev()
                      .addClass(t.bulletActiveClass + "-prev")
                      .prev()
                      .addClass(t.bulletActiveClass + "-prev-prev"),
                      h
                        .next()
                        .addClass(t.bulletActiveClass + "-next")
                        .next()
                        .addClass(t.bulletActiveClass + "-next-next");
                }
              }
              if (t.dynamicBullets) {
                var b = Math.min(u.length, t.dynamicMainBullets + 4),
                  v =
                    (this.pagination.bulletSize * b -
                      this.pagination.bulletSize) /
                      2 -
                    _ * this.pagination.bulletSize,
                  g = e ? "right" : "left";
                u.css(this.isHorizontal() ? g : "top", v + "px");
              }
            }
            if (
              ("fraction" === t.type &&
                (i
                  .find(Object(a.b)(t.currentClass))
                  .text(t.formatFractionCurrent(n + 1)),
                i
                  .find(Object(a.b)(t.totalClass))
                  .text(t.formatFractionTotal(l))),
              "progressbar" === t.type)
            ) {
              var w;
              w = t.progressbarOpposite
                ? this.isHorizontal()
                  ? "vertical"
                  : "horizontal"
                : this.isHorizontal()
                  ? "horizontal"
                  : "vertical";
              var x = (n + 1) / l,
                k = 1,
                O = 1;
              "horizontal" === w ? (k = x) : (O = x),
                i
                  .find(Object(a.b)(t.progressbarFillClass))
                  .transform(
                    "translate3d(0,0,0) scaleX(" + k + ") scaleY(" + O + ")",
                  )
                  .transition(this.params.speed);
            }
            "custom" === t.type && t.renderCustom
              ? (i.html(t.renderCustom(this, n + 1, l)),
                this.emit("paginationRender", i[0]))
              : this.emit("paginationUpdate", i[0]),
              this.params.watchOverflow &&
                this.enabled &&
                i[this.isLocked ? "addClass" : "removeClass"](t.lockClass);
          }
        },
        render: function () {
          var e = this.params.pagination;
          if (
            e.el &&
            this.pagination.el &&
            this.pagination.$el &&
            0 !== this.pagination.$el.length
          ) {
            var t =
                this.virtual && this.params.virtual.enabled
                  ? this.virtual.slides.length
                  : this.slides.length,
              n = this.pagination.$el,
              o = "";
            if ("bullets" === e.type) {
              var r = this.params.loop
                ? Math.ceil(
                    (t - 2 * this.loopedSlides) / this.params.slidesPerGroup,
                  )
                : this.snapGrid.length;
              this.params.freeMode && !this.params.loop && r > t && (r = t);
              for (var i = 0; i < r; i += 1)
                e.renderBullet
                  ? (o += e.renderBullet.call(this, i, e.bulletClass))
                  : (o +=
                      "<" +
                      e.bulletElement +
                      ' class="' +
                      e.bulletClass +
                      '"></' +
                      e.bulletElement +
                      ">");
              n.html(o),
                (this.pagination.bullets = n.find(Object(a.b)(e.bulletClass)));
            }
            "fraction" === e.type &&
              ((o = e.renderFraction
                ? e.renderFraction.call(this, e.currentClass, e.totalClass)
                : '<span class="' +
                  e.currentClass +
                  '"></span> / <span class="' +
                  e.totalClass +
                  '"></span>'),
              n.html(o)),
              "progressbar" === e.type &&
                ((o = e.renderProgressbar
                  ? e.renderProgressbar.call(this, e.progressbarFillClass)
                  : '<span class="' + e.progressbarFillClass + '"></span>'),
                n.html(o)),
              "custom" !== e.type &&
                this.emit("paginationRender", this.pagination.$el[0]);
          }
        },
        init: function () {
          var e = this;
          e.params.pagination = Object(a.c)(
            e.$el,
            e.params.pagination,
            e.params.createElements,
            { el: "swiper-pagination" },
          );
          var t = e.params.pagination;
          if (t.el) {
            var n = Object(o.a)(t.el);
            0 !== n.length &&
              (e.params.uniqueNavElements &&
                "string" === typeof t.el &&
                n.length > 1 &&
                (n = e.$el.find(t.el)),
              "bullets" === t.type &&
                t.clickable &&
                n.addClass(t.clickableClass),
              n.addClass(t.modifierClass + t.type),
              "bullets" === t.type &&
                t.dynamicBullets &&
                (n.addClass("" + t.modifierClass + t.type + "-dynamic"),
                (e.pagination.dynamicBulletIndex = 0),
                t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
              "progressbar" === t.type &&
                t.progressbarOpposite &&
                n.addClass(t.progressbarOppositeClass),
              t.clickable &&
                n.on("click", Object(a.b)(t.bulletClass), function (t) {
                  t.preventDefault();
                  var n = Object(o.a)(this).index() * e.params.slidesPerGroup;
                  e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                }),
              Object(a.e)(e.pagination, { $el: n, el: n[0] }),
              e.enabled || n.addClass(t.lockClass));
          }
        },
        destroy: function () {
          var e = this.params.pagination;
          if (
            e.el &&
            this.pagination.el &&
            this.pagination.$el &&
            0 !== this.pagination.$el.length
          ) {
            var t = this.pagination.$el;
            t.removeClass(e.hiddenClass),
              t.removeClass(e.modifierClass + e.type),
              this.pagination.bullets &&
                this.pagination.bullets.removeClass(e.bulletActiveClass),
              e.clickable && t.off("click", Object(a.b)(e.bulletClass));
          }
        },
      };
      t.a = {
        name: "pagination",
        params: {
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: !1,
            hideOnClick: !1,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: !1,
            type: "bullets",
            dynamicBullets: !1,
            dynamicMainBullets: 1,
            formatFractionCurrent: function (e) {
              return e;
            },
            formatFractionTotal: function (e) {
              return e;
            },
            bulletClass: "swiper-pagination-bullet",
            bulletActiveClass: "swiper-pagination-bullet-active",
            modifierClass: "swiper-pagination-",
            currentClass: "swiper-pagination-current",
            totalClass: "swiper-pagination-total",
            hiddenClass: "swiper-pagination-hidden",
            progressbarFillClass: "swiper-pagination-progressbar-fill",
            progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
            clickableClass: "swiper-pagination-clickable",
            lockClass: "swiper-pagination-lock",
          },
        },
        create: function () {
          Object(a.a)(this, { pagination: r({ dynamicBulletIndex: 0 }, i) });
        },
        on: {
          init: function (e) {
            e.pagination.init(), e.pagination.render(), e.pagination.update();
          },
          activeIndexChange: function (e) {
            e.params.loop
              ? e.pagination.update()
              : "undefined" === typeof e.snapIndex && e.pagination.update();
          },
          snapIndexChange: function (e) {
            e.params.loop || e.pagination.update();
          },
          slidesLengthChange: function (e) {
            e.params.loop && (e.pagination.render(), e.pagination.update());
          },
          snapGridLengthChange: function (e) {
            e.params.loop || (e.pagination.render(), e.pagination.update());
          },
          destroy: function (e) {
            e.pagination.destroy();
          },
          "enable disable": function (e) {
            var t = e.pagination.$el;
            t &&
              t[e.enabled ? "removeClass" : "addClass"](
                e.params.pagination.lockClass,
              );
          },
          click: function (e, t) {
            var n = t.target;
            if (
              e.params.pagination.el &&
              e.params.pagination.hideOnClick &&
              e.pagination.$el.length > 0 &&
              !Object(o.a)(n).hasClass(e.params.pagination.bulletClass)
            ) {
              if (
                e.navigation &&
                ((e.navigation.nextEl && n === e.navigation.nextEl) ||
                  (e.navigation.prevEl && n === e.navigation.prevEl))
              )
                return;
              !0 === e.pagination.$el.hasClass(e.params.pagination.hiddenClass)
                ? e.emit("paginationShow")
                : e.emit("paginationHide"),
                e.pagination.$el.toggleClass(e.params.pagination.hiddenClass);
            }
          },
        },
      };
    },
    Xi7e: function (e, t, n) {
      var o = n("KMkd"),
        a = n("adU4"),
        r = n("tMB7"),
        i = n("+6XX"),
        l = n("Z8oC");
      function s(e) {
        var t = -1,
          n = null == e ? 0 : e.length;
        for (this.clear(); ++t < n; ) {
          var o = e[t];
          this.set(o[0], o[1]);
        }
      }
      (s.prototype.clear = o),
        (s.prototype.delete = a),
        (s.prototype.get = r),
        (s.prototype.has = i),
        (s.prototype.set = l),
        (e.exports = s);
    },
    XrJB: function (e, t, n) {
      var o, a, r;
      "undefined" != typeof self && self,
        (e.exports =
          ((o = n("q1tI")),
          (a = n("17x9")),
          (r = n("TSYQ")),
          (function (e) {
            function t(o) {
              if (n[o]) return n[o].exports;
              var a = (n[o] = { i: o, l: !1, exports: {} });
              return (
                e[o].call(a.exports, a, a.exports, t), (a.l = !0), a.exports
              );
            }
            var n = {};
            return (
              (t.m = e),
              (t.c = n),
              (t.d = function (e, n, o) {
                t.o(e, n) ||
                  Object.defineProperty(e, n, {
                    configurable: !1,
                    enumerable: !0,
                    get: o,
                  });
              }),
              (t.n = function (e) {
                var n =
                  e && e.__esModule
                    ? function () {
                        return e.default;
                      }
                    : function () {
                        return e;
                      };
                return t.d(n, "a", n), n;
              }),
              (t.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }),
              (t.p = ""),
              t((t.s = 65))
            );
          })([
            function (e, t) {
              var n = (e.exports =
                "undefined" != typeof window && window.Math == Math
                  ? window
                  : "undefined" != typeof self && self.Math == Math
                    ? self
                    : Function("return this")());
              "number" == typeof __g && (__g = n);
            },
            function (e, t) {
              var n = (e.exports = { version: "2.5.3" });
              "number" == typeof __e && (__e = n);
            },
            function (e, t, n) {
              e.exports = !n(8)(function () {
                return (
                  7 !=
                  Object.defineProperty({}, "a", {
                    get: function () {
                      return 7;
                    },
                  }).a
                );
              });
            },
            function (e, t) {
              e.exports = function (e) {
                return "object" == typeof e
                  ? null !== e
                  : "function" == typeof e;
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(32),
                r = n(21),
                i = Object.defineProperty;
              t.f = n(2)
                ? Object.defineProperty
                : function (e, t, n) {
                    if ((o(e), (t = r(t, !0)), o(n), a))
                      try {
                        return i(e, t, n);
                      } catch (e) {}
                    if ("get" in n || "set" in n)
                      throw TypeError("Accessors not supported!");
                    return "value" in n && (e[t] = n.value), e;
                  };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e) {
                if (!o(e)) throw TypeError(e + " is not an object!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(35),
                a = n(30);
              e.exports = function (e) {
                return o(a(e));
              };
            },
            function (e, t) {
              var n = {}.hasOwnProperty;
              e.exports = function (e, t) {
                return n.call(e, t);
              };
            },
            function (e, t) {
              e.exports = function (e) {
                try {
                  return !!e();
                } catch (e) {
                  return !0;
                }
              };
            },
            function (e, t) {
              e.exports = o;
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(27),
                i = n(18),
                l = "prototype",
                s = function (e, t, n) {
                  var c,
                    _,
                    u,
                    d = e & s.F,
                    p = e & s.G,
                    f = e & s.S,
                    h = e & s.P,
                    m = e & s.B,
                    y = e & s.W,
                    b = p ? a : a[t] || (a[t] = {}),
                    v = b[l],
                    g = p ? o : f ? o[t] : (o[t] || {})[l];
                  for (c in (p && (n = t), n))
                    ((_ = !d && g && void 0 !== g[c]) && c in b) ||
                      ((u = _ ? g[c] : n[c]),
                      (b[c] =
                        p && "function" != typeof g[c]
                          ? n[c]
                          : m && _
                            ? r(u, o)
                            : y && g[c] == u
                              ? (function (e) {
                                  var t = function (t, n, o) {
                                    if (this instanceof e) {
                                      switch (arguments.length) {
                                        case 0:
                                          return new e();
                                        case 1:
                                          return new e(t);
                                        case 2:
                                          return new e(t, n);
                                      }
                                      return new e(t, n, o);
                                    }
                                    return e.apply(this, arguments);
                                  };
                                  return (t[l] = e[l]), t;
                                })(u)
                              : h && "function" == typeof u
                                ? r(Function.call, u)
                                : u),
                      h &&
                        (((b.virtual || (b.virtual = {}))[c] = u),
                        e & s.R && v && !v[c] && i(v, c, u)));
                };
              (s.F = 1),
                (s.G = 2),
                (s.S = 4),
                (s.P = 8),
                (s.B = 16),
                (s.W = 32),
                (s.U = 64),
                (s.R = 128),
                (e.exports = s);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22);
              e.exports =
                Object.keys ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t) {
              e.exports = a;
            },
            function (e, t, n) {
              e.exports = { default: n(49), __esModule: !0 };
            },
            function (e, t, n) {
              e.exports = { default: n(51), __esModule: !0 };
            },
            function (e, t) {
              t.f = {}.propertyIsEnumerable;
            },
            function (e, t, n) {
              e.exports = { default: n(57), __esModule: !0 };
            },
            function (e, t) {
              var n = 0,
                o = Math.random();
              e.exports = function (e) {
                return "Symbol(".concat(
                  void 0 === e ? "" : e,
                  ")_",
                  (++n + o).toString(36),
                );
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(20);
              e.exports = n(2)
                ? function (e, t, n) {
                    return o.f(e, t, a(1, n));
                  }
                : function (e, t, n) {
                    return (e[t] = n), e;
                  };
            },
            function (e, t, n) {
              var o = n(25)("wks"),
                a = n(17),
                r = n(0).Symbol,
                i = "function" == typeof r;
              (e.exports = function (e) {
                return (
                  o[e] || (o[e] = (i && r[e]) || (i ? r : a)("Symbol." + e))
                );
              }).store = o;
            },
            function (e, t) {
              e.exports = function (e, t) {
                return {
                  enumerable: !(1 & e),
                  configurable: !(2 & e),
                  writable: !(4 & e),
                  value: t,
                };
              };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e, t) {
                if (!o(e)) return e;
                var n, a;
                if (
                  t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
                  return a;
                if (
                  !t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                throw TypeError("Can't convert object to primitive value");
              };
            },
            function (e, t) {
              e.exports =
                "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                  ",",
                );
            },
            function (e, t) {
              e.exports = r;
            },
            function (e, t, n) {
              e.exports = { default: n(60), __esModule: !0 };
            },
            function (e, t, n) {
              var o = n(0),
                a = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
              e.exports = function (e) {
                return a[e] || (a[e] = {});
              };
            },
            function (e, t) {
              t.f = Object.getOwnPropertySymbols;
            },
            function (e, t, n) {
              var o = n(42);
              e.exports = function (e, t, n) {
                if ((o(e), void 0 === t)) return e;
                switch (n) {
                  case 1:
                    return function (n) {
                      return e.call(t, n);
                    };
                  case 2:
                    return function (n, o) {
                      return e.call(t, n, o);
                    };
                  case 3:
                    return function (n, o, a) {
                      return e.call(t, n, o, a);
                    };
                }
                return function () {
                  return e.apply(t, arguments);
                };
              };
            },
            function (e, t) {
              var n = Math.ceil,
                o = Math.floor;
              e.exports = function (e) {
                return isNaN((e = +e)) ? 0 : (e > 0 ? o : n)(e);
              };
            },
            function (e, t, n) {
              var o = n(25)("keys"),
                a = n(17);
              e.exports = function (e) {
                return o[e] || (o[e] = a(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if (void 0 == e) throw TypeError("Can't call method on  " + e);
                return e;
              };
            },
            function (e, t, n) {
              var o = n(3),
                a = n(0).document,
                r = o(a) && o(a.createElement);
              e.exports = function (e) {
                return r ? a.createElement(e) : {};
              };
            },
            function (e, t, n) {
              e.exports =
                !n(2) &&
                !n(8)(function () {
                  return (
                    7 !=
                    Object.defineProperty(n(31)("div"), "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
            },
            function (e, t) {
              var n = {}.toString;
              e.exports = function (e) {
                return n.call(e).slice(8, -1);
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(48),
                r = n(22),
                i = n(29)("IE_PROTO"),
                l = function () {},
                s = function () {
                  var e,
                    t = n(31)("iframe"),
                    o = r.length;
                  for (
                    t.style.display = "none",
                      n(44).appendChild(t),
                      t.src = "javascript:",
                      (e = t.contentWindow.document).open(),
                      e.write("<script>document.F=Object</script>"),
                      e.close(),
                      s = e.F;
                    o--;

                  )
                    delete s.prototype[r[o]];
                  return s();
                };
              e.exports =
                Object.create ||
                function (e, t) {
                  var n;
                  return (
                    null !== e
                      ? ((l.prototype = o(e)),
                        (n = new l()),
                        (l.prototype = null),
                        (n[i] = e))
                      : (n = s()),
                    void 0 === t ? n : a(n, t)
                  );
                };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports = Object("z").propertyIsEnumerable(0)
                ? Object
                : function (e) {
                    return "String" == o(e) ? e.split("") : Object(e);
                  };
            },
            function (e, t, n) {
              var o = n(7),
                a = n(6),
                r = n(46)(!1),
                i = n(29)("IE_PROTO");
              e.exports = function (e, t) {
                var n,
                  l = a(e),
                  s = 0,
                  c = [];
                for (n in l) n != i && o(l, n) && c.push(n);
                for (; t.length > s; )
                  o(l, (n = t[s++])) && (~r(c, n) || c.push(n));
                return c;
              };
            },
            function (e, t, n) {
              var o = n(15),
                a = n(20),
                r = n(6),
                i = n(21),
                l = n(7),
                s = n(32),
                c = Object.getOwnPropertyDescriptor;
              t.f = n(2)
                ? c
                : function (e, t) {
                    if (((e = r(e)), (t = i(t, !0)), s))
                      try {
                        return c(e, t);
                      } catch (e) {}
                    if (l(e, t)) return a(!o.f.call(e, t), e[t]);
                  };
            },
            function (e, t) {
              e.exports = !0;
            },
            function (e, t, n) {
              t.f = n(19);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22).concat("length", "prototype");
              t.f =
                Object.getOwnPropertyNames ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t, n) {
              var o = n(30);
              e.exports = function (e) {
                return Object(o(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if ("function" != typeof e)
                  throw TypeError(e + " is not a function!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.min;
              e.exports = function (e) {
                return e > 0 ? a(o(e), 9007199254740991) : 0;
              };
            },
            function (e, t, n) {
              var o = n(0).document;
              e.exports = o && o.documentElement;
            },
            function (e, t, n) {
              var o = n(4).f,
                a = n(7),
                r = n(19)("toStringTag");
              e.exports = function (e, t, n) {
                e &&
                  !a((e = n ? e : e.prototype), r) &&
                  o(e, r, { configurable: !0, value: t });
              };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(43),
                r = n(47);
              e.exports = function (e) {
                return function (t, n, i) {
                  var l,
                    s = o(t),
                    c = a(s.length),
                    _ = r(i, c);
                  if (e && n != n) {
                    for (; c > _; ) if ((l = s[_++]) != l) return !0;
                  } else
                    for (; c > _; _++)
                      if ((e || _ in s) && s[_] === n) return e || _ || 0;
                  return !e && -1;
                };
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.max,
                r = Math.min;
              e.exports = function (e, t) {
                return (e = o(e)) < 0 ? a(e + t, 0) : r(e, t);
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(5),
                r = n(11);
              e.exports = n(2)
                ? Object.defineProperties
                : function (e, t) {
                    a(e);
                    for (var n, i = r(t), l = i.length, s = 0; l > s; )
                      o.f(e, (n = i[s++]), t[n]);
                    return e;
                  };
            },
            function (e, t, n) {
              n(50);
              var o = n(1).Object;
              e.exports = function (e, t) {
                return o.create(e, t);
              };
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { create: n(34) });
            },
            function (e, t, n) {
              n(52), (e.exports = n(1).Object.setPrototypeOf);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { setPrototypeOf: n(53).set });
            },
            function (e, t, n) {
              var o = n(3),
                a = n(5),
                r = function (e, t) {
                  if ((a(e), !o(t) && null !== t))
                    throw TypeError(t + ": can't set as prototype!");
                };
              e.exports = {
                set:
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function (e, t, o) {
                        try {
                          (o = n(27)(
                            Function.call,
                            n(37).f(Object.prototype, "__proto__").set,
                            2,
                          ))(e, []),
                            (t = !(e instanceof Array));
                        } catch (e) {
                          t = !0;
                        }
                        return function (e, n) {
                          return r(e, n), t ? (e.__proto__ = n) : o(e, n), e;
                        };
                      })({}, !1)
                    : void 0),
                check: r,
              };
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(38),
                i = n(39),
                l = n(4).f;
              e.exports = function (e) {
                var t = a.Symbol || (a.Symbol = r ? {} : o.Symbol || {});
                "_" == e.charAt(0) || e in t || l(t, e, { value: i.f(e) });
              };
            },
            function (e, t, n) {
              e.exports = n(18);
            },
            function (e, t, n) {
              "use strict";
              var o = n(0),
                a = n(7),
                r = n(2),
                i = n(10),
                l = n(55),
                s = n(61).KEY,
                c = n(8),
                _ = n(25),
                u = n(45),
                d = n(17),
                p = n(19),
                f = n(39),
                h = n(54),
                m = n(62),
                y = n(63),
                b = n(5),
                v = n(3),
                g = n(6),
                w = n(21),
                x = n(20),
                k = n(34),
                O = n(64),
                I = n(37),
                S = n(4),
                j = n(11),
                T = I.f,
                C = S.f,
                M = O.f,
                P = o.Symbol,
                E = o.JSON,
                L = E && E.stringify,
                B = "prototype",
                N = p("_hidden"),
                D = p("toPrimitive"),
                z = {}.propertyIsEnumerable,
                A = _("symbol-registry"),
                R = _("symbols"),
                F = _("op-symbols"),
                V = Object[B],
                H = "function" == typeof P,
                W = o.QObject,
                U = !W || !W[B] || !W[B].findChild,
                G =
                  r &&
                  c(function () {
                    return (
                      7 !=
                      k(
                        C({}, "a", {
                          get: function () {
                            return C(this, "a", { value: 7 }).a;
                          },
                        }),
                      ).a
                    );
                  })
                    ? function (e, t, n) {
                        var o = T(V, t);
                        o && delete V[t],
                          C(e, t, n),
                          o && e !== V && C(V, t, o);
                      }
                    : C,
                Y = function (e) {
                  var t = (R[e] = k(P[B]));
                  return (t._k = e), t;
                },
                q =
                  H && "symbol" == typeof P.iterator
                    ? function (e) {
                        return "symbol" == typeof e;
                      }
                    : function (e) {
                        return e instanceof P;
                      },
                X = function (e, t, n) {
                  return (
                    e === V && X(F, t, n),
                    b(e),
                    (t = w(t, !0)),
                    b(n),
                    a(R, t)
                      ? (n.enumerable
                          ? (a(e, N) && e[N][t] && (e[N][t] = !1),
                            (n = k(n, { enumerable: x(0, !1) })))
                          : (a(e, N) || C(e, N, x(1, {})), (e[N][t] = !0)),
                        G(e, t, n))
                      : C(e, t, n)
                  );
                },
                Z = function (e, t) {
                  b(e);
                  for (var n, o = m((t = g(t))), a = 0, r = o.length; r > a; )
                    X(e, (n = o[a++]), t[n]);
                  return e;
                },
                K = function (e) {
                  var t = z.call(this, (e = w(e, !0)));
                  return (
                    !(this === V && a(R, e) && !a(F, e)) &&
                    (!(
                      t ||
                      !a(this, e) ||
                      !a(R, e) ||
                      (a(this, N) && this[N][e])
                    ) ||
                      t)
                  );
                },
                Q = function (e, t) {
                  if (
                    ((e = g(e)), (t = w(t, !0)), e !== V || !a(R, t) || a(F, t))
                  ) {
                    var n = T(e, t);
                    return (
                      !n ||
                        !a(R, t) ||
                        (a(e, N) && e[N][t]) ||
                        (n.enumerable = !0),
                      n
                    );
                  }
                },
                J = function (e) {
                  for (var t, n = M(g(e)), o = [], r = 0; n.length > r; )
                    a(R, (t = n[r++])) || t == N || t == s || o.push(t);
                  return o;
                },
                $ = function (e) {
                  for (
                    var t, n = e === V, o = M(n ? F : g(e)), r = [], i = 0;
                    o.length > i;

                  )
                    !a(R, (t = o[i++])) || (n && !a(V, t)) || r.push(R[t]);
                  return r;
                };
              H ||
                (l(
                  (P = function () {
                    if (this instanceof P)
                      throw TypeError("Symbol is not a constructor!");
                    var e = d(arguments.length > 0 ? arguments[0] : void 0),
                      t = function (n) {
                        this === V && t.call(F, n),
                          a(this, N) && a(this[N], e) && (this[N][e] = !1),
                          G(this, e, x(1, n));
                      };
                    return (
                      r && U && G(V, e, { configurable: !0, set: t }), Y(e)
                    );
                  })[B],
                  "toString",
                  function () {
                    return this._k;
                  },
                ),
                (I.f = Q),
                (S.f = X),
                (n(40).f = O.f = J),
                (n(15).f = K),
                (n(26).f = $),
                r && !n(38) && l(V, "propertyIsEnumerable", K, !0),
                (f.f = function (e) {
                  return Y(p(e));
                })),
                i(i.G + i.W + i.F * !H, { Symbol: P });
              for (
                var ee =
                    "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
                      ",",
                    ),
                  te = 0;
                ee.length > te;

              )
                p(ee[te++]);
              for (var ne = j(p.store), oe = 0; ne.length > oe; ) h(ne[oe++]);
              i(i.S + i.F * !H, "Symbol", {
                for: function (e) {
                  return a(A, (e += "")) ? A[e] : (A[e] = P(e));
                },
                keyFor: function (e) {
                  if (!q(e)) throw TypeError(e + " is not a symbol!");
                  for (var t in A) if (A[t] === e) return t;
                },
                useSetter: function () {
                  U = !0;
                },
                useSimple: function () {
                  U = !1;
                },
              }),
                i(i.S + i.F * !H, "Object", {
                  create: function (e, t) {
                    return void 0 === t ? k(e) : Z(k(e), t);
                  },
                  defineProperty: X,
                  defineProperties: Z,
                  getOwnPropertyDescriptor: Q,
                  getOwnPropertyNames: J,
                  getOwnPropertySymbols: $,
                }),
                E &&
                  i(
                    i.S +
                      i.F *
                        (!H ||
                          c(function () {
                            var e = P();
                            return (
                              "[null]" != L([e]) ||
                              "{}" != L({ a: e }) ||
                              "{}" != L(Object(e))
                            );
                          })),
                    "JSON",
                    {
                      stringify: function (e) {
                        for (var t, n, o = [e], a = 1; arguments.length > a; )
                          o.push(arguments[a++]);
                        if (((n = t = o[1]), (v(t) || void 0 !== e) && !q(e)))
                          return (
                            y(t) ||
                              (t = function (e, t) {
                                if (
                                  ("function" == typeof n &&
                                    (t = n.call(this, e, t)),
                                  !q(t))
                                )
                                  return t;
                              }),
                            (o[1] = t),
                            L.apply(E, o)
                          );
                      },
                    },
                  ),
                P[B][D] || n(18)(P[B], D, P[B].valueOf),
                u(P, "Symbol"),
                u(Math, "Math", !0),
                u(o.JSON, "JSON", !0);
            },
            function (e, t, n) {
              n(58), (e.exports = n(1).Object.assign);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S + o.F, "Object", { assign: n(59) });
            },
            function (e, t, n) {
              "use strict";
              var o = n(11),
                a = n(26),
                r = n(15),
                i = n(41),
                l = n(35),
                s = Object.assign;
              e.exports =
                !s ||
                n(8)(function () {
                  var e = {},
                    t = {},
                    n = Symbol(),
                    o = "abcdefghijklmnopqrst";
                  return (
                    (e[n] = 7),
                    o.split("").forEach(function (e) {
                      t[e] = e;
                    }),
                    7 != s({}, e)[n] || Object.keys(s({}, t)).join("") != o
                  );
                })
                  ? function (e, t) {
                      for (
                        var n = i(e),
                          s = arguments.length,
                          c = 1,
                          _ = a.f,
                          u = r.f;
                        s > c;

                      )
                        for (
                          var d,
                            p = l(arguments[c++]),
                            f = _ ? o(p).concat(_(p)) : o(p),
                            h = f.length,
                            m = 0;
                          h > m;

                        )
                          u.call(p, (d = f[m++])) && (n[d] = p[d]);
                      return n;
                    }
                  : s;
            },
            function (e, t, n) {
              n(56), (e.exports = n(1).Object.getOwnPropertySymbols);
            },
            function (e, t, n) {
              var o = n(17)("meta"),
                a = n(3),
                r = n(7),
                i = n(4).f,
                l = 0,
                s =
                  Object.isExtensible ||
                  function () {
                    return !0;
                  },
                c = !n(8)(function () {
                  return s(Object.preventExtensions({}));
                }),
                _ = function (e) {
                  i(e, o, { value: { i: "O" + ++l, w: {} } });
                },
                u = (e.exports = {
                  KEY: o,
                  NEED: !1,
                  fastKey: function (e, t) {
                    if (!a(e))
                      return "symbol" == typeof e
                        ? e
                        : ("string" == typeof e ? "S" : "P") + e;
                    if (!r(e, o)) {
                      if (!s(e)) return "F";
                      if (!t) return "E";
                      _(e);
                    }
                    return e[o].i;
                  },
                  getWeak: function (e, t) {
                    if (!r(e, o)) {
                      if (!s(e)) return !0;
                      if (!t) return !1;
                      _(e);
                    }
                    return e[o].w;
                  },
                  onFreeze: function (e) {
                    return c && u.NEED && s(e) && !r(e, o) && _(e), e;
                  },
                });
            },
            function (e, t, n) {
              var o = n(11),
                a = n(26),
                r = n(15);
              e.exports = function (e) {
                var t = o(e),
                  n = a.f;
                if (n)
                  for (var i, l = n(e), s = r.f, c = 0; l.length > c; )
                    s.call(e, (i = l[c++])) && t.push(i);
                return t;
              };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports =
                Array.isArray ||
                function (e) {
                  return "Array" == o(e);
                };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(40).f,
                r = {}.toString,
                i =
                  "object" == typeof window &&
                  window &&
                  Object.getOwnPropertyNames
                    ? Object.getOwnPropertyNames(window)
                    : [];
              e.exports.f = function (e) {
                return i && "[object Window]" == r.call(e)
                  ? (function (e) {
                      try {
                        return a(e);
                      } catch (e) {
                        return i.slice();
                      }
                    })(e)
                  : a(o(e));
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = a(n(71)),
                p = o(n(73)),
                f = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                h =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                m = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                y = n(74),
                b = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    f(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        n = e.name,
                        o = e.className,
                        a = m(e, ["name", "className"]),
                        r = (0, u.default)(
                          (p || {})["" + t.classNamePrefix + n],
                          o,
                        );
                      return c.createElement(
                        d.default,
                        h({ className: r, fontFamily: y.fontFamily }, a),
                      );
                    }),
                    (t.classNamePrefix = "icon-"),
                    (t.propTypes = {
                      name: _.default.string.isRequired,
                      spin: _.default.bool,
                      className: _.default.string,
                    }),
                    t
                  );
                })(c.PureComponent);
              t.default = b;
            },
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = o(n(72)),
                p = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                m = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    p(t, e),
                    (t.prototype.render = function () {
                      var e,
                        t = this.props,
                        n = t.className,
                        o = t.fontFamily,
                        a = t.style,
                        r = t.spin,
                        l = h(t, ["className", "fontFamily", "style", "spin"]),
                        s = (0, u.default)(
                          n,
                          d.icon,
                          (((e = {})[d.spin] = !!r), e),
                        ),
                        _ = (0, i.default)({}, a, { fontFamily: o });
                      return c.createElement(
                        "i",
                        f({ className: s, style: _ }, l),
                      );
                    }),
                    (t.propTypes = {
                      classNames: _.default.object,
                      fontFamily: _.default.string,
                      spin: _.default.bool,
                    }),
                    (t.defaultProps = { fontFamily: "iconfont" }),
                    t
                  );
                })(c.PureComponent);
              t.default = m;
            },
            function (e, t) {
              e.exports = {
                icon: "_3c0Qz",
                spin: "_1j2v0",
                "icon-spin": "-lu88",
                iconSpin: "-lu88",
              };
            },
            function (e, t) {
              e.exports = {
                "icon-address-book": "_35bgc",
                iconAddressBook: "_35bgc",
                "icon-address-card": "byXrR",
                iconAddressCard: "byXrR",
                "icon-adjust": "_128ri",
                iconAdjust: "_128ri",
                "icon-check-alt-light": "_1KHsi",
                iconCheckAltLight: "_1KHsi",
                "icon-coins-light": "_2bT-Y",
                iconCoinsLight: "_2bT-Y",
                "icon-exclamation-circle-light": "_3UEZX",
                iconExclamationCircleLight: "_3UEZX",
                "icon-loading-alt-light": "_1fXKU",
                iconLoadingAltLight: "_1fXKU",
                "icon-instagram": "_2OZ_n",
                iconInstagram: "_2OZ_n",
                "icon-minus-light": "_6cr8a",
                iconMinusLight: "_6cr8a",
                "icon-ticket-alt": "ZAGKa",
                iconTicketAlt: "ZAGKa",
                "icon-ticket-alt-light": "_1lH5w",
                iconTicketAltLight: "_1lH5w",
                "icon-plus-light": "_3BSr4",
                iconPlusLight: "_3BSr4",
                "icon-truck": "_4wlbR",
                iconTruck: "_4wlbR",
                "icon-trash-alt-light": "_26SUY",
                iconTrashAltLight: "_26SUY",
                "icon-times-circle": "_30-mD",
                iconTimesCircle: "_30-mD",
                "icon-vimeo-v": "_1_xvC",
                iconVimeoV: "_1_xvC",
                "icon-twitter": "_17P2f",
                iconTwitter: "_17P2f",
                "icon-youtube": "_2I_EY",
                iconYoutube: "_2I_EY",
                "icon-caret-down": "_3qb3s",
                iconCaretDown: "_3qb3s",
                "icon-caret-up": "_2jwD5",
                iconCaretUp: "_2jwD5",
                "icon-comments-o": "_19X43",
                iconCommentsO: "_19X43",
                "icon-download-o": "_2WwM4",
                iconDownloadO: "_2WwM4",
                "icon-info-circle-o": "_1shcg",
                iconInfoCircleO: "_1shcg",
                "icon-external-link-o": "_1qLWd",
                iconExternalLinkO: "_1qLWd",
                "icon-globe-o": "Z8Prc",
                iconGlobeO: "Z8Prc",
                "icon-question-o": "_3MItB",
                iconQuestionO: "_3MItB",
                "icon-play-circle-o": "_2Bvn6",
                iconPlayCircleO: "_2Bvn6",
                "icon-angle-double-left": "_3IVo_",
                iconAngleDoubleLeft: "_3IVo_",
                "icon-angle-down": "_34FGS",
                iconAngleDown: "_34FGS",
                "icon-angle-double-right": "_3e62_",
                iconAngleDoubleRight: "_3e62_",
                "icon-angle-left": "_1zbhS",
                iconAngleLeft: "_1zbhS",
                "icon-angle-right": "_27RtX",
                iconAngleRight: "_27RtX",
                "icon-angle-up": "jhfcy",
                iconAngleUp: "jhfcy",
                "icon-arrival-reminder": "Q82xM",
                iconArrivalReminder: "Q82xM",
                "icon-ban": "_1vyf0",
                iconBan: "_1vyf0",
                "icon-bullhorn": "B0IHZ",
                iconBullhorn: "B0IHZ",
                "icon-bars": "_2cpQ_",
                iconBars: "_2cpQ_",
                "icon-caret-left-o": "_2FImd",
                iconCaretLeftO: "_2FImd",
                "icon-caret-down-o": "_3wXJB",
                iconCaretDownO: "_3wXJB",
                "icon-caret-right-o": "_2fXyR",
                iconCaretRightO: "_2fXyR",
                "icon-caret-up-o": "_2KLCQ",
                iconCaretUpO: "_2KLCQ",
                "icon-cart": "_-4DAY",
                iconCart: "_-4DAY",
                "icon-certificate": "_2I4g3",
                iconCertificate: "_2I4g3",
                "icon-check-circle-o": "_1m5z7",
                iconCheckCircleO: "_1m5z7",
                "icon-check-square-o": "_1vR3p",
                iconCheckSquareO: "_1vR3p",
                "icon-check": "_2LJ7o",
                iconCheck: "_2LJ7o",
                "icon-circle-notch": "_3AQSX",
                iconCircleNotch: "_3AQSX",
                "icon-clock": "_3ASBw",
                iconClock: "_3ASBw",
                "icon-cog": "_6eszT",
                iconCog: "_6eszT",
                "icon-cloud-upload": "_1WxHW",
                iconCloudUpload: "_1WxHW",
                "icon-coins": "_2uv1U",
                iconCoins: "_2uv1U",
                "icon-compare": "_3s-NW",
                iconCompare: "_3s-NW",
                "icon-comment-alt-smile": "_1ZzVY",
                iconCommentAltSmile: "_1ZzVY",
                "icon-copy": "OBwuW",
                iconCopy: "OBwuW",
                "icon-compress": "_2Ri-k",
                iconCompress: "_2Ri-k",
                "icon-coupon": "_1588m",
                iconCoupon: "_1588m",
                "icon-credit-card": "_2uIqb",
                iconCreditCard: "_2uIqb",
                "icon-download": "_1P5xZ",
                iconDownload: "_1P5xZ",
                "icon-edit": "_2iuBX",
                iconEdit: "_2iuBX",
                "icon-ellipsis-h": "_1exha",
                iconEllipsisH: "_1exha",
                "icon-education": "_3bokS",
                iconEducation: "_3bokS",
                "icon-envelope": "vMM-Y",
                iconEnvelope: "vMM-Y",
                "icon-ellipsis-v": "_3jZwp",
                iconEllipsisV: "_3jZwp",
                "icon-exclamation-circle": "_2SUQ-",
                iconExclamationCircle: "_2SUQ-",
                "icon-exclamation": "_1Piil",
                iconExclamation: "_1Piil",
                "icon-exclamation-square": "_20oXE",
                iconExclamationSquare: "_20oXE",
                "icon-external-link": "_2gTe8",
                iconExternalLink: "_2gTe8",
                "icon-expand": "okv_Y",
                iconExpand: "okv_Y",
                "icon-eye": "_3l-6g",
                iconEye: "_3l-6g",
                "icon-file-alt": "OhY9C",
                iconFileAlt: "OhY9C",
                "icon-facebook": "Cb5jY",
                iconFacebook: "Cb5jY",
                "icon-file": "_1ajFe",
                iconFile: "_1ajFe",
                "icon-file-pdf": "ve2KQ",
                iconFilePdf: "ve2KQ",
                "icon-frame": "_3OU3j",
                iconFrame: "_3OU3j",
                "icon-globe": "lgV2x",
                iconGlobe: "lgV2x",
                "icon-headset": "_1gQtG",
                iconHeadset: "_1gQtG",
                "icon-heart-o": "_3Zaag",
                iconHeartO: "_3Zaag",
                "icon-home": "_33jTA",
                iconHome: "_33jTA",
                "icon-image-view": "_1jJbn",
                iconImageView: "_1jJbn",
                "icon-info-square": "UuxAk",
                iconInfoSquare: "UuxAk",
                "icon-info-circle": "_1OEuY",
                iconInfoCircle: "_1OEuY",
                "icon-info": "Lm_MF",
                iconInfo: "Lm_MF",
                "icon-language": "_3LwbN",
                iconLanguage: "_3LwbN",
                "icon-link": "_2XN05",
                iconLink: "_2XN05",
                "icon-list-view": "_33OcX",
                iconListView: "_33OcX",
                "icon-location-arrow": "bMc_E",
                iconLocationArrow: "bMc_E",
                "icon-list": "IAlEP",
                iconList: "IAlEP",
                "icon-location": "_25GQ2",
                iconLocation: "_25GQ2",
                "icon-lock-alt": "_3t3HT",
                iconLockAlt: "_3t3HT",
                "icon-map-marked-alt": "_2W_XA",
                iconMapMarkedAlt: "_2W_XA",
                "icon-map-marker-alt": "_3NPLS",
                iconMapMarkerAlt: "_3NPLS",
                "icon-minus": "UhwjW",
                iconMinus: "UhwjW",
                "icon-paperclip": "_2hDpl",
                iconPaperclip: "_2hDpl",
                "icon-order": "dCZz2",
                iconOrder: "dCZz2",
                "icon-play-circle": "_1FMUV",
                iconPlayCircle: "_1FMUV",
                "icon-phone": "_2H8bj",
                iconPhone: "_2H8bj",
                "icon-plus": "_3KkpT",
                iconPlus: "_3KkpT",
                "icon-purchase": "_23p5a",
                iconPurchase: "_23p5a",
                "icon-question-circle": "_18A_e",
                iconQuestionCircle: "_18A_e",
                "icon-qrcode": "gf_rb",
                iconQrcode: "gf_rb",
                "icon-search-minus": "_1Djb6",
                iconSearchMinus: "_1Djb6",
                "icon-search": "_3d-6G",
                iconSearch: "_3d-6G",
                "icon-setup": "_1fawl",
                iconSetup: "_1fawl",
                "icon-search-plus": "_20uY7",
                iconSearchPlus: "_20uY7",
                "icon-tag": "_2Z6dE",
                iconTag: "_2Z6dE",
                "icon-share": "_1c3Qh",
                iconShare: "_1c3Qh",
                "icon-times-circle-o": "_1GlZx",
                iconTimesCircleO: "_1GlZx",
                "icon-times": "_3hG3b",
                iconTimes: "_3hG3b",
                "icon-times-square-o": "_15wCJ",
                iconTimesSquareO: "_15wCJ",
                "icon-trash-alt": "_1Rw_U",
                iconTrashAlt: "_1Rw_U",
                "icon-truck-moving": "_2Jlwc",
                iconTruckMoving: "_2Jlwc",
                "icon-unfold": "_1bahP",
                iconUnfold: "_1bahP",
                "icon-unlock-alt": "_27Nd-",
                iconUnlockAlt: "_27Nd-",
                "icon-user": "_3To44",
                iconUser: "_3To44",
                "icon-users": "_1O_Hy",
                iconUsers: "_1O_Hy",
                "icon-video": "W6H_f",
                iconVideo: "W6H_f",
                "icon-fa-light-redo": "_2_sls",
                iconFaLightRedo: "_2_sls",
                "icon-fa-solid-play": "_35BGQ",
                iconFaSolidPlay: "_35BGQ",
                "icon-download-black-main": "_3xfLM",
                iconDownloadBlackMain: "_3xfLM",
                "icon-plus-circle": "_1pvYF",
                iconPlusCircle: "_1pvYF",
              };
            },
            function (e, t) {
              e.exports = {
                icons: [
                  { name: "address-book", unicode: "f2b9" },
                  { name: "address-card", unicode: "f2bb" },
                  { name: "adjust", unicode: "f042" },
                  { name: "check-alt-light", unicode: "e917" },
                  { name: "coins-light", unicode: "e348" },
                  { name: "exclamation-circle-light", unicode: "eca2" },
                  { name: "loading-alt-light", unicode: "ee57" },
                  { name: "instagram", unicode: "f16d" },
                  { name: "minus-light", unicode: "e719" },
                  { name: "ticket-alt", unicode: "f3ff" },
                  { name: "ticket-alt-light", unicode: "ebad" },
                  { name: "plus-light", unicode: "e8b5" },
                  { name: "truck", unicode: "f0d1" },
                  { name: "trash-alt-light", unicode: "e3a8" },
                  { name: "times-circle", unicode: "f057" },
                  { name: "vimeo-v", unicode: "f27d" },
                  { name: "twitter", unicode: "f099" },
                  { name: "youtube", unicode: "f167" },
                  { name: "caret-down", unicode: "f0d7" },
                  { name: "caret-up", unicode: "f0d8" },
                  { name: "comments-o", unicode: "ecde" },
                  { name: "download-o", unicode: "e6c0" },
                  { name: "info-circle-o", unicode: "ed3f" },
                  { name: "external-link-o", unicode: "ebd6" },
                  { name: "globe-o", unicode: "efe0" },
                  { name: "question-o", unicode: "e65f" },
                  { name: "play-circle-o", unicode: "e0ca" },
                  { name: "angle-double-left", unicode: "f100" },
                  { name: "angle-down", unicode: "f107" },
                  { name: "angle-double-right", unicode: "f101" },
                  { name: "angle-left", unicode: "f104" },
                  { name: "angle-right", unicode: "f105" },
                  { name: "angle-up", unicode: "f106" },
                  { name: "arrival-reminder", unicode: "e386" },
                  { name: "ban", unicode: "f05e" },
                  { name: "bullhorn", unicode: "f0a1" },
                  { name: "bars", unicode: "f0c9" },
                  { name: "caret-left-o", unicode: "eb68" },
                  { name: "caret-down-o", unicode: "ec02" },
                  { name: "caret-right-o", unicode: "ef8e" },
                  { name: "caret-up-o", unicode: "edd8" },
                  { name: "cart", unicode: "e540" },
                  { name: "certificate", unicode: "f0a3" },
                  { name: "check-circle-o", unicode: "e753" },
                  { name: "check-square-o", unicode: "ee6b" },
                  { name: "check", unicode: "f00c" },
                  { name: "circle-notch", unicode: "f1ce" },
                  { name: "clock", unicode: "f017" },
                  { name: "cog", unicode: "f013" },
                  { name: "cloud-upload", unicode: "f0ee" },
                  { name: "coins", unicode: "e688" },
                  { name: "compare", unicode: "e1f8" },
                  { name: "comment-alt-smile", unicode: "e7e4" },
                  { name: "copy", unicode: "f0c5" },
                  { name: "compress", unicode: "f066" },
                  { name: "coupon", unicode: "ed6e" },
                  { name: "credit-card", unicode: "f09d" },
                  { name: "download", unicode: "f019" },
                  { name: "edit", unicode: "f044" },
                  { name: "ellipsis-h", unicode: "f141" },
                  { name: "education", unicode: "ed0b" },
                  { name: "envelope", unicode: "f0e0" },
                  { name: "ellipsis-v", unicode: "f142" },
                  { name: "exclamation-circle", unicode: "f06a" },
                  { name: "exclamation", unicode: "f12a" },
                  { name: "exclamation-square", unicode: "f321" },
                  { name: "external-link", unicode: "f08e" },
                  { name: "expand", unicode: "f065" },
                  { name: "eye", unicode: "f06e" },
                  { name: "file-alt", unicode: "f15c" },
                  { name: "facebook", unicode: "f09a" },
                  { name: "file", unicode: "f15b" },
                  { name: "file-pdf", unicode: "f1c1" },
                  { name: "frame", unicode: "edcf" },
                  { name: "globe", unicode: "f0ac" },
                  { name: "headset", unicode: "e902" },
                  { name: "heart-o", unicode: "ee55" },
                  { name: "home", unicode: "f015" },
                  { name: "image-view", unicode: "e348" },
                  { name: "info-square", unicode: "f30f" },
                  { name: "info-circle", unicode: "f05a" },
                  { name: "info", unicode: "f129" },
                  { name: "language", unicode: "f1ab" },
                  { name: "link", unicode: "f0c1" },
                  { name: "list-view", unicode: "e8c1" },
                  { name: "location-arrow", unicode: "f124" },
                  { name: "list", unicode: "f03a" },
                  { name: "location", unicode: "ed51" },
                  { name: "lock-alt", unicode: "f30d" },
                  { name: "map-marked-alt", unicode: "ee36" },
                  { name: "map-marker-alt", unicode: "f3c5" },
                  { name: "minus", unicode: "f068" },
                  { name: "paperclip", unicode: "f0c6" },
                  { name: "order", unicode: "e70a" },
                  { name: "play-circle", unicode: "f144" },
                  { name: "phone", unicode: "f095" },
                  { name: "plus", unicode: "f067" },
                  { name: "purchase", unicode: "e85d" },
                  { name: "question-circle", unicode: "f059" },
                  { name: "qrcode", unicode: "f029" },
                  { name: "search-minus", unicode: "f010" },
                  { name: "search", unicode: "f002" },
                  { name: "setup", unicode: "ea0f" },
                  { name: "search-plus", unicode: "f00e" },
                  { name: "tag", unicode: "f02b" },
                  { name: "share", unicode: "f064" },
                  { name: "times-circle-o", unicode: "e200" },
                  { name: "times", unicode: "f00d" },
                  { name: "times-square-o", unicode: "eea2" },
                  { name: "trash-alt", unicode: "f2ed" },
                  { name: "truck-moving", unicode: "eaaa" },
                  { name: "unfold", unicode: "e872" },
                  { name: "unlock-alt", unicode: "f13e" },
                  { name: "user", unicode: "f007" },
                  { name: "users", unicode: "f0c0" },
                  { name: "video", unicode: "f03d" },
                  { name: "fa-light-redo", unicode: "e087" },
                  { name: "fa-solid-play", unicode: "e665" },
                  { name: "download-black-main", unicode: "e111" },
                  { name: "plus-circle", unicode: "f055" },
                ],
                total: 120,
                cssPrefix: "icon-",
                fontFamily: "quark",
              };
            },
          ])));
    },
    XwSB: function (e, t, n) {},
    Xwp0: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return i;
      }),
        n.d(t, "c", function () {
          return y;
        }),
        n.d(t, "d", function () {
          return b;
        }),
        n.d(t, "b", function () {
          return v;
        });
      var o = n("rePB");
      function a(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function r(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? a(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : a(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var i = (function (e) {
          return (
            (e.DEFAULT = ""),
            (e.PRUE = "PRUE"),
            (e.GRADATION = "GRADATION"),
            (e.IMAGE = "IMAGE"),
            (e.VIDEO = "VIDEO"),
            e
          );
        })({}),
        l = [
          { label: "\u9ed8\u8ba4", value: i.DEFAULT },
          { label: "\u7eaf\u8272", value: i.PRUE },
          { label: "\u6e10\u53d8\u8272", value: i.GRADATION },
          { label: "\u80cc\u666f\u56fe", value: i.IMAGE },
          { label: "\u80cc\u666f\u89c6\u9891", value: i.VIDEO },
        ],
        s = { label: "\u80cc\u666f\u56fe\u7247", type: "image" },
        c = { controlBy: "backgroundType", controlValue: i.IMAGE },
        _ = { backgroundImage: r(r({}, s), c) },
        u = { backgroundImage: r({}, s) },
        d = {
          backgroundPrue: {
            label: "\u80cc\u666f\u8272",
            type: "string",
            controlBy: "backgroundType",
            controlValue: i.PRUE,
          },
        },
        p = {
          backgroundGradient: {
            label: "\u80cc\u666f\u6e10\u53d8\u8272",
            type: "string",
            controlBy: "backgroundType",
            controlValue: i.GRADATION,
          },
        },
        f = {
          backgroundVideo: {
            type: "video",
            label: "\u80cc\u666f\u89c6\u9891\u914d\u7f6e",
            videoType: "background",
            controlBy: "backgroundType",
            controlValue: i.VIDEO,
          },
        },
        h = r(
          r(
            r(
              r(
                {
                  backgroundType: {
                    label: "\u80cc\u666f\u7c7b\u578b",
                    type: "select",
                    items: l,
                  },
                },
                d,
              ),
              p,
            ),
            _,
          ),
          f,
        ),
        m = r(
          r(
            r(
              {
                backgroundType: {
                  label: "\u80cc\u666f\u7c7b\u578b",
                  type: "select",
                  items: [].concat(l).splice(0, l.length - 1),
                },
              },
              d,
            ),
            p,
          ),
          _,
        ),
        y = { label: "\u80cc\u666f\u8bbe\u7f6e", props: r({}, h) },
        b = { label: "\u80cc\u666f\u8bbe\u7f6e", props: r({}, m) },
        v = { label: "\u80cc\u666f\u8bbe\u7f6e", props: r({}, u) };
    },
    XxN0: function (e, t, n) {
      "use strict";
      var o = n("KQm4"),
        a = n("rePB"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("a6RD"),
        m = n.n(h),
        y = n("FCep"),
        b = n("XnI8"),
        v = n("TSYQ"),
        g = n.n(v),
        w = n("u6T5"),
        x = n.n(w),
        k = n("XrJB"),
        O = n.n(k),
        I = n("yWgo"),
        S = n("r7AC"),
        j = n("gn4A"),
        T = n.n(j),
        C = (n("CDV2"), n("aiR1"), n("1Sjk"), f.a.createElement);
      function M(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function P(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var E = {
          "@dji/quark/dist/Tabs.css": {
            _3lMTV: "Tabs___3lMTV___2pQ-A",
            _2bOox: "Tabs___2bOox___2CQtU",
            _28KUW: "Tabs___28KUW___-Srg6",
            _1Ltud: "Tabs___1Ltud___n6KKI",
            _2LH7P: "Tabs___2LH7P___3Keah",
            _1ubfg: "Tabs___1ubfg___3dybl",
            zPFdO: "Tabs__zPFdO___3lvSR",
            "_3-a_h": "Tabs___3-a_h___5FW1k",
            _8wsGN: "Tabs___8wsGN___gL3-r",
            _1RPG6: "Tabs___1RPG6___3wbtN",
            _2RUui: "Tabs___2RUui___1-O61",
            pHyFu: "Tabs__pHyFu___3CP5v",
            _3yx3R: "Tabs___3yx3R___1zv_m",
            _1DkKo: "Tabs___1DkKo___du86p",
            _1G3aQ: "Tabs___1G3aQ___ZMYAi",
            _3Qm4W: "Tabs___3Qm4W___36FQs",
            _14aFm: "Tabs___14aFm___Jiw0n",
            _2d3yp: "Tabs___2d3yp___3n3ff",
            _1RhgG: "Tabs___1RhgG___1vwAY",
            "quark-tab-default-tab-bar-wrap":
              "Tabs__quark-tab-default-tab-bar-wrap___3Cd6d",
            "quark-tab-default-tab-bar":
              "Tabs__quark-tab-default-tab-bar___3mZvV",
            "quark-tab-default-tab-container":
              "Tabs__quark-tab-default-tab-container___3qQ8P",
          },
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "wm161-model-container": "style__wm161-model-container___30e7G",
            "quark-tab-default-tab-bar":
              "style__quark-tab-default-tab-bar___2kfuR",
            hidden: "style__hidden___zYnbk",
            "fade-up": "style__fade-up___2J9A4",
            "fade-up-reverse": "style__fade-up-reverse___2u1vV",
            reverse: "style__reverse___27m56",
            "model-switch": "style__model-switch___12ICk",
            rotate: "style__rotate___14J0k",
            "top-animation": "style__top-animation___2e3Rd",
            "bottom-animation": "style__bottom-animation___18LYJ",
            "front-animation": "style__front-animation___2446z",
            "back-animation": "style__back-animation___L5DSw",
            "left-animation": "style__left-animation___3R-c2",
            "right-animation": "style__right-animation___3-4Xm",
            "model-title": "style__model-title___1EHUJ",
            "model-tabs": "style__model-tabs___1WJZg",
            "model-tabs-back-mask": "style__model-tabs-back-mask___SDF0o",
            "model-tabs-panel": "style__model-tabs-panel___2GSAa",
            "model-ar-block": "style__model-ar-block___2vuJC",
            "model-block": "style__model-block___Gknf8",
            "model-desc": "style__model-desc___heClW",
            "model-ar-desc": "style__model-ar-desc___3oWGU",
            "not-support-ar": "style__not-support-ar___29TGI",
            "not-good-support-ar": "style__not-good-support-ar___3MeFG",
            "normal-ar-entry": "style__normal-ar-entry___13sZa",
            "angle-right-icon": "style__angle-right-icon___2_0ZE",
            "model-ar-img": "style__model-ar-img___2Qxvz",
            "unfold-model-viewer": "style__unfold-model-viewer___2RNj3",
            "fold-model-viewer": "style__fold-model-viewer___10qQa",
            "model-content": "style__model-content___1gy78",
            "model-progress": "style__model-progress___2B0L7",
            "cube-box": "style__cube-box___1iJ7a",
            cube: "style__cube___3cAOS",
            sides: "style__sides___2TZd1",
            top: "style__top___NArHd",
            bottom: "style__bottom___-RVp6",
            front: "style__front___1v1IB",
            back: "style__back___32Zg8",
            left: "style__left___3LNwS",
            right: "style__right___1IR51",
            text: "style__text___2_gjz",
            "bar-wrapper": "style__bar-wrapper___1U5Gx",
            bar: "style__bar___u4qNR",
            "model-error": "style__model-error___10zDo",
            "model-retry-btn": "style__model-retry-btn___1AvnD",
            "model-retry-logo": "style__model-retry-logo___2TjAl",
            "model-error-logo": "style__model-error-logo___237uu",
            "progress-show": "style__progress-show___1uNUe",
            "switch-model": "style__switch-model___2r4Zd",
            "model-ar-tips": "style__model-ar-tips___9ZVUu",
            "wm161-model-container-in-modal":
              "style__wm161-model-container-in-modal___tMx0t",
            "quark-tab-default-tab-container":
              "style__quark-tab-default-tab-container___b9Mr1",
            "aos-animate": "style__aos-animate___PNXFk",
            "model-3d-block": "style__model-3d-block___3u3CB",
            "normal-ar-entry-first": "style__normal-ar-entry-first___1IXa_",
            "wm161-model-container-light-theme":
              "style__wm161-model-container-light-theme___3Vg_B",
            _8wsGN: "style___8wsGN___1RWte",
            _28KUW: "style___28KUW___36P5c",
            _1Ltud: "style___1Ltud___nnnFr",
          },
        },
        L = m()(
          function () {
            return n.e(169).then(n.bind(null, "yy0B"));
          },
          {
            ssr: !1,
            loadableGenerated: {
              webpack: function () {
                return ["yy0B"];
              },
              modules: ["./multiModelTabs"],
            },
          },
        ),
        B = function (e) {
          var t = e.isIOS,
            n = e.modelList,
            o = e.openAr,
            a = e.sendGaEvent;
          return C(
            "div",
            null,
            n.map(function (e, n) {
              return C(
                "p",
                {
                  key: e.key,
                  className: d()(
                    "normal-ar-entry ".concat(!n && "normal-ar-entry-first"),
                    E,
                    {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    },
                  ),
                },
                t
                  ? C(
                      "a",
                      {
                        rel: "ar",
                        href: e.url,
                        onClick: function () {
                          a(e.key, "ios")();
                        },
                      },
                      e.desc,
                      C("img", { alt: "" }),
                    )
                  : C("span", {
                      onClick: function () {
                        o(e.key), a(e.key, "android")();
                      },
                      dangerouslySetInnerHTML: { __html: e.desc },
                    }),
                C(O.a, {
                  name: "angle-right",
                  className: "style__angle-right-icon___2_0ZE",
                }),
              );
            }),
          );
        },
        N = (function (e) {
          function t(e) {
            var n;
            return (
              Object(r.default)(this, t),
              ((n = P(this, t, [e])).modelTabKeyList = {
                normal: "3dModel",
                ar: "arModel",
              }),
              (n.state = {
                isIOS: !1,
                isSupportAr: !1,
                isActiveArTabs: !1,
                isStartLoadModel: !1,
                activeTabKey: n.modelTabKeyList.normal,
              }),
              (n.openAndroidAr = n.openAndroidAr.bind(Object(c.a)(n))),
              (n.handleTabsChange = n.handleTabsChange.bind(Object(c.a)(n))),
              (n.handleStartLoadModel = n.handleStartLoadModel.bind(
                Object(c.a)(n),
              )),
              (n.setActiveModelType = n.setActiveModelType.bind(
                Object(c.a)(n),
              )),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "handleStartLoadModel",
                value: function () {
                  var e = this;
                  Object(S.b)({
                    elm: this.modelContainer,
                    offset: 600,
                    callback: function (t) {
                      t.inView && e.setState({ isStartLoadModel: !0 });
                    },
                  });
                },
              },
              {
                key: "componentDidMount",
                value: function () {
                  var e = Object(I.i)(),
                    t = Object(I.r)();
                  this.setState({ isIOS: e, isSupportAr: t }),
                    this.handleStartLoadModel();
                },
              },
              {
                key: "UNSAFE_componentWillReceiveProps",
                value: function (e) {
                  e &&
                    e.activeModelType !== this.props.activeModelType &&
                    e.activeModelType &&
                    this.setActiveModelType(e.activeModelType);
                },
              },
              {
                key: "setActiveModelType",
                value: function (e) {
                  var t = e === this.modelTabKeyList.ar;
                  this.setState(function (n) {
                    return (function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                          ? M(Object(n), !0).forEach(function (t) {
                              Object(a.a)(e, t, n[t]);
                            })
                          : Object.getOwnPropertyDescriptors
                            ? Object.defineProperties(
                                e,
                                Object.getOwnPropertyDescriptors(n),
                              )
                            : M(Object(n)).forEach(function (t) {
                                Object.defineProperty(
                                  e,
                                  t,
                                  Object.getOwnPropertyDescriptor(n, t),
                                );
                              });
                      }
                      return e;
                    })(
                      { isActiveArTabs: t },
                      n.activeTabKey !== e ? { activeTabKey: e } : {},
                    );
                  });
                },
              },
              {
                key: "openAndroidAr",
                value: function (e) {
                  var t = "#".concat(e, "-model-viewer");
                  document.querySelector(t).activateAR();
                },
              },
              {
                key: "handleTabsChange",
                value: function (e) {
                  (0, this.props.sendGa)("tabs-".concat(e))(),
                    this.setActiveModelType(e);
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = x.a.TabPanel,
                    n = this.props,
                    a = n.component_data,
                    r = n.t,
                    i = n.sendGa,
                    l = n.modelTabsName,
                    s = n.modelArTabsName,
                    c = n.showAsModal,
                    _ = this.state,
                    u = _.isActiveArTabs,
                    p = _.isIOS,
                    f = _.isSupportAr,
                    h = _.isStartLoadModel,
                    m = _.activeTabKey,
                    b = this.modelTabKeyList,
                    v = a.foldModelArDesc,
                    w = a.unfoldModelArDesc,
                    k = a.thirdModelArDesc,
                    O = a.foldIosArModelUrl,
                    S = a.unfoldIosArModelUrl,
                    j = a.thirdIosArModelUrl,
                    M = a.mainTitle,
                    P = a.mainDesc,
                    N = a.modelFirstTitle,
                    D = a.modelDesc,
                    z = a.modelArFirstTitle,
                    A = a.arModelPosterUrl,
                    R = a.arModelSizeTips,
                    F = a.arModelSupportTips,
                    V = a.customBackgroundColor,
                    H = a.theme,
                    W = a.hasThirdMode,
                    U = a.closeFold,
                    G = a.showOnlyOneAtIOS15,
                    Y = a.hideAndriord,
                    q = a.disableFadeAnimation,
                    X = U || (G && T.a.isIOS15()),
                    Z = [
                      { key: "unfold", url: Object(I.hb)(S), desc: r(w) },
                    ].concat(
                      Object(o.a)(
                        X
                          ? []
                          : [{ key: "fold", url: Object(I.hb)(O), desc: r(v) }],
                      ),
                      Object(o.a)(
                        W && !X
                          ? [{ key: "third", url: Object(I.hb)(j), desc: r(k) }]
                          : [],
                      ),
                    ),
                    K =
                      f && u
                        ? C(
                            "div",
                            { className: "style__model-ar-tips___9ZVUu" },
                            C("p", {
                              dangerouslySetInnerHTML: { __html: r(R) },
                            }),
                            C("p", {
                              dangerouslySetInnerHTML: { __html: r(F) },
                            }),
                          )
                        : null,
                    Q = V ? { backgroundColor: V } : {},
                    J = g()({
                      "wm161-model-container": !0,
                      "wm161-model-container-light-theme": "light" === H,
                      "wm161-model-container-in-modal": c,
                    }),
                    $ = T.a.isAndroid(),
                    ee = q ? "none" : "fade-up",
                    te = C(
                      t,
                      {
                        className: "style__model-tabs-panel___2GSAa",
                        tab: l,
                        key: b.normal,
                      },
                      C(
                        "div",
                        {
                          "data-aos": ee,
                          "data-aos-delay": "900",
                          className:
                            "style__model-3d-block___3u3CB style__model-block___Gknf8",
                        },
                        C(
                          "div",
                          { className: "style__model-desc___heClW" },
                          C("h3", {
                            dangerouslySetInnerHTML: { __html: r(N) },
                          }),
                          C("p", { dangerouslySetInnerHTML: { __html: r(D) } }),
                        ),
                        h
                          ? C(L, {
                              showOnlyOne: X,
                              theme: H,
                              component_data: a,
                              t: r,
                              sendGa: i,
                            })
                          : null,
                      ),
                    ),
                    ne = C(
                      t,
                      {
                        className: "style__model-tabs-panel___2GSAa",
                        tab: s,
                        key: b.ar,
                      },
                      C(
                        "div",
                        { className: "style__model-ar-block___2vuJC" },
                        C(
                          "div",
                          { className: "style__model-ar-desc___3oWGU" },
                          C("h3", {
                            dangerouslySetInnerHTML: { __html: r(z) },
                          }),
                          f
                            ? C(B, {
                                isIOS: p,
                                modelList: Z,
                                openAr: this.openAndroidAr,
                                sendGaEvent: function (e, t) {
                                  return i(
                                    "ar-".concat(e, "-").concat(t, "-entry"),
                                  );
                                },
                                arSupportTips: r(F),
                              })
                            : C("span", {
                                className: "style__not-support-ar___29TGI",
                                dangerouslySetInnerHTML: { __html: r(F) },
                              }),
                          c ? K : "",
                        ),
                        C(
                          "div",
                          { className: "style__model-ar-img___2Qxvz" },
                          C(y.a, { type: "img", src: A }),
                        ),
                      ),
                    ),
                    oe = {
                      activeKey: m,
                      theme: "dark",
                      tabPosition: "center",
                      tabDisplay: "inline-block",
                      onChange: this.handleTabsChange,
                      tabBarStyle: { textAlign: "center" },
                    };
                  return Y && $
                    ? null
                    : C(
                        "section",
                        {
                          style: Q,
                          ref: function (t) {
                            e.modelContainer = t;
                          },
                          className:
                            (J ? J + " " : "") +
                            d()(J, E, {
                              autoResolveMultipleImports: !0,
                              handleMissingStyleName: "warn",
                            }),
                        },
                        C(
                          "div",
                          { className: "style__model-title___1EHUJ" },
                          C(
                            "div",
                            { "data-aos": ee },
                            C("h3", {
                              dangerouslySetInnerHTML: { __html: r(M) },
                            }),
                          ),
                          C(
                            "div",
                            { "data-aos": ee, "data-aos-delay": "300" },
                            C("p", {
                              dangerouslySetInnerHTML: { __html: r(P) },
                            }),
                          ),
                        ),
                        C(
                          "div",
                          {
                            className: "style__model-tabs___1WJZg",
                            "data-aos": ee,
                            "data-aos-delay": "600",
                          },
                          $ ? C(x.a, oe, te) : C(x.a, oe, te, ne),
                        ),
                        f ? K : null,
                      );
                },
              },
            ]),
            t
          );
        })(f.a.Component);
      t.a = Object(b.a)(N);
    },
    Y7ZC: function (e, t, n) {
      var o = n("5T2Y"),
        a = n("WEpk"),
        r = n("2GTP"),
        i = n("NegM"),
        l = n("B+OT"),
        s = function (e, t, n) {
          var c,
            _,
            u,
            d = e & s.F,
            p = e & s.G,
            f = e & s.S,
            h = e & s.P,
            m = e & s.B,
            y = e & s.W,
            b = p ? a : a[t] || (a[t] = {}),
            v = b.prototype,
            g = p ? o : f ? o[t] : (o[t] || {}).prototype;
          for (c in (p && (n = t), n))
            ((_ = !d && g && void 0 !== g[c]) && l(b, c)) ||
              ((u = _ ? g[c] : n[c]),
              (b[c] =
                p && "function" != typeof g[c]
                  ? n[c]
                  : m && _
                    ? r(u, o)
                    : y && g[c] == u
                      ? (function (e) {
                          var t = function (t, n, o) {
                            if (this instanceof e) {
                              switch (arguments.length) {
                                case 0:
                                  return new e();
                                case 1:
                                  return new e(t);
                                case 2:
                                  return new e(t, n);
                              }
                              return new e(t, n, o);
                            }
                            return e.apply(this, arguments);
                          };
                          return (t.prototype = e.prototype), t;
                        })(u)
                      : h && "function" == typeof u
                        ? r(Function.call, u)
                        : u),
              h &&
                (((b.virtual || (b.virtual = {}))[c] = u),
                e & s.R && v && !v[c] && i(v, c, u)));
        };
      (s.F = 1),
        (s.G = 2),
        (s.S = 4),
        (s.P = 8),
        (s.B = 16),
        (s.W = 32),
        (s.U = 64),
        (s.R = 128),
        (e.exports = s);
    },
    YEIV: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o,
        a = n("SEkw"),
        r = (o = a) && o.__esModule ? o : { default: o };
      t.default = function (e, t, n) {
        return (
          t in e
            ? (0, r.default)(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      };
    },
    YESw: function (e, t, n) {
      var o = n("Cwc5")(Object, "create");
      e.exports = o;
    },
    YKpp: function (e, t, n) {
      e.exports = {
        section: "style__section___1jf2Y",
        "content-card-list": "style__content-card-list___e50Nu",
        "content-card": "style__content-card___lAXPI",
        "light-theme": "style__light-theme___3Tb-v",
        title: "style__title___2w1gu",
        link: "style__link___1exF8",
        desc: "style__desc___39G1o",
        "product-cover": "style__product-cover___2WNk5",
        "spec-list": "style__spec-list___2TPrl",
        "link-list": "style__link-list___1oxtU",
        "product-name": "style__product-name___2tC2e",
        "guide-list": "style__guide-list___2vAjr",
        icon: "style__icon___2fy3c",
        description: "style__description___1gCqM",
        "fa-angle-right": "style__fa-angle-right___3YodB",
        "product-price": "style__product-price___2_tMs",
        origin: "style__origin___1mLcf",
        "price-affirm": "style__price-affirm___3ukXL",
        "learn-more-phone": "style__learn-more-phone___26zB4",
        container: "style__container___153th",
        "product-box": "style__product-box___1uwGO",
        "guide-list-col-3": "style__guide-list-col-3___21pGQ",
        "guide-list-col-4": "style__guide-list-col-4___2avEe",
        "guide-list-col-5": "style__guide-list-col-5___4Hjg9",
        "spec-list-wrapper": "style__spec-list-wrapper___1Qyzd",
        spec: "style__spec___WxfEa",
        "buy-box": "style__buy-box___3kfRb",
        "light-theme-section": "style__light-theme-section___2WtOP",
      };
    },
    YRpl: function (e, t, n) {
      var o = n("lwsE"),
        a = n("W8MJ"),
        r = (function () {
          "use strict";
          function e(t) {
            o(this, e),
              (this.defaultParams = {
                reset: !1,
                replayWhenRevisible: !1,
                visiblePlay: !1,
                lazyLoad: !1,
                lazyLoadThreshold: 0,
                containerClassName: "dbv",
                replayClassName: "",
                downgradeHtml: "",
              }),
              this._init(t);
          }
          return (
            a(e, [
              {
                key: "_init",
                value: function (e) {
                  (this.params = Object.assign(this.defaultParams, e)),
                    this._processVideo();
                },
              },
              {
                key: "_processVideo",
                value: function () {
                  var e = this,
                    t =
                      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                        navigator.userAgent,
                      ),
                    n = window.navigator.userAgent,
                    o = !!n.match(/MicroMessenger/gi);
                  (this.video_containers = Array.from(
                    document.querySelectorAll(
                      ".".concat(this.params.containerClassName),
                    ),
                  )),
                    (this.videos = Array.from(
                      document.querySelectorAll(
                        ".".concat(this.params.containerClassName, " video"),
                      ),
                    )),
                    this.videos.length &&
                      this.videos.forEach(function (a, r) {
                        if (t) {
                          var i = !!n.match(/iPad/i) || !!n.match(/iPhone/i),
                            l = !!n.match(/UCBrowser/gi),
                            s = !!n.match(/android/gi),
                            c = !!n.match(/\bm?qqbrowser\/([0-9.]+)/gi);
                          if (s || (i && (l || c)))
                            return void e._initDowngrade(a);
                          e._videoWithControl(a);
                        }
                        e.params.lazyLoad && e._initLazyLoad(a),
                          o
                            ? document.addEventListener(
                                "WeixinJSBridgeReady",
                                function () {
                                  e.params.visiblePlay &&
                                    e._initVisiblePlay(a, r),
                                    e.params.replayClassName &&
                                      e._initReplay(a, r),
                                    e.params.reset && e._bindEndReset(a);
                                },
                              )
                            : (e.params.visiblePlay && e._initVisiblePlay(a, r),
                              e.params.replayClassName && e._initReplay(a, r),
                              e.params.reset && e._bindEndReset(a));
                      });
                },
              },
              {
                key: "_initLazyLoad",
                value: function (e) {
                  var t = this,
                    n = this._throttle(a, 50);
                  window.addEventListener("scroll", n),
                    window.addEventListener("resize", n);
                  var o = !1;
                  function a() {
                    if (o) return !1;
                    if (t._checkVideoVisible(e, t.params.lazyLoadThreshold)) {
                      for (
                        var a = e.querySelectorAll("source"), r = 0;
                        r < a.length;
                        r++
                      ) {
                        var i = a[r].dataset.layzrSrc;
                        a[r].setAttribute("src", i);
                        var l = e.dataset.layzrPoster;
                        l && e.setAttribute("poster", l);
                      }
                      e.load(),
                        (o = !0),
                        window.removeEventListener("scroll", n),
                        window.removeEventListener("resize", n);
                    }
                  }
                  a();
                },
              },
              {
                key: "_initVisiblePlay",
                value: function (e, t) {
                  var n = !1,
                    o = !1,
                    a = this,
                    r = a.params.replayWhenRevisible,
                    i = a._throttle(l, 50);
                  function l() {
                    var l = a._showWholeElm(e);
                    if (r) {
                      if (
                        (o ||
                          (a._bindVideoEvent(e, function (e) {
                            a._triggerVideoPlay(e), e.pause();
                          }),
                          (o = !0)),
                        l && !n)
                      )
                        (e.currentTime > 0 &&
                          !e.paused &&
                          !e.ended &&
                          e.readyState > 2) ||
                          a._bindVideoEvent(e, function (e) {
                            ((e.currentTime = 0),
                            a._triggerVideoPlay(e),
                            a.params.replayClassName) &&
                              (a.video_containers[t].querySelector(
                                ".".concat(a.params.replayClassName),
                              ).style.display = "none");
                            o = !0;
                          });
                      n = l;
                    } else {
                      if (o || !l) return;
                      a._bindVideoEvent(e, function (e) {
                        (e.currentTime = 0),
                          a._triggerVideoPlay(e),
                          (o = !0),
                          window.removeEventListener("scroll", i),
                          window.removeEventListener("resize", i);
                      });
                    }
                  }
                  window.addEventListener("scroll", i),
                    window.addEventListener("resize", i),
                    l();
                },
              },
              {
                key: "_initReplay",
                value: function (e, t) {
                  var n = this,
                    o = n.video_containers[t].querySelector(
                      ".".concat(n.params.replayClassName),
                    );
                  e.addEventListener("ended", function () {
                    (o.style.display = "block"), e.pause();
                  }),
                    o.addEventListener("click", function () {
                      n._bindVideoEvent(e, function (e) {
                        (e.currentTime = 0), n._triggerVideoPlay(e);
                      }),
                        (o.style.display = "none");
                    });
                },
              },
              {
                key: "_initDowngrade",
                value: function (e) {
                  var t = this.params.downgradeHtml;
                  if (t) {
                    var n = e.parentNode,
                      o = document.createElement("div"),
                      a = e.dataset;
                    Object.keys(a).forEach(function (e) {
                      if (e.match(/downgrade/i)) {
                        var n = e;
                        n = n.replace("downgrade", "");
                        var o = a[e];
                        t = t.replace("#".concat(n.toLowerCase(), "#"), o);
                      }
                    }),
                      (o.innerHTML = t);
                    var r = o.childNodes[0];
                    n.replaceChild(r, e);
                  }
                },
              },
              {
                key: "_bindEndReset",
                value: function (e) {
                  e.addEventListener("ended", function () {
                    e.currentTime = 0;
                  });
                },
              },
              {
                key: "_videoWithControl",
                value: function (e) {
                  e.removeAttribute("autoplay"),
                    e.setAttribute("playsinline", !0),
                    e.setAttribute("x5-playsinline", !0),
                    e.setAttribute("webkit-playsinline", !0),
                    e.setAttribute("controls", !0),
                    setTimeout(function () {
                      e.removeAttribute("controls");
                    }, 0);
                },
              },
              {
                key: "_bindVideoEvent",
                value: function (e, t) {
                  !!window.MSInputMethodContext && !!document.documentMode
                    ? (e.load && e.load(),
                      e.addEventListener("canplay", function n() {
                        t(e), e.removeEventListener("canplay", n);
                      }))
                    : t(e);
                },
              },
              {
                key: "_triggerVideoPlay",
                value: function (e) {
                  if (
                    !!window.navigator.userAgent.match(/MicroMessenger/gi) &&
                    WeixinJSBridge
                  )
                    WeixinJSBridge.invoke(
                      "getNetworkType",
                      {},
                      function () {
                        setTimeout(function () {
                          var t = e.play();
                          t &&
                            t.then &&
                            "function" === typeof t.then &&
                            t.then(
                              function () {},
                              function () {},
                            );
                        }, 0);
                      },
                      !1,
                    );
                  else {
                    var t = e.play();
                    t &&
                      t.then &&
                      "function" === typeof t.then &&
                      t.then(
                        function () {},
                        function () {},
                      );
                  }
                },
              },
              {
                key: "_throttle",
                value: function (e, t) {
                  var n = arguments,
                    o = this,
                    a = !1;
                  return function () {
                    var r = n,
                      i = o;
                    if (!a)
                      return (
                        e.apply(i, r),
                        (a = !0),
                        setTimeout(function () {
                          return (a = !1);
                        }, t)
                      );
                  };
                },
              },
              {
                key: "_checkVideoVisible",
                value: function (e, t) {
                  for (
                    var n = t || 0,
                      o = window.scrollY || window.pageYOffset,
                      a = o + window.innerHeight,
                      r = e.offsetTop - n,
                      i = e.offsetHeight + n;
                    e.offsetParent;

                  )
                    r += (e = e.offsetParent).offsetTop;
                  return (
                    (o <= (i += r) && i <= a) ||
                    (a >= r && r >= o) ||
                    (r <= o && i >= a)
                  );
                },
              },
              {
                key: "_showWholeElm",
                value: function (e) {
                  for (
                    var t = window.scrollY || window.pageYOffset,
                      n = t + window.innerHeight,
                      o = e.offsetTop,
                      a = e.offsetHeight;
                    e.offsetParent;

                  )
                    o += (e = e.offsetParent).offsetTop;
                  return (a += o), (o >= t && n >= a) || (o <= t && n <= a);
                },
              },
            ]),
            e
          );
        })();
      e.exports = r;
    },
    "YZ1+": function (e, t, n) {
      e.exports = {
        "form-group-zh-enterprise": "style__form-group-zh-enterprise___2hZjx",
        "form-box-zh-enterprise": "style__form-box-zh-enterprise___3D8TF",
        "form-group-zh-enterprise-select-label-show":
          "style__form-group-zh-enterprise-select-label-show___3nYZs",
        "form-group-zh-enterprise-position":
          "style__form-group-zh-enterprise-position___3gCpT",
        "form-group-zh-enterprise-tip":
          "style__form-group-zh-enterprise-tip___23AhS",
        "form-group-zh-enterprise-select-font":
          "style__form-group-zh-enterprise-select-font___2Q86l",
        "section-form-component": "style__section-form-component___ZZNnU",
        "zh-enterprise-text-box": "style__zh-enterprise-text-box___28SMI",
        "text-box": "style__text-box___319Qy",
        title: "style__title___1j1t2",
        desc: "style__desc___11r5B",
        "form-box": "style__form-box___2decN",
        "form-group": "style__form-group___Ba9UW",
        icon: "style__icon___1sAIZ",
        "form-input-label": "style__form-input-label___3Vf-B",
        "form-input-label-focussend":
          "style__form-input-label-focussend___38jS8",
        "form-textarea-label": "style__form-textarea-label___oevt-",
        "select-box": "style__select-box___mDy8I",
        select: "style__select___1tanE",
        cooperationIntention: "style__cooperationIntention___2tWj3",
        "cooperationIntention-zh-enterprise":
          "style__cooperationIntention-zh-enterprise___3_HRI",
        margin: "style__margin___1FhgI",
        "no-margin": "style__no-margin___1meyN",
        "terms-desc": "style__terms-desc___39PwA",
        "form-button": "style__form-button___2BWRW",
        "zh-enterprise-form-btn-margin":
          "style__zh-enterprise-form-btn-margin___2_9yE",
        "zh-enterprise-form-button": "style__zh-enterprise-form-button___2H0Ur",
        btn: "style__btn___3Hr69",
        "button-box": "style__button-box___3LH7o",
        "submit-btn": "style__submit-btn___23hy9",
        "check-box-group": "style__check-box-group____CzmU",
        "check-box": "style__check-box___3cDDa",
        "subscribe-check": "style__subscribe-check___3Zwp2",
        "form-check-box": "style__form-check-box___1MYUR",
        "tp-form-item": "style__tp-form-item___3uLaF",
        "check-box-group-column": "style__check-box-group-column___2vyuA",
        "check-box-group-column-pc-width":
          "style__check-box-group-column-pc-width___3kKU0",
        "check-box-group-column-mobile-width":
          "style__check-box-group-column-mobile-width___2VEAA",
        "check-box-group-column-mobile-width-overflow":
          "style__check-box-group-column-mobile-width-overflow___36src",
        "check-box-group-column-mobile-width-overflow-margin":
          "style__check-box-group-column-mobile-width-overflow-margin___dRV81",
        "nc-required": "style__nc-required___22ZZf",
        captcha: "style__captcha___2hod_",
        "captcha-no-show": "style__captcha-no-show___2pCBL",
        "zh-enterprise-captcha": "style__zh-enterprise-captcha___4tevy",
        "zh-enterprise-nc-container":
          "style__zh-enterprise-nc-container___2HOLY",
        "form-error": "style__form-error___1KBdi",
        "loading-circle": "style__loading-circle___EqDr_",
        loading: "style__loading___3Vcdn",
        "button-state": "style__button-state___2kGM4",
        "checkbox-item": "style__checkbox-item___1a3Lu",
        "modal-header": "style__modal-header___2Y1y5",
        "modal-logo": "style__modal-logo___2sqMS",
        "modal-title": "style__modal-title___2bFAu",
        "modal-body": "style__modal-body___2RblD",
        "new-modal-box-mobile": "style__new-modal-box-mobile___3vXQm",
        "new-modal-box": "style__new-modal-box___1B5ST",
        "new-modal-zh": "style__new-modal-zh___1QSQA",
        "new-modal-header": "style__new-modal-header___1sGsj",
        "new-modal-logo": "style__new-modal-logo___3X2ER",
        "fail-logo": "style__fail-logo___1yh21",
        "success-logo": "style__success-logo___2nBeZ",
        "new-modal-body": "style__new-modal-body___1BYWd",
        button: "style__button___1W0UV",
        "new-modal-text-box": "style__new-modal-text-box___2x2n5",
        "right-logo": "style__right-logo___1_TXI",
      };
    },
    YovF: function (e, t, n) {
      e.exports = {
        "wm161-model-container": "style__wm161-model-container___17bBU",
        "model-wrapper": "style__model-wrapper___3KRq2",
        "model-title": "style__model-title___2UrJl",
        "model-tabs": "style__model-tabs___tUzLq",
        "model-tabs-back-mask": "style__model-tabs-back-mask___1zPkE",
        "model-tabs-panel": "style__model-tabs-panel___39W1C",
        "model-block": "style__model-block___1Yk9k",
        "model-desc": "style__model-desc___ksMoi",
        "model-qc-code": "style__model-qc-code___32K79",
        "qc-active": "style__qc-active___O6vGA",
        "unfold-tabs-panel": "style__unfold-tabs-panel___3-Vep",
        "fold-tabs-panel": "style__fold-tabs-panel___3Vmup",
        "model-content": "style__model-content___MhwPT",
        "model-ie-img": "style__model-ie-img___9Zry2",
        "model-progress": "style__model-progress___3ZHjt",
        cube: "style__cube___1n9AS",
        sides: "style__sides___1Kt_u",
        rotate: "style__rotate___3y-Li",
        top: "style__top___3Jy_d",
        "top-animation": "style__top-animation___2Sqbv",
        bottom: "style__bottom___321L8",
        "bottom-animation": "style__bottom-animation___3aU5w",
        front: "style__front___3QhDu",
        "front-animation": "style__front-animation___2od4a",
        back: "style__back___2q48n",
        "back-animation": "style__back-animation___v7X_u",
        left: "style__left___2SWKs",
        "left-animation": "style__left-animation___KcuUK",
        right: "style__right___2x5Tx",
        "right-animation": "style__right-animation___-FV_o",
        "cube-box": "style__cube-box___MrewK",
        text: "style__text___3ireS",
        "bar-wrapper": "style__bar-wrapper___1v6sT",
        bar: "style__bar___2kDyi",
        "flex-box": "style__flex-box___2heey",
        "model-error": "style__model-error___3RyIi",
        "model-retry-btn": "style__model-retry-btn___3BCvF",
        "model-retry-logo": "style__model-retry-logo___hfW1Y",
        "model-error-logo": "style__model-error-logo___1Ns95",
        "progress-show": "style__progress-show___2-G45",
        "model-active": "style__model-active___1k12E",
        "model-ar-img": "style__model-ar-img___35I2Z",
        "model-ar-tips": "style__model-ar-tips___dUwjr",
        "wm161-model-container-in-modal":
          "style__wm161-model-container-in-modal___kKLsO",
        "model-block-3d": "style__model-block-3d___2fudz",
        "switch-tabs": "style__switch-tabs___28KKA",
        "model-block-ar": "style__model-block-ar___xAZuZ",
        tip: "style__tip___234JL",
        "wm161-model-container-light-theme":
          "style__wm161-model-container-light-theme___216_A",
        "switch-tabs-panel": "style__switch-tabs-panel___1B1wi",
        "switch-active": "style__switch-active___1NdeD",
      };
    },
    YqAc: function (e, t) {
      var n = 0,
        o = Math.random();
      e.exports = function (e) {
        return "Symbol(".concat(
          void 0 === e ? "" : e,
          ")_",
          (++n + o).toString(36),
        );
      };
    },
    YuTi: function (e, t) {
      e.exports = function (e) {
        return (
          e.webpackPolyfill ||
            ((e.deprecate = function () {}),
            (e.paths = []),
            e.children || (e.children = []),
            Object.defineProperty(e, "loaded", {
              enumerable: !0,
              get: function () {
                return e.l;
              },
            }),
            Object.defineProperty(e, "id", {
              enumerable: !0,
              get: function () {
                return e.i;
              },
            }),
            (e.webpackPolyfill = 1)),
          e
        );
      };
    },
    Z0cm: function (e, t) {
      var n = Array.isArray;
      e.exports = n;
    },
    Z4y5: function (e, t, n) {
      e.exports = {
        "visual-hidden": "style__visual-hidden___2yhAv",
        "component-background-video":
          "style__component-background-video___32B8C",
        "video-mask": "style__video-mask___1h3ER",
        "component-downgrade-image": "style__component-downgrade-image___2xNLO",
        "card-link-container": "style__card-link-container___2aQ1B",
        "card-container": "style__card-container___2V9hZ",
        "card-wrapper": "style__card-wrapper___1XjdI",
        "vertical-top-align": "style__vertical-top-align___2XA_5",
        "vertical-center-align": "style__vertical-center-align___2oPDD",
        "vertical-bottom-align": "style__vertical-bottom-align___27EEk",
        "card-background-video": "style__card-background-video___IqrGq",
        "card-downgrade-image": "style__card-downgrade-image___gyTuM",
        "card-content": "style__card-content___1KUg1",
        "topping-img": "style__topping-img___9C8uf",
        "tag-container": "style__tag-container___3-SG6",
        "tag-content": "style__tag-content___iXOYY",
        "price-container": "style__price-container___2aDwy",
        "real-price": "style__real-price___2Q9oV",
        "origin-price": "style__origin-price___3s4ZE",
        "horizontal-left-align": "style__horizontal-left-align___HMr09",
        "horizontal-right-align": "style__horizontal-right-align___3tGha",
        eyebrow: "style__eyebrow___ZTRWw",
        headline: "style__headline___318tu",
        subhead: "style__subhead___m-2eb",
        description: "style__description___2VBf0",
        note: "style__note___3JtfM",
        "icon-pic": "style__icon-pic___2bOdP",
        "media-pic": "style__media-pic___3D6zc",
        divider: "style__divider___5huii",
        "download-buttons-container":
          "style__download-buttons-container___1Mt_M",
        "icons-list": "style__icons-list___1FWab",
        "horizontal-center-align": "style__horizontal-center-align___3nRQ3",
        "content-text-color-black": "style__content-text-color-black___27HZt",
        "icon-title": "style__icon-title___3_ay9",
        "icon-desc": "style__icon-desc___16Anm",
        "content-text-color-white": "style__content-text-color-white___3106q",
        "size-xxxxxl": "style__size-xxxxxl___7JhfU",
        "connect-pic": "style__connect-pic___3vFtW",
        "connect-eyebrow-text": "style__connect-eyebrow-text___1BIKE",
        link: "style__link___2-YIH",
        "icons-container": "style__icons-container___3aMHn",
        "card-icon-container": "style__card-icon-container___1zxWm",
        "icon-number": "style__icon-number___3t1wd",
        "icon-unit": "style__icon-unit___1hibl",
        "size-xxxxl": "style__size-xxxxl___1QBXH",
        "size-xxxl": "style__size-xxxl___3CYX8",
        "size-xxl": "style__size-xxl___J8jbE",
        "size-xl": "style__size-xl___oC7gu",
        "size-l": "style__size-l___W5bai",
        "size-m": "style__size-m___1Hd2S",
        "size-s": "style__size-s___3tUPd",
        "size-xs": "style__size-xs___1AfBE",
        "size-xxs": "style__size-xxs___FtF08",
        "divider-container": "style__divider-container___28WKu",
        "buttons-container": "style__buttons-container___1rTcQ",
        "button-wrapper": "style__button-wrapper___1RWq-",
        "button-inner": "style__button-inner___15njm",
        "button-video-play": "style__button-video-play___IPVoE",
        "zoom-button": "style__zoom-button___275xt",
        "video-play": "style__video-play___2_GDD",
        "video-play-light": "style__video-play-light___1XcJi",
        "video-play-dark": "style__video-play-dark___N0FX-",
        download: "style__download___32XP5",
        "links-container": "style__links-container___3lcNO",
        "icon-eyebrow-container": "style__icon-eyebrow-container___1bc3R",
        "left-align": "style__left-align___3v0jv",
        "center-align": "style__center-align___15bal",
        "right-align": "style__right-align___2sZpF",
        "icon-number-container": "style__icon-number-container___xnV5s",
        horizontal: "style__horizontal___3MifN",
        part: "style__part___lml13",
        left: "style__left___1FJvA",
        right: "style__right___2yXBZ",
        "credit-container": "style__credit-container___lItGO",
        "credit-content": "style__credit-content___3Bcuf",
        "card-media": "style__card-media___1ai8W",
        "card-media-multi": "style__card-media-multi___3427G",
        "card-media-multi-leftRight":
          "style__card-media-multi-leftRight___XFCne",
        "card-media-part": "style__card-media-part___2dhKm",
        "card-media-multi-left2right1":
          "style__card-media-multi-left2right1___2p7az",
        "card-media-item": "style__card-media-item___3tEKk",
        "card-media-multi-up1down2": "style__card-media-multi-up1down2___3pUrZ",
        "card-media-multi-updown": "style__card-media-multi-updown___2R8qf",
        "card-media-multi-up2down1": "style__card-media-multi-up2down1___1djR0",
        "media-zoom-wrapper": "style__media-zoom-wrapper___8HUR2",
        "media-video": "style__media-video___2M39S",
        "parallax-fore-pic": "style__parallax-fore-pic___2xl3F",
        "media-sticker": "style__media-sticker___3WSy2",
        "downgrade-img": "style__downgrade-img___3vadq",
        "downgrade-pic": "style__downgrade-pic___2eONy",
        "downgrade-play-btn": "style__downgrade-play-btn___3TlQl",
        "parallax-fore-video": "style__parallax-fore-video___muc4i",
        "video-buttom": "style__video-buttom___2QEX9",
        "replay-buttom": "style__replay-buttom___3RzNw",
        "play-buttom": "style__play-buttom___1y7w_",
        "pause-buttom": "style__pause-buttom___3-Q4U",
        dark: "style__dark___2xKps",
      };
    },
    Z8oC: function (e, t, n) {
      var o = n("y1pI");
      e.exports = function (e, t) {
        var n = this.__data__,
          a = o(n, e);
        return a < 0 ? (++this.size, n.push([e, t])) : (n[a][1] = t), this;
      };
    },
    ZLSR: function (e, t, n) {
      e.exports = {
        "media-modal-container": "modal__media-modal-container___wbEaJ",
        show: "modal__show___35ST7",
        "media-modal-close": "modal__media-modal-close___33NCY",
        "modal-content": "modal__modal-content___1mrw_",
        "media-tips": "modal__media-tips___2Z-0e",
        "is-move": "modal__is-move___3MOan",
        "tips-icon": "modal__tips-icon___48bWZ",
        "tips-text": "modal__tips-text___1bDwj",
        dark: "modal__dark___EzIc_",
        light: "modal__light___SrCfj",
        rotate90: "modal__rotate90___1TFLI",
        "media-modal-iframe": "modal__media-modal-iframe___1kwwp",
        "media-modal-iframe-360": "modal__media-modal-iframe-360___2ns1r",
        "link-button": "modal__link-button___2DHgq",
        wrapper: "modal__wrapper___2TNOe",
        "zoom-out-div": "modal__zoom-out-div___2WaJ9",
        "bg-style": "modal__bg-style___oL6Td",
        icon: "modal__icon___3OaHQ",
        "icon-more": "modal__icon-more___lwmzv",
        "icon-180": "modal__icon-180___4ojr8",
        "icon-360": "modal__icon-360___1wBxf",
        tip: "modal__tip___dASBf",
        "mask-360": "modal__mask-360___2YsMn",
      };
    },
    ZO6J: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = ["RU", "MX", "AE", "BR", "ID", "OR"];
    },
    ZPPD: function (e, t, n) {
      "use strict";
      n.d(t, "c", function () {
        return p;
      }),
        n.d(t, "b", function () {
          return h;
        }),
        n.d(t, "a", function () {
          return m;
        });
      var o = n("q1tI"),
        a = n.n(o),
        r = n("xk4V"),
        i = n.n(r),
        l = n("HcE9"),
        s = n("ub/+"),
        c = n("nPaQ"),
        _ = n("tZZE"),
        u = n("inn5"),
        d = (n("z8P2"), a.a.createElement),
        p = function (e, t) {
          var n = t.gaTextPrefix,
            o = t.linkType,
            a = t.linkText,
            r = t.link,
            c = l.b.normal,
            _ = n;
          switch (o) {
            case "internal-link":
              (c = l.b.more), (_ = "".concat(_, "in"));
              break;
            case "external-link":
              (c = l.b.external), (_ = "".concat(_, "out"));
              break;
            case "download-link":
              (c = l.b.download), (_ = "".concat(_, "download"));
              break;
            case "no-icon-link":
              (c = l.b.normal), (_ = "".concat(_, "normal"));
              break;
            default:
              (c = l.b.more), (_ = "".concat(_, "in"));
          }
          var u = l.a[e.linkColor],
            p = {
              fontSize: e.linkFontSize || "16px",
              lineHeight: Object(s.a)(e.linkFontSize, e.linkLineHeight),
            };
          return d(
            "div",
            {
              "data-aos": e.aosFade,
              "data-aos-once": !0,
              className: "style__link___36f7n",
              key: i()(),
              "data-ga-label": _,
            },
            d(
              l.c,
              { theme: u, type: c, style: p, href: r },
              d("span", { dangerouslySetInnerHTML: { __html: a || "" } }),
            ),
          );
        },
        f = function (e, t, n) {
          var o = !1;
          return (
            e &&
              t &&
              "/" !== t &&
              ((n !== u.t.button &&
                n !== u.t["external-button"] &&
                n !== u.t["store-button"]) ||
                (o = !0),
              (n !== u.v["internal-link"] && n !== u.t["external-link"]) ||
                (o = !0)),
            o
          );
        },
        h = function () {
          for (
            var e =
                arguments.length > 0 && void 0 !== arguments[0]
                  ? arguments[0]
                  : [],
              t = -1,
              n = 0;
            n < e.length;
            n++
          ) {
            var o = e[n];
            if (
              o &&
              o.text &&
              "/" !== o.text &&
              ("internal-link" === o.linkType || "external-link" === o.linkType)
            ) {
              t = n;
              break;
            }
          }
          return t;
        },
        m = function (e) {
          var t = "",
            n = _.a.SELF,
            o = { url: void 0, target: n, gaLabel: "" };
          if (e.hasJumpLink && e.jumpLink && "/" !== e.jumpLink) return o;
          if (f(e.hasPrimaryButton, e.primaryButtonLink, e.primaryButtonType))
            return (
              (n = Object(c.c)(e.primaryButtonType)),
              (t = Object(c.b)(e.primaryButtonGaLabel, e.index)),
              (o = { url: e.primaryButtonLink, target: n, gaLabel: t })
            );
          if (
            f(
              e.hasSecondaryButton,
              e.secondaryButtonLink,
              e.secondaryButtonType,
            )
          )
            return (
              (n = Object(c.c)(e.secondaryButtonType)),
              (t = Object(c.b)(e.secondaryButtonGaLabel, e.index)),
              (o = { url: e.secondaryButtonLink, target: n, gaLabel: t })
            );
          if (f(e.hasThirdlyButton, e.thirdlyButtonLink, e.thirdlyButtonType))
            return (
              (n = Object(c.c)(e.thirdlyButtonType)),
              (t = Object(c.b)(e.thirdlyButtonGaLabel, e.index)),
              (o = { url: e.thirdlyButtonLink, target: n, gaLabel: t })
            );
          if (e.hasCardLinks && e.links) {
            var a = h(e.links),
              r = e.links[a];
            if (a > -1 && r) {
              var i = "card-".concat(e.index, "-link-").concat(a, "-link-"),
                l = r.linkGaLabel ? "".concat(r.linkGaLabel, "-") : i;
              return (
                "internal-link" === r.linkType &&
                  (o = {
                    url: r.text,
                    target: _.a.SELF,
                    gaLabel: "".concat(l, "in"),
                  }),
                "external-link" === r.linkType &&
                  (o = {
                    url: r.text,
                    target: _.a.BLANK,
                    gaLabel: "".concat(l, "out"),
                  }),
                o
              );
            }
          }
          return o;
        };
    },
    ZRcJ: function (e, t, n) {
      "use strict";
      function o() {
        return {
          default: "Validation error on field %s",
          required: "%s is required",
          enum: "%s must be one of %s",
          whitespace: "%s cannot be empty",
          date: {
            format: "%s date %s is invalid for format %s",
            parse: "%s date could not be parsed, %s is invalid ",
            invalid: "%s date %s is invalid",
          },
          types: {
            string: "%s is not a %s",
            method: "%s is not a %s (function)",
            array: "%s is not an %s",
            object: "%s is not an %s",
            number: "%s is not a %s",
            date: "%s is not a %s",
            boolean: "%s is not a %s",
            integer: "%s is not an %s",
            float: "%s is not a %s",
            regexp: "%s is not a valid %s",
            email: "%s is not a valid %s",
            url: "%s is not a valid %s",
            hex: "%s is not a valid %s",
          },
          string: {
            len: "%s must be exactly %s characters",
            min: "%s must be at least %s characters",
            max: "%s cannot be longer than %s characters",
            range: "%s must be between %s and %s characters",
          },
          number: {
            len: "%s must equal %s",
            min: "%s cannot be less than %s",
            max: "%s cannot be greater than %s",
            range: "%s must be between %s and %s",
          },
          array: {
            len: "%s must be exactly %s in length",
            min: "%s cannot be less than %s in length",
            max: "%s cannot be greater than %s in length",
            range: "%s must be between %s and %s in length",
          },
          pattern: { mismatch: "%s value %s does not match pattern %s" },
          clone: function () {
            var e = JSON.parse(JSON.stringify(this));
            return (e.clone = this.clone), e;
          },
        };
      }
      Object.defineProperty(t, "__esModule", { value: !0 }),
        (t.newMessages = o);
      t.messages = o();
    },
    ZWtO: function (e, t, n) {
      var o = n("4uTw"),
        a = n("9Nap");
      e.exports = function (e, t) {
        for (var n = 0, r = (t = o(t, e)).length; null != e && n < r; )
          e = e[a(t[n++])];
        return n && n == r ? e : void 0;
      };
    },
    ZYh2: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return m;
      }),
        n.d(t, "b", function () {
          return f;
        }),
        n.d(t, "c", function () {
          return h;
        });
      var o = function () {
          return "undefined" === typeof window;
        },
        a = function (e) {
          e = e || navigator.userAgent;
          var t = /(iPad).*OS\s([\d_]+)/.test(e);
          return {
            ios: (!t && /(iPhone\sOS)\s([\d_]+)/.test(e)) || t,
            android: /(Android);?[\s/]+([\d.]+)?/.test(e),
          };
        };
      var r = 0,
        i = 0,
        l = 0,
        s = null,
        c = !1,
        _ = [],
        u = (function (e) {
          if (o()) return !1;
          if (!e) throw new Error("options must be provided");
          var t = !1,
            n = {
              get passive() {
                t = !0;
              },
            },
            a = function () {};
          window.addEventListener("__TUA_BSL_TEST_PASSIVE__", a, n),
            window.removeEventListener("__TUA_BSL_TEST_PASSIVE__", a, n);
          var r = e.capture;
          return t ? e : "undefined" !== typeof r && r;
        })({ passive: !1 }),
        d = !o() && "scrollBehavior" in document.documentElement.style,
        p = function (e) {
          e.cancelable && e.preventDefault();
        },
        f = function (e, t) {
          if (!o()) {
            if (a().ios) {
              if (e)
                (Array.isArray(e) ? e : [e]).forEach(function (e) {
                  e &&
                    -1 === _.indexOf(e) &&
                    ((e.ontouchstart = function (e) {
                      (i = e.targetTouches[0].clientY),
                        (l = e.targetTouches[0].clientX);
                    }),
                    (e.ontouchmove = function (t) {
                      1 === t.targetTouches.length &&
                        (function (e, t) {
                          if (t) {
                            var n = t.scrollTop,
                              o = t.scrollLeft,
                              a = t.scrollWidth,
                              r = t.scrollHeight,
                              s = t.clientWidth,
                              c = t.clientHeight,
                              _ = e.targetTouches[0].clientX - l,
                              u = e.targetTouches[0].clientY - i,
                              d = Math.abs(u) > Math.abs(_);
                            if (
                              (d &&
                                ((u > 0 && 0 === n) ||
                                  (u < 0 && n + c + 1 >= r))) ||
                              (!d &&
                                ((_ > 0 && 0 === o) ||
                                  (_ < 0 && o + s + 1 >= a)))
                            )
                              return p(e);
                          }
                          e.stopPropagation();
                        })(t, e);
                    }),
                    _.push(e));
                });
              c || (document.addEventListener("touchmove", p, u), (c = !0));
            } else
              r <= 0 &&
                (s = a().android
                  ? (function (e) {
                      var t = document.documentElement,
                        n = document.body,
                        o = t.scrollTop || n.scrollTop,
                        a = Object.assign({}, t.style),
                        r = Object.assign({}, n.style);
                      return (
                        (t.style.height = "100%"),
                        (t.style.overflow = "hidden"),
                        (n.style.top = "-".concat(o, "px")),
                        (n.style.width = "100%"),
                        (n.style.height = "auto"),
                        (n.style.position = "fixed"),
                        (n.style.overflow =
                          (null === e || void 0 === e
                            ? void 0
                            : e.overflowType) || "hidden"),
                        function () {
                          (t.style.height = a.height || ""),
                            (t.style.overflow = a.overflow || ""),
                            [
                              "top",
                              "width",
                              "height",
                              "overflow",
                              "position",
                            ].forEach(function (e) {
                              n.style[e] = r[e] || "";
                            });
                          var e = { top: o, behavior: "instant" };
                          d ? window.scrollTo(e) : window.scrollTo(0, o);
                        }
                      );
                    })(t)
                  : (function () {
                      var e = document.documentElement,
                        t = Object.assign({}, e.style),
                        n = window.innerWidth - e.clientWidth,
                        o = parseInt(
                          window.getComputedStyle(e).paddingRight,
                          10,
                        );
                      return (
                        (e.style.overflow = "hidden"),
                        (e.style.boxSizing = "border-box"),
                        (e.style.paddingRight = "".concat(n + o, "px")),
                        function () {
                          ["overflow", "boxSizing", "paddingRight"].forEach(
                            function (n) {
                              e.style[n] = t[n] || "";
                            },
                          );
                        }
                      );
                    })());
            r += 1;
          }
        },
        h = function (e) {
          if (!o() && !((r -= 1) > 0))
            if (a().ios || "function" !== typeof s) {
              if (e)
                (Array.isArray(e) ? e : [e]).forEach(function (e) {
                  var t = _.indexOf(e);
                  -1 !== t &&
                    ((e.ontouchmove = null),
                    (e.ontouchstart = null),
                    _.splice(t, 1));
                });
              c && (document.removeEventListener("touchmove", p, u), (c = !1));
            } else s();
        },
        m = function () {
          if (!o())
            if (((r = 0), a().ios || "function" !== typeof s)) {
              if (_.length)
                for (var e = _.pop(); e; )
                  (e.ontouchmove = null),
                    (e.ontouchstart = null),
                    (e = _.pop());
              c && (document.removeEventListener("touchmove", p, u), (c = !1));
            } else s();
        };
    },
    ZkIW: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      var l = "enum";
      t.default = function (e, t, n, o, a) {
        var s = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t) && !e.required) return n();
          r.default.required(e, t, o, s, a), t && r.default[l](e, t, o, s, a);
        }
        n(s);
      };
    },
    Zxgi: function (e, t, n) {
      var o = n("5T2Y"),
        a = n("WEpk"),
        r = n("uOPS"),
        i = n("zLkG"),
        l = n("2faE").f;
      e.exports = function (e) {
        var t = a.Symbol || (a.Symbol = r ? {} : o.Symbol || {});
        "_" == e.charAt(0) || e in t || l(t, e, { value: i.f(e) });
      };
    },
    a0xu: function (e, t) {
      var n = {}.toString;
      e.exports = function (e) {
        return n.call(e).slice(8, -1);
      };
    },
    aFXD: function (e, t, n) {
      e.exports = {
        "product-elevator": "style__product-elevator___191VM",
        "elevator-details": "style__elevator-details___n3VyO",
        "elevator-item": "style__elevator-item___2SXkY",
        "elevator-item-active": "style__elevator-item-active___1oZBv",
        "elevator-stop": "style__elevator-stop___3SUjz",
        "icon-line": "style__icon-line___2CemJ",
        "elevator-mode-circle": "style__elevator-mode-circle___1Z1Fn",
        "elevator-mode-dark": "style__elevator-mode-dark___20Qx3",
        "elevator-show": "style__elevator-show___1gArh",
        "elevator-mode-edit": "style__elevator-mode-edit___1rucl",
      };
    },
    aGtg: function (e, t, n) {
      "use strict";
      var o = n("q1tI"),
        a = n.n(o);
      t.a = function (e) {
        var t = e.prototype;
        if (!t || !t.isReactComponent)
          throw new Error("Can only polyfill class components");
        return "function" !== typeof t.componentWillReceiveProps
          ? e
          : a.a.Profiler
            ? ((t.UNSAFE_componentWillReceiveProps =
                t.componentWillReceiveProps),
              delete t.componentWillReceiveProps,
              e)
            : e;
      };
    },
    adOz: function (e, t, n) {
      n("Zxgi")("asyncIterator");
    },
    adU4: function (e, t, n) {
      var o = n("y1pI"),
        a = Array.prototype.splice;
      e.exports = function (e) {
        var t = this.__data__,
          n = o(t, e);
        return (
          !(n < 0) &&
          (n == t.length - 1 ? t.pop() : a.call(t, n, 1), --this.size, !0)
        );
      };
    },
    aiR1: function (e, t, n) {},
    aqq1: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = function (e) {
        return "number" === typeof e;
      };
    },
    "ar/p": function (e, t, n) {
      var o = n("5vMV"),
        a = n("FpHa").concat("length", "prototype");
      t.f =
        Object.getOwnPropertyNames ||
        function (e) {
          return o(e, a);
        };
    },
    atyN: function (e, t, n) {
      var o, a, r;
      "undefined" != typeof self && self,
        (e.exports =
          ((o = n("q1tI")),
          (a = n("17x9")),
          (r = n("TSYQ")),
          (function (e) {
            function t(o) {
              if (n[o]) return n[o].exports;
              var a = (n[o] = { i: o, l: !1, exports: {} });
              return (
                e[o].call(a.exports, a, a.exports, t), (a.l = !0), a.exports
              );
            }
            var n = {};
            return (
              (t.m = e),
              (t.c = n),
              (t.d = function (e, n, o) {
                t.o(e, n) ||
                  Object.defineProperty(e, n, {
                    configurable: !1,
                    enumerable: !0,
                    get: o,
                  });
              }),
              (t.n = function (e) {
                var n =
                  e && e.__esModule
                    ? function () {
                        return e.default;
                      }
                    : function () {
                        return e;
                      };
                return t.d(n, "a", n), n;
              }),
              (t.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }),
              (t.p = ""),
              t((t.s = 105))
            );
          })([
            function (e, t) {
              var n = (e.exports =
                "undefined" != typeof window && window.Math == Math
                  ? window
                  : "undefined" != typeof self && self.Math == Math
                    ? self
                    : Function("return this")());
              "number" == typeof __g && (__g = n);
            },
            function (e, t) {
              var n = (e.exports = { version: "2.5.3" });
              "number" == typeof __e && (__e = n);
            },
            function (e, t, n) {
              e.exports = !n(8)(function () {
                return (
                  7 !=
                  Object.defineProperty({}, "a", {
                    get: function () {
                      return 7;
                    },
                  }).a
                );
              });
            },
            function (e, t) {
              e.exports = function (e) {
                return "object" == typeof e
                  ? null !== e
                  : "function" == typeof e;
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(32),
                r = n(21),
                i = Object.defineProperty;
              t.f = n(2)
                ? Object.defineProperty
                : function (e, t, n) {
                    if ((o(e), (t = r(t, !0)), o(n), a))
                      try {
                        return i(e, t, n);
                      } catch (e) {}
                    if ("get" in n || "set" in n)
                      throw TypeError("Accessors not supported!");
                    return "value" in n && (e[t] = n.value), e;
                  };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e) {
                if (!o(e)) throw TypeError(e + " is not an object!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(35),
                a = n(30);
              e.exports = function (e) {
                return o(a(e));
              };
            },
            function (e, t) {
              var n = {}.hasOwnProperty;
              e.exports = function (e, t) {
                return n.call(e, t);
              };
            },
            function (e, t) {
              e.exports = function (e) {
                try {
                  return !!e();
                } catch (e) {
                  return !0;
                }
              };
            },
            function (e, t) {
              e.exports = o;
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(27),
                i = n(18),
                l = "prototype",
                s = function (e, t, n) {
                  var c,
                    _,
                    u,
                    d = e & s.F,
                    p = e & s.G,
                    f = e & s.S,
                    h = e & s.P,
                    m = e & s.B,
                    y = e & s.W,
                    b = p ? a : a[t] || (a[t] = {}),
                    v = b[l],
                    g = p ? o : f ? o[t] : (o[t] || {})[l];
                  for (c in (p && (n = t), n))
                    ((_ = !d && g && void 0 !== g[c]) && c in b) ||
                      ((u = _ ? g[c] : n[c]),
                      (b[c] =
                        p && "function" != typeof g[c]
                          ? n[c]
                          : m && _
                            ? r(u, o)
                            : y && g[c] == u
                              ? (function (e) {
                                  var t = function (t, n, o) {
                                    if (this instanceof e) {
                                      switch (arguments.length) {
                                        case 0:
                                          return new e();
                                        case 1:
                                          return new e(t);
                                        case 2:
                                          return new e(t, n);
                                      }
                                      return new e(t, n, o);
                                    }
                                    return e.apply(this, arguments);
                                  };
                                  return (t[l] = e[l]), t;
                                })(u)
                              : h && "function" == typeof u
                                ? r(Function.call, u)
                                : u),
                      h &&
                        (((b.virtual || (b.virtual = {}))[c] = u),
                        e & s.R && v && !v[c] && i(v, c, u)));
                };
              (s.F = 1),
                (s.G = 2),
                (s.S = 4),
                (s.P = 8),
                (s.B = 16),
                (s.W = 32),
                (s.U = 64),
                (s.R = 128),
                (e.exports = s);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22);
              e.exports =
                Object.keys ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t) {
              e.exports = a;
            },
            function (e, t, n) {
              e.exports = { default: n(49), __esModule: !0 };
            },
            function (e, t, n) {
              e.exports = { default: n(51), __esModule: !0 };
            },
            function (e, t) {
              t.f = {}.propertyIsEnumerable;
            },
            function (e, t, n) {
              e.exports = { default: n(57), __esModule: !0 };
            },
            function (e, t) {
              var n = 0,
                o = Math.random();
              e.exports = function (e) {
                return "Symbol(".concat(
                  void 0 === e ? "" : e,
                  ")_",
                  (++n + o).toString(36),
                );
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(20);
              e.exports = n(2)
                ? function (e, t, n) {
                    return o.f(e, t, a(1, n));
                  }
                : function (e, t, n) {
                    return (e[t] = n), e;
                  };
            },
            function (e, t, n) {
              var o = n(25)("wks"),
                a = n(17),
                r = n(0).Symbol,
                i = "function" == typeof r;
              (e.exports = function (e) {
                return (
                  o[e] || (o[e] = (i && r[e]) || (i ? r : a)("Symbol." + e))
                );
              }).store = o;
            },
            function (e, t) {
              e.exports = function (e, t) {
                return {
                  enumerable: !(1 & e),
                  configurable: !(2 & e),
                  writable: !(4 & e),
                  value: t,
                };
              };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e, t) {
                if (!o(e)) return e;
                var n, a;
                if (
                  t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
                  return a;
                if (
                  !t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                throw TypeError("Can't convert object to primitive value");
              };
            },
            function (e, t) {
              e.exports =
                "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                  ",",
                );
            },
            function (e, t) {
              e.exports = r;
            },
            function (e, t, n) {
              e.exports = { default: n(60), __esModule: !0 };
            },
            function (e, t, n) {
              var o = n(0),
                a = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
              e.exports = function (e) {
                return a[e] || (a[e] = {});
              };
            },
            function (e, t) {
              t.f = Object.getOwnPropertySymbols;
            },
            function (e, t, n) {
              var o = n(42);
              e.exports = function (e, t, n) {
                if ((o(e), void 0 === t)) return e;
                switch (n) {
                  case 1:
                    return function (n) {
                      return e.call(t, n);
                    };
                  case 2:
                    return function (n, o) {
                      return e.call(t, n, o);
                    };
                  case 3:
                    return function (n, o, a) {
                      return e.call(t, n, o, a);
                    };
                }
                return function () {
                  return e.apply(t, arguments);
                };
              };
            },
            function (e, t) {
              var n = Math.ceil,
                o = Math.floor;
              e.exports = function (e) {
                return isNaN((e = +e)) ? 0 : (e > 0 ? o : n)(e);
              };
            },
            function (e, t, n) {
              var o = n(25)("keys"),
                a = n(17);
              e.exports = function (e) {
                return o[e] || (o[e] = a(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if (void 0 == e) throw TypeError("Can't call method on  " + e);
                return e;
              };
            },
            function (e, t, n) {
              var o = n(3),
                a = n(0).document,
                r = o(a) && o(a.createElement);
              e.exports = function (e) {
                return r ? a.createElement(e) : {};
              };
            },
            function (e, t, n) {
              e.exports =
                !n(2) &&
                !n(8)(function () {
                  return (
                    7 !=
                    Object.defineProperty(n(31)("div"), "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
            },
            function (e, t) {
              var n = {}.toString;
              e.exports = function (e) {
                return n.call(e).slice(8, -1);
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(48),
                r = n(22),
                i = n(29)("IE_PROTO"),
                l = function () {},
                s = function () {
                  var e,
                    t = n(31)("iframe"),
                    o = r.length;
                  for (
                    t.style.display = "none",
                      n(44).appendChild(t),
                      t.src = "javascript:",
                      (e = t.contentWindow.document).open(),
                      e.write("<script>document.F=Object</script>"),
                      e.close(),
                      s = e.F;
                    o--;

                  )
                    delete s.prototype[r[o]];
                  return s();
                };
              e.exports =
                Object.create ||
                function (e, t) {
                  var n;
                  return (
                    null !== e
                      ? ((l.prototype = o(e)),
                        (n = new l()),
                        (l.prototype = null),
                        (n[i] = e))
                      : (n = s()),
                    void 0 === t ? n : a(n, t)
                  );
                };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports = Object("z").propertyIsEnumerable(0)
                ? Object
                : function (e) {
                    return "String" == o(e) ? e.split("") : Object(e);
                  };
            },
            function (e, t, n) {
              var o = n(7),
                a = n(6),
                r = n(46)(!1),
                i = n(29)("IE_PROTO");
              e.exports = function (e, t) {
                var n,
                  l = a(e),
                  s = 0,
                  c = [];
                for (n in l) n != i && o(l, n) && c.push(n);
                for (; t.length > s; )
                  o(l, (n = t[s++])) && (~r(c, n) || c.push(n));
                return c;
              };
            },
            function (e, t, n) {
              var o = n(15),
                a = n(20),
                r = n(6),
                i = n(21),
                l = n(7),
                s = n(32),
                c = Object.getOwnPropertyDescriptor;
              t.f = n(2)
                ? c
                : function (e, t) {
                    if (((e = r(e)), (t = i(t, !0)), s))
                      try {
                        return c(e, t);
                      } catch (e) {}
                    if (l(e, t)) return a(!o.f.call(e, t), e[t]);
                  };
            },
            function (e, t) {
              e.exports = !0;
            },
            function (e, t, n) {
              t.f = n(19);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22).concat("length", "prototype");
              t.f =
                Object.getOwnPropertyNames ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t, n) {
              var o = n(30);
              e.exports = function (e) {
                return Object(o(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if ("function" != typeof e)
                  throw TypeError(e + " is not a function!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.min;
              e.exports = function (e) {
                return e > 0 ? a(o(e), 9007199254740991) : 0;
              };
            },
            function (e, t, n) {
              var o = n(0).document;
              e.exports = o && o.documentElement;
            },
            function (e, t, n) {
              var o = n(4).f,
                a = n(7),
                r = n(19)("toStringTag");
              e.exports = function (e, t, n) {
                e &&
                  !a((e = n ? e : e.prototype), r) &&
                  o(e, r, { configurable: !0, value: t });
              };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(43),
                r = n(47);
              e.exports = function (e) {
                return function (t, n, i) {
                  var l,
                    s = o(t),
                    c = a(s.length),
                    _ = r(i, c);
                  if (e && n != n) {
                    for (; c > _; ) if ((l = s[_++]) != l) return !0;
                  } else
                    for (; c > _; _++)
                      if ((e || _ in s) && s[_] === n) return e || _ || 0;
                  return !e && -1;
                };
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.max,
                r = Math.min;
              e.exports = function (e, t) {
                return (e = o(e)) < 0 ? a(e + t, 0) : r(e, t);
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(5),
                r = n(11);
              e.exports = n(2)
                ? Object.defineProperties
                : function (e, t) {
                    a(e);
                    for (var n, i = r(t), l = i.length, s = 0; l > s; )
                      o.f(e, (n = i[s++]), t[n]);
                    return e;
                  };
            },
            function (e, t, n) {
              n(50);
              var o = n(1).Object;
              e.exports = function (e, t) {
                return o.create(e, t);
              };
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { create: n(34) });
            },
            function (e, t, n) {
              n(52), (e.exports = n(1).Object.setPrototypeOf);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { setPrototypeOf: n(53).set });
            },
            function (e, t, n) {
              var o = n(3),
                a = n(5),
                r = function (e, t) {
                  if ((a(e), !o(t) && null !== t))
                    throw TypeError(t + ": can't set as prototype!");
                };
              e.exports = {
                set:
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function (e, t, o) {
                        try {
                          (o = n(27)(
                            Function.call,
                            n(37).f(Object.prototype, "__proto__").set,
                            2,
                          ))(e, []),
                            (t = !(e instanceof Array));
                        } catch (e) {
                          t = !0;
                        }
                        return function (e, n) {
                          return r(e, n), t ? (e.__proto__ = n) : o(e, n), e;
                        };
                      })({}, !1)
                    : void 0),
                check: r,
              };
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(38),
                i = n(39),
                l = n(4).f;
              e.exports = function (e) {
                var t = a.Symbol || (a.Symbol = r ? {} : o.Symbol || {});
                "_" == e.charAt(0) || e in t || l(t, e, { value: i.f(e) });
              };
            },
            function (e, t, n) {
              e.exports = n(18);
            },
            function (e, t, n) {
              "use strict";
              var o = n(0),
                a = n(7),
                r = n(2),
                i = n(10),
                l = n(55),
                s = n(61).KEY,
                c = n(8),
                _ = n(25),
                u = n(45),
                d = n(17),
                p = n(19),
                f = n(39),
                h = n(54),
                m = n(62),
                y = n(63),
                b = n(5),
                v = n(3),
                g = n(6),
                w = n(21),
                x = n(20),
                k = n(34),
                O = n(64),
                I = n(37),
                S = n(4),
                j = n(11),
                T = I.f,
                C = S.f,
                M = O.f,
                P = o.Symbol,
                E = o.JSON,
                L = E && E.stringify,
                B = "prototype",
                N = p("_hidden"),
                D = p("toPrimitive"),
                z = {}.propertyIsEnumerable,
                A = _("symbol-registry"),
                R = _("symbols"),
                F = _("op-symbols"),
                V = Object[B],
                H = "function" == typeof P,
                W = o.QObject,
                U = !W || !W[B] || !W[B].findChild,
                G =
                  r &&
                  c(function () {
                    return (
                      7 !=
                      k(
                        C({}, "a", {
                          get: function () {
                            return C(this, "a", { value: 7 }).a;
                          },
                        }),
                      ).a
                    );
                  })
                    ? function (e, t, n) {
                        var o = T(V, t);
                        o && delete V[t],
                          C(e, t, n),
                          o && e !== V && C(V, t, o);
                      }
                    : C,
                Y = function (e) {
                  var t = (R[e] = k(P[B]));
                  return (t._k = e), t;
                },
                q =
                  H && "symbol" == typeof P.iterator
                    ? function (e) {
                        return "symbol" == typeof e;
                      }
                    : function (e) {
                        return e instanceof P;
                      },
                X = function (e, t, n) {
                  return (
                    e === V && X(F, t, n),
                    b(e),
                    (t = w(t, !0)),
                    b(n),
                    a(R, t)
                      ? (n.enumerable
                          ? (a(e, N) && e[N][t] && (e[N][t] = !1),
                            (n = k(n, { enumerable: x(0, !1) })))
                          : (a(e, N) || C(e, N, x(1, {})), (e[N][t] = !0)),
                        G(e, t, n))
                      : C(e, t, n)
                  );
                },
                Z = function (e, t) {
                  b(e);
                  for (var n, o = m((t = g(t))), a = 0, r = o.length; r > a; )
                    X(e, (n = o[a++]), t[n]);
                  return e;
                },
                K = function (e) {
                  var t = z.call(this, (e = w(e, !0)));
                  return (
                    !(this === V && a(R, e) && !a(F, e)) &&
                    (!(
                      t ||
                      !a(this, e) ||
                      !a(R, e) ||
                      (a(this, N) && this[N][e])
                    ) ||
                      t)
                  );
                },
                Q = function (e, t) {
                  if (
                    ((e = g(e)), (t = w(t, !0)), e !== V || !a(R, t) || a(F, t))
                  ) {
                    var n = T(e, t);
                    return (
                      !n ||
                        !a(R, t) ||
                        (a(e, N) && e[N][t]) ||
                        (n.enumerable = !0),
                      n
                    );
                  }
                },
                J = function (e) {
                  for (var t, n = M(g(e)), o = [], r = 0; n.length > r; )
                    a(R, (t = n[r++])) || t == N || t == s || o.push(t);
                  return o;
                },
                $ = function (e) {
                  for (
                    var t, n = e === V, o = M(n ? F : g(e)), r = [], i = 0;
                    o.length > i;

                  )
                    !a(R, (t = o[i++])) || (n && !a(V, t)) || r.push(R[t]);
                  return r;
                };
              H ||
                (l(
                  (P = function () {
                    if (this instanceof P)
                      throw TypeError("Symbol is not a constructor!");
                    var e = d(arguments.length > 0 ? arguments[0] : void 0),
                      t = function (n) {
                        this === V && t.call(F, n),
                          a(this, N) && a(this[N], e) && (this[N][e] = !1),
                          G(this, e, x(1, n));
                      };
                    return (
                      r && U && G(V, e, { configurable: !0, set: t }), Y(e)
                    );
                  })[B],
                  "toString",
                  function () {
                    return this._k;
                  },
                ),
                (I.f = Q),
                (S.f = X),
                (n(40).f = O.f = J),
                (n(15).f = K),
                (n(26).f = $),
                r && !n(38) && l(V, "propertyIsEnumerable", K, !0),
                (f.f = function (e) {
                  return Y(p(e));
                })),
                i(i.G + i.W + i.F * !H, { Symbol: P });
              for (
                var ee =
                    "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
                      ",",
                    ),
                  te = 0;
                ee.length > te;

              )
                p(ee[te++]);
              for (var ne = j(p.store), oe = 0; ne.length > oe; ) h(ne[oe++]);
              i(i.S + i.F * !H, "Symbol", {
                for: function (e) {
                  return a(A, (e += "")) ? A[e] : (A[e] = P(e));
                },
                keyFor: function (e) {
                  if (!q(e)) throw TypeError(e + " is not a symbol!");
                  for (var t in A) if (A[t] === e) return t;
                },
                useSetter: function () {
                  U = !0;
                },
                useSimple: function () {
                  U = !1;
                },
              }),
                i(i.S + i.F * !H, "Object", {
                  create: function (e, t) {
                    return void 0 === t ? k(e) : Z(k(e), t);
                  },
                  defineProperty: X,
                  defineProperties: Z,
                  getOwnPropertyDescriptor: Q,
                  getOwnPropertyNames: J,
                  getOwnPropertySymbols: $,
                }),
                E &&
                  i(
                    i.S +
                      i.F *
                        (!H ||
                          c(function () {
                            var e = P();
                            return (
                              "[null]" != L([e]) ||
                              "{}" != L({ a: e }) ||
                              "{}" != L(Object(e))
                            );
                          })),
                    "JSON",
                    {
                      stringify: function (e) {
                        for (var t, n, o = [e], a = 1; arguments.length > a; )
                          o.push(arguments[a++]);
                        if (((n = t = o[1]), (v(t) || void 0 !== e) && !q(e)))
                          return (
                            y(t) ||
                              (t = function (e, t) {
                                if (
                                  ("function" == typeof n &&
                                    (t = n.call(this, e, t)),
                                  !q(t))
                                )
                                  return t;
                              }),
                            (o[1] = t),
                            L.apply(E, o)
                          );
                      },
                    },
                  ),
                P[B][D] || n(18)(P[B], D, P[B].valueOf),
                u(P, "Symbol"),
                u(Math, "Math", !0),
                u(o.JSON, "JSON", !0);
            },
            function (e, t, n) {
              n(58), (e.exports = n(1).Object.assign);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S + o.F, "Object", { assign: n(59) });
            },
            function (e, t, n) {
              "use strict";
              var o = n(11),
                a = n(26),
                r = n(15),
                i = n(41),
                l = n(35),
                s = Object.assign;
              e.exports =
                !s ||
                n(8)(function () {
                  var e = {},
                    t = {},
                    n = Symbol(),
                    o = "abcdefghijklmnopqrst";
                  return (
                    (e[n] = 7),
                    o.split("").forEach(function (e) {
                      t[e] = e;
                    }),
                    7 != s({}, e)[n] || Object.keys(s({}, t)).join("") != o
                  );
                })
                  ? function (e, t) {
                      for (
                        var n = i(e),
                          s = arguments.length,
                          c = 1,
                          _ = a.f,
                          u = r.f;
                        s > c;

                      )
                        for (
                          var d,
                            p = l(arguments[c++]),
                            f = _ ? o(p).concat(_(p)) : o(p),
                            h = f.length,
                            m = 0;
                          h > m;

                        )
                          u.call(p, (d = f[m++])) && (n[d] = p[d]);
                      return n;
                    }
                  : s;
            },
            function (e, t, n) {
              n(56), (e.exports = n(1).Object.getOwnPropertySymbols);
            },
            function (e, t, n) {
              var o = n(17)("meta"),
                a = n(3),
                r = n(7),
                i = n(4).f,
                l = 0,
                s =
                  Object.isExtensible ||
                  function () {
                    return !0;
                  },
                c = !n(8)(function () {
                  return s(Object.preventExtensions({}));
                }),
                _ = function (e) {
                  i(e, o, { value: { i: "O" + ++l, w: {} } });
                },
                u = (e.exports = {
                  KEY: o,
                  NEED: !1,
                  fastKey: function (e, t) {
                    if (!a(e))
                      return "symbol" == typeof e
                        ? e
                        : ("string" == typeof e ? "S" : "P") + e;
                    if (!r(e, o)) {
                      if (!s(e)) return "F";
                      if (!t) return "E";
                      _(e);
                    }
                    return e[o].i;
                  },
                  getWeak: function (e, t) {
                    if (!r(e, o)) {
                      if (!s(e)) return !0;
                      if (!t) return !1;
                      _(e);
                    }
                    return e[o].w;
                  },
                  onFreeze: function (e) {
                    return c && u.NEED && s(e) && !r(e, o) && _(e), e;
                  },
                });
            },
            function (e, t, n) {
              var o = n(11),
                a = n(26),
                r = n(15);
              e.exports = function (e) {
                var t = o(e),
                  n = a.f;
                if (n)
                  for (var i, l = n(e), s = r.f, c = 0; l.length > c; )
                    s.call(e, (i = l[c++])) && t.push(i);
                return t;
              };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports =
                Array.isArray ||
                function (e) {
                  return "Array" == o(e);
                };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(40).f,
                r = {}.toString,
                i =
                  "object" == typeof window &&
                  window &&
                  Object.getOwnPropertyNames
                    ? Object.getOwnPropertyNames(window)
                    : [];
              e.exports.f = function (e) {
                return i && "[object Window]" == r.call(e)
                  ? (function (e) {
                      try {
                        return a(e);
                      } catch (e) {
                        return i.slice();
                      }
                    })(e)
                  : a(o(e));
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = a(n(71)),
                p = o(n(73)),
                f = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                h =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                m = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                y = n(74),
                b = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    f(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        n = e.name,
                        o = e.className,
                        a = m(e, ["name", "className"]),
                        r = (0, u.default)(
                          (p || {})["" + t.classNamePrefix + n],
                          o,
                        );
                      return c.createElement(
                        d.default,
                        h({ className: r, fontFamily: y.fontFamily }, a),
                      );
                    }),
                    (t.classNamePrefix = "icon-"),
                    (t.propTypes = {
                      name: _.default.string.isRequired,
                      spin: _.default.bool,
                      className: _.default.string,
                    }),
                    t
                  );
                })(c.PureComponent);
              t.default = b;
            },
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = o(n(72)),
                p = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                m = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    p(t, e),
                    (t.prototype.render = function () {
                      var e,
                        t = this.props,
                        n = t.className,
                        o = t.fontFamily,
                        a = t.style,
                        r = t.spin,
                        l = h(t, ["className", "fontFamily", "style", "spin"]),
                        s = (0, u.default)(
                          n,
                          d.icon,
                          (((e = {})[d.spin] = !!r), e),
                        ),
                        _ = (0, i.default)({}, a, { fontFamily: o });
                      return c.createElement(
                        "i",
                        f({ className: s, style: _ }, l),
                      );
                    }),
                    (t.propTypes = {
                      classNames: _.default.object,
                      fontFamily: _.default.string,
                      spin: _.default.bool,
                    }),
                    (t.defaultProps = { fontFamily: "iconfont" }),
                    t
                  );
                })(c.PureComponent);
              t.default = m;
            },
            function (e, t) {
              e.exports = {
                icon: "_3c0Qz",
                spin: "_1j2v0",
                "icon-spin": "-lu88",
                iconSpin: "-lu88",
              };
            },
            function (e, t) {
              e.exports = {
                "icon-address-book": "_35bgc",
                iconAddressBook: "_35bgc",
                "icon-address-card": "byXrR",
                iconAddressCard: "byXrR",
                "icon-adjust": "_128ri",
                iconAdjust: "_128ri",
                "icon-check-alt-light": "_1KHsi",
                iconCheckAltLight: "_1KHsi",
                "icon-coins-light": "_2bT-Y",
                iconCoinsLight: "_2bT-Y",
                "icon-exclamation-circle-light": "_3UEZX",
                iconExclamationCircleLight: "_3UEZX",
                "icon-loading-alt-light": "_1fXKU",
                iconLoadingAltLight: "_1fXKU",
                "icon-instagram": "_2OZ_n",
                iconInstagram: "_2OZ_n",
                "icon-minus-light": "_6cr8a",
                iconMinusLight: "_6cr8a",
                "icon-ticket-alt": "ZAGKa",
                iconTicketAlt: "ZAGKa",
                "icon-ticket-alt-light": "_1lH5w",
                iconTicketAltLight: "_1lH5w",
                "icon-plus-light": "_3BSr4",
                iconPlusLight: "_3BSr4",
                "icon-truck": "_4wlbR",
                iconTruck: "_4wlbR",
                "icon-trash-alt-light": "_26SUY",
                iconTrashAltLight: "_26SUY",
                "icon-times-circle": "_30-mD",
                iconTimesCircle: "_30-mD",
                "icon-vimeo-v": "_1_xvC",
                iconVimeoV: "_1_xvC",
                "icon-twitter": "_17P2f",
                iconTwitter: "_17P2f",
                "icon-youtube": "_2I_EY",
                iconYoutube: "_2I_EY",
                "icon-caret-down": "_3qb3s",
                iconCaretDown: "_3qb3s",
                "icon-caret-up": "_2jwD5",
                iconCaretUp: "_2jwD5",
                "icon-comments-o": "_19X43",
                iconCommentsO: "_19X43",
                "icon-download-o": "_2WwM4",
                iconDownloadO: "_2WwM4",
                "icon-info-circle-o": "_1shcg",
                iconInfoCircleO: "_1shcg",
                "icon-external-link-o": "_1qLWd",
                iconExternalLinkO: "_1qLWd",
                "icon-globe-o": "Z8Prc",
                iconGlobeO: "Z8Prc",
                "icon-question-o": "_3MItB",
                iconQuestionO: "_3MItB",
                "icon-play-circle-o": "_2Bvn6",
                iconPlayCircleO: "_2Bvn6",
                "icon-angle-double-left": "_3IVo_",
                iconAngleDoubleLeft: "_3IVo_",
                "icon-angle-down": "_34FGS",
                iconAngleDown: "_34FGS",
                "icon-angle-double-right": "_3e62_",
                iconAngleDoubleRight: "_3e62_",
                "icon-angle-left": "_1zbhS",
                iconAngleLeft: "_1zbhS",
                "icon-angle-right": "_27RtX",
                iconAngleRight: "_27RtX",
                "icon-angle-up": "jhfcy",
                iconAngleUp: "jhfcy",
                "icon-arrival-reminder": "Q82xM",
                iconArrivalReminder: "Q82xM",
                "icon-ban": "_1vyf0",
                iconBan: "_1vyf0",
                "icon-bullhorn": "B0IHZ",
                iconBullhorn: "B0IHZ",
                "icon-bars": "_2cpQ_",
                iconBars: "_2cpQ_",
                "icon-caret-left-o": "_2FImd",
                iconCaretLeftO: "_2FImd",
                "icon-caret-down-o": "_3wXJB",
                iconCaretDownO: "_3wXJB",
                "icon-caret-right-o": "_2fXyR",
                iconCaretRightO: "_2fXyR",
                "icon-caret-up-o": "_2KLCQ",
                iconCaretUpO: "_2KLCQ",
                "icon-cart": "_-4DAY",
                iconCart: "_-4DAY",
                "icon-certificate": "_2I4g3",
                iconCertificate: "_2I4g3",
                "icon-check-circle-o": "_1m5z7",
                iconCheckCircleO: "_1m5z7",
                "icon-check-square-o": "_1vR3p",
                iconCheckSquareO: "_1vR3p",
                "icon-check": "_2LJ7o",
                iconCheck: "_2LJ7o",
                "icon-circle-notch": "_3AQSX",
                iconCircleNotch: "_3AQSX",
                "icon-clock": "_3ASBw",
                iconClock: "_3ASBw",
                "icon-cog": "_6eszT",
                iconCog: "_6eszT",
                "icon-cloud-upload": "_1WxHW",
                iconCloudUpload: "_1WxHW",
                "icon-coins": "_2uv1U",
                iconCoins: "_2uv1U",
                "icon-compare": "_3s-NW",
                iconCompare: "_3s-NW",
                "icon-comment-alt-smile": "_1ZzVY",
                iconCommentAltSmile: "_1ZzVY",
                "icon-copy": "OBwuW",
                iconCopy: "OBwuW",
                "icon-compress": "_2Ri-k",
                iconCompress: "_2Ri-k",
                "icon-coupon": "_1588m",
                iconCoupon: "_1588m",
                "icon-credit-card": "_2uIqb",
                iconCreditCard: "_2uIqb",
                "icon-download": "_1P5xZ",
                iconDownload: "_1P5xZ",
                "icon-edit": "_2iuBX",
                iconEdit: "_2iuBX",
                "icon-ellipsis-h": "_1exha",
                iconEllipsisH: "_1exha",
                "icon-education": "_3bokS",
                iconEducation: "_3bokS",
                "icon-envelope": "vMM-Y",
                iconEnvelope: "vMM-Y",
                "icon-ellipsis-v": "_3jZwp",
                iconEllipsisV: "_3jZwp",
                "icon-exclamation-circle": "_2SUQ-",
                iconExclamationCircle: "_2SUQ-",
                "icon-exclamation": "_1Piil",
                iconExclamation: "_1Piil",
                "icon-exclamation-square": "_20oXE",
                iconExclamationSquare: "_20oXE",
                "icon-external-link": "_2gTe8",
                iconExternalLink: "_2gTe8",
                "icon-expand": "okv_Y",
                iconExpand: "okv_Y",
                "icon-eye": "_3l-6g",
                iconEye: "_3l-6g",
                "icon-file-alt": "OhY9C",
                iconFileAlt: "OhY9C",
                "icon-facebook": "Cb5jY",
                iconFacebook: "Cb5jY",
                "icon-file": "_1ajFe",
                iconFile: "_1ajFe",
                "icon-file-pdf": "ve2KQ",
                iconFilePdf: "ve2KQ",
                "icon-frame": "_3OU3j",
                iconFrame: "_3OU3j",
                "icon-globe": "lgV2x",
                iconGlobe: "lgV2x",
                "icon-headset": "_1gQtG",
                iconHeadset: "_1gQtG",
                "icon-heart-o": "_3Zaag",
                iconHeartO: "_3Zaag",
                "icon-home": "_33jTA",
                iconHome: "_33jTA",
                "icon-image-view": "_1jJbn",
                iconImageView: "_1jJbn",
                "icon-info-square": "UuxAk",
                iconInfoSquare: "UuxAk",
                "icon-info-circle": "_1OEuY",
                iconInfoCircle: "_1OEuY",
                "icon-info": "Lm_MF",
                iconInfo: "Lm_MF",
                "icon-language": "_3LwbN",
                iconLanguage: "_3LwbN",
                "icon-link": "_2XN05",
                iconLink: "_2XN05",
                "icon-list-view": "_33OcX",
                iconListView: "_33OcX",
                "icon-location-arrow": "bMc_E",
                iconLocationArrow: "bMc_E",
                "icon-list": "IAlEP",
                iconList: "IAlEP",
                "icon-location": "_25GQ2",
                iconLocation: "_25GQ2",
                "icon-lock-alt": "_3t3HT",
                iconLockAlt: "_3t3HT",
                "icon-map-marked-alt": "_2W_XA",
                iconMapMarkedAlt: "_2W_XA",
                "icon-map-marker-alt": "_3NPLS",
                iconMapMarkerAlt: "_3NPLS",
                "icon-minus": "UhwjW",
                iconMinus: "UhwjW",
                "icon-paperclip": "_2hDpl",
                iconPaperclip: "_2hDpl",
                "icon-order": "dCZz2",
                iconOrder: "dCZz2",
                "icon-play-circle": "_1FMUV",
                iconPlayCircle: "_1FMUV",
                "icon-phone": "_2H8bj",
                iconPhone: "_2H8bj",
                "icon-plus": "_3KkpT",
                iconPlus: "_3KkpT",
                "icon-purchase": "_23p5a",
                iconPurchase: "_23p5a",
                "icon-question-circle": "_18A_e",
                iconQuestionCircle: "_18A_e",
                "icon-qrcode": "gf_rb",
                iconQrcode: "gf_rb",
                "icon-search-minus": "_1Djb6",
                iconSearchMinus: "_1Djb6",
                "icon-search": "_3d-6G",
                iconSearch: "_3d-6G",
                "icon-setup": "_1fawl",
                iconSetup: "_1fawl",
                "icon-search-plus": "_20uY7",
                iconSearchPlus: "_20uY7",
                "icon-tag": "_2Z6dE",
                iconTag: "_2Z6dE",
                "icon-share": "_1c3Qh",
                iconShare: "_1c3Qh",
                "icon-times-circle-o": "_1GlZx",
                iconTimesCircleO: "_1GlZx",
                "icon-times": "_3hG3b",
                iconTimes: "_3hG3b",
                "icon-times-square-o": "_15wCJ",
                iconTimesSquareO: "_15wCJ",
                "icon-trash-alt": "_1Rw_U",
                iconTrashAlt: "_1Rw_U",
                "icon-truck-moving": "_2Jlwc",
                iconTruckMoving: "_2Jlwc",
                "icon-unfold": "_1bahP",
                iconUnfold: "_1bahP",
                "icon-unlock-alt": "_27Nd-",
                iconUnlockAlt: "_27Nd-",
                "icon-user": "_3To44",
                iconUser: "_3To44",
                "icon-users": "_1O_Hy",
                iconUsers: "_1O_Hy",
                "icon-video": "W6H_f",
                iconVideo: "W6H_f",
                "icon-fa-light-redo": "_2_sls",
                iconFaLightRedo: "_2_sls",
                "icon-fa-solid-play": "_35BGQ",
                iconFaSolidPlay: "_35BGQ",
                "icon-download-black-main": "_3xfLM",
                iconDownloadBlackMain: "_3xfLM",
                "icon-plus-circle": "_1pvYF",
                iconPlusCircle: "_1pvYF",
              };
            },
            function (e, t) {
              e.exports = {
                icons: [
                  { name: "address-book", unicode: "f2b9" },
                  { name: "address-card", unicode: "f2bb" },
                  { name: "adjust", unicode: "f042" },
                  { name: "check-alt-light", unicode: "e917" },
                  { name: "coins-light", unicode: "e348" },
                  { name: "exclamation-circle-light", unicode: "eca2" },
                  { name: "loading-alt-light", unicode: "ee57" },
                  { name: "instagram", unicode: "f16d" },
                  { name: "minus-light", unicode: "e719" },
                  { name: "ticket-alt", unicode: "f3ff" },
                  { name: "ticket-alt-light", unicode: "ebad" },
                  { name: "plus-light", unicode: "e8b5" },
                  { name: "truck", unicode: "f0d1" },
                  { name: "trash-alt-light", unicode: "e3a8" },
                  { name: "times-circle", unicode: "f057" },
                  { name: "vimeo-v", unicode: "f27d" },
                  { name: "twitter", unicode: "f099" },
                  { name: "youtube", unicode: "f167" },
                  { name: "caret-down", unicode: "f0d7" },
                  { name: "caret-up", unicode: "f0d8" },
                  { name: "comments-o", unicode: "ecde" },
                  { name: "download-o", unicode: "e6c0" },
                  { name: "info-circle-o", unicode: "ed3f" },
                  { name: "external-link-o", unicode: "ebd6" },
                  { name: "globe-o", unicode: "efe0" },
                  { name: "question-o", unicode: "e65f" },
                  { name: "play-circle-o", unicode: "e0ca" },
                  { name: "angle-double-left", unicode: "f100" },
                  { name: "angle-down", unicode: "f107" },
                  { name: "angle-double-right", unicode: "f101" },
                  { name: "angle-left", unicode: "f104" },
                  { name: "angle-right", unicode: "f105" },
                  { name: "angle-up", unicode: "f106" },
                  { name: "arrival-reminder", unicode: "e386" },
                  { name: "ban", unicode: "f05e" },
                  { name: "bullhorn", unicode: "f0a1" },
                  { name: "bars", unicode: "f0c9" },
                  { name: "caret-left-o", unicode: "eb68" },
                  { name: "caret-down-o", unicode: "ec02" },
                  { name: "caret-right-o", unicode: "ef8e" },
                  { name: "caret-up-o", unicode: "edd8" },
                  { name: "cart", unicode: "e540" },
                  { name: "certificate", unicode: "f0a3" },
                  { name: "check-circle-o", unicode: "e753" },
                  { name: "check-square-o", unicode: "ee6b" },
                  { name: "check", unicode: "f00c" },
                  { name: "circle-notch", unicode: "f1ce" },
                  { name: "clock", unicode: "f017" },
                  { name: "cog", unicode: "f013" },
                  { name: "cloud-upload", unicode: "f0ee" },
                  { name: "coins", unicode: "e688" },
                  { name: "compare", unicode: "e1f8" },
                  { name: "comment-alt-smile", unicode: "e7e4" },
                  { name: "copy", unicode: "f0c5" },
                  { name: "compress", unicode: "f066" },
                  { name: "coupon", unicode: "ed6e" },
                  { name: "credit-card", unicode: "f09d" },
                  { name: "download", unicode: "f019" },
                  { name: "edit", unicode: "f044" },
                  { name: "ellipsis-h", unicode: "f141" },
                  { name: "education", unicode: "ed0b" },
                  { name: "envelope", unicode: "f0e0" },
                  { name: "ellipsis-v", unicode: "f142" },
                  { name: "exclamation-circle", unicode: "f06a" },
                  { name: "exclamation", unicode: "f12a" },
                  { name: "exclamation-square", unicode: "f321" },
                  { name: "external-link", unicode: "f08e" },
                  { name: "expand", unicode: "f065" },
                  { name: "eye", unicode: "f06e" },
                  { name: "file-alt", unicode: "f15c" },
                  { name: "facebook", unicode: "f09a" },
                  { name: "file", unicode: "f15b" },
                  { name: "file-pdf", unicode: "f1c1" },
                  { name: "frame", unicode: "edcf" },
                  { name: "globe", unicode: "f0ac" },
                  { name: "headset", unicode: "e902" },
                  { name: "heart-o", unicode: "ee55" },
                  { name: "home", unicode: "f015" },
                  { name: "image-view", unicode: "e348" },
                  { name: "info-square", unicode: "f30f" },
                  { name: "info-circle", unicode: "f05a" },
                  { name: "info", unicode: "f129" },
                  { name: "language", unicode: "f1ab" },
                  { name: "link", unicode: "f0c1" },
                  { name: "list-view", unicode: "e8c1" },
                  { name: "location-arrow", unicode: "f124" },
                  { name: "list", unicode: "f03a" },
                  { name: "location", unicode: "ed51" },
                  { name: "lock-alt", unicode: "f30d" },
                  { name: "map-marked-alt", unicode: "ee36" },
                  { name: "map-marker-alt", unicode: "f3c5" },
                  { name: "minus", unicode: "f068" },
                  { name: "paperclip", unicode: "f0c6" },
                  { name: "order", unicode: "e70a" },
                  { name: "play-circle", unicode: "f144" },
                  { name: "phone", unicode: "f095" },
                  { name: "plus", unicode: "f067" },
                  { name: "purchase", unicode: "e85d" },
                  { name: "question-circle", unicode: "f059" },
                  { name: "qrcode", unicode: "f029" },
                  { name: "search-minus", unicode: "f010" },
                  { name: "search", unicode: "f002" },
                  { name: "setup", unicode: "ea0f" },
                  { name: "search-plus", unicode: "f00e" },
                  { name: "tag", unicode: "f02b" },
                  { name: "share", unicode: "f064" },
                  { name: "times-circle-o", unicode: "e200" },
                  { name: "times", unicode: "f00d" },
                  { name: "times-square-o", unicode: "eea2" },
                  { name: "trash-alt", unicode: "f2ed" },
                  { name: "truck-moving", unicode: "eaaa" },
                  { name: "unfold", unicode: "e872" },
                  { name: "unlock-alt", unicode: "f13e" },
                  { name: "user", unicode: "f007" },
                  { name: "users", unicode: "f0c0" },
                  { name: "video", unicode: "f03d" },
                  { name: "fa-light-redo", unicode: "e087" },
                  { name: "fa-solid-play", unicode: "e665" },
                  { name: "download-black-main", unicode: "e111" },
                  { name: "plus-circle", unicode: "f055" },
                ],
                total: 120,
                cssPrefix: "icon-",
                fontFamily: "quark",
              };
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                c = o(n(12)),
                _ = o(n(65)),
                u = o(n(114)),
                d = o(n(116)),
                p = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                m = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    p(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        t = e.children,
                        n = e.loading,
                        o = e.icon,
                        a = h(e, ["children", "loading", "icon"]),
                        r = o || n;
                      return s.createElement(
                        u.default,
                        f({ loading: n }, a),
                        r
                          ? s.createElement(_.default, {
                              className: d.default.icon,
                              name: "" + (n ? "circle-notch" : o),
                              spin: !!n,
                            })
                          : null,
                        t,
                      );
                    }),
                    (t.propTypes = {
                      block: c.default.bool,
                      htmlType: c.default.string,
                      loading: c.default.bool,
                      icon: c.default.string,
                      square: c.default.bool,
                      radius: c.default.oneOf(["large", "small", "none"]),
                      size: c.default.oneOf([
                        "huge",
                        "large",
                        "medium",
                        "small",
                        "mini",
                      ]),
                      type: c.default.oneOf([
                        "brand",
                        "dark-bordered",
                        "special",
                        "default",
                        "primary",
                        "danger",
                        "warning",
                        "success",
                        "ghost",
                      ]),
                    }),
                    t
                  );
                })(s.Component);
              t.default = m;
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                c = o(n(12)),
                _ = o(n(23)),
                u = o(n(115)),
                d = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                p =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                f = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                h = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    d(t, e),
                    (t.prototype.clickable = function () {
                      var e = this.props,
                        t = e.disabled,
                        n = e.loading;
                      return !t && !n;
                    }),
                    (t.prototype.render = function () {
                      var e,
                        t = this.props,
                        n = t.block,
                        o = t.children,
                        a = t.className,
                        r = t.htmlType,
                        i = t.loading,
                        l = t.disabled,
                        c = t.square,
                        d = t.radius,
                        h = t.size,
                        m = t.type,
                        y = f(t, [
                          "block",
                          "children",
                          "className",
                          "htmlType",
                          "loading",
                          "disabled",
                          "square",
                          "radius",
                          "size",
                          "type",
                        ]),
                        b = m || "default",
                        v = h || "medium",
                        g = d || "small",
                        w = (0, _.default)(
                          u.default.btn,
                          u.default["btn-" + b],
                          u.default["btn-radius-" + g],
                          u.default["btn-size-" + v],
                          (((e = {})[u.default["btn-square"]] = c),
                          (e[u.default["btn-block"]] = n),
                          (e[u.default["btn-loading"]] = i),
                          e),
                          a,
                        );
                      return s.createElement(
                        "button",
                        p({ type: r, className: w, disabled: l || i }, y),
                        o,
                      );
                    }),
                    (t.propTypes = {
                      block: c.default.bool,
                      htmlType: c.default.string,
                      loading: c.default.bool,
                      square: c.default.bool,
                      radius: c.default.oneOf(["large", "small", "none"]),
                      size: c.default.oneOf([
                        "huge",
                        "large",
                        "medium",
                        "small",
                        "mini",
                      ]),
                      type: c.default.oneOf([
                        "brand",
                        "dark-bordered",
                        "special",
                        "default",
                        "primary",
                        "danger",
                        "warning",
                        "success",
                        "ghost",
                      ]),
                    }),
                    (t.defaultProps = { loading: !1 }),
                    t
                  );
                })(s.PureComponent);
              t.default = h;
            },
            function (e, t) {
              e.exports = {
                icon: "_3TvKd",
                btn: "xnv6R",
                focus: "_3e-BG",
                "btn-block": "_3RO_K",
                btnBlock: "_3RO_K",
                "btn-brand": "_19X_H",
                btnBrand: "_19X_H",
                "btn-dark-bordered": "_8oCtR",
                btnDarkBordered: "_8oCtR",
                "btn-special": "_1bpad",
                btnSpecial: "_1bpad",
                "btn-default": "_27-6k",
                btnDefault: "_27-6k",
                "btn-primary": "_2QwEc",
                btnPrimary: "_2QwEc",
                "btn-danger": "_3IIr-",
                btnDanger: "_3IIr-",
                "btn-success": "_16fYW",
                btnSuccess: "_16fYW",
                "btn-warning": "upL7u",
                btnWarning: "upL7u",
                "btn-ghost": "_3oax7",
                btnGhost: "_3oax7",
                "btn-radius-large": "_958V1",
                btnRadiusLarge: "_958V1",
                "btn-radius-small": "_22qIt",
                btnRadiusSmall: "_22qIt",
                "btn-radius-none": "mrbT4",
                btnRadiusNone: "mrbT4",
                "btn-size-huge": "_1i5fk",
                btnSizeHuge: "_1i5fk",
                "btn-square": "_1FsY1",
                btnSquare: "_1FsY1",
                "btn-size-large": "p8s4W",
                btnSizeLarge: "p8s4W",
                "btn-size-medium": "_27-yu",
                btnSizeMedium: "_27-yu",
                "btn-size-small": "_2ghvt",
                btnSizeSmall: "_2ghvt",
                "btn-size-mini": "_21L3I",
                btnSizeMini: "_21L3I",
                "btn-loading": "_1wazg",
                btnLoading: "_1wazg",
              };
            },
            function (e, t) {
              e.exports = { icon: "j7iyJ" };
            },
          ])));
    },
    "b+vk": function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("iKuz"),
        u = n.n(_),
        d = n("q1tI"),
        p = n.n(d),
        f = n("XnI8"),
        h = (n("YZ1+"), n("/MKj")),
        m = n("hKI/"),
        y = n.n(m),
        b = n("yWgo"),
        v = n("TSYQ"),
        g = n.n(v),
        w = n("u11H"),
        x = n("XrJB"),
        k = n.n(x),
        O = (n("aiR1"), n("atyN")),
        I = n.n(O),
        S = (n("VsOx"), n("b/8j")),
        j = n.n(S),
        T = (n("3/+E"), n("ISdw")),
        C = n("Lu0/"),
        M = n("2OhW"),
        P = n("t3Un"),
        E = n("ZYh2"),
        L = n("u6T5"),
        B = n.n(L),
        N = (n("CDV2"), n("W0Nb"), p.a.createElement),
        D = {
          "@dji/quark/dist/Tabs.css": {
            _3lMTV: "Tabs___3lMTV___2pQ-A",
            _2bOox: "Tabs___2bOox___2CQtU",
            _28KUW: "Tabs___28KUW___-Srg6",
            _1Ltud: "Tabs___1Ltud___n6KKI",
            _2LH7P: "Tabs___2LH7P___3Keah",
            _1ubfg: "Tabs___1ubfg___3dybl",
            zPFdO: "Tabs__zPFdO___3lvSR",
            "_3-a_h": "Tabs___3-a_h___5FW1k",
            _8wsGN: "Tabs___8wsGN___gL3-r",
            _1RPG6: "Tabs___1RPG6___3wbtN",
            _2RUui: "Tabs___2RUui___1-O61",
            pHyFu: "Tabs__pHyFu___3CP5v",
            _3yx3R: "Tabs___3yx3R___1zv_m",
            _1DkKo: "Tabs___1DkKo___du86p",
            _1G3aQ: "Tabs___1G3aQ___ZMYAi",
            _3Qm4W: "Tabs___3Qm4W___36FQs",
            _14aFm: "Tabs___14aFm___Jiw0n",
            _2d3yp: "Tabs___2d3yp___3n3ff",
            _1RhgG: "Tabs___1RhgG___1vwAY",
            "quark-tab-default-tab-bar-wrap":
              "Tabs__quark-tab-default-tab-bar-wrap___3Cd6d",
            "quark-tab-default-tab-bar":
              "Tabs__quark-tab-default-tab-bar___3mZvV",
            "quark-tab-default-tab-container":
              "Tabs__quark-tab-default-tab-container___3qQ8P",
          },
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "form-group-zh-enterprise":
              "style__form-group-zh-enterprise___3XhEO",
            "form-group": "style__form-group___3qY25",
            hide: "style__hide___11I_N",
            "form-group-zh-enterprise-input-error":
              "style__form-group-zh-enterprise-input-error___LEAPm",
            "arealinkage-cn-box": "style__arealinkage-cn-box___1kasu",
            icon: "style__icon___2zsCg",
            "icon-show": "style__icon-show___2PyzX",
            "icon-no-show": "style__icon-no-show___3cKAt",
            "arealinkage-cn-input-label":
              "style__arealinkage-cn-input-label___3k2tv",
            "arealinkage-cn-input-label-focussend":
              "style__arealinkage-cn-input-label-focussend___1K6ur",
            "style__form-error-height___11O7x":
              "style__style__form-error-height___11O7x___1CkVK",
            "arealinkage-cn-box-mobile-margin":
              "style__arealinkage-cn-box-mobile-margin___3p_nH",
            "arealinkage-cn-input-modal-pc":
              "style__arealinkage-cn-input-modal-pc___DnWem",
            "arealinkage-cn-input-modal-mobile":
              "style__arealinkage-cn-input-modal-mobile___5ISl0",
            "arealinkage-cn-input-modal-pc-city-box":
              "style__arealinkage-cn-input-modal-pc-city-box___3cXF3",
            "arealinkage-cn-modal-normal":
              "style__arealinkage-cn-modal-normal___2rtFr",
            "arealinkage-cn-modal-height-change":
              "style__arealinkage-cn-modal-height-change___2p0tQ",
            "arealinkage-cn-input-modal-mobile-city-box":
              "style__arealinkage-cn-input-modal-mobile-city-box___1GG7O",
            "arealinkage-cn-input-modal-pc-item":
              "style__arealinkage-cn-input-modal-pc-item___AoWr9",
            "arealinkage-cn-input-modal-mobile-item":
              "style__arealinkage-cn-input-modal-mobile-item___3Ihzf",
            "arealinkage-cn-input-modal-pc-item-active":
              "style__arealinkage-cn-input-modal-pc-item-active___3lIcV",
            "arealinkage-cn-form-item-position":
              "style__arealinkage-cn-form-item-position___20kjp",
            "form-error-height-normal":
              "style__form-error-height-normal___2T9ai",
            "form-error-height-change-box":
              "style__form-error-height-change-box___3eNCV",
            "arealinkage-cn-form-item-no-show":
              "style__arealinkage-cn-form-item-no-show___2l2Up",
            "zh-enterprise-pop-up-wrapper-mobile":
              "style__zh-enterprise-pop-up-wrapper-mobile___37s7E",
            "zh-enterprise-pop-up-wrapper-mobile-active":
              "style__zh-enterprise-pop-up-wrapper-mobile-active___2yKNz",
            "pop-up-mask": "style__pop-up-mask___3mJQh",
            "popup-content-wrapper": "style__popup-content-wrapper___3HiOh",
            "zh-enterprise-display-none":
              "style__zh-enterprise-display-none___1KXC_",
            "no-live": "style__no-live___3Ze9t",
            "pop-up-inner-wrapper": "style__pop-up-inner-wrapper___-kkEm",
            "pop-up-content": "style__pop-up-content___31rR1",
            close: "style__close___25CBc",
            "pop-up-title": "style__pop-up-title___2nV0F",
            "line-box": "style__line-box___2gK2j",
            "line-text": "style__line-text___dh3Qe",
            line: "style__line___2RQLd",
            "platform-list-wrapper": "style__platform-list-wrapper___2NS9V",
            "platform-item": "style__platform-item___yKYdZ",
            "platform-logo": "style__platform-logo___3EMtr",
          },
        };
      function z(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var A = function (e, t, n) {
          if ("string" !== typeof e) return "";
          var o = e.replace(" *", "").replace("*", ""),
            a = t && !n ? " *" : "";
          return "".concat(o).concat(a);
        },
        R = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t),
              (n = z(this, t, [e])),
              Object(c.a)(Object(l.a)(n), "handleMoveDomToBody", function () {
                var e = n.state.opened;
                if ("undefined" !== typeof document && document) {
                  var t = document.querySelector("body"),
                    o = n.popUpDom;
                  !e &&
                    o &&
                    (o.removeNode
                      ? (o.removeNode(),
                        n.iframeDom && o.appendChild(n.iframeDom),
                        t && t.appendChild(o))
                      : (o.remove(), t && t.append(o)),
                    n.setState({ opened: !0 }));
                }
              }),
              Object(c.a)(Object(l.a)(n), "handleMobileModalShow", function () {
                var e = n.props.mobileMode;
                e &&
                  (n.setState({ showPopUp: !0 }),
                  e && Object(E.b)(n.wrapperDom),
                  n.popUpDom && n.handleMoveDomToBody());
              }),
              Object(c.a)(Object(l.a)(n), "handleClosePopUp", function () {
                var e = n.props.mobileMode;
                n.setState({ showPopUp: !1 }), e && Object(E.c)(n.wrapperDom);
              }),
              Object(c.a)(Object(l.a)(n), "handleSingleCity", function (e) {
                var t = n.props.form;
                1 === (null === e || void 0 === e ? void 0 : e.data.length)
                  ? (n.handleClosePopUp(),
                    n.setState({
                      areaLinkageCnModalShow: !1,
                      cityTabTitle:
                        null === e || void 0 === e ? void 0 : e.data[0],
                      activeTabKey: "1",
                    }),
                    t.setFieldsValue({
                      city: null === e || void 0 === e ? void 0 : e.data[0],
                    }))
                  : n.setState({ cityTabTitle: "" });
              }),
              Object(c.a)(Object(l.a)(n), "handleStatesChange", function (e) {
                var t = n.props,
                  o = t.localization,
                  a = t.form,
                  r = null === e || void 0 === e ? void 0 : e.code;
                a.setFieldsValue({
                  state: null === e || void 0 === e ? void 0 : e.code,
                }),
                  w.default
                    .request(
                      {
                        method: "GET",
                        name: "citiesInChina",
                        query: { state: r },
                      },
                      o,
                    )
                    .then(function (e) {
                      return e.json();
                    })
                    .then(function (e) {
                      try {
                        a.setFieldsValue({ city: "" }),
                          n.handleSingleCity(e),
                          n.setState({ cities: e, activeTabKey: "1" });
                      } catch (t) {}
                    }),
                  n.setState({
                    cities: [],
                    cityTabTitle: "",
                    stateTabTitle: null === e || void 0 === e ? void 0 : e.name,
                  });
              }),
              Object(c.a)(Object(l.a)(n), "handleCityChange", function (e) {
                var t = n.props.form;
                n.setState({ cityTabTitle: e, areaLinkageCnModalShow: !1 }),
                  n.handleClosePopUp(),
                  t.setFieldsValue({ city: e });
              }),
              Object(c.a)(Object(l.a)(n), "handleTabChange", function (e) {
                n.setState({ activeTabKey: e });
              }),
              Object(c.a)(Object(l.a)(n), "handleTabCilick", function () {}),
              Object(c.a)(Object(l.a)(n), "resetData", function () {
                n.props.successModalClose &&
                  n.setState(function (e) {
                    if (
                      e.cityTabTitle ||
                      e.stateTabTitle ||
                      e.labelOnfoucs ||
                      e.labelOnBlur ||
                      e.opened
                    )
                      return {
                        cityTabTitle: "",
                        stateTabTitle: "",
                        labelOnfoucs: !1,
                        labelOnBlur: !1,
                        opened: !1,
                        activeTabKey: "0",
                      };
                  });
              }),
              (n.state = {
                states: [],
                cities: [],
                labelOnfoucs: !1,
                labelOnBlur: !1,
                areaLinkageCnModalShow: !1,
                stateTabTitle: "",
                cityTabTitle: "",
                activeTabKey: "0",
                showPopUp: !1,
                opened: !1,
              }),
              (n.getState = n.getState.bind(Object(l.a)(n))),
              n
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = this.props.form;
                  this.getState(),
                    e.setFieldsValue({ continent: "Asia" }),
                    e.setFieldsValue({ activity_country: "cn" }),
                    this.exitArealinkageCnDialog("area-linkage-cn-modal"),
                    this.handleMoveDomToBody();
                },
              },
              {
                key: "componentWillUnmount",
                value: function () {
                  Object(E.a)();
                },
              },
              {
                key: "autoSetAddressByIp",
                value: function () {
                  var e = this,
                    t = this.props.localization,
                    n = this.state.states,
                    o = Object(b.L)("ip", !0),
                    a = {};
                  o && "" !== o && (a.ip = o),
                    w.default
                      .request(
                        { method: "GET", name: "flySafeIpLocation", query: a },
                        t,
                      )
                      .then(function (e) {
                        return e.json();
                      })
                      .then(function (t) {
                        if (t && "200" === t.status) {
                          var o,
                            a,
                            r,
                            i =
                              "CN" === t.country
                                ? null === (o = t.state) || void 0 === o
                                  ? void 0
                                  : o.name_cn
                                : null === (a = t.state) || void 0 === a
                                  ? void 0
                                  : a.name_cn,
                            l =
                              null === n || void 0 === n
                                ? void 0
                                : null === (r = n.data) || void 0 === r
                                  ? void 0
                                  : r.find(function (e) {
                                      return e.name.includes(i);
                                    });
                          l && e.handleStatesChange(l);
                        }
                      });
                },
              },
              {
                key: "exitArealinkageCnDialog",
                value: function (e) {
                  var t = this;
                  document.addEventListener("mouseup", function (n) {
                    var o = document.getElementById(e),
                      a = document.getElementById("arealinkage-cn-input");
                    o &&
                      (o.contains(n.target) || a.contains(n.target)
                        ? (t.setState({ areaLinkageCnModalShow: !0 }),
                          n.stopPropagation())
                        : (t.setState({ areaLinkageCnModalShow: !1 }),
                          n.stopPropagation()));
                  });
                },
              },
              {
                key: "getState",
                value: function () {
                  var e = this,
                    t = this.props.localization;
                  return Object(P.a)(
                    { url: w.default.renderAPI("/api/dealers/states/cn") },
                    t,
                  )
                    .then(function (e) {
                      return e.json();
                    })
                    .then(function (t) {
                      try {
                        e.setState({ states: t }),
                          Object(b.pb)(function () {
                            setTimeout(function () {
                              e.autoSetAddressByIp();
                            }, 10);
                          });
                      } catch (n) {}
                    });
                },
              },
              {
                key: "renderMobileModal",
                value: function () {
                  var e,
                    t,
                    n = this,
                    o = this.state,
                    a = o.showPopUp,
                    r = o.activeTabKey,
                    i = o.stateTabTitle,
                    l = o.states,
                    s = o.cities,
                    c = o.cityTabTitle,
                    _ = this.props,
                    d = _.mobileMode,
                    p = _.t,
                    f = _.component_data,
                    h = _.notRequired,
                    m = !(void 0 !== h && h),
                    y = g()({
                      "zh-enterprise-pop-up-wrapper-mobile": !0,
                      "zh-enterprise-pop-up-wrapper-mobile-active": a,
                      "zh-enterprise-display-none": !d,
                    });
                  return N(
                    "div",
                    {
                      ref: function (e) {
                        n.popUpDom = e;
                      },
                      className:
                        "zh-enterprise-pop-up-wrapper " +
                        u()(y, D, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                    },
                    N(
                      "div",
                      {
                        className: "style__pop-up-inner-wrapper___-kkEm",
                        ref: function (e) {
                          n.iframeDom = e;
                        },
                      },
                      N("div", {
                        className: "style__pop-up-mask___3mJQh",
                        onClick: function () {
                          return n.handleClosePopUp();
                        },
                      }),
                      N(
                        "div",
                        {
                          className: "style__popup-content-wrapper___3HiOh",
                          ref: function (e) {
                            n.wrapperDom = e;
                          },
                        },
                        N("div", {
                          className: "style__close___25CBc",
                          onClick: function () {
                            return n.handleClosePopUp();
                          },
                        }),
                        N(
                          "div",
                          { className: "style__pop-up-content___31rR1" },
                          N(
                            B.a,
                            {
                              activeKey: r,
                              onTabClick: function () {
                                return n.handleTabCilick();
                              },
                              onChange: function (e) {
                                return n.handleTabChange(e);
                              },
                            },
                            N(
                              B.a.TabPanel,
                              { tab: i || A(p(f.state), m, !0), key: "0" },
                              N(
                                "div",
                                {
                                  className:
                                    "style__arealinkage-cn-input-modal-mobile-city-box___1GG7O",
                                  dataKey: "0",
                                },
                                null === l || void 0 === l
                                  ? void 0
                                  : null === (e = l.data) || void 0 === e
                                    ? void 0
                                    : e.map(function (e) {
                                        return N(
                                          "div",
                                          {
                                            key:
                                              null === e || void 0 === e
                                                ? void 0
                                                : e.code,
                                            onClick: function () {
                                              return n.handleStatesChange(e);
                                            },
                                            className: u()(
                                              "".concat(
                                                (null === e || void 0 === e
                                                  ? void 0
                                                  : e.code) === i
                                                  ? "arealinkage-cn-input-modal-pc-item-active"
                                                  : "",
                                                " arealinkage-cn-input-modal-mobile-item",
                                              ),
                                              D,
                                              {
                                                autoResolveMultipleImports: !0,
                                                handleMissingStyleName: "warn",
                                              },
                                            ),
                                          },
                                          null === e || void 0 === e
                                            ? void 0
                                            : e.name,
                                        );
                                      }),
                              ),
                            ),
                            N(
                              B.a.TabPanel,
                              {
                                tab: c || A(p(f.city), m, !0),
                                key: "1",
                                disabled: !i,
                              },
                              N(
                                "div",
                                {
                                  className:
                                    "style__arealinkage-cn-input-modal-mobile-city-box___1GG7O",
                                  dataKey: "1",
                                },
                                null === s || void 0 === s
                                  ? void 0
                                  : null === (t = s.data) || void 0 === t
                                    ? void 0
                                    : t.map(function (e) {
                                        return N(
                                          "div",
                                          {
                                            key: e,
                                            onClick: function () {
                                              return n.handleCityChange(e);
                                            },
                                            className: u()(
                                              "".concat(
                                                e === c
                                                  ? "arealinkage-cn-input-modal-pc-item-active"
                                                  : "",
                                                " arealinkage-cn-input-modal-mobile-item",
                                              ),
                                              D,
                                              {
                                                autoResolveMultipleImports: !0,
                                                handleMissingStyleName: "warn",
                                              },
                                            ),
                                          },
                                          e,
                                        );
                                      }),
                              ),
                            ),
                          ),
                        ),
                      ),
                    ),
                  );
                },
              },
              {
                key: "onFocus",
                value: function () {
                  this.setState({ labelOnfoucs: !0 });
                },
              },
              {
                key: "onBlur",
                value: function () {
                  this.setState({ labelOnBlur: !0 });
                },
              },
              {
                key: "render",
                value: function () {
                  var e,
                    t,
                    n = this,
                    o = this.props,
                    a = o.form,
                    r = o.t,
                    i = o.notRequired,
                    l = void 0 !== i && i,
                    s = o.component_data,
                    c = o.hideRequiredStar,
                    _ = o.cityFoucs,
                    d = o.mobileMode;
                  this.resetData();
                  var f = !l,
                    h = this.state,
                    m = h.states,
                    y = h.cities,
                    b = h.areaLinkageCnModalShow,
                    v = h.stateTabTitle,
                    w = h.cityTabTitle,
                    x = h.activeTabKey,
                    O = h.labelOnfoucs,
                    I = h.labelOnBlur,
                    S = a.getFieldDecorator,
                    j = (!w || !v) && (_ || I) && !b,
                    C = (_ || I || O || v) && !w,
                    M = g()({
                      "form-error-height-normal": !0,
                      "form-error-height-change-box": j,
                    });
                  return N(
                    "div",
                    {
                      className:
                        "style__arealinkage-cn-form-item-position___20kjp",
                    },
                    N(
                      "div",
                      {
                        className: u()(
                          "arealinkage-cn-box form-group-zh-enterprise ".concat(
                            d ? "arealinkage-cn-box-mobile-margin" : "",
                          ),
                          D,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      N(
                        T.b,
                        null,
                        S("continent", { initialValue: "" })(
                          N(
                            "div",
                            { error: "city" },
                            N("input", {
                              id: "arealinkage-cn-input",
                              type: "text",
                              name: "arealinkage_cn",
                              onFocus: function () {
                                return n.onFocus();
                              },
                              onBlur: function () {
                                return n.onBlur();
                              },
                              onClick: function () {
                                return n.handleMobileModalShow();
                              },
                              value: "".concat(
                                C
                                  ? ""
                                      .concat(A(r(s.state), f, !0), " ")
                                      .concat(A(r(s.city), f, !0))
                                  : "".concat(v, " ").concat(w),
                              ),
                              readOnly: !0,
                              style: {
                                border: "1px solid rgba(0, 0, 0, 0.15)",
                                color: C
                                  ? "rgba(0, 0, 0, 0.45)"
                                  : "rgba(0, 0, 0, 0.85)",
                              },
                              className: u()(
                                "".concat(
                                  j
                                    ? "form-group-zh-enterprise-input-error"
                                    : "",
                                ),
                                D,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            }),
                            N(
                              "div",
                              {
                                className:
                                  "form-error style__form-error___1S7vw ".concat(
                                    j
                                      ? " style__form-error-height___11O7x form-error-height"
                                      : "",
                                  ) +
                                  " " +
                                  u()(M, D, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              },
                              N("i", {
                                className: "_30-mD _3c0Qz",
                                style: { fontFamily: "quark" },
                              }),
                              N("span", null, r(s.city_error)),
                            ),
                            N(
                              "label",
                              {
                                htmlFor: "arealinkage_cn",
                                className: u()(
                                  O || _ || v
                                    ? "arealinkage-cn-input-label-focussend"
                                    : "arealinkage-cn-input-label",
                                  D,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                              },
                              A(r(s.city), f, c),
                            ),
                            N(
                              "div",
                              { className: "style__icon___2zsCg" },
                              N(
                                k.a,
                                b
                                  ? { name: "caret-up" }
                                  : { name: "caret-down" },
                              ),
                            ),
                          ),
                        ),
                      ),
                      N(
                        "div",
                        {
                          className:
                            "style__arealinkage-cn-form-item-no-show___2l2Up",
                        },
                        N(
                          T.b,
                          null,
                          S("activity_country", { initialValue: "" })(
                            N(p.a.Fragment, null),
                          ),
                        ),
                        N(
                          T.b,
                          null,
                          S("state", {
                            initialValue: "",
                            validateTrigger: "onBlur",
                            rules: [
                              { required: !0, whitespace: !0, message: "" },
                            ],
                          })(N(p.a.Fragment, null)),
                        ),
                        N(
                          T.b,
                          null,
                          S("city", {
                            initialValue: "",
                            validateTrigger: "onBlur",
                            rules: [
                              { required: !0, whitespace: !0, message: "" },
                            ],
                          })(N(p.a.Fragment, null)),
                        ),
                      ),
                    ),
                    N(
                      "div",
                      {
                        id: "area-linkage-cn-modal",
                        className: u()(
                          ""
                            .concat(
                              b ? "arealinkage-cn-modal-height-change" : "",
                              " arealinkage-cn-modal-normal ",
                            )
                            .concat(
                              d
                                ? "arealinkage-cn-input-modal-mobile"
                                : "arealinkage-cn-input-modal-pc",
                            ),
                          D,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      N(
                        B.a,
                        {
                          activeKey: x,
                          onTabClick: function () {
                            return n.handleTabCilick();
                          },
                          onChange: function (e) {
                            return n.handleTabChange(e);
                          },
                        },
                        N(
                          B.a.TabPanel,
                          { tab: v || A(r(s.state), f, !0), key: "0" },
                          N(
                            "div",
                            {
                              className:
                                "style__arealinkage-cn-input-modal-pc-city-box___3cXF3",
                              dataKey: "0",
                            },
                            null === m || void 0 === m
                              ? void 0
                              : null === (e = m.data) || void 0 === e
                                ? void 0
                                : e.map(function (e) {
                                    return N(
                                      "div",
                                      {
                                        key:
                                          null === e || void 0 === e
                                            ? void 0
                                            : e.code,
                                        onClick: function () {
                                          return n.handleStatesChange(e);
                                        },
                                        className: u()(
                                          "".concat(
                                            (null === e || void 0 === e
                                              ? void 0
                                              : e.code) === v
                                              ? "arealinkage-cn-input-modal-pc-item-active"
                                              : "",
                                            " arealinkage-cn-input-modal-pc-item",
                                          ),
                                          D,
                                          {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          },
                                        ),
                                      },
                                      null === e || void 0 === e
                                        ? void 0
                                        : e.name,
                                    );
                                  }),
                          ),
                        ),
                        N(
                          B.a.TabPanel,
                          {
                            tab: w || A(r(s.city), f, !0),
                            key: "1",
                            disabled: !v,
                          },
                          N(
                            "div",
                            {
                              className:
                                "style__arealinkage-cn-input-modal-pc-city-box___3cXF3",
                              dataKey: "1",
                            },
                            null === y || void 0 === y
                              ? void 0
                              : null === (t = y.data) || void 0 === t
                                ? void 0
                                : t.map(function (e) {
                                    return N(
                                      "div",
                                      {
                                        key: e,
                                        onClick: function () {
                                          return n.handleCityChange(e);
                                        },
                                        className: u()(
                                          "".concat(
                                            e === w
                                              ? "arealinkage-cn-input-modal-pc-item-active"
                                              : "",
                                            " arealinkage-cn-input-modal-pc-item",
                                          ),
                                          D,
                                          {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          },
                                        ),
                                      },
                                      e,
                                    );
                                  }),
                          ),
                        ),
                      ),
                    ),
                    this.renderMobileModal(),
                  );
                },
              },
            ]),
            t
          );
        })(p.a.Component);
      Object(c.a)(R, "defaultProps", {
        t: function () {},
        form: "",
        component_data: {},
      });
      var F = Object(f.a)(R),
        V = n("S5C5"),
        H = n("3iuL"),
        W = p.a.createElement,
        U = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "@dji/quark/dist/Button.css": {
            _3c0Qz: "Button___3c0Qz___3_YsB",
            _1j2v0: "Button___1j2v0___1pv-M",
            "-lu88": "Button__-lu88___2GQjh",
            _35bgc: "Button___35bgc___3n8Rj",
            byXrR: "Button__byXrR___1rGCj",
            _128ri: "Button___128ri___cMk_M",
            _1KHsi: "Button___1KHsi___3zDhv",
            "_2bT-Y": "Button___2bT-Y___1BQim",
            _3UEZX: "Button___3UEZX___34LNn",
            _1fXKU: "Button___1fXKU___2p1SZ",
            _2OZ_n: "Button___2OZ_n___YkVy4",
            _6cr8a: "Button___6cr8a___1Yfq-",
            ZAGKa: "Button__ZAGKa___1dwyB",
            _1lH5w: "Button___1lH5w___21_9c",
            _3BSr4: "Button___3BSr4___35AVQ",
            _4wlbR: "Button___4wlbR___2ZD_N",
            _26SUY: "Button___26SUY___1S1ah",
            "_30-mD": "Button___30-mD___18GAM",
            _1_xvC: "Button___1_xvC___1As6M",
            _17P2f: "Button___17P2f___1PWRA",
            _2I_EY: "Button___2I_EY___1kVmM",
            _3qb3s: "Button___3qb3s___1VKTa",
            _2jwD5: "Button___2jwD5___34QGU",
            _19X43: "Button___19X43___1bIzm",
            _2WwM4: "Button___2WwM4___3DLDq",
            _1shcg: "Button___1shcg___xYyCK",
            _1qLWd: "Button___1qLWd___3xAFl",
            Z8Prc: "Button__Z8Prc___3Y6cV",
            _3MItB: "Button___3MItB___2GmVw",
            _2Bvn6: "Button___2Bvn6___1ZN51",
            _3IVo_: "Button___3IVo____37Zlk",
            _34FGS: "Button___34FGS___19x0T",
            _3e62_: "Button___3e62____1kXjH",
            _1zbhS: "Button___1zbhS___1e1Z9",
            _27RtX: "Button___27RtX___1EMvI",
            jhfcy: "Button__jhfcy___aBpb9",
            Q82xM: "Button__Q82xM___1HSjO",
            _1vyf0: "Button___1vyf0___GWMBB",
            B0IHZ: "Button__B0IHZ___DG2N7",
            _2cpQ_: "Button___2cpQ____2btfh",
            _2FImd: "Button___2FImd___2-tY9",
            _3wXJB: "Button___3wXJB___2yeXW",
            _2fXyR: "Button___2fXyR___Rjv-D",
            _2KLCQ: "Button___2KLCQ___BFWbF",
            "_-4DAY": "Button___-4DAY___2ioyI",
            _2I4g3: "Button___2I4g3___3Eaa-",
            _1m5z7: "Button___1m5z7___1MkYM",
            _1vR3p: "Button___1vR3p___2p5DE",
            _2LJ7o: "Button___2LJ7o___28N0F",
            _3AQSX: "Button___3AQSX___7_7y3",
            _3ASBw: "Button___3ASBw___2Y-VE",
            _6eszT: "Button___6eszT___3mq5H",
            _1WxHW: "Button___1WxHW___2xO4X",
            _2uv1U: "Button___2uv1U___3ZHoj",
            "_3s-NW": "Button___3s-NW___1zAS9",
            _1ZzVY: "Button___1ZzVY___3SJE5",
            OBwuW: "Button__OBwuW___3xvOP",
            "_2Ri-k": "Button___2Ri-k___Sly51",
            _1588m: "Button___1588m___XB3VC",
            _2uIqb: "Button___2uIqb___2sh69",
            _1P5xZ: "Button___1P5xZ___1zouk",
            _2iuBX: "Button___2iuBX___2bjKy",
            _1exha: "Button___1exha___3RWAJ",
            _3bokS: "Button___3bokS___2ePXE",
            "vMM-Y": "Button__vMM-Y___8IgyG",
            _3jZwp: "Button___3jZwp___1Ev6Q",
            "_2SUQ-": "Button___2SUQ-___3lLH9",
            _1Piil: "Button___1Piil___1QyQw",
            _20oXE: "Button___20oXE___ElSIH",
            _2gTe8: "Button___2gTe8___2xBdm",
            okv_Y: "Button__okv_Y___1ubHf",
            "_3l-6g": "Button___3l-6g___2KJmk",
            OhY9C: "Button__OhY9C___ZT6G_",
            Cb5jY: "Button__Cb5jY___9nnVH",
            _1ajFe: "Button___1ajFe___1tm_G",
            ve2KQ: "Button__ve2KQ___3RJJm",
            _3OU3j: "Button___3OU3j___2kvsA",
            lgV2x: "Button__lgV2x___3MLDY",
            _1gQtG: "Button___1gQtG___3qZq1",
            _3Zaag: "Button___3Zaag___2musd",
            _33jTA: "Button___33jTA___25uDV",
            _1jJbn: "Button___1jJbn___E5qyl",
            UuxAk: "Button__UuxAk___1y9FB",
            _1OEuY: "Button___1OEuY___2ApAD",
            Lm_MF: "Button__Lm_MF___2UiBr",
            _3LwbN: "Button___3LwbN___3NRup",
            _2XN05: "Button___2XN05___2oonD",
            _33OcX: "Button___33OcX___3U-s2",
            bMc_E: "Button__bMc_E___Errdw",
            IAlEP: "Button__IAlEP___2OxlB",
            _25GQ2: "Button___25GQ2___2Cy9i",
            _3t3HT: "Button___3t3HT___2ItHs",
            _2W_XA: "Button___2W_XA___18R0_",
            _3NPLS: "Button___3NPLS___2kmEj",
            UhwjW: "Button__UhwjW___3t6jI",
            _2hDpl: "Button___2hDpl___G-xHk",
            dCZz2: "Button__dCZz2___3zTk3",
            _1FMUV: "Button___1FMUV___19Yjz",
            _2H8bj: "Button___2H8bj___3QJ_5",
            _3KkpT: "Button___3KkpT___34Sn5",
            _23p5a: "Button___23p5a___1Zcup",
            _18A_e: "Button___18A_e___1Cd-X",
            gf_rb: "Button__gf_rb___QDm63",
            _1Djb6: "Button___1Djb6___2V3dX",
            "_3d-6G": "Button___3d-6G___1MXwX",
            _1fawl: "Button___1fawl___I7NdV",
            _20uY7: "Button___20uY7___2hDdw",
            _2Z6dE: "Button___2Z6dE___3tJRR",
            _1c3Qh: "Button___1c3Qh___1HVho",
            _1GlZx: "Button___1GlZx___1flj5",
            _3hG3b: "Button___3hG3b___2Q80A",
            _15wCJ: "Button___15wCJ___KdW5M",
            _1Rw_U: "Button___1Rw_U___2GLMY",
            _2Jlwc: "Button___2Jlwc___2VzvV",
            _1bahP: "Button___1bahP___C4-1_",
            "_27Nd-": "Button___27Nd-___1KCCP",
            _3To44: "Button___3To44___3KOU7",
            _1O_Hy: "Button___1O_Hy___1zbxZ",
            W6H_f: "Button__W6H_f___xYs0p",
            _2_sls: "Button___2_sls___1k3Nb",
            _35BGQ: "Button___35BGQ___3N9zl",
            _3xfLM: "Button___3xfLM___2XcWP",
            _1pvYF: "Button___1pvYF___3oKsk",
            _3TvKd: "Button___3TvKd___2VIEV",
            xnv6R: "Button__xnv6R___2cBTA",
            "_3e-BG": "Button___3e-BG___2ZOCl",
            _3RO_K: "Button___3RO_K___3-4UL",
            _19X_H: "Button___19X_H___3bvjE",
            _8oCtR: "Button___8oCtR___1W4rm",
            _1bpad: "Button___1bpad___3AT8k",
            "_27-6k": "Button___27-6k___2eKen",
            _2QwEc: "Button___2QwEc___1HW_3",
            "_3IIr-": "Button___3IIr-___31mOV",
            _16fYW: "Button___16fYW___OEeVD",
            upL7u: "Button__upL7u___Yy3v0",
            _3oax7: "Button___3oax7___2c1CL",
            _958V1: "Button___958V1___3twpf",
            _22qIt: "Button___22qIt___1aIOI",
            mrbT4: "Button__mrbT4___1NRK4",
            _1i5fk: "Button___1i5fk___1zH_K",
            _1FsY1: "Button___1FsY1___xNXOo",
            p8s4W: "Button__p8s4W___1JDPQ",
            "_27-yu": "Button___27-yu___1vw79",
            _2ghvt: "Button___2ghvt___3koQZ",
            _21L3I: "Button___21L3I___1O4m3",
            _1wazg: "Button___1wazg___3BzGo",
            j7iyJ: "Button__j7iyJ___SXP4U",
          },
          "@dji/quark/dist/Modal.css": {
            _3c0Qz: "Modal___3c0Qz___1hxye",
            _1j2v0: "Modal___1j2v0___3_lju",
            "-lu88": "Modal__-lu88___3rDys",
            _35bgc: "Modal___35bgc___1ozWv",
            byXrR: "Modal__byXrR___3Cd-d",
            _128ri: "Modal___128ri___1KHPb",
            _1KHsi: "Modal___1KHsi___1zsfj",
            "_2bT-Y": "Modal___2bT-Y___27h2f",
            _3UEZX: "Modal___3UEZX___2U_W9",
            _1fXKU: "Modal___1fXKU___2lC-k",
            _2OZ_n: "Modal___2OZ_n___qxozy",
            _6cr8a: "Modal___6cr8a___3XaOx",
            ZAGKa: "Modal__ZAGKa___2ry_R",
            _1lH5w: "Modal___1lH5w___1d17g",
            _3BSr4: "Modal___3BSr4___3tVqE",
            _4wlbR: "Modal___4wlbR___Y98qQ",
            _26SUY: "Modal___26SUY___6oGL0",
            "_30-mD": "Modal___30-mD___pz8-w",
            _1_xvC: "Modal___1_xvC___hbxNG",
            _17P2f: "Modal___17P2f___xpPnw",
            _2I_EY: "Modal___2I_EY___3ZRi0",
            _3qb3s: "Modal___3qb3s___3Rh8U",
            _2jwD5: "Modal___2jwD5___1axi7",
            _19X43: "Modal___19X43___I7gZu",
            _2WwM4: "Modal___2WwM4___1mT27",
            _1shcg: "Modal___1shcg___RYLyE",
            _1qLWd: "Modal___1qLWd___Hy02w",
            Z8Prc: "Modal__Z8Prc___1vsjj",
            _3MItB: "Modal___3MItB___14wzI",
            _2Bvn6: "Modal___2Bvn6___ptoA7",
            _3IVo_: "Modal___3IVo____2ssAq",
            _34FGS: "Modal___34FGS___F0hii",
            _3e62_: "Modal___3e62____V2cVJ",
            _1zbhS: "Modal___1zbhS___P3bAh",
            _27RtX: "Modal___27RtX___1Z7dB",
            jhfcy: "Modal__jhfcy___3vXBh",
            Q82xM: "Modal__Q82xM___1X4Qt",
            _1vyf0: "Modal___1vyf0___1jVEL",
            B0IHZ: "Modal__B0IHZ___edWy2",
            _2cpQ_: "Modal___2cpQ____2rMFO",
            _2FImd: "Modal___2FImd___1r2eY",
            _3wXJB: "Modal___3wXJB___1HrbN",
            _2fXyR: "Modal___2fXyR___299OI",
            _2KLCQ: "Modal___2KLCQ___2ZNUN",
            "_-4DAY": "Modal___-4DAY___3kdcK",
            _2I4g3: "Modal___2I4g3___1V1pR",
            _1m5z7: "Modal___1m5z7___1mtzi",
            _1vR3p: "Modal___1vR3p___30mES",
            _2LJ7o: "Modal___2LJ7o___2YvzT",
            _3AQSX: "Modal___3AQSX___1Ix-w",
            _3ASBw: "Modal___3ASBw___1Gr4Q",
            _6eszT: "Modal___6eszT___1XSgf",
            _1WxHW: "Modal___1WxHW___11cu7",
            _2uv1U: "Modal___2uv1U___36lQA",
            "_3s-NW": "Modal___3s-NW___2FBN8",
            _1ZzVY: "Modal___1ZzVY___1Rns8",
            OBwuW: "Modal__OBwuW___3LvYe",
            "_2Ri-k": "Modal___2Ri-k___3fKmX",
            _1588m: "Modal___1588m___YvJv8",
            _2uIqb: "Modal___2uIqb___yrL5a",
            _1P5xZ: "Modal___1P5xZ___3YA_P",
            _2iuBX: "Modal___2iuBX___2yEjU",
            _1exha: "Modal___1exha___2H1Oc",
            _3bokS: "Modal___3bokS___3SJWJ",
            "vMM-Y": "Modal__vMM-Y___n5FWk",
            _3jZwp: "Modal___3jZwp___2tkD0",
            "_2SUQ-": "Modal___2SUQ-___tsFd_",
            _1Piil: "Modal___1Piil___2zv3C",
            _20oXE: "Modal___20oXE___1KX-3",
            _2gTe8: "Modal___2gTe8___2Snjy",
            okv_Y: "Modal__okv_Y___1IYbZ",
            "_3l-6g": "Modal___3l-6g___1CjpU",
            OhY9C: "Modal__OhY9C___1yFDE",
            Cb5jY: "Modal__Cb5jY___3Jwr9",
            _1ajFe: "Modal___1ajFe___1-Zk5",
            ve2KQ: "Modal__ve2KQ___2XW_h",
            _3OU3j: "Modal___3OU3j___3aGvD",
            lgV2x: "Modal__lgV2x___2U6ZR",
            _1gQtG: "Modal___1gQtG___2MYA6",
            _3Zaag: "Modal___3Zaag___pL3_l",
            _33jTA: "Modal___33jTA___z9tIP",
            _1jJbn: "Modal___1jJbn___1rzCJ",
            UuxAk: "Modal__UuxAk___2Z5Kb",
            _1OEuY: "Modal___1OEuY___3krH7",
            Lm_MF: "Modal__Lm_MF___1h5L2",
            _3LwbN: "Modal___3LwbN___Zi8fH",
            _2XN05: "Modal___2XN05___2H5yU",
            _33OcX: "Modal___33OcX___16pGT",
            bMc_E: "Modal__bMc_E___3q73Q",
            IAlEP: "Modal__IAlEP___2alUV",
            _25GQ2: "Modal___25GQ2___1rVVy",
            _3t3HT: "Modal___3t3HT___2t2yE",
            _2W_XA: "Modal___2W_XA___3BdCd",
            _3NPLS: "Modal___3NPLS___9C7eH",
            UhwjW: "Modal__UhwjW___29k4U",
            _2hDpl: "Modal___2hDpl___1iI6T",
            dCZz2: "Modal__dCZz2___1GECo",
            _1FMUV: "Modal___1FMUV___1X9ed",
            _2H8bj: "Modal___2H8bj___1ZO3P",
            _3KkpT: "Modal___3KkpT___18c4z",
            _23p5a: "Modal___23p5a___3NYPd",
            _18A_e: "Modal___18A_e___2nJNn",
            gf_rb: "Modal__gf_rb___3XNvC",
            _1Djb6: "Modal___1Djb6___2ILzk",
            "_3d-6G": "Modal___3d-6G___3-eRu",
            _1fawl: "Modal___1fawl___PX6gv",
            _20uY7: "Modal___20uY7___6DvMd",
            _2Z6dE: "Modal___2Z6dE___2ckZ2",
            _1c3Qh: "Modal___1c3Qh___2Dxo1",
            _1GlZx: "Modal___1GlZx___8NJ6T",
            _3hG3b: "Modal___3hG3b___1acxy",
            _15wCJ: "Modal___15wCJ___3v132",
            _1Rw_U: "Modal___1Rw_U___3ZmKB",
            _2Jlwc: "Modal___2Jlwc___1Pekq",
            _1bahP: "Modal___1bahP___j2Y7v",
            "_27Nd-": "Modal___27Nd-___1rWCR",
            _3To44: "Modal___3To44___3fsW4",
            _1O_Hy: "Modal___1O_Hy___2i0oT",
            W6H_f: "Modal__W6H_f___374T2",
            _2_sls: "Modal___2_sls___3pBvS",
            _35BGQ: "Modal___35BGQ___266xM",
            _3xfLM: "Modal___3xfLM___2-m15",
            _1pvYF: "Modal___1pvYF___32eWR",
            _3TvKd: "Modal___3TvKd___ucMBe",
            xnv6R: "Modal__xnv6R___3Uti5",
            "_3e-BG": "Modal___3e-BG___24NGT",
            _3RO_K: "Modal___3RO_K___2wIIm",
            _19X_H: "Modal___19X_H___1iK4s",
            _8oCtR: "Modal___8oCtR___3osk3",
            _1bpad: "Modal___1bpad___2DHVM",
            "_27-6k": "Modal___27-6k___2eMZO",
            _2QwEc: "Modal___2QwEc___1R5iz",
            "_3IIr-": "Modal___3IIr-___21oa3",
            _16fYW: "Modal___16fYW___2N0UQ",
            upL7u: "Modal__upL7u___1It5R",
            _3oax7: "Modal___3oax7___1GvUE",
            _958V1: "Modal___958V1___2LaDZ",
            _22qIt: "Modal___22qIt___2Lxjy",
            mrbT4: "Modal__mrbT4___25dj0",
            _1i5fk: "Modal___1i5fk___2M86Z",
            _1FsY1: "Modal___1FsY1___Xksry",
            p8s4W: "Modal__p8s4W___23KRN",
            "_27-yu": "Modal___27-yu___2ZlAn",
            _2ghvt: "Modal___2ghvt___1s7WX",
            _21L3I: "Modal___21L3I___NQLRc",
            _1wazg: "Modal___1wazg___3o1-L",
            j7iyJ: "Modal__j7iyJ___rVNnX",
            _5iCMy: "Modal___5iCMy___1g4Mo",
            _3N80o: "Modal___3N80o___3hzWL",
            _3jNlY: "Modal___3jNlY___AuNhs",
            _249s1: "Modal___249s1___1q559",
            RBtig: "Modal__RBtig___2OH6O",
            _1SoeU: "Modal___1SoeU___10PPl",
            _2bhiO: "Modal___2bhiO___wGRf0",
            _5FUC: "Modal___5FUC___3b14u",
            _19qBt: "Modal___19qBt___2aYeO",
            _1fEts: "Modal___1fEts____21_m",
            "_2-nfI": "Modal___2-nfI___1_qQW",
            UT4Rh: "Modal__UT4Rh___MxfSj",
            _134Zt: "Modal___134Zt___2d6sn",
            Vsj0k: "Modal__Vsj0k___3eF0d",
            _3WeTt: "Modal___3WeTt___2Dpru",
            _2_fNz: "Modal___2_fNz___1ZGEe",
            _29zRf: "Modal___29zRf___J8pxa",
            bsi6l: "Modal__bsi6l___1hpsS",
            _2fvBN: "Modal___2fvBN___2-MB-",
            kvUUT: "Modal__kvUUT___1_zP9",
            F2CYv: "Modal__F2CYv___3ljvg",
            ssUw_: "Modal__ssUw____hpdy7",
            _2PzHu: "Modal___2PzHu___1hF58",
            _12j5q: "Modal___12j5q___10AX1",
            g2SoP: "Modal__g2SoP___t9h9r",
            _3U3Et: "Modal___3U3Et___32HbG",
            _2b7K4: "Modal___2b7K4___3caDv",
            _3XX52: "Modal___3XX52___1AiZV",
            _168gc: "Modal___168gc___z6qOQ",
            _3N4z4: "Modal___3N4z4___BBD8-",
            _33vWN: "Modal___33vWN___1vcqr",
            _17SAi: "Modal___17SAi___2DuC_",
            "_2ND-v": "Modal___2ND-v___RZbtI",
            _2VI4U: "Modal___2VI4U___2q2Rl",
            _32gGw: "Modal___32gGw___3csNR",
            _2P3bW: "Modal___2P3bW___2Faa6",
            _2RlE1: "Modal___2RlE1___W9FQ6",
            _2YiVO: "Modal___2YiVO___3h_a0",
            _3LZfU: "Modal___3LZfU___sP7Ia",
            kmSxj: "Modal__kmSxj___2g9U3",
            SGzBY: "Modal__SGzBY___pVICf",
            leytg: "Modal__leytg___p4YSs",
            _1Fbwl: "Modal___1Fbwl___1RxHR",
            _3Nq3W: "Modal___3Nq3W___27RFi",
            _38_U0: "Modal___38_U0___b_ZGh",
            _2gf0i: "Modal___2gf0i___3d9M9",
            _2l3Wv: "Modal___2l3Wv___1Cj2P",
            _3GTn6: "Modal___3GTn6___2z7yr",
            _38rwj: "Modal___38rwj___1vLdM",
            _28BxZ: "Modal___28BxZ___1QdX1",
            "Jf-sC": "Modal__Jf-sC___2JX-L",
            _303Q5: "Modal___303Q5___34m77",
            _1gPIw: "Modal___1gPIw___2MlB-",
          },
          "./style.css": {
            "form-group-zh-enterprise":
              "style__form-group-zh-enterprise___2hZjx",
            "form-box-zh-enterprise": "style__form-box-zh-enterprise___3D8TF",
            "form-group-zh-enterprise-select-label-show":
              "style__form-group-zh-enterprise-select-label-show___3nYZs",
            "form-group-zh-enterprise-position":
              "style__form-group-zh-enterprise-position___3gCpT",
            "form-group-zh-enterprise-tip":
              "style__form-group-zh-enterprise-tip___23AhS",
            "form-group-zh-enterprise-select-font":
              "style__form-group-zh-enterprise-select-font___2Q86l",
            "section-form-component": "style__section-form-component___ZZNnU",
            loading: "style__loading___3Vcdn",
            "zh-enterprise-text-box": "style__zh-enterprise-text-box___28SMI",
            "text-box": "style__text-box___319Qy",
            title: "style__title___1j1t2",
            desc: "style__desc___11r5B",
            "form-box": "style__form-box___2decN",
            "form-group": "style__form-group___Ba9UW",
            icon: "style__icon___1sAIZ",
            "form-input-label": "style__form-input-label___3Vf-B",
            "form-input-label-focussend":
              "style__form-input-label-focussend___38jS8",
            "form-textarea-label": "style__form-textarea-label___oevt-",
            "select-box": "style__select-box___mDy8I",
            select: "style__select___1tanE",
            cooperationIntention: "style__cooperationIntention___2tWj3",
            "cooperationIntention-zh-enterprise":
              "style__cooperationIntention-zh-enterprise___3_HRI",
            margin: "style__margin___1FhgI",
            "no-margin": "style__no-margin___1meyN",
            "terms-desc": "style__terms-desc___39PwA",
            "form-button": "style__form-button___2BWRW",
            "zh-enterprise-form-btn-margin":
              "style__zh-enterprise-form-btn-margin___2_9yE",
            "zh-enterprise-form-button":
              "style__zh-enterprise-form-button___2H0Ur",
            btn: "style__btn___3Hr69",
            "button-box": "style__button-box___3LH7o",
            "submit-btn": "style__submit-btn___23hy9",
            "check-box-group": "style__check-box-group____CzmU",
            "check-box": "style__check-box___3cDDa",
            "subscribe-check": "style__subscribe-check___3Zwp2",
            "form-check-box": "style__form-check-box___1MYUR",
            "tp-form-item": "style__tp-form-item___3uLaF",
            "check-box-group-column": "style__check-box-group-column___2vyuA",
            "check-box-group-column-pc-width":
              "style__check-box-group-column-pc-width___3kKU0",
            "check-box-group-column-mobile-width":
              "style__check-box-group-column-mobile-width___2VEAA",
            "check-box-group-column-mobile-width-overflow":
              "style__check-box-group-column-mobile-width-overflow___36src",
            "check-box-group-column-mobile-width-overflow-margin":
              "style__check-box-group-column-mobile-width-overflow-margin___dRV81",
            "nc-required": "style__nc-required___22ZZf",
            captcha: "style__captcha___2hod_",
            "captcha-no-show": "style__captcha-no-show___2pCBL",
            "zh-enterprise-captcha": "style__zh-enterprise-captcha___4tevy",
            "zh-enterprise-nc-container":
              "style__zh-enterprise-nc-container___2HOLY",
            "form-error": "style__form-error___1KBdi",
            "loading-circle": "style__loading-circle___EqDr_",
            "button-state": "style__button-state___2kGM4",
            "checkbox-item": "style__checkbox-item___1a3Lu",
            "modal-header": "style__modal-header___2Y1y5",
            "modal-logo": "style__modal-logo___2sqMS",
            "modal-title": "style__modal-title___2bFAu",
            "modal-body": "style__modal-body___2RblD",
            "new-modal-box-mobile": "style__new-modal-box-mobile___3vXQm",
            "new-modal-box": "style__new-modal-box___1B5ST",
            "new-modal-zh": "style__new-modal-zh___1QSQA",
            "new-modal-header": "style__new-modal-header___1sGsj",
            "new-modal-logo": "style__new-modal-logo___3X2ER",
            "fail-logo": "style__fail-logo___1yh21",
            "success-logo": "style__success-logo___2nBeZ",
            "new-modal-body": "style__new-modal-body___1BYWd",
            button: "style__button___1W0UV",
            "new-modal-text-box": "style__new-modal-text-box___2x2n5",
            "right-logo": "style__right-logo___1_TXI",
            RBtig: "style__RBtig___2PJNG",
            _2PzHu: "style___2PzHu___3rLV2",
            "nc-container": "style__nc-container___2GdOp",
            nc_wrapper: "style__nc_wrapper___cRr2i",
            nc_scale: "style__nc_scale___2lumZ",
            nc_iconfont: "style__nc_iconfont___3Mi2M",
            scale_text: "style__scale_text___3xsYY",
            scale_text2: "style__scale_text2___1dZfd",
            btn_ok: "style__btn_ok___3VA4U",
            "form-item-control-wrapper":
              "style__form-item-control-wrapper___2EWjR",
            "dji-pt-BR": "style__dji-pt-BR___TtclX",
            "dji-de": "style__dji-de___2nK9f",
            "dji-it": "style__dji-it___2dX6J",
            "dji-es": "style__dji-es___1Com4",
          },
        };
      function G(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function Y(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? G(Object(n), !0).forEach(function (t) {
                Object(c.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : G(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function q(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var X =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        Z = function (e, t) {
          if ("string" !== typeof e) return "";
          var n = e.replace(" *", "").replace("*", ""),
            o = t ? " *" : "";
          return "".concat(n).concat(o);
        },
        K = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t),
              ((n = q(this, t, [e])).state = {
                requiredTermsCheck: !1,
                optionalTermsCheck: !1,
                resultModalVisible: !1,
                resultSuccess: !1,
                needCaptcha: !1,
                showCaptchaError: !1,
                buttonLoading: !0,
                resultModalTitle: "",
                resultModalContent: "",
                focusArr: {
                  activity_name: !1,
                  activity_email: !1,
                  tel: !1,
                  company: !1,
                  city: !1,
                  message: !1,
                  industry: !1,
                  cityFoucs: !1,
                },
                hasValueArr: {
                  activity_name: !1,
                  activity_email: !1,
                  tel: !1,
                  company: !1,
                  city: !1,
                  message: !1,
                  industry: !1,
                },
                successModalClose: !1,
                industryTipShow: !0,
                companyTipShow: !0,
              }),
              (n.validateTerms = n.validateTerms.bind(Object(l.a)(n))),
              (n.handleSubmit = n.handleSubmit.bind(Object(l.a)(n))),
              (n.closeModal = n.closeModal.bind(Object(l.a)(n))),
              (n.onFocus = n.onFocus.bind(Object(l.a)(n))),
              n
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e,
                    t = this,
                    n = this.props,
                    o = n.localization,
                    a = n.t,
                    r = n.context.mobileMode,
                    i = n.component_data,
                    l = this.state.focusArr,
                    s = i.customFormItems,
                    c = void 0 === s ? [] : s,
                    _ = o;
                  (this.captcha = new C.a({
                    renderDom: "#captcha",
                    recordDomsId: ["activity_activity_type"],
                    width: "300",
                    localization: _,
                    t: a,
                    isMobile: r,
                  })),
                    this.captcha.init(function () {}),
                    this.captcha._getCaptchaNeeded(function (e) {
                      e && t.setState({ needCaptcha: !0 });
                    }),
                    null === c ||
                      void 0 === c ||
                      null ===
                        (e = c.filter(function (e) {
                          return e.key;
                        })) ||
                      void 0 === e ||
                      e.map(function (e) {
                        var t = e.key;
                        l[t] = !1;
                      }),
                    Object(b.pb)(function () {
                      t.setState({ buttonLoading: !1 });
                    });
                },
              },
              {
                key: "componentWillUpdate",
                value: function () {
                  var e = this,
                    t = document.getElementById("captcha-input");
                  t &&
                    t.addEventListener("\u03bfnblur", function () {
                      "pass" === e.captchaDom.value &&
                        e.setState({ showCaptchaError: !1 });
                    });
                },
              },
              {
                key: "validateTerms",
                value: function (e, t, n) {
                  var o = this.props.t;
                  t ? n() : n(o(H.FORM_KEY.MUST_SELECT_TIP));
                },
              },
              {
                key: "resetFormData",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.form,
                    o = "zh-CN" === t.localization.language;
                  this.setState({ successModalClose: !0 }),
                    setTimeout(function () {
                      e.setState(function (e) {
                        if (e.successModalClose)
                          return { successModalClose: !1 };
                      });
                    }, 300),
                    o && n.setFieldsValue({ continent: "Asia" }),
                    o && n.setFieldsValue({ activity_country: "cn" });
                  var a = document.getElementsByTagName("input"),
                    r = document.getElementsByTagName("textarea"),
                    i = Array.from(a),
                    l = Array.from(r),
                    s = document.getElementsByTagName("select"),
                    c = Array.from(s);
                  null === i ||
                    void 0 === i ||
                    i.map(function (e) {
                      e.value = "";
                    }),
                    null === l ||
                      void 0 === l ||
                      l.map(function (e) {
                        e.value = "";
                      }),
                    null === c ||
                      void 0 === c ||
                      c.map(function (e) {
                        e.value = "";
                      });
                },
              },
              {
                key: "closeModal",
                value: function () {
                  var e = this;
                  this.state.resultSuccess &&
                    (this.props.form.resetFields(),
                    this.resetFormData(),
                    this.handleChangeFocus(!1)),
                    this.setState({
                      resultModalVisible: !1,
                      requiredTermsCheck: !1,
                      optionalTermsCheck: !1,
                    }),
                    this.captcha.init(function (t) {
                      e.setState({ needCaptcha: t }), e.captcha.reload();
                    });
                },
              },
              {
                key: "handleChangeFocus",
                value: function (e) {
                  var t = this.state,
                    n = t.focusArr,
                    o = t.hasValueArr,
                    a = Object.keys(n),
                    r = Object.keys(o);
                  null === a ||
                    void 0 === a ||
                    a.map(function (t) {
                      n[t] = e;
                    }),
                    null === r ||
                      void 0 === r ||
                      r.map(function (t) {
                        o[t] = e;
                      }),
                    this.setState({
                      focusArr: n,
                      hasValueArr: o,
                      industryTipShow: !0,
                      companyTipShow: !0,
                    });
                },
              },
              {
                key: "handleSubmit",
                value: function (e) {
                  var t = this;
                  e.preventDefault();
                  var n = this.props,
                    o = n.localization,
                    a = n.form,
                    r = n.component_data,
                    i = n.gaSend,
                    l = r.hasSuccessText,
                    s = r.successTitle,
                    c = r.successDesc,
                    _ = r.hasErrorText,
                    u = r.errorTitle,
                    d = r.errorDesc;
                  this.onFocus("cityFoucs"),
                    this.setState({ industryTipShow: !1, companyTipShow: !1 }),
                    this.captcha.getResult()
                      ? this.setState({ showCaptchaError: !1 })
                      : this.setState({ showCaptchaError: !0 });
                  var p = this.captcha.getValidateParams();
                  a.validateFields(function (e, n) {
                    e &&
                      (e.terms && i("submit", H.FORMGATYPES.TERMS_REQUIRE),
                      i("submit", H.FORMGATYPES.REQUIRE),
                      (n.activity_activity_type += "-fail")),
                      !t.captcha.isCaptchaNeeded || t.captcha.pass
                        ? (e || t.setState({ buttonLoading: !0 }),
                          n.activity_email ||
                            (n.activity_email = "".concat(
                              Object(b.lb)(8),
                              "@dji.com",
                            )),
                          w.default
                            .request(
                              {
                                method: "POST",
                                name: "formSubmit",
                                data: Y(
                                  Y({}, n),
                                  {},
                                  {
                                    validate_params: JSON.stringify(p),
                                    activity_country: n.activity_country || "",
                                  },
                                ),
                              },
                              o,
                            )
                            .then(function (e) {
                              return e.json();
                            })
                            .then(function (o) {
                              e &&
                                t.captcha.init(function (e) {
                                  t.setState({ needCaptcha: e }),
                                    t.captcha.reload();
                                }),
                                o.success
                                  ? (t.setState({
                                      resultSuccess: !0,
                                      resultModalTitle:
                                        (l ? s : "") || H.FORM_KEY.successTitle,
                                      resultModalContent:
                                        (l ? c : "") || H.FORM_KEY.successDesc,
                                    }),
                                    e ||
                                      (window.dataLayer &&
                                        window.dataLayer &&
                                        window.dataLayer.push &&
                                        window.dataLayer.push({
                                          event: "form_submit_success",
                                          activityType:
                                            n.activity_activity_type || "",
                                        }),
                                      i("submit", H.FORMGATYPES.SUCCESS)))
                                  : (t.setState({
                                      resultSuccess: !1,
                                      resultModalTitle:
                                        (_ ? u : "") || H.FORM_KEY.errorTitle,
                                      resultModalContent:
                                        (_ ? d : "") || H.FORM_KEY.errorDesc,
                                    }),
                                    o.data && o.data.email && 422 === o.status
                                      ? i(
                                          "submit",
                                          H.FORMGATYPES.MORE_SUBMISSION,
                                        )
                                      : i("submit", H.FORMGATYPES.DEFAULT)),
                                t.setState({ buttonLoading: !1 }),
                                e || t.setState({ resultModalVisible: !0 });
                            }))
                        : i("submit", H.FORMGATYPES.CAPTCHA_VERIFICATION_FAIL);
                  });
                },
              },
              {
                key: "onFocus",
                value: function (e) {
                  var t = this.state.focusArr;
                  (t[e] = !0),
                    "industry" === e && this.setState({ industryTipShow: !1 }),
                    "company" === e && this.setState({ companyTipShow: !1 }),
                    this.setState({ focusArr: t }),
                    this.focusSend ||
                      (this.props.gaSend("active", e), (this.focusSend = !0));
                },
              },
              {
                key: "onBlur",
                value: function (e, t) {
                  var n = e.target.value,
                    o = this.state,
                    a = o.focusArr,
                    r = o.hasValueArr;
                  "industry" !== t && (a[t] = !1),
                    this.setState({ focusArr: a }),
                    n
                      ? ((r[t] = !0), this.setState({ hasValueArr: r }))
                      : ((r[t] = !1), this.setState({ hasValueArr: r }));
                },
              },
              {
                key: "renderInstitutions",
                value: function (e) {
                  var t = this.props,
                    n = t.t;
                  return (
                    "zh-CN" === t.localization.language && "enterprise" === e
                      ? H.INSTITUTION_TYPE_TO_OPTIONS.enterprise_cn
                      : H.INSTITUTION_TYPE_TO_OPTIONS[e] || []
                  ).map(function (e) {
                    var t = e.key,
                      o = e.labelTranslateKey;
                    return W("option", { value: n(t), key: t }, n(o));
                  });
                },
              },
              {
                key: "renderZhEndterpriseLabel",
                value: function (e, t, n, o) {
                  var a = this.props.t,
                    r = this.state,
                    i = r.focusArr,
                    l = r.hasValueArr;
                  return W(
                    "label",
                    {
                      htmlFor: e,
                      className: u()(
                        o
                          ? i[e] || l[e]
                            ? "form-input-label-focussend"
                            : "form-textarea-label"
                          : i[e] || l[e]
                            ? "form-input-label-focussend"
                            : "form-input-label",
                        U,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    Z(a(t), n),
                  );
                },
              },
              {
                key: "renderNewModal",
                value: function () {
                  var e = this.props,
                    t = e.context,
                    n = t.mobileMode,
                    o = t.subdomain,
                    a = e.t,
                    r = e.localization,
                    i = e.component_data,
                    l = i.hasSuccessLink,
                    s = i.successLinkTitle,
                    c = i.successLinkPath,
                    _ = r.country,
                    d = r.language,
                    p = this.state,
                    f = p.resultSuccess,
                    h = p.resultModalTitle,
                    m = p.resultModalContent,
                    y = p.resultModalVisible,
                    b = "zh-CN" === r.language;
                  return W(
                    j.a,
                    {
                      visible: y,
                      onCancel: this.closeModal,
                      onClose: this.closeModal,
                      type: "primary",
                      cancelText: "stay",
                      okText: "back to homepage",
                      footer: null,
                      size: n ? "small" : "",
                      className: u()(
                        b && (n ? "new-modal-box-mobile" : "new-modal-box"),
                        U,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    W(
                      "div",
                      { className: "style__new-modal-zh___1QSQA" },
                      W(
                        "div",
                        { className: "style__new-modal-header___1sGsj" },
                        W(
                          "div",
                          { className: "style__new-modal-logo___3X2ER" },
                          W(
                            "div",
                            f
                              ? { className: "style__success-logo___2nBeZ" }
                              : { className: "style__fail-logo___1yh21" },
                          ),
                        ),
                        W("h2", {
                          className: "style__modal-title___2bFAu",
                          dangerouslySetInnerHTML: { __html: a(h) },
                        }),
                      ),
                      W("div", {
                        className: "style__new-modal-body___1BYWd",
                        dangerouslySetInnerHTML: { __html: a(m) },
                      }),
                      f
                        ? W(
                            "div",
                            null,
                            l &&
                              W(
                                "a",
                                {
                                  href: Object(V.k)({
                                    domain: o,
                                    url:
                                      null === c || void 0 === c
                                        ? void 0
                                        : c.path,
                                    country: _,
                                    locale: d,
                                  }),
                                  target: "_blank",
                                },
                                W(
                                  "div",
                                  { className: "style__button___1W0UV" },
                                  W(
                                    "div",
                                    {
                                      className:
                                        "style__new-modal-text-box___2x2n5",
                                    },
                                    W(
                                      "span",
                                      null,
                                      a(s),
                                      W("div", {
                                        className: "style__right-logo___1_TXI",
                                      }),
                                    ),
                                  ),
                                ),
                              ),
                          )
                        : W(
                            "div",
                            { onClick: this.closeModal },
                            W(
                              "div",
                              { className: "style__button___1W0UV" },
                              W(
                                "div",
                                {
                                  className:
                                    "style__new-modal-text-box___2x2n5",
                                },
                                W(
                                  "span",
                                  null,
                                  a("v2.product.enterprise.contact.back"),
                                ),
                              ),
                            ),
                          ),
                    ),
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.form,
                    o = t.component_data,
                    a = t.t,
                    r = t.localization,
                    i = t.context.mobileMode,
                    l = t.gaSend,
                    s = n.getFieldDecorator,
                    c = this.state,
                    _ = c.requiredTermsCheck,
                    d = c.resultModalVisible,
                    p = c.needCaptcha,
                    f = c.showCaptchaError,
                    h = c.buttonLoading,
                    m = c.resultModalContent,
                    y = c.resultModalTitle,
                    v = c.optionalTermsCheck,
                    w = c.focusArr,
                    x = c.hasValueArr,
                    O = c.successModalClose,
                    S = c.industryTipShow,
                    C = c.companyTipShow,
                    P = o.activityType,
                    E = o.hasName,
                    L = o.hasEmail,
                    B = o.hasPhone,
                    N = o.hasCompany,
                    D = o.hasAddress,
                    z = o.hasInstitution,
                    A = o.hasRemark,
                    R = o.hasRequiredTerms,
                    V = o.hasOptionalTerms,
                    G = o.nameRequired,
                    q = o.emailCnNotRequired,
                    K = o.phoneRequired,
                    Q = o.companyRequired,
                    J = o.addressRequired,
                    $ = o.institutionType,
                    ee = o.institutionRequired,
                    te = o.requiredTerms,
                    ne = o.optionalTerms,
                    oe = o.customFormItems,
                    ae = void 0 === oe ? [] : oe,
                    re = $ === H.INSTITUTION_TYPE.AGRICULTURE,
                    ie = "zh-CN" === r.language,
                    le = !(q && "cn" === r.country.toLowerCase());
                  return W(
                    "section",
                    null,
                    W(
                      "div",
                      {
                        className: u()(
                          ie ? "form-box-zh-enterprise" : "form-box",
                          U,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      W(
                        T.a,
                        { form: n },
                        E &&
                          W(
                            "div",
                            {
                              className: u()(
                                "form-group ".concat(
                                  ie ? "form-group-zh-enterprise" : "",
                                ),
                                U,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            W(
                              T.b,
                              null,
                              s("activity_name", {
                                initialValue: "",
                                validateTrigger: "onBlur",
                                rules: [
                                  {
                                    required: G,
                                    whitespace: !0,
                                    message: a(
                                      ie
                                        ? H.FORM_KEY.NAME_ERROR_TIP
                                        : H.FORM_KEY.REQUIRED_TIP,
                                    ),
                                  },
                                ],
                              })(
                                W(
                                  "div",
                                  { error: "activity_name" },
                                  W("input", {
                                    placeholder:
                                      !ie && Z(a(H.FORM_KEY.NAME), G),
                                    type: "text",
                                    id: "activity_name",
                                    name: "activity_name",
                                    error: "activity_name",
                                    maxLength: "255",
                                    onFocus: function () {
                                      return e.onFocus("activity_name");
                                    },
                                    onBlur: function (t) {
                                      return e.onBlur(t, "activity_name");
                                    },
                                  }),
                                  ie
                                    ? this.renderZhEndterpriseLabel(
                                        "activity_name",
                                        H.FORM_KEY.NAME,
                                        G,
                                        !1,
                                      )
                                    : null,
                                ),
                              ),
                            ),
                          ),
                        B &&
                          W(
                            "div",
                            {
                              className: u()(
                                "form-group ".concat(
                                  ie ? "form-group-zh-enterprise" : "",
                                ),
                                U,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            W(
                              T.b,
                              null,
                              s("tel", {
                                initialValue: "",
                                validateTrigger: "onBlur",
                                rules: [
                                  {
                                    required: K,
                                    pattern: Object(b.J)(
                                      null === r || void 0 === r
                                        ? void 0
                                        : r.language,
                                    ),
                                    whitespace: !0,
                                    message: a(
                                      ie
                                        ? H.FORM_KEY.PHONE_ERROR_TIP
                                        : H.FORM_KEY.REQUIRED_TIP,
                                    ),
                                  },
                                ],
                              })(
                                W(
                                  "div",
                                  { error: "tel" },
                                  W("input", {
                                    placeholder:
                                      !ie && Z(a(H.FORM_KEY.PHONE), K),
                                    type: "text",
                                    error: "tel",
                                    name: "tel",
                                    maxLength: "255",
                                    onFocus: function () {
                                      return e.onFocus("tel");
                                    },
                                    onBlur: function (t) {
                                      return e.onBlur(t, "tel");
                                    },
                                  }),
                                  ie
                                    ? this.renderZhEndterpriseLabel(
                                        "tel",
                                        H.FORM_KEY.PHONE,
                                        K,
                                        !1,
                                      )
                                    : null,
                                ),
                              ),
                            ),
                          ),
                        L &&
                          !ie &&
                          W(
                            "div",
                            { className: "style__form-group___Ba9UW" },
                            W(
                              T.b,
                              null,
                              s("activity_email", {
                                rules: [
                                  {
                                    validator: function (e, t, n) {
                                      !t && le
                                        ? n(a(H.FORM_KEY.REQUIRED_TIP))
                                        : t && !t.match(X)
                                          ? (l(
                                              "click",
                                              H.FORMGATYPES
                                                .EMAIL_VERIFICATION_FAIL,
                                            ),
                                            n(a(H.FORM_KEY.EMAIL_ERROR_TIP)))
                                          : n();
                                    },
                                  },
                                ],
                                initialValue: "",
                                validateTrigger: "onBlur",
                              })(
                                W(
                                  "div",
                                  { error: "activity_email" },
                                  W("input", {
                                    placeholder: Z(a(H.FORM_KEY.EMAIL), le),
                                    type: "text",
                                    id: "activity_email",
                                    error: "activity_email",
                                    name: "activity_email",
                                    maxLength: "255",
                                  }),
                                ),
                              ),
                            ),
                          ),
                        N &&
                          W(
                            "div",
                            {
                              className: u()(
                                "form-group ".concat(
                                  ie ? "form-group-zh-enterprise" : "",
                                ),
                                U,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            W(
                              T.b,
                              null,
                              s("company", {
                                initialValue: "",
                                validateTrigger: "onBlur",
                                rules: [
                                  {
                                    required: Q,
                                    whitespace: !0,
                                    message: a(H.FORM_KEY.COMPANY_ERROR_TIP),
                                  },
                                ],
                              })(
                                W(
                                  "div",
                                  { error: "company" },
                                  W(
                                    "div",
                                    {
                                      className:
                                        "style__form-group-zh-enterprise-position___3gCpT",
                                    },
                                    W("input", {
                                      placeholder:
                                        !ie && Z(a(H.FORM_KEY.COMPANY), Q),
                                      type: "text",
                                      error: "company",
                                      name: "company",
                                      maxLength: "255",
                                      onFocus: function () {
                                        return e.onFocus("company");
                                      },
                                      onBlur: function (t) {
                                        return e.onBlur(t, "company");
                                      },
                                    }),
                                    ie
                                      ? this.renderZhEndterpriseLabel(
                                          "company",
                                          H.FORM_KEY.COMPANY,
                                          Q,
                                          !1,
                                        )
                                      : null,
                                  ),
                                  ie &&
                                    !(null === x || void 0 === x
                                      ? void 0
                                      : x.company) &&
                                    !(null === w || void 0 === w
                                      ? void 0
                                      : w.company) &&
                                    C &&
                                    W(
                                      "div",
                                      {
                                        className:
                                          "style__form-group-zh-enterprise-tip___23AhS",
                                      },
                                      a(H.FORM_KEY.COMPANY_ERROR_TIP),
                                    ),
                                ),
                              ),
                            ),
                          ),
                        z &&
                          W(
                            "div",
                            {
                              className: u()(
                                "form-group ".concat(
                                  ie ? "form-group-zh-enterprise" : "",
                                ),
                                U,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            W(
                              T.b,
                              null,
                              s("industry", {
                                initialValue: "",
                                validateTrigger: "onBlur",
                                rules: [
                                  {
                                    required: ee,
                                    whitespace: !0,
                                    message: a(
                                      ie
                                        ? H.FORM_KEY.INDUSTRY_ERROR_TIP
                                        : H.FORM_KEY.MUST_SELECT_TIP,
                                    ),
                                  },
                                ],
                              })(
                                W(
                                  "div",
                                  { error: "industry" },
                                  W(
                                    "div",
                                    { className: "style__select-box___mDy8I" },
                                    W(
                                      "select",
                                      {
                                        style: {
                                          border:
                                            ie &&
                                            "1px solid rgba(0, 0, 0, 0.15)",
                                        },
                                        name: "industry",
                                        onFocus: function () {
                                          e.onFocus("industry");
                                        },
                                        onBlur: function (t) {
                                          return e.onBlur(t, "industry");
                                        },
                                        className: u()(
                                          "select ".concat(
                                            ie &&
                                              ((
                                                null === w || void 0 === w
                                                  ? void 0
                                                  : w.industry
                                              )
                                                ? "form-group-zh-enterprise-select-label-show"
                                                : "form-group-zh-enterprise-select-font"),
                                          ),
                                          U,
                                          {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          },
                                        ),
                                      },
                                      W(
                                        "option",
                                        { value: "" },
                                        Z(
                                          a(
                                            re
                                              ? H.FORM_KEY.AG_IDENTITY
                                              : H.FORM_KEY.INSTITUTION,
                                          ),
                                          ee,
                                        ),
                                      ),
                                      this.renderInstitutions($),
                                    ),
                                    ie &&
                                      (null === w || void 0 === w
                                        ? void 0
                                        : w.industry)
                                      ? this.renderZhEndterpriseLabel(
                                          "industry",
                                          H.FORM_KEY.INSTITUTION,
                                          ee,
                                          !1,
                                        )
                                      : null,
                                    W(
                                      "div",
                                      { className: "style__icon___1sAIZ" },
                                      W(k.a, { name: "caret-down" }),
                                    ),
                                  ),
                                  ie &&
                                    !(null === x || void 0 === x
                                      ? void 0
                                      : x.industry) &&
                                    !(null === w || void 0 === w
                                      ? void 0
                                      : w.industry) &&
                                    S &&
                                    W(
                                      "div",
                                      {
                                        className:
                                          "style__form-group-zh-enterprise-tip___23AhS",
                                      },
                                      a(H.FORM_KEY.INDUSTRY_ERROR_TIP),
                                    ),
                                ),
                              ),
                            ),
                          ),
                        D &&
                          !ie &&
                          W(M.a, {
                            autoMatch: !0,
                            notRequired: !J,
                            removeContainer: !0,
                            form: n,
                            localization: r,
                            component_data: Y(
                              Y({}, o),
                              {},
                              {
                                promptRequire: H.FORM_KEY.REQUIRED_TIP,
                                continent: H.FORM_KEY.CONTINENT,
                                country: H.FORM_KEY.COUNTRY,
                                state: H.FORM_KEY.PROVINCE,
                                city: H.FORM_KEY.CITY,
                              },
                            ),
                            t: a,
                          }),
                        D &&
                          ie &&
                          W(F, {
                            successModalClose: O,
                            autoMatch: !0,
                            notRequired: !J,
                            cityFoucs: w.cityFoucs,
                            form: n,
                            localization: r,
                            mobileMode: i,
                            component_data: Y(
                              Y({}, o),
                              {},
                              {
                                promptRequire: H.FORM_KEY.REQUIRED_TIP,
                                continent: H.FORM_KEY.CONTINENT,
                                country: H.FORM_KEY.COUNTRY,
                                state: H.FORM_KEY.PROVINCE,
                                city: H.FORM_KEY.CITY,
                                city_error: H.FORM_KEY.CITY_ERROR_TIP,
                              },
                            ),
                            t: a,
                          }),
                        L &&
                          ie &&
                          W(
                            "div",
                            {
                              className: u()(
                                "form-group ".concat(
                                  ie
                                    ? "form-group-zh-enterprise cooperationIntention-zh-enterprise"
                                    : "",
                                ),
                                U,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            W(
                              T.b,
                              null,
                              s("activity_email", {
                                rules: [
                                  {
                                    validator: function (e, t, n) {
                                      !t && le
                                        ? n(a(H.FORM_KEY.REQUIRED_TIP))
                                        : t && !t.match(X)
                                          ? (l(
                                              "click",
                                              H.FORMGATYPES
                                                .EMAIL_VERIFICATION_FAIL,
                                            ),
                                            n(a(H.FORM_KEY.EMAIL_ERROR_TIP)))
                                          : n();
                                    },
                                  },
                                ],
                                initialValue: "",
                                validateTrigger: "onBlur",
                              })(
                                W(
                                  "div",
                                  { error: "activity_email" },
                                  W("input", {
                                    type: "text",
                                    id: "activity_email",
                                    error: "activity_email",
                                    name: "activity_email",
                                    maxLength: "255",
                                    onFocus: function () {
                                      return e.onFocus("activity_email");
                                    },
                                    onBlur: function (t) {
                                      return e.onBlur(t, "activity_email");
                                    },
                                  }),
                                  ie
                                    ? this.renderZhEndterpriseLabel(
                                        "activity_email",
                                        H.FORM_KEY.EMAIL,
                                        le,
                                        !1,
                                      )
                                    : null,
                                ),
                              ),
                            ),
                          ),
                        (ae || [])
                          .filter(function (e) {
                            return e.key;
                          })
                          .map(function (t) {
                            var n = t.key,
                              o = t.labelKey,
                              r = t.required,
                              i = t.type;
                            return (
                              n &&
                              W(
                                "div",
                                {
                                  key: n,
                                  className: u()(
                                    "form-group "
                                      .concat(
                                        "textArea" === i
                                          ? "cooperationIntention"
                                          : "",
                                        " ",
                                      )
                                      .concat(
                                        ie
                                          ? "cooperationIntention-zh-enterprise form-group-zh-enterprise"
                                          : "",
                                      ),
                                    U,
                                    {
                                      autoResolveMultipleImports: !0,
                                      handleMissingStyleName: "warn",
                                    },
                                  ),
                                },
                                W(
                                  T.b,
                                  null,
                                  "textArea" === i
                                    ? s(n, {
                                        initialValue: "",
                                        validateTrigger: "onBlur",
                                        rules: [
                                          {
                                            required: r,
                                            whitespace: !0,
                                            message: a(H.FORM_KEY.REQUIRED_TIP),
                                          },
                                        ],
                                      })(
                                        W(
                                          "div",
                                          { error: n },
                                          W("textarea", {
                                            placeholder: !ie && Z(a(o), r),
                                            type: "text",
                                            error: n,
                                            name: n,
                                            maxLength: "255",
                                            onFocus: function () {
                                              return e.onFocus(n);
                                            },
                                            onBlur: function (t) {
                                              return e.onBlur(t, n);
                                            },
                                          }),
                                          ie
                                            ? e.renderZhEndterpriseLabel(
                                                n,
                                                o,
                                                r,
                                                !0,
                                              )
                                            : null,
                                        ),
                                      )
                                    : s(n, {
                                        initialValue: "",
                                        validateTrigger: "onBlur",
                                        rules: [
                                          {
                                            required: r,
                                            whitespace: !0,
                                            message: a(H.FORM_KEY.REQUIRED_TIP),
                                          },
                                        ],
                                      })(
                                        W(
                                          "div",
                                          { error: n },
                                          W("input", {
                                            placeholder: !ie && Z(a(o), r),
                                            type: "text",
                                            error: n,
                                            name: n,
                                            maxLength: "255",
                                            onFocus: function () {
                                              return e.onFocus(n);
                                            },
                                            onBlur: function (t) {
                                              return e.onBlur(t, n);
                                            },
                                          }),
                                          ie
                                            ? e.renderZhEndterpriseLabel(
                                                n,
                                                o,
                                                r,
                                                !1,
                                              )
                                            : null,
                                        ),
                                      ),
                                ),
                              )
                            );
                          }),
                        A &&
                          W(
                            "div",
                            {
                              className: u()(
                                "form-group cooperationIntention ".concat(
                                  ie
                                    ? "cooperationIntention-zh-enterprise form-group-zh-enterprise"
                                    : "",
                                ),
                                U,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            W(
                              T.b,
                              null,
                              s(
                                "message",
                                {},
                              )(
                                W(
                                  "div",
                                  null,
                                  W("textarea", {
                                    placeholder: !ie && Z(a(H.FORM_KEY.REMARK)),
                                    type: "text",
                                    error: "message",
                                    name: "message",
                                    maxLength: "255",
                                    id: "message",
                                    onFocus: function () {
                                      return e.onFocus("message");
                                    },
                                    onBlur: function (t) {
                                      return e.onBlur(t, "message");
                                    },
                                  }),
                                  ie
                                    ? this.renderZhEndterpriseLabel(
                                        "message",
                                        H.FORM_KEY.REMARK,
                                        null,
                                        !0,
                                      )
                                    : null,
                                ),
                              ),
                            ),
                          ),
                        ie
                          ? null
                          : W(
                              "div",
                              {
                                className:
                                  "captcha style__form-group___Ba9UW style__captcha___2hod_",
                              },
                              W("div", { id: "captcha" }),
                              p &&
                                W("input", {
                                  ref: function (t) {
                                    e.captchaDom = t;
                                  },
                                  name: "captcha-input",
                                  className: "style__nc-required___22ZZf",
                                  id: "captcha-input",
                                }),
                              f
                                ? W(
                                    "div",
                                    {
                                      className: "style__form-error___1KBdi",
                                      style: { height: "16px" },
                                    },
                                    W(k.a, { name: "times-circle" }),
                                    a(H.FORM_KEY.VALIDATE_CODE_SLIDE_TIP),
                                  )
                                : W("div", {
                                    className: "style__form-error___1KBdi",
                                  }),
                            ),
                        W(
                          "div",
                          {
                            className: u()(
                              "check-box-group "
                                .concat(
                                  ie ? "check-box-group-column" : "form-group",
                                  " ",
                                )
                                .concat(
                                  ie
                                    ? "".concat(
                                        i
                                          ? " check-box-group-column-mobile-width"
                                          : "check-box-group-column-pc-width",
                                      )
                                    : "",
                                ),
                              U,
                              {
                                autoResolveMultipleImports: !0,
                                handleMissingStyleName: "warn",
                              },
                            ),
                          },
                          W(
                            "div",
                            {
                              className:
                                "captcha " +
                                u()(
                                  "".concat(
                                    ie
                                      ? "zh-enterprise-captcha"
                                      : "captcha-no-show",
                                    " form-group captcha",
                                  ),
                                  U,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                            },
                            W("div", {
                              id: "captcha",
                              className:
                                "style__zh-enterprise-nc-container___2HOLY",
                            }),
                            p &&
                              W("input", {
                                ref: function (t) {
                                  e.captchaDom = t;
                                },
                                name: "captcha-input",
                                className: "style__nc-required___22ZZf",
                                id: "captcha-input",
                              }),
                            f
                              ? W(
                                  "div",
                                  {
                                    className: "style__form-error___1KBdi",
                                    style: { height: "16px" },
                                  },
                                  W(k.a, { name: "times-circle" }),
                                  a(H.FORM_KEY.VALIDATE_CODE_SLIDE_TIP),
                                )
                              : W("div", {
                                  className: "style__form-error___1KBdi",
                                }),
                          ),
                          V &&
                            W(
                              "div",
                              {
                                className: u()(
                                  "".concat(
                                    ie &&
                                      (i
                                        ? "check-box-group-column-mobile-width-overflow"
                                        : "check-box-group-column-mobile-width-overflow-margin"),
                                    " form-check-box subscribe-check",
                                  ),
                                  U,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                              },
                              W(
                                T.b,
                                null,
                                s("subscribe", {
                                  valuePropName: "checked",
                                  initialValue: !1,
                                })(
                                  W(
                                    "div",
                                    {
                                      className: "style__check-box___3cDDa",
                                      error: "subscribe",
                                    },
                                    W("input", {
                                      type: "checkbox",
                                      className: "style__checkbox-item___1a3Lu",
                                      onClick: function (t) {
                                        e.setState({
                                          optionalTermsCheck: t.target.checked,
                                        });
                                      },
                                      checked: v,
                                      onFocus: function () {
                                        return e.onFocus("subscribe");
                                      },
                                    }),
                                    W("span", {
                                      className: "style__terms-desc___39PwA",
                                      dangerouslySetInnerHTML: {
                                        __html: a(ne),
                                      },
                                    }),
                                  ),
                                ),
                              ),
                            ),
                          R &&
                            W(
                              "div",
                              {
                                className: u()(
                                  "".concat(
                                    ie &&
                                      (i
                                        ? "check-box-group-column-mobile-width-overflow"
                                        : "check-box-group-column-mobile-width-overflow-margin"),
                                    " form-check-box",
                                  ),
                                  U,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                              },
                              W(
                                T.b,
                                null,
                                s("terms", {
                                  rules: [{ validator: this.validateTerms }],
                                  valuePropName: "checked",
                                  initialValue: !1,
                                })(
                                  W(
                                    "div",
                                    {
                                      className: "style__check-box___3cDDa",
                                      error: "terms",
                                    },
                                    W("input", {
                                      type: "checkbox",
                                      className: "style__checkbox-item___1a3Lu",
                                      onClick: function (t) {
                                        e.setState({
                                          requiredTermsCheck: t.target.checked,
                                        });
                                      },
                                      checked: _,
                                      onFocus: function () {
                                        return e.onFocus("terms");
                                      },
                                    }),
                                    W("span", {
                                      className: "style__terms-desc___39PwA",
                                      dangerouslySetInnerHTML: {
                                        __html: a(te),
                                      },
                                    }),
                                  ),
                                ),
                              ),
                            ),
                        ),
                        W(
                          T.b,
                          { hide: !0 },
                          s("activity_activity_type", { initialValue: P })(
                            W("input", {
                              error: "activity_activity_type",
                              name: "activity_activity_type",
                              id: "activity_activity_type",
                            }),
                          ),
                        ),
                        W(
                          "div",
                          {
                            className: u()(
                              g()({
                                "button-state": h,
                                "form-button": !0,
                                "zh-enterprise-form-btn-margin": ie,
                              }),
                              U,
                              {
                                autoResolveMultipleImports: !0,
                                handleMissingStyleName: "warn",
                              },
                            ),
                          },
                          W(
                            I.a,
                            {
                              block: !0,
                              size: "md",
                              type: "brand",
                              value: "Submit",
                              onClick: this.handleSubmit,
                              className: u()(
                                "".concat(
                                  ie ? "zh-enterprise-form-button" : "",
                                  " btn",
                                ),
                                U,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            W(
                              "div",
                              { className: "style__button-box___3LH7o" },
                              h
                                ? W("span", {
                                    className: "style__loading-circle___EqDr_",
                                  })
                                : "",
                              W(
                                "span",
                                { className: "style__submit-btn___23hy9" },
                                a(o.buttonTitle) || a(H.FORM_KEY.SUBMIT),
                              ),
                            ),
                          ),
                        ),
                      ),
                      d &&
                        (ie
                          ? this.renderNewModal()
                          : W(
                              j.a,
                              {
                                visible: d,
                                onCancel: this.closeModal,
                                onClose: this.closeModal,
                                type: "primary",
                                cancelText: "stay",
                                okText: "back to homepage",
                                footer: null,
                                size: i ? "mini" : "",
                              },
                              W(
                                "div",
                                null,
                                W(
                                  "div",
                                  { className: "style__modal-header___2Y1y5" },
                                  W("img", {
                                    className: "style__modal-logo___2sqMS",
                                    src: "https://www1.djicdn.com/dps/c3da0b151f83761820db2f7a9701177f.png",
                                    alt: "",
                                  }),
                                  W("h2", {
                                    className: "style__modal-title___2bFAu",
                                    dangerouslySetInnerHTML: { __html: a(y) },
                                  }),
                                ),
                                W("div", {
                                  className: "style__modal-body___2RblD",
                                  dangerouslySetInnerHTML: { __html: a(m) },
                                }),
                              ),
                            )),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(p.a.Component);
      Object(c.a)(K, "defaultProps", {
        t: function () {},
        component_data: {},
        form: [],
      });
      var Q = T.a.create()(
          Object(f.a)(
            Object(h.b)(function (e) {
              return { localization: e.localization, context: e.context };
            })(K),
          ),
        ),
        J = d.createElement,
        $ = {
          "./style.css": {
            "form-group-zh-enterprise":
              "style__form-group-zh-enterprise___2hZjx",
            "form-box-zh-enterprise": "style__form-box-zh-enterprise___3D8TF",
            "form-group-zh-enterprise-select-label-show":
              "style__form-group-zh-enterprise-select-label-show___3nYZs",
            "form-group-zh-enterprise-position":
              "style__form-group-zh-enterprise-position___3gCpT",
            "form-group-zh-enterprise-tip":
              "style__form-group-zh-enterprise-tip___23AhS",
            "form-group-zh-enterprise-select-font":
              "style__form-group-zh-enterprise-select-font___2Q86l",
            "section-form-component": "style__section-form-component___ZZNnU",
            loading: "style__loading___3Vcdn",
            "zh-enterprise-text-box": "style__zh-enterprise-text-box___28SMI",
            "text-box": "style__text-box___319Qy",
            title: "style__title___1j1t2",
            desc: "style__desc___11r5B",
            "form-box": "style__form-box___2decN",
            "form-group": "style__form-group___Ba9UW",
            icon: "style__icon___1sAIZ",
            "form-input-label": "style__form-input-label___3Vf-B",
            "form-input-label-focussend":
              "style__form-input-label-focussend___38jS8",
            "form-textarea-label": "style__form-textarea-label___oevt-",
            "select-box": "style__select-box___mDy8I",
            select: "style__select___1tanE",
            cooperationIntention: "style__cooperationIntention___2tWj3",
            "cooperationIntention-zh-enterprise":
              "style__cooperationIntention-zh-enterprise___3_HRI",
            margin: "style__margin___1FhgI",
            "no-margin": "style__no-margin___1meyN",
            "terms-desc": "style__terms-desc___39PwA",
            "form-button": "style__form-button___2BWRW",
            "zh-enterprise-form-btn-margin":
              "style__zh-enterprise-form-btn-margin___2_9yE",
            "zh-enterprise-form-button":
              "style__zh-enterprise-form-button___2H0Ur",
            btn: "style__btn___3Hr69",
            "button-box": "style__button-box___3LH7o",
            "submit-btn": "style__submit-btn___23hy9",
            "check-box-group": "style__check-box-group____CzmU",
            "check-box": "style__check-box___3cDDa",
            "subscribe-check": "style__subscribe-check___3Zwp2",
            "form-check-box": "style__form-check-box___1MYUR",
            "tp-form-item": "style__tp-form-item___3uLaF",
            "check-box-group-column": "style__check-box-group-column___2vyuA",
            "check-box-group-column-pc-width":
              "style__check-box-group-column-pc-width___3kKU0",
            "check-box-group-column-mobile-width":
              "style__check-box-group-column-mobile-width___2VEAA",
            "check-box-group-column-mobile-width-overflow":
              "style__check-box-group-column-mobile-width-overflow___36src",
            "check-box-group-column-mobile-width-overflow-margin":
              "style__check-box-group-column-mobile-width-overflow-margin___dRV81",
            "nc-required": "style__nc-required___22ZZf",
            captcha: "style__captcha___2hod_",
            "captcha-no-show": "style__captcha-no-show___2pCBL",
            "zh-enterprise-captcha": "style__zh-enterprise-captcha___4tevy",
            "zh-enterprise-nc-container":
              "style__zh-enterprise-nc-container___2HOLY",
            "form-error": "style__form-error___1KBdi",
            "loading-circle": "style__loading-circle___EqDr_",
            "button-state": "style__button-state___2kGM4",
            "checkbox-item": "style__checkbox-item___1a3Lu",
            "modal-header": "style__modal-header___2Y1y5",
            "modal-logo": "style__modal-logo___2sqMS",
            "modal-title": "style__modal-title___2bFAu",
            "modal-body": "style__modal-body___2RblD",
            "new-modal-box-mobile": "style__new-modal-box-mobile___3vXQm",
            "new-modal-box": "style__new-modal-box___1B5ST",
            "new-modal-zh": "style__new-modal-zh___1QSQA",
            "new-modal-header": "style__new-modal-header___1sGsj",
            "new-modal-logo": "style__new-modal-logo___3X2ER",
            "fail-logo": "style__fail-logo___1yh21",
            "success-logo": "style__success-logo___2nBeZ",
            "new-modal-body": "style__new-modal-body___1BYWd",
            button: "style__button___1W0UV",
            "new-modal-text-box": "style__new-modal-text-box___2x2n5",
            "right-logo": "style__right-logo___1_TXI",
            RBtig: "style__RBtig___2PJNG",
            _2PzHu: "style___2PzHu___3rLV2",
            "nc-container": "style__nc-container___2GdOp",
            nc_wrapper: "style__nc_wrapper___cRr2i",
            nc_scale: "style__nc_scale___2lumZ",
            nc_iconfont: "style__nc_iconfont___3Mi2M",
            scale_text: "style__scale_text___3xsYY",
            scale_text2: "style__scale_text2___1dZfd",
            btn_ok: "style__btn_ok___3VA4U",
            "form-item-control-wrapper":
              "style__form-item-control-wrapper___2EWjR",
            "dji-pt-BR": "style__dji-pt-BR___TtclX",
            "dji-de": "style__dji-de___2nK9f",
            "dji-it": "style__dji-it___2dX6J",
            "dji-es": "style__dji-es___1Com4",
          },
        };
      function ee(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var te = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = ee(this, t, [e])).state = {}),
            (n.timer = null),
            (n.handleAnchorJump = n.handleAnchorJump.bind(Object(l.a)(n))),
            (n.handleLoadEventLister = n.handleLoadEventLister.bind(
              Object(l.a)(n),
            )),
            (n.handleScrollEventLister = y()(
              n.handleScrollEventLister.bind(Object(l.a)(n)),
              300,
            )),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                this.handleAnchorJump();
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                window.removeEventListener("load", this.handleLoadEventLister),
                  window.removeEventListener(
                    "scroll",
                    this.handleScrollEventLister,
                  );
              },
            },
            {
              key: "handleAnchorJump",
              value: function () {
                if (b.Q) {
                  var e = this.props.component_data,
                    t = window.location.hash,
                    n = window.location.pathname,
                    o = !1;
                  ("" !== window.name && window.name === n) ||
                    ((o = !0), (window.name = n)),
                    t === "#".concat(e.formAnchor) &&
                      o &&
                      "complete" !== document.readyState &&
                      window.addEventListener(
                        "load",
                        this.handleLoadEventLister,
                        { passive: !0 },
                      );
                }
              },
            },
            {
              key: "handleLoadEventLister",
              value: function () {
                this.handleScrollEventLister(),
                  window.addEventListener(
                    "scroll",
                    this.handleScrollEventLister,
                    { passive: !0 },
                  );
              },
            },
            {
              key: "handleScrollEventLister",
              value: function () {
                var e = this,
                  t = document.documentElement.scrollTop;
                this.timer && clearTimeout(this.timer),
                  (this.timer = setTimeout(function () {
                    t === document.documentElement.scrollTop &&
                      (e.formDom.scrollIntoView(),
                      window.removeEventListener(
                        "scroll",
                        e.handleScrollEventLister,
                      ),
                      clearTimeout(e.timer));
                  }, 300));
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.t,
                  o = t.gaSend,
                  a = t.component_data,
                  r = t.context,
                  i = t.localization,
                  l = (r || {}).mobileMode,
                  s = a || {},
                  c = s.formAnchor,
                  _ = s.formTitle,
                  d = s.formDesc,
                  p = s.activityType,
                  f = l ? "50px" : "0",
                  h = a.paddingTop || f,
                  m = a.paddingBottom || "48px",
                  y = "zh-CN" === i.language;
                return J(
                  "section",
                  {
                    id: c || "",
                    className: "style__section-form-component___ZZNnU",
                    style: { paddingBottom: m, paddingTop: h },
                    onMouseOver: function () {
                      e.mouseEntered || (o("show", p), (e.mouseEntered = !0));
                    },
                    ref: function (t) {
                      e.formDom = t;
                    },
                  },
                  J(
                    "div",
                    {
                      className: u()(
                        "".concat(
                          y ? "zh-enterprise-text-box" : "",
                          " text-box",
                        ),
                        $,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    J("h1", {
                      className: "style__title___1j1t2",
                      dangerouslySetInnerHTML: { __html: n(_) },
                    }),
                    J("p", {
                      className: "style__desc___11r5B",
                      dangerouslySetInnerHTML: { __html: n(d) },
                    }),
                  ),
                  J(
                    "div",
                    { className: "style__form-box___2decN" },
                    J(Q, { component_data: a, t: n, gaSend: o }),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(d.Component);
      Object(c.a)(te, "defaultProps", {
        t: function () {},
        gaSend: function () {},
        component_data: {
          activityType: "",
          formAnchor: "contact-us",
          formTitle: "\u8868\u5355\u6807\u9898",
          formDesc:
            "\u83b7\u53d6\u6211\u4eec\u7684\u6700\u65b0\u52a8\u6001\uff0c\u6216\u7559\u4e0b\u8054\u7cfb\u65b9\u5f0f\uff0c\u4ee5\u4fbf\u6211\u4eec\u8fdb\u4e00\u6b65\u4e0e\u60a8\u6c9f\u901a\u8bf7\u8054\u7cfb\u60a8\u9644\u8fd1\u7684\u4ee3\u7406\u5546\uff0c\u6216\u5728\u4e0b\u65b9\u7559\u4e0b\u60a8\u7684\u8054\u7cfb\u65b9\u5f0f\uff0c\u6211\u4eec\u5c06\u5c3d\u5feb\u4e0e\u60a8\u8054\u7cfb\u3002",
          hasName: !0,
          nameRequired: !0,
          hasEmail: !0,
          emailCnNotRequired: !0,
          hasPhone: !0,
          phoneRequired: !0,
          hasCompany: !0,
          companyRequired: !0,
          hasAddress: !0,
          addressRequired: !0,
          hasInstitution: !0,
          institutionType: "enterprise",
          institutionRequired: !0,
          hasRemark: !0,
          hasRequiredTerms: !0,
          requiredTerms: "v2.product.enterprise.contact.form.terms",
          hasOptionalTerms: !0,
          optionalTerms: "v2.product.enterprise.contact.form.newsletter",
          customFormItems: [],
          hasSuccessText: !0,
          hasSuccessLink: !1,
          buttonTitle: "",
          successTitle: H.FORM_KEY.successTitle,
          successLinkTitle: "",
          successLinkPath: "/find-a-dealer",
          successDesc: H.FORM_KEY.successDesc,
          hasErrorText: !0,
          errorTitle: H.FORM_KEY.errorTitle,
          errorDesc: H.FORM_KEY.errorDesc,
          paddingTop: "0px",
          paddingBottom: "48px",
        },
      }),
        Object(c.a)(te, "editSetting", {
          key: "customForm",
          name: "customForm",
          contentSetting: {
            form: {
              label: "\u8868\u5355\u5fc5\u586b\u4fe1\u606f",
              props: {
                activityType: {
                  label: "\u8868\u5355 activity_type",
                  type: "string",
                },
                formAnchor: {
                  type: "string",
                  label: "\u8868\u5355\u951a\u70b9",
                },
                formTitle: {
                  type: "string",
                  content: "text",
                  label: "\u8868\u5355\u6807\u9898",
                },
                formDesc: {
                  type: "string",
                  content: "text",
                  label: "\u8868\u5355\u63cf\u8ff0",
                },
              },
            },
            style: {
              label: "\u6837\u5f0f\u8c03\u6574",
              props: {
                paddingTop: {
                  label:
                    '\u4e0a\u8fb9\u8ddd\uff0cPC\u9ed8\u8ba4"0px",M\u7aef\u9ed8\u8ba4"50px", \u9700\u5e26\u5355\u4f4d(\u5982\u8bbe\u7f6e\u4e86\u951a\u70b9M\u7aef\u8bf7\u8bbe\u7f6e\u5927\u4e8e50px)',
                  type: "string",
                },
                paddingBottom: {
                  label:
                    '\u4e0b\u8fb9\u8ddd\uff0c\u9ed8\u8ba4 "48px", \u5e26\u5355\u4f4d',
                  type: "string",
                },
              },
            },
            name: {
              switch: "hasName",
              label: "\u59d3\u540d",
              props: {
                nameRequired: {
                  type: "boolean",
                  label: "\u59d3\u540d\u662f\u5426\u5fc5\u586b",
                },
              },
            },
            email: {
              switch: "hasEmail",
              label: "\u90ae\u7bb1",
              props: {
                emailCnNotRequired: {
                  type: "boolean",
                  label: "\u4e2d\u6587\u8bbe\u7f6e\u4e3a\u975e\u5fc5\u586b",
                },
              },
            },
            phone: {
              switch: "hasPhone",
              label: "\u624b\u673a",
              props: {
                phoneRequired: {
                  type: "boolean",
                  label: "\u662f\u5426\u5fc5\u586b",
                },
              },
            },
            company: {
              switch: "hasCompany",
              label: "\u516c\u53f8",
              props: {
                companyRequired: {
                  type: "boolean",
                  label: "\u662f\u5426\u5fc5\u586b",
                },
              },
            },
            address: {
              switch: "hasAddress",
              label: "\u5730\u5740",
              props: {
                addressRequired: {
                  type: "boolean",
                  label: "\u662f\u5426\u5fc5\u586b",
                },
              },
            },
            institution: {
              switch: "hasInstitution",
              label: "\u884c\u4e1a",
              props: {
                institutionType: {
                  label: "\u884c\u4e1a\u9009\u62e9\u5668\u7c7b\u578b",
                  type: "select",
                  items: [
                    {
                      label: "\u884c\u4e1a",
                      value: H.INSTITUTION_TYPE.ENTERPRISE,
                    },
                    {
                      label: "\u519c\u4e1a",
                      value: H.INSTITUTION_TYPE.AGRICULTURE,
                    },
                    {
                      label: "\u6559\u80b2",
                      value: H.INSTITUTION_TYPE.EDUCATION,
                    },
                    {
                      label: "\u8fd0\u8f7d",
                      value: H.INSTITUTION_TYPE.DELIVERY,
                    },
                  ],
                },
                institutionRequired: {
                  type: "boolean",
                  label: "\u662f\u5426\u5fc5\u586b",
                },
              },
            },
            remark: {
              label: "\u5907\u6ce8",
              props: { hasRemark: { type: "boolean", label: "\u5907\u6ce8" } },
            },
            requiredTerms: {
              switch: "hasRequiredTerms",
              label: "\u5fc5\u9009\u6761\u6b3e",
              props: {
                requiredTerms: {
                  type: "string",
                  content: "text",
                  label: "\u5fc5\u9009\u6761\u6b3e\u5185\u5bb9",
                },
              },
            },
            optionalTerms: {
              switch: "hasOptionalTerms",
              label: "\u975e\u5fc5\u9009\u6761\u6b3e",
              props: {
                optionalTerms: {
                  type: "string",
                  content: "text",
                  label: "\u975e\u5fc5\u9009\u6761\u6b3e\u5185\u5bb9",
                },
              },
            },
            customFormPart: {
              label: "\u81ea\u5b9a\u4e49\u5b57\u6bb5",
              props: {
                customFormItems: {
                  label: "\u81ea\u5b9a\u4e49\u5b57\u6bb5\u7ec4",
                  type: "array",
                  props: {
                    key: {
                      label:
                        '\u5b57\u6bb5\u6570\u636eKey (\u82f1\u6587\u5355\u8bcd\uff0c\u8bf7\u4e0d\u8981\u5e26"."\u6216\u5176\u4ed6\u5b57\u7b26, \u5982\u65b0\u589e\u5b57\u6bb5\uff0c\u4e14\u6709\u63a8\u9001\u7b49\u4e1a\u52a1\u903b\u8f91\u8bf7\u8054\u7cfb\u4ea7\u54c1\u4e0e\u5f00\u53d1\u662f\u5426\u9700\u8981\u66f4\u6539\u903b\u8f91, \u8be5\u9879\u4e0d\u586b\u5199\u65f6\u8868\u5355\u9879\u4e0d\u4f1a\u51fa\u73b0)',
                      type: "string",
                    },
                    labelKey: {
                      label: "\u5b57\u6bb5\u6807\u9898\u7ffb\u8bd1key",
                      content: "text",
                      type: "string",
                    },
                    required: {
                      label: "\u662f\u5426\u5fc5\u586b",
                      type: "boolean",
                    },
                    type: {
                      label: "\u81ea\u5b9a\u4e49\u8868\u683c\u7c7b\u578b",
                      type: "select",
                      items: [
                        { label: "input", value: "input" },
                        { label: "textArea", value: "textArea" },
                      ],
                    },
                  },
                },
              },
            },
            successText: {
              switch: "hasSuccessText",
              label:
                "\u662f\u5426\u81ea\u5b9a\u4e49\u63d0\u4ea4\u6210\u529f\u63d0\u793a\u8bed",
              props: {
                successTitle: {
                  label:
                    "\u63d0\u4ea4\u6210\u529f\u63d0\u793a\u8bed-\u6807\u9898",
                  type: "string",
                  content: "text",
                },
                successDesc: {
                  label:
                    "\u63d0\u4ea4\u6210\u529f\u63d0\u793a\u8bed-\u63cf\u8ff0",
                  type: "string",
                  content: "text",
                },
              },
            },
            errorText: {
              switch: "hasErrorText",
              label:
                "\u662f\u5426\u81ea\u5b9a\u4e49\u63d0\u4ea4\u5931\u8d25\u63d0\u793a\u8bed",
              props: {
                errorTitle: {
                  label:
                    "\u63d0\u4ea4\u5931\u8d25\u63d0\u793a\u8bed-\u6807\u9898",
                  type: "string",
                  content: "text",
                },
                errorDesc: {
                  label:
                    "\u63d0\u4ea4\u5931\u8d25\u63d0\u793a\u8bed-\u63cf\u8ff0",
                  type: "string",
                  content: "text",
                },
              },
            },
            newBtnKey: {
              label: "\u63d0\u4ea4\u6309\u94ae\u6587\u6848",
              props: {
                buttonTitle: {
                  label: "\u6309\u94ae-\u6587\u6848",
                  type: "string",
                  content: "text",
                },
              },
            },
            successLink: {
              switch: "hasSuccessLink",
              label:
                "\u662f\u5426\u81ea\u5b9a\u4e49\u6210\u529f\u5f39\u7a97\u7684\u8df3\u8f6c\u94fe\u63a5",
              props: {
                successLinkTitle: {
                  label: "\u94fe\u63a5-\u6807\u9898",
                  type: "string",
                  content: "text",
                },
                successLinkPath: {
                  label: "\u94fe\u63a5-\u5730\u5740",
                  type: "string",
                  content: "url",
                },
              },
            },
          },
          skinSetting: {},
          defaultKeys: H.PREFETCH_KEYS,
        });
      t.a = Object(f.a)(
        Object(h.b)(function (e) {
          return { localization: e.localization, context: e.context };
        })(te),
      );
    },
    "b/8j": function (e, t, n) {
      var o, a, r, i, l, s;
      "undefined" != typeof self && self,
        (e.exports =
          ((o = n("q1tI")),
          (a = n("17x9")),
          (r = n("TSYQ")),
          (i = n("1w3K")),
          (l = n("i8i4")),
          (s = n("9/5/")),
          (function (e) {
            function t(o) {
              if (n[o]) return n[o].exports;
              var a = (n[o] = { i: o, l: !1, exports: {} });
              return (
                e[o].call(a.exports, a, a.exports, t), (a.l = !0), a.exports
              );
            }
            var n = {};
            return (
              (t.m = e),
              (t.c = n),
              (t.d = function (e, n, o) {
                t.o(e, n) ||
                  Object.defineProperty(e, n, {
                    configurable: !1,
                    enumerable: !0,
                    get: o,
                  });
              }),
              (t.n = function (e) {
                var n =
                  e && e.__esModule
                    ? function () {
                        return e.default;
                      }
                    : function () {
                        return e;
                      };
                return t.d(n, "a", n), n;
              }),
              (t.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }),
              (t.p = ""),
              t((t.s = 226))
            );
          })([
            function (e, t) {
              var n = (e.exports =
                "undefined" != typeof window && window.Math == Math
                  ? window
                  : "undefined" != typeof self && self.Math == Math
                    ? self
                    : Function("return this")());
              "number" == typeof __g && (__g = n);
            },
            function (e, t) {
              var n = (e.exports = { version: "2.5.3" });
              "number" == typeof __e && (__e = n);
            },
            function (e, t, n) {
              e.exports = !n(8)(function () {
                return (
                  7 !=
                  Object.defineProperty({}, "a", {
                    get: function () {
                      return 7;
                    },
                  }).a
                );
              });
            },
            function (e, t) {
              e.exports = function (e) {
                return "object" == typeof e
                  ? null !== e
                  : "function" == typeof e;
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(32),
                r = n(21),
                i = Object.defineProperty;
              t.f = n(2)
                ? Object.defineProperty
                : function (e, t, n) {
                    if ((o(e), (t = r(t, !0)), o(n), a))
                      try {
                        return i(e, t, n);
                      } catch (e) {}
                    if ("get" in n || "set" in n)
                      throw TypeError("Accessors not supported!");
                    return "value" in n && (e[t] = n.value), e;
                  };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e) {
                if (!o(e)) throw TypeError(e + " is not an object!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(35),
                a = n(30);
              e.exports = function (e) {
                return o(a(e));
              };
            },
            function (e, t) {
              var n = {}.hasOwnProperty;
              e.exports = function (e, t) {
                return n.call(e, t);
              };
            },
            function (e, t) {
              e.exports = function (e) {
                try {
                  return !!e();
                } catch (e) {
                  return !0;
                }
              };
            },
            function (e, t) {
              e.exports = o;
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(27),
                i = n(18),
                l = "prototype",
                s = function (e, t, n) {
                  var c,
                    _,
                    u,
                    d = e & s.F,
                    p = e & s.G,
                    f = e & s.S,
                    h = e & s.P,
                    m = e & s.B,
                    y = e & s.W,
                    b = p ? a : a[t] || (a[t] = {}),
                    v = b[l],
                    g = p ? o : f ? o[t] : (o[t] || {})[l];
                  for (c in (p && (n = t), n))
                    ((_ = !d && g && void 0 !== g[c]) && c in b) ||
                      ((u = _ ? g[c] : n[c]),
                      (b[c] =
                        p && "function" != typeof g[c]
                          ? n[c]
                          : m && _
                            ? r(u, o)
                            : y && g[c] == u
                              ? (function (e) {
                                  var t = function (t, n, o) {
                                    if (this instanceof e) {
                                      switch (arguments.length) {
                                        case 0:
                                          return new e();
                                        case 1:
                                          return new e(t);
                                        case 2:
                                          return new e(t, n);
                                      }
                                      return new e(t, n, o);
                                    }
                                    return e.apply(this, arguments);
                                  };
                                  return (t[l] = e[l]), t;
                                })(u)
                              : h && "function" == typeof u
                                ? r(Function.call, u)
                                : u),
                      h &&
                        (((b.virtual || (b.virtual = {}))[c] = u),
                        e & s.R && v && !v[c] && i(v, c, u)));
                };
              (s.F = 1),
                (s.G = 2),
                (s.S = 4),
                (s.P = 8),
                (s.B = 16),
                (s.W = 32),
                (s.U = 64),
                (s.R = 128),
                (e.exports = s);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22);
              e.exports =
                Object.keys ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t) {
              e.exports = a;
            },
            function (e, t, n) {
              e.exports = { default: n(49), __esModule: !0 };
            },
            function (e, t, n) {
              e.exports = { default: n(51), __esModule: !0 };
            },
            function (e, t) {
              t.f = {}.propertyIsEnumerable;
            },
            function (e, t, n) {
              e.exports = { default: n(57), __esModule: !0 };
            },
            function (e, t) {
              var n = 0,
                o = Math.random();
              e.exports = function (e) {
                return "Symbol(".concat(
                  void 0 === e ? "" : e,
                  ")_",
                  (++n + o).toString(36),
                );
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(20);
              e.exports = n(2)
                ? function (e, t, n) {
                    return o.f(e, t, a(1, n));
                  }
                : function (e, t, n) {
                    return (e[t] = n), e;
                  };
            },
            function (e, t, n) {
              var o = n(25)("wks"),
                a = n(17),
                r = n(0).Symbol,
                i = "function" == typeof r;
              (e.exports = function (e) {
                return (
                  o[e] || (o[e] = (i && r[e]) || (i ? r : a)("Symbol." + e))
                );
              }).store = o;
            },
            function (e, t) {
              e.exports = function (e, t) {
                return {
                  enumerable: !(1 & e),
                  configurable: !(2 & e),
                  writable: !(4 & e),
                  value: t,
                };
              };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e, t) {
                if (!o(e)) return e;
                var n, a;
                if (
                  t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
                  return a;
                if (
                  !t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                throw TypeError("Can't convert object to primitive value");
              };
            },
            function (e, t) {
              e.exports =
                "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                  ",",
                );
            },
            function (e, t) {
              e.exports = r;
            },
            function (e, t, n) {
              e.exports = { default: n(60), __esModule: !0 };
            },
            function (e, t, n) {
              var o = n(0),
                a = "__core-js_shared__",
                r = o[a] || (o[a] = {});
              e.exports = function (e) {
                return r[e] || (r[e] = {});
              };
            },
            function (e, t) {
              t.f = Object.getOwnPropertySymbols;
            },
            function (e, t, n) {
              var o = n(42);
              e.exports = function (e, t, n) {
                if ((o(e), void 0 === t)) return e;
                switch (n) {
                  case 1:
                    return function (n) {
                      return e.call(t, n);
                    };
                  case 2:
                    return function (n, o) {
                      return e.call(t, n, o);
                    };
                  case 3:
                    return function (n, o, a) {
                      return e.call(t, n, o, a);
                    };
                }
                return function () {
                  return e.apply(t, arguments);
                };
              };
            },
            function (e, t) {
              var n = Math.ceil,
                o = Math.floor;
              e.exports = function (e) {
                return isNaN((e = +e)) ? 0 : (e > 0 ? o : n)(e);
              };
            },
            function (e, t, n) {
              var o = n(25)("keys"),
                a = n(17);
              e.exports = function (e) {
                return o[e] || (o[e] = a(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if (void 0 == e) throw TypeError("Can't call method on  " + e);
                return e;
              };
            },
            function (e, t, n) {
              var o = n(3),
                a = n(0).document,
                r = o(a) && o(a.createElement);
              e.exports = function (e) {
                return r ? a.createElement(e) : {};
              };
            },
            function (e, t, n) {
              e.exports =
                !n(2) &&
                !n(8)(function () {
                  return (
                    7 !=
                    Object.defineProperty(n(31)("div"), "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
            },
            function (e, t) {
              var n = {}.toString;
              e.exports = function (e) {
                return n.call(e).slice(8, -1);
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(48),
                r = n(22),
                i = n(29)("IE_PROTO"),
                l = function () {},
                s = "prototype",
                c = function () {
                  var e,
                    t = n(31)("iframe"),
                    o = r.length;
                  for (
                    t.style.display = "none",
                      n(44).appendChild(t),
                      t.src = "javascript:",
                      (e = t.contentWindow.document).open(),
                      e.write("<script>document.F=Object</script>"),
                      e.close(),
                      c = e.F;
                    o--;

                  )
                    delete c[s][r[o]];
                  return c();
                };
              e.exports =
                Object.create ||
                function (e, t) {
                  var n;
                  return (
                    null !== e
                      ? ((l[s] = o(e)),
                        (n = new l()),
                        (l[s] = null),
                        (n[i] = e))
                      : (n = c()),
                    void 0 === t ? n : a(n, t)
                  );
                };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports = Object("z").propertyIsEnumerable(0)
                ? Object
                : function (e) {
                    return "String" == o(e) ? e.split("") : Object(e);
                  };
            },
            function (e, t, n) {
              var o = n(7),
                a = n(6),
                r = n(46)(!1),
                i = n(29)("IE_PROTO");
              e.exports = function (e, t) {
                var n,
                  l = a(e),
                  s = 0,
                  c = [];
                for (n in l) n != i && o(l, n) && c.push(n);
                for (; t.length > s; )
                  o(l, (n = t[s++])) && (~r(c, n) || c.push(n));
                return c;
              };
            },
            function (e, t, n) {
              var o = n(15),
                a = n(20),
                r = n(6),
                i = n(21),
                l = n(7),
                s = n(32),
                c = Object.getOwnPropertyDescriptor;
              t.f = n(2)
                ? c
                : function (e, t) {
                    if (((e = r(e)), (t = i(t, !0)), s))
                      try {
                        return c(e, t);
                      } catch (e) {}
                    if (l(e, t)) return a(!o.f.call(e, t), e[t]);
                  };
            },
            function (e, t) {
              e.exports = !0;
            },
            function (e, t, n) {
              t.f = n(19);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22).concat("length", "prototype");
              t.f =
                Object.getOwnPropertyNames ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t, n) {
              var o = n(30);
              e.exports = function (e) {
                return Object(o(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if ("function" != typeof e)
                  throw TypeError(e + " is not a function!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.min;
              e.exports = function (e) {
                return e > 0 ? a(o(e), 9007199254740991) : 0;
              };
            },
            function (e, t, n) {
              var o = n(0).document;
              e.exports = o && o.documentElement;
            },
            function (e, t, n) {
              var o = n(4).f,
                a = n(7),
                r = n(19)("toStringTag");
              e.exports = function (e, t, n) {
                e &&
                  !a((e = n ? e : e.prototype), r) &&
                  o(e, r, { configurable: !0, value: t });
              };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(43),
                r = n(47);
              e.exports = function (e) {
                return function (t, n, i) {
                  var l,
                    s = o(t),
                    c = a(s.length),
                    _ = r(i, c);
                  if (e && n != n) {
                    for (; c > _; ) if ((l = s[_++]) != l) return !0;
                  } else
                    for (; c > _; _++)
                      if ((e || _ in s) && s[_] === n) return e || _ || 0;
                  return !e && -1;
                };
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.max,
                r = Math.min;
              e.exports = function (e, t) {
                return (e = o(e)) < 0 ? a(e + t, 0) : r(e, t);
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(5),
                r = n(11);
              e.exports = n(2)
                ? Object.defineProperties
                : function (e, t) {
                    a(e);
                    for (var n, i = r(t), l = i.length, s = 0; l > s; )
                      o.f(e, (n = i[s++]), t[n]);
                    return e;
                  };
            },
            function (e, t, n) {
              n(50);
              var o = n(1).Object;
              e.exports = function (e, t) {
                return o.create(e, t);
              };
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { create: n(34) });
            },
            function (e, t, n) {
              n(52), (e.exports = n(1).Object.setPrototypeOf);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { setPrototypeOf: n(53).set });
            },
            function (e, t, n) {
              var o = n(3),
                a = n(5),
                r = function (e, t) {
                  if ((a(e), !o(t) && null !== t))
                    throw TypeError(t + ": can't set as prototype!");
                };
              e.exports = {
                set:
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function (e, t, o) {
                        try {
                          (o = n(27)(
                            Function.call,
                            n(37).f(Object.prototype, "__proto__").set,
                            2,
                          ))(e, []),
                            (t = !(e instanceof Array));
                        } catch (e) {
                          t = !0;
                        }
                        return function (e, n) {
                          return r(e, n), t ? (e.__proto__ = n) : o(e, n), e;
                        };
                      })({}, !1)
                    : void 0),
                check: r,
              };
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(38),
                i = n(39),
                l = n(4).f;
              e.exports = function (e) {
                var t = a.Symbol || (a.Symbol = r ? {} : o.Symbol || {});
                "_" == e.charAt(0) || e in t || l(t, e, { value: i.f(e) });
              };
            },
            function (e, t, n) {
              e.exports = n(18);
            },
            function (e, t, n) {
              "use strict";
              var o = n(0),
                a = n(7),
                r = n(2),
                i = n(10),
                l = n(55),
                s = n(61).KEY,
                c = n(8),
                _ = n(25),
                u = n(45),
                d = n(17),
                p = n(19),
                f = n(39),
                h = n(54),
                m = n(62),
                y = n(63),
                b = n(5),
                v = n(3),
                g = n(6),
                w = n(21),
                x = n(20),
                k = n(34),
                O = n(64),
                I = n(37),
                S = n(4),
                j = n(11),
                T = I.f,
                C = S.f,
                M = O.f,
                P = o.Symbol,
                E = o.JSON,
                L = E && E.stringify,
                B = "prototype",
                N = p("_hidden"),
                D = p("toPrimitive"),
                z = {}.propertyIsEnumerable,
                A = _("symbol-registry"),
                R = _("symbols"),
                F = _("op-symbols"),
                V = Object[B],
                H = "function" == typeof P,
                W = o.QObject,
                U = !W || !W[B] || !W[B].findChild,
                G =
                  r &&
                  c(function () {
                    return (
                      7 !=
                      k(
                        C({}, "a", {
                          get: function () {
                            return C(this, "a", { value: 7 }).a;
                          },
                        }),
                      ).a
                    );
                  })
                    ? function (e, t, n) {
                        var o = T(V, t);
                        o && delete V[t],
                          C(e, t, n),
                          o && e !== V && C(V, t, o);
                      }
                    : C,
                Y = function (e) {
                  var t = (R[e] = k(P[B]));
                  return (t._k = e), t;
                },
                q =
                  H && "symbol" == typeof P.iterator
                    ? function (e) {
                        return "symbol" == typeof e;
                      }
                    : function (e) {
                        return e instanceof P;
                      },
                X = function (e, t, n) {
                  return (
                    e === V && X(F, t, n),
                    b(e),
                    (t = w(t, !0)),
                    b(n),
                    a(R, t)
                      ? (n.enumerable
                          ? (a(e, N) && e[N][t] && (e[N][t] = !1),
                            (n = k(n, { enumerable: x(0, !1) })))
                          : (a(e, N) || C(e, N, x(1, {})), (e[N][t] = !0)),
                        G(e, t, n))
                      : C(e, t, n)
                  );
                },
                Z = function (e, t) {
                  b(e);
                  for (var n, o = m((t = g(t))), a = 0, r = o.length; r > a; )
                    X(e, (n = o[a++]), t[n]);
                  return e;
                },
                K = function (e) {
                  var t = z.call(this, (e = w(e, !0)));
                  return (
                    !(this === V && a(R, e) && !a(F, e)) &&
                    (!(
                      t ||
                      !a(this, e) ||
                      !a(R, e) ||
                      (a(this, N) && this[N][e])
                    ) ||
                      t)
                  );
                },
                Q = function (e, t) {
                  if (
                    ((e = g(e)), (t = w(t, !0)), e !== V || !a(R, t) || a(F, t))
                  ) {
                    var n = T(e, t);
                    return (
                      !n ||
                        !a(R, t) ||
                        (a(e, N) && e[N][t]) ||
                        (n.enumerable = !0),
                      n
                    );
                  }
                },
                J = function (e) {
                  for (var t, n = M(g(e)), o = [], r = 0; n.length > r; )
                    a(R, (t = n[r++])) || t == N || t == s || o.push(t);
                  return o;
                },
                $ = function (e) {
                  for (
                    var t, n = e === V, o = M(n ? F : g(e)), r = [], i = 0;
                    o.length > i;

                  )
                    !a(R, (t = o[i++])) || (n && !a(V, t)) || r.push(R[t]);
                  return r;
                };
              H ||
                (l(
                  (P = function () {
                    if (this instanceof P)
                      throw TypeError("Symbol is not a constructor!");
                    var e = d(arguments.length > 0 ? arguments[0] : void 0),
                      t = function (n) {
                        this === V && t.call(F, n),
                          a(this, N) && a(this[N], e) && (this[N][e] = !1),
                          G(this, e, x(1, n));
                      };
                    return (
                      r && U && G(V, e, { configurable: !0, set: t }), Y(e)
                    );
                  })[B],
                  "toString",
                  function () {
                    return this._k;
                  },
                ),
                (I.f = Q),
                (S.f = X),
                (n(40).f = O.f = J),
                (n(15).f = K),
                (n(26).f = $),
                r && !n(38) && l(V, "propertyIsEnumerable", K, !0),
                (f.f = function (e) {
                  return Y(p(e));
                })),
                i(i.G + i.W + i.F * !H, { Symbol: P });
              for (
                var ee =
                    "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
                      ",",
                    ),
                  te = 0;
                ee.length > te;

              )
                p(ee[te++]);
              for (var ne = j(p.store), oe = 0; ne.length > oe; ) h(ne[oe++]);
              i(i.S + i.F * !H, "Symbol", {
                for: function (e) {
                  return a(A, (e += "")) ? A[e] : (A[e] = P(e));
                },
                keyFor: function (e) {
                  if (!q(e)) throw TypeError(e + " is not a symbol!");
                  for (var t in A) if (A[t] === e) return t;
                },
                useSetter: function () {
                  U = !0;
                },
                useSimple: function () {
                  U = !1;
                },
              }),
                i(i.S + i.F * !H, "Object", {
                  create: function (e, t) {
                    return void 0 === t ? k(e) : Z(k(e), t);
                  },
                  defineProperty: X,
                  defineProperties: Z,
                  getOwnPropertyDescriptor: Q,
                  getOwnPropertyNames: J,
                  getOwnPropertySymbols: $,
                }),
                E &&
                  i(
                    i.S +
                      i.F *
                        (!H ||
                          c(function () {
                            var e = P();
                            return (
                              "[null]" != L([e]) ||
                              "{}" != L({ a: e }) ||
                              "{}" != L(Object(e))
                            );
                          })),
                    "JSON",
                    {
                      stringify: function (e) {
                        for (var t, n, o = [e], a = 1; arguments.length > a; )
                          o.push(arguments[a++]);
                        if (((n = t = o[1]), (v(t) || void 0 !== e) && !q(e)))
                          return (
                            y(t) ||
                              (t = function (e, t) {
                                if (
                                  ("function" == typeof n &&
                                    (t = n.call(this, e, t)),
                                  !q(t))
                                )
                                  return t;
                              }),
                            (o[1] = t),
                            L.apply(E, o)
                          );
                      },
                    },
                  ),
                P[B][D] || n(18)(P[B], D, P[B].valueOf),
                u(P, "Symbol"),
                u(Math, "Math", !0),
                u(o.JSON, "JSON", !0);
            },
            function (e, t, n) {
              n(58), (e.exports = n(1).Object.assign);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S + o.F, "Object", { assign: n(59) });
            },
            function (e, t, n) {
              "use strict";
              var o = n(11),
                a = n(26),
                r = n(15),
                i = n(41),
                l = n(35),
                s = Object.assign;
              e.exports =
                !s ||
                n(8)(function () {
                  var e = {},
                    t = {},
                    n = Symbol(),
                    o = "abcdefghijklmnopqrst";
                  return (
                    (e[n] = 7),
                    o.split("").forEach(function (e) {
                      t[e] = e;
                    }),
                    7 != s({}, e)[n] || Object.keys(s({}, t)).join("") != o
                  );
                })
                  ? function (e, t) {
                      for (
                        var n = i(e),
                          s = arguments.length,
                          c = 1,
                          _ = a.f,
                          u = r.f;
                        s > c;

                      )
                        for (
                          var d,
                            p = l(arguments[c++]),
                            f = _ ? o(p).concat(_(p)) : o(p),
                            h = f.length,
                            m = 0;
                          h > m;

                        )
                          u.call(p, (d = f[m++])) && (n[d] = p[d]);
                      return n;
                    }
                  : s;
            },
            function (e, t, n) {
              n(56), (e.exports = n(1).Object.getOwnPropertySymbols);
            },
            function (e, t, n) {
              var o = n(17)("meta"),
                a = n(3),
                r = n(7),
                i = n(4).f,
                l = 0,
                s =
                  Object.isExtensible ||
                  function () {
                    return !0;
                  },
                c = !n(8)(function () {
                  return s(Object.preventExtensions({}));
                }),
                _ = function (e) {
                  i(e, o, { value: { i: "O" + ++l, w: {} } });
                },
                u = (e.exports = {
                  KEY: o,
                  NEED: !1,
                  fastKey: function (e, t) {
                    if (!a(e))
                      return "symbol" == typeof e
                        ? e
                        : ("string" == typeof e ? "S" : "P") + e;
                    if (!r(e, o)) {
                      if (!s(e)) return "F";
                      if (!t) return "E";
                      _(e);
                    }
                    return e[o].i;
                  },
                  getWeak: function (e, t) {
                    if (!r(e, o)) {
                      if (!s(e)) return !0;
                      if (!t) return !1;
                      _(e);
                    }
                    return e[o].w;
                  },
                  onFreeze: function (e) {
                    return c && u.NEED && s(e) && !r(e, o) && _(e), e;
                  },
                });
            },
            function (e, t, n) {
              var o = n(11),
                a = n(26),
                r = n(15);
              e.exports = function (e) {
                var t = o(e),
                  n = a.f;
                if (n)
                  for (var i, l = n(e), s = r.f, c = 0; l.length > c; )
                    s.call(e, (i = l[c++])) && t.push(i);
                return t;
              };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports =
                Array.isArray ||
                function (e) {
                  return "Array" == o(e);
                };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(40).f,
                r = {}.toString,
                i =
                  "object" == typeof window &&
                  window &&
                  Object.getOwnPropertyNames
                    ? Object.getOwnPropertyNames(window)
                    : [];
              e.exports.f = function (e) {
                return i && "[object Window]" == r.call(e)
                  ? (function (e) {
                      try {
                        return a(e);
                      } catch (e) {
                        return i.slice();
                      }
                    })(e)
                  : a(o(e));
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = a(n(71)),
                p = o(n(73)),
                f = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                h =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                m = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                y = n(74),
                b = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    f(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        n = e.name,
                        o = e.className,
                        a = m(e, ["name", "className"]),
                        r = (0, u.default)(
                          (p || {})["" + t.classNamePrefix + n],
                          o,
                        );
                      return c.createElement(
                        d.default,
                        h({ className: r, fontFamily: y.fontFamily }, a),
                      );
                    }),
                    (t.classNamePrefix = "icon-"),
                    (t.propTypes = {
                      name: _.default.string.isRequired,
                      spin: _.default.bool,
                      className: _.default.string,
                    }),
                    t
                  );
                })(c.PureComponent);
              t.default = b;
            },
            function (e, t) {
              e.exports = {};
            },
            ,
            function (e, t) {
              e.exports = i;
            },
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 }),
                (t.default = {
                  genTransitionClassNames: function (e, t) {
                    return {
                      appear: t[e + "-appear"] || "",
                      appearActive: t[e + "-appear-active"] || "",
                      enter: t[e + "-enter"] || "",
                      enterActive: t[e + "-enter-active"] || "",
                      enterDone: t[e + "-enter-done"] || "",
                      exit: t[e + "-exit"] || "",
                      exitActive: t[e + "-exit-active"] || "",
                      exitDone: t[e + "-exit-done"] || "",
                    };
                  },
                });
            },
            function (e, t) {
              e.exports = l;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14)),
                c = o(n(9)),
                _ = a(n(12)),
                u = a(n(23)),
                d = o(n(72)),
                p = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                m = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    p(t, e),
                    (t.prototype.render = function () {
                      var e,
                        t = this.props,
                        n = t.className,
                        o = t.fontFamily,
                        a = t.style,
                        r = t.spin,
                        l = h(t, ["className", "fontFamily", "style", "spin"]),
                        s = (0, u.default)(
                          n,
                          d.icon,
                          (((e = {})[d.spin] = !!r), e),
                        ),
                        _ = (0, i.default)({}, a, { fontFamily: o });
                      return c.createElement(
                        "i",
                        f({ className: s, style: _ }, l),
                      );
                    }),
                    (t.propTypes = {
                      classNames: _.default.object,
                      fontFamily: _.default.string,
                      spin: _.default.bool,
                    }),
                    (t.defaultProps = { fontFamily: "iconfont" }),
                    t
                  );
                })(c.PureComponent);
              t.default = m;
            },
            function (e, t) {
              e.exports = {
                icon: "_3c0Qz",
                spin: "_1j2v0",
                "icon-spin": "-lu88",
                iconSpin: "-lu88",
              };
            },
            function (e, t) {
              e.exports = {
                "icon-address-book": "_35bgc",
                iconAddressBook: "_35bgc",
                "icon-address-card": "byXrR",
                iconAddressCard: "byXrR",
                "icon-adjust": "_128ri",
                iconAdjust: "_128ri",
                "icon-check-alt-light": "_1KHsi",
                iconCheckAltLight: "_1KHsi",
                "icon-coins-light": "_2bT-Y",
                iconCoinsLight: "_2bT-Y",
                "icon-exclamation-circle-light": "_3UEZX",
                iconExclamationCircleLight: "_3UEZX",
                "icon-loading-alt-light": "_1fXKU",
                iconLoadingAltLight: "_1fXKU",
                "icon-instagram": "_2OZ_n",
                iconInstagram: "_2OZ_n",
                "icon-minus-light": "_6cr8a",
                iconMinusLight: "_6cr8a",
                "icon-ticket-alt": "ZAGKa",
                iconTicketAlt: "ZAGKa",
                "icon-ticket-alt-light": "_1lH5w",
                iconTicketAltLight: "_1lH5w",
                "icon-plus-light": "_3BSr4",
                iconPlusLight: "_3BSr4",
                "icon-truck": "_4wlbR",
                iconTruck: "_4wlbR",
                "icon-trash-alt-light": "_26SUY",
                iconTrashAltLight: "_26SUY",
                "icon-times-circle": "_30-mD",
                iconTimesCircle: "_30-mD",
                "icon-vimeo-v": "_1_xvC",
                iconVimeoV: "_1_xvC",
                "icon-twitter": "_17P2f",
                iconTwitter: "_17P2f",
                "icon-youtube": "_2I_EY",
                iconYoutube: "_2I_EY",
                "icon-caret-down": "_3qb3s",
                iconCaretDown: "_3qb3s",
                "icon-caret-up": "_2jwD5",
                iconCaretUp: "_2jwD5",
                "icon-comments-o": "_19X43",
                iconCommentsO: "_19X43",
                "icon-download-o": "_2WwM4",
                iconDownloadO: "_2WwM4",
                "icon-info-circle-o": "_1shcg",
                iconInfoCircleO: "_1shcg",
                "icon-external-link-o": "_1qLWd",
                iconExternalLinkO: "_1qLWd",
                "icon-globe-o": "Z8Prc",
                iconGlobeO: "Z8Prc",
                "icon-question-o": "_3MItB",
                iconQuestionO: "_3MItB",
                "icon-play-circle-o": "_2Bvn6",
                iconPlayCircleO: "_2Bvn6",
                "icon-angle-double-left": "_3IVo_",
                iconAngleDoubleLeft: "_3IVo_",
                "icon-angle-down": "_34FGS",
                iconAngleDown: "_34FGS",
                "icon-angle-double-right": "_3e62_",
                iconAngleDoubleRight: "_3e62_",
                "icon-angle-left": "_1zbhS",
                iconAngleLeft: "_1zbhS",
                "icon-angle-right": "_27RtX",
                iconAngleRight: "_27RtX",
                "icon-angle-up": "jhfcy",
                iconAngleUp: "jhfcy",
                "icon-arrival-reminder": "Q82xM",
                iconArrivalReminder: "Q82xM",
                "icon-ban": "_1vyf0",
                iconBan: "_1vyf0",
                "icon-bullhorn": "B0IHZ",
                iconBullhorn: "B0IHZ",
                "icon-bars": "_2cpQ_",
                iconBars: "_2cpQ_",
                "icon-caret-left-o": "_2FImd",
                iconCaretLeftO: "_2FImd",
                "icon-caret-down-o": "_3wXJB",
                iconCaretDownO: "_3wXJB",
                "icon-caret-right-o": "_2fXyR",
                iconCaretRightO: "_2fXyR",
                "icon-caret-up-o": "_2KLCQ",
                iconCaretUpO: "_2KLCQ",
                "icon-cart": "_-4DAY",
                iconCart: "_-4DAY",
                "icon-certificate": "_2I4g3",
                iconCertificate: "_2I4g3",
                "icon-check-circle-o": "_1m5z7",
                iconCheckCircleO: "_1m5z7",
                "icon-check-square-o": "_1vR3p",
                iconCheckSquareO: "_1vR3p",
                "icon-check": "_2LJ7o",
                iconCheck: "_2LJ7o",
                "icon-circle-notch": "_3AQSX",
                iconCircleNotch: "_3AQSX",
                "icon-clock": "_3ASBw",
                iconClock: "_3ASBw",
                "icon-cog": "_6eszT",
                iconCog: "_6eszT",
                "icon-cloud-upload": "_1WxHW",
                iconCloudUpload: "_1WxHW",
                "icon-coins": "_2uv1U",
                iconCoins: "_2uv1U",
                "icon-compare": "_3s-NW",
                iconCompare: "_3s-NW",
                "icon-comment-alt-smile": "_1ZzVY",
                iconCommentAltSmile: "_1ZzVY",
                "icon-copy": "OBwuW",
                iconCopy: "OBwuW",
                "icon-compress": "_2Ri-k",
                iconCompress: "_2Ri-k",
                "icon-coupon": "_1588m",
                iconCoupon: "_1588m",
                "icon-credit-card": "_2uIqb",
                iconCreditCard: "_2uIqb",
                "icon-download": "_1P5xZ",
                iconDownload: "_1P5xZ",
                "icon-edit": "_2iuBX",
                iconEdit: "_2iuBX",
                "icon-ellipsis-h": "_1exha",
                iconEllipsisH: "_1exha",
                "icon-education": "_3bokS",
                iconEducation: "_3bokS",
                "icon-envelope": "vMM-Y",
                iconEnvelope: "vMM-Y",
                "icon-ellipsis-v": "_3jZwp",
                iconEllipsisV: "_3jZwp",
                "icon-exclamation-circle": "_2SUQ-",
                iconExclamationCircle: "_2SUQ-",
                "icon-exclamation": "_1Piil",
                iconExclamation: "_1Piil",
                "icon-exclamation-square": "_20oXE",
                iconExclamationSquare: "_20oXE",
                "icon-external-link": "_2gTe8",
                iconExternalLink: "_2gTe8",
                "icon-expand": "okv_Y",
                iconExpand: "okv_Y",
                "icon-eye": "_3l-6g",
                iconEye: "_3l-6g",
                "icon-file-alt": "OhY9C",
                iconFileAlt: "OhY9C",
                "icon-facebook": "Cb5jY",
                iconFacebook: "Cb5jY",
                "icon-file": "_1ajFe",
                iconFile: "_1ajFe",
                "icon-file-pdf": "ve2KQ",
                iconFilePdf: "ve2KQ",
                "icon-frame": "_3OU3j",
                iconFrame: "_3OU3j",
                "icon-globe": "lgV2x",
                iconGlobe: "lgV2x",
                "icon-headset": "_1gQtG",
                iconHeadset: "_1gQtG",
                "icon-heart-o": "_3Zaag",
                iconHeartO: "_3Zaag",
                "icon-home": "_33jTA",
                iconHome: "_33jTA",
                "icon-image-view": "_1jJbn",
                iconImageView: "_1jJbn",
                "icon-info-square": "UuxAk",
                iconInfoSquare: "UuxAk",
                "icon-info-circle": "_1OEuY",
                iconInfoCircle: "_1OEuY",
                "icon-info": "Lm_MF",
                iconInfo: "Lm_MF",
                "icon-language": "_3LwbN",
                iconLanguage: "_3LwbN",
                "icon-link": "_2XN05",
                iconLink: "_2XN05",
                "icon-list-view": "_33OcX",
                iconListView: "_33OcX",
                "icon-location-arrow": "bMc_E",
                iconLocationArrow: "bMc_E",
                "icon-list": "IAlEP",
                iconList: "IAlEP",
                "icon-location": "_25GQ2",
                iconLocation: "_25GQ2",
                "icon-lock-alt": "_3t3HT",
                iconLockAlt: "_3t3HT",
                "icon-map-marked-alt": "_2W_XA",
                iconMapMarkedAlt: "_2W_XA",
                "icon-map-marker-alt": "_3NPLS",
                iconMapMarkerAlt: "_3NPLS",
                "icon-minus": "UhwjW",
                iconMinus: "UhwjW",
                "icon-paperclip": "_2hDpl",
                iconPaperclip: "_2hDpl",
                "icon-order": "dCZz2",
                iconOrder: "dCZz2",
                "icon-play-circle": "_1FMUV",
                iconPlayCircle: "_1FMUV",
                "icon-phone": "_2H8bj",
                iconPhone: "_2H8bj",
                "icon-plus": "_3KkpT",
                iconPlus: "_3KkpT",
                "icon-purchase": "_23p5a",
                iconPurchase: "_23p5a",
                "icon-question-circle": "_18A_e",
                iconQuestionCircle: "_18A_e",
                "icon-qrcode": "gf_rb",
                iconQrcode: "gf_rb",
                "icon-search-minus": "_1Djb6",
                iconSearchMinus: "_1Djb6",
                "icon-search": "_3d-6G",
                iconSearch: "_3d-6G",
                "icon-setup": "_1fawl",
                iconSetup: "_1fawl",
                "icon-search-plus": "_20uY7",
                iconSearchPlus: "_20uY7",
                "icon-tag": "_2Z6dE",
                iconTag: "_2Z6dE",
                "icon-share": "_1c3Qh",
                iconShare: "_1c3Qh",
                "icon-times-circle-o": "_1GlZx",
                iconTimesCircleO: "_1GlZx",
                "icon-times": "_3hG3b",
                iconTimes: "_3hG3b",
                "icon-times-square-o": "_15wCJ",
                iconTimesSquareO: "_15wCJ",
                "icon-trash-alt": "_1Rw_U",
                iconTrashAlt: "_1Rw_U",
                "icon-truck-moving": "_2Jlwc",
                iconTruckMoving: "_2Jlwc",
                "icon-unfold": "_1bahP",
                iconUnfold: "_1bahP",
                "icon-unlock-alt": "_27Nd-",
                iconUnlockAlt: "_27Nd-",
                "icon-user": "_3To44",
                iconUser: "_3To44",
                "icon-users": "_1O_Hy",
                iconUsers: "_1O_Hy",
                "icon-video": "W6H_f",
                iconVideo: "W6H_f",
                "icon-fa-light-redo": "_2_sls",
                iconFaLightRedo: "_2_sls",
                "icon-fa-solid-play": "_35BGQ",
                iconFaSolidPlay: "_35BGQ",
                "icon-download-black-main": "_3xfLM",
                iconDownloadBlackMain: "_3xfLM",
                "icon-plus-circle": "_1pvYF",
                iconPlusCircle: "_1pvYF",
              };
            },
            function (e, t) {
              e.exports = {
                icons: [
                  { name: "address-book", unicode: "f2b9" },
                  { name: "address-card", unicode: "f2bb" },
                  { name: "adjust", unicode: "f042" },
                  { name: "check-alt-light", unicode: "e917" },
                  { name: "coins-light", unicode: "e348" },
                  { name: "exclamation-circle-light", unicode: "eca2" },
                  { name: "loading-alt-light", unicode: "ee57" },
                  { name: "instagram", unicode: "f16d" },
                  { name: "minus-light", unicode: "e719" },
                  { name: "ticket-alt", unicode: "f3ff" },
                  { name: "ticket-alt-light", unicode: "ebad" },
                  { name: "plus-light", unicode: "e8b5" },
                  { name: "truck", unicode: "f0d1" },
                  { name: "trash-alt-light", unicode: "e3a8" },
                  { name: "times-circle", unicode: "f057" },
                  { name: "vimeo-v", unicode: "f27d" },
                  { name: "twitter", unicode: "f099" },
                  { name: "youtube", unicode: "f167" },
                  { name: "caret-down", unicode: "f0d7" },
                  { name: "caret-up", unicode: "f0d8" },
                  { name: "comments-o", unicode: "ecde" },
                  { name: "download-o", unicode: "e6c0" },
                  { name: "info-circle-o", unicode: "ed3f" },
                  { name: "external-link-o", unicode: "ebd6" },
                  { name: "globe-o", unicode: "efe0" },
                  { name: "question-o", unicode: "e65f" },
                  { name: "play-circle-o", unicode: "e0ca" },
                  { name: "angle-double-left", unicode: "f100" },
                  { name: "angle-down", unicode: "f107" },
                  { name: "angle-double-right", unicode: "f101" },
                  { name: "angle-left", unicode: "f104" },
                  { name: "angle-right", unicode: "f105" },
                  { name: "angle-up", unicode: "f106" },
                  { name: "arrival-reminder", unicode: "e386" },
                  { name: "ban", unicode: "f05e" },
                  { name: "bullhorn", unicode: "f0a1" },
                  { name: "bars", unicode: "f0c9" },
                  { name: "caret-left-o", unicode: "eb68" },
                  { name: "caret-down-o", unicode: "ec02" },
                  { name: "caret-right-o", unicode: "ef8e" },
                  { name: "caret-up-o", unicode: "edd8" },
                  { name: "cart", unicode: "e540" },
                  { name: "certificate", unicode: "f0a3" },
                  { name: "check-circle-o", unicode: "e753" },
                  { name: "check-square-o", unicode: "ee6b" },
                  { name: "check", unicode: "f00c" },
                  { name: "circle-notch", unicode: "f1ce" },
                  { name: "clock", unicode: "f017" },
                  { name: "cog", unicode: "f013" },
                  { name: "cloud-upload", unicode: "f0ee" },
                  { name: "coins", unicode: "e688" },
                  { name: "compare", unicode: "e1f8" },
                  { name: "comment-alt-smile", unicode: "e7e4" },
                  { name: "copy", unicode: "f0c5" },
                  { name: "compress", unicode: "f066" },
                  { name: "coupon", unicode: "ed6e" },
                  { name: "credit-card", unicode: "f09d" },
                  { name: "download", unicode: "f019" },
                  { name: "edit", unicode: "f044" },
                  { name: "ellipsis-h", unicode: "f141" },
                  { name: "education", unicode: "ed0b" },
                  { name: "envelope", unicode: "f0e0" },
                  { name: "ellipsis-v", unicode: "f142" },
                  { name: "exclamation-circle", unicode: "f06a" },
                  { name: "exclamation", unicode: "f12a" },
                  { name: "exclamation-square", unicode: "f321" },
                  { name: "external-link", unicode: "f08e" },
                  { name: "expand", unicode: "f065" },
                  { name: "eye", unicode: "f06e" },
                  { name: "file-alt", unicode: "f15c" },
                  { name: "facebook", unicode: "f09a" },
                  { name: "file", unicode: "f15b" },
                  { name: "file-pdf", unicode: "f1c1" },
                  { name: "frame", unicode: "edcf" },
                  { name: "globe", unicode: "f0ac" },
                  { name: "headset", unicode: "e902" },
                  { name: "heart-o", unicode: "ee55" },
                  { name: "home", unicode: "f015" },
                  { name: "image-view", unicode: "e348" },
                  { name: "info-square", unicode: "f30f" },
                  { name: "info-circle", unicode: "f05a" },
                  { name: "info", unicode: "f129" },
                  { name: "language", unicode: "f1ab" },
                  { name: "link", unicode: "f0c1" },
                  { name: "list-view", unicode: "e8c1" },
                  { name: "location-arrow", unicode: "f124" },
                  { name: "list", unicode: "f03a" },
                  { name: "location", unicode: "ed51" },
                  { name: "lock-alt", unicode: "f30d" },
                  { name: "map-marked-alt", unicode: "ee36" },
                  { name: "map-marker-alt", unicode: "f3c5" },
                  { name: "minus", unicode: "f068" },
                  { name: "paperclip", unicode: "f0c6" },
                  { name: "order", unicode: "e70a" },
                  { name: "play-circle", unicode: "f144" },
                  { name: "phone", unicode: "f095" },
                  { name: "plus", unicode: "f067" },
                  { name: "purchase", unicode: "e85d" },
                  { name: "question-circle", unicode: "f059" },
                  { name: "qrcode", unicode: "f029" },
                  { name: "search-minus", unicode: "f010" },
                  { name: "search", unicode: "f002" },
                  { name: "setup", unicode: "ea0f" },
                  { name: "search-plus", unicode: "f00e" },
                  { name: "tag", unicode: "f02b" },
                  { name: "share", unicode: "f064" },
                  { name: "times-circle-o", unicode: "e200" },
                  { name: "times", unicode: "f00d" },
                  { name: "times-square-o", unicode: "eea2" },
                  { name: "trash-alt", unicode: "f2ed" },
                  { name: "truck-moving", unicode: "eaaa" },
                  { name: "unfold", unicode: "e872" },
                  { name: "unlock-alt", unicode: "f13e" },
                  { name: "user", unicode: "f007" },
                  { name: "users", unicode: "f0c0" },
                  { name: "video", unicode: "f03d" },
                  { name: "fa-light-redo", unicode: "e087" },
                  { name: "fa-solid-play", unicode: "e665" },
                  { name: "download-black-main", unicode: "e111" },
                  { name: "plus-circle", unicode: "f055" },
                ],
                total: 120,
                cssPrefix: "icon-",
                fontFamily: "quark",
              };
            },
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 });
              var o = (t.inBrowser = "undefined" != typeof window);
              t.isIOS = o && navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              var o = n(38),
                a = n(10),
                r = n(55),
                i = n(18),
                l = n(7),
                s = n(66),
                c = n(86),
                _ = n(45),
                u = n(87),
                d = n(19)("iterator"),
                p = !([].keys && "next" in [].keys()),
                f = "values",
                h = function () {
                  return this;
                };
              e.exports = function (e, t, n, m, y, b, v) {
                c(n, t, m);
                var g,
                  w,
                  x,
                  k = function (e) {
                    if (!p && e in j) return j[e];
                    switch (e) {
                      case "keys":
                      case f:
                        return function () {
                          return new n(this, e);
                        };
                    }
                    return function () {
                      return new n(this, e);
                    };
                  },
                  O = t + " Iterator",
                  I = y == f,
                  S = !1,
                  j = e.prototype,
                  T = j[d] || j["@@iterator"] || (y && j[y]),
                  C = (!p && T) || k(y),
                  M = y ? (I ? k("entries") : C) : void 0,
                  P = ("Array" == t && j.entries) || T;
                if (
                  (P &&
                    (x = u(P.call(new e()))) !== Object.prototype &&
                    x.next &&
                    (_(x, O, !0), o || l(x, d) || i(x, d, h)),
                  I &&
                    T &&
                    T.name !== f &&
                    ((S = !0),
                    (C = function () {
                      return T.call(this);
                    })),
                  (o && !v) || (!p && !S && j[d]) || i(j, d, C),
                  (s[t] = C),
                  (s[O] = h),
                  y)
                )
                  if (
                    ((g = {
                      values: I ? C : k(f),
                      keys: b ? C : k("keys"),
                      entries: M,
                    }),
                    v)
                  )
                    for (w in g) w in j || r(j, w, g[w]);
                  else a(a.P + a.F * (p || S), t, g);
                return g;
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              t.__esModule = !0;
              var a = o(n(93)),
                r = o(n(95)),
                i =
                  "function" == typeof r.default && "symbol" == typeof a.default
                    ? function (e) {
                        return typeof e;
                      }
                    : function (e) {
                        return e &&
                          "function" == typeof r.default &&
                          e.constructor === r.default &&
                          e !== r.default.prototype
                          ? "symbol"
                          : typeof e;
                      };
              t.default =
                "function" == typeof r.default && "symbol" === i(a.default)
                  ? function (e) {
                      return void 0 === e ? "undefined" : i(e);
                    }
                  : function (e) {
                      return e &&
                        "function" == typeof r.default &&
                        e.constructor === r.default &&
                        e !== r.default.prototype
                        ? "symbol"
                        : void 0 === e
                          ? "undefined"
                          : i(e);
                    };
            },
            function (e, t, n) {
              "use strict";
              var o = n(85)(!0);
              n(80)(
                String,
                "String",
                function (e) {
                  (this._t = String(e)), (this._i = 0);
                },
                function () {
                  var e,
                    t = this._t,
                    n = this._i;
                  return n >= t.length
                    ? { value: void 0, done: !0 }
                    : ((e = o(t, n)),
                      (this._i += e.length),
                      { value: e, done: !1 });
                },
              );
            },
            function (e, t, n) {
              n(88);
              for (
                var o = n(0),
                  a = n(18),
                  r = n(66),
                  i = n(19)("toStringTag"),
                  l =
                    "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(
                      ",",
                    ),
                  s = 0;
                s < l.length;
                s++
              ) {
                var c = l[s],
                  _ = o[c],
                  u = _ && _.prototype;
                u && !u[i] && a(u, i, c), (r[c] = r.Array);
              }
            },
            function (e, t) {},
            function (e, t, n) {
              var o = n(28),
                a = n(30);
              e.exports = function (e) {
                return function (t, n) {
                  var r,
                    i,
                    l = String(a(t)),
                    s = o(n),
                    c = l.length;
                  return s < 0 || s >= c
                    ? e
                      ? ""
                      : void 0
                    : (r = l.charCodeAt(s)) < 55296 ||
                        r > 56319 ||
                        s + 1 === c ||
                        (i = l.charCodeAt(s + 1)) < 56320 ||
                        i > 57343
                      ? e
                        ? l.charAt(s)
                        : r
                      : e
                        ? l.slice(s, s + 2)
                        : i - 56320 + ((r - 55296) << 10) + 65536;
                };
              };
            },
            function (e, t, n) {
              "use strict";
              var o = n(34),
                a = n(20),
                r = n(45),
                i = {};
              n(18)(i, n(19)("iterator"), function () {
                return this;
              }),
                (e.exports = function (e, t, n) {
                  (e.prototype = o(i, { next: a(1, n) })),
                    r(e, t + " Iterator");
                });
            },
            function (e, t, n) {
              var o = n(7),
                a = n(41),
                r = n(29)("IE_PROTO"),
                i = Object.prototype;
              e.exports =
                Object.getPrototypeOf ||
                function (e) {
                  return (
                    (e = a(e)),
                    o(e, r)
                      ? e[r]
                      : "function" == typeof e.constructor &&
                          e instanceof e.constructor
                        ? e.constructor.prototype
                        : e instanceof Object
                          ? i
                          : null
                  );
                };
            },
            function (e, t, n) {
              "use strict";
              var o = n(89),
                a = n(90),
                r = n(66),
                i = n(6);
              (e.exports = n(80)(
                Array,
                "Array",
                function (e, t) {
                  (this._t = i(e)), (this._i = 0), (this._k = t);
                },
                function () {
                  var e = this._t,
                    t = this._k,
                    n = this._i++;
                  return !e || n >= e.length
                    ? ((this._t = void 0), a(1))
                    : a(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
                },
                "values",
              )),
                (r.Arguments = r.Array),
                o("keys"),
                o("values"),
                o("entries");
            },
            function (e, t) {
              e.exports = function () {};
            },
            function (e, t) {
              e.exports = function (e, t) {
                return { value: t, done: !!e };
              };
            },
            function (e, t) {
              e.exports = s;
            },
            ,
            function (e, t, n) {
              e.exports = { default: n(94), __esModule: !0 };
            },
            function (e, t, n) {
              n(82), n(83), (e.exports = n(39).f("iterator"));
            },
            function (e, t, n) {
              e.exports = { default: n(96), __esModule: !0 };
            },
            function (e, t, n) {
              n(56), n(84), n(97), n(98), (e.exports = n(1).Symbol);
            },
            function (e, t, n) {
              n(54)("asyncIterator");
            },
            function (e, t, n) {
              n(54)("observable");
            },
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 });
              var o = (function (e) {
                return e && e.__esModule ? e : { default: e };
              })(n(81));
              (t.setTransform = function (e, t) {
                e &&
                  "object" ===
                    (void 0 === e ? "undefined" : (0, o.default)(e)) &&
                  t &&
                  ((e.transform = t),
                  (e.WebkitTransform = t),
                  (e.MozTransform = t));
              }),
                (t.removeStyleProperty = function (e, t) {
                  var n = e && e.style;
                  if (!n)
                    throw new Error(
                      "Invalid type of " + e + ". Expected DOM element.",
                    );
                  if (!n.removeProperty && !n.removeAttribute)
                    throw new Error(
                      "Unexpected element style " +
                        n +
                        ". It is not supported to remove inline style.",
                    );
                  n.removeProperty && n.removeProperty(t),
                    n.removeAttribute && n.removeAttribute(t);
                });
            },
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                c = o(n(12)),
                _ = o(n(65)),
                u = o(n(114)),
                d = o(n(116)),
                p = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                m = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    p(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        t = e.children,
                        n = e.loading,
                        o = e.icon,
                        a = h(e, ["children", "loading", "icon"]),
                        r = o || n;
                      return s.createElement(
                        u.default,
                        f({ loading: n }, a),
                        r
                          ? s.createElement(_.default, {
                              className: d.default.icon,
                              name: "" + (n ? "circle-notch" : o),
                              spin: !!n,
                            })
                          : null,
                        t,
                      );
                    }),
                    (t.propTypes = {
                      block: c.default.bool,
                      htmlType: c.default.string,
                      loading: c.default.bool,
                      icon: c.default.string,
                      square: c.default.bool,
                      radius: c.default.oneOf(["large", "small", "none"]),
                      size: c.default.oneOf([
                        "huge",
                        "large",
                        "medium",
                        "small",
                        "mini",
                      ]),
                      type: c.default.oneOf([
                        "brand",
                        "dark-bordered",
                        "special",
                        "default",
                        "primary",
                        "danger",
                        "warning",
                        "success",
                        "ghost",
                      ]),
                    }),
                    t
                  );
                })(s.Component);
              t.default = m;
            },
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 }),
                (t.getScrollBarWidth = function () {
                  var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : o.inBrowser
                          ? window
                          : void 0,
                    t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : o.inBrowser
                          ? document
                          : void 0;
                  if (null === e || void 0 === e) return 0;
                  if (null === t.body || void 0 === t.body) return 0;
                  var n = t.createElement("div");
                  (n.style.visibility = "hidden"),
                    (n.style.width = "100px"),
                    (n.style.msOverflowStyle = "scrollbar"),
                    t.body.appendChild(n);
                  var a = n.offsetWidth;
                  n.style.overflow = "scroll";
                  var r = t.createElement("div");
                  (r.style.width = "100%"), n.appendChild(r);
                  var i = r.offsetWidth;
                  return n.parentNode.removeChild(n), a - i;
                });
              var o = n(75);
            },
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 });
              var o = (function (e) {
                return e && e.__esModule ? e : { default: e };
              })(n(128));
              t.default = o.default;
            },
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 });
              var o = (function (e) {
                return e && e.__esModule ? e : { default: e };
              })(n(139));
              t.default = o.default;
            },
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                c = o(n(12)),
                _ = o(n(23)),
                u = o(n(115)),
                d = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                p =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                f = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                h = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    d(t, e),
                    (t.prototype.clickable = function () {
                      var e = this.props,
                        t = e.disabled,
                        n = e.loading;
                      return !t && !n;
                    }),
                    (t.prototype.render = function () {
                      var e,
                        t = this.props,
                        n = t.block,
                        o = t.children,
                        a = t.className,
                        r = t.htmlType,
                        i = t.loading,
                        l = t.disabled,
                        c = t.square,
                        d = t.radius,
                        h = t.size,
                        m = t.type,
                        y = f(t, [
                          "block",
                          "children",
                          "className",
                          "htmlType",
                          "loading",
                          "disabled",
                          "square",
                          "radius",
                          "size",
                          "type",
                        ]),
                        b = m || "default",
                        v = h || "medium",
                        g = d || "small",
                        w = (0, _.default)(
                          u.default.btn,
                          u.default["btn-" + b],
                          u.default["btn-radius-" + g],
                          u.default["btn-size-" + v],
                          (((e = {})[u.default["btn-square"]] = c),
                          (e[u.default["btn-block"]] = n),
                          (e[u.default["btn-loading"]] = i),
                          e),
                          a,
                        );
                      return s.createElement(
                        "button",
                        p({ type: r, className: w, disabled: l || i }, y),
                        o,
                      );
                    }),
                    (t.propTypes = {
                      block: c.default.bool,
                      htmlType: c.default.string,
                      loading: c.default.bool,
                      square: c.default.bool,
                      radius: c.default.oneOf(["large", "small", "none"]),
                      size: c.default.oneOf([
                        "huge",
                        "large",
                        "medium",
                        "small",
                        "mini",
                      ]),
                      type: c.default.oneOf([
                        "brand",
                        "dark-bordered",
                        "special",
                        "default",
                        "primary",
                        "danger",
                        "warning",
                        "success",
                        "ghost",
                      ]),
                    }),
                    (t.defaultProps = { loading: !1 }),
                    t
                  );
                })(s.PureComponent);
              t.default = h;
            },
            function (e, t) {
              e.exports = {
                icon: "_3TvKd",
                btn: "xnv6R",
                focus: "_3e-BG",
                "btn-block": "_3RO_K",
                btnBlock: "_3RO_K",
                "btn-brand": "_19X_H",
                btnBrand: "_19X_H",
                "btn-dark-bordered": "_8oCtR",
                btnDarkBordered: "_8oCtR",
                "btn-special": "_1bpad",
                btnSpecial: "_1bpad",
                "btn-default": "_27-6k",
                btnDefault: "_27-6k",
                "btn-primary": "_2QwEc",
                btnPrimary: "_2QwEc",
                "btn-danger": "_3IIr-",
                btnDanger: "_3IIr-",
                "btn-success": "_16fYW",
                btnSuccess: "_16fYW",
                "btn-warning": "upL7u",
                btnWarning: "upL7u",
                "btn-ghost": "_3oax7",
                btnGhost: "_3oax7",
                "btn-radius-large": "_958V1",
                btnRadiusLarge: "_958V1",
                "btn-radius-small": "_22qIt",
                btnRadiusSmall: "_22qIt",
                "btn-radius-none": "mrbT4",
                btnRadiusNone: "mrbT4",
                "btn-size-huge": "_1i5fk",
                btnSizeHuge: "_1i5fk",
                "btn-square": "_1FsY1",
                btnSquare: "_1FsY1",
                "btn-size-large": "p8s4W",
                btnSizeLarge: "p8s4W",
                "btn-size-medium": "_27-yu",
                btnSizeMedium: "_27-yu",
                "btn-size-small": "_2ghvt",
                btnSizeSmall: "_2ghvt",
                "btn-size-mini": "_21L3I",
                btnSizeMini: "_21L3I",
                "btn-loading": "_1wazg",
                btnLoading: "_1wazg",
              };
            },
            function (e, t) {
              e.exports = { icon: "j7iyJ" };
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                c = o(n(12)),
                _ = o(n(23)),
                u = o(n(129)),
                d = o(n(131)),
                p = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                m = (function (e) {
                  function t() {
                    var t = (null !== e && e.apply(this, arguments)) || this;
                    return (
                      (t.onMaskClick = function () {
                        for (var e = [], n = 0; n < arguments.length; n++)
                          e[n] = arguments[n];
                        var o = t.props,
                          a = o.onClose,
                          r = o.onClick,
                          i = o.visible;
                        a && a(!i), r && r.apply(void 0, e);
                      }),
                      t
                    );
                  }
                  return (
                    p(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        t = e.className,
                        n = e.visible,
                        o = h(e, ["className", "visible"]),
                        a = (0, r.default)({}, o);
                      delete a.onClick;
                      var i = (0, _.default)(d.default.mask, t);
                      return s.createElement(
                        u.default,
                        { in: n, unmountOnExit: !0 },
                        s.createElement(
                          "div",
                          f({ className: i, onClick: this.onMaskClick }, a),
                        ),
                      );
                    }),
                    (t.propTypes = {
                      onClose: c.default.func,
                      visible: c.default.bool,
                    }),
                    (t.defaultProps = { onClose: function () {}, visible: !1 }),
                    t
                  );
                })(s.Component);
              t.default = m;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = n(68),
                s = o(n(130)),
                c = o(n(69)),
                _ =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                u = { enter: 500, exit: 300 },
                d = c.default.genTransitionClassNames("fade", s.default);
              t.default = function (e) {
                var t = e.children,
                  n = (function (e, t) {
                    var n = {};
                    for (var o in e)
                      Object.prototype.hasOwnProperty.call(e, o) &&
                        t.indexOf(o) < 0 &&
                        (n[o] = e[o]);
                    if (null != e && "function" == typeof a.default) {
                      var r = 0;
                      for (o = (0, a.default)(e); r < o.length; r++)
                        t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                  })(e, ["children"]);
                return i.createElement(
                  l.CSSTransition,
                  _({}, n, { timeout: u, classNames: d }),
                  t,
                );
              };
            },
            function (e, t) {
              e.exports = {
                "fade-enter": "_5iCMy",
                fadeEnter: "_5iCMy",
                "fade-enter-active": "_3N80o",
                fadeEnterActive: "_3N80o",
                "fade-exit": "_3jNlY",
                fadeExit: "_3jNlY",
                "fade-exit-active": "_249s1",
                fadeExitActive: "_249s1",
              };
            },
            function (e, t) {
              e.exports = { mask: "RBtig" };
            },
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 }),
                (t.destroyQueues = void 0);
              var a = o(n(13)),
                r = o(n(14)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = o(n(12)),
                s = o(n(23)),
                c = o(n(91)),
                _ = o(n(105)),
                u = o(n(227)),
                d = o(n(229)),
                p = o(n(231)),
                f = o(n(65)),
                h = o(n(110)),
                m = o(n(111)),
                y = o(n(233)),
                b = o(n(235)),
                v = n(109),
                g = n(75),
                w = n(99),
                x = o(n(237)),
                k = (function () {
                  var e =
                    r.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, a.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                O =
                  ((t.destroyQueues = []),
                  (function (e) {
                    function t(t) {
                      var n = e.call(this, t) || this;
                      return (
                        (n.offsetPadding = 40),
                        (n.contentPadding = 24),
                        (n.rootElement = null),
                        (n.scrollbarWidth = 0),
                        (n.closeMask = function () {
                          var e = n.props,
                            t = e.maskClosable,
                            o = e.onClose;
                          t && o && o();
                        }),
                        (n.onContainerClick = function (e) {
                          n.modal &&
                            !n.modal.contains(e.target) &&
                            n.closeMask();
                        }),
                        (n.unmountModal = function () {
                          var e = n.props.afterClose;
                          n.enableRootScrolling(),
                            n.portal && n.portal.unmountPortalImmediately(),
                            n.setState({ mount: !1 }),
                            "function" == typeof e && e();
                        }),
                        (n.updateContentMaxHeight = function () {
                          var e = n.state.contentMaxHeight,
                            t = n.getContentMaxHeight();
                          if (e !== t) {
                            n.setState({ contentMaxHeight: t });
                            var o = n.props.onContentMaxHeightChange;
                            "function" == typeof o &&
                              o(t - 2 * n.contentPadding);
                          }
                        }),
                        (n.state = {
                          contentMaxHeight: n.getContentMaxHeight(),
                          mount: t.visible,
                          visible: t.visible,
                        }),
                        (n.updateContentHeightLater = (0, c.default)(
                          n.updateContentMaxHeight,
                          100,
                        )),
                        n
                      );
                    }
                    return (
                      k(t, e),
                      (t.prototype.componentDidMount = function () {
                        this.listenWindowResize(), this.initBrowserInfo();
                      }),
                      (t.prototype.componentWillReceiveProps = function (e) {
                        e.visible ? this.showModal() : this.hideModal();
                      }),
                      (t.prototype.componentWillUnmount = function () {
                        this.removeWindowResizeListener();
                      }),
                      (t.prototype.disableRootScrolling = function () {
                        this.props.preventRootScroll &&
                          this.rootElement &&
                          ((this.rootElement.style.overflow = "hidden"),
                          (this.rootElement.style.paddingRight =
                            this.scrollbarWidth + "px"));
                      }),
                      (t.prototype.enableRootScrolling = function () {
                        (0, w.removeStyleProperty)(
                          this.rootElement,
                          "overflow",
                        ),
                          (0, w.removeStyleProperty)(
                            this.rootElement,
                            "padding-right",
                          );
                      }),
                      (t.prototype.getContentMaxHeight = function () {
                        var e = window.innerHeight,
                          t = Math.ceil(e - 2 * this.offsetPadding),
                          n = 0,
                          o = 0;
                        return (
                          this.header &&
                            (n = this.header.getBoundingClientRect().height),
                          this.footer &&
                            (o = this.footer.getBoundingClientRect().height),
                          t - n - o
                        );
                      }),
                      (t.prototype.hideModal = function () {
                        this.setState({ visible: !1 });
                      }),
                      (t.prototype.initBrowserInfo = function () {
                        g.inBrowser &&
                          ((this.rootElement = document.querySelector("html")),
                          (this.scrollbarWidth = (0, v.getScrollBarWidth)()));
                      }),
                      (t.prototype.listenWindowResize = function () {
                        g.inBrowser &&
                          window.addEventListener(
                            "resize",
                            this.updateContentHeightLater,
                            !1,
                          );
                      }),
                      (t.prototype.mountModal = function (e) {
                        void 0 === e && (e = function () {}),
                          this.setState({ mount: !0 }, function () {
                            e();
                          });
                      }),
                      (t.prototype.removeWindowResizeListener = function () {
                        g.inBrowser &&
                          window.removeEventListener(
                            "resize",
                            this.updateContentHeightLater,
                          );
                      }),
                      (t.prototype.showModal = function () {
                        var e = this,
                          t = this.state.mount;
                        this.disableRootScrolling(),
                          t
                            ? this.setState({ visible: !0 })
                            : this.mountModal(function () {
                                e.setState({ visible: !0 });
                              });
                      }),
                      (t.prototype.renderCloseBtn = function () {
                        var e = this.props,
                          t = e.closable,
                          n = e.onClose,
                          o = e.type,
                          a = e.title;
                        if (!t) return null;
                        var r = (0, s.default)(
                          x.default["close-btn"],
                          x.default["close-btn-" + (a ? o : "default")],
                        );
                        return i.createElement(
                          "span",
                          { className: r, onClick: n },
                          i.createElement(f.default, { name: "times" }),
                        );
                      }),
                      (t.prototype.renderContent = function () {
                        var e = this.props.children,
                          t = { maxHeight: this.state.contentMaxHeight + "px" };
                        return i.createElement(u.default, { style: t }, e);
                      }),
                      (t.prototype.renderFooter = function () {
                        var e = this,
                          t = this.props,
                          n = t.cancelText,
                          o = t.footer,
                          a = t.okText,
                          r = t.okLoading,
                          l = t.onCancel,
                          s = t.onOk,
                          c = t.type;
                        return o
                          ? "string" == typeof o
                            ? i.createElement(
                                d.default,
                                {
                                  className: x.default["footer-default"],
                                  innerRef: function (t) {
                                    e.footer = t;
                                  },
                                },
                                n &&
                                  i.createElement(
                                    _.default,
                                    { size: "small", onClick: l },
                                    n,
                                  ),
                                a &&
                                  i.createElement(
                                    _.default,
                                    {
                                      onClick: s,
                                      size: "small",
                                      type: c,
                                      loading: !!r,
                                    },
                                    a,
                                  ),
                              )
                            : i.createElement(
                                d.default,
                                {
                                  innerRef: function (t) {
                                    e.footer = t;
                                  },
                                },
                                o,
                              )
                          : null;
                      }),
                      (t.prototype.renderHeader = function () {
                        var e = this,
                          t = this.props,
                          n = t.title,
                          o = t.type;
                        return n
                          ? i.createElement(
                              p.default,
                              {
                                innerRef: function (t) {
                                  e.header = t;
                                },
                                type: o,
                              },
                              n,
                            )
                          : null;
                      }),
                      (t.prototype.renderModal = function () {
                        var e = this,
                          t = this.props,
                          n = t.size,
                          o = t.modalStyle,
                          a = t.position,
                          r = (0, s.default)(
                            x.default["modal-container"],
                            x.default["modal-container-" + a],
                          ),
                          l = (0, s.default)(
                            x.default.modal,
                            x.default["modal-" + n],
                          );
                        return i.createElement(
                          "div",
                          { className: r, onClick: this.onContainerClick },
                          i.createElement(
                            "div",
                            {
                              className: l,
                              style: o,
                              ref: function (t) {
                                e.modal = t;
                              },
                            },
                            this.renderHeader(),
                            this.renderContent(),
                            this.renderFooter(),
                            this.renderCloseBtn(),
                          ),
                        );
                      }),
                      (t.prototype.render = function () {
                        var e = this,
                          t = this.state,
                          n = t.mount,
                          o = t.visible,
                          a = this.props,
                          r = a.position,
                          l = a.maskStyle,
                          s = a.containerStyle,
                          c = a.className,
                          _ = a.mask,
                          u = "bottom" === r ? y.default : b.default;
                        return n
                          ? i.createElement(
                              m.default,
                              {
                                ref: function (t) {
                                  e.portal = t;
                                },
                                unmountOnExit: !1,
                                visible: o,
                                className: c,
                              },
                              i.createElement(h.default, {
                                onClose: this.closeMask,
                                visible: o && _,
                                style: l,
                              }),
                              i.createElement(
                                u,
                                {
                                  in: o,
                                  onEnter: this.updateContentMaxHeight,
                                  onExited: this.unmountModal,
                                  style: s,
                                  unmountOnExit: !0,
                                },
                                this.renderModal(),
                              ),
                            )
                          : null;
                      }),
                      (t.propTypes = {
                        cancelText: l.default.string,
                        closable: l.default.bool,
                        mask: l.default.bool,
                        footer: l.default.node,
                        maskClosable: l.default.bool,
                        okText: l.default.string,
                        okLoading: l.default.bool,
                        onCancel: l.default.func,
                        onClose: l.default.func,
                        onOk: l.default.func,
                        onContentMaxHeightChange: l.default.func,
                        afterClose: l.default.func,
                        preventRootScroll: l.default.bool,
                        size: l.default.oneOf([
                          "huge",
                          "large",
                          "medium",
                          "small",
                          "mini",
                        ]),
                        title: l.default.node,
                        type: l.default.oneOf([
                          "default",
                          "primary",
                          "success",
                          "danger",
                          "warning",
                          "brand",
                        ]),
                        position: l.default.oneOf(["middle", "bottom"]),
                        visible: l.default.bool,
                        className: l.default.string,
                      }),
                      (t.defaultProps = {
                        cancelText: "\u53d6\u6d88",
                        closable: !0,
                        footer: "OKCancel",
                        mask: !0,
                        maskClosable: !0,
                        okText: "\u786e\u5b9a",
                        okLoading: !1,
                        onCancel: function () {},
                        onClose: function () {},
                        onOk: function () {},
                        onContentMaxHeightChange: function () {},
                        preventRootScroll: !0,
                        size: "medium",
                        type: "default",
                        position: "middle",
                        visible: !1,
                        className: "",
                      }),
                      (t.Content = u.default),
                      (t.Footer = d.default),
                      (t.Header = p.default),
                      t
                    );
                  })(i.Component));
              t.default = O;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(13)),
                r = o(n(14)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = o(n(70)),
                s = o(n(12)),
                c = o(n(91)),
                _ = n(75),
                u = (function () {
                  var e =
                    r.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, a.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                d = (function (e) {
                  function t(t) {
                    var n = e.call(this, t) || this;
                    return (
                      (n.state = { visible: t.visible }),
                      (n.unmountPortalImmediately = n.unmountFactories(0)),
                      (n.unmountPortalLater = n.unmountFactories(t.timeout)),
                      n.initRootElement(),
                      n
                    );
                  }
                  return (
                    u(t, e),
                    (t.prototype.componentDidMount = function () {
                      this.props.visible && this.mountPortal();
                    }),
                    (t.prototype.componentWillReceiveProps = function (e) {
                      var t = e.unmountOnExit,
                        n = e.visible;
                      n && this.mountPortal(),
                        !n && t && this.unmountPortalLater();
                    }),
                    (t.prototype.componentWillUnmount = function () {
                      this.unmountPortalLater.cancel &&
                        this.unmountPortalLater.cancel(),
                        this.unmountPortalImmediately();
                    }),
                    (t.prototype.initRootElement = function () {
                      (this.el = _.inBrowser
                        ? document.createElement("div")
                        : null),
                        this.mountPortal();
                    }),
                    (t.prototype.mountPortal = function () {
                      var e = this.props,
                        t = e.mountNode,
                        n = e.className;
                      _.inBrowser &&
                        t &&
                        this.el &&
                        (t.contains(this.el) ||
                          ((this.el.className = n || ""),
                          t.appendChild(this.el)));
                    }),
                    (t.prototype.unmountPortal = function () {
                      var e = this.props.mountNode;
                      _.inBrowser &&
                        e &&
                        this.el &&
                        e.contains(this.el) &&
                        e.removeChild(this.el);
                    }),
                    (t.prototype.unmountFactories = function (e) {
                      return (
                        void 0 === e && (e = 0),
                        e
                          ? (0, c.default)(this.unmountPortal.bind(this), e)
                          : this.unmountPortal.bind(this)
                      );
                    }),
                    (t.prototype.render = function () {
                      if (!this.el) return null;
                      var e = this.props.children;
                      return l.default.createPortal(e, this.el);
                    }),
                    (t.propTypes = {
                      mountNode: s.default.object,
                      timeout: s.default.number,
                      unmountOnExit: s.default.bool,
                      visible: s.default.bool,
                      className: s.default.string,
                    }),
                    (t.defaultProps = {
                      mountNode: _.inBrowser ? document.body : null,
                      timeout: 1e3,
                      unmountOnExit: !0,
                      visible: !0,
                      className: "",
                    }),
                    t
                  );
                })(i.Component);
              t.default = d;
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(16)),
                r = o(n(138)),
                i = n(238),
                l = o(i),
                s =
                  a.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  };
              (r.default.confirm = function (e) {
                var t = s({}, e);
                return (0, i.confirm)(t);
              }),
                (r.default.info = function (e) {
                  var t = s({ iconType: "primary", icon: "info-circle" }, e);
                  return (0, i.confirm)(t);
                }),
                (r.default.success = function (e) {
                  var t = s({ iconType: "success", icon: "check-circle-o" }, e);
                  return (0, i.confirm)(t);
                }),
                (r.default.error = function (e) {
                  var t = s({ iconType: "danger", icon: "times-circle-o" }, e);
                  return (0, i.confirm)(t);
                }),
                (r.default.warning = function (e) {
                  var t = s(
                    { iconType: "warning", icon: "exclamation-circle" },
                    e,
                  );
                  return (0, i.confirm)(t);
                }),
                (r.default.help = function (e) {
                  var t = s({ iconType: "help", icon: "question-circle" }, e);
                  return (0, i.confirm)(t);
                }),
                (r.default.Confirm = l.default),
                (t.default = r.default);
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = o(n(12)),
                s = o(n(23)),
                c = o(n(228)),
                _ =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                u = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                d = function (e) {
                  var t = e.children,
                    n = e.className,
                    o = e.innerRef,
                    a = u(e, ["children", "className", "innerRef"]),
                    r = (0, s.default)(c.default["modal-content"], n);
                  return i.createElement(
                    "main",
                    _({ className: r, ref: o }, a),
                    t,
                  );
                };
              (d.propTypes = { innerRef: l.default.func }),
                (d.defaultProps = { innerRef: function () {} }),
                (t.default = d);
            },
            function (e, t) {
              e.exports = { "modal-content": "_1SoeU", modalContent: "_1SoeU" };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = o(n(12)),
                s = o(n(23)),
                c = o(n(230)),
                _ =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                u = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                d = function (e) {
                  var t = e.children,
                    n = e.className,
                    o = e.innerRef,
                    a = u(e, ["children", "className", "innerRef"]),
                    r = (0, s.default)(c.default["modal-footer"], n);
                  return i.createElement(
                    "footer",
                    _({ className: r, ref: o }, a),
                    t,
                  );
                };
              (d.propTypes = { innerRef: l.default.func }),
                (d.defaultProps = { innerRef: function () {} }),
                (t.default = d);
            },
            function (e, t) {
              e.exports = { "modal-footer": "_2bhiO", modalFooter: "_2bhiO" };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = o(n(12)),
                s = o(n(23)),
                c = o(n(232)),
                _ =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                u = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                d = function (e) {
                  var t = e.children,
                    n = e.className,
                    o = e.innerRef,
                    a = e.type,
                    r = u(e, ["children", "className", "innerRef", "type"]),
                    l = (0, s.default)(
                      c.default["modal-header"],
                      c.default["header-" + a],
                      n,
                    );
                  return i.createElement(
                    "header",
                    _({ className: l, ref: o }, r),
                    t,
                  );
                };
              (d.propTypes = {
                innerRef: l.default.func,
                type: l.default.oneOf([
                  "default",
                  "primary",
                  "success",
                  "danger",
                  "warning",
                  "brand",
                ]),
              }),
                (d.defaultProps = {
                  innerRef: function () {},
                  type: "default",
                }),
                (t.default = d);
            },
            function (e, t) {
              e.exports = {
                "modal-header": "_5FUC",
                modalHeader: "_5FUC",
                "header-default": "_19qBt",
                headerDefault: "_19qBt",
                "header-primary": "_1fEts",
                headerPrimary: "_1fEts",
                "header-success": "_2-nfI",
                headerSuccess: "_2-nfI",
                "header-danger": "UT4Rh",
                headerDanger: "UT4Rh",
                "header-warning": "_134Zt",
                headerWarning: "_134Zt",
                "header-brand": "Vsj0k",
                headerBrand: "Vsj0k",
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = n(68),
                s = o(n(234)),
                c = o(n(69)),
                _ =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                u = { enter: 300, exit: 200 },
                d = c.default.genTransitionClassNames(
                  "fade-in-bottom",
                  s.default,
                );
              t.default = function (e) {
                var t = e.children,
                  n = (function (e, t) {
                    var n = {};
                    for (var o in e)
                      Object.prototype.hasOwnProperty.call(e, o) &&
                        t.indexOf(o) < 0 &&
                        (n[o] = e[o]);
                    if (null != e && "function" == typeof a.default) {
                      var r = 0;
                      for (o = (0, a.default)(e); r < o.length; r++)
                        t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                  })(e, ["children"]);
                return i.createElement(
                  l.CSSTransition,
                  _({}, n, { timeout: u, classNames: d }),
                  t,
                );
              };
            },
            function (e, t) {
              e.exports = {
                "fade-in-bottom-enter": "_3WeTt",
                fadeInBottomEnter: "_3WeTt",
                "fade-in-bottom-enter-active": "_2_fNz",
                fadeInBottomEnterActive: "_2_fNz",
                "fade-in-bottom-exit": "_29zRf",
                fadeInBottomExit: "_29zRf",
                "fade-in-bottom-exit-active": "bsi6l",
                fadeInBottomExitActive: "bsi6l",
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                l = n(68),
                s = o(n(236)),
                c = o(n(69)),
                _ =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                u = { enter: 500, exit: 300 },
                d = c.default.genTransitionClassNames("slide-fade", s.default);
              t.default = function (e) {
                var t = e.children,
                  n = (function (e, t) {
                    var n = {};
                    for (var o in e)
                      Object.prototype.hasOwnProperty.call(e, o) &&
                        t.indexOf(o) < 0 &&
                        (n[o] = e[o]);
                    if (null != e && "function" == typeof a.default) {
                      var r = 0;
                      for (o = (0, a.default)(e); r < o.length; r++)
                        t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                    }
                    return n;
                  })(e, ["children"]);
                return i.createElement(
                  l.CSSTransition,
                  _({}, n, { timeout: u, classNames: d }),
                  t,
                );
              };
            },
            function (e, t) {
              e.exports = {
                "slide-fade-enter": "_2fvBN",
                slideFadeEnter: "_2fvBN",
                "slide-fade-enter-active": "kvUUT",
                slideFadeEnterActive: "kvUUT",
                "slide-fade-exit": "F2CYv",
                slideFadeExit: "F2CYv",
                "slide-fade-exit-active": "ssUw_",
                slideFadeExitActive: "ssUw_",
              };
            },
            function (e, t) {
              e.exports = {
                "modal-container": "_2PzHu",
                modalContainer: "_2PzHu",
                "modal-container-middle": "_12j5q",
                modalContainerMiddle: "_12j5q",
                "modal-container-bottom": "g2SoP",
                modalContainerBottom: "g2SoP",
                modal: "_3U3Et",
                "modal-huge": "_2b7K4",
                modalHuge: "_2b7K4",
                "modal-large": "_3XX52",
                modalLarge: "_3XX52",
                "modal-medium": "_168gc",
                modalMedium: "_168gc",
                "modal-small": "_3N4z4",
                modalSmall: "_3N4z4",
                "modal-mini": "_33vWN",
                modalMini: "_33vWN",
                "footer-default": "_17SAi",
                footerDefault: "_17SAi",
                "close-btn": "_2ND-v",
                closeBtn: "_2ND-v",
                "close-btn-dark": "_2VI4U",
                closeBtnDark: "_2VI4U",
                "close-btn-default": "_32gGw",
                closeBtnDefault: "_32gGw",
                "close-btn-light": "kmSxj",
                closeBtnLight: "kmSxj",
                "close-btn-primary": "_2YiVO",
                closeBtnPrimary: "_2YiVO",
                "close-btn-danger": "_2P3bW",
                closeBtnDanger: "_2P3bW",
                "close-btn-success": "_2RlE1",
                closeBtnSuccess: "_2RlE1",
                "close-btn-warning": "_3LZfU",
                closeBtnWarning: "_3LZfU",
                "close-btn-brand": "SGzBY",
                closeBtnBrand: "SGzBY",
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e)
                  for (var n in e)
                    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                return (t.default = e), t;
              }
              function a(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var r = a(n(24)),
                i = a(n(16)),
                l = a(n(13)),
                s = a(n(14));
              t.confirm = function (e) {
                function t() {
                  for (var n = [], i = 0; i < arguments.length; i++)
                    n[i] = arguments[i];
                  o(
                    (r = y({}, r, {
                      visible: !1,
                      afterClose: function () {
                        (function () {
                          for (var n = [], o = 0; o < arguments.length; o++)
                            n[o] = arguments[o];
                          _.unmountComponentAtNode(a) &&
                            a.parentNode &&
                            a.parentNode.removeChild(a);
                          var r = n.some(function (e) {
                            return e && e.triggerCancel;
                          });
                          e.onCancel && r && e.onCancel.apply(e, n);
                          for (var i = 0; i < p.destroyQueues.length; i++) {
                            var l = p.destroyQueues[i];
                            if (l === t) {
                              p.destroyQueues.splice(i, 1);
                              break;
                            }
                          }
                        }).apply(void 0, n);
                      },
                    })),
                  );
                }
                function n(e) {
                  o((r = y({}, r, e)));
                }
                function o(e, t) {
                  _.render(c.createElement(v, y({}, e)), a, t);
                }
                var a = document.createElement("div");
                document.body.appendChild(a);
                var r = y({}, e, { close: t, visible: !1 });
                return (
                  o(r),
                  n({ visible: !0 }),
                  p.destroyQueues.push(t),
                  { destroy: t, update: n }
                );
              };
              var c = o(n(9)),
                _ = o(n(70)),
                u = a(n(23)),
                d = a(n(65)),
                p = n(138),
                f = a(p),
                h = a(n(239)),
                m = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                y =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                b = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                v = (function (e) {
                  function t(t) {
                    var n = e.call(this, t) || this;
                    return (n.state = { loading: !!t.okLoading }), n;
                  }
                  return (
                    m(t, e),
                    (t.prototype.render = function () {
                      var e = this,
                        t = this.props,
                        n = t.icon,
                        o = void 0 === n ? "info-circle" : n,
                        a = t.type,
                        r = void 0 === a ? "primary" : a,
                        i = t.size,
                        l = void 0 === i ? "small" : i,
                        s = t.iconType,
                        _ = void 0 === s ? "primary" : s,
                        p = t.title,
                        m = t.content,
                        v = t.children,
                        g = t.onClose,
                        w = t.onCancel,
                        x = t.onOk,
                        k = t.close,
                        O = void 0 === k ? function () {} : k,
                        I = b(t, [
                          "icon",
                          "type",
                          "size",
                          "iconType",
                          "title",
                          "content",
                          "children",
                          "onClose",
                          "onCancel",
                          "onOk",
                          "close",
                        ]),
                        S = this.state.loading,
                        j = (0, u.default)(
                          h.default.icon,
                          h.default["icon-" + _],
                        ),
                        T = !1,
                        C =
                          "string" == typeof o
                            ? c.createElement(d.default, {
                                name: o,
                                className: j,
                              })
                            : o;
                      return c.createElement(
                        f.default,
                        y(
                          {
                            size: l,
                            type: r,
                            onCancel: function (e) {
                              "function" == typeof w && w(e),
                                O({ triggerCancel: !1 });
                            },
                            onClose: function (e) {
                              "function" == typeof g && g(e),
                                O({ triggerCancel: !1 });
                            },
                            onOk: function (t) {
                              if (!T)
                                if (((T = !0), "function" == typeof x)) {
                                  var n = x(t);
                                  n && n.then
                                    ? (e.setState({ loading: !0 }),
                                      n.then(
                                        function () {
                                          for (
                                            var e = [], t = 0;
                                            t < arguments.length;
                                            t++
                                          )
                                            e[t] = arguments[t];
                                          O({ triggerCancel: !1 });
                                        },
                                        function () {
                                          e.setState({ loading: !1 });
                                        },
                                      ))
                                    : O({ triggerCancel: !1 });
                                } else O({ triggerCancel: !1 });
                            },
                            okLoading: S,
                          },
                          I,
                        ),
                        c.createElement(
                          "div",
                          { className: h.default.body },
                          C,
                          c.createElement(
                            "div",
                            { className: h.default.content },
                            c.createElement(
                              "h6",
                              { className: h.default.title },
                              p,
                            ),
                            c.createElement(
                              "div",
                              { className: h.default.text },
                              m,
                              v,
                            ),
                          ),
                        ),
                      );
                    }),
                    t
                  );
                })(c.Component);
              t.default = v;
            },
            function (e, t) {
              e.exports = {
                body: "leytg",
                content: "_1Fbwl",
                title: "_3Nq3W",
                text: "_38_U0",
                icon: "_2gf0i",
                "icon-default": "_2l3Wv",
                iconDefault: "_2l3Wv",
                "icon-primary": "_3GTn6",
                iconPrimary: "_3GTn6",
                "icon-success": "_38rwj",
                iconSuccess: "_38rwj",
                "icon-danger": "_28BxZ",
                iconDanger: "_28BxZ",
                "icon-warning": "Jf-sC",
                iconWarning: "Jf-sC",
                "icon-brand": "_303Q5",
                iconBrand: "_303Q5",
                "icon-help": "_1gPIw",
                iconHelp: "_1gPIw",
              };
            },
          ])));
    },
    b2z7: function (e, t) {
      var n = /\w*$/;
      e.exports = function (e) {
        var t = new e.constructor(e.source, n.exec(e));
        return (t.lastIndex = e.lastIndex), t;
      };
    },
    b80T: function (e, t, n) {
      var o = n("UNi/"),
        a = n("03A+"),
        r = n("Z0cm"),
        i = n("DSRE"),
        l = n("wJg7"),
        s = n("c6wG"),
        c = Object.prototype.hasOwnProperty;
      e.exports = function (e, t) {
        var n = r(e),
          _ = !n && a(e),
          u = !n && !_ && i(e),
          d = !n && !_ && !u && s(e),
          p = n || _ || u || d,
          f = p ? o(e.length, String) : [],
          h = f.length;
        for (var m in e)
          (!t && !c.call(e, m)) ||
            (p &&
              ("length" == m ||
                (u && ("offset" == m || "parent" == m)) ||
                (d &&
                  ("buffer" == m || "byteLength" == m || "byteOffset" == m)) ||
                l(m, h))) ||
            f.push(m);
        return f;
      };
    },
    bBy9: function (e, t, n) {
      n("w2d+");
      for (
        var o = n("5T2Y"),
          a = n("NegM"),
          r = n("SBuE"),
          i = n("UWiX")("toStringTag"),
          l =
            "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(
              ",",
            ),
          s = 0;
        s < l.length;
        s++
      ) {
        var c = l[s],
          _ = o[c],
          u = _ && _.prototype;
        u && !u[i] && a(u, i, c), (r[c] = r.Array);
      }
    },
    bQW5: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return d;
      }),
        n.d(t, "c", function () {
          return p;
        }),
        n.d(t, "d", function () {
          return y;
        });
      var o =
          "undefined" !== typeof performance
            ? function () {
                return performance.now();
              }
            : function () {
                return Date.now();
              },
        a =
          "undefined" !== typeof window
            ? function (e) {
                return window.requestAnimationFrame(e);
              }
            : function (e) {
                return setTimeout(
                  function () {
                    return e(o());
                  },
                  (1 / 60) * 1e3,
                );
              };
      var r = !0,
        i = !1,
        l = !1,
        s = { delta: 0, timestamp: 0 },
        c = ["read", "update", "preRender", "render", "postRender"],
        _ = c.reduce(function (e, t) {
          return (
            (e[t] = (function (e) {
              var t = [],
                n = [],
                o = 0,
                a = !1,
                r = new WeakSet(),
                i = {
                  schedule: function (e, i, l) {
                    void 0 === i && (i = !1), void 0 === l && (l = !1);
                    var s = l && a,
                      c = s ? t : n;
                    return (
                      i && r.add(e),
                      -1 === c.indexOf(e) &&
                        (c.push(e), s && a && (o = t.length)),
                      e
                    );
                  },
                  cancel: function (e) {
                    var t = n.indexOf(e);
                    -1 !== t && n.splice(t, 1), r.delete(e);
                  },
                  process: function (l) {
                    var s;
                    if (
                      ((a = !0),
                      (t = (s = [n, t])[0]),
                      ((n = s[1]).length = 0),
                      (o = t.length))
                    )
                      for (var c = 0; c < o; c++) {
                        var _ = t[c];
                        _(l), r.has(_) && (i.schedule(_), e());
                      }
                    a = !1;
                  },
                };
              return i;
            })(function () {
              return (i = !0);
            })),
            e
          );
        }, {}),
        u = c.reduce(function (e, t) {
          var n = _[t];
          return (
            (e[t] = function (e, t, o) {
              return (
                void 0 === t && (t = !1),
                void 0 === o && (o = !1),
                i || m(),
                n.schedule(e, t, o)
              );
            }),
            e
          );
        }, {}),
        d = c.reduce(function (e, t) {
          return (e[t] = _[t].cancel), e;
        }, {}),
        p = c.reduce(function (e, t) {
          return (
            (e[t] = function () {
              return _[t].process(s);
            }),
            e
          );
        }, {}),
        f = function (e) {
          return _[e].process(s);
        },
        h = function (e) {
          (i = !1),
            (s.delta = r
              ? (1 / 60) * 1e3
              : Math.max(Math.min(e - s.timestamp, 40), 1)),
            (s.timestamp = e),
            (l = !0),
            c.forEach(f),
            (l = !1),
            i && ((r = !1), a(h));
        },
        m = function () {
          (i = !0), (r = !0), l || a(h);
        },
        y = function () {
          return s;
        };
      t.b = u;
    },
    bQgK: function (e, t, n) {
      (function (t) {
        (function () {
          var n, o, a, r, i, l;
          "undefined" !== typeof performance &&
          null !== performance &&
          performance.now
            ? (e.exports = function () {
                return performance.now();
              })
            : "undefined" !== typeof t && null !== t && t.hrtime
              ? ((e.exports = function () {
                  return (n() - i) / 1e6;
                }),
                (o = t.hrtime),
                (r = (n = function () {
                  var e;
                  return 1e9 * (e = o())[0] + e[1];
                })()),
                (l = 1e9 * t.uptime()),
                (i = r - l))
              : Date.now
                ? ((e.exports = function () {
                    return Date.now() - a;
                  }),
                  (a = Date.now()))
                : ((e.exports = function () {
                    return new Date().getTime() - a;
                  }),
                  (a = new Date().getTime()));
        }).call(this);
      }).call(this, n("8oxB"));
    },
    bTu8: function (e, t, n) {
      "use strict";
      var o,
        a,
        r,
        i = n("/xfr"),
        l = n("Jq2x"),
        s = n("cKS0");
      function c() {
        return (
          o ||
            (o = (function () {
              var e = Object(i.b)(),
                t = Object(i.a)();
              return {
                touch: !!(
                  "ontouchstart" in e ||
                  (e.DocumentTouch && t instanceof e.DocumentTouch)
                ),
                pointerEvents:
                  !!e.PointerEvent &&
                  "maxTouchPoints" in e.navigator &&
                  e.navigator.maxTouchPoints >= 0,
                observer:
                  "MutationObserver" in e || "WebkitMutationObserver" in e,
                passiveListener: (function () {
                  var t = !1;
                  try {
                    var n = Object.defineProperty({}, "passive", {
                      get: function () {
                        t = !0;
                      },
                    });
                    e.addEventListener("testPassiveListener", null, n);
                  } catch (o) {}
                  return t;
                })(),
                gestures: "ongesturestart" in e,
              };
            })()),
          o
        );
      }
      function _(e) {
        return (
          void 0 === e && (e = {}),
          a ||
            (a = (function (e) {
              var t = (void 0 === e ? {} : e).userAgent,
                n = c(),
                o = Object(i.b)(),
                a = o.navigator.platform,
                r = t || o.navigator.userAgent,
                l = { ios: !1, android: !1 },
                s = o.screen.width,
                _ = o.screen.height,
                u = r.match(/(Android);?[\s\/]+([\d.]+)?/),
                d = r.match(/(iPad).*OS\s([\d_]+)/),
                p = r.match(/(iPod)(.*OS\s([\d_]+))?/),
                f = !d && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                h = "Win32" === a,
                m = "MacIntel" === a;
              return (
                !d &&
                  m &&
                  n.touch &&
                  [
                    "1024x1366",
                    "1366x1024",
                    "834x1194",
                    "1194x834",
                    "834x1112",
                    "1112x834",
                    "768x1024",
                    "1024x768",
                    "820x1180",
                    "1180x820",
                    "810x1080",
                    "1080x810",
                  ].indexOf(s + "x" + _) >= 0 &&
                  ((d = r.match(/(Version)\/([\d.]+)/)) ||
                    (d = [0, 1, "13_0_0"]),
                  (m = !1)),
                u && !h && ((l.os = "android"), (l.android = !0)),
                (d || f || p) && ((l.os = "ios"), (l.ios = !0)),
                l
              );
            })(e)),
          a
        );
      }
      function u() {
        return (
          r ||
            (r = (function () {
              var e = Object(i.b)();
              return {
                isEdge: !!e.navigator.userAgent.match(/Edge/g),
                isSafari: (function () {
                  var t = e.navigator.userAgent.toLowerCase();
                  return (
                    t.indexOf("safari") >= 0 &&
                    t.indexOf("chrome") < 0 &&
                    t.indexOf("android") < 0
                  );
                })(),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                  e.navigator.userAgent,
                ),
              };
            })()),
          r
        );
      }
      var d = {
        name: "resize",
        create: function () {
          var e = this;
          Object(s.e)(e, {
            resize: {
              observer: null,
              createObserver: function () {
                e &&
                  !e.destroyed &&
                  e.initialized &&
                  ((e.resize.observer = new ResizeObserver(function (t) {
                    var n = e.width,
                      o = e.height,
                      a = n,
                      r = o;
                    t.forEach(function (t) {
                      var n = t.contentBoxSize,
                        o = t.contentRect,
                        i = t.target;
                      (i && i !== e.el) ||
                        ((a = o ? o.width : (n[0] || n).inlineSize),
                        (r = o ? o.height : (n[0] || n).blockSize));
                    }),
                      (a === n && r === o) || e.resize.resizeHandler();
                  })),
                  e.resize.observer.observe(e.el));
              },
              removeObserver: function () {
                e.resize.observer &&
                  e.resize.observer.unobserve &&
                  e.el &&
                  (e.resize.observer.unobserve(e.el),
                  (e.resize.observer = null));
              },
              resizeHandler: function () {
                e &&
                  !e.destroyed &&
                  e.initialized &&
                  (e.emit("beforeResize"), e.emit("resize"));
              },
              orientationChangeHandler: function () {
                e &&
                  !e.destroyed &&
                  e.initialized &&
                  e.emit("orientationchange");
              },
            },
          });
        },
        on: {
          init: function (e) {
            var t = Object(i.b)();
            e.params.resizeObserver &&
            "undefined" !== typeof Object(i.b)().ResizeObserver
              ? e.resize.createObserver()
              : (t.addEventListener("resize", e.resize.resizeHandler),
                t.addEventListener(
                  "orientationchange",
                  e.resize.orientationChangeHandler,
                ));
          },
          destroy: function (e) {
            var t = Object(i.b)();
            e.resize.removeObserver(),
              t.removeEventListener("resize", e.resize.resizeHandler),
              t.removeEventListener(
                "orientationchange",
                e.resize.orientationChangeHandler,
              );
          },
        },
      };
      function p() {
        return (p =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      var f = {
          attach: function (e, t) {
            void 0 === t && (t = {});
            var n = Object(i.b)(),
              o = this,
              a = new (n.MutationObserver || n.WebkitMutationObserver)(
                function (e) {
                  if (1 !== e.length) {
                    var t = function () {
                      o.emit("observerUpdate", e[0]);
                    };
                    n.requestAnimationFrame
                      ? n.requestAnimationFrame(t)
                      : n.setTimeout(t, 0);
                  } else o.emit("observerUpdate", e[0]);
                },
              );
            a.observe(e, {
              attributes: "undefined" === typeof t.attributes || t.attributes,
              childList: "undefined" === typeof t.childList || t.childList,
              characterData:
                "undefined" === typeof t.characterData || t.characterData,
            }),
              o.observer.observers.push(a);
          },
          init: function () {
            if (this.support.observer && this.params.observer) {
              if (this.params.observeParents)
                for (var e = this.$el.parents(), t = 0; t < e.length; t += 1)
                  this.observer.attach(e[t]);
              this.observer.attach(this.$el[0], {
                childList: this.params.observeSlideChildren,
              }),
                this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
            }
          },
          destroy: function () {
            this.observer.observers.forEach(function (e) {
              e.disconnect();
            }),
              (this.observer.observers = []);
          },
        },
        h = {
          name: "observer",
          params: {
            observer: !1,
            observeParents: !1,
            observeSlideChildren: !1,
          },
          create: function () {
            Object(s.a)(this, { observer: p({}, f, { observers: [] }) });
          },
          on: {
            init: function (e) {
              e.observer.init();
            },
            destroy: function (e) {
              e.observer.destroy();
            },
          },
        };
      function m(e) {
        var t = Object(i.a)(),
          n = Object(i.b)(),
          o = this.touchEventsData,
          a = this.params,
          r = this.touches;
        if (
          this.enabled &&
          (!this.animating || !a.preventInteractionOnTransition)
        ) {
          var c = e;
          c.originalEvent && (c = c.originalEvent);
          var _ = Object(l.a)(c.target);
          if (
            ("wrapper" !== a.touchEventsTarget ||
              _.closest(this.wrapperEl).length) &&
            ((o.isTouchEvent = "touchstart" === c.type),
            (o.isTouchEvent || !("which" in c) || 3 !== c.which) &&
              !(!o.isTouchEvent && "button" in c && c.button > 0) &&
              (!o.isTouched || !o.isMoved))
          ) {
            !!a.noSwipingClass &&
              "" !== a.noSwipingClass &&
              c.target &&
              c.target.shadowRoot &&
              e.path &&
              e.path[0] &&
              (_ = Object(l.a)(e.path[0]));
            var u = a.noSwipingSelector
                ? a.noSwipingSelector
                : "." + a.noSwipingClass,
              d = !(!c.target || !c.target.shadowRoot);
            if (
              a.noSwiping &&
              (d
                ? (function (e, t) {
                    return (
                      void 0 === t && (t = this),
                      (function t(n) {
                        return n && n !== Object(i.a)() && n !== Object(i.b)()
                          ? (n.assignedSlot && (n = n.assignedSlot),
                            n.closest(e) || t(n.getRootNode().host))
                          : null;
                      })(t)
                    );
                  })(u, c.target)
                : _.closest(u)[0])
            )
              this.allowClick = !0;
            else if (!a.swipeHandler || _.closest(a.swipeHandler)[0]) {
              (r.currentX =
                "touchstart" === c.type ? c.targetTouches[0].pageX : c.pageX),
                (r.currentY =
                  "touchstart" === c.type ? c.targetTouches[0].pageY : c.pageY);
              var p = r.currentX,
                f = r.currentY,
                h = a.edgeSwipeDetection || a.iOSEdgeSwipeDetection,
                m = a.edgeSwipeThreshold || a.iOSEdgeSwipeThreshold;
              if (h && (p <= m || p >= n.innerWidth - m)) {
                if ("prevent" !== h) return;
                e.preventDefault();
              }
              if (
                (Object(s.e)(o, {
                  isTouched: !0,
                  isMoved: !1,
                  allowTouchCallbacks: !0,
                  isScrolling: void 0,
                  startMoving: void 0,
                }),
                (r.startX = p),
                (r.startY = f),
                (o.touchStartTime = Object(s.h)()),
                (this.allowClick = !0),
                this.updateSize(),
                (this.swipeDirection = void 0),
                a.threshold > 0 && (o.allowThresholdMove = !1),
                "touchstart" !== c.type)
              ) {
                var y = !0;
                _.is(o.focusableElements) && (y = !1),
                  t.activeElement &&
                    Object(l.a)(t.activeElement).is(o.focusableElements) &&
                    t.activeElement !== _[0] &&
                    t.activeElement.blur();
                var b = y && this.allowTouchMove && a.touchStartPreventDefault;
                (!a.touchStartForcePreventDefault && !b) ||
                  _[0].isContentEditable ||
                  c.preventDefault();
              }
              this.emit("touchStart", c);
            }
          }
        }
      }
      function y(e) {
        var t = Object(i.a)(),
          n = this.touchEventsData,
          o = this.params,
          a = this.touches,
          r = this.rtlTranslate;
        if (this.enabled) {
          var c = e;
          if ((c.originalEvent && (c = c.originalEvent), n.isTouched)) {
            if (!n.isTouchEvent || "touchmove" === c.type) {
              var _ =
                  "touchmove" === c.type &&
                  c.targetTouches &&
                  (c.targetTouches[0] || c.changedTouches[0]),
                u = "touchmove" === c.type ? _.pageX : c.pageX,
                d = "touchmove" === c.type ? _.pageY : c.pageY;
              if (c.preventedByNestedSwiper)
                return (a.startX = u), void (a.startY = d);
              if (!this.allowTouchMove)
                return (
                  (this.allowClick = !1),
                  void (
                    n.isTouched &&
                    (Object(s.e)(a, {
                      startX: u,
                      startY: d,
                      currentX: u,
                      currentY: d,
                    }),
                    (n.touchStartTime = Object(s.h)()))
                  )
                );
              if (n.isTouchEvent && o.touchReleaseOnEdges && !o.loop)
                if (this.isVertical()) {
                  if (
                    (d < a.startY && this.translate <= this.maxTranslate()) ||
                    (d > a.startY && this.translate >= this.minTranslate())
                  )
                    return (n.isTouched = !1), void (n.isMoved = !1);
                } else if (
                  (u < a.startX && this.translate <= this.maxTranslate()) ||
                  (u > a.startX && this.translate >= this.minTranslate())
                )
                  return;
              if (
                n.isTouchEvent &&
                t.activeElement &&
                c.target === t.activeElement &&
                Object(l.a)(c.target).is(n.focusableElements)
              )
                return (n.isMoved = !0), void (this.allowClick = !1);
              if (
                (n.allowTouchCallbacks && this.emit("touchMove", c),
                !(c.targetTouches && c.targetTouches.length > 1))
              ) {
                (a.currentX = u), (a.currentY = d);
                var p = a.currentX - a.startX,
                  f = a.currentY - a.startY;
                if (
                  !(
                    this.params.threshold &&
                    Math.sqrt(Math.pow(p, 2) + Math.pow(f, 2)) <
                      this.params.threshold
                  )
                ) {
                  var h;
                  if ("undefined" === typeof n.isScrolling)
                    (this.isHorizontal() && a.currentY === a.startY) ||
                    (this.isVertical() && a.currentX === a.startX)
                      ? (n.isScrolling = !1)
                      : p * p + f * f >= 25 &&
                        ((h =
                          (180 * Math.atan2(Math.abs(f), Math.abs(p))) /
                          Math.PI),
                        (n.isScrolling = this.isHorizontal()
                          ? h > o.touchAngle
                          : 90 - h > o.touchAngle));
                  if (
                    (n.isScrolling && this.emit("touchMoveOpposite", c),
                    "undefined" === typeof n.startMoving &&
                      ((a.currentX === a.startX && a.currentY === a.startY) ||
                        (n.startMoving = !0)),
                    n.isScrolling)
                  )
                    n.isTouched = !1;
                  else if (n.startMoving) {
                    (this.allowClick = !1),
                      !o.cssMode && c.cancelable && c.preventDefault(),
                      o.touchMoveStopPropagation &&
                        !o.nested &&
                        c.stopPropagation(),
                      n.isMoved ||
                        (o.loop && this.loopFix(),
                        (n.startTranslate = this.getTranslate()),
                        this.setTransition(0),
                        this.animating &&
                          this.$wrapperEl.trigger(
                            "webkitTransitionEnd transitionend",
                          ),
                        (n.allowMomentumBounce = !1),
                        !o.grabCursor ||
                          (!0 !== this.allowSlideNext &&
                            !0 !== this.allowSlidePrev) ||
                          this.setGrabCursor(!0),
                        this.emit("sliderFirstMove", c)),
                      this.emit("sliderMove", c),
                      (n.isMoved = !0);
                    var m = this.isHorizontal() ? p : f;
                    (a.diff = m),
                      (m *= o.touchRatio),
                      r && (m = -m),
                      (this.swipeDirection = m > 0 ? "prev" : "next"),
                      (n.currentTranslate = m + n.startTranslate);
                    var y = !0,
                      b = o.resistanceRatio;
                    if (
                      (o.touchReleaseOnEdges && (b = 0),
                      m > 0 && n.currentTranslate > this.minTranslate()
                        ? ((y = !1),
                          o.resistance &&
                            (n.currentTranslate =
                              this.minTranslate() -
                              1 +
                              Math.pow(
                                -this.minTranslate() + n.startTranslate + m,
                                b,
                              )))
                        : m < 0 &&
                          n.currentTranslate < this.maxTranslate() &&
                          ((y = !1),
                          o.resistance &&
                            (n.currentTranslate =
                              this.maxTranslate() +
                              1 -
                              Math.pow(
                                this.maxTranslate() - n.startTranslate - m,
                                b,
                              ))),
                      y && (c.preventedByNestedSwiper = !0),
                      !this.allowSlideNext &&
                        "next" === this.swipeDirection &&
                        n.currentTranslate < n.startTranslate &&
                        (n.currentTranslate = n.startTranslate),
                      !this.allowSlidePrev &&
                        "prev" === this.swipeDirection &&
                        n.currentTranslate > n.startTranslate &&
                        (n.currentTranslate = n.startTranslate),
                      this.allowSlidePrev ||
                        this.allowSlideNext ||
                        (n.currentTranslate = n.startTranslate),
                      o.threshold > 0)
                    ) {
                      if (!(Math.abs(m) > o.threshold || n.allowThresholdMove))
                        return void (n.currentTranslate = n.startTranslate);
                      if (!n.allowThresholdMove)
                        return (
                          (n.allowThresholdMove = !0),
                          (a.startX = a.currentX),
                          (a.startY = a.currentY),
                          (n.currentTranslate = n.startTranslate),
                          void (a.diff = this.isHorizontal()
                            ? a.currentX - a.startX
                            : a.currentY - a.startY)
                        );
                    }
                    o.followFinger &&
                      !o.cssMode &&
                      ((o.freeMode ||
                        o.watchSlidesProgress ||
                        o.watchSlidesVisibility) &&
                        (this.updateActiveIndex(), this.updateSlidesClasses()),
                      o.freeMode &&
                        (0 === n.velocities.length &&
                          n.velocities.push({
                            position:
                              a[this.isHorizontal() ? "startX" : "startY"],
                            time: n.touchStartTime,
                          }),
                        n.velocities.push({
                          position:
                            a[this.isHorizontal() ? "currentX" : "currentY"],
                          time: Object(s.h)(),
                        })),
                      this.updateProgress(n.currentTranslate),
                      this.setTranslate(n.currentTranslate));
                  }
                }
              }
            }
          } else
            n.startMoving && n.isScrolling && this.emit("touchMoveOpposite", c);
        }
      }
      function b(e) {
        var t = this,
          n = t.touchEventsData,
          o = t.params,
          a = t.touches,
          r = t.rtlTranslate,
          i = t.$wrapperEl,
          l = t.slidesGrid,
          c = t.snapGrid;
        if (t.enabled) {
          var _ = e;
          if (
            (_.originalEvent && (_ = _.originalEvent),
            n.allowTouchCallbacks && t.emit("touchEnd", _),
            (n.allowTouchCallbacks = !1),
            !n.isTouched)
          )
            return (
              n.isMoved && o.grabCursor && t.setGrabCursor(!1),
              (n.isMoved = !1),
              void (n.startMoving = !1)
            );
          o.grabCursor &&
            n.isMoved &&
            n.isTouched &&
            (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
            t.setGrabCursor(!1);
          var u,
            d = Object(s.h)(),
            p = d - n.touchStartTime;
          if (
            (t.allowClick &&
              (t.updateClickedSlide(_),
              t.emit("tap click", _),
              p < 300 &&
                d - n.lastClickTime < 300 &&
                t.emit("doubleTap doubleClick", _)),
            (n.lastClickTime = Object(s.h)()),
            Object(s.g)(function () {
              t.destroyed || (t.allowClick = !0);
            }),
            !n.isTouched ||
              !n.isMoved ||
              !t.swipeDirection ||
              0 === a.diff ||
              n.currentTranslate === n.startTranslate)
          )
            return (
              (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1)
            );
          if (
            ((n.isTouched = !1),
            (n.isMoved = !1),
            (n.startMoving = !1),
            (u = o.followFinger
              ? r
                ? t.translate
                : -t.translate
              : -n.currentTranslate),
            !o.cssMode)
          )
            if (o.freeMode) {
              if (u < -t.minTranslate()) return void t.slideTo(t.activeIndex);
              if (u > -t.maxTranslate())
                return void (t.slides.length < c.length
                  ? t.slideTo(c.length - 1)
                  : t.slideTo(t.slides.length - 1));
              if (o.freeModeMomentum) {
                if (n.velocities.length > 1) {
                  var f = n.velocities.pop(),
                    h = n.velocities.pop(),
                    m = f.position - h.position,
                    y = f.time - h.time;
                  (t.velocity = m / y),
                    (t.velocity /= 2),
                    Math.abs(t.velocity) < o.freeModeMinimumVelocity &&
                      (t.velocity = 0),
                    (y > 150 || Object(s.h)() - f.time > 300) &&
                      (t.velocity = 0);
                } else t.velocity = 0;
                (t.velocity *= o.freeModeMomentumVelocityRatio),
                  (n.velocities.length = 0);
                var b = 1e3 * o.freeModeMomentumRatio,
                  v = t.velocity * b,
                  g = t.translate + v;
                r && (g = -g);
                var w,
                  x,
                  k = !1,
                  O = 20 * Math.abs(t.velocity) * o.freeModeMomentumBounceRatio;
                if (g < t.maxTranslate())
                  o.freeModeMomentumBounce
                    ? (g + t.maxTranslate() < -O && (g = t.maxTranslate() - O),
                      (w = t.maxTranslate()),
                      (k = !0),
                      (n.allowMomentumBounce = !0))
                    : (g = t.maxTranslate()),
                    o.loop && o.centeredSlides && (x = !0);
                else if (g > t.minTranslate())
                  o.freeModeMomentumBounce
                    ? (g - t.minTranslate() > O && (g = t.minTranslate() + O),
                      (w = t.minTranslate()),
                      (k = !0),
                      (n.allowMomentumBounce = !0))
                    : (g = t.minTranslate()),
                    o.loop && o.centeredSlides && (x = !0);
                else if (o.freeModeSticky) {
                  for (var I, S = 0; S < c.length; S += 1)
                    if (c[S] > -g) {
                      I = S;
                      break;
                    }
                  g = -(g =
                    Math.abs(c[I] - g) < Math.abs(c[I - 1] - g) ||
                    "next" === t.swipeDirection
                      ? c[I]
                      : c[I - 1]);
                }
                if (
                  (x &&
                    t.once("transitionEnd", function () {
                      t.loopFix();
                    }),
                  0 !== t.velocity)
                ) {
                  if (
                    ((b = r
                      ? Math.abs((-g - t.translate) / t.velocity)
                      : Math.abs((g - t.translate) / t.velocity)),
                    o.freeModeSticky)
                  ) {
                    var j = Math.abs((r ? -g : g) - t.translate),
                      T = t.slidesSizesGrid[t.activeIndex];
                    b =
                      j < T
                        ? o.speed
                        : j < 2 * T
                          ? 1.5 * o.speed
                          : 2.5 * o.speed;
                  }
                } else if (o.freeModeSticky) return void t.slideToClosest();
                o.freeModeMomentumBounce && k
                  ? (t.updateProgress(w),
                    t.setTransition(b),
                    t.setTranslate(g),
                    t.transitionStart(!0, t.swipeDirection),
                    (t.animating = !0),
                    i.transitionEnd(function () {
                      t &&
                        !t.destroyed &&
                        n.allowMomentumBounce &&
                        (t.emit("momentumBounce"),
                        t.setTransition(o.speed),
                        setTimeout(function () {
                          t.setTranslate(w),
                            i.transitionEnd(function () {
                              t && !t.destroyed && t.transitionEnd();
                            });
                        }, 0));
                    }))
                  : t.velocity
                    ? (t.updateProgress(g),
                      t.setTransition(b),
                      t.setTranslate(g),
                      t.transitionStart(!0, t.swipeDirection),
                      t.animating ||
                        ((t.animating = !0),
                        i.transitionEnd(function () {
                          t && !t.destroyed && t.transitionEnd();
                        })))
                    : (t.emit("_freeModeNoMomentumRelease"),
                      t.updateProgress(g)),
                  t.updateActiveIndex(),
                  t.updateSlidesClasses();
              } else {
                if (o.freeModeSticky) return void t.slideToClosest();
                o.freeMode && t.emit("_freeModeNoMomentumRelease");
              }
              (!o.freeModeMomentum || p >= o.longSwipesMs) &&
                (t.updateProgress(),
                t.updateActiveIndex(),
                t.updateSlidesClasses());
            } else {
              for (
                var C = 0, M = t.slidesSizesGrid[0], P = 0;
                P < l.length;
                P += P < o.slidesPerGroupSkip ? 1 : o.slidesPerGroup
              ) {
                var E = P < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
                "undefined" !== typeof l[P + E]
                  ? u >= l[P] &&
                    u < l[P + E] &&
                    ((C = P), (M = l[P + E] - l[P]))
                  : u >= l[P] &&
                    ((C = P), (M = l[l.length - 1] - l[l.length - 2]));
              }
              var L = (u - l[C]) / M,
                B = C < o.slidesPerGroupSkip - 1 ? 1 : o.slidesPerGroup;
              if (p > o.longSwipesMs) {
                if (!o.longSwipes) return void t.slideTo(t.activeIndex);
                "next" === t.swipeDirection &&
                  (L >= o.longSwipesRatio ? t.slideTo(C + B) : t.slideTo(C)),
                  "prev" === t.swipeDirection &&
                    (L > 1 - o.longSwipesRatio
                      ? t.slideTo(C + B)
                      : t.slideTo(C));
              } else {
                if (!o.shortSwipes) return void t.slideTo(t.activeIndex);
                t.navigation &&
                (_.target === t.navigation.nextEl ||
                  _.target === t.navigation.prevEl)
                  ? _.target === t.navigation.nextEl
                    ? t.slideTo(C + B)
                    : t.slideTo(C)
                  : ("next" === t.swipeDirection && t.slideTo(C + B),
                    "prev" === t.swipeDirection && t.slideTo(C));
              }
            }
        }
      }
      function v() {
        var e = this.params,
          t = this.el;
        if (!t || 0 !== t.offsetWidth) {
          e.breakpoints && this.setBreakpoint();
          var n = this.allowSlideNext,
            o = this.allowSlidePrev,
            a = this.snapGrid;
          (this.allowSlideNext = !0),
            (this.allowSlidePrev = !0),
            this.updateSize(),
            this.updateSlides(),
            this.updateSlidesClasses(),
            ("auto" === e.slidesPerView || e.slidesPerView > 1) &&
            this.isEnd &&
            !this.isBeginning &&
            !this.params.centeredSlides
              ? this.slideTo(this.slides.length - 1, 0, !1, !0)
              : this.slideTo(this.activeIndex, 0, !1, !0),
            this.autoplay &&
              this.autoplay.running &&
              this.autoplay.paused &&
              this.autoplay.run(),
            (this.allowSlidePrev = o),
            (this.allowSlideNext = n),
            this.params.watchOverflow &&
              a !== this.snapGrid &&
              this.checkOverflow();
        }
      }
      function g(e) {
        this.enabled &&
          (this.allowClick ||
            (this.params.preventClicks && e.preventDefault(),
            this.params.preventClicksPropagation &&
              this.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function w() {
        var e = this.wrapperEl,
          t = this.rtlTranslate;
        if (this.enabled) {
          (this.previousTranslate = this.translate),
            this.isHorizontal()
              ? (this.translate = t
                  ? e.scrollWidth - e.offsetWidth - e.scrollLeft
                  : -e.scrollLeft)
              : (this.translate = -e.scrollTop),
            -0 === this.translate && (this.translate = 0),
            this.updateActiveIndex(),
            this.updateSlidesClasses();
          var n = this.maxTranslate() - this.minTranslate();
          (0 === n ? 0 : (this.translate - this.minTranslate()) / n) !==
            this.progress &&
            this.updateProgress(t ? -this.translate : this.translate),
            this.emit("setTranslate", this.translate, !1);
        }
      }
      var x = !1;
      function k() {}
      var O = {
        init: !0,
        direction: "horizontal",
        touchEventsTarget: "container",
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !1,
        nested: !1,
        createElements: !1,
        enabled: !0,
        focusableElements:
          "input, select, option, textarea, button, video, label",
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        freeMode: !1,
        freeModeMomentum: !0,
        freeModeMomentumRatio: 1,
        freeModeMomentumBounce: !0,
        freeModeMomentumBounceRatio: 1,
        freeModeMomentumVelocityRatio: 1,
        freeModeSticky: !1,
        freeModeMinimumVelocity: 0.02,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: "slide",
        breakpoints: void 0,
        breakpointsBase: "window",
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerColumnFill: "column",
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        watchOverflow: !1,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 0,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        watchSlidesVisibility: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        preloadImages: !0,
        updateOnImagesReady: !0,
        loop: !1,
        loopAdditionalSlides: 0,
        loopedSlides: null,
        loopFillGroupWithBlank: !1,
        loopPreventsSlide: !0,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: "swiper-no-swiping",
        noSwipingSelector: null,
        passiveListeners: !0,
        containerModifierClass: "swiper-container-",
        slideClass: "swiper-slide",
        slideBlankClass: "swiper-slide-invisible-blank",
        slideActiveClass: "swiper-slide-active",
        slideDuplicateActiveClass: "swiper-slide-duplicate-active",
        slideVisibleClass: "swiper-slide-visible",
        slideDuplicateClass: "swiper-slide-duplicate",
        slideNextClass: "swiper-slide-next",
        slideDuplicateNextClass: "swiper-slide-duplicate-next",
        slidePrevClass: "swiper-slide-prev",
        slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
        wrapperClass: "swiper-wrapper",
        runCallbacksOnInit: !0,
        _emitClasses: !1,
      };
      function I(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          (o.enumerable = o.enumerable || !1),
            (o.configurable = !0),
            "value" in o && (o.writable = !0),
            Object.defineProperty(e, o.key, o);
        }
      }
      var S = {
          modular: {
            useParams: function (e) {
              var t = this;
              t.modules &&
                Object.keys(t.modules).forEach(function (n) {
                  var o = t.modules[n];
                  o.params && Object(s.e)(e, o.params);
                });
            },
            useModules: function (e) {
              void 0 === e && (e = {});
              var t = this;
              t.modules &&
                Object.keys(t.modules).forEach(function (n) {
                  var o = t.modules[n],
                    a = e[n] || {};
                  o.on &&
                    t.on &&
                    Object.keys(o.on).forEach(function (e) {
                      t.on(e, o.on[e]);
                    }),
                    o.create && o.create.bind(t)(a);
                });
            },
          },
          eventsEmitter: {
            on: function (e, t, n) {
              var o = this;
              if ("function" !== typeof t) return o;
              var a = n ? "unshift" : "push";
              return (
                e.split(" ").forEach(function (e) {
                  o.eventsListeners[e] || (o.eventsListeners[e] = []),
                    o.eventsListeners[e][a](t);
                }),
                o
              );
            },
            once: function (e, t, n) {
              var o = this;
              if ("function" !== typeof t) return o;
              function a() {
                o.off(e, a), a.__emitterProxy && delete a.__emitterProxy;
                for (
                  var n = arguments.length, r = new Array(n), i = 0;
                  i < n;
                  i++
                )
                  r[i] = arguments[i];
                t.apply(o, r);
              }
              return (a.__emitterProxy = t), o.on(e, a, n);
            },
            onAny: function (e, t) {
              if ("function" !== typeof e) return this;
              var n = t ? "unshift" : "push";
              return (
                this.eventsAnyListeners.indexOf(e) < 0 &&
                  this.eventsAnyListeners[n](e),
                this
              );
            },
            offAny: function (e) {
              if (!this.eventsAnyListeners) return this;
              var t = this.eventsAnyListeners.indexOf(e);
              return t >= 0 && this.eventsAnyListeners.splice(t, 1), this;
            },
            off: function (e, t) {
              var n = this;
              return n.eventsListeners
                ? (e.split(" ").forEach(function (e) {
                    "undefined" === typeof t
                      ? (n.eventsListeners[e] = [])
                      : n.eventsListeners[e] &&
                        n.eventsListeners[e].forEach(function (o, a) {
                          (o === t ||
                            (o.__emitterProxy && o.__emitterProxy === t)) &&
                            n.eventsListeners[e].splice(a, 1);
                        });
                  }),
                  n)
                : n;
            },
            emit: function () {
              var e,
                t,
                n,
                o = this;
              if (!o.eventsListeners) return o;
              for (
                var a = arguments.length, r = new Array(a), i = 0;
                i < a;
                i++
              )
                r[i] = arguments[i];
              "string" === typeof r[0] || Array.isArray(r[0])
                ? ((e = r[0]), (t = r.slice(1, r.length)), (n = o))
                : ((e = r[0].events), (t = r[0].data), (n = r[0].context || o)),
                t.unshift(n);
              var l = Array.isArray(e) ? e : e.split(" ");
              return (
                l.forEach(function (e) {
                  o.eventsAnyListeners &&
                    o.eventsAnyListeners.length &&
                    o.eventsAnyListeners.forEach(function (o) {
                      o.apply(n, [e].concat(t));
                    }),
                    o.eventsListeners &&
                      o.eventsListeners[e] &&
                      o.eventsListeners[e].forEach(function (e) {
                        e.apply(n, t);
                      });
                }),
                o
              );
            },
          },
          update: {
            updateSize: function () {
              var e,
                t,
                n = this.$el;
              (e =
                "undefined" !== typeof this.params.width &&
                null !== this.params.width
                  ? this.params.width
                  : n[0].clientWidth),
                (t =
                  "undefined" !== typeof this.params.height &&
                  null !== this.params.height
                    ? this.params.height
                    : n[0].clientHeight),
                (0 === e && this.isHorizontal()) ||
                  (0 === t && this.isVertical()) ||
                  ((e =
                    e -
                    parseInt(n.css("padding-left") || 0, 10) -
                    parseInt(n.css("padding-right") || 0, 10)),
                  (t =
                    t -
                    parseInt(n.css("padding-top") || 0, 10) -
                    parseInt(n.css("padding-bottom") || 0, 10)),
                  Number.isNaN(e) && (e = 0),
                  Number.isNaN(t) && (t = 0),
                  Object(s.e)(this, {
                    width: e,
                    height: t,
                    size: this.isHorizontal() ? e : t,
                  }));
            },
            updateSlides: function () {
              var e = this;
              function t(t) {
                return e.isHorizontal()
                  ? t
                  : {
                      width: "height",
                      "margin-top": "margin-left",
                      "margin-bottom ": "margin-right",
                      "margin-left": "margin-top",
                      "margin-right": "margin-bottom",
                      "padding-left": "padding-top",
                      "padding-right": "padding-bottom",
                      marginRight: "marginBottom",
                    }[t];
              }
              function n(e, n) {
                return parseFloat(e.getPropertyValue(t(n)) || 0);
              }
              var o = e.params,
                a = e.$wrapperEl,
                r = e.size,
                i = e.rtlTranslate,
                l = e.wrongRTL,
                c = e.virtual && o.virtual.enabled,
                _ = c ? e.virtual.slides.length : e.slides.length,
                u = a.children("." + e.params.slideClass),
                d = c ? e.virtual.slides.length : u.length,
                p = [],
                f = [],
                h = [],
                m = o.slidesOffsetBefore;
              "function" === typeof m && (m = o.slidesOffsetBefore.call(e));
              var y = o.slidesOffsetAfter;
              "function" === typeof y && (y = o.slidesOffsetAfter.call(e));
              var b = e.snapGrid.length,
                v = e.slidesGrid.length,
                g = o.spaceBetween,
                w = -m,
                x = 0,
                k = 0;
              if ("undefined" !== typeof r) {
                var O, I;
                "string" === typeof g &&
                  g.indexOf("%") >= 0 &&
                  (g = (parseFloat(g.replace("%", "")) / 100) * r),
                  (e.virtualSize = -g),
                  i
                    ? u.css({ marginLeft: "", marginBottom: "", marginTop: "" })
                    : u.css({
                        marginRight: "",
                        marginBottom: "",
                        marginTop: "",
                      }),
                  o.slidesPerColumn > 1 &&
                    ((O =
                      Math.floor(d / o.slidesPerColumn) ===
                      d / e.params.slidesPerColumn
                        ? d
                        : Math.ceil(d / o.slidesPerColumn) * o.slidesPerColumn),
                    "auto" !== o.slidesPerView &&
                      "row" === o.slidesPerColumnFill &&
                      (O = Math.max(O, o.slidesPerView * o.slidesPerColumn)));
                for (
                  var S,
                    j,
                    T,
                    C = o.slidesPerColumn,
                    M = O / C,
                    P = Math.floor(d / o.slidesPerColumn),
                    E = 0;
                  E < d;
                  E += 1
                ) {
                  I = 0;
                  var L = u.eq(E);
                  if (o.slidesPerColumn > 1) {
                    var B = void 0,
                      N = void 0,
                      D = void 0;
                    if (
                      "row" === o.slidesPerColumnFill &&
                      o.slidesPerGroup > 1
                    ) {
                      var z = Math.floor(
                          E / (o.slidesPerGroup * o.slidesPerColumn),
                        ),
                        A = E - o.slidesPerColumn * o.slidesPerGroup * z,
                        R =
                          0 === z
                            ? o.slidesPerGroup
                            : Math.min(
                                Math.ceil((d - z * C * o.slidesPerGroup) / C),
                                o.slidesPerGroup,
                              );
                      (B =
                        (N =
                          A -
                          (D = Math.floor(A / R)) * R +
                          z * o.slidesPerGroup) +
                        (D * O) / C),
                        L.css({
                          "-webkit-box-ordinal-group": B,
                          "-moz-box-ordinal-group": B,
                          "-ms-flex-order": B,
                          "-webkit-order": B,
                          order: B,
                        });
                    } else
                      "column" === o.slidesPerColumnFill
                        ? ((D = E - (N = Math.floor(E / C)) * C),
                          (N > P || (N === P && D === C - 1)) &&
                            (D += 1) >= C &&
                            ((D = 0), (N += 1)))
                        : (N = E - (D = Math.floor(E / M)) * M);
                    L.css(
                      t("margin-top"),
                      0 !== D ? o.spaceBetween && o.spaceBetween + "px" : "",
                    );
                  }
                  if ("none" !== L.css("display")) {
                    if ("auto" === o.slidesPerView) {
                      var F = getComputedStyle(L[0]),
                        V = L[0].style.transform,
                        H = L[0].style.webkitTransform;
                      if (
                        (V && (L[0].style.transform = "none"),
                        H && (L[0].style.webkitTransform = "none"),
                        o.roundLengths)
                      )
                        I = e.isHorizontal()
                          ? L.outerWidth(!0)
                          : L.outerHeight(!0);
                      else {
                        var W = n(F, "width"),
                          U = n(F, "padding-left"),
                          G = n(F, "padding-right"),
                          Y = n(F, "margin-left"),
                          q = n(F, "margin-right"),
                          X = F.getPropertyValue("box-sizing");
                        if (X && "border-box" === X) I = W + Y + q;
                        else {
                          var Z = L[0],
                            K = Z.clientWidth;
                          I = W + U + G + Y + q + (Z.offsetWidth - K);
                        }
                      }
                      V && (L[0].style.transform = V),
                        H && (L[0].style.webkitTransform = H),
                        o.roundLengths && (I = Math.floor(I));
                    } else
                      (I = (r - (o.slidesPerView - 1) * g) / o.slidesPerView),
                        o.roundLengths && (I = Math.floor(I)),
                        u[E] && (u[E].style[t("width")] = I + "px");
                    u[E] && (u[E].swiperSlideSize = I),
                      h.push(I),
                      o.centeredSlides
                        ? ((w = w + I / 2 + x / 2 + g),
                          0 === x && 0 !== E && (w = w - r / 2 - g),
                          0 === E && (w = w - r / 2 - g),
                          Math.abs(w) < 0.001 && (w = 0),
                          o.roundLengths && (w = Math.floor(w)),
                          k % o.slidesPerGroup === 0 && p.push(w),
                          f.push(w))
                        : (o.roundLengths && (w = Math.floor(w)),
                          (k - Math.min(e.params.slidesPerGroupSkip, k)) %
                            e.params.slidesPerGroup ===
                            0 && p.push(w),
                          f.push(w),
                          (w = w + I + g)),
                      (e.virtualSize += I + g),
                      (x = I),
                      (k += 1);
                  }
                }
                if (
                  ((e.virtualSize = Math.max(e.virtualSize, r) + y),
                  i &&
                    l &&
                    ("slide" === o.effect || "coverflow" === o.effect) &&
                    a.css({ width: e.virtualSize + o.spaceBetween + "px" }),
                  o.setWrapperSize)
                )
                  a.css(
                    (((j = {})[t("width")] =
                      e.virtualSize + o.spaceBetween + "px"),
                    j),
                  );
                if (o.slidesPerColumn > 1)
                  if (
                    ((e.virtualSize = (I + o.spaceBetween) * O),
                    (e.virtualSize =
                      Math.ceil(e.virtualSize / o.slidesPerColumn) -
                      o.spaceBetween),
                    a.css(
                      (((T = {})[t("width")] =
                        e.virtualSize + o.spaceBetween + "px"),
                      T),
                    ),
                    o.centeredSlides)
                  ) {
                    S = [];
                    for (var Q = 0; Q < p.length; Q += 1) {
                      var J = p[Q];
                      o.roundLengths && (J = Math.floor(J)),
                        p[Q] < e.virtualSize + p[0] && S.push(J);
                    }
                    p = S;
                  }
                if (!o.centeredSlides) {
                  S = [];
                  for (var $ = 0; $ < p.length; $ += 1) {
                    var ee = p[$];
                    o.roundLengths && (ee = Math.floor(ee)),
                      p[$] <= e.virtualSize - r && S.push(ee);
                  }
                  (p = S),
                    Math.floor(e.virtualSize - r) -
                      Math.floor(p[p.length - 1]) >
                      1 && p.push(e.virtualSize - r);
                }
                if ((0 === p.length && (p = [0]), 0 !== o.spaceBetween)) {
                  var te,
                    ne =
                      e.isHorizontal() && i ? "marginLeft" : t("marginRight");
                  u.filter(function (e, t) {
                    return !o.cssMode || t !== u.length - 1;
                  }).css((((te = {})[ne] = g + "px"), te));
                }
                if (o.centeredSlides && o.centeredSlidesBounds) {
                  var oe = 0;
                  h.forEach(function (e) {
                    oe += e + (o.spaceBetween ? o.spaceBetween : 0);
                  });
                  var ae = (oe -= o.spaceBetween) - r;
                  p = p.map(function (e) {
                    return e < 0 ? -m : e > ae ? ae + y : e;
                  });
                }
                if (o.centerInsufficientSlides) {
                  var re = 0;
                  if (
                    (h.forEach(function (e) {
                      re += e + (o.spaceBetween ? o.spaceBetween : 0);
                    }),
                    (re -= o.spaceBetween) < r)
                  ) {
                    var ie = (r - re) / 2;
                    p.forEach(function (e, t) {
                      p[t] = e - ie;
                    }),
                      f.forEach(function (e, t) {
                        f[t] = e + ie;
                      });
                  }
                }
                Object(s.e)(e, {
                  slides: u,
                  snapGrid: p,
                  slidesGrid: f,
                  slidesSizesGrid: h,
                }),
                  d !== _ && e.emit("slidesLengthChange"),
                  p.length !== b &&
                    (e.params.watchOverflow && e.checkOverflow(),
                    e.emit("snapGridLengthChange")),
                  f.length !== v && e.emit("slidesGridLengthChange"),
                  (o.watchSlidesProgress || o.watchSlidesVisibility) &&
                    e.updateSlidesOffset();
              }
            },
            updateAutoHeight: function (e) {
              var t,
                n = this,
                o = [],
                a = n.virtual && n.params.virtual.enabled,
                r = 0;
              "number" === typeof e
                ? n.setTransition(e)
                : !0 === e && n.setTransition(n.params.speed);
              var i = function (e) {
                return a
                  ? n.slides.filter(function (t) {
                      return (
                        parseInt(
                          t.getAttribute("data-swiper-slide-index"),
                          10,
                        ) === e
                      );
                    })[0]
                  : n.slides.eq(e)[0];
              };
              if (
                "auto" !== n.params.slidesPerView &&
                n.params.slidesPerView > 1
              )
                if (n.params.centeredSlides)
                  n.visibleSlides.each(function (e) {
                    o.push(e);
                  });
                else
                  for (t = 0; t < Math.ceil(n.params.slidesPerView); t += 1) {
                    var l = n.activeIndex + t;
                    if (l > n.slides.length && !a) break;
                    o.push(i(l));
                  }
              else o.push(i(n.activeIndex));
              for (t = 0; t < o.length; t += 1)
                if ("undefined" !== typeof o[t]) {
                  var s = o[t].offsetHeight;
                  r = s > r ? s : r;
                }
              r && n.$wrapperEl.css("height", r + "px");
            },
            updateSlidesOffset: function () {
              for (var e = this.slides, t = 0; t < e.length; t += 1)
                e[t].swiperSlideOffset = this.isHorizontal()
                  ? e[t].offsetLeft
                  : e[t].offsetTop;
            },
            updateSlidesProgress: function (e) {
              void 0 === e && (e = (this && this.translate) || 0);
              var t = this.params,
                n = this.slides,
                o = this.rtlTranslate;
              if (0 !== n.length) {
                "undefined" === typeof n[0].swiperSlideOffset &&
                  this.updateSlidesOffset();
                var a = -e;
                o && (a = e),
                  n.removeClass(t.slideVisibleClass),
                  (this.visibleSlidesIndexes = []),
                  (this.visibleSlides = []);
                for (var r = 0; r < n.length; r += 1) {
                  var i = n[r],
                    s =
                      (a +
                        (t.centeredSlides ? this.minTranslate() : 0) -
                        i.swiperSlideOffset) /
                      (i.swiperSlideSize + t.spaceBetween);
                  if (
                    t.watchSlidesVisibility ||
                    (t.centeredSlides && t.autoHeight)
                  ) {
                    var c = -(a - i.swiperSlideOffset),
                      _ = c + this.slidesSizesGrid[r];
                    ((c >= 0 && c < this.size - 1) ||
                      (_ > 1 && _ <= this.size) ||
                      (c <= 0 && _ >= this.size)) &&
                      (this.visibleSlides.push(i),
                      this.visibleSlidesIndexes.push(r),
                      n.eq(r).addClass(t.slideVisibleClass));
                  }
                  i.progress = o ? -s : s;
                }
                this.visibleSlides = Object(l.a)(this.visibleSlides);
              }
            },
            updateProgress: function (e) {
              if ("undefined" === typeof e) {
                var t = this.rtlTranslate ? -1 : 1;
                e = (this && this.translate && this.translate * t) || 0;
              }
              var n = this.params,
                o = this.maxTranslate() - this.minTranslate(),
                a = this.progress,
                r = this.isBeginning,
                i = this.isEnd,
                l = r,
                c = i;
              0 === o
                ? ((a = 0), (r = !0), (i = !0))
                : ((r = (a = (e - this.minTranslate()) / o) <= 0),
                  (i = a >= 1)),
                Object(s.e)(this, { progress: a, isBeginning: r, isEnd: i }),
                (n.watchSlidesProgress ||
                  n.watchSlidesVisibility ||
                  (n.centeredSlides && n.autoHeight)) &&
                  this.updateSlidesProgress(e),
                r && !l && this.emit("reachBeginning toEdge"),
                i && !c && this.emit("reachEnd toEdge"),
                ((l && !r) || (c && !i)) && this.emit("fromEdge"),
                this.emit("progress", a);
            },
            updateSlidesClasses: function () {
              var e,
                t = this.slides,
                n = this.params,
                o = this.$wrapperEl,
                a = this.activeIndex,
                r = this.realIndex,
                i = this.virtual && n.virtual.enabled;
              t.removeClass(
                n.slideActiveClass +
                  " " +
                  n.slideNextClass +
                  " " +
                  n.slidePrevClass +
                  " " +
                  n.slideDuplicateActiveClass +
                  " " +
                  n.slideDuplicateNextClass +
                  " " +
                  n.slideDuplicatePrevClass,
              ),
                (e = i
                  ? this.$wrapperEl.find(
                      "." +
                        n.slideClass +
                        '[data-swiper-slide-index="' +
                        a +
                        '"]',
                    )
                  : t.eq(a)).addClass(n.slideActiveClass),
                n.loop &&
                  (e.hasClass(n.slideDuplicateClass)
                    ? o
                        .children(
                          "." +
                            n.slideClass +
                            ":not(." +
                            n.slideDuplicateClass +
                            ')[data-swiper-slide-index="' +
                            r +
                            '"]',
                        )
                        .addClass(n.slideDuplicateActiveClass)
                    : o
                        .children(
                          "." +
                            n.slideClass +
                            "." +
                            n.slideDuplicateClass +
                            '[data-swiper-slide-index="' +
                            r +
                            '"]',
                        )
                        .addClass(n.slideDuplicateActiveClass));
              var l = e
                .nextAll("." + n.slideClass)
                .eq(0)
                .addClass(n.slideNextClass);
              n.loop &&
                0 === l.length &&
                (l = t.eq(0)).addClass(n.slideNextClass);
              var s = e
                .prevAll("." + n.slideClass)
                .eq(0)
                .addClass(n.slidePrevClass);
              n.loop &&
                0 === s.length &&
                (s = t.eq(-1)).addClass(n.slidePrevClass),
                n.loop &&
                  (l.hasClass(n.slideDuplicateClass)
                    ? o
                        .children(
                          "." +
                            n.slideClass +
                            ":not(." +
                            n.slideDuplicateClass +
                            ')[data-swiper-slide-index="' +
                            l.attr("data-swiper-slide-index") +
                            '"]',
                        )
                        .addClass(n.slideDuplicateNextClass)
                    : o
                        .children(
                          "." +
                            n.slideClass +
                            "." +
                            n.slideDuplicateClass +
                            '[data-swiper-slide-index="' +
                            l.attr("data-swiper-slide-index") +
                            '"]',
                        )
                        .addClass(n.slideDuplicateNextClass),
                  s.hasClass(n.slideDuplicateClass)
                    ? o
                        .children(
                          "." +
                            n.slideClass +
                            ":not(." +
                            n.slideDuplicateClass +
                            ')[data-swiper-slide-index="' +
                            s.attr("data-swiper-slide-index") +
                            '"]',
                        )
                        .addClass(n.slideDuplicatePrevClass)
                    : o
                        .children(
                          "." +
                            n.slideClass +
                            "." +
                            n.slideDuplicateClass +
                            '[data-swiper-slide-index="' +
                            s.attr("data-swiper-slide-index") +
                            '"]',
                        )
                        .addClass(n.slideDuplicatePrevClass)),
                this.emitSlidesClasses();
            },
            updateActiveIndex: function (e) {
              var t,
                n = this.rtlTranslate ? this.translate : -this.translate,
                o = this.slidesGrid,
                a = this.snapGrid,
                r = this.params,
                i = this.activeIndex,
                l = this.realIndex,
                c = this.snapIndex,
                _ = e;
              if ("undefined" === typeof _) {
                for (var u = 0; u < o.length; u += 1)
                  "undefined" !== typeof o[u + 1]
                    ? n >= o[u] && n < o[u + 1] - (o[u + 1] - o[u]) / 2
                      ? (_ = u)
                      : n >= o[u] && n < o[u + 1] && (_ = u + 1)
                    : n >= o[u] && (_ = u);
                r.normalizeSlideIndex &&
                  (_ < 0 || "undefined" === typeof _) &&
                  (_ = 0);
              }
              if (a.indexOf(n) >= 0) t = a.indexOf(n);
              else {
                var d = Math.min(r.slidesPerGroupSkip, _);
                t = d + Math.floor((_ - d) / r.slidesPerGroup);
              }
              if ((t >= a.length && (t = a.length - 1), _ !== i)) {
                var p = parseInt(
                  this.slides.eq(_).attr("data-swiper-slide-index") || _,
                  10,
                );
                Object(s.e)(this, {
                  snapIndex: t,
                  realIndex: p,
                  previousIndex: i,
                  activeIndex: _,
                }),
                  this.emit("activeIndexChange"),
                  this.emit("snapIndexChange"),
                  l !== p && this.emit("realIndexChange"),
                  (this.initialized || this.params.runCallbacksOnInit) &&
                    this.emit("slideChange");
              } else
                t !== c && ((this.snapIndex = t), this.emit("snapIndexChange"));
            },
            updateClickedSlide: function (e) {
              var t,
                n = this.params,
                o = Object(l.a)(e.target).closest("." + n.slideClass)[0],
                a = !1;
              if (o)
                for (var r = 0; r < this.slides.length; r += 1)
                  if (this.slides[r] === o) {
                    (a = !0), (t = r);
                    break;
                  }
              if (!o || !a)
                return (
                  (this.clickedSlide = void 0),
                  void (this.clickedIndex = void 0)
                );
              (this.clickedSlide = o),
                this.virtual && this.params.virtual.enabled
                  ? (this.clickedIndex = parseInt(
                      Object(l.a)(o).attr("data-swiper-slide-index"),
                      10,
                    ))
                  : (this.clickedIndex = t),
                n.slideToClickedSlide &&
                  void 0 !== this.clickedIndex &&
                  this.clickedIndex !== this.activeIndex &&
                  this.slideToClickedSlide();
            },
          },
          translate: {
            getTranslate: function (e) {
              void 0 === e && (e = this.isHorizontal() ? "x" : "y");
              var t = this.params,
                n = this.rtlTranslate,
                o = this.translate,
                a = this.$wrapperEl;
              if (t.virtualTranslate) return n ? -o : o;
              if (t.cssMode) return o;
              var r = Object(s.f)(a[0], e);
              return n && (r = -r), r || 0;
            },
            setTranslate: function (e, t) {
              var n = this.rtlTranslate,
                o = this.params,
                a = this.$wrapperEl,
                r = this.wrapperEl,
                i = this.progress,
                l = 0,
                s = 0;
              this.isHorizontal() ? (l = n ? -e : e) : (s = e),
                o.roundLengths && ((l = Math.floor(l)), (s = Math.floor(s))),
                o.cssMode
                  ? (r[this.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                      this.isHorizontal() ? -l : -s)
                  : o.virtualTranslate ||
                    a.transform("translate3d(" + l + "px, " + s + "px, 0px)"),
                (this.previousTranslate = this.translate),
                (this.translate = this.isHorizontal() ? l : s);
              var c = this.maxTranslate() - this.minTranslate();
              (0 === c ? 0 : (e - this.minTranslate()) / c) !== i &&
                this.updateProgress(e),
                this.emit("setTranslate", this.translate, t);
            },
            minTranslate: function () {
              return -this.snapGrid[0];
            },
            maxTranslate: function () {
              return -this.snapGrid[this.snapGrid.length - 1];
            },
            translateTo: function (e, t, n, o, a) {
              void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === n && (n = !0),
                void 0 === o && (o = !0);
              var r = this,
                i = r.params,
                l = r.wrapperEl;
              if (r.animating && i.preventInteractionOnTransition) return !1;
              var s,
                c = r.minTranslate(),
                _ = r.maxTranslate();
              if (
                ((s = o && e > c ? c : o && e < _ ? _ : e),
                r.updateProgress(s),
                i.cssMode)
              ) {
                var u,
                  d = r.isHorizontal();
                if (0 === t) l[d ? "scrollLeft" : "scrollTop"] = -s;
                else if (l.scrollTo)
                  l.scrollTo(
                    (((u = {})[d ? "left" : "top"] = -s),
                    (u.behavior = "smooth"),
                    u),
                  );
                else l[d ? "scrollLeft" : "scrollTop"] = -s;
                return !0;
              }
              return (
                0 === t
                  ? (r.setTransition(0),
                    r.setTranslate(s),
                    n &&
                      (r.emit("beforeTransitionStart", t, a),
                      r.emit("transitionEnd")))
                  : (r.setTransition(t),
                    r.setTranslate(s),
                    n &&
                      (r.emit("beforeTransitionStart", t, a),
                      r.emit("transitionStart")),
                    r.animating ||
                      ((r.animating = !0),
                      r.onTranslateToWrapperTransitionEnd ||
                        (r.onTranslateToWrapperTransitionEnd = function (e) {
                          r &&
                            !r.destroyed &&
                            e.target === this &&
                            (r.$wrapperEl[0].removeEventListener(
                              "transitionend",
                              r.onTranslateToWrapperTransitionEnd,
                            ),
                            r.$wrapperEl[0].removeEventListener(
                              "webkitTransitionEnd",
                              r.onTranslateToWrapperTransitionEnd,
                            ),
                            (r.onTranslateToWrapperTransitionEnd = null),
                            delete r.onTranslateToWrapperTransitionEnd,
                            n && r.emit("transitionEnd"));
                        }),
                      r.$wrapperEl[0].addEventListener(
                        "transitionend",
                        r.onTranslateToWrapperTransitionEnd,
                      ),
                      r.$wrapperEl[0].addEventListener(
                        "webkitTransitionEnd",
                        r.onTranslateToWrapperTransitionEnd,
                      ))),
                !0
              );
            },
          },
          transition: {
            setTransition: function (e, t) {
              this.params.cssMode || this.$wrapperEl.transition(e),
                this.emit("setTransition", e, t);
            },
            transitionStart: function (e, t) {
              void 0 === e && (e = !0);
              var n = this.activeIndex,
                o = this.params,
                a = this.previousIndex;
              if (!o.cssMode) {
                o.autoHeight && this.updateAutoHeight();
                var r = t;
                if (
                  (r || (r = n > a ? "next" : n < a ? "prev" : "reset"),
                  this.emit("transitionStart"),
                  e && n !== a)
                ) {
                  if ("reset" === r)
                    return void this.emit("slideResetTransitionStart");
                  this.emit("slideChangeTransitionStart"),
                    "next" === r
                      ? this.emit("slideNextTransitionStart")
                      : this.emit("slidePrevTransitionStart");
                }
              }
            },
            transitionEnd: function (e, t) {
              void 0 === e && (e = !0);
              var n = this.activeIndex,
                o = this.previousIndex,
                a = this.params;
              if (((this.animating = !1), !a.cssMode)) {
                this.setTransition(0);
                var r = t;
                if (
                  (r || (r = n > o ? "next" : n < o ? "prev" : "reset"),
                  this.emit("transitionEnd"),
                  e && n !== o)
                ) {
                  if ("reset" === r)
                    return void this.emit("slideResetTransitionEnd");
                  this.emit("slideChangeTransitionEnd"),
                    "next" === r
                      ? this.emit("slideNextTransitionEnd")
                      : this.emit("slidePrevTransitionEnd");
                }
              }
            },
          },
          slide: {
            slideTo: function (e, t, n, o, a) {
              if (
                (void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === n && (n = !0),
                "number" !== typeof e && "string" !== typeof e)
              )
                throw new Error(
                  "The 'index' argument cannot have type other than 'number' or 'string'. [" +
                    typeof e +
                    "] given.",
                );
              if ("string" === typeof e) {
                var r = parseInt(e, 10);
                if (!isFinite(r))
                  throw new Error(
                    "The passed-in 'index' (string) couldn't be converted to 'number'. [" +
                      e +
                      "] given.",
                  );
                e = r;
              }
              var i = this,
                l = e;
              l < 0 && (l = 0);
              var s = i.params,
                c = i.snapGrid,
                _ = i.slidesGrid,
                u = i.previousIndex,
                d = i.activeIndex,
                p = i.rtlTranslate,
                f = i.wrapperEl,
                h = i.enabled;
              if (
                (i.animating && s.preventInteractionOnTransition) ||
                (!h && !o && !a)
              )
                return !1;
              var m = Math.min(i.params.slidesPerGroupSkip, l),
                y = m + Math.floor((l - m) / i.params.slidesPerGroup);
              y >= c.length && (y = c.length - 1),
                (d || s.initialSlide || 0) === (u || 0) &&
                  n &&
                  i.emit("beforeSlideChangeStart");
              var b,
                v = -c[y];
              if ((i.updateProgress(v), s.normalizeSlideIndex))
                for (var g = 0; g < _.length; g += 1) {
                  var w = -Math.floor(100 * v),
                    x = Math.floor(100 * _[g]),
                    k = Math.floor(100 * _[g + 1]);
                  "undefined" !== typeof _[g + 1]
                    ? w >= x && w < k - (k - x) / 2
                      ? (l = g)
                      : w >= x && w < k && (l = g + 1)
                    : w >= x && (l = g);
                }
              if (i.initialized && l !== d) {
                if (
                  !i.allowSlideNext &&
                  v < i.translate &&
                  v < i.minTranslate()
                )
                  return !1;
                if (
                  !i.allowSlidePrev &&
                  v > i.translate &&
                  v > i.maxTranslate() &&
                  (d || 0) !== l
                )
                  return !1;
              }
              if (
                ((b = l > d ? "next" : l < d ? "prev" : "reset"),
                (p && -v === i.translate) || (!p && v === i.translate))
              )
                return (
                  i.updateActiveIndex(l),
                  s.autoHeight && i.updateAutoHeight(),
                  i.updateSlidesClasses(),
                  "slide" !== s.effect && i.setTranslate(v),
                  "reset" !== b &&
                    (i.transitionStart(n, b), i.transitionEnd(n, b)),
                  !1
                );
              if (s.cssMode) {
                var O,
                  I = i.isHorizontal(),
                  S = -v;
                if ((p && (S = f.scrollWidth - f.offsetWidth - S), 0 === t))
                  f[I ? "scrollLeft" : "scrollTop"] = S;
                else if (f.scrollTo)
                  f.scrollTo(
                    (((O = {})[I ? "left" : "top"] = S),
                    (O.behavior = "smooth"),
                    O),
                  );
                else f[I ? "scrollLeft" : "scrollTop"] = S;
                return !0;
              }
              return (
                0 === t
                  ? (i.setTransition(0),
                    i.setTranslate(v),
                    i.updateActiveIndex(l),
                    i.updateSlidesClasses(),
                    i.emit("beforeTransitionStart", t, o),
                    i.transitionStart(n, b),
                    i.transitionEnd(n, b))
                  : (i.setTransition(t),
                    i.setTranslate(v),
                    i.updateActiveIndex(l),
                    i.updateSlidesClasses(),
                    i.emit("beforeTransitionStart", t, o),
                    i.transitionStart(n, b),
                    i.animating ||
                      ((i.animating = !0),
                      i.onSlideToWrapperTransitionEnd ||
                        (i.onSlideToWrapperTransitionEnd = function (e) {
                          i &&
                            !i.destroyed &&
                            e.target === this &&
                            (i.$wrapperEl[0].removeEventListener(
                              "transitionend",
                              i.onSlideToWrapperTransitionEnd,
                            ),
                            i.$wrapperEl[0].removeEventListener(
                              "webkitTransitionEnd",
                              i.onSlideToWrapperTransitionEnd,
                            ),
                            (i.onSlideToWrapperTransitionEnd = null),
                            delete i.onSlideToWrapperTransitionEnd,
                            i.transitionEnd(n, b));
                        }),
                      i.$wrapperEl[0].addEventListener(
                        "transitionend",
                        i.onSlideToWrapperTransitionEnd,
                      ),
                      i.$wrapperEl[0].addEventListener(
                        "webkitTransitionEnd",
                        i.onSlideToWrapperTransitionEnd,
                      ))),
                !0
              );
            },
            slideToLoop: function (e, t, n, o) {
              void 0 === e && (e = 0),
                void 0 === t && (t = this.params.speed),
                void 0 === n && (n = !0);
              var a = e;
              return (
                this.params.loop && (a += this.loopedSlides),
                this.slideTo(a, t, n, o)
              );
            },
            slideNext: function (e, t, n) {
              void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
              var o = this.params,
                a = this.animating;
              if (!this.enabled) return this;
              var r =
                this.activeIndex < o.slidesPerGroupSkip ? 1 : o.slidesPerGroup;
              if (o.loop) {
                if (a && o.loopPreventsSlide) return !1;
                this.loopFix(),
                  (this._clientLeft = this.$wrapperEl[0].clientLeft);
              }
              return this.slideTo(this.activeIndex + r, e, t, n);
            },
            slidePrev: function (e, t, n) {
              void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
              var o = this.params,
                a = this.animating,
                r = this.snapGrid,
                i = this.slidesGrid,
                l = this.rtlTranslate;
              if (!this.enabled) return this;
              if (o.loop) {
                if (a && o.loopPreventsSlide) return !1;
                this.loopFix(),
                  (this._clientLeft = this.$wrapperEl[0].clientLeft);
              }
              function s(e) {
                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
              }
              var c,
                _ = s(l ? this.translate : -this.translate),
                u = r.map(function (e) {
                  return s(e);
                }),
                d = r[u.indexOf(_) - 1];
              return (
                "undefined" === typeof d &&
                  o.cssMode &&
                  r.forEach(function (e) {
                    !d && _ >= e && (d = e);
                  }),
                "undefined" !== typeof d &&
                  (c = i.indexOf(d)) < 0 &&
                  (c = this.activeIndex - 1),
                this.slideTo(c, e, t, n)
              );
            },
            slideReset: function (e, t, n) {
              return (
                void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                this.slideTo(this.activeIndex, e, t, n)
              );
            },
            slideToClosest: function (e, t, n, o) {
              void 0 === e && (e = this.params.speed),
                void 0 === t && (t = !0),
                void 0 === o && (o = 0.5);
              var a = this.activeIndex,
                r = Math.min(this.params.slidesPerGroupSkip, a),
                i = r + Math.floor((a - r) / this.params.slidesPerGroup),
                l = this.rtlTranslate ? this.translate : -this.translate;
              if (l >= this.snapGrid[i]) {
                var s = this.snapGrid[i];
                l - s > (this.snapGrid[i + 1] - s) * o &&
                  (a += this.params.slidesPerGroup);
              } else {
                var c = this.snapGrid[i - 1];
                l - c <= (this.snapGrid[i] - c) * o &&
                  (a -= this.params.slidesPerGroup);
              }
              return (
                (a = Math.max(a, 0)),
                (a = Math.min(a, this.slidesGrid.length - 1)),
                this.slideTo(a, e, t, n)
              );
            },
            slideToClickedSlide: function () {
              var e,
                t = this,
                n = t.params,
                o = t.$wrapperEl,
                a =
                  "auto" === n.slidesPerView
                    ? t.slidesPerViewDynamic()
                    : n.slidesPerView,
                r = t.clickedIndex;
              if (n.loop) {
                if (t.animating) return;
                (e = parseInt(
                  Object(l.a)(t.clickedSlide).attr("data-swiper-slide-index"),
                  10,
                )),
                  n.centeredSlides
                    ? r < t.loopedSlides - a / 2 ||
                      r > t.slides.length - t.loopedSlides + a / 2
                      ? (t.loopFix(),
                        (r = o
                          .children(
                            "." +
                              n.slideClass +
                              '[data-swiper-slide-index="' +
                              e +
                              '"]:not(.' +
                              n.slideDuplicateClass +
                              ")",
                          )
                          .eq(0)
                          .index()),
                        Object(s.g)(function () {
                          t.slideTo(r);
                        }))
                      : t.slideTo(r)
                    : r > t.slides.length - a
                      ? (t.loopFix(),
                        (r = o
                          .children(
                            "." +
                              n.slideClass +
                              '[data-swiper-slide-index="' +
                              e +
                              '"]:not(.' +
                              n.slideDuplicateClass +
                              ")",
                          )
                          .eq(0)
                          .index()),
                        Object(s.g)(function () {
                          t.slideTo(r);
                        }))
                      : t.slideTo(r);
              } else t.slideTo(r);
            },
          },
          loop: {
            loopCreate: function () {
              var e = this,
                t = Object(i.a)(),
                n = e.params,
                o = e.$wrapperEl;
              o.children(
                "." + n.slideClass + "." + n.slideDuplicateClass,
              ).remove();
              var a = o.children("." + n.slideClass);
              if (n.loopFillGroupWithBlank) {
                var r = n.slidesPerGroup - (a.length % n.slidesPerGroup);
                if (r !== n.slidesPerGroup) {
                  for (var s = 0; s < r; s += 1) {
                    var c = Object(l.a)(t.createElement("div")).addClass(
                      n.slideClass + " " + n.slideBlankClass,
                    );
                    o.append(c);
                  }
                  a = o.children("." + n.slideClass);
                }
              }
              "auto" !== n.slidesPerView ||
                n.loopedSlides ||
                (n.loopedSlides = a.length),
                (e.loopedSlides = Math.ceil(
                  parseFloat(n.loopedSlides || n.slidesPerView, 10),
                )),
                (e.loopedSlides += n.loopAdditionalSlides),
                e.loopedSlides > a.length && (e.loopedSlides = a.length);
              var _ = [],
                u = [];
              a.each(function (t, n) {
                var o = Object(l.a)(t);
                n < e.loopedSlides && u.push(t),
                  n < a.length && n >= a.length - e.loopedSlides && _.push(t),
                  o.attr("data-swiper-slide-index", n);
              });
              for (var d = 0; d < u.length; d += 1)
                o.append(
                  Object(l.a)(u[d].cloneNode(!0)).addClass(
                    n.slideDuplicateClass,
                  ),
                );
              for (var p = _.length - 1; p >= 0; p -= 1)
                o.prepend(
                  Object(l.a)(_[p].cloneNode(!0)).addClass(
                    n.slideDuplicateClass,
                  ),
                );
            },
            loopFix: function () {
              this.emit("beforeLoopFix");
              var e,
                t = this.activeIndex,
                n = this.slides,
                o = this.loopedSlides,
                a = this.allowSlidePrev,
                r = this.allowSlideNext,
                i = this.snapGrid,
                l = this.rtlTranslate;
              (this.allowSlidePrev = !0), (this.allowSlideNext = !0);
              var s = -i[t] - this.getTranslate();
              if (t < o)
                (e = n.length - 3 * o + t),
                  (e += o),
                  this.slideTo(e, 0, !1, !0) &&
                    0 !== s &&
                    this.setTranslate(
                      (l ? -this.translate : this.translate) - s,
                    );
              else if (t >= n.length - o) {
                (e = -n.length + t + o),
                  (e += o),
                  this.slideTo(e, 0, !1, !0) &&
                    0 !== s &&
                    this.setTranslate(
                      (l ? -this.translate : this.translate) - s,
                    );
              }
              (this.allowSlidePrev = a),
                (this.allowSlideNext = r),
                this.emit("loopFix");
            },
            loopDestroy: function () {
              var e = this.$wrapperEl,
                t = this.params,
                n = this.slides;
              e
                .children(
                  "." +
                    t.slideClass +
                    "." +
                    t.slideDuplicateClass +
                    ",." +
                    t.slideClass +
                    "." +
                    t.slideBlankClass,
                )
                .remove(),
                n.removeAttr("data-swiper-slide-index");
            },
          },
          grabCursor: {
            setGrabCursor: function (e) {
              if (
                !(
                  this.support.touch ||
                  !this.params.simulateTouch ||
                  (this.params.watchOverflow && this.isLocked) ||
                  this.params.cssMode
                )
              ) {
                var t = this.el;
                (t.style.cursor = "move"),
                  (t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
                  (t.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
                  (t.style.cursor = e ? "grabbing" : "grab");
              }
            },
            unsetGrabCursor: function () {
              this.support.touch ||
                (this.params.watchOverflow && this.isLocked) ||
                this.params.cssMode ||
                (this.el.style.cursor = "");
            },
          },
          manipulation: {
            appendSlide: function (e) {
              var t = this.$wrapperEl,
                n = this.params;
              if (
                (n.loop && this.loopDestroy(),
                "object" === typeof e && "length" in e)
              )
                for (var o = 0; o < e.length; o += 1) e[o] && t.append(e[o]);
              else t.append(e);
              n.loop && this.loopCreate(),
                (n.observer && this.support.observer) || this.update();
            },
            prependSlide: function (e) {
              var t = this.params,
                n = this.$wrapperEl,
                o = this.activeIndex;
              t.loop && this.loopDestroy();
              var a = o + 1;
              if ("object" === typeof e && "length" in e) {
                for (var r = 0; r < e.length; r += 1) e[r] && n.prepend(e[r]);
                a = o + e.length;
              } else n.prepend(e);
              t.loop && this.loopCreate(),
                (t.observer && this.support.observer) || this.update(),
                this.slideTo(a, 0, !1);
            },
            addSlide: function (e, t) {
              var n = this.$wrapperEl,
                o = this.params,
                a = this.activeIndex;
              o.loop &&
                ((a -= this.loopedSlides),
                this.loopDestroy(),
                (this.slides = n.children("." + o.slideClass)));
              var r = this.slides.length;
              if (e <= 0) this.prependSlide(t);
              else if (e >= r) this.appendSlide(t);
              else {
                for (
                  var i = a > e ? a + 1 : a, l = [], s = r - 1;
                  s >= e;
                  s -= 1
                ) {
                  var c = this.slides.eq(s);
                  c.remove(), l.unshift(c);
                }
                if ("object" === typeof t && "length" in t) {
                  for (var _ = 0; _ < t.length; _ += 1) t[_] && n.append(t[_]);
                  i = a > e ? a + t.length : a;
                } else n.append(t);
                for (var u = 0; u < l.length; u += 1) n.append(l[u]);
                o.loop && this.loopCreate(),
                  (o.observer && this.support.observer) || this.update(),
                  o.loop
                    ? this.slideTo(i + this.loopedSlides, 0, !1)
                    : this.slideTo(i, 0, !1);
              }
            },
            removeSlide: function (e) {
              var t = this.params,
                n = this.$wrapperEl,
                o = this.activeIndex;
              t.loop &&
                ((o -= this.loopedSlides),
                this.loopDestroy(),
                (this.slides = n.children("." + t.slideClass)));
              var a,
                r = o;
              if ("object" === typeof e && "length" in e) {
                for (var i = 0; i < e.length; i += 1)
                  (a = e[i]),
                    this.slides[a] && this.slides.eq(a).remove(),
                    a < r && (r -= 1);
                r = Math.max(r, 0);
              } else
                (a = e),
                  this.slides[a] && this.slides.eq(a).remove(),
                  a < r && (r -= 1),
                  (r = Math.max(r, 0));
              t.loop && this.loopCreate(),
                (t.observer && this.support.observer) || this.update(),
                t.loop
                  ? this.slideTo(r + this.loopedSlides, 0, !1)
                  : this.slideTo(r, 0, !1);
            },
            removeAllSlides: function () {
              for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
              this.removeSlide(e);
            },
          },
          events: {
            attachEvents: function () {
              var e = Object(i.a)(),
                t = this.params,
                n = this.touchEvents,
                o = this.el,
                a = this.wrapperEl,
                r = this.device,
                l = this.support;
              (this.onTouchStart = m.bind(this)),
                (this.onTouchMove = y.bind(this)),
                (this.onTouchEnd = b.bind(this)),
                t.cssMode && (this.onScroll = w.bind(this)),
                (this.onClick = g.bind(this));
              var s = !!t.nested;
              if (!l.touch && l.pointerEvents)
                o.addEventListener(n.start, this.onTouchStart, !1),
                  e.addEventListener(n.move, this.onTouchMove, s),
                  e.addEventListener(n.end, this.onTouchEnd, !1);
              else {
                if (l.touch) {
                  var c = !(
                    "touchstart" !== n.start ||
                    !l.passiveListener ||
                    !t.passiveListeners
                  ) && { passive: !0, capture: !1 };
                  o.addEventListener(n.start, this.onTouchStart, c),
                    o.addEventListener(
                      n.move,
                      this.onTouchMove,
                      l.passiveListener ? { passive: !1, capture: s } : s,
                    ),
                    o.addEventListener(n.end, this.onTouchEnd, c),
                    n.cancel &&
                      o.addEventListener(n.cancel, this.onTouchEnd, c),
                    x || (e.addEventListener("touchstart", k), (x = !0));
                }
                ((t.simulateTouch && !r.ios && !r.android) ||
                  (t.simulateTouch && !l.touch && r.ios)) &&
                  (o.addEventListener("mousedown", this.onTouchStart, !1),
                  e.addEventListener("mousemove", this.onTouchMove, s),
                  e.addEventListener("mouseup", this.onTouchEnd, !1));
              }
              (t.preventClicks || t.preventClicksPropagation) &&
                o.addEventListener("click", this.onClick, !0),
                t.cssMode && a.addEventListener("scroll", this.onScroll),
                t.updateOnWindowResize
                  ? this.on(
                      r.ios || r.android
                        ? "resize orientationchange observerUpdate"
                        : "resize observerUpdate",
                      v,
                      !0,
                    )
                  : this.on("observerUpdate", v, !0);
            },
            detachEvents: function () {
              var e = Object(i.a)(),
                t = this.params,
                n = this.touchEvents,
                o = this.el,
                a = this.wrapperEl,
                r = this.device,
                l = this.support,
                s = !!t.nested;
              if (!l.touch && l.pointerEvents)
                o.removeEventListener(n.start, this.onTouchStart, !1),
                  e.removeEventListener(n.move, this.onTouchMove, s),
                  e.removeEventListener(n.end, this.onTouchEnd, !1);
              else {
                if (l.touch) {
                  var c = !(
                    "onTouchStart" !== n.start ||
                    !l.passiveListener ||
                    !t.passiveListeners
                  ) && { passive: !0, capture: !1 };
                  o.removeEventListener(n.start, this.onTouchStart, c),
                    o.removeEventListener(n.move, this.onTouchMove, s),
                    o.removeEventListener(n.end, this.onTouchEnd, c),
                    n.cancel &&
                      o.removeEventListener(n.cancel, this.onTouchEnd, c);
                }
                ((t.simulateTouch && !r.ios && !r.android) ||
                  (t.simulateTouch && !l.touch && r.ios)) &&
                  (o.removeEventListener("mousedown", this.onTouchStart, !1),
                  e.removeEventListener("mousemove", this.onTouchMove, s),
                  e.removeEventListener("mouseup", this.onTouchEnd, !1));
              }
              (t.preventClicks || t.preventClicksPropagation) &&
                o.removeEventListener("click", this.onClick, !0),
                t.cssMode && a.removeEventListener("scroll", this.onScroll),
                this.off(
                  r.ios || r.android
                    ? "resize orientationchange observerUpdate"
                    : "resize observerUpdate",
                  v,
                );
            },
          },
          breakpoints: {
            setBreakpoint: function () {
              var e = this.activeIndex,
                t = this.initialized,
                n = this.loopedSlides,
                o = void 0 === n ? 0 : n,
                a = this.params,
                r = this.$el,
                i = a.breakpoints;
              if (i && (!i || 0 !== Object.keys(i).length)) {
                var l = this.getBreakpoint(
                  i,
                  this.params.breakpointsBase,
                  this.el,
                );
                if (l && this.currentBreakpoint !== l) {
                  var c = l in i ? i[l] : void 0;
                  c &&
                    [
                      "slidesPerView",
                      "spaceBetween",
                      "slidesPerGroup",
                      "slidesPerGroupSkip",
                      "slidesPerColumn",
                    ].forEach(function (e) {
                      var t = c[e];
                      "undefined" !== typeof t &&
                        (c[e] =
                          "slidesPerView" !== e ||
                          ("AUTO" !== t && "auto" !== t)
                            ? "slidesPerView" === e
                              ? parseFloat(t)
                              : parseInt(t, 10)
                            : "auto");
                    });
                  var _ = c || this.originalParams,
                    u = a.slidesPerColumn > 1,
                    d = _.slidesPerColumn > 1,
                    p = a.enabled;
                  u && !d
                    ? (r.removeClass(
                        a.containerModifierClass +
                          "multirow " +
                          a.containerModifierClass +
                          "multirow-column",
                      ),
                      this.emitContainerClasses())
                    : !u &&
                      d &&
                      (r.addClass(a.containerModifierClass + "multirow"),
                      ((_.slidesPerColumnFill &&
                        "column" === _.slidesPerColumnFill) ||
                        (!_.slidesPerColumnFill &&
                          "column" === a.slidesPerColumnFill)) &&
                        r.addClass(
                          a.containerModifierClass + "multirow-column",
                        ),
                      this.emitContainerClasses());
                  var f = _.direction && _.direction !== a.direction,
                    h = a.loop && (_.slidesPerView !== a.slidesPerView || f);
                  f && t && this.changeDirection(), Object(s.e)(this.params, _);
                  var m = this.params.enabled;
                  Object(s.e)(this, {
                    allowTouchMove: this.params.allowTouchMove,
                    allowSlideNext: this.params.allowSlideNext,
                    allowSlidePrev: this.params.allowSlidePrev,
                  }),
                    p && !m ? this.disable() : !p && m && this.enable(),
                    (this.currentBreakpoint = l),
                    this.emit("_beforeBreakpoint", _),
                    h &&
                      t &&
                      (this.loopDestroy(),
                      this.loopCreate(),
                      this.updateSlides(),
                      this.slideTo(e - o + this.loopedSlides, 0, !1)),
                    this.emit("breakpoint", _);
                }
              }
            },
            getBreakpoint: function (e, t, n) {
              if (
                (void 0 === t && (t = "window"), e && ("container" !== t || n))
              ) {
                var o = !1,
                  a = Object(i.b)(),
                  r = "window" === t ? a.innerHeight : n.clientHeight,
                  l = Object.keys(e).map(function (e) {
                    if ("string" === typeof e && 0 === e.indexOf("@")) {
                      var t = parseFloat(e.substr(1));
                      return { value: r * t, point: e };
                    }
                    return { value: e, point: e };
                  });
                l.sort(function (e, t) {
                  return parseInt(e.value, 10) - parseInt(t.value, 10);
                });
                for (var s = 0; s < l.length; s += 1) {
                  var c = l[s],
                    _ = c.point,
                    u = c.value;
                  "window" === t
                    ? a.matchMedia("(min-width: " + u + "px)").matches &&
                      (o = _)
                    : u <= n.clientWidth && (o = _);
                }
                return o || "max";
              }
            },
          },
          checkOverflow: {
            checkOverflow: function () {
              var e = this.params,
                t = this.isLocked,
                n =
                  this.slides.length > 0 &&
                  e.slidesOffsetBefore +
                    e.spaceBetween * (this.slides.length - 1) +
                    this.slides[0].offsetWidth * this.slides.length;
              e.slidesOffsetBefore && e.slidesOffsetAfter && n
                ? (this.isLocked = n <= this.size)
                : (this.isLocked = 1 === this.snapGrid.length),
                (this.allowSlideNext = !this.isLocked),
                (this.allowSlidePrev = !this.isLocked),
                t !== this.isLocked &&
                  this.emit(this.isLocked ? "lock" : "unlock"),
                t &&
                  t !== this.isLocked &&
                  ((this.isEnd = !1),
                  this.navigation && this.navigation.update());
            },
          },
          classes: {
            addClasses: function () {
              var e = this.classNames,
                t = this.params,
                n = this.rtl,
                o = this.$el,
                a = this.device,
                r = this.support,
                i = (function (e, t) {
                  var n = [];
                  return (
                    e.forEach(function (e) {
                      "object" === typeof e
                        ? Object.keys(e).forEach(function (o) {
                            e[o] && n.push(t + o);
                          })
                        : "string" === typeof e && n.push(t + e);
                    }),
                    n
                  );
                })(
                  [
                    "initialized",
                    t.direction,
                    { "pointer-events": r.pointerEvents && !r.touch },
                    { "free-mode": t.freeMode },
                    { autoheight: t.autoHeight },
                    { rtl: n },
                    { multirow: t.slidesPerColumn > 1 },
                    {
                      "multirow-column":
                        t.slidesPerColumn > 1 &&
                        "column" === t.slidesPerColumnFill,
                    },
                    { android: a.android },
                    { ios: a.ios },
                    { "css-mode": t.cssMode },
                  ],
                  t.containerModifierClass,
                );
              e.push.apply(e, i),
                o.addClass([].concat(e).join(" ")),
                this.emitContainerClasses();
            },
            removeClasses: function () {
              var e = this.$el,
                t = this.classNames;
              e.removeClass(t.join(" ")), this.emitContainerClasses();
            },
          },
          images: {
            loadImage: function (e, t, n, o, a, r) {
              var s,
                c = Object(i.b)();
              function _() {
                r && r();
              }
              Object(l.a)(e).parent("picture")[0] || (e.complete && a)
                ? _()
                : t
                  ? (((s = new c.Image()).onload = _),
                    (s.onerror = _),
                    o && (s.sizes = o),
                    n && (s.srcset = n),
                    t && (s.src = t))
                  : _();
            },
            preloadImages: function () {
              var e = this;
              function t() {
                "undefined" !== typeof e &&
                  null !== e &&
                  e &&
                  !e.destroyed &&
                  (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                  e.imagesLoaded === e.imagesToLoad.length &&
                    (e.params.updateOnImagesReady && e.update(),
                    e.emit("imagesReady")));
              }
              e.imagesToLoad = e.$el.find("img");
              for (var n = 0; n < e.imagesToLoad.length; n += 1) {
                var o = e.imagesToLoad[n];
                e.loadImage(
                  o,
                  o.currentSrc || o.getAttribute("src"),
                  o.srcset || o.getAttribute("srcset"),
                  o.sizes || o.getAttribute("sizes"),
                  !0,
                  t,
                );
              }
            },
          },
        },
        j = {},
        T = (function () {
          function e() {
            for (
              var t, n, o = arguments.length, a = new Array(o), r = 0;
              r < o;
              r++
            )
              a[r] = arguments[r];
            if (
              (1 === a.length &&
              a[0].constructor &&
              "Object" === Object.prototype.toString.call(a[0]).slice(8, -1)
                ? (n = a[0])
                : ((t = a[0]), (n = a[1])),
              n || (n = {}),
              (n = Object(s.e)({}, n)),
              t && !n.el && (n.el = t),
              n.el && Object(l.a)(n.el).length > 1)
            ) {
              var i = [];
              return (
                Object(l.a)(n.el).each(function (t) {
                  var o = Object(s.e)({}, n, { el: t });
                  i.push(new e(o));
                }),
                i
              );
            }
            var d = this;
            (d.__swiper__ = !0),
              (d.support = c()),
              (d.device = _({ userAgent: n.userAgent })),
              (d.browser = u()),
              (d.eventsListeners = {}),
              (d.eventsAnyListeners = []),
              "undefined" === typeof d.modules && (d.modules = {}),
              Object.keys(d.modules).forEach(function (e) {
                var t = d.modules[e];
                if (t.params) {
                  var o = Object.keys(t.params)[0],
                    a = t.params[o];
                  if ("object" !== typeof a || null === a) return;
                  if (
                    (["navigation", "pagination", "scrollbar"].indexOf(o) >=
                      0 &&
                      !0 === n[o] &&
                      (n[o] = { auto: !0 }),
                    !(o in n && "enabled" in a))
                  )
                    return;
                  !0 === n[o] && (n[o] = { enabled: !0 }),
                    "object" !== typeof n[o] ||
                      "enabled" in n[o] ||
                      (n[o].enabled = !0),
                    n[o] || (n[o] = { enabled: !1 });
                }
              });
            var p = Object(s.e)({}, O);
            return (
              d.useParams(p),
              (d.params = Object(s.e)({}, p, j, n)),
              (d.originalParams = Object(s.e)({}, d.params)),
              (d.passedParams = Object(s.e)({}, n)),
              d.params &&
                d.params.on &&
                Object.keys(d.params.on).forEach(function (e) {
                  d.on(e, d.params.on[e]);
                }),
              d.params && d.params.onAny && d.onAny(d.params.onAny),
              (d.$ = l.a),
              Object(s.e)(d, {
                enabled: d.params.enabled,
                el: t,
                classNames: [],
                slides: Object(l.a)(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: function () {
                  return "horizontal" === d.params.direction;
                },
                isVertical: function () {
                  return "vertical" === d.params.direction;
                },
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: d.params.allowSlideNext,
                allowSlidePrev: d.params.allowSlidePrev,
                touchEvents: (function () {
                  var e = [
                      "touchstart",
                      "touchmove",
                      "touchend",
                      "touchcancel",
                    ],
                    t = ["mousedown", "mousemove", "mouseup"];
                  return (
                    d.support.pointerEvents &&
                      (t = ["pointerdown", "pointermove", "pointerup"]),
                    (d.touchEventsTouch = {
                      start: e[0],
                      move: e[1],
                      end: e[2],
                      cancel: e[3],
                    }),
                    (d.touchEventsDesktop = {
                      start: t[0],
                      move: t[1],
                      end: t[2],
                    }),
                    d.support.touch || !d.params.simulateTouch
                      ? d.touchEventsTouch
                      : d.touchEventsDesktop
                  );
                })(),
                touchEventsData: {
                  isTouched: void 0,
                  isMoved: void 0,
                  allowTouchCallbacks: void 0,
                  touchStartTime: void 0,
                  isScrolling: void 0,
                  currentTranslate: void 0,
                  startTranslate: void 0,
                  allowThresholdMove: void 0,
                  focusableElements: d.params.focusableElements,
                  lastClickTime: Object(s.h)(),
                  clickTimeout: void 0,
                  velocities: [],
                  allowMomentumBounce: void 0,
                  isTouchEvent: void 0,
                  startMoving: void 0,
                },
                allowClick: !0,
                allowTouchMove: d.params.allowTouchMove,
                touches: {
                  startX: 0,
                  startY: 0,
                  currentX: 0,
                  currentY: 0,
                  diff: 0,
                },
                imagesToLoad: [],
                imagesLoaded: 0,
              }),
              d.useModules(),
              d.emit("_swiper"),
              d.params.init && d.init(),
              d
            );
          }
          var t,
            n,
            o,
            a = e.prototype;
          return (
            (a.enable = function () {
              this.enabled ||
                ((this.enabled = !0),
                this.params.grabCursor && this.setGrabCursor(),
                this.emit("enable"));
            }),
            (a.disable = function () {
              this.enabled &&
                ((this.enabled = !1),
                this.params.grabCursor && this.unsetGrabCursor(),
                this.emit("disable"));
            }),
            (a.setProgress = function (e, t) {
              e = Math.min(Math.max(e, 0), 1);
              var n = this.minTranslate(),
                o = (this.maxTranslate() - n) * e + n;
              this.translateTo(o, "undefined" === typeof t ? 0 : t),
                this.updateActiveIndex(),
                this.updateSlidesClasses();
            }),
            (a.emitContainerClasses = function () {
              var e = this;
              if (e.params._emitClasses && e.el) {
                var t = e.el.className.split(" ").filter(function (t) {
                  return (
                    0 === t.indexOf("swiper-container") ||
                    0 === t.indexOf(e.params.containerModifierClass)
                  );
                });
                e.emit("_containerClasses", t.join(" "));
              }
            }),
            (a.getSlideClasses = function (e) {
              var t = this;
              return e.className
                .split(" ")
                .filter(function (e) {
                  return (
                    0 === e.indexOf("swiper-slide") ||
                    0 === e.indexOf(t.params.slideClass)
                  );
                })
                .join(" ");
            }),
            (a.emitSlidesClasses = function () {
              var e = this;
              if (e.params._emitClasses && e.el) {
                var t = [];
                e.slides.each(function (n) {
                  var o = e.getSlideClasses(n);
                  t.push({ slideEl: n, classNames: o }),
                    e.emit("_slideClass", n, o);
                }),
                  e.emit("_slideClasses", t);
              }
            }),
            (a.slidesPerViewDynamic = function () {
              var e = this.params,
                t = this.slides,
                n = this.slidesGrid,
                o = this.size,
                a = this.activeIndex,
                r = 1;
              if (e.centeredSlides) {
                for (
                  var i, l = t[a].swiperSlideSize, s = a + 1;
                  s < t.length;
                  s += 1
                )
                  t[s] &&
                    !i &&
                    ((r += 1), (l += t[s].swiperSlideSize) > o && (i = !0));
                for (var c = a - 1; c >= 0; c -= 1)
                  t[c] &&
                    !i &&
                    ((r += 1), (l += t[c].swiperSlideSize) > o && (i = !0));
              } else
                for (var _ = a + 1; _ < t.length; _ += 1)
                  n[_] - n[a] < o && (r += 1);
              return r;
            }),
            (a.update = function () {
              var e = this;
              if (e && !e.destroyed) {
                var t = e.snapGrid,
                  n = e.params;
                n.breakpoints && e.setBreakpoint(),
                  e.updateSize(),
                  e.updateSlides(),
                  e.updateProgress(),
                  e.updateSlidesClasses(),
                  e.params.freeMode
                    ? (o(), e.params.autoHeight && e.updateAutoHeight())
                    : (("auto" === e.params.slidesPerView ||
                        e.params.slidesPerView > 1) &&
                      e.isEnd &&
                      !e.params.centeredSlides
                        ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                        : e.slideTo(e.activeIndex, 0, !1, !0)) || o(),
                  n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
                  e.emit("update");
              }
              function o() {
                var t = e.rtlTranslate ? -1 * e.translate : e.translate,
                  n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
                e.setTranslate(n),
                  e.updateActiveIndex(),
                  e.updateSlidesClasses();
              }
            }),
            (a.changeDirection = function (e, t) {
              void 0 === t && (t = !0);
              var n = this.params.direction;
              return (
                e || (e = "horizontal" === n ? "vertical" : "horizontal"),
                e === n || ("horizontal" !== e && "vertical" !== e)
                  ? this
                  : (this.$el
                      .removeClass("" + this.params.containerModifierClass + n)
                      .addClass("" + this.params.containerModifierClass + e),
                    this.emitContainerClasses(),
                    (this.params.direction = e),
                    this.slides.each(function (t) {
                      "vertical" === e
                        ? (t.style.width = "")
                        : (t.style.height = "");
                    }),
                    this.emit("changeDirection"),
                    t && this.update(),
                    this)
              );
            }),
            (a.mount = function (e) {
              var t = this;
              if (t.mounted) return !0;
              var n = Object(l.a)(e || t.params.el);
              if (!(e = n[0])) return !1;
              e.swiper = t;
              var o = function () {
                  return (
                    "." +
                    (t.params.wrapperClass || "").trim().split(" ").join(".")
                  );
                },
                a = (function () {
                  if (e && e.shadowRoot && e.shadowRoot.querySelector) {
                    var t = Object(l.a)(e.shadowRoot.querySelector(o()));
                    return (
                      (t.children = function (e) {
                        return n.children(e);
                      }),
                      t
                    );
                  }
                  return n.children(o());
                })();
              if (0 === a.length && t.params.createElements) {
                var r = Object(i.a)().createElement("div");
                (a = Object(l.a)(r)),
                  (r.className = t.params.wrapperClass),
                  n.append(r),
                  n.children("." + t.params.slideClass).each(function (e) {
                    a.append(e);
                  });
              }
              return (
                Object(s.e)(t, {
                  $el: n,
                  el: e,
                  $wrapperEl: a,
                  wrapperEl: a[0],
                  mounted: !0,
                  rtl:
                    "rtl" === e.dir.toLowerCase() ||
                    "rtl" === n.css("direction"),
                  rtlTranslate:
                    "horizontal" === t.params.direction &&
                    ("rtl" === e.dir.toLowerCase() ||
                      "rtl" === n.css("direction")),
                  wrongRTL: "-webkit-box" === a.css("display"),
                }),
                !0
              );
            }),
            (a.init = function (e) {
              return this.initialized
                ? this
                : !1 === this.mount(e)
                  ? this
                  : (this.emit("beforeInit"),
                    this.params.breakpoints && this.setBreakpoint(),
                    this.addClasses(),
                    this.params.loop && this.loopCreate(),
                    this.updateSize(),
                    this.updateSlides(),
                    this.params.watchOverflow && this.checkOverflow(),
                    this.params.grabCursor &&
                      this.enabled &&
                      this.setGrabCursor(),
                    this.params.preloadImages && this.preloadImages(),
                    this.params.loop
                      ? this.slideTo(
                          this.params.initialSlide + this.loopedSlides,
                          0,
                          this.params.runCallbacksOnInit,
                          !1,
                          !0,
                        )
                      : this.slideTo(
                          this.params.initialSlide,
                          0,
                          this.params.runCallbacksOnInit,
                          !1,
                          !0,
                        ),
                    this.attachEvents(),
                    (this.initialized = !0),
                    this.emit("init"),
                    this.emit("afterInit"),
                    this);
            }),
            (a.destroy = function (e, t) {
              void 0 === e && (e = !0), void 0 === t && (t = !0);
              var n = this,
                o = n.params,
                a = n.$el,
                r = n.$wrapperEl,
                i = n.slides;
              return "undefined" === typeof n.params || n.destroyed
                ? null
                : (n.emit("beforeDestroy"),
                  (n.initialized = !1),
                  n.detachEvents(),
                  o.loop && n.loopDestroy(),
                  t &&
                    (n.removeClasses(),
                    a.removeAttr("style"),
                    r.removeAttr("style"),
                    i &&
                      i.length &&
                      i
                        .removeClass(
                          [
                            o.slideVisibleClass,
                            o.slideActiveClass,
                            o.slideNextClass,
                            o.slidePrevClass,
                          ].join(" "),
                        )
                        .removeAttr("style")
                        .removeAttr("data-swiper-slide-index")),
                  n.emit("destroy"),
                  Object.keys(n.eventsListeners).forEach(function (e) {
                    n.off(e);
                  }),
                  !1 !== e && ((n.$el[0].swiper = null), Object(s.d)(n)),
                  (n.destroyed = !0),
                  null);
            }),
            (e.extendDefaults = function (e) {
              Object(s.e)(j, e);
            }),
            (e.installModule = function (t) {
              e.prototype.modules || (e.prototype.modules = {});
              var n =
                t.name ||
                Object.keys(e.prototype.modules).length + "_" + Object(s.h)();
              e.prototype.modules[n] = t;
            }),
            (e.use = function (t) {
              return Array.isArray(t)
                ? (t.forEach(function (t) {
                    return e.installModule(t);
                  }),
                  e)
                : (e.installModule(t), e);
            }),
            (t = e),
            (o = [
              {
                key: "extendedDefaults",
                get: function () {
                  return j;
                },
              },
              {
                key: "defaults",
                get: function () {
                  return O;
                },
              },
            ]),
            (n = null) && I(t.prototype, n),
            o && I(t, o),
            e
          );
        })();
      Object.keys(S).forEach(function (e) {
        Object.keys(S[e]).forEach(function (t) {
          T.prototype[t] = S[e][t];
        });
      }),
        T.use([d, h]);
      t.a = T;
    },
    bck3: function (e, t, n) {
      e.exports = {
        "canvas-player-component": "style__canvas-player-component___1OvJG",
      };
    },
    bdgK: function (e, t, n) {
      "use strict";
      n.r(t),
        function (e) {
          var n = (function () {
              if ("undefined" !== typeof Map) return Map;
              function e(e, t) {
                var n = -1;
                return (
                  e.some(function (e, o) {
                    return e[0] === t && ((n = o), !0);
                  }),
                  n
                );
              }
              return (function () {
                function t() {
                  this.__entries__ = [];
                }
                return (
                  Object.defineProperty(t.prototype, "size", {
                    get: function () {
                      return this.__entries__.length;
                    },
                    enumerable: !0,
                    configurable: !0,
                  }),
                  (t.prototype.get = function (t) {
                    var n = e(this.__entries__, t),
                      o = this.__entries__[n];
                    return o && o[1];
                  }),
                  (t.prototype.set = function (t, n) {
                    var o = e(this.__entries__, t);
                    ~o
                      ? (this.__entries__[o][1] = n)
                      : this.__entries__.push([t, n]);
                  }),
                  (t.prototype.delete = function (t) {
                    var n = this.__entries__,
                      o = e(n, t);
                    ~o && n.splice(o, 1);
                  }),
                  (t.prototype.has = function (t) {
                    return !!~e(this.__entries__, t);
                  }),
                  (t.prototype.clear = function () {
                    this.__entries__.splice(0);
                  }),
                  (t.prototype.forEach = function (e, t) {
                    void 0 === t && (t = null);
                    for (var n = 0, o = this.__entries__; n < o.length; n++) {
                      var a = o[n];
                      e.call(t, a[1], a[0]);
                    }
                  }),
                  t
                );
              })();
            })(),
            o =
              "undefined" !== typeof window &&
              "undefined" !== typeof document &&
              window.document === document,
            a =
              "undefined" !== typeof e && e.Math === Math
                ? e
                : "undefined" !== typeof self && self.Math === Math
                  ? self
                  : "undefined" !== typeof window && window.Math === Math
                    ? window
                    : Function("return this")(),
            r =
              "function" === typeof requestAnimationFrame
                ? requestAnimationFrame.bind(a)
                : function (e) {
                    return setTimeout(function () {
                      return e(Date.now());
                    }, 1e3 / 60);
                  },
            i = 2;
          var l = 20,
            s = [
              "top",
              "right",
              "bottom",
              "left",
              "width",
              "height",
              "size",
              "weight",
            ],
            c = "undefined" !== typeof MutationObserver,
            _ = (function () {
              function e() {
                (this.connected_ = !1),
                  (this.mutationEventsAdded_ = !1),
                  (this.mutationsObserver_ = null),
                  (this.observers_ = []),
                  (this.onTransitionEnd_ = this.onTransitionEnd_.bind(this)),
                  (this.refresh = (function (e, t) {
                    var n = !1,
                      o = !1,
                      a = 0;
                    function l() {
                      n && ((n = !1), e()), o && c();
                    }
                    function s() {
                      r(l);
                    }
                    function c() {
                      var e = Date.now();
                      if (n) {
                        if (e - a < i) return;
                        o = !0;
                      } else (n = !0), (o = !1), setTimeout(s, t);
                      a = e;
                    }
                    return c;
                  })(this.refresh.bind(this), l));
              }
              return (
                (e.prototype.addObserver = function (e) {
                  ~this.observers_.indexOf(e) || this.observers_.push(e),
                    this.connected_ || this.connect_();
                }),
                (e.prototype.removeObserver = function (e) {
                  var t = this.observers_,
                    n = t.indexOf(e);
                  ~n && t.splice(n, 1),
                    !t.length && this.connected_ && this.disconnect_();
                }),
                (e.prototype.refresh = function () {
                  this.updateObservers_() && this.refresh();
                }),
                (e.prototype.updateObservers_ = function () {
                  var e = this.observers_.filter(function (e) {
                    return e.gatherActive(), e.hasActive();
                  });
                  return (
                    e.forEach(function (e) {
                      return e.broadcastActive();
                    }),
                    e.length > 0
                  );
                }),
                (e.prototype.connect_ = function () {
                  o &&
                    !this.connected_ &&
                    (document.addEventListener(
                      "transitionend",
                      this.onTransitionEnd_,
                    ),
                    window.addEventListener("resize", this.refresh),
                    c
                      ? ((this.mutationsObserver_ = new MutationObserver(
                          this.refresh,
                        )),
                        this.mutationsObserver_.observe(document, {
                          attributes: !0,
                          childList: !0,
                          characterData: !0,
                          subtree: !0,
                        }))
                      : (document.addEventListener(
                          "DOMSubtreeModified",
                          this.refresh,
                        ),
                        (this.mutationEventsAdded_ = !0)),
                    (this.connected_ = !0));
                }),
                (e.prototype.disconnect_ = function () {
                  o &&
                    this.connected_ &&
                    (document.removeEventListener(
                      "transitionend",
                      this.onTransitionEnd_,
                    ),
                    window.removeEventListener("resize", this.refresh),
                    this.mutationsObserver_ &&
                      this.mutationsObserver_.disconnect(),
                    this.mutationEventsAdded_ &&
                      document.removeEventListener(
                        "DOMSubtreeModified",
                        this.refresh,
                      ),
                    (this.mutationsObserver_ = null),
                    (this.mutationEventsAdded_ = !1),
                    (this.connected_ = !1));
                }),
                (e.prototype.onTransitionEnd_ = function (e) {
                  var t = e.propertyName,
                    n = void 0 === t ? "" : t;
                  s.some(function (e) {
                    return !!~n.indexOf(e);
                  }) && this.refresh();
                }),
                (e.getInstance = function () {
                  return (
                    this.instance_ || (this.instance_ = new e()), this.instance_
                  );
                }),
                (e.instance_ = null),
                e
              );
            })(),
            u = function (e, t) {
              for (var n = 0, o = Object.keys(t); n < o.length; n++) {
                var a = o[n];
                Object.defineProperty(e, a, {
                  value: t[a],
                  enumerable: !1,
                  writable: !1,
                  configurable: !0,
                });
              }
              return e;
            },
            d = function (e) {
              return (e && e.ownerDocument && e.ownerDocument.defaultView) || a;
            },
            p = v(0, 0, 0, 0);
          function f(e) {
            return parseFloat(e) || 0;
          }
          function h(e) {
            for (var t = [], n = 1; n < arguments.length; n++)
              t[n - 1] = arguments[n];
            return t.reduce(function (t, n) {
              return t + f(e["border-" + n + "-width"]);
            }, 0);
          }
          function m(e) {
            var t = e.clientWidth,
              n = e.clientHeight;
            if (!t && !n) return p;
            var o = d(e).getComputedStyle(e),
              a = (function (e) {
                for (
                  var t = {}, n = 0, o = ["top", "right", "bottom", "left"];
                  n < o.length;
                  n++
                ) {
                  var a = o[n],
                    r = e["padding-" + a];
                  t[a] = f(r);
                }
                return t;
              })(o),
              r = a.left + a.right,
              i = a.top + a.bottom,
              l = f(o.width),
              s = f(o.height);
            if (
              ("border-box" === o.boxSizing &&
                (Math.round(l + r) !== t && (l -= h(o, "left", "right") + r),
                Math.round(s + i) !== n && (s -= h(o, "top", "bottom") + i)),
              !(function (e) {
                return e === d(e).document.documentElement;
              })(e))
            ) {
              var c = Math.round(l + r) - t,
                _ = Math.round(s + i) - n;
              1 !== Math.abs(c) && (l -= c), 1 !== Math.abs(_) && (s -= _);
            }
            return v(a.left, a.top, l, s);
          }
          var y =
            "undefined" !== typeof SVGGraphicsElement
              ? function (e) {
                  return e instanceof d(e).SVGGraphicsElement;
                }
              : function (e) {
                  return (
                    e instanceof d(e).SVGElement &&
                    "function" === typeof e.getBBox
                  );
                };
          function b(e) {
            return o
              ? y(e)
                ? (function (e) {
                    var t = e.getBBox();
                    return v(0, 0, t.width, t.height);
                  })(e)
                : m(e)
              : p;
          }
          function v(e, t, n, o) {
            return { x: e, y: t, width: n, height: o };
          }
          var g = (function () {
              function e(e) {
                (this.broadcastWidth = 0),
                  (this.broadcastHeight = 0),
                  (this.contentRect_ = v(0, 0, 0, 0)),
                  (this.target = e);
              }
              return (
                (e.prototype.isActive = function () {
                  var e = b(this.target);
                  return (
                    (this.contentRect_ = e),
                    e.width !== this.broadcastWidth ||
                      e.height !== this.broadcastHeight
                  );
                }),
                (e.prototype.broadcastRect = function () {
                  var e = this.contentRect_;
                  return (
                    (this.broadcastWidth = e.width),
                    (this.broadcastHeight = e.height),
                    e
                  );
                }),
                e
              );
            })(),
            w = function (e, t) {
              var n = (function (e) {
                var t = e.x,
                  n = e.y,
                  o = e.width,
                  a = e.height,
                  r =
                    "undefined" !== typeof DOMRectReadOnly
                      ? DOMRectReadOnly
                      : Object,
                  i = Object.create(r.prototype);
                return (
                  u(i, {
                    x: t,
                    y: n,
                    width: o,
                    height: a,
                    top: n,
                    right: t + o,
                    bottom: a + n,
                    left: t,
                  }),
                  i
                );
              })(t);
              u(this, { target: e, contentRect: n });
            },
            x = (function () {
              function e(e, t, o) {
                if (
                  ((this.activeObservations_ = []),
                  (this.observations_ = new n()),
                  "function" !== typeof e)
                )
                  throw new TypeError(
                    "The callback provided as parameter 1 is not a function.",
                  );
                (this.callback_ = e),
                  (this.controller_ = t),
                  (this.callbackCtx_ = o);
              }
              return (
                (e.prototype.observe = function (e) {
                  if (!arguments.length)
                    throw new TypeError(
                      "1 argument required, but only 0 present.",
                    );
                  if (
                    "undefined" !== typeof Element &&
                    Element instanceof Object
                  ) {
                    if (!(e instanceof d(e).Element))
                      throw new TypeError(
                        'parameter 1 is not of type "Element".',
                      );
                    var t = this.observations_;
                    t.has(e) ||
                      (t.set(e, new g(e)),
                      this.controller_.addObserver(this),
                      this.controller_.refresh());
                  }
                }),
                (e.prototype.unobserve = function (e) {
                  if (!arguments.length)
                    throw new TypeError(
                      "1 argument required, but only 0 present.",
                    );
                  if (
                    "undefined" !== typeof Element &&
                    Element instanceof Object
                  ) {
                    if (!(e instanceof d(e).Element))
                      throw new TypeError(
                        'parameter 1 is not of type "Element".',
                      );
                    var t = this.observations_;
                    t.has(e) &&
                      (t.delete(e),
                      t.size || this.controller_.removeObserver(this));
                  }
                }),
                (e.prototype.disconnect = function () {
                  this.clearActive(),
                    this.observations_.clear(),
                    this.controller_.removeObserver(this);
                }),
                (e.prototype.gatherActive = function () {
                  var e = this;
                  this.clearActive(),
                    this.observations_.forEach(function (t) {
                      t.isActive() && e.activeObservations_.push(t);
                    });
                }),
                (e.prototype.broadcastActive = function () {
                  if (this.hasActive()) {
                    var e = this.callbackCtx_,
                      t = this.activeObservations_.map(function (e) {
                        return new w(e.target, e.broadcastRect());
                      });
                    this.callback_.call(e, t, e), this.clearActive();
                  }
                }),
                (e.prototype.clearActive = function () {
                  this.activeObservations_.splice(0);
                }),
                (e.prototype.hasActive = function () {
                  return this.activeObservations_.length > 0;
                }),
                e
              );
            })(),
            k = "undefined" !== typeof WeakMap ? new WeakMap() : new n(),
            O = function e(t) {
              if (!(this instanceof e))
                throw new TypeError("Cannot call a class as a function.");
              if (!arguments.length)
                throw new TypeError("1 argument required, but only 0 present.");
              var n = _.getInstance(),
                o = new x(t, n, this);
              k.set(this, o);
            };
          ["observe", "unobserve", "disconnect"].forEach(function (e) {
            O.prototype[e] = function () {
              var t;
              return (t = k.get(this))[e].apply(t, arguments);
            };
          });
          var I =
            "undefined" !== typeof a.ResizeObserver ? a.ResizeObserver : O;
          t.default = I;
        }.call(this, n("yLpj"));
    },
    c6wG: function (e, t, n) {
      var o = n("dD9F"),
        a = n("sEf8"),
        r = n("mdPL"),
        i = r && r.isTypedArray,
        l = i ? a(i) : o;
      e.exports = l;
    },
    cAZH: function (e, t, n) {},
    cKS0: function (e, t, n) {
      "use strict";
      n.d(t, "d", function () {
        return a;
      }),
        n.d(t, "g", function () {
          return r;
        }),
        n.d(t, "h", function () {
          return i;
        }),
        n.d(t, "f", function () {
          return l;
        }),
        n.d(t, "e", function () {
          return c;
        }),
        n.d(t, "a", function () {
          return _;
        }),
        n.d(t, "b", function () {
          return u;
        }),
        n.d(t, "c", function () {
          return d;
        });
      var o = n("/xfr");
      function a(e) {
        var t = e;
        Object.keys(t).forEach(function (e) {
          try {
            t[e] = null;
          } catch (n) {}
          try {
            delete t[e];
          } catch (n) {}
        });
      }
      function r(e, t) {
        return void 0 === t && (t = 0), setTimeout(e, t);
      }
      function i() {
        return Date.now();
      }
      function l(e, t) {
        void 0 === t && (t = "x");
        var n,
          a,
          r,
          i = Object(o.b)(),
          l = (function (e) {
            var t,
              n = Object(o.b)();
            return (
              n.getComputedStyle && (t = n.getComputedStyle(e, null)),
              !t && e.currentStyle && (t = e.currentStyle),
              t || (t = e.style),
              t
            );
          })(e);
        return (
          i.WebKitCSSMatrix
            ? ((a = l.transform || l.webkitTransform).split(",").length > 6 &&
                (a = a
                  .split(", ")
                  .map(function (e) {
                    return e.replace(",", ".");
                  })
                  .join(", ")),
              (r = new i.WebKitCSSMatrix("none" === a ? "" : a)))
            : (n = (r =
                l.MozTransform ||
                l.OTransform ||
                l.MsTransform ||
                l.msTransform ||
                l.transform ||
                l
                  .getPropertyValue("transform")
                  .replace("translate(", "matrix(1, 0, 0, 1,"))
                .toString()
                .split(",")),
          "x" === t &&
            (a = i.WebKitCSSMatrix
              ? r.m41
              : 16 === n.length
                ? parseFloat(n[12])
                : parseFloat(n[4])),
          "y" === t &&
            (a = i.WebKitCSSMatrix
              ? r.m42
              : 16 === n.length
                ? parseFloat(n[13])
                : parseFloat(n[5])),
          a || 0
        );
      }
      function s(e) {
        return (
          "object" === typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function c() {
        for (
          var e,
            t = Object(arguments.length <= 0 ? void 0 : arguments[0]),
            n = ["__proto__", "constructor", "prototype"],
            o = 1;
          o < arguments.length;
          o += 1
        ) {
          var a = o < 0 || arguments.length <= o ? void 0 : arguments[o];
          if (
            void 0 !== a &&
            null !== a &&
            ((e = a),
            !("undefined" !== typeof window &&
            "undefined" !== typeof window.HTMLElement
              ? e instanceof HTMLElement
              : e && (1 === e.nodeType || 11 === e.nodeType)))
          )
            for (
              var r = Object.keys(Object(a)).filter(function (e) {
                  return n.indexOf(e) < 0;
                }),
                i = 0,
                l = r.length;
              i < l;
              i += 1
            ) {
              var _ = r[i],
                u = Object.getOwnPropertyDescriptor(a, _);
              void 0 !== u &&
                u.enumerable &&
                (s(t[_]) && s(a[_])
                  ? a[_].__swiper__
                    ? (t[_] = a[_])
                    : c(t[_], a[_])
                  : !s(t[_]) && s(a[_])
                    ? ((t[_] = {}),
                      a[_].__swiper__ ? (t[_] = a[_]) : c(t[_], a[_]))
                    : (t[_] = a[_]));
            }
        }
        return t;
      }
      function _(e, t) {
        Object.keys(t).forEach(function (n) {
          s(t[n]) &&
            Object.keys(t[n]).forEach(function (o) {
              "function" === typeof t[n][o] && (t[n][o] = t[n][o].bind(e));
            }),
            (e[n] = t[n]);
        });
      }
      function u(e) {
        return (
          void 0 === e && (e = ""),
          "." +
            e
              .trim()
              .replace(/([\.:!\/])/g, "\\$1")
              .replace(/ /g, ".")
        );
      }
      function d(e, t, n, a) {
        var r = Object(o.a)();
        return (
          n &&
            Object.keys(a).forEach(function (n) {
              if (!t[n] && !0 === t.auto) {
                var o = r.createElement("div");
                (o.className = a[n]), e.append(o), (t[n] = o);
              }
            }),
          t
        );
      }
    },
    cKzW: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return p;
      });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("q1tI"),
        u = (n("DTFi"), _.createElement);
      function d(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var p = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            (n = d(this, t, [e])),
            Object(c.a)(Object(l.a)(n), "bodyInitialOverflow", void 0),
            Object(c.a)(Object(l.a)(n), "bodyInitialScroll", void 0),
            Object(c.a)(Object(l.a)(n), "modalDom", void 0),
            Object(c.a)(Object(l.a)(n), "closeDom", void 0),
            Object(c.a)(Object(l.a)(n), "iframeDom", void 0),
            (n.state = { modalShow: !1, opened: !1 }),
            (n.handleCloseButtonClick = n.handleCloseButtonClick.bind(
              Object(l.a)(n),
            )),
            (n.handleShowButtonClick = n.handleShowButtonClick.bind(
              Object(l.a)(n),
            )),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "handleCloseButtonClick",
              value: function () {
                if ("undefined" !== typeof document && document) {
                  var e = document.querySelector("body");
                  e &&
                    ((e.style.overflow = this.bodyInitialOverflow || ""),
                    (e.style.height = ""),
                    window.scrollTo(0, this.bodyInitialScroll),
                    this.setState({ modalShow: !1 }));
                }
              },
            },
            {
              key: "handleShowButtonClick",
              value: function (e) {
                e.preventDefault();
                var t = this.state.opened,
                  n = this.modalDom;
                if ("undefined" !== typeof document && document) {
                  var o = document.querySelector("body");
                  t
                    ? ((this.bodyInitialScroll =
                        window.scrollY || window.pageYOffset),
                      this.setState({ modalShow: !0 }))
                    : (n.removeNode
                        ? (n.removeNode(),
                          n.appendChild(this.closeDom),
                          n.appendChild(this.iframeDom),
                          o && o.appendChild(n))
                        : (n.remove(), o && o.append(n)),
                      (this.bodyInitialScroll =
                        window.scrollY || window.pageYOffset),
                      this.setState({ modalShow: !0, opened: !0 })),
                    o &&
                      ((this.bodyInitialOverflow = o.style.overflow),
                      (o.style.overflow = "hidden"),
                      (o.style.height = "100vh"));
                }
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.link,
                  o = t.text,
                  a = t.style,
                  r = t.children,
                  i = t.isMobile,
                  l = this.state.modalShow;
                return u(
                  "div",
                  { style: a, className: "atom-design-v1" },
                  u(
                    "a",
                    {
                      className: "style__link-button___1pM2o",
                      href: "javascript:;",
                      tabIndex: 0,
                      onClick: this.handleShowButtonClick,
                    },
                    o || r,
                  ),
                  u(
                    "div",
                    {
                      className: "style__media-modal-container___t6IW3",
                      style: { display: l ? "block" : "none" },
                      ref: function (t) {
                        e.modalDom = t;
                      },
                    },
                    u("button", {
                      ref: function (t) {
                        e.closeDom = t;
                      },
                      type: "button",
                      "aria-label": "close",
                      className: "style__media-modal-close___1w4Vj",
                      onClick: this.handleCloseButtonClick,
                      onKeyDown: function () {},
                    }),
                    u(
                      "div",
                      {
                        ref: function (t) {
                          e.iframeDom = t;
                        },
                        className: "style__media-modal-iframe___2aQ0n",
                        style: {
                          height: i ? "210px" : "675px",
                          width: i ? "100vw" : "1200px",
                        },
                      },
                      l
                        ? u("iframe", {
                            title: "media-modal",
                            src: n,
                            allowtransparency: "true",
                            style: { backgroundColor: "#000" },
                            frameBorder: "0",
                            width: "100%",
                            height: "100%",
                            scrolling: "auto",
                            webkitallowfullscreen: "true",
                            mozallowfullscreen: "true",
                            allowFullScreen: "true",
                          })
                        : "",
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(_.Component);
      Object(c.a)(p, "defaultProps", void 0);
    },
    cN7M: function (e, t, n) {
      "use strict";
      n.r(t);
      var o = n("ODXe"),
        a = n("HaE+"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("Ji7U"),
        _ = n("rePB"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("TSYQ"),
        m = n.n(h),
        y = n("xk4V"),
        b = n.n(y),
        v = n("XnI8"),
        g = n("SBOM"),
        w = (n("YKpp"), n("irwQ")),
        x = n("75bK"),
        k = n("u11H"),
        O = n("0b+E"),
        I = n("S5C5"),
        S = n("P5sE"),
        j = n.n(S),
        T = n("/MKj"),
        C = n("r7AC"),
        M = f.a.createElement,
        P = {
          "./style.css": {
            section: "style__section___1jf2Y",
            "content-card-list": "style__content-card-list___e50Nu",
            "content-card": "style__content-card___lAXPI",
            "light-theme": "style__light-theme___3Tb-v",
            title: "style__title___2w1gu",
            link: "style__link___1exF8",
            desc: "style__desc___39G1o",
            "product-cover": "style__product-cover___2WNk5",
            "spec-list": "style__spec-list___2TPrl",
            "link-list": "style__link-list___1oxtU",
            "product-name": "style__product-name___2tC2e",
            "guide-list": "style__guide-list___2vAjr",
            icon: "style__icon___2fy3c",
            description: "style__description___1gCqM",
            "fa-angle-right": "style__fa-angle-right___3YodB",
            "product-price": "style__product-price___2_tMs",
            origin: "style__origin___1mLcf",
            "price-affirm": "style__price-affirm___3ukXL",
            "learn-more-phone": "style__learn-more-phone___26zB4",
            container: "style__container___153th",
            "product-box": "style__product-box___1uwGO",
            "guide-list-col-3": "style__guide-list-col-3___21pGQ",
            "guide-list-col-4": "style__guide-list-col-4___2avEe",
            "guide-list-col-5": "style__guide-list-col-5___4Hjg9",
            "spec-list-wrapper": "style__spec-list-wrapper___1Qyzd",
            spec: "style__spec___WxfEa",
            "buy-box": "style__buy-box___3kfRb",
            "light-theme-section": "style__light-theme-section___2WtOP",
          },
        };
      function E() {
        E = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new M(o || []);
          return a(i, "_invoke", { value: S(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var g = {};
        c(g, i, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          x = w && w(w(P([])));
        x && x !== n && o.call(x, i) && (g = x);
        var k = (v.prototype = y.prototype = Object.create(g));
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function I(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function S(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = j(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function j(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                j(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function T(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function C(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function M(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(T, this),
            this.reset(!0);
        }
        function P(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(k, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(k)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          O(I.prototype),
          c(I.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = I),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new I(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          O(k),
          c(k, s, "Generator"),
          c(k, i, function () {
            return this;
          }),
          c(k, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = P),
          (M.prototype = {
            constructor: M,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(C),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), C(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    C(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: P(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      function L(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var B = (function (e) {
        function t() {
          var e;
          return (
            Object(r.default)(this, t),
            ((e = L(this, t)).state = { showPrice: !1, priceLoaded: !1 }),
            e
          );
        }
        return (
          Object(c.a)(t, e),
          Object(i.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this,
                  t = this.state.priceLoaded;
                Object(C.b)({
                  elm: this.guideDom,
                  offset: 1200,
                  callback: function (n) {
                    n.inView &&
                      !t &&
                      (e.getPrice(), e.setState({ priceLoaded: !0 }));
                  },
                });
              },
            },
            {
              key: "getPrice",
              value: (function () {
                var e = Object(a.default)(
                  E().mark(function e() {
                    var t, n, a, r, i, l, s, c, _, u, d, p, f, h, m, y, b;
                    return E().wrap(
                      function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              if (
                                ((t = this.props),
                                (n = t.localization),
                                (a = t.productData),
                                (r = void 0 === a ? {} : a),
                                (i = t.t),
                                (l = r.ean),
                                (s = void 0 === l ? "" : l),
                                (c = this),
                                (_ =
                                  i("v3.common.price.special.product_slug") ||
                                  ""),
                                (r.slug || "").toLowerCase() ===
                                  _.toLowerCase())
                              )
                                try {
                                  (u = JSON.parse(
                                    i(
                                      "v3.common.price.special.product_price",
                                    ) || "{}",
                                  )),
                                    (d =
                                      (u[n.country] &&
                                        j.a.format(u[n.country], {
                                          country: n.country.toLowerCase(),
                                        })) ||
                                      ""),
                                    this.setState({
                                      showPrice: !0,
                                      priceInfo: { price: d },
                                    });
                                } catch (v) {}
                              if (s) {
                                e.next = 8;
                                break;
                              }
                              return e.abrupt("return");
                            case 8:
                              return (
                                (e.prev = 8),
                                (e.next = 11),
                                k.default.request(
                                  {
                                    name: "productGetPrice",
                                    method: "GET",
                                    query: { ean: s },
                                  },
                                  n,
                                )
                              );
                            case 11:
                              return (p = e.sent), (e.next = 14), p.json();
                            case 14:
                              200 === (f = e.sent).status &&
                                ((h = f.data),
                                (m = void 0 === h ? [] : h),
                                (y = Object(o.a)(m, 1)),
                                (b = y[0]) &&
                                  b.price &&
                                  b.on_sale &&
                                  c.setState({ priceInfo: b, showPrice: !0 })),
                                (e.next = 20);
                              break;
                            case 18:
                              (e.prev = 18), (e.t0 = e.catch(8));
                            case 20:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this,
                      [[8, 18]],
                    );
                  }),
                );
                return function () {
                  return e.apply(this, arguments);
                };
              })(),
            },
            {
              key: "_throttle",
              value: function (e, t) {
                var n = arguments,
                  o = this,
                  a = !1;
                return function () {
                  var r = n,
                    i = o;
                  if (!a)
                    return (
                      e.apply(i, r),
                      (a = !0),
                      setTimeout(function () {
                        return (a = !1);
                      }, t)
                    );
                };
              },
            },
            {
              key: "geSend",
              value: function (e, t, n, o) {
                if (
                  (O.a.event({ category: e, action: t, label: n }),
                  o && window && window._agl)
                ) {
                  var a = Object(I.j)(o) ? 7 : 1;
                  window._agl.push(["track", ["success", { t: a }]]);
                }
              },
            },
            {
              key: "canShowImageLink",
              value: function (e) {
                var t = this,
                  n = e.showPrimaryButton,
                  o = e.target,
                  a = e.primaryButtonLink,
                  r = e.secondary_button,
                  i = e.ga_category,
                  l = e.mobileMode,
                  s = e.ga_label,
                  c = { url: void 0, target: o, onClick: function () {} };
                if (n)
                  (c.url = a),
                    (c.onClick = function () {
                      t.geSend(
                        i,
                        "click",
                        ""
                          .concat(l ? "Mobile-" : "PC-", "sg_action_button_")
                          .concat(s),
                        a,
                      );
                    });
                else if (r && r.length > 0) {
                  var _ = r[0],
                    u = _.link,
                    d = _.link_type,
                    p = "relative-path" === d ? "_self" : "_blank";
                  (c = {
                    url: c({
                      domain: "store-path" === d ? "store" : "",
                      url: u,
                      country: localization.country,
                      locale: localization.language,
                      mobileMode: l,
                    }),
                    target: p,
                  }).onClick = function () {
                    t.geSend(
                      i,
                      "click",
                      ""
                        .concat(l ? "Mobile-" : "PC-", "sg_action_button_")
                        .concat(s),
                      null,
                    );
                  };
                }
                return c;
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this,
                  n = this.props,
                  o = n.component_data,
                  a = void 0 === o ? {} : o,
                  r = n.t,
                  i = n.productData,
                  l = n.localization,
                  s = n.mobileMode,
                  c = (a || {}).guideItemMaxWidth,
                  _ = i.shopping_guides,
                  u = i.slug,
                  p = i.priceData,
                  f = void 0 === p ? {} : p,
                  h = "";
                if (!_) return null;
                var y = _.product_list,
                  v = void 0 === y ? [] : y,
                  k = _.show,
                  O = _.recommended_content,
                  S = void 0 === O ? [] : O,
                  j = "";
                if (!k) return null;
                _ &&
                  _.theme_color &&
                  (j = "black" === _.theme_color ? "#3B3E40" : "#fff"),
                  _ && _.background_color && (j = _.background_color);
                var T = { backgroundColor: j },
                  C = m()({
                    section: !0,
                    "light-theme": "a" === a.light,
                    "light-theme-section":
                      _ && _.theme_color && "black" === _.theme_color,
                  }),
                  E = ""
                    .concat(s ? "Mobile-" : "PC-")
                    .concat(i.title, "-shoppingguide"),
                  L = this.state,
                  B = L.priceInfo,
                  N = void 0 === B ? {} : B,
                  D = L.showPrice;
                !N.price && f.price && f.on_sale && ((N = f), (D = !0)),
                  S &&
                    S.length > 0 &&
                    (h =
                      S.length >= 5
                        ? "guide-list-col-5"
                        : 4 === S.length
                          ? "guide-list-col-4"
                          : "guide-list-col-3");
                var z = m()({
                  "guide-list": !0,
                  "guide-list-col-5": "guide-list-col-5" === h,
                  "guide-list-col-4": "guide-list-col-4" === h,
                  "guide-list-col-3": "guide-list-col-3" === h,
                });
                return M(
                  "section",
                  {
                    style: T,
                    ref: function (t) {
                      e.guideDom = t;
                    },
                    className: d()(C, P, {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    }),
                  },
                  M(
                    "div",
                    { className: "style__container___153th" },
                    v.map(function (n) {
                      var o = n.title,
                        a = n.cover,
                        c = n.ga_label,
                        d = n.slogan,
                        p = n.highlight,
                        f = n.primary_button,
                        h = n.secondary_button,
                        m = null === f || void 0 === f ? void 0 : f.link_type,
                        y =
                          "store-path" !== m && "absolute-path" !== m && m
                            ? ""
                            : "store",
                        v = "relative-path" === m ? "_self" : "_blank",
                        x = Object(I.k)({
                          domain: y,
                          url: null === f || void 0 === f ? void 0 : f.link,
                          country: l.country,
                          locale: l.language,
                          mobileMode: s,
                        }),
                        k = f && f.title && f.link,
                        O = e.canShowImageLink({
                          showPrimaryButton: k,
                          target: v,
                          primaryButtonLink: x,
                          secondary_button: h,
                          ga_category: E,
                          mobileMode: s,
                          ga_label: c,
                        });
                      return M(
                        "div",
                        {
                          key: "product-box-".concat(o),
                          className: "style__product-box___1uwGO",
                        },
                        M(
                          "div",
                          { className: "style__content-card-list___e50Nu" },
                          M(
                            "div",
                            { className: "style__content-card___lAXPI" },
                            o
                              ? M(
                                  "div",
                                  { className: "style__product-name___2tC2e" },
                                  M(g.a, { type: "img", alt: "", src: o }),
                                )
                              : null,
                            d
                              ? M("p", { className: "style__desc___39G1o" }, d)
                              : null,
                            a
                              ? M(
                                  "a",
                                  {
                                    className: "style__product-cover___2WNk5",
                                    href: O.url,
                                    target: O.target,
                                    onClick: O.onClick,
                                  },
                                  M(g.a, { type: "img", src: a, alt: i.title }),
                                )
                              : null,
                            M(
                              "div",
                              { className: "style__spec-list-wrapper___1Qyzd" },
                              (function () {
                                for (
                                  var e =
                                      arguments.length > 0 &&
                                      void 0 !== arguments[0]
                                        ? arguments[0]
                                        : [],
                                    t = e.slice(),
                                    n = t.splice(0, 3),
                                    o = [];
                                  n.length;

                                )
                                  o.push(
                                    M(
                                      "ul",
                                      {
                                        className: "style__spec-list___2TPrl",
                                        key: b()(),
                                      },
                                      n.map(function (e) {
                                        return M(
                                          "li",
                                          {
                                            className: "style__spec___WxfEa",
                                            key: b()(),
                                          },
                                          e,
                                        );
                                      }),
                                    ),
                                  ),
                                    (n = t.splice(0, 3));
                                return o;
                              })(p),
                            ),
                            D &&
                              N.price &&
                              M(
                                "div",
                                { className: "style__product-price___2_tMs" },
                                N.has_discount &&
                                  M(
                                    "span",
                                    { className: "style__origin___1mLcf" },
                                    N.original_price,
                                  ),
                                M("span", {
                                  dangerouslySetInnerHTML: {
                                    __html: r(
                                      "v3.common.shoppingguide.price.prefix",
                                    ),
                                  },
                                }),
                                M("span", {
                                  dangerouslySetInnerHTML: { __html: N.price },
                                }),
                                M("span", {
                                  dangerouslySetInnerHTML: {
                                    __html: r(
                                      "v3.common.shoppingguide.price.suffix",
                                    ),
                                  },
                                }),
                              ),
                          ),
                        ),
                        M(
                          "div",
                          { className: "style__buy-box___3kfRb" },
                          k &&
                            M(
                              w.a,
                              {
                                type:
                                  _ &&
                                  _.theme_color &&
                                  "black" === _.theme_color
                                    ? "light"
                                    : "dark",
                                href: x,
                                size: "xl",
                                onClick: t.geSend.bind(
                                  t,
                                  E,
                                  "click",
                                  ""
                                    .concat(
                                      s ? "Mobile-" : "PC-",
                                      "sg_action_button_",
                                    )
                                    .concat(c),
                                  x,
                                ),
                                target: v,
                              },
                              f.title,
                            ),
                          h.map(function (e, n) {
                            var o = e.link,
                              a = e.title,
                              r = e.link_type,
                              i = "store-path" === r ? "store" : "",
                              u = "relative-path" === r ? "_self" : "_blank";
                            return M(
                              w.a,
                              {
                                type:
                                  _ &&
                                  _.theme_color &&
                                  "black" === _.theme_color
                                    ? "secondary-light"
                                    : "secondary-dark",
                                href: Object(I.k)({
                                  domain: i,
                                  url: o,
                                  country: l.country,
                                  locale: l.language,
                                  mobileMode: s,
                                }),
                                target: u,
                                size: "xl",
                                key: n,
                                onClick: t.geSend.bind(
                                  t,
                                  E,
                                  "click",
                                  ""
                                    .concat(
                                      s ? "Mobile-" : "PC-",
                                      "sg_action_button_",
                                    )
                                    .concat(c),
                                  null,
                                ),
                              },
                              a,
                            );
                          }),
                        ),
                        u === r("v3.common.shopping_guides.show_jump_link")
                          ? M("div", {
                              className: "style__learn-more-phone___26zB4",
                              dangerouslySetInnerHTML: {
                                __html: r("v3.common.shopping.learn_more.pdf"),
                              },
                            })
                          : null,
                      );
                    }),
                    S.length > 0 &&
                      M(
                        "ul",
                        {
                          className: d()(z, P, {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          }),
                        },
                        S.map(function (e, n) {
                          var o = e.icon,
                            a = e.link,
                            r = e.action_name,
                            i = e.title,
                            u = e.ga_label,
                            d = e.description;
                          return M(
                            "li",
                            { key: n, style: c ? { maxWidth: c } : {} },
                            M(
                              "div",
                              { className: "style__icon___2fy3c" },
                              M(g.a, {
                                type: "img",
                                src: Object(I.m)(o),
                                alt: "",
                              }),
                            ),
                            M("label", {
                              dangerouslySetInnerHTML: { __html: i },
                            }),
                            d &&
                              M("div", {
                                className: "style__description___1gCqM",
                                dangerouslySetInnerHTML: { __html: d },
                              }),
                            M(
                              x.a,
                              {
                                href: Object(I.k)({
                                  url: a,
                                  country: l.country,
                                  locale: l.language,
                                  mobileMode: s,
                                }),
                                theme:
                                  _ &&
                                  _.theme_color &&
                                  "black" === _.theme_color
                                    ? "white-main"
                                    : "black-main",
                                type: "more",
                                onClick: t.geSend.bind(
                                  t,
                                  E,
                                  "click",
                                  ""
                                    .concat(s ? "Mobile-" : "PC-", "sg_button_")
                                    .concat(u),
                                  null,
                                ),
                              },
                              M("span", {
                                dangerouslySetInnerHTML: { __html: r },
                              }),
                            ),
                          );
                        }),
                      ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(f.a.Component);
      Object(_.a)(B, "defaultProps", { t: function () {}, productData: {} }),
        Object(_.a)(B, "propSettings", {
          key: "shoppingGuide",
          name: "shoppingGuide",
          contentSetting: {
            style: {
              label: "\u6837\u5f0f\u914d\u7f6e",
              props: {
                guideItemMaxWidth: {
                  type: "string",
                  label: "guideList maxWidth",
                },
              },
            },
          },
          skinSetting: {},
        }),
        (t.default = Object(v.a)(
          Object(T.b)(function (e) {
            return { mobileMode: e.context.mobileMode };
          })(B),
        ));
    },
    "cc/H": function (e, t, n) {
      e.exports = {
        "button-anchor": "style__button-anchor___24tVB",
        "button-anchorvisited": "style__button-anchorvisited___3q84i",
        "button-anchor-disabled": "style__button-anchor-disabled___2OZkt",
        "dji-btn-col": "style__dji-btn-col___dgT5s",
        "dji-btn": "style__dji-btn___ILmHs",
        "dji-btn-btn": "style__dji-btn-btn___1ZdY_",
        fab: "style__fab___3S5X1",
        loading: "style__loading___yeduE",
        block: "style__block___KTkFd",
        icon: "style__icon___3D424",
        "dji-btn-xl": "style__dji-btn-xl___20iJH",
        "dji-btn-lg": "style__dji-btn-lg___2BnLT",
        "dji-btn-md": "style__dji-btn-md___3XnI3",
        "dji-btn-sm": "style__dji-btn-sm___1wC1v",
        "dji-btn-disabled-solid-dark":
          "style__dji-btn-disabled-solid-dark___nsNj-",
        "dji-btn-disabled-outline-dark":
          "style__dji-btn-disabled-outline-dark___VZHH9",
        "dji-btn-disabled-flat-dark":
          "style__dji-btn-disabled-flat-dark___2d-0N",
        "dji-btn-disabled-solid-light":
          "style__dji-btn-disabled-solid-light___2yTxf",
        "dji-btn-disabled-outline-light":
          "style__dji-btn-disabled-outline-light___3nSbF",
        "dji-btn-disabled-flat-light":
          "style__dji-btn-disabled-flat-light___3GaV_",
        "dji-btn-primary": "style__dji-btn-primary___3tFe2",
        "dji-btn-dark": "style__dji-btn-dark___3vZGF",
        "dji-btn-danger": "style__dji-btn-danger___3L8sd",
        "dji-btn-light": "style__dji-btn-light___3oAJz",
        "dji-btn-secondary-danger": "style__dji-btn-secondary-danger___38EhR",
        "dji-btn-secondary-dark": "style__dji-btn-secondary-dark___30qIM",
        "dji-btn-secondary-light": "style__dji-btn-secondary-light___1Lf7g",
        "dji-btn-tertiary-light": "style__dji-btn-tertiary-light___3KGv_",
        "dji-btn-variant": "style__dji-btn-variant___1AMwc",
        "dji-btn-variant-danger": "style__dji-btn-variant-danger___cf_5S",
        "dji-btn-variant-light": "style__dji-btn-variant-light___9BBSd",
        "dji-btn-variant-dark": "style__dji-btn-variant-dark___zscvz",
        "dji-btn-tertiary": "style__dji-btn-tertiary___1-c1j",
        "dji-btn-tertiary-dark": "style__dji-btn-tertiary-dark___3_xGb",
        "dji-btn-group": "style__dji-btn-group___1_bC1",
        active: "style__active___2kYCH",
      };
    },
    ccE7: function (e, t, n) {
      var o = n("Ojgd"),
        a = n("Jes0");
      e.exports = function (e) {
        return function (t, n) {
          var r,
            i,
            l = String(a(t)),
            s = o(n),
            c = l.length;
          return s < 0 || s >= c
            ? e
              ? ""
              : void 0
            : (r = l.charCodeAt(s)) < 55296 ||
                r > 56319 ||
                s + 1 === c ||
                (i = l.charCodeAt(s + 1)) < 56320 ||
                i > 57343
              ? e
                ? l.charAt(s)
                : r
              : e
                ? l.slice(s, s + 2)
                : i - 56320 + ((r - 55296) << 10) + 65536;
        };
      };
    },
    ce2M: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return b;
      });
      var o = n("wx14"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("rePB"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n("r7AC"),
        h = p.createElement,
        m = {};
      function y(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var b = (function (e) {
        function t() {
          var e;
          Object(a.default)(this, t);
          for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
            o[r] = arguments[r];
          return (
            (e = y(this, t, [].concat(o))),
            Object(_.a)(Object(s.a)(e), "targetDom", void 0),
            Object(_.a)(Object(s.a)(e), "animationFrame", void 0),
            Object(_.a)(Object(s.a)(e), "prevCalcOffset", void 0),
            Object(_.a)(Object(s.a)(e), "indicatorPosition", void 0),
            e
          );
        }
        return (
          Object(c.a)(t, e),
          Object(r.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this;
                this.parallaxScroll(),
                  Object(f.b)({
                    elm: this.targetDom,
                    offset: 2e3,
                    callback: function (t) {
                      return (
                        t.inView
                          ? e.parallaxScroll()
                          : e.animationFrame &&
                            (window.cancelAnimationFrame(e.animationFrame),
                            (e.animationFrame = null)),
                        !0
                      );
                    },
                  });
              },
            },
            {
              key: "parallaxScroll",
              value: function () {
                if (!this.animationFrame) {
                  var e = !1,
                    t = this.props,
                    n = t.factor,
                    o = void 0 === n ? 0.1 : n,
                    a = t.offset,
                    r = void 0 === a ? 200 : a,
                    i = t.background,
                    l = t.firstSlideDisabled;
                  "number" !== typeof this.indicatorPosition &&
                    (this.indicatorPosition = 0);
                  var s = this.targetDom,
                    c = this;
                  s &&
                    (function t() {
                      var n = window.scrollY || window.pageYOffset,
                        a = o || 0.1;
                      if ((l && !e && ((a = 1), (e = !0)), s)) {
                        for (
                          var _ = window.innerHeight, u = s, d = s.offsetTop;
                          u.offsetParent;

                        )
                          d += (u = u.offsetParent).offsetTop;
                        var p = s.offsetHeight;
                        if (n >= d - _ && n <= d + p) {
                          var f = (d - _ - n) / (_ + p);
                          c.indicatorPosition += (f - c.indicatorPosition) * a;
                          var h = +(c.indicatorPosition * r).toFixed(2);
                          h !== c.prevCalcOffset &&
                            ((c.prevCalcOffset = h),
                            i
                              ? (s.style["background-position-y"] = "".concat(
                                  h,
                                  "px",
                                ))
                              : (s.style.transform = "translateY(".concat(
                                  h,
                                  "px)",
                                )));
                        }
                        c.animationFrame = requestAnimationFrame(t);
                      }
                    })();
                }
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.children,
                  a = t.style,
                  r = t.styleName,
                  i = t.className,
                  l = t.attr;
                return h(
                  "div",
                  Object(o.a)(
                    {
                      ref: function (t) {
                        e.targetDom = t;
                      },
                      style: a,
                    },
                    l,
                    {
                      className:
                        (i ? i + " " : "") +
                        d()(r, m, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }) +
                        " " +
                        ((l && l.className) || ""),
                    },
                  ),
                  n,
                );
              },
            },
          ]),
          t
        );
      })(p.Component);
      Object(_.a)(b, "defaultProps", void 0),
        (b.defaultProps = {
          factor: 0.1,
          offset: 200,
          tabIndex: "",
          styleName: "",
          style: {},
          children: "",
          background: !1,
          className: "",
          attr: {},
          firstSlideDisabled: !1,
        });
    },
    cvCv: function (e, t) {
      e.exports = function (e) {
        return function () {
          return e;
        };
      };
    },
    dD9F: function (e, t, n) {
      var o = n("NykK"),
        a = n("shjB"),
        r = n("ExA7"),
        i = {};
      (i["[object Float32Array]"] =
        i["[object Float64Array]"] =
        i["[object Int8Array]"] =
        i["[object Int16Array]"] =
        i["[object Int32Array]"] =
        i["[object Uint8Array]"] =
        i["[object Uint8ClampedArray]"] =
        i["[object Uint16Array]"] =
        i["[object Uint32Array]"] =
          !0),
        (i["[object Arguments]"] =
          i["[object Array]"] =
          i["[object ArrayBuffer]"] =
          i["[object Boolean]"] =
          i["[object DataView]"] =
          i["[object Date]"] =
          i["[object Error]"] =
          i["[object Function]"] =
          i["[object Map]"] =
          i["[object Number]"] =
          i["[object Object]"] =
          i["[object RegExp]"] =
          i["[object Set]"] =
          i["[object String]"] =
          i["[object WeakMap]"] =
            !1),
        (e.exports = function (e) {
          return r(e) && a(e.length) && !!i[o(e)];
        });
    },
    dTAl: function (e, t, n) {
      var o = n("GoyQ"),
        a = Object.create,
        r = (function () {
          function e() {}
          return function (t) {
            if (!o(t)) return {};
            if (a) return a(t);
            e.prototype = t;
            var n = new e();
            return (e.prototype = void 0), n;
          };
        })();
      e.exports = r;
    },
    dWbz: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t) && !e.required) return n();
          r.default.required(e, t, o, l, a),
            (0, i.isEmptyValue)(t) || r.default.type(e, t, o, l, a);
        }
        n(l);
      };
    },
    deQI: function (e, t, n) {
      e.exports = {
        "accessories-sticky-component":
          "style__accessories-sticky-component___2sRu2",
        "section-title": "style__section-title___4fVVC",
        "section-container": "style__section-container___1bUJT",
        "sticky-wrap": "style__sticky-wrap___3sSDh",
        "sticky-box": "style__sticky-box___NT0u5",
        "sticky-content": "style__sticky-content___1DXTY",
        "sticky-content-ceiling": "style__sticky-content-ceiling___1N4Ek",
        "sticky-content-ie": "style__sticky-content-ie___31F8W",
        "scroll-content": "style__scroll-content___2RLkw",
        "accessories-ul": "style__accessories-ul___2v2QY",
        waterfall: "style__waterfall___2vI53",
        "accessories-item-last": "style__accessories-item-last___2Oz0e",
        "img-box": "style__img-box___3Pbgr",
        "accessories-item": "style__accessories-item___121oZ",
        title: "style__title___yvJWK",
        "accessories-video-ul": "style__accessories-video-ul___6mLs9",
        "accessories-item-video": "style__accessories-item-video___3GYOi",
        "accessories-video": "style__accessories-video___1jS0I",
        "replay-btn": "style__replay-btn___2-kOI",
        icon: "style__icon___3cbVV",
        "text-box": "style__text-box___ugrkw",
        introduce: "style__introduce___12Qc4",
        "btn-wrapper": "style__btn-wrapper___3OIPG",
        desc: "style__desc___2oOJT",
        "replay-btn-box": "style__replay-btn-box___1TdNb",
        "accessories-sticky-component-special":
          "style__accessories-sticky-component-special___9ufd2",
        "accessories-item-special": "style__accessories-item-special___fvF-4",
      };
    },
    dhd8: function (e, t, n) {
      "use strict";
      var o = n("rePB"),
        a = n("q1tI"),
        r = n.n(a),
        i = n("yWgo"),
        l = n("D7K2"),
        s = n("SBOM"),
        c = (n("piUf"), r.a.createElement);
      function _(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function u(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? _(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : _(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      t.a = function (e) {
        var t = e.anchorImage,
          n = e.visibleByDefault,
          o = e.anchorImageAlt,
          a = e.style,
          r = e.anchorImageWidth,
          _ = e.anchorImageHeight,
          d = e.anchorId,
          p = e.gaLabel,
          f = e.index,
          h = e.gaSend,
          m = e.t,
          y = function (e, t, n) {
            e.stopPropagation(),
              (function (e) {
                h("click", e);
              })(n);
          },
          b = p || "card-".concat(f, "-link");
        return c(
          "a",
          {
            href: d ? "#".concat(d) : "javascript:;",
            style: u({}, Object(l.c)(r, _)),
            className: "style__anchor-wrapper___1gYVQ",
            onClick: function (e) {
              return y(e, 0, b);
            },
          },
          t
            ? c(s.a, {
                type: "img",
                style: u({}, a),
                visibleByDefault: n,
                className: "",
                src: t,
                alt: o ? Object(i.w)(m(o)) : "",
              })
            : null,
        );
      };
    },
    dl0q: function (e, t, n) {
      n("Zxgi")("observable");
    },
    dt0z: function (e, t, n) {
      var o = n("zoYe");
      e.exports = function (e) {
        return null == e ? "" : o(e);
      };
    },
    dxL8: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("JX7q"),
        c = n("Ji7U"),
        _ = n("rePB"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("XnI8"),
        m = (n("N2pn"), n("x/Rj")),
        y = n("XxN0"),
        b = n("gn4A"),
        v = n.n(b),
        g = f.a.createElement,
        w = {
          "./style.css": {
            "click-modal-btns-m": "style__click-modal-btns-m___z6y8Q",
            "click-modal-btn": "style__click-modal-btn___2kQB_",
            content: "style__content___F2UYA",
            "click-modal-btns-pc": "style__click-modal-btns-pc___5fE5V",
            "modal-close": "style__modal-close___1rrwL",
            "modal-container": "style__modal-container___3BmKX",
            "light-theme": "style__light-theme___1IuEt",
            "modal-content-box": "style__modal-content-box___3d7ut",
            "model-box": "style__model-box___2d8qp",
            disabled: "style__disabled___2HBnj",
            active: "style__active___flIqM",
            "modal-frame": "style__modal-frame___1wf1B",
            "modal-container-m": "style__modal-container-m___2Wolb",
            "modal-arModel": "style__modal-arModel___vNyxR",
            "modal-3dModel": "style__modal-3dModel___1DlT8",
          },
        };
      function x(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function k(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? x(Object(n), !0).forEach(function (t) {
                Object(_.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : x(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function O(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var I = "3dModel",
        S = "arModel",
        j = (function (e) {
          function t(e) {
            var n;
            return (
              Object(a.default)(this, t),
              ((n = O(this, t, [e])).state = { modalShow: !1, opened: !1 }),
              (n.unlockModalTimer = null),
              (n.handleCloseButtonClick = n.handleCloseButtonClick.bind(
                Object(s.a)(n),
              )),
              (n.handleShowButtonClick = n.handleShowButtonClick.bind(
                Object(s.a)(n),
              )),
              (n.handleWrapperClick = n.handleWrapperClick.bind(
                Object(s.a)(n),
              )),
              (n.sendGa = n.sendGa.bind(Object(s.a)(n))),
              n
            );
          }
          return (
            Object(c.a)(t, e),
            Object(r.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  this.props.onRef && this.props.onRef(this),
                    this.renderButtons();
                },
              },
              {
                key: "handleShowButtonClick",
                value: function (e, t) {
                  this.unlockModalTimer && clearTimeout(this.unlockModalTimer),
                    e.preventDefault();
                  var n = this.state.opened;
                  this.props.isStopPropagation && e.stopPropagation();
                  var o = this.modalDom;
                  if ("undefined" !== typeof document && document) {
                    var a = document.querySelector("body"),
                      r = document.querySelector("html");
                    if (
                      (n
                        ? ((this.bodyInitialScroll =
                            window.scrollY || window.pageYOffset),
                          this.setState({ modalShow: !0, modelType: t }))
                        : (o && o.removeNode
                            ? (o.removeNode(),
                              o.appendChild(this.frameDom),
                              this.frameDom.appendChild(this.closeDom),
                              a && a.appendChild(o))
                            : (null === o || void 0 === o || o.remove(),
                              a && o && a.append(o)),
                          (this.bodyInitialScroll =
                            window.scrollY || window.pageYOffset),
                          this.setState({
                            modalShow: !0,
                            opened: !0,
                            modelType: t,
                          })),
                      a)
                    ) {
                      this.bodyInitialOverflow = a.style.overflow;
                      var i = window.innerWidth - a.clientWidth;
                      (r.style.overflow = "hidden"),
                        (r.style.paddingRight = "".concat(i, "px")),
                        (0, this.props.gaSend)(
                          "click",
                          "modal-button-".concat(t),
                        );
                    }
                  }
                },
              },
              {
                key: "handleCloseButtonClick",
                value: function (e) {
                  var t = this;
                  if (
                    (this.props.isStopPropagation && e && e.stopPropagation(),
                    "undefined" !== typeof document && document)
                  ) {
                    var n = document.querySelector("body"),
                      o = document.querySelector("html");
                    if (n) {
                      window.scrollTo(0, this.bodyInitialScroll),
                        this.setState({ modalShow: !1 });
                      this.unlockModalTimer = setTimeout(function () {
                        (n.style.overflow = t.bodyInitialOverflow || ""),
                          (o.style.overflow = ""),
                          (o.style.paddingRight = "");
                      }, 600);
                    }
                  }
                },
              },
              {
                key: "handleWrapperClick",
                value: function (e) {
                  e.stopPropagation(),
                    e.target &&
                      e.target.classList.contains("3d-ar-modal-container") &&
                      this.handleCloseButtonClick();
                },
              },
              {
                key: "sendGa",
                value: function (e) {
                  var t = this;
                  return function () {
                    var n = t.props,
                      o = n.gaSend,
                      a = n.productData,
                      r = n.mobileMode,
                      i = "accessories-".concat(e);
                    a &&
                      a.slug &&
                      o(
                        "click",
                        i,
                        ""
                          .concat(r ? "m" : "pc", "_")
                          .concat(a.slug, "_detail"),
                      );
                  };
                },
              },
              {
                key: "render3dArModel",
                value: function () {
                  var e = this.state.modelType,
                    t = this.props,
                    n = t.component_data,
                    a = t.mobileMode,
                    r = t.t,
                    i = n.qqDowngrade,
                    l = void 0 !== i && i,
                    s = n.modelArTabsName,
                    c = n.modelTabsName,
                    _ = l && v.a.isQQBrowser(),
                    u = {
                      modelArTabsName: r(s),
                      modelTabsName: r(c),
                      component_data: k(
                        k({}, n),
                        {},
                        { disableFadeAnimation: !0 },
                      ),
                      t: r,
                      sendGa: this.sendGa,
                      showAsModal: !0,
                    };
                  return g(
                    "div",
                    { className: "style__model-box___2d8qp" },
                    a
                      ? g(y.a, Object(o.a)({}, u, { activeModelType: e }))
                      : g(
                          m.a,
                          Object(o.a)({ forceDowngrade: _ }, u, {
                            activeModelType: e,
                          }),
                        ),
                  );
                },
              },
              {
                key: "renderModal",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.modalContainerClassName,
                    o = t.mobileMode,
                    a = t.component_data,
                    r = this.state,
                    i = r.modelType,
                    l = r.modalShow,
                    s = r.opened,
                    c = "light" === a.theme;
                  return g(
                    "div",
                    {
                      ref: function (t) {
                        e.modalDom = t;
                      },
                      onClick: this.handleWrapperClick,
                      className:
                        "3d-ar-modal-container ".concat(n || "") +
                        " " +
                        d()(
                          "modal-container modal-container-"
                            .concat(o ? "m" : "pc", " ")
                            .concat(l ? "active" : "", " ")
                            .concat(s ? "" : "disabled", " ")
                            .concat(c ? "light-theme" : ""),
                          w,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                    },
                    g(
                      "div",
                      {
                        ref: function (t) {
                          e.frameDom = t;
                        },
                        className: d()("modal-".concat(i, " modal-frame"), w, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      g("div", {
                        ref: function (t) {
                          e.closeDom = t;
                        },
                        className: "style__modal-close___1rrwL",
                        onClick: this.handleCloseButtonClick,
                      }),
                      g(
                        "div",
                        { className: "style__modal-content-box___3d7ut" },
                        g("div", { className: "" }, this.render3dArModel()),
                      ),
                    ),
                  );
                },
              },
              {
                key: "renderButtons",
                value: function () {
                  var e = this,
                    t = this.props.id;
                  if (t) {
                    var n =
                      "undefined" !== typeof document &&
                      document.querySelector("body");
                    n &&
                      n.addEventListener("click", function (n) {
                        n.target.id === "".concat(t, "-ARtype") &&
                          (n.stopPropagation(), e.handleShowButtonClick(n, S)),
                          n.target.id === "".concat(t, "-3Dtype") &&
                            (n.stopPropagation(),
                            e.handleShowButtonClick(n, I));
                      });
                  }
                },
              },
              {
                key: "render",
                value: function () {
                  return g(
                    "div",
                    { style: this.props.style },
                    this.renderModal(),
                  );
                },
              },
            ]),
            t
          );
        })(f.a.Component);
      Object(_.a)(j, "defaultProps", {
        t: function () {},
        mobileMode: !1,
        component_data: {},
        gaSend: function () {},
        style: {},
        btnStyle: {},
        btnWrapperStyle: {},
        modalContainerClassName: "",
        className: "",
        isStopPropagation: !1,
      }),
        (t.a = Object(h.a)(j));
    },
    e3dM: function (e, t, n) {
      e.exports = {
        "hero-vertical-card": "style__hero-vertical-card___2B64y",
        "card-wrapper": "style__card-wrapper___3yqfZ",
        "eyebrow-text": "style__eyebrow-text___1gRhT",
        headline: "style__headline___1ripS",
        subhead: "style__subhead___qRMqE",
        "vertical-top-align": "style__vertical-top-align___3w7Dp",
        "vertical-center-align": "style__vertical-center-align___3RP93",
        "vertical-bottom-align": "style__vertical-bottom-align___1f7Y3",
        "horizontal-left-align": "style__horizontal-left-align___3tk_z",
        "horizontal-center-align": "style__horizontal-center-align___YtBVc",
        eyebrow: "style__eyebrow___3m_hp",
        description: "style__description___2V1Q7",
        note: "style__note___3_j8s",
        "icon-pic": "style__icon-pic___1SGsP",
        "topping-img": "style__topping-img___1J_U3",
        "icon-row-container": "style__icon-row-container___3A3EC",
        "icon-item": "style__icon-item___UZU5k",
        horizontal: "style__horizontal___2rPj4",
        "icon-number-container": "style__icon-number-container___2cK9V",
        "buttons-container": "style__buttons-container___2Vw5K",
        divider: "style__divider___G4nDm",
        "horizontal-right-align": "style__horizontal-right-align___1i25L",
        "card-container": "style__card-container___KPQkl",
        "size-xxs": "style__size-xxs___22TZb",
        "connect-pic": "style__connect-pic___26ccD",
        link: "style__link___1IIwB",
        "links-container": "style__links-container___D4Ibd",
        "icons-container": "style__icons-container___1CoW-",
        "icon-col-container": "style__icon-col-container___2pohI",
        "icon-number": "style__icon-number___2OOlV",
        "icon-unit": "style__icon-unit___2hz_k",
        "icon-title": "style__icon-title___2ZaL_",
        "icon-desc": "style__icon-desc___Otw9j",
        "size-xs": "style__size-xs___BV21_",
        "size-s": "style__size-s___--zS-",
        "size-m": "style__size-m___QlNqG",
        "size-l": "style__size-l___2n_6X",
        "size-xl": "style__size-xl___30LZE",
        "size-xxl": "style__size-xxl___xhAlV",
        "size-xxxl": "style__size-xxxl___36o2G",
        "size-xxxxl": "style__size-xxxxl___3ItPZ",
        "size-xxxxxl": "style__size-xxxxxl___3-JTI",
        "video-content": "style__video-content___R99ab",
        "parallax-fore-video": "style__parallax-fore-video___3KBns",
        "fore-controller-video-poster-bg":
          "style__fore-controller-video-poster-bg___3pLX6",
        "image-content": "style__image-content___UYyC1",
        "video-buttom": "style__video-buttom___1zeaz",
        "replay-buttom": "style__replay-buttom___35dZ3",
        "play-buttom": "style__play-buttom___3K-Xo",
        "pause-buttom": "style__pause-buttom___1mLag",
        dark: "style__dark___3nSM1",
        "fore-image": "style__fore-image___1Qau6",
        "parallax-fore-pic": "style__parallax-fore-pic___3wdiE",
        "headline-pic": "style__headline-pic___2WrWy",
        "eyebrow-pic": "style__eyebrow-pic___3VeeB",
        "headline-text": "style__headline-text___1tW5r",
        "visual-hidden": "style__visual-hidden___32pnD",
        "divider-container": "style__divider-container___2u5xw",
        "button-wrapper": "style__button-wrapper___3Lzku",
        "button-inner": "style__button-inner___3_kJl",
        "button-link": "style__button-link___1kepz",
        "button-video-play": "style__button-video-play___Ye-JI",
        "video-play": "style__video-play___3eLhN",
        "video-play-light": "style__video-play-light___1yGfi",
        "video-play-dark": "style__video-play-dark___3EK_y",
        "download-buttons-container":
          "style__download-buttons-container___M5rzS",
        download: "style__download___3GbaI",
        "download-google-play": "style__download-google-play___1rP3M",
        "image-text": "style__image-text___7HoYo",
        "text-image": "style__text-image___12_xF",
        part: "style__part___15TtD",
        left: "style__left___hVVQM",
        right: "style__right___1ZAB_",
        "background-video": "style__background-video___EQUNk",
        "video-mask": "style__video-mask___2p6XD",
        "card-link": "style__card-link___o1KCU",
        "text-content-container": "style__text-content-container___1aLKY",
        "has-media-screen": "style__has-media-screen___3Mu1K",
        "media-screen-1440": "style__media-screen-1440___2do0U",
        "has-content-media-screen": "style__has-content-media-screen___x-GFM",
        "margin-top-48": "style__margin-top-48___r13B3",
        "margin-top-40": "style__margin-top-40___l1nVl",
        "margin-top-32": "style__margin-top-32___27yrJ",
        "margin-top-24": "style__margin-top-24___3BI68",
        "media-screen-1600": "style__media-screen-1600___3XhTE",
      };
    },
    e4Nc: function (e, t, n) {
      var o = n("fGT3"),
        a = n("k+1r"),
        r = n("JHgL"),
        i = n("pSRY"),
        l = n("H8j4");
      function s(e) {
        var t = -1,
          n = null == e ? 0 : e.length;
        for (this.clear(); ++t < n; ) {
          var o = e[t];
          this.set(o[0], o[1]);
        }
      }
      (s.prototype.clear = o),
        (s.prototype.delete = a),
        (s.prototype.get = r),
        (s.prototype.has = i),
        (s.prototype.set = l),
        (e.exports = s);
    },
    e5U0: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      });
      var o = n("q1tI"),
        a = Object(o.createContext)({
          transformPagePoint: function (e) {
            return e;
          },
          isStatic: !1,
        });
    },
    eDQT: function (e, t, n) {},
    eKi2: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = function (e) {
        var t = e.needTiming,
          n = e.onLineTimeSetting,
          o = e.outLineTimeSetting,
          a = e.id,
          r = e.isEdit;
        if (!(n && o && o < n) && t && !1 === r) {
          if (n)
            var i = setInterval(function () {
              if (new Date().getTime() / 1e3 >= Number(n)) {
                var e = document.getElementById(a);
                e &&
                  (e.style.removeProperty("opacity"),
                  e.style.removeProperty("height"),
                  clearInterval(i));
              }
            }, 1e4);
          if (o)
            var l = setInterval(function () {
              if (new Date().getTime() / 1e3 >= Number(o)) {
                var e = document.getElementById(a);
                e &&
                  (e.style.setProperty("opacity", "0"),
                  e.style.setProperty("height", "0px"),
                  clearInterval(l));
              }
            }, 1e4);
        }
      };
    },
    eUgh: function (e, t) {
      e.exports = function (e, t) {
        for (var n = -1, o = null == e ? 0 : e.length, a = Array(o); ++n < o; )
          a[n] = t(e[n], n, e);
        return a;
      };
    },
    eUtF: function (e, t, n) {
      e.exports =
        !n("jmDH") &&
        !n("KUxP")(function () {
          return (
            7 !=
            Object.defineProperty(n("Hsns")("div"), "a", {
              get: function () {
                return 7;
              },
            }).a
          );
        });
    },
    eZTX: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("rePB"),
        r = n("ODXe"),
        i = n("iKuz"),
        l = n.n(i),
        s = n("q1tI"),
        c = n.n(s),
        _ = n("XnI8"),
        u = (n("KT+k"), n("yWgo")),
        d = n("uN13"),
        p = n("DdlN"),
        f = n("6AKW"),
        h = n("hugj"),
        m = n("x1L9"),
        y = n("dhd8"),
        b = n("Ra6f"),
        v = n("SBOM"),
        g = n("ub/+"),
        w = n("TSYQ"),
        x = n.n(w),
        k = n("Xwp0"),
        O = n("EvnD"),
        I = n("QH4r"),
        S = n("cKzW"),
        j = c.a.createElement,
        T = {
          "./style.css": {
            "section-sale-point": "style__section-sale-point___2Qhfg",
            "layout-wrapper": "style__layout-wrapper___2uDlY",
            rasterisation: "style__rasterisation____7mzy",
            "card-wrapper": "style__card-wrapper___2eSM6",
            "video-player-button-position":
              "style__video-player-button-position___3tb8Q",
            "card-vertical-center": "style__card-vertical-center___2-S8K",
            "card-vertical-top": "style__card-vertical-top___ix6Qq",
            "card-vertical-bottom": "style__card-vertical-bottom___1QxNM",
            "card-horizontal-center": "style__card-horizontal-center___2jDA1",
            "card-content": "style__card-content___2Xnq1",
            "foreground-pic": "style__foreground-pic___3IOU9",
            "card-horizontal-left": "style__card-horizontal-left___1YUWY",
            "card-horizontal-right": "style__card-horizontal-right___2vqs3",
            "video-player-button-container":
              "style__video-player-button-container___5mhHI",
            "video-btn-text": "style__video-btn-text___1U_rD",
            "salepoint-video-play": "style__salepoint-video-play___RkMLz",
            "video-player-button-center":
              "style__video-player-button-center___1w_w-",
            "video-player-button-left-bottom":
              "style__video-player-button-left-bottom___2qE05",
            "video-player-button-right-bottom":
              "style__video-player-button-right-bottom___fTQ3L",
            "video-player-button-secondary-light":
              "style__video-player-button-secondary-light___2Eotl",
            "video-player-button-secondary-dark":
              "style__video-player-button-secondary-dark___3DBlb",
            "video-player-button-with-text":
              "style__video-player-button-with-text___L2Nvk",
            "divide-line": "style__divide-line___zLRkK",
            "amount-icon": "style__amount-icon___f81AR",
            "card-wrapper-product-bundle":
              "style__card-wrapper-product-bundle___6qMvi",
          },
        },
        C = function (e) {
          var t,
            n,
            o = e.t,
            a = e.videoBtnTheme,
            r = e.videoBtnNeedText,
            i = e.videoBtnFollow,
            c = e.cursorImage,
            _ = e.videoBtnAlign,
            u = e.videoBtnText,
            d = e.videoBtnGalabel,
            p = e.videoBtnLink,
            f = e.cardRef,
            h = Object(s.useRef)(null);
          i &&
            c &&
            (null === (t = f.current) ||
              void 0 === t ||
              t.style.setProperty(
                "--cursor-image",
                "url(".concat(c, ") 0 0,auto"),
              ),
            null === (n = h.current) ||
              void 0 === n ||
              n.style.setProperty("--btn-display", "none"));
          var m = r && u,
            y = _ ? "video-player-button-".concat(_) : "",
            b = a ? "video-player-button-".concat(a) : "",
            v = x()("video-player-button-position", y, b, {
              "video-player-button-with-text": m,
            });
          return j(
            "div",
            {
              "data-ga-label": o(d),
              "data-ga-category": "salepoint-video",
              "data-ga-action": "click",
              ref: h,
              className: l()(v, T, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            },
            j(
              S.a,
              {
                link: null === p || void 0 === p ? void 0 : p.path,
                style: { width: "100%" },
              },
              j(
                I.c,
                {
                  size: I.a["x-large"],
                  style: { borderRadius: "60px", width: "100%" },
                  type: I.b[a],
                },
                j(
                  "div",
                  { className: "style__video-player-button-container___5mhHI" },
                  j("span", {
                    className: "style__video-btn-text___1U_rD",
                    dangerouslySetInnerHTML: { __html: o(u) || "" },
                  }),
                  j("div", {
                    className: "style__salepoint-video-play___RkMLz",
                  }),
                ),
              ),
            ),
          );
        },
        M = c.a.createElement,
        P = function (e) {
          var t = e.t,
            n = e.children,
            o = e.videoBtnFollow,
            a = e.cursorImage,
            r = e.videoBtnLink,
            i = e.videoBtnGalabel,
            l = e.hasVideoBtn && o && a;
          return M(
            c.a.Fragment,
            null,
            l
              ? M(
                  S.a,
                  {
                    link: null === r || void 0 === r ? void 0 : r.path,
                    style: { width: "100%" },
                  },
                  M(
                    "div",
                    {
                      "data-ga-label": t(i),
                      "data-ga-category": "salepoint-video",
                      "data-ga-action": "click",
                    },
                    n,
                  ),
                )
              : n,
          );
        },
        E = n("D7K2"),
        L = c.a.createElement,
        B = {
          "./style.css": {
            "section-sale-point": "style__section-sale-point___2Qhfg",
            "layout-wrapper": "style__layout-wrapper___2uDlY",
            rasterisation: "style__rasterisation____7mzy",
            "card-wrapper": "style__card-wrapper___2eSM6",
            "video-player-button-position":
              "style__video-player-button-position___3tb8Q",
            "card-vertical-center": "style__card-vertical-center___2-S8K",
            "card-vertical-top": "style__card-vertical-top___ix6Qq",
            "card-vertical-bottom": "style__card-vertical-bottom___1QxNM",
            "card-horizontal-center": "style__card-horizontal-center___2jDA1",
            "card-content": "style__card-content___2Xnq1",
            "foreground-pic": "style__foreground-pic___3IOU9",
            "card-horizontal-left": "style__card-horizontal-left___1YUWY",
            "card-horizontal-right": "style__card-horizontal-right___2vqs3",
            "video-player-button-container":
              "style__video-player-button-container___5mhHI",
            "video-btn-text": "style__video-btn-text___1U_rD",
            "salepoint-video-play": "style__salepoint-video-play___RkMLz",
            "video-player-button-center":
              "style__video-player-button-center___1w_w-",
            "video-player-button-left-bottom":
              "style__video-player-button-left-bottom___2qE05",
            "video-player-button-right-bottom":
              "style__video-player-button-right-bottom___fTQ3L",
            "video-player-button-secondary-light":
              "style__video-player-button-secondary-light___2Eotl",
            "video-player-button-secondary-dark":
              "style__video-player-button-secondary-dark___3DBlb",
            "video-player-button-with-text":
              "style__video-player-button-with-text___L2Nvk",
            "divide-line": "style__divide-line___zLRkK",
            "amount-icon": "style__amount-icon___f81AR",
            "card-wrapper-product-bundle":
              "style__card-wrapper-product-bundle___6qMvi",
          },
        };
      function N(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function D(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? N(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : N(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var z = function (e) {
          var t = e.textFont,
            n = e.text,
            o = e.t;
          return L(g.e, {
            tagType: t.labelType,
            style: D({}, t.style),
            dangerouslySetInnerHTML: { __html: o(n) },
          });
        },
        A = function (e) {
          var t = e.image,
            n = e.visibleByDefault,
            o = e.imageAlt,
            a = e.style,
            r = e.imageWidth,
            i = e.imageHeight,
            l = e.t;
          return t
            ? L(v.a, {
                type: "img",
                style: D(D({}, a), Object(E.c)(r, i)),
                visibleByDefault: n,
                className: "style__foreground-pic___3IOU9",
                src: t,
                alt: Object(u.w)(l(o)),
              })
            : null;
        },
        R = function (e) {
          var t = e.divideWight,
            n = e.divideHeight,
            o = e.divideRadius,
            a = e.divideBgColor,
            r = e.divideBgGradientColor,
            i = {
              margin: e.divideMargin || "",
              padding: e.dividePadding || "",
            },
            l = {
              width: t || "",
              height: n || "",
              borderRadius: o || "",
              backgroundColor: a || "",
              backgroundImage: r || "",
            };
          return L(
            "div",
            { className: "style__divide-line___zLRkK", style: Object(u.v)(i) },
            L("div", { style: Object(u.v)(l) }),
          );
        },
        F = function (e) {
          var t = e.iconAmountFont,
            n = e.iconAmountText,
            o = e.iconUnitFont,
            a = e.iconUnitText,
            r = e.t,
            i =
              !!t &&
              L(g.e, {
                tagType: t.labelType,
                style: D({}, t.style),
                dangerouslySetInnerHTML: { __html: r(n) },
              }),
            l =
              !!o &&
              L(g.e, {
                tagType: o.labelType,
                style: D({}, o.style),
                dangerouslySetInnerHTML: { __html: r(a) },
              });
          return L(
            c.a.Fragment,
            null,
            L("div", { className: "style__amount-icon___f81AR" }, i, l),
          );
        },
        V = function (e) {
          var t,
            n = e.elementType,
            a = e.video,
            r = e.t,
            i = e.anchorLink,
            l = e.mobileMode;
          t = e.gaLabel ? D(D({}, e), {}, { gaLabel: r(e.gaLabel) }) : D({}, e);
          var s = e.linkGaLabel
            ? "".concat(r(e.linkGaLabel), "-")
            : "card-".concat(e.index, "-link-");
          switch (n) {
            case O.a.VIDEO:
              return L(
                "div",
                {
                  className: "style__card-content___2Xnq1",
                  style: Object(E.b)(e),
                },
                L(
                  "a",
                  { style: { display: "contents" }, href: i },
                  L(m.a, Object(o.a)({}, a, { mobileMode: l })),
                ),
              );
            case O.a.TEXT:
              return L(
                "div",
                {
                  className: "style__card-content___2Xnq1",
                  style: Object(E.b)(e),
                },
                L(z, e),
              );
            case O.a.IMAGE:
              return L(
                "div",
                { className: "style__card-content___2Xnq1" },
                L(
                  "a",
                  { style: { display: "contents" }, href: i },
                  L(A, Object(o.a)({ style: Object(E.b)(e) }, e)),
                ),
              );
            case O.a.ANCHOR:
              return L(y.a, t);
            case O.a.LINK:
              return L(
                "div",
                {
                  className: "style__card-content___2Xnq1",
                  style: Object(E.b)(e),
                },
                Object(b.b)(e, {
                  gaTextPrefix: s,
                  linkType: e.linkType,
                  linkText: r(e.linkText),
                  link: r(e.linkUrl),
                  gaCategory: "salepoint",
                  gaAction: "click",
                }),
              );
            case O.a.DIVIDE_LINE:
              return L(R, e);
            case O.a.ICON:
              return L(F, e);
            default:
              return "";
          }
          return L("div", { className: "style__card-content___2Xnq1" }, "");
        },
        H = function (e) {
          var t = e.elementList,
            n = e.t,
            a = e.visibleByDefault,
            r = e.gaSend,
            i = e.index,
            l = e.anchorLink,
            s = e.mobileMode;
          return L(
            c.a.Fragment,
            null,
            null === t || void 0 === t
              ? void 0
              : t.map(function (e) {
                  return L(
                    V,
                    Object(o.a)(
                      {
                        anchorLink: l,
                        gaSend: r,
                        index: i,
                        visibleByDefault: a,
                      },
                      e,
                      { t: n, mobileMode: s },
                    ),
                  );
                }),
          );
        },
        W = function (e) {
          var t = e.backgroundType,
            n = e.backgroundPrue,
            a = e.backgroundGradient,
            r = e.backgroundVideo,
            i = e.backgroundImage,
            c = e.radius,
            _ = e.horizontalAlign,
            u = e.verticalAlign,
            p = e.margin,
            f = e.hasVideoBtn,
            h = e.hasProductBundleModal,
            m = e.productBundleModalid,
            y = {
              backgroundType: t,
              backgroundPrue: n,
              backgroundGradient: a,
              backgroundVideo: r,
              backgroundImage: i,
            },
            b = (r || {}).backgroundVideoHoverPlay,
            v = void 0 !== b && b,
            g = Object(s.useState)(!1),
            w = g[0],
            I = g[1],
            S = u ? "card-vertical-".concat(u) : "",
            j = _ ? "card-horizontal-".concat(_) : "",
            T = h ? "card-wrapper-product-bundle" : "",
            M = Object(s.useRef)(null),
            N = x()("card-wrapper", S, j, T),
            z = (function (e, t, n) {
              return (e && t === k.a.IMAGE) || (n && t === k.a.VIDEO);
            })(i, t, r),
            A = (function (e) {
              var t,
                n = e.elementList;
              if (n && n.length > 0) {
                var o = n.filter(function (e) {
                  return e.elementType === O.a.ANCHOR;
                });
                o.length > 0 &&
                  o[0] &&
                  o[0].anchorId &&
                  (t = "#".concat(o[0].anchorId));
              }
              return t;
            })(e);
          return L(
            d.a,
            Object(o.a)({}, y, {
              isHovering: w,
              style: D(D({}, Object(E.f)(c)), Object(E.d)(p)),
            }),
            L(
              "a",
              { style: { display: "contents" }, href: z ? A : void 0 },
              L(
                P,
                e,
                L(
                  "div",
                  {
                    id: h && "productBundle-Modal-Type-".concat(m),
                    ref: M,
                    style: Object(E.a)(e),
                    onMouseEnter: function () {
                      v && I(!0);
                    },
                    onMouseLeave: function () {
                      v && I(!1);
                    },
                    className: l()(N, B, {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    }),
                  },
                  f && L(C, Object(o.a)({}, e, { cardRef: M })),
                  L(H, Object(o.a)({}, e, { anchorLink: A })),
                ),
              ),
            ),
          );
        },
        U = n("HaZN"),
        G = n("qt4/");
      function Y(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      var q = (function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Y(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : Y(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      })(
        {
          linkType: {
            label: "\u7c7b\u578b",
            type: "select",
            items: [
              { label: "\u7ad9\u5185\u94fe\u63a5", value: "internal-link" },
              { label: "\u7ad9\u5916\u94fe\u63a5", value: "external-link" },
              { label: "\u4e0b\u8f7d\u94fe\u63a5", value: "download-link" },
              {
                label: "\u65e0\u56fe\u6807\u94fe\u63a5",
                value: "no-icon-link",
              },
            ],
          },
          linkUrl: {
            label: "\u94fe\u63a5url",
            type: "string",
            content: "text",
          },
          linkText: {
            label: "\u94fe\u63a5\u6587\u6848",
            type: "string",
            key: "link-text",
            content: "text",
          },
          linkGaLabel: { label: "ga-label", type: "string", content: "text" },
        },
        {
          linkColor: {
            label: "\u94fe\u63a5\u989c\u8272",
            type: "select",
            items: [
              { label: "black-main", value: "black" },
              { label: "white-main", value: "white" },
              { label: "primary-on-dark(blue-4)", value: "dark" },
              { label: "primary-on-light(blue-6)", value: "normal" },
            ],
          },
          linkFontSize: {
            label: "\u94fe\u63a5\u5b57\u53f7",
            type: "select",
            items: [
              { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
              { label: "10px", value: "10px" },
              { label: "12px", value: "12px" },
              { label: "14px", value: "14px" },
              { label: "16px", value: "16px" },
              { label: "18px", value: "18px" },
              { label: "20px", value: "20px" },
              { label: "24px", value: "24px" },
              { label: "28px", value: "28px" },
              { label: "32px", value: "32px" },
              { label: "40px", value: "40px" },
              { label: "48px", value: "48px" },
              { label: "56px", value: "56px" },
              { label: "64px", value: "64px" },
              { label: "72px", value: "72px" },
              { label: "80px", value: "80px" },
              { label: "88px", value: "88px" },
              { label: "96px", value: "96px" },
              { label: "104px", value: "104px" },
              { label: "112px", value: "112px" },
              { label: "120px", value: "120px" },
            ],
          },
          linkLineHeight: {
            label: "\u94fe\u63a5\u884c\u9ad8",
            type: "select",
            items: [
              { label: "\u8ddf\u968f\u5168\u5c40", value: "" },
              { label: "\u7d27\u51d1\u884c\u9ad8", value: "compact" },
              { label: "\u6807\u51c6\u884c\u9ad8", value: "standard" },
            ],
          },
        },
      );
      function X(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function Z(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? X(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : X(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var K = [
          { label: "\u6587\u6848", value: O.a.TEXT },
          { label: "\u56fe\u7247", value: O.a.IMAGE },
          { label: "\u89c6\u9891", value: O.a.VIDEO },
          { label: "\u951a\u70b9\u6309\u94ae", value: O.a.ANCHOR },
          { label: "\u94fe\u63a5", value: O.a.LINK },
          { label: "\u5206\u5272\u7ebf", value: O.a.DIVIDE_LINE },
          { label: "icon", value: O.a.ICON },
        ],
        Q = {
          text: {
            type: "string",
            content: "text",
            label: "\u6587\u6848",
            controlBy: "elementType",
            controlValue: O.a.TEXT,
          },
          textFont: {
            type: "font",
            label: "\u6587\u6848-\u5b57\u4f53\u914d\u7f6e",
            controlBy: "elementType",
            controlValue: O.a.TEXT,
          },
        },
        J = {
          divideWight: {
            label: "\u5206\u5272\u7ebf\u5bbd\u5ea6",
            type: "string",
            helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
            controlBy: "elementType",
            controlValue: O.a.DIVIDE_LINE,
          },
          divideHeight: {
            label: "\u5206\u5272\u7ebf\u9ad8\u5ea6",
            type: "string",
            helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
            controlBy: "elementType",
            controlValue: O.a.DIVIDE_LINE,
          },
          divideRadius: {
            label: "\u5206\u5272\u7ebf\u5706\u89d2",
            type: "string",
            helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
            controlBy: "elementType",
            controlValue: O.a.DIVIDE_LINE,
          },
          divideBgColor: {
            label: "\u5206\u5272\u7ebf\u80cc\u666f\u8272",
            type: "string",
            content: "color",
            controlBy: "elementType",
            controlValue: O.a.DIVIDE_LINE,
          },
          divideBgGradientColor: {
            label: "\u5206\u5272\u7ebf\u80cc\u666f\u6e10\u53d8\u8272",
            type: "string",
            content: "color",
            controlBy: "elementType",
            controlValue: O.a.DIVIDE_LINE,
          },
          divideMargin: {
            label:
              "\u5206\u5272\u7ebf\u5916\u8fb9\u8ddd(\u4e0a\u53f3\u4e0b\u5de6\uff0c\u4f8b\uff1a20px 0 30px 0)",
            type: "string",
            helptext:
              "\u9700\u5e26\u5355\u4f4d\uff080\u53ef\u4ee5\u4e0d\u52a0\u5355\u4f4d\uff09, \u5982\u201cpx\u201d",
            controlBy: "elementType",
            controlValue: O.a.DIVIDE_LINE,
          },
          dividePadding: {
            label:
              "\u5206\u5272\u7ebf\u5185\u8fb9\u8ddd(\u4e0a\u53f3\u4e0b\u5de6\uff0c\u4f8b\uff1a20px 0 30px 0)",
            type: "string",
            helptext:
              "\u9700\u5e26\u5355\u4f4d\uff080\u53ef\u4ee5\u4e0d\u52a0\u5355\u4f4d\uff09, \u5982\u201cpx\u201d",
            controlBy: "elementType",
            controlValue: O.a.DIVIDE_LINE,
          },
        },
        $ = {
          iconAmountFont: {
            type: "font",
            label: "icon\u7684\u6570\u5b57-\u5b57\u4f53\u914d\u7f6e",
            controlBy: "elementType",
            controlValue: O.a.ICON,
          },
          iconUnitFont: {
            type: "font",
            label: "icon\u7684\u5355\u4f4d-\u5b57\u4f53\u914d\u7f6e",
            controlBy: "elementType",
            controlValue: O.a.ICON,
          },
          iconAmountText: {
            type: "string",
            content: "text",
            label: "icon\u7684\u6570\u5b57-\u6587\u6848",
            controlBy: "elementType",
            controlValue: O.a.ICON,
          },
          iconUnitText: {
            type: "string",
            content: "text",
            label: "icon\u7684\u5355\u4f4d-\u6587\u6848",
            controlBy: "elementType",
            controlValue: O.a.ICON,
          },
        },
        ee = Z(
          {
            image: {
              type: "image",
              label: "\u524d\u666f\u56fe\u7247",
              controlBy: "elementType",
              controlValue: O.a.IMAGE,
            },
            imageWidth: {
              label: "\u524d\u666f\u56fe\u7247\u5bbd\u5ea6",
              type: "string",
              helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
              controlBy: "elementType",
              controlValue: O.a.IMAGE,
            },
            imageHeight: {
              label: "\u524d\u666f\u56fe\u7247\u9ad8\u5ea6",
              type: "string",
              helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
              controlBy: "elementType",
              controlValue: O.a.IMAGE,
            },
            imageAlt: {
              label: "\u524d\u666f\u56fe\u7247 Alt",
              type: "string",
              content: "text",
              controlBy: "elementType",
              controlValue: O.a.IMAGE,
            },
          },
          O.e,
        ),
        te = Z(
          {
            video: {
              type: "video",
              label: "\u89c6\u9891\u914d\u7f6e",
              videoType: "foreground",
              controlBy: "elementType",
              controlValue: O.a.VIDEO,
            },
          },
          O.e,
        );
      Object.keys(G.a).forEach(function (e) {
        (G.a[e].controlBy = "elementType"), (G.a[e].controlValue = O.a.ANCHOR);
      }),
        Object.keys(q).forEach(function (e) {
          (q[e].controlBy = "elementType"), (q[e].controlValue = O.a.LINK);
        });
      var ne = Z(
          Z(
            Z(
              Z(
                Z(
                  Z(
                    Z(
                      Z(
                        Z(
                          {
                            elementType: {
                              type: "select",
                              label: "\u5143\u7d20\u7c7b\u578b",
                              items: K,
                            },
                          },
                          Q,
                        ),
                        ee,
                      ),
                      te,
                    ),
                    G.a,
                  ),
                  q,
                ),
                O.d,
              ),
              O.c,
            ),
            J,
          ),
          $,
        ),
        oe = {
          hasVideoBtn: {
            label:
              "\u662f\u5426\u5c55\u793a\u89c6\u9891\u5f39\u7a97\u6309\u94ae",
            type: "boolean",
            hide: "mobile",
          },
          videoBtnTheme: {
            type: "select",
            label: "\u89c6\u9891\u64ad\u653e\u6309\u94ae\u4e3b\u9898",
            items: O.h,
            hide: "mobile",
          },
          videoBtnNeedText: {
            type: "boolean",
            label:
              "\u89c6\u9891\u64ad\u653e\u6309\u94ae\u662f\u5426\u9700\u8981\u6587\u6848",
            helptext:
              "\u6309\u94ae\u6587\u6848\u9700\u8981\u5728\u3010\u5185\u5bb9\u7f16\u8f91\u3011\u4e0a\u4f20",
            hide: "mobile",
          },
          videoBtnFollow: {
            type: "boolean",
            label:
              "\u89c6\u9891\u64ad\u653e\u6309\u94ae\u662f\u5426\u9700\u8981\u8ddf\u624b",
            helptext:
              "\u9f20\u6807\u6837\u5f0f\u56fe\u7247\u9700\u8981\u5728\u3010\u5185\u5bb9\u7f16\u8f91\u3011\u4e0a\u4f20",
            hide: "mobile",
          },
          cursorImage: {
            type: "image",
            label:
              "\u89c6\u9891\u64ad\u653e\u6309\u94ae\u8ddf\u624b\u56fe\u7247",
            helptext: "\u4ec5\u5141\u8bb8\u4e0a\u4f20svg",
            controlBy: "videoBtnFollow",
            controlValue: !0,
            hide: "mobile",
          },
          videoBtnAlign: {
            type: "select",
            label: "\u89c6\u9891\u64ad\u653e\u6309\u94ae\u4f4d\u7f6e",
            items: O.g,
            hide: "mobile",
          },
          videoBtnText: {
            type: "string",
            content: "text",
            label: "\u89c6\u9891\u64ad\u653e\u6309\u94ae\u6587\u6848",
            controlBy: "videoBtnNeedText",
            controlValue: !0,
            hide: "mobile",
          },
          videoBtnGalabel: {
            type: "string",
            content: "text",
            label: "\u89c6\u9891\u64ad\u653e\u6309\u94aega-label",
            hide: "mobile",
          },
          videoBtnLink: {
            label: "\u64ad\u653e\u6309\u94ae\u89c6\u9891\u5730\u5740",
            type: "string",
            content: "url",
            hide: "mobile",
          },
        };
      function ae(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function re(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? ae(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : ae(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var ie = re(
          re(re(re({}, O.d), O.c), O.e),
          {},
          {
            cardMinHeight: {
              type: "string",
              helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
              label: "\u5361\u7247\u6700\u5c0f\u9ad8\u5ea6",
            },
            horizontalAlign: {
              type: "select",
              label: "\u5361\u7247\u5185\u5bb9\u6c34\u5e73\u5bf9\u9f50",
              items: O.b,
            },
            verticalAlign: {
              type: "select",
              label: "\u5361\u7247\u5185\u5bb9\u5782\u76f4\u5bf9\u9f50",
              items: O.f,
            },
          },
        ),
        le = {
          key: "salePoint",
          name: "salePoint",
          contentSetting: {
            cardList: {
              label: "\u5361\u7247",
              group_type: "array_card",
              group_prop_name: "cardConfigList",
              props: {
                cardBackgroundProps: re({}, k.c),
                cardSetting: {
                  label: "\u5361\u7247\u8bbe\u7f6e",
                  props: re({}, ie),
                },
                elements: {
                  label: "\u5143\u7d20\u8bbe\u7f6e",
                  props: {
                    elementList: {
                      label: "\u5143\u7d20\u5217\u8868",
                      type: "array",
                      controlByPositionTop: !0,
                      props: re({}, ne),
                    },
                  },
                },
                videoModalSetting: {
                  label: "\u89c6\u9891\u5f39\u7a97\u8bbe\u7f6e",
                  props: re({}, oe),
                },
                productBundleSetting: {
                  label: "\u4ea7\u54c1\u5957\u88c5\u5f39\u7a97\u8bbe\u7f6e",
                  props: {
                    hasProductBundleModal: {
                      label:
                        "\u662f\u5426\u652f\u6301\u4ea7\u54c1\u5957\u88c5\u5f39\u7a97",
                      type: "boolean",
                    },
                    productBundleModalid: {
                      label: "\u4ea7\u54c1\u5957\u88c5\u5f39\u7a97id",
                      type: "string",
                      helptext:
                        "\u8bf7\u786e\u4fdd\u586b\u5199\u9700\u5173\u8054\u7ec4\u4ef6\u76845\u4f4d\u6570\u5b57ID\uff0c \uff08\u76ee\u524d\u4ec5\u652f\u6301\u7ed1\u5b9aSalePoint\u7ec4\u4ef6\uff09",
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            typeProps: {
              label: "\u662f\u5426\u5c55\u793a\u4e3a\u5f39\u7a97",
              props: {
                showAsModal: {
                  label:
                    "\u662f\u5426\u5c55\u793a\u4e3a\u5f39\u7a97\u5185\u5bb9",
                  type: "boolean",
                },
                isModalCloseLight: {
                  label:
                    "\u5f39\u7a97\u5173\u95ed\u6309\u94ae\u662f\u5426\u9002\u914d\u6697\u8272\u80cc\u666f",
                  type: "boolean",
                  controlBy: "showAsModal",
                  controlValue: !0,
                },
                modalTopMask: {
                  label: "\u5f39\u7a97\u80cc\u666f\u8272",
                  type: "string",
                  helptext:
                    "\u5f39\u7a97\u80cc\u666f\u8272\u5e94\u4e0e\u7ec4\u4ef6\u80cc\u666f\u8272\u4e00\u81f4\uff0c\u6216\u4e0d\u914d\u7f6e\u7ec4\u4ef6\u80cc\u666f\u8272",
                  controlBy: "showAsModal",
                  controlValue: !0,
                },
              },
            },
            backgroundProps: re({}, k.c),
            paddingProps: {
              label: "\u8fb9\u8ddd\u8bbe\u7f6e",
              props: re({}, O.d),
            },
          },
          layoutSetting: {
            layoutProps: {
              label: "\u5e03\u5c40",
              props: {
                layoutProps: {
                  type: "layout",
                  label: "\u5e03\u5c40\u8bbe\u7f6e",
                },
              },
            },
          },
        },
        se = c.a.createElement,
        ce = {
          "./style.css": {
            "section-sale-point": "style__section-sale-point___2Qhfg",
            "layout-wrapper": "style__layout-wrapper___2uDlY",
            rasterisation: "style__rasterisation____7mzy",
            "card-wrapper": "style__card-wrapper___2eSM6",
            "video-player-button-position":
              "style__video-player-button-position___3tb8Q",
            "card-vertical-center": "style__card-vertical-center___2-S8K",
            "card-vertical-top": "style__card-vertical-top___ix6Qq",
            "card-vertical-bottom": "style__card-vertical-bottom___1QxNM",
            "card-horizontal-center": "style__card-horizontal-center___2jDA1",
            "card-content": "style__card-content___2Xnq1",
            "foreground-pic": "style__foreground-pic___3IOU9",
            "card-horizontal-left": "style__card-horizontal-left___1YUWY",
            "card-horizontal-right": "style__card-horizontal-right___2vqs3",
            "video-player-button-container":
              "style__video-player-button-container___5mhHI",
            "video-btn-text": "style__video-btn-text___1U_rD",
            "salepoint-video-play": "style__salepoint-video-play___RkMLz",
            "video-player-button-center":
              "style__video-player-button-center___1w_w-",
            "video-player-button-left-bottom":
              "style__video-player-button-left-bottom___2qE05",
            "video-player-button-right-bottom":
              "style__video-player-button-right-bottom___fTQ3L",
            "video-player-button-secondary-light":
              "style__video-player-button-secondary-light___2Eotl",
            "video-player-button-secondary-dark":
              "style__video-player-button-secondary-dark___3DBlb",
            "video-player-button-with-text":
              "style__video-player-button-with-text___L2Nvk",
            "divide-line": "style__divide-line___zLRkK",
            "amount-icon": "style__amount-icon___f81AR",
            "card-wrapper-product-bundle":
              "style__card-wrapper-product-bundle___6qMvi",
          },
        };
      function _e(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function ue(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? _e(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : _e(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var de = Object(u.G)(le.layoutSetting),
        pe = function (e, t) {
          var n = Object(p.a)({ mobileMode: !1, mobileHeightChangable: !1 }),
            o = Object(r.a)(n, 1)[0];
          return e === h.c.PX && t ? +t : Math.max(o, f.i);
        },
        fe = function (e) {
          var t = e.layoutColumns,
            n = e.gapWidth,
            a = e.gridWidth,
            r = e.cardConfigList,
            i = e.t,
            l = e.visibleByDefault,
            s = e.unitType,
            c = e.gaSend,
            _ = Array.from({ length: t }, function (e, t) {
              return t;
            });
          return null === _ || void 0 === _
            ? void 0
            : _.map(function (t) {
                var _ =
                    null === e || void 0 === e
                      ? void 0
                      : e["layoutColumnsRatio".concat(t + 1)],
                  u =
                    null === e || void 0 === e
                      ? void 0
                      : e["layoutColumnsCardRelations".concat(t + 1)],
                  d = {
                    width: (function (e, t, n) {
                      return e * ((t - 11 * n) / 12) + (e - 1) * n;
                    })(+_, pe(s, a), +n),
                    marginLeft: 0 !== t ? +n : 0,
                  },
                  p = (function (e, t) {
                    var n,
                      o =
                        null === e || void 0 === e
                          ? void 0
                          : null === (n = e.split(",")) || void 0 === n
                            ? void 0
                            : n.map(function (e) {
                                return e.trim();
                              });
                    return null === t || void 0 === t
                      ? void 0
                      : t.filter(function (e) {
                          return null === o || void 0 === o
                            ? void 0
                            : o.includes(e._cardId.slice(0, 8));
                        });
                  })(u, r);
                return se(
                  "div",
                  { style: ue({}, d), key: t },
                  null === p || void 0 === p
                    ? void 0
                    : p.map(function (e, n) {
                        return se(
                          W,
                          Object(o.a)(
                            {
                              gaSend: c,
                              index: "".concat(t, "-").concat(n),
                              visibleByDefault: l,
                              t: i,
                              key: n,
                            },
                            e,
                          ),
                        );
                      }),
                );
              });
        },
        he = function (e) {
          var t = e.cardConfigList,
            n = e.t,
            a = e.visibleByDefault,
            r = e.gaSend,
            i = e.mobileMode;
          return (null === t || void 0 === t ? void 0 : t.length) > 0
            ? null === t || void 0 === t
              ? void 0
              : t.map(function (e, t) {
                  return se(
                    W,
                    Object(o.a)(
                      {
                        index: t,
                        gaSend: r,
                        visibleByDefault: a,
                        t: n,
                        key: t,
                      },
                      e,
                      { mobileMode: i },
                    ),
                  );
                })
            : null;
        },
        me = function (e) {
          var t,
            n = e.gridWidth,
            o = e.layoutType,
            a = e.cardConfigList,
            r = e.t,
            i = e.visibleByDefault,
            s = e.style,
            c = e.unitType,
            _ = e.gaSend,
            u = e.mobileMode,
            d = ue({ width: u ? "100%" : pe(c, n) }, s);
          switch (o) {
            case h.a.RASTERISATION:
              t = se(fe, e);
              break;
            default:
              t = se(he, {
                gaSend: _,
                cardConfigList: a,
                t: r,
                visibleByDefault: i,
                mobileMode: u,
              });
          }
          var p = o === h.a.RASTERISATION ? "rasterisation " : "";
          return se(
            "div",
            {
              style: d,
              className: l()("layout-wrapper ".concat(p), ce, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            },
            t,
          );
        },
        ye = function (e) {
          var t = e.component_data,
            n = void 0 === t ? {} : t,
            a = e.t,
            r = e.visibleByDefault,
            i = e.gaSend,
            l = e.mobileMode,
            s = e.isEdit;
          de.forEach(function (e) {
            n[e] = "" === n[e] || void 0 === n[e] ? void 0 : +n[e];
          });
          var _ = n.backgroundType,
            u = n.backgroundPrue,
            p = n.backgroundGradient,
            f = n.backgroundVideo,
            h = n.backgroundImage,
            m = n.layoutProps,
            y = n.cardConfigList,
            b = n.showAsModal,
            v = {
              backgroundType: _,
              backgroundPrue: u,
              backgroundGradient: p,
              backgroundVideo: f,
              backgroundImage: h,
            },
            g = !1 === s && void 0 !== b && b;
          return se(
            c.a.Fragment,
            null,
            g
              ? se(
                  U.a,
                  Object(o.a)({ componentName: "salePoint" }, e),
                  se(
                    "section",
                    {
                      className: "style__section-sale-point___2Qhfg",
                      id: "section-sale-point",
                    },
                    se(
                      d.a,
                      v,
                      se(
                        me,
                        Object(o.a)(
                          {
                            gaSend: i,
                            style: ue(ue({}, Object(E.g)(n)), Object(E.e)(l)),
                            visibleByDefault: r,
                            t: a,
                            mobileMode: l,
                          },
                          m,
                          { cardConfigList: y },
                        ),
                      ),
                    ),
                  ),
                )
              : se(
                  "section",
                  {
                    className: "style__section-sale-point___2Qhfg",
                    id: "section-sale-point",
                  },
                  se(
                    d.a,
                    v,
                    se(
                      me,
                      Object(o.a)(
                        {
                          gaSend: i,
                          style: Object(E.g)(n),
                          visibleByDefault: r,
                          t: a,
                          mobileMode: l,
                        },
                        m,
                        { cardConfigList: y },
                      ),
                    ),
                  ),
                ),
          );
        };
      (ye.defaultProps = { component_data: {} }), (ye.propSettings = le);
      t.a = Object(_.a)(ye);
    },
    eaoh: function (e, t) {
      e.exports = function (e) {
        if ("function" != typeof e) throw TypeError(e + " is not a function!");
        return e;
      };
    },
    ebwN: function (e, t, n) {
      var o = n("Cwc5")(n("Kz5y"), "Map");
      e.exports = o;
    },
    ekgI: function (e, t, n) {
      var o = n("YESw"),
        a = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        var t = this.__data__;
        return o ? void 0 !== t[e] : a.call(t, e);
      };
    },
    epst: function (e, t, n) {
      e.exports = {
        "sub-nav-wrap": "style__sub-nav-wrap___37c08",
        "sub-nav-collapsed": "style__sub-nav-collapsed___3gfAG",
        "sub-nav-mask": "style__sub-nav-mask___11WGm",
        "angle-down": "style__angle-down___2-RnT",
        "sub-nav": "style__sub-nav___2cPn2",
        "sub-nav-tab": "style__sub-nav-tab___3qeZX",
        "sub-nav-drop": "style__sub-nav-drop___zg0Kd",
        "sub-nav-content": "style__sub-nav-content___1YXj1",
        "sub-nav-container": "style__sub-nav-container___rNAuB",
        "product-title": "style__product-title___2-wyq",
        "sub-nav-toggle": "style__sub-nav-toggle___Rmz1a",
        "sub-nav-toggle-btn": "style__sub-nav-toggle-btn___mSLdS",
        "sub-nav-right": "style__sub-nav-right___VvG5D",
        "sub-nav-btn": "style__sub-nav-btn___2eOM0",
        "sub-nav-buy-now": "style__sub-nav-buy-now___2U6wS",
      };
    },
    erpB: function (e, t, n) {
      e.exports = {
        banner: "style__banner___3GU3j",
        sticky: "style__sticky___3ThWK",
        "sticky-wrapper": "style__sticky-wrapper___3yU69",
        "frame-wrapper": "style__frame-wrapper___QWr92",
        "title-text": "style__title-text___2BqSS",
        "title-text-content": "style__title-text-content___1OCu_",
        "title-text-mobile-width": "style__title-text-mobile-width___3Zezk",
        "desc-text": "style__desc-text___1yKdX",
        "frame-text-wrapper": "style__frame-text-wrapper___33gS-",
        line: "style__line___1h1bo",
        "line-text-box": "style__line-text-box___2lKKl",
        "line-text-box-mobile": "style__line-text-box-mobile___1cvEN",
        "line-text-title": "style__line-text-title___3heSp",
        "line-text-title-mobile": "style__line-text-title-mobile___3l73K",
        "line-text-desc": "style__line-text-desc___10dbc",
        "line-text-desc-mobile": "style__line-text-desc-mobile___1xQzQ",
      };
    },
    "f/k9": function (e, t, n) {
      "use strict";
      var o = n("Qetd"),
        a = n("q1tI");
      t.useSubscription = function (e) {
        var t = e.getCurrentValue,
          n = e.subscribe,
          r = a.useState(function () {
            return { getCurrentValue: t, subscribe: n, value: t() };
          });
        e = r[0];
        var i = r[1];
        return (
          (r = e.value),
          (e.getCurrentValue === t && e.subscribe === n) ||
            ((r = t()), i({ getCurrentValue: t, subscribe: n, value: r })),
          a.useDebugValue(r),
          a.useEffect(
            function () {
              function e() {
                if (!a) {
                  var e = t();
                  i(function (a) {
                    return a.getCurrentValue !== t ||
                      a.subscribe !== n ||
                      a.value === e
                      ? a
                      : o({}, a, { value: e });
                  });
                }
              }
              var a = !1,
                r = n(e);
              return (
                e(),
                function () {
                  (a = !0), r();
                }
              );
            },
            [t, n],
          ),
          r
        );
      };
    },
    fGT3: function (e, t, n) {
      var o = n("4kuk"),
        a = n("Xi7e"),
        r = n("ebwN");
      e.exports = function () {
        (this.size = 0),
          (this.__data__ = {
            hash: new o(),
            map: new (r || a)(),
            string: new o(),
          });
      };
    },
    fNZA: function (e, t, n) {
      var o = n("QMMT"),
        a = n("UWiX")("iterator"),
        r = n("SBuE");
      e.exports = n("WEpk").getIteratorMethod = function (e) {
        if (void 0 != e) return e[a] || e["@@iterator"] || r[o(e)];
      };
    },
    "fR/l": function (e, t, n) {
      var o = n("CH3K"),
        a = n("Z0cm");
      e.exports = function (e, t, n) {
        var r = t(e);
        return a(e) ? r : o(r, n(e));
      };
    },
    fhzG: function (e, t, n) {
      "use strict";
      var o = n("q1tI"),
        a = n("lT4e");
      if ("undefined" === typeof o)
        throw Error(
          "create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.",
        );
      var r = new o.Component().updater;
      e.exports = a(o.Component, o.isValidElement, r);
    },
    fi7q: function (e, t, n) {
      "use strict";
      t.a = {
        label: "\u54cd\u5e94\u8282\u70b9",
        type: "select",
        items: [
          {
            label:
              "\u9ed8\u8ba4(\u5f53\u5c4f\u5e55\u5bbd\u5ea6<1440\u65f6\u9002\u7528\u5c0f\u5c4f\u5bbd\u5ea6)",
            value: "1440",
          },
          {
            label:
              "\u5f53\u5c4f\u5e55\u5bbd\u5ea6<1600\u65f6\u9002\u7528\u5c0f\u5c4f\u5bbd\u5ea6",
            value: "1600",
          },
        ],
      };
    },
    fl7H: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t, "array") && !e.required) return n();
          r.default.required(e, t, o, l, a, "array"),
            (0, i.isEmptyValue)(t, "array") ||
              (r.default.type(e, t, o, l, a), r.default.range(e, t, o, l, a));
        }
        n(l);
      };
    },
    fmRc: function (e, t, n) {
      var o = n("Xi7e"),
        a = n("77Zs"),
        r = n("L8xA"),
        i = n("gCq4"),
        l = n("VaNO"),
        s = n("0Cz8");
      function c(e) {
        var t = (this.__data__ = new o(e));
        this.size = t.size;
      }
      (c.prototype.clear = a),
        (c.prototype.delete = r),
        (c.prototype.get = i),
        (c.prototype.has = l),
        (c.prototype.set = s),
        (e.exports = c);
    },
    fpC5: function (e, t, n) {
      var o = n("2faE"),
        a = n("5K7Z"),
        r = n("w6GO");
      e.exports = n("jmDH")
        ? Object.defineProperties
        : function (e, t) {
            a(e);
            for (var n, i = r(t), l = i.length, s = 0; l > s; )
              o.f(e, (n = i[s++]), t[n]);
            return e;
          };
    },
    frqK: function (e, t, n) {
      "use strict";
      n.d(t, "f", function () {
        return o;
      }),
        n.d(t, "k", function () {
          return a;
        }),
        n.d(t, "g", function () {
          return r;
        }),
        n.d(t, "v", function () {
          return i;
        }),
        n.d(t, "l", function () {
          return l;
        }),
        n.d(t, "d", function () {
          return s;
        }),
        n.d(t, "e", function () {
          return c;
        }),
        n.d(t, "w", function () {
          return _;
        }),
        n.d(t, "m", function () {
          return u;
        }),
        n.d(t, "u", function () {
          return d;
        }),
        n.d(t, "t", function () {
          return p;
        }),
        n.d(t, "o", function () {
          return f;
        }),
        n.d(t, "q", function () {
          return h;
        }),
        n.d(t, "p", function () {
          return m;
        }),
        n.d(t, "s", function () {
          return y;
        }),
        n.d(t, "r", function () {
          return b;
        }),
        n.d(t, "n", function () {
          return v;
        }),
        n.d(t, "j", function () {
          return g;
        }),
        n.d(t, "x", function () {
          return w;
        }),
        n.d(t, "i", function () {
          return x;
        }),
        n.d(t, "c", function () {
          return k;
        }),
        n.d(t, "b", function () {
          return O;
        }),
        n.d(t, "a", function () {
          return I;
        }),
        n.d(t, "h", function () {
          return S;
        });
      var o = (function (e) {
          return (
            (e["internal-link"] = "internal-link"),
            (e["external-link"] = "external-link"),
            (e["download-link"] = "download-link"),
            (e["no-icon-link"] = "no-icon-link"),
            e
          );
        })({}),
        a = (function (e) {
          return (
            (e.h1 = "h1"),
            (e.h2 = "h2"),
            (e.h3 = "h3"),
            (e.h4 = "h4"),
            (e.p = "p"),
            e
          );
        })({}),
        r = (function (e) {
          return (
            (e.xxxxxl = "xxxxxl"),
            (e.xxxxl = "xxxxl"),
            (e.xxxl = "xxxl"),
            (e.xxl = "xxl"),
            (e.xl = "xl"),
            (e.l = "l"),
            (e.m = "m"),
            (e.s = "s"),
            (e.xs = "xs"),
            (e.xxs = "xxs"),
            e
          );
        })({}),
        i = (function (e) {
          return (
            (e["top-align"] = "top-align"),
            (e["center-align"] = "center-align"),
            (e["bottom-align"] = "bottom-align"),
            e
          );
        })({}),
        l = (function (e) {
          return (
            (e["left-align"] = "left-align"),
            (e["center-align"] = "center-align"),
            (e["right-align"] = "right-align"),
            e
          );
        })({}),
        s = (function (e) {
          return (
            (e["media-text"] = "media-text"),
            (e["text-media"] = "text-media"),
            e
          );
        })({}),
        c = (function (e) {
          return (e.picture = "picture"), (e.video = "video"), e;
        })({}),
        _ = (function (e) {
          return (
            (e.loop = "loop"),
            (e.once = "once"),
            (e.replayWhenRevisible = "replayWhenRevisible"),
            (e.withController = "withController"),
            e
          );
        })({}),
        u = (function (e) {
          return (e.vertical = "vertical"), (e.horizontal = "horizontal"), e;
        })({}),
        d = (function (e) {
          return (
            (e.svg = "svg"),
            (e["pure-text"] = "pure-text"),
            (e["gradient-text"] = "gradient-text"),
            e
          );
        })({}),
        p = (function (e) {
          return (e.black = "black"), (e.white = "white"), e;
        })({}),
        f = (function (e) {
          return (
            (e.black = "black"),
            (e.white = "white"),
            (e.dark = "dark"),
            (e.normal = "normal"),
            e
          );
        })({}),
        h = (function (e) {
          return (
            (e.button = "button"),
            (e["external-button"] = "external-button"),
            (e["store-button"] = "store-button"),
            (e["video-play"] = "video-play"),
            (e.salesPointPop = "salesPointPop"),
            e
          );
        })({}),
        m = (function (e) {
          return (
            (e.dark = "dark"), (e.light = "light"), (e.primary = "primary"), e
          );
        })({}),
        y = (function (e) {
          return (
            (e.button = "button"),
            (e["external-button"] = "external-button"),
            (e["video-play"] = "video-play"),
            (e["internal-link"] = "internal-link"),
            (e["external-link"] = "external-link"),
            (e["store-button"] = "store-button"),
            (e["download-link"] = "download-link"),
            (e["no-icon-link"] = "no-icon-link"),
            (e["3Dtype"] = "3Dtype"),
            (e.ARtype = "ARtype"),
            (e["zoom-button"] = "zoom-button"),
            (e.salesPointPop = "salesPointPop"),
            e
          );
        })({}),
        b = (function (e) {
          return (
            (e["secondary-dark"] = "secondary-dark"),
            (e["secondary-light"] = "secondary-light"),
            e
          );
        })({}),
        v = (function (e) {
          return (e.internal = "internal"), (e.external = "external"), e;
        })({}),
        g = (function (e) {
          return (
            (e["whole-item"] = "whole-item"),
            (e["inner-content"] = "inner-content"),
            e
          );
        })({}),
        w = (function (e) {
          return (e.light = "light"), (e.dark = "dark"), e;
        })({}),
        x = (function (e) {
          return (
            (e.one = "one"),
            (e.leftRight = "leftRight"),
            (e.upDown = "upDown"),
            (e.up1down2 = "up1down2"),
            (e.up2down1 = "up2down1"),
            (e.left2right1 = "left2right1"),
            e
          );
        })({}),
        k = (function (e) {
          return (
            (e["auto-fit"] = "auto-fit"), (e["custom-css"] = "custom-css"), e
          );
        })({}),
        O = (function (e) {
          return (
            (e.repeat = "repeat"),
            (e["repeat-x"] = "repeat-x"),
            (e["repeat-y"] = "repeat-y"),
            (e["no-repeat"] = "no-repeat"),
            e
          );
        })({}),
        I = (function (e) {
          return (e.fix = "fix"), (e.normal = "normal"), e;
        })({}),
        S = (function (e) {
          return (
            (e.dark = "dark"),
            (e.primary = "primary"),
            (e["secondary-light"] = "secondary-light"),
            e
          );
        })({});
    },
    fzFG: function (e, t, n) {
      e.exports = {
        "comparison-section": "style__comparison-section___2GIwn",
        "is-dark-theme": "style__is-dark-theme___3Xzn5",
        "need-line": "style__need-line___2Cpjm",
        "spec-item": "style__spec-item___1Nq2Y",
        "spec-desc": "style__spec-desc___3mAsK",
        "button-box": "style__button-box___2CIuc",
        "product-origin": "style__product-origin___2coco",
        "basic-info": "style__basic-info___3W7TH",
        "product-price": "style__product-price___EwZYs",
        "off-sale": "style__off-sale___3-zE2",
        container: "style__container___1VJiz",
        headline: "style__headline___Oq3it",
        "product-list": "style__product-list___3x48T",
        "product-item": "style__product-item___3L2Dr",
        "product-cover": "style__product-cover___WX2rj",
        eyebrow: "style__eyebrow___2AP0X",
        label: "style__label___2zk9X",
        "product-name": "style__product-name___1eaZ9",
        "product-desc": "style__product-desc___1zZUD",
        origin: "style__origin___1CM0q",
        "product-buy-now": "style__product-buy-now___1BLI4",
        "product-buy-now-btn": "style__product-buy-now-btn___24LU_",
        "product-learn-more": "style__product-learn-more___3CwJ9",
        "basic-info-bottom": "style__basic-info-bottom___2aYP7",
        "spec-title": "style__spec-title___IHKiC",
        "spec-icon": "style__spec-icon___3Dy50",
        "spec-name": "style__spec-name___2Z4yV",
        "comparison-btn": "style__comparison-btn___nl4mL",
        "buy-btn": "style__buy-btn___1LotJ",
      };
    },
    g0Ox: function (e, t, n) {
      "use strict";
      var o = n("Jq2x"),
        a = n("cKS0");
      function r() {
        return (r =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      var i = {
        toggleEl: function (e, t) {
          e[t ? "addClass" : "removeClass"](
            this.params.navigation.disabledClass,
          ),
            e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = t);
        },
        update: function () {
          var e = this.params.navigation,
            t = this.navigation.toggleEl;
          if (!this.params.loop) {
            var n = this.navigation,
              o = n.$nextEl,
              a = n.$prevEl;
            a &&
              a.length > 0 &&
              (this.isBeginning ? t(a, !0) : t(a, !1),
              this.params.watchOverflow &&
                this.enabled &&
                a[this.isLocked ? "addClass" : "removeClass"](e.lockClass)),
              o &&
                o.length > 0 &&
                (this.isEnd ? t(o, !0) : t(o, !1),
                this.params.watchOverflow &&
                  this.enabled &&
                  o[this.isLocked ? "addClass" : "removeClass"](e.lockClass));
          }
        },
        onPrevClick: function (e) {
          e.preventDefault(),
            (this.isBeginning && !this.params.loop) || this.slidePrev();
        },
        onNextClick: function (e) {
          e.preventDefault(),
            (this.isEnd && !this.params.loop) || this.slideNext();
        },
        init: function () {
          var e,
            t,
            n = this.params.navigation;
          ((this.params.navigation = Object(a.c)(
            this.$el,
            this.params.navigation,
            this.params.createElements,
            { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" },
          )),
          n.nextEl || n.prevEl) &&
            (n.nextEl &&
              ((e = Object(o.a)(n.nextEl)),
              this.params.uniqueNavElements &&
                "string" === typeof n.nextEl &&
                e.length > 1 &&
                1 === this.$el.find(n.nextEl).length &&
                (e = this.$el.find(n.nextEl))),
            n.prevEl &&
              ((t = Object(o.a)(n.prevEl)),
              this.params.uniqueNavElements &&
                "string" === typeof n.prevEl &&
                t.length > 1 &&
                1 === this.$el.find(n.prevEl).length &&
                (t = this.$el.find(n.prevEl))),
            e && e.length > 0 && e.on("click", this.navigation.onNextClick),
            t && t.length > 0 && t.on("click", this.navigation.onPrevClick),
            Object(a.e)(this.navigation, {
              $nextEl: e,
              nextEl: e && e[0],
              $prevEl: t,
              prevEl: t && t[0],
            }),
            this.enabled ||
              (e && e.addClass(n.lockClass), t && t.addClass(n.lockClass)));
        },
        destroy: function () {
          var e = this.navigation,
            t = e.$nextEl,
            n = e.$prevEl;
          t &&
            t.length &&
            (t.off("click", this.navigation.onNextClick),
            t.removeClass(this.params.navigation.disabledClass)),
            n &&
              n.length &&
              (n.off("click", this.navigation.onPrevClick),
              n.removeClass(this.params.navigation.disabledClass));
        },
      };
      t.a = {
        name: "navigation",
        params: {
          navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
          },
        },
        create: function () {
          Object(a.a)(this, { navigation: r({}, i) });
        },
        on: {
          init: function (e) {
            e.navigation.init(), e.navigation.update();
          },
          toEdge: function (e) {
            e.navigation.update();
          },
          fromEdge: function (e) {
            e.navigation.update();
          },
          destroy: function (e) {
            e.navigation.destroy();
          },
          "enable disable": function (e) {
            var t = e.navigation,
              n = t.$nextEl,
              o = t.$prevEl;
            n &&
              n[e.enabled ? "removeClass" : "addClass"](
                e.params.navigation.lockClass,
              ),
              o &&
                o[e.enabled ? "removeClass" : "addClass"](
                  e.params.navigation.lockClass,
                );
          },
          click: function (e, t) {
            var n = e.navigation,
              a = n.$nextEl,
              r = n.$prevEl,
              i = t.target;
            if (
              e.params.navigation.hideOnClick &&
              !Object(o.a)(i).is(r) &&
              !Object(o.a)(i).is(a)
            ) {
              if (
                e.pagination &&
                e.params.pagination &&
                e.params.pagination.clickable &&
                (e.pagination.el === i || e.pagination.el.contains(i))
              )
                return;
              var l;
              a
                ? (l = a.hasClass(e.params.navigation.hiddenClass))
                : r && (l = r.hasClass(e.params.navigation.hiddenClass)),
                !0 === l ? e.emit("navigationShow") : e.emit("navigationHide"),
                a && a.toggleClass(e.params.navigation.hiddenClass),
                r && r.toggleClass(e.params.navigation.hiddenClass);
            }
          },
        },
      };
    },
    gCq4: function (e, t) {
      e.exports = function (e) {
        return this.__data__.get(e);
      };
    },
    gFfm: function (e, t) {
      e.exports = function (e, t) {
        for (
          var n = -1, o = null == e ? 0 : e.length;
          ++n < o && !1 !== t(e[n], n, e);

        );
        return e;
      };
    },
    gUhf: function (e, t, n) {
      e.exports = {
        "modal-content-a": "content__modal-content-a___sV8Tx",
        "content-a-hr": "content__content-a-hr___1h394",
        "content-a-item": "content__content-a-item___1v0vA",
        "content-a-item-scene": "content__content-a-item-scene___lcDpL",
        "content-a-item-img": "content__content-a-item-img___2gMoH",
        "content-a-item-text": "content__content-a-item-text___2rOFe",
        video: "content__video___3iIO3",
        "video-buttom": "content__video-buttom___3zx2r",
        "replay-buttom": "content__replay-buttom___Rg4FG",
        "play-buttom": "content__play-buttom___1SrVY",
        "pause-buttom": "content__pause-buttom___3MrRD",
        "loading-buttom": "content__loading-buttom___1kuac",
        "downgrade-video": "content__downgrade-video___AsXka",
        "downgrade-play-btn": "content__downgrade-play-btn___1C8hC",
        "downgrade-pic": "content__downgrade-pic___37etP",
        "modal-content-a-mobile": "content__modal-content-a-mobile___HCDAw",
        "content-d-hr": "content__content-d-hr___3UJbe",
        "modal-content-b": "content__modal-content-b___1PJ2u",
        "content-b-scene": "content__content-b-scene___2gxbn",
        "content-b-img": "content__content-b-img___3BG8D",
        "content-b-item-video": "content__content-b-item-video___1uVAe",
        "content-b-item-text": "content__content-b-item-text___1xSJh",
        "content-b-hr": "content__content-b-hr___2D5Bj",
        "content-b-text": "content__content-b-text___1dLXo",
        "modal-content-b-mobile": "content__modal-content-b-mobile___12biZ",
        "modal-content-c": "content__modal-content-c___1WZAL",
        "content-c-scene": "content__content-c-scene___24dWD",
        "content-c-avatar": "content__content-c-avatar___Hch-G",
        "content-c-desc": "content__content-c-desc___1RbSC",
        "content-c-text": "content__content-c-text___1cV7c",
        "content-c-text-img": "content__content-c-text-img___sOk98",
        "content-c-text-desc": "content__content-c-text-desc___27Wao",
        "modal-content-c-mobile": "content__modal-content-c-mobile___1r-Fl",
        "content-d-item-text": "content__content-d-item-text___1IE6e",
        "content-d-item-text1": "content__content-d-item-text1___2_Kbi",
        "content-d-item-scene": "content__content-d-item-scene___2iBIx",
        "video-box-pop": "content__video-box-pop___zZz2b",
        "video-item": "content__video-item___3msSe",
        "video-button": "content__video-button___2EnF9",
        "video-box-pop-m": "content__video-box-pop-m___SL6nf",
        icon: "content__icon___2sOK-",
        "watch-video-icon": "content__watch-video-icon___1IQxS",
        "modal-content-e": "content__modal-content-e___2Mi6b",
        "content-e-scene": "content__content-e-scene___3U1la",
        "content-e-top-bg": "content__content-e-top-bg___3TnZr",
        "content-e-desc": "content__content-e-desc___k8WET",
        "content-e-section": "content__content-e-section___2GT7H",
        "content-e-section-1": "content__content-e-section-1___2xmvg",
        "content-e-features": "content__content-e-features___1kuYS",
        "content-e-feature": "content__content-e-feature___1PHJo",
        "content-e-icon": "content__content-e-icon___E0z_T",
        "content-e-section-2": "content__content-e-section-2___2U5WZ",
        "content-e-bg-1": "content__content-e-bg-1___1MHuJ",
        "content-e-bg-2": "content__content-e-bg-2___3gFhr",
        "content-e-section-3": "content__content-e-section-3___HAzzR",
        "content-e-cards": "content__content-e-cards___1cIdi",
        "content-e-card": "content__content-e-card___A_uPM",
        "content-e-section-4": "content__content-e-section-4___q1ANH",
        "modal-content-e-mobile": "content__modal-content-e-mobile___3sg9D",
        "modal-content-f": "content__modal-content-f___uOJ6S",
        "content-f-scene": "content__content-f-scene___IRexU",
        "content-f-top-bg": "content__content-f-top-bg___20WGC",
        "content-f-cards": "content__content-f-cards___3Lybz",
        "content-f-card": "content__content-f-card___EzJ4_",
        "content-f-card-title": "content__content-f-card-title___2mybz",
        "content-f-card-desc": "content__content-f-card-desc___19iIH",
        "modal-content-f-mobile": "content__modal-content-f-mobile___3dN1f",
      };
    },
    gb4I: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("iKuz"),
        u = n.n(_),
        d = n("q1tI"),
        p = n.n(d),
        f = n("XnI8"),
        h = n("TSYQ"),
        m = n.n(h),
        y = n("Enrl"),
        b = n("Sggk"),
        v = n("8tV9"),
        g = n("SBOM"),
        w = n("hKI/"),
        x = n.n(w),
        k = (n("8vI9"), n("yWgo")),
        O = n("/+VL"),
        I = p.a.createElement,
        S = {
          "./style.css": {
            "text-scroll-switch-video-component":
              "style__text-scroll-switch-video-component___1qCwg",
            sticky: "style__sticky___B3dWo",
            "adaptive-section": "style__adaptive-section___zZUEw",
            "adaptive-wrap": "style__adaptive-wrap___3IRWH",
            "adaptive-item": "style__adaptive-item___2I8F0",
            "sticky-dom-left": "style__sticky-dom-left___2x4BJ",
            "video-box": "style__video-box___2DM0L",
            "bg-box": "style__bg-box___2MB-L",
            "bg-style": "style__bg-style___3FRZX",
            "scroll-panel": "style__scroll-panel___3ypWy",
            "scroll-content": "style__scroll-content___2h3Mk",
            textRight: "style__textRight___bpCQ4",
            "will-change": "style__will-change___3CSVI",
            text: "style__text___1Ta0B",
            "item-title": "style__item-title___1EJem",
            "item-desc": "style__item-desc___3asy3",
            "downgrade-section": "style__downgrade-section___bXiaR",
            "downgrade-adaptive-item": "style__downgrade-adaptive-item___3gs5O",
            "downgrade-video-box": "style__downgrade-video-box___28aCq",
            "downgrade-text": "style__downgrade-text___1l6kj",
            "downgrade-img": "style__downgrade-img___1OrYA",
            active: "style__active___2ra-v",
            "wm330-sticky-hack-scroll":
              "style__wm330-sticky-hack-scroll___3jGQq",
          },
        };
      function j(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var T = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = j(this, t, [e])).state = {
              isIE: !1,
              windowHeight: window.innerHeight,
            }),
            (n.scrollText = []),
            (n.scrollTextInView = []),
            (n.stickyDom = []),
            (n.video = []),
            (n.listenersToRemove = []),
            (n.handleScroll = n.handleScroll.bind(Object(l.a)(n))),
            (n.removeClass = n.removeClass.bind(Object(l.a)(n))),
            (n.switchVideo = n.switchVideo.bind(Object(l.a)(n))),
            (n.changeImage = x()(n.changeImage.bind(Object(l.a)(n)), 500)),
            (n.setWindowHeight = x()(
              n.setWindowHeight.bind(Object(l.a)(n)),
              500,
            )),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this,
                  t = document.querySelector("body");
                t.classList.contains("wm330-sticky-hack-scroll") ||
                  t.classList.add("wm330-sticky-hack-scroll"),
                  O.a.getInstance().addNode(
                    this.section,
                    {
                      scrollIntoView: function () {
                        e.inView = !0;
                      },
                      scrollOutOfWiew: function () {
                        e.inView = !1;
                      },
                    },
                    void 0,
                    500,
                  ),
                  O.a
                    .getInstance()
                    .getDimension()
                    .addDimensionListener(
                      "textScrollSwitch".concat(this.props.id),
                      {
                        onScroll: function () {
                          e.inView &&
                            (e.sectionHeight ||
                              ((e.sectionHeight =
                                e.section && e.section.clientHeight),
                              (e.sectioinBottom =
                                e.section.offsetTop + e.sectionHeight)),
                            e.handleScroll());
                        },
                      },
                    ),
                  window.addEventListener("resize", this.setWindowHeight);
              },
            },
            {
              key: "componentWillUnmount",
              value: function () {
                this.listenersToRemove.forEach(function (e) {
                  "function" === typeof e && e();
                }),
                  window.removeEventListener("resize", this.setWindowHeight);
              },
            },
            {
              key: "setWindowHeight",
              value: function () {
                this.setState({ windowHeight: window.innerHeight });
              },
            },
            {
              key: "handleScroll",
              value: function () {
                if (this.section) {
                  var e = this.sectioinBottom,
                    t = this.state.windowHeight;
                  if (!this.props.component_data.scrollRange) {
                    var n =
                        Math.max(
                          document.documentElement.scrollTop,
                          document.body.scrollTop,
                        ) + t,
                      o = this.stickyDom.length - 1;
                    if (e < n) {
                      var a =
                        this.video[o] &&
                        this.video[o].player &&
                        this.video[o].player.player &&
                        this.video[o].player.player.videoDom;
                      e + t < n
                        ? a && a.duration && !a.paused && Object(k.jb)(a)
                        : a && a.paused && a.play();
                    } else this.switchVideo();
                  }
                }
              },
            },
            {
              key: "switchVideo",
              value: function () {
                for (
                  var e = this,
                    t = function (t) {
                      var n = e.scrollText[t];
                      void 0 === e.scrollTextInView[t] &&
                        ((e.scrollTextInView[t] = !1),
                        O.a.getInstance().addNode(
                          n,
                          {
                            scrollIntoView: function () {
                              (e.sectionHeight = e.section.clientHeight),
                                (e.sectioinBottom =
                                  e.section.offsetTop + e.sectionHeight),
                                (e.scrollTextInView[t] = !0);
                              var n =
                                e.video[t] &&
                                e.video[t].player &&
                                e.video[t].player.player &&
                                e.video[t].player.player.videoDom;
                              if (n) {
                                e.stickyDom[t].classList.add("active"),
                                  e.removeClass(t),
                                  Object(k.jb)(n),
                                  (n.currentTime = 0);
                                var o =
                                    e.video[t].player.player.videoDom.duration,
                                  a = e.video[t].player.player.videoDom.paused;
                                o && a && n.play();
                              } else
                                e.removeClass(t),
                                  e.stickyDom[t].classList.add("active");
                            },
                            scrollOutOfWiew: function () {
                              (e.sectionHeight = e.section.clientHeight),
                                (e.sectioinBottom =
                                  e.section.offsetTop + e.sectionHeight),
                                (e.scrollTextInView[t] = !1);
                            },
                          },
                          void 0,
                          0,
                        ));
                    },
                    n = 0;
                  n < this.scrollText.length;
                  n++
                )
                  t(n);
              },
            },
            {
              key: "removeClass",
              value: function (e) {
                for (var t = 0; t < this.stickyDom.length; t++)
                  if (this.stickyDom[t] && t !== e) {
                    this.stickyDom[t].classList.remove("active");
                    var n =
                      this.video[t] &&
                      this.video[t].player &&
                      this.video[t].player.player &&
                      this.video[t].player.player.videoDom;
                    n && n.duration && !n.paused && Object(k.jb)(n);
                  }
              },
            },
            {
              key: "changeImage",
              value: function (e) {
                if (this.templeIndex !== e) {
                  this.templeIndex = e;
                  var t =
                    this.video[e] &&
                    this.video[e].player &&
                    this.video[e].player.player &&
                    this.video[e].player.player.videoDom;
                  if (t) {
                    Object(k.jb)(t), (t.currentTime = 0);
                    var n = this.video[e].player.player.videoDom.duration,
                      o = this.video[e].player.player.videoDom.paused;
                    t &&
                      n &&
                      o &&
                      this.stickyDom[e] &&
                      (this.removeClass(e),
                      this.stickyDom[e].classList.add("active"),
                      t.play());
                  } else
                    this.removeClass(e),
                      this.stickyDom[e].classList.add("active");
                }
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.t,
                  o = t.component_data,
                  a = t.id,
                  r = o.scrollRange,
                  i = this.state,
                  l = i.isIE,
                  s = i.windowHeight,
                  c = o.featureList ? o.featureList.length : 0,
                  _ = Math.min(800, s / 2),
                  d = Math.max(
                    _,
                    r
                      ? "vh" === r.substr(-2, 2)
                        ? (s * r.substr(0, r.length - 2)) / 100
                        : r.substr(0, r.length - 2)
                      : s,
                  ),
                  p =
                    o && Array.isArray(o.featureList)
                      ? o.featureList.map(function (t, n) {
                          return t.hasVideo
                            ? I(
                                "div",
                                {
                                  key: "adaptive-video".concat(n),
                                  ref: function (t) {
                                    e.stickyDom[n] = t;
                                  },
                                  style: { width: o.contentWidth },
                                  className:
                                    (0 === n
                                      ? (0 === n ? "active" : "") + " "
                                      : "") +
                                    u()(
                                      m()("adaptive-item", {
                                        "sticky-dom-left":
                                          "leftPictureRightText" === o.layout,
                                      }),
                                      S,
                                      {
                                        autoResolveMultipleImports: !0,
                                        handleMissingStyleName: "warn",
                                      },
                                    ),
                                },
                                I(
                                  "div",
                                  {
                                    className: "style__video-box___2DM0L",
                                    style: {
                                      width: o.stickyDomWidth
                                        ? o.stickyDomWidth
                                        : "592px",
                                      height: o.stickyDomHeight
                                        ? o.stickyDomHeight
                                        : "592px",
                                    },
                                  },
                                  I(y.a, {
                                    url: [
                                      t.videoLinkWebm && t.videoLinkWebm.path,
                                      t.videoLink && t.videoLink.path,
                                    ],
                                    poster: t.videoPoster,
                                    lazyload: !0,
                                    visibleplay: !0,
                                    ref: function (t) {
                                      e.video[n] = t;
                                    },
                                    replayWhenRevisible: !(
                                      0 !== n && n !== e.video.length - 1
                                    ),
                                    style: {
                                      width: o.stickyDomWidth
                                        ? o.stickyDomWidth
                                        : "592px",
                                      height: o.stickyDomHeight
                                        ? o.stickyDomHeight
                                        : "592px",
                                    },
                                  }),
                                ),
                              )
                            : I(
                                "div",
                                {
                                  key: "adaptive-img".concat(n),
                                  ref: function (t) {
                                    e.stickyDom[n] = t;
                                  },
                                  style: { width: o.contentWidth },
                                  className:
                                    (0 === n
                                      ? (0 === n ? "active" : "") + " "
                                      : "") +
                                    u()(
                                      m()("adaptive-item", {
                                        "sticky-dom-left":
                                          "leftPictureRightText" === o.layout,
                                      }),
                                      S,
                                      {
                                        autoResolveMultipleImports: !0,
                                        handleMissingStyleName: "warn",
                                      },
                                    ),
                                },
                                I(g.a, {
                                  threshold: 1500,
                                  className:
                                    "style__bg-box___2MB-L style__bg-style___3FRZX",
                                  style: {
                                    width: o.stickyDomWidth
                                      ? o.stickyDomWidth
                                      : "592px",
                                    height: o.stickyDomHeight
                                      ? o.stickyDomHeight
                                      : "592px",
                                  },
                                  type: "bg",
                                  tagType: "div",
                                  src: t.image,
                                }),
                              );
                        })
                      : null,
                  f = function (e, t) {
                    return e <= 0.3
                      ? 0 === t
                        ? 1
                        : e / 0.5
                      : e > 0.3 && e <= 0.7
                        ? 1
                        : e > 0.7
                          ? t === c - 1
                            ? 1
                            : (1 - e) / 0.5
                          : 0;
                  },
                  h =
                    o && Array.isArray(o.featureList)
                      ? o.featureList.map(function (t, i) {
                          return I(
                            b.a,
                            null,
                            I(
                              b.b,
                              {
                                duration: d,
                                triggerElement: "#scroll-text"
                                  .concat(i)
                                  .concat(a),
                                lazyUpdate: !0,
                                lazyUpdateIntersection: !0,
                              },
                              function (l) {
                                return (
                                  r && l > 0 && e.changeImage(i),
                                  I(
                                    v.b,
                                    {
                                      duration: 0,
                                      ease: "none",
                                      to: { opacity: r ? f(l, i) : 1 },
                                    },
                                    I(
                                      "div",
                                      {
                                        id: "scroll-text".concat(i).concat(a),
                                        key: "scroll-text".concat(i),
                                        style: {
                                          width: o.contentWidth,
                                          height: r ? "".concat(d, "px") : "",
                                          marginTop:
                                            r && 0 === i ? (s - d) / 2 : "",
                                          marginBottom:
                                            r && i === c - 1 ? (s - d) / 2 : "",
                                        },
                                        className: u()(
                                          m()("scroll-content", {
                                            textRight:
                                              "leftPictureRightText" ===
                                              o.layout,
                                          }),
                                          S,
                                          {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          },
                                        ),
                                      },
                                      I(
                                        "div",
                                        {
                                          className: "style__text___1Ta0B",
                                          ref: function (t) {
                                            e.scrollText[i] = t;
                                          },
                                          style: {
                                            width: o.textWidth
                                              ? "".concat(o.textWidth)
                                              : "592px",
                                          },
                                        },
                                        I("h3", {
                                          className:
                                            "style__item-title___1EJem",
                                          dangerouslySetInnerHTML: {
                                            __html: n(t.title),
                                          },
                                          style: {
                                            fontSize: o.headlineFontSize || "",
                                            lineHeight:
                                              o.headlineLineHeight || "",
                                          },
                                        }),
                                        I("p", {
                                          className: "style__item-desc___3asy3",
                                          dangerouslySetInnerHTML: {
                                            __html: n(t.desc),
                                          },
                                          style: {
                                            fontSize: o.descFontSize || "",
                                            lineHeight: o.descLineHeight || "",
                                          },
                                        }),
                                      ),
                                    ),
                                  )
                                );
                              },
                            ),
                          );
                        })
                      : null,
                  w =
                    o && Array.isArray(o.featureList)
                      ? o.featureList.map(function (e, t) {
                          var a =
                              "leftPictureRightText" === o.layout
                                ? I(
                                    "div",
                                    {
                                      key: "downgrade-adaptive-video".concat(t),
                                      className:
                                        "style__downgrade-adaptive-item___3gs5O",
                                      style: { width: o.contentWidth },
                                    },
                                    I(
                                      "div",
                                      {
                                        className:
                                          "style__downgrade-video-box___28aCq",
                                        style: {
                                          width: o.stickyDomWidth
                                            ? o.stickyDomWidth
                                            : "592px",
                                          height: o.stickyDomHeight
                                            ? o.stickyDomHeight
                                            : "592px",
                                        },
                                      },
                                      I(y.a, {
                                        visibleplay: !0,
                                        lazyload: !0,
                                        replayWhenRevisible: !0,
                                        poster: e.videoPoster,
                                        url: [e.videoLink && e.videoLink.path],
                                      }),
                                    ),
                                    I(
                                      "div",
                                      {
                                        className:
                                          "style__downgrade-text___1l6kj",
                                        style: {
                                          width: o.textWidth
                                            ? "".concat(o.textWidth)
                                            : "592px",
                                        },
                                      },
                                      I("h3", {
                                        className: "style__item-title___1EJem",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.title),
                                        },
                                      }),
                                      I("p", {
                                        className: "style__item-desc___3asy3",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.desc),
                                        },
                                      }),
                                    ),
                                  )
                                : I(
                                    "div",
                                    {
                                      key: "downgrade-adaptive-video".concat(t),
                                      className:
                                        "style__downgrade-adaptive-item___3gs5O",
                                      style: { width: o.contentWidth },
                                    },
                                    I(
                                      "div",
                                      {
                                        className:
                                          "style__downgrade-text___1l6kj",
                                        style: {
                                          width: o.textWidth
                                            ? "".concat(o.textWidth)
                                            : "592px",
                                        },
                                      },
                                      I("h3", {
                                        className: "style__item-title___1EJem",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.title),
                                        },
                                      }),
                                      I("p", {
                                        className: "style__item-desc___3asy3",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.desc),
                                        },
                                      }),
                                    ),
                                    I(
                                      "div",
                                      {
                                        className:
                                          "style__downgrade-video-box___28aCq",
                                        style: {
                                          width: o.stickyDomWidth
                                            ? o.stickyDomWidth
                                            : "592px",
                                          height: o.stickyDomHeight
                                            ? o.stickyDomHeight
                                            : "592px",
                                        },
                                      },
                                      I(y.a, {
                                        visibleplay: !0,
                                        lazyload: !0,
                                        replayWhenRevisible: !0,
                                        poster: e.videoPoster,
                                        url: [e.videoLink && e.videoLink.path],
                                      }),
                                    ),
                                  ),
                            r =
                              "leftPictureRightText" === o.layout
                                ? I(
                                    "div",
                                    {
                                      key: "downgrade-adaptive-img".concat(t),
                                      className:
                                        "style__downgrade-adaptive-item___3gs5O",
                                      style: { width: o.contentWidth },
                                    },
                                    I(g.a, {
                                      threshold: 1500,
                                      className: "style__downgrade-img___1OrYA",
                                      type: "bg",
                                      tagType: "div",
                                      src: e.image,
                                      style: {
                                        width: o.stickyDomWidth
                                          ? o.stickyDomWidth
                                          : "592px",
                                        height: o.stickyDomHeight
                                          ? o.stickyDomHeight
                                          : "592px",
                                      },
                                    }),
                                    I(
                                      "div",
                                      {
                                        className:
                                          "style__downgrade-text___1l6kj",
                                        style: {
                                          width: o.textWidth
                                            ? "".concat(o.textWidth)
                                            : "592px",
                                        },
                                      },
                                      I("h3", {
                                        className: "style__item-title___1EJem",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.title),
                                        },
                                      }),
                                      I("p", {
                                        className: "style__item-desc___3asy3",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.desc),
                                        },
                                      }),
                                    ),
                                  )
                                : I(
                                    "div",
                                    {
                                      key: "downgrade-adaptive-img".concat(t),
                                      className:
                                        "style__downgrade-adaptive-item___3gs5O",
                                      style: { width: o.contentWidth },
                                    },
                                    I(
                                      "div",
                                      {
                                        className:
                                          "style__downgrade-text___1l6kj",
                                        style: {
                                          width: o.textWidth
                                            ? "".concat(o.textWidth)
                                            : "592px",
                                        },
                                      },
                                      I("h3", {
                                        className: "style__item-title___1EJem",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.title),
                                        },
                                      }),
                                      I("p", {
                                        className: "style__item-desc___3asy3",
                                        dangerouslySetInnerHTML: {
                                          __html: n(e.desc),
                                        },
                                      }),
                                    ),
                                    I(g.a, {
                                      threshold: 1500,
                                      className: "style__downgrade-img___1OrYA",
                                      type: "bg",
                                      tagType: "div",
                                      src: e.image,
                                      style: {
                                        width: o.stickyDomWidth
                                          ? o.stickyDomWidth
                                          : "592px",
                                        height: o.stickyDomHeight
                                          ? o.stickyDomHeight
                                          : "592px",
                                      },
                                    }),
                                  );
                          return e.hasVideo ? a : r;
                        })
                      : null;
                return I(
                  "section",
                  {
                    ref: function (t) {
                      e.section = t;
                    },
                    className:
                      "text-scroll-switch-video-component style__text-scroll-switch-video-component___1qCwg",
                  },
                  l
                    ? I(
                        "div",
                        { className: "style__downgrade-section___bXiaR" },
                        w,
                      )
                    : I(
                        "div",
                        null,
                        I(
                          "div",
                          {
                            className:
                              "style__adaptive-section___zZUEw style__sticky___B3dWo",
                          },
                          I(
                            "div",
                            { className: "style__adaptive-wrap___3IRWH" },
                            p,
                          ),
                        ),
                        I(
                          "div",
                          { className: "style__scroll-panel___3ypWy" },
                          h,
                        ),
                      ),
                );
              },
            },
          ]),
          t
        );
      })(p.a.Component);
      Object(c.a)(T, "propSettings", {
        key: "wm330TextScrollSwitchVideo",
        name: "wm330TextScrollSwitchVideo",
        contentSetting: {
          contentList: {
            label: "\u5185\u5bb9\u914d\u7f6e",
            props: {
              featureList: {
                type: "array",
                label: "\u5185\u5bb9\u914d\u7f6e",
                props: {
                  title: {
                    type: "string",
                    content: "text",
                    label: "\u6807\u9898",
                  },
                  desc: {
                    type: "string",
                    content: "text",
                    label: "\u63cf\u8ff0",
                  },
                  videoLink: {
                    label: "\u89c6\u9891\u914d\u7f6e",
                    type: "string",
                    content: "url",
                    switch: "hasVideo",
                  },
                  videoLinkWebm: {
                    label: "\u89c6\u9891\u914d\u7f6ewebm",
                    type: "string",
                    content: "url",
                  },
                  videoPoster: {
                    label: "\u89c6\u9891\u5c01\u9762\u56fe",
                    type: "image",
                  },
                  image: {
                    label: "\u56fe\u7247\u914d\u7f6e",
                    switch: "hasimage",
                    type: "image",
                  },
                },
              },
            },
          },
        },
        skinSetting: {
          structure: {
            label: "\u7ed3\u6784\u8bbe\u7f6e",
            props: {
              contentWidth: {
                label:
                  "\u5185\u5bb9\u76d2\u5b50\u5bbd\u5ea6\uff08\u9ed8\u8ba41200px\uff09",
                type: "string",
              },
              layout: {
                label: "\u5e03\u5c40",
                type: "select",
                items: [
                  {
                    label: "\u5de6(\u56fe/\u89c6\u9891)\u53f3\u6587\u5b57",
                    value: "leftPictureRightText",
                  },
                  {
                    label: "\u5de6\u6587\u53f3(\u56fe/\u89c6\u9891)",
                    value: "leftTextRightPicture",
                  },
                ],
              },
              textWidth: {
                label:
                  "\u6587\u5b57\u6a21\u5757\u7684\u5bbd\u5ea6(\u9ed8\u8ba4592px)",
                type: "string",
              },
              stickyDomWidth: {
                label: "\u56fe/\u89c6\u9891\u5bbd\u5ea6(\u9ed8\u8ba4592px)",
                type: "string",
              },
              stickyDomHeight: {
                label: "\u56fe/\u89c6\u9891\u9ad8\u5ea6(\u9ed8\u8ba4592px)",
                type: "string",
              },
              headlineFontSize: {
                label: "\u6807\u9898\u5b57\u4f53\u5927\u5c0f(\u5355\u4f4dpx)",
                type: "string",
                content: "size",
              },
              headlineLineHeight: {
                label: "\u6807\u9898\u884c\u9ad8(\u5355\u4f4dpx)",
                type: "string",
                content: "size",
              },
              descFontSize: {
                label: "\u63cf\u8ff0\u5b57\u4f53\u5927\u5c0f(\u5355\u4f4dpx)",
                type: "string",
                content: "size",
              },
              descLineHeight: {
                label: "\u63cf\u8ff0\u5b57\u4f53\u884c\u9ad8(\u5355\u4f4dpx)",
                type: "string",
                content: "size",
              },
              scrollRange: {
                label:
                  "\u6eda\u52a8\u8303\u56f4(\u5355\u4f4dvh/px,\u4e0d\u586b\u9ed8\u8ba4\u4e3a100vh,\u6700\u5c0f\u503c\u4e3amin(800px,50vh))",
                type: "string",
              },
            },
          },
        },
      }),
        (T.defaultProps = {
          t: function () {},
          component_data: { layout: "leftPictureRightText" },
        }),
        (t.a = Object(f.a)(T));
    },
    gn4A: function (e, t, n) {
      var o = n("yXPU"),
        a = n("lwsE"),
        r = n("W8MJ");
      function i() {
        "use strict";
        i = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          l = r.iterator || "@@iterator",
          s = r.asyncIterator || "@@asyncIterator",
          c = r.toStringTag || "@@toStringTag";
        function _(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          _({}, "");
        } catch (e) {
          _ = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function u(e, t, n, o) {
          var r = t && t.prototype instanceof b ? t : b,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function d(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = u;
        var p = "suspendedStart",
          f = "suspendedYield",
          h = "executing",
          m = "completed",
          y = {};
        function b() {}
        function v() {}
        function g() {}
        var w = {};
        _(w, l, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, l) && (w = k);
        var O = (g.prototype = b.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            _(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = d(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = p;
          return function (r, i) {
            if (a === h) throw new Error("Generator is already running");
            if (a === m) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === p) throw ((a = m), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = h;
              var c = d(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? m : f), c.arg === y)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = m), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              y
            );
          var r = d(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), y
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                y)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[l];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (v.prototype = g),
          a(O, "constructor", { value: g, configurable: !0 }),
          a(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = _(g, c, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), _(e, c, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          _(S.prototype, s, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(u(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          _(O, c, "Generator"),
          _(O, l, function () {
            return this;
          }),
          _(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), y)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                y
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                y
              );
            },
          }),
          t
        );
      }
      var l = (function () {
        "use strict";
        function e() {
          a(this, e);
        }
        return (
          r(e, null, [
            {
              key: "deepMapReplace",
              value: function (e, t, n) {
                return (function e(o) {
                  return (
                    o && "object" === typeof o
                      ? Array.isArray(o)
                        ? (o = o.map(function (t) {
                            return e(t);
                          }))
                        : Object.keys(o).forEach(function (t) {
                            o[t] = e(o[t]);
                          })
                      : "string" === typeof o && (o = o.replace(t, n)),
                    o
                  );
                })(e);
              },
            },
            {
              key: "getOffset",
              value: function (e) {
                var t = e,
                  n = t.offsetParent,
                  o = 0;
                if (n && "body" === n.nodeName.toLowerCase()) o += t.offsetTop;
                else for (; n; ) (o += n.offsetTop), (n = n.offsetParent);
                return o;
              },
            },
            {
              key: "showWholeElm",
              value: function (e) {
                if (!e) return !1;
                for (
                  var t = window.scrollY || window.pageYOffset,
                    n = t + window.innerHeight,
                    o = e.offsetTop,
                    a = e.offsetHeight,
                    r = e;
                  r.offsetParent;

                )
                  o += (r = r.offsetParent).offsetTop;
                return (a += o), (o >= t && n >= a) || (o <= t && n <= a);
              },
            },
            {
              key: "throttle",
              value: function (e, t) {
                for (
                  var n = this,
                    o = arguments.length,
                    a = new Array(o > 2 ? o - 2 : 0),
                    r = 2;
                  r < o;
                  r++
                )
                  a[r - 2] = arguments[r];
                var i = !1;
                return function () {
                  var o = n;
                  return (
                    !i &&
                    (e.apply(o, a),
                    (i = !0),
                    setTimeout(function () {
                      return (i = !1);
                    }, t))
                  );
                };
              },
            },
            {
              key: "checkIsIphone678",
              value: function () {
                var e = window.navigator.userAgent,
                  t = window.screen,
                  n = t.width,
                  o = t.height;
                return (
                  !!e.match(/iPhone/i) &&
                  ((375 === n && 667 === o) ||
                    (414 === n && 736 === o) ||
                    (320 === n && 568 === o))
                );
              },
            },
            {
              key: "checkIsIphoneMini",
              value: function () {
                var e = window.navigator.userAgent,
                  t = window.screen,
                  n = t.width,
                  o = t.height;
                return (
                  !!e.match(/iPhone/i) &&
                  ((360 === n && 780 === o) || (375 === n && 812 === o))
                );
              },
            },
            {
              key: "checkIsIphone14",
              value: function () {
                var e = window.navigator.userAgent,
                  t = window.screen,
                  n = t.width,
                  o = t.height;
                return (
                  !!e.match(/iPhone/i) &&
                  ((393 === n && 852 === o) || (430 === n && 932 === o))
                );
              },
            },
            {
              key: "isWhitelistMobileDevice",
              value: function () {
                return e.checkIsIphone14();
              },
            },
            {
              key: "isObsoleteMobileDevice",
              value: function () {
                return e.checkIsIphone678();
              },
            },
            {
              key: "isDJIWebview",
              value: function (e) {
                var t = e.isDJIFlyAPP,
                  n = e.isDJIGoAPP;
                return t || n;
              },
            },
            {
              key: "shouldDowngrade",
              value: function (t) {
                var n = t.isAndroid,
                  o = t.isIOS,
                  a = t.isFirefox,
                  r = t.isChrome,
                  i = t.isUC,
                  l = t.isQQBrowser,
                  s = t.isWeixin,
                  c = t.isDJIFlyAPP,
                  _ = t.isDJIGoAPP,
                  u = t.isStoreAPP,
                  d = t.isDJIMimo;
                return (
                  (n && !a && !r) ||
                  e.isDJIWebview({ isDJIFlyAPP: c, isDJIGoAPP: _ }) ||
                  (o &&
                    e.shouldIOSdowngrade({
                      isUC: i,
                      isQQBrowser: l,
                      isStoreAPP: u,
                      isDJIMimo: d,
                      isWeixin: s,
                    })) ||
                  e.isHuaweiBrowser()
                );
              },
            },
            {
              key: "shouldIOSdowngrade",
              value: function (e) {
                var t = e.isUC,
                  n = e.isQQBrowser,
                  o = e.isStoreAPP,
                  a = e.isDJIMimo,
                  r = e.isWeixin;
                return t || n || o || a || r;
              },
            },
            {
              key: "isDowngrade",
              value: function () {
                var t = window.navigator.userAgent,
                  n = window.navigator.appVersion,
                  o = !!t.match(/MicroMessenger/gi),
                  a = !!t.match(/iPad/i) || !!t.match(/iPhone/i),
                  r = !!t.match(/UCBrowser/gi),
                  i = !!t.match(/android/gi),
                  l = !!t.match(/\bm?qqbrowser\/([0-9.]+)/gi),
                  s = this.isStoreApp(),
                  c =
                    !!t.match(/DJI-App-pilot-go/gi) ||
                    !!t.match(/DJI-App-pilot/gi),
                  _ = !!t.match(/djifly_ios/gi),
                  u =
                    !!t.match(/DJI-app-mimo-android/gi) ||
                    !!t.match(/DJI-app-mimo-ios/gi),
                  d = !!t.match(/\bfirefox\/([0-9.ab]+)/gi),
                  p =
                    window.navigator &&
                    window.navigator.permissions &&
                    -1 !== n.indexOf("(KHTML, like Gecko) Chrome");
                return e.shouldDowngrade({
                  isAndroid: i,
                  isIOS: a,
                  isFirefox: d,
                  isChrome: p,
                  isUC: r,
                  isQQBrowser: l,
                  isWeixin: o,
                  isDJIFlyAPP: _,
                  isDJIGoAPP: c,
                  isStoreAPP: s,
                  isDJIMimo: u,
                });
              },
            },
            {
              key: "isUCVersionBefore",
              value: function (e) {
                var t = window.navigator.userAgent.match(/UCBrowser\/(\d+)./i);
                return Boolean(t) && +t[1] < e;
              },
            },
            {
              key: "isQQBrowser",
              value: function () {
                var e = window.navigator.userAgent;
                return /\bm?qqbrowser\/([0-9.]+)/gi.test(e);
              },
            },
            {
              key: "isAndroid",
              value: function () {
                var e = !!window.navigator.userAgent.match(/android/gi);
                return e;
              },
            },
            {
              key: "isSamsungBrowser",
              value: function () {
                return window.navigator.userAgent.match(/samsungbrowser/gi);
              },
            },
            {
              key: "isUC",
              value: function () {
                return !!window.navigator.userAgent.match(/UCBrowser/gi);
              },
            },
            {
              key: "isAPP",
              value: function () {
                var e = window.navigator.userAgent,
                  t = this.isStoreApp(),
                  n =
                    !!e.match(/DJI-App-pilot-go/gi) ||
                    !!e.match(/DJI-App-pilot/gi),
                  o = !!e.match(/djifly_ios/gi),
                  a =
                    !!e.match(/DJI-app-mimo-android/gi) ||
                    !!e.match(/DJI-app-mimo-ios/gi);
                return o || n || t || a;
              },
            },
            {
              key: "isWx",
              value: function () {
                return !!window.navigator.userAgent.match(/MicroMessenger/gi);
              },
            },
            {
              key: "isIpad",
              value: function () {
                return !!window.navigator.userAgent.match(/iPad/i);
              },
            },
            {
              key: "isiPadOriPadPro",
              value: function () {
                var e = !!window.navigator.userAgent.match(/iPad/i),
                  t =
                    "MacIntel" === navigator.platform &&
                    navigator.maxTouchPoints > 1;
                return e || t;
              },
            },
            {
              key: "isIOS15",
              value: function () {
                return !!window.navigator.userAgent.match(/iPhone OS 15/i);
              },
            },
            {
              key: "videoWithControl",
              value: function (e) {
                var t = window.navigator.userAgent;
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                  t,
                ) &&
                  (e.removeAttribute("autoplay"),
                  e.setAttribute("muted", !0),
                  e.setAttribute("playsinline", !0),
                  e.setAttribute("x5-playsinline", !0),
                  e.setAttribute("webkit-playsinline", !0),
                  e.setAttribute("controls", !0),
                  setTimeout(function () {
                    e.removeAttribute("controls");
                  }, 0));
              },
            },
            {
              key: "isMobile",
              value: function () {
                var e = window.navigator.userAgent;
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                  e,
                );
              },
            },
            {
              key: "getFileExtendingName",
              value: function (e) {
                var t = /[^\.]\w*$/.exec(e);
                return t ? t[0] : "";
              },
            },
            {
              key: "getIOSversion",
              value: function () {
                var e, t;
                return (
                  /iP(hone|od|ad)/.test(navigator.platform)
                    ? ((t = navigator.appVersion.match(
                        /OS (\d+)_(\d+)_?(\d+)?/,
                      )),
                      (e = {
                        status: !0,
                        version: parseInt(t[1], 10),
                        info: ""
                          .concat(parseInt(t[1], 10), ".")
                          .concat(parseInt(t[2], 10), ".")
                          .concat(parseInt(t[3] || 0, 10)),
                      }))
                    : (e = { status: !1, version: !1, info: "" }),
                  e
                );
              },
            },
            {
              key: "isStoreApp",
              value: function () {
                return !(!this.isStoreAppIos() && !this.isStoreAppAndroid());
              },
            },
            {
              key: "isStoreAppIos",
              value: function () {
                return !!window.navigator.userAgent.match(/DJI-App-Ios/gi);
              },
            },
            {
              key: "isStoreAppAndroid",
              value: function () {
                return !!window.navigator.userAgent.match(/DJI-App-Android/gi);
              },
            },
            {
              key: "isAuthed",
              value: function (e) {
                var t = e.request.header["x-publish-token"];
                return e.API.Terminator.verifyToken(t);
              },
            },
            {
              key: "isHuawei",
              value: function () {
                var e = !!window.navigator.userAgent.match(/HUAWEI/gi);
                return e;
              },
            },
            {
              key: "isHuaweiBrowser",
              value: function () {
                var e = !!window.navigator.userAgent.match(/HuaweiBrowser/gi);
                return e;
              },
            },
            {
              key: "removeURLParameter",
              value: function (e, t) {
                var n = e.split("?");
                if (n.length >= 2) {
                  for (
                    var o = "".concat(encodeURIComponent(t), "="),
                      a = n[1].split(/[&;]/g),
                      r = a.length - 1;
                    r >= 0;
                    r--
                  )
                    -1 !== a[r].lastIndexOf(o, 0) && a.splice(r, 1);
                  return n[0] + (a.length > 0 ? "?".concat(a.join("&")) : "");
                }
                return e;
              },
            },
            {
              key: "getMessageFromError",
              value: (function () {
                var e = o(
                  i().mark(function e(t) {
                    var n, o;
                    return i().wrap(function (e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            if (((n = { text: "" }), !t)) {
                              e.next = 10;
                              break;
                            }
                            if (
                              (t.text && (n.text = t.text),
                              !n.text && t.message && (n.text = t.message),
                              !t || "function" !== typeof t.json)
                            ) {
                              e.next = 10;
                              break;
                            }
                            return (e.next = 7), t.json();
                          case 7:
                            (o = e.sent) && o.code && (n.code = o.code),
                              (n.text = o.message);
                          case 10:
                            return e.abrupt("return", n);
                          case 11:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  }),
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })(),
            },
            {
              key: "isWindowsFirefox",
              value: function () {
                var e = window.navigator.userAgent;
                return !!(
                  e &&
                  (e.indexOf("win32") >= 0 ||
                    e.indexOf("wow32") >= 0 ||
                    e.indexOf("win64") >= 0 ||
                    e.indexOf("wow64") >= 0) &&
                  e.indexOf("firefox") > 0
                );
              },
            },
          ]),
          e
        );
      })();
      e.exports = l;
    },
    gpTt: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      });
      var o = n("yWgo");
      function a(e) {
        var t = e.link,
          n = e.linkType,
          a = e.localization,
          r = void 0 === a ? {} : a,
          i = e.from,
          l = e.mobileMode,
          s = e.site,
          c = void 0 === s ? "brandsite" : s;
        if (!t) return "javascript:;";
        var _ = t.split("#")[0];
        if ("absolute-path" !== n) {
          var u = "";
          (u =
            "brandsite" === c
              ? o.db.getCountryUrlPrefix({
                  country: r.country,
                  locale: r.language,
                })
              : o.db.getLangUrlPrefix(r.language)),
            /^[A-Za-z]/.test(_) && (_ = "/".concat(_));
          var d = l ? "/mobile" : "";
          _ = "".concat(u).concat(d).concat(_);
        }
        var p = i;
        i || (p = l ? "mobile_nav" : "nav");
        var f = "";
        return (
          _.indexOf("?") > 0 ? (f += "&") : (f += "?"),
          (f += "site=".concat(c, "&from=").concat(p)),
          t.split("#")[1] && (f += "#".concat(t.split("#")[1])),
          _ + f
        );
      }
    },
    "h/6u": function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              },
        r = n("WCV8"),
        i = (o = r) && o.__esModule ? o : { default: o };
      t.default = function (e, t, n, o, r) {
        var l = [],
          s = Array.isArray(t)
            ? "array"
            : "undefined" === typeof t
              ? "undefined"
              : a(t);
        i.default.required(e, t, o, l, r, s), n(l);
      };
    },
    hDam: function (e, t) {
      e.exports = function () {};
    },
    "hKI/": function (e, t, n) {
      (function (t) {
        var n = "Expected a function",
          o = NaN,
          a = "[object Symbol]",
          r = /^\s+|\s+$/g,
          i = /^[-+]0x[0-9a-f]+$/i,
          l = /^0b[01]+$/i,
          s = /^0o[0-7]+$/i,
          c = parseInt,
          _ = "object" == typeof t && t && t.Object === Object && t,
          u = "object" == typeof self && self && self.Object === Object && self,
          d = _ || u || Function("return this")(),
          p = Object.prototype.toString,
          f = Math.max,
          h = Math.min,
          m = function () {
            return d.Date.now();
          };
        function y(e, t, o) {
          var a,
            r,
            i,
            l,
            s,
            c,
            _ = 0,
            u = !1,
            d = !1,
            p = !0;
          if ("function" != typeof e) throw new TypeError(n);
          function y(t) {
            var n = a,
              o = r;
            return (a = r = void 0), (_ = t), (l = e.apply(o, n));
          }
          function g(e) {
            var n = e - c;
            return void 0 === c || n >= t || n < 0 || (d && e - _ >= i);
          }
          function w() {
            var e = m();
            if (g(e)) return x(e);
            s = setTimeout(
              w,
              (function (e) {
                var n = t - (e - c);
                return d ? h(n, i - (e - _)) : n;
              })(e),
            );
          }
          function x(e) {
            return (s = void 0), p && a ? y(e) : ((a = r = void 0), l);
          }
          function k() {
            var e = m(),
              n = g(e);
            if (((a = arguments), (r = this), (c = e), n)) {
              if (void 0 === s)
                return (function (e) {
                  return (_ = e), (s = setTimeout(w, t)), u ? y(e) : l;
                })(c);
              if (d) return (s = setTimeout(w, t)), y(c);
            }
            return void 0 === s && (s = setTimeout(w, t)), l;
          }
          return (
            (t = v(t) || 0),
            b(o) &&
              ((u = !!o.leading),
              (i = (d = "maxWait" in o) ? f(v(o.maxWait) || 0, t) : i),
              (p = "trailing" in o ? !!o.trailing : p)),
            (k.cancel = function () {
              void 0 !== s && clearTimeout(s),
                (_ = 0),
                (a = c = r = s = void 0);
            }),
            (k.flush = function () {
              return void 0 === s ? l : x(m());
            }),
            k
          );
        }
        function b(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function v(e) {
          if ("number" == typeof e) return e;
          if (
            (function (e) {
              return (
                "symbol" == typeof e ||
                ((function (e) {
                  return !!e && "object" == typeof e;
                })(e) &&
                  p.call(e) == a)
              );
            })(e)
          )
            return o;
          if (b(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = b(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(r, "");
          var n = l.test(e);
          return n || s.test(e) ? c(e.slice(2), n ? 2 : 8) : i.test(e) ? o : +e;
        }
        e.exports = function (e, t, o) {
          var a = !0,
            r = !0;
          if ("function" != typeof e) throw new TypeError(n);
          return (
            b(o) &&
              ((a = "leading" in o ? !!o.leading : a),
              (r = "trailing" in o ? !!o.trailing : r)),
            y(e, t, { leading: a, maxWait: t, trailing: r })
          );
        };
      }).call(this, n("yLpj"));
    },
    he42: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.Track = void 0);
      var o =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        a = l(n("q1tI")),
        r = l(n("TSYQ")),
        i = n("GzxR");
      function l(e) {
        return e && e.__esModule ? e : { default: e };
      }
      var s = function (e) {
          var t, n, o, a, r;
          return (
            (o =
              (r = e.rtl ? e.slideCount - 1 - e.index : e.index) < 0 ||
              r >= e.slideCount),
            e.centerMode
              ? ((a = Math.floor(e.slidesToShow / 2)),
                (n = (r - e.currentSlide) % e.slideCount === 0),
                r > e.currentSlide - a - 1 &&
                  r <= e.currentSlide + a &&
                  (t = !0))
              : (t =
                  e.currentSlide <= r && r < e.currentSlide + e.slidesToShow),
            {
              "slick-slide": !0,
              "slick-active": t,
              "slick-center": n,
              "slick-cloned": o,
              "slick-current": r === e.currentSlide,
            }
          );
        },
        c = function (e, t) {
          return e.key || t;
        },
        _ = function (e) {
          var t,
            n = [],
            l = [],
            _ = [],
            u = a.default.Children.count(e.children),
            d = (0, i.lazyStartIndex)(e),
            p = (0, i.lazyEndIndex)(e);
          return (
            a.default.Children.forEach(e.children, function (f, h) {
              var m = void 0,
                y = {
                  message: "children",
                  index: h,
                  slidesToScroll: e.slidesToScroll,
                  currentSlide: e.currentSlide,
                };
              m =
                !e.lazyLoad || (e.lazyLoad && e.lazyLoadedList.indexOf(h) >= 0)
                  ? f
                  : a.default.createElement("div", null);
              var b = (function (e) {
                  var t = {};
                  return (
                    (void 0 !== e.variableWidth && !1 !== e.variableWidth) ||
                      (t.width = e.slideWidth),
                    e.fade &&
                      ((t.position = "relative"),
                      e.vertical
                        ? (t.top = -e.index * parseInt(e.slideHeight))
                        : (t.left = -e.index * parseInt(e.slideWidth)),
                      (t.opacity = e.currentSlide === e.index ? 1 : 0),
                      (t.transition =
                        "opacity " +
                        e.speed +
                        "ms " +
                        e.cssEase +
                        ", visibility " +
                        e.speed +
                        "ms " +
                        e.cssEase),
                      (t.WebkitTransition =
                        "opacity " +
                        e.speed +
                        "ms " +
                        e.cssEase +
                        ", visibility " +
                        e.speed +
                        "ms " +
                        e.cssEase)),
                    t
                  );
                })(o({}, e, { index: h })),
                v = m.props.className || "",
                g = s(o({}, e, { index: h }));
              if (
                (n.push(
                  a.default.cloneElement(m, {
                    key: "original" + c(m, h),
                    "data-index": h,
                    className: (0, r.default)(g, v),
                    tabIndex: "-1",
                    "aria-hidden": !g["slick-active"],
                    style: o({ outline: "none" }, m.props.style || {}, b),
                    onClick: function (t) {
                      m.props && m.props.onClick && m.props.onClick(t),
                        e.focusOnSelect && e.focusOnSelect(y);
                    },
                  }),
                ),
                e.infinite && !1 === e.fade)
              ) {
                var w = u - h;
                w <= (0, i.getPreClones)(e) &&
                  u !== e.slidesToShow &&
                  ((t = -w) >= d && (m = f),
                  (g = s(o({}, e, { index: t }))),
                  l.push(
                    a.default.cloneElement(m, {
                      key: "precloned" + c(m, t),
                      "data-index": t,
                      tabIndex: "-1",
                      className: (0, r.default)(g, v),
                      "aria-hidden": !g["slick-active"],
                      style: o({}, m.props.style || {}, b),
                      onClick: function (t) {
                        m.props && m.props.onClick && m.props.onClick(t),
                          e.focusOnSelect && e.focusOnSelect(y);
                      },
                    }),
                  )),
                  u !== e.slidesToShow &&
                    h < e.slidesToShow &&
                    ((t = u + h) < p && (m = f),
                    (g = s(o({}, e, { index: t }))),
                    _.push(
                      a.default.cloneElement(m, {
                        key: "postcloned" + c(m, t),
                        "data-index": t,
                        tabIndex: "-1",
                        className: (0, r.default)(g, v),
                        "aria-hidden": !g["slick-active"],
                        style: o({}, m.props.style || {}, b),
                        onClick: function (t) {
                          m.props && m.props.onClick && m.props.onClick(t),
                            e.focusOnSelect && e.focusOnSelect(y);
                        },
                      }),
                    ));
              }
            }),
            e.rtl ? l.concat(n, _).reverse() : l.concat(n, _)
          );
        };
      t.Track = (function (e) {
        function t() {
          return (
            (function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
            (function (e, t) {
              if (!e)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return !t || ("object" !== typeof t && "function" !== typeof t)
                ? e
                : t;
            })(this, e.apply(this, arguments))
          );
        }
        return (
          (function (e, t) {
            if ("function" !== typeof t && null !== t)
              throw new TypeError(
                "Super expression must either be null or a function, not " +
                  typeof t,
              );
            (e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
              t &&
                (Object.setPrototypeOf
                  ? Object.setPrototypeOf(e, t)
                  : (e.__proto__ = t));
          })(t, e),
          (t.prototype.render = function () {
            var e = _(this.props),
              t = this.props,
              n = {
                onMouseEnter: t.onMouseEnter,
                onMouseOver: t.onMouseOver,
                onMouseLeave: t.onMouseLeave,
              };
            return a.default.createElement(
              "div",
              o({ className: "slick-track", style: this.props.trackStyle }, n),
              e,
            );
          }),
          t
        );
      })(a.default.PureComponent);
    },
    heNW: function (e, t) {
      e.exports = function (e, t, n) {
        switch (n.length) {
          case 0:
            return e.call(t);
          case 1:
            return e.call(t, n[0]);
          case 2:
            return e.call(t, n[0], n[1]);
          case 3:
            return e.call(t, n[0], n[1], n[2]);
        }
        return e.apply(t, n);
      };
    },
    hugj: function (e, t, n) {
      "use strict";
      n.d(t, "d", function () {
        return o;
      }),
        n.d(t, "a", function () {
          return a;
        }),
        n.d(t, "c", function () {
          return r;
        }),
        n.d(t, "b", function () {
          return i;
        });
      var o = (function (e) {
          return (
            (e.link = "link"),
            (e.video = "video"),
            (e["3d"] = "3d"),
            (e.www = "www"),
            (e.text = "text"),
            (e.xml = "xml"),
            e
          );
        })({}),
        a = (function (e) {
          return (
            (e.DEFAULT = "DEFAULT"), (e.RASTERISATION = "RASTERISATION"), e
          );
        })({}),
        r = (function (e) {
          return (e.DEFAULT = ""), (e.PX = "px"), e;
        })({}),
        i = (function (e) {
          return (e.internal = "internal"), (e.external = "external"), e;
        })({});
    },
    hyiO: function (e, t, n) {
      e.exports = {
        "media-modal-container": "style__media-modal-container___3m5la",
        "media-modal-close": "style__media-modal-close___1Y8ix",
        "media-modal-iframe": "style__media-modal-iframe___2PyPJ",
        "link-button": "style__link-button___3Pj2w",
      };
    },
    hypo: function (e, t, n) {
      var o = n("O0oS");
      e.exports = function (e, t, n) {
        "__proto__" == t && o
          ? o(e, t, {
              configurable: !0,
              enumerable: !0,
              value: n,
              writable: !0,
            })
          : (e[t] = n);
      };
    },
    iCc5: function (e, t, n) {
      "use strict";
      (t.__esModule = !0),
        (t.default = function (e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        });
    },
    iKuz: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 }),
        (t.default = void 0);
      var o,
        a = (o = n("Fe7O")) && o.__esModule ? o : { default: o };
      var r = function (e, t) {
        if ("throw" === t) throw new Error(e);
        return "warn" === t && console.warn(e), null;
      };
      t.default = function (e, t, n) {
        var o = Object.keys(t),
          i = n || {},
          l = i.handleMissingStyleName,
          s = void 0 === l ? a.default.handleMissingStyleName : l,
          c = i.autoResolveMultipleImports,
          _ = void 0 === c ? a.default.autoResolveMultipleImports : c;
        return e
          ? e
              .split(" ")
              .filter(function (e) {
                return e;
              })
              .map(function (e) {
                if (
                  (function (e) {
                    return -1 !== e.indexOf(".");
                  })(e)
                )
                  return (function (e, t, n) {
                    var o = e.split("."),
                      i = o[0],
                      l = o[1],
                      s = n || a.default.handleMissingStyleName;
                    return l
                      ? t[i]
                        ? t[i][l]
                          ? t[i][l]
                          : r("CSS module does not exist: " + l, s)
                        : r("CSS module import does not exist: " + i, s)
                      : r("Invalid style name: " + e, s);
                  })(e, t, s);
                if (0 === o.length)
                  throw new Error(
                    "Cannot use styleName attribute for style name '" +
                      e +
                      "' without importing at least one stylesheet.",
                  );
                if (o.length > 1) {
                  if (!_)
                    throw new Error(
                      "Cannot use anonymous style name '" +
                        e +
                        "' with more than one stylesheet import without setting 'autoResolveMultipleImports' to true.",
                    );
                  return (function (e, t, n) {
                    var o = n || a.default.handleMissingStyleName,
                      i = Object.keys(t)
                        .map(function (n) {
                          return t[n][e] && n;
                        })
                        .filter(function (e) {
                          return e;
                        });
                    if (i.length > 1)
                      throw new Error(
                        'Cannot resolve styleName "' +
                          e +
                          '" because it is present in multiple imports:\n\n\t' +
                          i.join("\n\t") +
                          '\n\nYou can resolve this by using a named import, e.g:\n\n\timport foo from "' +
                          i[0] +
                          '";\n\t<div styleName="foo.' +
                          e +
                          '" />\n\n',
                      );
                    return 0 === i.length
                      ? r("Could not resolve the styleName '" + e + "'.", o)
                      : t[i[0]][e];
                  })(e, t, s);
                }
                var n = t[o[0]];
                return n[e]
                  ? n[e]
                  : r("Could not resolve the styleName '" + e + "'.", s);
              })
              .filter(function (e) {
                return e;
              })
              .join(" ")
          : "";
      };
    },
    iLw5: function (e, t, n) {
      (function (t) {
        var n = 1 / 0,
          o = 9007199254740991,
          a = "[object Arguments]",
          r = "[object Function]",
          i = "[object GeneratorFunction]",
          l = "[object Symbol]",
          s = "object" == typeof t && t && t.Object === Object && t,
          c = "object" == typeof self && self && self.Object === Object && self,
          _ = s || c || Function("return this")();
        function u(e, t, n) {
          switch (n.length) {
            case 0:
              return e.call(t);
            case 1:
              return e.call(t, n[0]);
            case 2:
              return e.call(t, n[0], n[1]);
            case 3:
              return e.call(t, n[0], n[1], n[2]);
          }
          return e.apply(t, n);
        }
        function d(e, t) {
          for (var n = -1, o = t.length, a = e.length; ++n < o; )
            e[a + n] = t[n];
          return e;
        }
        var p = Object.prototype,
          f = p.hasOwnProperty,
          h = p.toString,
          m = _.Symbol,
          y = p.propertyIsEnumerable,
          b = m ? m.isConcatSpreadable : void 0,
          v = Math.max;
        function g(e) {
          return (
            x(e) ||
            (function (e) {
              return (
                (function (e) {
                  return (
                    k(e) &&
                    (function (e) {
                      return (
                        null != e &&
                        (function (e) {
                          return (
                            "number" == typeof e &&
                            e > -1 &&
                            e % 1 == 0 &&
                            e <= o
                          );
                        })(e.length) &&
                        !(function (e) {
                          var t = (function (e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                          })(e)
                            ? h.call(e)
                            : "";
                          return t == r || t == i;
                        })(e)
                      );
                    })(e)
                  );
                })(e) &&
                f.call(e, "callee") &&
                (!y.call(e, "callee") || h.call(e) == a)
              );
            })(e) ||
            !!(b && e && e[b])
          );
        }
        function w(e) {
          if (
            "string" == typeof e ||
            (function (e) {
              return "symbol" == typeof e || (k(e) && h.call(e) == l);
            })(e)
          )
            return e;
          var t = e + "";
          return "0" == t && 1 / e == -n ? "-0" : t;
        }
        var x = Array.isArray;
        function k(e) {
          return !!e && "object" == typeof e;
        }
        var O,
          I,
          S =
            ((O = function (e, t) {
              return null == e
                ? {}
                : (function (e, t) {
                    return (function (e, t, n) {
                      for (var o = -1, a = t.length, r = {}; ++o < a; ) {
                        var i = t[o],
                          l = e[i];
                        n(l, i) && (r[i] = l);
                      }
                      return r;
                    })((e = Object(e)), t, function (t, n) {
                      return n in e;
                    });
                  })(
                    e,
                    (function (e, t) {
                      for (
                        var n = -1, o = e ? e.length : 0, a = Array(o);
                        ++n < o;

                      )
                        a[n] = t(e[n], n, e);
                      return a;
                    })(
                      (function e(t, n, o, a, r) {
                        var i = -1,
                          l = t.length;
                        for (o || (o = g), r || (r = []); ++i < l; ) {
                          var s = t[i];
                          n > 0 && o(s)
                            ? n > 1
                              ? e(s, n - 1, o, a, r)
                              : d(r, s)
                            : a || (r[r.length] = s);
                        }
                        return r;
                      })(t, 1),
                      w,
                    ),
                  );
            }),
            (I = v(void 0 === I ? O.length - 1 : I, 0)),
            function () {
              for (
                var e = arguments, t = -1, n = v(e.length - I, 0), o = Array(n);
                ++t < n;

              )
                o[t] = e[I + t];
              t = -1;
              for (var a = Array(I + 1); ++t < I; ) a[t] = e[t];
              return (a[I] = o), u(O, this, a);
            });
        e.exports = S;
      }).call(this, n("yLpj"));
    },
    "iVi/": function (e, t, n) {
      "use strict";
      (t.parse = function (e, t) {
        if ("string" !== typeof e)
          throw new TypeError("argument str must be a string");
        var n = {},
          o = (t || {}).decode || r,
          a = 0;
        for (; a < e.length; ) {
          var i = e.indexOf("=", a);
          if (-1 === i) break;
          var s = e.indexOf(";", a);
          if (-1 === s) s = e.length;
          else if (s < i) {
            a = e.lastIndexOf(";", i - 1) + 1;
            continue;
          }
          var c = e.slice(a, i).trim();
          if (void 0 === n[c]) {
            var _ = e.slice(i + 1, s).trim();
            34 === _.charCodeAt(0) && (_ = _.slice(1, -1)), (n[c] = l(_, o));
          }
          a = s + 1;
        }
        return n;
      }),
        (t.serialize = function (e, t, n) {
          var r = n || {},
            l = r.encode || i;
          if ("function" !== typeof l)
            throw new TypeError("option encode is invalid");
          if (!a.test(e)) throw new TypeError("argument name is invalid");
          var s = l(t);
          if (s && !a.test(s)) throw new TypeError("argument val is invalid");
          var c = e + "=" + s;
          if (null != r.maxAge) {
            var _ = r.maxAge - 0;
            if (isNaN(_) || !isFinite(_))
              throw new TypeError("option maxAge is invalid");
            c += "; Max-Age=" + Math.floor(_);
          }
          if (r.domain) {
            if (!a.test(r.domain))
              throw new TypeError("option domain is invalid");
            c += "; Domain=" + r.domain;
          }
          if (r.path) {
            if (!a.test(r.path)) throw new TypeError("option path is invalid");
            c += "; Path=" + r.path;
          }
          if (r.expires) {
            var u = r.expires;
            if (
              !(function (e) {
                return "[object Date]" === o.call(e) || e instanceof Date;
              })(u) ||
              isNaN(u.valueOf())
            )
              throw new TypeError("option expires is invalid");
            c += "; Expires=" + u.toUTCString();
          }
          r.httpOnly && (c += "; HttpOnly");
          r.secure && (c += "; Secure");
          if (r.priority) {
            switch (
              "string" === typeof r.priority
                ? r.priority.toLowerCase()
                : r.priority
            ) {
              case "low":
                c += "; Priority=Low";
                break;
              case "medium":
                c += "; Priority=Medium";
                break;
              case "high":
                c += "; Priority=High";
                break;
              default:
                throw new TypeError("option priority is invalid");
            }
          }
          if (r.sameSite) {
            switch (
              "string" === typeof r.sameSite
                ? r.sameSite.toLowerCase()
                : r.sameSite
            ) {
              case !0:
                c += "; SameSite=Strict";
                break;
              case "lax":
                c += "; SameSite=Lax";
                break;
              case "strict":
                c += "; SameSite=Strict";
                break;
              case "none":
                c += "; SameSite=None";
                break;
              default:
                throw new TypeError("option sameSite is invalid");
            }
          }
          return c;
        });
      var o = Object.prototype.toString,
        a = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
      function r(e) {
        return -1 !== e.indexOf("%") ? decodeURIComponent(e) : e;
      }
      function i(e) {
        return encodeURIComponent(e);
      }
      function l(e, t) {
        try {
          return t(e);
        } catch (n) {
          return e;
        }
      }
    },
    iYzT: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o,
        a = n("q1tI"),
        r = (o = a) && o.__esModule ? o : { default: o };
      var i = {
        accessibility: !0,
        adaptiveHeight: !1,
        afterChange: null,
        appendDots: function (e) {
          return r.default.createElement(
            "ul",
            { style: { display: "block" } },
            e,
          );
        },
        arrows: !0,
        autoplay: !1,
        autoplaySpeed: 3e3,
        beforeChange: null,
        centerMode: !1,
        centerPadding: "50px",
        className: "",
        cssEase: "ease",
        customPaging: function (e) {
          return r.default.createElement("button", null, e + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: null,
        nextArrow: null,
        onEdge: null,
        onInit: null,
        onLazyLoadError: null,
        onReInit: null,
        pauseOnDotsHover: !1,
        pauseOnFocus: !1,
        pauseOnHover: !0,
        prevArrow: null,
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "div",
        slidesPerRow: 1,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 500,
        swipe: !0,
        swipeEvent: null,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        waitForAnimate: !0,
      };
      t.default = i;
    },
    inn5: function (e, t, n) {
      "use strict";
      n.d(t, "w", function () {
        return o;
      }),
        n.d(t, "r", function () {
          return a;
        }),
        n.d(t, "i", function () {
          return r;
        }),
        n.d(t, "m", function () {
          return i;
        }),
        n.d(t, "y", function () {
          return l;
        }),
        n.d(t, "o", function () {
          return s;
        }),
        n.d(t, "d", function () {
          return c;
        }),
        n.d(t, "e", function () {
          return _;
        }),
        n.d(t, "x", function () {
          return u;
        }),
        n.d(t, "z", function () {
          return d;
        }),
        n.d(t, "n", function () {
          return p;
        }),
        n.d(t, "c", function () {
          return f;
        }),
        n.d(t, "b", function () {
          return h;
        }),
        n.d(t, "a", function () {
          return m;
        }),
        n.d(t, "l", function () {
          return y;
        }),
        n.d(t, "g", function () {
          return b;
        }),
        n.d(t, "t", function () {
          return v;
        }),
        n.d(t, "s", function () {
          return g;
        }),
        n.d(t, "v", function () {
          return w;
        }),
        n.d(t, "u", function () {
          return x;
        }),
        n.d(t, "f", function () {
          return k;
        }),
        n.d(t, "p", function () {
          return O;
        }),
        n.d(t, "k", function () {
          return I;
        }),
        n.d(t, "j", function () {
          return S;
        }),
        n.d(t, "q", function () {
          return j;
        }),
        n.d(t, "h", function () {
          return T;
        });
      var o = (function (e) {
          return (e.black = "black"), (e.white = "white"), e;
        })({}),
        a = (function (e) {
          return (
            (e.black = "black"),
            (e.white = "white"),
            (e.dark = "dark"),
            (e.normal = "normal"),
            e
          );
        })({}),
        r = (function (e) {
          return (
            (e.svg = "svg"),
            (e["pure-text"] = "pure-text"),
            (e["gradient-text"] = "gradient-text"),
            e
          );
        })({}),
        i = (function (e) {
          return (
            (e.svg = "svg"),
            (e["pure-text"] = "pure-text"),
            (e["gradient-text"] = "gradient-text"),
            e
          );
        })({}),
        l = (function (e) {
          return (
            (e.loop = "loop"),
            (e.once = "once"),
            (e.replayWhenRevisible = "replayWhenRevisible"),
            (e.withController = "withController"),
            e
          );
        })({}),
        s = (function (e) {
          return (e.vertical = "vertical"), (e.horizontal = "horizontal"), e;
        })({}),
        c = (function (e) {
          return (
            (e["media-text"] = "media-text"),
            (e["text-media"] = "text-media"),
            e
          );
        })({}),
        _ = (function (e) {
          return (e.picture = "picture"), (e.video = "video"), e;
        })({}),
        u = (function (e) {
          return (
            (e["top-align"] = "top-align"),
            (e["center-align"] = "center-align"),
            (e["bottom-align"] = "bottom-align"),
            e
          );
        })({}),
        d = (function (e) {
          return (
            (e.carousel = "carousel"), (e["manual-switch"] = "manual-switch"), e
          );
        })({}),
        p = (function (e) {
          return (
            (e["left-align"] = "left-align"),
            (e["center-align"] = "center-align"),
            (e["right-align"] = "right-align"),
            e
          );
        })({}),
        f = (function (e) {
          return (
            (e["auto-fit"] = "auto-fit"), (e["custom-css"] = "custom-css"), e
          );
        })({}),
        h = (function (e) {
          return (
            (e.repeat = "repeat"),
            (e["repeat-x"] = "repeat-x"),
            (e["repeat-y"] = "repeat-y"),
            (e["no-repeat"] = "no-repeat"),
            e
          );
        })({}),
        m = (function (e) {
          return (e.fix = "fix"), (e.normal = "normal"), e;
        })({}),
        y = (function (e) {
          return (
            (e.h1 = "h1"),
            (e.h2 = "h2"),
            (e.h3 = "h3"),
            (e.h4 = "h4"),
            (e.p = "p"),
            e
          );
        })({}),
        b = (function (e) {
          return (
            (e.xxxxxl = "xxxxxl"),
            (e.xxxxl = "xxxxl"),
            (e.xxxl = "xxxl"),
            (e.xxl = "xxl"),
            (e.xl = "xl"),
            (e.l = "l"),
            (e.m = "m"),
            (e.s = "s"),
            (e.xs = "xs"),
            (e.xxs = "xxs"),
            e
          );
        })({}),
        v = (function (e) {
          return (
            (e.button = "button"),
            (e["external-button"] = "external-button"),
            (e["store-button"] = "store-button"),
            (e["video-play"] = "video-play"),
            e
          );
        })({}),
        g = (function (e) {
          return (
            (e.dark = "dark"), (e.light = "light"), (e.primary = "primary"), e
          );
        })({}),
        w = (function (e) {
          return (
            (e.button = "button"),
            (e["external-button"] = "external-button"),
            (e["video-play"] = "video-play"),
            (e["internal-link"] = "internal-link"),
            (e["external-link"] = "external-link"),
            (e["download-link"] = "download-link"),
            (e["no-icon-link"] = "no-icon-link"),
            (e["3Dtype"] = "3Dtype"),
            (e.ARtype = "ARtype"),
            (e["store-button"] = "store-button"),
            (e["zoom-button"] = "zoom-button"),
            e
          );
        })({}),
        x = (function (e) {
          return (
            (e["secondary-dark"] = "secondary-dark"),
            (e["secondary-light"] = "secondary-light"),
            e
          );
        })({}),
        k = (function (e) {
          return (
            (e["internal-link"] = "internal-link"),
            (e["external-link"] = "external-link"),
            (e["download-link"] = "download-link"),
            (e["no-icon-link"] = "no-icon-link"),
            e
          );
        })({}),
        O = (function (e) {
          return (e.internal = "internal"), (e.external = "external"), e;
        })({}),
        I = (function (e) {
          return (
            (e["whole-item"] = "whole-item"),
            (e["inner-content"] = "inner-content"),
            e
          );
        })({}),
        S = (function (e) {
          return (
            (e.one = "one"),
            (e.leftRight = "leftRight"),
            (e.upDown = "upDown"),
            (e.up1down2 = "up1down2"),
            (e.up2down1 = "up2down1"),
            (e.left2right1 = "left2right1"),
            e
          );
        })({}),
        j = (function (e) {
          return (
            (e[0] = "0"),
            (e[1] = "1"),
            (e[2] = "2"),
            (e[3] = "3"),
            (e[4] = "4"),
            (e[5] = "5"),
            (e[6] = "6"),
            (e[7] = "7"),
            (e[8] = "8"),
            (e[9] = "9"),
            (e[10] = "10"),
            (e[11] = "11"),
            (e[12] = "12"),
            e
          );
        })({}),
        T = (function (e) {
          return (
            (e.dark = "dark"),
            (e.primary = "primary"),
            (e["secondary-light"] = "secondary-light"),
            e
          );
        })({});
    },
    irwQ: function (e, t, n) {
      "use strict";
      var o = n("rePB"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("Ji7U"),
        c = n("QH4r"),
        _ = n("q1tI"),
        u = n.n(_),
        d = u.a.createElement;
      function p(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function f(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? p(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : p(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function h(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var m = (function (e) {
        function t(e) {
          var n;
          return (
            Object(a.default)(this, t),
            ((n = h(this, t)).state = { target: e.target }),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(r.default)(t, [
            {
              key: "componentDidMount",
              value: function () {
                var e = this.props.href;
                if (window.location.href && /(https?:)?\/\//.test(e))
                  try {
                    var t = new URL(window.location.href),
                      n = new URL(e);
                    t.host !== n.host && this.setState({ target: "_blank" });
                  } catch (o) {}
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.state.target,
                  t = f(f({}, this.props), {}, { target: e });
                return d(c.c, t);
              },
            },
          ]),
          t
        );
      })(u.a.Component);
      t.a = m;
    },
    j0XM: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return c;
      });
      var o = n("rePB"),
        a = n("KQm4"),
        r = n("yWgo"),
        i = n("IdKh");
      function l(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function s(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? l(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : l(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var c = function (e) {
        var t = e.animationConfig,
          n = e.rawDuration,
          o = Object.keys(t || {});
        return (
          o.forEach(function (e) {
            var o = t[e],
              i = o.actions;
            if (Array.isArray(i)) {
              i.forEach(function (e) {
                var t = e.start,
                  a = e.end,
                  i = e.from,
                  l = e.to;
                (e.getProgress = function (e) {
                  return e;
                }),
                  (Object(r.Z)(t) || Object(r.Z)(a)) &&
                    (Object(r.Z)(t) && Object(r.Z)(a)
                      ? ((e.startPoint = t / n),
                        (e.duration = a - t),
                        (e.per = e.duration / n),
                        (e.getProgress = function (t) {
                          return Object(r.gb)((t - e.startPoint) / e.per);
                        }))
                      : Object(r.Z)(t)
                        ? ((e.startPoint = t / n),
                          (e.getProgress = function (t) {
                            return t >= e.startPoint ? 1 : 0;
                          }))
                        : ((e.startPoint = a / n),
                          (e.getProgress = function (t) {
                            return t <= e.startPoint ? 1 : 0;
                          })),
                    Object(r.Z)(i) && Object(r.Z)(l)
                      ? ((o.from = Object(r.Z)(o.from) ? o.from : i),
                        (e.diff = l - i),
                        (e.addValue = function (t) {
                          return e.diff * t;
                        }))
                      : ((o.from = i), (o.to = l)));
              });
              var l = function (e, t, n) {
                return 0 === n
                  ? t
                  : 1 === n
                    ? [e, t]
                    : [].concat(Object(a.a)(e), [t]);
              };
              o.getProgressAndValue = function (e) {
                var t = Object(r.Z)(o.from),
                  n = 0;
                if (t) {
                  var a = Object(r.Ab)(
                    i.reduce(function (t, o, a) {
                      var r = o.getProgress(e);
                      return (
                        (n = l(n, r, a)),
                        t +
                          (null === o || void 0 === o ? void 0 : o.addValue(r))
                      );
                    }, o.from),
                    o.valueFixed || 2,
                  );
                  return { progress: n, to: a };
                }
                if (o.from && o.to) {
                  i.forEach(function (t, o) {
                    var a = t.getProgress(e);
                    n = l(n, a, o);
                  });
                  var s = Array.isArray(n)
                    ? n.reduce(function (e, t) {
                        return e + t;
                      }, 0) === n.length
                    : n;
                  return { progress: n, to: s ? o.to : o.from };
                }
                return (
                  i.forEach(function (t, o) {
                    var a = t.getProgress(e);
                    n = l(n, a, o);
                  }),
                  { progress: n }
                );
              };
            }
          }),
          function (e) {
            var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            return (
              (n.progress = e),
              o.forEach(function (o) {
                var a = t[o].getProgressAndValue(e);
                (n[o] = s(s({}, n[o]), a)),
                  Array.isArray(a.progress)
                    ? a.progress.forEach(function (e) {
                        n[o].moprogress || (n[o].moprogress = []),
                          n[o].moprogress[e]
                            ? n[o].moprogress[e].set(a.progress[e])
                            : (n[o].moprogress[e] = Object(i.a)(a.progress[e]));
                      })
                    : n[o].moprogress
                      ? n[o].moprogress.set(a.progress)
                      : (n[o].moprogress = Object(i.a)(a.progress)),
                  n[o].moto
                    ? n[o].moto.set(a.to)
                    : (n[o].moto = Object(i.a)(a.to));
              }),
              n
            );
          }
        );
      };
    },
    j2DC: function (e, t, n) {
      "use strict";
      var o = n("oVml"),
        a = n("rr1i"),
        r = n("RfKB"),
        i = {};
      n("NegM")(i, n("UWiX")("iterator"), function () {
        return this;
      }),
        (e.exports = function (e, t, n) {
          (e.prototype = o(i, { next: a(1, n) })), r(e, t + " Iterator");
        });
    },
    jCXQ: function (e, t, n) {
      "use strict";
      n.d(t, "c", function () {
        return i;
      }),
        n.d(t, "a", function () {
          return l;
        }),
        n.d(t, "b", function () {
          return s;
        });
      var o = n("gn4A"),
        a = n.n(o),
        r = n("yWgo"),
        i = function (e) {
          var t = e.mobileMode,
            n = e.forceDowngrade,
            o = !1;
          if (t) {
            var i =
              a.a.isDowngrade() ||
              a.a.isUCVersionBefore(13) ||
              !!a.a.isSamsungBrowser() ||
              a.a.isWx() ||
              a.a.isObsoleteMobileDevice();
            o = n || i;
          } else {
            var l = Object(r.h)();
            o = n || l;
          }
          return [o];
        },
        l = { forceDowngrade: !1 },
        s = {
          label: "\u662f\u5426\u964d\u7ea7",
          props: {
            forceDowngrade: {
              label: "\u662f\u5426\u964d\u7ea7",
              type: "boolean",
            },
          },
        };
    },
    jXQH: function (e, t, n) {
      var o = n("TO8r"),
        a = /^\s+/;
      e.exports = function (e) {
        return e ? e.slice(0, o(e) + 1).replace(a, "") : e;
      };
    },
    jmDH: function (e, t, n) {
      e.exports = !n("KUxP")(function () {
        return (
          7 !=
          Object.defineProperty({}, "a", {
            get: function () {
              return 7;
            },
          }).a
        );
      });
    },
    jo6Y: function (e, t, n) {
      "use strict";
      (t.__esModule = !0),
        (t.default = function (e, t) {
          var n = {};
          for (var o in e)
            t.indexOf(o) >= 0 ||
              (Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]));
          return n;
        });
    },
    jpXb: function (e, t, n) {
      var o = n("wZXL");
      e.exports = new o();
    },
    juv8: function (e, t, n) {
      var o = n("MrPd"),
        a = n("hypo");
      e.exports = function (e, t, n, r) {
        var i = !n;
        n || (n = {});
        for (var l = -1, s = t.length; ++l < s; ) {
          var c = t[l],
            _ = r ? r(n[c], e[c], c, n, e) : void 0;
          void 0 === _ && (_ = e[c]), i ? a(n, c, _) : o(n, c, _);
        }
        return n;
      };
    },
    "k+1r": function (e, t, n) {
      var o = n("QkVE");
      e.exports = function (e) {
        var t = o(this, e).delete(e);
        return (this.size -= t ? 1 : 0), t;
      };
    },
    k33e: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return j;
      }),
        n.d(t, "b", function () {
          return T;
        });
      var o = n("wx14"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("md7G"),
        l = n("foSv"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = (n("Lf8g"), n("q1tI")),
        u = n.n(_),
        d = n("a6RD"),
        p = n.n(d),
        f = n("xk4V"),
        h = n.n(f),
        m = n("17x9"),
        y = n.n(m),
        b = n("FCep"),
        v = n("XnI8"),
        g = n("gn4A"),
        w = n.n(g),
        x = n("pXgs"),
        k = u.a.createElement;
      function O(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function I(e, t, n) {
        return (
          (t = Object(l.a)(t)),
          Object(i.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(l.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var S = p()(
          function () {
            return n.e(165).then(n.bind(null, "CYTQ"));
          },
          {
            ssr: !1,
            loadableGenerated: {
              webpack: function () {
                return ["CYTQ"];
              },
              modules: ["./zoom"],
            },
          },
        ),
        j = { t: function () {}, gaSend: function () {}, component_data: x.a },
        T = { zoomComponentConf: x.b },
        C = (function (e) {
          function t() {
            return Object(a.default)(this, t), I(this, t, arguments);
          }
          return (
            Object(s.a)(t, e),
            Object(r.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.component_data,
                    n = e.t,
                    a = e.gaSend,
                    r = e.zoomContainerId,
                    i = e.wrapperProps,
                    l = void 0 === i ? {} : i,
                    s = e.isInAtom,
                    c = t.zoomImageRawWidth,
                    _ = t.zoomImageRawHeight,
                    d = t.zoomTilesUrl,
                    p = t.zoomRawImageSize,
                    f = t.zoomRawImageLink,
                    m = t.zoomDownloadDesc,
                    y = t.zoomDefaultZoomLevel,
                    v = t.zoomMinZoomLevel,
                    g = t.zoomMaxZoomLevel,
                    x = t.zoomSwitch,
                    O = {
                      zoomConf: {
                        id: r || h()(),
                        tileSources: [
                          {
                            type: "zoomifytileservice",
                            width: +c,
                            height: +_,
                            tilesUrl: "string" === typeof d ? d : d && d.path,
                          },
                        ],
                        defaultZoomLevel: y || void 0,
                        minZoomLevel: v || void 0,
                        maxZoomLevel: g || void 0,
                      },
                      rawImageSize: s ? p : n(p),
                      rawImageLink: "string" === typeof f ? f : f && f.path,
                      downloadDesc: s ? m : n(m),
                    },
                    I = w.a.isWx(),
                    j = w.a.isHuawei();
                  return k(
                    u.a.Fragment,
                    null,
                    I && j
                      ? x
                        ? k(
                            S,
                            Object(o.a)(
                              {
                                gaSend: a,
                                conf: O,
                                clickDom: this.props.children,
                              },
                              this.props,
                            ),
                          )
                        : this.props.children
                      : x
                        ? k(
                            b.a,
                            l,
                            k(
                              S,
                              Object(o.a)(
                                {
                                  gaSend: a,
                                  conf: O,
                                  clickDom: this.props.children,
                                },
                                this.props,
                              ),
                            ),
                          )
                        : this.props.children,
                  );
                },
              },
            ]),
            t
          );
        })(u.a.Component);
      Object(c.a)(C, "PropTypes", {
        component_data: y.a.object,
        t: y.a.func,
        gaSend: y.a.func,
      }),
        (C.defaultProps = (function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2
              ? O(Object(n), !0).forEach(function (t) {
                  Object(c.a)(e, t, n[t]);
                })
              : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n),
                  )
                : O(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t),
                    );
                  });
          }
          return e;
        })({}, j)),
        (t.c = Object(v.a)(C));
    },
    kAMH: function (e, t, n) {
      var o = n("a0xu");
      e.exports =
        Array.isArray ||
        function (e) {
          return "Array" == o(e);
        };
    },
    kCCV: function (e, t) {
      function n(e) {
        (this.options = e), !e.deferSetup && this.setup();
      }
      (n.prototype = {
        constructor: n,
        setup: function () {
          this.options.setup && this.options.setup(), (this.initialised = !0);
        },
        on: function () {
          !this.initialised && this.setup(),
            this.options.match && this.options.match();
        },
        off: function () {
          this.options.unmatch && this.options.unmatch();
        },
        destroy: function () {
          this.options.destroy ? this.options.destroy() : this.off();
        },
        equals: function (e) {
          return this.options === e || this.options.match === e;
        },
      }),
        (e.exports = n);
    },
    kI75: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("KQm4"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("XnI8"),
        m = n("SBOM"),
        y = n("xk4V"),
        b = n.n(y),
        v = n("TSYQ"),
        g = n.n(v),
        w = n("XrJB"),
        x = n.n(w),
        k = n("/+VL"),
        O = n("QH4r"),
        I = n("S5C5"),
        S = (n("aiR1"), n("deQI"), f.a.createElement);
      function j(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var T = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t),
              ((n = j(this, t, [e])).videoDom = []),
              (n.videos = []),
              (n.replayBtn = []),
              (n.showActive = n.showActive.bind(Object(l.a)(n))),
              (n.initLayzrVideo = n.initLayzrVideo.bind(Object(l.a)(n))),
              (n.playVideo = n.playVideo.bind(Object(l.a)(n))),
              (n.videoData = []),
              Array.isArray(e.component_data.waterfallLeft) &&
                (n.videoData = n.videoData.concat(
                  e.component_data.waterfallLeft,
                )),
              Array.isArray(e.component_data.waterfallCenter) &&
                (n.videoData = n.videoData.concat(
                  e.component_data.waterfallCenter,
                )),
              Array.isArray(e.component_data.waterfallRight) &&
                (n.videoData = n.videoData.concat(
                  e.component_data.waterfallRight,
                )),
              n
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              {
                key: "scheduleVideoLoad",
                value: function (e) {
                  var t = this,
                    n = this.videoDom[e];
                  n &&
                    void 0 === n.videoLoaded &&
                    ((n.videoLoaded = !1),
                    k.a.getInstance().addNode(n, {}, [
                      function () {
                        if (n.videoLoaded) return !0;
                        t.initLayzrVideo(n);
                      },
                    ]));
                },
              },
              {
                key: "componentDidMount",
                value: function () {
                  var e = this;
                  this.props.showVideo(this), this.scheduleVideoLoad(0);
                  var t = !1;
                  k.a.getInstance().addNode(
                    this.videoDom[0],
                    {},
                    [
                      function () {
                        var n = e.videoDom[0],
                          o = n.querySelectorAll("source"),
                          a = o[0].dataset.layzrSrc,
                          r = o[0].dataset.src,
                          i =
                            void 0 === a ||
                            "" === a ||
                            "/" === a ||
                            void 0 === r ||
                            "" === r ||
                            "/" === r;
                        return (
                          !(!Number.isNaN(n.duration) || !i) ||
                          (n && !t ? (e.playVideo(n, 0), (t = !0), !0) : void 0)
                        );
                      },
                    ],
                    500,
                    !0,
                  );
                },
              },
              {
                key: "initLayzrVideo",
                value: function (e) {
                  var t = e.querySelectorAll("source"),
                    n = t[0].dataset.layzrSrc;
                  t[0].setAttribute("src", n);
                  var o = e.dataset.layzrPoster;
                  o && e.setAttribute("poster", o),
                    e.load(),
                    (e.videoLoaded = !0);
                },
              },
              {
                key: "showActive",
                value: function (e, t) {
                  this.scheduleVideoLoad(e);
                  for (var n = 0; n < this.videos.length; n += 1)
                    this.videos[n].classList.remove("active"),
                      t === this.videos[n].getAttribute("tag") &&
                        ((this.replayBtn[n].style.display = "none"),
                        this.videos[n].classList.add("active"),
                        this.playVideo(this.videoDom[n], n));
                },
              },
              {
                key: "playVideo",
                value: function (e, t) {
                  var n = this;
                  if (e && !Number.isNaN(e.duration)) {
                    var o = !1;
                    !(function a() {
                      o ||
                        (!(function (e, t) {
                          !!window.MSInputMethodContext &&
                          !!document.documentMode
                            ? (e.load && e.load(),
                              e.addEventListener("canplay", function n() {
                                t(e), e.removeEventListener("canplay", n);
                              }))
                            : t(e);
                        })(e, function (e) {
                          var t = Object.assign(e);
                          (t.currentTime = 0),
                            (function (e) {
                              var t = e.play();
                              t &&
                                t.then &&
                                "function" === typeof t.then &&
                                t.then(
                                  function () {},
                                  function () {},
                                );
                            })(t);
                        }),
                        (o = !0),
                        e.addEventListener("ended", function () {
                          n.replayBtn[t] &&
                            (n.replayBtn[t].style.display = "block");
                        }),
                        n.replayBtn[t] &&
                          n.replayBtn[t].addEventListener("click", function () {
                            var o = e.play();
                            void 0 !== o &&
                              o.then(function () {}).catch(function () {}),
                              (n.replayBtn[t].style.display = "none");
                          }));
                      var r = window.requestAnimationFrame(a);
                      o && r && window.cancelAnimationFrame(r);
                    })();
                  }
                },
              },
              {
                key: "renderVideoContent",
                value: function (e, t) {
                  var n,
                    o,
                    a = this,
                    r = this.props,
                    i = r.t,
                    l = r.component_data,
                    s = r.localization,
                    c = r.gaSend,
                    _ = r.productData,
                    u = l.themsColor,
                    d = l.leftTitleSize,
                    p = l.leftTitleLineHeight,
                    h = l.leftDescSize,
                    m = l.leftDescLineHeight,
                    y = l.leftBorderRedis,
                    b = l.btnSize,
                    v = l.btnColor,
                    g = l.btnRadius,
                    w = l.btnMinWidth,
                    k = l.width,
                    j = l.leftGridproportion,
                    T = (j / 12) * ((k || 1200) - 176) + 16 * (j - 1),
                    C = function () {
                      "store-button" === e.btnType &&
                        c(
                          "click",
                          "Accessories-".concat(i(e.title), "-Buy-Now"),
                          "".concat(
                            null === _ || void 0 === _ ? void 0 : _.slug,
                            "_detail",
                          ),
                        );
                    },
                    M =
                      "store-button" === e.btnType
                        ? Object(I.e)(
                            Object(I.k)({
                              url: "/where-to-buy",
                              country:
                                null === s || void 0 === s ? void 0 : s.country,
                              locale:
                                null === s || void 0 === s
                                  ? void 0
                                  : s.language,
                            }),
                            null === (n = e.btnLink) || void 0 === n
                              ? void 0
                              : n.path,
                            null === s || void 0 === s ? void 0 : s.country,
                          )
                        : null === (o = e.btnLink) || void 0 === o
                          ? void 0
                          : o.path,
                    P =
                      "external-button" === e.btnType ||
                      "store-button" === e.btnType
                        ? "_blank"
                        : "_self";
                  return S(
                    f.a.Fragment,
                    null,
                    S(
                      "a",
                      {
                        style: { display: "contents" },
                        href: e.hasBtn ? M : void 0,
                        target: P,
                        onClick: C,
                      },
                      S(
                        "video",
                        {
                          muted: !0,
                          name: "media",
                          style: { borderRadius: y },
                          "data-layzr-poster": e.videoPoster,
                          className: "style__accessories-video___1jS0I",
                          ref: function (e) {
                            a.videoDom[t] = e;
                          },
                        },
                        S("source", {
                          type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                          "data-layzr-src":
                            e && e.videoLink && e.videoLink.path
                              ? e.videoLink.path
                              : "",
                        }),
                      ),
                    ),
                    S(
                      "div",
                      { className: "style__text-box___ugrkw" },
                      S(
                        "div",
                        {
                          style: { width: "".concat(T - 40, "px") },
                          className: "style__introduce___12Qc4",
                        },
                        S("h5", {
                          style: { color: u, fontSize: d, lineHeight: p },
                          className: "style__title___yvJWK",
                          dangerouslySetInnerHTML: { __html: i(e.title) },
                        }),
                        S("p", {
                          style: { fontSize: h, lineHeight: m },
                          className: "style__desc___2oOJT",
                          dangerouslySetInnerHTML: { __html: i(e.desc) },
                        }),
                        e.hasBtn
                          ? S(
                              "div",
                              { className: "style__btn-wrapper___3OIPG" },
                              S(
                                O.c,
                                {
                                  size: O.a[b],
                                  onClick: C,
                                  href: M,
                                  target: P,
                                  style: {
                                    borderRadius: g || "60px",
                                    minWidth: w || "auto",
                                  },
                                  type: v,
                                },
                                S("div", {
                                  className: "",
                                  dangerouslySetInnerHTML: {
                                    __html: i(e.btnText) || "",
                                  },
                                }),
                              ),
                            )
                          : null,
                      ),
                      S(
                        "div",
                        {
                          className:
                            "accessories-replay-btn style__replay-btn-box___1TdNb",
                          ref: function (e) {
                            a.replayBtn[t] = e;
                          },
                        },
                        S(
                          "div",
                          {
                            style: { borderColor: u },
                            className:
                              "accessories-replay-btn style__replay-btn___2-kOI",
                          },
                          S(x.a, {
                            name: "fa-light-redo",
                            className: "style__icon___3cbVV",
                          }),
                        ),
                      ),
                    ),
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props.component_data.leftBorderRedis,
                    n = this.videoData.map(function (n, o) {
                      return S(
                        "li",
                        {
                          key: b()(),
                          style: { borderRadius: t },
                          className:
                            "".concat(
                              0 === o ? "active" : "",
                              " dbv-accessories",
                            ) + " style__accessories-item-video___3GYOi",
                          tag: "accessories-video".concat(o),
                          ref: function (t) {
                            e.videos[o] = t;
                          },
                        },
                        e.renderVideoContent(n, o),
                      );
                    });
                  return S(
                    "ul",
                    {
                      className:
                        "accessores-dbv style__accessories-video-ul___6mLs9",
                      ref: function (t) {
                        e.stickyDom = t;
                      },
                      tag: "sticky",
                    },
                    n,
                  );
                },
              },
            ]),
            t
          );
        })(f.a.Component),
        C = Object(h.a)(T),
        M = f.a.createElement,
        P = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "accessories-sticky-component":
              "style__accessories-sticky-component___2sRu2",
            "section-title": "style__section-title___4fVVC",
            "section-container": "style__section-container___1bUJT",
            "sticky-wrap": "style__sticky-wrap___3sSDh",
            "sticky-box": "style__sticky-box___NT0u5",
            "sticky-content": "style__sticky-content___1DXTY",
            "sticky-content-ceiling": "style__sticky-content-ceiling___1N4Ek",
            "sticky-content-ie": "style__sticky-content-ie___31F8W",
            "scroll-content": "style__scroll-content___2RLkw",
            "accessories-ul": "style__accessories-ul___2v2QY",
            waterfall: "style__waterfall___2vI53",
            "accessories-item-last": "style__accessories-item-last___2Oz0e",
            "img-box": "style__img-box___3Pbgr",
            "accessories-item": "style__accessories-item___121oZ",
            title: "style__title___yvJWK",
            "accessories-video-ul": "style__accessories-video-ul___6mLs9",
            "accessories-item-video": "style__accessories-item-video___3GYOi",
            "accessories-video": "style__accessories-video___1jS0I",
            "replay-btn": "style__replay-btn___2-kOI",
            icon: "style__icon___3cbVV",
            "text-box": "style__text-box___ugrkw",
            introduce: "style__introduce___12Qc4",
            "btn-wrapper": "style__btn-wrapper___3OIPG",
            desc: "style__desc___2oOJT",
            "replay-btn-box": "style__replay-btn-box___1TdNb",
            "accessories-sticky-component-special":
              "style__accessories-sticky-component-special___9ufd2",
            "accessories-item-special":
              "style__accessories-item-special___fvF-4",
            active: "style__active___njtxV",
            "card-active-li": "style__card-active-li___1edLT",
          },
        };
      function E(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      function L(e) {
        var t = e.itemType,
          n = e.extra,
          o = void 0 === n ? [] : n,
          a = "";
        return (
          "accessory" === t && (a = g()({ "accessories-item": !0 })),
          (a = g.a.apply(void 0, [a].concat(Object(_.a)(o))))
        );
      }
      var B = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = E(this, t, [e])).accessories = []),
            (n.showVideo = n.showVideo.bind(Object(l.a)(n))),
            (n.showVideoDom = n.showVideoDom.bind(Object(l.a)(n))),
            "undefined" === typeof document
              ? (n.isIE11 = !1)
              : (n.isIE11 =
                  !!window.MSInputMethodContext && !!document.documentMode),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "showVideoDom",
              value: function (e) {
                this.child = e;
              },
            },
            {
              key: "showVideo",
              value: function (e, t, n) {
                var o = this;
                var a = this.props,
                  r = a.gaSend,
                  i = a.productData,
                  l = a.component_data,
                  s = a.t,
                  c = l.cardActiveColor,
                  _ = l.cardBackgroundColor;
                return function () {
                  i &&
                    i.slug &&
                    r(
                      "click",
                      "accessories-".concat(s(e.title)),
                      "".concat(i.slug, "_detail"),
                    );
                  for (
                    var t = document.getElementsByClassName("accessories-item"),
                      a = 0,
                      l = 0;
                    l < t.length;
                    l += 1
                  )
                    t[l].classList.remove("card-active-li"),
                      (t[l].style.backgroundColor = _ || null),
                      t[l].getAttribute("tag") === n &&
                        ((a = l),
                        t[l].classList.add("card-active-li"),
                        (t[l].style.backgroundColor = c || null));
                  o.child.showActive(a, "accessories-video".concat(a));
                };
              },
            },
            {
              key: "render",
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.t,
                  o = t.component_data,
                  a = t.gaSend,
                  r = t.productData,
                  i = o.backgroundColorStart,
                  l = o.themsColor,
                  s = o.paddingTop,
                  c = o.paddingBottom,
                  _ = o.width,
                  u = o.leftGridproportion,
                  p = o.rightGridproportion,
                  f = o.rightTitleSize,
                  h = o.rightTitleLineHeigh,
                  y = o.rightCardDistance,
                  v = o.rightCardPadding,
                  w = o.rightBorderRedis,
                  x = o.rightTitleTop,
                  k = o.cardBackgroundColor,
                  O = o.cardActiveColor,
                  I = o.cardOverColor,
                  S = o.ceiling,
                  j = g()({ "accessories-sticky-component": !0 }),
                  T = {
                    backgroundColor: i || "#000000",
                    color: l || "#ffffff",
                    paddingTop: s,
                    paddingBottom: c,
                  },
                  E = {
                    color: l || "#ffffff",
                    fontSize: f,
                    lineHeight: h,
                    top: x,
                  },
                  B = {
                    width: "".concat(
                      (u / 12) * ((_ || 1200) - 176) + 16 * (u - 1),
                      "px",
                    ),
                  },
                  N = {
                    width: "".concat(
                      (p / 12) * ((_ || 1200) - 176) + 16 * (p - 1),
                      "px",
                    ),
                  },
                  D =
                    o && Array.isArray(o.waterfallLeft)
                      ? o.waterfallLeft.map(function (t, o) {
                          return M(
                            "div",
                            {
                              key: b()(),
                              style: {
                                marginBottom: y,
                                borderRadius: w,
                                backgroundColor: "".concat(0 === o ? O : k),
                              },
                              onClick: e.showVideo(
                                t,
                                o,
                                "accessories-left-video".concat(o),
                              ),
                              ref: function (t) {
                                (e.accessories[o] = t),
                                  t &&
                                    (t.addEventListener(
                                      "mouseover",
                                      function () {
                                        !t.classList.contains(
                                          "card-active-li",
                                        ) &&
                                          I &&
                                          (t.style.backgroundColor = I);
                                      },
                                    ),
                                    t.addEventListener("mouseout", function () {
                                      !t.classList.contains("card-active-li") &&
                                        k &&
                                        (t.style.backgroundColor = k);
                                    }));
                              },
                              tag: "accessories-left-video".concat(o),
                              className:
                                "".concat(
                                  0 === o ? "card-active-li" : "",
                                  " item accessories-item",
                                ) +
                                " " +
                                d()(L({ itemType: "accessory" }), P, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            },
                            M("h5", {
                              className: "style__title___yvJWK",
                              style: E,
                              tag: "accessories-video".concat(o),
                              dangerouslySetInnerHTML: { __html: n(t.title) },
                            }),
                            M(
                              "div",
                              {
                                className: "style__img-box___3Pbgr",
                                style: {
                                  padding: "".concat(v),
                                  minHeight: t.productImgMinHeight,
                                },
                              },
                              M(m.a, {
                                type: "img",
                                src: t.productImg,
                                tag: "accessories-video".concat(o),
                              }),
                            ),
                          );
                        })
                      : null,
                  z =
                    o && Array.isArray(o.waterfallCenter)
                      ? o.waterfallCenter.map(function (t, o) {
                          return M(
                            "div",
                            {
                              key: b()(),
                              style: {
                                marginBottom: y,
                                borderRadius: w,
                                backgroundColor: k,
                              },
                              onClick: e.showVideo(
                                t,
                                o,
                                "accessories-center-video".concat(o),
                              ),
                              ref: function (t) {
                                (e.accessories[o] = t),
                                  t &&
                                    (t.addEventListener(
                                      "mouseover",
                                      function () {
                                        !t.classList.contains(
                                          "card-active-li",
                                        ) &&
                                          I &&
                                          (t.style.backgroundColor = I);
                                      },
                                    ),
                                    t.addEventListener("mouseout", function () {
                                      !t.classList.contains("card-active-li") &&
                                        k &&
                                        (t.style.backgroundColor = k);
                                    }));
                              },
                              tag: "accessories-center-video".concat(o),
                              className:
                                "accessories-item " +
                                d()(L({ itemType: "accessory" }), P, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            },
                            M("h5", {
                              className: "style__title___yvJWK",
                              style: E,
                              tag: "accessories-video".concat(o),
                              dangerouslySetInnerHTML: { __html: n(t.title) },
                            }),
                            M(
                              "div",
                              {
                                className: "style__img-box___3Pbgr",
                                style: {
                                  padding: "".concat(v),
                                  minHeight: t.productImgMinHeight,
                                },
                              },
                              M(m.a, {
                                type: "img",
                                src: t.productImg,
                                tag: "accessories-video".concat(o),
                              }),
                            ),
                          );
                        })
                      : null,
                  A =
                    o && Array.isArray(o.waterfallRight)
                      ? o.waterfallRight.map(function (t, o) {
                          return M(
                            "div",
                            {
                              key: b()(),
                              style: {
                                marginBottom: y,
                                borderRadius: w,
                                backgroundColor: k,
                              },
                              onClick: e.showVideo(
                                t,
                                o,
                                "accessories-right-video".concat(o),
                              ),
                              ref: function (t) {
                                (e.accessories[o] = t),
                                  t &&
                                    (t.addEventListener(
                                      "mouseover",
                                      function () {
                                        !t.classList.contains(
                                          "card-active-li",
                                        ) &&
                                          I &&
                                          (t.style.backgroundColor = I);
                                      },
                                    ),
                                    t.addEventListener("mouseout", function () {
                                      !t.classList.contains("card-active-li") &&
                                        k &&
                                        (t.style.backgroundColor = k);
                                    }));
                              },
                              tag: "accessories-right-video".concat(o),
                              className:
                                "accessories-item " +
                                d()(L({ itemType: "accessory" }), P, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            },
                            M("h5", {
                              className: "style__title___yvJWK",
                              style: E,
                              tag: "accessories-video".concat(o),
                              dangerouslySetInnerHTML: { __html: n(t.title) },
                            }),
                            M(
                              "div",
                              {
                                className: "style__img-box___3Pbgr",
                                style: {
                                  padding: "".concat(v),
                                  minHeight: t.productImgMinHeight,
                                },
                              },
                              M(m.a, {
                                type: "img",
                                src: t.productImg,
                                tag: "accessories-video".concat(o),
                              }),
                            ),
                          );
                        })
                      : null;
                return M(
                  "section",
                  {
                    id: o.anchor,
                    ref: function (t) {
                      e.component = t;
                    },
                    style: T,
                    className:
                      "accessories-sticky-component " +
                      d()(j, P, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                  },
                  M(
                    "div",
                    {
                      style: { width: "".concat(_, "px") },
                      className: "style__section-container___1bUJT",
                      id: "accessories-container",
                    },
                    M(
                      "div",
                      { style: B, className: "style__sticky-wrap___3sSDh" },
                      this.isIE11
                        ? M(
                            "div",
                            {
                              className: "style__sticky-content-ie___31F8W",
                              style: { marginTop: s },
                            },
                            M(C, {
                              t: n,
                              component_data: o,
                              showVideo: this.showVideoDom,
                              gaSend: a,
                              productData: r,
                            }),
                          )
                        : M(
                            "div",
                            {
                              style: { top: s },
                              className: d()(
                                "sticky-content ".concat(
                                  S && "sticky-content-ceiling",
                                ),
                                P,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            },
                            M(C, {
                              t: n,
                              component_data: o,
                              showVideo: this.showVideoDom,
                              gaSend: a,
                              productData: r,
                            }),
                          ),
                    ),
                    M(
                      "div",
                      { style: N, className: "style__scroll-content___2RLkw" },
                      M(
                        "div",
                        { className: "style__accessories-ul___2v2QY" },
                        o &&
                          Array.isArray(o.waterfallLeft) &&
                          o.waterfallLeft.length > 0 &&
                          M(
                            "div",
                            {
                              className: "style__waterfall___2vI53",
                              style: { marginRight: y },
                            },
                            D,
                          ),
                        o &&
                          Array.isArray(o.waterfallCenter) &&
                          o.waterfallCenter.length > 0 &&
                          M(
                            "div",
                            {
                              className: "style__waterfall___2vI53",
                              style: { marginRight: y },
                            },
                            z,
                          ),
                        o &&
                          Array.isArray(o.waterfallRight) &&
                          o.waterfallRight.length > 0 &&
                          M(
                            "div",
                            {
                              className: "style__waterfall___2vI53",
                              style: { marginRight: y },
                            },
                            A,
                          ),
                      ),
                    ),
                  ),
                );
              },
            },
          ]),
          t
        );
      })(f.a.Component);
      Object(c.a)(B, "defaultProps", {
        t: function () {},
        gaSend: function () {},
        component_data: {
          rightCardPadding: "56px 16px 16px 16px",
          leftGridproportion: 5,
          rightGridproportion: 6,
          btnSize: "medium",
          btnColor: "primary",
          paddingTop: "128px",
          paddingBottom: "128px",
          cardBackgroundColor: "rgba(255, 255, 255, 0.09)",
          leftTitleSize: "16px",
          leftTitleLineHeight: "24px",
          leftDescSize: "16px",
          leftDescLineHeight: "20px",
          rightTitleSize: "14px",
          rightTitleLineHeigh: "20px",
          rightTitleTop: "16px",
          rightCardDistance: "8px",
          waterfallLeft: [
            {
              title: "\u5361\u7247\u4e3b\u6807\u9898",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff0",
              videoLink: { path: "/" },
              videoPoster:
                "//www5.djicdn.com/assets/images/products/tiny/pc_8_4_cover-85b53891b1ae6fc93b37eb2faa16b811.jpg?from=cdnMap",
              productImg:
                "//www1.djicdn.com/dps/4a18e81586d84926d0ca73632546e46c.png",
              hasBtn: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u9898",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff0",
              videoLink: { path: "/" },
              videoPoster:
                "//www5.djicdn.com/assets/images/products/tiny/pc_8_9_cover-4316bf2d98ec6c825d019494d3b3e2c8.jpg?from=cdnMap",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u9898",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff0",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
            },
          ],
          waterfallCenter: [
            {
              title: "\u5361\u7247\u4e3b\u6807\u98982",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff02",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u98982",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff02",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
            },
            {
              ttitle: "\u5361\u7247\u4e3b\u6807\u98982",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff02",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
            },
          ],
          waterfallRight: [
            {
              ttitle: "\u5361\u7247\u4e3b\u6807\u98983",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff03",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
            },
            {
              title: "\u5361\u7247\u4e3b\u6807\u98983",
              desc: "\u8fd9\u662f\u4e00\u6bb5\u5361\u7247\u7684\u63cf\u8ff0\u63cf\u8ff03",
              videoLink: { path: "/" },
              videoPoster:
                "https://www1.djicdn.com/dps/6bfbbfd2709486954523cee5b22f0b00.png",
              productImg:
                "//www1.djicdn.com/dps/8aace2f42f972560d84875f3ec92a407.png",
              hasBtn: !1,
            },
          ],
        },
      }),
        Object(c.a)(B, "editSetting", {
          key: "Accessories",
          name: "Accessories",
          contentSetting: {
            stickySetting: {
              label: "\u5de6\u5217\u914d\u4ef6\u6a21\u5757\u5438\u9876",
              props: {
                ceiling: {
                  label:
                    "\u5de6\u5217\u914d\u4ef6\u6a21\u5757\u5438\u9876\u914d\u7f6e\uff08\u9ed8\u8ba4\u4e0d\u5438\u9876\uff09",
                  type: "boolean",
                },
              },
            },
            waterfallLeft: {
              label: "\u5de6\u5217\u914d\u4ef6\u914d\u7f6e",
              props: {
                waterfallLeft: {
                  type: "array",
                  label: "\u5de6\u5217\u914d\u4ef6",
                  props: {
                    title: {
                      label: "\u914d\u4ef6title",
                      type: "string",
                      content: "text",
                    },
                    desc: {
                      label: "\u914d\u4ef6\u63cf\u8ff0",
                      type: "string",
                      content: "text",
                    },
                    videoLink: {
                      label: "\u914d\u4ef6\u89c6\u9891",
                      type: "string",
                      content: "url",
                    },
                    videoPoster: {
                      type: "image",
                      label: "\u89c6\u9891\u5360\u4f4d\u56fe",
                    },
                    videoPosterMinHeight: {
                      label:
                        "\u89c6\u9891\u5360\u4f4d\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    productImg: { type: "image", label: "\u4ea7\u54c1\u56fe" },
                    productImgMinHeight: {
                      label:
                        "\u4ea7\u54c1\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    hasBtn: {
                      type: "boolean",
                      label:
                        "\u5de6\u5217\u914d\u4ef6\u662f\u5426\u6709\u6309\u94ae",
                    },
                    btnText: {
                      label: "\u5de6\u5217\u914d\u4ef6\u6309\u94ae\u6587\u6848",
                      type: "string",
                      content: "text",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                    btnType: {
                      label: "\u5de6\u5217\u914d\u4ef6\u6309\u94ae\u7c7b\u578b",
                      type: "select",
                      controlBy: "hasBtn",
                      controlValue: !0,
                      items: [
                        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                      ],
                    },
                    btnLink: {
                      type: "string",
                      content: "url",
                      label: "\u5de6\u5217\u914d\u4ef6\u6309\u94ae\u94fe\u63a5",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                  },
                },
              },
            },
            waterfallCenter: {
              label: "\u4e2d\u5217\u6a21\u5757\u914d\u7f6e",
              props: {
                waterfallCenter: {
                  type: "array",
                  label: "\u4e2d\u5217\u914d\u4ef6",
                  props: {
                    title: {
                      label: "\u914d\u4ef6title",
                      type: "string",
                      content: "text",
                    },
                    desc: {
                      label: "\u914d\u4ef6\u63cf\u8ff0",
                      type: "string",
                      content: "text",
                    },
                    videoLink: {
                      label: "\u89c6\u9891",
                      type: "string",
                      content: "url",
                    },
                    videoPoster: {
                      type: "image",
                      label: "\u89c6\u9891\u5360\u4f4d\u56fe",
                    },
                    videoPosterMinHeight: {
                      label:
                        "\u89c6\u9891\u5360\u4f4d\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    productImg: { type: "image", label: "\u4ea7\u54c1\u56fe" },
                    productImgMinHeight: {
                      label:
                        "\u4ea7\u54c1\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    hasBtn: {
                      type: "boolean",
                      label:
                        "\u4e2d\u5217\u914d\u4ef6\u662f\u5426\u6709\u6309\u94ae",
                    },
                    btnText: {
                      label: "\u4e2d\u5217\u914d\u4ef6\u6309\u94ae\u6587\u6848",
                      type: "string",
                      content: "text",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                    btnType: {
                      label: "\u4e2d\u5217\u914d\u4ef6\u6309\u94ae\u7c7b\u578b",
                      type: "select",
                      controlBy: "hasBtn",
                      controlValue: !0,
                      items: [
                        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                      ],
                    },
                    btnLink: {
                      type: "string",
                      content: "url",
                      label: "\u4e2d\u5217\u914d\u4ef6\u6309\u94ae\u94fe\u63a5",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                  },
                },
              },
            },
            waterfallRight: {
              label: "\u53f3\u5217\u914d\u4ef6\u914d\u7f6e",
              props: {
                waterfallRight: {
                  type: "array",
                  label: "\u53f3\u5217\u914d\u4ef6",
                  props: {
                    title: {
                      label: "\u914d\u4ef6title",
                      type: "string",
                      content: "text",
                    },
                    desc: {
                      label: "\u914d\u4ef6\u63cf\u8ff0",
                      type: "string",
                      content: "text",
                    },
                    videoLink: {
                      label: "\u89c6\u9891",
                      type: "string",
                      content: "url",
                    },
                    videoPoster: {
                      type: "image",
                      label: "\u89c6\u9891\u5360\u4f4d\u56fe",
                    },
                    videoPosterMinHeight: {
                      label:
                        "\u89c6\u9891\u5360\u4f4d\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    productImg: { type: "image", label: "\u4ea7\u54c1\u56fe" },
                    productImgMinHeight: {
                      label:
                        "\u4ea7\u54c1\u56fe\u6700\u5c0f\u9ad8\u5ea6(\u5e26\u5355\u4f4d,\u9632\u6b62\u56fe\u7247\u672a\u52a0\u8f7d\u65f6\u9ad8\u5ea6\u584c\u9677\uff09",
                      type: "string",
                    },
                    hasBtn: {
                      type: "boolean",
                      label:
                        "\u53f3\u5217\u914d\u4ef6\u662f\u5426\u6709\u6309\u94ae",
                    },
                    btnText: {
                      label: "\u53f3\u5217\u914d\u4ef6\u6309\u94ae\u6587\u6848",
                      type: "string",
                      content: "text",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                    btnType: {
                      label: "\u53f3\u5217\u914d\u4ef6\u6309\u94ae\u7c7b\u578b",
                      type: "select",
                      controlBy: "hasBtn",
                      controlValue: !0,
                      items: [
                        { label: "\u7ad9\u5185\u6309\u94ae", value: "button" },
                        {
                          value: "external-button",
                          label: "\u7ad9\u5916\u6309\u94ae",
                        },
                        {
                          value: "store-button",
                          label: "\u5546\u57ce\u6309\u94ae",
                        },
                      ],
                    },
                    btnLink: {
                      type: "string",
                      content: "url",
                      label: "\u53f3\u5217\u914d\u4ef6\u6309\u94ae\u94fe\u63a5",
                      controlBy: "hasBtn",
                      controlValue: !0,
                    },
                  },
                },
              },
            },
          },
          skinSetting: {
            themsSeting: {
              label: "\u7ec4\u4ef6\u4e3b\u9898\u81ea\u5b9a\u4e49\u8bbe\u7f6e",
              props: {
                themsColor: {
                  label:
                    "\u5b57\u4f53\u989c\u8272\uff08\u5b57\u4f53\u548c\u64ad\u653e\u6309\u94ae\u7684\u989c\u8272)",
                  type: "string",
                  content: "color",
                },
                backgroundColorStart: {
                  label: "\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
              },
            },
            layoutSeting: {
              label: "\u7ec4\u4ef6\u5e03\u5c40\u8bbe\u7f6e",
              props: {
                paddingTop: {
                  label: "\u6a21\u5757\u4e0a\u8fb9\u8ddd",
                  type: "string",
                },
                paddingBottom: {
                  label: "\u6a21\u5757\u4e0b\u8fb9\u8ddd",
                  type: "string",
                },
                width: {
                  label:
                    "\u5bbd\u5ea6 \u9ed8\u8ba4\uff081200\uff09\u4e0d\u5e26\u5355\u4f4d",
                  type: "number",
                },
                leftGridproportion: {
                  label:
                    "\u5de6\u4fa7\u7684\u6805\u683c\u5360\u6bd4\uff081-11\uff09",
                  type: "select",
                  items: [
                    { label: "1", value: 1 },
                    { label: "2", value: 2 },
                    { label: "3", value: 3 },
                    { label: "4", value: 4 },
                    { label: "5", value: 5 },
                    { label: "6", value: 6 },
                    { label: "7", value: 7 },
                    { label: "8", value: 8 },
                    { label: "9", value: 9 },
                    { label: "10", value: 10 },
                    { label: "11", value: 11 },
                  ],
                },
                rightGridproportion: {
                  label:
                    "\u53f3\u4fa7\u7684\u6805\u683c\u5360\u6bd4 \uff081-11\uff09",
                  type: "select",
                  items: [
                    { label: "1", value: 1 },
                    { label: "2", value: 2 },
                    { label: "3", value: 3 },
                    { label: "4", value: 4 },
                    { label: "5", value: 5 },
                    { label: "6", value: 6 },
                    { label: "7", value: 7 },
                    { label: "8", value: 8 },
                    { label: "9", value: 9 },
                    { label: "10", value: 10 },
                    { label: "11", value: 11 },
                  ],
                },
                anchor: {
                  type: "string",
                  content: "size",
                  label: "\u951a\u70b9",
                },
              },
            },
            cardSeting: {
              label: "\u914d\u4ef6\u4ea7\u54c1\u56fe\u8bbe\u7f6e",
              props: {
                cardBackgroundColor: {
                  label: "\u914d\u4ef6\u5361\u7247\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
                cardActiveColor: {
                  label:
                    "\u5361\u7247\u9009\u4e2d\u65f6\u7684\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "color",
                },
                cardOverColor: {
                  label:
                    "\u9f20\u6807\u60ac\u6d6e\u5361\u7247\u80cc\u666f\u8272",
                  type: "string",
                  content: "color",
                },
                rightCardDistance: {
                  label: "\u5361\u7247\u95f4\u7684\u8ddd\u79bb",
                  type: "string",
                },
                rightCardPadding: {
                  label: "\u5361\u7247\u56fe\u7247\u5185\u95f4\u8ddd",
                  type: "string",
                },
                rightBorderRedis: {
                  label: "\u5361\u7247\u5706\u89d2",
                  type: "string",
                },
                rightTitleSize: {
                  label: "\u5361\u7247\u6807\u9898\u5b57\u4f53\u5927\u5c0f",
                  type: "string",
                },
                rightTitleLineHeigh: {
                  label: "\u5361\u7247\u6807\u9898\u884c\u9ad8",
                  type: "string",
                },
                rightTitleTop: {
                  label:
                    "\u5361\u7247\u6807\u9898\u8ddd\u79bb\u9876\u7aef\u5b9a\u4f4d",
                  type: "string",
                },
              },
            },
            videoSeting: {
              label: "\u89c6\u9891\u6a21\u5757\u8bbe\u7f6e",
              props: {
                leftTitleSize: {
                  label: "\u6807\u9898\u5b57\u4f53\u5927\u5c0f",
                  type: "string",
                },
                leftTitleLineHeight: {
                  label: "\u6807\u9898\u884c\u9ad8",
                  type: "string",
                },
                leftDescSize: {
                  label: "\u63cf\u8ff0\u5b57\u4f53\u5927\u5c0f",
                  type: "string",
                },
                leftDescLineHeight: {
                  label: "\u63cf\u8ff0\u884c\u9ad8",
                  type: "string",
                },
                leftBorderRedis: {
                  label: "\u89c6\u9891\u5706\u89d2",
                  type: "string",
                },
              },
            },
            btnStyle: {
              label: "\u6309\u94ae\u6837\u5f0f\u914d\u7f6e",
              props: {
                btnColor: {
                  label: "\u6309\u94ae\u4e3b\u9898\u8272",
                  type: "select",
                  items: [
                    {
                      label:
                        "\u4e00\u7ea7\u4e3b\u8981\u6309\u94ae\uff08\u84dd\u8272\uff09",
                      value: "primary",
                    },
                    {
                      label:
                        "\u4e00\u7ea7\u6df1\u8272\u6309\u94ae\uff08\u5b9e\u5fc3\u9ed1\u8272\uff09",
                      value: "dark",
                    },
                    {
                      label:
                        "\u4e00\u7ea7\u6d45\u8272\u6309\u94ae\uff08\u5b9e\u5fc3\u767d\u8272\uff09",
                      value: "light",
                    },
                    {
                      label:
                        "\u4e8c\u7ea7\u6df1\u8272\u6309\u94ae\uff08\u7a7a\u5fc3\u9ed1\u8272\uff09",
                      value: "secondary-dark",
                    },
                    {
                      label:
                        "\u4e8c\u7ea7\u6d45\u8272\u6309\u94ae\uff08\u7a7a\u5fc3\u767d\u8272\uff09",
                      value: "secondary-light",
                    },
                  ],
                },
                btnMinWidth: {
                  label:
                    "\u6700\u5c0f\u5bbd\u5ea6(\u9700\u201cpx\u201d), \u9ed8\u8ba4auto",
                  type: "string",
                },
                btnRadius: {
                  label: "\u6309\u94ae\u5706\u89d2",
                  type: "string",
                },
                btnSize: {
                  label: "\u6309\u94ae\u5c3a\u5bf8",
                  type: "select",
                  items: [
                    { value: "x-large", label: "xl(48)" },
                    { value: "large", label: "l(40)" },
                    { value: "medium", label: "m(32)" },
                    { value: "small", label: "s(24)" },
                  ],
                },
              },
            },
          },
        });
      t.a = Object(h.a)(B);
    },
    kTiW: function (e, t, n) {
      e.exports = n("NegM");
    },
    kekF: function (e, t) {
      e.exports = function (e, t) {
        return function (n) {
          return e(t(n));
        };
      };
    },
    ku9G: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      });
      var o = n("vtNx"),
        a = function (e, t) {
          e &&
            -1 !== Object.values(o.a).indexOf(e) &&
            window.sensors &&
            window.sensors.track(
              e,
              Object.assign(t, {
                app_ucid: window.app_ucid,
                platform_type: "web",
              }),
            );
        };
    },
    kwZ1: function (e, t, n) {
      "use strict";
      var o = n("jmDH"),
        a = n("w6GO"),
        r = n("mqlF"),
        i = n("NV0k"),
        l = n("JB68"),
        s = n("M1xp"),
        c = Object.assign;
      e.exports =
        !c ||
        n("KUxP")(function () {
          var e = {},
            t = {},
            n = Symbol(),
            o = "abcdefghijklmnopqrst";
          return (
            (e[n] = 7),
            o.split("").forEach(function (e) {
              t[e] = e;
            }),
            7 != c({}, e)[n] || Object.keys(c({}, t)).join("") != o
          );
        })
          ? function (e, t) {
              for (
                var n = l(e), c = arguments.length, _ = 1, u = r.f, d = i.f;
                c > _;

              )
                for (
                  var p,
                    f = s(arguments[_++]),
                    h = u ? a(f).concat(u(f)) : a(f),
                    m = h.length,
                    y = 0;
                  m > y;

                )
                  (p = h[y++]), (o && !d.call(f, p)) || (n[p] = f[p]);
              return n;
            }
          : c;
    },
    kyQ6: function (e, t, n) {
      e.exports = {
        "hidden-text": "index__hidden-text___3_Kwy",
        "shown-text": "index__shown-text___2fpW2",
        "site-footer": "index__site-footer___3p9Tx",
        "footer-container": "index__footer-container___18PMZ",
        "footer-item": "index__footer-item___3YvKv",
        "footer-category": "index__footer-category___1zZV2",
        "nav-item": "index__nav-item___1iib8",
        subscribe: "index__subscribe___1I0dW",
        title: "index__title___2Lsco",
        "footer-column": "index__footer-column___2ZhHV",
        tip: "index__tip___2_3BY",
        "form-input": "index__form-input___ZkfKL",
        content: "index__content___1Rt1U",
        "form-submit": "index__form-submit___37FVb",
        "is-valid": "index__is-valid___1gA8p",
        "form-submit-icon": "index__form-submit-icon___1VKqP",
        "footer-about": "index__footer-about___2SXPA",
        "footer-nav": "index__footer-nav___2JLAj",
        "nav-brand": "index__nav-brand___yFkr1",
        gray: "index__gray___3r5bg",
        white: "index__white___1q2jz",
        "nav-right": "index__nav-right___NEmbn",
        "footer-social": "index__footer-social___1Wk4o",
        popup: "index__popup___uXrEe",
        "er-code": "index__er-code___bF-i4",
        triangle: "index__triangle___110j9",
        "social-wechat": "index__social-wechat___2WTL7",
        "footer-bottom": "index__footer-bottom___2jGCt",
        "footer-legal": "index__footer-legal___Bppas",
        "legal-links": "index__legal-links___CRALb",
        "footer-feedback": "index__footer-feedback___-We0L",
        "footer-ad-desc": "index__footer-ad-desc___2amAE",
        copyright: "index__copyright___14POp",
        "footer-add-desc-cn": "index__footer-add-desc-cn___1EGeF",
        "ad-desc": "index__ad-desc___3C_Oo",
        "footer-locale": "index__footer-locale___2-iqf",
        "icon-locale": "index__icon-locale___3OQRE",
        "fa-angle-up": "index__fa-angle-up___d2Hir",
        "select-locale": "index__select-locale___3fH7G",
        "show-panel": "index__show-panel___2rxwM",
        "dui-dropdown-menu": "index__dui-dropdown-menu___1m0rP",
        "change-language": "index__change-language___MzaB-",
        active: "index__active___3XI5O",
        "fa-angle-down": "index__fa-angle-down___2v3oI",
        "footer-change-country": "index__footer-change-country___3sH25",
        "change-locale": "index__change-locale___2OADp",
        "select-country": "index__select-country___31iN6",
        "country-panel": "index__country-panel___bUKsq",
        "country-header": "index__country-header___IeHBM",
        "country-body": "index__country-body___20U_V",
        countrybox: "index__countrybox___1GxHI",
        "countrybox--title": "index__countrybox--title___1T9qJ",
        "countrylist--item": "index__countrylist--item___3D_Au",
        "country-header--close": "index__country-header--close___1L6ZY",
        countrylist: "index__countrylist___1ZW6P",
        "countrylist--desc": "index__countrylist--desc___U_BKV",
        "countrylist--lang": "index__countrylist--lang___OWcJX",
        hidden: "index__hidden___MnUKn",
        "dji-ag-auto": "index__dji-ag-auto___276X5",
        "site-footer__light": "index__site-footer__light___2VrAm",
      };
    },
    l6NK: function (e, t, n) {
      e.exports = {
        "atom-horizontal-tabs": "style__atom-horizontal-tabs___3TqKI",
        "card-wrapper": "style__card-wrapper___3qAFX",
        mobile: "style__mobile___3r15Z",
        "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___AydlZ",
        "tab-bar-box": "style__tab-bar-box___3-e5c",
        "tab-item": "style__tab-item___1FMYw",
        "tab-content": "style__tab-content___34O_4",
        dark: "style__dark___Zy-jP",
        "tab-bar-wrap": "style__tab-bar-wrap___36K2U",
        light: "style__light___M5dzS",
        "atom-horizontal-tab-content":
          "style__atom-horizontal-tab-content___1b6xw",
        "atom-horizontal-tab-bisection":
          "style__atom-horizontal-tab-bisection___2Iejq",
        "atom-horizontal-tabs-left": "style__atom-horizontal-tabs-left___1AZgc",
        "atom-horizontal-tabs-center":
          "style__atom-horizontal-tabs-center___dMxey",
        "atom-horizontal-tabs-right":
          "style__atom-horizontal-tabs-right___32IDK",
        "tab-bar-wrapper": "style__tab-bar-wrapper___3Eodm",
        text: "style__text___3HqYI",
        "aotm-horizontal-tab-inkbar":
          "style__aotm-horizontal-tab-inkbar___13fHx",
        "atom-horizontal-tab-bar-theme-dark":
          "style__atom-horizontal-tab-bar-theme-dark___19ufo",
        "tab-item-active": "style__tab-item-active___JRqMK",
        "tab-hover-icon": "style__tab-hover-icon___xsD_s",
        "tab-icon": "style__tab-icon___2lHss",
        "atom-horizontal-tab-bar-theme-light":
          "style__atom-horizontal-tab-bar-theme-light___3xfW_",
        "atom-horizontal-tab-bar-left":
          "style__atom-horizontal-tab-bar-left___3Qt1H",
        "atom-horizontal-tab-bar-center":
          "style__atom-horizontal-tab-bar-center___1cgj1",
        "atom-horizontal-tab-content-left":
          "style__atom-horizontal-tab-content-left___lDl0k",
        "atom-horizontal-tab-content-center":
          "style__atom-horizontal-tab-content-center___AVe2v",
        "atom-horizontal-tab-content-right":
          "style__atom-horizontal-tab-content-right___1lRB-",
        "atom-horizontal-tabs-content-theme-dark":
          "style__atom-horizontal-tabs-content-theme-dark___2p08c",
        "tab-panel": "style__tab-panel___2BLpQ",
        "atom-horizontal-tabs-content-theme-light":
          "style__atom-horizontal-tabs-content-theme-light___1S7Ux",
        "tab-panel-active": "style__tab-panel-active___1DyaN",
        "scenario-tab-bar": "style__scenario-tab-bar___2M_X8",
        pc: "style__pc___2iq02",
      };
    },
    lBcN: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("rePB"),
        c = n("iKuz"),
        _ = n.n(c),
        u = n("q1tI"),
        d = n.n(u),
        p = n("XnI8"),
        f = n("yWgo"),
        h = (n("6A9R"), n("gpTt")),
        m = n("S5C5"),
        y = d.a.createElement;
      function b(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var v = {
          "./style.css": {
            "floating-button": "style__floating-button___3JFqx",
            button: "style__button___2kMoR",
            notification: "style__notification___-cIRj",
            active: "style__active___H2Pfs",
            content: "style__content___nD_l_",
            "notification-safari": "style__notification-safari___nP_NM",
            "button-safari": "style__button-safari___3v8lO",
          },
        },
        g = function (e) {
          var t = e.mobileMode,
            n = e.gaSend,
            o = e.supportFloat,
            a = e.localization,
            r = e.subdomain,
            i = a.country,
            l = a.language,
            s = Object(u.useState)(!1),
            c = s[0],
            d = s[1],
            p = Object(u.useState)(!1),
            b = p[0],
            g = p[1],
            w = Object(u.useRef)(null),
            x =
              "store-path" ===
              (null === o || void 0 === o ? void 0 : o.link_type)
                ? Object(m.k)({
                    domain: "store",
                    url: o.link_url,
                    country: i,
                    locale: l,
                  })
                : Object(h.a)({
                    link: o.link_url,
                    linkType: o.link_type,
                    from: "support_floats",
                    localization: a,
                    mobileMode: t,
                    site: r || "brandsite",
                  }),
            k = o.description,
            O = o.icon;
          Object(u.useEffect)(function () {
            window.ABTest || (window.ABTest = {}),
              (window.ABTest.showProductFloating = function () {
                g(!0),
                  setTimeout(function () {
                    d(!0);
                  }, 300),
                  setTimeout(function () {
                    d(!1);
                  }, 5e3);
              });
          }, []);
          var I = function () {
            !t && d(!0),
              n("float_button", "hover", "service_hover"),
              w.current.classList.remove("active");
          };
          return b
            ? y(
                "div",
                { className: "style__floating-button___3JFqx" },
                y(
                  "div",
                  {
                    className: _()(
                      "notification "
                        .concat(c ? "active" : "", " ")
                        .concat(
                          !t && Object(f.p)() ? "notification-safari" : "",
                        ),
                      v,
                      {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      },
                    ),
                  },
                  y("div", { className: "style__content___nD_l_" }, k),
                ),
                y("button", {
                  type: "button",
                  style: { backgroundImage: "url(".concat(O, ")") },
                  onMouseLeave: function () {
                    return d(!1);
                  },
                  onBlur: function () {
                    return d(!1);
                  },
                  onMouseEnter: function () {
                    return I();
                  },
                  onFocus: function () {
                    return I();
                  },
                  onClick: function () {
                    return (function () {
                      if (
                        (d(!1), n("float_button", "click", "service_click"), t)
                      ) {
                        var e = (window.screen.availHeight - 30 - 667) / 2,
                          o = (window.screen.availWidth - 10 - 375) / 2;
                        window.open(
                          x,
                          "",
                          "width=375,height=667,top="
                            .concat(e, ",left=")
                            .concat(o, ",scrollbars=yes,resizable=yes"),
                        );
                      } else {
                        var a = (window.screen.availHeight - 30 - 630) / 2,
                          r = (window.screen.availWidth - 10 - 768) / 2;
                        window.open(
                          x,
                          "",
                          "width=768,height=630,top="
                            .concat(a, ",left=")
                            .concat(r, ",scrollbars=yes,resizable=yes"),
                        ),
                          w.current.blur(),
                          w.current.classList.add("active");
                      }
                    })();
                  },
                  ref: w,
                  className: _()(
                    "button ".concat(
                      !t && Object(f.p)() ? "button-safari" : "",
                    ),
                    v,
                    {
                      autoResolveMultipleImports: !0,
                      handleMissingStyleName: "warn",
                    },
                  ),
                }),
              )
            : null;
        },
        w = (function (e) {
          function t() {
            return Object(o.default)(this, t), b(this, t, arguments);
          }
          return (
            Object(l.a)(t, e),
            Object(a.default)(t, [
              {
                key: "render",
                value: function () {
                  var e = this.props,
                    t = e.mobileMode,
                    n = e.t,
                    o = e.gaSend,
                    a = e.support_floats,
                    r = e.localization,
                    i = e.subdomain;
                  return y(g, {
                    gaSend: o,
                    mobileMode: t,
                    t: n,
                    supportFloat: a,
                    localization: r,
                    subdomain: i,
                  });
                },
              },
            ]),
            t
          );
        })(d.a.PureComponent);
      Object(s.a)(w, "defaultProps", {
        t: function () {},
        gaSend: function () {},
        mobileMode: !1,
      }),
        Object(s.a)(w, "propSettings", {
          key: "FloatButton",
          name: "FloatButton",
          contentSetting: {},
          skinSetting: {},
        }),
        (t.a = Object(p.a)(w));
    },
    lCc8: function (e, t, n) {
      var o = n("Y7ZC");
      o(o.S, "Object", { create: n("oVml") });
    },
    lSCD: function (e, t, n) {
      var o = n("NykK"),
        a = n("GoyQ"),
        r = "[object AsyncFunction]",
        i = "[object Function]",
        l = "[object GeneratorFunction]",
        s = "[object Proxy]";
      e.exports = function (e) {
        if (!a(e)) return !1;
        var t = o(e);
        return t == i || t == l || t == r || t == s;
      };
    },
    lT4e: function (e, t, n) {
      "use strict";
      var o = n("Qetd"),
        a = {};
      var r = function (e) {};
      function i(e, t, n, o, a, i, l, s) {
        if ((r(t), !e)) {
          var c;
          if (void 0 === t)
            c = new Error(
              "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.",
            );
          else {
            var _ = [n, o, a, i, l, s],
              u = 0;
            (c = new Error(
              t.replace(/%s/g, function () {
                return _[u++];
              }),
            )).name = "Invariant Violation";
          }
          throw ((c.framesToPop = 1), c);
        }
      }
      var l = "mixins";
      e.exports = function (e, t, n) {
        var r = [],
          s = {
            mixins: "DEFINE_MANY",
            statics: "DEFINE_MANY",
            propTypes: "DEFINE_MANY",
            contextTypes: "DEFINE_MANY",
            childContextTypes: "DEFINE_MANY",
            getDefaultProps: "DEFINE_MANY_MERGED",
            getInitialState: "DEFINE_MANY_MERGED",
            getChildContext: "DEFINE_MANY_MERGED",
            render: "DEFINE_ONCE",
            componentWillMount: "DEFINE_MANY",
            componentDidMount: "DEFINE_MANY",
            componentWillReceiveProps: "DEFINE_MANY",
            shouldComponentUpdate: "DEFINE_ONCE",
            componentWillUpdate: "DEFINE_MANY",
            componentDidUpdate: "DEFINE_MANY",
            componentWillUnmount: "DEFINE_MANY",
            UNSAFE_componentWillMount: "DEFINE_MANY",
            UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
            UNSAFE_componentWillUpdate: "DEFINE_MANY",
            updateComponent: "OVERRIDE_BASE",
          },
          c = { getDerivedStateFromProps: "DEFINE_MANY_MERGED" },
          _ = {
            displayName: function (e, t) {
              e.displayName = t;
            },
            mixins: function (e, t) {
              if (t) for (var n = 0; n < t.length; n++) d(e, t[n]);
            },
            childContextTypes: function (e, t) {
              e.childContextTypes = o({}, e.childContextTypes, t);
            },
            contextTypes: function (e, t) {
              e.contextTypes = o({}, e.contextTypes, t);
            },
            getDefaultProps: function (e, t) {
              e.getDefaultProps
                ? (e.getDefaultProps = f(e.getDefaultProps, t))
                : (e.getDefaultProps = t);
            },
            propTypes: function (e, t) {
              e.propTypes = o({}, e.propTypes, t);
            },
            statics: function (e, t) {
              !(function (e, t) {
                if (!t) return;
                for (var n in t) {
                  var o = t[n];
                  if (t.hasOwnProperty(n)) {
                    if (
                      (i(
                        !(n in _),
                        'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',
                        n,
                      ),
                      n in e)
                    )
                      return (
                        i(
                          "DEFINE_MANY_MERGED" ===
                            (c.hasOwnProperty(n) ? c[n] : null),
                          "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
                          n,
                        ),
                        void (e[n] = f(e[n], o))
                      );
                    e[n] = o;
                  }
                }
              })(e, t);
            },
            autobind: function () {},
          };
        function u(e, t) {
          var n = s.hasOwnProperty(t) ? s[t] : null;
          v.hasOwnProperty(t) &&
            i(
              "OVERRIDE_BASE" === n,
              "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",
              t,
            ),
            e &&
              i(
                "DEFINE_MANY" === n || "DEFINE_MANY_MERGED" === n,
                "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
                t,
              );
        }
        function d(e, n) {
          if (n) {
            i(
              "function" !== typeof n,
              "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.",
            ),
              i(
                !t(n),
                "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.",
              );
            var o = e.prototype,
              a = o.__reactAutoBindPairs;
            for (var r in (n.hasOwnProperty(l) && _.mixins(e, n.mixins), n))
              if (n.hasOwnProperty(r) && r !== l) {
                var c = n[r],
                  d = o.hasOwnProperty(r);
                if ((u(d, r), _.hasOwnProperty(r))) _[r](e, c);
                else {
                  var p = s.hasOwnProperty(r);
                  if ("function" === typeof c && !p && !d && !1 !== n.autobind)
                    a.push(r, c), (o[r] = c);
                  else if (d) {
                    var m = s[r];
                    i(
                      p && ("DEFINE_MANY_MERGED" === m || "DEFINE_MANY" === m),
                      "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",
                      m,
                      r,
                    ),
                      "DEFINE_MANY_MERGED" === m
                        ? (o[r] = f(o[r], c))
                        : "DEFINE_MANY" === m && (o[r] = h(o[r], c));
                  } else o[r] = c;
                }
              }
          } else;
        }
        function p(e, t) {
          for (var n in (i(
            e && t && "object" === typeof e && "object" === typeof t,
            "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.",
          ),
          t))
            t.hasOwnProperty(n) &&
              (i(
                void 0 === e[n],
                "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",
                n,
              ),
              (e[n] = t[n]));
          return e;
        }
        function f(e, t) {
          return function () {
            var n = e.apply(this, arguments),
              o = t.apply(this, arguments);
            if (null == n) return o;
            if (null == o) return n;
            var a = {};
            return p(a, n), p(a, o), a;
          };
        }
        function h(e, t) {
          return function () {
            e.apply(this, arguments), t.apply(this, arguments);
          };
        }
        function m(e, t) {
          return t.bind(e);
        }
        var y = {
            componentDidMount: function () {
              this.__isMounted = !0;
            },
          },
          b = {
            componentWillUnmount: function () {
              this.__isMounted = !1;
            },
          },
          v = {
            replaceState: function (e, t) {
              this.updater.enqueueReplaceState(this, e, t);
            },
            isMounted: function () {
              return !!this.__isMounted;
            },
          },
          g = function () {};
        return (
          o(g.prototype, e.prototype, v),
          function (e) {
            var t = function (e, o, r) {
              this.__reactAutoBindPairs.length &&
                (function (e) {
                  for (
                    var t = e.__reactAutoBindPairs, n = 0;
                    n < t.length;
                    n += 2
                  ) {
                    var o = t[n],
                      a = t[n + 1];
                    e[o] = m(e, a);
                  }
                })(this),
                (this.props = e),
                (this.context = o),
                (this.refs = a),
                (this.updater = r || n),
                (this.state = null);
              var l = this.getInitialState ? this.getInitialState() : null;
              i(
                "object" === typeof l && !Array.isArray(l),
                "%s.getInitialState(): must return an object or null",
                t.displayName || "ReactCompositeComponent",
              ),
                (this.state = l);
            };
            for (var o in ((t.prototype = new g()),
            (t.prototype.constructor = t),
            (t.prototype.__reactAutoBindPairs = []),
            r.forEach(d.bind(null, t)),
            d(t, y),
            d(t, e),
            d(t, b),
            t.getDefaultProps && (t.defaultProps = t.getDefaultProps()),
            i(
              t.prototype.render,
              "createClass(...): Class specification must implement a `render` method.",
            ),
            s))
              t.prototype[o] || (t.prototype[o] = null);
            return t;
          }
        );
      };
    },
    ljhN: function (e, t) {
      e.exports = function (e, t) {
        return e === t || (e !== e && t !== t);
      };
    },
    m1cH: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o,
        a = n("rfXi"),
        r = (o = a) && o.__esModule ? o : { default: o };
      t.default = function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
          return n;
        }
        return (0, r.default)(e);
      };
    },
    mAH3: function (e, t, n) {
      "use strict";
      var o = n("ODXe"),
        a = n("rePB"),
        r = n("iKuz"),
        i = n.n(r),
        l = n("q1tI"),
        s = n.n(l),
        c = n("mrSG"),
        _ = n("1RGQ"),
        u = function (e) {
          return (function (e) {
            return "object" === typeof e && e.mix;
          })(e)
            ? e.mix
            : void 0;
        };
      var d = n("oyjV"),
        p = n("J4/h");
      function f(e, t, n, o) {
        var a =
          "function" === typeof t
            ? t
            : (function () {
                for (var e = [], t = 0; t < arguments.length; t++)
                  e[t] = arguments[t];
                var n = !Array.isArray(e[0]),
                  o = n ? 0 : -1,
                  a = e[0 + o],
                  r = e[1 + o],
                  i = e[2 + o],
                  l = e[3 + o],
                  s = Object(_.a)(r, i, Object(c.a)({ mixer: u(i[0]) }, l));
                return n ? s(a) : s;
              })(t, n, o);
        return Array.isArray(e)
          ? h(e, a)
          : h([e], function (e) {
              var t = Object(c.c)(e, 1)[0];
              return a(t);
            });
      }
      function h(e, t) {
        var n = Object(p.a)(function () {
          return [];
        });
        return Object(d.a)(e, function () {
          n.length = 0;
          for (var o = e.length, a = 0; a < o; a++) n[a] = e[a].get();
          return t(n);
        });
      }
      var m = n("ATyU"),
        y = n("XnI8"),
        b = n("SBOM"),
        v = n("3vbH"),
        g = n("gn4A"),
        w = n.n(g),
        x = n("yWgo"),
        k = n("jCXQ"),
        O = n("DdlN"),
        I = n("IrEl"),
        S = n("fi7q");
      function j(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function T(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? j(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : j(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var C = {
          t: function () {},
          gaSend: function () {},
          component_data: T(
            T({}, k.a),
            {},
            {
              eyebrow: "",
              headline: "",
              sectionBg: "",
              downgradeMarginTop: "",
              downgradeMarginBottom: "",
              bgVideoLinkMp4: { path: "" },
              bgVideoLinkWebm: { path: "" },
              bgVideoPoster: "",
              playOnce: !1,
            },
          ),
        },
        M = {
          key: "BgZoomOut",
          name: "BgZoomOut",
          contentSetting: {
            smallScreenSetting: {
              label: "\u5c0f\u5c4f\u914d\u7f6e",
              switch: "hasMediaScreen",
              props: {
                mediaPoint: S.a,
                copywritingTemplate: {
                  label: "\u6587\u6848\u6a21\u7248",
                  type: "select",
                  items: [].concat([
                    {
                      label:
                        "\u9ed8\u8ba4 - \u5927\u6807\u989864px\uff5c\u63cf\u8ff032px\uff5c\u7709\u593424px",
                      value: "default",
                    },
                  ]),
                },
              },
            },
            context: {
              label: "\u6587\u6848\u914d\u7f6e",
              props: {
                eyebrow: {
                  type: "string",
                  label: "\u7709\u5934",
                  content: "text",
                },
                eyebrowStyle: {
                  type: "font",
                  label: "\u7709\u5934-\u5b57\u4f53\u914d\u7f6e",
                },
                headline: {
                  type: "string",
                  label: "\u5927\u6807\u9898",
                  content: "text",
                },
                headlineStyle: {
                  type: "font",
                  label: "\u5927\u6807\u9898-\u5b57\u4f53\u914d\u7f6e",
                },
                description: {
                  type: "string",
                  label: "\u63cf\u8ff0",
                  content: "text",
                },
                descriptionStyle: {
                  type: "font",
                  label: "\u63cf\u8ff0-\u5b57\u4f53\u914d\u7f6e",
                },
              },
            },
            background: {
              label: "\u80cc\u666f",
              props: {
                sectionBg: {
                  type: "image",
                  label:
                    "\u89c6\u9891\u964d\u7ea7\u56fe\uff08\u5982\u4e0d\u586b\uff0c\u964d\u7ea7\u9ed8\u8ba4\u53d6\u89c6\u9891\u5c01\u9762\uff09",
                  helptext:
                    "window\u7684firefox\u964d\u7ea7\uff0c\u5982\u4e0d\u586b\u9ed8\u8ba4\u53d6\u89c6\u9891\u5c01\u9762",
                },
                bgVideoLinkMp4: {
                  label: "\u80cc\u666f\u89c6\u9891mp4\u683c\u5f0f",
                  type: "string",
                  content: "url",
                },
                bgVideoLinkWebm: {
                  label: "\u80cc\u666f\u89c6\u9891webm\u683c\u5f0f",
                  type: "string",
                  content: "url",
                },
                bgVideoPoster: {
                  label: "\u80cc\u666f\u89c6\u9891\u5c01\u9762\u56fe",
                  type: "image",
                },
                playOnce: {
                  label:
                    "\u80cc\u666f\u89c6\u9891\u5faa\u73af\u4ec5\u64ad\u653e\u4e00\u6b21",
                  type: "boolean",
                },
                videoWithOffset: {
                  label:
                    "\u89c6\u9891\u5f00\u542foffset(\u63d0\u524d\u52a0\u8f7d)",
                  type: "boolean",
                },
              },
            },
            animation: {
              label: "\u52a8\u6548\u914d\u7f6e",
              props: {
                maskAnimation: {
                  type: "number",
                  label:
                    "\u8499\u5c42\u52a8\u6548\u8ddd\u79bb(\u4ec5PC\u751f\u6548)",
                },
              },
            },
          },
          skinSetting: {
            sectionStyle: {
              label: "\u7ec4\u4ef6\u7ed3\u6784\u7f16\u8f91",
              props: {
                sectionBackgroundcolor: {
                  label: "section \u80cc\u666f\u8272",
                  type: "string",
                  placeholder: "#fff",
                },
                gradientColor: {
                  label: "\u6e10\u53d8\u8272\u914d\u7f6e",
                  helptext:
                    "\u81ea\u5b9a\u4e49\u6e10\u53d8\u8272\u914d\u7f6e\uff0c\u4f18\u5148\u7ea7\u9ad8\u4e8e\u3010\u6e10\u53d8\u7ed3\u675f\u989c\u8272\u914d\u7f6e\u3011",
                  type: "string",
                  placeholder:
                    "linear-gradient(0deg, #000, #000 15%, rgba(0,0,0,0))",
                },
                gradientEndColor: {
                  label: "\u6e10\u53d8\u7ed3\u675f\u989c\u8272\u914d\u7f6e",
                  type: "string",
                  placeholder: "#27312F",
                },
                gradientHeight: {
                  label:
                    "\u6e10\u53d8\u9ad8\u5ea6 [\u5efa\u8bae\u914d\u7f6e 0~80vh]",
                  type: "string",
                  placeholder: "80vh",
                },
                gradientHeightRatio: {
                  label:
                    "\u6e10\u53d8\u9ad8\u5ea6\u6bd4\u4f8b [\u5efa\u8bae\u914d\u7f6e 0~0.5] (\u4f18\u5148\u4e8e\u6e10\u53d8\u9ad8\u5ea6)",
                  type: "number",
                },
                isGradientBehindText: {
                  label:
                    "\u6e10\u53d8\u662f\u5426\u4e0d\u906e\u4f4f\u6587\u5b57",
                  type: "boolean",
                },
                isTextAlignCenter: {
                  label: "\u6587\u5b57\u662f\u5426\u5782\u76f4\u5c45\u4e2d",
                  type: "boolean",
                },
              },
            },
            downgradeStyle: {
              label: "\u964d\u7ea7-\u7ec4\u4ef6\u7ed3\u6784\u7f16\u8f91",
              props: {
                downgradeMarginTop: {
                  label:
                    "\u964d\u7ea7section\u7684\u4e0a\u95f4\u8ddd\u914d\u7f6e",
                  type: "string",
                  content: "size",
                },
                downgradeMarginBottom: {
                  label:
                    "\u964d\u7ea7section\u7684\u4e0b\u95f4\u8ddd\u914d\u7f6e",
                  type: "string",
                  content: "size",
                },
                downgradeSectionBackground: {
                  label: "\u964d\u7ea7section\u7684\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "size",
                },
                downgradeSectionTopHeight: {
                  label: "\u964d\u7ea7section\u4e0a\u9762div\u9ad8\u5ea6",
                  type: "string",
                  content: "size",
                },
                downgradeSectionTopbgColor: {
                  label:
                    "\u964d\u7ea7section\u4e0a\u9762div\u80cc\u666f\u989c\u8272",
                  type: "string",
                  content: "size",
                },
              },
            },
          },
        },
        P = (n("4Sk2"), s.a.createElement),
        E = {
          "./style.css": {
            "section-common-bgzoomout-static-version":
              "style__section-common-bgzoomout-static-version___30s1M",
            "zoom-out-bg": "style__zoom-out-bg___1OGwi",
            "bg-style": "style__bg-style___2p1VZ",
            "text-box": "style__text-box___1X1B6",
            "text-eyebrow": "style__text-eyebrow___1ahGq",
            "text-headline": "style__text-headline___MVU5A",
            "text-description": "style__text-description___2HkiS",
            "mobile-mode": "style__mobile-mode___2qID_",
            "section-common-bgzoomout":
              "style__section-common-bgzoomout___30Gbs",
            sticky: "style__sticky___ZZvSo",
            "bg-gradient-section": "style__bg-gradient-section___2Q4w6",
            "animation-module": "style__animation-module___2xRPL",
            "section-borders": "style__section-borders___3YnOY",
            "zoomout-bg-box": "style__zoomout-bg-box___3_3lD",
            "font-box": "style__font-box___1iyye",
            eyebrow: "style__eyebrow___1u_jA",
            headline: "style__headline___2qzvn",
            description: "style__description___3SZjs",
            mask: "style__mask___2b91C",
            "elevator-position": "style__elevator-position___3DYgt",
            "copywriting-template-default":
              "style__copywriting-template-default___3vJkQ",
            "pc-mode": "style__pc-mode___1_uEq",
            "media-screen-1440": "style__media-screen-1440___1q6RV",
            "media-screen-1600": "style__media-screen-1600___2dRAI",
            "fade-in": "style__fade-in___2oPTN",
            "bg-hide": "style__bg-hide___3Bzbk",
            "font-remove-sticky": "style__font-remove-sticky___kMR1a",
            text: "style__text___20B2w",
            "white-mask-hide": "style__white-mask-hide___3gZ4R",
            "video-player-box": "style__video-player-box___3No8M",
          },
        };
      function L(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function B(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? L(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : L(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var N = function (e) {
        var t = (e = B(
            B(B({}, C), e),
            {},
            { component_data: B(B({}, C.component_data), e.component_data) },
          )),
          n = t.mobileMode,
          a = t.t,
          r = t.component_data,
          s = t.eventAction,
          c = r.eyebrow,
          _ = r.eyebrowStyle,
          u = void 0 === _ ? {} : _,
          d = r.headline,
          p = r.headlineStyle,
          h = void 0 === p ? {} : p,
          y = r.description,
          g = r.descriptionStyle,
          S = void 0 === g ? {} : g,
          j = r.sectionBg,
          T = r.bgVideoLinkMp4,
          M = r.bgVideoLinkWebm,
          L = r.bgVideoPoster,
          N = r.playOnce,
          D = r.maskAnimation,
          z = r.sectionBackgroundcolor,
          A = r.gradientColor,
          R = r.gradientEndColor,
          F = r.gradientHeight,
          V = r.gradientHeightRatio,
          H = r.isGradientBehindText,
          W = r.isTextAlignCenter,
          U = r.downgradeMarginTop,
          G = r.downgradeMarginBottom,
          Y = r.downgradeSectionBackground,
          q = r.downgradeSectionTopHeight,
          X = r.downgradeSectionTopbgColor,
          Z = r.mediaPoint,
          K = r.hasMediaScreen,
          Q = r.copywritingTemplate,
          J = Object(l.useState)(1080),
          $ = J[0],
          ee = J[1],
          te = Object(l.useState)(1920),
          ne = te[0],
          oe = te[1],
          ae = Object(l.useState)(0),
          re = ae[0],
          ie = ae[1],
          le = Object(l.useState)(0),
          se = le[0],
          ce = le[1],
          _e = Object(l.useRef)(),
          ue = Object(k.c)({ mobileMode: n }),
          de = Object(o.a)(ue, 1)[0],
          pe = Object(O.a)({
            mobileMode: n,
            sectionRef: _e,
            eventAction: s,
            mobileHeightChangable: !1,
          }),
          fe = Object(o.a)(pe, 2),
          he = fe[0],
          me = fe[1];
        Object(l.useEffect)(
          function () {
            !(function () {
              var e = (_e.current && _e.current.clientWidth) || he,
                t = (me + 1) / 1.5,
                n = (me - t) / 2;
              oe((e + 1) / 1.5), ee(t), ie(n);
            })();
          },
          [he, me],
        ),
          Object(l.useEffect)(
            function () {
              de && ce(window.innerHeight);
            },
            [de],
          );
        var ye = { backgroundColor: z || "#FFF" },
          be = Object(I.a)({
            target: _e,
            offset: ["start 80%", "".concat(me || 939, "px 80%")],
          }).scrollYProgress,
          ve = Object(I.a)({
            target: _e,
            offset: ["200px 20%", "1039px 20%"],
          }).scrollYProgress,
          ge = f(be, function (e) {
            return e >= 0.3 ? 1 : e / 0.3;
          }),
          we = f(be, function (e) {
            return 1 + 0.5 * e;
          }),
          xe = f(be, function (e) {
            return re * (e < 0.5 ? e / 0.5 : 1);
          }),
          ke = f(
            ve,
            n
              ? function (e) {
                  return e >= 0.5 ? (e - 0.5) / 0.5 : 0;
                }
              : function (e) {
                  return e >= 0.8 ? (e - 0.8) / 0.2 : 0;
                },
          ),
          Oe = f(ke, function (e) {
            return 15 * (1 - e) < 1 ? 1 : 15 * (1 - e);
          }),
          Ie =
            w.a.checkIsIphoneMini() || w.a.isWindowsFirefox() || Object(x.k)(),
          Se =
            ((null === T || void 0 === T ? void 0 : T.path) ||
              (null === M || void 0 === M ? void 0 : M.path)) &&
            !Ie,
          je = {};
        W && ((je.alignItems = "center"), (je.paddingTop = 0)),
          H && (je.zIndex = 100);
        var Te = "media-screen-".concat(Z || "1440"),
          Ce = "text-box ".concat(
            K && "copywriting-template-".concat(Q || "default"),
          );
        if (de)
          return P(
            "section",
            {
              style: {
                backgroundColor: Y || "#FFF",
                overflow: "hidden",
                marginTop: "-1px",
                height: n && "".concat(se, "px"),
              },
              className: i()(
                "section-common-bgzoomout-static-version "
                  .concat(n ? "mobile-mode" : "pc-mode", " ")
                  .concat(K && Te),
                E,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
            },
            P("div", {
              style: { width: "100%", height: q, backgroundColor: X },
            }),
            P(
              "div",
              {
                style: {
                  marginTop: U,
                  marginBottom: G,
                  position: "relative",
                  height: W && n && "".concat(se, "px"),
                },
              },
              P(b.a, {
                className: "style__zoom-out-bg___1OGwi style__bg-style___2p1VZ",
                type: "bg",
                tagType: "div",
                src: j || L,
                style: B(
                  {
                    position: n ? "absolute" : "initial",
                    height: "".concat(me, "px"),
                  },
                  n && W
                    ? {
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        paddingTop: 0,
                      }
                    : {},
                ),
              }),
              P(
                "div",
                {
                  style: W
                    ? { top: "50%", transform: "translate(-50%, -50%)" }
                    : {},
                  className: i()(Ce, E, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
                },
                P("h2", {
                  className: "text style__text-eyebrow___1ahGq",
                  dangerouslySetInnerHTML: { __html: a(c) },
                  style: B({}, u.style),
                }),
                P("br", null),
                P("h3", {
                  className: "text style__text-headline___MVU5A",
                  dangerouslySetInnerHTML: { __html: a(d) },
                  style: B({}, h.style),
                }),
                P("br", null),
                P("p", {
                  className: "text style__text-description___2HkiS",
                  dangerouslySetInnerHTML: { __html: a(y) },
                  style: B({}, S.style),
                }),
              ),
            ),
          );
        var Me = P(b.a, {
          className: "style__zoom-out-bg___1OGwi style__bg-style___2p1VZ",
          type: "bg",
          tagType: "div",
          src: j || L,
        });
        return P(
          "section",
          {
            id: "section-common-bgzoomout section-common-bgzoomout_".concat(
              e.id,
            ),
            style: ye,
            ref: _e,
            className:
              "section-common-bgzoomout " +
              i()(
                "section-common-bgzoomout "
                  .concat(n ? "mobile-mode" : "pc-mode", "  ")
                  .concat(K && Te),
                E,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
          },
          P(
            "div",
            {
              className: "style__animation-module___2xRPL",
              style: {
                height: n
                  ? "".concat(2.3 * me, "px")
                  : me < 900
                    ? D
                      ? +D + 1750
                      : 2250
                    : "220vh",
              },
            },
            P(
              "div",
              {
                className:
                  "style__section-borders___3YnOY style__sticky___ZZvSo",
                id: "sticky",
              },
              P(
                m.a.div,
                {
                  className: "style__zoomout-bg-box___3_3lD",
                  style: {
                    width: "".concat(Math.ceil(ne), "px"),
                    height: "".concat(Math.ceil($), "px"),
                    marginTop: "".concat(Math.ceil(re), "px"),
                    transformOrigin: "bottom",
                    opacity: ge,
                    scale: we,
                    y: xe,
                  },
                },
                Se
                  ? P(
                      v.a,
                      {
                        downgradeDom: Me,
                        lazyLoad: !0,
                        lazyLoadThreshold: 1200,
                        visiblePlay: !0,
                        replayWhenRevisible: !0,
                      },
                      P(
                        "video",
                        { muted: !0, "data-layzr-poster": L, loop: !N },
                        P("source", {
                          type: "video/webm",
                          "data-layzr-src":
                            null === M || void 0 === M ? void 0 : M.path,
                        }),
                        P("source", {
                          type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                          "data-layzr-src":
                            null === T || void 0 === T ? void 0 : T.path,
                        }),
                      ),
                    )
                  : Me,
              ),
            ),
            P(
              "div",
              {
                className: "font-box style__font-box___1iyye",
                id: "font-box",
                style: je,
              },
              P(
                "div",
                {
                  style: W ? { height: "auto" } : {},
                  className: i()(Ce, E, {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  }),
                },
                P(m.a.h2, {
                  className: "text style__eyebrow___1u_jA",
                  dangerouslySetInnerHTML: { __html: a(c) },
                  style: B(B({}, u.style), {}, { opacity: ke, y: Oe }),
                }),
                P("br", null),
                P(m.a.h3, {
                  className: "text style__headline___2qzvn",
                  dangerouslySetInnerHTML: { __html: a(d) },
                  style: B(B({}, h.style), {}, { opacity: ke, y: Oe }),
                }),
                P("br", null),
                P(m.a.p, {
                  className: "text style__description___3SZjs",
                  dangerouslySetInnerHTML: { __html: a(y) },
                  style: B(B({}, S.style), {}, { opacity: ke, y: Oe }),
                }),
              ),
            ),
          ),
          P("div", {
            className: "style__mask___2b91C",
            style: {
              background:
                A ||
                "linear-gradient(0deg, "
                  .concat(R, ", ")
                  .concat(R, " 15%, transparent)"),
              height: V ? "".concat(+V * me, "px") : F,
            },
          }),
          !n &&
            P("div", {
              className:
                "elevator-true elevator-bottom style__elevator-position___3DYgt",
            }),
        );
      };
      (N.defaultProps = C), (N.editSetting = M);
      t.a = Object(y.a)(N);
    },
    mRg0: function (e, t, n) {
      "use strict";
      t.__esModule = !0;
      var o = i(n("s3Ml")),
        a = i(n("AyUB")),
        r = i(n("EJiy"));
      function i(e) {
        return e && e.__esModule ? e : { default: e };
      }
      t.default = function (e, t) {
        if ("function" !== typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function, not " +
              ("undefined" === typeof t ? "undefined" : (0, r.default)(t)),
          );
        (e.prototype = (0, a.default)(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
          t && (o.default ? (0, o.default)(e, t) : (e.__proto__ = t));
      };
    },
    mTTR: function (e, t, n) {
      var o = n("b80T"),
        a = n("QcOe"),
        r = n("MMmD");
      e.exports = function (e) {
        return r(e) ? o(e, !0) : a(e);
      };
    },
    mdPL: function (e, t, n) {
      (function (e) {
        var o = n("WFqU"),
          a = t && !t.nodeType && t,
          r = a && "object" == typeof e && e && !e.nodeType && e,
          i = r && r.exports === a && o.process,
          l = (function () {
            try {
              var e = r && r.require && r.require("util").types;
              return e || (i && i.binding && i.binding("util"));
            } catch (t) {}
          })();
        e.exports = l;
      }).call(this, n("YuTi")(e));
    },
    mjmx: function (e, t, n) {
      e.exports = {
        "click-modal-btn-m": "style__click-modal-btn-m___2X214",
        "click-modal-btn": "style__click-modal-btn___2_uoL",
        "btn-downgrade": "style__btn-downgrade___JQfwc",
        "click-modal-btn-pc": "style__click-modal-btn-pc___1MeaG",
        "btn-gradient": "style__btn-gradient___2uWjE",
        content: "style__content___3PPcc",
        "btn-white": "style__btn-white___3agIi",
        "click-modal-btn-icon": "style__click-modal-btn-icon___3uHq6",
        "modal-container": "style__modal-container___3u7_z",
        "modal-close": "style__modal-close___ZQXTM",
        "modal-frame": "style__modal-frame___34s1W",
        "modal-content-box": "style__modal-content-box___K5aRM",
        "modal-container-m": "style__modal-container-m___3008D",
        "modal-button-type-F": "style__modal-button-type-F___2XWnn",
        "light-theme": "style__light-theme___cKoK3",
        "modal-container-pc": "style__modal-container-pc___3voHp",
      };
    },
    mnEE: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      });
      var o = n("W3Nv"),
        a = (function () {
          function e() {
            this.subscriptions = [];
          }
          return (
            (e.prototype.add = function (e) {
              var t = this;
              return (
                Object(o.a)(this.subscriptions, e),
                function () {
                  return Object(o.b)(t.subscriptions, e);
                }
              );
            }),
            (e.prototype.notify = function (e, t, n) {
              var o = this.subscriptions.length;
              if (o)
                if (1 === o) this.subscriptions[0](e, t, n);
                else
                  for (var a = 0; a < o; a++) {
                    var r = this.subscriptions[a];
                    r && r(e, t, n);
                  }
            }),
            (e.prototype.getSize = function () {
              return this.subscriptions.length;
            }),
            (e.prototype.clear = function () {
              this.subscriptions.length = 0;
            }),
            e
          );
        })();
    },
    mqlF: function (e, t) {
      t.f = Object.getOwnPropertySymbols;
    },
    mrSG: function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return a;
      }),
        n.d(t, "a", function () {
          return r;
        }),
        n.d(t, "d", function () {
          return i;
        }),
        n.d(t, "c", function () {
          return l;
        }),
        n.d(t, "e", function () {
          return s;
        });
      var o = function (e, t) {
        return (o =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (e, t) {
              e.__proto__ = t;
            }) ||
          function (e, t) {
            for (var n in t)
              Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          })(e, t);
      };
      function a(e, t) {
        if ("function" !== typeof t && null !== t)
          throw new TypeError(
            "Class extends value " +
              String(t) +
              " is not a constructor or null",
          );
        function n() {
          this.constructor = e;
        }
        o(e, t),
          (e.prototype =
            null === t
              ? Object.create(t)
              : ((n.prototype = t.prototype), new n()));
      }
      var r = function () {
        return (r =
          Object.assign ||
          function (e) {
            for (var t, n = 1, o = arguments.length; n < o; n++)
              for (var a in (t = arguments[n]))
                Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
            return e;
          }).apply(this, arguments);
      };
      function i(e, t) {
        var n = {};
        for (var o in e)
          Object.prototype.hasOwnProperty.call(e, o) &&
            t.indexOf(o) < 0 &&
            (n[o] = e[o]);
        if (null != e && "function" === typeof Object.getOwnPropertySymbols) {
          var a = 0;
          for (o = Object.getOwnPropertySymbols(e); a < o.length; a++)
            t.indexOf(o[a]) < 0 &&
              Object.prototype.propertyIsEnumerable.call(e, o[a]) &&
              (n[o[a]] = e[o[a]]);
        }
        return n;
      }
      Object.create;
      function l(e, t) {
        var n = "function" === typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var o,
          a,
          r = n.call(e),
          i = [];
        try {
          for (; (void 0 === t || t-- > 0) && !(o = r.next()).done; )
            i.push(o.value);
        } catch (l) {
          a = { error: l };
        } finally {
          try {
            o && !o.done && (n = r.return) && n.call(r);
          } finally {
            if (a) throw a.error;
          }
        }
        return i;
      }
      function s(e, t, n) {
        if (n || 2 === arguments.length)
          for (var o, a = 0, r = t.length; a < r; a++)
            (!o && a in t) ||
              (o || (o = Array.prototype.slice.call(t, 0, a)), (o[a] = t[a]));
        return e.concat(o || Array.prototype.slice.call(t));
      }
      Object.create;
      "function" === typeof SuppressedError && SuppressedError;
    },
    mtL0: function (e, t, n) {
      "use strict";
      function o(e, t) {
        return t ? e * (1e3 / t) : 0;
      }
      n.d(t, "a", function () {
        return o;
      });
    },
    "mv/X": function (e, t, n) {
      var o = n("ljhN"),
        a = n("MMmD"),
        r = n("wJg7"),
        i = n("GoyQ");
      e.exports = function (e, t, n) {
        if (!i(n)) return !1;
        var l = typeof t;
        return (
          !!("number" == l
            ? a(n) && r(t, n.length)
            : "string" == l && t in n) && o(n[t], e)
        );
      };
    },
    mwIZ: function (e, t, n) {
      var o = n("ZWtO");
      e.exports = function (e, t, n) {
        var a = null == e ? void 0 : o(e, t);
        return void 0 === a ? n : a;
      };
    },
    nJOd: function (e, t, n) {
      "use strict";
      n.d(t, "d", function () {
        return i;
      }),
        n.d(t, "c", function () {
          return l;
        }),
        n.d(t, "b", function () {
          return s;
        }),
        n.d(t, "a", function () {
          return c;
        });
      var o = n("ZO6J"),
        a = "prod",
        r = {
          en: "",
          "zh-CN": "cn",
          "zh-TW": "zh-tw",
          ja: "jp",
          ko: "kr",
          "pt-BR": "pt-br",
        };
      function i(e, t, n, i) {
        var l = r[n];
        l || "" === l || (l = n),
          (e = "/" !== e.substring(0, 1) ? "/".concat(e) : e);
        var s = i
          ? {
              dev: "m.dbeta.me",
              test: "m.dbeta.me",
              stag: "r-m.dbeta.me",
              prod: "m.dji.com",
            }[a] || "m.dji.com"
          : {
              dev: "store.dbeta.me",
              test: "store.dbeta.me",
              stag: "r-store.dbeta.me",
              prod: "store.dji.com",
            }[a] || "store.dji.com";
        return "ru" === l && "/ru/shopping-flow" === e
          ? s + e.replace("/ru", "")
          : -1 !== o.a.indexOf(t)
            ? "/where-to-buy"
            : l
              ? "https://".concat(s, "/").concat(l).concat(e)
              : "https://".concat(s).concat(l).concat(e);
      }
      function l(e, t, n, o) {
        var i = o
          ? {
              dev: "m.dbeta.me",
              test: "m.dbeta.me",
              stag: "r-m.dbeta.me",
              prod: "m.dji.com",
            }[a]
          : {
              dev: "accounts.dbeta.me",
              test: "accounts.dbeta.me",
              stag: "r-accounts.dbeta.me",
              prod: "accounts.dji.com",
            }[a];
        e = "/" !== e.substring(0, 1) ? "/".concat(e) : e;
        var l = r[n] || n;
        return (
          (l = "it" === l || "pt-br" === l || "ru" === l ? "" : l),
          "https://"
            .concat(i)
            .concat(l ? "/".concat(l) : "")
            .concat(e)
        );
      }
      function s(e) {
        var t = e.path,
          n = void 0 === t ? "" : t,
          o = e.backUrl,
          r = e.localization,
          i = "https://"
            .concat(
              {
                dev: "account.dbeta.me",
                test: "account.dbeta.me",
                stag: "r-account.dbeta.me",
                prod: "account.dji.com",
              }[a],
            )
            .concat(n)
            .concat(o ? "?backUrl=".concat(encodeURIComponent(o)) : "");
        if (r)
          try {
            var l = /-/.test(r.language)
                ? r.language.replace("-", "_")
                : ""
                    .concat(r.language.toLowerCase(), "_")
                    .concat(r.country.toUpperCase()),
              s = r.country.toUpperCase();
            i += ""
              .concat(i.indexOf("?") > 0 ? "&" : "?", "locale=")
              .concat(l, "&region=")
              .concat(s);
          } catch (c) {}
        return i;
      }
      function c(e) {
        var t = window.location.host;
        if (!e) return !1;
        var n =
            !e.match(/^http/gi) &&
            !e.match(/www\./gi) &&
            !e.match(/\.com/gi) &&
            !e.match(/^\/\//),
          o = new RegExp(t, "gi").test(e);
        return n || o ? "_self" : "_blank";
      }
    },
    nPaQ: function (e, t, n) {
      "use strict";
      n.d(t, "c", function () {
        return r;
      }),
        n.d(t, "b", function () {
          return l;
        }),
        n.d(t, "a", function () {
          return s;
        });
      var o = n("tZZE"),
        a = n("xTuV"),
        r = function (e) {
          var t = o.a.SELF;
          return (
            (e !== a.a["store-button"] && e !== a.a["external-button"]) ||
              (t = o.a.BLANK),
            (e !== a.b["store-button"] &&
              e !== a.b["external-button"] &&
              e !== a.b["external-link"]) ||
              (t = o.a.BLANK),
            t
          );
        },
        i = function (e, t, n) {
          var o = !1;
          return (
            e && t && "/" !== t && (o = !0),
            (n !== a.a["video-play"] && n !== a.b["video-play"]) || (o = !1),
            o
          );
        },
        l = function (e, t) {
          return e || "card-".concat(t, "-first-button");
        },
        s = function (e) {
          var t = "",
            n = o.a.SELF,
            a = { url: void 0, target: n, gaLabel: "" };
          if (e.hasCardLink && e.cardLink && "/" !== e.cardLink) return a;
          if (i(e.hasPrimaryButton, e.primaryButtonLink, e.primaryButtonType))
            return (
              (n = r(e.primaryButtonType)),
              (t = l(e.primaryButtonGaLabel, e.index)),
              (a = { url: e.primaryButtonLink, target: n, gaLabel: t })
            );
          if (
            i(
              e.hasSecondaryButton,
              e.secondaryButtonLink,
              e.secondaryButtonType,
            )
          )
            return (
              (n = r(e.secondaryButtonType)),
              (t = l(e.secondaryButtonGaLabel, e.index)),
              (a = { url: e.secondaryButtonLink, target: n, gaLabel: t })
            );
          if (e.hasLinks && e.links) {
            var s = (function () {
              for (
                var e =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : [],
                  t = -1,
                  n = 0;
                n < e.length;
                n++
              ) {
                var o = e[n];
                if (
                  o &&
                  o.linkUrl &&
                  "/" !== o.linkUrl &&
                  ("internal-link" === o.linkType ||
                    "external-link" === o.linkType)
                ) {
                  t = n;
                  break;
                }
              }
              return t > -1 ? e[t] : void 0;
            })(e.links);
            if (s) {
              var c = "card-".concat(e.index, "-link-0-link-"),
                _ = s.linkGaLabel ? "".concat(s.linkGaLabel, "-") : c;
              return (
                "internal-link" === s.linkType &&
                  (a = {
                    url: s.linkUrl,
                    target: o.a.SELF,
                    gaLabel: "".concat(_, "in"),
                  }),
                "external-link" === s.linkType &&
                  (a = {
                    url: s.linkUrl,
                    target: o.a.BLANK,
                    gaLabel: "".concat(_, "out"),
                  }),
                a
              );
            }
          }
          return a;
        };
    },
    nUpg: function (e, t, n) {
      e.exports = {
        "subscribe-modal-wrapper":
          "subcribeModal__subscribe-modal-wrapper___--Mxt",
        mask: "subcribeModal__mask___1U31N",
        unlocked: "subcribeModal__unlocked___2tVsU",
        active: "subcribeModal__active___jlUlh",
        "modal-container": "subcribeModal__modal-container___34fz1",
        "close-btn": "subcribeModal__close-btn___wHYxI",
        "close-icon": "subcribeModal__close-icon___jGbYH",
        "activity-modal-open-area":
          "subcribeModal__activity-modal-open-area___2Snt8",
        "modal-content": "subcribeModal__modal-content___10Q2_",
        envelope: "subcribeModal__envelope___lnmda",
        "envelope-video-svg": "subcribeModal__envelope-video-svg___2feIv",
        "activity-modal-container":
          "subcribeModal__activity-modal-container___1CfLW",
        "activity-modal-link": "subcribeModal__activity-modal-link___3ygMM",
        "submit-btn": "subcribeModal__submit-btn___KPyZB",
        "close-btn-new-light": "subcribeModal__close-btn-new-light___3ReKN",
        "close-btn-new-dark": "subcribeModal__close-btn-new-dark___3Ct7W",
        "activity-modal-link-no-show":
          "subcribeModal__activity-modal-link-no-show___EWBwV",
        "email-input": "subcribeModal__email-input___1SI4L",
        "subscribe-content": "subcribeModal__subscribe-content___2-wb7",
        note: "subcribeModal__note___mkiOO",
        btn: "subcribeModal__btn___3cqpO",
        success: "subcribeModal__success___1CSEs",
        "success-icon": "subcribeModal__success-icon___2vich",
        intro: "subcribeModal__intro___34zlx",
        "ok-btn": "subcribeModal__ok-btn___1St4G",
        hide: "subcribeModal__hide___1rscX",
        eyebrow: "subcribeModal__eyebrow___1VLd0",
        inputgroup: "subcribeModal__inputgroup___2BHRP",
        "input-theme-light": "subcribeModal__input-theme-light___1shlK",
        "input-theme-dark": "subcribeModal__input-theme-dark___1nOAh",
        "email-input-error": "subcribeModal__email-input-error___1zOgz",
        "spin-icon": "subcribeModal__spin-icon___wd1mz",
        "submit-text": "subcribeModal__submit-text___3Ne4j",
        "btn-margin-top": "subcribeModal__btn-margin-top___zL5Ze",
        "email-input-error-tip": "subcribeModal__email-input-error-tip___1TM74",
        show: "subcribeModal__show___3cD1X",
        "subscribe-modal-wrapper-pc":
          "subcribeModal__subscribe-modal-wrapper-pc___2CFgW",
        "success-content": "subcribeModal__success-content___2yfMl",
        "subscribe-modal-wrapper-mobile":
          "subcribeModal__subscribe-modal-wrapper-mobile___3gwVI",
        "success-content-wrapper":
          "subcribeModal__success-content-wrapper___2Kotc",
        "content-wrapper": "subcribeModal__content-wrapper___oqZNM",
        "hidden-text": "subcribeModal__hidden-text___1zSs9",
        "shown-text": "subcribeModal__shown-text___35eZ1",
      };
    },
    nmnc: function (e, t, n) {
      var o = n("Kz5y").Symbol;
      e.exports = o;
    },
    o8NH: function (e, t, n) {
      var o = n("Y7ZC");
      o(o.S + o.F, "Object", { assign: n("kwZ1") });
    },
    "oCl/": function (e, t, n) {
      var o = n("CH3K"),
        a = n("LcsW"),
        r = n("MvSz"),
        i = n("0ycA"),
        l = Object.getOwnPropertySymbols
          ? function (e) {
              for (var t = []; e; ) o(t, r(e)), (e = a(e));
              return t;
            }
          : i;
      e.exports = l;
    },
    oGC9: function (e, t, n) {
      e.exports = {
        "nav-placeholder": "style__nav-placeholder___3afxR",
        "sub-nav-wrap": "style__sub-nav-wrap___1m88z",
        "sub-nav-collapsed": "style__sub-nav-collapsed___2D0Xo",
        "sub-nav-mask": "style__sub-nav-mask___3Tn2P",
        "angle-down": "style__angle-down___E5J4Y",
        "sub-nav": "style__sub-nav___2tLmj",
        "sub-nav-fingerpost": "style__sub-nav-fingerpost___2xggV",
        active: "style__active___1MU_0",
        "sub-nav-tab": "style__sub-nav-tab___1d_ik",
        "sub-nav-drop": "style__sub-nav-drop___2nrnB",
        "sub-nav-content": "style__sub-nav-content___2qtPa",
        "sub-nav-container": "style__sub-nav-container___1vn1w",
        flex: "style__flex___U7fc4",
        "sub-nav-right": "style__sub-nav-right___284bL",
        "product-title": "style__product-title___TDuJE",
        "sub-nav-toggle": "style__sub-nav-toggle___1Evlt",
        "sub-nav-toggle-btn": "style__sub-nav-toggle-btn___6-0-s",
        "sub-nav-dropdown": "style__sub-nav-dropdown___3O2KH",
        "type-b": "style__type-b___1Y7XM",
        "sub-nav-btn": "style__sub-nav-btn___2Zr1P",
        "sub-nav-buy-now": "style__sub-nav-buy-now___2PDWz",
        "sub-nav-display-none-mobile":
          "style__sub-nav-display-none-mobile___1KcLY",
      };
    },
    oVml: function (e, t, n) {
      var o = n("5K7Z"),
        a = n("fpC5"),
        r = n("FpHa"),
        i = n("VVlx")("IE_PROTO"),
        l = function () {},
        s = function () {
          var e,
            t = n("Hsns")("iframe"),
            o = r.length;
          for (
            t.style.display = "none",
              n("MvwC").appendChild(t),
              t.src = "javascript:",
              (e = t.contentWindow.document).open(),
              e.write("<script>document.F=Object</script>"),
              e.close(),
              s = e.F;
            o--;

          )
            delete s.prototype[r[o]];
          return s();
        };
      e.exports =
        Object.create ||
        function (e, t) {
          var n;
          return (
            null !== e
              ? ((l.prototype = o(e)),
                (n = new l()),
                (l.prototype = null),
                (n[i] = e))
              : (n = s()),
            void 0 === t ? n : a(n, t)
          );
        };
    },
    "otv/": function (e, t, n) {
      var o = n("nmnc"),
        a = o ? o.prototype : void 0,
        r = a ? a.valueOf : void 0;
      e.exports = function (e) {
        return r ? Object(r.call(e)) : {};
      };
    },
    oyjV: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return c;
      });
      var o = n("mrSG"),
        a = n("q1tI"),
        r = n("IdKh"),
        i = n("e5U0"),
        l = n("J4/h");
      n("TLPt");
      var s = n("bQW5");
      function c(e, t) {
        var n = (function (e) {
            var t = Object(l.a)(function () {
              return Object(r.a)(e);
            });
            if (Object(a.useContext)(i.a).isStatic) {
              var n = Object(o.c)(Object(a.useState)(e), 2)[1];
              Object(a.useEffect)(function () {
                return t.onChange(n);
              }, []);
            }
            return t;
          })(t()),
          c = function () {
            return n.set(t());
          };
        return (
          c(),
          (function (e, t) {
            Object(a.useEffect)(function () {
              var n = e.map(function (e) {
                return e.onChange(t);
              });
              return function () {
                return n.forEach(function (e) {
                  return e();
                });
              };
            });
          })(e, function () {
            return s.b.update(c, !1, !0);
          }),
          n
        );
      }
    },
    p8LG: function (e, t, n) {
      "use strict";
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("Ji7U"),
        s = n("rePB"),
        c = n("q1tI"),
        _ = n.n(c),
        u = n("XnI8"),
        d = _.a.createElement;
      function p(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var f = (function (e) {
        function t() {
          return Object(o.default)(this, t), p(this, t, arguments);
        }
        return (
          Object(l.a)(t, e),
          Object(a.default)(t, [
            {
              key: "render",
              value: function () {
                var e,
                  t = this.props,
                  n = t.component_data;
                return t.isEdit ||
                  0 ===
                    (null === n || void 0 === n
                      ? void 0
                      : null === (e = n.customScripts) || void 0 === e
                        ? void 0
                        : e.length)
                  ? null
                  : d(function () {
                      var e;
                      return null === n || void 0 === n
                        ? void 0
                        : null === (e = n.customScripts) || void 0 === e
                          ? void 0
                          : e.map(function (e, t) {
                              return d("script", {
                                key: t,
                                dangerouslySetInnerHTML: {
                                  __html: e.customScript,
                                },
                              });
                            });
                    }, null);
              },
            },
          ]),
          t
        );
      })(_.a.Component);
      Object(s.a)(f, "editSetting", {
        key: "setScript",
        name: "setScript",
        contentSetting: {
          styles: {
            label: "script\u914d\u7f6e",
            props: {
              customScripts: {
                type: "array",
                label: "\u81ea\u5b9a\u4e49script\u5217\u8868",
                props: { customScript: { label: "Script", type: "string" } },
              },
              customTextKeys: {
                type: "array",
                label: "\u81ea\u5b9a\u4e49Key\u5217\u8868",
                helptext:
                  "\u7528\u4e8e\u5728\u672c\u9875\u9762\u65b0\u589ekey\uff0c\u4f46\u4e0d\u5728\u7ec4\u4ef6\u5185\u5c55\u793a",
                props: {
                  customTextKey: {
                    label: "Key",
                    type: "string",
                    content: "text",
                  },
                },
              },
            },
          },
        },
        skinSetting: {},
      }),
        (f.defaultProps = { component_data: {} }),
        (t.a = Object(u.a)(f));
    },
    pFRH: function (e, t, n) {
      var o = n("cvCv"),
        a = n("O0oS"),
        r = n("zZ0H"),
        i = a
          ? function (e, t) {
              return a(e, "toString", {
                configurable: !0,
                enumerable: !1,
                value: o(t),
                writable: !0,
              });
            }
          : r;
      e.exports = i;
    },
    pIsd: function (e, t, n) {
      var o = n("BJfS"),
        a = function (e) {
          var t = "",
            n = Object.keys(e);
          return (
            n.forEach(function (a, r) {
              var i = e[a];
              (function (e) {
                return /[height|width]$/.test(e);
              })((a = o(a))) &&
                "number" === typeof i &&
                (i += "px"),
                (t +=
                  !0 === i
                    ? a
                    : !1 === i
                      ? "not " + a
                      : "(" + a + ": " + i + ")"),
                r < n.length - 1 && (t += " and ");
            }),
            t
          );
        };
      e.exports = function (e) {
        var t = "";
        return "string" === typeof e
          ? e
          : e instanceof Array
            ? (e.forEach(function (n, o) {
                (t += a(n)), o < e.length - 1 && (t += ", ");
              }),
              t)
            : a(e);
      };
    },
    pR0O: function (e, t, n) {
      e.exports = {
        "hero-horizontal-component": "style__hero-horizontal-component___1c2xP",
        "background-video": "style__background-video___32EiK",
        "video-mask": "style__video-mask___3zvyy",
        "card-list": "style__card-list___XPXVu",
        "hero-horizontal-wrapper": "style__hero-horizontal-wrapper___3U6-D",
        "horizontal-card-list": "style__horizontal-card-list___3_oTU",
        "horizontal-card-col": "style__horizontal-card-col___2qRr9",
        "vertical-top-align": "style__vertical-top-align___2PCRs",
        "vertical-center-align": "style__vertical-center-align___2DhpN",
        "vertical-bottom-align": "style__vertical-bottom-align___1M56I",
        "has-media-screen": "style__has-media-screen___2s7Ms",
        "media-screen-1600": "style__media-screen-1600___1z6U8",
      };
    },
    pSRY: function (e, t, n) {
      var o = n("QkVE");
      e.exports = function (e) {
        return o(this, e).has(e);
      };
    },
    pXgs: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      }),
        n.d(t, "b", function () {
          return a;
        });
      var o = {
          zoomSwitch: !1,
          zoomImageRawWidth: 19418,
          zoomImageRawHeight: 6960,
          zoomTilesUrl: {
            path: "https://www1.djicdn.com/assets/uploads/p/1edb82f4-e31e-4e7a-a7c1-302119410646/260pano/",
          },
          zoomRawImageSize: "(100M)",
          zoomRawImageLink: { path: "https://www.dji.com" },
          zoomDownloadDesc: "\u4e0b\u8f7d RAW ",
          zoomDefaultZoomLevel: void 0,
          zoomMinZoomLevel: void 0,
          zoomMaxZoomLevel: void 0,
        },
        a = {
          label: "\u653e\u5927\u529f\u80fd\u53c2\u6570\u914d\u7f6e",
          props: {
            zoomSwitch: {
              label:
                "----------------\u3010\u653e\u5927\u529f\u80fd\u3011\u662f\u5426\u5f00\u542f\u653e\u5927\u529f\u80fd----------------",
              type: "boolean",
            },
            zoomImageRawWidth: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011\u539f\u59cb\u56fe\u7247\u6700\u5927\u5bbd\u5ea6",
              type: "number",
            },
            zoomImageRawHeight: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011\u539f\u59cb\u56fe\u7247\u6700\u5927\u9ad8\u5ea6",
              type: "number",
            },
            zoomTilesUrl: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011\u56fe\u7247\u5408\u96c6\u5730\u5740",
              type: "string",
              content: "url",
            },
            zoomRawImageSize: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011raw\u56fe\u5927\u5c0f(\u793a\u4f8b\uff1a100M)",
              type: "string",
              content: "text",
            },
            zoomRawImageLink: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011raw\u56fe\u4e0b\u8f7d\u94fe\u63a5",
              type: "string",
              content: "url",
            },
            zoomDownloadDesc: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011raw\u56fe\u4e0b\u8f7d\u63cf\u8ff0",
              type: "string",
              content: "text",
            },
            zoomDefaultZoomLevel: {
              label:
                "(\u653e\u5927\u529f\u80fd)\u9ed8\u8ba4\u653e\u5927\u500d\u6570\uff08\u53ef\u9009\uff09",
              type: "number",
            },
            zoomMinZoomLevel: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011\u6700\u5c0f\u653e\u5927\u500d\u6570\uff08\u53ef\u9009\uff09",
              type: "number",
            },
            zoomMaxZoomLevel: {
              label:
                "\u3010\u653e\u5927\u529f\u80fd\u3011\u6700\u5927\u653e\u5927\u500d\u6570(\u53ef\u9009)",
              type: "number",
            },
          },
        };
    },
    piUf: function (e, t, n) {
      e.exports = { "anchor-wrapper": "style__anchor-wrapper___1gYVQ" };
    },
    pwFm: function (e, t, n) {
      e.exports = {
        "store-point-wrapper": "storePoint__store-point-wrapper___228a8",
        "is-mobile": "storePoint__is-mobile___2dAO_",
        "store-point-button": "storePoint__store-point-button___2tgPd",
        button: "storePoint__button___2H2mF",
        "is-pc": "storePoint__is-pc___2-TP4",
        "white-all": "storePoint__white-all___1jz9J",
        black: "storePoint__black___3J3zv",
        "store-point-item": "storePoint__store-point-item___3WBrF",
        "store-point-name": "storePoint__store-point-name___26TiL",
        "one-sentence-box": "storePoint__one-sentence-box___3ib3y",
        "store-point-title": "storePoint__store-point-title___AWOb-",
        "store-point-desc": "storePoint__store-point-desc___S7bFR",
      };
    },
    pzan: function (e, t, n) {},
    q5jV: function (e, t, n) {
      "use strict";
      var o = n("KQm4"),
        a = n("HaE+"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("ODXe"),
        d = n("wx14"),
        p = n("rePB"),
        f = n("iKuz"),
        h = n.n(f),
        m = n("q1tI"),
        y = n.n(m),
        b = n("XnI8"),
        v = n("/MKj"),
        g = n("u6T5"),
        w = n.n(g),
        x = n("SBOM"),
        k = n("yWgo"),
        O = n("XrJB"),
        I = n.n(O),
        S = n("05bn"),
        j = n.n(S),
        T = n("S5C5"),
        C = n("u11H"),
        M = n("nJOd"),
        P =
          (n("aiR1"),
          n("CRHi"),
          {
            key: "comparison",
            name: "comparison",
            contentSetting: {
              content: {
                label: "\u5934\u90e8&\u5e95\u90e8",
                props: {
                  headline: {
                    label: "\u6a21\u5757\u6807\u9898",
                    type: "string",
                    content: "text",
                  },
                  headlineStyle: {
                    label: "\u6a21\u5757\u6807\u9898-\u6837\u5f0f",
                    type: "font",
                  },
                  offSale: {
                    label: "\u505c\u552e\u6807\u8bc6",
                    type: "string",
                    content: "text",
                  },
                  hasComparisonBtn: {
                    label:
                      "\u662f\u5426\u9700\u8981\u67e5\u770b\u5b8c\u6574\u5bf9\u6bd4\u6309\u94ae",
                    helptext:
                      "\u5168\u5c40\u7edf\u4e00\u914d\u7f6e\u4e00\u4e2a,\u52fe\u9009\u5219\u4e0d\u663e\u793a\u5206\u573a\u666f\u6309\u94ae",
                    type: "boolean",
                  },
                  comparisonBtnText: {
                    label: "\u5bf9\u6bd4\u6309\u94ae",
                    type: "string",
                    content: "text",
                  },
                  comparisonBtnLink: {
                    label: "\u5bf9\u6bd4\u94fe\u63a5",
                    type: "string",
                    content: "url",
                  },
                  hasBuyBtn: {
                    label:
                      "\u662f\u5426\u9700\u8981\u67e5\u770b\u5b8c\u6574\u9009\u8d2d\u6309\u94ae",
                    helptext:
                      "\u5168\u5c40\u7edf\u4e00\u914d\u7f6e\u4e00\u4e2a,\u52fe\u9009\u5219\u4e0d\u663e\u793a\u5206\u573a\u666f\u6309\u94ae",
                    type: "boolean",
                  },
                  buyBtnText: {
                    label: "\u9009\u8d2d\u6309\u94ae",
                    type: "string",
                    content: "text",
                  },
                  buyBtnLink: {
                    label: "\u9009\u8d2d\u94fe\u63a5",
                    type: "string",
                    content: "url",
                  },
                },
              },
              productList: {
                label: "\u5bf9\u6bd4\u5217\u8868",
                group_type: "array_card",
                group_prop_name: "productList",
                props: {
                  productData: {
                    label: "\u5bf9\u6bd4\u4fe1\u606f",
                    props: {
                      productSlug: {
                        label: "\u5fc5\u586b\uff1a\u4ea7\u54c1slug",
                        helptext: "\u5bf9\u5e94cms\u4e2d\u7684\u4ea7\u54c1slug",
                        type: "string",
                      },
                      tabTitle: {
                        label: "\u5e94\u7528\u573a\u666f\u540d\u79f0",
                        helptext:
                          "\u76f8\u540c\u573a\u666f\u4f7f\u7528\u540c\u4e00\u4e2akey\uff0c\u9700\u8981tab\u5207\u6362\u65f6\u5fc5\u586b",
                        type: "string",
                        content: "text",
                      },
                      needEyebrow: {
                        label:
                          "\u662f\u5426\u9700\u8981\u663e\u793a\u7709\u6807",
                        type: "boolean",
                      },
                      eyebrowText: {
                        label: "\u7709\u6807\u6587\u6848",
                        type: "string",
                        content: "text",
                      },
                      hasDesc: {
                        label:
                          "\u662f\u5426\u9700\u8981\u663e\u793a\u63cf\u8ff0",
                        helptext:
                          "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                        type: "boolean",
                      },
                      productDesc: {
                        label: "\u4ea7\u54c1 Slogen",
                        type: "string",
                        content: "text",
                      },
                      hasPrice: {
                        label:
                          "\u662f\u5426\u9700\u8981\u663e\u793a\u4ef7\u683c",
                        helptext:
                          "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                        type: "boolean",
                      },
                      hasBuyNow: {
                        label:
                          "\u662f\u5426\u9700\u8981\u663e\u793a\u8d2d\u4e70\u6309\u94ae",
                        helptext:
                          "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                        type: "boolean",
                      },
                      hasLearnMore: {
                        label:
                          "\u662f\u5426\u9700\u8981\u663e\u793a\u66f4\u591a\u6309\u94ae",
                        helptext:
                          "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                        type: "boolean",
                      },
                      learnMoreText: {
                        label: "\u66f4\u591a\u6309\u94ae",
                        type: "string",
                        content: "text",
                      },
                      learnMoreLink: {
                        label: "\u66f4\u591a\u94fe\u63a5",
                        type: "link",
                        content: "url",
                      },
                      needLine: {
                        label:
                          "\u662f\u5426\u9700\u8981\u663e\u793a\u5206\u5272\u7ebf",
                        type: "boolean",
                      },
                      specList: {
                        label: "\u6280\u672f\u89c4\u683c",
                        type: "array",
                        props: {
                          hasSpecTitle: {
                            label:
                              "\u662f\u5426\u9700\u8981\u89c4\u683c\u6807\u9898",
                            helptext:
                              "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                            type: "boolean",
                          },
                          specTitle: {
                            label: "\u89c4\u683c\u6807\u9898",
                            type: "string",
                            content: "text",
                          },
                          hasSpecIcon: {
                            label: "\u662f\u5426\u9700\u8981\u89c4\u683cIcon",
                            helptext:
                              "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                            type: "boolean",
                          },
                          specIcon: {
                            label: "\u89c4\u683cIcon-1:1",
                            type: "image",
                          },
                          hasSpecName: {
                            label:
                              "\u662f\u5426\u9700\u8981\u89c4\u683c\u540d\u79f0",
                            helptext:
                              "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                            type: "boolean",
                          },
                          specName: {
                            label: "\u89c4\u683c\u540d\u79f0",
                            type: "string",
                            content: "text",
                          },
                          hasSpecNameNote: {
                            label:
                              "\u662f\u5426\u9700\u8981\u89c4\u683c\u540d\u79f0-\u6d6e\u52a8\u6ce8\u91ca",
                            type: "boolean",
                          },
                          specNameNote: {
                            label:
                              "\u89c4\u683c\u540d\u79f0-\u6d6e\u52a8\u6ce8\u91ca",
                            type: "string",
                            content: "text",
                          },
                          hasSpecDesc: {
                            label:
                              "\u662f\u5426\u9700\u8981\u89c4\u683c\u63cf\u8ff0",
                            helptext:
                              "\u540c\u4e00\u573a\u666f\u4e0b\u7684\u5f00\u5173\u914d\u7f6e\u4fdd\u6301\u4e00\u81f4\u53ef\u5bf9\u9f50",
                            type: "boolean",
                          },
                          specDesc: {
                            label: "\u89c4\u683c\u63cf\u8ff0",
                            type: "string",
                            content: "text",
                          },
                        },
                      },
                    },
                  },
                },
              },
              buttonData: {
                label: "\u6309\u94ae\u5217\u8868",
                props: {
                  buttonList: {
                    label: "\u6309\u94ae\u5217\u8868",
                    type: "array",
                    props: {
                      tabTitle: {
                        label: "\u5e94\u7528\u573a\u666f\u540d\u79f0",
                        helptext:
                          "\u76f8\u540c\u573a\u666f\u4f7f\u7528\u540c\u4e00\u4e2akey\uff0c\u9700\u8981\u6309\u94ae\u65f6\u5fc5\u586b\uff0c\u6709\u591a\u4e2a\u76f8\u540c\u53d6\u7b2c\u4e00\u4e2a",
                        type: "string",
                        content: "text",
                      },
                      hasComparisonBtn: {
                        label:
                          "\u662f\u5426\u9700\u8981\u5bf9\u6bd4\u6309\u94ae",
                        helptext:
                          "by \u573a\u666f\u914d\u7f6e\uff0c\u5207\u6362\u6a21\u5757\u4e0a\u65b9\u7684\u573a\u666fTab\u65f6",
                        type: "boolean",
                      },
                      comparisonBtnText: {
                        label: "\u5bf9\u6bd4\u6309\u94ae",
                        type: "string",
                        content: "text",
                      },
                      comparisonBtnLink: {
                        label: "\u5bf9\u6bd4\u94fe\u63a5",
                        type: "string",
                        content: "url",
                      },
                      hasBuyBtn: {
                        label:
                          "\u662f\u5426\u9700\u8981\u9009\u8d2d\u6309\u94ae",
                        helptext:
                          "by \u573a\u666f\u914d\u7f6e\uff0c\u5207\u6362\u6a21\u5757\u4e0a\u65b9\u7684\u573a\u666fTab\u65f6",
                        type: "boolean",
                      },
                      buyBtnText: {
                        label: "\u9009\u8d2d\u6309\u94ae",
                        type: "string",
                        content: "text",
                      },
                      buyBtnLink: {
                        label: "\u9009\u8d2d\u94fe\u63a5",
                        type: "string",
                        content: "url",
                      },
                    },
                  },
                },
              },
            },
            skinSetting: {
              sectionSetting: {
                label: "\u7ec4\u4ef6\u914d\u7f6e",
                props: {
                  isDarkTheme: {
                    label: "\u662f\u5426\u4f7f\u7528\u6df1\u8272\u4e3b\u9898",
                    type: "boolean",
                  },
                  needTabBar: {
                    label:
                      "\u662f\u5426\u9700\u8981\u5e94\u7528\u573a\u666ftab\u5207\u6362",
                    type: "boolean",
                  },
                  backgroundColor: {
                    label: "\u6a21\u5757\u80cc\u666f\u989c\u8272",
                    type: "string",
                  },
                  paddingTop: {
                    label:
                      "\u6a21\u5757\u4e0a\u95f4\u8ddd-\u9700\u8981\u5e26\u5355\u4f4dpx",
                    type: "string",
                    content: "size",
                  },
                  paddingBottom: {
                    label:
                      "\u6a21\u5757\u4e0b\u95f4\u8ddd-\u9700\u8981\u5e26\u5355\u4f4dpx",
                    type: "string",
                    content: "size",
                  },
                },
              },
            },
          }),
        E = (n("fzFG"), y.a.createElement);
      function L() {
        L = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new M(o || []);
          return a(i, "_invoke", { value: S(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var g = {};
        c(g, i, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          x = w && w(w(P([])));
        x && x !== n && o.call(x, i) && (g = x);
        var k = (v.prototype = y.prototype = Object.create(g));
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function I(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function S(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = j(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function j(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                j(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function T(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function C(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function M(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(T, this),
            this.reset(!0);
        }
        function P(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(k, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(k)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          O(I.prototype),
          c(I.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = I),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new I(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          O(k),
          c(k, s, "Generator"),
          c(k, i, function () {
            return this;
          }),
          c(k, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = P),
          (M.prototype = {
            constructor: M,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(C),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), C(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    C(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: P(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      function B(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var N = {
        "@dji/quark/dist/Icon.css": {
          _3c0Qz: "Icon___3c0Qz___FIJlG",
          _1j2v0: "Icon___1j2v0___3n4_L",
          "-lu88": "Icon__-lu88___3d46C",
          _35bgc: "Icon___35bgc___3GNZF",
          byXrR: "Icon__byXrR___1RkT6",
          _128ri: "Icon___128ri___2tmqj",
          _1KHsi: "Icon___1KHsi___3Eodi",
          "_2bT-Y": "Icon___2bT-Y___2I6pp",
          _3UEZX: "Icon___3UEZX___2thwC",
          _1fXKU: "Icon___1fXKU___2BRJU",
          _2OZ_n: "Icon___2OZ_n___2RThy",
          _6cr8a: "Icon___6cr8a___IijMS",
          ZAGKa: "Icon__ZAGKa___1VXdb",
          _1lH5w: "Icon___1lH5w___1Fjc9",
          _3BSr4: "Icon___3BSr4___1Kmz0",
          _4wlbR: "Icon___4wlbR___3byTz",
          _26SUY: "Icon___26SUY___d0HAN",
          "_30-mD": "Icon___30-mD___3ZamP",
          _1_xvC: "Icon___1_xvC___2A-8f",
          _17P2f: "Icon___17P2f___rSHoE",
          _2I_EY: "Icon___2I_EY___2xSLv",
          _3qb3s: "Icon___3qb3s___rJOmo",
          _2jwD5: "Icon___2jwD5___2QGsT",
          _19X43: "Icon___19X43___3Kun2",
          _2WwM4: "Icon___2WwM4___1gBlP",
          _1shcg: "Icon___1shcg___3hDFq",
          _1qLWd: "Icon___1qLWd___2iuQy",
          Z8Prc: "Icon__Z8Prc___1Dms6",
          _3MItB: "Icon___3MItB___3_bo8",
          _2Bvn6: "Icon___2Bvn6___WbeJB",
          _3IVo_: "Icon___3IVo____3wyxI",
          _34FGS: "Icon___34FGS___33RR0",
          _3e62_: "Icon___3e62____92ZgY",
          _1zbhS: "Icon___1zbhS___2r2qq",
          _27RtX: "Icon___27RtX___27B0l",
          jhfcy: "Icon__jhfcy___16aAv",
          Q82xM: "Icon__Q82xM___oUbgj",
          _1vyf0: "Icon___1vyf0___1Q36k",
          B0IHZ: "Icon__B0IHZ___2i7iu",
          _2cpQ_: "Icon___2cpQ____1m_c2",
          _2FImd: "Icon___2FImd___3DKZV",
          _3wXJB: "Icon___3wXJB___kIf5S",
          _2fXyR: "Icon___2fXyR___I8f9m",
          _2KLCQ: "Icon___2KLCQ___20KdM",
          "_-4DAY": "Icon___-4DAY___3ZpEm",
          _2I4g3: "Icon___2I4g3___32bHH",
          _1m5z7: "Icon___1m5z7___1qVyd",
          _1vR3p: "Icon___1vR3p___2yoW_",
          _2LJ7o: "Icon___2LJ7o___jCzSa",
          _3AQSX: "Icon___3AQSX___1f3qw",
          _3ASBw: "Icon___3ASBw___1lGu0",
          _6eszT: "Icon___6eszT___2t_u2",
          _1WxHW: "Icon___1WxHW___GiKUo",
          _2uv1U: "Icon___2uv1U___1JiUZ",
          "_3s-NW": "Icon___3s-NW___1I_EX",
          _1ZzVY: "Icon___1ZzVY___2rvYH",
          OBwuW: "Icon__OBwuW___2fQc2",
          "_2Ri-k": "Icon___2Ri-k___2kk-7",
          _1588m: "Icon___1588m___9NDr4",
          _2uIqb: "Icon___2uIqb___1FdOg",
          _1P5xZ: "Icon___1P5xZ___2f_T2",
          _2iuBX: "Icon___2iuBX___L1dph",
          _1exha: "Icon___1exha___1m37C",
          _3bokS: "Icon___3bokS___1OYm4",
          "vMM-Y": "Icon__vMM-Y___3QgfP",
          _3jZwp: "Icon___3jZwp___3d5u1",
          "_2SUQ-": "Icon___2SUQ-___6nEm6",
          _1Piil: "Icon___1Piil___VvBSt",
          _20oXE: "Icon___20oXE___1xwx0",
          _2gTe8: "Icon___2gTe8___2yipi",
          okv_Y: "Icon__okv_Y___1Pe9p",
          "_3l-6g": "Icon___3l-6g___TPS6y",
          OhY9C: "Icon__OhY9C___23GW6",
          Cb5jY: "Icon__Cb5jY___2uZGR",
          _1ajFe: "Icon___1ajFe___HugcL",
          ve2KQ: "Icon__ve2KQ___t5XNa",
          _3OU3j: "Icon___3OU3j___xivTQ",
          lgV2x: "Icon__lgV2x___h-CeN",
          _1gQtG: "Icon___1gQtG___3bGQ2",
          _3Zaag: "Icon___3Zaag___Sa23k",
          _33jTA: "Icon___33jTA___2TKV5",
          _1jJbn: "Icon___1jJbn___1sLs7",
          UuxAk: "Icon__UuxAk___19lCZ",
          _1OEuY: "Icon___1OEuY___3iBjU",
          Lm_MF: "Icon__Lm_MF___3yQbY",
          _3LwbN: "Icon___3LwbN___3Kj8n",
          _2XN05: "Icon___2XN05___1rny3",
          _33OcX: "Icon___33OcX___394mm",
          bMc_E: "Icon__bMc_E___H5L8W",
          IAlEP: "Icon__IAlEP___2I8pV",
          _25GQ2: "Icon___25GQ2___2lovm",
          _3t3HT: "Icon___3t3HT___n_YD6",
          _2W_XA: "Icon___2W_XA___3qZb3",
          _3NPLS: "Icon___3NPLS___3Dm9I",
          UhwjW: "Icon__UhwjW___3Bath",
          _2hDpl: "Icon___2hDpl___3V_-b",
          dCZz2: "Icon__dCZz2___11T7f",
          _1FMUV: "Icon___1FMUV___LlZ0V",
          _2H8bj: "Icon___2H8bj___27UMO",
          _3KkpT: "Icon___3KkpT___1PPrL",
          _23p5a: "Icon___23p5a___1EP34",
          _18A_e: "Icon___18A_e___7QC5E",
          gf_rb: "Icon__gf_rb___2PXNg",
          _1Djb6: "Icon___1Djb6___2pUir",
          "_3d-6G": "Icon___3d-6G___14ssX",
          _1fawl: "Icon___1fawl___KUcfA",
          _20uY7: "Icon___20uY7___18OZm",
          _2Z6dE: "Icon___2Z6dE___1ik2v",
          _1c3Qh: "Icon___1c3Qh___2essq",
          _1GlZx: "Icon___1GlZx___1NCg-",
          _3hG3b: "Icon___3hG3b___2gAhc",
          _15wCJ: "Icon___15wCJ___X5oB6",
          _1Rw_U: "Icon___1Rw_U___16Osz",
          _2Jlwc: "Icon___2Jlwc___de1R5",
          _1bahP: "Icon___1bahP___3btKO",
          "_27Nd-": "Icon___27Nd-___2hUt0",
          _3To44: "Icon___3To44___1U_3e",
          _1O_Hy: "Icon___1O_Hy___3okVL",
          W6H_f: "Icon__W6H_f___3gCiH",
          _2_sls: "Icon___2_sls___yPeTY",
          _35BGQ: "Icon___35BGQ___jWjx9",
          _3xfLM: "Icon___3xfLM___3zQYM",
          _1pvYF: "Icon___1pvYF___1VGpm",
        },
        "@dji/quark/dist/Tooltip.css": {
          "quark-tooltip": "Tooltip__quark-tooltip___1G2AF",
          "quark-tooltip-hidden": "Tooltip__quark-tooltip-hidden___1vRgA",
          "quark-tooltip-placement-top":
            "Tooltip__quark-tooltip-placement-top___2nNvo",
          "quark-tooltip-placement-topLeft":
            "Tooltip__quark-tooltip-placement-topLeft___lZnd0",
          "quark-tooltip-placement-topRight":
            "Tooltip__quark-tooltip-placement-topRight___2Xq5x",
          "quark-tooltip-placement-right":
            "Tooltip__quark-tooltip-placement-right___3Dgga",
          "quark-tooltip-placement-rightBottom":
            "Tooltip__quark-tooltip-placement-rightBottom___3JBnS",
          "quark-tooltip-placement-rightTop":
            "Tooltip__quark-tooltip-placement-rightTop___3lS96",
          "quark-tooltip-placement-bottom":
            "Tooltip__quark-tooltip-placement-bottom____XEQ1",
          "quark-tooltip-placement-bottomLeft":
            "Tooltip__quark-tooltip-placement-bottomLeft___cn1wL",
          "quark-tooltip-placement-bottomRight":
            "Tooltip__quark-tooltip-placement-bottomRight___2nTta",
          "quark-tooltip-placement-left":
            "Tooltip__quark-tooltip-placement-left___1-GxV",
          "quark-tooltip-placement-leftBottom":
            "Tooltip__quark-tooltip-placement-leftBottom___1CeIQ",
          "quark-tooltip-placement-leftTop":
            "Tooltip__quark-tooltip-placement-leftTop___oFQeH",
          "quark-tooltip-inner": "Tooltip__quark-tooltip-inner___2YTbp",
          "quark-tooltip-arrow": "Tooltip__quark-tooltip-arrow___1EtLl",
          "fade-in-enter": "Tooltip__fade-in-enter___121FK",
          "fade-in-enter-active": "Tooltip__fade-in-enter-active___2JV27",
          "fade-in-leave": "Tooltip__fade-in-leave___3Iu-x",
          "fade-in-leave-active": "Tooltip__fade-in-leave-active___1eyWO",
        },
        "./style.css": {
          "comparison-section": "style__comparison-section___2GIwn",
          "is-dark-theme": "style__is-dark-theme___3Xzn5",
          "need-line": "style__need-line___2Cpjm",
          "spec-item": "style__spec-item___1Nq2Y",
          "spec-desc": "style__spec-desc___3mAsK",
          "button-box": "style__button-box___2CIuc",
          "product-origin": "style__product-origin___2coco",
          "basic-info": "style__basic-info___3W7TH",
          "product-price": "style__product-price___EwZYs",
          "off-sale": "style__off-sale___3-zE2",
          container: "style__container___1VJiz",
          headline: "style__headline___Oq3it",
          "product-list": "style__product-list___3x48T",
          "product-item": "style__product-item___3L2Dr",
          "product-cover": "style__product-cover___WX2rj",
          eyebrow: "style__eyebrow___2AP0X",
          label: "style__label___2zk9X",
          "product-name": "style__product-name___1eaZ9",
          "product-desc": "style__product-desc___1zZUD",
          origin: "style__origin___1CM0q",
          "product-buy-now": "style__product-buy-now___1BLI4",
          "product-buy-now-btn": "style__product-buy-now-btn___24LU_",
          "product-learn-more": "style__product-learn-more___3CwJ9",
          "basic-info-bottom": "style__basic-info-bottom___2aYP7",
          "spec-title": "style__spec-title___IHKiC",
          "spec-icon": "style__spec-icon___3Dy50",
          "spec-name": "style__spec-name___2Z4yV",
          "comparison-btn": "style__comparison-btn___nl4mL",
          "buy-btn": "style__buy-btn___1LotJ",
          "dji-pc": "style__dji-pc___28p-C",
          _28KUW: "style___28KUW___MLmah",
          "dji-mobile": "style__dji-mobile___1Eo8e",
          _2RUui: "style___2RUui___2Wsr6",
          "quark-tab-default-tab-container":
            "style__quark-tab-default-tab-container___25AXc",
          "quark-tab-default-tab-bar-wrap":
            "style__quark-tab-default-tab-bar-wrap___MQ_UN",
          _8wsGN: "style___8wsGN___1YyLd",
          "quark-tab-default-tab-bar":
            "style__quark-tab-default-tab-bar___TTZfW",
          _1Ltud: "style___1Ltud___2FTAW",
          zPFdO: "style__zPFdO___2ZzHH",
          _14aFm: "style___14aFm___27tGG",
          "quark-tooltip": "style__quark-tooltip___3r46U",
          "quark-tooltip-inner": "style__quark-tooltip-inner___2uZHl",
          "quark-tooltip-hidden": "style__quark-tooltip-hidden___3Dr0x",
        },
      };
      function D(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function z(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? D(Object(n), !0).forEach(function (t) {
                Object(p.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : D(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var A = function (e) {
          var t = e.mobileMode,
            n = e.isEndOfLine,
            o = e.specsData,
            a = void 0 === o ? {} : o,
            r = a.hasSpecTitle,
            i = a.specTitle,
            l = a.hasSpecIcon,
            s = a.specIcon,
            c = a.hasSpecName,
            _ = a.specName,
            u = a.hasSpecNameNote,
            p = a.specNameNote,
            f = a.hasSpecDesc,
            h = a.specDesc,
            m = e.t,
            y = z(
              z({}, t ? { trigger: "click" } : {}),
              n ? { placement: "left" } : {},
            );
          return E(
            "div",
            {
              className: "style__product-item___3L2Dr style__spec-item___1Nq2Y",
            },
            r &&
              E(
                "h4",
                { className: "style__spec-title___IHKiC" },
                E("span", { dangerouslySetInnerHTML: { __html: m(i) } }),
              ),
            l &&
              E(x.a, {
                className: "style__spec-icon___3Dy50",
                type: "bg",
                src: s,
                alt: m(i),
              }),
            c &&
              E(
                "p",
                { className: "style__spec-name___2Z4yV" },
                E("span", { dangerouslySetInnerHTML: { __html: m(_) } }),
                u &&
                  E(
                    j.a,
                    Object(d.a)({ title: m(p) }, y),
                    E(I.a, { name: "info-circle-o" }),
                  ),
              ),
            f &&
              E(
                "p",
                { className: "style__spec-desc___3mAsK" },
                E("span", { dangerouslySetInnerHTML: { __html: m(h) } }),
              ),
          );
        },
        R = function (e, t, n, o, a) {
          var r =
            "store-path" !== e && "absolute-path" !== e && e ? "" : "store";
          return Object(T.k)({
            domain: r,
            url: t,
            country: n,
            locale: o,
            mobileMode: a,
          });
        },
        F = function (e) {
          var t = e.productSlug,
            n = e.priceInfo,
            o = (void 0 === n ? {} : n).on_sale,
            a = e.shoppingGuides,
            r = (void 0 === a ? {} : a).product_list,
            i = void 0 === r ? [] : r,
            l = Object(u.a)(i, 1)[0],
            s = (void 0 === l ? {} : l).primary_button,
            c = void 0 === s ? {} : s,
            _ = c.title,
            d = c.link,
            p = c.link_type,
            f = e.localization,
            h = void 0 === f ? {} : f,
            m = h.country,
            y = h.language,
            b = e.mobileMode,
            v = e.gaSend,
            g = e.t,
            w = R(p, d, m, y, b);
          return E(
            "div",
            { className: "style__product-buy-now___1BLI4" },
            o &&
              d &&
              _ &&
              E("a", {
                className: "style__product-buy-now-btn___24LU_",
                href: w,
                dangerouslySetInnerHTML: { __html: Object(T.d)(_, m, g, null) },
                target: Object(M.a)(w),
                onClick: function () {
                  return v("".concat(t, "-buy_now"));
                },
              }),
          );
        },
        V = Object(m.forwardRef)(function (e, t) {
          var n = e.component_data,
            o = (void 0 === n ? {} : n).offSale,
            a = void 0 === o ? "\u5546\u57ce\u5df2\u505c\u552e" : o,
            r = e.productData,
            i = void 0 === r ? {} : r,
            l = i.hasPrice,
            s = i.priceInfo,
            c = void 0 === s ? {} : s,
            _ = i.hasBuyNow,
            u = i.hasLearnMore,
            d = i.learnMoreText,
            p = i.learnMoreLink,
            f = i.productSlug,
            h = i.shoppingGuides,
            m = void 0 === h ? {} : h,
            y = e.localization,
            b = void 0 === y ? {} : y,
            v = e.gaSend,
            g = e.mobileMode,
            w = e.t;
          return E(
            "div",
            { className: "style__basic-info-bottom___2aYP7", ref: t },
            l &&
              E(
                "p",
                { className: "style__product-price___EwZYs" },
                (null === c || void 0 === c ? void 0 : c.on_sale)
                  ? [
                      (null === c || void 0 === c ? void 0 : c.has_discount)
                        ? E(
                            "span",
                            { className: "style__origin___1CM0q" },
                            null === c || void 0 === c
                              ? void 0
                              : c.original_price,
                          )
                        : null,
                      E("span", {
                        dangerouslySetInnerHTML: {
                          __html: null === c || void 0 === c ? void 0 : c.price,
                        },
                      }),
                    ]
                  : E("span", {
                      className: "style__off-sale___3-zE2",
                      dangerouslySetInnerHTML: { __html: w(a) },
                    }),
              ),
            _ &&
              E(F, {
                priceInfo: c,
                productSlug: f,
                shoppingGuides: m,
                localization: b,
                mobileMode: g,
                gaSend: v,
                t: w,
              }),
            u &&
              E(
                "a",
                {
                  className: "style__product-learn-more___3CwJ9",
                  href: null === p || void 0 === p ? void 0 : p.path,
                  target: Object(M.a)(
                    null === p || void 0 === p ? void 0 : p.path,
                  ),
                  onClick: function () {
                    return v("".concat(f, "-learn_more"));
                  },
                },
                E("span", { dangerouslySetInnerHTML: { __html: w(d) } }),
                d && E(I.a, { name: "angle-right" }),
              ),
          );
        }),
        H = function (e) {
          var t = e.productData,
            n = void 0 === t ? {} : t,
            o = n.needEyebrow,
            a = n.eyebrowText,
            r = n.productCover,
            i = n.productName,
            l = n.hasDesc,
            s = n.productDesc,
            c = n.needLine,
            _ = n.label,
            u = e.t,
            p = e.isEdit
              ? ""
              : "\u65e0\u6570\u636e\u8bf7\u68c0\u67e5\u4ea7\u54c1slug",
            f = Object(m.useRef)(),
            y = Object(m.useState)(0),
            b = y[0],
            v = y[1],
            g = Object(m.useState)(!1),
            w = g[0],
            k = g[1];
          Object(m.useEffect)(function () {
            var e,
              t = new Date().getTime();
            if (
              (v(
                null === (e = f.current) || void 0 === e
                  ? void 0
                  : e.clientHeight,
              ),
              _ && !w)
            ) {
              var n = 1e3 * _.offline_at;
              n && t < n && !w && k(!0);
            }
          });
          var O = "".concat(b + 24, "px"),
            I = (function (e) {
              var t = {
                  url: void 0,
                  target: "_blank",
                  onClick: function () {},
                },
                n = e.productData,
                o = e.localization,
                a = e.gaSend,
                r = e.mobileMode,
                i = o || {},
                l = i.country,
                s = i.language,
                c = n || {},
                _ = c.hasBuyNow,
                u = c.priceInfo,
                d = c.shoppingGuides,
                p = c.hasLearnMore,
                f = c.learnMoreLink,
                h = c.productSlug,
                m =
                  (((d || {}).product_list || [])[0] || {}).primary_button ||
                  {},
                y = m.title,
                b = m.link,
                v = m.link_type,
                g = (u || {}).on_sale;
              if (_) {
                var w = g && b && y,
                  x = R(v, b, l, s, r);
                w &&
                  (t = {
                    url: x,
                    target: Object(M.a)(x),
                    onClick: function () {
                      return a("".concat(h, "-buy_now"));
                    },
                  });
              }
              return (
                !t.url &&
                  p &&
                  (t = {
                    url:
                      (null === f || void 0 === f ? void 0 : f.path) || void 0,
                    target: Object(M.a)(
                      null === f || void 0 === f ? void 0 : f.path,
                    ),
                    onClick: a("".concat(h, "-learn_more")),
                  }),
                t
              );
            })(e);
          return E(
            "div",
            {
              style: { paddingBottom: O },
              className: h()(
                "product-item basic-info ".concat(c ? "need-line" : ""),
                N,
                {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                },
              ),
            },
            r &&
              E(
                "a",
                {
                  style: { display: "contents" },
                  href: I.url,
                  target: I.target,
                  onClick: I.onClick,
                },
                E(x.a, {
                  className: "style__product-cover___WX2rj",
                  type: "img",
                  src: Object(T.m)(r),
                  alt: u(i),
                }),
              ),
            E(
              "h3",
              { className: "style__product-name___1eaZ9" },
              _ && w
                ? E(
                    "div",
                    {
                      className: "style__label___2zk9X",
                      style: { color: _.color },
                    },
                    _.text,
                  )
                : o &&
                    E("span", {
                      className: "style__eyebrow___2AP0X",
                      dangerouslySetInnerHTML: { __html: u(a) },
                    }),
              E("span", { dangerouslySetInnerHTML: { __html: i || p } }),
            ),
            l &&
              E(
                "p",
                { className: "style__product-desc___1zZUD" },
                E("span", { dangerouslySetInnerHTML: { __html: u(s) } }),
              ),
            E(V, Object(d.a)({ ref: f }, e)),
          );
        },
        W = function (e) {
          var t = e.buttons,
            n = void 0 === t ? {} : t,
            o = n.hasComparisonBtn,
            a = n.comparisonBtnLink,
            r = n.comparisonBtnText,
            i = n.hasBuyBtn,
            l = n.buyBtnLink,
            s = n.buyBtnText,
            c = e.gaSend,
            _ = e.t,
            u = e.localization;
          return (
            (null === l || void 0 === l ? void 0 : l.path) &&
              (l.path = Object(T.e)(
                Object(T.k)({
                  url: "/where-to-buy",
                  country: null === u || void 0 === u ? void 0 : u.country,
                  locale: null === u || void 0 === u ? void 0 : u.language,
                }),
                null === l || void 0 === l ? void 0 : l.path,
                null === u || void 0 === u ? void 0 : u.country,
              )),
            E(
              "div",
              { className: "style__button-box___2CIuc" },
              o &&
                E(
                  "a",
                  {
                    className: "style__comparison-btn___nl4mL",
                    href: null === a || void 0 === a ? void 0 : a.path,
                    target: Object(M.a)(
                      null === a || void 0 === a ? void 0 : a.path,
                    ),
                    onClick: function () {
                      return c("comparison-learn_more");
                    },
                  },
                  E("span", { dangerouslySetInnerHTML: { __html: _(r) } }),
                  E(I.a, { name: "angle-right" }),
                ),
              i &&
                E(
                  "a",
                  {
                    className: "style__buy-btn___1LotJ",
                    href: null === l || void 0 === l ? void 0 : l.path,
                    target: Object(M.a)(
                      null === l || void 0 === l ? void 0 : l.path,
                    ),
                    onClick: function () {
                      return c("comparison-store");
                    },
                  },
                  E("span", { dangerouslySetInnerHTML: { __html: _(s) } }),
                  E(I.a, { name: "angle-right" }),
                ),
            )
          );
        },
        U = function (e) {
          var t = e.component_data,
            n = void 0 === t ? {} : t,
            o = n.needTabBar,
            a = n.buttonList,
            r = void 0 === a ? [] : a,
            i = e.mobileMode,
            l = e.t,
            s = e.gaSend,
            c = e.productList,
            _ = e.hasGlobalButton,
            u = e.localization,
            p = i ? 2 : 4,
            f = (null === c || void 0 === c ? void 0 : c.length) > 0,
            h = Object(m.useState)(0),
            b = h[0],
            v = h[1];
          f &&
            c.forEach(function (e) {
              var t;
              (null === (t = e.products) || void 0 === t ? void 0 : t.length) >
                0 &&
                e.products.forEach(function (e) {
                  var t,
                    n =
                      null === (t = e.specList) || void 0 === t
                        ? void 0
                        : t.length;
                  n > b && v(n);
                });
            });
          return (
            f &&
            E(
              w.a,
              {
                tabBarStyle: { textAlign: "center", display: o ? "" : "none" },
                tabPosition: "center",
                tabDisplay: "inline-block",
                onChange: function (e) {
                  Object(k.rb)("comparison-section", e);
                },
              },
              c.map(function (t, n) {
                var o = t.title,
                  a = void 0 === o ? "\u5e94\u7528\u573a\u666f" : o,
                  c = t.products,
                  f = void 0 === c ? [] : c,
                  h = (null === f || void 0 === f ? void 0 : f.length) > 0,
                  m = (function (e) {
                    var t = {};
                    return r.length > 0
                      ? (r.forEach(function (n) {
                          n.tabTitle === e && (t = n);
                        }),
                        t)
                      : t;
                  })(a);
                return E(
                  w.a.TabPanel,
                  {
                    tab: a
                      ? l(a)
                      : "\u8bf7\u5f55\u5165\u5e94\u7528\u573a\u666f",
                    key: "tab-panel-".concat(n),
                  },
                  E(
                    y.a.Fragment,
                    null,
                    E(
                      "div",
                      { className: "style__product-list___3x48T" },
                      h &&
                        f.map(function (t, n) {
                          return (
                            n < p &&
                            t.productSlug &&
                            E(
                              H,
                              Object(d.a)({}, e, {
                                productData: t,
                                gaSend: s,
                                key: "basic-info-panel-".concat(n),
                              }),
                            )
                          );
                        }),
                    ),
                    (function (e) {
                      for (
                        var t = [],
                          n =
                            (null === e || void 0 === e ? void 0 : e.length) >
                            0,
                          o = function (o) {
                            var a = E(
                              "div",
                              { className: "style__product-list___3x48T" },
                              n &&
                                e.map(function (t, n) {
                                  var a =
                                      null === t || void 0 === t
                                        ? void 0
                                        : t.specList,
                                    r =
                                      (null === a || void 0 === a
                                        ? void 0
                                        : a.length) > 0,
                                    s = n < p && t.productSlug,
                                    c = i ? n % 2 === 1 : n === e.length - 1,
                                    _ = r && a[o];
                                  return (
                                    s &&
                                    E(A, {
                                      specsData: _,
                                      t: l,
                                      mobileMode: i,
                                      isEndOfLine: c,
                                    })
                                  );
                                }),
                            );
                            t.push(a);
                          },
                          a = 0;
                        a < b;
                        a++
                      )
                        o(a);
                      return t;
                    })(f),
                    !_ &&
                      m &&
                      E(W, { buttons: m, gaSend: s, t: l, localization: u }),
                  ),
                );
              }),
            )
          );
        },
        G = (function (e) {
          function t() {
            var e;
            return (
              Object(r.default)(this, t),
              (e = B(this, t)),
              Object(p.a)(
                Object(c.a)(e),
                "initData",
                Object(a.default)(
                  L().mark(function t() {
                    var n, o, a, r, i, l, s, c;
                    return L().wrap(function (t) {
                      for (;;)
                        switch ((t.prev = t.next)) {
                          case 0:
                            if (
                              ((n = e.props),
                              (o = n.component_data),
                              (a = (void 0 === o ? {} : o).productList),
                              (r = n.comparisonData),
                              (i = void 0 === r ? [] : r),
                              !a)
                            ) {
                              t.next = 9;
                              break;
                            }
                            return (
                              (l = []),
                              (s = []),
                              a.forEach(function (e) {
                                var t,
                                  n,
                                  o = e || {},
                                  a = o.tabTitle,
                                  r = void 0 === a ? "none" : a,
                                  c = o.productSlug,
                                  _ = void 0 === c ? "" : c;
                                _ &&
                                  (null === i || void 0 === i
                                    ? void 0
                                    : i.length) &&
                                  i.forEach(function (t) {
                                    var n;
                                    (null === t || void 0 === t
                                      ? void 0
                                      : t.slug) === _ &&
                                      ((e.productCover =
                                        null === (n = t.cover) || void 0 === n
                                          ? void 0
                                          : n.url),
                                      (e.productName = t.title),
                                      (e.ean = t.ean),
                                      (e.priceInfo = t.priceData),
                                      (e.shoppingGuides = t.shopping_guides),
                                      (e.label = t.label),
                                      s.push(t.ean));
                                  }),
                                  l[r] || (l[r] = { title: r, products: [] }),
                                  null === (t = l[r]) ||
                                    void 0 === t ||
                                    null === (n = t.products) ||
                                    void 0 === n ||
                                    n.push(e);
                              }),
                              (c = Object.values(l) || []),
                              (t.next = 8),
                              e.setState({ productList: c })
                            );
                          case 8:
                            e.updateProductPrice();
                          case 9:
                          case "end":
                            return t.stop();
                        }
                    }, t);
                  }),
                ),
              ),
              Object(p.a)(Object(c.a)(e), "gaSend", function (t) {
                (0, e.props.gaSend)("click", t);
              }),
              (e.state = { productList: [] }),
              (e.comparisonDom = y.a.createRef()),
              e
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  this.initData();
                },
              },
              {
                key: "updateProductPrice",
                value: (function () {

                  var e = Object(a.default)(
                    L().mark(function e() {
                      var t, n, a, r, i, l;
                      return L().wrap(
                        function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                if (
                                  ((t = Object(o.a)(this.state.productList)),
                                  (n = []),
                                  t.forEach(function (e) {
                                    var t;
                                    null === (t = e.products) ||
                                      void 0 === t ||
                                      t.forEach(function (e) {
                                        e.ean && n.push(e.ean);
                                      });
                                  }),
                                  console.log(n, t, "eans"),
                                  !(n.length <= 0))
                                ) {
                                  e.next = 6;
                                  break;
                                }
                                return e.abrupt("return");
                              case 6:
                                return (
                                  (a = n.join(",")),
                                  (r = this.props.localization),
                                  (e.prev = 8),
                                  (e.next = 11),
                                  C.default.request(
                                    {
                                      name: "productGetPrice",
                                      method: "GET",
                                      query: { ean: a },
                                    },
                                    r,
                                  )
                                );
                              case 11:
                                return (i = e.sent), (e.next = 14), i.json();
                              case 14:
                                200 === (l = e.sent).status &&
                                  (t.forEach(function (e) {
                                    var t;
                                    null === (t = e.products) ||
                                      void 0 === t ||
                                      t.forEach(function (e) {
                                        e.ean &&
                                          (null === l ||
                                            void 0 === l ||
                                            l.data.forEach(function (t) {
                                              t.ean === e.ean &&
                                                ((e.priceInfo.on_sale =
                                                  t.on_sale),
                                                t.on_sale &&
                                                  ((e.priceInfo.has_discount =
                                                    t.has_discount),
                                                  (e.priceInfo.price = t.price),
                                                  (e.price = t.price)));
                                            }));
                                      });
                                  }),
                                  this.setState({ productList: t })),
                                  (e.next = 20);
                                break;
                              case 18:
                                (e.prev = 18), (e.t0 = e.catch(8));
                              case 20:
                              case "end":
                                return e.stop();
                            }
                        },
                        e,
                        this,
                        [[8, 18]],
                      );
                    }),
                  );
                  return function () {
                    return e.apply(this, arguments);
                  };
                })(),
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = this.props,
                    n = t.component_data,
                    o = void 0 === n ? {} : n,
                    a = o.backgroundColor,
                    r = o.isDarkTheme,
                    i = o.hasComparisonBtn,
                    l = o.hasBuyBtn,
                    s = o.paddingTop,
                    c = o.paddingBottom,
                    _ = o.headline,
                    u = o.headlineStyle,
                    p = void 0 === u ? {} : u,
                    f = o.comparisonBtnText,
                    m = o.comparisonBtnLink,
                    y = o.buyBtnText,
                    b = o.buyBtnLink,
                    v = t.t,
                    g = t.localization,
                    w = this.state.productList,
                    x = {
                      hasComparisonBtn: i,
                      hasBuyBtn: l,
                      comparisonBtnText: f,
                      comparisonBtnLink: m,
                      buyBtnText: y,
                      buyBtnLink: b,
                    },
                    k = i || l;
                  return E(
                    "section",
                    {
                      style: {
                        paddingTop: s,
                        paddingBottom: c,
                        backgroundColor: a,
                      },
                      ref: function (t) {
                        e.comparisonDom = t;
                      },
                      className:
                        "comparison-section ".concat(r ? "is-dark-theme" : "") +
                        " " +
                        h()(
                          "comparison-section ".concat(
                            r ? "is-dark-theme" : "",
                          ),
                          N,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                    },
                    E(
                      "div",
                      { className: "style__container___1VJiz" },
                      E("h2", {
                        className: "style__headline___Oq3it",
                        style: p.style,
                        dangerouslySetInnerHTML: { __html: v(_) },
                      }),
                      E(
                        U,
                        Object(d.a)({}, this.props, {
                          gaSend: this.gaSend,
                          productList: w,
                          hasGlobalButton: k,
                        }),
                      ),
                      k &&
                        E(W, {
                          buttons: x,
                          gaSend: this.gaSend,
                          t: v,
                          localization: g,
                        }),
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(y.a.Component);
      (G.editSetting = P),
        (G.defaultProps = {
          component_data: {},
          comparisonData: [],
          t: function () {},
          gaSend: function () {},
        });
      t.a = Object(b.a)(
        Object(v.b)(function (e) {
          return { mobileMode: e.context.mobileMode };
        })(G),
      );
    },
    qJuD: function (e, t, n) {
      e.exports = {
        "video-player-component": "style__video-player-component___1LtC2",
        "video-player-box": "style__video-player-box___2yF0u",
        "video-player-wrapper": "style__video-player-wrapper___1AN4l",
        "fix-video-border": "style__fix-video-border___s6bUG",
        "video-player-poster": "style__video-player-poster___aDPVq",
        "video-player-downgrade-m": "style__video-player-downgrade-m___1uETX",
        "video-player-downgrade-m-btn":
          "style__video-player-downgrade-m-btn___1vWvy",
        "video-player-dom": "style__video-player-dom___FGbd_",
        "video-player-box-m": "style__video-player-box-m___3ogLP",
        "replay-btn": "style__replay-btn___2zwuY",
        "pause-btn": "style__pause-btn___zsEID",
        "play-btn": "style__play-btn___3bu6r",
        "loading-btn": "style__loading-btn___3ngla",
        "replay-btn-icon": "style__replay-btn-icon___27gnm",
      };
    },
    qZTm: function (e, t, n) {
      var o = n("fR/l"),
        a = n("MvSz"),
        r = n("7GkX");
      e.exports = function (e) {
        return o(e, r, a);
      };
    },
    qhfP: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = e.type,
          s = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t, l) && !e.required) return n();
          r.default.required(e, t, o, s, a, l),
            (0, i.isEmptyValue)(t, l) || r.default.type(e, t, o, s, a);
        }
        n(s);
      };
    },
    "qt4/": function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return r;
      });
      var o = n("rePB");
      function a(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      var r = (function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? a(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : a(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      })(
        {
          anchorId: {
            label: "\u951a\u70b9 id [\u9009\u586b, \u4e0d\u5e26#\u53f7]",
            type: "string",
          },
          gaLabel: {
            label: "\u951a\u70b9 ga-label",
            type: "string",
            content: "text",
          },
        },
        {
          anchorImageWidth: {
            label: "\u951a\u70b9\u56fe\u7247\u5bbd\u5ea6",
            type: "string",
            helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
          },
          anchorImageHeight: {
            label: "\u951a\u70b9\u56fe\u7247\u9ad8\u5ea6",
            type: "string",
            helptext: "\u9700\u5e26\u5355\u4f4d, \u5982\u201cpx\u201d",
          },
          anchorImage: { type: "image", label: "\u951a\u70b9\u56fe\u7247" },
          anchorImageAlt: {
            label: "\u951a\u70b9\u56fe\u7247 Alt",
            type: "string",
            content: "text",
          },
        },
      );
    },
    r7AC: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      }),
        n.d(t, "d", function () {
          return a;
        }),
        n.d(t, "b", function () {
          return i;
        }),
        n.d(t, "c", function () {
          return l;
        });
      n("Wr5T");
      function o(e) {
        if (!e) return !1;
        for (
          var t = e.offsetTop,
            n = e.offsetLeft,
            o = e.offsetWidth,
            a = e.offsetHeight;
          e.offsetParent;

        )
          (t += (e = e.offsetParent).offsetTop), (n += e.offsetLeft);
        return (
          t < window.pageYOffset + window.innerHeight &&
          n < window.pageXOffset + window.innerWidth &&
          t + a > window.pageYOffset &&
          n + o > window.pageXOffset
        );
      }
      function a(e, t, n) {
        if (e && "function" === typeof e.getBoundingClientRect) {
          var o = window.scrollY || window.pageYOffset,
            a = n || 0,
            r = o + a,
            i = o + window.innerHeight - a,
            l = t || 0,
            s = e.getBoundingClientRect().top + o,
            c = s - l,
            _ = s + e.offsetHeight + l;
          return c < i && _ > r;
        }
      }
      var r = !1;
      function i(e) {
        var t = e.elm,
          n = e.offset,
          o = void 0 === n ? 0 : n,
          a = e.callback,
          i = e.threshold,
          l = void 0 === i ? 0 : i,
          s = e.defaultInViewOnIE;
        if (t) {
          if (r && void 0 !== s && s)
            return setTimeout(function () {
              a({
                inView: !0,
                lastEntry: { isIntersecting: !0 },
                observer: { disconnect: function () {} },
                entries: [{ isIntersecting: !0 }],
              });
            }, 10);
          var c = { rootMargin: "".concat(o, "px"), threshold: l };
          new IntersectionObserver(function (e, t) {
            var n = e[e.length - 1],
              o = n.isIntersecting,
              r = a({ inView: o, lastEntry: n, observer: t, entries: e });
            n.isIntersecting && !r && t.disconnect();
          }, c).observe(t);
        }
      }
      function l(e, t, n) {
        return a(e, t, n ? 48 : 100);
      }
      r = !!window.MSInputMethodContext && !!document.documentMode;
    },
    rMj0: function (e, t, n) {
      "use strict";
      n.r(t);
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("q1tI"),
        u = n.n(_),
        d = n("XnI8"),
        p = n("x/Rj"),
        f = n("dxL8"),
        h = n("gn4A"),
        m = n.n(h),
        y = n("UG0I"),
        b = u.a.createElement;
      function v(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function g(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? v(Object(n), !0).forEach(function (t) {
                Object(c.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : v(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      function w(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var x = (function (e) {
        function t(e) {
          var n;
          return (
            Object(o.default)(this, t),
            ((n = w(this, t, [e])).sendGa = n.sendGa.bind(Object(l.a)(n))),
            n
          );
        }
        return (
          Object(s.a)(t, e),
          Object(a.default)(t, [
            {
              key: "sendGa",
              value: function (e) {
                var t = this;
                return function () {
                  var n = t.props,
                    o = n.gaSend,
                    a = n.productData,
                    r = "accessories-".concat(e);
                  a && a.slug && o("click", r, "pc_".concat(a.slug, "_detail"));
                };
              },
            },
            {
              key: "render",
              value: function () {
                var e = this.props,
                  t = e.t,
                  n = e.component_data,
                  o = e.localization,
                  a = n.showWhenJp,
                  r = void 0 !== a && a,
                  i = n.qqDowngrade,
                  l = void 0 !== i && i,
                  s = n.modelArTabsName,
                  c = n.modelTabsName,
                  _ = n.showModal,
                  d = "JP" === o.country,
                  h = l && m.a.isQQBrowser();
                return !d || r
                  ? b(
                      u.a.Fragment,
                      null,
                      b(
                        "div",
                        null,
                        b(p.a, {
                          forceDowngrade: h,
                          modelArTabsName: t(s),
                          modelTabsName: t(c),
                          component_data: n,
                          t: t,
                          sendGa: this.sendGa,
                        }),
                      ),
                      _ ? b(f.a, this.props) : null,
                    )
                  : null;
              },
            },
          ]),
          t
        );
      })(u.a.Component);
      Object(c.a)(x, "defaultProps", {
        t: function () {},
        gaSend: function () {},
        component_data: g({ showWhenJp: !0 }, y.a),
      }),
        Object(c.a)(x, "propSettings", {
          key: "modelViewer",
          name: "modelViewer",
          contentSetting: g(
            {
              special: {
                label: "\u5730\u533a\u8bed\u8a00-\u7279\u6b8a\u914d\u7f6e",
                props: {
                  showWhenJp: {
                    type: "boolean",
                    label: "\u65e5\u672c\u533a\u57df\u662f\u5426\u663e\u793a",
                  },
                },
              },
            },
            y.b,
          ),
          skinSetting: g(
            g({}, y.c),
            {},
            {
              themeForModelViewerColor: {
                label: "\u80cc\u666f\u989c\u8272\u914d\u7f6e",
                props: {
                  customBackgroundColor: {
                    type: "string",
                    label: "\u81ea\u5b9a\u4e49\u80cc\u666f\u8272",
                  },
                },
              },
            },
          ),
        }),
        (t.default = Object(d.a)(x));
    },
    rfXi: function (e, t, n) {
      e.exports = { default: n("0tVQ"), __esModule: !0 };
    },
    rr1i: function (e, t) {
      e.exports = function (e, t) {
        return {
          enumerable: !(1 & e),
          configurable: !(2 & e),
          writable: !(4 & e),
          value: t,
        };
      };
    },
    rxEf: function (e, t, n) {
      e.exports = {
        "hero-vertical-component": "style__hero-vertical-component___2JEHR",
        "background-video": "style__background-video___1extI",
        "video-mask": "style__video-mask___1DemG",
        "video-wrapper": "style__video-wrapper___JVagE",
        "card-list": "style__card-list___3Bphf",
        "hero-vertical-wrapper": "style__hero-vertical-wrapper___2mUEj",
        "hot-zone-link": "style__hot-zone-link___2d31i",
        "vertical-card-list": "style__vertical-card-list___LceQJ",
        "vertical-card-col": "style__vertical-card-col___3agtC",
        "vertical-top-align": "style__vertical-top-align___3JPlu",
        "vertical-center-align": "style__vertical-center-align___39Pu3",
        "vertical-bottom-align": "style__vertical-bottom-align___4Jy20",
        "has-media-screen": "style__has-media-screen___dOgoS",
        "media-screen-1440": "style__media-screen-1440___2Mhdb",
        "media-screen-1600": "style__media-screen-1600___1_p1O",
      };
    },
    s3Ml: function (e, t, n) {
      e.exports = { default: n("JbBM"), __esModule: !0 };
    },
    sEf8: function (e, t) {
      e.exports = function (e) {
        return function (t) {
          return e(t);
        };
      };
    },
    sEfC: function (e, t, n) {
      var o = n("GoyQ"),
        a = n("QIyF"),
        r = n("tLB3"),
        i = "Expected a function",
        l = Math.max,
        s = Math.min;
      e.exports = function (e, t, n) {
        var c,
          _,
          u,
          d,
          p,
          f,
          h = 0,
          m = !1,
          y = !1,
          b = !0;
        if ("function" != typeof e) throw new TypeError(i);
        function v(t) {
          var n = c,
            o = _;
          return (c = _ = void 0), (h = t), (d = e.apply(o, n));
        }
        function g(e) {
          var n = e - f;
          return void 0 === f || n >= t || n < 0 || (y && e - h >= u);
        }
        function w() {
          var e = a();
          if (g(e)) return x(e);
          p = setTimeout(
            w,
            (function (e) {
              var n = t - (e - f);
              return y ? s(n, u - (e - h)) : n;
            })(e),
          );
        }
        function x(e) {
          return (p = void 0), b && c ? v(e) : ((c = _ = void 0), d);
        }
        function k() {
          var e = a(),
            n = g(e);
          if (((c = arguments), (_ = this), (f = e), n)) {
            if (void 0 === p)
              return (function (e) {
                return (h = e), (p = setTimeout(w, t)), m ? v(e) : d;
              })(f);
            if (y) return clearTimeout(p), (p = setTimeout(w, t)), v(f);
          }
          return void 0 === p && (p = setTimeout(w, t)), d;
        }
        return (
          (t = r(t) || 0),
          o(n) &&
            ((m = !!n.leading),
            (u = (y = "maxWait" in n) ? l(r(n.maxWait) || 0, t) : u),
            (b = "trailing" in n ? !!n.trailing : b)),
          (k.cancel = function () {
            void 0 !== p && clearTimeout(p), (h = 0), (c = f = _ = p = void 0);
          }),
          (k.flush = function () {
            return void 0 === p ? d : x(a());
          }),
          k
        );
      };
    },
    sNwI: function (e, t, n) {
      var o = n("5K7Z");
      e.exports = function (e, t, n, a) {
        try {
          return a ? t(o(n)[0], n[1]) : t(n);
        } catch (i) {
          var r = e.return;
          throw (void 0 !== r && o(r.call(e)), i);
        }
      };
    },
    shjB: function (e, t) {
      var n = 9007199254740991;
      e.exports = function (e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
      };
    },
    t3Un: function (e, t, n) {
      "use strict";
      var o = n("rePB"),
        a = n("LpSC"),
        r = n.n(a),
        i = n("cr+I"),
        l = n.n(i);
      function s(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function c(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? s(Object(n), !0).forEach(function (t) {
                Object(o.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : s(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var _ = function (e) {
        return e.indexOf("?") < 0 ? "?" : "&";
      };
      t.a = function (e, t) {
        var n = e.method,
          o = e.url,
          a = e.query,
          i = e.data,
          s = e.formData,
          u = c(
            c(
              { method: n || "GET" },
              s
                ? {}
                : {
                    headers: {
                      "Content-Type": "application/json; charset=utf-8",
                    },
                  },
            ),
            {},
            { credentials: "include", query: a, body: null },
          );
        if ((/terminator/.test(o) && delete u.credentials, i))
          u.body = JSON.stringify(i);
        else if ("object" === typeof s) {
          var d = new FormData();
          Object.keys(s).forEach(function (e) {
            return d.append(e, s[e]);
          }),
            (u.body = d);
        } else delete u.body;
        var p = l.a.stringify(a),
          f = t.language,
          h = t.country,
          m = o;
        return (
          (m += p ? "".concat(_(m)).concat(p) : ""),
          (m += void 0 !== f ? "".concat(_(m), "language=").concat(f) : ""),
          void 0 === l.a.parse(l.a.extract(m)).country &&
            (m += h ? "".concat(_(m), "country=").concat(h) : ""),
          r()(m, u)
        );
      };
    },
    t8Fj: function (e, t, n) {
      e.exports = n("+VcZ");
    },
    tEej: function (e, t, n) {
      var o = n("Ojgd"),
        a = Math.min;
      e.exports = function (e) {
        return e > 0 ? a(o(e), 9007199254740991) : 0;
      };
    },
    tLB3: function (e, t, n) {
      var o = n("jXQH"),
        a = n("GoyQ"),
        r = n("/9aa"),
        i = NaN,
        l = /^[-+]0x[0-9a-f]+$/i,
        s = /^0b[01]+$/i,
        c = /^0o[0-7]+$/i,
        _ = parseInt;
      e.exports = function (e) {
        if ("number" == typeof e) return e;
        if (r(e)) return i;
        if (a(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = a(t) ? t + "" : t;
        }
        if ("string" != typeof e) return 0 === e ? e : +e;
        e = o(e);
        var n = s.test(e);
        return n || c.test(e) ? _(e.slice(2), n ? 2 : 8) : l.test(e) ? i : +e;
      };
    },
    tMB7: function (e, t, n) {
      var o = n("y1pI");
      e.exports = function (e) {
        var t = this.__data__,
          n = o(t, e);
        return n < 0 ? void 0 : t[n][1];
      };
    },
    tZZE: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      }),
        n.d(t, "b", function () {
          return r;
        });
      var o = (function (e) {
          return (e.BLANK = "_blank"), (e.SELF = "_self"), e;
        })({}),
        a = function (e, t) {
          var n, o;
          return !!(
            "A" === (null === e || void 0 === e ? void 0 : e.nodeName) ||
            "BUTTON" === (null === e || void 0 === e ? void 0 : e.nodeName) ||
            (null === e || void 0 === e
              ? void 0
              : null === (n = e.className) || void 0 === n
                ? void 0
                : n.includes("play-btn")) ||
            (null === e || void 0 === e
              ? void 0
              : null === (o = e.className) || void 0 === o
                ? void 0
                : o.includes(t)) ||
            (null === e || void 0 === e ? void 0 : e.getAttribute("data-link"))
          );
        },
        r = function (e, t) {
          var n =
            arguments.length > 2 && void 0 !== arguments[2]
              ? arguments[2]
              : "media-modal";
          if (e && e.target) {
            var o = e.target;
            if (!o.nodeName || !a(o, n)) {
              for (; o.offsetParent; )
                if (((o = o.offsetParent), a(o, n))) return;
              t && t.url && "/" !== t.url && window.open(t.url, t.target);
            }
          }
        };
    },
    tadb: function (e, t, n) {
      var o = n("Cwc5")(n("Kz5y"), "DataView");
      e.exports = o;
    },
    tfAK: function (e, t, n) {
      e.exports = {
        "product-sample-wrapper": "style__product-sample-wrapper___2k80u",
        "product-sample-inner-wrapper":
          "style__product-sample-inner-wrapper___SlMRm",
        "sample-title": "style__sample-title___2_u67",
      };
    },
    tm1d: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = function (e, t, n) {
        var o = t - e;
        return 0 === o ? 1 : (n - e) / o;
      };
    },
    tu8O: function (e, t, n) {
      "use strict";
      function o(e) {
        return (
          "object" === typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function a(e, t) {
        var n = ["__proto__", "constructor", "prototype"];
        Object.keys(t)
          .filter(function (e) {
            return n.indexOf(e) < 0;
          })
          .forEach(function (n) {
            "undefined" === typeof e[n]
              ? (e[n] = t[n])
              : o(t[n]) && o(e[n]) && Object.keys(t[n]).length > 0
                ? t[n].__swiper__
                  ? (e[n] = t[n])
                  : a(e[n], t[n])
                : (e[n] = t[n]);
          });
      }
      function r(e) {
        return (
          void 0 === e && (e = {}),
          e.navigation &&
            "undefined" === typeof e.navigation.nextEl &&
            "undefined" === typeof e.navigation.prevEl
        );
      }
      function i(e) {
        return (
          void 0 === e && (e = {}),
          e.pagination && "undefined" === typeof e.pagination.el
        );
      }
      function l(e) {
        return (
          void 0 === e && (e = {}),
          e.scrollbar && "undefined" === typeof e.scrollbar.el
        );
      }
      function s(e) {
        void 0 === e && (e = "");
        var t = e
            .split(" ")
            .map(function (e) {
              return e.trim();
            })
            .filter(function (e) {
              return !!e;
            }),
          n = [];
        return (
          t.forEach(function (e) {
            n.indexOf(e) < 0 && n.push(e);
          }),
          n.join(" ")
        );
      }
      n.d(t, "b", function () {
        return o;
      }),
        n.d(t, "a", function () {
          return a;
        }),
        n.d(t, "c", function () {
          return r;
        }),
        n.d(t, "d", function () {
          return i;
        }),
        n.d(t, "e", function () {
          return l;
        }),
        n.d(t, "f", function () {
          return s;
        });
    },
    tvYQ: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return i;
      }),
        n.d(t, "b", function () {
          return l;
        }),
        n.d(t, "c", function () {
          return u;
        }),
        n.d(t, "d", function () {
          return s;
        }),
        n.d(t, "e", function () {
          return c;
        }),
        n.d(t, "f", function () {
          return _;
        });
      var o = n("mrSG"),
        a = n("3T+G"),
        r = function (e) {
          return {
            test: function (t) {
              return (
                Object(a.d)(t) && t.endsWith(e) && 1 === t.split(" ").length
              );
            },
            parse: parseFloat,
            transform: function (t) {
              return "" + t + e;
            },
          };
        },
        i = r("deg"),
        l = r("%"),
        s = r("px"),
        c = r("vh"),
        _ = r("vw"),
        u = Object(o.a)(Object(o.a)({}, l), {
          parse: function (e) {
            return l.parse(e) / 100;
          },
          transform: function (e) {
            return l.transform(100 * e);
          },
        });
    },
    tzmE: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.Dots = void 0);
      var o =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        a = i(n("q1tI")),
        r = i(n("TSYQ"));
      function i(e) {
        return e && e.__esModule ? e : { default: e };
      }
      t.Dots = (function (e) {
        function t() {
          return (
            (function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
            (function (e, t) {
              if (!e)
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called",
                );
              return !t || ("object" !== typeof t && "function" !== typeof t)
                ? e
                : t;
            })(this, e.apply(this, arguments))
          );
        }
        return (
          (function (e, t) {
            if ("function" !== typeof t && null !== t)
              throw new TypeError(
                "Super expression must either be null or a function, not " +
                  typeof t,
              );
            (e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
              t &&
                (Object.setPrototypeOf
                  ? Object.setPrototypeOf(e, t)
                  : (e.__proto__ = t));
          })(t, e),
          (t.prototype.clickHandler = function (e, t) {
            t.preventDefault(), this.props.clickHandler(e);
          }),
          (t.prototype.render = function () {
            var e,
              t = this,
              n = (e = {
                slideCount: this.props.slideCount,
                slidesToScroll: this.props.slidesToScroll,
                slidesToShow: this.props.slidesToShow,
                infinite: this.props.infinite,
              }).infinite
                ? Math.ceil(e.slideCount / e.slidesToScroll)
                : Math.ceil(
                    (e.slideCount - e.slidesToShow) / e.slidesToScroll,
                  ) + 1,
              i = this.props,
              l = {
                onMouseEnter: i.onMouseEnter,
                onMouseOver: i.onMouseOver,
                onMouseLeave: i.onMouseLeave,
              },
              s = Array.apply(
                null,
                Array(n + 1)
                  .join("0")
                  .split(""),
              ).map(function (e, n) {
                var o = n * t.props.slidesToScroll,
                  i = n * t.props.slidesToScroll + (t.props.slidesToScroll - 1),
                  l = (0, r.default)({
                    "slick-active":
                      t.props.currentSlide >= o && t.props.currentSlide <= i,
                  }),
                  s = {
                    message: "dots",
                    index: n,
                    slidesToScroll: t.props.slidesToScroll,
                    currentSlide: t.props.currentSlide,
                  },
                  c = t.clickHandler.bind(t, s);
                return a.default.createElement(
                  "li",
                  { key: n, className: l },
                  a.default.cloneElement(t.props.customPaging(n), {
                    onClick: c,
                  }),
                );
              });
            return a.default.cloneElement(
              this.props.appendDots(s),
              o({ className: this.props.dotsClass }, l),
            );
          }),
          t
        );
      })(a.default.PureComponent);
    },
    "u+OR": function (e, t, n) {},
    u11H: function (e, t, n) {
      "use strict";
      n.r(t),
        n.d(t, "default", function () {
          return _;
        });
      var o = n("HaE+"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("rePB"),
        l = n("t3Un"),
        s = n("yWgo");
      function c() {
        c = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function _(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          _({}, "");
        } catch (e) {
          _ = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function u(e, t, n, o) {
          var r = t && t.prototype instanceof b ? t : b,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function d(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = u;
        var p = "suspendedStart",
          f = "suspendedYield",
          h = "executing",
          m = "completed",
          y = {};
        function b() {}
        function v() {}
        function g() {}
        var w = {};
        _(w, i, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, i) && (w = k);
        var O = (g.prototype = b.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            _(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = d(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = p;
          return function (r, i) {
            if (a === h) throw new Error("Generator is already running");
            if (a === m) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === p) throw ((a = m), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = h;
              var c = d(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? m : f), c.arg === y)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = m), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              y
            );
          var r = d(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), y
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                y)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (v.prototype = g),
          a(O, "constructor", { value: g, configurable: !0 }),
          a(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = _(g, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), _(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          _(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(u(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          _(O, s, "Generator"),
          _(O, i, function () {
            return this;
          }),
          _(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), y)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                y
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                y
              );
            },
          }),
          t
        );
      }
      var _ = (function () {
        function e() {
          Object(a.default)(this, e);
        }
        return (
          Object(r.default)(e, null, [
            {
              key: "renderAPI",
              value: function (t) {
                if ("string" !== typeof t) return t;
                var n = "";
                return (
                  e.apiHostList.official_api.prod &&
                    (n = e.apiHostList.official_api.prod.host),
                  n + t
                );
              },
            },
            {
              key: "request",
              value: (function () {
                var t = Object(o.default)(
                  c().mark(function t(n, o) {
                    var a, r, i, _, u, d;
                    return c().wrap(function (t) {
                      for (;;)
                        switch ((t.prev = t.next)) {
                          case 0:
                            if (
                              ((r = (a = n).name),
                              (i = a.method),
                              (_ = ""),
                              (u = ""),
                              e.apiList[r] && (u = e.apiList[r]),
                              e.apiHostList.official_api.prod &&
                                (_ = e.apiHostList.official_api.prod.host),
                              (d = ""),
                              o &&
                                (d = s.db.getCountryUrlPrefix({
                                  country: o.country,
                                  locale: o.language,
                                })),
                              u &&
                                (n = Object.assign(n, {
                                  url: "".concat(_).concat(d).concat(u),
                                })),
                              "POST" !== i)
                            ) {
                              t.next = 11;
                              break;
                            }
                            return (
                              (t.next = 11),
                              e.getCsrf({ host: _, localization: o, opt: n })
                            );
                          case 11:
                            return t.abrupt("return", Object(l.a)(n, o));
                          case 12:
                          case "end":
                            return t.stop();
                        }
                    }, t);
                  }),
                );
                return function (e, n) {
                  return t.apply(this, arguments);
                };
              })(),
            },
            {
              key: "getCsrf",
              value: (function () {
                var t = Object(o.default)(
                  c().mark(function t(n) {
                    var o, a, r, i, s, _;
                    return c().wrap(function (t) {
                      for (;;)
                        switch ((t.prev = t.next)) {
                          case 0:
                            return (
                              (o = n.host),
                              (a = n.localization),
                              (r = n.opt),
                              (t.next = 3),
                              Object(l.a)(
                                { url: "".concat(o).concat(e.apiList.csrf) },
                                a,
                              )
                            );
                          case 3:
                            return (i = t.sent), (t.next = 6), i.json();
                          case 6:
                            (s = t.sent),
                              (_ = s._csrf),
                              r.data
                                ? (r.data = Object.assign(r.data, { _csrf: _ }))
                                : r.formData &&
                                  (r.formData = Object.assign(r.formData, {
                                    _csrf: _,
                                  }));
                          case 9:
                          case "end":
                            return t.stop();
                        }
                    }, t);
                  }),
                );
                return function (e) {
                  return t.apply(this, arguments);
                };
              })(),
            },
          ]),
          e
        );
      })();
      Object(i.a)(_, "apiHostList", {
        official_api: {
          test: { host: "//test-www-api.dbeta.me" },
          dev: { host: "//test-www-api.dbeta.me" },
          stag: { host: "//stag-www-api.dbeta.me" },
          prod: { host: "//www-api.dji.com" },
          master: { host: "//www-api.dji.com" },
          host: "//www-api.dji.com",
        },
      }),
        Object(i.a)(_, "apiList", {
          arsDealer: "/api/ars-dealers",
          cart: "/api/user/cart",
          currentTime: "/api/util/current_time",
          csrf: "/api/csrf",
          createActivity: "/api/activity/create",
          chinaCities: "/api/dealers/china_cities/",
          citiesInChina: "/api/dealers/cities_in_china",
          captchaValidate: "/api/util/captcha/validate",
          dealerContinent: "/api/dealers/continents",
          dealerCountry: "/api/dealers/countries/",
          dealerState: "/api/dealers/states/",
          dealerStore: "/api/dealers/store/",
          dealerStores: "/api/dealers/stores/",
          dealerSubmit: "/api/dealers/submit?www=v2",
          dealerWarranties: "/api/dealers/warranties/",
          dealerZipcode: "/api/dealers/zipcode/",
          enterpriseSubIndustry: "/api/enterprise/subIndustry",
          flySafeIntroduction: "/api/flysafe/introduction",
          geoAreas: "/api/geo/areas",
          geoCountry: "/api/geo/country/",
          geoPointInfo: "/api/geo/point-info",
          geoSupportList: "/api/geo/support-list",
          geoSystemCheckUserVerify: "/api/geo-system/check-user-verify",
          geoSystemSubmitUnlockTerm: "/api/geo-system/submit-unlock-terms",
          geoSystemAdvanceUnlock: "/api/geo-system/advance-unlock?www=v2",
          geoSystemCustomUnlock:
            "/api/geo-system/custom-unlock?www=v2&www-cache=official",
          geoSystemFileUpload:
            "/api/geo-system/file-upload?www=v2&www-cache=official",
          localeIpLocation: "/api/locale/ip-location",
          noFlyCountry: "/api/no-fly/country/",
          officialGetUserInfo: "/api/official/get_user_info/",
          officialGetCurrentCountry: "/api/official/get_current_country",
          productCenterMg: "/api/product_center/mg-1/cn",
          productGroupAllSeries: "/api/products/groups/all-series",
          productListAllNav: "/api/products/list/all-nav",
          productListAllSeries: "/api/products/list/all-series",
          productPrice: "/api/product/price",
          productGetPrice: "/api/product/get_price",
          productGetMiniDetails: "/api/product/get_mini_details",
          productDealersMg1: "/api/product_dealers/mg-1",
          productCenterMg1: "/api/product_center/mg-1",
          reserveAvailable: "/api/reserve/available/",
          reserveTypelistWingedAppointment:
            "/api/reserve/typelist/winged_appointment",
          reserveVerify: "/api/reserve/verify?www=v2",
          searchHotWord: "/api/search/hot-word",
          searchFind: "/api/search/find",
          skypixelLogin: "/oauth2/auth?www=v2",
          showCaseSubmitVideo: "/api/showcase/submit/video?www=v2",
          subscribe: "/api/subscribe?www=v2",
          serviceCenter: "/api/service/center",
          userInformation: "/api/user/information",
          userInfoEmail: "/api/user/info/email",
          whereToBuyAgriMap: "/api/where-to-buy/agriculture-dealer-maps",
          whereToBuyDeliveryMap: "/api/where-to-buy/delivery-dealer-maps",
          whereToBuyDealerMap: "/api/where-to-buy/dealer-maps",
          whereToBuyProDealer: "/api/where-to-buy/professional-dealers/",
          whereToBuySearch: "/api/where-to-buy/search/",
          flySafeIpLocation: "/api/flysafe/ip-location",
          flySafeSelfUnlockVerify: "/api/flysafe/self-unlock/verify?www=v2",
          flySafeSelfUnlockSendVerifycationCode:
            "/api/flysafe/self-unlock/send-verification-code?www=v2",
          flySafeLink: "/api/flysafe/link",
          flySafeCountryChunkMap: "/api/flysafe/country-chunk-map",
          captchaNeeded: "/api/util/captcha_needed",
          formSubmit: "/api/activity/v3_create?www=v2",
          formSubmitByLogin: "/api/activity/create_by_login_user?www=v2",
          ecosystemFormSubmit:
            "/api/activity/ecosystem_form_create?www=v2&www-cache=official",
          supportMailFormSubmit:
            "/api/support/problem?lang=en&www=v2&www-cache=official",
          agCaseStudiesTagList: "/api/get-case-studies-tag-list",
          agCaseStudiesQueryNews: "/api/get-case-studies-news",
          getNewsMediaData: "/api/get_ag_news",
          getCurrentTime: "/api/util/current_time",
          getEcologyDetailData: "/api/get-enterprise-ecology-list",
          getWechatSignature: "/api/get-wechat-signature",
          getSubscribeCompaign: "/api/subscribe-compaign",
        });
    },
    u6T5: function (e, t, n) {
      var o, a, r, i;
      "undefined" != typeof self && self,
        (e.exports =
          ((o = n("q1tI")),
          (a = n("17x9")),
          (r = n("TSYQ")),
          (i = n("hKI/")),
          (function (e) {
            function t(o) {
              if (n[o]) return n[o].exports;
              var a = (n[o] = { i: o, l: !1, exports: {} });
              return (
                e[o].call(a.exports, a, a.exports, t), (a.l = !0), a.exports
              );
            }
            var n = {};
            return (
              (t.m = e),
              (t.c = n),
              (t.d = function (e, n, o) {
                t.o(e, n) ||
                  Object.defineProperty(e, n, {
                    configurable: !1,
                    enumerable: !0,
                    get: o,
                  });
              }),
              (t.n = function (e) {
                var n =
                  e && e.__esModule
                    ? function () {
                        return e.default;
                      }
                    : function () {
                        return e;
                      };
                return t.d(n, "a", n), n;
              }),
              (t.o = function (e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
              }),
              (t.p = ""),
              t((t.s = 259))
            );
          })([
            function (e, t) {
              var n = (e.exports =
                "undefined" != typeof window && window.Math == Math
                  ? window
                  : "undefined" != typeof self && self.Math == Math
                    ? self
                    : Function("return this")());
              "number" == typeof __g && (__g = n);
            },
            function (e, t) {
              var n = (e.exports = { version: "2.5.3" });
              "number" == typeof __e && (__e = n);
            },
            function (e, t, n) {
              e.exports = !n(8)(function () {
                return (
                  7 !=
                  Object.defineProperty({}, "a", {
                    get: function () {
                      return 7;
                    },
                  }).a
                );
              });
            },
            function (e, t) {
              e.exports = function (e) {
                return "object" == typeof e
                  ? null !== e
                  : "function" == typeof e;
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(32),
                r = n(21),
                i = Object.defineProperty;
              t.f = n(2)
                ? Object.defineProperty
                : function (e, t, n) {
                    if ((o(e), (t = r(t, !0)), o(n), a))
                      try {
                        return i(e, t, n);
                      } catch (e) {}
                    if ("get" in n || "set" in n)
                      throw TypeError("Accessors not supported!");
                    return "value" in n && (e[t] = n.value), e;
                  };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e) {
                if (!o(e)) throw TypeError(e + " is not an object!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(35),
                a = n(30);
              e.exports = function (e) {
                return o(a(e));
              };
            },
            function (e, t) {
              var n = {}.hasOwnProperty;
              e.exports = function (e, t) {
                return n.call(e, t);
              };
            },
            function (e, t) {
              e.exports = function (e) {
                try {
                  return !!e();
                } catch (e) {
                  return !0;
                }
              };
            },
            function (e, t) {
              e.exports = o;
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(27),
                i = n(18),
                l = "prototype",
                s = function (e, t, n) {
                  var c,
                    _,
                    u,
                    d = e & s.F,
                    p = e & s.G,
                    f = e & s.S,
                    h = e & s.P,
                    m = e & s.B,
                    y = e & s.W,
                    b = p ? a : a[t] || (a[t] = {}),
                    v = b[l],
                    g = p ? o : f ? o[t] : (o[t] || {})[l];
                  for (c in (p && (n = t), n))
                    ((_ = !d && g && void 0 !== g[c]) && c in b) ||
                      ((u = _ ? g[c] : n[c]),
                      (b[c] =
                        p && "function" != typeof g[c]
                          ? n[c]
                          : m && _
                            ? r(u, o)
                            : y && g[c] == u
                              ? (function (e) {
                                  var t = function (t, n, o) {
                                    if (this instanceof e) {
                                      switch (arguments.length) {
                                        case 0:
                                          return new e();
                                        case 1:
                                          return new e(t);
                                        case 2:
                                          return new e(t, n);
                                      }
                                      return new e(t, n, o);
                                    }
                                    return e.apply(this, arguments);
                                  };
                                  return (t[l] = e[l]), t;
                                })(u)
                              : h && "function" == typeof u
                                ? r(Function.call, u)
                                : u),
                      h &&
                        (((b.virtual || (b.virtual = {}))[c] = u),
                        e & s.R && v && !v[c] && i(v, c, u)));
                };
              (s.F = 1),
                (s.G = 2),
                (s.S = 4),
                (s.P = 8),
                (s.B = 16),
                (s.W = 32),
                (s.U = 64),
                (s.R = 128),
                (e.exports = s);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22);
              e.exports =
                Object.keys ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t) {
              e.exports = a;
            },
            function (e, t, n) {
              e.exports = { default: n(49), __esModule: !0 };
            },
            function (e, t, n) {
              e.exports = { default: n(51), __esModule: !0 };
            },
            function (e, t) {
              t.f = {}.propertyIsEnumerable;
            },
            function (e, t, n) {
              e.exports = { default: n(57), __esModule: !0 };
            },
            function (e, t) {
              var n = 0,
                o = Math.random();
              e.exports = function (e) {
                return "Symbol(".concat(
                  void 0 === e ? "" : e,
                  ")_",
                  (++n + o).toString(36),
                );
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(20);
              e.exports = n(2)
                ? function (e, t, n) {
                    return o.f(e, t, a(1, n));
                  }
                : function (e, t, n) {
                    return (e[t] = n), e;
                  };
            },
            function (e, t, n) {
              var o = n(25)("wks"),
                a = n(17),
                r = n(0).Symbol,
                i = "function" == typeof r;
              (e.exports = function (e) {
                return (
                  o[e] || (o[e] = (i && r[e]) || (i ? r : a)("Symbol." + e))
                );
              }).store = o;
            },
            function (e, t) {
              e.exports = function (e, t) {
                return {
                  enumerable: !(1 & e),
                  configurable: !(2 & e),
                  writable: !(4 & e),
                  value: t,
                };
              };
            },
            function (e, t, n) {
              var o = n(3);
              e.exports = function (e, t) {
                if (!o(e)) return e;
                var n, a;
                if (
                  t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                if ("function" == typeof (n = e.valueOf) && !o((a = n.call(e))))
                  return a;
                if (
                  !t &&
                  "function" == typeof (n = e.toString) &&
                  !o((a = n.call(e)))
                )
                  return a;
                throw TypeError("Can't convert object to primitive value");
              };
            },
            function (e, t) {
              e.exports =
                "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                  ",",
                );
            },
            function (e, t) {
              e.exports = r;
            },
            function (e, t, n) {
              e.exports = { default: n(60), __esModule: !0 };
            },
            function (e, t, n) {
              var o = n(0),
                a = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
              e.exports = function (e) {
                return a[e] || (a[e] = {});
              };
            },
            function (e, t) {
              t.f = Object.getOwnPropertySymbols;
            },
            function (e, t, n) {
              var o = n(42);
              e.exports = function (e, t, n) {
                if ((o(e), void 0 === t)) return e;
                switch (n) {
                  case 1:
                    return function (n) {
                      return e.call(t, n);
                    };
                  case 2:
                    return function (n, o) {
                      return e.call(t, n, o);
                    };
                  case 3:
                    return function (n, o, a) {
                      return e.call(t, n, o, a);
                    };
                }
                return function () {
                  return e.apply(t, arguments);
                };
              };
            },
            function (e, t) {
              var n = Math.ceil,
                o = Math.floor;
              e.exports = function (e) {
                return isNaN((e = +e)) ? 0 : (e > 0 ? o : n)(e);
              };
            },
            function (e, t, n) {
              var o = n(25)("keys"),
                a = n(17);
              e.exports = function (e) {
                return o[e] || (o[e] = a(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if (void 0 == e) throw TypeError("Can't call method on  " + e);
                return e;
              };
            },
            function (e, t, n) {
              var o = n(3),
                a = n(0).document,
                r = o(a) && o(a.createElement);
              e.exports = function (e) {
                return r ? a.createElement(e) : {};
              };
            },
            function (e, t, n) {
              e.exports =
                !n(2) &&
                !n(8)(function () {
                  return (
                    7 !=
                    Object.defineProperty(n(31)("div"), "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
            },
            function (e, t) {
              var n = {}.toString;
              e.exports = function (e) {
                return n.call(e).slice(8, -1);
              };
            },
            function (e, t, n) {
              var o = n(5),
                a = n(48),
                r = n(22),
                i = n(29)("IE_PROTO"),
                l = function () {},
                s = function () {
                  var e,
                    t = n(31)("iframe"),
                    o = r.length;
                  for (
                    t.style.display = "none",
                      n(44).appendChild(t),
                      t.src = "javascript:",
                      (e = t.contentWindow.document).open(),
                      e.write("<script>document.F=Object</script>"),
                      e.close(),
                      s = e.F;
                    o--;

                  )
                    delete s.prototype[r[o]];
                  return s();
                };
              e.exports =
                Object.create ||
                function (e, t) {
                  var n;
                  return (
                    null !== e
                      ? ((l.prototype = o(e)),
                        (n = new l()),
                        (l.prototype = null),
                        (n[i] = e))
                      : (n = s()),
                    void 0 === t ? n : a(n, t)
                  );
                };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports = Object("z").propertyIsEnumerable(0)
                ? Object
                : function (e) {
                    return "String" == o(e) ? e.split("") : Object(e);
                  };
            },
            function (e, t, n) {
              var o = n(7),
                a = n(6),
                r = n(46)(!1),
                i = n(29)("IE_PROTO");
              e.exports = function (e, t) {
                var n,
                  l = a(e),
                  s = 0,
                  c = [];
                for (n in l) n != i && o(l, n) && c.push(n);
                for (; t.length > s; )
                  o(l, (n = t[s++])) && (~r(c, n) || c.push(n));
                return c;
              };
            },
            function (e, t, n) {
              var o = n(15),
                a = n(20),
                r = n(6),
                i = n(21),
                l = n(7),
                s = n(32),
                c = Object.getOwnPropertyDescriptor;
              t.f = n(2)
                ? c
                : function (e, t) {
                    if (((e = r(e)), (t = i(t, !0)), s))
                      try {
                        return c(e, t);
                      } catch (e) {}
                    if (l(e, t)) return a(!o.f.call(e, t), e[t]);
                  };
            },
            function (e, t) {
              e.exports = !0;
            },
            function (e, t, n) {
              t.f = n(19);
            },
            function (e, t, n) {
              var o = n(36),
                a = n(22).concat("length", "prototype");
              t.f =
                Object.getOwnPropertyNames ||
                function (e) {
                  return o(e, a);
                };
            },
            function (e, t, n) {
              var o = n(30);
              e.exports = function (e) {
                return Object(o(e));
              };
            },
            function (e, t) {
              e.exports = function (e) {
                if ("function" != typeof e)
                  throw TypeError(e + " is not a function!");
                return e;
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.min;
              e.exports = function (e) {
                return e > 0 ? a(o(e), 9007199254740991) : 0;
              };
            },
            function (e, t, n) {
              var o = n(0).document;
              e.exports = o && o.documentElement;
            },
            function (e, t, n) {
              var o = n(4).f,
                a = n(7),
                r = n(19)("toStringTag");
              e.exports = function (e, t, n) {
                e &&
                  !a((e = n ? e : e.prototype), r) &&
                  o(e, r, { configurable: !0, value: t });
              };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(43),
                r = n(47);
              e.exports = function (e) {
                return function (t, n, i) {
                  var l,
                    s = o(t),
                    c = a(s.length),
                    _ = r(i, c);
                  if (e && n != n) {
                    for (; c > _; ) if ((l = s[_++]) != l) return !0;
                  } else
                    for (; c > _; _++)
                      if ((e || _ in s) && s[_] === n) return e || _ || 0;
                  return !e && -1;
                };
              };
            },
            function (e, t, n) {
              var o = n(28),
                a = Math.max,
                r = Math.min;
              e.exports = function (e, t) {
                return (e = o(e)) < 0 ? a(e + t, 0) : r(e, t);
              };
            },
            function (e, t, n) {
              var o = n(4),
                a = n(5),
                r = n(11);
              e.exports = n(2)
                ? Object.defineProperties
                : function (e, t) {
                    a(e);
                    for (var n, i = r(t), l = i.length, s = 0; l > s; )
                      o.f(e, (n = i[s++]), t[n]);
                    return e;
                  };
            },
            function (e, t, n) {
              n(50);
              var o = n(1).Object;
              e.exports = function (e, t) {
                return o.create(e, t);
              };
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { create: n(34) });
            },
            function (e, t, n) {
              n(52), (e.exports = n(1).Object.setPrototypeOf);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S, "Object", { setPrototypeOf: n(53).set });
            },
            function (e, t, n) {
              var o = n(3),
                a = n(5),
                r = function (e, t) {
                  if ((a(e), !o(t) && null !== t))
                    throw TypeError(t + ": can't set as prototype!");
                };
              e.exports = {
                set:
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function (e, t, o) {
                        try {
                          (o = n(27)(
                            Function.call,
                            n(37).f(Object.prototype, "__proto__").set,
                            2,
                          ))(e, []),
                            (t = !(e instanceof Array));
                        } catch (e) {
                          t = !0;
                        }
                        return function (e, n) {
                          return r(e, n), t ? (e.__proto__ = n) : o(e, n), e;
                        };
                      })({}, !1)
                    : void 0),
                check: r,
              };
            },
            function (e, t, n) {
              var o = n(0),
                a = n(1),
                r = n(38),
                i = n(39),
                l = n(4).f;
              e.exports = function (e) {
                var t = a.Symbol || (a.Symbol = r ? {} : o.Symbol || {});
                "_" == e.charAt(0) || e in t || l(t, e, { value: i.f(e) });
              };
            },
            function (e, t, n) {
              e.exports = n(18);
            },
            function (e, t, n) {
              "use strict";
              var o = n(0),
                a = n(7),
                r = n(2),
                i = n(10),
                l = n(55),
                s = n(61).KEY,
                c = n(8),
                _ = n(25),
                u = n(45),
                d = n(17),
                p = n(19),
                f = n(39),
                h = n(54),
                m = n(62),
                y = n(63),
                b = n(5),
                v = n(3),
                g = n(6),
                w = n(21),
                x = n(20),
                k = n(34),
                O = n(64),
                I = n(37),
                S = n(4),
                j = n(11),
                T = I.f,
                C = S.f,
                M = O.f,
                P = o.Symbol,
                E = o.JSON,
                L = E && E.stringify,
                B = "prototype",
                N = p("_hidden"),
                D = p("toPrimitive"),
                z = {}.propertyIsEnumerable,
                A = _("symbol-registry"),
                R = _("symbols"),
                F = _("op-symbols"),
                V = Object[B],
                H = "function" == typeof P,
                W = o.QObject,
                U = !W || !W[B] || !W[B].findChild,
                G =
                  r &&
                  c(function () {
                    return (
                      7 !=
                      k(
                        C({}, "a", {
                          get: function () {
                            return C(this, "a", { value: 7 }).a;
                          },
                        }),
                      ).a
                    );
                  })
                    ? function (e, t, n) {
                        var o = T(V, t);
                        o && delete V[t],
                          C(e, t, n),
                          o && e !== V && C(V, t, o);
                      }
                    : C,
                Y = function (e) {
                  var t = (R[e] = k(P[B]));
                  return (t._k = e), t;
                },
                q =
                  H && "symbol" == typeof P.iterator
                    ? function (e) {
                        return "symbol" == typeof e;
                      }
                    : function (e) {
                        return e instanceof P;
                      },
                X = function (e, t, n) {
                  return (
                    e === V && X(F, t, n),
                    b(e),
                    (t = w(t, !0)),
                    b(n),
                    a(R, t)
                      ? (n.enumerable
                          ? (a(e, N) && e[N][t] && (e[N][t] = !1),
                            (n = k(n, { enumerable: x(0, !1) })))
                          : (a(e, N) || C(e, N, x(1, {})), (e[N][t] = !0)),
                        G(e, t, n))
                      : C(e, t, n)
                  );
                },
                Z = function (e, t) {
                  b(e);
                  for (var n, o = m((t = g(t))), a = 0, r = o.length; r > a; )
                    X(e, (n = o[a++]), t[n]);
                  return e;
                },
                K = function (e) {
                  var t = z.call(this, (e = w(e, !0)));
                  return (
                    !(this === V && a(R, e) && !a(F, e)) &&
                    (!(
                      t ||
                      !a(this, e) ||
                      !a(R, e) ||
                      (a(this, N) && this[N][e])
                    ) ||
                      t)
                  );
                },
                Q = function (e, t) {
                  if (
                    ((e = g(e)), (t = w(t, !0)), e !== V || !a(R, t) || a(F, t))
                  ) {
                    var n = T(e, t);
                    return (
                      !n ||
                        !a(R, t) ||
                        (a(e, N) && e[N][t]) ||
                        (n.enumerable = !0),
                      n
                    );
                  }
                },
                J = function (e) {
                  for (var t, n = M(g(e)), o = [], r = 0; n.length > r; )
                    a(R, (t = n[r++])) || t == N || t == s || o.push(t);
                  return o;
                },
                $ = function (e) {
                  for (
                    var t, n = e === V, o = M(n ? F : g(e)), r = [], i = 0;
                    o.length > i;

                  )
                    !a(R, (t = o[i++])) || (n && !a(V, t)) || r.push(R[t]);
                  return r;
                };
              H ||
                (l(
                  (P = function () {
                    if (this instanceof P)
                      throw TypeError("Symbol is not a constructor!");
                    var e = d(arguments.length > 0 ? arguments[0] : void 0),
                      t = function (n) {
                        this === V && t.call(F, n),
                          a(this, N) && a(this[N], e) && (this[N][e] = !1),
                          G(this, e, x(1, n));
                      };
                    return (
                      r && U && G(V, e, { configurable: !0, set: t }), Y(e)
                    );
                  })[B],
                  "toString",
                  function () {
                    return this._k;
                  },
                ),
                (I.f = Q),
                (S.f = X),
                (n(40).f = O.f = J),
                (n(15).f = K),
                (n(26).f = $),
                r && !n(38) && l(V, "propertyIsEnumerable", K, !0),
                (f.f = function (e) {
                  return Y(p(e));
                })),
                i(i.G + i.W + i.F * !H, { Symbol: P });
              for (
                var ee =
                    "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
                      ",",
                    ),
                  te = 0;
                ee.length > te;

              )
                p(ee[te++]);
              for (var ne = j(p.store), oe = 0; ne.length > oe; ) h(ne[oe++]);
              i(i.S + i.F * !H, "Symbol", {
                for: function (e) {
                  return a(A, (e += "")) ? A[e] : (A[e] = P(e));
                },
                keyFor: function (e) {
                  if (!q(e)) throw TypeError(e + " is not a symbol!");
                  for (var t in A) if (A[t] === e) return t;
                },
                useSetter: function () {
                  U = !0;
                },
                useSimple: function () {
                  U = !1;
                },
              }),
                i(i.S + i.F * !H, "Object", {
                  create: function (e, t) {
                    return void 0 === t ? k(e) : Z(k(e), t);
                  },
                  defineProperty: X,
                  defineProperties: Z,
                  getOwnPropertyDescriptor: Q,
                  getOwnPropertyNames: J,
                  getOwnPropertySymbols: $,
                }),
                E &&
                  i(
                    i.S +
                      i.F *
                        (!H ||
                          c(function () {
                            var e = P();
                            return (
                              "[null]" != L([e]) ||
                              "{}" != L({ a: e }) ||
                              "{}" != L(Object(e))
                            );
                          })),
                    "JSON",
                    {
                      stringify: function (e) {
                        for (var t, n, o = [e], a = 1; arguments.length > a; )
                          o.push(arguments[a++]);
                        if (((n = t = o[1]), (v(t) || void 0 !== e) && !q(e)))
                          return (
                            y(t) ||
                              (t = function (e, t) {
                                if (
                                  ("function" == typeof n &&
                                    (t = n.call(this, e, t)),
                                  !q(t))
                                )
                                  return t;
                              }),
                            (o[1] = t),
                            L.apply(E, o)
                          );
                      },
                    },
                  ),
                P[B][D] || n(18)(P[B], D, P[B].valueOf),
                u(P, "Symbol"),
                u(Math, "Math", !0),
                u(o.JSON, "JSON", !0);
            },
            function (e, t, n) {
              n(58), (e.exports = n(1).Object.assign);
            },
            function (e, t, n) {
              var o = n(10);
              o(o.S + o.F, "Object", { assign: n(59) });
            },
            function (e, t, n) {
              "use strict";
              var o = n(11),
                a = n(26),
                r = n(15),
                i = n(41),
                l = n(35),
                s = Object.assign;
              e.exports =
                !s ||
                n(8)(function () {
                  var e = {},
                    t = {},
                    n = Symbol(),
                    o = "abcdefghijklmnopqrst";
                  return (
                    (e[n] = 7),
                    o.split("").forEach(function (e) {
                      t[e] = e;
                    }),
                    7 != s({}, e)[n] || Object.keys(s({}, t)).join("") != o
                  );
                })
                  ? function (e, t) {
                      for (
                        var n = i(e),
                          s = arguments.length,
                          c = 1,
                          _ = a.f,
                          u = r.f;
                        s > c;

                      )
                        for (
                          var d,
                            p = l(arguments[c++]),
                            f = _ ? o(p).concat(_(p)) : o(p),
                            h = f.length,
                            m = 0;
                          h > m;

                        )
                          u.call(p, (d = f[m++])) && (n[d] = p[d]);
                      return n;
                    }
                  : s;
            },
            function (e, t, n) {
              n(56), (e.exports = n(1).Object.getOwnPropertySymbols);
            },
            function (e, t, n) {
              var o = n(17)("meta"),
                a = n(3),
                r = n(7),
                i = n(4).f,
                l = 0,
                s =
                  Object.isExtensible ||
                  function () {
                    return !0;
                  },
                c = !n(8)(function () {
                  return s(Object.preventExtensions({}));
                }),
                _ = function (e) {
                  i(e, o, { value: { i: "O" + ++l, w: {} } });
                },
                u = (e.exports = {
                  KEY: o,
                  NEED: !1,
                  fastKey: function (e, t) {
                    if (!a(e))
                      return "symbol" == typeof e
                        ? e
                        : ("string" == typeof e ? "S" : "P") + e;
                    if (!r(e, o)) {
                      if (!s(e)) return "F";
                      if (!t) return "E";
                      _(e);
                    }
                    return e[o].i;
                  },
                  getWeak: function (e, t) {
                    if (!r(e, o)) {
                      if (!s(e)) return !0;
                      if (!t) return !1;
                      _(e);
                    }
                    return e[o].w;
                  },
                  onFreeze: function (e) {
                    return c && u.NEED && s(e) && !r(e, o) && _(e), e;
                  },
                });
            },
            function (e, t, n) {
              var o = n(11),
                a = n(26),
                r = n(15);
              e.exports = function (e) {
                var t = o(e),
                  n = a.f;
                if (n)
                  for (var i, l = n(e), s = r.f, c = 0; l.length > c; )
                    s.call(e, (i = l[c++])) && t.push(i);
                return t;
              };
            },
            function (e, t, n) {
              var o = n(33);
              e.exports =
                Array.isArray ||
                function (e) {
                  return "Array" == o(e);
                };
            },
            function (e, t, n) {
              var o = n(6),
                a = n(40).f,
                r = {}.toString,
                i =
                  "object" == typeof window &&
                  window &&
                  Object.getOwnPropertyNames
                    ? Object.getOwnPropertyNames(window)
                    : [];
              e.exports.f = function (e) {
                return i && "[object Window]" == r.call(e)
                  ? (function (e) {
                      try {
                        return a(e);
                      } catch (e) {
                        return i.slice();
                      }
                    })(e)
                  : a(o(e));
              };
            },
            ,
            function (e, t) {
              e.exports = {};
            },
            function (e, t, n) {
              e.exports = { default: n(77), __esModule: !0 };
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 }),
                (t.THEMES = { DARK: "dark", LIGHT: "light" });
            },
            function (e, t, n) {
              n(78), (e.exports = n(1).Object.keys);
            },
            function (e, t, n) {
              var o = n(41),
                a = n(11);
              n(79)("keys", function () {
                return function (e) {
                  return a(o(e));
                };
              });
            },
            function (e, t, n) {
              var o = n(10),
                a = n(1),
                r = n(8);
              e.exports = function (e, t) {
                var n = (a.Object || {})[e] || Object[e],
                  i = {};
                (i[e] = t(n)),
                  o(
                    o.S +
                      o.F *
                        r(function () {
                          n(1);
                        }),
                    "Object",
                    i,
                  );
              };
            },
            function (e, t, n) {
              "use strict";
              var o = n(38),
                a = n(10),
                r = n(55),
                i = n(18),
                l = n(7),
                s = n(66),
                c = n(86),
                _ = n(45),
                u = n(87),
                d = n(19)("iterator"),
                p = !([].keys && "next" in [].keys()),
                f = function () {
                  return this;
                };
              e.exports = function (e, t, n, h, m, y, b) {
                c(n, t, h);
                var v,
                  g,
                  w,
                  x = function (e) {
                    if (!p && e in S) return S[e];
                    switch (e) {
                      case "keys":
                      case "values":
                        return function () {
                          return new n(this, e);
                        };
                    }
                    return function () {
                      return new n(this, e);
                    };
                  },
                  k = t + " Iterator",
                  O = "values" == m,
                  I = !1,
                  S = e.prototype,
                  j = S[d] || S["@@iterator"] || (m && S[m]),
                  T = (!p && j) || x(m),
                  C = m ? (O ? x("entries") : T) : void 0,
                  M = ("Array" == t && S.entries) || j;
                if (
                  (M &&
                    (w = u(M.call(new e()))) !== Object.prototype &&
                    w.next &&
                    (_(w, k, !0), o || l(w, d) || i(w, d, f)),
                  O &&
                    j &&
                    "values" !== j.name &&
                    ((I = !0),
                    (T = function () {
                      return j.call(this);
                    })),
                  (o && !b) || (!p && !I && S[d]) || i(S, d, T),
                  (s[t] = T),
                  (s[k] = f),
                  m)
                )
                  if (
                    ((v = {
                      values: O ? T : x("values"),
                      keys: y ? T : x("keys"),
                      entries: C,
                    }),
                    b)
                  )
                    for (g in v) g in S || r(S, g, v[g]);
                  else a(a.P + a.F * (p || I), t, v);
                return v;
              };
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              t.__esModule = !0;
              var a = o(n(93)),
                r = o(n(95)),
                i =
                  "function" == typeof r.default && "symbol" == typeof a.default
                    ? function (e) {
                        return typeof e;
                      }
                    : function (e) {
                        return e &&
                          "function" == typeof r.default &&
                          e.constructor === r.default &&
                          e !== r.default.prototype
                          ? "symbol"
                          : typeof e;
                      };
              t.default =
                "function" == typeof r.default && "symbol" === i(a.default)
                  ? function (e) {
                      return void 0 === e ? "undefined" : i(e);
                    }
                  : function (e) {
                      return e &&
                        "function" == typeof r.default &&
                        e.constructor === r.default &&
                        e !== r.default.prototype
                        ? "symbol"
                        : void 0 === e
                          ? "undefined"
                          : i(e);
                    };
            },
            function (e, t, n) {
              "use strict";
              var o = n(85)(!0);
              n(80)(
                String,
                "String",
                function (e) {
                  (this._t = String(e)), (this._i = 0);
                },
                function () {
                  var e,
                    t = this._t,
                    n = this._i;
                  return n >= t.length
                    ? { value: void 0, done: !0 }
                    : ((e = o(t, n)),
                      (this._i += e.length),
                      { value: e, done: !1 });
                },
              );
            },
            function (e, t, n) {
              n(88);
              for (
                var o = n(0),
                  a = n(18),
                  r = n(66),
                  i = n(19)("toStringTag"),
                  l =
                    "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(
                      ",",
                    ),
                  s = 0;
                s < l.length;
                s++
              ) {
                var c = l[s],
                  _ = o[c],
                  u = _ && _.prototype;
                u && !u[i] && a(u, i, c), (r[c] = r.Array);
              }
            },
            function (e, t) {},
            function (e, t, n) {
              var o = n(28),
                a = n(30);
              e.exports = function (e) {
                return function (t, n) {
                  var r,
                    i,
                    l = String(a(t)),
                    s = o(n),
                    c = l.length;
                  return s < 0 || s >= c
                    ? e
                      ? ""
                      : void 0
                    : (r = l.charCodeAt(s)) < 55296 ||
                        r > 56319 ||
                        s + 1 === c ||
                        (i = l.charCodeAt(s + 1)) < 56320 ||
                        i > 57343
                      ? e
                        ? l.charAt(s)
                        : r
                      : e
                        ? l.slice(s, s + 2)
                        : i - 56320 + ((r - 55296) << 10) + 65536;
                };
              };
            },
            function (e, t, n) {
              "use strict";
              var o = n(34),
                a = n(20),
                r = n(45),
                i = {};
              n(18)(i, n(19)("iterator"), function () {
                return this;
              }),
                (e.exports = function (e, t, n) {
                  (e.prototype = o(i, { next: a(1, n) })),
                    r(e, t + " Iterator");
                });
            },
            function (e, t, n) {
              var o = n(7),
                a = n(41),
                r = n(29)("IE_PROTO"),
                i = Object.prototype;
              e.exports =
                Object.getPrototypeOf ||
                function (e) {
                  return (
                    (e = a(e)),
                    o(e, r)
                      ? e[r]
                      : "function" == typeof e.constructor &&
                          e instanceof e.constructor
                        ? e.constructor.prototype
                        : e instanceof Object
                          ? i
                          : null
                  );
                };
            },
            function (e, t, n) {
              "use strict";
              var o = n(89),
                a = n(90),
                r = n(66),
                i = n(6);
              (e.exports = n(80)(
                Array,
                "Array",
                function (e, t) {
                  (this._t = i(e)), (this._i = 0), (this._k = t);
                },
                function () {
                  var e = this._t,
                    t = this._k,
                    n = this._i++;
                  return !e || n >= e.length
                    ? ((this._t = void 0), a(1))
                    : a(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
                },
                "values",
              )),
                (r.Arguments = r.Array),
                o("keys"),
                o("values"),
                o("entries");
            },
            function (e, t) {
              e.exports = function () {};
            },
            function (e, t) {
              e.exports = function (e, t) {
                return { value: t, done: !!e };
              };
            },
            ,
            ,
            function (e, t, n) {
              e.exports = { default: n(94), __esModule: !0 };
            },
            function (e, t, n) {
              n(82), n(83), (e.exports = n(39).f("iterator"));
            },
            function (e, t, n) {
              e.exports = { default: n(96), __esModule: !0 };
            },
            function (e, t, n) {
              n(56), n(84), n(97), n(98), (e.exports = n(1).Symbol);
            },
            function (e, t, n) {
              n(54)("asyncIterator");
            },
            function (e, t, n) {
              n(54)("observable");
            },
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 });
              var o = (function (e) {
                return e && e.__esModule ? e : { default: e };
              })(n(81));
              (t.setTransform = function (e, t) {
                e &&
                  "object" ===
                    (void 0 === e ? "undefined" : (0, o.default)(e)) &&
                  t &&
                  ((e.transform = t),
                  (e.WebkitTransform = t),
                  (e.MozTransform = t));
              }),
                (t.removeStyleProperty = function (e, t) {
                  var n = e && e.style;
                  if (!n)
                    throw new Error(
                      "Invalid type of " + e + ". Expected DOM element.",
                    );
                  if (!n.removeProperty && !n.removeAttribute)
                    throw new Error(
                      "Unexpected element style " +
                        n +
                        ". It is not supported to remove inline style.",
                    );
                  n.removeProperty && n.removeProperty(t),
                    n.removeAttribute && n.removeAttribute(t);
                });
            },
            function (e, t) {
              e.exports = {
                tabs: "_3lMTV",
                "tabs-dark": "_2bOox",
                tabsDark: "_2bOox",
                "tab-item": "_28KUW",
                tabItem: "_28KUW",
                "tab-item-active": "_1Ltud",
                tabItemActive: "_1Ltud",
                "tab-item-disabled": "_2LH7P",
                tabItemDisabled: "_2LH7P",
                "tab-bar-animated": "_1ubfg",
                tabBarAnimated: "_1ubfg",
                "ink-bar": "zPFdO",
                inkBar: "zPFdO",
                "tab-bar-wrap": "_3-a_h",
                tabBarWrap: "_3-a_h",
                "tab-bar-border": "_8wsGN",
                tabBarBorder: "_8wsGN",
                "tab-bar-display": "_2RUui",
                tabBarDisplay: "_2RUui",
                "tab-bar": "_1RPG6",
                tabBar: "_1RPG6",
                "tab-bar-left": "pHyFu",
                tabBarLeft: "pHyFu",
                "tab-bar-right": "_3yx3R",
                tabBarRight: "_3yx3R",
                "tab-bar-center": "_1DkKo",
                tabBarCenter: "_1DkKo",
                "tab-bar-justified": "_1G3aQ",
                tabBarJustified: "_1G3aQ",
                "tab-content": "_3Qm4W",
                tabContent: "_3Qm4W",
                "tab-panel": "_14aFm",
                tabPanel: "_14aFm",
                "tab-panel-active": "_2d3yp",
                tabPanelActive: "_2d3yp",
                "tab-panel-disabled": "_1RhgG",
                tabPanelDisabled: "_1RhgG",
              };
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                c = o(n(12)),
                _ = o(n(23)),
                u = o(n(100)),
                d = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                p =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                f = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                h = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    d(t, e),
                    (t.prototype.render = function () {
                      var e,
                        t = this.props,
                        n = t.active,
                        o = t.disabled,
                        a = t.children,
                        r = t.className,
                        i = t.style,
                        l =
                          (t.tab,
                          f(t, [
                            "active",
                            "disabled",
                            "children",
                            "className",
                            "style",
                            "tab",
                          ])),
                        c = (0, _.default)(
                          u.default.tabPanel,
                          r,
                          (((e = {})[u.default.tabPanelActive] = n),
                          (e[u.default.tabPanelDisabled] = o),
                          e),
                        );
                      return s.createElement(
                        "div",
                        p({ style: i, className: c }, l),
                        a,
                      );
                    }),
                    (t.propTypes = {
                      active: c.default.bool,
                      tab: c.default.oneOfType([
                        c.default.string,
                        c.default.node,
                      ]),
                      disabled: c.default.bool,
                    }),
                    t
                  );
                })(s.PureComponent);
              t.default = h;
            },
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            ,
            function (e, t, n) {
              "use strict";
              Object.defineProperty(t, "__esModule", { value: !0 });
              var o = (function (e) {
                return e && e.__esModule ? e : { default: e };
              })(n(260));
              t.default = o.default;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(67)),
                r = o(n(24)),
                i = o(n(16)),
                l = o(n(13)),
                s = o(n(14)),
                c = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                _ = o(n(23)),
                u = o(n(12)),
                d = o(n(261)),
                p = o(n(263)),
                f = o(n(143)),
                h = o(n(100)),
                m = n(76),
                y = (function () {
                  var e =
                    s.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, l.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                b =
                  i.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                v = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof r.default) {
                    var a = 0;
                    for (o = (0, r.default)(e); a < o.length; a++)
                      t.indexOf(o[a]) < 0 && (n[o[a]] = e[o[a]]);
                  }
                  return n;
                },
                g = (function (e) {
                  function t(t) {
                    var n,
                      o = e.call(this, t) || this;
                    return (
                      (o.handleTabClick = function (e) {
                        var t = o.props,
                          n = t.onTabClick,
                          a = t.onChange;
                        o.setState({ activeKey: e }), a && a(e), n && n(e);
                      }),
                      (o.handleChange = function (e) {
                        var t = o.props.onChange;
                        t && t(e);
                      }),
                      (n =
                        "activeKey" in t
                          ? t.activeKey
                          : "defaultActiveKey" in t
                            ? t.defaultActiveKey
                            : (function (e) {
                                var t;
                                return (
                                  c.Children.forEach(e.children, function (e) {
                                    e && !t && (t = e.key);
                                  }),
                                  t
                                );
                              })(t)),
                      (o.state = { activeKey: n }),
                      o
                    );
                  }
                  return (
                    y(t, e),
                    (t.prototype.componentWillReceiveProps = function (e) {
                      var t = this.props.activeKey,
                        n = e.activeKey;
                      if ("string" == typeof n && t !== n) {
                        this.setState({ activeKey: n });
                        var o = this.props.onChange;
                        o && o(n);
                      }
                    }),
                    (t.prototype.render = function () {
                      var e = this.props,
                        t = e.children,
                        n = e.tabPosition,
                        o = e.animated,
                        a = e.border,
                        r = e.tabBarStyle,
                        i = e.tabDisplay,
                        l = e.prefixCls,
                        s = (e.onChange, e.theme),
                        u = e.className,
                        f =
                          (e.defaultActiveKey,
                          e.activeKey,
                          v(e, [
                            "children",
                            "tabPosition",
                            "animated",
                            "border",
                            "tabBarStyle",
                            "tabDisplay",
                            "prefixCls",
                            "onChange",
                            "theme",
                            "className",
                            "defaultActiveKey",
                            "activeKey",
                          ])),
                        y = this.state.activeKey,
                        g = s || this.context.theme || m.THEMES.LIGHT,
                        w = (0, _.default)(
                          h.default.tabs,
                          [h.default["tabs-" + g]],
                          u,
                        );
                      return c.createElement(
                        "div",
                        b({ className: w }, f),
                        c.createElement(d.default, {
                          key: "tabBar",
                          panels: t,
                          activeKey: y,
                          tabPosition: n,
                          onTabClick: this.handleTabClick,
                          animated: o,
                          border: a,
                          tabBarStyle: r,
                          tabDisplay: i,
                          prefixCls: l,
                        }),
                        c.createElement(p.default, {
                          panels: t,
                          activeKey: y,
                          key: "tabContent",
                        }),
                      );
                    }),
                    (t.TabPanel = f.default),
                    (t.propTypes = {
                      defaultActiveKey: u.default.string,
                      activeKey: u.default.string,
                      onChange: u.default.func,
                      onTabClick: u.default.func,
                      tabPosition: u.default.oneOf([
                        "left",
                        "center",
                        "right",
                        "justified",
                      ]),
                      theme: u.default.oneOf(
                        (0, a.default)(m.THEMES).map(function (e) {
                          return m.THEMES[e];
                        }),
                      ),
                      animated: u.default.bool,
                      border: u.default.bool,
                      tabBarStyle: u.default.object,
                      tabDisplay: u.default.oneOf(["block", "inline-block"]),
                      className: u.default.string,
                      prefixCls: u.default.string,
                    }),
                    (t.defaultProps = {
                      tabPosition: "left",
                      theme: "light",
                      animated: !0,
                      tabBarStyle: {},
                      tabDisplay: "block",
                      prefixCls: "quark-tab-default",
                    }),
                    t
                  );
                })(c.PureComponent);
              t.default = g;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(16)),
                r = o(n(13)),
                i = o(n(14)),
                l = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                s = o(n(12)),
                c = o(n(23)),
                _ = o(n(100)),
                u = n(99),
                d = o(n(262)),
                p = (function () {
                  var e =
                    i.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, r.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                f =
                  a.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                h = (function (e) {
                  function t() {
                    var t = (null !== e && e.apply(this, arguments)) || this;
                    return (t.state = { inkBarStyle: {} }), t;
                  }
                  return (
                    p(t, e),
                    (t.prototype.componentDidMount = function () {
                      this.updateInkBarStyle(),
                        (this.resizeHandler = (0, d.default)(
                          this.onResize.bind(this),
                          200,
                        )),
                        window.addEventListener("resize", this.resizeHandler);
                    }),
                    (t.prototype.componentWillUnmount = function () {
                      this.resizeHandler &&
                        window.removeEventListener(
                          "resize",
                          this.resizeHandler,
                        );
                    }),
                    (t.prototype.componentDidUpdate = function (e) {
                      e.activeKey !== this.props.activeKey &&
                        this.updateInkBarStyle();
                    }),
                    (t.prototype.onResize = function () {
                      this.updateInkBarStyle();
                    }),
                    (t.prototype.updateInkBarStyle = function () {
                      if (this.activeTab && this.tabBar) {
                        var e = { width: "" },
                          t =
                            this.activeTab.offsetLeft - this.tabBar.offsetLeft,
                          n = this.activeTab.clientWidth;
                        (0, u.setTransform)(e, "translate3d(" + t + "px,0,0)"),
                          (e.width = n + "px"),
                          this.setState({ inkBarStyle: e });
                      }
                    }),
                    (t.prototype.handleTabClick = function (e) {
                      var t = this.props.onTabClick;
                      t && t(e);
                    }),
                    (t.prototype.renderTabs = function () {
                      var e = this,
                        t = this.props,
                        n = t.panels,
                        o = t.activeKey;
                      return l.Children.map(n, function (t) {
                        if (t) {
                          var n,
                            a = t.key,
                            r = (0, c.default)(
                              _.default.tabItem,
                              (((n = {})[_.default.tabItemActive] = o === a),
                              (n[_.default.tabItemDisabled] = t.props.disabled),
                              n),
                            ),
                            i = {};
                          return (
                            t.props.disabled ||
                              (i = { onClick: e.handleTabClick.bind(e, a) }),
                            l.createElement(
                              "div",
                              f({ className: r, key: a }, i, {
                                ref: function (t) {
                                  o === a && (e.activeTab = t);
                                },
                              }),
                              t.props.tab,
                            )
                          );
                        }
                      });
                    }),
                    (t.prototype.renderInkBar = function () {
                      var e = this.state.inkBarStyle;
                      return l.createElement("div", {
                        style: e,
                        className: _.default.inkBar,
                      });
                    }),
                    (t.prototype.render = function () {
                      var e,
                        t = this,
                        n = this.props,
                        o = n.tabPosition,
                        a = n.animated,
                        r = n.border,
                        i = n.tabBarStyle,
                        s = n.tabDisplay,
                        u = n.prefixCls,
                        d = this.renderTabs(),
                        p = a ? this.renderInkBar() : null,
                        f = (0, c.default)(
                          _.default["tab-bar-" + o],
                          [u + "-tab-bar-wrap"],
                          (((e = {})[_.default["tab-bar-animated"]] = a),
                          (e[_.default["tab-bar-border"]] = r),
                          (e[_.default["tab-bar-display"]] =
                            "inline-block" === s),
                          e),
                        );
                      return l.createElement(
                        "div",
                        { style: i, className: u + "-tab-container" },
                        l.createElement(
                          "div",
                          { className: f },
                          l.createElement(
                            "div",
                            {
                              className: u + "-tab-bar",
                              ref: function (e) {
                                t.tabBar = e;
                              },
                            },
                            p,
                            d,
                          ),
                        ),
                      );
                    }),
                    (t.propTypes = {
                      panels: s.default.arrayOf(s.default.node),
                      activeKey: s.default.string,
                      onTabClick: s.default.func,
                      tabPosition: s.default.oneOf([
                        "left",
                        "center",
                        "right",
                        "justified",
                      ]),
                      animated: s.default.bool,
                      border: s.default.bool,
                      tabBarStyle: s.default.object,
                      tabDisplay: s.default.oneOf(["block", "inline-block"]),
                    }),
                    (t.defaultProps = {
                      tabPosition: "left",
                      animated: !0,
                      border: !0,
                      tabBarStyle: {},
                    }),
                    t
                  );
                })(l.PureComponent);
              t.default = h;
            },
            function (e, t) {
              e.exports = i;
            },
            function (e, t, n) {
              "use strict";
              function o(e) {
                return e && e.__esModule ? e : { default: e };
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var a = o(n(24)),
                r = o(n(16)),
                i = o(n(13)),
                l = o(n(14)),
                s = (function (e) {
                  if (e && e.__esModule) return e;
                  var t = {};
                  if (null != e)
                    for (var n in e)
                      Object.prototype.hasOwnProperty.call(e, n) &&
                        (t[n] = e[n]);
                  return (t.default = e), t;
                })(n(9)),
                c = o(n(12)),
                _ = o(n(143)),
                u = o(n(100)),
                d = (function () {
                  var e =
                    l.default ||
                    ({ __proto__: [] } instanceof Array &&
                      function (e, t) {
                        e.__proto__ = t;
                      }) ||
                    function (e, t) {
                      for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                    };
                  return function (t, n) {
                    function o() {
                      this.constructor = t;
                    }
                    e(t, n),
                      (t.prototype =
                        null === n
                          ? (0, i.default)(n)
                          : ((o.prototype = n.prototype), new o()));
                  };
                })(),
                p =
                  r.default ||
                  function (e) {
                    for (var t, n = 1, o = arguments.length; n < o; n++)
                      for (var a in (t = arguments[n]))
                        Object.prototype.hasOwnProperty.call(t, a) &&
                          (e[a] = t[a]);
                    return e;
                  },
                f = function (e, t) {
                  var n = {};
                  for (var o in e)
                    Object.prototype.hasOwnProperty.call(e, o) &&
                      t.indexOf(o) < 0 &&
                      (n[o] = e[o]);
                  if (null != e && "function" == typeof a.default) {
                    var r = 0;
                    for (o = (0, a.default)(e); r < o.length; r++)
                      t.indexOf(o[r]) < 0 && (n[o[r]] = e[o[r]]);
                  }
                  return n;
                },
                h = (function (e) {
                  function t() {
                    return (null !== e && e.apply(this, arguments)) || this;
                  }
                  return (
                    d(t, e),
                    (t.prototype.render = function () {
                      var e = this.props,
                        t = e.activeKey,
                        n = e.panels,
                        o = s.Children.map(n, function (e) {
                          var n = e.key,
                            o = e.props,
                            a = o.children,
                            r = f(o, ["children"]);
                          return s.createElement(
                            _.default,
                            p({ key: "tab-panel-" + n, active: t === n }, r),
                            a,
                          );
                        });
                      return s.createElement(
                        "div",
                        { className: u.default.tabContent },
                        o,
                      );
                    }),
                    (t.propTypes = {
                      panels: c.default.arrayOf(c.default.node),
                      activeKey: c.default.string,
                    }),
                    t
                  );
                })(s.PureComponent);
              t.default = h;
            },
          ])));
    },
    u8Dt: function (e, t, n) {
      var o = n("YESw"),
        a = "__lodash_hash_undefined__",
        r = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        var t = this.__data__;
        if (o) {
          var n = t[e];
          return n === a ? void 0 : n;
        }
        return r.call(t, e) ? t[e] : void 0;
      };
    },
    uF6l: function (e, t, n) {
      "use strict";
      var o = Object.prototype.hasOwnProperty,
        a = "~";
      function r() {}
      function i(e, t, n) {
        (this.fn = e), (this.context = t), (this.once = n || !1);
      }
      function l(e, t, n, o, r) {
        if ("function" !== typeof n)
          throw new TypeError("The listener must be a function");
        var l = new i(n, o || e, r),
          s = a ? a + t : t;
        return (
          e._events[s]
            ? e._events[s].fn
              ? (e._events[s] = [e._events[s], l])
              : e._events[s].push(l)
            : ((e._events[s] = l), e._eventsCount++),
          e
        );
      }
      function s(e, t) {
        0 === --e._eventsCount ? (e._events = new r()) : delete e._events[t];
      }
      function c() {
        (this._events = new r()), (this._eventsCount = 0);
      }
      Object.create &&
        ((r.prototype = Object.create(null)), new r().__proto__ || (a = !1)),
        (c.prototype.eventNames = function () {
          var e,
            t,
            n = [];
          if (0 === this._eventsCount) return n;
          for (t in (e = this._events))
            o.call(e, t) && n.push(a ? t.slice(1) : t);
          return Object.getOwnPropertySymbols
            ? n.concat(Object.getOwnPropertySymbols(e))
            : n;
        }),
        (c.prototype.listeners = function (e) {
          var t = a ? a + e : e,
            n = this._events[t];
          if (!n) return [];
          if (n.fn) return [n.fn];
          for (var o = 0, r = n.length, i = new Array(r); o < r; o++)
            i[o] = n[o].fn;
          return i;
        }),
        (c.prototype.listenerCount = function (e) {
          var t = a ? a + e : e,
            n = this._events[t];
          return n ? (n.fn ? 1 : n.length) : 0;
        }),
        (c.prototype.emit = function (e, t, n, o, r, i) {
          var l = a ? a + e : e;
          if (!this._events[l]) return !1;
          var s,
            c,
            _ = this._events[l],
            u = arguments.length;
          if (_.fn) {
            switch ((_.once && this.removeListener(e, _.fn, void 0, !0), u)) {
              case 1:
                return _.fn.call(_.context), !0;
              case 2:
                return _.fn.call(_.context, t), !0;
              case 3:
                return _.fn.call(_.context, t, n), !0;
              case 4:
                return _.fn.call(_.context, t, n, o), !0;
              case 5:
                return _.fn.call(_.context, t, n, o, r), !0;
              case 6:
                return _.fn.call(_.context, t, n, o, r, i), !0;
            }
            for (c = 1, s = new Array(u - 1); c < u; c++)
              s[c - 1] = arguments[c];
            _.fn.apply(_.context, s);
          } else {
            var d,
              p = _.length;
            for (c = 0; c < p; c++)
              switch (
                (_[c].once && this.removeListener(e, _[c].fn, void 0, !0), u)
              ) {
                case 1:
                  _[c].fn.call(_[c].context);
                  break;
                case 2:
                  _[c].fn.call(_[c].context, t);
                  break;
                case 3:
                  _[c].fn.call(_[c].context, t, n);
                  break;
                case 4:
                  _[c].fn.call(_[c].context, t, n, o);
                  break;
                default:
                  if (!s)
                    for (d = 1, s = new Array(u - 1); d < u; d++)
                      s[d - 1] = arguments[d];
                  _[c].fn.apply(_[c].context, s);
              }
          }
          return !0;
        }),
        (c.prototype.on = function (e, t, n) {
          return l(this, e, t, n, !1);
        }),
        (c.prototype.once = function (e, t, n) {
          return l(this, e, t, n, !0);
        }),
        (c.prototype.removeListener = function (e, t, n, o) {
          var r = a ? a + e : e;
          if (!this._events[r]) return this;
          if (!t) return s(this, r), this;
          var i = this._events[r];
          if (i.fn)
            i.fn !== t ||
              (o && !i.once) ||
              (n && i.context !== n) ||
              s(this, r);
          else {
            for (var l = 0, c = [], _ = i.length; l < _; l++)
              (i[l].fn !== t ||
                (o && !i[l].once) ||
                (n && i[l].context !== n)) &&
                c.push(i[l]);
            c.length
              ? (this._events[r] = 1 === c.length ? c[0] : c)
              : s(this, r);
          }
          return this;
        }),
        (c.prototype.removeAllListeners = function (e) {
          var t;
          return (
            e
              ? ((t = a ? a + e : e), this._events[t] && s(this, t))
              : ((this._events = new r()), (this._eventsCount = 0)),
            this
          );
        }),
        (c.prototype.off = c.prototype.removeListener),
        (c.prototype.addListener = c.prototype.on),
        (c.prefixed = a),
        (c.EventEmitter = c),
        (e.exports = c);
    },
    uM7l: function (e, t, n) {
      var o = n("OBhP"),
        a = 4;
      e.exports = function (e) {
        return o(e, a);
      };
    },
    uN13: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("q1tI"),
        r = n.n(a),
        i = n("SBOM"),
        l = n("x1L9"),
        s = (n("TeTh"), n("Xwp0")),
        c = r.a.createElement,
        _ = function (e) {
          var t,
            n = e.children,
            o = e.backgroundType,
            a = e.backgroundPrue,
            r = e.backgroundGradient;
          return (
            o === s.a.PRUE
              ? (t = { backgroundColor: a })
              : o === s.a.GRADATION && (t = { backgroundImage: r }),
            c("div", { className: "", style: t }, n)
          );
        },
        u = function (e) {
          return c(
            "div",
            { className: "background__bg-video-wrapper___Xalaj" },
            c(l.a, e),
          );
        },
        d = function (e) {
          var t = e.children,
            n = e.backgroundImage,
            o = e.backgroundPosition,
            a = e.isLazy,
            r = void 0 === a || a;
          return c(
            i.a,
            {
              className: "background__bg-image___3lzI8",
              type: "bg",
              tagType: "div",
              visibleByDefault: !r,
              src: n,
              style: { backgroundPosition: o },
            },
            t,
          );
        };
      t.a = function (e) {
        var t,
          n = e.children,
          a = e.style,
          i = e.backgroundType,
          l = e.backgroundImage,
          p = e.backgroundVideo,
          f = e.backgroundPrue,
          h = e.backgroundGradient,
          m = e.backgroundPosition,
          y = e.isHovering,
          b = e.isLazyImage;
        switch (i) {
          case s.a.PRUE:
            t = c(_, { backgroundType: i, backgroundPrue: f }, n);
            break;
          case s.a.GRADATION:
            t = c(_, { backgroundType: i, backgroundGradient: h }, n);
            break;
          case s.a.VIDEO:
            t = c(
              r.a.Fragment,
              null,
              c(u, Object(o.a)({}, p, { isHovering: y })),
              n,
            );
            break;
          case s.a.IMAGE:
            t = c(
              d,
              { backgroundPosition: m, backgroundImage: l, isLazy: b },
              n,
            );
            break;
          default:
            t = n;
        }
        return c(
          "div",
          { className: "background__bg-wrapper___3nICL", style: a },
          t,
        );
      };
    },
    uOPS: function (e, t) {
      e.exports = !0;
    },
    "ub/+": function (e, t, n) {
      "use strict";
      n.d(t, "b", function () {
        return l;
      }),
        n.d(t, "c", function () {
          return s;
        }),
        n.d(t, "d", function () {
          return c;
        }),
        n.d(t, "a", function () {
          return d;
        }),
        n.d(t, "f", function () {
          return p;
        }),
        n.d(t, "g", function () {
          return f;
        });
      var o = n("Ff2n"),
        a = n("q1tI"),
        r = ["tagType"],
        i = n.n(a).a.createElement,
        l = (function (e) {
          return (
            (e.default = ""),
            (e["10px"] = "10px"),
            (e["12px"] = "12px"),
            (e["14px"] = "14px"),
            (e["16px"] = "16px"),
            (e["18px"] = "18px"),
            (e["20px"] = "20px"),
            (e["24px"] = "24px"),
            (e["28px"] = "28px"),
            (e["32px"] = "32px"),
            (e["40px"] = "40px"),
            (e["48px"] = "48px"),
            (e["56px"] = "56px"),
            (e["64px"] = "64px"),
            (e["72px"] = "72px"),
            (e["80px"] = "80px"),
            e
          );
        })({}),
        s = (function (e) {
          return (
            (e.default = ""),
            (e[(e.regular = 400)] = "regular"),
            (e[(e.semibold = 600)] = "semibold"),
            e
          );
        })({}),
        c = (function (e) {
          return (
            (e.default = ""),
            (e.standard = "standard"),
            (e.compact = "compact"),
            e
          );
        })({}),
        _ = (function (e) {
          return (
            (e["10px"] = "16px"),
            (e["12px"] = "16px"),
            (e["14px"] = "24px"),
            (e["16px"] = "24px"),
            (e["18px"] = "28px"),
            (e["20px"] = "28px"),
            (e["24px"] = "32px"),
            (e["28px"] = "36px"),
            (e["32px"] = "40px"),
            (e["40px"] = "48px"),
            (e["48px"] = "56px"),
            (e["56px"] = "64px"),
            (e["64px"] = "72px"),
            (e["72px"] = "80px"),
            (e["80px"] = "88px"),
            (e["88px"] = "96px"),
            (e["96px"] = "104px"),
            (e["104px"] = "112px"),
            (e["112px"] = "120px"),
            (e["120px"] = "128px"),
            e
          );
        })(_ || {}),
        u = (function (e) {
          return (
            (e["10px"] = "16px"),
            (e["12px"] = "16px"),
            (e["14px"] = "20px"),
            (e["16px"] = "20px"),
            (e["18px"] = "24px"),
            (e["20px"] = "24px"),
            (e["24px"] = "28px"),
            (e["28px"] = "32px"),
            (e["32px"] = "36px"),
            (e["40px"] = "48px"),
            (e["48px"] = "52px"),
            (e["56px"] = "60px"),
            (e["64px"] = "68px"),
            (e["72px"] = "76px"),
            (e["80px"] = "84px"),
            (e["88px"] = "92px"),
            (e["96px"] = "100px"),
            (e["104px"] = "108px"),
            (e["112px"] = "116px"),
            (e["120px"] = "124px"),
            e
          );
        })(u || {});
      function d(e, t) {
        if (e && t) return (t === c.compact ? u : _)[e];
      }
      var p = [
          { label: "\u9ed8\u8ba4", value: "" },
          { label: "h1", value: "h1" },
          { label: "h2", value: "h2" },
          { label: "h3", value: "h3" },
          { label: "h4", value: "h4" },
          { label: "h5", value: "h5" },
          { label: "h6", value: "h6" },
          { label: "p", value: "p" },
        ],
        f = { label: "\u6807\u7b7e\u8bbe\u7f6e", type: "select", items: p };
      t.e = function (e) {
        var t = e.tagType,
          n = Object(o.a)(e, r);
        return "h1" === t
          ? i("h1", n)
          : "h2" === t
            ? i("h2", n)
            : "h3" === t
              ? i("h3", n)
              : "h4" === t
                ? i("h4", n)
                : "h5" === t
                  ? i("h5", n)
                  : "h6" === t
                    ? i("h6", n)
                    : "p" === t
                      ? i("p", n)
                      : null;
      };
    },
    "vN+2": function (e, t) {
      e.exports = function () {};
    },
    "vPd/": function (e, t, n) {
      var o = n("kCCV"),
        a = n("IX3V").each;
      function r(e, t) {
        (this.query = e),
          (this.isUnconditional = t),
          (this.handlers = []),
          (this.mql = window.matchMedia(e));
        var n = this;
        (this.listener = function (e) {
          (n.mql = e.currentTarget || e), n.assess();
        }),
          this.mql.addListener(this.listener);
      }
      (r.prototype = {
        constuctor: r,
        addHandler: function (e) {
          var t = new o(e);
          this.handlers.push(t), this.matches() && t.on();
        },
        removeHandler: function (e) {
          var t = this.handlers;
          a(t, function (n, o) {
            if (n.equals(e)) return n.destroy(), !t.splice(o, 1);
          });
        },
        matches: function () {
          return this.mql.matches || this.isUnconditional;
        },
        clear: function () {
          a(this.handlers, function (e) {
            e.destroy();
          }),
            this.mql.removeListener(this.listener),
            (this.handlers.length = 0);
        },
        assess: function () {
          var e = this.matches() ? "on" : "off";
          a(this.handlers, function (t) {
            t[e]();
          });
        },
      }),
        (e.exports = r);
    },
    vejd: function (e, t, n) {},
    vtNx: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return o;
      });
      var o = (function (e) {
        return (
          (e.UNIVERSUAL_PRODUCT_TIPS_SHOW = "universual_product_tips_show"),
          (e.UNIVERSUAL_PRODUCT_TIP_CLICK = "universual_product_tips_click"),
          (e.GOOGLE_ONE_TAP_SHOW = "google_one_tap_show"),
          (e.GOOGLE_ONE_TAP_CLICK = "google_one_tap_click"),
          (e.SUBSCRIBE_MODAL_SHOW = "subscribe_modal_show"),
          (e.SUBSCRIBE_MODAL_CLICK = "subscribe_modal_click"),
          (e.WEBPUSH_CONSENT_SHOW = "webpush_consent_show"),
          (e.WEBPUSH_CONSENT_CLICK = "webpush_consent_click"),
          e
        );
      })({});
    },
    vwuL: function (e, t, n) {
      var o = n("NV0k"),
        a = n("rr1i"),
        r = n("NsO/"),
        i = n("G8Mo"),
        l = n("B+OT"),
        s = n("eUtF"),
        c = Object.getOwnPropertyDescriptor;
      t.f = n("jmDH")
        ? c
        : function (e, t) {
            if (((e = r(e)), (t = i(t, !0)), s))
              try {
                return c(e, t);
              } catch (n) {}
            if (l(e, t)) return a(!o.f.call(e, t), e[t]);
          };
    },
    "w/wX": function (e, t, n) {
      var o = n("QqLw"),
        a = n("ExA7"),
        r = "[object Set]";
      e.exports = function (e) {
        return a(e) && o(e) == r;
      };
    },
    "w2d+": function (e, t, n) {
      "use strict";
      var o = n("hDam"),
        a = n("UO39"),
        r = n("SBuE"),
        i = n("NsO/");
      (e.exports = n("MPFp")(
        Array,
        "Array",
        function (e, t) {
          (this._t = i(e)), (this._i = 0), (this._k = t);
        },
        function () {
          var e = this._t,
            t = this._k,
            n = this._i++;
          return !e || n >= e.length
            ? ((this._t = void 0), a(1))
            : a(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]]);
        },
        "values",
      )),
        (r.Arguments = r.Array),
        o("keys"),
        o("values"),
        o("entries");
    },
    w6GO: function (e, t, n) {
      var o = n("5vMV"),
        a = n("FpHa");
      e.exports =
        Object.keys ||
        function (e) {
          return o(e, a);
        };
    },
    w6RS: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.InnerSlider = void 0);
      var o =
          "function" === typeof Symbol && "symbol" === typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" === typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              },
        a =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          },
        r = h(n("q1tI")),
        i = h(n("i8i4")),
        l = h(n("PlRC")),
        s = h(n("9/5/")),
        c = h(n("TSYQ")),
        _ = n("GzxR"),
        u = n("he42"),
        d = n("tzmE"),
        p = n("GOrF"),
        f = h(n("bdgK"));
      function h(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function m(e, t) {
        var n = {};
        for (var o in e)
          t.indexOf(o) >= 0 ||
            (Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]));
        return n;
      }
      t.InnerSlider = (function (e) {
        function t(n) {
          !(function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, t);
          var h = (function (e, t) {
            if (!e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called",
              );
            return !t || ("object" !== typeof t && "function" !== typeof t)
              ? e
              : t;
          })(this, e.call(this, n));
          return (
            (h.listRefHandler = function (e) {
              return (h.list = e);
            }),
            (h.trackRefHandler = function (e) {
              return (h.track = e);
            }),
            (h.adaptHeight = function () {
              if (h.props.adaptiveHeight && h.list) {
                var e = h.list.querySelector(
                  '[data-index="' + h.state.currentSlide + '"]',
                );
                h.list.style.height = (0, _.getHeight)(e) + "px";
              }
            }),
            (h.componentWillMount = function () {
              if (
                (h.ssrInit(),
                h.props.onInit && h.props.onInit(),
                h.props.lazyLoad)
              ) {
                var e = (0, _.getOnDemandLazySlides)(a({}, h.props, h.state));
                e.length > 0 &&
                  (h.setState(function (t) {
                    return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                  }),
                  h.props.onLazyLoad && h.props.onLazyLoad(e));
              }
            }),
            (h.componentDidMount = function () {
              var e = a({ listRef: h.list, trackRef: h.track }, h.props);
              h.list.addEventListener("mousemove", h.swipeMove, {
                passive: !1,
              }),
                h.list.addEventListener("touchmove", h.swipeMove, {
                  passive: !1,
                }),
                h.updateState(e, !0, function () {
                  h.adaptHeight(), h.props.autoplay && h.autoPlay("update");
                }),
                "progressive" === h.props.lazyLoad &&
                  (h.lazyLoadTimer = setInterval(h.progressiveLazyLoad, 1e3)),
                (h.ro = new f.default(function () {
                  h.state.animating
                    ? (h.onWindowResized(!1),
                      h.callbackTimers.push(
                        setTimeout(function () {
                          return h.onWindowResized();
                        }, h.props.speed),
                      ))
                    : h.onWindowResized();
                })),
                h.ro.observe(h.list),
                Array.prototype.forEach.call(
                  document.querySelectorAll(".slick-slide"),
                  function (e) {
                    (e.onfocus = h.props.pauseOnFocus ? h.onSlideFocus : null),
                      (e.onblur = h.props.pauseOnFocus ? h.onSlideBlur : null);
                  },
                ),
                window &&
                  (window.addEventListener
                    ? window.addEventListener("resize", h.onWindowResized)
                    : window.attachEvent("onresize", h.onWindowResized));
            }),
            (h.componentWillUnmount = function () {
              h.list.removeEventListener("mousemove", h.swipeMove, {
                passive: !1,
              }),
                h.list.removeEventListener("touchmove", h.swipeMove, {
                  passive: !1,
                }),
                h.animationEndCallback && clearTimeout(h.animationEndCallback),
                h.lazyLoadTimer && clearInterval(h.lazyLoadTimer),
                h.callbackTimers.length &&
                  (h.callbackTimers.forEach(function (e) {
                    return clearTimeout(e);
                  }),
                  (h.callbackTimers = [])),
                window.addEventListener
                  ? window.removeEventListener("resize", h.onWindowResized)
                  : window.detachEvent("onresize", h.onWindowResized),
                h.autoplayTimer && clearInterval(h.autoplayTimer);
            }),
            (h.componentWillReceiveProps = function (e) {
              var t = a({ listRef: h.list, trackRef: h.track }, e, h.state),
                n = !1,
                i = Object.keys(h.props),
                l = Array.isArray(i),
                s = 0;
              for (i = l ? i : i[Symbol.iterator](); ; ) {
                var c;
                if (l) {
                  if (s >= i.length) break;
                  c = i[s++];
                } else {
                  if ((s = i.next()).done) break;
                  c = s.value;
                }
                var _ = c;
                if (!e.hasOwnProperty(_)) {
                  n = !0;
                  break;
                }
                if (
                  "object" !== o(e[_]) &&
                  "function" !== typeof e[_] &&
                  e[_] !== h.props[_]
                ) {
                  n = !0;
                  break;
                }
              }
              h.updateState(t, n, function () {
                h.state.currentSlide >= r.default.Children.count(e.children) &&
                  h.changeSlide({
                    message: "index",
                    index:
                      r.default.Children.count(e.children) - e.slidesToShow,
                    currentSlide: h.state.currentSlide,
                  }),
                  e.autoplay ? h.autoPlay("update") : h.pause("paused");
              });
            }),
            (h.componentDidUpdate = function () {
              if (
                (h.checkImagesLoad(),
                h.props.onReInit && h.props.onReInit(),
                h.props.lazyLoad)
              ) {
                var e = (0, _.getOnDemandLazySlides)(a({}, h.props, h.state));
                e.length > 0 &&
                  (h.setState(function (t) {
                    return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                  }),
                  h.props.onLazyLoad && h.props.onLazyLoad(e));
              }
              h.adaptHeight();
            }),
            (h.onWindowResized = function (e) {
              h.debouncedResize && h.debouncedResize.cancel(),
                (h.debouncedResize = (0, s.default)(function () {
                  return h.resizeWindow(e);
                }, 50)),
                h.debouncedResize();
            }),
            (h.resizeWindow = function () {
              var e =
                !(arguments.length > 0 && void 0 !== arguments[0]) ||
                arguments[0];
              if (i.default.findDOMNode(h.track)) {
                var t = a(
                  { listRef: h.list, trackRef: h.track },
                  h.props,
                  h.state,
                );
                h.updateState(t, e, function () {
                  h.props.autoplay ? h.autoPlay("update") : h.pause("paused");
                }),
                  h.setState({ animating: !1 }),
                  clearTimeout(h.animationEndCallback),
                  delete h.animationEndCallback;
              }
            }),
            (h.updateState = function (e, t, n) {
              var o = (0, _.initializedState)(e);
              e = a({}, e, o, { slideIndex: o.currentSlide });
              var i = (0, _.getTrackLeft)(e);
              e = a({}, e, { left: i });
              var l = (0, _.getTrackCSS)(e);
              (t ||
                r.default.Children.count(h.props.children) !==
                  r.default.Children.count(e.children)) &&
                (o.trackStyle = l),
                h.setState(o, n);
            }),
            (h.ssrInit = function () {
              if (h.props.variableWidth) {
                var e = 0,
                  t = 0,
                  n = [],
                  o = (0, _.getPreClones)(
                    a({}, h.props, h.state, {
                      slideCount: h.props.children.length,
                    }),
                  ),
                  i = (0, _.getPostClones)(
                    a({}, h.props, h.state, {
                      slideCount: h.props.children.length,
                    }),
                  );
                h.props.children.forEach(function (t) {
                  n.push(t.props.style.width), (e += t.props.style.width);
                });
                for (var l = 0; l < o; l++)
                  (t += n[n.length - 1 - l]), (e += n[n.length - 1 - l]);
                for (var s = 0; s < i; s++) e += n[s];
                for (var c = 0; c < h.state.currentSlide; c++) t += n[c];
                var u = { width: e + "px", left: -t + "px" };
                if (h.props.centerMode) {
                  var d = n[h.state.currentSlide] + "px";
                  u.left = "calc(" + u.left + " + (100% - " + d + ") / 2 ) ";
                }
                h.setState({ trackStyle: u });
              } else {
                var p = r.default.Children.count(h.props.children),
                  f = a({}, h.props, h.state, { slideCount: p }),
                  m = (0, _.getPreClones)(f) + (0, _.getPostClones)(f) + p,
                  y = (100 / h.props.slidesToShow) * m,
                  b = 100 / m,
                  v =
                    (-b * ((0, _.getPreClones)(f) + h.state.currentSlide) * y) /
                    100;
                h.props.centerMode && (v += (100 - (b * y) / 100) / 2);
                var g = { width: y + "%", left: v + "%" };
                h.setState({ slideWidth: b + "%", trackStyle: g });
              }
            }),
            (h.checkImagesLoad = function () {
              var e = document.querySelectorAll(".slick-slide img"),
                t = e.length,
                n = 0;
              Array.prototype.forEach.call(e, function (e) {
                var o = function () {
                  return ++n && n >= t && h.onWindowResized();
                };
                if (e.onclick) {
                  var a = e.onclick;
                  e.onclick = function () {
                    a(), e.parentNode.focus();
                  };
                } else
                  e.onclick = function () {
                    return e.parentNode.focus();
                  };
                e.onload ||
                  (h.props.lazyLoad
                    ? (e.onload = function () {
                        h.adaptHeight(),
                          h.callbackTimers.push(
                            setTimeout(h.onWindowResized, h.props.speed),
                          );
                      })
                    : ((e.onload = o),
                      (e.onerror = function () {
                        o(),
                          h.props.onLazyLoadError && h.props.onLazyLoadError();
                      })));
              });
            }),
            (h.progressiveLazyLoad = function () {
              for (
                var e = [],
                  t = a({}, h.props, h.state),
                  n = h.state.currentSlide;
                n < h.state.slideCount + (0, _.getPostClones)(t);
                n++
              )
                if (h.state.lazyLoadedList.indexOf(n) < 0) {
                  e.push(n);
                  break;
                }
              for (
                var o = h.state.currentSlide - 1;
                o >= -(0, _.getPreClones)(t);
                o--
              )
                if (h.state.lazyLoadedList.indexOf(o) < 0) {
                  e.push(o);
                  break;
                }
              e.length > 0
                ? (h.setState(function (t) {
                    return { lazyLoadedList: t.lazyLoadedList.concat(e) };
                  }),
                  h.props.onLazyLoad && h.props.onLazyLoad(e))
                : h.lazyLoadTimer &&
                  (clearInterval(h.lazyLoadTimer), delete h.lazyLoadTimer);
            }),
            (h.slideHandler = function (e) {
              var t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                n = h.props,
                o = n.asNavFor,
                r = n.currentSlide,
                i = n.beforeChange,
                l = n.onLazyLoad,
                s = n.speed,
                c = n.afterChange,
                u = (0, _.slideHandler)(
                  a({ index: e }, h.props, h.state, {
                    trackRef: h.track,
                    useCSS: h.props.useCSS && !t,
                  }),
                ),
                d = u.state,
                p = u.nextState;
              if (d) {
                i && i(r, d.currentSlide);
                var f = d.lazyLoadedList.filter(function (e) {
                  return h.state.lazyLoadedList.indexOf(e) < 0;
                });
                l && f.length > 0 && l(f),
                  h.setState(d, function () {
                    o &&
                      o.innerSlider.state.currentSlide !== r &&
                      o.innerSlider.slideHandler(e),
                      p &&
                        (h.animationEndCallback = setTimeout(function () {
                          var e = p.animating,
                            t = m(p, ["animating"]);
                          h.setState(t, function () {
                            h.callbackTimers.push(
                              setTimeout(function () {
                                return h.setState({ animating: e });
                              }, 10),
                            ),
                              (h.clickable = !0),
                              c && c(d.currentSlide),
                              delete h.animationEndCallback;
                          });
                        }, s));
                  });
              }
            }),
            (h.changeSlide = function (e) {
              var t =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                n = a({}, h.props, h.state),
                o = (0, _.changeSlide)(n, e);
              (0 === o || o) &&
                (!0 === t ? h.slideHandler(o, t) : h.slideHandler(o));
            }),
            (h.clickHandler = function (e) {
              !1 === h.clickable && (e.stopPropagation(), e.preventDefault()),
                (h.clickable = !0);
            }),
            (h.keyHandler = function (e) {
              var t = (0, _.keyHandler)(e, h.props.accessibility, h.props.rtl);
              "" !== t && h.changeSlide({ message: t });
            }),
            (h.selectHandler = function (e) {
              h.changeSlide(e);
            }),
            (h.disableBodyScroll = function () {
              window.ontouchmove = function (e) {
                (e = e || window.event).preventDefault && e.preventDefault(),
                  (e.returnValue = !1);
              };
            }),
            (h.enableBodyScroll = function () {
              window.ontouchmove = null;
            }),
            (h.swipeStart = function (e) {
              h.pause("focused"),
                h.props.verticalSwiping && h.disableBodyScroll();
              var t = (0, _.swipeStart)(e, h.props.swipe, h.props.draggable);
              "" !== t && h.setState(t);
            }),
            (h.swipeMove = function (e) {
              if (h.state.dragging && h.props.touchMove) {
                var t = (0, _.swipeMove)(
                  e,
                  a({}, h.props, h.state, {
                    trackRef: h.track,
                    listRef: h.list,
                    slideIndex: h.state.currentSlide,
                  }),
                );
                if (!t) return;
                t.swiping && (h.clickable = !1), h.setState(t);
              }
            }),
            (h.swipeEnd = function (e) {
              h.autoPlay("blur");
              var t = (0, _.swipeEnd)(
                e,
                a({}, h.props, h.state, {
                  trackRef: h.track,
                  listRef: h.list,
                  slideIndex: h.state.currentSlide,
                }),
              );
              if (t) {
                var n = t.triggerSlideHandler;
                delete t.triggerSlideHandler,
                  h.setState(t),
                  void 0 !== n &&
                    (h.slideHandler(n),
                    h.props.verticalSwiping && h.enableBodyScroll());
              }
            }),
            (h.slickPrev = function () {
              h.callbackTimers.push(
                setTimeout(function () {
                  return h.changeSlide({ message: "previous" });
                }, 0),
              );
            }),
            (h.slickNext = function () {
              h.callbackTimers.push(
                setTimeout(function () {
                  return h.changeSlide({ message: "next" });
                }, 0),
              );
            }),
            (h.slickGoTo = function (e) {
              var t =
                arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              if (((e = Number(e)), isNaN(e))) return "";
              h.callbackTimers.push(
                setTimeout(function () {
                  return h.changeSlide(
                    {
                      message: "index",
                      index: e,
                      currentSlide: h.state.currentSlide,
                    },
                    t,
                  );
                }, 0),
              );
            }),
            (h.play = function () {
              var e;
              if (h.props.rtl)
                e = h.state.currentSlide - h.props.slidesToScroll;
              else {
                if (!(0, _.canGoNext)(a({}, h.props, h.state))) return !1;
                e = h.state.currentSlide + h.props.slidesToScroll;
              }
              h.slideHandler(e);
            }),
            (h.autoPlay = function (e) {
              h.autoplayTimer && clearInterval(h.autoplayTimer);
              var t = h.state.autoplaying;
              if ("update" === e) {
                if ("hovered" === t || "focused" === t || "paused" === t)
                  return;
              } else if ("leave" === e) {
                if ("paused" === t || "focused" === t) return;
              } else if ("blur" === e && ("paused" === t || "hovered" === t))
                return;
              (h.autoplayTimer = setInterval(
                h.play,
                h.props.autoplaySpeed + 50,
              )),
                h.setState({ autoplaying: "playing" });
            }),
            (h.pause = function (e) {
              h.autoplayTimer &&
                (clearInterval(h.autoplayTimer), (h.autoplayTimer = null));
              var t = h.state.autoplaying;
              "paused" === e
                ? h.setState({ autoplaying: "paused" })
                : "focused" === e
                  ? ("hovered" !== t && "playing" !== t) ||
                    h.setState({ autoplaying: "focused" })
                  : "playing" === t && h.setState({ autoplaying: "hovered" });
            }),
            (h.onDotsOver = function () {
              return h.props.autoplay && h.pause("hovered");
            }),
            (h.onDotsLeave = function () {
              return (
                h.props.autoplay &&
                "hovered" === h.state.autoplaying &&
                h.autoPlay("leave")
              );
            }),
            (h.onTrackOver = function () {
              return h.props.autoplay && h.pause("hovered");
            }),
            (h.onTrackLeave = function () {
              return (
                h.props.autoplay &&
                "hovered" === h.state.autoplaying &&
                h.autoPlay("leave")
              );
            }),
            (h.onSlideFocus = function () {
              return h.props.autoplay && h.pause("focused");
            }),
            (h.onSlideBlur = function () {
              return (
                h.props.autoplay &&
                "focused" === h.state.autoplaying &&
                h.autoPlay("blur")
              );
            }),
            (h.render = function () {
              var e,
                t,
                n,
                o = (0, c.default)("slick-slider", h.props.className, {
                  "slick-vertical": h.props.vertical,
                  "slick-initialized": !0,
                }),
                i = a({}, h.props, h.state),
                l = (0, _.extractObject)(i, [
                  "fade",
                  "cssEase",
                  "speed",
                  "infinite",
                  "centerMode",
                  "focusOnSelect",
                  "currentSlide",
                  "lazyLoad",
                  "lazyLoadedList",
                  "rtl",
                  "slideWidth",
                  "slideHeight",
                  "listHeight",
                  "vertical",
                  "slidesToShow",
                  "slidesToScroll",
                  "slideCount",
                  "trackStyle",
                  "variableWidth",
                  "unslick",
                  "centerPadding",
                ]),
                s = h.props.pauseOnHover;
              if (
                ((l = a({}, l, {
                  onMouseEnter: s ? h.onTrackOver : null,
                  onMouseLeave: s ? h.onTrackLeave : null,
                  onMouseOver: s ? h.onTrackOver : null,
                  focusOnSelect: h.props.focusOnSelect ? h.selectHandler : null,
                })),
                !0 === h.props.dots &&
                  h.state.slideCount >= h.props.slidesToShow)
              ) {
                var f = (0, _.extractObject)(i, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots",
                  ]),
                  m = h.props.pauseOnDotsHover;
                (f = a({}, f, {
                  clickHandler: h.changeSlide,
                  onMouseEnter: m ? h.onDotsLeave : null,
                  onMouseOver: m ? h.onDotsOver : null,
                  onMouseLeave: m ? h.onDotsLeave : null,
                })),
                  (e = r.default.createElement(d.Dots, f));
              }
              var y = (0, _.extractObject)(i, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow",
              ]);
              (y.clickHandler = h.changeSlide),
                h.props.arrows &&
                  ((t = r.default.createElement(p.PrevArrow, y)),
                  (n = r.default.createElement(p.NextArrow, y)));
              var b = null;
              h.props.vertical && (b = { height: h.state.listHeight });
              var v = null;
              !1 === h.props.vertical
                ? !0 === h.props.centerMode &&
                  (v = { padding: "0px " + h.props.centerPadding })
                : !0 === h.props.centerMode &&
                  (v = { padding: h.props.centerPadding + " 0px" });
              var g = a({}, b, v),
                w = h.props.touchMove,
                x = {
                  className: "slick-list",
                  style: g,
                  onClick: h.clickHandler,
                  onMouseDown: w ? h.swipeStart : null,
                  onMouseUp: w ? h.swipeEnd : null,
                  onMouseLeave: h.state.dragging && w ? h.swipeEnd : null,
                  onTouchStart: w ? h.swipeStart : null,
                  onTouchEnd: w ? h.swipeEnd : null,
                  onTouchCancel: h.state.dragging && w ? h.swipeEnd : null,
                  onKeyDown: h.props.accessibility ? h.keyHandler : null,
                },
                k = { className: o, dir: "ltr" };
              return (
                h.props.unslick &&
                  ((x = { className: "slick-list" }), (k = { className: o })),
                r.default.createElement(
                  "div",
                  k,
                  h.props.unslick ? "" : t,
                  r.default.createElement(
                    "div",
                    a({ ref: h.listRefHandler }, x),
                    r.default.createElement(
                      u.Track,
                      a({ ref: h.trackRefHandler }, l),
                      h.props.children,
                    ),
                  ),
                  h.props.unslick ? "" : n,
                  h.props.unslick ? "" : e,
                )
              );
            }),
            (h.list = null),
            (h.track = null),
            (h.state = a({}, l.default, {
              currentSlide: h.props.initialSlide,
              slideCount: r.default.Children.count(h.props.children),
            })),
            (h.callbackTimers = []),
            (h.clickable = !0),
            (h.debouncedResize = null),
            h
          );
        }
        return (
          (function (e, t) {
            if ("function" !== typeof t && null !== t)
              throw new TypeError(
                "Super expression must either be null or a function, not " +
                  typeof t,
              );
            (e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
              t &&
                (Object.setPrototypeOf
                  ? Object.setPrototypeOf(e, t)
                  : (e.__proto__ = t));
          })(t, e),
          t
        );
      })(r.default.Component);
    },
    wFID: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return a;
      }),
        n.d(t, "b", function () {
          return r;
        });
      var o = n("3T+G"),
        a = function (e, t) {
          return function (n) {
            return Boolean(
              (Object(o.d)(n) && o.f.test(n) && n.startsWith(e)) ||
                (t && Object.prototype.hasOwnProperty.call(n, t)),
            );
          };
        },
        r = function (e, t, n) {
          return function (a) {
            var r;
            if (!Object(o.d)(a)) return a;
            var i = a.match(o.c),
              l = i[0],
              s = i[1],
              c = i[2],
              _ = i[3];
            return (
              ((r = {})[e] = parseFloat(l)),
              (r[t] = parseFloat(s)),
              (r[n] = parseFloat(c)),
              (r.alpha = void 0 !== _ ? parseFloat(_) : 1),
              r
            );
          };
        };
    },
    wJg7: function (e, t) {
      var n = 9007199254740991,
        o = /^(?:0|[1-9]\d*)$/;
      e.exports = function (e, t) {
        var a = typeof e;
        return (
          !!(t = null == t ? n : t) &&
          ("number" == a || ("symbol" != a && o.test(e))) &&
          e > -1 &&
          e % 1 == 0 &&
          e < t
        );
      };
    },
    wOlv: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o,
        a = n("WCV8"),
        r = (o = a) && o.__esModule ? o : { default: o },
        i = n("Aw7D");
      t.default = function (e, t, n, o, a) {
        var l = [];
        if (e.required || (!e.required && o.hasOwnProperty(e.field))) {
          if ((0, i.isEmptyValue)(t, "string") && !e.required) return n();
          r.default.required(e, t, o, l, a, "string"),
            (0, i.isEmptyValue)(t, "string") ||
              (r.default.type(e, t, o, l, a),
              r.default.range(e, t, o, l, a),
              r.default.pattern(e, t, o, l, a),
              !0 === e.whitespace && r.default.whitespace(e, t, o, l, a));
        }
        n(l);
      };
    },
    wZXL: function (e, t, n) {
      var o = n("vPd/"),
        a = n("IX3V"),
        r = a.each,
        i = a.isFunction,
        l = a.isArray;
      function s() {
        if (!window.matchMedia)
          throw new Error(
            "matchMedia not present, legacy browsers require a polyfill",
          );
        (this.queries = {}),
          (this.browserIsIncapable = !window.matchMedia("only all").matches);
      }
      (s.prototype = {
        constructor: s,
        register: function (e, t, n) {
          var a = this.queries,
            s = n && this.browserIsIncapable;
          return (
            a[e] || (a[e] = new o(e, s)),
            i(t) && (t = { match: t }),
            l(t) || (t = [t]),
            r(t, function (t) {
              i(t) && (t = { match: t }), a[e].addHandler(t);
            }),
            this
          );
        },
        unregister: function (e, t) {
          var n = this.queries[e];
          return (
            n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])),
            this
          );
        },
      }),
        (e.exports = s);
    },
    waHC: function (e, t, n) {
      e.exports = {
        popover: "popover__popover___19ztE",
        show: "popover__show___2UdCz",
        "is-m": "popover__is-m___3pbTZ",
        "flex-box": "popover__flex-box___14szQ",
        "is-pc": "popover__is-pc___2rxjc",
        arrow: "popover__arrow___29rRa",
        close: "popover__close___1jBk4",
        "cover-image": "popover__cover-image___1yWkS",
        "content-text": "popover__content-text___2OyWK",
        title: "popover__title___245CC",
        desc: "popover__desc___3NoMo",
        container: "popover__container___2DyOM",
        "learn-more": "popover__learn-more___wGmmT",
      };
    },
    wclG: function (e, t, n) {
      var o = n("pFRH"),
        a = n("88Gu")(o);
      e.exports = a;
    },
    wgeU: function (e, t) {},
    wrZu: function (e, t, n) {
      var o = n("+K+b"),
        a = n("XYm9"),
        r = n("b2z7"),
        i = n("otv/"),
        l = n("yP5f"),
        s = "[object Boolean]",
        c = "[object Date]",
        _ = "[object Map]",
        u = "[object Number]",
        d = "[object RegExp]",
        p = "[object Set]",
        f = "[object String]",
        h = "[object Symbol]",
        m = "[object ArrayBuffer]",
        y = "[object DataView]",
        b = "[object Float32Array]",
        v = "[object Float64Array]",
        g = "[object Int8Array]",
        w = "[object Int16Array]",
        x = "[object Int32Array]",
        k = "[object Uint8Array]",
        O = "[object Uint8ClampedArray]",
        I = "[object Uint16Array]",
        S = "[object Uint32Array]";
      e.exports = function (e, t, n) {
        var j = e.constructor;
        switch (t) {
          case m:
            return o(e);
          case s:
          case c:
            return new j(+e);
          case y:
            return a(e, n);
          case b:
          case v:
          case g:
          case w:
          case x:
          case k:
          case O:
          case I:
          case S:
            return l(e, n);
          case _:
            return new j();
          case u:
          case f:
            return new j(e);
          case d:
            return r(e);
          case p:
            return new j();
          case h:
            return i(e);
        }
      };
    },
    "x/Rj": function (e, t, n) {
      "use strict";
      var o = n("KQm4"),
        a = n("rePB"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("a6RD"),
        m = n.n(h),
        y = n("FCep"),
        b = n("XnI8"),
        v = n("TSYQ"),
        g = n.n(v),
        w = n("yWgo"),
        x = n("r7AC"),
        k = n("u6T5"),
        O = n.n(k),
        I = (n("CDV2"), n("aiR1"), n("YovF"), f.a.createElement);
      function S(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function j(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var T = {
          "@dji/quark/dist/Tabs.css": {
            _3lMTV: "Tabs___3lMTV___2pQ-A",
            _2bOox: "Tabs___2bOox___2CQtU",
            _28KUW: "Tabs___28KUW___-Srg6",
            _1Ltud: "Tabs___1Ltud___n6KKI",
            _2LH7P: "Tabs___2LH7P___3Keah",
            _1ubfg: "Tabs___1ubfg___3dybl",
            zPFdO: "Tabs__zPFdO___3lvSR",
            "_3-a_h": "Tabs___3-a_h___5FW1k",
            _8wsGN: "Tabs___8wsGN___gL3-r",
            _1RPG6: "Tabs___1RPG6___3wbtN",
            _2RUui: "Tabs___2RUui___1-O61",
            pHyFu: "Tabs__pHyFu___3CP5v",
            _3yx3R: "Tabs___3yx3R___1zv_m",
            _1DkKo: "Tabs___1DkKo___du86p",
            _1G3aQ: "Tabs___1G3aQ___ZMYAi",
            _3Qm4W: "Tabs___3Qm4W___36FQs",
            _14aFm: "Tabs___14aFm___Jiw0n",
            _2d3yp: "Tabs___2d3yp___3n3ff",
            _1RhgG: "Tabs___1RhgG___1vwAY",
            "quark-tab-default-tab-bar-wrap":
              "Tabs__quark-tab-default-tab-bar-wrap___3Cd6d",
            "quark-tab-default-tab-bar":
              "Tabs__quark-tab-default-tab-bar___3mZvV",
            "quark-tab-default-tab-container":
              "Tabs__quark-tab-default-tab-container___3qQ8P",
          },
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "wm161-model-container": "style__wm161-model-container___17bBU",
            hidden: "style__hidden___3U51Z",
            "fade-up-title": "style__fade-up-title___1oEza",
            "fade-up-text": "style__fade-up-text___s9RAO",
            "fade-up-reverse": "style__fade-up-reverse___3Ffmw",
            reverse: "style__reverse___2G2Ys",
            rotate: "style__rotate___3y-Li",
            "top-animation": "style__top-animation___2Sqbv",
            "bottom-animation": "style__bottom-animation___3aU5w",
            "front-animation": "style__front-animation___2od4a",
            "back-animation": "style__back-animation___v7X_u",
            "left-animation": "style__left-animation___KcuUK",
            "right-animation": "style__right-animation___-FV_o",
            "model-wrapper": "style__model-wrapper___3KRq2",
            "model-title": "style__model-title___2UrJl",
            "model-tabs": "style__model-tabs___tUzLq",
            "model-tabs-back-mask": "style__model-tabs-back-mask___1zPkE",
            "model-tabs-panel": "style__model-tabs-panel___39W1C",
            "model-block": "style__model-block___1Yk9k",
            "model-desc": "style__model-desc___ksMoi",
            "model-qc-code": "style__model-qc-code___32K79",
            "qc-active": "style__qc-active___O6vGA",
            "unfold-tabs-panel": "style__unfold-tabs-panel___3-Vep",
            "fold-tabs-panel": "style__fold-tabs-panel___3Vmup",
            "model-content": "style__model-content___MhwPT",
            "model-ie-img": "style__model-ie-img___9Zry2",
            "model-progress": "style__model-progress___3ZHjt",
            cube: "style__cube___1n9AS",
            sides: "style__sides___1Kt_u",
            top: "style__top___3Jy_d",
            bottom: "style__bottom___321L8",
            front: "style__front___3QhDu",
            back: "style__back___2q48n",
            left: "style__left___2SWKs",
            right: "style__right___2x5Tx",
            "cube-box": "style__cube-box___MrewK",
            text: "style__text___3ireS",
            "bar-wrapper": "style__bar-wrapper___1v6sT",
            bar: "style__bar___2kDyi",
            "flex-box": "style__flex-box___2heey",
            "model-error": "style__model-error___3RyIi",
            "model-retry-btn": "style__model-retry-btn___3BCvF",
            "model-retry-logo": "style__model-retry-logo___hfW1Y",
            "model-error-logo": "style__model-error-logo___1Ns95",
            "progress-show": "style__progress-show___2-G45",
            "model-active": "style__model-active___1k12E",
            "model-ar-img": "style__model-ar-img___35I2Z",
            "model-ar-tips": "style__model-ar-tips___dUwjr",
            "wm161-model-container-in-modal":
              "style__wm161-model-container-in-modal___kKLsO",
            "model-block-3d": "style__model-block-3d___2fudz",
            "switch-tabs": "style__switch-tabs___28KKA",
            "model-block-ar": "style__model-block-ar___xAZuZ",
            tip: "style__tip___234JL",
            "wm161-model-container-light-theme":
              "style__wm161-model-container-light-theme___216_A",
            "quark-tab-default-tab-container":
              "style__quark-tab-default-tab-container___24CB6",
            "aos-animate": "style__aos-animate___2Ky33",
            "switch-tabs-panel": "style__switch-tabs-panel___1B1wi",
            "switch-active": "style__switch-active___1NdeD",
            _8wsGN: "style___8wsGN___aWYFD",
            "quark-tab-default-tab-bar":
              "style__quark-tab-default-tab-bar___1NrXy",
            _28KUW: "style___28KUW___1htnN",
            _1Ltud: "style___1Ltud___Pce63",
          },
        },
        C = m()(
          function () {
            return Promise.all([n.e(0), n.e(167)]).then(n.bind(null, "D9Jf"));
          },
          {
            ssr: !1,
            loadableGenerated: {
              webpack: function () {
                return ["D9Jf"];
              },
              modules: ["./modelInstance"],
            },
          },
        ),
        M = function (e) {
          var t = e.curState,
            n = e.switchOptions,
            o = e.sendGaEvent;
          return I(
            "ul",
            { className: "style__switch-tabs___28KKA" },
            n.map(function (e) {
              return I("li", {
                key: e.key,
                onClick: function () {
                  e.click(e.key), o(e.key)();
                },
                dangerouslySetInnerHTML: { __html: e.name },
                className: d()(
                  g()({ "switch-tabs-panel": !0, "switch-active": t[e.key] }),
                  T,
                  {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  },
                ),
              });
            }),
          );
        },
        P = function (e) {
          var t = e.modelDataList,
            n = e.curState,
            o = e.isIE,
            a = e.sendGaEvent,
            r = e.initState,
            i = e.theme;
          return I(
            f.a.Fragment,
            null,
            t.map(function (e) {
              var t = n[e.key],
                l = r[e.key];
              return o
                ? I(
                    "div",
                    {
                      onClick: a,
                      key: e.key,
                      className: d()(
                        g()({ "model-content": !0, "model-active": t }),
                        T,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    I(y.a, {
                      className: "style__model-ie-img___9Zry2",
                      type: "img",
                      src: e.ieImg,
                      alt: "",
                    }),
                  )
                : l
                  ? I(
                      "div",
                      {
                        onClick: a,
                        key: e.key,
                        className: d()(
                          g()({ "model-content": !0, "model-active": t }),
                          T,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      I(C, {
                        theme: i,
                        normalArModelUrl: e.url,
                        modelLightUrl: e.lightUrl,
                        modelCameraOrbit: e.orbit,
                        modelCameraDist: e.dist,
                        modelLoadDesc: e.desc,
                        isActived: t,
                        modelExposure: e.exposure,
                      }),
                    )
                  : null;
            }),
          );
        },
        E = function (e) {
          var t = e.arQcDataList,
            n = e.curState;
          return I(
            f.a.Fragment,
            null,
            t.map(function (e) {
              return I(y.a, {
                type: "img",
                key: e.key,
                src: e.url,
                alt: e.key,
                className: d()(
                  g()({ "model-qc-code": !0, "qc-active": n[e.key] }),
                  T,
                  {
                    autoResolveMultipleImports: !0,
                    handleMissingStyleName: "warn",
                  },
                ),
              });
            }),
          );
        },
        L = function (e) {
          var t = e.modelArFirstTitle,
            n = e.modelDesc,
            o = e.modelTip,
            a = e.curState,
            r = e.switchOptions,
            i = e.sendGaEvent,
            l = e.children;
          return I(
            "div",
            { className: "style__model-desc___ksMoi" },
            l,
            I("h3", { dangerouslySetInnerHTML: { __html: t } }),
            I("p", { dangerouslySetInnerHTML: { __html: n } }),
            I(M, { curState: a, switchOptions: r, sendGaEvent: i }),
            o || "",
          );
        },
        B = (function (e) {
          function t(e) {
            var n;
            return (
              Object(r.default)(this, t),
              ((n = j(this, t, [e])).modelTabKeyList = {
                normal: "3dModel",
                ar: "arModel",
              }),
              (n.state = {
                isIE: !1,
                isStartLoadModel: !1,
                isActiveArTabs: !1,
                curFoldModelState: { fold: !1, unfold: !0, third: !1 },
                curQcImgState: { fold: !1, unfold: !0, third: !1 },
                initModelState: { fold: !1, unfold: !0, third: !1 },
                curPosterImgType: null,
                activeTabKey: n.modelTabKeyList.normal,
              }),
              (n.modelFoldTypeList = {
                fold: "fold",
                unfold: "unfold",
                third: "third",
              }),
              (n.handleTabsChange = n.handleTabsChange.bind(Object(c.a)(n))),
              (n.handleSwitchModel = n.handleSwitchModel.bind(Object(c.a)(n))),
              (n.handleSwitchQcImg = n.handleSwitchQcImg.bind(Object(c.a)(n))),
              (n.handleStartLoadModel = n.handleStartLoadModel.bind(
                Object(c.a)(n),
              )),
              (n.setActiveModelType = n.setActiveModelType.bind(
                Object(c.a)(n),
              )),
              n
            );
          }
          return (
            Object(_.a)(t, e),
            Object(i.default)(t, [
              {
                key: "componentDidMount",
                value: function () {
                  var e = Object(w.h)() || this.props.forceDowngrade;
                  this.setState({ isIE: e }), this.handleStartLoadModel();
                },
              },
              {
                key: "UNSAFE_componentWillReceiveProps",
                value: function (e) {
                  e &&
                    e.activeModelType !== this.props.activeModelType &&
                    e.activeModelType &&
                    this.setActiveModelType(e.activeModelType);
                },
              },
              {
                key: "setActiveModelType",
                value: function (e) {
                  var t = e === this.modelTabKeyList.ar;
                  this.setState(function (n) {
                    return (function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                          ? S(Object(n), !0).forEach(function (t) {
                              Object(a.a)(e, t, n[t]);
                            })
                          : Object.getOwnPropertyDescriptors
                            ? Object.defineProperties(
                                e,
                                Object.getOwnPropertyDescriptors(n),
                              )
                            : S(Object(n)).forEach(function (t) {
                                Object.defineProperty(
                                  e,
                                  t,
                                  Object.getOwnPropertyDescriptor(n, t),
                                );
                              });
                      }
                      return e;
                    })(
                      { isActiveArTabs: t },
                      n.activeTabKey !== e ? { activeTabKey: e } : {},
                    );
                  });
                },
              },
              {
                key: "handleStartLoadModel",
                value: function () {
                  var e = this;
                  Object(x.b)({
                    elm: this.modelContainer,
                    offset: 600,
                    callback: function (t) {
                      t.inView && e.setState({ isStartLoadModel: !0 });
                    },
                  });
                },
              },
              {
                key: "handleTabsChange",
                value: function (e) {
                  (0, this.props.sendGa)("tabs-".concat(e))(),
                    this.setActiveModelType(e);
                },
              },
              {
                key: "handleSwitchModel",
                value: function (e) {
                  var t = this.state,
                    n = t.curFoldModelState,
                    o = t.initModelState;
                  Object.keys(n).forEach(function (t) {
                    n[t] = t === e;
                  }),
                    (o[e] = !0),
                    this.setState({ curFoldModelState: n, initModelState: o });
                },
              },
              {
                key: "handleSwitchQcImg",
                value: function (e) {
                  var t = this.state.curQcImgState;
                  Object.keys(t).forEach(function (n) {
                    t[n] = n === e;
                  }),
                    this.setState({ curQcImgState: t, curPosterImgType: e });
                },
              },
              {
                key: "render",
                value: function () {
                  var e = this,
                    t = O.a.TabPanel,
                    n = this.props,
                    a = n.component_data,
                    r = n.t,
                    i = n.sendGa,
                    l = n.modelTabsName,
                    s = n.modelArTabsName,
                    c = n.showAsModal,
                    _ = this.modelFoldTypeList,
                    u = this.state,
                    p = u.isIE,
                    f = u.isActiveArTabs,
                    h = u.curFoldModelState,
                    m = u.initModelState,
                    b = u.curQcImgState,
                    v = u.curPosterImgType,
                    x = u.isStartLoadModel,
                    k = u.activeTabKey,
                    S = a.foldTabsName,
                    j = a.foldArQcImg,
                    C = a.foldNormalArModelUrl,
                    M = a.foldModelLightUrl,
                    B = a.foldModelCameraOrbit,
                    N = a.foldModelCameraDist,
                    D = a.foldModelExposure,
                    z = a.arFoldModelPosterUrl,
                    A = a.ieFoldModelImg,
                    R = a.unfoldTabsName,
                    F = a.unfoldArQcImg,
                    V = a.unfoldNormalArModelUrl,
                    H = a.unfoldModelLightUrl,
                    W = a.unfoldModelCameraOrbit,
                    U = a.unfoldModelCameraDist,
                    G = a.unfoldModelExposure,
                    Y = a.arUnfoldModelPosterUrl,
                    q = a.ieUnfoldModelImg,
                    X = a.hasThirdMode,
                    Z = a.thirdTabsName,
                    K = a.thirdArQcImg,
                    Q = a.arThirdModelPosterUrl,
                    J = a.thirdNormalArModelUrl,
                    $ = a.thirdModelLightUrl,
                    ee = a.thirdModelCameraOrbit,
                    te = a.thirdModelCameraDist,
                    ne = a.thirdModelExposure,
                    oe = a.ieThirdModelImg,
                    ae = a.mainTitle,
                    re = a.mainDesc,
                    ie = a.modelArDesc,
                    le = a.modelFirstTitle,
                    se = a.modelDesc,
                    ce = a.modelArFirstTitle,
                    _e = a.modelLoadDesc,
                    ue = a.arModelSizeTips,
                    de = a.arModelSupportTips,
                    pe = a.customBackgroundColor,
                    fe = a.theme,
                    he = a.closeFold,
                    me = a.disableFadeAnimation,
                    ye = !!he,
                    be = [
                      {
                        key: _.unfold,
                        name: r(R),
                        click: this.handleSwitchModel,
                      },
                    ].concat(
                      Object(o.a)(
                        ye
                          ? []
                          : [
                              {
                                key: _.fold,
                                name: r(S),
                                click: this.handleSwitchModel,
                              },
                            ],
                      ),
                      Object(o.a)(
                        X && !ye
                          ? [
                              {
                                key: _.third,
                                name: r(Z),
                                click: this.handleSwitchModel,
                              },
                            ]
                          : [],
                      ),
                    ),
                    ve = [
                      {
                        key: _.unfold,
                        name: r(R),
                        click: this.handleSwitchQcImg,
                      },
                    ].concat(
                      Object(o.a)(
                        ye
                          ? []
                          : [
                              {
                                key: _.fold,
                                name: r(S),
                                click: this.handleSwitchQcImg,
                              },
                            ],
                      ),
                      Object(o.a)(
                        X && !ye
                          ? [
                              {
                                key: _.third,
                                name: r(Z),
                                click: this.handleSwitchQcImg,
                              },
                            ]
                          : [],
                      ),
                    ),
                    ge = [
                      {
                        key: _.unfold,
                        url: Object(w.hb)(V),
                        lightUrl: Object(w.hb)(H),
                        orbit: W,
                        dist: U,
                        desc: r(_e),
                        exposure: G,
                        ieImg: q,
                      },
                    ].concat(
                      Object(o.a)(
                        ye
                          ? []
                          : [
                              {
                                key: _.fold,
                                url: Object(w.hb)(C),
                                lightUrl: Object(w.hb)(M),
                                orbit: B,
                                dist: N,
                                desc: r(_e),
                                exposure: D,
                                ieImg: A,
                              },
                            ],
                      ),
                      Object(o.a)(
                        X && !ye
                          ? [
                              {
                                key: _.third,
                                url: Object(w.hb)(J),
                                lightUrl: Object(w.hb)($),
                                orbit: ee,
                                dist: te,
                                desc: r(_e),
                                exposure: ne,
                                ieImg: oe,
                              },
                            ]
                          : [],
                      ),
                    ),
                    we = { fold: z, unfold: Y, third: Q },
                    xe = [{ key: "unfold", url: F }].concat(
                      Object(o.a)(ye ? [] : [{ key: "fold", url: j }]),
                      Object(o.a)(X && !ye ? [{ key: "third", url: K }] : []),
                    ),
                    ke = f
                      ? I(
                          "div",
                          { className: "style__model-ar-tips___dUwjr" },
                          I("p", {
                            dangerouslySetInnerHTML: { __html: r(ue) },
                          }),
                          I("p", {
                            dangerouslySetInnerHTML: { __html: r(de) },
                          }),
                        )
                      : null,
                    Oe = pe ? { backgroundColor: pe } : {},
                    Ie = g()({
                      "wm161-model-container": !0,
                      "wm161-model-container-light-theme": "light" === fe,
                      "wm161-model-container-in-modal": c,
                    }),
                    Se = me ? "none" : "fade-up";
                  return I(
                    "section",
                    {
                      ref: function (t) {
                        e.modelContainer = t;
                      },
                      style: Oe,
                      className: d()(Ie, T, {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      }),
                    },
                    I(
                      "div",
                      { className: "style__model-wrapper___3KRq2", style: Oe },
                      I(
                        "div",
                        { className: "style__model-title___2UrJl" },
                        I(
                          "div",
                          { "data-aos": Se },
                          I("h3", {
                            dangerouslySetInnerHTML: { __html: r(ae) },
                          }),
                        ),
                        I(
                          "div",
                          { "data-aos": Se, "data-aos-delay": "300" },
                          I("p", {
                            dangerouslySetInnerHTML: { __html: r(re) },
                          }),
                        ),
                      ),
                      I(
                        "div",
                        {
                          className: "style__model-tabs___tUzLq",
                          "data-aos": Se,
                          "data-aos-delay": "600",
                        },
                        I("div", {
                          className: "style__model-tabs-back-mask___1zPkE",
                        }),
                        I(
                          O.a,
                          {
                            activeKey: k,
                            theme: fe || "dark",
                            tabPosition: "center",
                            tabDisplay: "inline-block",
                            onChange: this.handleTabsChange,
                            tabBarStyle: { textAlign: "center" },
                          },
                          I(
                            t,
                            {
                              className: "style__model-tabs-panel___39W1C",
                              tab: l,
                              key: this.modelTabKeyList.normal,
                            },
                            I(
                              "div",
                              {
                                "data-aos": Se,
                                "data-aos-delay": "900",
                                className:
                                  "style__model-block___1Yk9k style__model-block-3d___2fudz",
                              },
                              I(L, {
                                modelDesc: r(se),
                                modelArFirstTitle: r(le),
                                curState: h,
                                switchOptions: be,
                                sendGaEvent: function (e) {
                                  return i(
                                    "3d-inner-tabs-".concat(e, "-model"),
                                  );
                                },
                              }),
                              x
                                ? I(P, {
                                    isIE: p,
                                    theme: fe || "dark",
                                    sendGaEvent: i("touch-3d-model"),
                                    modelDataList: ge,
                                    curState: h,
                                    initState: m,
                                  })
                                : null,
                            ),
                          ),
                          I(
                            t,
                            {
                              className: "style__model-tabs-panel___39W1C",
                              tab: s,
                              key: this.modelTabKeyList.ar,
                            },
                            I(
                              "div",
                              {
                                className:
                                  "style__model-block___1Yk9k style__model-block-ar___xAZuZ",
                              },
                              I(
                                L,
                                {
                                  modelDesc: r(ie),
                                  modelArFirstTitle: r(ce),
                                  curState: b,
                                  switchOptions: ve,
                                  modelTip: c ? ke : null,
                                  sendGaEvent: function (e) {
                                    return i(
                                      "ar-inner-tabs-".concat(e, "-model"),
                                    );
                                  },
                                },
                                I(E, { arQcDataList: xe, curState: b }),
                              ),
                              I(
                                "div",
                                { className: "style__model-ar-img___35I2Z" },
                                I(y.a, {
                                  type: "img",
                                  src: we.unfold,
                                  style: {
                                    opacity: v && v !== _.unfold ? 0 : 1,
                                  },
                                }),
                                I(y.a, {
                                  type: "img",
                                  src: we.fold,
                                  style: { opacity: v === _.fold ? 1 : 0 },
                                }),
                                I(y.a, {
                                  type: "img",
                                  src: we.third,
                                  style: { opacity: v === _.third ? 1 : 0 },
                                }),
                              ),
                            ),
                          ),
                        ),
                      ),
                      ke,
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(f.a.Component);
      t.a = Object(b.a)(B);
    },
    x1L9: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("rePB"),
        r = n("q1tI"),
        i = n.n(r),
        l = n("iKuz"),
        s = n.n(l),
        c = n("SBOM"),
        _ = n("3vbH"),
        u = n("cKzW"),
        d = (n("3z1L"), n("RXxH")),
        p = i.a.createElement,
        f = {
          "./video.css": {
            "video-player-box": "video__video-player-box___10BYH",
            bgvideo: "video__bgvideo___20rm1",
            "media-video": "video__media-video___1WZym",
            dark: "video__dark___1ne7c",
            "video-button": "video__video-button___3OKvN",
            "video-button-box": "video__video-button-box___3If3A",
            "replay-button": "video__replay-button___3qvXn",
            hidden: "video__hidden___1fdch",
            "pause-button": "video__pause-button___1w7xC",
            "downgrade-img": "video__downgrade-img___1U438",
            "downgrade-pic": "video__downgrade-pic___3waNg",
            "downgrade-play-btn": "video__downgrade-play-btn___1hPQ1",
          },
        };
      function h(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function m(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? h(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : h(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var y = (function (e) {
          return (
            (e.loop = "loop"),
            (e.once = "once"),
            (e.replayWhenRevisible = "replayWhenRevisible"),
            (e.withController = "withController"),
            e
          );
        })({}),
        b = function (e) {
          var t = e.videoMp4,
            n = e.videoWebm,
            o = e.videoPoster,
            a = e.videoDowngradePic,
            r = e.backgroundVideoLoop,
            i = e.backgroundVideoVisiblePlay,
            l = e.backgroundVideoRelpayWhenRevisible,
            s = e.backgroundVideoHoverPlay,
            u = e.isHovering,
            d = p(c.a, { className: "", type: "bg", tagType: "div", src: a }),
            f = {
              backgroundImage: "url(".concat(o, ")"),
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
            };
          return p(
            _.a,
            {
              visiblePlay: i,
              replayWhenRevisible: l,
              triggerPlay: s && u,
              lazyLoad: !0,
              lazyLoadThreshold: 2e3,
              downgradeDom: d,
              style: m(
                { position: "relative", width: "100%", height: "100%" },
                f,
              ),
            },
            p(
              "video",
              { muted: !0, className: "bgvideo", loop: r, autoPlay: !i },
              (null === n || void 0 === n ? void 0 : n.path) &&
                p("source", { type: "video/webm", "data-layzr-src": n.path }),
              p("source", {
                type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                "data-layzr-src": null === t || void 0 === t ? void 0 : t.path,
              }),
            ),
          );
        },
        v = function (e) {
          var t = e.foregroundVideoPlayType,
            n = e.videoPoster,
            a = e.videoMp4,
            r = e.videoWebm,
            i = e.videoDowngradeLink,
            l = e.visibleByDefault,
            h = e.mobileMode,
            m = e.videoDowngradePoster,
            b = e.buttonTheme,
            v = p(
              "div",
              { className: "video__downgrade-img___1U438" },
              p(c.a, {
                type: "img",
                visibleByDefault: l,
                className: "video__downgrade-pic___3waNg",
                src: m || n,
                alt: "",
              }),
              p(
                u.a,
                {
                  link: null === i || void 0 === i ? void 0 : i.path,
                  isMobile: h,
                },
                p("div", { className: "video__downgrade-play-btn___1hPQ1" }),
              ),
            ),
            g = {};
          g["data-layzr-poster"] = n;
          var w = t !== y.once && t !== y.withController,
            x = t !== y.withController,
            k = t === y.replayWhenRevisible,
            O = t === y.loop ? "" : "replay-button",
            I = t === y.withController ? "play-button" : "",
            S = t === y.withController ? "pause-button" : "";
          return p(
            _.a,
            {
              lazyLoad: !0,
              lazyLoadThreshold: 2e3,
              replayWhenRevisible: w,
              visiblePlay: x,
              showWholeElmPlay: k,
              replayClassName: O,
              playClassName: I,
              pauseClassNameVal: S,
              downgradeDom: v,
            },
            p(
              "div",
              {
                "data-video": t,
                className: s()("media-video ".concat(b), f, {
                  autoResolveMultipleImports: !0,
                  handleMissingStyleName: "warn",
                }),
              },
              t === y.withController
                ? p("div", {
                    style: { backgroundImage: "url(".concat(n, ")") },
                  })
                : null,
              p(
                "video",
                Object(o.a)({ muted: !0 }, g, { loop: t === y.loop }),
                (null === r || void 0 === r ? void 0 : r.path) &&
                  p("source", {
                    type: "video/webm",
                    "data-layzr-src":
                      null === r || void 0 === r ? void 0 : r.path,
                  }),
                p("source", {
                  type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                  "data-layzr-src":
                    null === a || void 0 === a ? void 0 : a.path,
                }),
              ),
              [
                p(
                  "div",
                  {
                    key: "pause",
                    "data-link": "ture",
                    className:
                      "pause-button video__video-button___3OKvN video__pause-button___1w7xC",
                  },
                  p(
                    "div",
                    { className: "video__video-button-box___3If3A" },
                    p(d.a, null),
                  ),
                ),
                p(
                  "div",
                  {
                    key: "play",
                    "data-link": "ture",
                    className: "play-button video__video-button___3OKvN",
                  },
                  p(
                    "div",
                    { className: "video__video-button-box___3If3A" },
                    p(d.b, null),
                  ),
                ),
                p(
                  "div",
                  {
                    key: "replay",
                    "data-link": "ture",
                    className:
                      "replay-button video__video-button___3OKvN video__replay-button___3qvXn",
                  },
                  p(
                    "div",
                    { className: "video__video-button-box___3If3A" },
                    p(d.c, null),
                  ),
                ),
              ],
            ),
          );
        };
      t.a = function (e) {
        var t = e.videoType;
        return p("foreground" === t ? v : b, e);
      };
    },
    xA1j: function (e, t, n) {
      e.exports = {
        "hero-vertical-card": "style__hero-vertical-card___R3WRK",
        "panotips-wrapper": "style__panotips-wrapper___2T5fP",
        show: "style__show___3iSKO",
        "is-move": "style__is-move___3DQ8I",
        "tips-icon": "style__tips-icon___1ifLe",
        "tips-text": "style__tips-text___3nyYn",
        "card-wrapper": "style__card-wrapper___1hfls",
        "content-wrapper": "style__content-wrapper___2Ps9G",
        "bg-style": "style__bg-style___xqb00",
        dark: "style__dark___2n_6f",
        "video-button": "style__video-button___ji2fq",
        "replay-button": "style__replay-button___3WFfv",
        "play-button": "style__play-button___1Z91X",
        "pause-button": "style__pause-button___1i4L6",
        light: "style__light___2PNSR",
        "section-pano-120": "style__section-pano-120___26ez7",
        "section-pano-360": "style__section-pano-360___1u9fh",
        "image-content": "style__image-content___MvRPF",
        "media-video": "style__media-video___1DQzO",
        "section-pano-120-180": "style__section-pano-120-180___iqrnq",
        mobile: "style__mobile___31bYL",
        "card-fore-video-poster": "style__card-fore-video-poster___2qNlV",
        "downgrade-img": "style__downgrade-img___tSJLn",
        "downgrade-pic": "style__downgrade-pic___1kIMS",
        "downgrade-play-btn": "style__downgrade-play-btn___3YauZ",
        "normal-wrapper": "style__normal-wrapper___3RNXF",
        "img-hidden": "style__img-hidden___1bfz2",
        "vertical-top-align": "style__vertical-top-align___2jeQ3",
        "vertical-center-align": "style__vertical-center-align___7v4yJ",
        "vertical-bottom-align": "style__vertical-bottom-align___2e5Ci",
        "horizontal-left-align": "style__horizontal-left-align___8l5OI",
        "horizontal-center-align": "style__horizontal-center-align___9jQo0",
        eyebrow: "style__eyebrow___1m8aa",
        headline: "style__headline___31vSf",
        subhead: "style__subhead___38WNz",
        description: "style__description___3mjSU",
        note: "style__note___31_lE",
        "icon-pic": "style__icon-pic___XCp85",
        "topping-img": "style__topping-img___1Yg6q",
        "icon-row-container": "style__icon-row-container___36k2n",
        "icon-item": "style__icon-item___300uK",
        horizontal: "style__horizontal___iFEgT",
        "icon-number-container": "style__icon-number-container___382U_",
        "buttons-container": "style__buttons-container___1b3pR",
        divider: "style__divider___1uY_-",
        "horizontal-right-align": "style__horizontal-right-align___2xeLz",
        "card-container": "style__card-container___17N6B",
        "video-content": "style__video-content___1sh4L",
        "parallax-fore-video": "style__parallax-fore-video___23uUS",
        "fore-controller-video-poster-bg":
          "style__fore-controller-video-poster-bg___2Ucs7",
        hidden: "style__hidden___3yVfJ",
        "fore-image": "style__fore-image___2bMOf",
        "parallax-fore-pic": "style__parallax-fore-pic___1QnWn",
        "divider-container": "style__divider-container___29WoK",
        link: "style__link___1E1u5",
        "button-wrapper": "style__button-wrapper___1PDIO",
        "button-inner": "style__button-inner___3CW1Z",
        "button-link": "style__button-link___3eGxD",
        "button-video-play": "style__button-video-play___q53VQ",
        "video-play": "style__video-play___3Ym34",
        "video-play-light": "style__video-play-light___3RBn2",
        "video-play-dark": "style__video-play-dark___dXNCV",
        "download-buttons-container":
          "style__download-buttons-container___3TEeg",
        download: "style__download___25YoI",
        "download-google-play": "style__download-google-play___10qbT",
        "background-video": "style__background-video___2N4SQ",
        "video-mask": "style__video-mask___1GM2x",
        "card-link": "style__card-link___3FwZf",
        "text-content-container": "style__text-content-container___e4g8E",
      };
    },
    xEkU: function (e, t, n) {
      (function (t) {
        for (
          var o = n("bQgK"),
            a = "undefined" === typeof window ? t : window,
            r = ["moz", "webkit"],
            i = "AnimationFrame",
            l = a["request" + i],
            s = a["cancel" + i] || a["cancelRequest" + i],
            c = 0;
          !l && c < r.length;
          c++
        )
          (l = a[r[c] + "Request" + i]),
            (s = a[r[c] + "Cancel" + i] || a[r[c] + "CancelRequest" + i]);
        if (!l || !s) {
          var _ = 0,
            u = 0,
            d = [];
          (l = function (e) {
            if (0 === d.length) {
              var t = o(),
                n = Math.max(0, 1e3 / 60 - (t - _));
              (_ = n + t),
                setTimeout(function () {
                  var e = d.slice(0);
                  d.length = 0;
                  for (var t = 0; t < e.length; t++)
                    if (!e[t].cancelled)
                      try {
                        e[t].callback(_);
                      } catch (n) {
                        setTimeout(function () {
                          throw n;
                        }, 0);
                      }
                }, Math.round(n));
            }
            return d.push({ handle: ++u, callback: e, cancelled: !1 }), u;
          }),
            (s = function (e) {
              for (var t = 0; t < d.length; t++)
                d[t].handle === e && (d[t].cancelled = !0);
            });
        }
        (e.exports = function (e) {
          return l.call(a, e);
        }),
          (e.exports.cancel = function () {
            s.apply(a, arguments);
          }),
          (e.exports.polyfill = function (e) {
            e || (e = a),
              (e.requestAnimationFrame = l),
              (e.cancelAnimationFrame = s);
          });
      }).call(this, n("yLpj"));
    },
    xTuV: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return Z;
      }),
        n.d(t, "b", function () {
          return $;
        }),
        n.d(t, "c", function () {
          return ie;
        });
      var o = n("1OyB"),
        a = n("vuIU"),
        r = n("md7G"),
        i = n("foSv"),
        l = n("JX7q"),
        s = n("Ji7U"),
        c = n("rePB"),
        _ = n("iKuz"),
        u = n.n(_),
        d = n("q1tI"),
        p = n("QH4r"),
        f = n("Gsew"),
        h = n("cKzW"),
        m = n("HcE9"),
        y = n("ub/+"),
        b = n("3vbH"),
        v = n("ce2M"),
        g = n("SBOM"),
        w = n("xk4V"),
        x = n.n(w),
        k = n("8Kt/"),
        O = n.n(k),
        I = n("TSYQ"),
        S = n.n(I),
        j = n("/NQ+"),
        T = (n("e3dM"), n("yWgo")),
        C = n("S5C5"),
        M = n("nPaQ"),
        P = n("tZZE"),
        E = d.createElement;
      function L(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function B(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? L(Object(n), !0).forEach(function (t) {
                Object(c.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : L(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var N = {
        "./style.css": {
          "hero-vertical-card": "style__hero-vertical-card___2B64y",
          "card-wrapper": "style__card-wrapper___3yqfZ",
          "eyebrow-text": "style__eyebrow-text___1gRhT",
          headline: "style__headline___1ripS",
          subhead: "style__subhead___qRMqE",
          "vertical-top-align": "style__vertical-top-align___3w7Dp",
          "vertical-center-align": "style__vertical-center-align___3RP93",
          "vertical-bottom-align": "style__vertical-bottom-align___1f7Y3",
          "horizontal-left-align": "style__horizontal-left-align___3tk_z",
          "horizontal-center-align": "style__horizontal-center-align___YtBVc",
          eyebrow: "style__eyebrow___3m_hp",
          description: "style__description___2V1Q7",
          note: "style__note___3_j8s",
          "icon-pic": "style__icon-pic___1SGsP",
          "topping-img": "style__topping-img___1J_U3",
          "icon-row-container": "style__icon-row-container___3A3EC",
          "icon-item": "style__icon-item___UZU5k",
          horizontal: "style__horizontal___2rPj4",
          "icon-number-container": "style__icon-number-container___2cK9V",
          "buttons-container": "style__buttons-container___2Vw5K",
          divider: "style__divider___G4nDm",
          "horizontal-right-align": "style__horizontal-right-align___1i25L",
          "card-container": "style__card-container___KPQkl",
          "size-xxs": "style__size-xxs___22TZb",
          "connect-pic": "style__connect-pic___26ccD",
          link: "style__link___1IIwB",
          "links-container": "style__links-container___D4Ibd",
          "icons-container": "style__icons-container___1CoW-",
          "icon-col-container": "style__icon-col-container___2pohI",
          "icon-number": "style__icon-number___2OOlV",
          "icon-unit": "style__icon-unit___2hz_k",
          "icon-title": "style__icon-title___2ZaL_",
          "icon-desc": "style__icon-desc___Otw9j",
          "size-xs": "style__size-xs___BV21_",
          "size-s": "style__size-s___--zS-",
          "size-m": "style__size-m___QlNqG",
          "size-l": "style__size-l___2n_6X",
          "size-xl": "style__size-xl___30LZE",
          "size-xxl": "style__size-xxl___xhAlV",
          "size-xxxl": "style__size-xxxl___36o2G",
          "size-xxxxl": "style__size-xxxxl___3ItPZ",
          "size-xxxxxl": "style__size-xxxxxl___3-JTI",
          "video-content": "style__video-content___R99ab",
          "parallax-fore-video": "style__parallax-fore-video___3KBns",
          "fore-controller-video-poster-bg":
            "style__fore-controller-video-poster-bg___3pLX6",
          "image-content": "style__image-content___UYyC1",
          "video-buttom": "style__video-buttom___1zeaz",
          "replay-buttom": "style__replay-buttom___35dZ3",
          "play-buttom": "style__play-buttom___3K-Xo",
          "pause-buttom": "style__pause-buttom___1mLag",
          dark: "style__dark___3nSM1",
          "fore-image": "style__fore-image___1Qau6",
          "parallax-fore-pic": "style__parallax-fore-pic___3wdiE",
          "headline-pic": "style__headline-pic___2WrWy",
          "eyebrow-pic": "style__eyebrow-pic___3VeeB",
          "headline-text": "style__headline-text___1tW5r",
          "visual-hidden": "style__visual-hidden___32pnD",
          "divider-container": "style__divider-container___2u5xw",
          "button-wrapper": "style__button-wrapper___3Lzku",
          "button-inner": "style__button-inner___3_kJl",
          "button-link": "style__button-link___1kepz",
          "button-video-play": "style__button-video-play___Ye-JI",
          "video-play": "style__video-play___3eLhN",
          "video-play-light": "style__video-play-light___1yGfi",
          "video-play-dark": "style__video-play-dark___3EK_y",
          "download-buttons-container":
            "style__download-buttons-container___M5rzS",
          download: "style__download___3GbaI",
          "download-google-play": "style__download-google-play___1rP3M",
          "image-text": "style__image-text___7HoYo",
          "text-image": "style__text-image___12_xF",
          part: "style__part___15TtD",
          left: "style__left___hVVQM",
          right: "style__right___1ZAB_",
          "background-video": "style__background-video___EQUNk",
          "video-mask": "style__video-mask___2p6XD",
          "card-link": "style__card-link___o1KCU",
          "text-content-container": "style__text-content-container___1aLKY",
          "margin-top-48": "style__margin-top-48___r13B3",
          "margin-top-40": "style__margin-top-40___l1nVl",
          "margin-top-32": "style__margin-top-32___27yrJ",
          "margin-top-24": "style__margin-top-24___3BI68",
          "has-media-screen": "style__has-media-screen___3Mu1K",
          "media-screen-1440": "style__media-screen-1440___2do0U",
          "has-content-media-screen": "style__has-content-media-screen___x-GFM",
          "media-screen-1600": "style__media-screen-1600___3XhTE",
        },
      };
      function D(e, t, n) {
        return (
          (t = Object(i.a)(t)),
          Object(r.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(i.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      var z = (function (e) {
          return (
            (e.h1 = "h1"),
            (e.h2 = "h2"),
            (e.h3 = "h3"),
            (e.h4 = "h4"),
            (e.p = "p"),
            e
          );
        })({}),
        A = (function (e) {
          return (
            (e.xxxxxl = "xxxxxl"),
            (e.xxxxl = "xxxxl"),
            (e.xxxl = "xxxl"),
            (e.xxl = "xxl"),
            (e.xl = "xl"),
            (e.l = "l"),
            (e.m = "m"),
            (e.s = "s"),
            (e.xs = "xs"),
            (e.xxs = "xxs"),
            e
          );
        })({}),
        R = (function (e) {
          return (
            (e["top-align"] = "top-align"),
            (e["center-align"] = "center-align"),
            (e["bottom-align"] = "bottom-align"),
            e
          );
        })({}),
        F = (function (e) {
          return (
            (e["left-align"] = "left-align"),
            (e["center-align"] = "center-align"),
            (e["right-align"] = "right-align"),
            e
          );
        })({}),
        V = (function (e) {
          return (e.image = "image"), (e.video = "video"), e;
        })({}),
        H = (function (e) {
          return (e.light = "light"), (e.dark = "dark"), e;
        })({}),
        W = (function (e) {
          return (
            (e.repeat = "repeat"),
            (e.once = "once"),
            (e.every = "every"),
            (e.withController = "withController"),
            e
          );
        })({}),
        U = (function (e) {
          return (
            (e["image-text"] = "image-text"),
            (e["text-image"] = "text-image"),
            e
          );
        })({}),
        G = (function (e) {
          return (
            (e["auto-fit"] = "auto-fit"), (e["custom-css"] = "custom-css"), e
          );
        })({}),
        Y = (function (e) {
          return (
            (e.repeat = "repeat"),
            (e["repeat-x"] = "repeat-x"),
            (e["repeat-y"] = "repeat-y"),
            (e["no-repeat"] = "no-repeat"),
            e
          );
        })({}),
        q = (function (e) {
          return (
            (e.svg = "svg"),
            (e["pure-text"] = "pure-text"),
            (e["gradient-text"] = "gradient-text"),
            e
          );
        })({}),
        X = (function (e) {
          return (
            (e.svg = "svg"),
            (e["pure-text"] = "pure-text"),
            (e["gradient-text"] = "gradient-text"),
            e
          );
        })({}),
        Z = (function (e) {
          return (
            (e.button = "button"),
            (e["external-button"] = "external-button"),
            (e["store-button"] = "store-button"),
            (e["video-play"] = "video-play"),
            (e.salesPointPop = "salesPointPop"),
            e
          );
        })({}),
        K = (function (e) {
          return (
            (e.dark = "dark"), (e.light = "light"), (e.primary = "primary"), e
          );
        })({}),
        Q = (function (e) {
          return (
            (e["x-large"] = "x-large"),
            (e.large = "large"),
            (e.medium = "medium"),
            (e.small = "small"),
            e
          );
        })({}),
        J = (function (e) {
          return (
            (e.black = "black"),
            (e.white = "white"),
            (e.dark = "dark"),
            (e.normal = "normal"),
            e
          );
        })({}),
        $ = (function (e) {
          return (
            (e.button = "button"),
            (e["external-button"] = "external-button"),
            (e["store-button"] = "store-button"),
            (e["video-play"] = "video-play"),
            (e.salesPointPop = "salesPointPop"),
            (e["internal-link"] = "internal-link"),
            (e["external-link"] = "external-link"),
            (e["download-link"] = "download-link"),
            (e["no-icon-link"] = "no-icon-link"),
            e
          );
        })({}),
        ee = (function (e) {
          return (
            (e["secondary-dark"] = "secondary-dark"),
            (e["secondary-light"] = "secondary-light"),
            e
          );
        })({}),
        te = (function (e) {
          return (
            (e["x-large"] = "x-large"),
            (e.large = "large"),
            (e.medium = "medium"),
            (e.small = "small"),
            e
          );
        })({}),
        ne = (function (e) {
          return (
            (e["internal-link"] = "internal-link"),
            (e["external-link"] = "external-link"),
            (e["download-link"] = "download-link"),
            (e["no-icon-link"] = "no-icon-link"),
            e
          );
        })({}),
        oe = (function (e) {
          return (
            (e["image-text"] = "image-text"),
            (e["text-image"] = "text-image"),
            (e.horizontal = "horizontal"),
            e
          );
        })({}),
        ae = (function (e) {
          return (e.internal = "internal"), (e.external = "external"), e;
        })({}),
        re = (function (e) {
          return (
            (e["whole-item"] = "whole-item"),
            (e["inner-content"] = "inner-content"),
            e
          );
        })({}),
        ie = (function (e) {
          function t(e) {
            var n;
            return (
              Object(o.default)(this, t),
              (n = D(this, t, [e])),
              Object(c.a)(Object(l.a)(n), "cardInnerContent", void 0),
              Object(c.a)(Object(l.a)(n), "cardLink", void 0),
              (n.state = { hovering: !1 }),
              (n.cardLink =
                (e.hasBackgroundImage && e.backgroundImage) ||
                (e.hasBackgroundVideo &&
                  (e.backgroundVideoWebm || e.backgroundVideo))
                  ? Object(M.a)(e)
                  : void 0),
              (n.handleCardClick = n.handleCardClick.bind(Object(l.a)(n))),
              (n.cardInnerContent = n.renderCardInnerContent()),
              n
            );
          }
          return (
            Object(s.a)(t, e),
            Object(a.default)(t, [
              { key: "componentDidMount", value: function () {} },
              {
                key: "handleHotZoneClick",
                value: function (e, t) {
                  Object(P.b)(e, t, "media-modal-container");
                },
              },
              {
                key: "handleCardClick",
                value: function (e) {
                  var t = this.props,
                    n = t.cardLink,
                    o = t.jumpType;
                  if (e && e.target) {
                    var a = e.target;
                    if (
                      !a.nodeName ||
                      ("A" !== a.nodeName &&
                        "BUTTON" !== a.nodeName &&
                        !a.className.includes("media-modal-container") &&
                        !a.getAttribute("data-link"))
                    ) {
                      for (; a.offsetParent; )
                        if (
                          "A" === (a = a.offsetParent).nodeName ||
                          "BUTTON" === a.nodeName ||
                          a.className.includes("media-modal-container") ||
                          a.getAttribute("data-link")
                        )
                          return;
                      n &&
                        (o === ae.external
                          ? window.open(n)
                          : (window.location.href = n));
                    }
                  }
                },
              },
              {
                key: "handleInnerClick",
                value: function (e, t) {
                  Object(P.b)(e, t, "media-modal-container");
                },
              },
              {
                key: "renderCardInnerContent",
                value: function () {
                  var e,
                    t,
                    n,
                    o = this,
                    a = this.props,
                    r = "vertical-".concat(a.cardVerticalAlign),
                    i = "horizontal-".concat(a.cardHorizonalAlign),
                    l = "size-".concat(a.cardContentSize),
                    s = a.visibleByDefault,
                    c = a.localization,
                    _ = a.getFadeTransiation(),
                    d = a.getMediaTransiation(),
                    w = Object(T.h)(),
                    k = Object(M.a)(a),
                    I = {
                      minHeight: a.cardMinHeight,
                      paddingTop: a.paddingTop,
                      paddingBottom: a.paddingBottom,
                      paddingLeft: a.paddingLeft,
                      paddingRight: a.paddingRight,
                    },
                    P =
                      a.headlineSvgShowFirst || a.eyeBrowSvgShowFirst
                        ? E(
                            O.a,
                            null,
                            a.headlineSvgShowFirst &&
                              a.headlineSVG &&
                              E("link", {
                                rel: "preload",
                                href: a.headlineSVG,
                                as: "image",
                                type: "image/svg+xml",
                              }),
                            a.eyeBrowSvgShowFirst &&
                              a.eyeBrowSVG &&
                              E("link", {
                                rel: "preload",
                                href: a.eyeBrowSVG,
                                as: "image",
                                type: "image/svg+xml",
                              }),
                          )
                        : null,
                    L = function (e, t, n, o, r) {
                      var i = m.b.normal,
                        l = r ? "".concat(r, "-") : e;
                      switch (t) {
                        case "internal-link":
                          (i = m.b.more), (l = "".concat(l, "in"));
                          break;
                        case "external-link":
                          (i = m.b.external), (l = "".concat(l, "out"));
                          break;
                        case "download-link":
                          (i = m.b.download), (l = "".concat(l, "download"));
                          break;
                        case "no-icon-link":
                          (i = m.b.normal), (l = "".concat(l, "normal"));
                          break;
                        default:
                          (i = m.b.more), (l = "".concat(l, "in"));
                      }
                      var s = m.a[a.linkColor],
                        c = {
                          fontSize: a.linkFontSize || "16px",
                          lineHeight: Object(y.a)(
                            a.linkFontSize,
                            a.linkLineHeight,
                          ),
                        },
                        u = "text-ms-".concat(
                          Object(T.mb)(a.linkFontSize || "16px"),
                        );
                      return E(
                        "div",
                        {
                          className: "style__link___1IIwB",
                          key: n,
                          "data-aos": _,
                          "data-aos-once": !0,
                          "data-ga-label": l,
                        },
                        E(
                          m.c,
                          {
                            theme: s,
                            type: i,
                            style: c,
                            href: o,
                            className: u,
                          },
                          E("span", {
                            "data-link": "true",
                            dangerouslySetInnerHTML: { __html: n || "" },
                          }),
                        ),
                      );
                    },
                    D = function (e, t, n, o, r, i, l, s) {
                      var d = o ? p.b[o] : p.b.primary,
                        m = r ? p.a[r] : p.a.large,
                        y = !1,
                        b = !1;
                      (e !== Z["video-play"] && e !== $["video-play"]) ||
                        (y = !0),
                        (e !== Z.salesPointPop && e !== $.salesPointPop) ||
                          (b = !0);
                      var v = "";
                      if (l) v = l;
                      else
                        switch (e) {
                          case Z.button:
                          case Z.salesPointPop:
                            v = "card-".concat(a.index, "-first-button");
                            break;
                          case $.button:
                          case $.salesPointPop:
                            v = "card-".concat(a.index, "-second-button");
                            break;
                          case Z["store-button"]:
                            v = "card-".concat(a.index, "-first-button");
                            break;
                          case $["store-button"]:
                            v = "card-".concat(a.index, "-second-button");
                            break;
                          case Z["external-button"]:
                            v = "card-".concat(a.index, "-first-button");
                            break;
                          case $["external-button"]:
                            v = "card-".concat(a.index, "-second-button");
                            break;
                          case Z["video-play"]:
                            v = "card-".concat(a.index, "-first-video");
                            break;
                          case $["video-play"]:
                            v = "card-".concat(a.index, "-second-video");
                            break;
                          default:
                            v = "card-".concat(a.index, "-first-button");
                        }
                      if (
                        e === Z.button ||
                        e === $.button ||
                        e === Z["external-button"] ||
                        e === $["external-button"]
                      )
                        return E(
                          "div",
                          {
                            style: { minWidth: i },
                            className: "style__button-wrapper___3Lzku",
                            "data-aos": _,
                            "data-aos-once": !0,
                          },
                          E(
                            "div",
                            {
                              style: { width: "100%", display: "inline-flex" },
                              "data-ga-label": v,
                            },
                            E(
                              p.c,
                              {
                                size: m,
                                href: n,
                                target:
                                  e === Z["external-button"] ||
                                  e === $["external-button"]
                                    ? "_blank"
                                    : "_self",
                                style: { borderRadius: "60px", width: "100%" },
                                type: d,
                              },
                              E("div", {
                                className: "style__button-inner___3_kJl",
                                dangerouslySetInnerHTML: { __html: t || "" },
                              }),
                            ),
                          ),
                        );
                      if (
                        e === Z.button ||
                        e === $.button ||
                        e === Z["store-button"] ||
                        e === $["store-button"]
                      )
                        return E(
                          "div",
                          {
                            style: { minWidth: i },
                            className: "style__button-wrapper___3Lzku",
                            "data-aos": _,
                            "data-aos-once": !0,
                          },
                          E(
                            "div",
                            {
                              style: { width: "100%", display: "inline-flex" },
                              "data-ga-label": "".concat(v, "-buy-now"),
                            },
                            E(
                              p.c,
                              {
                                size: m,
                                href: Object(C.e)(
                                  Object(C.k)({
                                    url: "/where-to-buy",
                                    country:
                                      null === c || void 0 === c
                                        ? void 0
                                        : c.country,
                                    locale:
                                      null === c || void 0 === c
                                        ? void 0
                                        : c.language,
                                  }),
                                  n,
                                  null === c || void 0 === c
                                    ? void 0
                                    : c.country,
                                ),
                                target:
                                  e === Z["store-button"] ||
                                  e === $["store-button"]
                                    ? "_blank"
                                    : "_self",
                                style: { borderRadius: "60px", width: "100%" },
                                type: d,
                              },
                              E("div", {
                                className: "style__button-inner___3_kJl",
                                dangerouslySetInnerHTML: { __html: t || "" },
                              }),
                            ),
                          ),
                        );
                      if (y) {
                        var g = "video-play-light";
                        return (
                          ("dark" !== o &&
                            "primary" !== o &&
                            "secondary-light" !== o) ||
                            (g = "video-play-dark"),
                          E(
                            "div",
                            {
                              style: { minWidth: i },
                              className: "style__button-wrapper___3Lzku",
                              "data-aos-once": !0,
                              "data-aos": _,
                            },
                            E(
                              "div",
                              {
                                style: {
                                  width: "100%",
                                  display: "inline-flex",
                                },
                                "data-ga-label": v,
                              },
                              E(
                                h.a,
                                { link: n, style: { width: "100%" } },
                                E(
                                  p.c,
                                  {
                                    size: m,
                                    style: {
                                      borderRadius: "60px",
                                      minWidth: i,
                                    },
                                    type: d,
                                  },
                                  E(
                                    "div",
                                    {
                                      className: u()(
                                        "button-inner button-video-play ".concat(
                                          g,
                                        ),
                                        N,
                                        {
                                          autoResolveMultipleImports: !0,
                                          handleMissingStyleName: "warn",
                                        },
                                      ),
                                    },
                                    E("span", {
                                      dangerouslySetInnerHTML: {
                                        __html: t || "",
                                      },
                                    }),
                                    E("div", {
                                      className: "style__video-play___3eLhN",
                                    }),
                                  ),
                                ),
                              ),
                            ),
                          )
                        );
                      }
                      return b
                        ? ((d = (o = o.replace("secondary-", ""))
                            ? p.b["tertiary-".concat(o)]
                            : p.b.tertiary),
                          E(
                            "div",
                            {
                              style: { minWidth: i },
                              className: "style__button-wrapper___3Lzku",
                              "data-aos": _,
                              "data-aos-once": !0,
                            },
                            E(
                              "div",
                              {
                                style: {
                                  width: "100%",
                                  display: "inline-flex",
                                },
                                "data-ga-label": v,
                              },
                              E(
                                p.c,
                                {
                                  size: m,
                                  style: {
                                    borderRadius: "60px",
                                    width: "100%",
                                    border: "1px solid",
                                  },
                                  type: d,
                                  id: s && "salePoint-Modal-Type-".concat(s),
                                },
                                E("div", {
                                  className: "style__button-inner___3_kJl",
                                  dangerouslySetInnerHTML: { __html: t || "" },
                                }),
                                E(f.a, {
                                  weight: "light",
                                  name: "plus-circle",
                                }),
                              ),
                            ),
                          ))
                        : L("card-".concat(a.index, "-second-link-"), e, t, n);
                    },
                    A = function (e, t, n, o) {
                      return E(
                        "div",
                        {
                          className: "style__icon-row-container___3A3EC",
                          key: x()(),
                        },
                        e.map(function (e) {
                          var a =
                              e.hasNumber || e.hasUnit
                                ? E(
                                    "div",
                                    {
                                      className:
                                        "style__icon-number-container___2cK9V",
                                    },
                                    e.hasNumber
                                      ? E("span", {
                                          key: "number",
                                          className:
                                            "style__icon-number___2OOlV",
                                          style: { color: e.titleColor },
                                          dangerouslySetInnerHTML: {
                                            __html: e.number || "",
                                          },
                                        })
                                      : null,
                                    e.hasUnit
                                      ? E("span", {
                                          key: "unit",
                                          className: "style__icon-unit___2hz_k",
                                          style: { color: e.titleColor },
                                          dangerouslySetInnerHTML: {
                                            __html: e.unit || "",
                                          },
                                        })
                                      : null,
                                  )
                                : null,
                            r = {
                              color: e.titleColor,
                              fontWeight:
                                e.titleFontWeight && y.c[e.titleFontWeight]
                                  ? y.c[e.titleFontWeight]
                                  : void 0,
                              fontSize: e.titleFontSize,
                              lineHeight: Object(y.a)(
                                e.titleFontSize,
                                e.titleLineHeight,
                              ),
                            },
                            i = {
                              color: e.descColor,
                              fontWeight:
                                e.descFontWeight && y.c[e.descFontWeight]
                                  ? y.c[e.descFontWeight]
                                  : void 0,
                              fontSize: e.descFontSize,
                              lineHeight: Object(y.a)(
                                e.descFontSize,
                                e.descLineHeight,
                              ),
                            },
                            l = Object(T.kb)(
                              e.titleFontSize,
                              "text-ms-".concat(Object(T.mb)(e.titleFontSize)),
                              "",
                            ),
                            c = Object(T.kb)(
                              e.descFontSize,
                              "text-ms-".concat(Object(T.mb)(e.descFontSize)),
                              "",
                            ),
                            d =
                              e.iconAlt ||
                              (e.hasTitle && e.title) ||
                              (e.hasDesc && e.desc) ||
                              "",
                            p =
                              e.hasIcon && e.icon
                                ? E(g.a, {
                                    alt: Object(T.w)(d),
                                    className: "style__icon-pic___1SGsP",
                                    visibleByDefault: s,
                                    key: "icon",
                                    type: "img",
                                    src: e.icon,
                                    style: { height: n },
                                  })
                                : null,
                            f = e.hasTitle
                              ? E("p", {
                                  key: "title",
                                  className:
                                    (l ? l + " " : "") +
                                    "style__icon-title___2ZaL_",
                                  style: r,
                                  dangerouslySetInnerHTML: {
                                    __html: e.title || "",
                                  },
                                })
                              : null,
                            h = e.hasDesc
                              ? E("p", {
                                  key: "desc",
                                  className:
                                    (c ? c + " " : "") +
                                    "style__icon-desc___Otw9j",
                                  style: i,
                                  dangerouslySetInnerHTML: {
                                    __html: e.desc || "",
                                  },
                                })
                              : null;
                          return E(
                            "div",
                            {
                              "data-aos": _,
                              "data-aos-once": !0,
                              key: x()(),
                              className: "style__icon-col-container___2pohI",
                            },
                            E(
                              "div",
                              {
                                style: {
                                  maxWidth: t === oe.horizontal ? o : "none",
                                },
                                className: u()("icon-item ".concat(t), N, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                              },
                              (function () {
                                switch (t) {
                                  case oe["image-text"]:
                                    return [a, p, f, h];
                                  case oe["text-image"]:
                                    return [f, h, a, p];
                                  case oe.horizontal:
                                    return [
                                      E(
                                        "div",
                                        {
                                          className:
                                            "style__left___hVVQM style__part___15TtD",
                                          key: "left",
                                        },
                                        a,
                                        p,
                                      ),
                                      E(
                                        "div",
                                        {
                                          className:
                                            "style__right___1ZAB_ style__part___15TtD",
                                          key: "right",
                                        },
                                        f,
                                        h,
                                      ),
                                    ];
                                  default:
                                    return [a, p, f, h];
                                }
                              })(),
                            ),
                          );
                        }),
                      );
                    },
                    R = a.hasEyeBrow
                      ? (function () {
                          var e = "eyebrow ".concat(
                            a.hasToppingImage ? "connect-pic" : "",
                          );
                          if (a.eyeBrowType === q.svg) {
                            var t = E("h1", {
                              className: "style__visual-hidden___32pnD",
                              dangerouslySetInnerHTML: {
                                __html: a.eyeBrowText || "",
                              },
                            });
                            if (a.eyeBrowTag)
                              t = E(y.e, {
                                tagType: a.eyeBrowTag,
                                className: "style__visual-hidden___32pnD",
                                dangerouslySetInnerHTML: {
                                  __html: a.eyeBrowText || "",
                                },
                              });
                            else
                              switch (a.cardHeadlineSize) {
                                case z.h1:
                                  t = E("h1", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.eyeBrowText || "",
                                    },
                                  });
                                  break;
                                case z.h2:
                                  t = E("h2", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.eyeBrowText || "",
                                    },
                                  });
                                  break;
                                case z.h3:
                                  t = E("h3", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.eyeBrowText || "",
                                    },
                                  });
                                  break;
                                case z.h4:
                                  t = E("h4", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.eyeBrowText || "",
                                    },
                                  });
                                  break;
                                case z.p:
                                  t = E("p", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.eyeBrowText || "",
                                    },
                                  });
                                  break;
                                default:
                                  t = E("h1", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.eyeBrowText || "",
                                    },
                                  });
                              }
                            return [
                              E("img", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                alt: Object(T.w)(a.eyeBrowText) || "",
                                src: a.eyeBrowSVG,
                                style: { height: a.eyeBrowSVGHeight },
                                className: u()("eyebrow-pic ".concat(e), N, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                              }),
                              t,
                            ];
                          }
                          var n = {
                            fontWeight:
                              a.eyeBrowFontWeight && y.c[a.eyeBrowFontWeight]
                                ? y.c[a.eyeBrowFontWeight]
                                : void 0,
                            fontSize: a.eyeBrowFontSize,
                            lineHeight: Object(y.a)(
                              a.eyeBrowFontSize,
                              a.eyeBrowLineHeight,
                            ),
                          };
                          a.eyeBrowType === q["pure-text"]
                            ? (n.color = a.eyeBrowPureColor)
                            : w
                              ? (n.color = a.eyeBrowIEGradientColor)
                              : ((n.color = "transparent"),
                                (n.backgroundImage = a.eyeBrowGradientColor),
                                (n.WebkitBackgroundClip = "text"),
                                (n.paddingBottom = "0.1em"),
                                (n.marginBottom = "-0.1em")),
                            (n.maxWidth = a.eyeBrowMaxWidth);
                          var o = S()("eyebrow-text", "".concat(e)),
                            r = Object(T.kb)(
                              a.eyeBrowFontSize,
                              "text-ms-".concat(
                                Object(T.mb)(a.eyeBrowFontSize),
                              ),
                              "",
                            );
                          if (a.eyeBrowTag)
                            return E(y.e, {
                              tagType: a.eyeBrowTag,
                              "data-aos": _,
                              "data-aos-once": !0,
                              style: n,
                              dangerouslySetInnerHTML: {
                                __html: a.eyeBrowText || "",
                              },
                              className:
                                (r ? r + " " : "") +
                                u()(o, N, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            });
                          switch (a.cardHeadlineSize) {
                            case z.h1:
                              return E("h1", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: n,
                                dangerouslySetInnerHTML: {
                                  __html: a.eyeBrowText || "",
                                },
                                className:
                                  (r ? r + " " : "") +
                                  u()(o, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h2:
                              return E("h2", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: n,
                                dangerouslySetInnerHTML: {
                                  __html: a.eyeBrowText || "",
                                },
                                className:
                                  (r ? r + " " : "") +
                                  u()(o, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h3:
                              return E("h3", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: n,
                                dangerouslySetInnerHTML: {
                                  __html: a.eyeBrowText || "",
                                },
                                className:
                                  (r ? r + " " : "") +
                                  u()(o, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h4:
                              return E("h4", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: n,
                                dangerouslySetInnerHTML: {
                                  __html: a.eyeBrowText || "",
                                },
                                className:
                                  (r ? r + " " : "") +
                                  u()(o, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.p:
                              return E("p", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: n,
                                dangerouslySetInnerHTML: {
                                  __html: a.eyeBrowText || "",
                                },
                                className:
                                  (r ? r + " " : "") +
                                  u()(o, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            default:
                              return E("h1", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: n,
                                dangerouslySetInnerHTML: {
                                  __html: a.eyeBrowText || "",
                                },
                                className:
                                  (r ? r + " " : "") +
                                  u()(o, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                          }
                        })()
                      : null,
                    F = a.hasHeadline
                      ? (function () {
                          var e = a.hasToppingImage && !a.hasEyeBrow,
                            t = a.hasEyeBrow && a.eyeBrowType === q.svg,
                            n = "headline ".concat(e || t ? "connect-pic" : ""),
                            o = a.cardHeadlineSize;
                          if (a.hasEyeBrow)
                            switch (a.cardHeadlineSize) {
                              case z.h1:
                                o = z.h2;
                                break;
                              case z.h2:
                                o = z.h3;
                                break;
                              case z.h3:
                                o = z.h4;
                                break;
                              case z.p:
                                o = z.p;
                                break;
                              default:
                                o = z.h4;
                            }
                          if (a.headlineType === X.svg) {
                            var r = E("h2", {
                              className: "style__visual-hidden___32pnD",
                              dangerouslySetInnerHTML: {
                                __html: a.headlineText || "",
                              },
                            });
                            if (a.headlineTag)
                              r = E(y.e, {
                                tagType: a.headlineTag,
                                className: "style__visual-hidden___32pnD",
                                dangerouslySetInnerHTML: {
                                  __html: a.headlineText || "",
                                },
                              });
                            else
                              switch (o) {
                                case z.h1:
                                  r = E("h1", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.headlineText || "",
                                    },
                                  });
                                  break;
                                case z.h2:
                                  r = E("h2", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.headlineText || "",
                                    },
                                  });
                                  break;
                                case z.h3:
                                  r = E("h3", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.headlineText || "",
                                    },
                                  });
                                  break;
                                case z.h4:
                                  r = E("h4", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.headlineText || "",
                                    },
                                  });
                                  break;
                                case z.p:
                                  r = E("p", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.headlineText || "",
                                    },
                                  });
                                  break;
                                default:
                                  r = E("h2", {
                                    className: "style__visual-hidden___32pnD",
                                    dangerouslySetInnerHTML: {
                                      __html: a.headlineText || "",
                                    },
                                  });
                              }
                            return [
                              a.headlineSVG
                                ? E("img", {
                                    "data-aos": _,
                                    "data-aos-once": !0,
                                    src: a.headlineSVG,
                                    style: { height: a.headlineSVGHeight },
                                    alt: Object(T.w)(a.headlineText) || "",
                                    className: u()(
                                      "".concat(n, " headline-pic"),
                                      N,
                                      {
                                        autoResolveMultipleImports: !0,
                                        handleMissingStyleName: "warn",
                                      },
                                    ),
                                  })
                                : null,
                              r,
                            ];
                          }
                          var i = {
                            fontWeight:
                              a.headlineFontWeight && y.c[a.headlineFontWeight]
                                ? y.c[a.headlineFontWeight]
                                : void 0,
                            fontSize: a.headlineFontSize,
                            lineHeight: Object(y.a)(
                              a.headlineFontSize,
                              a.headlineLineHeight,
                            ),
                          };
                          a.headlineType === X["pure-text"]
                            ? (i.color = a.headlinePureColor)
                            : w
                              ? (i.color = a.headlineIEGradientColor)
                              : ((i.backgroundImage = a.headlineGradientColor),
                                (i.WebkitBackgroundClip = "text"),
                                (i.color = "transparent"),
                                (i.paddingBottom = "0.1em"),
                                (i.marginBottom = "-0.1em")),
                            (i.maxWidth = a.headlineMaxWidth);
                          var l = S()("".concat(n), "headline-text"),
                            s = Object(T.kb)(
                              a.headlineFontSize,
                              "text-ms-".concat(
                                Object(T.mb)(a.headlineFontSize),
                              ),
                              "",
                            );
                          if (a.headlineTag)
                            return E(y.e, {
                              tagType: a.headlineTag,
                              "data-aos": _,
                              "data-aos-once": !0,
                              style: i,
                              dangerouslySetInnerHTML: {
                                __html: a.headlineText || "",
                              },
                              className:
                                (s ? s + " " : "") +
                                u()(l, N, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            });
                          switch (o) {
                            case z.h1:
                              return E("h1", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: i,
                                dangerouslySetInnerHTML: {
                                  __html: a.headlineText || "",
                                },
                                className:
                                  (s ? s + " " : "") +
                                  u()(l, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h2:
                              return E("h2", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: i,
                                dangerouslySetInnerHTML: {
                                  __html: a.headlineText || "",
                                },
                                className:
                                  (s ? s + " " : "") +
                                  u()(l, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h3:
                              return E("h3", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: i,
                                dangerouslySetInnerHTML: {
                                  __html: a.headlineText || "",
                                },
                                className:
                                  (s ? s + " " : "") +
                                  u()(l, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h4:
                              return E("h4", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: i,
                                dangerouslySetInnerHTML: {
                                  __html: a.headlineText || "",
                                },
                                className:
                                  (s ? s + " " : "") +
                                  u()(l, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.p:
                              return E("p", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: i,
                                dangerouslySetInnerHTML: {
                                  __html: a.headlineText || "",
                                },
                                className:
                                  (s ? s + " " : "") +
                                  u()(l, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            default:
                              return E("h2", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: i,
                                dangerouslySetInnerHTML: {
                                  __html: a.headlineText || "",
                                },
                                className:
                                  (s ? s + " " : "") +
                                  u()(l, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                          }
                        })()
                      : null,
                    H = a.hasSubHeadline
                      ? (function () {
                          var e = {
                            color: a.subHeadlineColor,
                            maxWidth: a.subHeadlineMaxWidth,
                            fontWeight:
                              a.subHeadlineFontWeight &&
                              y.c[a.subHeadlineFontWeight]
                                ? y.c[a.subHeadlineFontWeight]
                                : void 0,
                            fontSize: a.subHeadlineFontSize,
                            lineHeight: Object(y.a)(
                              a.subHeadlineFontSize,
                              a.subHeadlineLineHeight,
                            ),
                          };
                          a.subHeadlineType === X["gradient-text"]
                            ? w
                              ? (e.color = a.subHeadlineIEGradientColor)
                              : ((e.backgroundImage =
                                  a.subHeadlineGradientColor),
                                (e.WebkitBackgroundClip = "text"),
                                (e.color = "transparent"),
                                (e.paddingBottom = "0.1em"),
                                (e.marginBottom = "-0.1em"))
                            : (e.color = a.subHeadlineColor);
                          var t = S()("subhead"),
                            n = Object(T.kb)(
                              a.subHeadlineFontSize,
                              "text-ms-".concat(
                                Object(T.mb)(a.subHeadlineFontSize),
                              ),
                              "",
                            );
                          if (a.subHeadlineTag)
                            return E(y.e, {
                              tagType: a.subHeadlineTag,
                              "data-aos": _,
                              "data-aos-once": !0,
                              style: e,
                              dangerouslySetInnerHTML: {
                                __html: a.subHeadlineText || "",
                              },
                              className:
                                (n ? n + " " : "") +
                                u()(t, N, {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                }),
                            });
                          switch (a.cardHeadlineSize) {
                            case z.h1:
                              return E("h2", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: e,
                                dangerouslySetInnerHTML: {
                                  __html: a.subHeadlineText || "",
                                },
                                className:
                                  (n ? n + " " : "") +
                                  u()(t, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h2:
                              return E("h3", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: e,
                                dangerouslySetInnerHTML: {
                                  __html: a.subHeadlineText || "",
                                },
                                className:
                                  (n ? n + " " : "") +
                                  u()(t, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.h3:
                              return E("h4", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: e,
                                dangerouslySetInnerHTML: {
                                  __html: a.subHeadlineText || "",
                                },
                                className:
                                  (n ? n + " " : "") +
                                  u()(t, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            case z.p:
                              return E("p", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: e,
                                dangerouslySetInnerHTML: {
                                  __html: a.subHeadlineText || "",
                                },
                                className:
                                  (n ? n + " " : "") +
                                  u()(t, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                            default:
                              return E("h5", {
                                "data-aos": _,
                                "data-aos-once": !0,
                                style: e,
                                dangerouslySetInnerHTML: {
                                  __html: a.subHeadlineText || "",
                                },
                                className:
                                  (n ? n + " " : "") +
                                  u()(t, N, {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  }),
                              });
                          }
                        })()
                      : null,
                    G = a.hasDividedLine
                      ? (function () {
                          var e = {
                            height: a.dividedLineHeight,
                            borderRadius: a.dividedLineRadius,
                            width: a.dividedLineWidth,
                            backgroundColor: a.dividedLineColor,
                            backgroundImage: a.dividedLineGradientColor,
                          };
                          return E(
                            "div",
                            {
                              "data-aos": _,
                              "data-aos-once": !0,
                              className: "style__divider-container___2u5xw",
                              style: { height: a.dividedBlockHeight },
                            },
                            E("div", {
                              className: "style__divider___G4nDm",
                              style: e,
                            }),
                          );
                        })()
                      : null,
                    Y =
                      a.hasPrimaryButton || a.hasSecondaryButton
                        ? E(
                            "div",
                            { className: "style__buttons-container___2Vw5K" },
                            a.hasPrimaryButton
                              ? D(
                                  a.primaryButtonType,
                                  a.primaryButtonText,
                                  a.primaryButtonLink,
                                  a.primaryButtonColor,
                                  a.primaryButtonSize,
                                  a.primaryButtonMinWidth,
                                  a.primaryButtonGaLabel,
                                  a.primaryButtonModalID,
                                )
                              : null,
                            a.hasSecondaryButton
                              ? D(
                                  a.secondaryButtonType,
                                  a.secondaryButtonText,
                                  a.secondaryButtonLink,
                                  a.secondaryButtonColor,
                                  a.secondaryButtonSize,
                                  a.secondaryButtonMinWidth,
                                  a.secondaryButtonGaLabel,
                                  a.secondaryButtonModalID,
                                )
                              : null,
                          )
                        : null,
                    K = a.hasLinks
                      ? E(
                          "div",
                          { className: "style__links-container___D4Ibd" },
                          a.links.map(function (e, t) {
                            var n = "card-"
                              .concat(a.index, "-link-")
                              .concat(t, "-link-");
                            return L(
                              n,
                              e.linkType,
                              e.linkText,
                              e.linkUrl,
                              e.linkGaLabel,
                            );
                          }),
                        )
                      : null,
                    Q = a.hasDownloadButton
                      ? (function () {
                          var e = a.hasAppStoreButton
                              ? E(
                                  "a",
                                  {
                                    "data-aos": _,
                                    "data-aos-once": !0,
                                    href: a.appStoreButtonLink,
                                    className: "style__download___3GbaI",
                                    key: "appstore",
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    "data-ga-label": a.appStoreButtonGaLabel
                                      ? a.appStoreButtonGaLabel
                                      : "card-".concat(
                                          a.index,
                                          "-download-app",
                                        ),
                                  },
                                  E("img", {
                                    src: "https://www1.djicdn.com/dps/d8962a855592fbdcfd989cb52866de8f.svg",
                                    alt: "",
                                  }),
                                )
                              : null,
                            t = a.hasGooglePlayButton
                              ? E(
                                  "a",
                                  {
                                    "data-aos": _,
                                    "data-aos-once": !0,
                                    href: a.googlePlayButtonLink,
                                    className:
                                      "style__download___3GbaI style__download-google-play___1rP3M",
                                    key: "googleplay",
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    "data-ga-label": a.googlePlayButtonGaLabel
                                      ? a.googlePlayButtonGaLabel
                                      : "card-".concat(
                                          a.index,
                                          "-download-google",
                                        ),
                                  },
                                  E("img", {
                                    src: "https://www1.djicdn.com/dps/4f1fabc4e78d0217098d38575a06f60a.svg",
                                    alt: "",
                                  }),
                                )
                              : null,
                            n = a.hasAndroidButton
                              ? E(
                                  "a",
                                  {
                                    "data-aos": _,
                                    "data-aos-once": !0,
                                    href: a.androidButtonLink,
                                    className: "style__download___3GbaI",
                                    key: "android",
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    "data-ga-label": a.androidButtonGaLabel
                                      ? a.androidButtonGaLabel
                                      : "card-".concat(
                                          a.index,
                                          "-download-android",
                                        ),
                                  },
                                  E("img", {
                                    src: "https://www1.djicdn.com/dps/e7b4e2a27522cb29c514ffc403fc781b.svg",
                                    alt: "",
                                  }),
                                )
                              : null;
                          return E(
                            "div",
                            {
                              className:
                                "style__download-buttons-container___M5rzS",
                            },
                            [e, n, t],
                          );
                        })()
                      : null,
                    J =
                      !!a.hasModalButton &&
                      E(j.l, {
                        contentType: "F",
                        lightThemeOn: a.modalBtnIsLightTheme,
                        modalContent: {
                          modalBtnContentTopImage: a.modalBtnContentTopImage,
                          modalBtnContentTopImageHeight:
                            a.modalBtnContentTopImageHeight,
                          modalBtnContentList: a.modalBtnContentList,
                          modal_OpenBtnFText: a.modalBtnText,
                        },
                        translateOff: !0,
                        isMobile: !1,
                        containerClassname:
                          "info-card-horizontal-modal-container",
                        contentStyle: { padding: 0 },
                        btnStyle: B(
                          {
                            fontSize: a.modalBtnFontSize || "16px",
                            letterSpacing: "-0.02em",
                            height: a.modalBtnHeight || "40px",
                            display: "inline-flex",
                            alignItems: "center",
                            boxShadow: "none",
                            background: "none",
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            paddingTop: a.modalBtnPaddingY || "8px",
                            paddingBottom: a.modalBtnPaddingY || "8px",
                          },
                          a.modalBtnMarginTop
                            ? { marginTop: a.modalBtnMarginTop }
                            : {},
                        ),
                        gaSend: a.gaSend,
                        gaLabel: a.modalBtnGaLabel,
                      }),
                    ee = {
                      fontWeight:
                        a.noteFontWeight && y.c[a.noteFontWeight]
                          ? y.c[a.noteFontWeight]
                          : void 0,
                      fontSize: a.noteFontSize,
                      lineHeight: Object(y.a)(a.noteFontSize, a.noteLineHeight),
                      color: a.noteColor,
                      marginTop: a.noteMarginTop || void 0,
                    },
                    te = Object(T.kb)(
                      a.noteFontSize,
                      "text-ms-".concat(Object(T.mb)(a.noteFontSize)),
                      "",
                    ),
                    ne = a.hasNote
                      ? E("p", {
                          "data-aos": _,
                          "data-aos-once": !0,
                          className:
                            (te ? te + " " : "") + "style__note___3_j8s",
                          style: ee,
                          dangerouslySetInnerHTML: { __html: a.noteText || "" },
                        })
                      : null,
                    ae = {
                      fontWeight:
                        a.descriptionFontWeight && y.c[a.descriptionFontWeight]
                          ? y.c[a.descriptionFontWeight]
                          : void 0,
                      fontSize: a.descriptionFontSize,
                      lineHeight: Object(y.a)(
                        a.descriptionFontSize,
                        a.descriptionLineHeight,
                      ),
                      color: a.descriptionColor,
                      minHeight: a.descriptionMinHeight,
                      marginTop: a.hasDividedLine ? "0" : "",
                      maxWidth: a.descriptionMaxWidth,
                    },
                    ie = Object(T.kb)(
                      a.descriptionFontSize,
                      "text-ms-".concat(Object(T.mb)(a.descriptionFontSize)),
                      "",
                    ),
                    le = a.hasDescription
                      ? E("p", {
                          "data-aos": _,
                          "data-aos-once": !0,
                          className:
                            (ie ? ie + " " : "") + "style__description___2V1Q7",
                          style: ae,
                          dangerouslySetInnerHTML: {
                            __html: a.descriptionText || "",
                          },
                        })
                      : null,
                    se = a.hasToppingImage
                      ? E(g.a, {
                          visibleByDefault: s,
                          "data-aos": d,
                          "data-aos-once": !0,
                          src: a.toppingImage,
                          alt: a.toppingImage ? Object(T.w)(a.toppingAlt) : "",
                          className: "style__topping-img___1J_U3",
                          style: { height: a.toppingImageHeight },
                          type: "img",
                        })
                      : null,
                    ce = a.hasForeContent
                      ? (function () {
                          var e =
                              a.foregroundHasParallax &&
                              a.foregroundParallax === re["whole-item"],
                            t =
                              a.foregroundHasParallax &&
                              a.foregroundParallax === re["inner-content"],
                            n = E(g.a, {
                              parallax: t,
                              visibleByDefault: s,
                              type: t ? "bg" : "img",
                              src: a.foreImage,
                              alt: Object(T.w)(a.foreImageAlt),
                              className: u()(
                                "fore-image".concat(
                                  t ? " parallax-fore-pic" : "",
                                ),
                                N,
                                {
                                  autoResolveMultipleImports: !0,
                                  handleMissingStyleName: "warn",
                                },
                              ),
                            }),
                            o = E(
                              "div",
                              {
                                className: u()(
                                  "video-content".concat(
                                    t ? " parallax-fore-video" : "",
                                  ),
                                  N,
                                  {
                                    autoResolveMultipleImports: !0,
                                    handleMissingStyleName: "warn",
                                  },
                                ),
                              },
                              a.foreVideoPlay === W.withController
                                ? E("div", {
                                    style: {
                                      backgroundImage: "url(".concat(
                                        a.foreVideoPoster,
                                        ")",
                                      ),
                                    },
                                    className:
                                      "style__fore-controller-video-poster-bg___3pLX6",
                                  })
                                : null,
                              E(
                                "video",
                                {
                                  id: "fore-video-bin",
                                  muted: !0,
                                  "data-layzr-poster": a.foreVideoPoster,
                                  loop: a.foreVideoPlay === W.repeat,
                                },
                                a.foreVideoWebm &&
                                  E("source", {
                                    type: "video/webm",
                                    "data-layzr-src": a.foreVideoWebm,
                                  }),
                                E("source", {
                                  type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                                  "data-layzr-src": a.foreVideo,
                                }),
                              ),
                              t
                                ? null
                                : [
                                    E("div", {
                                      "data-link": "ture",
                                      className:
                                        "replay-button " +
                                        u()(
                                          "video-buttom replay-buttom ".concat(
                                            "dark" === a.foreVideoColor
                                              ? "dark"
                                              : "",
                                          ),
                                          N,
                                          {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          },
                                        ),
                                    }),
                                    E("div", {
                                      "data-link": "ture",
                                      className:
                                        "pause-button " +
                                        u()(
                                          "video-buttom pause-buttom ".concat(
                                            "dark" === a.foreVideoColor
                                              ? "dark"
                                              : "",
                                          ),
                                          N,
                                          {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          },
                                        ),
                                    }),
                                    E("div", {
                                      "data-link": "ture",
                                      className:
                                        "play-button " +
                                        u()(
                                          "video-buttom play-buttom ".concat(
                                            "dark" === a.foreVideoColor
                                              ? "dark"
                                              : "",
                                          ),
                                          N,
                                          {
                                            autoResolveMultipleImports: !0,
                                            handleMissingStyleName: "warn",
                                          },
                                        ),
                                    }),
                                  ],
                            );
                          o = E(
                            b.a,
                            {
                              style: {
                                height: t ? "100%" : "",
                                width: t ? "100%" : "",
                              },
                              replayWhenRevisible:
                                a.foreVideoPlay !== W.once &&
                                a.foreVideoPlay !== W.withController,
                              visiblePlay: a.foreVideoPlay !== W.withController,
                              lazyLoad: !0,
                              lazyLoadThreshold: 2e3,
                              replayClassName:
                                a.foreVideoPlay === W.repeat
                                  ? ""
                                  : "replay-button",
                              pauseClassName:
                                a.foreVideoPlay === W.withController
                                  ? "pause-button"
                                  : "",
                              playClassName:
                                a.foreVideoPlay === W.withController
                                  ? "play-button"
                                  : "",
                              videoLazyLoadDistance: a.videoLazyLoadDistance,
                            },
                            t
                              ? E(
                                  v.a,
                                  {
                                    offset: "-100",
                                    style: {
                                      height: "calc(100% + 100px)",
                                      marginTop: "-100px",
                                    },
                                  },
                                  o,
                                )
                              : o,
                            t
                              ? [
                                  E("div", {
                                    "data-link": "ture",
                                    className:
                                      "replay-button style__video-buttom___1zeaz style__replay-buttom___35dZ3",
                                  }),
                                  E("div", {
                                    "data-link": "ture",
                                    className:
                                      "pause-button style__video-buttom___1zeaz style__pause-buttom___1mLag",
                                  }),
                                  E("div", {
                                    "data-link": "ture",
                                    className:
                                      "play-button style__video-buttom___1zeaz style__play-buttom___3K-Xo",
                                  }),
                                ]
                              : null,
                          );
                          var r = {};
                          (r =
                            "100%" === a.foregroundHeight
                              ? { "align-self": "stretch" }
                              : { height: a.foregroundHeight }),
                            (r = t ? r : {});
                          var i = a.foreContentType === V.image ? n : o,
                            l = "image-content "
                              .concat(
                                a.elementDistance
                                  ? "margin-top-".concat(a.elementDistance)
                                  : "",
                                " ",
                              )
                              .concat(
                                a.hasContentMedia
                                  ? "has-content-media-screen "
                                  : "",
                              );
                          return E(
                            "div",
                            {
                              "data-aos": d || _,
                              "data-aos-once": !0,
                              key: "image-content",
                              style: B(
                                B({}, r),
                                {},
                                {
                                  marginBottom:
                                    a.foreContentPosition === U["image-text"]
                                      ? a.foreContentGap
                                      : "",
                                  marginTop:
                                    a.foreContentPosition === U["text-image"]
                                      ? a.foreContentGap
                                      : "",
                                  borderRadius: a.foreContentRadius,
                                  overflow: e ? "visible" : "hidden",
                                },
                              ),
                              className: u()(l, N, {
                                autoResolveMultipleImports: !0,
                                handleMissingStyleName: "warn",
                              }),
                            },
                            E(
                              "a",
                              {
                                style: { display: "contents" },
                                href:
                                  null === k || void 0 === k ? void 0 : k.url,
                                target:
                                  null === k || void 0 === k
                                    ? void 0
                                    : k.target,
                                "data-ga-label":
                                  null === k || void 0 === k
                                    ? void 0
                                    : k.gaLabel,
                              },
                              e ? E(v.a, { offset: "-50" }, i) : i,
                            ),
                          );
                        })()
                      : null,
                    _e =
                      a.hasIconsFirstRow || a.hasIconsSecondRow
                        ? E(
                            "div",
                            { className: "style__icons-container___1CoW-" },
                            a.hasIconsFirstRow
                              ? A(
                                  a.iconsFirstRow,
                                  a.iconsLayoutFirstRow,
                                  a.iconsFirstHeight,
                                  a.iconsFirstMaxWidth,
                                )
                              : null,
                            a.hasIconsSecondRow
                              ? A(
                                  a.iconsSecondRow,
                                  a.iconsLayoutSecondRow,
                                  a.iconsSecondHeight,
                                  a.iconsSecondMaxWidth,
                                )
                              : null,
                          )
                        : null,
                    ue = {
                      paddingTop: a.contentPaddingTop,
                      paddingBottom: a.contentPaddingBottom,
                      paddingLeft: a.contentPaddingLeft,
                      paddingRight: a.contentPaddingRight,
                      cursor:
                        (null === (e = a.hotZoneLink) || void 0 === e
                          ? void 0
                          : e.url) ||
                        (null === (t = this.cardLink) || void 0 === t
                          ? void 0
                          : t.url)
                          ? "pointer"
                          : "initial",
                    },
                    de = E(
                      "div",
                      {
                        key: "text-content",
                        className: "style__text-content-container___1aLKY",
                        style: ue,
                        "data-ga-label":
                          null === (n = a.hotZoneLink) || void 0 === n
                            ? void 0
                            : n.gaLabel,
                        onClick: function (e) {
                          return o.handleHotZoneClick(e, a.hotZoneLink);
                        },
                      },
                      se,
                      R,
                      F,
                      H,
                      G,
                      le,
                      Y,
                      Q,
                      J,
                      K,
                      ne,
                      _e,
                    );
                  return E(
                    "div",
                    {
                      role: "button",
                      tabIndex: 0,
                      style: B(
                        B({}, I),
                        {},
                        {
                          cursor: a.hasCardLink ? "pointer" : "",
                          outline: "none",
                        },
                      ),
                      onClick: a.hasCardLink
                        ? this.handleCardClick
                        : function () {},
                      onKeyDown: a.hasCardLink
                        ? this.handleCardClick
                        : function () {},
                      "data-ga-label": a.hasCardLink
                        ? a.cardLinkGaLabel
                          ? a.cardLinkGaLabel
                          : "card-".concat(a.index, "-link")
                        : "",
                      className: u()(
                        "card-wrapper ".concat(r, " ").concat(i),
                        N,
                        {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        },
                      ),
                    },
                    P,
                    E(
                      "div",
                      {
                        className: u()("card-container ".concat(l), N, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                      },
                      a.foreContentPosition === U["image-text"]
                        ? [ce, de]
                        : [de, ce],
                    ),
                  );
                },
              },
              {
                key: "render",
                value: function () {
                  var e,
                    t,
                    n,
                    o = this,
                    a = this.props,
                    r = this.state.hovering,
                    i = a.visibleByDefault,
                    l = a.hasMediaScreen,
                    s = a.mediaPoint,
                    c = {
                      backgroundColor: a.pureBackgroundColor,
                      borderRadius: a.cardRadius,
                      overflow: "" !== a.cardRadius ? "hidden" : "",
                    };
                  a.hasBackgroundImage
                    ? ((n = a.backgroundImage),
                      (c.backgroundPosition = a.backgroundPosition),
                      (c.backgroundSize =
                        a.backgroundSize === G["auto-fit"]
                          ? "cover"
                          : a.backgroundSizeCustom),
                      (c.backgroundRepeat = a.backgroundRepeat),
                      a.backgroundGradient &&
                        (n = "url('"
                          .concat(a.backgroundImage, "'), ")
                          .concat(a.backgroundGradient)))
                    : a.backgroundGradient && (n = a.backgroundGradient),
                    a.getCardsStretch() && (c.height = "100%");
                  var _ = "hero-vertical-card ".concat(
                    Object(T.kb)(l, "has-media-screen", ""),
                    " ",
                    "media-screen-".concat(s || "1440"),
                  );
                  return E(
                    g.a,
                    {
                      type: "bg",
                      visibleByDefault: i,
                      src: n,
                      bgWidth: a.backgroundImageWidth,
                      bgHeight: a.backgroundImageHeight,
                      parallax: a.hasBackgroundImage && a.backgroundParallax,
                      threshold: 1e3,
                      style: c,
                      onMouseEnter: function () {
                        a.backgroundVideoHoverPlay &&
                          o.setState({ hovering: !0 });
                      },
                      onMouseLeave: function () {
                        a.backgroundVideoHoverPlay &&
                          o.setState({ hovering: !1 });
                      },
                      className:
                        "atom-design-v1 " +
                        u()(_, N, {
                          autoResolveMultipleImports: !0,
                          handleMissingStyleName: "warn",
                        }),
                    },
                    E(
                      "div",
                      {
                        onClick: function (e) {
                          return o.handleInnerClick(e, o.cardLink);
                        },
                        style: {
                          display: "contents",
                          cursor: (
                            null === (e = this.cardLink) || void 0 === e
                              ? void 0
                              : e.url
                          )
                            ? "pointer"
                            : "initial",
                        },
                        "data-ga-label":
                          null === (t = this.cardLink) || void 0 === t
                            ? void 0
                            : t.gaLabel,
                      },
                      a.hasBackgroundVideo
                        ? E(
                            "div",
                            {
                              className:
                                "background-video-wrapper style__background-video___EQUNk",
                            },
                            E(
                              b.a,
                              {
                                visiblePlay: a.backgroundVideoVisiblePlay,
                                replayWhenRevisible:
                                  a.backgroundVideoVisiblePlay,
                                triggerPlay: a.backgroundVideoHoverPlay && r,
                                triggerPause: a.backgroundVideoHoverPlay && !r,
                                videoLazyLoadDistance: a.videoLazyLoadDistance,
                                lazyLoad: !0,
                                lazyLoadThreshold: 2e3,
                                style: { width: "100%", height: "100%" },
                              },
                              E(
                                "video",
                                {
                                  muted: !0,
                                  "data-layzr-poster": a.backgroundVideoPoster,
                                  loop: a.backgroundVideoLoop,
                                  autoPlay:
                                    !a.backgroundVideoVisiblePlay &&
                                    !a.backgroundVideoHoverPlay,
                                },
                                a.backgroundVideoWebm &&
                                  E("source", {
                                    type: "video/webm",
                                    "data-layzr-src": a.backgroundVideoWebm,
                                  }),
                                E("source", {
                                  type: 'video/mp4; codecs="avc1.4D401E, mp4a.40.2"',
                                  "data-layzr-src": a.backgroundVideo,
                                }),
                              ),
                            ),
                            E("div", {
                              className: "style__video-mask___2p6XD",
                              style: {
                                backgroundColor: a.backgroundVideoMaskColor,
                                opacity: a.backgroundVideoMaskOpacity,
                              },
                            }),
                          )
                        : null,
                      this.cardInnerContent,
                    ),
                  );
                },
              },
            ]),
            t
          );
        })(d.Component);
      Object(c.a)(
        ie,
        "defaultProps",
        B(
          B(
            {
              hotZoneLink: null,
              _cardId: x()(),
              index: 0,
              cardHeadlineSize: z.h1,
              cardContentSize: A.xl,
              cardVerticalAlign: R["center-align"],
              cardHorizonalAlign: F["center-align"],
              hasCardLink: !1,
              cardLink: "",
              jumpType: ae.external,
              paddingTop: "0",
              paddingBottom: "0",
              paddingLeft: "",
              paddingRight: "",
              cardMinHeight: "",
              pureBackgroundColor: "",
              backgroundGradient: "",
              cardRadius: "",
              hasBackgroundImage: !1,
              backgroundImage: "",
              backgroundImageWidth: "",
              backgroundImageHeight: "",
              backgroundPosition: "center",
              backgroundSize: G["auto-fit"],
              backgroundSizeCustom: "",
              backgroundRepeat: Y["no-repeat"],
              backgroundParallax: !1,
              hasBackgroundVideo: !1,
              backgroundVideoLoop: !1,
              backgroundVideoHoverPlay: !1,
              backgroundVideoVisiblePlay: !1,
              backgroundVideo: "",
              backgroundVideoWebm: "",
              backgroundVideoPoster: "",
              backgroundVideoMaskColor: "#000000",
              backgroundVideoMaskOpacity: "0",
              hasForeContent: !1,
              foreContentType: V.image,
              foreVideoColor: H.light,
              foreVideo:
                "https://asset1.djicdn.com/videos/mammoth/pipeline/Circle-v2.mp4",
              foreVideoWebm: "",
              foreImage:
                "https://www1.djicdn.com/dps/e2be7f3115eba85952fed9a6a03758dc.jpg",
              foreImageAlt: "",
              foregroundHasParallax: !1,
              foregroundParallax: re["inner-content"],
              foregroundHeight: "300px",
              foreVideoPoster: "",
              foreVideoPlay: W.repeat,
              foreContentGap: "48px",
              foreContentPosition: U["image-text"],
              foreContentRadius: "",
              contentPaddingTop: "",
              contentPaddingBottom: "",
              contentPaddingLeft: "",
              contentPaddingRight: "",
              hasToppingImage: !1,
              toppingImage:
                "//www1.djicdn.com/dps/b10b501584ac0f7e81407bcb84b95947.svg",
              toppingImageHeight: "96px",
              hasEyeBrow: !1,
              eyeBrowType: q["pure-text"],
              eyeBrowMaxWidth: "693px",
              eyeBrowSVG: "",
              eyeBrowSVGHeight: "",
              eyeBrowText: "Eyebrow",
              eyeBrowPureColor: "rgba(0, 0, 0, 0.85)",
              eyeBrowGradientColor: "",
              eyeBrowIEGradientColor: "",
              eyeBrowFontSize: y.b.default,
              eyeBrowFontWeight: "",
              eyeBrowLineHeight: y.d.default,
              hasHeadline: !0,
              headlineType: X["pure-text"],
              headlineSVG: "",
              headlineText: "Headline",
              headlineMaxWidth: "693px",
              headlineSVGHeight: "32px",
              headlinePureColor: "rgba(0, 0, 0, 0.85)",
              headlineGradientColor: "",
              headlineIEGradientColor: "",
              headlineFontSize: y.b.default,
              headlineFontWeight: "",
              headlineLineHeight: y.d.default,
              hasSubHeadline: !1,
              subHeadlineType: X["pure-text"],
              subHeadlineColor: "rgba(0, 0, 0, 0.85)",
              subHeadlineText: "Subhead",
              subHeadlineGradientColor: "",
              subHeadlineIEGradientColor: "",
              subHeadlineMaxWidth: "693px",
              subHeadlineFontSize: y.b.default,
              subHeadlineFontWeight: "",
              subHeadlineLineHeight: y.d.default,
              hasDescription: !0,
              descriptionColor: "rgba(0, 0, 0, 0.65)",
              descriptionText: "Description",
              descriptionMaxWidth: "693px",
              descriptionFontSize: y.b.default,
              descriptionFontWeight: "",
              descriptionLineHeight: y.d.default,
              hasDividedLine: !1,
              dividedBlockHeight: "48px",
              dividedLineWidth: "48px",
              dividedLineHeight: "1px",
              dividedLineRadius: "0",
              dividedLineColor: "",
              dividedLineGradientColor: "",
              hasPrimaryButton: !1,
              primaryButtonType: Z.button,
              primaryButtonColor: K.dark,
              primaryButtonLink: "",
              primaryButtonText: "",
              primaryButtonMinWidth: "",
              primaryButtonSize: Q.large,
              hasSecondaryButton: !1,
              secondaryButtonType: $["video-play"],
              secondaryButtonColor: ee["secondary-light"],
              secondaryButtonLink: "",
              secondaryButtonText: "",
              secondaryButtonMinWidth: "",
              secondaryButtonSize: te.large,
              hasDownloadButton: !1,
              hasAppStoreButton: !0,
              appStoreButtonLink: "",
              hasAndroidButton: !0,
              androidButtonLink: "",
              hasGooglePlayButton: !0,
              googlePlayButtonLink: "",
            },
            j.j,
          ),
          {},
          {
            hasLinks: !1,
            links: [
              {
                linkType: ne["internal-link"],
                linkUrl: "/",
                linkText: "link1",
                linkGaLabel: "",
              },
              {
                linkType: ne["internal-link"],
                linkUrl: "/",
                linkText: "link2",
                linkGaLabel: "",
              },
            ],
            linkColor: J.normal,
            linkFontSize: y.b.default,
            linkLineHeight: y.d.default,
            hasNote: !1,
            noteMarginTop: "",
            noteText: "note",
            noteFontSize: y.b.default,
            noteFontWeight: "",
            noteLineHeight: y.d.default,
            noteColor: "rgba(0, 0, 0, 0.45)",
            hasIconsFirstRow: !1,
            iconsFirstHeight: "48px",
            iconsFirstMaxWidth: "none",
            iconsLayoutFirstRow: oe["image-text"],
            iconsFirstRow: [
              {
                hasIcon: !0,
                hasTitle: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                icon: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                title: "title1",
                titleFontSize: y.b.default,
                titleFontWeight: "",
                titleLineHeight: y.d.default,
                desc: "desc1",
                descFontSize: y.b.default,
                descFontWeight: "",
                descLineHeight: y.d.default,
              },
              {
                hasIcon: !0,
                hasTitle: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                icon: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                title: "title2",
                titleFontSize: y.b.default,
                titleFontWeight: "",
                titleLineHeight: y.d.default,
                desc: "desc2",
                descFontSize: y.b.default,
                descFontWeight: "",
                descLineHeight: y.d.default,
              },
              {
                hasIcon: !0,
                hasTitle: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                icon: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                title: "title3",
                desc: "desc3",
                titleFontSize: y.b.default,
                titleFontWeight: "",
                titleLineHeight: y.d.default,
                descFontSize: y.b.default,
                descFontWeight: "",
                descLineHeight: y.d.default,
              },
            ],
            hasIconsSecondRow: !1,
            iconsSecondMaxWidth: "none",
            iconsLayoutSecondRow: oe["image-text"],
            iconsSecondHeight: "48px",
            iconsSecondRow: [
              {
                hasIcon: !0,
                hasTitle: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                icon: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                title: "title1",
                desc: "desc1",
                titleFontSize: y.b.default,
                titleFontWeight: "",
                titleLineHeight: y.d.default,
                descFontSize: y.b.default,
                descFontWeight: "",
                descLineHeight: y.d.default,
              },
              {
                hasIcon: !0,
                hasTitle: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                icon: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                title: "title2",
                desc: "desc2",
                titleFontSize: y.b.default,
                titleFontWeight: "",
                titleLineHeight: y.d.default,
                descFontSize: y.b.default,
                descFontWeight: "",
                descLineHeight: y.d.default,
              },
              {
                hasIcon: !0,
                hasTitle: !0,
                hasDesc: !0,
                hasNumber: !1,
                hasUnit: !1,
                number: "99",
                unit: "m/s",
                titleColor: "rgba(0, 0, 0, 0.85)",
                descColor: "rgba(0, 0, 0, 0.65)",
                icon: "//www1.djicdn.com/dps/9acd88bf1c77155924aae20431647f31.svg",
                title: "title3",
                desc: "desc3",
                titleFontSize: y.b.default,
                titleFontWeight: "",
                titleLineHeight: y.d.default,
                descFontSize: y.b.default,
                descFontWeight: "",
                descLineHeight: y.d.default,
              },
            ],
          },
        ),
      );
    },
    xVxQ: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return c;
      });
      var o = n("HaE+"),
        a = n("1OyB"),
        r = n("vuIU"),
        i = n("rePB"),
        l = n("u11H");
      function s() {
        s = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          c = r.toStringTag || "@@toStringTag";
        function _(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          _({}, "");
        } catch (e) {
          _ = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function u(e, t, n, o) {
          var r = t && t.prototype instanceof b ? t : b,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function d(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = u;
        var p = "suspendedStart",
          f = "suspendedYield",
          h = "executing",
          m = "completed",
          y = {};
        function b() {}
        function v() {}
        function g() {}
        var w = {};
        _(w, i, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, i) && (w = k);
        var O = (g.prototype = b.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            _(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = d(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = p;
          return function (r, i) {
            if (a === h) throw new Error("Generator is already running");
            if (a === m) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === p) throw ((a = m), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = h;
              var c = d(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? m : f), c.arg === y)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = m), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              y
            );
          var r = d(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), y
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                y)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (v.prototype = g),
          a(O, "constructor", { value: g, configurable: !0 }),
          a(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = _(g, c, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), _(e, c, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          _(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(u(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          _(O, c, "Generator"),
          _(O, i, function () {
            return this;
          }),
          _(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), y)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                y
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                y
              );
            },
          }),
          t
        );
      }
      var c = (function () {
        function e() {
          Object(a.default)(this, e),
            Object(i.a)(this, "allEanList", void 0),
            Object(i.a)(this, "apiLocalization", void 0),
            Object(i.a)(this, "eanPriceMap", void 0),
            Object(i.a)(this, "callbackList", void 0),
            Object(i.a)(this, "fetchPricesCalled", !1),
            (this.eanPriceMap = null),
            (this.callbackList = []);
        }
        return (
          Object(r.default)(
            e,
            [
              {
                key: "init",
                value: function (e, t) {
                  Array.isArray(e) &&
                    e.length &&
                    t &&
                    ((this.allEanList = e), (this.apiLocalization = t));
                },
              },
              {
                key: "fetchPricesByEans",
                value: (function () {
                  var e = Object(o.default)(
                    s().mark(function e() {
                      var t, n, o, a;
                      return s().wrap(
                        function (e) {
                          for (;;)
                            switch ((e.prev = e.next)) {
                              case 0:
                                if (
                                  Array.isArray(this.allEanList) &&
                                  this.allEanList.length &&
                                  this.apiLocalization
                                ) {
                                  e.next = 2;
                                  break;
                                }
                                return e.abrupt("return");
                              case 2:
                                return (
                                  (this.fetchPricesCalled = !0),
                                  (e.prev = 3),
                                  (i = this.allEanList),
                                  (t = i.join(",")),
                                  (e.next = 7),
                                  l.default.request(
                                    {
                                      name: "productGetPrice",
                                      method: "GET",
                                      query: { ean: t },
                                    },
                                    this.apiLocalization,
                                  )
                                );
                              case 7:
                                return (n = e.sent), (e.next = 10), n.json();
                              case 10:
                                if (
                                  200 !==
                                  (null === (o = e.sent) || void 0 === o
                                    ? void 0
                                    : o.status)
                                ) {
                                  e.next = 17;
                                  break;
                                }
                                (a = o.data),
                                  (this.eanPriceMap =
                                    ((r = a),
                                    Array.isArray(r) && r.length
                                      ? r.reduce(function (e, t) {
                                          return (
                                            t && t.ean && (e[t.ean] = t), e
                                          );
                                        }, {})
                                      : {})),
                                  this.notifyCallbacksOnPriceFetched(),
                                  (e.next = 18);
                                break;
                              case 17:
                                throw new Error(
                                  "Error occurred while fetching price with eans="
                                    .concat(t, ": invalid status received: ")
                                    .concat(
                                      null === o || void 0 === o
                                        ? void 0
                                        : o.status,
                                      "-",
                                    )
                                    .concat(
                                      null === o || void 0 === o
                                        ? void 0
                                        : o.msg,
                                    ),
                                );
                              case 18:
                                e.next = 24;
                                break;
                              case 20:
                                (e.prev = 20),
                                  (e.t0 = e.catch(3)),
                                  "object" === typeof window.Sentry &&
                                    window.Sentry.captureException(e.t0),
                                  console.error(
                                    "Error occurred while fetching price: ",
                                    e.t0,
                                  );
                              case 24:
                              case "end":
                                return e.stop();
                            }
                          var r, i;
                        },
                        e,
                        this,
                        [[3, 20]],
                      );
                    }),
                  );
                  return function () {
                    return e.apply(this, arguments);
                  };
                })(),
              },
              {
                key: "addCallback",
                value: function (e) {
                  "function" === typeof e &&
                    (this.fetchPricesCalled || this.fetchPricesByEans(),
                    this.eanPriceMap
                      ? e(this.eanPriceMap)
                      : this.callbackList.push(e));
                },
              },
              {
                key: "notifyCallbacksOnPriceFetched",
                value: function () {
                  var e = this;
                  this.callbackList.forEach(function (t) {
                    t(e.eanPriceMap);
                  });
                },
              },
            ],
            [
              {
                key: "getInstance",
                value: function () {
                  return (
                    this.instance || (this.instance = new e()), this.instance
                  );
                },
              },
            ],
          ),
          e
        );
      })();
      Object(i.a)(c, "instance", void 0);
    },
    xcIm: function (e, t, n) {
      "use strict";
      n.r(t),
        n.d(t, "addCustomEventListener", function () {
          return a;
        }),
        n.d(t, "removeCustomEventListener", function () {
          return r;
        });
      var o = n("r6IF");
      function a(e, t) {
        return { type: o.a.ADD_CUSTOM_EVENT, eventName: e, eventFunc: t };
      }
      function r(e, t) {
        return { type: o.a.REMOVE_CUSTOM_EVENT, eventName: e, eventFunc: t };
      }
    },
    xfxO: function (e, t, n) {
      "use strict";
      (t.__esModule = !0), (t.classNamesShape = t.timeoutsShape = void 0);
      var o;
      (o = n("17x9")) && o.__esModule;
      t.timeoutsShape = null;
      t.classNamesShape = null;
    },
    xqva: function (e, t, n) {
      "use strict";
      n.d(t, "a", function () {
        return f;
      });
      var o = n("q1tI"),
        a = n.n(o),
        r = n("bTu8"),
        i = n("tu8O"),
        l = [
          "init",
          "_direction",
          "touchEventsTarget",
          "initialSlide",
          "_speed",
          "cssMode",
          "updateOnWindowResize",
          "resizeObserver",
          "nested",
          "focusableElements",
          "_enabled",
          "_width",
          "_height",
          "preventInteractionOnTransition",
          "userAgent",
          "url",
          "_edgeSwipeDetection",
          "_edgeSwipeThreshold",
          "_freeMode",
          "_freeModeMomentum",
          "_freeModeMomentumRatio",
          "_freeModeMomentumBounce",
          "_freeModeMomentumBounceRatio",
          "_freeModeMomentumVelocityRatio",
          "_freeModeSticky",
          "_freeModeMinimumVelocity",
          "_autoHeight",
          "setWrapperSize",
          "virtualTranslate",
          "_effect",
          "breakpoints",
          "_spaceBetween",
          "_slidesPerView",
          "_slidesPerColumn",
          "_slidesPerColumnFill",
          "_slidesPerGroup",
          "_slidesPerGroupSkip",
          "_centeredSlides",
          "_centeredSlidesBounds",
          "_slidesOffsetBefore",
          "_slidesOffsetAfter",
          "normalizeSlideIndex",
          "_centerInsufficientSlides",
          "_watchOverflow",
          "roundLengths",
          "touchRatio",
          "touchAngle",
          "simulateTouch",
          "_shortSwipes",
          "_longSwipes",
          "longSwipesRatio",
          "longSwipesMs",
          "_followFinger",
          "allowTouchMove",
          "_threshold",
          "touchMoveStopPropagation",
          "touchStartPreventDefault",
          "touchStartForcePreventDefault",
          "touchReleaseOnEdges",
          "uniqueNavElements",
          "_resistance",
          "_resistanceRatio",
          "_watchSlidesProgress",
          "_watchSlidesVisibility",
          "_grabCursor",
          "preventClicks",
          "preventClicksPropagation",
          "_slideToClickedSlide",
          "_preloadImages",
          "updateOnImagesReady",
          "_loop",
          "_loopAdditionalSlides",
          "_loopedSlides",
          "_loopFillGroupWithBlank",
          "loopPreventsSlide",
          "_allowSlidePrev",
          "_allowSlideNext",
          "_swipeHandler",
          "_noSwiping",
          "noSwipingClass",
          "noSwipingSelector",
          "passiveListeners",
          "containerModifierClass",
          "slideClass",
          "slideBlankClass",
          "slideActiveClass",
          "slideDuplicateActiveClass",
          "slideVisibleClass",
          "slideDuplicateClass",
          "slideNextClass",
          "slideDuplicateNextClass",
          "slidePrevClass",
          "slideDuplicatePrevClass",
          "wrapperClass",
          "runCallbacksOnInit",
          "observer",
          "observeParents",
          "observeSlideChildren",
          "a11y",
          "autoplay",
          "_controller",
          "coverflowEffect",
          "cubeEffect",
          "fadeEffect",
          "flipEffect",
          "hashNavigation",
          "history",
          "keyboard",
          "lazy",
          "mousewheel",
          "_navigation",
          "_pagination",
          "parallax",
          "_scrollbar",
          "_thumbs",
          "virtual",
          "zoom",
        ];
      function s(e, t) {
        var n = t.slidesPerView;
        if (t.breakpoints) {
          var o = r.a.prototype.getBreakpoint(t.breakpoints),
            a = o in t.breakpoints ? t.breakpoints[o] : void 0;
          a && a.slidesPerView && (n = a.slidesPerView);
        }
        var i = Math.ceil(parseFloat(t.loopedSlides || n, 10));
        return (i += t.loopAdditionalSlides) > e.length && (i = e.length), i;
      }
      function c(e) {
        var t = [],
          n = {
            "container-start": [],
            "container-end": [],
            "wrapper-start": [],
            "wrapper-end": [],
          };
        return (
          a.a.Children.toArray(e).forEach(function (e) {
            if (e.type && "SwiperSlide" === e.type.displayName) t.push(e);
            else if (e.props && e.props.slot && n[e.props.slot])
              n[e.props.slot].push(e);
            else if (e.props && e.props.children) {
              var o = (function e(t) {
                var n = [];
                return (
                  a.a.Children.toArray(t).forEach(function (t) {
                    t.type && "SwiperSlide" === t.type.displayName
                      ? n.push(t)
                      : t.props &&
                        t.props.children &&
                        e(t.props.children).forEach(function (e) {
                          return n.push(e);
                        });
                  }),
                  n
                );
              })(e.props.children);
              o.length > 0
                ? o.forEach(function (e) {
                    return t.push(e);
                  })
                : n["container-end"].push(e);
            } else n["container-end"].push(e);
          }),
          { slides: t, slots: n }
        );
      }
      function _(e) {
        var t,
          n,
          o,
          a,
          r,
          l = e.swiper,
          s = e.slides,
          c = e.passedParams,
          _ = e.changedParams,
          u = e.nextEl,
          d = e.prevEl,
          p = e.scrollbarEl,
          f = e.paginationEl,
          h = _.filter(function (e) {
            return "children" !== e && "direction" !== e;
          }),
          m = l.params,
          y = l.pagination,
          b = l.navigation,
          v = l.scrollbar,
          g = l.virtual,
          w = l.thumbs;
        _.includes("thumbs") &&
          c.thumbs &&
          c.thumbs.swiper &&
          m.thumbs &&
          !m.thumbs.swiper &&
          (t = !0),
          _.includes("controller") &&
            c.controller &&
            c.controller.control &&
            m.controller &&
            !m.controller.control &&
            (n = !0),
          _.includes("pagination") &&
            c.pagination &&
            (c.pagination.el || f) &&
            (m.pagination || !1 === m.pagination) &&
            y &&
            !y.el &&
            (o = !0),
          _.includes("scrollbar") &&
            c.scrollbar &&
            (c.scrollbar.el || p) &&
            (m.scrollbar || !1 === m.scrollbar) &&
            v &&
            !v.el &&
            (a = !0),
          _.includes("navigation") &&
            c.navigation &&
            (c.navigation.prevEl || d) &&
            (c.navigation.nextEl || u) &&
            (m.navigation || !1 === m.navigation) &&
            b &&
            !b.prevEl &&
            !b.nextEl &&
            (r = !0);
        (h.forEach(function (e) {
          if (Object(i.b)(m[e]) && Object(i.b)(c[e])) Object(i.a)(m[e], c[e]);
          else {
            var t = c[e];
            (!0 !== t && !1 !== t) ||
            ("navigation" !== e && "pagination" !== e && "scrollbar" !== e)
              ? (m[e] = c[e])
              : !1 === t &&
                l[(n = e)] &&
                (l[n].destroy(),
                "navigation" === n
                  ? ((m[n].prevEl = void 0),
                    (m[n].nextEl = void 0),
                    (l[n].prevEl = void 0),
                    (l[n].nextEl = void 0))
                  : ((m[n].el = void 0), (l[n].el = void 0)));
          }
          var n;
        }),
        _.includes("children") && g && m.virtual.enabled
          ? ((g.slides = s), g.update(!0))
          : _.includes("children") &&
            l.lazy &&
            l.params.lazy.enabled &&
            l.lazy.load(),
        t) &&
          w.init() &&
          w.update(!0);
        n && (l.controller.control = m.controller.control),
          o && (f && (m.pagination.el = f), y.init(), y.render(), y.update()),
          a &&
            (p && (m.scrollbar.el = p),
            v.init(),
            v.updateSize(),
            v.setTranslate()),
          r &&
            (u && (m.navigation.nextEl = u),
            d && (m.navigation.prevEl = d),
            b.init(),
            b.update()),
          _.includes("allowSlideNext") && (l.allowSlideNext = c.allowSlideNext),
          _.includes("allowSlidePrev") && (l.allowSlidePrev = c.allowSlidePrev),
          _.includes("direction") && l.changeDirection(c.direction, !1),
          l.update();
      }
      var u = n("/Pgi"),
        d = ["className", "tag", "wrapperTag", "children", "onSwiper"];
      function p() {
        return (p =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
          }).apply(this, arguments);
      }
      var f = Object(o.forwardRef)(function (e, t) {
        var n = void 0 === e ? {} : e,
          f = n.className,
          h = n.tag,
          m = void 0 === h ? "div" : h,
          y = n.wrapperTag,
          b = void 0 === y ? "div" : y,
          v = n.children,
          g = n.onSwiper,
          w = (function (e, t) {
            if (null == e) return {};
            var n,
              o,
              a = {},
              r = Object.keys(e);
            for (o = 0; o < r.length; o++)
              (n = r[o]), t.indexOf(n) >= 0 || (a[n] = e[n]);
            return a;
          })(n, d),
          x = !1,
          k = Object(o.useState)("swiper-container"),
          O = k[0],
          I = k[1],
          S = Object(o.useState)(null),
          j = S[0],
          T = S[1],
          C = Object(o.useState)(!1),
          M = C[0],
          P = C[1],
          E = Object(o.useRef)(!1),
          L = Object(o.useRef)(null),
          B = Object(o.useRef)(null),
          N = Object(o.useRef)(null),
          D = Object(o.useRef)(null),
          z = Object(o.useRef)(null),
          A = Object(o.useRef)(null),
          R = Object(o.useRef)(null),
          F = Object(o.useRef)(null),
          V = (function (e) {
            void 0 === e && (e = {});
            var t = { on: {} },
              n = {},
              o = {};
            Object(i.a)(t, r.a.defaults),
              Object(i.a)(t, r.a.extendedDefaults),
              (t._emitClasses = !0),
              (t.init = !1);
            var a = {},
              s = l.map(function (e) {
                return e.replace(/_/, "");
              });
            return (
              Object.keys(e).forEach(function (r) {
                s.indexOf(r) >= 0
                  ? Object(i.b)(e[r])
                    ? ((t[r] = {}),
                      (o[r] = {}),
                      Object(i.a)(t[r], e[r]),
                      Object(i.a)(o[r], e[r]))
                    : ((t[r] = e[r]), (o[r] = e[r]))
                  : 0 === r.search(/on[A-Z]/) && "function" === typeof e[r]
                    ? (n["" + r[2].toLowerCase() + r.substr(3)] = e[r])
                    : (a[r] = e[r]);
              }),
              ["navigation", "pagination", "scrollbar"].forEach(function (e) {
                !0 === t[e] && (t[e] = {}), !1 === t[e] && delete t[e];
              }),
              { params: t, passedParams: o, rest: a, events: n }
            );
          })(w),
          H = V.params,
          W = V.passedParams,
          U = V.rest,
          G = V.events,
          Y = c(v),
          q = Y.slides,
          X = Y.slots,
          Z = function () {
            P(!M);
          };
        if (
          (Object.assign(H.on, {
            _containerClasses: function (e, t) {
              I(t);
            },
          }),
          !L.current &&
            (Object.assign(H.on, G),
            (x = !0),
            (B.current = (function (e) {
              return new r.a(e);
            })(H)),
            (B.current.loopCreate = function () {}),
            (B.current.loopDestroy = function () {}),
            H.loop && (B.current.loopedSlides = s(q, H)),
            B.current.virtual && B.current.params.virtual.enabled))
        ) {
          B.current.virtual.slides = q;
          var K = { cache: !1, renderExternal: T, renderExternalUpdate: !1 };
          Object(i.a)(B.current.params.virtual, K),
            Object(i.a)(B.current.originalParams.virtual, K);
        }
        B.current && B.current.on("_beforeBreakpoint", Z);
        return (
          Object(o.useEffect)(function () {
            return function () {
              B.current && B.current.off("_beforeBreakpoint", Z);
            };
          }),
          Object(o.useEffect)(function () {
            !E.current &&
              B.current &&
              (B.current.emitSlidesClasses(), (E.current = !0));
          }),
          Object(u.a)(function () {
            if ((t && (t.current = L.current), L.current))
              return (
                (function (e, t) {
                  var n = e.el,
                    o = e.nextEl,
                    a = e.prevEl,
                    r = e.paginationEl,
                    l = e.scrollbarEl,
                    s = e.swiper;
                  Object(i.c)(t) &&
                    o &&
                    a &&
                    ((s.params.navigation.nextEl = o),
                    (s.originalParams.navigation.nextEl = o),
                    (s.params.navigation.prevEl = a),
                    (s.originalParams.navigation.prevEl = a)),
                    Object(i.d)(t) &&
                      r &&
                      ((s.params.pagination.el = r),
                      (s.originalParams.pagination.el = r)),
                    Object(i.e)(t) &&
                      l &&
                      ((s.params.scrollbar.el = l),
                      (s.originalParams.scrollbar.el = l)),
                    s.init(n);
                })(
                  {
                    el: L.current,
                    nextEl: z.current,
                    prevEl: A.current,
                    paginationEl: R.current,
                    scrollbarEl: F.current,
                    swiper: B.current,
                  },
                  H,
                ),
                g && g(B.current),
                function () {
                  B.current &&
                    !B.current.destroyed &&
                    B.current.destroy(!0, !1);
                }
              );
          }, []),
          Object(u.a)(function () {
            !x &&
              G &&
              B.current &&
              Object.keys(G).forEach(function (e) {
                B.current.on(e, G[e]);
              });
            var e = (function (e, t, n, o) {
              var a = [];
              if (!t) return a;
              var r = function (e) {
                  a.indexOf(e) < 0 && a.push(e);
                },
                s = o.map(function (e) {
                  return e.key;
                }),
                c = n.map(function (e) {
                  return e.key;
                });
              return (
                s.join("") !== c.join("") && r("children"),
                o.length !== n.length && r("children"),
                l
                  .filter(function (e) {
                    return "_" === e[0];
                  })
                  .map(function (e) {
                    return e.replace(/_/, "");
                  })
                  .forEach(function (n) {
                    if (n in e && n in t)
                      if (Object(i.b)(e[n]) && Object(i.b)(t[n])) {
                        var o = Object.keys(e[n]),
                          a = Object.keys(t[n]);
                        o.length !== a.length
                          ? r(n)
                          : (o.forEach(function (o) {
                              e[n][o] !== t[n][o] && r(n);
                            }),
                            a.forEach(function (o) {
                              e[n][o] !== t[n][o] && r(n);
                            }));
                      } else e[n] !== t[n] && r(n);
                  }),
                a
              );
            })(W, N.current, q, D.current);
            return (
              (N.current = W),
              (D.current = q),
              e.length &&
                B.current &&
                !B.current.destroyed &&
                _({
                  swiper: B.current,
                  slides: q,
                  passedParams: W,
                  changedParams: e,
                  nextEl: z.current,
                  prevEl: A.current,
                  scrollbarEl: F.current,
                  paginationEl: R.current,
                }),
              function () {
                G &&
                  B.current &&
                  Object.keys(G).forEach(function (e) {
                    B.current.off(e, G[e]);
                  });
              }
            );
          }),
          Object(u.a)(
            function () {
              var e;
              !(e = B.current) ||
                e.destroyed ||
                !e.params.virtual ||
                (e.params.virtual && !e.params.virtual.enabled) ||
                (e.updateSlides(),
                e.updateProgress(),
                e.updateSlidesClasses(),
                e.lazy && e.params.lazy.enabled && e.lazy.load(),
                e.parallax &&
                  e.params.parallax &&
                  e.params.parallax.enabled &&
                  e.parallax.setTranslate());
            },
            [j],
          ),
          a.a.createElement(
            m,
            p({ ref: L, className: Object(i.f)(O + (f ? " " + f : "")) }, U),
            X["container-start"],
            Object(i.c)(H) &&
              a.a.createElement(
                a.a.Fragment,
                null,
                a.a.createElement("div", {
                  ref: A,
                  className: "swiper-button-prev",
                }),
                a.a.createElement("div", {
                  ref: z,
                  className: "swiper-button-next",
                }),
              ),
            Object(i.e)(H) &&
              a.a.createElement("div", {
                ref: F,
                className: "swiper-scrollbar",
              }),
            Object(i.d)(H) &&
              a.a.createElement("div", {
                ref: R,
                className: "swiper-pagination",
              }),
            a.a.createElement(
              b,
              { className: "swiper-wrapper" },
              X["wrapper-start"],
              H.virtual
                ? (function (e, t, n) {
                    var o;
                    if (!n) return null;
                    var r = e.isHorizontal()
                      ? (((o = {})[e.rtlTranslate ? "right" : "left"] =
                          n.offset + "px"),
                        o)
                      : { top: n.offset + "px" };
                    return t
                      .filter(function (e, t) {
                        return t >= n.from && t <= n.to;
                      })
                      .map(function (t) {
                        return a.a.cloneElement(t, { swiper: e, style: r });
                      });
                  })(B.current, q, j)
                : !H.loop || (B.current && B.current.destroyed)
                  ? q.map(function (e) {
                      return a.a.cloneElement(e, { swiper: B.current });
                    })
                  : (function (e, t, n) {
                      var o = t.map(function (t, n) {
                        return a.a.cloneElement(t, {
                          swiper: e,
                          "data-swiper-slide-index": n,
                        });
                      });
                      function r(e, t, o) {
                        return a.a.cloneElement(e, {
                          key: e.key + "-duplicate-" + t + "-" + o,
                          className:
                            (e.props.className || "") +
                            " " +
                            n.slideDuplicateClass,
                        });
                      }
                      if (n.loopFillGroupWithBlank) {
                        var i =
                          n.slidesPerGroup - (o.length % n.slidesPerGroup);
                        if (i !== n.slidesPerGroup)
                          for (var l = 0; l < i; l += 1) {
                            var c = a.a.createElement("div", {
                              className: n.slideClass + " " + n.slideBlankClass,
                            });
                            o.push(c);
                          }
                      }
                      "auto" !== n.slidesPerView ||
                        n.loopedSlides ||
                        (n.loopedSlides = o.length);
                      var _ = s(o, n),
                        u = [],
                        d = [];
                      return (
                        o.forEach(function (e, t) {
                          t < _ && d.push(r(e, t, "prepend")),
                            t < o.length &&
                              t >= o.length - _ &&
                              u.push(r(e, t, "append"));
                        }),
                        e && (e.loopedSlides = _),
                        [].concat(u, o, d)
                      );
                    })(B.current, q, H),
              X["wrapper-end"],
            ),
            X["container-end"],
          )
        );
      });
      f.displayName = "Swiper";
    },
    xwbB: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("rePB"),
        r = n("iKuz"),
        i = n.n(r),
        l = n("q1tI"),
        s = n.n(l),
        c = n("yWgo"),
        _ = n("ub/+"),
        u = n("TSYQ"),
        d = n.n(u),
        p = (n("l6NK"), s.a.createElement);
      function f(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          t &&
            (o = o.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, o);
        }
        return n;
      }
      function h(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? f(Object(n), !0).forEach(function (t) {
                Object(a.a)(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : f(Object(n)).forEach(function (t) {
                  Object.defineProperty(
                    e,
                    t,
                    Object.getOwnPropertyDescriptor(n, t),
                  );
                });
        }
        return e;
      }
      var m = {
          "./style.css": {
            "atom-horizontal-tabs": "style__atom-horizontal-tabs___3TqKI",
            "card-wrapper": "style__card-wrapper___3qAFX",
            mobile: "style__mobile___3r15Z",
            "atom-horizontal-tab-bar": "style__atom-horizontal-tab-bar___AydlZ",
            "tab-bar-box": "style__tab-bar-box___3-e5c",
            "tab-item": "style__tab-item___1FMYw",
            "tab-content": "style__tab-content___34O_4",
            dark: "style__dark___Zy-jP",
            "tab-bar-wrap": "style__tab-bar-wrap___36K2U",
            light: "style__light___M5dzS",
            "atom-horizontal-tab-content":
              "style__atom-horizontal-tab-content___1b6xw",
            "atom-horizontal-tab-bisection":
              "style__atom-horizontal-tab-bisection___2Iejq",
            "atom-horizontal-tabs-left":
              "style__atom-horizontal-tabs-left___1AZgc",
            "atom-horizontal-tabs-center":
              "style__atom-horizontal-tabs-center___dMxey",
            "atom-horizontal-tabs-right":
              "style__atom-horizontal-tabs-right___32IDK",
            "tab-bar-wrapper": "style__tab-bar-wrapper___3Eodm",
            text: "style__text___3HqYI",
            "aotm-horizontal-tab-inkbar":
              "style__aotm-horizontal-tab-inkbar___13fHx",
            "atom-horizontal-tab-bar-theme-dark":
              "style__atom-horizontal-tab-bar-theme-dark___19ufo",
            "tab-item-active": "style__tab-item-active___JRqMK",
            "tab-hover-icon": "style__tab-hover-icon___xsD_s",
            "tab-icon": "style__tab-icon___2lHss",
            "atom-horizontal-tab-bar-theme-light":
              "style__atom-horizontal-tab-bar-theme-light___3xfW_",
            "atom-horizontal-tab-bar-left":
              "style__atom-horizontal-tab-bar-left___3Qt1H",
            "atom-horizontal-tab-bar-center":
              "style__atom-horizontal-tab-bar-center___1cgj1",
            "atom-horizontal-tab-content-left":
              "style__atom-horizontal-tab-content-left___lDl0k",
            "atom-horizontal-tab-content-center":
              "style__atom-horizontal-tab-content-center___AVe2v",
            "atom-horizontal-tab-content-right":
              "style__atom-horizontal-tab-content-right___1lRB-",
            "atom-horizontal-tabs-content-theme-dark":
              "style__atom-horizontal-tabs-content-theme-dark___2p08c",
            "tab-panel": "style__tab-panel___2BLpQ",
            "atom-horizontal-tabs-content-theme-light":
              "style__atom-horizontal-tabs-content-theme-light___1S7Ux",
            "tab-panel-active": "style__tab-panel-active___1DyaN",
            "scenario-tab-bar": "style__scenario-tab-bar___2M_X8",
            pc: "style__pc___2iq02",
          },
        },
        y = function (e) {
          var t,
            n = e.t,
            o = e.activeKey,
            a = e.activeTabRef,
            r = e.titleStyle,
            l = e.id,
            s = e.tabItemStyle,
            u = e.gaSend;
          return null === (t = e.barContent) || void 0 === t
            ? void 0
            : t.map(function (t, f) {
                return p(
                  "div",
                  {
                    onClick: function () {
                      return (function (t, n, o) {
                        var a = e.onTabClick;
                        a && (a(t, n, !0), u("click", o));
                      })(t.tabKey, f, "all-".concat(f, "-tab-button"));
                    },
                    key: "".concat(l, "-title-").concat(f),
                    "data-ga-label": "all-".concat(f, "-tab-button"),
                    ref: function (e) {
                      a.current[f] = e;
                    },
                    style: s,
                    className: i()(
                      d()("tab-item", {
                        "tab-item-active":
                          o ===
                          (null === t || void 0 === t ? void 0 : t.tabKey),
                      }),
                      m,
                      {
                        autoResolveMultipleImports: !0,
                        handleMissingStyleName: "warn",
                      },
                    ),
                  },
                  p(_.e, {
                    className: "style__text___3HqYI",
                    tagType:
                      ((y = r),
                      Object(c.fb)(
                        null === y || void 0 === y ? void 0 : y.labelType,
                        "p",
                      )),
                    style: h({}, null === r || void 0 === r ? void 0 : r.style),
                    dangerouslySetInnerHTML: { __html: n(t.title) },
                  }),
                );
                var y;
              });
        },
        b = function (e) {
          var t = e.t,
            n = e.activeKey,
            o = e.tabTheme,
            a = e.barContent,
            r = e.hasDesc,
            l = e.descStyle,
            s = e.descRef,
            c = e.id,
            _ = d()(
              "atom-horizontal-tab-content",
              "atom-horizontal-tab-content-center",
              "atom-horizontal-tabs-content-theme-".concat(o),
              o ? "".concat(o) : "",
            ),
            u = function () {
              var e,
                t,
                n =
                  null === (e = s.current) || void 0 === e
                    ? void 0
                    : null === (t = e[0]) || void 0 === t
                      ? void 0
                      : t.clientHeight;
              return (
                s.current.forEach(function (e) {
                  n = Math.max(e.clientHeight, n);
                }),
                n
              );
            },
            f =
              null === a || void 0 === a
                ? void 0
                : a.map(function (e, o) {
                    return p(
                      "div",
                      {
                        key: "".concat(c, "-desc-").concat(o),
                        className: i()(
                          d()("tab-panel", {
                            "tab-panel-active":
                              n ===
                              (null === e || void 0 === e ? void 0 : e.tabKey),
                          }),
                          m,
                          {
                            autoResolveMultipleImports: !0,
                            handleMissingStyleName: "warn",
                          },
                        ),
                      },
                      r &&
                        p(
                          "div",
                          {
                            style: { minHeight: u() },
                            className: "style__tab-content___34O_4",
                          },
                          p("p", {
                            style: h(
                              {},
                              null === l || void 0 === l ? void 0 : l.style,
                            ),
                            ref: function (e) {
                              s.current[o] = e;
                            },
                            dangerouslySetInnerHTML: { __html: t(e.desc) },
                          }),
                        ),
                    );
                  });
          return p(
            "div",
            {
              className: i()(_, m, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            },
            f,
          );
        },
        v = function (e) {
          return p("div", {
            style: e,
            className: "style__aotm-horizontal-tab-inkbar___13fHx",
          });
        };
      t.a = function (e) {
        var t = e.t,
          n = e.activeKey,
          a = e.tabBarRef,
          r = e.inView,
          s = e.mobileMode,
          _ = e.tabTheme,
          u = e.textAlign,
          f = e.customStyleName,
          h = e.windowWidth,
          g = Object(l.useRef)([]),
          w = Object(l.useRef)([]),
          x = Object(l.useRef)(),
          k = Object(l.useState)({}),
          O = k[0],
          I = k[1],
          S = d()(
            "atom-horizontal-tab-bar",
            "atom-horizontal-tab-bar-".concat(u || "center"),
            "atom-horizontal-tab-bar-theme-".concat(_),
            s ? "mobile" : "pc",
            _ && "".concat(_),
          ),
          j = function () {
            if (g && x) {
              var e,
                t,
                o = { width: "0px" },
                r =
                  null === g || void 0 === g
                    ? void 0
                    : null === (e = g.current) || void 0 === e
                      ? void 0
                      : e[n - 1],
                i =
                  (null === r || void 0 === r ? void 0 : r.offsetLeft) -
                  (null === x || void 0 === x
                    ? void 0
                    : null === (t = x.current) || void 0 === t
                      ? void 0
                      : t.offsetLeft),
                l = null === r || void 0 === r ? void 0 : r.clientWidth;
              !(function (e, t) {
                var n = e;
                e &&
                  "object" === typeof e &&
                  t &&
                  ((n.transform = t),
                  (n.WebkitTransform = t),
                  (n.MozTransform = t));
              })(o, "translate3d(".concat(i, "px,0,0)")),
                (o.width = "".concat(l, "px")),
                I(o),
                a && Object(c.sb)(a.current, r);
            }
          };
        Object(l.useEffect)(function () {
          setTimeout(function () {
            j();
          }, 100);
        }, []),
          Object(l.useEffect)(
            function () {
              setTimeout(function () {
                j();
              }, 100);
            },
            [r, h],
          ),
          Object(l.useEffect)(
            function () {
              j();
            },
            [n],
          );
        var T = { activeKey: n, t: t };
        return p(
          "div",
          {
            className: i()("tab-bar-wrapper ".concat(f || "", " "), m, {
              autoResolveMultipleImports: !0,
              handleMissingStyleName: "warn",
            }),
          },
          p(
            "div",
            {
              ref: a,
              className: i()(S, m, {
                autoResolveMultipleImports: !0,
                handleMissingStyleName: "warn",
              }),
            },
            p(
              "div",
              { ref: x, className: "style__tab-bar-box___3-e5c" },
              p(v, O),
              p(
                "div",
                { className: "style__tab-bar-wrap___36K2U" },
                p(
                  y,
                  Object(o.a)({ activeTabRef: g }, e, T, {
                    updateInkBarStyle: j,
                  }),
                ),
              ),
            ),
          ),
          p(b, Object(o.a)({}, e, { descRef: w })),
        );
      };
    },
    y1pI: function (e, t, n) {
      var o = n("ljhN");
      e.exports = function (e, t) {
        for (var n = e.length; n--; ) if (o(e[n][0], t)) return n;
        return -1;
      };
    },
    yD6e: function (e, t, n) {
      "use strict";
      (t.__esModule = !0),
        (t.default = function (e, t) {
          return e.classList
            ? !!t && e.classList.contains(t)
            : -1 !==
                (" " + (e.className.baseVal || e.className) + " ").indexOf(
                  " " + t + " ",
                );
        }),
        (e.exports = t.default);
    },
    yGk4: function (e, t, n) {
      var o = n("Cwc5")(n("Kz5y"), "Set");
      e.exports = o;
    },
    yHx3: function (e, t) {
      var n = Object.prototype.hasOwnProperty;
      e.exports = function (e) {
        var t = e.length,
          o = new e.constructor(t);
        return (
          t &&
            "string" == typeof e[0] &&
            n.call(e, "index") &&
            ((o.index = e.index), (o.input = e.input)),
          o
        );
      };
    },
    yLpj: function (e, t) {
      var n;
      n = (function () {
        return this;
      })();
      try {
        n = n || new Function("return this")();
      } catch (o) {
        "object" === typeof window && (n = window);
      }
      e.exports = n;
    },
    yP5f: function (e, t, n) {
      var o = n("+K+b");
      e.exports = function (e, t) {
        var n = t ? o(e.buffer) : e.buffer;
        return new e.constructor(n, e.byteOffset, e.length);
      };
    },
    yWgo: function (e, t, n) {
      "use strict";
      n.d(t, "Gb", function () {
        return u;
      }),
        n.d(t, "Fb", function () {
          return d;
        }),
        n.d(t, "J", function () {
          return p;
        }),
        n.d(t, "y", function () {
          return f;
        }),
        n.d(t, "x", function () {
          return h;
        }),
        n.d(t, "Q", function () {
          return y;
        }),
        n.d(t, "o", function () {
          return v;
        }),
        n.d(t, "h", function () {
          return g;
        }),
        n.d(t, "f", function () {
          return w;
        }),
        n.d(t, "p", function () {
          return x;
        }),
        n.d(t, "k", function () {
          return k;
        }),
        n.d(t, "i", function () {
          return O;
        }),
        n.d(t, "m", function () {
          return I;
        }),
        n.d(t, "l", function () {
          return S;
        }),
        n.d(t, "r", function () {
          return j;
        }),
        n.d(t, "q", function () {
          return T;
        }),
        n.d(t, "s", function () {
          return C;
        }),
        n.d(t, "n", function () {
          return M;
        }),
        n.d(t, "j", function () {
          return P;
        }),
        n.d(t, "H", function () {
          return E;
        }),
        n.d(t, "N", function () {
          return L;
        }),
        n.d(t, "db", function () {
          return m;
        }),
        n.d(t, "zb", function () {
          return B;
        }),
        n.d(t, "yb", function () {
          return N;
        }),
        n.d(t, "nb", function () {
          return D;
        }),
        n.d(t, "u", function () {
          return z;
        }),
        n.d(t, "M", function () {
          return R;
        }),
        n.d(t, "ub", function () {
          return F;
        }),
        n.d(t, "z", function () {
          return V;
        }),
        n.d(t, "xb", function () {
          return U;
        }),
        n.d(t, "ob", function () {
          return G;
        }),
        n.d(t, "vb", function () {
          return Y;
        }),
        n.d(t, "D", function () {
          return q;
        }),
        n.d(t, "wb", function () {
          return X;
        }),
        n.d(t, "E", function () {
          return Z;
        }),
        n.d(t, "lb", function () {
          return K;
        }),
        n.d(t, "pb", function () {
          return Q;
        }),
        n.d(t, "ib", function () {
          return J;
        }),
        n.d(t, "Z", function () {
          return $;
        }),
        n.d(t, "Ab", function () {
          return ee;
        }),
        n.d(t, "gb", function () {
          return te;
        }),
        n.d(t, "A", function () {
          return ne;
        }),
        n.d(t, "c", function () {
          return oe;
        }),
        n.d(t, "tb", function () {
          return ae;
        }),
        n.d(t, "Eb", function () {
          return re;
        }),
        n.d(t, "B", function () {
          return ie;
        }),
        n.d(t, "O", function () {
          return le;
        }),
        n.d(t, "L", function () {
          return se;
        }),
        n.d(t, "g", function () {
          return ce;
        }),
        n.d(t, "U", function () {
          return _e;
        }),
        n.d(t, "R", function () {
          return ue;
        }),
        n.d(t, "hb", function () {
          return de;
        }),
        n.d(t, "Hb", function () {
          return pe;
        }),
        n.d(t, "t", function () {
          return fe;
        }),
        n.d(t, "qb", function () {
          return he;
        }),
        n.d(t, "rb", function () {
          return me;
        }),
        n.d(t, "sb", function () {
          return ye;
        }),
        n.d(t, "b", function () {
          return be;
        }),
        n.d(t, "C", function () {
          return ve;
        }),
        n.d(t, "Bb", function () {
          return ge;
        }),
        n.d(t, "T", function () {
          return we;
        }),
        n.d(t, "G", function () {
          return xe;
        }),
        n.d(t, "V", function () {
          return ke;
        }),
        n.d(t, "Cb", function () {
          return Oe;
        }),
        n.d(t, "S", function () {
          return Ie;
        }),
        n.d(t, "Db", function () {
          return Se;
        }),
        n.d(t, "P", function () {
          return je;
        }),
        n.d(t, "fb", function () {
          return Te;
        }),
        n.d(t, "a", function () {
          return Ce;
        }),
        n.d(t, "kb", function () {
          return Me;
        }),
        n.d(t, "bb", function () {
          return Pe;
        }),
        n.d(t, "K", function () {
          return Ee;
        }),
        n.d(t, "F", function () {
          return Be;
        }),
        n.d(t, "w", function () {
          return Ne;
        }),
        n.d(t, "Y", function () {
          return De;
        }),
        n.d(t, "ab", function () {
          return ze;
        }),
        n.d(t, "W", function () {
          return Ae;
        }),
        n.d(t, "v", function () {
          return Re;
        }),
        n.d(t, "X", function () {
          return Fe;
        }),
        n.d(t, "eb", function () {
          return Ve;
        }),
        n.d(t, "jb", function () {
          return He;
        }),
        n.d(t, "I", function () {
          return We;
        }),
        n.d(t, "mb", function () {
          return Ue;
        }),
        n.d(t, "cb", function () {
          return Ge;
        }),
        n.d(t, "d", function () {
          return Ye;
        }),
        n.d(t, "e", function () {
          return qe;
        });
      var o = n("KQm4"),
        a = n("ODXe"),
        r = n("HaE+"),
        i = n("p46w"),
        l = n.n(i),
        s = n("dhHj"),
        c = n("ZO6J");
      function _() {
        _ = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function u(e, t, n, o) {
          var r = t && t.prototype instanceof b ? t : b,
            i = Object.create(r.prototype),
            l = new P(o || []);
          return a(i, "_invoke", { value: j(e, n, l) }), i;
        }
        function d(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = u;
        var p = "suspendedStart",
          f = "suspendedYield",
          h = "executing",
          m = "completed",
          y = {};
        function b() {}
        function v() {}
        function g() {}
        var w = {};
        c(w, i, function () {
          return this;
        });
        var x = Object.getPrototypeOf,
          k = x && x(x(E([])));
        k && k !== n && o.call(k, i) && (w = k);
        var O = (g.prototype = b.prototype = Object.create(w));
        function I(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function S(e, t) {
          function n(a, r, i, l) {
            var s = d(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function j(t, n, o) {
          var a = p;
          return function (r, i) {
            if (a === h) throw new Error("Generator is already running");
            if (a === m) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = T(l, o);
                if (s) {
                  if (s === y) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === p) throw ((a = m), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = h;
              var c = d(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? m : f), c.arg === y)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = m), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function T(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                T(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              y
            );
          var r = d(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), y
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                y)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              y);
        }
        function C(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function M(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(C, this),
            this.reset(!0);
        }
        function E(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (v.prototype = g),
          a(O, "constructor", { value: g, configurable: !0 }),
          a(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = c(g, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(O)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          I(S.prototype),
          c(S.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = S),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new S(u(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          I(O),
          c(O, s, "Generator"),
          c(O, i, function () {
            return this;
          }),
          c(O, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = E),
          (P.prototype = {
            constructor: P,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(M),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), y)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                y
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), M(n), y;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    M(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: E(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                y
              );
            },
          }),
          t
        );
      }
      function u(e) {
        return /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*\.){1,63}[a-z0-9]+$/.test(
          e,
        );
      }
      function d(e, t) {
        return ("zh-CN" === t ? /^1[3-9](\d{9})$/ : /^[0-9\-]+$/).test(e);
      }
      function p(e) {
        return "zh-CN" === e ? /^1[3-9](\d{9})$/ : /^[0-9\-]+$/;
      }
      function f(e, t, n) {
        return e ? t : n;
      }
      function h(e) {
        var t = l.a.get("lang"),
          n = "";
        if (e && "" !== e) {
          var o = e.split(" ")[0],
            a = o.split("-")[0],
            r = o.split("-")[1].startsWith("0")
              ? o.split("-")[1][1]
              : o.split("-")[1],
            i = o.split("-")[2].startsWith("0")
              ? o.split("-")[2][1]
              : o.split("-")[2];
          n =
            "zh-CN" === t
              ? ""
                  .concat(a, " \u5e74 ")
                  .concat(r, " \u6708 ")
                  .concat(i, " \u65e5")
              : ""
                  .concat(
                    [
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ][parseInt(r, 10) - 1],
                    " ",
                  )
                  .concat(i, ", ")
                  .concat(a);
        }
        return n;
      }
      var m = new s.Localize({ domain: ".dji.com" });
      var y = !0,
        b = "undefined" !== typeof document;
      function v() {
        if (y)
          return !!window.navigator.userAgent.match(
            /\bm?qqbrowser\/([0-9.]+)/gi,
          );
      }
      function g() {
        if (y) {
          var e = !1,
            t = window.navigator.userAgent,
            n = t.indexOf("MSIE "),
            o = t.indexOf("Trident/"),
            a = t.indexOf("Edge/");
          return (n > 0 || o > 0 || a > 0) && (e = !0), e;
        }
      }
      function w() {
        if (y) {
          var e = window.navigator.userAgent;
          return /firefox/i.test(e);
        }
      }
      function x() {
        if (y) {
          var e = window.navigator.userAgent;
          return /Safari/i.test(e) && !/Chrome/i.test(e);
        }
      }
      function k() {
        if (y) {
          var e = window.navigator.userAgent,
            t = "MacIntel" === window.navigator.platform || /Intel/i.test(e);
          return /Safari/i.test(e) && !/Chrome/i.test(e) && t;
        }
      }
      function O() {
        if (y) {
          var e = window.navigator.userAgent;
          return !!e.match(/iPad/i) || !!e.match(/iPhone/i);
        }
      }
      function I() {
        if (y) {
          var e = window.navigator.platform;
          return (
            -1 !== ["Macintosh", "MacIntel", "MacPPC", "Mac68K"].indexOf(e)
          );
        }
      }
      function S() {
        if (y) {
          var e = window.navigator.userAgent.toLowerCase(),
            t = !!e.match(/iPad/i) || !!e.match(/iPhone/i),
            n =
              -1 !== e.indexOf("safari") &&
              -1 === e.indexOf("crios") &&
              -1 === e.indexOf("browser") &&
              -1 === e.indexOf("fxios");
          return t && n;
        }
      }
      function j() {
        if (y) {
          var e = window.navigator.userAgent;
          if (!!e.match(/android/gi)) return !1;
          var t = /MicroMessenger/i.test(e),
            n = /Safari/i.test(e),
            o = /Chrome/i.test(e);
          return !((!n && !o) || t);
        }
      }
      function T() {
        if (y) return !!!window.navigator.userAgent.match(/UCBrowser/gi);
      }
      function C() {
        if (y) {
          var e = window.navigator.userAgent;
          return /MicroMessenger/i.test(e);
        }
      }
      function M() {
        if (y) {
          var e = window.location.hostname;
          return !(/stag/i.test(e) || /test/i.test(e));
        }
      }
      function P() {
        if (y) {
          var e = navigator.userAgent,
            t = -1 !== e.indexOf("Safari") && -1 !== e.indexOf("Version"),
            n = -1 !== e.indexOf("iPhone") && -1 !== e.indexOf("Version");
          return t && !n && "ontouchend" in document;
        }
      }
      function E() {
        return P()
          ? Math.max(window.screen.height, window.innerHeight)
          : window.innerHeight;
      }
      function L(e) {
        for (
          var t = window.location.search.substring(1).split("&"),
            n = 0,
            o = t.length;
          n < o;
          n++
        ) {
          var a = t[n].split("=");
          if (a[0] === e) return a[1];
        }
        return !1;
      }
      function B() {
        var e = window.navigator.userAgent,
          t = !!e.match(/MicroMessenger/gi),
          n = !!e.match(/iPad/i) || !!e.match(/iPhone/i),
          o = !!e.match(/UCBrowser/gi),
          a = !!e.match(/android/gi),
          r = !!e.match(/\bm?qqbrowser\/([0-9.]+)/gi),
          i = !!e.match(/DJI-App-Ios/gi),
          l = !!e.match(/DJI-App-pilot-go/gi),
          s = !!e.match(/djifly_ios/gi),
          c = !!e.match(/DJI-app-mimo/gi);
        return a || s || l || (n && (o || r || t || i || c));
      }
      function N(e, t) {
        e && (e.style.willChange = t);
      }
      function D(e) {
        e && (e.style.willChange = "auto");
      }
      function z(e) {
        return A.apply(this, arguments);
      }
      function A() {
        return (A = Object(r.default)(
          _().mark(function e(t) {
            var n, a, r, i, l, s, c;
            return _().wrap(function (e) {
              for (;;)
                switch ((e.prev = e.next)) {
                  case 0:
                    if (
                      ((n = t.XLSX),
                      (a = t.fileName),
                      (r = t.sheetName),
                      (i = t.header),
                      (l = t.body),
                      n)
                    ) {
                      e.next = 4;
                      break;
                    }
                    return (
                      console.error("\u7f3a\u5c11 XLSX \u63d2\u4ef6"),
                      e.abrupt("return")
                    );
                  case 4:
                    (s = n.utils.book_new()),
                      (c = n.utils.aoa_to_sheet([i].concat(Object(o.a)(l)))),
                      n.utils.book_append_sheet(s, c, r),
                      n.writeFile(s, a, {
                        bookType: "xlsx",
                        bookSST: !0,
                        type: "binary",
                      });
                  case 8:
                  case "end":
                    return e.stop();
                }
            }, e);
          }),
        )).apply(this, arguments);
      }
      function R() {
        var e = new Date(),
          t = "".concat(e.getMonth() + 1),
          n = "".concat(e.getDate());
        return (
          t.length < 2 && (t = "0".concat(t)),
          n.length < 2 && (n = "0".concat(n)),
          [t, n].join("")
        );
      }
      function F(e, t, n) {
        var o = new Date();
        o.setTime(o.getTime() + 24 * n * 60 * 60 * 1e3),
          (document.cookie = ""
            .concat(e, "=")
            .concat(t, "; expires=")
            .concat(o.toGMTString(), "; path=/"));
      }
      function V(e) {
        for (
          var t = "".concat(e, "="), n = document.cookie.split(";"), o = 0;
          o < n.length;
          o++
        ) {
          var a = n[o].trim();
          if (0 === a.indexOf(t)) return a.substring(t.length, a.length);
        }
        return "";
      }
      var H = "_ab_exp";
      function W(e) {
        document.cookie = ""
          .concat(H, "=")
          .concat(e, "; path=/; domain=")
          .concat(
            (function () {
              if (!y) return "";
              var e = window.location.hostname.split(".").reverse(),
                t = Object(a.a)(e, 2),
                n = t[0],
                o = t[1];
              return ".".concat(o, ".").concat(n);
            })(),
            "; max-age=",
          )
          .concat(7776e3);
      }
      function U() {
        var e = V(H),
          t = "";
        return (
          e
            ? ((t = e
                .replace("~pop-footer-subscribe-courtesy.A", "")
                .replace("~pop-footer-subscribe-courtesy.B", "")
                .replace("pop-footer-subscribe-courtesy.A", "")
                .replace("pop-footer-subscribe-courtesy.B", "")),
              (t += "~pop-footer-subscribe-courtesy.B"))
            : (t = "pop-footer-subscribe-courtesy.B"),
          W(t),
          e
        );
      }
      function G(e) {
        e && W(e);
      }
      function Y(e, t) {
        try {
          window.localStorage.setItem(e, t);
        } catch (n) {}
      }
      function q(e) {
        try {
          return window.localStorage.getItem(e);
        } catch (t) {
          return "";
        }
      }
      function X(e, t) {
        try {
          Y(e, JSON.stringify(t));
        } catch (n) {
          console.error(n);
        }
      }
      function Z(e) {
        try {
          var t = q(e);
          return JSON.parse(t);
        } catch (n) {
          return console.error(n), "";
        }
      }
      var K = function (e) {
          e = e || 32;
          for (
            var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
              n = t.length,
              o = "",
              a = 0;
            a < e;
            a++
          )
            o += t.charAt(Math.floor(Math.random() * n));
          return o;
        },
        Q = function (e) {
          "undefined" !== typeof document &&
            "function" === typeof e &&
            ("complete" !== document.readyState
              ? window.addEventListener("load", e)
              : e());
        },
        J = function (e) {
          return e >= 1 ? 1 : e <= 0 ? 0 : e;
        },
        $ = function (e) {
          return "number" === typeof e && !Number.isNaN(e);
        },
        ee = function (e, t) {
          var n = Math.pow(10, t || 2);
          return Math.round(e * n) / n;
        },
        te = function (e) {
          return e >= 1 ? 1 : e <= 0 ? 0 : ee(e, 3);
        },
        ne = function (e) {
          var t,
            n = e.windowWidth,
            o = e.windowHeight,
            a = e.videoWhRatio;
          if (!a) return 1;
          n / o < (a = +a) ? (t = o / (n / a)) : (t = n / (o * a));
          return t;
        },
        oe = function () {
          if ("undefined" !== typeof document) {
            var e = document.createElement("canvas");
            return (
              !(!e.getContext || !e.getContext("2d")) &&
              0 === e.toDataURL("image/webp").indexOf("data:image/webp")
            );
          }
        },
        ae = function () {
          "undefined" !== typeof document &&
            document.body &&
            (document.body.style.backgroundColor = "black");
        },
        re = function (e, t, n, o) {
          if (e && t && n && o) {
            var a = t.getContext("2d");
            a.clearRect(0, 0, n, o), a.drawImage(e, 0, 0, n, o);
          }
        },
        ie = function (e, t, n, o) {
          var a = oe();
          return {
            _address: a && o && "" !== n ? n : e,
            _format: a && o && "" !== n ? "webp" : t,
          };
        },
        le = function (e, t) {
          if (!Number.isNaN(e))
            return e % 1 === 0 ? e : parseFloat(e.toFixed(t));
        },
        se = function (e, t) {
          if (y && !t) {
            var n = new RegExp("(^|&)".concat(e, "=([^&]*)(&|$)"), "i"),
              o = window.location.search.substr(1).match(n),
              a = "";
            return null != o && (a = o[2]), a;
          }
        };
      function ce(e) {
        return Number(e) === e && e % 1 !== 0;
      }
      var _e = y && window.location.pathname.includes("/edit/"),
        ue = function (e, t) {
          "function" === typeof t &&
            y &&
            ((window.ABTest = window.ABTest || {}),
            (window.ABTest[e] = window.ABTest[e] || {}),
            (window.ABTest[e].waitingList = window.ABTest[e].waitingList || []),
            (window.ABTest[e].exec =
              window.ABTest[e].exec ||
              function () {
                for (
                  var t = window.ABTest[e].waitingList, n = 0;
                  n < t.length;
                  n++
                )
                  "function" === typeof t[n] && t[n]();
              }),
            window.ABTest[e].startFlag
              ? t()
              : window.ABTest[e].waitingList.push(t));
        },
        de = function (e) {
          return "string" === typeof e
            ? e
            : ("object" === typeof e && e && e.path) || "";
        },
        pe = function (e) {
          return "string" !== typeof e
            ? ""
            : /(s3\.amazonaws|djicdn\.com)/gi.test(e)
              ? e
              : "https://dji-official-fe.djicdn.com/".concat(e);
        },
        fe = function (e) {
          return /vimeo.com\/(\d+)/.test(e)
            ? "//player.vimeo.com/video/".concat(RegExp.$1)
            : /\.youku\.com\/player\.php\/sid\/(.+)\/v\.swf/.test(e)
              ? "https://player.youku.com/embed/".concat(RegExp.$1)
              : /\.youtube\.com\/watch\?v=(.+)/.test(e)
                ? "//www.youtube.com/embed/".concat(RegExp.$1)
                : /^https?:\/\//.test(e)
                  ? e.replace(/^https?:/, "")
                  : e;
        },
        he = function (e, t) {
          t = +t;
          var n = document.querySelector(".page-wrapper .sections-wrapper");
          if (n) {
            var o = n.clientWidth,
              a = (document.querySelectorAll(".".concat(e, " ._28KUW")) || [])[
                t
              ],
              r = document.querySelector(
                ".".concat(e, " .quark-tab-default-tab-bar"),
              ),
              i = document.querySelector(
                ".".concat(e, " .quark-tab-default-tab-container"),
              );
            if (a) {
              var l = -(a.offsetLeft - (o - a.offsetWidth) / 2),
                s = r.clientWidth;
              if (-l < 0 || 0 === t)
                return void i.scroll({ left: 0, behavior: "smooth" });
              if (l < o - s)
                return void i.scroll({
                  left: -(o - s - 48),
                  behavior: "smooth",
                });
              i.scroll({ left: -l, behavior: "smooth" });
            }
          }
        },
        me = function (e, t) {
          t = +t;
          var n = (document.querySelectorAll(".".concat(e, " ._28KUW")) || [])[
              t
            ],
            o = document.querySelector(
              ".".concat(e, " .quark-tab-default-tab-container"),
            );
          if (n && o) {
            var a = o.clientWidth / 2 - n.offsetLeft - n.clientWidth / 2;
            o.scroll({ left: -a, behavior: "smooth" });
          }
        },
        ye = function (e, t, n) {
          if (t && e) {
            var o = e.clientWidth / 2 - t.offsetLeft - t.clientWidth / 2;
            e.scroll({ left: -o, behavior: n || "smooth" });
          }
        },
        be = function (e, t) {
          var n,
            o = t - e,
            a = o > 0 ? o : -o;
          return (
            a < 8e-4
              ? (n = t)
              : ((o *= 0.2),
                (n = e),
                a >= 0.03
                  ? (o = o > 0 ? 0.015 : -0.015)
                  : a < 0.03 && a >= 0.002
                    ? (o = o > 0 ? 0.002 : -0.002)
                    : a < 8e-4 && (o = o > 0 ? 8e-4 : -8e-4),
                (n += o)),
            n > 1 ? (n = 1) : n < 0 && (n = 0),
            n
          );
        },
        ve = function (e) {
          var t = +(e || "").replace("px", "");
          return t && !Number.isNaN(t)
            ? t >= 18
              ? "-0.03em"
              : "-0.02em"
            : void 0;
        },
        ge = function () {
          if (y)
            try {
              window.dispatchEvent(new CustomEvent("scroll"));
            } catch (e) {}
        },
        we = function (e) {
          return e.match(/^floatButton$|^supportFloating$|^setScript$/);
        },
        xe = function e(t) {
          var n = [];
          return (
            Object.keys(t).forEach(function (a) {
              if (t[a].type && "number" === t[a].type) n.push(a);
              else if (t[a].props) {
                var r = e(t[a].props);
                n.push.apply(n, Object(o.a)(r));
              }
            }),
            n
          );
        },
        ke = function () {
          return !!window.navigator.userAgent.match(/iPhone OS 16/i);
        };
      function Oe(e) {
        var t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
        return Math.floor(e * Math.pow(10, t)) / Math.pow(10, t);
      }
      function Ie(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (e > t) return [];
        for (
          var o = [], a = [], r = 0, i = t - e + 1, l = Math.floor(i / 2);
          l >= 1;

        ) {
          for (var s = 0, c = e; c <= t; c += l)
            o.includes(c) || (o.push(c), (s += 1));
          var _ = o.slice(r, o.length);
          a.push(_), (r += s), (l = Math.floor(l / 2));
        }
        return n ? a : o;
      }
      var Se = function (e) {
        return Array.isArray(e) ? Array.from(new Set(e)) : [];
      };
      function je(e) {
        return !c.a.includes(e);
      }
      var Te = function (e, t) {
          return e || t;
        },
        Ce = function (e, t) {
          return e && t;
        },
        Me = function (e, t, n) {
          return e ? t : n;
        },
        Pe = function (e, t) {
          return t(e) === "key::".concat(e);
        },
        Ee = function (e, t) {
          return Pe(e, t) ? "" : t(e);
        },
        Le = {
          en: "en_US",
          "zh-CN": "zh_CN",
          "zh-TW": "zh_TW",
          ja: "ja_JP",
          ko: "ko_KR",
          fr: "fr_FR",
          de: "DE_DE",
          es: "es_ES",
          it: "it_IT",
        },
        Be = function (e) {
          return Le[e];
        },
        Ne = function (e) {
          if (e) return e.replace(/(<([^>]+)>)/gi, "");
        },
        De = function (e) {
          if (!e) return !1;
          return ["infoCardVertical"].some(function (t) {
            return -1 !== e.indexOf(t);
          });
        },
        ze = function () {
          return (
            window.location.pathname.includes("/trailer") ||
            window.location.pathname.includes("/teaser")
          );
        },
        Ae = function () {
          return window.location.pathname.includes("/live/");
        },
        Re = function (e) {
          var t = {};
          return (
            Object.keys(e || {}).forEach(function (n) {
              var o = e[n];
              o && (t[n] = o);
            }),
            t
          );
        },
        Fe = function () {
          return window.location.href.includes("/mobile");
        },
        Ve = function (e) {
          b &&
            "function" === typeof e &&
            ("complete" === document.readyState
              ? e()
              : document.addEventListener("readystatechange", function () {
                  "complete" === document.readyState && e();
                }));
        },
        He = function (e) {
          e.isPlaying && e.pause();
        },
        We = function (e) {
          for (
            var t =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : 1,
              n = [],
              o = 0;
            o < t && e && (e && e.id && n.push(e.id), e.parentNode);
            o++
          )
            e = e.parentNode;
          return n;
        };
      function Ue(e) {
        return parseInt(e, 10);
      }
      var Ge = function () {
        return -1 !== window.navigator.appVersion.indexOf("Win");
      };
      function Ye() {
        var e = window.navigator.userAgent;
        if ("undefined" !== typeof e) return !!e.match(/android/gi);
      }
      function qe() {
        var e = window.navigator.userAgent;
        if ("undefined" !== typeof e)
          return -1 !== e.indexOf("Edge/") || -1 !== e.indexOf("Edg/");
      }
    },
    ycFn: function (e, t, n) {
      "use strict";
      var o = n("TqRt");
      (t.__esModule = !0),
        (t.default = function (e, t) {
          e.classList
            ? e.classList.add(t)
            : (0, a.default)(e, t) ||
              ("string" === typeof e.className
                ? (e.className = e.className + " " + t)
                : e.setAttribute(
                    "class",
                    ((e.className && e.className.baseVal) || "") + " " + t,
                  ));
        });
      var a = o(n("yD6e"));
      e.exports = t.default;
    },
    "z/o8": function (e, t, n) {
      "use strict";
      function o(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called",
          );
        return e;
      }
      function a(e, t) {
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          (e.__proto__ = t);
      }
      n.d(t, "a", function () {
        return Ao;
      });
      var r,
        i,
        l,
        s,
        c,
        _,
        u,
        d,
        p,
        f,
        h,
        m = {
          autoSleep: 120,
          force3D: "auto",
          nullTargetWarn: 1,
          units: { lineHeight: "" },
        },
        y = { duration: 0.5, overwrite: !1, delay: 0 },
        b = 1e-8,
        v = 2 * Math.PI,
        g = v / 4,
        w = 0,
        x = Math.sqrt,
        k = Math.cos,
        O = Math.sin,
        I = function (e) {
          return "string" === typeof e;
        },
        S = function (e) {
          return "function" === typeof e;
        },
        j = function (e) {
          return "number" === typeof e;
        },
        T = function (e) {
          return "undefined" === typeof e;
        },
        C = function (e) {
          return "object" === typeof e;
        },
        M = function (e) {
          return !1 !== e;
        },
        P = function () {
          return "undefined" !== typeof window;
        },
        E = function (e) {
          return S(e) || I(e);
        },
        L =
          ("function" === typeof ArrayBuffer && ArrayBuffer.isView) ||
          function () {},
        B = Array.isArray,
        N = /(?:-?\.?\d|\.)+/gi,
        D = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
        z = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
        A = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
        R = /[+-]=-?[.\d]+/,
        F = /[^,'"\[\]\s]+/gi,
        V = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
        H = {},
        W = {},
        U = function (e) {
          return (W = ve(e, H)) && gn;
        },
        G = function (e, t) {
          return console.warn(
            "Invalid property",
            e,
            "set to",
            t,
            "Missing plugin? gsap.registerPlugin()",
          );
        },
        Y = function (e, t) {
          return !t && console.warn(e);
        },
        q = function (e, t) {
          return (e && (H[e] = t) && W && (W[e] = t)) || H;
        },
        X = function () {
          return 0;
        },
        Z = { suppressEvents: !0, isStart: !0, kill: !1 },
        K = { suppressEvents: !0, kill: !1 },
        Q = { suppressEvents: !0 },
        J = {},
        $ = [],
        ee = {},
        te = {},
        ne = {},
        oe = 30,
        ae = [],
        re = "",
        ie = function (e) {
          var t,
            n,
            o = e[0];
          if ((C(o) || S(o) || (e = [e]), !(t = (o._gsap || {}).harness))) {
            for (n = ae.length; n-- && !ae[n].targetTest(o); );
            t = ae[n];
          }
          for (n = e.length; n--; )
            (e[n] && (e[n]._gsap || (e[n]._gsap = new Lt(e[n], t)))) ||
              e.splice(n, 1);
          return e;
        },
        le = function (e) {
          return e._gsap || ie(Qe(e))[0]._gsap;
        },
        se = function (e, t, n) {
          return (n = e[t]) && S(n)
            ? e[t]()
            : (T(n) && e.getAttribute && e.getAttribute(t)) || n;
        },
        ce = function (e, t) {
          return (e = e.split(",")).forEach(t) || e;
        },
        _e = function (e) {
          return Math.round(1e5 * e) / 1e5 || 0;
        },
        ue = function (e) {
          return Math.round(1e7 * e) / 1e7 || 0;
        },
        de = function (e, t) {
          var n = t.charAt(0),
            o = parseFloat(t.substr(2));
          return (
            (e = parseFloat(e)),
            "+" === n ? e + o : "-" === n ? e - o : "*" === n ? e * o : e / o
          );
        },
        pe = function (e, t) {
          for (var n = t.length, o = 0; e.indexOf(t[o]) < 0 && ++o < n; );
          return o < n;
        },
        fe = function () {
          var e,
            t,
            n = $.length,
            o = $.slice(0);
          for (ee = {}, $.length = 0, e = 0; e < n; e++)
            (t = o[e]) &&
              t._lazy &&
              (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
        },
        he = function (e, t, n, o) {
          $.length && !i && fe(),
            e.render(t, n, o || (i && t < 0 && (e._initted || e._startAt))),
            $.length && !i && fe();
        },
        me = function (e) {
          var t = parseFloat(e);
          return (t || 0 === t) && (e + "").match(F).length < 2
            ? t
            : I(e)
              ? e.trim()
              : e;
        },
        ye = function (e) {
          return e;
        },
        be = function (e, t) {
          for (var n in t) n in e || (e[n] = t[n]);
          return e;
        },
        ve = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        ge = function e(t, n) {
          for (var o in n)
            "__proto__" !== o &&
              "constructor" !== o &&
              "prototype" !== o &&
              (t[o] = C(n[o]) ? e(t[o] || (t[o] = {}), n[o]) : n[o]);
          return t;
        },
        we = function (e, t) {
          var n,
            o = {};
          for (n in e) n in t || (o[n] = e[n]);
          return o;
        },
        xe = function (e) {
          var t,
            n = e.parent || s,
            o = e.keyframes
              ? ((t = B(e.keyframes)),
                function (e, n) {
                  for (var o in n)
                    o in e ||
                      ("duration" === o && t) ||
                      "ease" === o ||
                      (e[o] = n[o]);
                })
              : be;
          if (M(e.inherit))
            for (; n; ) o(e, n.vars.defaults), (n = n.parent || n._dp);
          return e;
        },
        ke = function (e, t, n, o, a) {
          void 0 === n && (n = "_first"), void 0 === o && (o = "_last");
          var r,
            i = e[o];
          if (a) for (r = t[a]; i && i[a] > r; ) i = i._prev;
          return (
            i
              ? ((t._next = i._next), (i._next = t))
              : ((t._next = e[n]), (e[n] = t)),
            t._next ? (t._next._prev = t) : (e[o] = t),
            (t._prev = i),
            (t.parent = t._dp = e),
            t
          );
        },
        Oe = function (e, t, n, o) {
          void 0 === n && (n = "_first"), void 0 === o && (o = "_last");
          var a = t._prev,
            r = t._next;
          a ? (a._next = r) : e[n] === t && (e[n] = r),
            r ? (r._prev = a) : e[o] === t && (e[o] = a),
            (t._next = t._prev = t.parent = null);
        },
        Ie = function (e, t) {
          e.parent &&
            (!t || e.parent.autoRemoveChildren) &&
            e.parent.remove &&
            e.parent.remove(e),
            (e._act = 0);
        },
        Se = function (e, t) {
          if (e && (!t || t._end > e._dur || t._start < 0))
            for (var n = e; n; ) (n._dirty = 1), (n = n.parent);
          return e;
        },
        je = function (e) {
          for (var t = e.parent; t && t.parent; )
            (t._dirty = 1), t.totalDuration(), (t = t.parent);
          return e;
        },
        Te = function (e, t, n, o) {
          return (
            e._startAt &&
            (i
              ? e._startAt.revert(K)
              : (e.vars.immediateRender && !e.vars.autoRevert) ||
                e._startAt.render(t, !0, o))
          );
        },
        Ce = function e(t) {
          return !t || (t._ts && e(t.parent));
        },
        Me = function (e) {
          return e._repeat
            ? Pe(e._tTime, (e = e.duration() + e._rDelay)) * e
            : 0;
        },
        Pe = function (e, t) {
          var n = Math.floor((e /= t));
          return e && n === e ? n - 1 : n;
        },
        Ee = function (e, t) {
          return (
            (e - t._start) * t._ts +
            (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur)
          );
        },
        Le = function (e) {
          return (e._end = ue(
            e._start + (e._tDur / Math.abs(e._ts || e._rts || b) || 0),
          ));
        },
        Be = function (e, t) {
          var n = e._dp;
          return (
            n &&
              n.smoothChildTiming &&
              e._ts &&
              ((e._start = ue(
                n._time -
                  (e._ts > 0
                    ? t / e._ts
                    : ((e._dirty ? e.totalDuration() : e._tDur) - t) / -e._ts),
              )),
              Le(e),
              n._dirty || Se(n, e)),
            e
          );
        },
        Ne = function (e, t) {
          var n;
          if (
            ((t._time ||
              (!t._dur && t._initted) ||
              (t._start < e._time && (t._dur || !t.add))) &&
              ((n = Ee(e.rawTime(), t)),
              (!t._dur || Ye(0, t.totalDuration(), n) - t._tTime > b) &&
                t.render(n, !0)),
            Se(e, t)._dp && e._initted && e._time >= e._dur && e._ts)
          ) {
            if (e._dur < e.duration())
              for (n = e; n._dp; )
                n.rawTime() >= 0 && n.totalTime(n._tTime), (n = n._dp);
            e._zTime = -b;
          }
        },
        De = function (e, t, n, o) {
          return (
            t.parent && Ie(t),
            (t._start = ue(
              (j(n) ? n : n || e !== s ? We(e, n, t) : e._time) + t._delay,
            )),
            (t._end = ue(
              t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0),
            )),
            ke(e, t, "_first", "_last", e._sort ? "_start" : 0),
            Re(t) || (e._recent = t),
            o || Ne(e, t),
            e._ts < 0 && Be(e, e._tTime),
            e
          );
        },
        ze = function (e, t) {
          return (
            (H.ScrollTrigger || G("scrollTrigger", t)) &&
            H.ScrollTrigger.create(t, e)
          );
        },
        Ae = function (e, t, n, o, a) {
          return (
            Vt(e, t, a),
            e._initted
              ? !n &&
                e._pt &&
                !i &&
                ((e._dur && !1 !== e.vars.lazy) || (!e._dur && e.vars.lazy)) &&
                p !== gt.frame
                ? ($.push(e), (e._lazy = [a, o]), 1)
                : void 0
              : 1
          );
        },
        Re = function (e) {
          var t = e.data;
          return "isFromStart" === t || "isStart" === t;
        },
        Fe = function (e, t, n, o) {
          var a = e._repeat,
            r = ue(t) || 0,
            i = e._tTime / e._tDur;
          return (
            i && !o && (e._time *= r / e._dur),
            (e._dur = r),
            (e._tDur = a
              ? a < 0
                ? 1e10
                : ue(r * (a + 1) + e._rDelay * a)
              : r),
            i > 0 && !o && Be(e, (e._tTime = e._tDur * i)),
            e.parent && Le(e),
            n || Se(e.parent, e),
            e
          );
        },
        Ve = function (e) {
          return e instanceof Nt ? Se(e) : Fe(e, e._dur);
        },
        He = { _start: 0, endTime: X, totalDuration: X },
        We = function e(t, n, o) {
          var a,
            r,
            i,
            l = t.labels,
            s = t._recent || He,
            c = t.duration() >= 1e8 ? s.endTime(!1) : t._dur;
          return I(n) && (isNaN(n) || n in l)
            ? ((r = n.charAt(0)),
              (i = "%" === n.substr(-1)),
              (a = n.indexOf("=")),
              "<" === r || ">" === r
                ? (a >= 0 && (n = n.replace(/=/, "")),
                  ("<" === r ? s._start : s.endTime(s._repeat >= 0)) +
                    (parseFloat(n.substr(1)) || 0) *
                      (i ? (a < 0 ? s : o).totalDuration() / 100 : 1))
                : a < 0
                  ? (n in l || (l[n] = c), l[n])
                  : ((r = parseFloat(n.charAt(a - 1) + n.substr(a + 1))),
                    i &&
                      o &&
                      (r = (r / 100) * (B(o) ? o[0] : o).totalDuration()),
                    a > 1 ? e(t, n.substr(0, a - 1), o) + r : c + r))
            : null == n
              ? c
              : +n;
        },
        Ue = function (e, t, n) {
          var o,
            a,
            r = j(t[1]),
            i = (r ? 2 : 1) + (e < 2 ? 0 : 1),
            l = t[i];
          if ((r && (l.duration = t[1]), (l.parent = n), e)) {
            for (o = l, a = n; a && !("immediateRender" in o); )
              (o = a.vars.defaults || {}), (a = M(a.vars.inherit) && a.parent);
            (l.immediateRender = M(o.immediateRender)),
              e < 2 ? (l.runBackwards = 1) : (l.startAt = t[i - 1]);
          }
          return new Yt(t[0], l, t[i + 1]);
        },
        Ge = function (e, t) {
          return e || 0 === e ? t(e) : t;
        },
        Ye = function (e, t, n) {
          return n < e ? e : n > t ? t : n;
        },
        qe = function (e, t) {
          return I(e) && (t = V.exec(e)) ? t[1] : "";
        },
        Xe = [].slice,
        Ze = function (e, t) {
          return (
            e &&
            C(e) &&
            "length" in e &&
            ((!t && !e.length) || (e.length - 1 in e && C(e[0]))) &&
            !e.nodeType &&
            e !== c
          );
        },
        Ke = function (e, t, n) {
          return (
            void 0 === n && (n = []),
            e.forEach(function (e) {
              var o;
              return (I(e) && !t) || Ze(e, 1)
                ? (o = n).push.apply(o, Qe(e))
                : n.push(e);
            }) || n
          );
        },
        Qe = function (e, t, n) {
          return l && !t && l.selector
            ? l.selector(e)
            : !I(e) || n || (!_ && wt())
              ? B(e)
                ? Ke(e, n)
                : Ze(e)
                  ? Xe.call(e, 0)
                  : e
                    ? [e]
                    : []
              : Xe.call((t || u).querySelectorAll(e), 0);
        },
        Je = function (e) {
          return (
            (e = Qe(e)[0] || Y("Invalid scope") || {}),
            function (t) {
              var n = e.current || e.nativeElement || e;
              return Qe(
                t,
                n.querySelectorAll
                  ? n
                  : n === e
                    ? Y("Invalid scope") || u.createElement("div")
                    : e,
              );
            }
          );
        },
        $e = function (e) {
          return e.sort(function () {
            return 0.5 - Math.random();
          });
        },
        et = function (e) {
          if (S(e)) return e;
          var t = C(e) ? e : { each: e },
            n = Tt(t.ease),
            o = t.from || 0,
            a = parseFloat(t.base) || 0,
            r = {},
            i = o > 0 && o < 1,
            l = isNaN(o) || i,
            s = t.axis,
            c = o,
            _ = o;
          return (
            I(o)
              ? (c = _ = { center: 0.5, edges: 0.5, end: 1 }[o] || 0)
              : !i && l && ((c = o[0]), (_ = o[1])),
            function (e, i, u) {
              var d,
                p,
                f,
                h,
                m,
                y,
                b,
                v,
                g,
                w = (u || t).length,
                k = r[w];
              if (!k) {
                if (!(g = "auto" === t.grid ? 0 : (t.grid || [1, 1e8])[1])) {
                  for (
                    b = -1e8;
                    b < (b = u[g++].getBoundingClientRect().left) && g < w;

                  );
                  g--;
                }
                for (
                  k = r[w] = [],
                    d = l ? Math.min(g, w) * c - 0.5 : o % g,
                    p = 1e8 === g ? 0 : l ? (w * _) / g - 0.5 : (o / g) | 0,
                    b = 0,
                    v = 1e8,
                    y = 0;
                  y < w;
                  y++
                )
                  (f = (y % g) - d),
                    (h = p - ((y / g) | 0)),
                    (k[y] = m =
                      s ? Math.abs("y" === s ? h : f) : x(f * f + h * h)),
                    m > b && (b = m),
                    m < v && (v = m);
                "random" === o && $e(k),
                  (k.max = b - v),
                  (k.min = v),
                  (k.v = w =
                    (parseFloat(t.amount) ||
                      parseFloat(t.each) *
                        (g > w
                          ? w - 1
                          : s
                            ? "y" === s
                              ? w / g
                              : g
                            : Math.max(g, w / g)) ||
                      0) * ("edges" === o ? -1 : 1)),
                  (k.b = w < 0 ? a - w : a),
                  (k.u = qe(t.amount || t.each) || 0),
                  (n = n && w < 0 ? St(n) : n);
              }
              return (
                (w = (k[e] - k.min) / k.max || 0),
                ue(k.b + (n ? n(w) : w) * k.v) + k.u
              );
            }
          );
        },
        tt = function (e) {
          var t = Math.pow(10, ((e + "").split(".")[1] || "").length);
          return function (n) {
            var o = ue(Math.round(parseFloat(n) / e) * e * t);
            return (o - (o % 1)) / t + (j(n) ? 0 : qe(n));
          };
        },
        nt = function (e, t) {
          var n,
            o,
            a = B(e);
          return (
            !a &&
              C(e) &&
              ((n = a = e.radius || 1e8),
              e.values
                ? ((e = Qe(e.values)), (o = !j(e[0])) && (n *= n))
                : (e = tt(e.increment))),
            Ge(
              t,
              a
                ? S(e)
                  ? function (t) {
                      return (o = e(t)), Math.abs(o - t) <= n ? o : t;
                    }
                  : function (t) {
                      for (
                        var a,
                          r,
                          i = parseFloat(o ? t.x : t),
                          l = parseFloat(o ? t.y : 0),
                          s = 1e8,
                          c = 0,
                          _ = e.length;
                        _--;

                      )
                        (a = o
                          ? (a = e[_].x - i) * a + (r = e[_].y - l) * r
                          : Math.abs(e[_] - i)) < s && ((s = a), (c = _));
                      return (
                        (c = !n || s <= n ? e[c] : t),
                        o || c === t || j(t) ? c : c + qe(t)
                      );
                    }
                : tt(e),
            )
          );
        },
        ot = function (e, t, n, o) {
          return Ge(B(e) ? !t : !0 === n ? !!(n = 0) : !o, function () {
            return B(e)
              ? e[~~(Math.random() * e.length)]
              : (n = n || 1e-5) &&
                  (o = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) &&
                  Math.floor(
                    Math.round(
                      (e - n / 2 + Math.random() * (t - e + 0.99 * n)) / n,
                    ) *
                      n *
                      o,
                  ) / o;
          });
        },
        at = function (e, t, n) {
          return Ge(n, function (n) {
            return e[~~t(n)];
          });
        },
        rt = function (e) {
          for (var t, n, o, a, r = 0, i = ""; ~(t = e.indexOf("random(", r)); )
            (o = e.indexOf(")", t)),
              (a = "[" === e.charAt(t + 7)),
              (n = e.substr(t + 7, o - t - 7).match(a ? F : N)),
              (i +=
                e.substr(r, t - r) +
                ot(a ? n : +n[0], a ? 0 : +n[1], +n[2] || 1e-5)),
              (r = o + 1);
          return i + e.substr(r, e.length - r);
        },
        it = function (e, t, n, o, a) {
          var r = t - e,
            i = o - n;
          return Ge(a, function (t) {
            return n + (((t - e) / r) * i || 0);
          });
        },
        lt = function (e, t, n) {
          var o,
            a,
            r,
            i = e.labels,
            l = 1e8;
          for (o in i)
            (a = i[o] - t) < 0 === !!n &&
              a &&
              l > (a = Math.abs(a)) &&
              ((r = o), (l = a));
          return r;
        },
        st = function (e, t, n) {
          var o,
            a,
            r,
            i = e.vars,
            s = i[t],
            c = l,
            _ = e._ctx;
          if (s)
            return (
              (o = i[t + "Params"]),
              (a = i.callbackScope || e),
              n && $.length && fe(),
              _ && (l = _),
              (r = o ? s.apply(a, o) : s.call(a)),
              (l = c),
              r
            );
        },
        ct = function (e) {
          return (
            Ie(e),
            e.scrollTrigger && e.scrollTrigger.kill(!!i),
            e.progress() < 1 && st(e, "onInterrupt"),
            e
          );
        },
        _t = [],
        ut = function (e) {
          if (P() && e) {
            var t = (e = (!e.name && e.default) || e).name,
              n = S(e),
              o =
                t && !n && e.init
                  ? function () {
                      this._props = [];
                    }
                  : e,
              a = {
                init: X,
                render: tn,
                add: Rt,
                kill: on,
                modifier: nn,
                rawVars: 0,
              },
              r = {
                targetTest: 0,
                get: 0,
                getSetter: Qt,
                aliases: {},
                register: 0,
              };
            if ((wt(), e !== o)) {
              if (te[t]) return;
              be(o, be(we(e, a), r)),
                ve(o.prototype, ve(a, we(e, r))),
                (te[(o.prop = t)] = o),
                e.targetTest && (ae.push(o), (J[t] = 1)),
                (t =
                  ("css" === t
                    ? "CSS"
                    : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin");
            }
            q(t, o), e.register && e.register(gn, o, ln);
          } else e && _t.push(e);
        },
        dt = {
          aqua: [0, 255, 255],
          lime: [0, 255, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, 255],
          navy: [0, 0, 128],
          white: [255, 255, 255],
          olive: [128, 128, 0],
          yellow: [255, 255, 0],
          orange: [255, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [255, 0, 0],
          pink: [255, 192, 203],
          cyan: [0, 255, 255],
          transparent: [255, 255, 255, 0],
        },
        pt = function (e, t, n) {
          return (
            (255 *
              (6 * (e += e < 0 ? 1 : e > 1 ? -1 : 0) < 1
                ? t + (n - t) * e * 6
                : e < 0.5
                  ? n
                  : 3 * e < 2
                    ? t + (n - t) * (2 / 3 - e) * 6
                    : t) +
              0.5) |
            0
          );
        },
        ft = function (e, t, n) {
          var o,
            a,
            r,
            i,
            l,
            s,
            c,
            _,
            u,
            d,
            p = e ? (j(e) ? [e >> 16, (e >> 8) & 255, 255 & e] : 0) : dt.black;
          if (!p) {
            if (
              ("," === e.substr(-1) && (e = e.substr(0, e.length - 1)), dt[e])
            )
              p = dt[e];
            else if ("#" === e.charAt(0)) {
              if (
                (e.length < 6 &&
                  ((o = e.charAt(1)),
                  (a = e.charAt(2)),
                  (r = e.charAt(3)),
                  (e =
                    "#" +
                    o +
                    o +
                    a +
                    a +
                    r +
                    r +
                    (5 === e.length ? e.charAt(4) + e.charAt(4) : ""))),
                9 === e.length)
              )
                return [
                  (p = parseInt(e.substr(1, 6), 16)) >> 16,
                  (p >> 8) & 255,
                  255 & p,
                  parseInt(e.substr(7), 16) / 255,
                ];
              p = [
                (e = parseInt(e.substr(1), 16)) >> 16,
                (e >> 8) & 255,
                255 & e,
              ];
            } else if ("hsl" === e.substr(0, 3))
              if (((p = d = e.match(N)), t)) {
                if (~e.indexOf("="))
                  return (p = e.match(D)), n && p.length < 4 && (p[3] = 1), p;
              } else
                (i = (+p[0] % 360) / 360),
                  (l = +p[1] / 100),
                  (o =
                    2 * (s = +p[2] / 100) -
                    (a = s <= 0.5 ? s * (l + 1) : s + l - s * l)),
                  p.length > 3 && (p[3] *= 1),
                  (p[0] = pt(i + 1 / 3, o, a)),
                  (p[1] = pt(i, o, a)),
                  (p[2] = pt(i - 1 / 3, o, a));
            else p = e.match(N) || dt.transparent;
            p = p.map(Number);
          }
          return (
            t &&
              !d &&
              ((o = p[0] / 255),
              (a = p[1] / 255),
              (r = p[2] / 255),
              (s = ((c = Math.max(o, a, r)) + (_ = Math.min(o, a, r))) / 2),
              c === _
                ? (i = l = 0)
                : ((u = c - _),
                  (l = s > 0.5 ? u / (2 - c - _) : u / (c + _)),
                  (i =
                    c === o
                      ? (a - r) / u + (a < r ? 6 : 0)
                      : c === a
                        ? (r - o) / u + 2
                        : (o - a) / u + 4),
                  (i *= 60)),
              (p[0] = ~~(i + 0.5)),
              (p[1] = ~~(100 * l + 0.5)),
              (p[2] = ~~(100 * s + 0.5))),
            n && p.length < 4 && (p[3] = 1),
            p
          );
        },
        ht = function (e) {
          var t = [],
            n = [],
            o = -1;
          return (
            e.split(yt).forEach(function (e) {
              var a = e.match(z) || [];
              t.push.apply(t, a), n.push((o += a.length + 1));
            }),
            (t.c = n),
            t
          );
        },
        mt = function (e, t, n) {
          var o,
            a,
            r,
            i,
            l = "",
            s = (e + l).match(yt),
            c = t ? "hsla(" : "rgba(",
            _ = 0;
          if (!s) return e;
          if (
            ((s = s.map(function (e) {
              return (
                (e = ft(e, t, 1)) &&
                c +
                  (t
                    ? e[0] + "," + e[1] + "%," + e[2] + "%," + e[3]
                    : e.join(",")) +
                  ")"
              );
            })),
            n && ((r = ht(e)), (o = n.c).join(l) !== r.c.join(l)))
          )
            for (i = (a = e.replace(yt, "1").split(z)).length - 1; _ < i; _++)
              l +=
                a[_] +
                (~o.indexOf(_)
                  ? s.shift() || c + "0,0,0,0)"
                  : (r.length ? r : s.length ? s : n).shift());
          if (!a)
            for (i = (a = e.split(yt)).length - 1; _ < i; _++) l += a[_] + s[_];
          return l + a[i];
        },
        yt = (function () {
          var e,
            t =
              "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
          for (e in dt) t += "|" + e + "\\b";
          return new RegExp(t + ")", "gi");
        })(),
        bt = /hsl[a]?\(/,
        vt = function (e) {
          var t,
            n = e.join(" ");
          if (((yt.lastIndex = 0), yt.test(n)))
            return (
              (t = bt.test(n)),
              (e[1] = mt(e[1], t)),
              (e[0] = mt(e[0], t, ht(e[1]))),
              !0
            );
        },
        gt = (function () {
          var e,
            t,
            n,
            o,
            a,
            r,
            i = Date.now,
            l = 500,
            s = 33,
            p = i(),
            f = p,
            m = 1e3 / 240,
            y = m,
            b = [],
            v = function n(c) {
              var _,
                u,
                d,
                h,
                v = i() - f,
                g = !0 === c;
              if (
                (v > l && (p += v - s),
                ((_ = (d = (f += v) - p) - y) > 0 || g) &&
                  ((h = ++o.frame),
                  (a = d - 1e3 * o.time),
                  (o.time = d /= 1e3),
                  (y += _ + (_ >= m ? 4 : m - _)),
                  (u = 1)),
                g || (e = t(n)),
                u)
              )
                for (r = 0; r < b.length; r++) b[r](d, a, h, c);
            };
          return (o = {
            time: 0,
            frame: 0,
            tick: function () {
              v(!0);
            },
            deltaRatio: function (e) {
              return a / (1e3 / (e || 60));
            },
            wake: function () {
              d &&
                (!_ &&
                  P() &&
                  ((c = _ = window),
                  (u = c.document || {}),
                  (H.gsap = gn),
                  (c.gsapVersions || (c.gsapVersions = [])).push(gn.version),
                  U(W || c.GreenSockGlobals || (!c.gsap && c) || {}),
                  (n = c.requestAnimationFrame),
                  _t.forEach(ut)),
                e && o.sleep(),
                (t =
                  n ||
                  function (e) {
                    return setTimeout(e, (y - 1e3 * o.time + 1) | 0);
                  }),
                (h = 1),
                v(2));
            },
            sleep: function () {
              (n ? c.cancelAnimationFrame : clearTimeout)(e), (h = 0), (t = X);
            },
            lagSmoothing: function (e, t) {
              (l = e || 1 / 0), (s = Math.min(t || 33, l));
            },
            fps: function (e) {
              (m = 1e3 / (e || 240)), (y = 1e3 * o.time + m);
            },
            add: function (e, t, n) {
              var a = t
                ? function (t, n, r, i) {
                    e(t, n, r, i), o.remove(a);
                  }
                : e;
              return o.remove(e), b[n ? "unshift" : "push"](a), wt(), a;
            },
            remove: function (e, t) {
              ~(t = b.indexOf(e)) && b.splice(t, 1) && r >= t && r--;
            },
            _listeners: b,
          });
        })(),
        wt = function () {
          return !h && gt.wake();
        },
        xt = {},
        kt = /^[\d.\-M][\d.\-,\s]/,
        Ot = /["']/g,
        It = function (e) {
          for (
            var t,
              n,
              o,
              a = {},
              r = e.substr(1, e.length - 3).split(":"),
              i = r[0],
              l = 1,
              s = r.length;
            l < s;
            l++
          )
            (n = r[l]),
              (t = l !== s - 1 ? n.lastIndexOf(",") : n.length),
              (o = n.substr(0, t)),
              (a[i] = isNaN(o) ? o.replace(Ot, "").trim() : +o),
              (i = n.substr(t + 1).trim());
          return a;
        },
        St = function (e) {
          return function (t) {
            return 1 - e(1 - t);
          };
        },
        jt = function e(t, n) {
          for (var o, a = t._first; a; )
            a instanceof Nt
              ? e(a, n)
              : !a.vars.yoyoEase ||
                (a._yoyo && a._repeat) ||
                a._yoyo === n ||
                (a.timeline
                  ? e(a.timeline, n)
                  : ((o = a._ease),
                    (a._ease = a._yEase),
                    (a._yEase = o),
                    (a._yoyo = n))),
              (a = a._next);
        },
        Tt = function (e, t) {
          return (
            (e &&
              (S(e)
                ? e
                : xt[e] ||
                  (function (e) {
                    var t = (e + "").split("("),
                      n = xt[t[0]];
                    return n && t.length > 1 && n.config
                      ? n.config.apply(
                          null,
                          ~e.indexOf("{")
                            ? [It(t[1])]
                            : (function (e) {
                                var t = e.indexOf("(") + 1,
                                  n = e.indexOf(")"),
                                  o = e.indexOf("(", t);
                                return e.substring(
                                  t,
                                  ~o && o < n ? e.indexOf(")", n + 1) : n,
                                );
                              })(e)
                                .split(",")
                                .map(me),
                        )
                      : xt._CE && kt.test(e)
                        ? xt._CE("", e)
                        : n;
                  })(e))) ||
            t
          );
        },
        Ct = function (e, t, n, o) {
          void 0 === n &&
            (n = function (e) {
              return 1 - t(1 - e);
            }),
            void 0 === o &&
              (o = function (e) {
                return e < 0.5 ? t(2 * e) / 2 : 1 - t(2 * (1 - e)) / 2;
              });
          var a,
            r = { easeIn: t, easeOut: n, easeInOut: o };
          return (
            ce(e, function (e) {
              for (var t in ((xt[e] = H[e] = r),
              (xt[(a = e.toLowerCase())] = n),
              r))
                xt[
                  a +
                    ("easeIn" === t
                      ? ".in"
                      : "easeOut" === t
                        ? ".out"
                        : ".inOut")
                ] = xt[e + "." + t] = r[t];
            }),
            r
          );
        },
        Mt = function (e) {
          return function (t) {
            return t < 0.5
              ? (1 - e(1 - 2 * t)) / 2
              : 0.5 + e(2 * (t - 0.5)) / 2;
          };
        },
        Pt = function e(t, n, o) {
          var a = n >= 1 ? n : 1,
            r = (o || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1),
            i = (r / v) * (Math.asin(1 / a) || 0),
            l = function (e) {
              return 1 === e
                ? 1
                : a * Math.pow(2, -10 * e) * O((e - i) * r) + 1;
            },
            s =
              "out" === t
                ? l
                : "in" === t
                  ? function (e) {
                      return 1 - l(1 - e);
                    }
                  : Mt(l);
          return (
            (r = v / r),
            (s.config = function (n, o) {
              return e(t, n, o);
            }),
            s
          );
        },
        Et = function e(t, n) {
          void 0 === n && (n = 1.70158);
          var o = function (e) {
              return e ? --e * e * ((n + 1) * e + n) + 1 : 0;
            },
            a =
              "out" === t
                ? o
                : "in" === t
                  ? function (e) {
                      return 1 - o(1 - e);
                    }
                  : Mt(o);
          return (
            (a.config = function (n) {
              return e(t, n);
            }),
            a
          );
        };
      ce("Linear,Quad,Cubic,Quart,Quint,Strong", function (e, t) {
        var n = t < 5 ? t + 1 : t;
        Ct(
          e + ",Power" + (n - 1),
          t
            ? function (e) {
                return Math.pow(e, n);
              }
            : function (e) {
                return e;
              },
          function (e) {
            return 1 - Math.pow(1 - e, n);
          },
          function (e) {
            return e < 0.5
              ? Math.pow(2 * e, n) / 2
              : 1 - Math.pow(2 * (1 - e), n) / 2;
          },
        );
      }),
        (xt.Linear.easeNone = xt.none = xt.Linear.easeIn),
        Ct("Elastic", Pt("in"), Pt("out"), Pt()),
        (function (e, t) {
          var n = 1 / t,
            o = function (o) {
              return o < n
                ? e * o * o
                : o < 0.7272727272727273
                  ? e * Math.pow(o - 1.5 / t, 2) + 0.75
                  : o < 0.9090909090909092
                    ? e * (o -= 2.25 / t) * o + 0.9375
                    : e * Math.pow(o - 2.625 / t, 2) + 0.984375;
            };
          Ct(
            "Bounce",
            function (e) {
              return 1 - o(1 - e);
            },
            o,
          );
        })(7.5625, 2.75),
        Ct("Expo", function (e) {
          return e ? Math.pow(2, 10 * (e - 1)) : 0;
        }),
        Ct("Circ", function (e) {
          return -(x(1 - e * e) - 1);
        }),
        Ct("Sine", function (e) {
          return 1 === e ? 1 : 1 - k(e * g);
        }),
        Ct("Back", Et("in"), Et("out"), Et()),
        (xt.SteppedEase =
          xt.steps =
          H.SteppedEase =
            {
              config: function (e, t) {
                void 0 === e && (e = 1);
                var n = 1 / e,
                  o = e + (t ? 0 : 1),
                  a = t ? 1 : 0,
                  r = 1 - b;
                return function (e) {
                  return (((o * Ye(0, r, e)) | 0) + a) * n;
                };
              },
            }),
        (y.ease = xt["quad.out"]),
        ce(
          "onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt",
          function (e) {
            return (re += e + "," + e + "Params,");
          },
        );
      var Lt = function (e, t) {
          (this.id = w++),
            (e._gsap = this),
            (this.target = e),
            (this.harness = t),
            (this.get = t ? t.get : se),
            (this.set = t ? t.getSetter : Qt);
        },
        Bt = (function () {
          function e(e) {
            (this.vars = e),
              (this._delay = +e.delay || 0),
              (this._repeat = e.repeat === 1 / 0 ? -2 : e.repeat || 0) &&
                ((this._rDelay = e.repeatDelay || 0),
                (this._yoyo = !!e.yoyo || !!e.yoyoEase)),
              (this._ts = 1),
              Fe(this, +e.duration, 1, 1),
              (this.data = e.data),
              l && ((this._ctx = l), l.data.push(this)),
              h || gt.wake();
          }
          var t = e.prototype;
          return (
            (t.delay = function (e) {
              return e || 0 === e
                ? (this.parent &&
                    this.parent.smoothChildTiming &&
                    this.startTime(this._start + e - this._delay),
                  (this._delay = e),
                  this)
                : this._delay;
            }),
            (t.duration = function (e) {
              return arguments.length
                ? this.totalDuration(
                    this._repeat > 0
                      ? e + (e + this._rDelay) * this._repeat
                      : e,
                  )
                : this.totalDuration() && this._dur;
            }),
            (t.totalDuration = function (e) {
              return arguments.length
                ? ((this._dirty = 0),
                  Fe(
                    this,
                    this._repeat < 0
                      ? e
                      : (e - this._repeat * this._rDelay) / (this._repeat + 1),
                  ))
                : this._tDur;
            }),
            (t.totalTime = function (e, t) {
              if ((wt(), !arguments.length)) return this._tTime;
              var n = this._dp;
              if (n && n.smoothChildTiming && this._ts) {
                for (
                  Be(this, e), !n._dp || n.parent || Ne(n, this);
                  n && n.parent;

                )
                  n.parent._time !==
                    n._start +
                      (n._ts >= 0
                        ? n._tTime / n._ts
                        : (n.totalDuration() - n._tTime) / -n._ts) &&
                    n.totalTime(n._tTime, !0),
                    (n = n.parent);
                !this.parent &&
                  this._dp.autoRemoveChildren &&
                  ((this._ts > 0 && e < this._tDur) ||
                    (this._ts < 0 && e > 0) ||
                    (!this._tDur && !e)) &&
                  De(this._dp, this, this._start - this._delay);
              }
              return (
                (this._tTime !== e ||
                  (!this._dur && !t) ||
                  (this._initted && Math.abs(this._zTime) === b) ||
                  (!e && !this._initted && (this.add || this._ptLookup))) &&
                  (this._ts || (this._pTime = e), he(this, e, t)),
                this
              );
            }),
            (t.time = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    Math.min(this.totalDuration(), e + Me(this)) %
                      (this._dur + this._rDelay) || (e ? this._dur : 0),
                    t,
                  )
                : this._time;
            }),
            (t.totalProgress = function (e, t) {
              return arguments.length
                ? this.totalTime(this.totalDuration() * e, t)
                : this.totalDuration()
                  ? Math.min(1, this._tTime / this._tDur)
                  : this.ratio;
            }),
            (t.progress = function (e, t) {
              return arguments.length
                ? this.totalTime(
                    this.duration() *
                      (!this._yoyo || 1 & this.iteration() ? e : 1 - e) +
                      Me(this),
                    t,
                  )
                : this.duration()
                  ? Math.min(1, this._time / this._dur)
                  : this.ratio;
            }),
            (t.iteration = function (e, t) {
              var n = this.duration() + this._rDelay;
              return arguments.length
                ? this.totalTime(this._time + (e - 1) * n, t)
                : this._repeat
                  ? Pe(this._tTime, n) + 1
                  : 1;
            }),
            (t.timeScale = function (e) {
              if (!arguments.length) return this._rts === -b ? 0 : this._rts;
              if (this._rts === e) return this;
              var t =
                this.parent && this._ts
                  ? Ee(this.parent._time, this)
                  : this._tTime;
              return (
                (this._rts = +e || 0),
                (this._ts = this._ps || e === -b ? 0 : this._rts),
                this.totalTime(Ye(-Math.abs(this._delay), this._tDur, t), !0),
                Le(this),
                je(this)
              );
            }),
            (t.paused = function (e) {
              return arguments.length
                ? (this._ps !== e &&
                    ((this._ps = e),
                    e
                      ? ((this._pTime =
                          this._tTime ||
                          Math.max(-this._delay, this.rawTime())),
                        (this._ts = this._act = 0))
                      : (wt(),
                        (this._ts = this._rts),
                        this.totalTime(
                          this.parent && !this.parent.smoothChildTiming
                            ? this.rawTime()
                            : this._tTime || this._pTime,
                          1 === this.progress() &&
                            Math.abs(this._zTime) !== b &&
                            (this._tTime -= b),
                        ))),
                  this)
                : this._ps;
            }),
            (t.startTime = function (e) {
              if (arguments.length) {
                this._start = e;
                var t = this.parent || this._dp;
                return (
                  t &&
                    (t._sort || !this.parent) &&
                    De(t, this, e - this._delay),
                  this
                );
              }
              return this._start;
            }),
            (t.endTime = function (e) {
              return (
                this._start +
                (M(e) ? this.totalDuration() : this.duration()) /
                  Math.abs(this._ts || 1)
              );
            }),
            (t.rawTime = function (e) {
              var t = this.parent || this._dp;
              return t
                ? e &&
                  (!this._ts ||
                    (this._repeat && this._time && this.totalProgress() < 1))
                  ? this._tTime % (this._dur + this._rDelay)
                  : this._ts
                    ? Ee(t.rawTime(e), this)
                    : this._tTime
                : this._tTime;
            }),
            (t.revert = function (e) {
              void 0 === e && (e = Q);
              var t = i;
              return (
                (i = e),
                (this._initted || this._startAt) &&
                  (this.timeline && this.timeline.revert(e),
                  this.totalTime(-0.01, e.suppressEvents)),
                "nested" !== this.data && !1 !== e.kill && this.kill(),
                (i = t),
                this
              );
            }),
            (t.globalTime = function (e) {
              for (var t = this, n = arguments.length ? e : t.rawTime(); t; )
                (n = t._start + n / (t._ts || 1)), (t = t._dp);
              return !this.parent && this._sat
                ? this._sat.vars.immediateRender
                  ? -1 / 0
                  : this._sat.globalTime(e)
                : n;
            }),
            (t.repeat = function (e) {
              return arguments.length
                ? ((this._repeat = e === 1 / 0 ? -2 : e), Ve(this))
                : -2 === this._repeat
                  ? 1 / 0
                  : this._repeat;
            }),
            (t.repeatDelay = function (e) {
              if (arguments.length) {
                var t = this._time;
                return (this._rDelay = e), Ve(this), t ? this.time(t) : this;
              }
              return this._rDelay;
            }),
            (t.yoyo = function (e) {
              return arguments.length ? ((this._yoyo = e), this) : this._yoyo;
            }),
            (t.seek = function (e, t) {
              return this.totalTime(We(this, e), M(t));
            }),
            (t.restart = function (e, t) {
              return this.play().totalTime(e ? -this._delay : 0, M(t));
            }),
            (t.play = function (e, t) {
              return null != e && this.seek(e, t), this.reversed(!1).paused(!1);
            }),
            (t.reverse = function (e, t) {
              return (
                null != e && this.seek(e || this.totalDuration(), t),
                this.reversed(!0).paused(!1)
              );
            }),
            (t.pause = function (e, t) {
              return null != e && this.seek(e, t), this.paused(!0);
            }),
            (t.resume = function () {
              return this.paused(!1);
            }),
            (t.reversed = function (e) {
              return arguments.length
                ? (!!e !== this.reversed() &&
                    this.timeScale(-this._rts || (e ? -b : 0)),
                  this)
                : this._rts < 0;
            }),
            (t.invalidate = function () {
              return (this._initted = this._act = 0), (this._zTime = -b), this;
            }),
            (t.isActive = function () {
              var e,
                t = this.parent || this._dp,
                n = this._start;
              return !(
                t &&
                !(
                  this._ts &&
                  this._initted &&
                  t.isActive() &&
                  (e = t.rawTime(!0)) >= n &&
                  e < this.endTime(!0) - b
                )
              );
            }),
            (t.eventCallback = function (e, t, n) {
              var o = this.vars;
              return arguments.length > 1
                ? (t
                    ? ((o[e] = t),
                      n && (o[e + "Params"] = n),
                      "onUpdate" === e && (this._onUpdate = t))
                    : delete o[e],
                  this)
                : o[e];
            }),
            (t.then = function (e) {
              var t = this;
              return new Promise(function (n) {
                var o = S(e) ? e : ye,
                  a = function () {
                    var e = t.then;
                    (t.then = null),
                      S(o) && (o = o(t)) && (o.then || o === t) && (t.then = e),
                      n(o),
                      (t.then = e);
                  };
                (t._initted && 1 === t.totalProgress() && t._ts >= 0) ||
                (!t._tTime && t._ts < 0)
                  ? a()
                  : (t._prom = a);
              });
            }),
            (t.kill = function () {
              ct(this);
            }),
            e
          );
        })();
      be(Bt.prototype, {
        _time: 0,
        _start: 0,
        _end: 0,
        _tTime: 0,
        _tDur: 0,
        _dirty: 0,
        _repeat: 0,
        _yoyo: !1,
        parent: null,
        _initted: !1,
        _rDelay: 0,
        _ts: 1,
        _dp: 0,
        ratio: 0,
        _zTime: -b,
        _prom: 0,
        _ps: !1,
        _rts: 1,
      });
      var Nt = (function (e) {
        function t(t, n) {
          var a;
          return (
            void 0 === t && (t = {}),
            ((a = e.call(this, t) || this).labels = {}),
            (a.smoothChildTiming = !!t.smoothChildTiming),
            (a.autoRemoveChildren = !!t.autoRemoveChildren),
            (a._sort = M(t.sortChildren)),
            s && De(t.parent || s, o(a), n),
            t.reversed && a.reverse(),
            t.paused && a.paused(!0),
            t.scrollTrigger && ze(o(a), t.scrollTrigger),
            a
          );
        }
        a(t, e);
        var n = t.prototype;
        return (
          (n.to = function (e, t, n) {
            return Ue(0, arguments, this), this;
          }),
          (n.from = function (e, t, n) {
            return Ue(1, arguments, this), this;
          }),
          (n.fromTo = function (e, t, n, o) {
            return Ue(2, arguments, this), this;
          }),
          (n.set = function (e, t, n) {
            return (
              (t.duration = 0),
              (t.parent = this),
              xe(t).repeatDelay || (t.repeat = 0),
              (t.immediateRender = !!t.immediateRender),
              new Yt(e, t, We(this, n), 1),
              this
            );
          }),
          (n.call = function (e, t, n) {
            return De(this, Yt.delayedCall(0, e, t), n);
          }),
          (n.staggerTo = function (e, t, n, o, a, r, i) {
            return (
              (n.duration = t),
              (n.stagger = n.stagger || o),
              (n.onComplete = r),
              (n.onCompleteParams = i),
              (n.parent = this),
              new Yt(e, n, We(this, a)),
              this
            );
          }),
          (n.staggerFrom = function (e, t, n, o, a, r, i) {
            return (
              (n.runBackwards = 1),
              (xe(n).immediateRender = M(n.immediateRender)),
              this.staggerTo(e, t, n, o, a, r, i)
            );
          }),
          (n.staggerFromTo = function (e, t, n, o, a, r, i, l) {
            return (
              (o.startAt = n),
              (xe(o).immediateRender = M(o.immediateRender)),
              this.staggerTo(e, t, o, a, r, i, l)
            );
          }),
          (n.render = function (e, t, n) {
            var o,
              a,
              r,
              l,
              c,
              _,
              u,
              d,
              p,
              f,
              h,
              m,
              y = this._time,
              v = this._dirty ? this.totalDuration() : this._tDur,
              g = this._dur,
              w = e <= 0 ? 0 : ue(e),
              x = this._zTime < 0 !== e < 0 && (this._initted || !g);
            if (
              (this !== s && w > v && e >= 0 && (w = v),
              w !== this._tTime || n || x)
            ) {
              if (
                (y !== this._time &&
                  g &&
                  ((w += this._time - y), (e += this._time - y)),
                (o = w),
                (p = this._start),
                (_ = !(d = this._ts)),
                x && (g || (y = this._zTime), (e || !t) && (this._zTime = e)),
                this._repeat)
              ) {
                if (
                  ((h = this._yoyo),
                  (c = g + this._rDelay),
                  this._repeat < -1 && e < 0)
                )
                  return this.totalTime(100 * c + e, t, n);
                if (
                  ((o = ue(w % c)),
                  w === v
                    ? ((l = this._repeat), (o = g))
                    : ((l = ~~(w / c)) && l === w / c && ((o = g), l--),
                      o > g && (o = g)),
                  (f = Pe(this._tTime, c)),
                  !y &&
                    this._tTime &&
                    f !== l &&
                    this._tTime - f * c - this._dur <= 0 &&
                    (f = l),
                  h && 1 & l && ((o = g - o), (m = 1)),
                  l !== f && !this._lock)
                ) {
                  var k = h && 1 & f,
                    O = k === (h && 1 & l);
                  if (
                    (l < f && (k = !k),
                    (y = k ? 0 : w % g ? g : w),
                    (this._lock = 1),
                    (this.render(y || (m ? 0 : ue(l * c)), t, !g)._lock = 0),
                    (this._tTime = w),
                    !t && this.parent && st(this, "onRepeat"),
                    this.vars.repeatRefresh &&
                      !m &&
                      (this.invalidate()._lock = 1),
                    (y && y !== this._time) ||
                      _ !== !this._ts ||
                      (this.vars.onRepeat && !this.parent && !this._act))
                  )
                    return this;
                  if (
                    ((g = this._dur),
                    (v = this._tDur),
                    O &&
                      ((this._lock = 2),
                      (y = k ? g : -1e-4),
                      this.render(y, !0),
                      this.vars.repeatRefresh && !m && this.invalidate()),
                    (this._lock = 0),
                    !this._ts && !_)
                  )
                    return this;
                  jt(this, m);
                }
              }
              if (
                (this._hasPause &&
                  !this._forcing &&
                  this._lock < 2 &&
                  (u = (function (e, t, n) {
                    var o;
                    if (n > t)
                      for (o = e._first; o && o._start <= n; ) {
                        if ("isPause" === o.data && o._start > t) return o;
                        o = o._next;
                      }
                    else
                      for (o = e._last; o && o._start >= n; ) {
                        if ("isPause" === o.data && o._start < t) return o;
                        o = o._prev;
                      }
                  })(this, ue(y), ue(o))) &&
                  (w -= o - (o = u._start)),
                (this._tTime = w),
                (this._time = o),
                (this._act = !d),
                this._initted ||
                  ((this._onUpdate = this.vars.onUpdate),
                  (this._initted = 1),
                  (this._zTime = e),
                  (y = 0)),
                !y && o && !t && !l && (st(this, "onStart"), this._tTime !== w))
              )
                return this;
              if (o >= y && e >= 0)
                for (a = this._first; a; ) {
                  if (
                    ((r = a._next),
                    (a._act || o >= a._start) && a._ts && u !== a)
                  ) {
                    if (a.parent !== this) return this.render(e, t, n);
                    if (
                      (a.render(
                        a._ts > 0
                          ? (o - a._start) * a._ts
                          : (a._dirty ? a.totalDuration() : a._tDur) +
                              (o - a._start) * a._ts,
                        t,
                        n,
                      ),
                      o !== this._time || (!this._ts && !_))
                    ) {
                      (u = 0), r && (w += this._zTime = -b);
                      break;
                    }
                  }
                  a = r;
                }
              else {
                a = this._last;
                for (var I = e < 0 ? e : o; a; ) {
                  if (
                    ((r = a._prev), (a._act || I <= a._end) && a._ts && u !== a)
                  ) {
                    if (a.parent !== this) return this.render(e, t, n);
                    if (
                      (a.render(
                        a._ts > 0
                          ? (I - a._start) * a._ts
                          : (a._dirty ? a.totalDuration() : a._tDur) +
                              (I - a._start) * a._ts,
                        t,
                        n || (i && (a._initted || a._startAt)),
                      ),
                      o !== this._time || (!this._ts && !_))
                    ) {
                      (u = 0), r && (w += this._zTime = I ? -b : b);
                      break;
                    }
                  }
                  a = r;
                }
              }
              if (
                u &&
                !t &&
                (this.pause(),
                (u.render(o >= y ? 0 : -b)._zTime = o >= y ? 1 : -1),
                this._ts)
              )
                return (this._start = p), Le(this), this.render(e, t, n);
              this._onUpdate && !t && st(this, "onUpdate", !0),
                ((w === v && this._tTime >= this.totalDuration()) ||
                  (!w && y)) &&
                  ((p !== this._start && Math.abs(d) === Math.abs(this._ts)) ||
                    this._lock ||
                    ((e || !g) &&
                      ((w === v && this._ts > 0) || (!w && this._ts < 0)) &&
                      Ie(this, 1),
                    t ||
                      (e < 0 && !y) ||
                      (!w && !y && v) ||
                      (st(
                        this,
                        w === v && e >= 0 ? "onComplete" : "onReverseComplete",
                        !0,
                      ),
                      this._prom &&
                        !(w < v && this.timeScale() > 0) &&
                        this._prom())));
            }
            return this;
          }),
          (n.add = function (e, t) {
            var n = this;
            if ((j(t) || (t = We(this, t, e)), !(e instanceof Bt))) {
              if (B(e))
                return (
                  e.forEach(function (e) {
                    return n.add(e, t);
                  }),
                  this
                );
              if (I(e)) return this.addLabel(e, t);
              if (!S(e)) return this;
              e = Yt.delayedCall(0, e);
            }
            return this !== e ? De(this, e, t) : this;
          }),
          (n.getChildren = function (e, t, n, o) {
            void 0 === e && (e = !0),
              void 0 === t && (t = !0),
              void 0 === n && (n = !0),
              void 0 === o && (o = -1e8);
            for (var a = [], r = this._first; r; )
              r._start >= o &&
                (r instanceof Yt
                  ? t && a.push(r)
                  : (n && a.push(r),
                    e && a.push.apply(a, r.getChildren(!0, t, n)))),
                (r = r._next);
            return a;
          }),
          (n.getById = function (e) {
            for (var t = this.getChildren(1, 1, 1), n = t.length; n--; )
              if (t[n].vars.id === e) return t[n];
          }),
          (n.remove = function (e) {
            return I(e)
              ? this.removeLabel(e)
              : S(e)
                ? this.killTweensOf(e)
                : (Oe(this, e),
                  e === this._recent && (this._recent = this._last),
                  Se(this));
          }),
          (n.totalTime = function (t, n) {
            return arguments.length
              ? ((this._forcing = 1),
                !this._dp &&
                  this._ts &&
                  (this._start = ue(
                    gt.time -
                      (this._ts > 0
                        ? t / this._ts
                        : (this.totalDuration() - t) / -this._ts),
                  )),
                e.prototype.totalTime.call(this, t, n),
                (this._forcing = 0),
                this)
              : this._tTime;
          }),
          (n.addLabel = function (e, t) {
            return (this.labels[e] = We(this, t)), this;
          }),
          (n.removeLabel = function (e) {
            return delete this.labels[e], this;
          }),
          (n.addPause = function (e, t, n) {
            var o = Yt.delayedCall(0, t || X, n);
            return (
              (o.data = "isPause"),
              (this._hasPause = 1),
              De(this, o, We(this, e))
            );
          }),
          (n.removePause = function (e) {
            var t = this._first;
            for (e = We(this, e); t; )
              t._start === e && "isPause" === t.data && Ie(t), (t = t._next);
          }),
          (n.killTweensOf = function (e, t, n) {
            for (var o = this.getTweensOf(e, n), a = o.length; a--; )
              Dt !== o[a] && o[a].kill(e, t);
            return this;
          }),
          (n.getTweensOf = function (e, t) {
            for (var n, o = [], a = Qe(e), r = this._first, i = j(t); r; )
              r instanceof Yt
                ? pe(r._targets, a) &&
                  (i
                    ? (!Dt || (r._initted && r._ts)) &&
                      r.globalTime(0) <= t &&
                      r.globalTime(r.totalDuration()) > t
                    : !t || r.isActive()) &&
                  o.push(r)
                : (n = r.getTweensOf(a, t)).length && o.push.apply(o, n),
                (r = r._next);
            return o;
          }),
          (n.tweenTo = function (e, t) {
            t = t || {};
            var n,
              o = this,
              a = We(o, e),
              r = t,
              i = r.startAt,
              l = r.onStart,
              s = r.onStartParams,
              c = r.immediateRender,
              _ = Yt.to(
                o,
                be(
                  {
                    ease: t.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: a,
                    overwrite: "auto",
                    duration:
                      t.duration ||
                      Math.abs(
                        (a - (i && "time" in i ? i.time : o._time)) /
                          o.timeScale(),
                      ) ||
                      b,
                    onStart: function () {
                      if ((o.pause(), !n)) {
                        var e =
                          t.duration ||
                          Math.abs(
                            (a - (i && "time" in i ? i.time : o._time)) /
                              o.timeScale(),
                          );
                        _._dur !== e && Fe(_, e, 0, 1).render(_._time, !0, !0),
                          (n = 1);
                      }
                      l && l.apply(_, s || []);
                    },
                  },
                  t,
                ),
              );
            return c ? _.render(0) : _;
          }),
          (n.tweenFromTo = function (e, t, n) {
            return this.tweenTo(t, be({ startAt: { time: We(this, e) } }, n));
          }),
          (n.recent = function () {
            return this._recent;
          }),
          (n.nextLabel = function (e) {
            return void 0 === e && (e = this._time), lt(this, We(this, e));
          }),
          (n.previousLabel = function (e) {
            return void 0 === e && (e = this._time), lt(this, We(this, e), 1);
          }),
          (n.currentLabel = function (e) {
            return arguments.length
              ? this.seek(e, !0)
              : this.previousLabel(this._time + b);
          }),
          (n.shiftChildren = function (e, t, n) {
            void 0 === n && (n = 0);
            for (var o, a = this._first, r = this.labels; a; )
              a._start >= n && ((a._start += e), (a._end += e)), (a = a._next);
            if (t) for (o in r) r[o] >= n && (r[o] += e);
            return Se(this);
          }),
          (n.invalidate = function (t) {
            var n = this._first;
            for (this._lock = 0; n; ) n.invalidate(t), (n = n._next);
            return e.prototype.invalidate.call(this, t);
          }),
          (n.clear = function (e) {
            void 0 === e && (e = !0);
            for (var t, n = this._first; n; )
              (t = n._next), this.remove(n), (n = t);
            return (
              this._dp && (this._time = this._tTime = this._pTime = 0),
              e && (this.labels = {}),
              Se(this)
            );
          }),
          (n.totalDuration = function (e) {
            var t,
              n,
              o,
              a = 0,
              r = this,
              i = r._last,
              l = 1e8;
            if (arguments.length)
              return r.timeScale(
                (r._repeat < 0 ? r.duration() : r.totalDuration()) /
                  (r.reversed() ? -e : e),
              );
            if (r._dirty) {
              for (o = r.parent; i; )
                (t = i._prev),
                  i._dirty && i.totalDuration(),
                  (n = i._start) > l && r._sort && i._ts && !r._lock
                    ? ((r._lock = 1), (De(r, i, n - i._delay, 1)._lock = 0))
                    : (l = n),
                  n < 0 &&
                    i._ts &&
                    ((a -= n),
                    ((!o && !r._dp) || (o && o.smoothChildTiming)) &&
                      ((r._start += n / r._ts),
                      (r._time -= n),
                      (r._tTime -= n)),
                    r.shiftChildren(-n, !1, -Infinity),
                    (l = 0)),
                  i._end > a && i._ts && (a = i._end),
                  (i = t);
              Fe(r, r === s && r._time > a ? r._time : a, 1, 1), (r._dirty = 0);
            }
            return r._tDur;
          }),
          (t.updateRoot = function (e) {
            if ((s._ts && (he(s, Ee(e, s)), (p = gt.frame)), gt.frame >= oe)) {
              oe += m.autoSleep || 120;
              var t = s._first;
              if ((!t || !t._ts) && m.autoSleep && gt._listeners.length < 2) {
                for (; t && !t._ts; ) t = t._next;
                t || gt.sleep();
              }
            }
          }),
          t
        );
      })(Bt);
      be(Nt.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
      var Dt,
        zt,
        At = function (e, t, n, o, a, r, i) {
          var l,
            s,
            c,
            _,
            u,
            d,
            p,
            f,
            h = new ln(this._pt, e, t, 0, 1, en, null, a),
            m = 0,
            y = 0;
          for (
            h.b = n,
              h.e = o,
              n += "",
              (p = ~(o += "").indexOf("random(")) && (o = rt(o)),
              r && (r((f = [n, o]), e, t), (n = f[0]), (o = f[1])),
              s = n.match(A) || [];
            (l = A.exec(o));

          )
            (_ = l[0]),
              (u = o.substring(m, l.index)),
              c ? (c = (c + 1) % 5) : "rgba(" === u.substr(-5) && (c = 1),
              _ !== s[y++] &&
                ((d = parseFloat(s[y - 1]) || 0),
                (h._pt = {
                  _next: h._pt,
                  p: u || 1 === y ? u : ",",
                  s: d,
                  c: "=" === _.charAt(1) ? de(d, _) - d : parseFloat(_) - d,
                  m: c && c < 4 ? Math.round : 0,
                }),
                (m = A.lastIndex));
          return (
            (h.c = m < o.length ? o.substring(m, o.length) : ""),
            (h.fp = i),
            (R.test(o) || p) && (h.e = 0),
            (this._pt = h),
            h
          );
        },
        Rt = function (e, t, n, o, a, r, i, l, s, c) {
          S(o) && (o = o(a || 0, e, r));
          var _,
            u = e[t],
            d =
              "get" !== n
                ? n
                : S(u)
                  ? s
                    ? e[
                        t.indexOf("set") || !S(e["get" + t.substr(3)])
                          ? t
                          : "get" + t.substr(3)
                      ](s)
                    : e[t]()
                  : u,
            p = S(u) ? (s ? Zt : Xt) : qt;
          if (
            (I(o) &&
              (~o.indexOf("random(") && (o = rt(o)),
              "=" === o.charAt(1) &&
                ((_ = de(d, o) + (qe(d) || 0)) || 0 === _) &&
                (o = _)),
            !c || d !== o || zt)
          )
            return isNaN(d * o) || "" === o
              ? (!u && !(t in e) && G(t, o),
                At.call(this, e, t, d, o, p, l || m.stringFilter, s))
              : ((_ = new ln(
                  this._pt,
                  e,
                  t,
                  +d || 0,
                  o - (d || 0),
                  "boolean" === typeof u ? $t : Jt,
                  0,
                  p,
                )),
                s && (_.fp = s),
                i && _.modifier(i, this, e),
                (this._pt = _));
        },
        Ft = function (e, t, n, o, a, r) {
          var i, l, s, c;
          if (
            te[e] &&
            !1 !==
              (i = new te[e]()).init(
                a,
                i.rawVars
                  ? t[e]
                  : (function (e, t, n, o, a) {
                      if (
                        (S(e) && (e = Wt(e, a, t, n, o)),
                        !C(e) || (e.style && e.nodeType) || B(e) || L(e))
                      )
                        return I(e) ? Wt(e, a, t, n, o) : e;
                      var r,
                        i = {};
                      for (r in e) i[r] = Wt(e[r], a, t, n, o);
                      return i;
                    })(t[e], o, a, r, n),
                n,
                o,
                r,
              ) &&
            ((n._pt = l =
              new ln(n._pt, a, e, 0, 1, i.render, i, 0, i.priority)),
            n !== f)
          )
            for (
              s = n._ptLookup[n._targets.indexOf(a)], c = i._props.length;
              c--;

            )
              s[i._props[c]] = l;
          return i;
        },
        Vt = function e(t, n, o) {
          var a,
            l,
            c,
            _,
            u,
            d,
            p,
            f,
            h,
            m,
            v,
            g,
            w,
            x = t.vars,
            k = x.ease,
            O = x.startAt,
            I = x.immediateRender,
            S = x.lazy,
            j = x.onUpdate,
            T = x.onUpdateParams,
            C = x.callbackScope,
            P = x.runBackwards,
            E = x.yoyoEase,
            L = x.keyframes,
            B = x.autoRevert,
            N = t._dur,
            D = t._startAt,
            z = t._targets,
            A = t.parent,
            R = A && "nested" === A.data ? A.vars.targets : z,
            F = "auto" === t._overwrite && !r,
            V = t.timeline;
          if (
            (V && (!L || !k) && (k = "none"),
            (t._ease = Tt(k, y.ease)),
            (t._yEase = E ? St(Tt(!0 === E ? k : E, y.ease)) : 0),
            E &&
              t._yoyo &&
              !t._repeat &&
              ((E = t._yEase), (t._yEase = t._ease), (t._ease = E)),
            (t._from = !V && !!x.runBackwards),
            !V || (L && !x.stagger))
          ) {
            if (
              ((g = (f = z[0] ? le(z[0]).harness : 0) && x[f.prop]),
              (a = we(x, J)),
              D &&
                (D._zTime < 0 && D.progress(1),
                n < 0 && P && I && !B
                  ? D.render(-1, !0)
                  : D.revert(P && N ? K : Z),
                (D._lazy = 0)),
              O)
            ) {
              if (
                (Ie(
                  (t._startAt = Yt.set(
                    z,
                    be(
                      {
                        data: "isStart",
                        overwrite: !1,
                        parent: A,
                        immediateRender: !0,
                        lazy: !D && M(S),
                        startAt: null,
                        delay: 0,
                        onUpdate: j,
                        onUpdateParams: T,
                        callbackScope: C,
                        stagger: 0,
                      },
                      O,
                    ),
                  )),
                ),
                (t._startAt._dp = 0),
                (t._startAt._sat = t),
                n < 0 && (i || (!I && !B)) && t._startAt.revert(K),
                I && N && n <= 0 && o <= 0)
              )
                return void (n && (t._zTime = n));
            } else if (P && N && !D)
              if (
                (n && (I = !1),
                (c = be(
                  {
                    overwrite: !1,
                    data: "isFromStart",
                    lazy: I && !D && M(S),
                    immediateRender: I,
                    stagger: 0,
                    parent: A,
                  },
                  a,
                )),
                g && (c[f.prop] = g),
                Ie((t._startAt = Yt.set(z, c))),
                (t._startAt._dp = 0),
                (t._startAt._sat = t),
                n < 0 && (i ? t._startAt.revert(K) : t._startAt.render(-1, !0)),
                (t._zTime = n),
                I)
              ) {
                if (!n) return;
              } else e(t._startAt, b, b);
            for (
              t._pt = t._ptCache = 0, S = (N && M(S)) || (S && !N), l = 0;
              l < z.length;
              l++
            ) {
              if (
                ((p = (u = z[l])._gsap || ie(z)[l]._gsap),
                (t._ptLookup[l] = m = {}),
                ee[p.id] && $.length && fe(),
                (v = R === z ? l : R.indexOf(u)),
                f &&
                  !1 !== (h = new f()).init(u, g || a, t, v, R) &&
                  ((t._pt = _ =
                    new ln(t._pt, u, h.name, 0, 1, h.render, h, 0, h.priority)),
                  h._props.forEach(function (e) {
                    m[e] = _;
                  }),
                  h.priority && (d = 1)),
                !f || g)
              )
                for (c in a)
                  te[c] && (h = Ft(c, a, t, v, u, R))
                    ? h.priority && (d = 1)
                    : (m[c] = _ =
                        Rt.call(t, u, c, "get", a[c], v, R, 0, x.stringFilter));
              t._op && t._op[l] && t.kill(u, t._op[l]),
                F &&
                  t._pt &&
                  ((Dt = t),
                  s.killTweensOf(u, m, t.globalTime(n)),
                  (w = !t.parent),
                  (Dt = 0)),
                t._pt && S && (ee[p.id] = 1);
            }
            d && rn(t), t._onInit && t._onInit(t);
          }
          (t._onUpdate = j),
            (t._initted = (!t._op || t._pt) && !w),
            L && n <= 0 && V.render(1e8, !0, !0);
        },
        Ht = function (e, t, n, o) {
          var a,
            r,
            i = t.ease || o || "power1.inOut";
          if (B(t))
            (r = n[e] || (n[e] = [])),
              t.forEach(function (e, n) {
                return r.push({ t: (n / (t.length - 1)) * 100, v: e, e: i });
              });
          else
            for (a in t)
              (r = n[a] || (n[a] = [])),
                "ease" === a || r.push({ t: parseFloat(e), v: t[a], e: i });
        },
        Wt = function (e, t, n, o, a) {
          return S(e)
            ? e.call(t, n, o, a)
            : I(e) && ~e.indexOf("random(")
              ? rt(e)
              : e;
        },
        Ut = re + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
        Gt = {};
      ce(Ut + ",id,stagger,delay,duration,paused,scrollTrigger", function (e) {
        return (Gt[e] = 1);
      });
      var Yt = (function (e) {
        function t(t, n, a, i) {
          var l;
          "number" === typeof n && ((a.duration = n), (n = a), (a = null));
          var c,
            _,
            u,
            d,
            p,
            f,
            h,
            y,
            v = (l = e.call(this, i ? n : xe(n)) || this).vars,
            g = v.duration,
            w = v.delay,
            x = v.immediateRender,
            k = v.stagger,
            O = v.overwrite,
            I = v.keyframes,
            S = v.defaults,
            T = v.scrollTrigger,
            P = v.yoyoEase,
            N = n.parent || s,
            D = (B(t) || L(t) ? j(t[0]) : "length" in n) ? [t] : Qe(t);
          if (
            ((l._targets = D.length
              ? ie(D)
              : Y(
                  "GSAP target " + t + " not found. https://greensock.com",
                  !m.nullTargetWarn,
                ) || []),
            (l._ptLookup = []),
            (l._overwrite = O),
            I || k || E(g) || E(w))
          ) {
            if (
              ((n = l.vars),
              (c = l.timeline =
                new Nt({
                  data: "nested",
                  defaults: S || {},
                  targets: N && "nested" === N.data ? N.vars.targets : D,
                })).kill(),
              (c.parent = c._dp = o(l)),
              (c._start = 0),
              k || E(g) || E(w))
            ) {
              if (((d = D.length), (h = k && et(k)), C(k)))
                for (p in k) ~Ut.indexOf(p) && (y || (y = {}), (y[p] = k[p]));
              for (_ = 0; _ < d; _++)
                ((u = we(n, Gt)).stagger = 0),
                  P && (u.yoyoEase = P),
                  y && ve(u, y),
                  (f = D[_]),
                  (u.duration = +Wt(g, o(l), _, f, D)),
                  (u.delay = (+Wt(w, o(l), _, f, D) || 0) - l._delay),
                  !k &&
                    1 === d &&
                    u.delay &&
                    ((l._delay = w = u.delay), (l._start += w), (u.delay = 0)),
                  c.to(f, u, h ? h(_, f, D) : 0),
                  (c._ease = xt.none);
              c.duration() ? (g = w = 0) : (l.timeline = 0);
            } else if (I) {
              xe(be(c.vars.defaults, { ease: "none" })),
                (c._ease = Tt(I.ease || n.ease || "none"));
              var z,
                A,
                R,
                F = 0;
              if (B(I))
                I.forEach(function (e) {
                  return c.to(D, e, ">");
                }),
                  c.duration();
              else {
                for (p in ((u = {}), I))
                  "ease" === p ||
                    "easeEach" === p ||
                    Ht(p, I[p], u, I.easeEach);
                for (p in u)
                  for (
                    z = u[p].sort(function (e, t) {
                      return e.t - t.t;
                    }),
                      F = 0,
                      _ = 0;
                    _ < z.length;
                    _++
                  )
                    ((R = {
                      ease: (A = z[_]).e,
                      duration: ((A.t - (_ ? z[_ - 1].t : 0)) / 100) * g,
                    })[p] = A.v),
                      c.to(D, R, F),
                      (F += R.duration);
                c.duration() < g && c.to({}, { duration: g - c.duration() });
              }
            }
            g || l.duration((g = c.duration()));
          } else l.timeline = 0;
          return (
            !0 !== O || r || ((Dt = o(l)), s.killTweensOf(D), (Dt = 0)),
            De(N, o(l), a),
            n.reversed && l.reverse(),
            n.paused && l.paused(!0),
            (x ||
              (!g &&
                !I &&
                l._start === ue(N._time) &&
                M(x) &&
                Ce(o(l)) &&
                "nested" !== N.data)) &&
              ((l._tTime = -b), l.render(Math.max(0, -w) || 0)),
            T && ze(o(l), T),
            l
          );
        }
        a(t, e);
        var n = t.prototype;
        return (
          (n.render = function (e, t, n) {
            var o,
              a,
              r,
              l,
              s,
              c,
              _,
              u,
              d,
              p = this._time,
              f = this._tDur,
              h = this._dur,
              m = e < 0,
              y = e > f - b && !m ? f : e < b ? 0 : e;
            if (h) {
              if (
                y !== this._tTime ||
                !e ||
                n ||
                (!this._initted && this._tTime) ||
                (this._startAt && this._zTime < 0 !== m)
              ) {
                if (((o = y), (u = this.timeline), this._repeat)) {
                  if (((l = h + this._rDelay), this._repeat < -1 && m))
                    return this.totalTime(100 * l + e, t, n);
                  if (
                    ((o = ue(y % l)),
                    y === f
                      ? ((r = this._repeat), (o = h))
                      : ((r = ~~(y / l)) && r === y / l && ((o = h), r--),
                        o > h && (o = h)),
                    (c = this._yoyo && 1 & r) &&
                      ((d = this._yEase), (o = h - o)),
                    (s = Pe(this._tTime, l)),
                    o === p && !n && this._initted)
                  )
                    return (this._tTime = y), this;
                  r !== s &&
                    (u && this._yEase && jt(u, c),
                    !this.vars.repeatRefresh ||
                      c ||
                      this._lock ||
                      ((this._lock = n = 1),
                      (this.render(ue(l * r), !0).invalidate()._lock = 0)));
                }
                if (!this._initted) {
                  if (Ae(this, m ? e : o, n, t, y))
                    return (this._tTime = 0), this;
                  if (p !== this._time) return this;
                  if (h !== this._dur) return this.render(e, t, n);
                }
                if (
                  ((this._tTime = y),
                  (this._time = o),
                  !this._act && this._ts && ((this._act = 1), (this._lazy = 0)),
                  (this.ratio = _ = (d || this._ease)(o / h)),
                  this._from && (this.ratio = _ = 1 - _),
                  o &&
                    !p &&
                    !t &&
                    !r &&
                    (st(this, "onStart"), this._tTime !== y))
                )
                  return this;
                for (a = this._pt; a; ) a.r(_, a.d), (a = a._next);
                (u &&
                  u.render(
                    e < 0 ? e : !o && c ? -b : u._dur * u._ease(o / this._dur),
                    t,
                    n,
                  )) ||
                  (this._startAt && (this._zTime = e)),
                  this._onUpdate &&
                    !t &&
                    (m && Te(this, e, 0, n), st(this, "onUpdate")),
                  this._repeat &&
                    r !== s &&
                    this.vars.onRepeat &&
                    !t &&
                    this.parent &&
                    st(this, "onRepeat"),
                  (y !== this._tDur && y) ||
                    this._tTime !== y ||
                    (m && !this._onUpdate && Te(this, e, 0, !0),
                    (e || !h) &&
                      ((y === this._tDur && this._ts > 0) ||
                        (!y && this._ts < 0)) &&
                      Ie(this, 1),
                    t ||
                      (m && !p) ||
                      !(y || p || c) ||
                      (st(
                        this,
                        y === f ? "onComplete" : "onReverseComplete",
                        !0,
                      ),
                      this._prom &&
                        !(y < f && this.timeScale() > 0) &&
                        this._prom()));
              }
            } else
              !(function (e, t, n, o) {
                var a,
                  r,
                  l,
                  s = e.ratio,
                  c =
                    t < 0 ||
                    (!t &&
                      ((!e._start &&
                        (function e(t) {
                          var n = t.parent;
                          return (
                            n &&
                            n._ts &&
                            n._initted &&
                            !n._lock &&
                            (n.rawTime() < 0 || e(n))
                          );
                        })(e) &&
                        (e._initted || !Re(e))) ||
                        ((e._ts < 0 || e._dp._ts < 0) && !Re(e))))
                      ? 0
                      : 1,
                  _ = e._rDelay,
                  u = 0;
                if (
                  (_ &&
                    e._repeat &&
                    ((u = Ye(0, e._tDur, t)),
                    (r = Pe(u, _)),
                    e._yoyo && 1 & r && (c = 1 - c),
                    r !== Pe(e._tTime, _) &&
                      ((s = 1 - c),
                      e.vars.repeatRefresh && e._initted && e.invalidate())),
                  c !== s || i || o || e._zTime === b || (!t && e._zTime))
                ) {
                  if (!e._initted && Ae(e, t, o, n, u)) return;
                  for (
                    l = e._zTime,
                      e._zTime = t || (n ? b : 0),
                      n || (n = t && !l),
                      e.ratio = c,
                      e._from && (c = 1 - c),
                      e._time = 0,
                      e._tTime = u,
                      a = e._pt;
                    a;

                  )
                    a.r(c, a.d), (a = a._next);
                  t < 0 && Te(e, t, 0, !0),
                    e._onUpdate && !n && st(e, "onUpdate"),
                    u && e._repeat && !n && e.parent && st(e, "onRepeat"),
                    (t >= e._tDur || t < 0) &&
                      e.ratio === c &&
                      (c && Ie(e, 1),
                      n ||
                        i ||
                        (st(e, c ? "onComplete" : "onReverseComplete", !0),
                        e._prom && e._prom()));
                } else e._zTime || (e._zTime = t);
              })(this, e, t, n);
            return this;
          }),
          (n.targets = function () {
            return this._targets;
          }),
          (n.invalidate = function (t) {
            return (
              (!t || !this.vars.runBackwards) && (this._startAt = 0),
              (this._pt =
                this._op =
                this._onUpdate =
                this._lazy =
                this.ratio =
                  0),
              (this._ptLookup = []),
              this.timeline && this.timeline.invalidate(t),
              e.prototype.invalidate.call(this, t)
            );
          }),
          (n.resetTo = function (e, t, n, o) {
            h || gt.wake(), this._ts || this.play();
            var a = Math.min(
              this._dur,
              (this._dp._time - this._start) * this._ts,
            );
            return (
              this._initted || Vt(this, a),
              (function (e, t, n, o, a, r, i) {
                var l,
                  s,
                  c,
                  _,
                  u = ((e._pt && e._ptCache) || (e._ptCache = {}))[t];
                if (!u)
                  for (
                    u = e._ptCache[t] = [],
                      c = e._ptLookup,
                      _ = e._targets.length;
                    _--;

                  ) {
                    if ((l = c[_][t]) && l.d && l.d._pt)
                      for (l = l.d._pt; l && l.p !== t && l.fp !== t; )
                        l = l._next;
                    if (!l)
                      return (
                        (zt = 1), (e.vars[t] = "+=0"), Vt(e, i), (zt = 0), 1
                      );
                    u.push(l);
                  }
                for (_ = u.length; _--; )
                  ((l = (s = u[_])._pt || s).s =
                    (!o && 0 !== o) || a ? l.s + (o || 0) + r * l.c : o),
                    (l.c = n - l.s),
                    s.e && (s.e = _e(n) + qe(s.e)),
                    s.b && (s.b = l.s + qe(s.b));
              })(this, e, t, n, o, this._ease(a / this._dur), a)
                ? this.resetTo(e, t, n, o)
                : (Be(this, 0),
                  this.parent ||
                    ke(
                      this._dp,
                      this,
                      "_first",
                      "_last",
                      this._dp._sort ? "_start" : 0,
                    ),
                  this.render(0))
            );
          }),
          (n.kill = function (e, t) {
            if ((void 0 === t && (t = "all"), !e && (!t || "all" === t)))
              return (this._lazy = this._pt = 0), this.parent ? ct(this) : this;
            if (this.timeline) {
              var n = this.timeline.totalDuration();
              return (
                this.timeline.killTweensOf(e, t, Dt && !0 !== Dt.vars.overwrite)
                  ._first || ct(this),
                this.parent &&
                  n !== this.timeline.totalDuration() &&
                  Fe(this, (this._dur * this.timeline._tDur) / n, 0, 1),
                this
              );
            }
            var o,
              a,
              r,
              i,
              l,
              s,
              c,
              _ = this._targets,
              u = e ? Qe(e) : _,
              d = this._ptLookup,
              p = this._pt;
            if (
              (!t || "all" === t) &&
              (function (e, t) {
                for (
                  var n = e.length, o = n === t.length;
                  o && n-- && e[n] === t[n];

                );
                return n < 0;
              })(_, u)
            )
              return "all" === t && (this._pt = 0), ct(this);
            for (
              o = this._op = this._op || [],
                "all" !== t &&
                  (I(t) &&
                    ((l = {}),
                    ce(t, function (e) {
                      return (l[e] = 1);
                    }),
                    (t = l)),
                  (t = (function (e, t) {
                    var n,
                      o,
                      a,
                      r,
                      i = e[0] ? le(e[0]).harness : 0,
                      l = i && i.aliases;
                    if (!l) return t;
                    for (o in ((n = ve({}, t)), l))
                      if ((o in n))
                        for (a = (r = l[o].split(",")).length; a--; )
                          n[r[a]] = n[o];
                    return n;
                  })(_, t))),
                c = _.length;
              c--;

            )
              if (~u.indexOf(_[c]))
                for (l in ((a = d[c]),
                "all" === t
                  ? ((o[c] = t), (i = a), (r = {}))
                  : ((r = o[c] = o[c] || {}), (i = t)),
                i))
                  (s = a && a[l]) &&
                    (("kill" in s.d && !0 !== s.d.kill(l)) ||
                      Oe(this, s, "_pt"),
                    delete a[l]),
                    "all" !== r && (r[l] = 1);
            return this._initted && !this._pt && p && ct(this), this;
          }),
          (t.to = function (e, n) {
            return new t(e, n, arguments[2]);
          }),
          (t.from = function (e, t) {
            return Ue(1, arguments);
          }),
          (t.delayedCall = function (e, n, o, a) {
            return new t(n, 0, {
              immediateRender: !1,
              lazy: !1,
              overwrite: !1,
              delay: e,
              onComplete: n,
              onReverseComplete: n,
              onCompleteParams: o,
              onReverseCompleteParams: o,
              callbackScope: a,
            });
          }),
          (t.fromTo = function (e, t, n) {
            return Ue(2, arguments);
          }),
          (t.set = function (e, n) {
            return (
              (n.duration = 0), n.repeatDelay || (n.repeat = 0), new t(e, n)
            );
          }),
          (t.killTweensOf = function (e, t, n) {
            return s.killTweensOf(e, t, n);
          }),
          t
        );
      })(Bt);
      be(Yt.prototype, {
        _targets: [],
        _lazy: 0,
        _startAt: 0,
        _op: 0,
        _onInit: 0,
      }),
        ce("staggerTo,staggerFrom,staggerFromTo", function (e) {
          Yt[e] = function () {
            var t = new Nt(),
              n = Xe.call(arguments, 0);
            return (
              n.splice("staggerFromTo" === e ? 5 : 4, 0, 0), t[e].apply(t, n)
            );
          };
        });
      var qt = function (e, t, n) {
          return (e[t] = n);
        },
        Xt = function (e, t, n) {
          return e[t](n);
        },
        Zt = function (e, t, n, o) {
          return e[t](o.fp, n);
        },
        Kt = function (e, t, n) {
          return e.setAttribute(t, n);
        },
        Qt = function (e, t) {
          return S(e[t]) ? Xt : T(e[t]) && e.setAttribute ? Kt : qt;
        },
        Jt = function (e, t) {
          return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e)) / 1e6, t);
        },
        $t = function (e, t) {
          return t.set(t.t, t.p, !!(t.s + t.c * e), t);
        },
        en = function (e, t) {
          var n = t._pt,
            o = "";
          if (!e && t.b) o = t.b;
          else if (1 === e && t.e) o = t.e;
          else {
            for (; n; )
              (o =
                n.p +
                (n.m
                  ? n.m(n.s + n.c * e)
                  : Math.round(1e4 * (n.s + n.c * e)) / 1e4) +
                o),
                (n = n._next);
            o += t.c;
          }
          t.set(t.t, t.p, o, t);
        },
        tn = function (e, t) {
          for (var n = t._pt; n; ) n.r(e, n.d), (n = n._next);
        },
        nn = function (e, t, n, o) {
          for (var a, r = this._pt; r; )
            (a = r._next), r.p === o && r.modifier(e, t, n), (r = a);
        },
        on = function (e) {
          for (var t, n, o = this._pt; o; )
            (n = o._next),
              (o.p === e && !o.op) || o.op === e
                ? Oe(this, o, "_pt")
                : o.dep || (t = 1),
              (o = n);
          return !t;
        },
        an = function (e, t, n, o) {
          o.mSet(e, t, o.m.call(o.tween, n, o.mt), o);
        },
        rn = function (e) {
          for (var t, n, o, a, r = e._pt; r; ) {
            for (t = r._next, n = o; n && n.pr > r.pr; ) n = n._next;
            (r._prev = n ? n._prev : a) ? (r._prev._next = r) : (o = r),
              (r._next = n) ? (n._prev = r) : (a = r),
              (r = t);
          }
          e._pt = o;
        },
        ln = (function () {
          function e(e, t, n, o, a, r, i, l, s) {
            (this.t = t),
              (this.s = o),
              (this.c = a),
              (this.p = n),
              (this.r = r || Jt),
              (this.d = i || this),
              (this.set = l || qt),
              (this.pr = s || 0),
              (this._next = e),
              e && (e._prev = this);
          }
          return (
            (e.prototype.modifier = function (e, t, n) {
              (this.mSet = this.mSet || this.set),
                (this.set = an),
                (this.m = e),
                (this.mt = n),
                (this.tween = t);
            }),
            e
          );
        })();
      ce(
        re +
          "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
        function (e) {
          return (J[e] = 1);
        },
      ),
        (H.TweenMax = H.TweenLite = Yt),
        (H.TimelineLite = H.TimelineMax = Nt),
        (s = new Nt({
          sortChildren: !1,
          defaults: y,
          autoRemoveChildren: !0,
          id: "root",
          smoothChildTiming: !0,
        })),
        (m.stringFilter = vt);
      var sn = [],
        cn = {},
        _n = [],
        un = 0,
        dn = 0,
        pn = function (e) {
          return (cn[e] || _n).map(function (e) {
            return e();
          });
        },
        fn = function () {
          var e = Date.now(),
            t = [];
          e - un > 2 &&
            (pn("matchMediaInit"),
            sn.forEach(function (e) {
              var n,
                o,
                a,
                r,
                i = e.queries,
                l = e.conditions;
              for (o in i)
                (n = c.matchMedia(i[o]).matches) && (a = 1),
                  n !== l[o] && ((l[o] = n), (r = 1));
              r && (e.revert(), a && t.push(e));
            }),
            pn("matchMediaRevert"),
            t.forEach(function (e) {
              return e.onMatch(e);
            }),
            (un = e),
            pn("matchMedia"));
        },
        hn = (function () {
          function e(e, t) {
            (this.selector = t && Je(t)),
              (this.data = []),
              (this._r = []),
              (this.isReverted = !1),
              (this.id = dn++),
              e && this.add(e);
          }
          var t = e.prototype;
          return (
            (t.add = function (e, t, n) {
              S(e) && ((n = t), (t = e), (e = S));
              var o = this,
                a = function () {
                  var e,
                    a = l,
                    r = o.selector;
                  return (
                    a && a !== o && a.data.push(o),
                    n && (o.selector = Je(n)),
                    (l = o),
                    (e = t.apply(o, arguments)),
                    S(e) && o._r.push(e),
                    (l = a),
                    (o.selector = r),
                    (o.isReverted = !1),
                    e
                  );
                };
              return (o.last = a), e === S ? a(o) : e ? (o[e] = a) : a;
            }),
            (t.ignore = function (e) {
              var t = l;
              (l = null), e(this), (l = t);
            }),
            (t.getTweens = function () {
              var t = [];
              return (
                this.data.forEach(function (n) {
                  return n instanceof e
                    ? t.push.apply(t, n.getTweens())
                    : n instanceof Yt &&
                        !(n.parent && "nested" === n.parent.data) &&
                        t.push(n);
                }),
                t
              );
            }),
            (t.clear = function () {
              this._r.length = this.data.length = 0;
            }),
            (t.kill = function (e, t) {
              var n = this;
              if (e) {
                var o = this.getTweens();
                this.data.forEach(function (e) {
                  "isFlip" === e.data &&
                    (e.revert(),
                    e.getChildren(!0, !0, !1).forEach(function (e) {
                      return o.splice(o.indexOf(e), 1);
                    }));
                }),
                  o
                    .map(function (e) {
                      return { g: e.globalTime(0), t: e };
                    })
                    .sort(function (e, t) {
                      return t.g - e.g || -1 / 0;
                    })
                    .forEach(function (t) {
                      return t.t.revert(e);
                    }),
                  this.data.forEach(function (t) {
                    return !(t instanceof Yt) && t.revert && t.revert(e);
                  }),
                  this._r.forEach(function (t) {
                    return t(e, n);
                  }),
                  (this.isReverted = !0);
              } else
                this.data.forEach(function (e) {
                  return e.kill && e.kill();
                });
              if ((this.clear(), t))
                for (var a = sn.length; a--; )
                  sn[a].id === this.id && sn.splice(a, 1);
            }),
            (t.revert = function (e) {
              this.kill(e || {});
            }),
            e
          );
        })(),
        mn = (function () {
          function e(e) {
            (this.contexts = []), (this.scope = e);
          }
          var t = e.prototype;
          return (
            (t.add = function (e, t, n) {
              C(e) || (e = { matches: e });
              var o,
                a,
                r,
                i = new hn(0, n || this.scope),
                s = (i.conditions = {});
              for (a in (l && !i.selector && (i.selector = l.selector),
              this.contexts.push(i),
              (t = i.add("onMatch", t)),
              (i.queries = e),
              e))
                "all" === a
                  ? (r = 1)
                  : (o = c.matchMedia(e[a])) &&
                    (sn.indexOf(i) < 0 && sn.push(i),
                    (s[a] = o.matches) && (r = 1),
                    o.addListener
                      ? o.addListener(fn)
                      : o.addEventListener("change", fn));
              return r && t(i), this;
            }),
            (t.revert = function (e) {
              this.kill(e || {});
            }),
            (t.kill = function (e) {
              this.contexts.forEach(function (t) {
                return t.kill(e, !0);
              });
            }),
            e
          );
        })(),
        yn = {
          registerPlugin: function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
              t[n] = arguments[n];
            t.forEach(function (e) {
              return ut(e);
            });
          },
          timeline: function (e) {
            return new Nt(e);
          },
          getTweensOf: function (e, t) {
            return s.getTweensOf(e, t);
          },
          getProperty: function (e, t, n, o) {
            I(e) && (e = Qe(e)[0]);
            var a = le(e || {}).get,
              r = n ? ye : me;
            return (
              "native" === n && (n = ""),
              e
                ? t
                  ? r(((te[t] && te[t].get) || a)(e, t, n, o))
                  : function (t, n, o) {
                      return r(((te[t] && te[t].get) || a)(e, t, n, o));
                    }
                : e
            );
          },
          quickSetter: function (e, t, n) {
            if ((e = Qe(e)).length > 1) {
              var o = e.map(function (e) {
                  return gn.quickSetter(e, t, n);
                }),
                a = o.length;
              return function (e) {
                for (var t = a; t--; ) o[t](e);
              };
            }
            e = e[0] || {};
            var r = te[t],
              i = le(e),
              l = (i.harness && (i.harness.aliases || {})[t]) || t,
              s = r
                ? function (t) {
                    var o = new r();
                    (f._pt = 0),
                      o.init(e, n ? t + n : t, f, 0, [e]),
                      o.render(1, o),
                      f._pt && tn(1, f);
                  }
                : i.set(e, l);
            return r
              ? s
              : function (t) {
                  return s(e, l, n ? t + n : t, i, 1);
                };
          },
          quickTo: function (e, t, n) {
            var o,
              a = gn.to(
                e,
                ve((((o = {})[t] = "+=0.1"), (o.paused = !0), o), n || {}),
              ),
              r = function (e, n, o) {
                return a.resetTo(t, e, n, o);
              };
            return (r.tween = a), r;
          },
          isTweening: function (e) {
            return s.getTweensOf(e, !0).length > 0;
          },
          defaults: function (e) {
            return e && e.ease && (e.ease = Tt(e.ease, y.ease)), ge(y, e || {});
          },
          config: function (e) {
            return ge(m, e || {});
          },
          registerEffect: function (e) {
            var t = e.name,
              n = e.effect,
              o = e.plugins,
              a = e.defaults,
              r = e.extendTimeline;
            (o || "").split(",").forEach(function (e) {
              return (
                e &&
                !te[e] &&
                !H[e] &&
                Y(t + " effect requires " + e + " plugin.")
              );
            }),
              (ne[t] = function (e, t, o) {
                return n(Qe(e), be(t || {}, a), o);
              }),
              r &&
                (Nt.prototype[t] = function (e, n, o) {
                  return this.add(ne[t](e, C(n) ? n : (o = n) && {}, this), o);
                });
          },
          registerEase: function (e, t) {
            xt[e] = Tt(t);
          },
          parseEase: function (e, t) {
            return arguments.length ? Tt(e, t) : xt;
          },
          getById: function (e) {
            return s.getById(e);
          },
          exportRoot: function (e, t) {
            void 0 === e && (e = {});
            var n,
              o,
              a = new Nt(e);
            for (
              a.smoothChildTiming = M(e.smoothChildTiming),
                s.remove(a),
                a._dp = 0,
                a._time = a._tTime = s._time,
                n = s._first;
              n;

            )
              (o = n._next),
                (!t &&
                  !n._dur &&
                  n instanceof Yt &&
                  n.vars.onComplete === n._targets[0]) ||
                  De(a, n, n._start - n._delay),
                (n = o);
            return De(s, a, 0), a;
          },
          context: function (e, t) {
            return e ? new hn(e, t) : l;
          },
          matchMedia: function (e) {
            return new mn(e);
          },
          matchMediaRefresh: function () {
            return (
              sn.forEach(function (e) {
                var t,
                  n,
                  o = e.conditions;
                for (n in o) o[n] && ((o[n] = !1), (t = 1));
                t && e.revert();
              }) || fn()
            );
          },
          addEventListener: function (e, t) {
            var n = cn[e] || (cn[e] = []);
            ~n.indexOf(t) || n.push(t);
          },
          removeEventListener: function (e, t) {
            var n = cn[e],
              o = n && n.indexOf(t);
            o >= 0 && n.splice(o, 1);
          },
          utils: {
            wrap: function e(t, n, o) {
              var a = n - t;
              return B(t)
                ? at(t, e(0, t.length), n)
                : Ge(o, function (e) {
                    return ((a + ((e - t) % a)) % a) + t;
                  });
            },
            wrapYoyo: function e(t, n, o) {
              var a = n - t,
                r = 2 * a;
              return B(t)
                ? at(t, e(0, t.length - 1), n)
                : Ge(o, function (e) {
                    return (
                      t + ((e = (r + ((e - t) % r)) % r || 0) > a ? r - e : e)
                    );
                  });
            },
            distribute: et,
            random: ot,
            snap: nt,
            normalize: function (e, t, n) {
              return it(e, t, 0, 1, n);
            },
            getUnit: qe,
            clamp: function (e, t, n) {
              return Ge(n, function (n) {
                return Ye(e, t, n);
              });
            },
            splitColor: ft,
            toArray: Qe,
            selector: Je,
            mapRange: it,
            pipe: function () {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              return function (e) {
                return t.reduce(function (e, t) {
                  return t(e);
                }, e);
              };
            },
            unitize: function (e, t) {
              return function (n) {
                return e(parseFloat(n)) + (t || qe(n));
              };
            },
            interpolate: function e(t, n, o, a) {
              var r = isNaN(t + n)
                ? 0
                : function (e) {
                    return (1 - e) * t + e * n;
                  };
              if (!r) {
                var i,
                  l,
                  s,
                  c,
                  _,
                  u = I(t),
                  d = {};
                if ((!0 === o && (a = 1) && (o = null), u))
                  (t = { p: t }), (n = { p: n });
                else if (B(t) && !B(n)) {
                  for (s = [], c = t.length, _ = c - 2, l = 1; l < c; l++)
                    s.push(e(t[l - 1], t[l]));
                  c--,
                    (r = function (e) {
                      e *= c;
                      var t = Math.min(_, ~~e);
                      return s[t](e - t);
                    }),
                    (o = n);
                } else a || (t = ve(B(t) ? [] : {}, t));
                if (!s) {
                  for (i in n) Rt.call(d, t, i, "get", n[i]);
                  r = function (e) {
                    return tn(e, d) || (u ? t.p : t);
                  };
                }
              }
              return Ge(o, r);
            },
            shuffle: $e,
          },
          install: U,
          effects: ne,
          ticker: gt,
          updateRoot: Nt.updateRoot,
          plugins: te,
          globalTimeline: s,
          core: {
            PropTween: ln,
            globals: q,
            Tween: Yt,
            Timeline: Nt,
            Animation: Bt,
            getCache: le,
            _removeLinkedListItem: Oe,
            reverting: function () {
              return i;
            },
            context: function (e) {
              return e && l && (l.data.push(e), (e._ctx = l)), l;
            },
            suppressOverwrites: function (e) {
              return (r = e);
            },
          },
        };
      ce("to,from,fromTo,delayedCall,set,killTweensOf", function (e) {
        return (yn[e] = Yt[e]);
      }),
        gt.add(Nt.updateRoot),
        (f = yn.to({}, { duration: 0 }));
      var bn = function (e, t) {
          for (var n = e._pt; n && n.p !== t && n.op !== t && n.fp !== t; )
            n = n._next;
          return n;
        },
        vn = function (e, t) {
          return {
            name: e,
            rawVars: 1,
            init: function (e, n, o) {
              o._onInit = function (e) {
                var o, a;
                if (
                  (I(n) &&
                    ((o = {}),
                    ce(n, function (e) {
                      return (o[e] = 1);
                    }),
                    (n = o)),
                  t)
                ) {
                  for (a in ((o = {}), n)) o[a] = t(n[a]);
                  n = o;
                }
                !(function (e, t) {
                  var n,
                    o,
                    a,
                    r = e._targets;
                  for (n in t)
                    for (o = r.length; o--; )
                      (a = e._ptLookup[o][n]) &&
                        (a = a.d) &&
                        (a._pt && (a = bn(a, n)),
                        a && a.modifier && a.modifier(t[n], e, r[o], n));
                })(e, n);
              };
            },
          };
        },
        gn =
          yn.registerPlugin(
            {
              name: "attr",
              init: function (e, t, n, o, a) {
                var r, i, l;
                for (r in ((this.tween = n), t))
                  (l = e.getAttribute(r) || ""),
                    ((i = this.add(
                      e,
                      "setAttribute",
                      (l || 0) + "",
                      t[r],
                      o,
                      a,
                      0,
                      0,
                      r,
                    )).op = r),
                    (i.b = l),
                    this._props.push(r);
              },
              render: function (e, t) {
                for (var n = t._pt; n; )
                  i ? n.set(n.t, n.p, n.b, n) : n.r(e, n.d), (n = n._next);
              },
            },
            {
              name: "endArray",
              init: function (e, t) {
                for (var n = t.length; n--; )
                  this.add(e, n, e[n] || 0, t[n], 0, 0, 0, 0, 0, 1);
              },
            },
            vn("roundProps", tt),
            vn("modifiers"),
            vn("snap", nt),
          ) || yn;
      (Yt.version = Nt.version = gn.version = "3.12.2"), (d = 1), P() && wt();
      xt.Power0,
        xt.Power1,
        xt.Power2,
        xt.Power3,
        xt.Power4,
        xt.Linear,
        xt.Quad,
        xt.Cubic,
        xt.Quart,
        xt.Quint,
        xt.Strong,
        xt.Elastic,
        xt.Back,
        xt.SteppedEase,
        xt.Bounce,
        xt.Sine,
        xt.Expo,
        xt.Circ;
      var wn,
        xn,
        kn,
        On,
        In,
        Sn,
        jn,
        Tn,
        Cn = {},
        Mn = 180 / Math.PI,
        Pn = Math.PI / 180,
        En = Math.atan2,
        Ln = /([A-Z])/g,
        Bn = /(left|right|width|margin|padding|x)/i,
        Nn = /[\s,\(]\S/,
        Dn = {
          autoAlpha: "opacity,visibility",
          scale: "scaleX,scaleY",
          alpha: "opacity",
        },
        zn = function (e, t) {
          return t.set(
            t.t,
            t.p,
            Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t,
          );
        },
        An = function (e, t) {
          return t.set(
            t.t,
            t.p,
            1 === e ? t.e : Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u,
            t,
          );
        },
        Rn = function (e, t) {
          return t.set(
            t.t,
            t.p,
            e ? Math.round(1e4 * (t.s + t.c * e)) / 1e4 + t.u : t.b,
            t,
          );
        },
        Fn = function (e, t) {
          var n = t.s + t.c * e;
          t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : 0.5)) + t.u, t);
        },
        Vn = function (e, t) {
          return t.set(t.t, t.p, e ? t.e : t.b, t);
        },
        Hn = function (e, t) {
          return t.set(t.t, t.p, 1 !== e ? t.b : t.e, t);
        },
        Wn = function (e, t, n) {
          return (e.style[t] = n);
        },
        Un = function (e, t, n) {
          return e.style.setProperty(t, n);
        },
        Gn = function (e, t, n) {
          return (e._gsap[t] = n);
        },
        Yn = function (e, t, n) {
          return (e._gsap.scaleX = e._gsap.scaleY = n);
        },
        qn = function (e, t, n, o, a) {
          var r = e._gsap;
          (r.scaleX = r.scaleY = n), r.renderTransform(a, r);
        },
        Xn = function (e, t, n, o, a) {
          var r = e._gsap;
          (r[t] = n), r.renderTransform(a, r);
        },
        Zn = "transform",
        Kn = Zn + "Origin",
        Qn = function e(t, n) {
          var o = this,
            a = this.target,
            r = a.style;
          if (t in Cn && r) {
            if (((this.tfm = this.tfm || {}), "transform" === t))
              return Dn.transform.split(",").forEach(function (t) {
                return e.call(o, t, n);
              });
            if (
              (~(t = Dn[t] || t).indexOf(",")
                ? t.split(",").forEach(function (e) {
                    return (o.tfm[e] = mo(a, e));
                  })
                : (this.tfm[t] = a._gsap.x ? a._gsap[t] : mo(a, t)),
              this.props.indexOf(Zn) >= 0)
            )
              return;
            a._gsap.svg &&
              ((this.svgo = a.getAttribute("data-svg-origin")),
              this.props.push(Kn, n, "")),
              (t = Zn);
          }
          (r || n) && this.props.push(t, n, r[t]);
        },
        Jn = function (e) {
          e.translate &&
            (e.removeProperty("translate"),
            e.removeProperty("scale"),
            e.removeProperty("rotate"));
        },
        $n = function () {
          var e,
            t,
            n = this.props,
            o = this.target,
            a = o.style,
            r = o._gsap;
          for (e = 0; e < n.length; e += 3)
            n[e + 1]
              ? (o[n[e]] = n[e + 2])
              : n[e + 2]
                ? (a[n[e]] = n[e + 2])
                : a.removeProperty(
                    "--" === n[e].substr(0, 2)
                      ? n[e]
                      : n[e].replace(Ln, "-$1").toLowerCase(),
                  );
          if (this.tfm) {
            for (t in this.tfm) r[t] = this.tfm[t];
            r.svg &&
              (r.renderTransform(),
              o.setAttribute("data-svg-origin", this.svgo || "")),
              ((e = jn()) && e.isStart) || a[Zn] || (Jn(a), (r.uncache = 1));
          }
        },
        eo = function (e, t) {
          var n = { target: e, props: [], revert: $n, save: Qn };
          return (
            e._gsap || gn.core.getCache(e),
            t &&
              t.split(",").forEach(function (e) {
                return n.save(e);
              }),
            n
          );
        },
        to = function (e, t) {
          var n = xn.createElementNS
            ? xn.createElementNS(
                (t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"),
                e,
              )
            : xn.createElement(e);
          return n.style ? n : xn.createElement(e);
        },
        no = function e(t, n, o) {
          var a = getComputedStyle(t);
          return (
            a[n] ||
            a.getPropertyValue(n.replace(Ln, "-$1").toLowerCase()) ||
            a.getPropertyValue(n) ||
            (!o && e(t, ao(n) || n, 1)) ||
            ""
          );
        },
        oo = "O,Moz,ms,Ms,Webkit".split(","),
        ao = function (e, t, n) {
          var o = (t || In).style,
            a = 5;
          if (e in o && !n) return e;
          for (
            e = e.charAt(0).toUpperCase() + e.substr(1);
            a-- && !(oo[a] + e in o);

          );
          return a < 0 ? null : (3 === a ? "ms" : a >= 0 ? oo[a] : "") + e;
        },
        ro = function () {
          "undefined" !== typeof window &&
            window.document &&
            ((wn = window),
            (xn = wn.document),
            (kn = xn.documentElement),
            (In = to("div") || { style: {} }),
            to("div"),
            (Zn = ao(Zn)),
            (Kn = Zn + "Origin"),
            (In.style.cssText =
              "border-width:0;line-height:0;position:absolute;padding:0"),
            (Tn = !!ao("perspective")),
            (jn = gn.core.reverting),
            (On = 1));
        },
        io = function e(t) {
          var n,
            o = to(
              "svg",
              (this.ownerSVGElement &&
                this.ownerSVGElement.getAttribute("xmlns")) ||
                "http://www.w3.org/2000/svg",
            ),
            a = this.parentNode,
            r = this.nextSibling,
            i = this.style.cssText;
          if (
            (kn.appendChild(o),
            o.appendChild(this),
            (this.style.display = "block"),
            t)
          )
            try {
              (n = this.getBBox()),
                (this._gsapBBox = this.getBBox),
                (this.getBBox = e);
            } catch (l) {}
          else this._gsapBBox && (n = this._gsapBBox());
          return (
            a && (r ? a.insertBefore(this, r) : a.appendChild(this)),
            kn.removeChild(o),
            (this.style.cssText = i),
            n
          );
        },
        lo = function (e, t) {
          for (var n = t.length; n--; )
            if (e.hasAttribute(t[n])) return e.getAttribute(t[n]);
        },
        so = function (e) {
          var t;
          try {
            t = e.getBBox();
          } catch (n) {
            t = io.call(e, !0);
          }
          return (
            (t && (t.width || t.height)) ||
              e.getBBox === io ||
              (t = io.call(e, !0)),
            !t || t.width || t.x || t.y
              ? t
              : {
                  x: +lo(e, ["x", "cx", "x1"]) || 0,
                  y: +lo(e, ["y", "cy", "y1"]) || 0,
                  width: 0,
                  height: 0,
                }
          );
        },
        co = function (e) {
          return !(!e.getCTM || (e.parentNode && !e.ownerSVGElement) || !so(e));
        },
        _o = function (e, t) {
          if (t) {
            var n = e.style;
            t in Cn && t !== Kn && (t = Zn),
              n.removeProperty
                ? (("ms" !== t.substr(0, 2) && "webkit" !== t.substr(0, 6)) ||
                    (t = "-" + t),
                  n.removeProperty(t.replace(Ln, "-$1").toLowerCase()))
                : n.removeAttribute(t);
          }
        },
        uo = function (e, t, n, o, a, r) {
          var i = new ln(e._pt, t, n, 0, 1, r ? Hn : Vn);
          return (e._pt = i), (i.b = o), (i.e = a), e._props.push(n), i;
        },
        po = { deg: 1, rad: 1, turn: 1 },
        fo = { grid: 1, flex: 1 },
        ho = function e(t, n, o, a) {
          var r,
            i,
            l,
            s,
            c = parseFloat(o) || 0,
            _ = (o + "").trim().substr((c + "").length) || "px",
            u = In.style,
            d = Bn.test(n),
            p = "svg" === t.tagName.toLowerCase(),
            f = (p ? "client" : "offset") + (d ? "Width" : "Height"),
            h = "px" === a,
            m = "%" === a;
          return a === _ || !c || po[a] || po[_]
            ? c
            : ("px" !== _ && !h && (c = e(t, n, o, "px")),
              (s = t.getCTM && co(t)),
              (!m && "%" !== _) || (!Cn[n] && !~n.indexOf("adius"))
                ? ((u[d ? "width" : "height"] = 100 + (h ? _ : a)),
                  (i =
                    ~n.indexOf("adius") || ("em" === a && t.appendChild && !p)
                      ? t
                      : t.parentNode),
                  s && (i = (t.ownerSVGElement || {}).parentNode),
                  (i && i !== xn && i.appendChild) || (i = xn.body),
                  (l = i._gsap) &&
                  m &&
                  l.width &&
                  d &&
                  l.time === gt.time &&
                  !l.uncache
                    ? _e((c / l.width) * 100)
                    : ((m || "%" === _) &&
                        !fo[no(i, "display")] &&
                        (u.position = no(t, "position")),
                      i === t && (u.position = "static"),
                      i.appendChild(In),
                      (r = In[f]),
                      i.removeChild(In),
                      (u.position = "absolute"),
                      d &&
                        m &&
                        (((l = le(i)).time = gt.time), (l.width = i[f])),
                      _e(h ? (r * c) / 100 : r && c ? (100 / r) * c : 0)))
                : ((r = s ? t.getBBox()[d ? "width" : "height"] : t[f]),
                  _e(m ? (c / r) * 100 : (c / 100) * r)));
        },
        mo = function (e, t, n, o) {
          var a;
          return (
            On || ro(),
            t in Dn &&
              "transform" !== t &&
              ~(t = Dn[t]).indexOf(",") &&
              (t = t.split(",")[0]),
            Cn[t] && "transform" !== t
              ? ((a = To(e, o)),
                (a =
                  "transformOrigin" !== t
                    ? a[t]
                    : a.svg
                      ? a.origin
                      : Co(no(e, Kn)) + " " + a.zOrigin + "px"))
              : (!(a = e.style[t]) ||
                  "auto" === a ||
                  o ||
                  ~(a + "").indexOf("calc(")) &&
                (a =
                  (wo[t] && wo[t](e, t, n)) ||
                  no(e, t) ||
                  se(e, t) ||
                  ("opacity" === t ? 1 : 0)),
            n && !~(a + "").trim().indexOf(" ") ? ho(e, t, a, n) + n : a
          );
        },
        yo = function (e, t, n, o) {
          if (!n || "none" === n) {
            var a = ao(t, e, 1),
              r = a && no(e, a, 1);
            r && r !== n
              ? ((t = a), (n = r))
              : "borderColor" === t && (n = no(e, "borderTopColor"));
          }
          var i,
            l,
            s,
            c,
            _,
            u,
            d,
            p,
            f,
            h,
            y,
            b = new ln(this._pt, e.style, t, 0, 1, en),
            v = 0,
            g = 0;
          if (
            ((b.b = n),
            (b.e = o),
            (n += ""),
            "auto" === (o += "") &&
              ((e.style[t] = o), (o = no(e, t) || o), (e.style[t] = n)),
            vt((i = [n, o])),
            (o = i[1]),
            (s = (n = i[0]).match(z) || []),
            (o.match(z) || []).length)
          ) {
            for (; (l = z.exec(o)); )
              (d = l[0]),
                (f = o.substring(v, l.index)),
                _
                  ? (_ = (_ + 1) % 5)
                  : ("rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5)) ||
                    (_ = 1),
                d !== (u = s[g++] || "") &&
                  ((c = parseFloat(u) || 0),
                  (y = u.substr((c + "").length)),
                  "=" === d.charAt(1) && (d = de(c, d) + y),
                  (p = parseFloat(d)),
                  (h = d.substr((p + "").length)),
                  (v = z.lastIndex - h.length),
                  h ||
                    ((h = h || m.units[t] || y),
                    v === o.length && ((o += h), (b.e += h))),
                  y !== h && (c = ho(e, t, u, h) || 0),
                  (b._pt = {
                    _next: b._pt,
                    p: f || 1 === g ? f : ",",
                    s: c,
                    c: p - c,
                    m: (_ && _ < 4) || "zIndex" === t ? Math.round : 0,
                  }));
            b.c = v < o.length ? o.substring(v, o.length) : "";
          } else b.r = "display" === t && "none" === o ? Hn : Vn;
          return R.test(o) && (b.e = 0), (this._pt = b), b;
        },
        bo = {
          top: "0%",
          bottom: "100%",
          left: "0%",
          right: "100%",
          center: "50%",
        },
        vo = function (e) {
          var t = e.split(" "),
            n = t[0],
            o = t[1] || "50%";
          return (
            ("top" !== n && "bottom" !== n && "left" !== o && "right" !== o) ||
              ((e = n), (n = o), (o = e)),
            (t[0] = bo[n] || n),
            (t[1] = bo[o] || o),
            t.join(" ")
          );
        },
        go = function (e, t) {
          if (t.tween && t.tween._time === t.tween._dur) {
            var n,
              o,
              a,
              r = t.t,
              i = r.style,
              l = t.u,
              s = r._gsap;
            if ("all" === l || !0 === l) (i.cssText = ""), (o = 1);
            else
              for (a = (l = l.split(",")).length; --a > -1; )
                (n = l[a]),
                  Cn[n] && ((o = 1), (n = "transformOrigin" === n ? Kn : Zn)),
                  _o(r, n);
            o &&
              (_o(r, Zn),
              s &&
                (s.svg && r.removeAttribute("transform"),
                To(r, 1),
                (s.uncache = 1),
                Jn(i)));
          }
        },
        wo = {
          clearProps: function (e, t, n, o, a) {
            if ("isFromStart" !== a.data) {
              var r = (e._pt = new ln(e._pt, t, n, 0, 0, go));
              return (
                (r.u = o), (r.pr = -10), (r.tween = a), e._props.push(n), 1
              );
            }
          },
        },
        xo = [1, 0, 0, 1, 0, 0],
        ko = {},
        Oo = function (e) {
          return "matrix(1, 0, 0, 1, 0, 0)" === e || "none" === e || !e;
        },
        Io = function (e) {
          var t = no(e, Zn);
          return Oo(t) ? xo : t.substr(7).match(D).map(_e);
        },
        So = function (e, t) {
          var n,
            o,
            a,
            r,
            i = e._gsap || le(e),
            l = e.style,
            s = Io(e);
          return i.svg && e.getAttribute("transform")
            ? "1,0,0,1,0,0" ===
              (s = [
                (a = e.transform.baseVal.consolidate().matrix).a,
                a.b,
                a.c,
                a.d,
                a.e,
                a.f,
              ]).join(",")
              ? xo
              : s
            : (s !== xo ||
                e.offsetParent ||
                e === kn ||
                i.svg ||
                ((a = l.display),
                (l.display = "block"),
                ((n = e.parentNode) && e.offsetParent) ||
                  ((r = 1), (o = e.nextElementSibling), kn.appendChild(e)),
                (s = Io(e)),
                a ? (l.display = a) : _o(e, "display"),
                r &&
                  (o
                    ? n.insertBefore(e, o)
                    : n
                      ? n.appendChild(e)
                      : kn.removeChild(e))),
              t && s.length > 6 ? [s[0], s[1], s[4], s[5], s[12], s[13]] : s);
        },
        jo = function (e, t, n, o, a, r) {
          var i,
            l,
            s,
            c = e._gsap,
            _ = a || So(e, !0),
            u = c.xOrigin || 0,
            d = c.yOrigin || 0,
            p = c.xOffset || 0,
            f = c.yOffset || 0,
            h = _[0],
            m = _[1],
            y = _[2],
            b = _[3],
            v = _[4],
            g = _[5],
            w = t.split(" "),
            x = parseFloat(w[0]) || 0,
            k = parseFloat(w[1]) || 0;
          n
            ? _ !== xo &&
              (l = h * b - m * y) &&
              ((s = x * (-m / l) + k * (h / l) - (h * g - m * v) / l),
              (x = x * (b / l) + k * (-y / l) + (y * g - b * v) / l),
              (k = s))
            : ((x =
                (i = so(e)).x + (~w[0].indexOf("%") ? (x / 100) * i.width : x)),
              (k =
                i.y +
                (~(w[1] || w[0]).indexOf("%") ? (k / 100) * i.height : k))),
            o || (!1 !== o && c.smooth)
              ? ((v = x - u),
                (g = k - d),
                (c.xOffset = p + (v * h + g * y) - v),
                (c.yOffset = f + (v * m + g * b) - g))
              : (c.xOffset = c.yOffset = 0),
            (c.xOrigin = x),
            (c.yOrigin = k),
            (c.smooth = !!o),
            (c.origin = t),
            (c.originIsAbsolute = !!n),
            (e.style[Kn] = "0px 0px"),
            r &&
              (uo(r, c, "xOrigin", u, x),
              uo(r, c, "yOrigin", d, k),
              uo(r, c, "xOffset", p, c.xOffset),
              uo(r, c, "yOffset", f, c.yOffset)),
            e.setAttribute("data-svg-origin", x + " " + k);
        },
        To = function (e, t) {
          var n = e._gsap || new Lt(e);
          if ("x" in n && !t && !n.uncache) return n;
          var o,
            a,
            r,
            i,
            l,
            s,
            c,
            _,
            u,
            d,
            p,
            f,
            h,
            y,
            b,
            v,
            g,
            w,
            x,
            k,
            O,
            I,
            S,
            j,
            T,
            C,
            M,
            P,
            E,
            L,
            B,
            N,
            D = e.style,
            z = n.scaleX < 0,
            A = getComputedStyle(e),
            R = no(e, Kn) || "0";
          return (
            (o = a = r = s = c = _ = u = d = p = 0),
            (i = l = 1),
            (n.svg = !(!e.getCTM || !co(e))),
            A.translate &&
              (("none" === A.translate &&
                "none" === A.scale &&
                "none" === A.rotate) ||
                (D[Zn] =
                  ("none" !== A.translate
                    ? "translate3d(" +
                      (A.translate + " 0 0").split(" ").slice(0, 3).join(", ") +
                      ") "
                    : "") +
                  ("none" !== A.rotate ? "rotate(" + A.rotate + ") " : "") +
                  ("none" !== A.scale
                    ? "scale(" + A.scale.split(" ").join(",") + ") "
                    : "") +
                  ("none" !== A[Zn] ? A[Zn] : "")),
              (D.scale = D.rotate = D.translate = "none")),
            (y = So(e, n.svg)),
            n.svg &&
              (n.uncache
                ? ((T = e.getBBox()),
                  (R = n.xOrigin - T.x + "px " + (n.yOrigin - T.y) + "px"),
                  (j = ""))
                : (j = !t && e.getAttribute("data-svg-origin")),
              jo(e, j || R, !!j || n.originIsAbsolute, !1 !== n.smooth, y)),
            (f = n.xOrigin || 0),
            (h = n.yOrigin || 0),
            y !== xo &&
              ((w = y[0]),
              (x = y[1]),
              (k = y[2]),
              (O = y[3]),
              (o = I = y[4]),
              (a = S = y[5]),
              6 === y.length
                ? ((i = Math.sqrt(w * w + x * x)),
                  (l = Math.sqrt(O * O + k * k)),
                  (s = w || x ? En(x, w) * Mn : 0),
                  (u = k || O ? En(k, O) * Mn + s : 0) &&
                    (l *= Math.abs(Math.cos(u * Pn))),
                  n.svg &&
                    ((o -= f - (f * w + h * k)), (a -= h - (f * x + h * O))))
                : ((N = y[6]),
                  (L = y[7]),
                  (M = y[8]),
                  (P = y[9]),
                  (E = y[10]),
                  (B = y[11]),
                  (o = y[12]),
                  (a = y[13]),
                  (r = y[14]),
                  (c = (b = En(N, E)) * Mn),
                  b &&
                    ((j = I * (v = Math.cos(-b)) + M * (g = Math.sin(-b))),
                    (T = S * v + P * g),
                    (C = N * v + E * g),
                    (M = I * -g + M * v),
                    (P = S * -g + P * v),
                    (E = N * -g + E * v),
                    (B = L * -g + B * v),
                    (I = j),
                    (S = T),
                    (N = C)),
                  (_ = (b = En(-k, E)) * Mn),
                  b &&
                    ((v = Math.cos(-b)),
                    (B = O * (g = Math.sin(-b)) + B * v),
                    (w = j = w * v - M * g),
                    (x = T = x * v - P * g),
                    (k = C = k * v - E * g)),
                  (s = (b = En(x, w)) * Mn),
                  b &&
                    ((j = w * (v = Math.cos(b)) + x * (g = Math.sin(b))),
                    (T = I * v + S * g),
                    (x = x * v - w * g),
                    (S = S * v - I * g),
                    (w = j),
                    (I = T)),
                  c &&
                    Math.abs(c) + Math.abs(s) > 359.9 &&
                    ((c = s = 0), (_ = 180 - _)),
                  (i = _e(Math.sqrt(w * w + x * x + k * k))),
                  (l = _e(Math.sqrt(S * S + N * N))),
                  (b = En(I, S)),
                  (u = Math.abs(b) > 2e-4 ? b * Mn : 0),
                  (p = B ? 1 / (B < 0 ? -B : B) : 0)),
              n.svg &&
                ((j = e.getAttribute("transform")),
                (n.forceCSS =
                  e.setAttribute("transform", "") || !Oo(no(e, Zn))),
                j && e.setAttribute("transform", j))),
            Math.abs(u) > 90 &&
              Math.abs(u) < 270 &&
              (z
                ? ((i *= -1),
                  (u += s <= 0 ? 180 : -180),
                  (s += s <= 0 ? 180 : -180))
                : ((l *= -1), (u += u <= 0 ? 180 : -180))),
            (t = t || n.uncache),
            (n.x =
              o -
              ((n.xPercent =
                o &&
                ((!t && n.xPercent) ||
                  (Math.round(e.offsetWidth / 2) === Math.round(-o) ? -50 : 0)))
                ? (e.offsetWidth * n.xPercent) / 100
                : 0) +
              "px"),
            (n.y =
              a -
              ((n.yPercent =
                a &&
                ((!t && n.yPercent) ||
                  (Math.round(e.offsetHeight / 2) === Math.round(-a)
                    ? -50
                    : 0)))
                ? (e.offsetHeight * n.yPercent) / 100
                : 0) +
              "px"),
            (n.z = r + "px"),
            (n.scaleX = _e(i)),
            (n.scaleY = _e(l)),
            (n.rotation = _e(s) + "deg"),
            (n.rotationX = _e(c) + "deg"),
            (n.rotationY = _e(_) + "deg"),
            (n.skewX = u + "deg"),
            (n.skewY = d + "deg"),
            (n.transformPerspective = p + "px"),
            (n.zOrigin = parseFloat(R.split(" ")[2]) || 0) && (D[Kn] = Co(R)),
            (n.xOffset = n.yOffset = 0),
            (n.force3D = m.force3D),
            (n.renderTransform = n.svg ? Lo : Tn ? Eo : Po),
            (n.uncache = 0),
            n
          );
        },
        Co = function (e) {
          return (e = e.split(" "))[0] + " " + e[1];
        },
        Mo = function (e, t, n) {
          var o = qe(t);
          return _e(parseFloat(t) + parseFloat(ho(e, "x", n + "px", o))) + o;
        },
        Po = function (e, t) {
          (t.z = "0px"),
            (t.rotationY = t.rotationX = "0deg"),
            (t.force3D = 0),
            Eo(e, t);
        },
        Eo = function (e, t) {
          var n = t || this,
            o = n.xPercent,
            a = n.yPercent,
            r = n.x,
            i = n.y,
            l = n.z,
            s = n.rotation,
            c = n.rotationY,
            _ = n.rotationX,
            u = n.skewX,
            d = n.skewY,
            p = n.scaleX,
            f = n.scaleY,
            h = n.transformPerspective,
            m = n.force3D,
            y = n.target,
            b = n.zOrigin,
            v = "",
            g = ("auto" === m && e && 1 !== e) || !0 === m;
          if (b && ("0deg" !== _ || "0deg" !== c)) {
            var w,
              x = parseFloat(c) * Pn,
              k = Math.sin(x),
              O = Math.cos(x);
            (x = parseFloat(_) * Pn),
              (w = Math.cos(x)),
              (r = Mo(y, r, k * w * -b)),
              (i = Mo(y, i, -Math.sin(x) * -b)),
              (l = Mo(y, l, O * w * -b + b));
          }
          "0px" !== h && (v += "perspective(" + h + ") "),
            (o || a) && (v += "translate(" + o + "%, " + a + "%) "),
            (g || "0px" !== r || "0px" !== i || "0px" !== l) &&
              (v +=
                "0px" !== l || g
                  ? "translate3d(" + r + ", " + i + ", " + l + ") "
                  : "translate(" + r + ", " + i + ") "),
            "0deg" !== s && (v += "rotate(" + s + ") "),
            "0deg" !== c && (v += "rotateY(" + c + ") "),
            "0deg" !== _ && (v += "rotateX(" + _ + ") "),
            ("0deg" === u && "0deg" === d) ||
              (v += "skew(" + u + ", " + d + ") "),
            (1 === p && 1 === f) || (v += "scale(" + p + ", " + f + ") "),
            (y.style[Zn] = v || "translate(0, 0)");
        },
        Lo = function (e, t) {
          var n,
            o,
            a,
            r,
            i,
            l = t || this,
            s = l.xPercent,
            c = l.yPercent,
            _ = l.x,
            u = l.y,
            d = l.rotation,
            p = l.skewX,
            f = l.skewY,
            h = l.scaleX,
            m = l.scaleY,
            y = l.target,
            b = l.xOrigin,
            v = l.yOrigin,
            g = l.xOffset,
            w = l.yOffset,
            x = l.forceCSS,
            k = parseFloat(_),
            O = parseFloat(u);
          (d = parseFloat(d)),
            (p = parseFloat(p)),
            (f = parseFloat(f)) && ((p += f = parseFloat(f)), (d += f)),
            d || p
              ? ((d *= Pn),
                (p *= Pn),
                (n = Math.cos(d) * h),
                (o = Math.sin(d) * h),
                (a = Math.sin(d - p) * -m),
                (r = Math.cos(d - p) * m),
                p &&
                  ((f *= Pn),
                  (i = Math.tan(p - f)),
                  (a *= i = Math.sqrt(1 + i * i)),
                  (r *= i),
                  f &&
                    ((i = Math.tan(f)),
                    (n *= i = Math.sqrt(1 + i * i)),
                    (o *= i))),
                (n = _e(n)),
                (o = _e(o)),
                (a = _e(a)),
                (r = _e(r)))
              : ((n = h), (r = m), (o = a = 0)),
            ((k && !~(_ + "").indexOf("px")) ||
              (O && !~(u + "").indexOf("px"))) &&
              ((k = ho(y, "x", _, "px")), (O = ho(y, "y", u, "px"))),
            (b || v || g || w) &&
              ((k = _e(k + b - (b * n + v * a) + g)),
              (O = _e(O + v - (b * o + v * r) + w))),
            (s || c) &&
              ((i = y.getBBox()),
              (k = _e(k + (s / 100) * i.width)),
              (O = _e(O + (c / 100) * i.height))),
            (i =
              "matrix(" +
              n +
              "," +
              o +
              "," +
              a +
              "," +
              r +
              "," +
              k +
              "," +
              O +
              ")"),
            y.setAttribute("transform", i),
            x && (y.style[Zn] = i);
        },
        Bo = function (e, t, n, o, a) {
          var r,
            i,
            l = I(a),
            s = parseFloat(a) * (l && ~a.indexOf("rad") ? Mn : 1) - o,
            c = o + s + "deg";
          return (
            l &&
              ("short" === (r = a.split("_")[1]) &&
                (s %= 360) !== s % 180 &&
                (s += s < 0 ? 360 : -360),
              "cw" === r && s < 0
                ? (s = ((s + 36e9) % 360) - 360 * ~~(s / 360))
                : "ccw" === r &&
                  s > 0 &&
                  (s = ((s - 36e9) % 360) - 360 * ~~(s / 360))),
            (e._pt = i = new ln(e._pt, t, n, o, s, An)),
            (i.e = c),
            (i.u = "deg"),
            e._props.push(n),
            i
          );
        },
        No = function (e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        },
        Do = function (e, t, n) {
          var o,
            a,
            r,
            i,
            l,
            s,
            c,
            _ = No({}, n._gsap),
            u = n.style;
          for (a in (_.svg
            ? ((r = n.getAttribute("transform")),
              n.setAttribute("transform", ""),
              (u[Zn] = t),
              (o = To(n, 1)),
              _o(n, Zn),
              n.setAttribute("transform", r))
            : ((r = getComputedStyle(n)[Zn]),
              (u[Zn] = t),
              (o = To(n, 1)),
              (u[Zn] = r)),
          Cn))
            (r = _[a]) !== (i = o[a]) &&
              "perspective,force3D,transformOrigin,svgOrigin".indexOf(a) < 0 &&
              ((l = qe(r) !== (c = qe(i)) ? ho(n, a, r, c) : parseFloat(r)),
              (s = parseFloat(i)),
              (e._pt = new ln(e._pt, o, a, l, s - l, zn)),
              (e._pt.u = c || 0),
              e._props.push(a));
          No(o, _);
        };
      ce("padding,margin,Width,Radius", function (e, t) {
        var n = "Top",
          o = "Right",
          a = "Bottom",
          r = "Left",
          i = (t < 3 ? [n, o, a, r] : [n + r, n + o, a + o, a + r]).map(
            function (n) {
              return t < 2 ? e + n : "border" + n + e;
            },
          );
        wo[t > 1 ? "border" + e : e] = function (e, t, n, o, a) {
          var r, l;
          if (arguments.length < 4)
            return (
              (r = i.map(function (t) {
                return mo(e, t, n);
              })),
              5 === (l = r.join(" ")).split(r[0]).length ? r[0] : l
            );
          (r = (o + "").split(" ")),
            (l = {}),
            i.forEach(function (e, t) {
              return (l[e] = r[t] = r[t] || r[((t - 1) / 2) | 0]);
            }),
            e.init(t, l, a);
        };
      });
      var zo = {
        name: "css",
        register: ro,
        targetTest: function (e) {
          return e.style && e.nodeType;
        },
        init: function (e, t, n, o, a) {
          var r,
            i,
            l,
            s,
            c,
            _,
            u,
            d,
            p,
            f,
            h,
            y,
            b,
            v,
            g,
            w,
            x = this._props,
            k = e.style,
            O = n.vars.startAt;
          for (u in (On || ro(),
          (this.styles = this.styles || eo(e)),
          (w = this.styles.props),
          (this.tween = n),
          t))
            if (
              "autoRound" !== u &&
              ((i = t[u]), !te[u] || !Ft(u, t, n, o, e, a))
            )
              if (
                ((c = typeof i),
                (_ = wo[u]),
                "function" === c && (c = typeof (i = i.call(n, o, e, a))),
                "string" === c && ~i.indexOf("random(") && (i = rt(i)),
                _)
              )
                _(this, e, u, i, n) && (g = 1);
              else if ("--" === u.substr(0, 2))
                (r = (getComputedStyle(e).getPropertyValue(u) + "").trim()),
                  (i += ""),
                  (yt.lastIndex = 0),
                  yt.test(r) || ((d = qe(r)), (p = qe(i))),
                  p ? d !== p && (r = ho(e, u, r, p) + p) : d && (i += d),
                  this.add(k, "setProperty", r, i, o, a, 0, 0, u),
                  x.push(u),
                  w.push(u, 0, k[u]);
              else if ("undefined" !== c) {
                if (
                  (O && u in O
                    ? ((r =
                        "function" === typeof O[u]
                          ? O[u].call(n, o, e, a)
                          : O[u]),
                      I(r) && ~r.indexOf("random(") && (r = rt(r)),
                      qe(r + "") || (r += m.units[u] || qe(mo(e, u)) || ""),
                      "=" === (r + "").charAt(1) && (r = mo(e, u)))
                    : (r = mo(e, u)),
                  (s = parseFloat(r)),
                  (f =
                    "string" === c && "=" === i.charAt(1) && i.substr(0, 2)) &&
                    (i = i.substr(2)),
                  (l = parseFloat(i)),
                  u in Dn &&
                    ("autoAlpha" === u &&
                      (1 === s &&
                        "hidden" === mo(e, "visibility") &&
                        l &&
                        (s = 0),
                      w.push("visibility", 0, k.visibility),
                      uo(
                        this,
                        k,
                        "visibility",
                        s ? "inherit" : "hidden",
                        l ? "inherit" : "hidden",
                        !l,
                      )),
                    "scale" !== u &&
                      "transform" !== u &&
                      ~(u = Dn[u]).indexOf(",") &&
                      (u = u.split(",")[0])),
                  (h = u in Cn))
                )
                  if (
                    (this.styles.save(u),
                    y ||
                      (((b = e._gsap).renderTransform && !t.parseTransform) ||
                        To(e, t.parseTransform),
                      (v = !1 !== t.smoothOrigin && b.smooth),
                      ((y = this._pt =
                        new ln(
                          this._pt,
                          k,
                          Zn,
                          0,
                          1,
                          b.renderTransform,
                          b,
                          0,
                          -1,
                        )).dep = 1)),
                    "scale" === u)
                  )
                    (this._pt = new ln(
                      this._pt,
                      b,
                      "scaleY",
                      b.scaleY,
                      (f ? de(b.scaleY, f + l) : l) - b.scaleY || 0,
                      zn,
                    )),
                      (this._pt.u = 0),
                      x.push("scaleY", u),
                      (u += "X");
                  else {
                    if ("transformOrigin" === u) {
                      w.push(Kn, 0, k[Kn]),
                        (i = vo(i)),
                        b.svg
                          ? jo(e, i, 0, v, 0, this)
                          : ((p = parseFloat(i.split(" ")[2]) || 0) !==
                              b.zOrigin && uo(this, b, "zOrigin", b.zOrigin, p),
                            uo(this, k, u, Co(r), Co(i)));
                      continue;
                    }
                    if ("svgOrigin" === u) {
                      jo(e, i, 1, v, 0, this);
                      continue;
                    }
                    if (u in ko) {
                      Bo(this, b, u, s, f ? de(s, f + i) : i);
                      continue;
                    }
                    if ("smoothOrigin" === u) {
                      uo(this, b, "smooth", b.smooth, i);
                      continue;
                    }
                    if ("force3D" === u) {
                      b[u] = i;
                      continue;
                    }
                    if ("transform" === u) {
                      Do(this, i, e);
                      continue;
                    }
                  }
                else u in k || (u = ao(u) || u);
                if (
                  h ||
                  ((l || 0 === l) && (s || 0 === s) && !Nn.test(i) && u in k)
                )
                  l || (l = 0),
                    (d = (r + "").substr((s + "").length)) !==
                      (p = qe(i) || (u in m.units ? m.units[u] : d)) &&
                      (s = ho(e, u, r, p)),
                    (this._pt = new ln(
                      this._pt,
                      h ? b : k,
                      u,
                      s,
                      (f ? de(s, f + l) : l) - s,
                      h || ("px" !== p && "zIndex" !== u) || !1 === t.autoRound
                        ? zn
                        : Fn,
                    )),
                    (this._pt.u = p || 0),
                    d !== p &&
                      "%" !== p &&
                      ((this._pt.b = r), (this._pt.r = Rn));
                else if (u in k) yo.call(this, e, u, r, f ? f + i : i);
                else if (u in e) this.add(e, u, r || e[u], f ? f + i : i, o, a);
                else if ("parseTransform" !== u) {
                  G(u, i);
                  continue;
                }
                h || (u in k ? w.push(u, 0, k[u]) : w.push(u, 1, r || e[u])),
                  x.push(u);
              }
          g && rn(this);
        },
        render: function (e, t) {
          if (t.tween._time || !jn())
            for (var n = t._pt; n; ) n.r(e, n.d), (n = n._next);
          else t.styles.revert();
        },
        get: mo,
        aliases: Dn,
        getSetter: function (e, t, n) {
          var o = Dn[t];
          return (
            o && o.indexOf(",") < 0 && (t = o),
            t in Cn && t !== Kn && (e._gsap.x || mo(e, "x"))
              ? n && Sn === n
                ? "scale" === t
                  ? Yn
                  : Gn
                : (Sn = n || {}) && ("scale" === t ? qn : Xn)
              : e.style && !T(e.style[t])
                ? Wn
                : ~t.indexOf("-")
                  ? Un
                  : Qt(e, t)
          );
        },
        core: { _removeProperty: _o, _getMatrix: So },
      };
      (gn.utils.checkPrefix = ao),
        (gn.core.getStyleSaver = eo),
        (function (e, t, n, o) {
          var a = ce(
            "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," +
              t +
              ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
            function (e) {
              Cn[e] = 1;
            },
          );
          ce(t, function (e) {
            (m.units[e] = "deg"), (ko[e] = 1);
          }),
            (Dn[a[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + t),
            ce(
              "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY",
              function (e) {
                var t = e.split(":");
                Dn[t[1]] = a[t[0]];
              },
            );
        })(0, "rotation,rotationX,rotationY,skewX,skewY"),
        ce(
          "x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective",
          function (e) {
            m.units[e] = "px";
          },
        ),
        gn.registerPlugin(zo);
      var Ao = gn.registerPlugin(zo) || gn;
      Ao.core.Tween;
    },
    z8P2: function (e, t, n) {
      e.exports = {
        "card-link-container": "style__card-link-container___17v88",
        "card-container": "style__card-container___3mjN3",
        "card-wrapper": "style__card-wrapper___1DqOx",
        "vertical-top-align": "style__vertical-top-align___1s3Hj",
        "vertical-center-align": "style__vertical-center-align___3mf-F",
        "vertical-bottom-align": "style__vertical-bottom-align___JKN_Y",
        "card-background-video": "style__card-background-video___1108n",
        "video-mask": "style__video-mask___3Z49h",
        "card-downgrade-image": "style__card-downgrade-image___1ZzZa",
        "card-content": "style__card-content___vH0I2",
        "horizontal-left-align": "style__horizontal-left-align___1piH2",
        "horizontal-right-align": "style__horizontal-right-align___1k3dg",
        "tag-container": "style__tag-container___1t87X",
        "tag-content": "style__tag-content___2sjEO",
        eyebrow: "style__eyebrow___3767l",
        headline: "style__headline___1GB_U",
        subhead: "style__subhead___1-icl",
        description: "style__description___37V2m",
        note: "style__note___JDE7h",
        "icon-pic": "style__icon-pic___3-zqP",
        "topping-img": "style__topping-img___2_zBh",
        divider: "style__divider___k3dpz",
        "download-buttons-container":
          "style__download-buttons-container___25rLz",
        "icons-container": "style__icons-container___2fJmw",
        "icon-number-container": "style__icon-number-container___22BrE",
        "horizontal-center-align": "style__horizontal-center-align___3ggDc",
        "content-text-color-black": "style__content-text-color-black___38P05",
        "icon-title": "style__icon-title___bGMXt",
        "icon-desc": "style__icon-desc___1CQub",
        "content-text-color-white": "style__content-text-color-white___2nplh",
        "credit-wrapper": "style__credit-wrapper___31b8l",
        "credit-container": "style__credit-container___3BA6K",
        "credit-content": "style__credit-content___xOkfI",
        "size-xxxxxl": "style__size-xxxxxl___1VAz7",
        "connect-pic": "style__connect-pic___MDMRC",
        "connect-eyebrow-text": "style__connect-eyebrow-text___1mtMl",
        link: "style__link___36f7n",
        "card-icons-container": "style__card-icons-container___2FX2x",
        "card-icon-container": "style__card-icon-container___F6BCn",
        "icon-number": "style__icon-number___22dek",
        "icon-unit": "style__icon-unit___3iS0V",
        "size-xxxxl": "style__size-xxxxl___1FO2n",
        "size-xxxl": "style__size-xxxl___1Y--4",
        "size-xxl": "style__size-xxl___cbKEg",
        "size-xl": "style__size-xl___cmT-W",
        "size-l": "style__size-l___3xNLm",
        "size-m": "style__size-m___3_02b",
        "size-s": "style__size-s___2Qc-8",
        "size-xs": "style__size-xs___DThSi",
        "size-xxs": "style__size-xxs___10O36",
        "visual-hidden": "style__visual-hidden___2tPnU",
        "divider-container": "style__divider-container___3AxY_",
        "price-container": "style__price-container___sPpJJ",
        "real-price": "style__real-price___2CYaY",
        "origin-price": "style__origin-price___2TUsS",
        "buttons-container": "style__buttons-container___3cR_a",
        "button-wrapper": "style__button-wrapper___2sw2O",
        "button-inner": "style__button-inner___2d6iZ",
        "button-video-play": "style__button-video-play___usCnv",
        "zoom-button": "style__zoom-button___1HyFB",
        "video-play": "style__video-play___cjJlz",
        "video-play-light": "style__video-play-light___1T1v8",
        "video-play-dark": "style__video-play-dark___3PmPb",
        download: "style__download___2hSKC",
        "download-google-play": "style__download-google-play___1HiCP",
        "links-container": "style__links-container___1gH9d",
        horizontal: "style__horizontal___1K_GU",
        part: "style__part___eEtb1",
        left: "style__left___2NDSB",
        right: "style__right___2g_dT",
        "card-media": "style__card-media___AnYZC",
        "card-media-multi": "style__card-media-multi___1_28d",
        "card-media-multi-leftRight":
          "style__card-media-multi-leftRight___awTbn",
        "card-media-part": "style__card-media-part___3Rnlj",
        "card-media-multi-left2right1":
          "style__card-media-multi-left2right1___cYtEd",
        "card-media-item": "style__card-media-item___1tEYL",
        "card-media-multi-up1down2": "style__card-media-multi-up1down2___6dU4Q",
        "card-media-multi-updown": "style__card-media-multi-updown___XkNiM",
        "card-media-multi-up2down1": "style__card-media-multi-up2down1___2t2N0",
        "media-zoom-wrapper": "style__media-zoom-wrapper___mUYDF",
        "media-pic": "style__media-pic___3hS5Q",
        "media-sticker": "style__media-sticker___2vBF1",
        "media-video": "style__media-video___3Q0jo",
        "parallax-fore-pic": "style__parallax-fore-pic___UDO5S",
        "card-fore-video-poster": "style__card-fore-video-poster___1GTJx",
        "video-buttom": "style__video-buttom___2mMcP",
        "replay-buttom": "style__replay-buttom___3-axl",
        "play-buttom": "style__play-buttom___1YaPT",
        "pause-buttom": "style__pause-buttom___3stBv",
        "parallax-fore-video": "style__parallax-fore-video___3RGrL",
        "has-media-screen": "style__has-media-screen___2M2eq",
        "media-screen-1440": "style__media-screen-1440___3gmu4",
        "tab-card-wrapper": "style__tab-card-wrapper___3X43W",
        "media-screen-1600": "style__media-screen-1600___2pukG",
      };
    },
    zEVN: function (e, t, n) {
      var o = n("Gi0A"),
        a = n("sEf8"),
        r = n("mdPL"),
        i = r && r.isMap,
        l = i ? a(i) : o;
      e.exports = l;
    },
    zLkG: function (e, t, n) {
      t.f = n("UWiX");
    },
    zOXz: function (e, t, n) {
      e.exports = {
        "ie-modal": "style__ie-modal___2aV8J",
        mask: "style__mask___QUaGp",
        "modal-warpper": "style__modal-warpper___2dLEO",
        show: "style__show___9YNMF",
        "modal-box": "style__modal-box___2-MRo",
        close: "style__close___1vxmD",
        icon: "style__icon___37RjH",
        title: "style__title___2sCdf",
        desc: "style__desc___ru-0k",
        button: "style__button___3Fyz1",
      };
    },
    zT9C: function (e, t, n) {
      (function (e, n) {
        var o = 200,
          a = "__lodash_hash_undefined__",
          r = 9007199254740991,
          i = "[object Arguments]",
          l = "[object Boolean]",
          s = "[object Date]",
          c = "[object Function]",
          _ = "[object GeneratorFunction]",
          u = "[object Map]",
          d = "[object Number]",
          p = "[object Object]",
          f = "[object RegExp]",
          h = "[object Set]",
          m = "[object String]",
          y = "[object Symbol]",
          b = "[object ArrayBuffer]",
          v = "[object DataView]",
          g = "[object Float32Array]",
          w = "[object Float64Array]",
          x = "[object Int8Array]",
          k = "[object Int16Array]",
          O = "[object Int32Array]",
          I = "[object Uint8Array]",
          S = "[object Uint8ClampedArray]",
          j = "[object Uint16Array]",
          T = "[object Uint32Array]",
          C = /\w*$/,
          M = /^\[object .+?Constructor\]$/,
          P = /^(?:0|[1-9]\d*)$/,
          E = {};
        (E[i] =
          E["[object Array]"] =
          E[b] =
          E[v] =
          E[l] =
          E[s] =
          E[g] =
          E[w] =
          E[x] =
          E[k] =
          E[O] =
          E[u] =
          E[d] =
          E[p] =
          E[f] =
          E[h] =
          E[m] =
          E[y] =
          E[I] =
          E[S] =
          E[j] =
          E[T] =
            !0),
          (E["[object Error]"] = E[c] = E["[object WeakMap]"] = !1);
        var L = "object" == typeof e && e && e.Object === Object && e,
          B = "object" == typeof self && self && self.Object === Object && self,
          N = L || B || Function("return this")(),
          D = t && !t.nodeType && t,
          z = D && "object" == typeof n && n && !n.nodeType && n,
          A = z && z.exports === D;
        function R(e, t) {
          return e.set(t[0], t[1]), e;
        }
        function F(e, t) {
          return e.add(t), e;
        }
        function V(e, t, n, o) {
          var a = -1,
            r = e ? e.length : 0;
          for (o && r && (n = e[++a]); ++a < r; ) n = t(n, e[a], a, e);
          return n;
        }
        function H(e) {
          var t = !1;
          if (null != e && "function" != typeof e.toString)
            try {
              t = !!(e + "");
            } catch (n) {}
          return t;
        }
        function W(e) {
          var t = -1,
            n = Array(e.size);
          return (
            e.forEach(function (e, o) {
              n[++t] = [o, e];
            }),
            n
          );
        }
        function U(e, t) {
          return function (n) {
            return e(t(n));
          };
        }
        function G(e) {
          var t = -1,
            n = Array(e.size);
          return (
            e.forEach(function (e) {
              n[++t] = e;
            }),
            n
          );
        }
        var Y = Array.prototype,
          q = Function.prototype,
          X = Object.prototype,
          Z = N["__core-js_shared__"],
          K = (function () {
            var e = /[^.]+$/.exec((Z && Z.keys && Z.keys.IE_PROTO) || "");
            return e ? "Symbol(src)_1." + e : "";
          })(),
          Q = q.toString,
          J = X.hasOwnProperty,
          $ = X.toString,
          ee = RegExp(
            "^" +
              Q.call(J)
                .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  "$1.*?",
                ) +
              "$",
          ),
          te = A ? N.Buffer : void 0,
          ne = N.Symbol,
          oe = N.Uint8Array,
          ae = U(Object.getPrototypeOf, Object),
          re = Object.create,
          ie = X.propertyIsEnumerable,
          le = Y.splice,
          se = Object.getOwnPropertySymbols,
          ce = te ? te.isBuffer : void 0,
          _e = U(Object.keys, Object),
          ue = De(N, "DataView"),
          de = De(N, "Map"),
          pe = De(N, "Promise"),
          fe = De(N, "Set"),
          he = De(N, "WeakMap"),
          me = De(Object, "create"),
          ye = Ve(ue),
          be = Ve(de),
          ve = Ve(pe),
          ge = Ve(fe),
          we = Ve(he),
          xe = ne ? ne.prototype : void 0,
          ke = xe ? xe.valueOf : void 0;
        function Oe(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        function Ie(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        function Se(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var o = e[t];
            this.set(o[0], o[1]);
          }
        }
        function je(e) {
          this.__data__ = new Ie(e);
        }
        function Te(e, t) {
          var n =
              We(e) ||
              (function (e) {
                return (
                  (function (e) {
                    return (
                      (function (e) {
                        return !!e && "object" == typeof e;
                      })(e) && Ue(e)
                    );
                  })(e) &&
                  J.call(e, "callee") &&
                  (!ie.call(e, "callee") || $.call(e) == i)
                );
              })(e)
                ? (function (e, t) {
                    for (var n = -1, o = Array(e); ++n < e; ) o[n] = t(n);
                    return o;
                  })(e.length, String)
                : [],
            o = n.length,
            a = !!o;
          for (var r in e)
            (!t && !J.call(e, r)) ||
              (a && ("length" == r || Re(r, o))) ||
              n.push(r);
          return n;
        }
        function Ce(e, t, n) {
          var o = e[t];
          (J.call(e, t) && He(o, n) && (void 0 !== n || t in e)) || (e[t] = n);
        }
        function Me(e, t) {
          for (var n = e.length; n--; ) if (He(e[n][0], t)) return n;
          return -1;
        }
        function Pe(e, t, n, o, a, r, M) {
          var P;
          if ((o && (P = r ? o(e, a, r, M) : o(e)), void 0 !== P)) return P;
          if (!qe(e)) return e;
          var L = We(e);
          if (L) {
            if (
              ((P = (function (e) {
                var t = e.length,
                  n = e.constructor(t);
                t &&
                  "string" == typeof e[0] &&
                  J.call(e, "index") &&
                  ((n.index = e.index), (n.input = e.input));
                return n;
              })(e)),
              !t)
            )
              return (function (e, t) {
                var n = -1,
                  o = e.length;
                t || (t = Array(o));
                for (; ++n < o; ) t[n] = e[n];
                return t;
              })(e, P);
          } else {
            var B = Ae(e),
              N = B == c || B == _;
            if (Ge(e))
              return (function (e, t) {
                if (t) return e.slice();
                var n = new e.constructor(e.length);
                return e.copy(n), n;
              })(e, t);
            if (B == p || B == i || (N && !r)) {
              if (H(e)) return r ? e : {};
              if (
                ((P = (function (e) {
                  return "function" != typeof e.constructor || Fe(e)
                    ? {}
                    : ((t = ae(e)), qe(t) ? re(t) : {});
                  var t;
                })(N ? {} : e)),
                !t)
              )
                return (function (e, t) {
                  return Be(e, ze(e), t);
                })(
                  e,
                  (function (e, t) {
                    return e && Be(t, Xe(t), e);
                  })(P, e),
                );
            } else {
              if (!E[B]) return r ? e : {};
              P = (function (e, t, n, o) {
                var a = e.constructor;
                switch (t) {
                  case b:
                    return Le(e);
                  case l:
                  case s:
                    return new a(+e);
                  case v:
                    return (function (e, t) {
                      var n = t ? Le(e.buffer) : e.buffer;
                      return new e.constructor(n, e.byteOffset, e.byteLength);
                    })(e, o);
                  case g:
                  case w:
                  case x:
                  case k:
                  case O:
                  case I:
                  case S:
                  case j:
                  case T:
                    return (function (e, t) {
                      var n = t ? Le(e.buffer) : e.buffer;
                      return new e.constructor(n, e.byteOffset, e.length);
                    })(e, o);
                  case u:
                    return (function (e, t, n) {
                      return V(t ? n(W(e), !0) : W(e), R, new e.constructor());
                    })(e, o, n);
                  case d:
                  case m:
                    return new a(e);
                  case f:
                    return (function (e) {
                      var t = new e.constructor(e.source, C.exec(e));
                      return (t.lastIndex = e.lastIndex), t;
                    })(e);
                  case h:
                    return (function (e, t, n) {
                      return V(t ? n(G(e), !0) : G(e), F, new e.constructor());
                    })(e, o, n);
                  case y:
                    return (r = e), ke ? Object(ke.call(r)) : {};
                }
                var r;
              })(e, B, Pe, t);
            }
          }
          M || (M = new je());
          var D = M.get(e);
          if (D) return D;
          if ((M.set(e, P), !L))
            var z = n
              ? (function (e) {
                  return (function (e, t, n) {
                    var o = t(e);
                    return We(e)
                      ? o
                      : (function (e, t) {
                          for (
                            var n = -1, o = t.length, a = e.length;
                            ++n < o;

                          )
                            e[a + n] = t[n];
                          return e;
                        })(o, n(e));
                  })(e, Xe, ze);
                })(e)
              : Xe(e);
          return (
            (function (e, t) {
              for (
                var n = -1, o = e ? e.length : 0;
                ++n < o && !1 !== t(e[n], n, e);

              );
            })(z || e, function (a, r) {
              z && (a = e[(r = a)]), Ce(P, r, Pe(a, t, n, o, r, e, M));
            }),
            P
          );
        }
        function Ee(e) {
          return (
            !(!qe(e) || ((t = e), K && K in t)) &&
            (Ye(e) || H(e) ? ee : M).test(Ve(e))
          );
          var t;
        }
        function Le(e) {
          var t = new e.constructor(e.byteLength);
          return new oe(t).set(new oe(e)), t;
        }
        function Be(e, t, n, o) {
          n || (n = {});
          for (var a = -1, r = t.length; ++a < r; ) {
            var i = t[a],
              l = o ? o(n[i], e[i], i, n, e) : void 0;
            Ce(n, i, void 0 === l ? e[i] : l);
          }
          return n;
        }
        function Ne(e, t) {
          var n = e.__data__;
          return (function (e) {
            var t = typeof e;
            return "string" == t ||
              "number" == t ||
              "symbol" == t ||
              "boolean" == t
              ? "__proto__" !== e
              : null === e;
          })(t)
            ? n["string" == typeof t ? "string" : "hash"]
            : n.map;
        }
        function De(e, t) {
          var n = (function (e, t) {
            return null == e ? void 0 : e[t];
          })(e, t);
          return Ee(n) ? n : void 0;
        }
        (Oe.prototype.clear = function () {
          this.__data__ = me ? me(null) : {};
        }),
          (Oe.prototype.delete = function (e) {
            return this.has(e) && delete this.__data__[e];
          }),
          (Oe.prototype.get = function (e) {
            var t = this.__data__;
            if (me) {
              var n = t[e];
              return n === a ? void 0 : n;
            }
            return J.call(t, e) ? t[e] : void 0;
          }),
          (Oe.prototype.has = function (e) {
            var t = this.__data__;
            return me ? void 0 !== t[e] : J.call(t, e);
          }),
          (Oe.prototype.set = function (e, t) {
            return (this.__data__[e] = me && void 0 === t ? a : t), this;
          }),
          (Ie.prototype.clear = function () {
            this.__data__ = [];
          }),
          (Ie.prototype.delete = function (e) {
            var t = this.__data__,
              n = Me(t, e);
            return (
              !(n < 0) && (n == t.length - 1 ? t.pop() : le.call(t, n, 1), !0)
            );
          }),
          (Ie.prototype.get = function (e) {
            var t = this.__data__,
              n = Me(t, e);
            return n < 0 ? void 0 : t[n][1];
          }),
          (Ie.prototype.has = function (e) {
            return Me(this.__data__, e) > -1;
          }),
          (Ie.prototype.set = function (e, t) {
            var n = this.__data__,
              o = Me(n, e);
            return o < 0 ? n.push([e, t]) : (n[o][1] = t), this;
          }),
          (Se.prototype.clear = function () {
            this.__data__ = {
              hash: new Oe(),
              map: new (de || Ie)(),
              string: new Oe(),
            };
          }),
          (Se.prototype.delete = function (e) {
            return Ne(this, e).delete(e);
          }),
          (Se.prototype.get = function (e) {
            return Ne(this, e).get(e);
          }),
          (Se.prototype.has = function (e) {
            return Ne(this, e).has(e);
          }),
          (Se.prototype.set = function (e, t) {
            return Ne(this, e).set(e, t), this;
          }),
          (je.prototype.clear = function () {
            this.__data__ = new Ie();
          }),
          (je.prototype.delete = function (e) {
            return this.__data__.delete(e);
          }),
          (je.prototype.get = function (e) {
            return this.__data__.get(e);
          }),
          (je.prototype.has = function (e) {
            return this.__data__.has(e);
          }),
          (je.prototype.set = function (e, t) {
            var n = this.__data__;
            if (n instanceof Ie) {
              var a = n.__data__;
              if (!de || a.length < o - 1) return a.push([e, t]), this;
              n = this.__data__ = new Se(a);
            }
            return n.set(e, t), this;
          });
        var ze = se
            ? U(se, Object)
            : function () {
                return [];
              },
          Ae = function (e) {
            return $.call(e);
          };
        function Re(e, t) {
          return (
            !!(t = null == t ? r : t) &&
            ("number" == typeof e || P.test(e)) &&
            e > -1 &&
            e % 1 == 0 &&
            e < t
          );
        }
        function Fe(e) {
          var t = e && e.constructor;
          return e === (("function" == typeof t && t.prototype) || X);
        }
        function Ve(e) {
          if (null != e) {
            try {
              return Q.call(e);
            } catch (t) {}
            try {
              return e + "";
            } catch (t) {}
          }
          return "";
        }
        function He(e, t) {
          return e === t || (e !== e && t !== t);
        }
        ((ue && Ae(new ue(new ArrayBuffer(1))) != v) ||
          (de && Ae(new de()) != u) ||
          (pe && "[object Promise]" != Ae(pe.resolve())) ||
          (fe && Ae(new fe()) != h) ||
          (he && "[object WeakMap]" != Ae(new he()))) &&
          (Ae = function (e) {
            var t = $.call(e),
              n = t == p ? e.constructor : void 0,
              o = n ? Ve(n) : void 0;
            if (o)
              switch (o) {
                case ye:
                  return v;
                case be:
                  return u;
                case ve:
                  return "[object Promise]";
                case ge:
                  return h;
                case we:
                  return "[object WeakMap]";
              }
            return t;
          });
        var We = Array.isArray;
        function Ue(e) {
          return (
            null != e &&
            (function (e) {
              return "number" == typeof e && e > -1 && e % 1 == 0 && e <= r;
            })(e.length) &&
            !Ye(e)
          );
        }
        var Ge =
          ce ||
          function () {
            return !1;
          };
        function Ye(e) {
          var t = qe(e) ? $.call(e) : "";
          return t == c || t == _;
        }
        function qe(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function Xe(e) {
          return Ue(e)
            ? Te(e)
            : (function (e) {
                if (!Fe(e)) return _e(e);
                var t = [];
                for (var n in Object(e))
                  J.call(e, n) && "constructor" != n && t.push(n);
                return t;
              })(e);
        }
        n.exports = function (e) {
          return Pe(e, !0, !0);
        };
      }).call(this, n("yLpj"), n("YuTi")(e));
    },
    zWvU: function (e, t, n) {
      "use strict";
      Object.defineProperty(t, "__esModule", { value: !0 });
      var o = (function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e)
          for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        return (t.default = e), t;
      })(n("Aw7D"));
      t.default = function (e, t, n, a, r, i) {
        !e.required ||
          (n.hasOwnProperty(e.field) && !o.isEmptyValue(t, i || e.type)) ||
          a.push(o.format(r.messages.required, e.fullField));
      };
    },
    "zZ+F": function (e, t, n) {
      e.exports = {
        "section-103-change-color": "style__section-103-change-color___5cRUs",
        "sticky-container": "style__sticky-container___SiEyD",
      };
    },
    zZ0H: function (e, t) {
      e.exports = function (e) {
        return e;
      };
    },
    zoYe: function (e, t, n) {
      var o = n("nmnc"),
        a = n("eUgh"),
        r = n("Z0cm"),
        i = n("/9aa"),
        l = 1 / 0,
        s = o ? o.prototype : void 0,
        c = s ? s.toString : void 0;
      e.exports = function e(t) {
        if ("string" == typeof t) return t;
        if (r(t)) return a(t, e) + "";
        if (i(t)) return c ? c.call(t) : "";
        var n = t + "";
        return "0" == n && 1 / t == -l ? "-0" : n;
      };
    },
    zs13: function (e, t) {
      e.exports = function (e, t) {
        if (e.indexOf) return e.indexOf(t);
        for (var n = 0; n < e.length; ++n) if (e[n] === t) return n;
        return -1;
      };
    },
    zwpK: function (e, t, n) {
      "use strict";
      var o = n("wx14"),
        a = n("HaE+"),
        r = n("1OyB"),
        i = n("vuIU"),
        l = n("md7G"),
        s = n("foSv"),
        c = n("JX7q"),
        _ = n("Ji7U"),
        u = n("iKuz"),
        d = n.n(u),
        p = n("q1tI"),
        f = n.n(p),
        h = n("/MKj"),
        m = n("8Kt/"),
        y = n.n(m),
        b = n("XnI8"),
        v = n("UiZK"),
        g = n.n(v),
        w = n("9/5/"),
        x = n.n(w),
        k = n("hKI/"),
        O = n.n(k),
        I = n("TSYQ"),
        S = n.n(I),
        j = n("iVi/"),
        T = n.n(j),
        C = n("u11H"),
        M = n("0b+E"),
        P = n("S5C5"),
        E = n("ZO6J"),
        L = n("yWgo"),
        B = n("gpTt"),
        N = n("Ntax"),
        D = (n("aiR1"), n("LPlb")),
        z = (n("S8lS"), f.a.createElement),
        A = {
          "@dji/quark/dist/Icon.css": {
            _3c0Qz: "Icon___3c0Qz___FIJlG",
            _1j2v0: "Icon___1j2v0___3n4_L",
            "-lu88": "Icon__-lu88___3d46C",
            _35bgc: "Icon___35bgc___3GNZF",
            byXrR: "Icon__byXrR___1RkT6",
            _128ri: "Icon___128ri___2tmqj",
            _1KHsi: "Icon___1KHsi___3Eodi",
            "_2bT-Y": "Icon___2bT-Y___2I6pp",
            _3UEZX: "Icon___3UEZX___2thwC",
            _1fXKU: "Icon___1fXKU___2BRJU",
            _2OZ_n: "Icon___2OZ_n___2RThy",
            _6cr8a: "Icon___6cr8a___IijMS",
            ZAGKa: "Icon__ZAGKa___1VXdb",
            _1lH5w: "Icon___1lH5w___1Fjc9",
            _3BSr4: "Icon___3BSr4___1Kmz0",
            _4wlbR: "Icon___4wlbR___3byTz",
            _26SUY: "Icon___26SUY___d0HAN",
            "_30-mD": "Icon___30-mD___3ZamP",
            _1_xvC: "Icon___1_xvC___2A-8f",
            _17P2f: "Icon___17P2f___rSHoE",
            _2I_EY: "Icon___2I_EY___2xSLv",
            _3qb3s: "Icon___3qb3s___rJOmo",
            _2jwD5: "Icon___2jwD5___2QGsT",
            _19X43: "Icon___19X43___3Kun2",
            _2WwM4: "Icon___2WwM4___1gBlP",
            _1shcg: "Icon___1shcg___3hDFq",
            _1qLWd: "Icon___1qLWd___2iuQy",
            Z8Prc: "Icon__Z8Prc___1Dms6",
            _3MItB: "Icon___3MItB___3_bo8",
            _2Bvn6: "Icon___2Bvn6___WbeJB",
            _3IVo_: "Icon___3IVo____3wyxI",
            _34FGS: "Icon___34FGS___33RR0",
            _3e62_: "Icon___3e62____92ZgY",
            _1zbhS: "Icon___1zbhS___2r2qq",
            _27RtX: "Icon___27RtX___27B0l",
            jhfcy: "Icon__jhfcy___16aAv",
            Q82xM: "Icon__Q82xM___oUbgj",
            _1vyf0: "Icon___1vyf0___1Q36k",
            B0IHZ: "Icon__B0IHZ___2i7iu",
            _2cpQ_: "Icon___2cpQ____1m_c2",
            _2FImd: "Icon___2FImd___3DKZV",
            _3wXJB: "Icon___3wXJB___kIf5S",
            _2fXyR: "Icon___2fXyR___I8f9m",
            _2KLCQ: "Icon___2KLCQ___20KdM",
            "_-4DAY": "Icon___-4DAY___3ZpEm",
            _2I4g3: "Icon___2I4g3___32bHH",
            _1m5z7: "Icon___1m5z7___1qVyd",
            _1vR3p: "Icon___1vR3p___2yoW_",
            _2LJ7o: "Icon___2LJ7o___jCzSa",
            _3AQSX: "Icon___3AQSX___1f3qw",
            _3ASBw: "Icon___3ASBw___1lGu0",
            _6eszT: "Icon___6eszT___2t_u2",
            _1WxHW: "Icon___1WxHW___GiKUo",
            _2uv1U: "Icon___2uv1U___1JiUZ",
            "_3s-NW": "Icon___3s-NW___1I_EX",
            _1ZzVY: "Icon___1ZzVY___2rvYH",
            OBwuW: "Icon__OBwuW___2fQc2",
            "_2Ri-k": "Icon___2Ri-k___2kk-7",
            _1588m: "Icon___1588m___9NDr4",
            _2uIqb: "Icon___2uIqb___1FdOg",
            _1P5xZ: "Icon___1P5xZ___2f_T2",
            _2iuBX: "Icon___2iuBX___L1dph",
            _1exha: "Icon___1exha___1m37C",
            _3bokS: "Icon___3bokS___1OYm4",
            "vMM-Y": "Icon__vMM-Y___3QgfP",
            _3jZwp: "Icon___3jZwp___3d5u1",
            "_2SUQ-": "Icon___2SUQ-___6nEm6",
            _1Piil: "Icon___1Piil___VvBSt",
            _20oXE: "Icon___20oXE___1xwx0",
            _2gTe8: "Icon___2gTe8___2yipi",
            okv_Y: "Icon__okv_Y___1Pe9p",
            "_3l-6g": "Icon___3l-6g___TPS6y",
            OhY9C: "Icon__OhY9C___23GW6",
            Cb5jY: "Icon__Cb5jY___2uZGR",
            _1ajFe: "Icon___1ajFe___HugcL",
            ve2KQ: "Icon__ve2KQ___t5XNa",
            _3OU3j: "Icon___3OU3j___xivTQ",
            lgV2x: "Icon__lgV2x___h-CeN",
            _1gQtG: "Icon___1gQtG___3bGQ2",
            _3Zaag: "Icon___3Zaag___Sa23k",
            _33jTA: "Icon___33jTA___2TKV5",
            _1jJbn: "Icon___1jJbn___1sLs7",
            UuxAk: "Icon__UuxAk___19lCZ",
            _1OEuY: "Icon___1OEuY___3iBjU",
            Lm_MF: "Icon__Lm_MF___3yQbY",
            _3LwbN: "Icon___3LwbN___3Kj8n",
            _2XN05: "Icon___2XN05___1rny3",
            _33OcX: "Icon___33OcX___394mm",
            bMc_E: "Icon__bMc_E___H5L8W",
            IAlEP: "Icon__IAlEP___2I8pV",
            _25GQ2: "Icon___25GQ2___2lovm",
            _3t3HT: "Icon___3t3HT___n_YD6",
            _2W_XA: "Icon___2W_XA___3qZb3",
            _3NPLS: "Icon___3NPLS___3Dm9I",
            UhwjW: "Icon__UhwjW___3Bath",
            _2hDpl: "Icon___2hDpl___3V_-b",
            dCZz2: "Icon__dCZz2___11T7f",
            _1FMUV: "Icon___1FMUV___LlZ0V",
            _2H8bj: "Icon___2H8bj___27UMO",
            _3KkpT: "Icon___3KkpT___1PPrL",
            _23p5a: "Icon___23p5a___1EP34",
            _18A_e: "Icon___18A_e___7QC5E",
            gf_rb: "Icon__gf_rb___2PXNg",
            _1Djb6: "Icon___1Djb6___2pUir",
            "_3d-6G": "Icon___3d-6G___14ssX",
            _1fawl: "Icon___1fawl___KUcfA",
            _20uY7: "Icon___20uY7___18OZm",
            _2Z6dE: "Icon___2Z6dE___1ik2v",
            _1c3Qh: "Icon___1c3Qh___2essq",
            _1GlZx: "Icon___1GlZx___1NCg-",
            _3hG3b: "Icon___3hG3b___2gAhc",
            _15wCJ: "Icon___15wCJ___X5oB6",
            _1Rw_U: "Icon___1Rw_U___16Osz",
            _2Jlwc: "Icon___2Jlwc___de1R5",
            _1bahP: "Icon___1bahP___3btKO",
            "_27Nd-": "Icon___27Nd-___2hUt0",
            _3To44: "Icon___3To44___1U_3e",
            _1O_Hy: "Icon___1O_Hy___3okVL",
            W6H_f: "Icon__W6H_f___3gCiH",
            _2_sls: "Icon___2_sls___yPeTY",
            _35BGQ: "Icon___35BGQ___jWjx9",
            _3xfLM: "Icon___3xfLM___3zQYM",
            _1pvYF: "Icon___1pvYF___1VGpm",
          },
          "./style.css": {
            "nav-bar": "style__nav-bar___2jDiV",
            "navbar-searching": "style__navbar-searching___3sXIA",
            "nav-brand": "style__nav-brand___2GZL5",
            "hover-logo": "style__hover-logo___Kfmu6",
            logo: "style__logo___1rTym",
            "subdomain-placeholder": "style__subdomain-placeholder___CNF1B",
            "dji-subdomain": "style__dji-subdomain___19h9Q",
            "navbar-left": "style__navbar-left___21csv",
            "dropdown-menu": "style__dropdown-menu___3bKmE",
            single: "style__single____ROH8",
            "subitem-a": "style__subitem-a___3qBvJ",
            "category-item": "style__category-item___1cjD0",
            "category-item-link": "style__category-item-link___1OlOz",
            "category-item-unclickable":
              "style__category-item-unclickable___4elUm",
            "columns-menu": "style__columns-menu___2JYv6",
            center: "style__center___3Af-M",
            "navbar-right": "style__navbar-right___2zo17",
            columns: "style__columns___IVMej",
            "with-pic": "style__with-pic___3cW58",
            "without-pic": "style__without-pic___301Zf",
            "column-right": "style__column-right___1rVP-",
            "product-list": "style__product-list___t0q6I",
            "product-link": "style__product-link___2AaY9",
            title: "style__title___2yXSb",
            desc: "style__desc___m43p-",
            "navbar-contact": "style__navbar-contact___2_Psy",
            "contact-btn": "style__contact-btn___-4dGT",
            "contact-btn-text": "style__contact-btn-text___IUF2M",
            "store-btn": "style__store-btn___1iBNH",
            "contact-btn-new": "style__contact-btn-new___1IGWY",
            "dji-subdomain-cn": "style__dji-subdomain-cn___2rJvi",
            "dji-enterprise": "style__dji-enterprise___25kSn",
            "bottom-menu": "style__bottom-menu___2S2du",
            cell: "style__cell___3mOKW",
            "subitem-ul": "style__subitem-ul___1OMfg",
            "full-screen": "style__full-screen___2S2Cs",
            "columns-dropdown": "style__columns-dropdown___CSU-M",
            "column-item": "style__column-item___BC4Em",
            "home-navbar": "style__home-navbar___2_0O9",
            "navbar-main": "style__navbar-main___3RWcj",
            "user-icon": "style__user-icon___vEILH",
            "user-icon-hover": "style__user-icon-hover___3W2RW",
            "search-icon": "style__search-icon___3C9vR",
            "search-icon-hover": "style__search-icon-hover___3NGSM",
            "common-navbar": "style__common-navbar___83P30",
            "nav-container": "style__nav-container___1LprZ",
            "navbar-header": "style__navbar-header___1GWWc",
            "navbar-category": "style__navbar-category___26cPV",
            "nav-store": "style__nav-store___1aMzR",
            "nav-user": "style__nav-user___252k4",
            "nav-account": "style__nav-account___1JCxy",
            "user-name": "style__user-name___2an5C",
            "nav-drop-active": "style__nav-drop-active___VBQYy",
            active: "style__active___3GdgW",
            "header-search": "style__header-search___2hIE6",
            silde_to_left: "style__silde_to_left___kQDhC",
            show: "style__show___x5Z51",
            "search-box": "style__search-box___a_UJ0",
            "search-tips": "style__search-tips___29yx4",
            "search-box-cover": "style__search-box-cover___3GgCo",
            "search-form": "style__search-form___1RrLb",
            "search-btn": "style__search-btn___2ab3B",
            "search-input": "style__search-input___39Gow",
            "close-btn": "style__close-btn___dFgkX",
            "search-list": "style__search-list___2rFF4",
            hidden: "style__hidden___3oW3d",
            "quick-link": "style__quick-link___WGlJE",
            relative: "style__relative___3ENam",
            "subitem-li": "style__subitem-li___1N90c",
            "right-icon": "style__right-icon___2W5mI",
            "subitem-div": "style__subitem-div___2CTWv",
            "menu-container": "style__menu-container___2Kghk",
            "compare-pill": "style__compare-pill____GqLH",
            "top-menu": "style__top-menu___dpzy_",
            "top-menu-wrapper": "style__top-menu-wrapper___rs49l",
            pill: "style__pill___VaMMq",
            "site-icon": "style__site-icon___O4rOJ",
            "enter-site": "style__enter-site___2OEY7",
            "horizontal-divider": "style__horizontal-divider___1Lc7K",
            lite: "style__lite___3FPPy",
            last: "style__last___e3LiG",
            "column-left": "style__column-left___EE1fv",
            "product-cover": "style__product-cover___1Pwns",
            "nav-item": "style__nav-item___MmuJ6",
            "nav-item-link": "style__nav-item-link___3lD4V",
            "cart-container": "style__cart-container___32k3P",
            cart: "style__cart___gvLQw",
            "product-item": "style__product-item___1NcAt",
            "product-wrap": "style__product-wrap___3sAOw",
            text: "style__text___1nFAw",
            photo: "style__photo___23IWy",
            name: "style__name___3NL2r",
            quantity: "style__quantity___1Smz4",
            "left-tips": "style__left-tips___3Pu6S",
            checkout: "style__checkout___1s6Ve",
            "checkout-btn": "style__checkout-btn___1w6Lw",
            "bottom-horizontal-divider":
              "style__bottom-horizontal-divider___3SxUZ",
            "nav-header-wrapper": "style__nav-header-wrapper___29QHC",
            "nav-header": "style__nav-header___2t2MJ",
            "nav-menu-wrapper": "style__nav-menu-wrapper___2rTvL",
            "disable-pointer-events": "style__disable-pointer-events___2CCyV",
            "explore-menu": "style__explore-menu___2TN65",
            "dji-menu-list": "style__dji-menu-list___2uS42",
            "show-up": "style__show-up___114aV",
            "dji-menu-link": "style__dji-menu-link___35kQc",
            "nav-menu": "style__nav-menu___1BBsm",
            "img-box": "style__img-box___3jsax",
            "close-menu": "style__close-menu___zmc1z",
            "dji-tab-container": "style__dji-tab-container___vgjah",
            "enterprise-tab": "style__enterprise-tab___1L4OP",
            "dji-tab": "style__dji-tab___1qtC7",
            "dji-tab-list": "style__dji-tab-list___x9wLY",
            "dji-tab-item": "style__dji-tab-item___fOEhk",
            "dji-tab-link": "style__dji-tab-link___Q4vTh",
            container: "style__container___2i1Jx",
            commercial: "style__commercial___3ikuU",
            row: "style__row___2KaA8",
            support: "style__support___b7dyF",
            "series-list": "style__series-list___1USBX",
            "series-list-divider": "style__series-list-divider___3DMUW",
            hide: "style__hide___2CmXA",
            "link-list": "style__link-list___14-fM",
            "content-wrapper": "style__content-wrapper___-m5VK",
            "dji-link": "style__dji-link___1tHR3",
            suffix: "style__suffix___xpNfl",
            "vertical-divider": "style__vertical-divider___1_815",
            "serieslist-row": "style__serieslist-row___2Tyjw",
            "row-top": "style__row-top___3cvKK",
            "row-bot": "style__row-bot___13e6r",
            "col-3": "style__col-3___1M822",
            "series-list-item": "style__series-list-item___1koeo",
            "series-name": "style__series-name___3drhG",
            solutions: "style__solutions___2qspo",
            "solution-list": "style__solution-list___1v-QU",
            "solution-list-item": "style__solution-list-item___zOVfu",
            intro: "style__intro___ZDfTM",
            "no-cursor": "style__no-cursor___3hNlv",
            "col-xs-12": "style__col-xs-12___2owFL",
            "dji-divider": "style__dji-divider___2y_vT",
            "series-name-link": "style__series-name-link___1uQ5t",
            "series-intro": "style__series-intro___dajmK",
            "product-list-wrapper": "style__product-list-wrapper___34oY1",
            "series-cover": "style__series-cover___2ZeaB",
            "product-item-cover": "style__product-item-cover___2HUX4",
            "img-has-second": "style__img-has-second___3xJNh",
            second: "style__second___AiIGM",
            first: "style__first___c4V4q",
            "img-product-name": "style__img-product-name___2-rg5",
            "product-list-item": "style__product-list-item___nqjqQ",
            "product-name": "style__product-name___saKN6",
            new: "style__new___qCOp3",
            "dji-btn": "style__dji-btn___lIxI4",
            external: "style__external___1IWdZ",
            "btn-wrapper": "style__btn-wrapper___1dTaB",
            "close-menu-wrapper": "style__close-menu-wrapper___1HklX",
            "icon-close": "style__icon-close___MXGAM",
            "no-product-tip": "style__no-product-tip___3yZXL",
            "shopping-bag": "style__shopping-bag___NTAk_",
          },
        };
      function R() {
        R = function () {
          return t;
        };
        var e,
          t = {},
          n = Object.prototype,
          o = n.hasOwnProperty,
          a =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          l = r.asyncIterator || "@@asyncIterator",
          s = r.toStringTag || "@@toStringTag";
        function c(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          c({}, "");
        } catch (e) {
          c = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function _(e, t, n, o) {
          var r = t && t.prototype instanceof y ? t : y,
            i = Object.create(r.prototype),
            l = new M(o || []);
          return a(i, "_invoke", { value: S(e, n, l) }), i;
        }
        function u(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = _;
        var d = "suspendedStart",
          p = "suspendedYield",
          f = "executing",
          h = "completed",
          m = {};
        function y() {}
        function b() {}
        function v() {}
        var g = {};
        c(g, i, function () {
          return this;
        });
        var w = Object.getPrototypeOf,
          x = w && w(w(P([])));
        x && x !== n && o.call(x, i) && (g = x);
        var k = (v.prototype = y.prototype = Object.create(g));
        function O(e) {
          ["next", "throw", "return"].forEach(function (t) {
            c(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function I(e, t) {
          function n(a, r, i, l) {
            var s = u(e[a], e, r);
            if ("throw" !== s.type) {
              var c = s.arg,
                _ = c.value;
              return _ && "object" == typeof _ && o.call(_, "__await")
                ? t.resolve(_.__await).then(
                    function (e) {
                      n("next", e, i, l);
                    },
                    function (e) {
                      n("throw", e, i, l);
                    },
                  )
                : t.resolve(_).then(
                    function (e) {
                      (c.value = e), i(c);
                    },
                    function (e) {
                      return n("throw", e, i, l);
                    },
                  );
            }
            l(s.arg);
          }
          var r;
          a(this, "_invoke", {
            value: function (e, o) {
              function a() {
                return new t(function (t, a) {
                  n(e, o, t, a);
                });
              }
              return (r = r ? r.then(a, a) : a());
            },
          });
        }
        function S(t, n, o) {
          var a = d;
          return function (r, i) {
            if (a === f) throw new Error("Generator is already running");
            if (a === h) {
              if ("throw" === r) throw i;
              return { value: e, done: !0 };
            }
            for (o.method = r, o.arg = i; ; ) {
              var l = o.delegate;
              if (l) {
                var s = j(l, o);
                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }
              if ("next" === o.method) o.sent = o._sent = o.arg;
              else if ("throw" === o.method) {
                if (a === d) throw ((a = h), o.arg);
                o.dispatchException(o.arg);
              } else "return" === o.method && o.abrupt("return", o.arg);
              a = f;
              var c = u(t, n, o);
              if ("normal" === c.type) {
                if (((a = o.done ? h : p), c.arg === m)) continue;
                return { value: c.arg, done: o.done };
              }
              "throw" === c.type &&
                ((a = h), (o.method = "throw"), (o.arg = c.arg));
            }
          };
        }
        function j(t, n) {
          var o = n.method,
            a = t.iterator[o];
          if (a === e)
            return (
              (n.delegate = null),
              ("throw" === o &&
                t.iterator.return &&
                ((n.method = "return"),
                (n.arg = e),
                j(t, n),
                "throw" === n.method)) ||
                ("return" !== o &&
                  ((n.method = "throw"),
                  (n.arg = new TypeError(
                    "The iterator does not provide a '" + o + "' method",
                  )))),
              m
            );
          var r = u(a, t.iterator, n.arg);
          if ("throw" === r.type)
            return (
              (n.method = "throw"), (n.arg = r.arg), (n.delegate = null), m
            );
          var i = r.arg;
          return i
            ? i.done
              ? ((n[t.resultName] = i.value),
                (n.next = t.nextLoc),
                "return" !== n.method && ((n.method = "next"), (n.arg = e)),
                (n.delegate = null),
                m)
              : i
            : ((n.method = "throw"),
              (n.arg = new TypeError("iterator result is not an object")),
              (n.delegate = null),
              m);
        }
        function T(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function C(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function M(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(T, this),
            this.reset(!0);
        }
        function P(t) {
          if (t || "" === t) {
            var n = t[i];
            if (n) return n.call(t);
            if ("function" == typeof t.next) return t;
            if (!isNaN(t.length)) {
              var a = -1,
                r = function n() {
                  for (; ++a < t.length; )
                    if (o.call(t, a)) return (n.value = t[a]), (n.done = !1), n;
                  return (n.value = e), (n.done = !0), n;
                };
              return (r.next = r);
            }
          }
          throw new TypeError(typeof t + " is not iterable");
        }
        return (
          (b.prototype = v),
          a(k, "constructor", { value: v, configurable: !0 }),
          a(v, "constructor", { value: b, configurable: !0 }),
          (b.displayName = c(v, s, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === b || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, v)
                : ((e.__proto__ = v), c(e, s, "GeneratorFunction")),
              (e.prototype = Object.create(k)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          O(I.prototype),
          c(I.prototype, l, function () {
            return this;
          }),
          (t.AsyncIterator = I),
          (t.async = function (e, n, o, a, r) {
            void 0 === r && (r = Promise);
            var i = new I(_(e, n, o, a), r);
            return t.isGeneratorFunction(n)
              ? i
              : i.next().then(function (e) {
                  return e.done ? e.value : i.next();
                });
          }),
          O(k),
          c(k, s, "Generator"),
          c(k, i, function () {
            return this;
          }),
          c(k, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var o in t) n.push(o);
            return (
              n.reverse(),
              function e() {
                for (; n.length; ) {
                  var o = n.pop();
                  if (o in t) return (e.value = o), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = P),
          (M.prototype = {
            constructor: M,
            reset: function (t) {
              if (
                ((this.prev = 0),
                (this.next = 0),
                (this.sent = this._sent = e),
                (this.done = !1),
                (this.delegate = null),
                (this.method = "next"),
                (this.arg = e),
                this.tryEntries.forEach(C),
                !t)
              )
                for (var n in this)
                  "t" === n.charAt(0) &&
                    o.call(this, n) &&
                    !isNaN(+n.slice(1)) &&
                    (this[n] = e);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var n = this;
              function a(o, a) {
                return (
                  (l.type = "throw"),
                  (l.arg = t),
                  (n.next = o),
                  a && ((n.method = "next"), (n.arg = e)),
                  !!a
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  l = i.completion;
                if ("root" === i.tryLoc) return a("end");
                if (i.tryLoc <= this.prev) {
                  var s = o.call(i, "catchLoc"),
                    c = o.call(i, "finallyLoc");
                  if (s && c) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  } else if (s) {
                    if (this.prev < i.catchLoc) return a(i.catchLoc, !0);
                  } else {
                    if (!c)
                      throw new Error("try statement without catch or finally");
                    if (this.prev < i.finallyLoc) return a(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var a = this.tryEntries[n];
                if (
                  a.tryLoc <= this.prev &&
                  o.call(a, "finallyLoc") &&
                  this.prev < a.finallyLoc
                ) {
                  var r = a;
                  break;
                }
              }
              r &&
                ("break" === e || "continue" === e) &&
                r.tryLoc <= t &&
                t <= r.finallyLoc &&
                (r = null);
              var i = r ? r.completion : {};
              return (
                (i.type = e),
                (i.arg = t),
                r
                  ? ((this.method = "next"), (this.next = r.finallyLoc), m)
                  : this.complete(i)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                m
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), C(n), m;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var o = n.completion;
                  if ("throw" === o.type) {
                    var a = o.arg;
                    C(n);
                  }
                  return a;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (t, n, o) {
              return (
                (this.delegate = { iterator: P(t), resultName: n, nextLoc: o }),
                "next" === this.method && (this.arg = e),
                m
              );
            },
          }),
          t
        );
      }
      function F(e, t, n) {
        return (
          (t = Object(s.a)(t)),
          Object(l.a)(
            e,
            (function () {
              try {
                var e = !Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {}),
                );
              } catch (e) {}
              return (function () {
                return !!e;
              })();
            })()
              ? Reflect.construct(t, n || [], Object(s.a)(e).constructor)
              : t.apply(e, n),
          )
        );
      }
      
    },
  },
  [["Oujc", 1, 0]],
]);
